import { o as e, r as t } from "./rolldown-runtime-jwUa06l-.js";
import { $ as n, $n as r, $t as i, A as a, An as o, Ar as s, At as c, B as l, Bn as u, Br as d, C as f, Cn as p, Cr as m, Ct as h, D as g, Dn as _, Dr as v, Dt as y, E as b, En as x, Er as S, Et as C, F as w, Fn as T, Fr as ee, Ft as E, G as D, Gn as te, Gt as ne, H as re, Hn as ie, Hr as ae, Ht as oe, I as se, In as ce, Ir as le, It as ue, J as de, Jn as fe, Jt as pe, Kn as me, Kr as he, Kt as ge, L as _e, Ln as ve, Lr as ye, Lt as be, M as xe, Mn as Se, Mt as Ce, N as we, Nn as Te, Nr as O, Nt as Ee, O as De, On as Oe, Or as ke, Ot as Ae, P as je, Pr as Me, Pt as Ne, Q as Pe, Qn as Fe, Qt as Ie, R as Le, Rn as Re, Rr as ze, Rt as Be, S as Ve, Sn as He, Sr as Ue, St as We, T as Ge, Tn as Ke, Tr as qe, Tt as Je, U as Ye, Un as Xe, Ur as Ze, Ut as Qe, V as $e, Vn as et, Vr as tt, Vt as nt, W as rt, Wn as it, Wr as at, Wt as ot, X as st, Xn as ct, Xt as lt, Y as ut, Yn as dt, Yr as ft, Yt as pt, Z as mt, Zn as ht, Zt as gt, _ as _t, _n as vt, _r as yt, _t as bt, a as xt, an as St, ar as Ct, at as wt, b as Tt, bn as Et, br as Dt, bt as Ot, c as kt, cn as At, d as jt, dn as Mt, dt as Nt, en as Pt, er as Ft, et as It, f as Lt, fn as Rt, fr as zt, ft as Bt, g as Vt, gn as Ht, gr as Ut, gt as Wt, h as Gt, hn as Kt, hr as qt, ht as Jt, i as Yt, in as Xt, ir as Zt, it as Qt, j as $t, jn as en, jr as tn, jt as nn, k as rn, kn as an, kr as on, kt as sn, l as cn, ln, lr as un, lt as dn, m as fn, mn as pn, mr as mn, mt as hn, n as gn, nn as _n, nr as vn, nt as yn, on as bn, or as xn, ot as Sn, p as Cn, pn as wn, pr as Tn, pt as En, q as Dn, qn as On, qr as kn, qt as An, r as jn, rn as Mn, rt as Nn, s as Pn, sn as Fn, sr as In, st as Ln, t as Rn, tn as zn, tr as Bn, tt as Vn, u as Hn, un as Un, ur as Wn, v as Gn, vn as Kn, vr as qn, vt as Jn, w as Yn, wn as Xn, wr as Zn, wt as Qn, x as $n, xn as er, xr as tr, xt as nr, y as rr, yn as ir, yr as ar, yt as or, z as sr, zn as cr, zr as lr, zt as ur } from "./@global-configuration-CBGz_rZL.js";
import { $ as dr, $t as fr, A as pr, At as mr, B as hr, Bt as gr, C as _r, Cn as vr, Ct as yr, D as br, Dt as xr, E as Sr, Et as Cr, F as wr, Ft as Tr, G as Er, Gt as Dr, H as Or, Ht as kr, I as Ar, It as jr, J as Mr, Jt as Nr, K as Pr, Kt as Fr, L as Ir, Lt as Lr, M as Rr, Mt as zr, N as Br, Nt as Vr, O as Hr, Ot as Ur, P as Wr, Pt as Gr, Q as Kr, Qt as qr, R as Jr, Rt as Yr, S as Xr, Sn as Zr, St as Qr, T as $r, Tn as ei, Tt as ti, U as ni, Ut as ri, V as ii, Vt as ai, W as oi, Wt as si, X as ci, Xt as li, Y as ui, Yt as di, Z as fi, Zt as pi, _ as mi, _n as hi, _t as gi, a as _i, an as vi, at as yi, b as bi, bn as xi, bt as Si, c as Ci, cn as wi, ct as Ti, d as Ei, dn as Di, en as Oi, et as ki, f as Ai, fn as ji, ft as Mi, g as Ni, gn as Pi, gt as Fi, h as Ii, hn as Li, ht as Ri, i as zi, in as Bi, it as Vi, jt as Hi, k as Ui, kt as Wi, l as Gi, ln as Ki, m as qi, mn as Ji, mt as Yi, n as Xi, nn as Zi, nt as Qi, o as $i, on as ea, ot as ta, p as na, pn as ra, pt as ia, q as aa, qt as oa, r as sa, rn as ca, rt as la, s as ua, sn as da, st as fa, t as pa, tn as ma, tt as ha, u as ga, un as _a, v as va, vn as ya, vt as ba, w as xa, wt as Sa, x as Ca, xn as wa, xt as Ta, y as Ea, yn as Da, yt as Oa, z as ka, zt as Aa } from "./@software-distribution-hub-BL7eaG_S.js";
import { a as ja, i as Ma, n as Na, o as Pa, r as Fa, t as Ia } from "./@vendor-mU5RMT5J.js";
import { i as La, n as Ra, r as za, t as Ba } from "./RuntimeParameters-C_nFSYC5.js";
import { Fragment as Va, cloneElement as Ha, createContext as Ua, lazy as Wa, memo as Ga, useCallback as Ka, useContext as qa, useEffect as k, useMemo as A, useRef as Ja, useState as j } from "react";
import { ACTION_STATE as Ya, AIAgentContextSourceType as Xa, ALLOW_ACTION_OUTSIDE_FOCUS_TRAP as Za, ALL_NAMESPACE_OPTION as Qa, APIResponseHandler as $a, API_STATUS_CODES as eo, API_TOKEN_PREFIX as to, APPROVAL_MODAL_TYPE as no, AboutDevtronBody as ro, ActionMenu as io, ActivateLicenseDialog as ao, ActivityIndicator as oo, AddCDButton as so, AddCDPositions as co, AnimatePresence as lo, AnimatedDeployButton as uo, ApiQueuingWithBatch as fo, AppStatus as po, AppThemeType as mo, AppType as ho, ApplyPolicyToStage as go, ApprovalRuntimeStateType as _o, BASE_ROUTES as vo, Backdrop as yo, BackupAndScheduleListViewEnum as bo, BackupLocationsTypes as xo, Badge as So, BreadCrumb as Co, BreadcrumbStore as wo, BreadcrumbText as To, BuildInfraToleranceEffectType as Eo, BulkEditVersion as Do, BulkOperations as Oo, BulkSelection as ko, BulkSelectionEvents as Ao, BulkSelectionProvider as jo, Button as M, ButtonComponentType as N, ButtonStyleType as P, ButtonVariantType as F, ButtonWithLoader as Mo, CDMaterialResourceQuery as No, CDMaterialServiceEnum as Po, CHART_COLORS as Fo, CHECKBOX_VALUE as Io, CLUSTER_PROVIDER_TO_ICON_NAME as Lo, CLUSTER_PROVIDER_TO_LABEL as Ro, CONFIGURATION_TYPE_OPTIONS as zo, CONTACT_SUPPORT_LINK as Bo, CORDON_NODE_MODAL_MESSAGING as Vo, Card as Ho, Chart as Uo, Checkbox as Wo, Chip as Go, ClearIndicator as Ko, ClipboardButton as qo, ClusterStatusIcon as Jo, ClusterStatusType as Yo, CodeEditor as Xo, Collapse as Zo, CollapsibleList as Qo, CompareFromApprovalOptionsValuesType as $o, ComponentSizeType as I, ConditionalWrap as es, ConfigToolbarPopupNodeType as ts, ConfirmationModal as ns, ConfirmationModalVariantType as rs, ConsequenceAction as is, CostBreakdownItemViewParamsType as as, CostBreakdownViewType as L, CustomInput as os, DATE_TIME_FORMATS as ss, DATE_TIME_FORMAT_STRING as cs, DC_DELETE_SUBTITLES as ls, DEFAULT_LOCKED_KEYS_CONFIG as us, DEFAULT_ROUTE_PROMPT_MESSAGE as ds, DEFAULT_SECRET_PLACEHOLDER as fs, DELETE_NODE_MODAL_MESSAGING as ps, DEPLOYMENT_WINDOW_TYPE as ms, DEVTRON_AI_URL as hs, DOCUMENTATION as gs, DOCUMENTATION_HOME_PAGE as _s, DRAIN_NODE_MODAL_MESSAGING as vs, DTApplicationMetricsFormField as ys, DTSwitch as bs, DateTimePicker as xs, DebouncedSearch as Ss, DefaultUserKey as Cs, DeleteCINodeButton as ws, DeleteConfirmationModal as Ts, DependencyType as Es, DeploymentNodeType as Ds, DeploymentPolicy as Os, DetectBottom as ks, DevtronCopyright as As, DevtronLicenseCard as js, DevtronProgressing as Ms, DocLink as Ns, DraftState as Ps, DraggableButton as Fs, DraggablePositionVariant as Is, DraggableWrapper as Ls, Drawer as Rs, DryRunEditorMode as zs, DynamicDataTable as Bs, DynamicDataTableRowDataType as Vs, EMPTY_STATE_STATUS as Hs, ERROR_STATUS_CODE as Us, EXCLUDED_IMAGE_TOOLTIP as Ws, EnvironmentSelector as Gs, ErrorScreenManager as Ks, ErrorScreenNotAuthorized as qs, ExcludedImageNode as Js, ExportToCsv as Ys, FeatureTitleWithInfo as Xs, FilterChips as Zs, FilterConditionType as Qs, FilterSelectPicker as $s, FilterStates as ec, FiltersTypeEnum as tc, ForceDeleteOption as nc, GUIViewError as rc, GVK_FILTER_API_VERSION_QUERY_PARAM_KEY as ic, GVK_FILTER_KIND_QUERY_PARAM_KEY as ac, GenericEmptyState as R, GenericFilterEmptyState as oc, GenericInfoCardBorderVariant as sc, GenericModal as cc, GenericSectionErrorState as lc, GetTemplateAPIRouteType as uc, GitProviderIcon as dc, Grid as fc, GroupedFilterSelectPicker as pc, HIDE_SUBMIT_BUTTON_UI_SCHEMA as mc, INVALID_LICENSE_KEY as hc, Icon as z, Illustration as gc, ImageCard as _c, ImageCardAccordion as vc, ImageType as yc, ImageWithFallback as bc, InfoBlock as xc, InfoBlockVariant as Sc, InfoIconTippy as Cc, InstallationClusterStatus as wc, InstallationFingerprintInfo as Tc, InvalidYAMLTippyWrapper as Ec, K8S_EMPTY_GROUP as Dc, K8sResourcePayloadAppType as Oc, KeyValueTable as kc, LARGE_PAGE_SIZE_OPTIONS as Ac, LicenseInfoDialogType as jc, LicenseStatus as Mc, LoadingCard as Nc, LoadingDonutChart as Pc, MODAL_TYPE as Fc, MODES as Ic, MarkDown as Lc, MaterialDataSource as Rc, MetricsInfoCard as zc, MetricsInfoLoadingCard as Bc, ModalSidebarPanel as Vc, ModuleNameMap as Hc, ModuleStatus as Uc, NestedBreadCrumb as Wc, NodeDrainOptions as Gc, Nodes as Kc, NumbersCount as qc, OPEN_NEW_TICKET as Jc, OVERVIEW_PAGE_SIZE_OPTIONS as Yc, Option as Xc, OverrideMergeStrategyType as Zc, PageHeader as Qc, Pagination as $c, PaginationEnum as el, PipelineStageTaskActionModalType as tl, PluginImageContainer as nl, PluginRequiredStage as rl, PluginType as il, PolicyKindType as al, Popover as ol, PopupMenu as sl, PortalContainer as cl, ProdNonProdSelectValueTypes as ll, Progressing as ul, PromiseAllStatusType as dl, PromoetheusConfigCard as fl, ProtectConfigTabsType as pl, REGISTRY_TYPE_MAP as ml, REMOTE_CONNECTION_TYPE_LABEL_MAP as hl, RJSFForm as gl, ROUTER_URLS as B, ROUTES as _l, RadioGroup as vl, RadioGroupItem as yl, RefVariableType as bl, RegistryIcon as xl, Reload as Sl, RemoteConnectionType as Cl, ReportTabEmptyState as wl, RepositoryAction as Tl, ResourceBrowserActionMenuEnum as El, ResourceKindType as Dl, ResourceRecommenderHeaderType as Ol, ResourceVersionType as kl, ResponseHeaders as Al, SCHEMA_07_VALIDATOR as jl, SERVER_MODE as Ml, STAGE_TYPE as Nl, STRATEGY_TYPE_TO_TITLE_MAP as Pl, ScannedByToolModal as Fl, SearchBar as Il, SectionEmptyState as Ll, SecurityDetailsCards as Rl, SegmentedBarChart as zl, SegmentedControl as Bl, SelectAllDialogStatus as Vl, SelectPicker as V, SelectPickerVariantType as Hl, ServerError as Ul, ServerErrors as Wl, SideNavigation as Gl, SidePanelTab as Kl, SortableTableHeaderCell as ql, SortingOrder as Jl, SourceTypeMap as Yl, StatusComponent as Xl, StatusType as Zl, TARGET_IDS as Ql, TARGET_K8S_VERSION_SEARCH_KEY as $l, TOAST_ACCESS_DENIED as eu, TOKEN_COOKIE_NAME as tu, TabGroup as nu, Table as ru, TableSignalEnum as iu, TagsContainer as au, Textarea as ou, TippyCustomized as su, TippyTheme as cu, ToastManager as H, ToastVariantType as U, Tooltip as W, TreeView as lu, TriggerTypeMap as uu, UNCHANGED_ARRAY_ELEMENT_SYMBOL as du, UNSAVED_CHANGES_PROMPT_MESSAGE as fu, URLProtocolType as pu, URLS as mu, URL_FILTER_KEYS as hu, UserIdentifier as gu, UserListSortableKeys as _u, ViewIsPipelineRBACConfiguredRadioTabs as vu, VirtualClusterSidebar as yu, VirtualizedList as bu, VisibleModal as xu, VisibleModal2 as Su, WorkflowNodeType as Cu, WorkflowOptionsModal as wu, YAMLStringify as Tu, ZERO_TIME_STRING as Eu, abortPreviousRequests as Du, applyCompareDiffOnUneditedDocument as Ou, buildObjectFromPath as ku, capitalizeFirstLetter as Au, commonSelectStyles as ju, convertJSONPointerToJSONPath as Mu, copyToClipboard as Nu, cordonNodeCapacity as Pu, createNewResource as Fu, createResourceRequestBody as Iu, dateComparatorBySortOrder as Lu, deleteNodeCapacity as Ru, deleteResource as zu, drainNodeCapacity as Bu, explainCronExpression as Vu, flatMapOfJSONPaths as Hu, formatNumberToCurrency as Uu, genericCDMaterialsService as Wu, get as G, getAllClusterListMin as Gu, getAlphabetIcon as Ku, getAppOptionsGroupedByProjects as qu, getApplicationManagementBreadcrumb as Ju, getAppsInfoForEnv as Yu, getClusterListRaw as Xu, getClusterOptions as Zu, getComponentSpecificThemeClass as Qu, getConfirmationLabel as $u, getCookie as ed, getDefaultConfig as td, getDetailedClusterList as nd, getDockerRegistriesListMin as rd, getEnvironmentOptionsGroupedByClusters as id, getGitProvidersListMin as ad, getGroupVersionFromApiVersion as od, getHandleOpenURL as sd, getIframeWithDefaultAttributes as cd, getInfrastructureManagementBreadcrumb as ld, getInvalidTippyContent as ud, getIsApprovalPolicyConfigured as dd, getIsMaterialInfoAvailable as fd, getIsRequestAborted as pd, getK8sResourceList as md, getK8sResourceListPayload as hd, getNullValueFromType as gd, getPluginsDetail as _d, getPolicyApiUrl as vd, getProjectOptions as yd, getRandomColor as bd, getResourceApiUrl as xd, getResourceGroupListRaw as Sd, getSanitizedIframe as Cd, getSchemaPathToUpdatePathMap as wd, getSecurityCenterBreadcrumb as Td, getSecurityScan as Ed, getSelectPickerOptionByValue as Dd, getSelectPickerOptionsByValue as Od, getSortedVulnerabilities as kd, getStageTitle as Ad, getTTLInHumanReadableFormat as jd, getTeamListMin as Md, getTemplateAPIRoute as Nd, getTimeDifference as Pd, getTotalVulnerabilityCount as Fd, getUniqueId as Id, getUpdatedPluginStore as Ld, getUrlWithSearchParams as Rd, getUserPreferences as zd, handleAddCD as Bd, handleAnalyticsEvent as Vd, handleRedirectToLicenseActivation as Hd, handleUTCTime as Ud, hasHashiOrAWS as Wd, highlightSearchText as Gd, isAWSCodeCommitURL as Kd, isImageActiveOnEnvironment as qd, isNullOrUndefined as Jd, joinObjects as Yd, logExceptionToSentry as Xd, motion as Zd, multiSelectStyles as Qd, noop as $d, numberComparatorBySortOrder as ef, parseGetResourceScanDetailsResponse as tf, post as nf, prefixZeroIfSingleDigit as rf, preventDefault as af, processDeployedTime as of, put as sf, recursivelyRemoveSymbolFromArraysInObject as cf, requiredField as lf, showError as K, stopPropagation as uf, stringComparatorBySortOrder as df, trash as ff, triggerCDNode as pf, updateUserPreferences as mf, useAsync as hf, useBreadcrumb as gf, useBulkSelection as _f, useClickOutside as vf, useDownload as yf, useEffectAfterMount as bf, useForm as xf, useGetResourceKindsOptions as Sf, useGetUserRoles as Cf, useInfiniteQuery as wf, useMainContext as Tf, useMutation as Ef, usePopover as Df, usePrompt as Of, useQuery as q, useQueryClient as kf, useRegisterShortcut as Af, useSearchString as jf, useStateFilters as Mf, useTheme as Nf, useUrlFilters as Pf, useUserEmail as Ff, validateAppName as If, validateCronExpression as Lf, validateDescription as Rf, validateIframe as zf, validateName as Bf, validateProtocols as Vf, validateTagKeyValue as Hf, validateTagValue as Uf } from "@devtron-labs/devtron-fe-common-lib";
import { Link as Wf, NavLink as Gf, Navigate as Kf, Route as J, Routes as qf, generatePath as Y, matchPath as Jf, useLocation as Yf, useNavigate as X, useParams as Z } from "react-router-dom";
import Xf from "./assets/no-approved-images@2x.68e1cd3c.png";
import Zf from "./assets/no-artifact.fd2d84d9.webp";
import Qf from "yaml";
import $f from "./assets/empty-folder.4570c4ae.webp";
import ep, { components as tp } from "react-select";
import np from "./assets/no-data-in-cloud.741541cd.webp";
import rp from "./assets/ic-empty-virtual-deployment.cff37cf2.png";
import ip from "./assets/no-pending-action@2x.d2fb3b54.png";
import ap from "./assets/no-comments.5b278181.png";
import op from "./assets/active-latest.33674f1e.webp";
import sp from "./assets/empty-tag.7e4b779e.png";
import cp from "./assets/how-to-unblock.e29d6544.png";
import lp from "./assets/how-to-unblock-job.2561f2b5.png";
import up from "./assets/post-deployment-action-required.ec0af23d.png";
import dp from "./assets/pre-deployment-action-required.59bdaef8.png";
import fp from "./assets/inject-tag-info.b2eb5772.png";
import './assets/index.css';//#region src/Components/Tags/Tags.service.ts
var pp = (e) => G(`${O.TAGS}${e ? `?id=${e}` : ""}`), mp = (e, t) => {
	let n = { tags: e };
	return t ? sf(O.TAGS, n) : nf(O.TAGS, n);
}, hp = (e) => ff(O.TAGS, { ids: e }), gp = (e) => G(`${O.TAGS}/${O.filter}?projectId=${e}`), _p = (e) => ({
	data: {
		...e?.length ? { tagKey: {
			value: "",
			type: Vs.SELECT_TEXT,
			props: {
				placeholder: "Eg. owner-name",
				options: e.map((e) => ({
					label: e,
					value: e
				}))
			}
		} } : { tagKey: {
			value: "",
			type: Vs.TEXT,
			props: { placeholder: "Eg. owner-name" }
		} },
		tagValue: {
			value: "",
			type: Vs.TEXT,
			props: { placeholder: "Enter value" }
		}
	},
	id: (Date.now() * Math.random()).toString(16),
	customState: { propagateTag: !1 }
}), vp = (e) => ({
	value: e,
	type: Vs.TEXT,
	props: { placeholder: "Enter value" }
}), yp = (e, t) => ({
	value: e,
	type: Vs.DROPDOWN,
	props: {
		options: t.map((e) => ({
			label: e,
			value: e
		})),
		placeholder: "Select an option"
	}
}), bp = (e, t) => ({
	value: e,
	type: Vs.SELECT_TEXT,
	props: {
		options: t.map((e) => ({
			label: e,
			value: e
		})),
		placeholder: "Select an option"
	}
}), xp = (e, t) => !t || !t.choices ? vp(e) : t.blockCustomValue ? yp(e, t.choices) : bp(e, t.choices), Sp = (e, t) => {
	let n = t?.get(e.key), r = {
		data: {
			tagKey: {
				value: e.key,
				disabled: e.isMandatory,
				required: e.isMandatory,
				type: Vs.TEXT,
				...e.description ? { tooltip: { content: e.description } } : {},
				props: {}
			},
			tagValue: xp(n?.value || "", e.valueConstraint)
		},
		id: (Date.now() * Math.random()).toString(16),
		customState: {
			propagateTag: e.propagate || n?.propagate,
			disablePropagateButton: e.key === hs ? !0 : e.isMandatory && e.propagate,
			isCreatedWithoutProject: !1
		},
		disableDelete: e.isMandatory
	};
	return n && t.delete(e.key), r;
}, Cp = (e) => e.reduce((e, t) => (e[t.key] = t.description, e), {}), wp = (e, t) => {
	let n = Cp(t);
	return Array.from(e, ([e, t]) => {
		let { value: r, propagate: i, isCreatedWithoutProject: a } = t;
		return {
			data: {
				tagKey: {
					value: e,
					type: Vs.TEXT,
					props: {},
					...n[e] ? { tooltip: { content: n[e] } } : {}
				},
				tagValue: {
					value: r,
					type: Vs.TEXT,
					props: {}
				}
			},
			customState: {
				propagateTag: i,
				isCreatedWithoutProject: a
			},
			id: (Date.now() * Math.random()).toString(16)
		};
	});
}, Tp = (e) => {
	let t = /* @__PURE__ */ new Map();
	return e.forEach((e) => {
		t.set(e.data.tagKey.value, {
			value: e.data.tagValue.value,
			propagate: e.customState.propagateTag || !1,
			isCreatedWithoutProject: !0
		});
	}), t;
}, Q = kn(), Ep = ({ appType: e, tags: t, setTags: n, isCreateApp: r = !1, projectId: i, hidePropagateTags: a, configuredTagsMap: o, tagsError: s, setTagErrors: c }) => {
	let [, l] = hf(() => gp(i), [i], !!i), u = A(() => Tp(t.filter((e) => e.customState.isCreatedWithoutProject)), [t]), { mandatoryTags: d, suggestedTags: f, suggestedTagsChoices: p } = A(() => l?.result.reduce((e, t) => (t.isMandatory ? e.mandatoryTags.push(t) : (e.suggestedTags.push(t), e.suggestedTagsChoices.push(t.key)), e), {
		mandatoryTags: [],
		suggestedTags: [],
		suggestedTagsChoices: []
	}) ?? {
		mandatoryTags: [],
		suggestedTags: [],
		suggestedTagsChoices: []
	}, [l]);
	k(() => {
		n([
			...d.map((e) => Sp(e, o ?? u)),
			...o || u ? wp(o ?? u, f) : [],
			_p(p)
		]);
	}, [d]);
	let m = (e, r, a) => {
		let o = structuredClone(s);
		o[e.id] || (o[e.id] = {
			tagKey: {
				isValid: !0,
				errorMessages: []
			},
			tagValue: {
				isValid: !0,
				errorMessages: []
			}
		}), r === "tagKey" ? o[e.id].tagKey = Hf(a) : o[e.id].tagValue = Uf(a, e.data.tagKey.value);
		let l = t.map((t) => {
			if (t.id === e.id && r === "tagKey" && p.some((e) => a === e)) {
				let e = f.find((e) => e.key === a);
				return {
					...t,
					data: {
						tagKey: {
							...t.data.tagKey,
							value: a
						},
						tagValue: xp("", e.valueConstraint)
					},
					customState: {
						...t.customState,
						propagateTag: a === hs ? !1 : e.propagate
					}
				};
			}
			return t.id === e.id ? {
				...t,
				data: {
					...t.data,
					[r]: {
						...t.data[r],
						value: a
					}
				},
				customState: {
					...t.customState,
					...i ? {} : { isCreatedWithoutProject: !0 },
					propagateTag: r === "tagKey" && a === hs ? !1 : t.customState.propagateTag
				}
			} : t;
		});
		c(o), n(l);
	};
	return /* @__PURE__ */ (0, Q.jsx)(au, {
		appType: e,
		rows: t,
		setRows: n,
		isCreateApp: r,
		...i ? { getEmptyRow: () => _p(p) } : {},
		onRowEdit: m,
		tagsError: s,
		setTagErrors: c,
		hidePropagateTags: a
	});
}, Dp = ({ prometheusConfig: e, handleOnChange: t, costModuleEnabled: n, toggleCostModule: r, onPrometheusAuthTypeChange: i, isGrafanaModuleInstalled: a, costModuleConfig: o, handleCostConfigChange: s, config: c, costModuleSchema: l }) => {
	let { installationStatus: u, installationError: d } = o || {}, f = a ? u === "Installing" ? "Cost module installation is in progress. Please wait..." : u === "Upgrading" ? "Cost module upgrade is in progress. Please wait..." : "" : "Please install Grafana module to enable cost tracking", p = (e) => {
		s(e.formData);
	}, m = () => u === "Failed" ? {
		variant: "error",
		heading: "Cost agent unavailable",
		description: d
	} : u === "Installing" || u === "Upgrading" ? {
		variant: "neutral",
		heading: "Cost agent is being installed",
		customIcon: /* @__PURE__ */ (0, Q.jsx)(z, {
			name: "ic-circle-loader",
			size: 18,
			color: "N700"
		})
	} : u === "Success" ? {
		variant: "success",
		heading: "Cost agent active",
		description: "The agent is installed and working as expected"
	} : null;
	return /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox-col flex-grow-1 dc__gap-20 p-20 cluster-cost-config",
		children: [
			/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox-col",
				children: [/* @__PURE__ */ (0, Q.jsx)("span", {
					className: "fs-16 fw-6 lh-1-5 cn-9",
					children: "Cost Visiblity"
				}), /* @__PURE__ */ (0, Q.jsx)("span", {
					className: "fs-13 fw-4 lh-1-5 cn-7",
					children: "Get insights into your infrastructure spending and cost optimization opportunity for this cluster"
				})]
			}),
			/* @__PURE__ */ (0, Q.jsx)("div", { className: "divider__secondary--horizontal" }),
			/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox-col dc__gap-16 bg__primary p-20 br-8 border__secondary",
				children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "flexbox dc__content-space dc__gap-16",
					children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
						className: "flexbox-col",
						children: [/* @__PURE__ */ (0, Q.jsx)("span", {
							className: "fs-13 fw-6 lh-1-5 cn-9",
							children: "Enable cost tracking"
						}), /* @__PURE__ */ (0, Q.jsx)("span", {
							className: "fs-12 fw-4 lh-1-5 cn-7",
							children: "Infrastructure cost tracking for this cluster with deep insights"
						})]
					}), /* @__PURE__ */ (0, Q.jsx)(bs, {
						name: "toggle-cost-tracking",
						ariaLabel: "Toggle cost tracking",
						isChecked: n,
						onChange: r,
						isDisabled: !!f,
						tooltipContent: f
					})]
				}), n && /* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "flexbox-col dc__gap-16",
					children: [m() && /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsx)(xc, { ...m() }), /* @__PURE__ */ (0, Q.jsx)("div", { className: "divider divider--n1" })] }), /* @__PURE__ */ (0, Q.jsx)(gl, {
						className: "w-100",
						schema: l,
						formData: c,
						onChange: p,
						experimental_defaultFormStateBehavior: { emptyObjectFields: "skipDefaults" },
						liveValidate: !0,
						uiSchema: mc
					})]
				})]
			}),
			n && /* @__PURE__ */ (0, Q.jsx)(fl, {
				prometheusConfig: e,
				handleOnChange: t,
				onPrometheusAuthTypeChange: i
			})
		]
	});
}, Op = /* @__PURE__ */ e(Fe(), 1), kp = ({ label: e, isActive: t, handleOpen: n, handleShowDeleteModal: r }) => /* @__PURE__ */ (0, Q.jsxs)("div", {
	className: `flexbox dc__align-items-center dc__gap-8 flex-grow-1 pr-8 dc__opacity-hover dc__opacity-hover--parent br-4 ${t ? "bcb-1" : "dc__hover-n50"}`,
	children: [/* @__PURE__ */ (0, Q.jsx)("button", {
		type: "button",
		className: "flex left dc__unset-button-styles flex-grow-1 py-8 pl-8",
		onClick: n,
		children: /* @__PURE__ */ (0, Q.jsx)("span", {
			className: `dc__truncate fs-13 fw-4 lh-1-5 ${t ? "cb-5" : "cn-9"}`,
			children: e
		})
	}), /* @__PURE__ */ (0, Q.jsx)(M, {
		dataTestId: "delete-thread-button",
		isOpacityHoverChild: !0,
		icon: /* @__PURE__ */ (0, Q.jsx)(z, {
			name: "ic-delete",
			color: null
		}),
		variant: F.borderLess,
		style: P.negative,
		ariaLabel: "Delete thread",
		onClick: r,
		size: I.xxs,
		showAriaLabelInTippy: !1
	})]
}), Ap = ({ date: e, list: t, handleChatSelect: n, selectedThreadId: r, getShowDeleteModalHandler: i, isExpandedHistoryView: a }) => {
	let o = (e) => () => {
		n(e);
	};
	return /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox-col",
		children: [/* @__PURE__ */ (0, Q.jsx)("div", {
			className: "px-8 py-4",
			children: /* @__PURE__ */ (0, Q.jsx)("span", {
				className: "fs-13 fw-6 lh-1-5 cn-7",
				children: (() => {
					let t = (0, Op.default)(), n = (0, Op.default)().subtract(1, "day"), r = (0, Op.default)(e);
					return r.isSame(t, "day") ? "Today" : r.isSame(n, "day") ? "Yesterday" : (0, Op.default)(e).format(ss.WEEKDAY_WITH_DATE_MONTH_AND_YEAR);
				})()
			})
		}), (t ?? []).map((e) => {
			let { threadId: t, threadName: n } = e;
			return /* @__PURE__ */ (0, Q.jsx)(kp, {
				label: n,
				isActive: a && r === t,
				handleOpen: o(e),
				handleShowDeleteModal: i(e)
			}, t);
		})]
	});
}, jp = () => /* @__PURE__ */ (0, Q.jsx)("div", {
	className: "flexbox-col dc__gap-12",
	children: [
		100,
		80,
		60
	].map((e) => /* @__PURE__ */ (0, Q.jsx)("div", {
		style: { width: `${e}px` },
		className: "h-20 shimmer"
	}, e))
}), Mp = ({ searchKey: e }) => wf({
	initialPageParam: 0,
	queryKey: ["ai-chat-history-infinite", e],
	queryFn: ({ signal: t, pageParam: n }) => nf(`${_l.ATHENA}/${O.LIST_THREADS}`, {
		limit: 20,
		offset: n || 0,
		sortBy: "createdAt",
		sortOrder: Jl.DESC,
		search: e || ""
	}, {
		isProxyHost: !0,
		signal: t
	}),
	getNextPageParam: (e, t) => e.result?.threads?.length < 20 ? void 0 : t.length * 20,
	select: (e) => ({
		pageParams: e?.pageParams,
		pages: (e?.pages || []).map((e) => e?.result || { threads: [] })
	})
}), Np = async (e) => {
	try {
		return await ff(`${_l.ATHENA}/${Y(O.CHAT_THREAD, { threadId: e })}`, null, { isProxyHost: !0 }), !0;
	} catch (e) {
		return K(e), !1;
	}
}, Pp = ({ handleChatSelect: e, selectedThread: t, isExpandedHistoryView: n, handleBackNavigation: r }) => {
	let { handleCreateNewChat: i } = Ta(), a = t?.threadId || "", [o, s] = j(""), [c, l] = j(!1), [u, d] = j(null), { isFetching: f, isError: p, hasNextPage: m, fetchNextPage: h, data: g, refetch: _ } = Mp({ searchKey: o }), [v, y] = j(t ? [t] : []);
	k(() => {
		if (!t) return;
		let e = v.findIndex((e) => e.threadId === t.threadId);
		if (e > -1) {
			let n = structuredClone(v);
			n[e] = t, y(n);
		} else y((e) => [...e, t]);
	}, [t]);
	let b = A(() => {
		let e = (g?.pages || []).reduce((e, t) => (t.threads.forEach((t) => {
			let n = t.createdAt.split("T")[0];
			e[n] || (e[n] = []), e[n].push(t);
		}), e), {});
		if (!o) {
			let t = Object.values(e).reduce((e, t) => (t.forEach((t) => {
				e[t.threadId] = !0;
			}), e), {});
			v.forEach((n) => {
				if (!t[n.threadId]) {
					let t = n.createdAt.split("T")[0];
					e[t] || (e[t] = []), e[t].unshift(n);
				}
			});
		}
		return e;
	}, [g, v]), x = A(() => Object.keys(b).sort(Lu), [b]), S = !f && !p && Object.keys(b).length === 0, C = S && !o, w = (e) => {
		s(e.trim());
	}, T = (e) => () => {
		d(e);
	}, ee = () => {
		d(null);
	};
	return /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsx)("div", {
		className: `${C ? "flex column flex-grow-1" : "flexbox-col"} ${n ? "border__primary--right dc__overflow-hidden" : " dc__overflow-auto"}`,
		children: C ? /* @__PURE__ */ (0, Q.jsx)(lc, {
			customIcon: /* @__PURE__ */ (0, Q.jsx)(z, {
				name: "ic-comment",
				color: null
			}),
			title: "No conversations yet",
			subTitle: "Your chat history will appear here once you start interacting with the AI Agent",
			description: ""
		}) : /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox dc__align-items-center dc__gap-8 p-12",
			children: [
				!n && r && /* @__PURE__ */ (0, Q.jsx)(M, {
					dataTestId: "back-button",
					icon: /* @__PURE__ */ (0, Q.jsx)(z, {
						name: "ic-caret-left",
						color: null
					}),
					onClick: r,
					variant: F.secondary,
					style: P.neutral,
					size: I.medium,
					ariaLabel: "Back Navigation",
					showAriaLabelInTippy: !1
				}),
				/* @__PURE__ */ (0, Q.jsx)("div", {
					className: "flex-grow-1",
					children: /* @__PURE__ */ (0, Q.jsx)(Il, {
						inputProps: {
							placeholder: "Search Chats",
							disabled: f
						},
						handleEnter: w,
						debounceTimeout: 300
					})
				}),
				n && /* @__PURE__ */ (0, Q.jsx)(M, {
					dataTestId: "new-chat",
					icon: /* @__PURE__ */ (0, Q.jsx)(z, {
						name: "ic-edit",
						color: null
					}),
					onClick: i,
					variant: F.secondary,
					style: P.neutral,
					ariaLabel: "New Chat",
					size: I.medium
				})
			]
		}), /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "p-12 flexbox-col dc__gap-8 flex-grow-1 dc__overflow-auto",
			children: [
				x.map((t) => /* @__PURE__ */ (0, Q.jsx)(Ap, {
					date: t,
					list: b[t],
					selectedThreadId: a,
					handleChatSelect: e,
					getShowDeleteModalHandler: T,
					isExpandedHistoryView: n
				}, t)),
				f ? /* @__PURE__ */ (0, Q.jsx)(jp, {}) : p ? /* @__PURE__ */ (0, Q.jsx)(lc, {
					subTitle: "",
					reload: h
				}) : S ? /* @__PURE__ */ (0, Q.jsx)("span", {
					className: "fs-13 fw-4 lh-20 cn-8",
					children: "No matching chats"
				}) : null,
				!f && m && /* @__PURE__ */ (0, Q.jsx)(ks, {
					hasError: p,
					callback: h
				})
			]
		})] })
	}), !!u && /* @__PURE__ */ (0, Q.jsx)(ns, {
		variant: rs.delete,
		title: "Delete Chat",
		subtitle: `This will delete ${u.threadName}.`,
		handleClose: ee,
		buttonConfig: {
			primaryButtonConfig: {
				text: "Delete",
				onClick: async () => {
					l(!0);
					let e = await Np(u.threadId);
					l(!1), e && (ee(), y((e) => e.filter((e) => e.threadId !== u.threadId)), a === u.threadId && i(), await _());
				},
				isLoading: c
			},
			secondaryButtonConfig: {
				text: "Cancel",
				onClick: ee
			}
		}
	})] });
}, Fp = () => {
	let { handleThreadChange: e, handleCreateNewChat: t, selectedThread: n, refetchInitialConversation: r, isFetchingInitialConversation: i, initialConversationError: a } = Ta();
	return /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "dc__grid chat-history__container dc__overflow-auto h-100",
		children: [/* @__PURE__ */ (0, Q.jsx)(Pp, {
			handleChatSelect: (t) => {
				n?.threadId !== t.threadId && e(t);
			},
			selectedThread: n,
			isExpandedHistoryView: !0
		}), /* @__PURE__ */ (0, Q.jsx)($a, {
			isLoading: i,
			progressingProps: { pageLoader: !0 },
			error: a,
			errorScreenManagerProps: {
				code: a?.code,
				reload: r,
				on404Redirect: t
			},
			children: /* @__PURE__ */ (0, Q.jsx)(Xp, { isExpandedHistoryView: !0 })
		})]
	});
}, Ip = ({ context: e }) => /* @__PURE__ */ (0, Q.jsxs)("div", {
	className: "dc__grid dc__gap-6 chip-tooltip__container",
	children: [
		/* @__PURE__ */ (0, Q.jsx)(z, {
			name: Sa[e.source],
			size: 14,
			color: "white"
		}),
		/* @__PURE__ */ (0, Q.jsx)("span", {
			className: "fs-11 fw-6 lh-1-5",
			children: ti[e.source]
		}),
		/* @__PURE__ */ (0, Q.jsx)("span", {
			className: "dc__grid dc__align-self-stretch dc__content-center dc__no-shrink",
			children: /* @__PURE__ */ (0, Q.jsx)("span", { className: "dc__inline-block w-1 bcn-2 h-100 br-2" })
		}),
		(() => {
			switch (e.source) {
				case Xa.APP_DETAILS: return /* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "flexbox-col dc__gap-2",
					children: [
						/* @__PURE__ */ (0, Q.jsxs)("div", {
							className: "dc__grid app-details-context__container dc__gap-4 fs-12 lh-1-5",
							children: [/* @__PURE__ */ (0, Q.jsx)("span", {
								className: "fw-4",
								children: "App"
							}), /* @__PURE__ */ (0, Q.jsx)("span", {
								className: "fw-6 dc__truncate",
								children: e.data.appName || "Unknown App"
							})]
						}),
						e.data.envName && /* @__PURE__ */ (0, Q.jsxs)("div", {
							className: "dc__grid app-details-context__container dc__gap-4 fs-12 lh-1-5",
							children: [/* @__PURE__ */ (0, Q.jsx)("span", {
								className: "fw-4",
								children: "Env"
							}), /* @__PURE__ */ (0, Q.jsx)("span", {
								className: "fw-6 dc__truncate",
								children: e.data.envName || "Unknown Env"
							})]
						}),
						e.data.namespace && /* @__PURE__ */ (0, Q.jsxs)("div", {
							className: "dc__grid app-details-context__container dc__gap-4 fs-12 lh-1-5",
							children: [/* @__PURE__ */ (0, Q.jsx)("span", {
								className: "fw-4",
								children: "Ns"
							}), /* @__PURE__ */ (0, Q.jsx)("span", {
								className: "fw-6 dc__truncate",
								children: e.data.namespace || "Unknown Namespace"
							})]
						})
					]
				});
				case Xa.RESOURCE_BROWSER_CLUSTER: return /* @__PURE__ */ (0, Q.jsx)("span", {
					className: "fs-11 fw-6 lh-1-5 dc__truncate",
					children: e.data.clusterName || "Unknown Cluster"
				});
				default: return null;
			}
		})()
	]
}), Lp = () => {
	let { aiAgentContext: e, debugAgentContext: t } = Tf(), n = t || e, { useCurrentContext: r, handleToggleUseCurrentContext: i } = Ta(), [a, o] = j(!1);
	return n ? /* @__PURE__ */ (0, Q.jsx)("div", {
		className: "p-8 flexbox dc__gap-8 dc__top-radius-8 bg__secondary w-100",
		children: /* @__PURE__ */ (0, Q.jsx)(W, {
			alwaysShowTippyOnHover: !0,
			content: r && a ? /* @__PURE__ */ (0, Q.jsx)("span", { children: "Remove context" }) : /* @__PURE__ */ (0, Q.jsx)(Ip, { context: n }),
			placement: a ? "top-start" : "top",
			children: r ? /* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "py-4 px-8 flexbox dc__align-items-center dc__gap-4 br-4 dc__visible-hover dc__visible-hover--parent dc__mxw-300 context-chip__container",
				children: [
					/* @__PURE__ */ (0, Q.jsx)("div", {
						className: "dc__visible-hover--hide-child dc__no-shrink icon-dim-14",
						children: /* @__PURE__ */ (0, Q.jsx)(z, {
							name: Sa[n.source],
							size: 14,
							color: "N700"
						})
					}),
					/* @__PURE__ */ (0, Q.jsx)("button", {
						type: "button",
						onClick: i,
						className: "dc__transparent flex dc__visible-hover--child context-chip__container--remove-icon p-0-imp",
						"aria-label": "Remove Context",
						onMouseEnter: () => {
							o(!0);
						},
						onMouseLeave: () => {
							o(!1);
						},
						children: /* @__PURE__ */ (0, Q.jsx)(z, {
							name: "ic-close-small",
							size: 14,
							color: null
						})
					}),
					yr(n)
				]
			}) : /* @__PURE__ */ (0, Q.jsxs)("button", {
				type: "button",
				className: "dc__transparent py-4 px-8 flexbox dc__align-items-center dc__gap-4 br-4 border__secondary-translucent bg__primary dc__mxw-300 attach-context__container",
				onClick: i,
				children: [/* @__PURE__ */ (0, Q.jsx)("div", {
					className: "icon-dim-14 dc__no-shrink attach-context__container--icon",
					children: /* @__PURE__ */ (0, Q.jsx)(z, {
						name: "ic-add",
						color: null,
						size: 14
					})
				}), /* @__PURE__ */ (0, Q.jsx)("span", {
					className: "fs-12 fw-4 lh-1-5 attach-context__container--text",
					children: "Attach Context"
				})]
			})
		})
	}) : null;
}, Rp = ({ messageId: e, handleClose: t }) => {
	let { selectedThread: n, handleFeedbackClick: r } = Ta(), [i, a] = j({}), [o, s] = j(""), c = () => {
		r({
			threadId: n?.threadId || "",
			messageId: e,
			feedbackStatus: "dislike",
			reasons: Object.entries(i).filter(([, e]) => e).map(([e]) => e),
			additionalDetails: o || null
		}), t();
	}, l = (e) => {
		s(e.target.value);
	}, u = (e) => () => {
		a((t) => ({
			...t,
			[e]: !t[e]
		}));
	};
	return /* @__PURE__ */ (0, Q.jsx)(ns, {
		variant: rs.custom,
		Icon: /* @__PURE__ */ (0, Q.jsx)(z, {
			name: "ic-medium-megaphone",
			size: 48,
			color: null
		}),
		title: "Help us improve",
		subtitle: "Your feedback helps make Devtron AI more accurate and useful. Let us know what didn't work.",
		handleClose: t,
		buttonConfig: {
			primaryButtonConfig: {
				onClick: c,
				text: "Submit Feedback",
				disabled: Object.values(i).every((e) => !e)
			},
			secondaryButtonConfig: {
				text: "Cancel",
				onClick: t
			}
		},
		children: /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox-col dc__gap-16",
			children: [/* @__PURE__ */ (0, Q.jsx)("div", {
				className: "flexbox-col",
				children: Object.entries(Cr).map(([e, t]) => /* @__PURE__ */ (0, Q.jsx)(Wo, {
					isChecked: !!i[e],
					value: Io.CHECKED,
					rootClassName: "mb-0 dc__align-self-start dc__no-shrink py-6",
					onChange: u(e),
					children: /* @__PURE__ */ (0, Q.jsx)("span", {
						className: "cn-9 fs-13 fw-4 lh-20",
						children: t
					})
				}, e))
			}), /* @__PURE__ */ (0, Q.jsx)(ou, {
				name: "additionalComments",
				label: "Additional details (optional)",
				placeholder: "Tell us what went wrong or how this response could be improved…",
				value: o,
				onChange: l
			})]
		})
	});
}, zp = ({ formData: e, isLastGroup: t }) => {
	let { handleInitiateStream: n } = Ta();
	return /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox-col br-12 border__secondary bg__primary dc__mxw-400",
		children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox dc__content-space dc__gap-16 p-20",
			children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox-col dc__gap-8",
				children: [/* @__PURE__ */ (0, Q.jsx)("h2", {
					className: "cn-9 fs-14 fw-6 lh-1-5 m-0",
					children: "Application is ready"
				}), t && /* @__PURE__ */ (0, Q.jsx)("p", {
					className: "m-0 fs-13 fw-4 lh-20",
					children: "Application is ready to deploy. Confirm to deploy"
				})]
			}), /* @__PURE__ */ (0, Q.jsx)(z, {
				name: "ic-check",
				size: t ? 36 : 20,
				color: "G500"
			})]
		}), t && /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox-col px-20 pb-16 dc__gap-12",
			children: [/* @__PURE__ */ (0, Q.jsx)(M, {
				dataTestId: "build-and-deploy-btn",
				size: I.small,
				text: "Build & deploy",
				startIcon: /* @__PURE__ */ (0, Q.jsx)(z, {
					name: "ic-rocket-launch",
					color: null
				}),
				onClick: async () => {
					await n({
						type: Ur.FORM_SUBMISSION,
						formData: e
					});
				}
			}), !!e.data?.appId && /* @__PURE__ */ (0, Q.jsx)(M, {
				dataTestId: "view-app-workflow",
				size: I.small,
				text: "View application workflow",
				startIcon: /* @__PURE__ */ (0, Q.jsx)(z, {
					name: "ic-visibility-on",
					color: null
				}),
				variant: F.secondary,
				component: N.link,
				linkProps: {
					to: `${mu.APPLICATION_MANAGEMENT_APP}/${e.data.appId}/trigger`,
					target: "_blank",
					rel: "noopener noreferrer"
				}
			})]
		})]
	});
}, Bp = ({ messageId: e, identifier: t, formData: n, isLastGroup: r }) => {
	let { handleCreateAppFormChange: i, isStreamingChat: a, handleInitiateStream: o } = Ta(), { data: s, isFetching: c, error: l, refetch: u } = q({
		queryKey: [`${t}-projects`],
		queryFn: () => yd(),
		select: (e) => (e || []).map(({ id: e, name: t }) => ({
			label: t,
			value: e
		}))
	}), { data: d, isFetching: f, error: p, refetch: m } = q({
		queryKey: [`${t}-environments`],
		queryFn: () => id(),
		select: (e) => (e || []).flatMap((e) => e.envList || []).map((e) => ({
			label: e.name,
			value: e.id
		})).sort((e, t) => df(e.label, t.label))
	}), { data: h, isFetching: g, error: _, refetch: v } = q({
		queryKey: [`${t}-docker-registries`],
		queryFn: ({ signal: e }) => rd(e),
		select: (e) => (e?.result || []).map((e) => ({
			label: e.id,
			value: e,
			startIcon: /* @__PURE__ */ (0, Q.jsx)(xl, { registryType: e.registryType })
		}))
	}), { data: y, isFetching: b, error: x, refetch: S } = q({
		queryKey: [`${t}-git-repositories`],
		queryFn: ({ signal: e }) => ad(e),
		select: (e) => (e?.result || []).map((e) => ({
			label: e.name,
			value: e,
			startIcon: /* @__PURE__ */ (0, Q.jsx)(dc, { gitRepoUrl: e.url })
		}))
	});
	k(() => {
		let r = (y || []).find((e) => e.value.name === "Github Public");
		r && !n.data.gitAccountId && i({
			messageId: e,
			identifier: t,
			action: "updateGitAccountId",
			payload: { gitAccountId: r.value.id }
		});
	}, [y]), k(() => {
		let r = (h || []).find((e) => e.value.isDefault);
		r && !n.data.dockerRegistry && i({
			messageId: e,
			identifier: t,
			action: "updateDockerRegistry",
			payload: { dockerRegistry: r.value.id }
		});
	}, [h]);
	let C = (n) => {
		i({
			messageId: e,
			identifier: t,
			action: "updateAppName",
			payload: { appName: n.target.value }
		});
	}, w = (n) => {
		i({
			messageId: e,
			identifier: t,
			action: "updateGitRepoUrl",
			payload: { gitRepoUrl: n.target.value }
		});
	}, T = (n) => {
		i({
			messageId: e,
			identifier: t,
			action: "updateProjectId",
			payload: { projectId: n.value }
		});
	}, ee = (n) => {
		i({
			messageId: e,
			identifier: t,
			action: "updateEnvironmentId",
			payload: { environmentId: n.value }
		});
	}, E = y?.find((e) => e.value.id === n.data.gitAccountId) || null, D = h?.find((e) => e.value.id === n.data.dockerRegistry) || null;
	return /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "dc__mxw-400 flexbox-col dc__content-space border__primary br-8 w-100",
		children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "py-8 flexbox-col flex-grow-1",
			children: [/* @__PURE__ */ (0, Q.jsx)("div", {
				className: "px-12 flexbox border__bottom--primary pt-8 pb-16",
				children: /* @__PURE__ */ (0, Q.jsx)("h2", {
					className: "cn-9 fs-13 fw-6 lh-1-5 m-0",
					children: "Create Application"
				})
			}), /* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox-col px-12 dc__gap-16",
				children: [
					/* @__PURE__ */ (0, Q.jsxs)("div", {
						className: "flexbox-col dc__gap-8",
						children: [
							/* @__PURE__ */ (0, Q.jsx)(os, {
								name: `${t}-app-name`,
								label: "Application Name",
								placeholder: "Eg. orchestrator, dashboard",
								required: !0,
								value: n.data.appName,
								onChange: C,
								error: n.error.appName,
								disabled: !r
							}),
							/* @__PURE__ */ (0, Q.jsx)(V, {
								inputId: `${t}-project-select`,
								placeholder: "Eg. core, infrastructure, platform",
								label: "Project",
								name: "projectId",
								required: !0,
								options: s || [],
								isLoading: c,
								optionListError: l,
								reloadOptionList: u,
								value: n.data.projectId && (s || []).find((e) => e.value === n.data.projectId) || null,
								onChange: T,
								error: n.error.projectId,
								isClearable: !1,
								isDisabled: !r
							}),
							/* @__PURE__ */ (0, Q.jsx)(V, {
								inputId: `${t}-environment-select`,
								placeholder: "Eg. dev, staging, production",
								label: "Environment",
								name: "environmentId",
								required: !0,
								options: d || [],
								isLoading: f,
								optionListError: p,
								reloadOptionList: m,
								onChange: ee,
								value: d?.find((e) => e.value === n.data.environmentId) || null,
								error: n.error.environmentId,
								isClearable: !1,
								isDisabled: !r
							})
						]
					}),
					/* @__PURE__ */ (0, Q.jsx)("div", { className: "divider w-100" }),
					/* @__PURE__ */ (0, Q.jsxs)("div", {
						className: "flexbox-col dc__gap-8",
						children: [/* @__PURE__ */ (0, Q.jsx)(V, {
							inputId: `${t}-git-account-select`,
							placeholder: "Select Git Account",
							label: "Git Account",
							name: "gitAccountId",
							required: !0,
							isLoading: b,
							optionListError: x,
							reloadOptionList: S,
							isOptionSelected: (e) => e.value.id === n.data.gitAccountId,
							value: E,
							options: y || [],
							onChange: (n) => {
								i({
									messageId: e,
									identifier: t,
									action: "updateGitAccountId",
									payload: { gitAccountId: n.value.id }
								});
							},
							error: n.error.gitAccountId,
							size: I.large,
							isClearable: !1,
							isDisabled: !r
						}), /* @__PURE__ */ (0, Q.jsx)(os, {
							name: `${t}-git-repo-url`,
							label: `Git Repository URL ${E ? `(use ${E.value.authMode === "SSH" ? "SSH" : "https"})` : ""}`,
							placeholder: Kd(E?.value?.url || "") ? "e.g. git-codecommit.ap-south-1.amazonaws.com/v1/repos/repo_name" : E?.value?.authMode === "SSH" ? "e.g. git@github.com:abc/xyz.git" : "e.g. https://gitlab.com/abc/xyz.git",
							required: !0,
							value: n.data.gitRepoUrl,
							onChange: w,
							error: n.error.gitRepoUrl,
							disabled: !r
						})]
					}),
					/* @__PURE__ */ (0, Q.jsx)("div", { className: "divider w-100" }),
					/* @__PURE__ */ (0, Q.jsxs)("div", {
						className: "flexbox-col dc__gap-8",
						children: [/* @__PURE__ */ (0, Q.jsx)(V, {
							inputId: `${t}-docker-registry-select`,
							placeholder: "Select Docker Registry",
							label: "Container Registry",
							name: "dockerRegistry",
							required: !0,
							options: h,
							isOptionSelected: (e) => e.value.id === n.data.dockerRegistry,
							isLoading: g,
							optionListError: _,
							reloadOptionList: v,
							value: D,
							error: n.error.dockerRegistry,
							onChange: (n) => {
								i({
									messageId: e,
									identifier: t,
									action: "updateDockerRegistry",
									payload: { dockerRegistry: n.value.id }
								});
							},
							size: I.large,
							isClearable: !1,
							isDisabled: !r
						}), /* @__PURE__ */ (0, Q.jsx)(os, {
							name: `${t}-docker-repo-url`,
							label: `Container Repository ${ml[D?.value?.registryType || ""]?.desiredFormat || ""}`,
							placeholder: ml[D?.value?.registryType || ""]?.placeholderText || "Enter repository name",
							required: !0,
							value: n.data.dockerRepository,
							error: n.error.dockerRepository,
							onChange: (n) => {
								i({
									messageId: e,
									identifier: t,
									action: "updateDockerRepository",
									payload: { dockerRepository: n.target.value }
								});
							},
							disabled: !r
						})]
					})
				]
			})]
		}), r && /* @__PURE__ */ (0, Q.jsx)("div", {
			className: "flexbox dc__content-end px-12 py-8",
			children: /* @__PURE__ */ (0, Q.jsx)(M, {
				dataTestId: "create-app-button",
				text: "Create Application",
				disabled: a,
				onClick: async () => {
					let { areErrorsPresent: r } = mr(n);
					if (r) {
						H.showToast({
							variant: U.error,
							description: "Please fix the errors in the form before submitting."
						}), i({
							messageId: e,
							identifier: t,
							action: "validateForm",
							payload: { validateFormData: n }
						});
						return;
					}
					await o({
						type: Ur.FORM_SUBMISSION,
						formData: n
					});
				}
			})
		})]
	});
}, Vp = ({ formData: e, messageId: t, identifier: n, isLastGroup: r }) => e.type === "createApp" ? /* @__PURE__ */ (0, Q.jsx)(Bp, {
	formData: e,
	messageId: t,
	identifier: n,
	isLastGroup: r
}) : e.type === "appCreatedReadyToDeploy" ? /* @__PURE__ */ (0, Q.jsx)(zp, {
	formData: e,
	isLastGroup: r
}) : null, Hp = ({ graphId: e, messageId: t, isExpandedHistoryView: n, title: r }) => {
	let { selectedThread: i } = Ta(), a = Ja(Id()), o = i?.threadId || null, { isFetching: s, error: c, data: l, refetch: u } = q({
		queryKey: [
			"ai-chat-graph-data",
			e,
			t,
			o
		],
		queryFn: ({ signal: n }) => Qr({
			graphId: e,
			messageId: t,
			threadId: o,
			signal: n
		})
	}), d = () => u(), f = () => l?.type === "pie" ? /* @__PURE__ */ (0, Q.jsx)("div", {
		className: "dc_max-width__max-content",
		children: /* @__PURE__ */ (0, Q.jsx)(Uo, {
			...l,
			id: a.current
		})
	}) : /* @__PURE__ */ (0, Q.jsx)(Uo, {
		...l,
		id: a.current
	});
	return n ? /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox-col dc__align-start p-20 dc__gap-20 br-8 border__primary bg__primary h-360",
		children: [r && /* @__PURE__ */ (0, Q.jsx)("span", {
			className: "cn-9 fs-14 fw-6 lh-1-5 dc__truncate",
			children: r
		}), /* @__PURE__ */ (0, Q.jsx)("div", {
			className: "flex-grow-1 flex w-100",
			children: s ? /* @__PURE__ */ (0, Q.jsx)(lc, {
				customIcon: /* @__PURE__ */ (0, Q.jsx)(z, {
					name: "ic-circle-loader",
					color: "N700"
				}),
				title: "Building visualization",
				subTitle: "Fetching data and building your visualization…",
				description: ""
			}) : c || !l ? /* @__PURE__ */ (0, Q.jsx)(lc, {
				title: "Failed to load visualization",
				subTitle: "The chart couldn't be generated. Try again.",
				description: "",
				reload: d
			}) : f()
		})]
	}) : /* @__PURE__ */ (0, Q.jsx)("div", {
		className: "flexbox-col dc__gap-12 dc__content-space h-100 flex-grow-1 dc__overflow-auto",
		children: /* @__PURE__ */ (0, Q.jsx)("div", {
			className: "flex-grow-1 dc__overflow-auto flex column p-12",
			children: /* @__PURE__ */ (0, Q.jsx)($a, {
				isLoading: s,
				progressingProps: { pageLoader: !0 },
				error: c,
				errorScreenManagerProps: {
					code: c?.code,
					reload: d
				},
				children: f()
			})
		})
	});
}, Up = ({ isExpandedHistoryView: e, graphId: t, title: n, messageId: r }) => {
	let { setTempAppWindowConfig: i } = Tf();
	return e ? /* @__PURE__ */ (0, Q.jsx)(Hp, {
		title: n,
		graphId: t,
		messageId: r,
		isExpandedHistoryView: e
	}) : /* @__PURE__ */ (0, Q.jsxs)("button", {
		type: "button",
		onClick: () => {
			i({
				open: !0,
				title: n || "Report",
				component: /* @__PURE__ */ (0, Q.jsx)(Hp, {
					title: n,
					graphId: t,
					messageId: r,
					isExpandedHistoryView: e
				})
			});
		},
		className: "dc__transparent br-12 border__primary-translucent p-12 flexbox dc__gap-8 dc__mxw-280 bg__hover",
		children: [/* @__PURE__ */ (0, Q.jsx)(z, {
			name: "ic-clipboard",
			size: 24,
			color: "N700"
		}), /* @__PURE__ */ (0, Q.jsxs)("span", {
			className: "flexbox-col dc__gap-4 dc__align-start",
			children: [/* @__PURE__ */ (0, Q.jsx)(W, {
				content: n || "View Report",
				children: /* @__PURE__ */ (0, Q.jsx)("span", {
					className: "dc__truncate cn-9 fs-13 fw-6 lh-1-5 dc__align-start",
					children: n || "View Report"
				})
			}), !!n && /* @__PURE__ */ (0, Q.jsx)("span", {
				className: "cn-7 fs-12 fw-4 lh-1-5 dc__align-start",
				children: "View Report"
			})]
		})]
	});
}, Wp = ({ messageToCopy: e, status: t, isSendingFeedback: n, messageId: r, handleShowFeedbackDialog: i }) => {
	let { handleFeedbackClick: a, selectedThread: o } = Ta();
	return /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox dc__align-items-center dc__gap-2",
		children: [/* @__PURE__ */ (0, Q.jsx)(qo, {
			content: e,
			size: I.small,
			variant: "borderLess"
		}), t === "none" ? /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsx)(M, {
			dataTestId: "like-message-button",
			variant: F.borderLess,
			style: P.neutral,
			size: I.small,
			icon: /* @__PURE__ */ (0, Q.jsx)(z, {
				name: "ic-thumb-up",
				color: null
			}),
			ariaLabel: "Like Message",
			showAriaLabelInTippy: !1,
			onClick: () => {
				a({
					messageId: r,
					threadId: o?.threadId || "",
					feedbackStatus: "like"
				});
			},
			disabled: n
		}), /* @__PURE__ */ (0, Q.jsx)(M, {
			dataTestId: "dislike-message-button",
			variant: F.borderLess,
			style: P.neutral,
			size: I.small,
			icon: /* @__PURE__ */ (0, Q.jsx)(z, {
				name: "ic-thumb-down",
				color: null
			}),
			ariaLabel: "Dislike Message",
			showAriaLabelInTippy: !1,
			onClick: () => {
				i(r);
			},
			disabled: n
		})] }) : /* @__PURE__ */ (0, Q.jsx)(M, {
			dataTestId: "revert-feedback-button",
			variant: F.borderLess,
			style: P.neutral,
			size: I.small,
			icon: /* @__PURE__ */ (0, Q.jsx)(z, {
				name: t === "like" ? "ic-thumb-up-fill" : "ic-thumb-down-fill",
				color: null
			}),
			ariaLabel: "Revert Feedback",
			showAriaLabelInTippy: !1,
			onClick: () => {
				a({
					messageId: r,
					threadId: o?.threadId || "",
					feedbackStatus: "none"
				});
			},
			disabled: n
		})]
	});
}, Gp = ({ context: e }) => /* @__PURE__ */ (0, Q.jsx)("div", {
	className: "flexbox w-100 dc__content-end",
	children: /* @__PURE__ */ (0, Q.jsx)(W, {
		alwaysShowTippyOnHover: !0,
		content: /* @__PURE__ */ (0, Q.jsx)(Ip, { context: e }),
		children: /* @__PURE__ */ (0, Q.jsxs)(Wf, {
			to: (() => {
				if (e.source === Xa.APP_DETAILS) switch (e.data.appType) {
					case "devtronHelmChart": return Y(B.INFRASTRUCTURE_MANAGEMENT_APP_DETAIL.DEVTRON_CHART, {
						appId: String(e.data.appId),
						envId: String(e.data.envId)
					});
					case "externalArgoApp": return Y(B.INFRASTRUCTURE_MANAGEMENT_APP_DETAIL.EXTERNAL_ARGO_APP, {
						clusterId: String(e.data.clusterId),
						appName: String(e.data.appName),
						namespace: String(e.data.namespace)
					});
					case "externalFluxApp": return Y(B.INFRASTRUCTURE_MANAGEMENT_APP_DETAIL.EXTERNAL_FLUX_APP, {
						clusterId: String(e.data.clusterId),
						appName: String(e.data.appName),
						namespace: String(e.data.namespace),
						templateType: String(e.data.fluxAppDeploymentType)
					});
					case "externalHelmChart": return Y(B.INFRASTRUCTURE_MANAGEMENT_APP_DETAIL.EXTERNAL_HELM_APP, {
						appId: String(e.data.appId),
						appName: String(e.data.appName)
					});
					default: return Y(B.DEVTRON_APP_DETAILS.ENV_DETAILS, {
						appId: String(e.data.appId),
						envId: String(e.data.envId)
					});
				}
				return Y(B.RESOURCE_BROWSER.CLUSTER_DETAILS.K8S_RESOURCE_LIST, {
					clusterId: String(e.data.clusterId),
					kind: Kc.Node,
					group: Dc
				});
			})(),
			className: "dc__mxw-300 flexbox dc__align-items-center dc__gap-4 py-4 px-8 br-8 previous-context-chip__container",
			children: [/* @__PURE__ */ (0, Q.jsx)(z, {
				name: Sa[e.source],
				size: 16,
				color: "B700"
			}), yr(e, !0)]
		})
	})
}), Kp = ({ title: e, steps: t, context: n }) => {
	let r = (e) => {
		if (!n) return null;
		if (e === "build_image") {
			let { appId: e } = n, { ciPipelineId: t } = n, { ciWorkflowId: r } = n;
			return !e || !t ? null : /* @__PURE__ */ (0, Q.jsx)(M, {
				dataTestId: "step-progress-build-image",
				icon: /* @__PURE__ */ (0, Q.jsx)(z, {
					name: "ic-arrow-square-out",
					color: null
				}),
				ariaLabel: "View build logs",
				showAriaLabelInTippy: !1,
				component: N.link,
				linkProps: {
					to: `${mu.APPLICATION_MANAGEMENT_APP}/${e}/${mu.APP_CI_DETAILS}/${t}/${r || ""}`,
					target: "_blank",
					rel: "noopener noreferrer"
				},
				variant: F.borderLess,
				size: I.xxs
			});
		}
		if (e === "deployment") {
			let { appId: e } = n, { environmentId: t } = n;
			return !e || !t ? null : /* @__PURE__ */ (0, Q.jsx)(M, {
				dataTestId: "step-progress-deployment",
				icon: /* @__PURE__ */ (0, Q.jsx)(z, {
					name: "ic-arrow-square-out",
					color: null
				}),
				ariaLabel: "View deployment details",
				showAriaLabelInTippy: !1,
				component: N.link,
				linkProps: {
					to: `${mu.APPLICATION_MANAGEMENT_APP}/${e}/${mu.APP_DETAILS}/${t}`,
					target: "_blank",
					rel: "noopener noreferrer"
				},
				variant: F.borderLess,
				size: I.xxs
			});
		}
		return null;
	};
	return /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox-col br-12 border__secondary bg__primary dc__mxw-400 p-20 dc__gap-8",
		children: [e && /* @__PURE__ */ (0, Q.jsx)("h2", {
			className: "m-0 cn-9 fs-13 fw-6 lh-1-5 dc__truncate",
			children: e
		}), t.map(({ id: e, status: t, label: n }) => /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox dc__gap-8",
			children: [/* @__PURE__ */ (0, Q.jsx)(z, {
				name: "ic-help-filled",
				size: 16,
				...xr[t]
			}), /* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox dc__gap-8",
				children: [/* @__PURE__ */ (0, Q.jsx)("span", {
					className: "cn-9 fs-13 fw-4 lh-1-5 dc__word-break flex-grow-1",
					children: n
				}), t !== "pending" && r(e)]
			})]
		}, e))]
	});
}, qp = ({ children: e, handleToggleOpen: t, isThinking: n }) => n ? /* @__PURE__ */ (0, Q.jsx)("div", {
	className: "flexbox dc__gap-8 dc__align-items-center",
	children: e
}) : /* @__PURE__ */ (0, Q.jsx)("button", {
	onClick: t,
	type: "button",
	"data-testid": "thought-bubble-heading-btn",
	className: "dc__transparent flexbox dc__gap-8 dc__align-items-center",
	children: e
}), Jp = ({ content: e, isThinking: t, hasReceivedMessageStream: n }) => {
	let [r, i] = j(t && !n);
	return k(() => {
		n && i(!1);
	}, [n]), /* @__PURE__ */ (0, Q.jsx)("div", {
		className: "pr-16",
		children: /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: `flexbox-col dc__gap-8 br-12 border__primary-translucent bg__primary py-8 px-12 thought-bubble__container ${r ? "dc__mxw-500" : "dc__mxw-132"}`,
			children: [/* @__PURE__ */ (0, Q.jsxs)(qp, {
				handleToggleOpen: () => {
					i((e) => !e);
				},
				isThinking: t,
				children: [/* @__PURE__ */ (0, Q.jsx)(z, {
					name: "ic-brain",
					color: "N900",
					size: 16
				}), /* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "flexbox dc__gap-4 dc__align-items-center",
					children: [/* @__PURE__ */ (0, Q.jsx)("span", {
						className: `fs-13 fw-6 lh-1-5 cn-9 ${t ? "dc__loading-dots" : ""}`,
						children: t ? "Thinking" : "Thoughts"
					}), !t && /* @__PURE__ */ (0, Q.jsx)(z, {
						name: "ic-caret-down-small",
						rotateBy: r ? 180 : 0,
						color: "N700",
						size: 16
					})]
				})]
			}), r && !!e?.length && /* @__PURE__ */ (0, Q.jsx)("ul", {
				className: "pl-12 m-0-imp",
				children: e.map((e, t) => /* @__PURE__ */ (0, Q.jsx)("li", {
					className: "m-0 fs-13 lh-20 cn-9 fw-4",
					children: /* @__PURE__ */ (0, Q.jsx)(Lc, {
						className: "fs-13 fw-4 lh-20 cn-9 m-0 dc__no-border dc__word-break dc__text-wrap dc__open-sans p-0-imp w-100",
						markdown: e
					})
				}, t))
			})]
		})
	});
}, Yp = ({ content: e }) => /* @__PURE__ */ (0, Q.jsx)("div", {
	className: "flexbox w-100 dc__content-end user-chat-bubble__container",
	children: /* @__PURE__ */ (0, Q.jsx)("div", {
		className: "dc__mxw-500 py-8 px-12 dc__align-items-center dc__gap-4 br-12 border__secondary-translucent bcn-1",
		children: /* @__PURE__ */ (0, Q.jsx)(Lc, {
			className: "fs-14 fw-4 lh-20 cn-9 m-0 dc__no-border dc__word-break dc__text-wrap dc__open-sans p-0-imp w-100",
			markdown: e
		})
	})
}), Xp = ({ isExpandedHistoryView: e, showThreadHistory: t, handleHideThreadHistory: n }) => {
	let r = Ja(null), [i, a] = j(0), [o, s] = j(0), [c, l] = j(null), { messageInput: u, isStreamingChat: d, chatMessageGroups: f, handleMessageInputChange: p, handleInitiateStream: m, onScroll: h, onScrollToBottomClick: g, animationControl: _, handleUpdateScrollContainerRef: v, selectedThread: y, handleThreadChange: b, textAreaRef: x, handleUpdateTextAreaRef: S, handleAbortMessage: C, handleUpdateLastUserMessageRef: w, isAbortingMessage: T } = Ta(), { setTempAppWindowConfig: ee } = Tf(), E = Ka((e) => {
		e.key === "Enter" && !e.shiftKey && (e.preventDefault(), r.current?.click());
	}, []);
	k(() => () => {
		w(null), x.current?.removeEventListener("keydown", E);
	}, []), k(() => {
		g(!1);
	}, []);
	let D = () => {
		g();
	}, te = async () => {
		await m({});
	}, ne = (e) => {
		n?.(), y?.threadId !== e.threadId && (ee({
			open: !1,
			title: null,
			url: null,
			component: null,
			image: null
		}), b(e));
	}, re = `calc(100vh - 122px - ${o}px - ${i}px)`, ie = A(() => f.map((e, t) => ({
		...e,
		index: t
	})).filter((e) => e.senderType === Wi.USER), [f]), ae = (e) => {
		l(e);
	};
	return /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [
		e || t || !f.length ? null : /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "p-12 flexbox dc__align-items-center dc__gap-8",
			children: [/* @__PURE__ */ (0, Q.jsx)(z, {
				name: "ic-chat-circle-dots",
				size: 20,
				color: "N900"
			}), /* @__PURE__ */ (0, Q.jsx)("span", {
				className: "dc__truncate cn-9 fs-13 fw-6 lh-1-5",
				children: y?.threadName || "Untitled Chat"
			})]
		}),
		/* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox-col dc__content-space dc__align-items-center flex-grow-1 h-100 dc__overflow-auto pb-12",
			children: [/* @__PURE__ */ (0, Q.jsx)("div", {
				onScroll: h,
				ref: v,
				className: `flexbox-col flex-grow-1 w-100 dc__overflow-auto dc__align-items-center h-100 ${e || t ? "" : "px-12"}`,
				children: /* @__PURE__ */ (0, Q.jsx)("div", {
					className: `dc__mxw-800 flexbox-col flex-grow-1 w-100 dc__gap-20 ${e ? "py-8" : ""} ${t ? "dc__overflow-auto" : ""}`,
					children: t ? /* @__PURE__ */ (0, Q.jsx)(Pp, {
						handleChatSelect: ne,
						selectedThread: y,
						isExpandedHistoryView: !1,
						handleBackNavigation: n
					}) : f.length === 0 ? /* @__PURE__ */ (0, Q.jsxs)("div", {
						className: "flex column dc__gap-16 flex-grow-1",
						children: [/* @__PURE__ */ (0, Q.jsx)("div", {
							className: "enable-svg-animation--infinite flex",
							children: /* @__PURE__ */ (0, Q.jsx)(z, {
								name: "ic-devtron-ai",
								color: null,
								size: 48
							})
						}), /* @__PURE__ */ (0, Q.jsxs)("div", {
							className: "flexbox-col dc__gap-8 dc__align-center",
							children: [/* @__PURE__ */ (0, Q.jsx)("h2", {
								className: "m-0 cn-9 fs-15 fw-6 lh-1-5",
								children: "Ask Devtron Expert"
							}), /* @__PURE__ */ (0, Q.jsx)("span", {
								className: "cn-8 fs-13 fw-4 lh-20",
								children: "Expert in Kubernetes, Devtron, and cloud provider issue resolution"
							})]
						})]
					}) : /* @__PURE__ */ (0, Q.jsx)(Q.Fragment, { children: f.map((t, n) => {
						let r = n === f.length - 1;
						if (t.senderType === Wi.USER) {
							let e = ie[ie.length - 1].index === n;
							return /* @__PURE__ */ (0, Q.jsxs)("div", {
								ref: (t) => {
									e && t && (w(t), t.offsetHeight !== i && a(t.offsetHeight));
								},
								className: "pl-16 flexbox-col dc__gap-8",
								children: [t.context && /* @__PURE__ */ (0, Q.jsx)(Gp, { context: t.context }), /* @__PURE__ */ (0, Q.jsx)(Yp, { content: t.content })]
							}, `${t.messageId}-user`);
						}
						return r && d && t.senderType === Wi.BOT && !t.messages?.length ? /* @__PURE__ */ (0, Q.jsx)("div", {
							className: "dc__mxw-800 flexbox-col flex-grow-1 w-100 dc__gap-8",
							style: { minHeight: re },
							children: d && /* @__PURE__ */ (0, Q.jsx)(Jp, {
								isThinking: !0,
								content: []
							})
						}) : /* @__PURE__ */ (0, Q.jsxs)("div", {
							className: "flexbox-col flex-grow-1 w-100 dc__gap-8 pb-8",
							style: r ? { minHeight: re } : {},
							children: [t.messages.map((n, i) => {
								switch (n.type) {
									case "thoughts": return /* @__PURE__ */ (0, Q.jsx)(Jp, {
										content: n.content,
										isThinking: d && r && i === t.messages.length - 1,
										hasReceivedMessageStream: i < t.messages.length - 1
									}, `${n.identifier}-thoughts`);
									case "text-message": return /* @__PURE__ */ (0, Q.jsx)(Lc, {
										className: "fs-13 fw-4 lh-20 cn-9 m-0 dc__no-border dc__word-break dc__text-wrap dc__open-sans p-0-imp w-100",
										markdown: n.content
									}, `${n.identifier}-text-message`);
									case "graph": return /* @__PURE__ */ (0, Q.jsx)(Up, {
										isExpandedHistoryView: e,
										graphId: n.graphProps.graphId,
										title: n.graphProps.title,
										messageId: t.messageId
									}, `${n.identifier}-graph`);
									case "form-data": return /* @__PURE__ */ (0, Q.jsx)(Vp, {
										formData: n.content,
										messageId: t.messageId,
										identifier: n.identifier,
										isLastGroup: r
									}, `${n.identifier}-form-data`);
									case "step-progress": return /* @__PURE__ */ (0, Q.jsx)(Kp, {
										title: n.content.title,
										steps: n.content.steps,
										context: n.content.context
									}, `${t.messageId}-${n.content.actionIdentifier}-step-progress`);
									default: return null;
								}
							}), (!r || !d) && /* @__PURE__ */ (0, Q.jsx)(Wp, {
								messageToCopy: t.messageToCopy,
								status: t.userFeedbackStatus,
								isSendingFeedback: t.isSendingFeedback || !1,
								messageId: t.messageId,
								handleShowFeedbackDialog: ae
							})]
						}, `${t.messageId}-bot`);
					}) })
				})
			}), !t && /* @__PURE__ */ (0, Q.jsxs)("div", {
				className: `flex column w-100 dc__align-items-center dc__mxw-800 dc__position-rel ${e ? "" : "px-12"}`,
				ref: (e) => {
					e && e.offsetHeight !== o && s(e.offsetHeight);
				},
				children: [
					/* @__PURE__ */ (0, Q.jsx)(Zd.div, {
						initial: { scale: 0 },
						animate: _,
						className: "dc__position-abs chat-container__scroll-to-bottom--button flex bg__primary br-8 dc__overflow-hidden shadow__card--20 border__primary-translucent",
						children: /* @__PURE__ */ (0, Q.jsx)(M, {
							dataTestId: "ai-chat__scroll-to-bottom",
							icon: /* @__PURE__ */ (0, Q.jsx)(z, {
								name: "ic-arrow-right",
								color: null,
								rotateBy: 90
							}),
							size: I.medium,
							variant: F.borderLess,
							style: P.neutral,
							onClick: D,
							ariaLabel: "Scroll to bottom",
							showAriaLabelInTippy: !1
						})
					}),
					/* @__PURE__ */ (0, Q.jsx)(Lp, {}),
					/* @__PURE__ */ (0, Q.jsxs)("div", {
						className: "chat-container__bottom-input--container flexbox-col dc__contain--paint br-8 border__primary-translucent shadow__card--10 w-100 bg__secondary dc__mxw-800",
						children: [/* @__PURE__ */ (0, Q.jsx)(ou, {
							name: "ai-chat-input",
							textareaRef: (e) => {
								x.current?.removeEventListener("keydown", E), S(e), e?.addEventListener("keydown", E);
							},
							value: u,
							placeholder: "Ask Devtron...",
							disabled: d,
							size: I.small,
							onChange: p,
							borderConfig: {
								top: !1,
								right: !1,
								bottom: !1,
								left: !1
							},
							borderRadiusConfig: {
								top: !1,
								right: !1,
								bottom: !1,
								left: !1
							},
							autoFocus: !0,
							disableResize: !0,
							newlineOnShiftEnter: !0
						}), /* @__PURE__ */ (0, Q.jsxs)("div", {
							className: "flexbox dc__content-end p-12 bg__secondary",
							children: [/* @__PURE__ */ (0, Q.jsx)("div", {
								style: { display: d ? "none" : "block" },
								children: /* @__PURE__ */ (0, Q.jsx)(M, {
									dataTestId: "ai-chat-send-button",
									icon: /* @__PURE__ */ (0, Q.jsx)(z, {
										name: "ic-arrow-right",
										rotateBy: -90,
										color: null
									}),
									ariaLabel: "Send message",
									showAriaLabelInTippy: !1,
									size: I.small,
									onClick: te,
									disabled: !u.trim() || d,
									ref: r
								})
							}), /* @__PURE__ */ (0, Q.jsx)("div", {
								style: { display: d ? "block" : "none" },
								children: /* @__PURE__ */ (0, Q.jsx)(M, {
									dataTestId: "abort-ai-chat-button",
									icon: /* @__PURE__ */ (0, Q.jsx)(z, {
										name: "ic-stop-fill",
										color: null
									}),
									variant: F.secondary,
									style: P.neutral,
									size: I.small,
									disabled: !d,
									ariaLabel: "Abort chat",
									showAriaLabelInTippy: !1,
									onClick: C,
									isLoading: T
								})
							})]
						})]
					})
				]
			})]
		}),
		c && /* @__PURE__ */ (0, Q.jsx)(Rp, {
			messageId: c,
			handleClose: () => {
				l(null);
			}
		})
	] });
}, Zp = ({ SidePanelHeaderActions: e }) => {
	let { handleCreateNewChat: t, initialConversationError: n, isFetchingInitialConversation: r, refetchInitialConversation: i } = Ta(), [a, o] = j(!1), { setTempAppWindowConfig: s, setSidePanelConfig: c, sidePanelConfig: { state: l } } = Tf(), u = () => {
		s({
			open: !0,
			title: "Ask AI",
			component: /* @__PURE__ */ (0, Q.jsx)(Fp, {}),
			customCloseConfig: {
				icon: /* @__PURE__ */ (0, Q.jsx)(zr, {}),
				beforeClose: () => {
					c({
						state: Kl.ASK_DEVTRON,
						docLink: null,
						isExpandedView: !1
					});
				}
			}
		}), setTimeout(() => {
			c({
				state: "closed",
				docLink: null,
				reinitialize: !1
			});
		}, 0);
	}, d = () => {
		o(!1);
	};
	return /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsx)(e, { children: l === Kl.ASK_DEVTRON && /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flex dc__gap-8",
		children: [
			!a && /* @__PURE__ */ (0, Q.jsx)(M, {
				dataTestId: "ai-chat__header--show-chat-history-btn",
				onClick: () => {
					o(!0);
				},
				icon: /* @__PURE__ */ (0, Q.jsx)(z, {
					name: "ic-clock-counterclockwise",
					color: null
				}),
				size: I.xs,
				variant: F.borderLess,
				ariaLabel: "Show Chat History",
				showAriaLabelInTippy: !1,
				style: P.neutral
			}),
			/* @__PURE__ */ (0, Q.jsx)(M, {
				dataTestId: "ai-chat__header--new-chat-btn",
				onClick: () => {
					t(), d(), s({
						open: !1,
						title: null,
						url: null,
						component: null,
						image: null
					});
				},
				icon: /* @__PURE__ */ (0, Q.jsx)(z, {
					name: "ic-edit",
					color: null
				}),
				size: I.xs,
				variant: F.borderLess,
				ariaLabel: "Open New Chat",
				showAriaLabelInTippy: !1,
				style: P.neutral
			}),
			/* @__PURE__ */ (0, Q.jsx)(M, {
				dataTestId: "ai-chat__header--expand-btn",
				onClick: u,
				icon: /* @__PURE__ */ (0, Q.jsx)(Hi, {}),
				size: I.xs,
				variant: F.borderLess,
				ariaLabel: "Expand Ask Devtron",
				showAriaLabelInTippy: !1,
				style: P.neutral
			})
		]
	}) }), /* @__PURE__ */ (0, Q.jsx)($a, {
		isLoading: r,
		customLoader: /* @__PURE__ */ (0, Q.jsx)("div", {
			className: "flex column flex-grow-1",
			children: /* @__PURE__ */ (0, Q.jsx)(z, {
				name: "ic-circle-loader",
				size: 36,
				color: "N600"
			})
		}),
		error: n,
		genericSectionErrorProps: {
			reload: i,
			title: "Failed to load conversation",
			description: "An error occurred while fetching the conversation. Please try again.",
			subTitle: ""
		},
		children: /* @__PURE__ */ (0, Q.jsx)(Xp, {
			showThreadHistory: a,
			handleHideThreadHistory: d
		})
	})] });
}, Qp = () => {
	let { setSidePanelConfig: e } = Tf(), { handleCreateNewChat: t } = Ta();
	return /* @__PURE__ */ (0, Q.jsx)(W, {
		content: "Ask Devtron AI",
		placement: "bottom",
		alwaysShowTippyOnHover: !0,
		delay: [500, null],
		children: /* @__PURE__ */ (0, Q.jsx)("button", {
			className: "enable-svg-animation--hover flex dc__no-background p-2 dc__outline-none-imp dc__no-border",
			onClick: () => {
				t(), Vd({
					category: "AI",
					action: "HELP_ASK_DEVTRON_AI"
				}), e((e) => ({
					...e,
					state: Kl.ASK_DEVTRON
				}));
			},
			type: "button",
			"aria-label": "Ask Devtron Expert",
			children: /* @__PURE__ */ (0, Q.jsx)(z, {
				name: "ic-devtron-ai",
				color: null,
				size: 28
			})
		})
	});
}, $p = (e) => /* @__PURE__ */ (0, Q.jsxs)("svg", {
	"data-style-override": "false",
	width: 250,
	height: 200,
	viewBox: "0 0 250 200",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [
		/* @__PURE__ */ (0, Q.jsx)("mask", {
			id: "mask0_2672_5444",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 151,
			y: 58,
			width: 62,
			height: 85,
			children: /* @__PURE__ */ (0, Q.jsx)("path", {
				d: "M194.273 58L212.818 79.6364C212.818 99.4242 212.818 119.212 212.818 139C212.818 141.209 211.027 143 208.818 143H155C152.791 143 151 141.209 151 139V62C151 59.7909 152.779 58 154.988 58C163.409 58 183.138 58 194.273 58Z",
				fill: "white"
			})
		}),
		/* @__PURE__ */ (0, Q.jsxs)("g", {
			mask: "url(#mask0_2672_5444)",
			children: [
				/* @__PURE__ */ (0, Q.jsx)("path", {
					d: "M194.01 58.5H194.043L212.318 79.8213V79.8683V79.9842V80.1001V80.2161V80.332V80.448V80.5639V80.6799V80.7958V80.9118V81.0277V81.1436V81.2596V81.3755V81.4915V81.6074V81.7234V81.8393V81.9553V82.0712V82.1871V82.3031V82.419V82.535V82.6509V82.7669V82.8828V82.9988V83.1147V83.2306V83.3466V83.4625V83.5785V83.6944V83.8104V83.9263V84.0423V84.1582V84.2741V84.3901V84.506V84.622V84.7379V84.8539V84.9698V85.0858V85.2017V85.3176V85.4336V85.5495V85.6655V85.7814V85.8974V86.0133V86.1293V86.2452V86.3612V86.4771V86.593V86.709V86.8249V86.9409V87.0568V87.1728V87.2887V87.4047V87.5206V87.6365V87.7525V87.8684V87.9844V88.1003V88.2163V88.3322V88.4482V88.5641V88.68V88.796V88.9119V89.0279V89.1438V89.2598V89.3757V89.4917V89.6076V89.7235V89.8395V89.9554V90.0714V90.1873V90.3033V90.4192V90.5352V90.6511V90.767V90.883V90.9989V91.1149V91.2308V91.3468V91.4627V91.5787V91.6946V91.8105V91.9265V92.0424V92.1584V92.2743V92.3903V92.5062V92.6222V92.7381V92.854V92.97V93.0859V93.2019V93.3178V93.4338V93.5497V93.6657V93.7816V93.8975V94.0135V94.1294V94.2454V94.3613V94.4773V94.5932V94.7092V94.8251V94.9411V95.057V95.1729V95.2889V95.4048V95.5208V95.6367V95.7527V95.8686V95.9846V96.1005V96.2164V96.3324V96.4483V96.5643V96.6802V96.7962V96.9121V97.0281V97.144V97.2599V97.3759V97.4918V97.6078V97.7237V97.8397V97.9556V98.0716V98.1875V98.3034V98.4194V98.5353V98.6513V98.7672V98.8832V98.9991V99.1151V99.231V99.3469V99.4629V99.5788V99.6948V99.8107V99.9267V100.043V100.159V100.275V100.39V100.506V100.622V100.738V100.854V100.97V101.086V101.202V101.318V101.434V101.55V101.666V101.782V101.898V102.014V102.13V102.246V102.362V102.477V102.593V102.709V102.825V102.941V103.057V103.173V103.289V103.405V103.521V103.637V103.753V103.869V103.985V104.101V104.217V104.333V104.449V104.564V104.68V104.796V104.912V105.028V105.144V105.26V105.376V105.492V105.608V105.724V105.84V105.956V106.072V106.188V106.304V106.42V106.536V106.651V106.767V106.883V106.999V107.115V107.231V107.347V107.463V107.579V107.695V107.811V107.927V108.043V108.159V108.275V108.391V108.507V108.623V108.738V108.854V108.97V109.086V109.202V109.318V109.434V109.55V109.666V109.782V109.898V110.014V110.13V110.246V110.362V110.478V110.594V110.71V110.825V110.941V111.057V111.173V111.289V111.405V111.521V111.637V111.753V111.869V111.985V112.101V112.217V112.333V112.449V112.565V112.681V112.797V112.912V113.028V113.144V113.26V113.376V113.492V113.608V113.724V113.84V113.956V114.072V114.188V114.304V114.42V114.536V114.652V114.768V114.884V114.999V115.115V115.231V115.347V115.463V115.579V115.695V115.811V115.927V116.043V116.159V116.275V116.391V116.507V116.623V116.739V116.855V116.971V117.086V117.202V117.318V117.434V117.55V117.666V117.782V117.898V118.014V118.13V118.246V118.362V118.478V118.594V118.71V118.826V118.942V119.058V119.173V119.289V119.405V119.521V119.637V119.753V119.869V119.985V120.101V120.217V120.333V120.449V120.565V120.681V120.797V120.913V121.029V121.145V121.26V121.376V121.492V121.608V121.724V121.84V121.956V122.072V122.188V122.304V122.42V122.536V122.652V122.768V122.884V123V123.116V123.232V123.347V123.463V123.579V123.695V123.811V123.927V124.043V124.159V124.275V124.391V124.507V124.623V124.739V124.855V124.971V125.087V125.203V125.319V125.434V125.55V125.666V125.782V125.898V126.014V126.13V126.246V126.362V126.478V126.594V126.71V126.826V126.942V127.058V127.174V127.29V127.406V127.521V127.637V127.753V127.869V127.985V128.101V128.217V128.333V128.449V128.565V128.681V128.797V128.913V129.029V129.145V129.261V129.377V129.493V129.608V129.724V129.84V129.956V130.072V130.188V130.304V130.42V130.536V130.652V130.768V130.884V131V131.116V131.232V131.348V131.464V131.58V131.695V131.811V131.927V132.043V132.159V132.275V132.391V132.507V132.623V132.739V132.855V132.971V133.087V133.203V133.319V133.435V133.551V133.667V133.782V133.898V134.014V134.13V134.246V134.362V134.478V134.594V134.71V134.826V134.942V135.058V135.174V135.29V135.406V135.522V135.638V135.754V135.869V135.985V136.101V136.217V136.333V136.449V136.565V136.681V136.797V136.913V137.029V137.145V137.261V137.377V137.493V137.609V137.725V137.841V137.956V138.072V138.188V138.304V138.42V138.536V138.652V138.768V138.884V139C212.318 140.933 210.751 142.5 208.818 142.5H155C153.067 142.5 151.5 140.933 151.5 139V62C151.5 60.0651 153.057 58.5 154.988 58.5H155.038H155.088H155.138H155.188H155.238H155.289H155.34H155.391H155.443H155.495H155.547H155.599H155.651H155.704H155.757H155.81H155.864H155.918H155.972H156.026H156.08H156.135H156.19H156.245H156.3H156.356H156.412H156.468H156.524H156.581H156.638H156.695H156.752H156.81H156.867H156.925H156.984H157.042H157.101H157.16H157.219H157.278H157.338H157.397H157.457H157.517H157.578H157.638H157.699H157.76H157.822H157.883H157.945H158.007H158.069H158.131H158.194H158.257H158.319H158.383H158.446H158.51H158.573H158.637H158.702H158.766H158.83H158.895H158.96H159.025H159.091H159.156H159.222H159.288H159.354H159.421H159.487H159.554H159.621H159.688H159.755H159.823H159.89H159.958H160.026H160.094H160.163H160.231H160.3H160.369H160.438H160.508H160.577H160.647H160.716H160.786H160.857H160.927H160.997H161.068H161.139H161.21H161.281H161.353H161.424H161.496H161.568H161.64H161.712H161.784H161.857H161.929H162.002H162.075H162.148H162.222H162.295H162.369H162.443H162.516H162.591H162.665H162.739H162.814H162.888H162.963H163.038H163.113H163.188H163.264H163.339H163.415H163.491H163.567H163.643H163.719H163.796H163.872H163.949H164.026H164.102H164.18H164.257H164.334H164.411H164.489H164.567H164.645H164.723H164.801H164.879H164.957H165.036H165.114H165.193H165.272H165.351H165.43H165.509H165.588H165.668H165.747H165.827H165.907H165.987H166.067H166.147H166.227H166.307H166.388H166.468H166.549H166.63H166.71H166.791H166.872H166.954H167.035H167.116H167.198H167.279H167.361H167.443H167.525H167.607H167.689H167.771H167.853H167.935H168.018H168.1H168.183H168.265H168.348H168.431H168.514H168.597H168.68H168.763H168.847H168.93H169.013H169.097H169.18H169.264H169.348H169.432H169.516H169.6H169.684H169.768H169.852H169.936H170.02H170.105H170.189H170.274H170.358H170.443H170.528H170.613H170.697H170.782H170.867H170.952H171.037H171.123H171.208H171.293H171.378H171.464H171.549H171.635H171.72H171.806H171.891H171.977H172.063H172.148H172.234H172.32H172.406H172.492H172.578H172.664H172.75H172.836H172.922H173.008H173.095H173.181H173.267H173.354H173.44H173.526H173.613H173.699H173.786H173.872H173.959H174.045H174.132H174.219H174.305H174.392H174.479H174.565H174.652H174.739H174.826H174.912H174.999H175.086H175.173H175.26H175.347H175.434H175.521H175.607H175.694H175.781H175.868H175.955H176.042H176.129H176.216H176.303H176.39H176.477H176.564H176.651H176.738H176.825H176.912H177.086H177.782H177.955H178.042H178.129H178.216H178.303H178.39H178.476H178.563H178.65H178.737H178.823H178.91H178.997H179.083H179.17H179.257H179.343H179.43H179.516H179.603H179.689H179.776H179.862H179.948H180.035H180.121H180.207H180.294H180.38H180.466H180.552H180.638H180.724H180.81H180.896H180.982H181.068H181.153H181.239H181.325H181.411H181.496H181.582H181.667H181.753H181.838H181.924H182.009H182.094H182.179H182.264H182.349H182.434H182.519H182.604H182.689H182.774H182.859H182.943H183.028H183.112H183.197H183.281H183.366H183.45H183.534H183.618H183.702H183.786H183.87H183.954H184.037H184.121H184.205H184.288H184.372H184.455H184.538H184.621H184.704H184.787H184.87H184.953H185.036H185.119H185.201H185.284H185.366H185.448H185.531H185.613H185.695H185.777H185.858H185.94H186.022H186.103H186.185H186.266H186.347H186.429H186.51H186.591H186.671H186.752H186.833H186.913H186.994H187.074H187.154H187.234H187.314H187.394H187.474H187.553H187.633H187.712H187.792H187.871H187.95H188.029H188.108H188.186H188.265H188.343H188.422H188.5H188.578H188.656H188.734H188.811H188.889H188.966H189.044H189.121H189.198H189.275H189.352H189.428H189.505H189.581H189.657H189.733H189.809H189.885H189.961H190.036H190.112H190.187H190.262H190.337H190.412H190.486H190.561H190.635H190.709H190.783H190.857H190.931H191.005H191.078H191.151H191.224H191.297H191.37H191.443H191.515H191.588H191.66H191.732H191.803H191.875H191.947H192.018H192.089H192.16H192.231H192.302H192.372H192.442H192.513H192.583H192.652H192.722H192.791H192.861H192.93H192.999H193.067H193.136H193.204H193.272H193.34H193.408H193.476H193.543H193.611H193.678H193.745H193.811H193.878H193.944H194.01Z",
					fill: "url(#paint0_linear_2672_5444)",
					stroke: "url(#paint1_linear_2672_5444)"
				}),
				/* @__PURE__ */ (0, Q.jsx)("path", {
					d: "M193.772 103.081C193.046 102.627 192.217 102.362 191.362 102.311C191.216 102.299 191.069 102.299 190.922 102.311C190.646 101.394 190.068 100.597 189.282 100.051C189.08 99.9151 188.81 99.9447 188.642 100.121C187.94 101.059 187.677 102.255 187.922 103.401C187.94 103.55 187.892 103.699 187.792 103.811C187.705 103.908 187.581 103.962 187.452 103.961H187.002V101.501C187.002 101.225 186.778 101.001 186.502 101.001H184.001V95.5001C184.001 95.2239 183.778 95 183.501 95H180.501C180.225 95 180.001 95.2239 180.001 95.5001V98.0003H174.5C174.224 98.0003 174 98.2242 174 98.5004V101.001H171.5C171.224 101.001 171 101.225 171 101.501V104.001H170.5C170.224 104.001 170 104.225 170 104.501C170 112.172 175.591 113.002 178.001 113.002C183.095 113.017 187.812 110.319 190.382 105.921C191.819 105.732 193.109 104.943 193.932 103.751C194.066 103.521 193.996 103.226 193.772 103.081ZM186.002 104.001H184.001V102.001H186.002V104.001ZM175.001 104.001V102.001H177.001V104.001H175.001ZM178.001 104.001V102.001H180.001V104.001H178.001ZM183.001 99.0004V101.001H181.001V99.0004H183.001ZM181.001 104.001V102.001H183.001V104.001H181.001ZM181.001 96.0001H183.001V98.0003H181.001V96.0001ZM180.001 101.001H178.001V99.0004H180.001V101.001ZM175.001 99.0004H177.001V101.001H175.001V99.0004ZM172 102.001H174V104.001H172V102.001ZM175.001 109.001C174.448 109.001 174 108.554 174 108.001C174 107.449 174.448 107.001 175.001 107.001C175.553 107.001 176.001 107.449 176.001 108.001C176.001 108.554 175.553 109.001 175.001 109.001Z",
					fill: "#B7DBFF"
				}),
				/* @__PURE__ */ (0, Q.jsx)("path", {
					d: "M194.773 65.1736C194.773 63.2321 194.772 61.2902 194.772 59.3484L211.669 79H198.273C196.34 79 194.773 77.4329 194.773 75.4997C194.773 72.0605 194.773 68.6176 194.773 65.1736Z",
					fill: "#E5F2FF",
					stroke: "url(#paint2_linear_2672_5444)"
				})
			]
		}),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			d: "M216.029 131.247L214.746 131.99L216.029 131.247C215.722 130.715 215.28 130.275 214.748 129.968C214.217 129.661 213.614 129.5 213 129.5C212.386 129.5 211.783 129.661 211.252 129.968C210.72 130.275 210.278 130.715 209.971 131.247L211.255 131.99L209.971 131.247L198.974 150.246C198.666 150.778 198.503 151.381 198.503 151.996C198.502 152.611 198.664 153.215 198.971 153.747C199.278 154.28 199.72 154.722 200.252 155.03C200.784 155.337 201.388 155.499 202.003 155.499H223.997C224.612 155.499 225.216 155.337 225.748 155.03C226.28 154.722 226.722 154.28 227.029 153.747C227.336 153.215 227.498 152.611 227.497 151.996C227.496 151.381 227.334 150.778 227.026 150.246L216.029 131.247Z",
			fill: "#FFB549",
			stroke: "var(--bg-primary)",
			strokeWidth: 3
		}),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M214.333 140C214.333 139.264 213.736 138.667 213 138.667C212.264 138.667 211.667 139.264 211.667 140V145C211.667 145.736 212.264 146.333 213 146.333C213.736 146.333 214.333 145.736 214.333 145V140ZM214.5 149.5C214.5 150.329 213.828 151 213 151C212.172 151 211.5 150.329 211.5 149.5C211.5 148.672 212.172 148 213 148C213.828 148 214.5 148.672 214.5 149.5Z",
			fill: "#3B444C"
		}),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			d: "M65.5601 191.308C65.5601 191.192 66.7131 188.02 68.0981 184.213L70.6361 177.291L77.0961 177.118L83.4991 176.945L86.2671 179.252C88.5751 181.214 99.0631 186.799 100.399 187.559C101.29 188.065 102.466 189.353 103.925 191.423C78.3481 191.385 65.5601 191.346 65.5601 191.308Z",
			fill: "#80AEF2"
		}),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			d: "M32 191.308C32 191.192 33.154 188.02 34.538 184.213L37.076 177.291L43.536 177.118L49.939 176.945L52.708 179.252C55.015 181.214 65.503 186.799 66.84 187.559C67.73 188.065 68.906 189.353 70.365 191.423C44.788 191.385 32 191.346 32 191.308Z",
			fill: "#94BBF8"
		}),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			d: "M75.655 109.836C76.745 112.994 77.481 115.734 77.863 118.056C78.243 120.377 80.381 140.211 84.274 177.556H66.296C64.852 174.938 64.13 173.099 64.13 172.038C64.13 170.448 65.043 168.268 65.043 165.97C65.043 164.438 63.009 159.147 58.939 150.099L62.87 110.75L75.655 109.836Z",
			fill: "#1D225F"
		}),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M50.5541 177.555H33.7601C33.3601 176.17 32.9681 174.301 32.5851 171.949C31.8351 167.161 32.4051 163.989 35.6351 157.413C38.8651 150.895 40.5011 147.341 40.5011 143.649C40.5591 137.881 41.7231 132.333 44.7811 126.334C47.1451 121.604 48.2761 121.248 48.5061 118.364L48.9261 112.162H70.0041C70.5161 113.595 70.7001 116.237 70.5541 120.087C70.4091 123.937 63.7421 143.093 50.5531 177.555H50.5541Z",
			fill: "url(#paint3_linear_2672_5444)"
		}),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			d: "M95.9399 50.818L112.78 29.988H132.971L115.532 50.818H95.9399Z",
			fill: "#98BDF9"
		}),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			d: "M118.14 27.384C119.518 27.384 120.646 28.454 120.737 29.809L120.743 29.988H120.165C120.165 28.869 119.258 27.963 118.14 27.963C117.021 27.963 116.115 28.869 116.115 29.988C116.115 31.05 116.933 31.922 117.974 32.006L118.14 32.013V32.591C116.702 32.591 115.536 31.426 115.536 29.988C115.536 28.55 116.702 27.384 118.14 27.384ZM125.083 27.384C126.461 27.384 127.589 28.454 127.681 29.809L127.687 29.988H127.108C127.108 28.869 126.202 27.963 125.083 27.963C123.965 27.963 123.058 28.869 123.058 29.988C123.058 31.05 123.876 31.922 124.917 32.006L125.083 32.013V32.591C123.645 32.591 122.479 31.426 122.479 29.988C122.479 28.55 123.645 27.384 125.083 27.384Z",
			fill: "#2174DB"
		}),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			d: "M94.4722 54.8291C97.2792 53.8671 100.026 52.5301 102.714 50.8181H109.585C107.21 52.9881 105.613 54.5241 104.794 55.4281C103.974 56.3311 102.285 58.0661 99.7262 60.6331C98.6352 66.4141 97.4722 68.8431 96.2392 67.9181C94.3892 66.5321 88.3002 57.0211 94.4722 54.8281V54.8291Z",
			fill: "#F3A29D"
		}),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			d: "M98.2542 60.6541C102.617 58.9861 105.433 57.7971 106.701 57.0871C108.201 56.2221 108.778 55.4141 110.508 51.7801C110.738 51.3191 111.2 49.4151 111.604 47.6271C112.527 43.0701 114.027 43.3011 114.142 47.9731C114.2 49.2431 114.488 50.3961 114.834 50.5111C115.122 50.6271 116.795 49.0111 118.468 46.9351C120.141 44.8581 121.756 43.1851 122.044 43.1851C122.736 43.1851 122.736 48.4921 121.987 50.3381C121.698 51.2031 117.257 56.0481 112.123 61.1821C108.701 64.6051 103.692 69.2501 97.0972 75.1191L98.2542 60.6541Z",
			fill: "#FAB6AF"
		}),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			d: "M78.5812 35.7741C79.3532 32.6881 80.1242 30.7591 80.8962 29.9871C79.7392 28.8301 78.5812 27.6731 76.2662 26.5161C75.4962 28.0591 73.9522 29.6021 71.6382 31.1451C71.6382 33.4591 72.4092 35.0021 73.9522 35.7741C75.4952 36.5451 77.0382 36.5451 78.5822 35.7741H78.5812Z",
			fill: "#F3A29D"
		}),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			d: "M49.3081 112.98C46.9431 112.806 43.0781 111.999 40.8281 111.249L36.6181 109.864L36.5031 105.538C36.2141 93.5981 37.0801 84.8881 39.7911 73.7561C43.4821 58.4701 54.0961 42.8391 66.9592 33.6671C71.9192 30.0911 72.0351 30.0911 73.4771 32.5141C74.1111 33.6671 75.4371 34.8211 76.3611 35.1671L78.5221 35.7611C75.4761 65.0851 76.6521 89.3911 82.0532 108.678C80.8961 109.836 80.1071 110.36 79.2451 110.73C78.2061 111.133 76.8801 111.537 76.1881 111.595C75.4951 111.653 73.1881 112.114 70.9381 112.633C66.7281 113.556 57.5561 113.729 49.3081 112.979V112.98Z",
			fill: "url(#paint4_linear_2672_5444)"
		}),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M94.4721 54.8281L96.2391 66.1391L76.2671 68.7841L77.3731 53.1311C79.5141 54.8661 81.7171 55.9071 83.9811 56.2541C86.2441 56.6021 89.7411 56.1261 94.4711 54.8281H94.4721Z",
			fill: "#D6D7D8"
		}),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			d: "M98.2541 60.653L103.157 83.798C102.589 84.955 101.147 85.727 98.8331 86.112C93.6251 86.691 88.4181 84.376 82.0531 84.376C75.6881 84.376 75.9631 88.426 66.7051 84.956C60.5331 82.641 58.0251 72.226 59.1821 53.71L77.2361 51.98C77.1581 57.762 77.8911 61.232 79.4341 62.389C80.9461 63.523 87.0031 62.99 97.6041 60.789L98.2541 60.653Z",
			fill: "#E9E9E9"
		}),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			d: "M90.3051 15.4439C91.3751 16.9639 91.7931 18.9799 91.5581 21.4929C91.4961 22.1489 91.1821 22.3759 91.1821 23.5449C91.1821 24.6649 91.2521 26.0509 91.3941 27.7019L89.0771 27.8629C86.8551 30.2749 84.5031 31.3429 82.0221 31.0699C79.5421 30.7949 77.7711 29.7269 76.7121 27.8629C74.5321 23.8399 75.0911 20.4189 78.3871 17.6009C81.6831 14.7829 85.6561 14.0639 90.3051 15.4439Z",
			fill: "#FAB6AF"
		}),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M79.646 8C82.244 8 85.363 9.017 87.64 10.74C89.917 12.462 91.485 13.76 92.19 15.837C92.66 17.221 92.438 19.151 91.526 21.628C91.656 19.283 91.478 17.981 90.993 17.722C90.323 19.375 89.398 19.709 88.29 20.509C87.67 20.957 85.499 21.027 83.373 21.406C80.745 23.128 79.07 24.736 78.506 26.266C78.058 27.484 78.104 28.874 78.654 30.443L78.78 30.782L78.24 30.992C77.526 29.159 77.43 27.514 77.963 26.067C78.485 24.65 79.813 23.229 81.857 21.746C80.767 22.053 79.806 22.5 79.223 23.195C77.944 24.721 77.195 26.96 76.977 29.911C74.211 29.411 71.672 28.478 69.36 27.111C67.048 25.745 64.915 23.917 62.962 21.628C63.358 20.794 63.866 20.104 64.483 19.558C65.154 18.966 66.418 18.45 67.652 17.736L67.587 17.757L66.383 18.158C65.123 18.582 64.427 18.871 63.988 19.19C63.158 19.791 62.728 20.465 62.675 21.222L62.67 21.413L62.091 21.42C62.079 20.381 62.607 19.477 63.648 18.721C64.075 18.411 64.661 18.148 65.631 17.805L67.387 17.215L67.997 17.002C68.591 16.789 69.061 16.601 69.436 16.418C70.732 15.019 71.606 12.447 73.526 10.74C75.641 8.855 77.048 8 79.645 8H79.646Z",
			fill: "#E94A47"
		}),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			d: "M84.3598 21.5751C84.9568 19.9351 86.5298 18.9781 87.8948 19.4751C88.9558 19.8611 89.5488 20.9991 89.4808 22.2561C89.8408 22.1651 90.1698 22.1191 90.4688 22.1201L90.6768 22.1271C90.9318 22.1471 91.1428 22.1831 91.3128 22.2411C91.8248 20.9701 93.0208 20.2181 94.0628 20.5971C95.1328 20.9871 95.5608 22.4001 95.0748 23.7371C94.5878 25.0741 93.3518 25.8811 92.2808 25.4911C91.3278 25.1441 90.8838 23.9871 91.1408 22.7941C91.0378 22.7561 90.8668 22.7221 90.6328 22.7041C90.2988 22.6791 89.8958 22.7331 89.4248 22.8691L89.3938 22.8791C89.3578 23.0381 89.3108 23.1971 89.2538 23.3561C88.6568 24.9961 87.0838 25.9531 85.7178 25.4561C84.3518 24.9591 83.7628 23.2151 84.3598 21.5751ZM93.8638 21.1411C93.1338 20.8751 92.1998 21.4841 91.8118 22.5491C91.4248 23.6151 91.7478 24.6811 92.4788 24.9471C93.2098 25.2131 94.1428 24.6041 94.5308 23.5391C94.9188 22.4741 94.5948 21.4071 93.8638 21.1411ZM87.6968 20.0191C86.6608 19.6421 85.3998 20.4091 84.9038 21.7731C84.4078 23.1361 84.8798 24.5351 85.9158 24.9131C86.9518 25.2891 88.2138 24.5211 88.7098 23.1581C89.2058 21.7951 88.7328 20.3961 87.6968 20.0181V20.0191Z",
			fill: "#222768"
		}),
		/* @__PURE__ */ (0, Q.jsxs)("defs", { children: [
			/* @__PURE__ */ (0, Q.jsxs)("linearGradient", {
				id: "paint0_linear_2672_5444",
				x1: 213,
				y1: 58,
				x2: 151,
				y2: 143,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ (0, Q.jsx)("stop", { stopColor: "#ABCFF3" }),
					/* @__PURE__ */ (0, Q.jsx)("stop", {
						offset: .357625,
						stopColor: "#F0F7FF"
					}),
					/* @__PURE__ */ (0, Q.jsx)("stop", {
						offset: .644375,
						stopColor: "white"
					}),
					/* @__PURE__ */ (0, Q.jsx)("stop", {
						offset: 1,
						stopColor: "#F0F7FF"
					})
				]
			}),
			/* @__PURE__ */ (0, Q.jsxs)("linearGradient", {
				id: "paint1_linear_2672_5444",
				x1: 181.909,
				y1: 58,
				x2: 181.909,
				y2: 143,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ (0, Q.jsx)("stop", { stopColor: "white" }), /* @__PURE__ */ (0, Q.jsx)("stop", {
					offset: 1,
					stopColor: "#E5F2FF"
				})]
			}),
			/* @__PURE__ */ (0, Q.jsxs)("linearGradient", {
				id: "paint2_linear_2672_5444",
				x1: 199.5,
				y1: 67.5,
				x2: 191,
				y2: 85.5,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ (0, Q.jsx)("stop", { stopColor: "white" }), /* @__PURE__ */ (0, Q.jsx)("stop", {
					offset: 1,
					stopColor: "#E5F2FF"
				})]
			}),
			/* @__PURE__ */ (0, Q.jsxs)("linearGradient", {
				id: "paint3_linear_2672_5444",
				x1: 53.3662,
				y1: 112.162,
				x2: 38.2601,
				y2: 175.224,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ (0, Q.jsx)("stop", { stopColor: "#2A318C" }), /* @__PURE__ */ (0, Q.jsx)("stop", {
					offset: 1,
					stopColor: "#1D225F"
				})]
			}),
			/* @__PURE__ */ (0, Q.jsxs)("linearGradient", {
				id: "paint4_linear_2672_5444",
				x1: 59.2517,
				y1: 30.8201,
				x2: 59.2517,
				y2: 113.448,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ (0, Q.jsx)("stop", { stopColor: "#EEEEEE" }), /* @__PURE__ */ (0, Q.jsx)("stop", {
					offset: 1,
					stopColor: "#D6D7D8"
				})]
			})
		] })
	]
}), em = (e) => /* @__PURE__ */ (0, Q.jsx)(Wo, {
	...e,
	rootClassName: "mb-0 flex top dc_max-width__max-content",
	"data-testid": "ask-value-at-runtime-checkbox",
	children: /* @__PURE__ */ (0, Q.jsx)(W, {
		alwaysShowTippyOnHover: !0,
		className: "w-200",
		placement: "bottom-start",
		content: /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "fs-12 lh-18 flexbox-col dc__gap-2",
			children: [/* @__PURE__ */ (0, Q.jsx)("p", {
				className: "m-0 fw-6",
				children: "Ask value at runtime"
			}), /* @__PURE__ */ (0, Q.jsx)("p", {
				className: "m-0",
				children: "Value can be provided at runtime. Entered value will be pre-filled as default"
			})]
		}),
		children: /* @__PURE__ */ (0, Q.jsx)("div", {
			className: "dc__border-dashed--n3-bottom fs-13 cn-9 lh-20",
			children: "Ask value at runtime"
		})
	})
}), tm = /* @__PURE__ */ t({ default: () => nm });
function nm({ consumedImagePresent: e, triggerType: t, isRollbackTrigger: n, envName: r, viewAllImages: i, className: a }) {
	return /* @__PURE__ */ (0, Q.jsx)(R, {
		classname: a ?? "",
		image: t === uu.automatic ? Zf : Xf,
		title: t === uu.automatic ? pi.noImage.title : pi.noApprovedImages.title,
		subTitle: t === uu.automatic ? pi.noImage.cdAutoMode(r) : n ? pi.noImage.rollbackSubtitle : pi.noImage.cdSubtitle,
		isButtonAvailable: !0,
		renderButton: () => /* @__PURE__ */ (0, Q.jsx)("button", {
			className: "cta ghosted flex h-36",
			"data-selected-tab": "0",
			onClick: i,
			children: e ? pi.noImage.label : pi.noApprovedImages.label
		})
	});
}
//#endregion
//#region src/Pages/App/AppDetails/DeploymentStrategy/utils.tsx
var rm = (e, t) => {
	for (let n = t - 1; n >= 0; n--) {
		let t = e[n]?.setWeight;
		if (t) return t;
	}
	return 0;
}, im = (e) => {
	let { setWeight: t } = e;
	if (!Jd(t)) return {
		message: `Rollout to ${e.setWeight}% users`,
		iconName: "ic-users",
		isFullRollout: e.setWeight === 100
	};
	if (e.pause) return {
		message: typeof e.pause.duration == "string" ? `Pause for ${e.pause.duration}` : "Pause indefinitely",
		iconName: "ic-timer"
	};
	if ("analysis" in e) return {
		message: "Run analysis",
		iconName: "ic-magnifying-glass"
	};
	if ("experiment" in e) return {
		message: "Run experiment",
		iconName: "ic-flask"
	};
	if (e.plugin) return {
		message: `Execute ${e.plugin.name} plugin`,
		iconName: "ic-lego"
	};
	if (e.setCanaryScale) {
		let { replicas: t, weight: n, matchTrafficWeight: r } = e.setCanaryScale, i = [];
		return t && i.push(`${t} replicas`), n && i.push(`${n} weight`), Jd(r) || i.push(`matchTrafficWeight: ${r}`), {
			message: `Set canary scale to ${i.join(" and ")}`,
			iconName: "ic-cube"
		};
	}
	let n = e.setHeaderRoute || e.setMirrorRoute;
	return n ? {
		message: `Set ${e.setHeaderRoute ? "header" : "mirror"} route${n.name ? ` - ${n.name}` : ""}`,
		iconName: "ic-cube"
	} : {
		message: "",
		iconName: "ic-cube"
	};
}, am = (e, t, n) => {
	if (!e || !e.length) return {
		currentRolloutWeight: 0,
		parsedSteps: [],
		currentSetWeight: 0
	};
	let r = e.map(im);
	return {
		currentRolloutWeight: n === "Healthy" ? 100 : rm(e, t),
		parsedSteps: r,
		currentSetWeight: e[t]?.setWeight ?? 0
	};
}, om = (e, t) => e < t ? "G500" : e === t ? "O500" : "N900", sm = (e) => e == eo.NOT_FOUND, cm = (e, t, n) => {
	if (e === "Healthy") return {
		rolloutStatus: "Rollout Complete",
		nextAction: null
	};
	let r = "No action required";
	return e === "Progressing" ? n ? {
		rolloutStatus: "Promoting",
		nextAction: null
	} : {
		rolloutStatus: "In Progress",
		nextAction: r
	} : t ? {
		rolloutStatus: "In Progress",
		nextAction: r
	} : {
		rolloutStatus: "Awaiting traffic swap",
		nextAction: "Swap Traffic"
	};
}, lm = ({ phase: e, autoPromotionEnabled: t, promoteFull: n, renderRollbackButton: r, handleOpenSwapTrafficDialog: i }) => {
	let { rolloutStatus: a } = cm(e, t, n), o = {
		title: "Blue Green Strategy",
		iconName: "ic-strategy-blue-green-color",
		status: a
	};
	return e === "Healthy" ? {
		...o,
		renderActionButton: r
	} : e === "Progressing" ? {
		...o,
		currentSetWeight: 100,
		currentRolloutWeight: 0,
		...n ? { renderActionButton: r } : { actionButtonConfig: {
			text: "Skip & promote full",
			onClick: i
		} }
	} : {
		...o,
		actionButtonConfig: {
			text: t ? "Skip & promote full" : "Swap traffic",
			onClick: i
		},
		...t ? {
			currentSetWeight: 100,
			currentRolloutWeight: 0
		} : {}
	};
}, um = async ({ appId: e, envId: t, helmPackageName: n, cdWorkflowType: r, handleDownload: i, appName: a }) => {
	let o = {
		appId: e,
		envId: t,
		appName: a || n || "helm-package",
		...r ? { cdWorkflowType: r } : {}
	};
	return i({
		downloadUrl: Oe(o),
		fileName: o.appName.endsWith(".gz") ? o.appName : `${o.appName}.gz`,
		downloadSuccessToastContent: "Manifest Downloaded Successfully"
	});
}, dm = async (e) => {
	let { result: t } = await nf(O.CD_PIPELINE_STRATEGIES, { pipelineIds: e });
	return (t ?? []).map(({ pipelineId: e, strategies: t, error: n }) => ({
		pipelineId: e,
		strategies: t ?? [],
		error: n
	}));
}, fm = {
	DEFAULT: "ic-gear",
	"BLUE-GREEN": "ic-strategy-blue-green-color",
	CANARY: "ic-strategy-canary-color",
	RECREATE: "ic-strategy-recreate-color",
	ROLLING: "ic-strategy-rolling-color",
	ROLLINGUPDATE: "ic-rocket-gear",
	ONDELETE: "ic-rocket-gear"
}, pm = {
	DEFAULT: "ic-gear",
	"BLUE-GREEN": "ic-strategy-blue-green",
	CANARY: "ic-strategy-canary",
	RECREATE: "ic-strategy-recreate",
	ROLLING: "ic-strategy-rolling",
	ROLLINGUPDATE: "ic-rocket-gear",
	ONDELETE: "ic-rocket-gear"
}, mm = ({ hasError: e, bulkDeploymentStrategy: t, currentDeploymentStrategy: n }) => n === "DEFAULT" ? "Deployment will be triggered using strategy defined in chart" : e ? "Could not fetch strategies for current pipeline, please reload" : n ? `Deployment will be triggered using ${Pl[n] ?? n} strategy` : `${Pl[t] ?? t} strategy is not configured. Deployment will be skipped.`, hm = (e) => e.reduce((e, t) => (e[t.pipelineId] = {
	strategies: t.strategies.map(({ deploymentTemplate: e }) => e) ?? [],
	error: t.error
}, e), {}), gm = ({ strategies: e, selectedValue: t, handleUpdateStrategy: n, error: r, reloadOptions: i }) => {
	if (!e?.length) return /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flex dc__gap-6",
		children: [/* @__PURE__ */ (0, Q.jsx)(z, {
			name: "ic-info-filled",
			color: "B500"
		}), /* @__PURE__ */ (0, Q.jsx)("span", { children: "Strategy not found" })]
	});
	let a = e.map((e) => ({
		value: e,
		label: Pl[e] ?? e,
		startIcon: /* @__PURE__ */ (0, Q.jsx)(z, {
			name: fm[e] ?? "ic-rocket-gear",
			color: null
		})
	}));
	return /* @__PURE__ */ (0, Q.jsx)(V, {
		inputId: "select-strategy-for-app",
		options: a,
		variant: Hl.COMPACT,
		placeholder: "Select strategy",
		icon: /* @__PURE__ */ (0, Q.jsx)(z, {
			name: "ic-gear",
			color: null
		}),
		size: I.medium,
		showSelectedOptionIcon: !0,
		onChange: ({ value: e }) => {
			n(e);
		},
		value: Dd(a, t, null),
		...r ? {
			optionListError: new Wl({
				code: r.code,
				errors: [r]
			}),
			reloadOptionList: i
		} : {}
	});
}, _m = ({ appList: e, envName: t, onClickDeploy: n, bulkDeploymentStrategy: r, pipelineIdVsStrategyMap: i, setPipelineIdVsStrategyMap: a }) => {
	let [o, s, c, l] = hf(() => dm(e.map((e) => e.pipelineId))), { sortBy: u, sortOrder: d, handleSorting: f } = Mf({}), p = Ja(e), m = A(() => {
		if (!u) return p.current;
		let t = [...e].sort((e, t) => u === "appName" ? df(e.appName, t.appName, d) : df(i[e.pipelineId] ?? "", i[t.pipelineId] ?? "", d));
		return p.current = t, t;
	}, [u, d]), h = A(() => hm(s ?? []), [s]);
	if (k(() => {
		if (s) {
			let e = {};
			s.forEach(({ pipelineId: t, strategies: n, error: i }) => {
				n.find((e) => e.deploymentTemplate === r) ? e[t] = r : sm(i?.code) && (e[t] = "DEFAULT");
			}), a(e), f("deploymentStrategy");
		}
	}, [s]), o) return /* @__PURE__ */ (0, Q.jsx)(R, {
		imgName: "img-mechanical-operation",
		title: `Checking deployment feasibility for ${e.length} Applications on '${t}'`,
		subTitle: "It might take some time depending upon the number of applications"
	});
	if (c) return /* @__PURE__ */ (0, Q.jsx)(Ks, {
		code: c.code,
		reload: l
	});
	let g = (e) => () => f(e), _ = (e) => (t) => {
		a({
			...i,
			[e]: t
		}), f(null);
	}, v = e.filter(({ pipelineId: e }) => !!i[e] || sm(h[e]?.error?.code)).length;
	return /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "bg__primary dc__overflow-auto dc__content-space flexbox-col flex-grow-1 h-100",
		children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flex-grow-1 mh-0 dc__overflow-auto pb-16",
			children: [
				/* @__PURE__ */ (0, Q.jsx)("div", {
					className: "p-20",
					children: /* @__PURE__ */ (0, Q.jsxs)("div", {
						className: "br-8 border__primary shadow__card--20",
						children: [/* @__PURE__ */ (0, Q.jsx)(zl, {
							entities: [{
								color: "var(--G500)",
								label: "Feasible",
								value: v
							}, {
								color: "var(--R500)",
								label: "Not feasible",
								value: e.length - v
							}],
							labelClassName: "fs-13 fw-4 lh-20 cn-9",
							countClassName: "fs-13 fw-6 lh-20 cn-9",
							showAnimationOnBar: !0,
							rootClassName: "p-16 border__secondary--bottom"
						}), /* @__PURE__ */ (0, Q.jsxs)("div", {
							className: "flexbox dc__align-items-center dc__gap-6 px-16 py-8",
							children: [/* @__PURE__ */ (0, Q.jsx)(z, {
								name: "ic-info-outline",
								color: null,
								size: 20
							}), /* @__PURE__ */ (0, Q.jsxs)("span", { children: [
								"Deployment will be triggered for ",
								v,
								" applications"
							] })]
						})]
					})
				}),
				/* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "feasibility-row border__secondary--bottom py-8 px-20 fs-12 lh-20 cn-7 dc__position-sticky dc__top-0 bg__primary dc__zi-1",
					children: [
						/* @__PURE__ */ (0, Q.jsx)(ql, {
							title: "APPLICATION",
							isSorted: u === "appName",
							sortOrder: d,
							isSortable: !0,
							triggerSorting: g("appName"),
							disabled: !1
						}),
						/* @__PURE__ */ (0, Q.jsx)(ql, {
							title: "DEPLOYMENT STRATEGY",
							isSorted: u === "deploymentStrategy",
							sortOrder: d,
							isSortable: !0,
							triggerSorting: g("deploymentStrategy"),
							disabled: !1
						}),
						/* @__PURE__ */ (0, Q.jsx)(ql, {
							title: "MESSAGE",
							isSorted: !1,
							sortOrder: null,
							isSortable: !1,
							triggerSorting: $d,
							disabled: !1
						})
					]
				}),
				m.map(({ appName: e, pipelineId: t }) => {
					let n = h[t], a = i[t];
					return /* @__PURE__ */ (0, Q.jsxs)("div", {
						className: "feasibility-row py-8 px-20 fs-13 fw-4 cn-9 lh-20",
						children: [
							/* @__PURE__ */ (0, Q.jsx)("span", { children: e }),
							a === "DEFAULT" ? /* @__PURE__ */ (0, Q.jsxs)("div", {
								className: "flexbox dc__gap-6",
								children: [/* @__PURE__ */ (0, Q.jsx)(z, {
									name: "ic-info-filled",
									color: "B500",
									size: 20
								}), "Strategy not found"]
							}) : /* @__PURE__ */ (0, Q.jsx)("div", {
								className: "dc__mxw-fit-content",
								children: /* @__PURE__ */ (0, Q.jsx)(gm, {
									selectedValue: a,
									strategies: n?.strategies,
									error: n?.error,
									reloadOptions: l,
									handleUpdateStrategy: _(t)
								})
							}),
							/* @__PURE__ */ (0, Q.jsx)("span", { children: mm({
								hasError: !!n?.error,
								currentDeploymentStrategy: a,
								bulkDeploymentStrategy: r
							}) })
						]
					}, e);
				})
			]
		}), /* @__PURE__ */ (0, Q.jsx)("div", {
			className: "flex dc__align-items-center dc__content-end px-20 py-16 border__secondary--top",
			children: /* @__PURE__ */ (0, Q.jsx)(uo, {
				dataTestId: "cd-trigger-deploy-button",
				text: "Deploy",
				onButtonClick: n,
				startIcon: /* @__PURE__ */ (0, Q.jsx)(z, {
					name: "ic-rocket-launch",
					color: null
				}),
				disabled: !v
			})
		})]
	});
}, vm = (e) => /* @__PURE__ */ (0, Q.jsxs)("svg", {
	width: 250,
	height: 200,
	viewBox: "0 0 250 200",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [
		/* @__PURE__ */ (0, Q.jsx)("style", { children: "@keyframes rotate-clockwise{0%{transform:rotate(0deg)}to{transform:rotate(360deg)}}@keyframes rotate-counter-clockwise{0%{transform:rotate(360deg)}to{transform:rotate(0deg)}}" }),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			d: "M65.56 191.308c0-.116 1.153-3.288 2.538-7.095l2.538-6.922 6.46-.173 6.403-.173 2.768 2.307c2.308 1.962 12.796 7.547 14.132 8.307q1.337.759 3.526 3.864-38.365-.058-38.365-.115",
			fill: "#80AEF2"
		}),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			d: "M32 191.308c0-.116 1.154-3.288 2.538-7.095l2.538-6.922 6.46-.173 6.403-.173 2.769 2.307c2.307 1.962 12.795 7.547 14.132 8.307q1.336.759 3.525 3.864Q32 191.365 32 191.308",
			fill: "#94BBF8"
		}),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			d: "M75.655 109.836q1.635 4.737 2.208 8.22.57 3.482 6.411 59.5H66.296q-2.166-3.927-2.166-5.518c0-1.59.913-3.77.913-6.068q0-2.299-6.104-15.871l3.931-39.349z",
			fill: "#1D225F"
		}),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M50.554 177.555H33.76q-.6-2.078-1.175-5.606c-.75-4.788-.18-7.96 3.05-14.536 3.23-6.518 4.866-10.072 4.866-13.764.058-5.768 1.222-11.316 4.28-17.315 2.364-4.73 3.495-5.086 3.725-7.97l.42-6.202h21.078q.769 2.15.55 7.925t-20 57.468",
			fill: "url(#paint0_linear_2664_5084)"
		}),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			d: "m95.94 50.818 16.84-20.83h20.191l-17.439 20.83z",
			fill: "#98BDF9"
		}),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			d: "M118.14 27.384a2.6 2.6 0 0 1 2.597 2.425l.006.179h-.578a2.025 2.025 0 1 0-2.191 2.018l.166.007v.578a2.603 2.603 0 1 1 0-5.207m6.943 0a2.604 2.604 0 0 1 2.598 2.425l.006.179h-.579a2.024 2.024 0 1 0-2.191 2.018l.166.007v.578a2.603 2.603 0 1 1 0-5.207",
			fill: "#2174DB"
		}),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			d: "M94.472 54.83q4.21-1.444 8.242-4.012h6.871q-3.562 3.255-4.791 4.61t-5.068 5.205q-1.636 8.672-3.487 7.285c-1.85-1.386-7.939-10.897-1.767-13.09z",
			fill: "#F3A29D"
		}),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			d: "M98.254 60.654q6.545-2.502 8.447-3.567c1.5-.865 2.077-1.673 3.807-5.307.23-.46.692-2.365 1.096-4.153.923-4.557 2.423-4.326 2.538.346.058 1.27.346 2.423.692 2.538.288.116 1.961-1.5 3.634-3.576s3.288-3.75 3.576-3.75c.692 0 .692 5.307-.057 7.153-.289.865-4.73 5.71-9.864 10.844q-5.133 5.134-15.026 13.937z",
			fill: "#FAB6AF"
		}),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			d: "M78.581 35.774q1.157-4.629 2.315-5.787c-1.157-1.157-2.315-2.314-4.63-3.47q-1.156 2.313-4.628 4.628 0 3.47 2.314 4.63 2.314 1.155 4.63 0",
			fill: "#F3A29D"
		}),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			d: "M49.308 112.98c-2.365-.174-6.23-.981-8.48-1.731l-4.21-1.385-.115-4.326c-.289-11.94.577-20.65 3.288-31.782C43.482 58.47 54.096 42.84 66.96 33.667c4.96-3.576 5.076-3.576 6.518-1.153.634 1.153 1.96 2.307 2.884 2.653l2.161.594q-4.57 43.986 3.531 72.917c-1.157 1.158-1.946 1.682-2.808 2.052-1.039.403-2.365.807-3.057.865-.693.058-3 .519-5.25 1.038-4.21.923-13.382 1.096-21.63.346z",
			fill: "url(#paint1_linear_2664_5084)"
		}),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M94.472 54.828 96.24 66.14l-19.972 2.645 1.106-15.653q3.212 2.602 6.608 3.123t10.49-1.426z",
			fill: "#D6D7D8"
		}),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			d: "m98.254 60.653 4.903 23.145q-.853 1.736-4.324 2.314c-5.208.579-10.415-1.736-16.78-1.736s-6.09 4.05-15.348.58q-9.258-3.472-7.523-31.246l18.054-1.73q-.117 8.673 2.198 10.409 2.269 1.701 18.17-1.6z",
			fill: "#E9E9E9"
		}),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			d: "M90.305 15.444q1.605 2.28 1.253 6.049c-.062.656-.376.883-.376 2.052q0 1.68.212 4.157l-2.317.16q-3.333 3.618-7.055 3.208-3.72-.412-5.31-3.207-3.269-6.035 1.675-10.262 4.945-4.227 11.918-2.157",
			fill: "#FAB6AF"
		}),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M79.646 8c2.598 0 5.717 1.017 7.994 2.74 2.277 1.722 3.845 3.02 4.55 5.097q.705 2.076-.664 5.791.195-3.517-.533-3.906c-.67 1.653-1.595 1.987-2.703 2.787-.62.448-2.791.518-4.917.897-2.628 1.722-4.303 3.33-4.867 4.86-.448 1.218-.402 2.608.148 4.177l.126.339-.54.21c-.714-1.833-.81-3.478-.277-4.925.522-1.417 1.85-2.838 3.894-4.321-1.09.307-2.051.754-2.634 1.449q-1.919 2.29-2.246 6.716-4.149-.75-7.617-2.8t-6.398-5.483q.595-1.251 1.521-2.07c.671-.592 1.935-1.108 3.169-1.822l-.065.021-1.204.401c-1.26.424-1.956.713-2.395 1.032-.83.601-1.26 1.275-1.313 2.032l-.005.191-.579.007c-.012-1.039.516-1.943 1.557-2.699.427-.31 1.013-.573 1.983-.916l1.756-.59.61-.213a15 15 0 0 0 1.439-.584c1.296-1.399 2.17-3.971 4.09-5.678C75.641 8.855 77.048 8 79.645 8z",
			fill: "#E94A47"
		}),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			d: "M84.36 21.575c.597-1.64 2.17-2.597 3.535-2.1 1.06.386 1.654 1.524 1.586 2.781q.54-.136.988-.136l.208.007q.382.029.636.114c.512-1.27 1.708-2.023 2.75-1.644 1.07.39 1.498 1.803 1.012 3.14-.487 1.337-1.723 2.144-2.794 1.754-.953-.347-1.397-1.504-1.14-2.697a2 2 0 0 0-.508-.09q-.501-.037-1.208.165l-.031.01a4 4 0 0 1-.14.477c-.597 1.64-2.17 2.597-3.536 2.1s-1.955-2.24-1.358-3.88m9.504-.434c-.73-.266-1.664.343-2.052 1.408-.387 1.066-.064 2.132.667 2.398.73.266 1.664-.343 2.052-1.408s.064-2.132-.667-2.398m-6.167-1.122c-1.036-.377-2.297.39-2.793 1.754s-.024 2.762 1.012 3.14c1.036.376 2.298-.392 2.794-1.755s.023-2.762-1.013-3.14z",
			fill: "#222768"
		}),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			d: "M153.783 115.079c-.449-.4-.897-2.243-1.097-4.187-.399-3.938-.698-4.486-3.589-6.031l-2.093-1.147-3.788 1.545c-2.094.848-4.087 1.446-4.436 1.296-.947-.349-6.78-10.716-6.78-12.012 0-.698 1.048-1.894 3.24-3.589l3.24-2.542V82.93l-3.24-2.542c-2.043-1.595-3.24-2.89-3.24-3.539 0-1.047 5.085-10.417 6.331-11.663.598-.549 1.196-.499 4.037.598 4.736 1.844 5.085 1.894 7.627.25 2.243-1.447 2.292-1.546 2.641-4.637.648-5.93-.15-5.383 8.075-5.383 8.324 0 7.776-.349 8.424 5.533l.349 3.24 2.592 1.395 2.592 1.396 3.19-1.296c4.037-1.645 5.183-1.645 6.38.1 2.093 3.04 5.582 9.57 5.582 10.467 0 .648-1.196 1.894-3.24 3.39l-3.19 2.442v2.99l-.05 2.991 3.24 2.443c2.044 1.545 3.24 2.79 3.24 3.39 0 1.046-5.582 10.915-6.679 11.812-.548.449-1.645.2-4.586-.997l-3.937-1.545-2.542 1.396-2.542 1.395-.599 3.988c-.348 2.691-.847 4.237-1.395 4.685-1.296.947-12.81.848-13.757-.15m11.414-19.639c6.58-2.99 8.374-11.265 3.639-16.698-6.28-7.128-17.844-3.29-18.792 6.23-.398 4.287 2.991 9.371 7.377 11.066 1.595.598 5.832.3 7.776-.598",
			fill: "var(--B700)",
			style: {
				animation: "rotate-clockwise 2s infinite linear",
				transformOrigin: "center",
				transformBox: "fill-box"
			}
		}),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			d: "M176.263 146.231c-1.845-1.146-3.49-2.243-3.64-2.442-.149-.25.2-1.545.749-2.841.996-2.293.996-2.443.15-4.038-.699-1.345-1.197-1.644-3.141-1.894-3.639-.498-3.49-.249-3.49-5.433v-4.735l1.895-.299c3.589-.598 3.838-.698 4.785-2.243.897-1.545.847-1.595-.15-4.037-.598-1.346-.947-2.692-.797-2.891.299-.549 7.128-4.536 7.726-4.536.249 0 1.296.997 2.342 2.243 1.446 1.744 2.194 2.243 3.39 2.243s1.944-.499 3.39-2.243c1.046-1.246 2.093-2.243 2.342-2.243.598 0 7.427 3.987 7.726 4.536.15.2-.2 1.545-.748 2.89-.997 2.293-1.047 2.543-.299 3.988.798 1.496 1.196 1.695 4.935 2.293l1.844.3v4.734c0 5.184.15 4.935-3.49 5.433-1.893.25-2.442.549-3.14 1.894-.797 1.546-.797 1.695.15 4.187l.997 2.592-1.396.947c-2.542 1.745-6.03 3.589-6.729 3.589-.448 0-1.445-.947-2.292-2.044-1.247-1.744-1.795-2.093-3.29-2.143s-1.944.25-3.34 2.094c-.847 1.146-1.944 2.093-2.342 2.093-.449 0-2.293-.897-4.137-1.994m13.109-10.716c4.486-2.343 4.486-9.371-.1-11.813-5.832-3.14-12.212 3.19-9.171 9.121 1.595 3.09 6.03 4.337 9.27 2.692z",
			fill: "var(--R500)",
			style: {
				animation: "rotate-counter-clockwise 2s infinite linear",
				transformOrigin: "center",
				transformBox: "fill-box"
			}
		}),
		/* @__PURE__ */ (0, Q.jsxs)("defs", { children: [/* @__PURE__ */ (0, Q.jsxs)("linearGradient", {
			id: "paint0_linear_2664_5084",
			x1: 53.366,
			y1: 112.162,
			x2: 38.26,
			y2: 175.224,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ (0, Q.jsx)("stop", { stopColor: "#2A318C" }), /* @__PURE__ */ (0, Q.jsx)("stop", {
				offset: 1,
				stopColor: "#1D225F"
			})]
		}), /* @__PURE__ */ (0, Q.jsxs)("linearGradient", {
			id: "paint1_linear_2664_5084",
			x1: 59.252,
			y1: 30.82,
			x2: 59.252,
			y2: 113.448,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ (0, Q.jsx)("stop", { stopColor: "#EEE" }), /* @__PURE__ */ (0, Q.jsx)("stop", {
				offset: 1,
				stopColor: "#D6D7D8"
			})]
		})] })
	]
}), ym = /* @__PURE__ */ function(e) {
	return e.FAIL = "Fail", e.SUCCESS = "Success", e.PROGRESSING = "Progressing", e;
}({}), bm = (e) => {
	switch (e) {
		case ym.FAIL: return /* @__PURE__ */ (0, Q.jsx)(z, {
			name: "ic-close-large",
			color: "R500"
		});
		case ym.SUCCESS: return /* @__PURE__ */ (0, Q.jsx)(z, {
			name: "ic-check",
			color: "G500"
		});
		default: return /* @__PURE__ */ (0, Q.jsx)(z, {
			name: "ic-circle-loader",
			color: "N300"
		});
	}
}, xm = (e) => {
	switch (e) {
		case ym.FAIL: return "Failed";
		case ym.SUCCESS: return "Succeeded";
		default: return "Progressing";
	}
}, Sm = /* @__PURE__ */ function(e) {
	return e.CI_BUILD = "CI_BUILD", e.LINKED_CI = "LINKED", e.EXTERNAL_CI = "EXTERNAL", e.CI_JOB = "CI_JOB", e.LINKED_CD = "LINKED_CD", e;
}({}), Cm = /* @__PURE__ */ function(e) {
	return e.SELECT_ENV = "SelectEnv", e.FEASIBILITY = "Feasibility", e.SWITCH = "Switch", e;
}({}), wm = (e) => {
	let t = +e.id;
	return e.type === Cu.WEBHOOK ? {
		pipelineType: Sm.EXTERNAL_CI,
		pipelineId: t
	} : e.isJobCI ? {
		pipelineType: Sm.CI_JOB,
		pipelineId: t
	} : e.isLinkedCD ? {
		pipelineType: Sm.LINKED_CD,
		pipelineId: t
	} : e.isLinkedCI ? {
		pipelineType: Sm.LINKED_CI,
		pipelineId: t
	} : {
		pipelineType: Sm.CI_BUILD,
		pipelineId: t
	};
}, Tm = (e) => e.flatMap((e) => e.nodes.map((t) => ({
	...t,
	appName: e.name,
	appId: e.appId
}))).filter((e) => e.type === Cu.CI || e.type === Cu.WEBHOOK), Em = (e, t) => {
	let n = new Map(t.map((e) => [+e.id, e.appName]));
	return e.map(({ sourcePipelineId: e, status: t, statusDetails: r }) => ({
		pipelineId: e,
		appName: n.get(e),
		status: t,
		statusDetails: r
	}));
}, Dm = async ({ dryRun: e = !1, destinationPipelineData: t, ciNodes: n }) => {
	let r = { dryRun: e };
	return Em((await nf(Rd(O.CI_PIPELINE_SWITCH, r), {
		sourcePipelines: n.map(wm),
		destinationPipelineData: t
	})).result, n);
}, Om = () => /* @__PURE__ */ (0, Q.jsx)(R, {
	title: "Checking feasibility...",
	subTitle: "It might take some time depending upon the number of applications",
	SvgImage: vm
}), km = ({ changeCIFeasibility: e, isDryRun: t }) => {
	let n = (e) => {
		switch (e) {
			case ym.FAIL: return t ? "Cannot change" : "Failed to change";
			case ym.SUCCESS: return t ? "Can change" : "Changed";
			default: return "Progressing";
		}
	};
	return /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "px-20 py-20 flexbox-col flex-grow-1 dc__overflow-auto",
		children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "dc__grid dc__gap-16 feasibility-modal-columns fs-12 fw-6 lh-18 cn-7 py-8",
			children: [
				/* @__PURE__ */ (0, Q.jsx)("span", { children: "APPLICATION" }),
				/* @__PURE__ */ (0, Q.jsx)("span", { children: t ? "FEASIBILITY" : "CHANGE SOURCE STATUS" }),
				/* @__PURE__ */ (0, Q.jsx)("span", { children: "MESSAGE" })
			]
		}), e.map((e) => /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "dc__grid dc__gap-16 feasibility-modal-columns fs-13 fw-4 lh-20 cn-9 py-8",
			children: [
				/* @__PURE__ */ (0, Q.jsx)("span", {
					className: "dc__ellipsis-right",
					children: e.appName
				}),
				/* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "flexbox dc__align-items-center dc__h-fit-content dc__gap-6",
					children: [bm(e.status), /* @__PURE__ */ (0, Q.jsx)("span", {
						className: "fs-13 fw-4 lh-20 cn-9",
						children: n(e.status)
					})]
				}),
				/* @__PURE__ */ (0, Q.jsx)("span", { children: e.statusDetails })
			]
		}, `${e.appName}=${e.pipelineId}`))]
	});
}, Am = ({ ciNodes: e, envName: t, setCINodes: n, handleTriggerSwitchPipelines: r }) => {
	let [i, a, o, s] = hf(() => Dm({
		dryRun: !0,
		ciNodes: e,
		destinationPipelineData: {
			pipelineType: t ? Sm.LINKED_CD : Sm.CI_BUILD,
			...t ? { customConfigurations: { linkedCdEnvironment: t } } : {}
		}
	})), c = new Map(a?.map((e) => [e.pipelineId, e.status === ym.SUCCESS])), l = () => {
		n(e.filter((e) => c.get(+e.id))), r();
	}, u = a?.filter((e) => e.status === ym.SUCCESS).length, d = a?.length;
	return i ? /* @__PURE__ */ (0, Q.jsx)(Om, {}) : o ? /* @__PURE__ */ (0, Q.jsx)(Ks, {
		code: o.code,
		reload: s
	}) : /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox-col flex-grow-1 dc__overflow-auto",
		children: [/* @__PURE__ */ (0, Q.jsx)(km, {
			isDryRun: !0,
			changeCIFeasibility: a
		}), /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox px-20 py-16 dc__content-space dc__border-top",
			children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox dc__align-items-center dc__gap-8",
				children: [u === d ? /* @__PURE__ */ (0, Q.jsx)(he, { className: "icon-dim-20 scg-5 dc__no-shrink" }) : /* @__PURE__ */ (0, Q.jsx)(Et, { className: "icon-dim-20 dc__no-shrink" }), /* @__PURE__ */ (0, Q.jsxs)("span", {
					className: "fs-13 fw-4 lh-20 cn-9",
					children: [
						u,
						"/",
						d,
						" selected applications\xA0",
						t ? `can be synced with ${t}` : "image source can be changed to build pipeline"
					]
				})]
			}), /* @__PURE__ */ (0, Q.jsx)(M, {
				dataTestId: "change-ci-create-build-pipeline",
				text: t ? "Change image source" : "Create build pipeline",
				size: I.medium,
				disabled: !u,
				onClick: l
			})]
		})]
	});
}, jm = 20, Mm = ({ ciNodes: e, setCINodes: t, pipelineType: n, customConfigurations: r, handleCloseChangeCIModal: i }) => {
	let [a, o] = j(!1), [s, c] = j(e.reduce((e, t) => ({
		...e,
		[t.id]: {
			appName: t.appName,
			status: ym.PROGRESSING,
			statusDetails: ""
		}
	}), {})), l = async () => {
		let { FORCE_SECURITY_SCANNING: t, RECOMMEND_SECURITY_SCANNING: i, DEFAULT_CI_TRIGGER_TYPE_MANUAL: a } = window._env_, l = {};
		o(!0);
		let u = [];
		for (let o = 0; o < e.length; o += jm) u.push(async () => {
			let u = e.slice(o, o + jm);
			try {
				(await Dm({
					dryRun: !1,
					ciNodes: u,
					destinationPipelineData: {
						pipelineType: n,
						customConfigurations: {
							...r,
							isManual: a ?? !1,
							scanEnabled: (i || t) ?? !1
						}
					}
				})).forEach((e) => {
					l[e.pipelineId] = {
						appName: e.appName,
						status: e.status,
						statusDetails: e.statusDetails,
						pipelineId: e.pipelineId
					};
				});
			} catch (e) {
				u.forEach((t) => {
					l[+t.id] = {
						...s[+t.id],
						status: ym.FAIL,
						statusDetails: e?.errors?.[0].userMessage || ""
					};
				});
			} finally {
				c({
					...s,
					...l
				});
			}
		});
		await fo(u, !1, u.length), o(!1);
	};
	k(() => {
		l();
	}, [e]);
	let u = () => {
		let n = e.filter((e) => s[+e.id]?.status === ym.FAIL), r = n.reduce((e, t) => ({
			...e,
			[t.id]: {
				appName: t.appName,
				status: ym.PROGRESSING,
				statusDetails: ""
			}
		}), {});
		t(n), c(r);
	}, d = Object.values(s), f = (e) => d.filter((t) => t.status === e).length, p = f(ym.FAIL), m = f(ym.SUCCESS), h = f(ym.PROGRESSING);
	return /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox-col dc__gap-16 flex-grow-1 mh-0",
		children: [/* @__PURE__ */ (0, Q.jsx)("div", {
			className: "px-20 pt-16",
			children: /* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "dc__border br-8 shadow__card--20",
				children: [/* @__PURE__ */ (0, Q.jsx)(zl, {
					entities: [
						{
							color: "var(--G500)",
							label: "Success",
							value: m
						},
						{
							color: "var(--Y500)",
							label: "Progressing",
							value: h
						},
						{
							color: "var(--R500)",
							label: "Failed",
							value: p
						}
					],
					rootClassName: "fs-13 dc__border-bottom-n1 p-16"
				}), /* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "flexbox dc__gap-8 py-8 px-16 dc__align-items-center",
					children: [/* @__PURE__ */ (0, Q.jsx)(z, {
						name: a ? "ic-circle-loader" : "ic-info-outline",
						size: 20,
						color: "Y500"
					}), /* @__PURE__ */ (0, Q.jsx)("span", { children: a ? "Progressing" : `Image source changed for ${m} environment(s)` })]
				})]
			})
		}), /* @__PURE__ */ (0, Q.jsx)(km, {
			changeCIFeasibility: d,
			isDryRun: !1
		})]
	}), /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox px-20 py-16 dc__gap-16 dc__border-top",
		children: [/* @__PURE__ */ (0, Q.jsx)(M, {
			dataTestId: "close-change-ci-bulk",
			text: "Close",
			style: P.neutral,
			variant: F.secondary,
			size: I.medium,
			onClick: i,
			disabled: a
		}), !!p && !a && /* @__PURE__ */ (0, Q.jsx)(M, {
			dataTestId: "retry-change-ci-bulk",
			text: "Retry failed",
			startIcon: /* @__PURE__ */ (0, Q.jsx)(ir, {}),
			size: I.medium,
			onClick: u
		})]
	})] });
}, Nm = {
	BranchFixed: "Branch fixed",
	BranchRegex: "Branch regex"
}, Pm = [{
	label: Nm.BranchFixed,
	value: Yl.BranchFixed
}, {
	label: Nm.BranchRegex,
	value: Yl.BranchRegex
}], Fm = ({ sourceType: e, branchName: t, handleBranchNameChange: n, handleChangeSourceType: r, handleCloseGitSourceModal: i, handleCreatePipeline: a }) => /* @__PURE__ */ (0, Q.jsx)(Su, {
	close: i,
	children: /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "w-600 bg__primary flexbox-col br-8 dc__m-auto mt-40",
		onClick: uf,
		children: [
			/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "dc__border-bottom px-20 py-16 flexbox dc__content-space",
				children: [/* @__PURE__ */ (0, Q.jsx)("span", {
					className: "fs-16 fw-6 lh-24 cn-9",
					children: "Create build pipeline"
				}), /* @__PURE__ */ (0, Q.jsx)(M, {
					dataTestId: "close-change-ci",
					ariaLabel: "close-change-ci",
					icon: /* @__PURE__ */ (0, Q.jsx)(tr, {}),
					size: I.small,
					showAriaLabelInTippy: !1,
					variant: F.borderLess,
					style: P.negativeGrey,
					onClick: i
				})]
			}),
			/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox-col dc__gap-8 p-20 h-250",
				children: [/* @__PURE__ */ (0, Q.jsx)("span", {
					className: "fs-14 fw-6 lh-20 cn-9",
					children: "Select code source"
				}), /* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "flexbox dc__gap-16",
					children: [/* @__PURE__ */ (0, Q.jsx)("div", {
						className: "w-50",
						children: /* @__PURE__ */ (0, Q.jsx)(V, {
							inputId: "select-branch-source-type",
							label: "Source type",
							required: !0,
							options: Pm,
							value: e,
							onChange: r,
							size: I.large
						})
					}), /* @__PURE__ */ (0, Q.jsx)("div", {
						className: "w-50",
						children: /* @__PURE__ */ (0, Q.jsx)(os, {
							autoFocus: !0,
							name: "change-ci-source",
							label: "Branch",
							required: !0,
							value: t,
							onChange: n,
							placeholder: `${e.label}`,
							onKeyDown: (e) => {
								e.key === "Enter" && (uf(e), a());
							}
						})
					})]
				})]
			}),
			/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox dc__align-items-center dc__content-end py-16 px-20 dc__gap-12",
				children: [/* @__PURE__ */ (0, Q.jsx)(M, {
					dataTestId: "cancel-change-source",
					text: "Cancel",
					variant: F.secondary,
					style: P.neutral,
					onClick: i
				}), /* @__PURE__ */ (0, Q.jsx)(M, {
					dataTestId: "cancel-change-source",
					text: "Create pipeline",
					onClick: a,
					disabled: !t
				})]
			})
		]
	})
}), Im = ({ selectedWorkflows: e, handleCloseChangeCIModal: t }) => {
	let [n, r] = j(Tm(e)), [i, a] = j(Cm.FEASIBILITY), [o, s] = j(!1), [c, l] = j(Pm[0]), [u, d] = j(""), f = () => {
		s(!0);
	}, p = () => {
		s(!1);
	}, m = (e) => {
		l(e);
	}, h = (e) => {
		d(e.target.value);
	}, g = () => {
		u && (s(!1), a(Cm.SWITCH));
	}, _ = () => t(!0), v = () => {
		if (i === Cm.SWITCH) {
			_();
			return;
		}
		t();
	};
	return /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsx)(Rs, {
		position: "right",
		onClose: v,
		onEscape: v,
		children: /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "w-800 h-100 bg__primary flexbox-col",
			onClick: uf,
			children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "dc__border-bottom py-12 px-16 flexbox dc__content-space",
				children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "flex dc__gap-4",
					children: [
						/* @__PURE__ */ (0, Q.jsx)("span", {
							className: "fs-16 lh-24 fw-4 cn-9",
							children: "Change Image Source"
						}),
						/* @__PURE__ */ (0, Q.jsx)(He, { className: "icon-dim-20 dc__flip-180" }),
						/* @__PURE__ */ (0, Q.jsx)("span", {
							className: "fs-16 fw-6 lh-24 cn-9",
							children: "build pipeline"
						}),
						i === Cm.SWITCH && /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsx)(He, { className: "icon-dim-20 dc__flip-180" }), /* @__PURE__ */ (0, Q.jsx)("span", {
							className: "fs-16 fw-6 lh-24 cn-9",
							children: "Status"
						})] })
					]
				}), /* @__PURE__ */ (0, Q.jsx)(M, {
					dataTestId: "close-change-ci",
					ariaLabel: "close change ci modal",
					icon: /* @__PURE__ */ (0, Q.jsx)(er, {}),
					size: I.xs,
					showAriaLabelInTippy: !1,
					variant: F.borderLess,
					style: P.negativeGrey,
					onClick: v
				})]
			}), i === Cm.FEASIBILITY ? /* @__PURE__ */ (0, Q.jsx)(Am, {
				ciNodes: n,
				setCINodes: r,
				handleTriggerSwitchPipelines: f
			}) : /* @__PURE__ */ (0, Q.jsx)(Mm, {
				pipelineType: Sm.CI_BUILD,
				ciNodes: n,
				customConfigurations: { ciMaterialSource: {
					type: c.value,
					...c.value === Yl.BranchFixed ? { value: u } : { regex: u }
				} },
				setCINodes: r,
				handleCloseChangeCIModal: _
			})]
		})
	}), o && /* @__PURE__ */ (0, Q.jsx)(Fm, {
		sourceType: c,
		branchName: u,
		handleBranchNameChange: h,
		handleChangeSourceType: m,
		handleCreatePipeline: g,
		handleCloseGitSourceModal: p
	})] });
}, Lm = "Sync with Environment", Rm = ["IMAGE SOURCE", "DEPLOY TO ENVIRONMENT"], zm = "Search environment", Bm = "Keep deployments in sync with another environment by making images from the desired environment available for deployment.", Vm = "Sync with Environment", Hm = "Deployment pipeline created", Um = {
	DEPLOY_TO: "Deploy to...",
	CREATE_PIPELINE: "Create Pipeline",
	UPDATE_PIPELINE: "Update Pipeline",
	DELETE_PIPELINE: "Delete Pipeline"
}, Wm = {
	IMAGE_SOURCE: "image-source",
	DEPLOY_TO: "deploy-to"
}, Gm = { NO_SEARCH_ENV: {
	TITLE: "No environments found",
	SUBTITLE: "Try changing the search query"
} }, Km = {
	CREATION: "Pipeline created successfully",
	NO_SOURCE_SELECTED: "Please select an image source",
	SUCCESS_DELETE: "Pipeline deleted successfully"
}, qm = {
	LOADING_REQUEST: "Request in progress",
	SELECT_SOURCE: "Select an image source",
	ADD_NEW_DEPLOYMENT_PIPELINE: "Add deployment pipeline",
	CANT_ADD_DEPLOYMENT_PIPELINE: "Cannot add new workflow or deployment pipelines when environment filter is applied.",
	DISABLED_RADIO: {
		SELECTED: "Image source cannot belong to the same workflow",
		CYCLIC: "This environment cannot be used as image source as it is using another environment as image source",
		PRESENT: "Deployment pipeline already exists for this environment"
	}
}, Jm = ({ appIds: e, selectedEnv: t, setSelectedEnv: n, handleCheckFeasibility: r }) => {
	let { searchKey: i, handleSearch: a, clearFilters: o } = Mf(), [s, c, l, u] = hf(() => bn(e));
	return s ? /* @__PURE__ */ (0, Q.jsx)(ul, {}) : l ? /* @__PURE__ */ (0, Q.jsx)(Ks, {
		code: l.code,
		reload: u
	}) : /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [
		/* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "py-12 px-20 dc__gap-12 flexbox dc__align-items-center",
			children: [/* @__PURE__ */ (0, Q.jsx)(vt, { className: "icon-dim-20" }), /* @__PURE__ */ (0, Q.jsx)("span", {
				className: "fs-12 fw-6 lh-20 cn-7",
				children: "IMAGE SOURCE"
			})]
		}),
		/* @__PURE__ */ (0, Q.jsx)(Il, {
			initialSearchText: i,
			containerClassName: "px-12 py-8",
			handleSearchChange: a
		}),
		c?.length ? /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsx)(vl, {
			className: "dc__overflow-auto flexbox-imp flexbox-col flex-grow-1 sync-with-cd-list dc__inline-radio-group dc__no-border-imp",
			name: "app-group-sync-cd",
			value: t,
			onChange: (e) => {
				n(e.target.value);
			},
			children: (() => {
				let e = i.toLowerCase(), t = c?.filter((t) => t.environmentName.includes(e)) ?? [];
				return t.length ? t.map((e) => {
					let { environmentName: t, environmentId: n, isProd: r } = e;
					return /* @__PURE__ */ (0, Q.jsx)(yl, {
						value: t,
						children: /* @__PURE__ */ (0, Q.jsxs)("div", {
							className: "flexbox dc__align-items-center dc__gap-6",
							children: [/* @__PURE__ */ (0, Q.jsx)("span", {
								className: "fs-13 fw-4 lh-20 cn-9",
								children: t
							}), r && /* @__PURE__ */ (0, Q.jsx)("span", {
								className: "fs-10 fw-6 cn-7 lh-12 p-4 dc__border br-4 bcn-50",
								children: "PROD"
							})]
						})
					}, n);
				}) : /* @__PURE__ */ (0, Q.jsx)(oc, { handleClearFilters: o });
			})()
		}), /* @__PURE__ */ (0, Q.jsx)("div", {
			className: "flexbox px-20 py-16 flex-justify-end dc__border-top",
			children: /* @__PURE__ */ (0, Q.jsx)(M, {
				dataTestId: "change-ci-sync-cd-feasibility",
				text: "Next",
				endIcon: /* @__PURE__ */ (0, Q.jsx)(Kn, {}),
				size: I.medium,
				disabled: !t,
				onClick: r
			})
		})] }) : /* @__PURE__ */ (0, Q.jsx)(R, { title: "No environments" })
	] });
}, Ym = ({ selectedWorkflows: e, handleCloseChangeCIModal: t }) => {
	let [n, r] = j(Tm(e)), [i, a] = j(Cm.SELECT_ENV), [o, s] = j(null), c = () => {
		a(Cm.SELECT_ENV);
	}, l = () => {
		a(Cm.FEASIBILITY);
	}, u = () => {
		a(Cm.SWITCH);
	}, d = () => t(!0), f = () => {
		if (i === Cm.SWITCH) {
			d();
			return;
		}
		t();
	};
	return /* @__PURE__ */ (0, Q.jsx)(Rs, {
		position: "right",
		onClose: f,
		onEscape: f,
		children: /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "w-800 h-100 bg__primary flexbox-col",
			onClick: uf,
			children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "dc__border-bottom py-12 px-16 flexbox dc__content-space",
				children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "flex dc__gap-12",
					children: [i === Cm.FEASIBILITY && /* @__PURE__ */ (0, Q.jsx)(M, {
						ariaLabel: "sync-cd-back",
						dataTestId: "sync-cd-back",
						icon: /* @__PURE__ */ (0, Q.jsx)(Kn, { className: "dc__flip-180" }),
						variant: F.secondary,
						style: P.neutral,
						size: I.xs,
						showAriaLabelInTippy: !1,
						onClick: c
					}), /* @__PURE__ */ (0, Q.jsxs)("div", {
						className: "flex dc__gap-4",
						children: [
							/* @__PURE__ */ (0, Q.jsx)("span", {
								className: "fs-16 lh-24 fw-4 cn-9",
								children: "Change Image Source"
							}),
							/* @__PURE__ */ (0, Q.jsx)(He, { className: "icon-dim-20 dc__flip-180" }),
							/* @__PURE__ */ (0, Q.jsx)("span", {
								className: "fs-16 fw-6 lh-24 cn-9",
								children: `Sync with ${i === Cm.SWITCH ? o : "environment"}`
							}),
							/* @__PURE__ */ (0, Q.jsx)(Cc, {
								heading: Vm,
								infoText: Bm,
								iconClassName: "icon-dim-20"
							}),
							i === Cm.SWITCH && /* @__PURE__ */ (0, Q.jsx)("span", {
								className: "fs-16 fw-6 lh-24 cn-9",
								children: "Status"
							})
						]
					})]
				}), /* @__PURE__ */ (0, Q.jsx)(M, {
					dataTestId: "close-change-ci",
					ariaLabel: "close-change-ci",
					icon: /* @__PURE__ */ (0, Q.jsx)(er, {}),
					size: I.xs,
					showAriaLabelInTippy: !1,
					variant: F.borderLess,
					style: P.negativeGrey,
					onClick: f
				})]
			}), (() => {
				switch (i) {
					case Cm.SELECT_ENV: return /* @__PURE__ */ (0, Q.jsx)(Jm, {
						appIds: n.map((e) => e.appId),
						handleCheckFeasibility: l,
						selectedEnv: o,
						setSelectedEnv: s
					});
					case Cm.FEASIBILITY: return /* @__PURE__ */ (0, Q.jsx)(Am, {
						ciNodes: n,
						setCINodes: r,
						envName: o,
						handleTriggerSwitchPipelines: u
					});
					default: return /* @__PURE__ */ (0, Q.jsx)(Mm, {
						pipelineType: Sm.LINKED_CD,
						ciNodes: n,
						setCINodes: r,
						customConfigurations: { linkedCdEnvironment: o },
						handleCloseChangeCIModal: d
					});
				}
			})()]
		})
	});
}, Xm = ({ selectedWorkflows: e, handleCloseChangeImageSource: t }) => {
	let [n, r] = j(!1), [i, a] = j(null), o = () => {
		r(!0);
	}, c = () => {
		r(!1);
	}, l = () => {
		r(!1), a(Sm.CI_BUILD);
	}, u = (e) => {
		a(null), e && t();
	};
	return /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [
		/* @__PURE__ */ (0, Q.jsx)(M, {
			dataTestId: "change-ci-bulk",
			text: "Change image source",
			onClick: o,
			size: I.medium,
			style: P.neutral,
			variant: F.secondary
		}),
		/* @__PURE__ */ (0, Q.jsx)(wu, {
			open: n,
			onClose: c,
			showLinkedCDSource: !0,
			addCIPipeline: l,
			addLinkedCD: () => {
				r(!1), a(Sm.LINKED_CD);
			},
			addWebhookCD: $d,
			linkedCDSourceVariant: s,
			changeCIPayload: null,
			resetChangeCIPayload: $d,
			isAppGroup: !0,
			isTemplateView: !1
		}),
		i === Sm.CI_BUILD && /* @__PURE__ */ (0, Q.jsx)(Im, {
			selectedWorkflows: e,
			handleCloseChangeCIModal: u
		}),
		i === Sm.LINKED_CD && /* @__PURE__ */ (0, Q.jsx)(Ym, {
			selectedWorkflows: e,
			handleCloseChangeCIModal: u
		})
	] });
}, Zm = (e) => /* @__PURE__ */ (0, Q.jsx)("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "0 0 24 24",
	...e,
	children: /* @__PURE__ */ (0, Q.jsx)("path", {
		fill: "#3B444C",
		fillRule: "evenodd",
		d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Zm3-7a5.975 5.975 0 0 0 3.807-1.363 7 7 0 1 1-8.445-8.445A6 6 0 0 0 15 15Z",
		clipRule: "evenodd"
	})
}), Qm = ({ envId: e, envName: t, appIds: n, isDeploymentLoading: r, skipHibernated: i, setSkipHibernated: a }) => {
	let [o, s, c, l] = hf(() => Yu({
		envId: e,
		appIds: n
	}), []), u = s?.apps.filter((e) => e.appStatus === Zl.HIBERNATING) ?? [], d = u.length;
	return o ? /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flex dc__gap-8 py-6",
		children: [/* @__PURE__ */ (0, Q.jsx)(z, {
			name: "ic-circle-loader",
			size: 20,
			color: null
		}), /* @__PURE__ */ (0, Q.jsx)("span", {
			className: "fs-13 fw-4 lh-20",
			children: "Checking hibernated applications"
		})]
	}) : !c && s && !d ? /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flex dc__gap-8 py-6",
		children: [/* @__PURE__ */ (0, Q.jsx)(z, {
			name: "ic-info-outline",
			size: 20,
			color: null
		}), /* @__PURE__ */ (0, Q.jsx)("span", {
			className: "fs-13 fw-4 lh-20",
			children: "None of the selected apps are hibernated"
		})]
	}) : /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flex dc__gap-8",
		children: [/* @__PURE__ */ (0, Q.jsx)(Wo, {
			dataTestId: "skip-hibernated-deployment",
			isChecked: i,
			value: Io.CHECKED,
			onChange: () => {
				a((e) => !e);
			},
			rootClassName: "m-0",
			disabled: r,
			children: /* @__PURE__ */ (0, Q.jsx)("span", {
				className: "fs-13 fw-4 lh-20",
				children: "Do not deploy hibernated applications"
			})
		}), c ? /* @__PURE__ */ (0, Q.jsx)(M, {
			dataTestId: "reload-hibernated-apps",
			text: "View applications",
			variant: F.text,
			onClick: l
		}) : /* @__PURE__ */ (0, Q.jsx)(su, {
			heading: "Hibernated Applications",
			Icon: Zm,
			showCloseButton: !0,
			theme: cu.white,
			trigger: "click",
			additionalContent: /* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "fs-13 lh-20 cn-9 fw-4 p-12 mxh-200 dc__overflow-auto",
				children: [/* @__PURE__ */ (0, Q.jsx)("span", {
					className: "fs-13 lh-20 fw-4 dc__word-break",
					children: `Hibernated applications deployed on ${t}:`
				}), /* @__PURE__ */ (0, Q.jsx)("ol", {
					className: "p-0 mb-0 ml-16 mt-20",
					children: u.map(({ appId: e, appName: t }) => /* @__PURE__ */ (0, Q.jsx)("li", { children: t }, `${e}-${t}`))
				})]
			}),
			className: "w-300",
			interactive: !0,
			children: /* @__PURE__ */ (0, Q.jsx)("div", { children: /* @__PURE__ */ (0, Q.jsx)(M, {
				dataTestId: "view-hibernated-apps",
				text: `View ${d} ${d === 1 ? "application" : "applications"}`,
				variant: F.text
			}) })
		})]
	});
}, $m = {
	CLONE_PIPELINE_BUTTON: "Clone pipeline config",
	CANCEL: "Cancel",
	CLOSE_MODAL: "Close modal",
	SOURCE_ENVIRONMENT_TITLE: "Clone pipeline configuration from source environment",
	TARGET_ENVIRONMENT_SELECTOR_LABEL: "Create deployment pipeline to target environment",
	TARGET_ENVIRONMENT_SELECTOR_PLACEHOLDER: "Select target environment",
	WORKFLOW_TYPE_SELECTION_HEADING: "Create deployment pipeline in",
	NEW_WORKFLOW_TITLE: "New workflow",
	NEW_WORKFLOW_INFO: "Creates deployment pipeline in a new workflow. Image source will be same as the source environment.",
	SOURCE_WORKFLOW_TITLE: "Workflow as source environment",
	SOURCE_WORKFLOW_INFO: "Creates deployment pipeline in source environment's workflow.",
	CLONE_LOADING_SUBTITLE: "It might take some time depending upon the number of applications",
	STATUS_TABLE_HEADER: {
		APPLICATION: "Application",
		SOURCE: "Source Environment",
		TARGET: "Target Environment",
		STATUS: "Clone status"
	},
	RETRY_FAILED: "Retry failed",
	DEFAULT_ERROR_MESSAGE: "Failed to clone pipeline config"
}, eh = /* @__PURE__ */ function(e) {
	return e.SUCCESS = "SUCCESS", e.FAILED = "FAILED", e.SKIPPED = "SKIPPED", e;
}({}), th = /* @__PURE__ */ function(e) {
	return e.NEW_WORKFLOW = "NEW_WORKFLOW", e.SAME_WORKFLOW = "SAME_WORKFLOW", e;
}({}), nh = /* @__PURE__ */ function(e) {
	return e.APP_NAME = "appName", e.CLONE_STATUS = "status", e;
}({}), rh = (e) => `Clone the pipeline configuration of '${e}' pipeline and generate a deployment pipeline of target environment for selected application(s).`, ih = (e) => e ? null : "Target environment is required to clone pipeline configuration.", ah = (e) => `Clone pipeline config for ${Array.isArray(e) ? `${e.length} applications` : `'${e.application}'`}`, oh = (e) => e === th.NEW_WORKFLOW ? "Clone in new workflow" : "Clone in source workflow", sh = (e) => `Initiating cloning of '${e}' for selected application(s)`, ch = (e) => e ? "Cloning in process" : "Clone Status", lh = (e) => `Go to application group '${e}'`, uh = {
	...ju,
	control: (e, t) => ({
		...ju.control(e, t),
		width: "480px"
	})
}, dh = (e) => {
	switch (e) {
		case eh.SKIPPED: return /* @__PURE__ */ (0, Q.jsx)(gi, { className: "dc__no-shrink icon-dim-16 mt-2" });
		case eh.SUCCESS: return /* @__PURE__ */ (0, Q.jsx)(Zr, { className: "dc__no-shrink icon-dim-16 mt-2" });
		default: return /* @__PURE__ */ (0, Q.jsx)(ba, { className: "dc__no-shrink icon-dim-16 mt-2" });
	}
}, fh = (e) => {
	switch (e) {
		case eh.SKIPPED: return /* @__PURE__ */ (0, Q.jsx)("span", {
			className: "cy-7 fs-13 fw-4 lh-20",
			children: "Skipped"
		});
		case eh.SUCCESS: return /* @__PURE__ */ (0, Q.jsx)("span", {
			className: "cg-7 fs-13 fw-4 lh-20",
			children: "Clone successful"
		});
		default: return /* @__PURE__ */ (0, Q.jsx)("span", {
			className: "cr-7 fs-13 fw-4 lh-20",
			children: "Failed"
		});
	}
}, ph = ({ onClick: e, sourceEnvironmentName: t, disabled: n }) => /* @__PURE__ */ (0, Q.jsx)(ft, {
	className: "default-tt w-250",
	arrow: !1,
	content: rh(t),
	placement: "top",
	children: /* @__PURE__ */ (0, Q.jsxs)("button", {
		type: "button",
		className: "dc__transparent w-100 py-6 px-8 flexbox dc__align-items-center dc__gap-8 dc__hover-n50 dc__truncate cn-9 fs-13 lh-20",
		onClick: e,
		"data-testid": "clone-environment",
		disabled: n,
		children: [/* @__PURE__ */ (0, Q.jsx)(Oa, { className: "dc__no-shrink dc__no-svg-fill icon-dim-16 scn-7" }), $m.CLONE_PIPELINE_BUTTON]
	})
}), mh = ({ isLoading: e, handleClonePipeline: t, handleCloseClonePipelineModal: n, sourceEnvironmentName: r, statusList: i, targetEnvironmentName: a, targetEnvironmentId: o }) => {
	let s = X(), { sortOrder: c, sortBy: l, handleSorting: u } = Mf({ initialSortKey: nh.APP_NAME });
	Of({
		shouldPrompt: e,
		message: ds
	});
	let d = A(() => l === nh.APP_NAME ? i.sort((e, t) => df(e.application, t.application, c)) : l === nh.CLONE_STATUS ? i.sort((e, t) => df(e.status, t.status, c)) : i, [
		i,
		c,
		l
	]), f = A(() => i.filter((e) => e.status === eh.FAILED), [i]), p = async () => {
		await t(f.map((e) => e.application));
	}, m = () => {
		u(nh.APP_NAME);
	}, h = () => {
		u(nh.CLONE_STATUS);
	}, g = () => {
		e || n();
	}, _ = () => {
		s(Y(B.APP_GROUP_DETAILS.OVERVIEW, { envId: String(o) }));
	}, v = () => e ? /* @__PURE__ */ (0, Q.jsx)(R, {
		classname: "dc__text-center",
		title: sh(r),
		subTitle: $m.CLONE_LOADING_SUBTITLE,
		SvgImage: vm,
		imageType: yc.Large,
		children: /* @__PURE__ */ (0, Q.jsx)(xc, {
			description: ds,
			variant: "warning"
		})
	}) : /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox-col h-100 dc__overflow-auto",
		children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "display-grid dc__column-gap-16 clone-pipeline-response-modal--row-wrapper dc__align-items-center dc__uppercase bg__primary dc__position-sticky dc__top-0 dc__zi-1 dc__border-bottom-n1 fs-12 fw-6 lh-20 px-20 py-8",
			children: [
				/* @__PURE__ */ (0, Q.jsx)(ql, {
					isSorted: l === nh.APP_NAME,
					sortOrder: c,
					title: $m.STATUS_TABLE_HEADER.APPLICATION,
					triggerSorting: m,
					disabled: !1
				}),
				/* @__PURE__ */ (0, Q.jsx)(ql, {
					title: $m.STATUS_TABLE_HEADER.SOURCE,
					isSortable: !1
				}),
				/* @__PURE__ */ (0, Q.jsx)(ql, {
					title: $m.STATUS_TABLE_HEADER.TARGET,
					isSortable: !1
				}),
				/* @__PURE__ */ (0, Q.jsx)(ql, {
					isSorted: l === nh.CLONE_STATUS,
					sortOrder: c,
					title: $m.STATUS_TABLE_HEADER.STATUS,
					triggerSorting: h,
					disabled: !1
				})
			]
		}), d.map((e) => /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "dc__odd-child--sibling-bcn-50 display-grid dc__column-gap-16 clone-pipeline-response-modal--row-wrapper dc__align-start px-20 py-8",
			children: [
				/* @__PURE__ */ (0, Q.jsx)("span", {
					className: "cn-9 fs-13 fw-4 lh-20 dc__break-word",
					children: e.application
				}),
				/* @__PURE__ */ (0, Q.jsx)("span", {
					className: "cn-9 fs-13 fw-4 lh-20 dc__break-word",
					children: r
				}),
				/* @__PURE__ */ (0, Q.jsx)("span", {
					className: "cn-9 fs-13 fw-4 lh-20 dc__break-word",
					children: a
				}),
				/* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "flexbox dc__gap-4",
					children: [dh(e.status), /* @__PURE__ */ (0, Q.jsxs)("div", {
						className: "flexbox-col dc__gap-4",
						children: [fh(e.status), /* @__PURE__ */ (0, Q.jsx)("p", {
							className: "m-0 cn-7 fs-12 fw-4 lh-18 dc__break-word",
							children: e.message
						})]
					})]
				})
			]
		}, e.application))]
	}), y = !e;
	return /* @__PURE__ */ (0, Q.jsx)(xu, {
		className: "",
		onEscape: g,
		close: g,
		children: /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "bg__primary dc__position-fixed dc__right-0 dc__top-0 h-100 flexbox-col dc__content-space w-1024",
			onClick: uf,
			children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox-col dc__content-space h-100 dc__overflow-auto",
				children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "px-20 py-12 flexbox dc__content-space dc__align-items-center dc__border-bottom",
					children: [/* @__PURE__ */ (0, Q.jsx)("h2", {
						className: "dc__truncate cn-9 fs-16 fw-6 lh-24 m-0",
						children: ch(e)
					}), /* @__PURE__ */ (0, Q.jsx)("button", {
						type: "button",
						className: `p-0 flex dc__no-border dc__no-background dc__outline-none-imp dc__tab-focus h-20 w-20 dc__tab-focus ${e ? "dc__disabled" : ""}`,
						onClick: g,
						"data-testid": "close-clone-pipeline-response-modal",
						"aria-label": $m.CLOSE_MODAL,
						children: /* @__PURE__ */ (0, Q.jsx)(er, { className: "dc__no-shrink icon-dim-20" })
					})]
				}), v()]
			}), y && /* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "py-16 px-20 flexbox dc__content-end dc__align-items-center dc__gap-16 dc__border-top dc__no-shrink",
				children: [/* @__PURE__ */ (0, Q.jsxs)("button", {
					type: "button",
					className: `cta ${f.length > 0 ? "secondary" : ""} flex dc__no-text-transform dc__gap-8`,
					onClick: _,
					"data-testid": "open-target-environment-overview",
					children: [/* @__PURE__ */ (0, Q.jsx)("span", {
						className: "dc__truncate dc__mxw-300",
						children: lh(a)
					}), /* @__PURE__ */ (0, Q.jsx)(Kn, { className: `dc__no-shrink icon-dim-16 ${f.length > 0 ? "scb-5" : "scn-0"}` })]
				}), f.length > 0 && /* @__PURE__ */ (0, Q.jsxs)("button", {
					type: "button",
					className: "cta flex h-36 dc__no-text-transform dc__no-svg-fill dc__gap-8",
					onClick: p,
					"data-testid": "retry-failed-requests",
					children: [/* @__PURE__ */ (0, Q.jsx)(ir, { className: "dc__no-shrink icon-dim-16" }), $m.RETRY_FAILED]
				})]
			})]
		})
	});
}, hh = async ({ sourceEnvironmentName: e, targetEnvironmentName: t, appName: n, clonedPipelineWorkflowType: r }) => {
	try {
		let i = {
			appName: n,
			targetEnvironmentName: t,
			sourceEnvironmentName: e,
			...r === th.SAME_WORKFLOW && { cloneEnvInSameWorkflow: !0 }
		}, a = await nf(O.APP_WORKFLOW_CLONE, i);
		return a?.result ? {
			status: a.result.status,
			message: a.result.message
		} : {
			status: eh.FAILED,
			message: $m.DEFAULT_ERROR_MESSAGE
		};
	} catch (e) {
		return {
			status: eh.FAILED,
			message: e?.errors?.[0]?.userMessage || $m.DEFAULT_ERROR_MESSAGE
		};
	}
}, gh = ({ sourceEnvironmentName: e, selectedAppDetailsList: t, handleCloseClonePipelineModal: n }) => {
	let [r, i] = j(null), [a, o] = j(!1), [s, c] = j(th.NEW_WORKFLOW), [l, u] = j(!1), [d, f] = j([]), p = !Array.isArray(t), m = async (t) => {
		o(!0), u(!0);
		let n = [];
		t.forEach((t) => {
			n.push(() => hh({
				appName: t,
				sourceEnvironmentName: e,
				targetEnvironmentName: r.label,
				clonedPipelineWorkflowType: s
			}));
		});
		let i = await fo(n), a = [];
		i.forEach((e, n) => {
			e.status === dl.FULFILLED && a.push({
				application: t[n],
				status: e.value.status,
				message: e.value.message
			});
		}), u(!1), f(a);
	}, h = async () => {
		await m((p ? [t] : t).map((e) => e.application));
	}, g = (e) => {
		i(e);
	}, _ = (e) => {
		c(e.target.value);
	}, v = Ka((t) => t.map((t) => ({
		...t,
		options: t.options.filter((t) => t.label !== e)
	})).filter((e) => e.options.length > 0), [e]), y = ih(r), b = (e) => /* @__PURE__ */ (0, Q.jsx)(ft, {
		arrow: !1,
		content: y,
		className: "default-tt w-200",
		children: /* @__PURE__ */ (0, Q.jsx)("div", { children: e })
	});
	return a ? /* @__PURE__ */ (0, Q.jsx)(mh, {
		isLoading: l,
		handleClonePipeline: m,
		handleCloseClonePipelineModal: n,
		sourceEnvironmentName: e,
		statusList: d,
		targetEnvironmentName: r.label,
		targetEnvironmentId: +r.value
	}) : /* @__PURE__ */ (0, Q.jsx)(xu, {
		className: "",
		onEscape: n,
		close: n,
		children: /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "bg__primary dc__position-fixed dc__right-0 dc__top-0 h-100 flexbox-col dc__content-space w-600",
			onClick: uf,
			children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox-col dc__content-space h-100 dc__overflow-auto",
				children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "flexbox dc__content-space px-20 py-12 dc__align-items-center dc__border-bottom",
					children: [/* @__PURE__ */ (0, Q.jsx)("h2", {
						className: "dc__truncate cn-9 fs-16 fw-6 lh-24 m-0",
						children: ah(t)
					}), /* @__PURE__ */ (0, Q.jsx)("button", {
						type: "button",
						className: "p-0 flex dc__no-border dc__no-background dc__outline-none-imp dc__tab-focus h-20 w-20 dc__tab-focus",
						onClick: n,
						"data-testid": "close-clone-pipeline-modal",
						"aria-label": $m.CLOSE_MODAL,
						children: /* @__PURE__ */ (0, Q.jsx)(er, { className: "dc__no-shrink icon-dim-20" })
					})]
				}), /* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "flexbox-col dc__gap-20 h-100 dc__overflow-auto py-20 px-16",
					children: [
						/* @__PURE__ */ (0, Q.jsxs)("div", {
							className: "flexbox-col",
							children: [
								/* @__PURE__ */ (0, Q.jsxs)("div", {
									className: "flexbox dc__gap-8",
									children: [/* @__PURE__ */ (0, Q.jsx)("div", {
										className: "flex dc__no-shrink dc__border-radius-50-per eb-5 bw-1 icon-dim-20",
										children: /* @__PURE__ */ (0, Q.jsx)(Fi, { className: "dc__no-shrink icon-dim-12" })
									}), /* @__PURE__ */ (0, Q.jsxs)("p", {
										className: "m-0 cn-9 fs-13 fw-4 lh-20 dc__truncate",
										children: [
											$m.SOURCE_ENVIRONMENT_TITLE,
											"\xA0",
											/* @__PURE__ */ (0, Q.jsxs)("span", {
												className: "fw-6",
												children: [
													"'",
													e,
													"'"
												]
											})
										]
									})]
								}),
								/* @__PURE__ */ (0, Q.jsx)("div", { className: "h-24 w-10 dc__border-right--b5" }),
								/* @__PURE__ */ (0, Q.jsxs)("div", {
									className: "flexbox dc__gap-8 dc__align-start",
									children: [/* @__PURE__ */ (0, Q.jsx)("div", {
										className: "flex dc__no-shrink dc__border-radius-50-per eb-5 bw-1 icon-dim-20 bcb-5",
										children: /* @__PURE__ */ (0, Q.jsx)(Fi, { className: "dc__no-shrink icon-dim-12 ic-env-white" })
									}), /* @__PURE__ */ (0, Q.jsxs)("div", {
										className: "flexbox-col dc__align-start dc__gap-4",
										children: [/* @__PURE__ */ (0, Q.jsx)("p", {
											className: "m-0 cn-9 fs-13 fw-4 lh-20",
											children: $m.TARGET_ENVIRONMENT_SELECTOR_LABEL
										}), /* @__PURE__ */ (0, Q.jsx)(Gs, {
											isMulti: !1,
											handleEnvironmentChange: g,
											selectedEnvironmentsMap: r ? { [r.label]: !0 } : {},
											processOptions: v,
											styles: uh,
											autoFocus: !0,
											placeholder: $m.TARGET_ENVIRONMENT_SELECTOR_PLACEHOLDER
										})]
									})]
								})
							]
						}),
						/* @__PURE__ */ (0, Q.jsx)("div", { className: "w-100 en-1 bw-1" }),
						/* @__PURE__ */ (0, Q.jsxs)("section", {
							className: "flexbox-col dc__gap-12",
							children: [/* @__PURE__ */ (0, Q.jsx)("h3", {
								className: "m-0 cn-9 fs-13 fw-6 lh-20",
								children: $m.WORKFLOW_TYPE_SELECTION_HEADING
							}), /* @__PURE__ */ (0, Q.jsxs)(vl, {
								className: "radio-group-no-border clone-pipeline-modal--radio-group",
								value: s,
								name: "clone-source-workflow-type",
								onChange: _,
								children: [/* @__PURE__ */ (0, Q.jsx)(yl, {
									dataTestId: `${th.NEW_WORKFLOW}-radio-item`,
									value: th.NEW_WORKFLOW,
									children: /* @__PURE__ */ (0, Q.jsxs)("span", {
										className: `cn-9 fs-13 lh-20 ${s === th.NEW_WORKFLOW ? "fw-6" : "fw-4"}`,
										children: [
											$m.NEW_WORKFLOW_TITLE,
											/* @__PURE__ */ (0, Q.jsx)("br", {}),
											/* @__PURE__ */ (0, Q.jsx)("span", {
												className: "cn-7 fs-12 fw-4 lh-18",
												children: $m.NEW_WORKFLOW_INFO
											})
										]
									})
								}), /* @__PURE__ */ (0, Q.jsx)(yl, {
									dataTestId: `${th.SAME_WORKFLOW}-radio-item`,
									value: th.SAME_WORKFLOW,
									children: /* @__PURE__ */ (0, Q.jsxs)("span", {
										className: `cn-9 fs-13 lh-20 ${s === th.SAME_WORKFLOW ? "fw-6" : "fw-4"}`,
										children: [
											$m.SOURCE_WORKFLOW_TITLE,
											/* @__PURE__ */ (0, Q.jsx)("br", {}),
											/* @__PURE__ */ (0, Q.jsx)("span", {
												className: "cn-7 fs-12 fw-4 lh-18",
												children: $m.SOURCE_WORKFLOW_INFO
											})
										]
									})
								})]
							})]
						})
					]
				})]
			}), /* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox px-20 py-16 dc__content-end dc__align-items-end dc__no-shrink dc__gap-12 dc__border-top",
				children: [/* @__PURE__ */ (0, Q.jsx)("button", {
					type: "button",
					className: "cta cancel flex h-36",
					onClick: n,
					"data-testid": "cancel-clone-pipeline",
					children: $m.CANCEL
				}), /* @__PURE__ */ (0, Q.jsx)(es, {
					condition: !!y,
					wrap: b,
					children: /* @__PURE__ */ (0, Q.jsx)("button", {
						type: "button",
						className: "flex cta h-36 dc__no-text-transform",
						onClick: h,
						"data-testid": "clone-pipeline-cta",
						disabled: !!y,
						children: oh(s)
					})
				})]
			})]
		})
	});
}, _h = /* @__PURE__ */ function(e) {
	return e.APPLICATION = "APPLICATION", e.ROLLOUT_STATUS = "ROLLOUT_STATUS", e.NEXT_ACTION = "NEXT_ACTION", e;
}({}), vh = /* @__PURE__ */ function(e) {
	return e.ALL_APPLICATIONS = "ALL-APPLICATIONS", e.CANARY = "CANARY", e.BLUE_GREEN = "BLUE-GREEN", e.NOT_ELIGIBLE = "NOT-ELIGIBLE", e;
}({}), yh = [
	{
		value: vh.ALL_APPLICATIONS,
		label: "All Applications"
	},
	{
		value: vh.CANARY,
		label: "Canary"
	},
	{
		value: vh.BLUE_GREEN,
		label: "Blue-Green"
	},
	{
		value: vh.NOT_ELIGIBLE,
		label: "Not Eligible"
	}
], bh = {
	[_h.APPLICATION]: "Application",
	[_h.ROLLOUT_STATUS]: "Rollout Status",
	[_h.NEXT_ACTION]: "Next Action"
}, xh = {
	[_h.APPLICATION]: "application",
	[_h.ROLLOUT_STATUS]: "rolloutStatus",
	[_h.NEXT_ACTION]: "nextAction"
}, Sh = "Not eligible for further action", Ch = async ({ appId: e, appIds: t, envId: n, options: r }) => {
	let { result: i } = await G(Rd(O.APP_STRATEGY, {
		appIds: t ?? e,
		envId: n,
		fetchStatus: !0
	}), r);
	return i.map(({ currentPodHash: e, currentStepIndex: t, phase: n, rolloutIdentifier: r, steps: i, strategy: a, appId: o, envId: s, error: c, autoPromotionEnabled: l, promoteFull: u }) => {
		let d = (i ?? []).map((e) => e.pause?.duration && typeof e.pause.duration == "number" ? {
			...e,
			pause: { duration: `${e.pause.duration}s` }
		} : e);
		return d.find((e) => e.setWeight === 100) || d.push({ setWeight: 100 }), {
			currentPodHash: e ?? "",
			currentStepIndex: t ?? 0,
			phase: n,
			rolloutIdentifier: { name: r?.name || "" },
			steps: d,
			strategy: a,
			appId: o,
			envId: s,
			error: c,
			autoPromotionEnabled: l ?? !1,
			promoteFull: u ?? !1
		};
	});
}, wh = (e, t) => nf(O.APP_STRATEGY_ROLLOUT, e, t), Th = ({ onClick: e, disabled: t }) => ({
	label: "Manage Traffic",
	iconName: "ic-traffic-signal",
	onClick: e,
	disabled: t
}), Eh = async ({ appInfoList: e, envId: t, abortControllerRef: n }) => (await Ch({
	appIds: e.map(({ appId: e }) => e).join(","),
	envId: t,
	options: { abortControllerRef: n }
})).reduce((e, t) => (e[t.appId] = t, e), {}), Dh = ({ steps: e, currentStepIndex: t, phase: n, autoPromotionEnabled: r, promoteFull: i, strategy: a, error: o }) => {
	if (o) return {
		rolloutStatus: o.userMessage ?? "-",
		strategyIcon: "ic-error",
		nextAction: Sh,
		notEligible: !0
	};
	let s = fm[a] ?? "ic-rocket-gear";
	switch (a) {
		case "CANARY": {
			let { parsedSteps: r } = am(e, t, n), i = r[t], a = i.message;
			return i.isFullRollout ? {
				rolloutStatus: a,
				strategyIcon: s,
				nextAction: Sh,
				notEligible: !0
			} : {
				rolloutStatus: a,
				strategyIcon: s,
				nextAction: r[t + 1].message,
				notEligible: !1
			};
		}
		case "BLUE-GREEN": {
			let { rolloutStatus: e, nextAction: t } = cm(n, r, i);
			return {
				rolloutStatus: e,
				strategyIcon: s,
				nextAction: t ?? "Not eligible for further action",
				notEligible: !t
			};
		}
		default: return {
			rolloutStatus: "Not applicable",
			strategyIcon: s,
			nextAction: Sh,
			notEligible: !0
		};
	}
}, Oh = (e, t) => e.flatMap((e) => {
	let n = t[e.appId];
	return n ? {
		...e,
		environmentId: n.envId,
		strategy: n.strategy,
		currentPodHash: n.currentPodHash,
		currentStepIndex: n.currentStepIndex,
		rolloutIdentifier: n.rolloutIdentifier,
		phase: n.phase,
		autoPromotionEnabled: n.autoPromotionEnabled,
		...Dh(n)
	} : [];
}), kh = (e, t) => Oh(e, t).reduce((e, t) => (e[t.appId] = t, e), {}), Ah = (e, t, n = !1) => e.filter(({ strategy: e, notEligible: r }) => (!n || !r) && e === t), jh = (e) => e.filter(({ notEligible: e }) => e), Mh = (e) => yh.filter(({ value: t }) => {
	switch (t) {
		case vh.BLUE_GREEN:
		case vh.CANARY: return e.some(({ strategy: e }) => e === t);
		case vh.NOT_ELIGIBLE: return e.some(({ notEligible: e }) => e);
		default: return !0;
	}
}), Nh = ({ appsFilter: e, appsDetail: t }) => {
	switch (e) {
		case vh.CANARY:
		case vh.BLUE_GREEN: return Ah(t, e);
		case vh.NOT_ELIGIBLE: return jh(t);
		default: return t;
	}
}, Ph = (e) => {
	let t = Object.entries(e).map(([, e]) => e);
	return {
		[vh.ALL_APPLICATIONS]: t.length,
		[vh.CANARY]: Ah(t, "CANARY", !0).length,
		[vh.BLUE_GREEN]: Ah(t, "BLUE-GREEN", !0).length,
		[vh.NOT_ELIGIBLE]: jh(t).length
	};
}, Fh = (e, t, n, r) => {
	let i = (Array.isArray(e) ? e : Object.values(e)).map((e) => {
		if (!e.notEligible) {
			if (n === "CANARY" && e.strategy === "CANARY") return {
				...e,
				nextAction: t === "promoteFull" ? "Rollout to 100% users" : Dh(r[e.appId]).nextAction
			};
			if (n === "BLUE-GREEN" && e.strategy === "BLUE-GREEN" && e.phase !== "Progressing" && !e.autoPromotionEnabled) return {
				...e,
				nextAction: t === "promoteFull" ? "Skip & Promote Full" : Dh(r[e.appId]).nextAction
			};
		}
		return e;
	});
	return Array.isArray(e) ? i : i.reduce((e, t) => (e[t.appId] = t, e), {});
}, Ih = (e) => (Array.isArray(e) ? e : Object.values(e)).some((e) => !e.notEligible && e.strategy === "BLUE-GREEN" && e.phase !== "Progressing" && !e.autoPromotionEnabled), Lh = (e, t, n, r) => {
	if (!n) return 0;
	let i = Number(!!r[e.appId]), a = Number(!!r[t.appId]), o = Number(e.notEligible), s = Number(t.notEligible);
	return i === a ? o === s ? 0 : o - s : n === Jl.ASC ? a - i : i - a;
}, Rh = (e) => Object.fromEntries(Object.entries(e).filter(([, e]) => !e.notEligible).map(([e, { appId: t, environmentId: n, application: r, nextAction: i, currentPodHash: a, currentStepIndex: o, rolloutIdentifier: s, strategy: c, strategyIcon: l }]) => [e, {
	appId: t,
	envId: n,
	nextAction: i,
	appName: r,
	currentPodHash: a,
	currentStepIndex: o,
	rolloutName: s.name,
	status: ym.PROGRESSING,
	strategy: c,
	strategyIcon: l,
	errorMsg: ""
}])), zh = (e, t, n) => {
	switch (e) {
		case ym.FAIL: return n;
		case ym.SUCCESS: return t;
		case ym.PROGRESSING:
		default: return "";
	}
}, Bh = (e) => ({
	successCount: e.filter(({ status: e }) => e === ym.SUCCESS).length,
	failCount: e.filter(({ status: e }) => e === ym.FAIL).length,
	progressingCount: e.filter(({ status: e }) => e === ym.PROGRESSING).length
}), Vh = ({ selectedAppsDetail: e, canaryPromoteAction: t, blueGreenPromoteAction: n, handleClose: r }) => {
	let i = Ja(new AbortController()), [a, o] = j(Rh(e)), { sortBy: s, sortOrder: c, handleSorting: l } = Mf({ initialSortKey: "appName" }), u = Object.values(a), { successCount: d, failCount: f, progressingCount: p } = A(() => Bh(u), [u]), m = !!p, h = [
		{
			color: "var(--G500)",
			label: "Succeeded",
			value: d
		},
		{
			color: "var(--R500)",
			label: "Failed",
			value: f
		},
		{
			color: "var(--N300)",
			label: "Pending",
			value: p
		}
	], g = (e) => () => {
		l(e);
	}, _ = async (e) => {
		await fo((e ?? u).map((e) => {
			let { appId: r, envId: a, currentPodHash: s, currentStepIndex: c, rolloutName: l, strategy: u } = e;
			return async () => {
				try {
					await wh({
						appId: r,
						envId: a,
						promoteAction: u === "CANARY" ? t : n,
						currentPodHash: s,
						currentStepIndex: c,
						rolloutName: l
					}, { signal: i.current.signal }), o((t) => ({
						...t,
						[r]: {
							...e,
							status: ym.SUCCESS,
							errorMsg: ""
						}
					}));
				} catch (t) {
					let n = t.errors[0];
					o((t) => ({
						...t,
						[r]: {
							...e,
							status: ym.FAIL,
							errorMsg: n.userMessage || n.internalMessage || ""
						}
					}));
				}
			};
		}), !1, 5);
	}, v = () => {
		i.current.abort();
	};
	k(() => (_(), v), []);
	let y = async () => {
		let e = u.filter(({ status: e }) => e === ym.FAIL), { envId: t } = u[0], n = (await Ch({
			appIds: e.map(({ appId: e }) => e).join(),
			envId: t
		})).reduce((e, t) => (e[t.appId] = t, e), {}), r = Object.fromEntries(e.map((e) => {
			let { currentPodHash: t, currentStepIndex: r } = n[e.appId];
			return [e.appId, {
				...e,
				status: ym.PROGRESSING,
				errorMsg: "",
				currentPodHash: t,
				currentStepIndex: r
			}];
		}));
		o(r), await _(Object.values(r));
	}, b = A(() => Object.values(a).sort((e, t) => s === "appName" ? df(e.appName, t.appName, c) : s === "rolloutStrategy" ? df(e.strategy, t.strategy, c) : df(e.status, t.status, c)), [
		s,
		c,
		a
	]);
	return /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flex-grow-1 flexbox-col dc__overflow-auto",
		children: [
			/* @__PURE__ */ (0, Q.jsx)("div", {
				className: "p-20",
				children: /* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "br-8 border__primary shadow__card--20",
					children: [/* @__PURE__ */ (0, Q.jsx)(zl, {
						entities: h,
						labelClassName: "fs-13 fw-4 lh-20 cn-9",
						countClassName: "fs-13 fw-6 lh-20 cn-9",
						showAnimationOnBar: !0,
						rootClassName: "p-16 border__secondary--bottom"
					}), /* @__PURE__ */ (0, Q.jsxs)("div", {
						className: "flexbox dc__align-items-center dc__gap-6 px-16 py-8",
						children: [/* @__PURE__ */ (0, Q.jsx)(z, {
							name: m ? "ic-circle-loader" : "ic-info-outline",
							color: m ? "O500" : null,
							size: 20
						}), /* @__PURE__ */ (0, Q.jsx)("span", { children: m ? "Increasing rollout to next step" : `Rollout increased for ${d} deployments` })]
					})]
				})
			}),
			/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "rollout-status-row fs-12 lh-20 cn-7 px-20 py-8 border__secondary--bottom",
				children: [
					/* @__PURE__ */ (0, Q.jsx)(ql, {
						title: "APPLICATION",
						isSorted: s === "appName",
						sortOrder: c,
						isSortable: !0,
						triggerSorting: g("appName"),
						disabled: !1
					}),
					/* @__PURE__ */ (0, Q.jsx)(ql, {
						title: "ROLLOUT STRATEGY",
						isSorted: s === "rolloutStrategy",
						sortOrder: c,
						isSortable: !0,
						triggerSorting: g("rolloutStrategy"),
						disabled: !1
					}),
					/* @__PURE__ */ (0, Q.jsx)(ql, {
						title: "STATUS",
						isSorted: s === "status",
						sortOrder: c,
						isSortable: !0,
						triggerSorting: g("status"),
						disabled: !1
					}),
					/* @__PURE__ */ (0, Q.jsx)(ql, {
						title: "MESSAGE",
						isSorted: !1,
						sortOrder: c,
						isSortable: !1,
						triggerSorting: $d,
						disabled: !1
					})
				]
			}),
			b.map(({ appName: e, strategyIcon: t, strategy: n, status: r, nextAction: i, errorMsg: a }) => /* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "rollout-status-row fs-13 fw-4 lh-20 cn-9 px-20 py-8",
				children: [
					/* @__PURE__ */ (0, Q.jsx)("span", {
						className: "dc__truncate",
						children: e
					}),
					/* @__PURE__ */ (0, Q.jsxs)("div", {
						className: "flexbox dc__gap-6",
						children: [/* @__PURE__ */ (0, Q.jsx)(z, {
							name: t,
							size: 20,
							color: null
						}), /* @__PURE__ */ (0, Q.jsx)("span", {
							className: "dc__first-letter-capitalize",
							children: n
						})]
					}),
					/* @__PURE__ */ (0, Q.jsxs)("div", {
						className: "flexbox dc__align-items-center dc__h-fit-content dc__gap-6",
						children: [bm(r), /* @__PURE__ */ (0, Q.jsx)("span", {
							className: "fs-13 fw-4 lh-20 cn-9",
							children: xm(r)
						})]
					}),
					/* @__PURE__ */ (0, Q.jsx)("span", { children: zh(r, i, a) })
				]
			}, e))
		]
	}), /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: `flexbox ${m ? "dc__content-end" : "dc__content-space"} px-20 py-16 border__secondary--top`,
		children: [!m && /* @__PURE__ */ (0, Q.jsx)(M, {
			dataTestId: "close-manage-traffic",
			text: "Close",
			variant: F.secondary,
			style: P.neutral,
			size: I.large,
			onClick: r
		}), /* @__PURE__ */ (0, Q.jsx)(M, {
			dataTestId: m ? "abort-bulk-rollout" : "retry-failed-rollout",
			text: m ? "Abort" : "Retry Failed",
			startIcon: /* @__PURE__ */ (0, Q.jsx)(z, {
				name: m ? "ic-aborted" : "ic-arrow-clockwise",
				color: null
			}),
			size: I.large,
			...m ? {
				style: P.neutral,
				variant: F.secondary
			} : {},
			disabled: !m && !f,
			onClick: m ? v : y
		})]
	})] });
}, Hh = ({ variant: e = "primary", children: t, count: n, title: r, icon: i, isFilterActive: a = !1, onFilterToggle: o }) => {
	if (!n) return null;
	let s = e === "error";
	return /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: `manage-traffic-filter-card dc__visible-hover dc__visible-hover--parent br-6 flexbox-col ${s ? "er-2" : "border__primary"} ${s ? "bcr-50" : "bg__primary"}`,
		children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
			className: `manage-traffic-filter-card__title-container flex left dc__gap-12 px-12 pt-8 pb-7 ${s ? "error" : "border__secondary--bottom"}`,
			children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flex-grow-1 flexbox dc__align-items-center dc__gap-8 mt-4",
				children: [
					/* @__PURE__ */ (0, Q.jsx)("p", {
						className: "m-0 fs-14 lh-20 fw-6 cn-9",
						children: n < 10 ? `0${n}` : n
					}),
					/* @__PURE__ */ (0, Q.jsx)("span", { className: "manage-traffic-filter-card__count-divider divider__primary-translucent" }),
					/* @__PURE__ */ (0, Q.jsxs)("div", {
						className: "flex left dc__gap-6",
						children: [/* @__PURE__ */ (0, Q.jsx)(z, {
							name: s ? "ic-error" : i,
							color: null
						}), /* @__PURE__ */ (0, Q.jsx)(W, {
							content: s ? "Not eligible for further action" : r,
							children: /* @__PURE__ */ (0, Q.jsx)("p", {
								className: `m-0 fs-13 lh-20 dc__truncate ${s ? "cr-5" : "cn-9"}`,
								children: s ? "Not eligible for further action" : r
							})
						})]
					})
				]
			}), /* @__PURE__ */ (0, Q.jsx)("div", {
				className: `${a ? "dc__visible" : "dc__visible-hover--child"}`,
				children: /* @__PURE__ */ (0, Q.jsx)(M, {
					icon: /* @__PURE__ */ (0, Q.jsx)(z, {
						name: a ? "ic-filter-applied" : "ic-filter",
						color: null
					}),
					dataTestId: `manage-traffic-filter-card-${r}-button`,
					ariaLabel: `manage-traffic-filter-card-${r}-button`,
					variant: F.borderLess,
					style: P.neutral,
					size: I.xs,
					showAriaLabelInTippy: !1,
					onClick: () => o(!a)
				})
			})]
		}), t]
	});
}, Uh = ({ appsFilterCount: e, appsFilter: t, handleAppsFilterChange: n, canaryPromoteAction: r, blueGreenPromoteAction: i, handlePromoteActionChange: a, handleRemoveNotEligibleSelections: o, handleShowInitiateRollout: s, handleSortSelected: c, isSwapTrafficEnabled: l }) => {
	let u = !!(e[vh.CANARY] || e[vh.BLUE_GREEN]), d = !!e[vh.NOT_ELIGIBLE], f = (e) => (t) => {
		n(t ? yh.find(({ value: t }) => t === e) : yh[0]), t && c(Jl.ASC);
	};
	return /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flex-grow-1 p-16 flexbox-col dc__gap-20",
		children: [u && /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox-col dc__gap-12",
			children: [/* @__PURE__ */ (0, Q.jsx)("h3", {
				className: "m-0 fs-13 lh-20 fw-6 cn-9",
				children: "Eligible Rollouts"
			}), /* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox-col dc__gap-8",
				children: [/* @__PURE__ */ (0, Q.jsx)(Hh, {
					variant: "primary",
					count: e[vh.CANARY],
					title: "Canary Strategy",
					icon: fm.CANARY,
					isFilterActive: t === vh.CANARY,
					onFilterToggle: f(vh.CANARY),
					children: /* @__PURE__ */ (0, Q.jsxs)(vl, {
						name: "manage-traffic-canary-promote-action-radio",
						className: "promote-action-radio",
						value: r,
						onChange: a("CANARY"),
						children: [/* @__PURE__ */ (0, Q.jsx)(yl, {
							value: "promoteToNext",
							children: "Rollout to Next Step"
						}), /* @__PURE__ */ (0, Q.jsx)(yl, {
							value: "promoteFull",
							children: "Full Rollout"
						})]
					})
				}), /* @__PURE__ */ (0, Q.jsx)(Hh, {
					variant: "primary",
					count: e[vh.BLUE_GREEN],
					title: "Blue-Green Strategy",
					icon: fm["BLUE-GREEN"],
					isFilterActive: t === vh.BLUE_GREEN,
					onFilterToggle: f(vh.BLUE_GREEN),
					children: /* @__PURE__ */ (0, Q.jsxs)(vl, {
						name: "manage-traffic-blue-green-promote-action-radio",
						className: "promote-action-radio",
						value: i,
						onChange: a("BLUE-GREEN"),
						children: [/* @__PURE__ */ (0, Q.jsx)(yl, {
							value: "promoteToNext",
							disabled: !l,
							children: "Swap Traffic"
						}), /* @__PURE__ */ (0, Q.jsx)(yl, {
							value: "promoteFull",
							children: "Skip & Promote Full"
						})]
					})
				})]
			})]
		}), d && /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox-col dc__gap-12",
			children: [/* @__PURE__ */ (0, Q.jsx)("h3", {
				className: "m-0 fs-13 lh-20 fw-6 cn-9",
				children: "Non-eligible Rollouts"
			}), /* @__PURE__ */ (0, Q.jsx)(Hh, {
				variant: "error",
				count: e[vh.NOT_ELIGIBLE],
				isFilterActive: t === vh.NOT_ELIGIBLE,
				onFilterToggle: f(vh.NOT_ELIGIBLE),
				children: /* @__PURE__ */ (0, Q.jsx)("div", {
					className: "p-12",
					children: /* @__PURE__ */ (0, Q.jsx)(M, {
						dataTestId: "manage-traffic-initiate-rollout-button",
						variant: F.text,
						size: I.medium,
						text: "Remove not eligible selections",
						onClick: o
					})
				})
			})]
		})]
	}), /* @__PURE__ */ (0, Q.jsx)("div", {
		className: "p-16",
		children: /* @__PURE__ */ (0, Q.jsx)(M, {
			dataTestId: "manage-traffic-initiate-rollout-button",
			size: I.medium,
			text: "Initiate Eligible Rollouts",
			onClick: s,
			fullWidth: !0,
			disabled: !u,
			showTooltip: !u,
			tooltipProps: { content: "No eligible rollouts" }
		})
	})] });
}, Wh = ({ envId: e, appInfoList: t, initialSelectedAppList: n }) => {
	let [r, i] = j(vh.ALL_APPLICATIONS), [a, o] = j([]), [s, c] = j({}), [l, u] = j(null), [d, f] = j("promoteToNext"), [p, m] = j("promoteToNext"), [h, g] = j(!1), _ = Ja(new AbortController());
	k(() => () => {
		_.current.abort();
	}, []);
	let { handleSorting: v, sortBy: y, sortOrder: b } = Mf({ initialSortKey: _h.APPLICATION }), [x, S, C, w] = hf(() => Eh({
		appInfoList: t,
		envId: e,
		abortControllerRef: _
	})), T = A(() => Nh({
		appsDetail: a,
		appsFilter: r
	}), [a, r]), { appsFilterCount: ee, isSwapTrafficEnabled: E } = A(() => ({
		appsFilterCount: Ph(s),
		isSwapTrafficEnabled: Ih(s)
	}), [s]), D = ({ value: e }) => {
		i(e);
	}, te = (e, t) => {
		o(Fh(a, t, e, S)), c(Fh(s, t, e, S));
	};
	return k(() => {
		y && o((e) => [...e].sort((e, t) => df(e[xh[y]], t[xh[y]], b)));
	}, [y, b]), k(() => {
		if (!x && S) {
			let e = Oh(t, S);
			o(e), c(kh(n, S)), m(Ih(e) ? "promoteToNext" : "promoteFull");
		}
	}, [S, x]), {
		appsFilter: r,
		appsFilterSegments: Mh(a),
		filteredAppsDetail: T,
		selectedAppsDetail: s,
		appsFilterCount: ee,
		handleAppsFilterChange: D,
		handleBulkCheckboxChange: (e) => {
			let { checked: t } = e.target;
			c((e) => {
				let n = { ...e }, i = Object.fromEntries(T.map((e) => [e.appId, e]));
				return r === vh.ALL_APPLICATIONS ? n = t ? i : {} : t ? n = {
					...s,
					...i
				} : Object.keys(i).forEach((e) => {
					delete n[e];
				}), n;
			}), u(null);
		},
		handleRowCheckboxChange: (e) => () => {
			c((t) => {
				let n = { ...t };
				return n[e.appId] ? delete n[e.appId] : n[e.appId] = e, n;
			}), u(null);
		},
		handleRemoveNotEligibleSelections: () => {
			c(Object.fromEntries(Object.entries(s).filter(([, e]) => !e.notEligible))), u(null);
		},
		canaryPromoteAction: d,
		isSwapTrafficEnabled: E,
		blueGreenPromoteAction: p,
		handlePromoteActionChange: (e) => (t) => {
			let n = t.target.value;
			e === "CANARY" ? (Mn.event({
				category: "App Group Manage Traffic",
				action: n === "promoteToNext" ? "APP_GROUP_MANAGE_TRAFFIC_NEXT_CLICKED" : "APP_GROUP_MANAGE_TRAFFIC_FULL_CLICKED"
			}), f(n)) : e === "BLUE-GREEN" && m(n), te(e, n);
		},
		sortBy: y,
		sortOrder: b,
		handleTableSorting: (e) => () => {
			u(null), v(e);
		},
		sortSelectedSortOrder: l,
		handleSortSelected: (e) => {
			let t = e ?? (l === Jl.ASC ? Jl.DESC : Jl.ASC);
			v(null), u(t), o((e) => [...e].sort((e, n) => Lh(e, n, t, s)));
		},
		isLoading: x,
		err: C,
		reload: w,
		showInitiateRollout: h,
		handleShowInitiateRollout: () => {
			g(!0);
		}
	};
}, Gh = () => /* @__PURE__ */ (0, Q.jsx)(R, {
	title: "Checking current rollout status",
	subTitle: "It might take some time depending upon the number of applications",
	SvgImage: vm
}), Kh = ({ envId: e, envName: t, appInfoList: n = [], initialSelectedAppList: r = [], onClose: i }) => {
	let { appsFilter: a, appsFilterSegments: o, filteredAppsDetail: s, selectedAppsDetail: c, appsFilterCount: l, handleAppsFilterChange: u, handleBulkCheckboxChange: d, handleRowCheckboxChange: f, handleRemoveNotEligibleSelections: p, canaryPromoteAction: m, isSwapTrafficEnabled: h, blueGreenPromoteAction: g, handlePromoteActionChange: _, sortBy: v, sortOrder: y, handleTableSorting: b, sortSelectedSortOrder: x, handleSortSelected: S, isLoading: C, err: w, reload: T, showInitiateRollout: ee, handleShowInitiateRollout: E } = Wh({
		appInfoList: n,
		envId: e,
		initialSelectedAppList: r
	}), D = A(() => Object.keys(c).length, [c]), te = A(() => D && s.every(({ appId: e }) => !!c[e]), [s, D]), ne = A(() => !te && s.some(({ appId: e }) => !!c[e]), [
		s,
		D,
		te
	]);
	return /* @__PURE__ */ (0, Q.jsx)(Rs, {
		position: "right",
		width: "100%",
		minWidth: "1024px",
		maxWidth: "1024px",
		onEscape: i,
		children: /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "bg__primary h-100 flexbox-col",
			children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flex dc__content-space dc__gap-12 px-20 pt-12 pb-11 border__primary--bottom",
				children: [/* @__PURE__ */ (0, Q.jsx)("h2", {
					className: "m-0 fs-16 lh-24 fw-6 cn-9",
					children: `Manage traffic for applications on '${t}'`
				}), /* @__PURE__ */ (0, Q.jsx)(M, {
					icon: /* @__PURE__ */ (0, Q.jsx)(z, {
						name: "ic-close-large",
						color: null
					}),
					dataTestId: "manage-traffic-close-button",
					ariaLabel: "manage-traffic-close-button",
					variant: F.borderLess,
					style: P.negativeGrey,
					size: I.xs,
					showAriaLabelInTippy: !1,
					onClick: i
				})]
			}), ee ? /* @__PURE__ */ (0, Q.jsx)(Vh, {
				handleClose: i,
				selectedAppsDetail: c,
				canaryPromoteAction: m,
				blueGreenPromoteAction: g
			}) : /* @__PURE__ */ (0, Q.jsx)("div", {
				className: "flex-grow-1 flexbox-col dc__overflow-hidden",
				children: /* @__PURE__ */ (0, Q.jsx)($a, {
					isLoading: C,
					customLoader: /* @__PURE__ */ (0, Q.jsx)(Gh, {}),
					error: w,
					errorScreenManagerProps: {
						code: w?.code,
						reload: T
					},
					children: /* @__PURE__ */ (0, Q.jsxs)(Zd.div, {
						className: "manage-traffic-container dc__grid flex-grow-1 dc__overflow-hidden",
						animate: { gridTemplateColumns: `1fr ${D > 0 ? "300px" : "0px"}` },
						transition: { duration: .2 },
						children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
							className: "flexbox-col dc__overflow-hidden",
							children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
								className: "flexbox dc__content-space px-16 py-10",
								children: [/* @__PURE__ */ (0, Q.jsx)(Bl, {
									name: "manage-traffic-apps-filter",
									segments: o,
									value: a,
									onChange: u
								}), D > 0 && /* @__PURE__ */ (0, Q.jsx)(M, {
									dataTestId: "manage-traffic-sort-selected-button",
									startIcon: /* @__PURE__ */ (0, Q.jsx)(z, {
										name: x && (x === Jl.ASC ? "ic-sort-ascending" : "ic-sort-descending") || "ic-sortable",
										color: null
									}),
									variant: F.borderLess,
									style: P.neutral,
									size: I.medium,
									text: "Sort Selected",
									onClick: () => S()
								})]
							}), /* @__PURE__ */ (0, Q.jsxs)("div", {
								className: "manage-traffic-table flex-grow-1 dc__overflow-auto px-12 pb-16",
								children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
									className: "manage-traffic-table__row bg__primary no-hover px-8 pt-8 pb-7 border__secondary--bottom dc__position-sticky dc__top-0 dc__zi-1",
									children: [/* @__PURE__ */ (0, Q.jsx)(Wo, {
										rootClassName: "m-0 pt-4 pb-3",
										isChecked: te || ne,
										value: ne ? "INTERMEDIATE" : "CHECKED",
										onChange: d
									}), Object.values(_h).map((e) => /* @__PURE__ */ (0, Q.jsx)("div", {
										className: "manage-traffic-table__cell",
										children: /* @__PURE__ */ (0, Q.jsx)(ql, {
											title: bh[e],
											isSortable: !0,
											disabled: !1,
											isSorted: v === e,
											sortOrder: y,
											triggerSorting: b(e)
										})
									}, e))]
								}), s.map((e) => {
									let { appId: t, notEligible: n, application: r, strategy: i, strategyIcon: a, rolloutStatus: o, nextAction: s } = e, l = !!c[t];
									return /* @__PURE__ */ (0, Q.jsxs)("div", {
										role: "checkbox",
										"aria-checked": l,
										tabIndex: 0,
										className: `manage-traffic-table__row cursor p-8 br-4 ${l ? "is-selected no-hover" : ""} ${n ? "not-eligible" : ""}`,
										onClick: f(e),
										children: [
											/* @__PURE__ */ (0, Q.jsx)(Wo, {
												rootClassName: "m-0 pt-4 pb-3",
												isChecked: l,
												value: "CHECKED",
												onChange: f(e),
												error: n
											}),
											/* @__PURE__ */ (0, Q.jsx)(W, {
												content: r,
												children: /* @__PURE__ */ (0, Q.jsx)("p", {
													className: "m-0 fs-13 lh-20 fw-4 cn-9 dc__truncate",
													children: r
												})
											}),
											/* @__PURE__ */ (0, Q.jsxs)("div", {
												className: "flex left dc__gap-8",
												children: [/* @__PURE__ */ (0, Q.jsx)(z, {
													name: a,
													color: null,
													tooltipProps: {
														alwaysShowTippyOnHover: !!Pl[i],
														content: `${Pl[i]} Strategy`
													}
												}), /* @__PURE__ */ (0, Q.jsx)(W, {
													content: o,
													children: /* @__PURE__ */ (0, Q.jsx)("p", {
														className: "m-0 fs-13 lh-20 fw-4 cn-9 dc__truncate",
														children: o
													})
												})]
											}),
											/* @__PURE__ */ (0, Q.jsx)(W, {
												content: s,
												children: /* @__PURE__ */ (0, Q.jsx)("p", {
													className: `m-0 fs-13 lh-20 fw-4 dc__truncate ${n ? "cr-5" : "cn-9"}`,
													children: s
												})
											})
										]
									}, t);
								})]
							})]
						}), /* @__PURE__ */ (0, Q.jsx)(lo, { children: D && /* @__PURE__ */ (0, Q.jsx)(Zd.div, {
							className: "bg__modal--secondary border__secondary--left flexbox-col",
							initial: {
								x: 300,
								opacity: 0
							},
							animate: {
								x: 0,
								opacity: 1
							},
							exit: {
								x: 300,
								opacity: 0
							},
							transition: { duration: .2 },
							children: /* @__PURE__ */ (0, Q.jsx)(Uh, {
								appsFilterCount: l,
								appsFilter: a,
								handleAppsFilterChange: u,
								canaryPromoteAction: m,
								blueGreenPromoteAction: g,
								handlePromoteActionChange: _,
								handleRemoveNotEligibleSelections: p,
								handleShowInitiateRollout: E,
								handleSortSelected: S,
								isSwapTrafficEnabled: h
							})
						}) })]
					})
				})
			})]
		})
	});
}, qh = ({ to: e, onClick: t }) => /* @__PURE__ */ (0, Q.jsx)(M, {
	dataTestId: "app-group-manage-traffic-button",
	startIcon: /* @__PURE__ */ (0, Q.jsx)(z, {
		name: "ic-traffic-signal",
		color: null
	}),
	variant: F.secondary,
	size: I.medium,
	text: "Manage Traffic",
	onClick: t,
	component: N.link,
	linkProps: { to: e }
}), Jh = [{
	label: "v1beta2/application",
	value: Do.v2
}], Yh = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Bulk Edit Application batch/v1beta2 Schema",
	type: "object",
	description: "Input Script for bulk edit",
	properties: { apiVersion: {
		type: "string",
		enum: ["batch/v1beta1", "batch/v1beta2"],
		description: "API version of the bulk edit schema"
	} }
}, Xh = () => G(`${O.BULK_EDIT_V2}/config`), Zh = (e) => nf(`${O.BULK_EDIT_V2}`, e), Qh = (e) => nf(`${O.BULK_EDIT_V2}/dryrun`, e), $h = async () => ({ category: (await G(O.CHART_CATEGORY_LIST)).result?.category ?? [] }), eg = ({ selectedCategories: e, handleUpdateCategoryFilter: t }) => {
	let [n, r, i, a] = hf($h, []), o = (n) => {
		if (e.find((e) => e === n)) {
			t(e.filter((e) => e !== n));
			return;
		}
		t([...e, n]);
	};
	return r?.category?.length <= 0 ? null : /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [
		/* @__PURE__ */ (0, Q.jsx)("hr", { className: "mt-8 mb-8" }),
		/* @__PURE__ */ (0, Q.jsx)("span", {
			className: "fs-12 lh-20 cn-6 fw-6 px-8 py-8",
			children: "CATEGORY"
		}),
		(() => {
			if (n) return /* @__PURE__ */ (0, Q.jsxs)("div", { children: [
				/* @__PURE__ */ (0, Q.jsx)("span", { className: "w-180 shimmer" }),
				/* @__PURE__ */ (0, Q.jsx)("span", { className: "w-180 shimmer" }),
				/* @__PURE__ */ (0, Q.jsx)("span", { className: "w-180 shimmer" })
			] });
			if (i) return /* @__PURE__ */ (0, Q.jsx)(lc, {
				title: "Could not load categories",
				subTitle: "",
				reload: a
			});
			let t = (e) => () => o(e);
			return /* @__PURE__ */ (0, Q.jsx)(Q.Fragment, { children: r.category.map((n) => {
				let r = n.id.toString();
				return /* @__PURE__ */ (0, Q.jsx)("div", {
					className: "dc__hover-n50",
					children: /* @__PURE__ */ (0, Q.jsx)(Wo, {
						isChecked: !!e.find((e) => e === r),
						value: Io.CHECKED,
						onChange: t(r),
						dataTestId: `chart-store-category-${n.name}-checkbox`,
						rootClassName: "mb-0 py-6 ml-8",
						children: /* @__PURE__ */ (0, Q.jsx)("span", {
							className: "fs-13 lh-20 dc__truncate",
							children: n.name
						})
					})
				}, `${n.name}-${n.id}`);
			}) });
		})()
	] });
}, tg = () => {
	let e = X();
	return /* @__PURE__ */ (0, Q.jsxs)("button", {
		className: "cta h-28 flex dc__gap-8",
		type: "button",
		onClick: () => {
			e(B.NETWORK_STATUS_INTERFACE.CREATE_CONTROLLER);
		},
		children: [/* @__PURE__ */ (0, Q.jsx)(E, { className: "dc__no-shrink icon-dim-12 fcn-0" }), "Add Controller"]
	});
}, ng = /* @__PURE__ */ function(e) {
	return e.CONTROLLER_ACTIVE = "Controller-Active", e.CONTROLLER_STANDBY = "Controller-Standby", e;
}({}), rg = /* @__PURE__ */ function(e) {
	return e.COLUMN_TEMPLATE = "columnTemplate", e;
}({}), ig = /* @__PURE__ */ function(e) {
	return e.SYSTEM_CONTROLLER_NAME = "systemControllerName", e.NUMBER_OF_SUB_CLOUDS = "numberOfSubClouds", e;
}({}), ag = /* @__PURE__ */ function(e) {
	return e.SUB_CLOUD_PAGE_SIZE = "subCloudPageSize", e;
}({}), og = [
	{
		field: "invprovision",
		label: "Invprovision"
	},
	{
		field: "administrative",
		label: "Administrative"
	},
	{
		field: "operational",
		label: "Operational"
	},
	{
		field: "availability",
		label: "Availability"
	}
].map((e, t) => ({
	...e,
	width: 180,
	isSortable: !0,
	type: "string",
	order: t
})), sg = [
	{
		field: "deploy-status",
		label: "Deploy Status"
	},
	{
		field: "software-version",
		label: "Software Version"
	},
	{
		field: "availability-status",
		label: "Availability"
	},
	{
		field: "management-state",
		label: "Management State"
	},
	{
		field: "error-description",
		label: "Error"
	},
	{
		field: "region-name",
		label: "Region Name"
	},
	{
		field: "management-start-ip",
		label: "Management Start IP"
	}
].map((e, t) => ({
	...e,
	width: 180,
	type: "string",
	order: t
})), cg = {
	systemControllerMap: {},
	ids: [],
	columnConfig: {
		systemControllerColumns: og,
		subCloudColumns: sg,
		id: 0
	}
}, lg = {
	id: 0,
	key: rg.COLUMN_TEMPLATE,
	value: null
}, ug = (e) => ({
	analyze: e?.analyze || "",
	manage: e?.manage || "",
	deploy: e?.deploy || ""
}), dg = (e) => e?.length ? e.find((e) => e?.capabilities?.Personality === ng.CONTROLLER_ACTIVE) : null, fg = (e) => ({
	field: e?.field || "",
	label: e?.label || "",
	order: e?.order ? parseInt(e.order, 10) : 0,
	width: e?.width ? parseInt(e.width, 10) : 180,
	isSortable: e?.isSortable || !1,
	type: e?.type || "string"
}), pg = ({ systemControllerResponse: e, columnConfigResponse: t }) => {
	if (!e?.length) return structuredClone(cg);
	let n = e.reduce((e, t) => {
		let { id: n, actionLinks: r, subclouds: i, systemControllers: a, systemControllerDetails: o } = t;
		if (!n || !a?.ihosts?.length) return e;
		let s = dg(a.ihosts);
		return s ? (e.ids.push(n), e.systemControllerMap[n] = {
			id: n,
			actionLinks: ug(r),
			subclouds: i && Array.isArray(i) ? i.sort((e, t) => df(e?.name || "", t?.name || "")) : [],
			activeController: s,
			systemControllerName: o?.isystems?.[0]?.name || "",
			systemControllerDetails: o
		}, e) : e;
	}, structuredClone(cg));
	try {
		let e = JSON.parse(t.value), r = e?.systemControllerColumns?.map(fg)?.filter((e) => e.field && e.label)?.sort((e, t) => ef(e.order, t.order)), i = e?.subCloudColumns?.map(fg)?.filter((e) => e.field && e.label)?.sort((e, t) => ef(e.order, t.order));
		return {
			...n,
			columnConfig: {
				id: t.id || 0,
				systemControllerColumns: r?.length ? r : structuredClone(og),
				subCloudColumns: i?.length ? i : structuredClone(sg)
			}
		};
	} catch {
		return H.showToast({
			variant: U.warn,
			description: "Issue while parsing column config data, reverting to default column config"
		}), n;
	}
}, mg = (e) => {
	let { ipAddress: t, username: n, actionLinks: r } = e;
	return {
		ipAddress: t || "",
		username: n || "",
		password: "",
		actionLinks: ug(r)
	};
}, hg = ({ rootClassName: e, style: t }) => /* @__PURE__ */ (0, Q.jsxs)("div", {
	className: `${e || ""} flexbox dc__align-items-center dc__gap-4`,
	style: t || {},
	children: [/* @__PURE__ */ (0, Q.jsx)(lr, { className: "icon-dim-16 dc__no-shrink fcn-6" }), /* @__PURE__ */ (0, Q.jsx)("i", {
		className: "dc__truncate cn-6 fs-13 fw-4 lh-20",
		children: "No data found"
	})]
}), gg = (e) => {
	switch (e) {
		case ig.NUMBER_OF_SUB_CLOUDS: return "number";
		default: return "string";
	}
}, _g = (e) => ({ subCloudPageSize: +(e.get(ag.SUB_CLOUD_PAGE_SIZE) || 20) || 20 }), vg = async (e) => {
	let { result: t } = await G(Rd(_l.ATTRIBUTES, { key: rg.COLUMN_TEMPLATE }), { signal: e });
	return t || structuredClone(lg);
}, yg = async (e) => {
	let { result: t } = await G(O.SYSTEM_NETWORK_CONTROLLER_INFO, {
		signal: e,
		timeout: window._env_.SYSTEM_CONTROLLER_LISTING_TIMEOUT || window._env_.GLOBAL_API_TIMEOUT || 6e4
	});
	return t ? t.map((e) => {
		let t = JSON.parse(e.subclouds || "{}")?.subclouds || [];
		return {
			...e,
			systemControllers: JSON.parse(e.systemControllers || "[]"),
			subclouds: t,
			systemControllerDetails: JSON.parse(e.systemControllerDetails || "{}")
		};
	}) : [];
}, bg = async ({ signal: e }) => {
	try {
		let [t, n] = await Promise.all([vg(e), yg(e)]);
		return pg({
			columnConfigResponse: t,
			systemControllerResponse: n
		});
	} catch (e) {
		throw pd(e) || K(e), e;
	}
}, xg = async ({ controllerId: e }) => {
	try {
		let { result: t } = await G(`${O.SYSTEM_NETWORK_CONTROLLER_CONFIG}/${e}`);
		return mg(t);
	} catch (e) {
		throw K(e), e;
	}
}, Sg = async ({ id: e, controllerForm: t }) => {
	let n = {
		...t,
		id: e
	};
	return sf(O.SYSTEM_NETWORK_CONTROLLER_CONFIG, n);
}, Cg = async (e) => ff(`${O.SYSTEM_NETWORK_CONTROLLER_CONFIG}/${e}`), wg = {
	ipAddress: "",
	username: "",
	password: "",
	actionLinks: {
		analyze: "",
		manage: "",
		deploy: ""
	}
}, Tg = {
	ipAddress: "",
	username: "",
	password: "",
	analyze: "",
	manage: "",
	deploy: ""
}, Eg = [pu.HTTP, pu.HTTPS], Dg = /* @__PURE__ */ function(e) {
	return e.UPDATE_IP_ADDRESS = "UPDATE_IP_ADDRESS", e.UPDATE_USERNAME = "UPDATE_USERNAME", e.UPDATE_PASSWORD = "UPDATE_PASSWORD", e.UPDATE_ANALYZE_LINK = "UPDATE_ANALYZE_LINK", e.UPDATE_MANAGE_LINK = "UPDATE_MANAGE_LINK", e.UPDATE_DEPLOY_LINK = "UPDATE_DEPLOY_LINK", e;
}({}), Og = ({ label: e, placeholder: t, value: n, error: r, handleChange: i, action: a, required: o = !1, autoFocus: s = !1, isSensitive: c = !1, type: l, ...u }) => {
	let [d, f] = j(!1), p = (e) => {
		i({
			payload: e.target.value,
			action: a
		});
	}, m = () => {
		f(!0);
	}, h = () => {
		f(!1);
	}, g = !c || d || n ? n : fs;
	return /* @__PURE__ */ (0, Q.jsx)(os, {
		...u,
		name: `${a}-input`,
		label: e,
		value: g,
		error: r,
		placeholder: t,
		required: o,
		autoFocus: s,
		onChange: p,
		onFocus: m,
		onBlur: h,
		type: l,
		fullWidth: !0
	});
}, kg = ({ action: e, label: t, handleChange: n, value: r, error: i }) => /* @__PURE__ */ (0, Q.jsx)(Og, {
	placeholder: "Enter URL",
	value: r,
	error: i,
	handleChange: n,
	action: e,
	label: t,
	required: !1,
	layout: "row"
}), Ag = ({ handleChange: e, controllerForm: t, controllerFormError: n }) => {
	let { controllerId: r } = Z(), i = !!r;
	return /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "p-20 flexbox-col flex-grow-1 dc__gap-16 dc__overflow-auto w-100",
		children: [
			/* @__PURE__ */ (0, Q.jsx)(Og, {
				label: "Controller URL",
				required: !0,
				placeholder: "Enter controller URL",
				value: t.ipAddress,
				error: n.ipAddress,
				handleChange: e,
				action: Dg.UPDATE_IP_ADDRESS,
				autoFocus: !0
			}),
			/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "dc__grid-cols-2 dc__column-gap-12",
				children: [/* @__PURE__ */ (0, Q.jsx)(Og, {
					label: "Username",
					required: !0,
					placeholder: "Enter username",
					value: t.username,
					error: n.username,
					handleChange: e,
					action: Dg.UPDATE_USERNAME
				}), /* @__PURE__ */ (0, Q.jsx)(Og, {
					label: "Password",
					required: !0,
					placeholder: "Enter password",
					value: t.password,
					error: n.password,
					handleChange: e,
					action: Dg.UPDATE_PASSWORD,
					isSensitive: i,
					type: "password"
				})]
			}),
			/* @__PURE__ */ (0, Q.jsx)("div", { className: "dc__border-bottom" }),
			/* @__PURE__ */ (0, Q.jsx)("h3", {
				className: "m-0 cn-9 fs-13 fw-6 lh-20",
				children: "Action links"
			}),
			/* @__PURE__ */ (0, Q.jsx)(kg, {
				label: "Analyze",
				action: Dg.UPDATE_ANALYZE_LINK,
				handleChange: e,
				value: t.actionLinks.analyze,
				error: n.analyze
			}),
			/* @__PURE__ */ (0, Q.jsx)(kg, {
				label: "Manage",
				action: Dg.UPDATE_MANAGE_LINK,
				handleChange: e,
				value: t.actionLinks.manage,
				error: n.manage
			}),
			/* @__PURE__ */ (0, Q.jsx)(kg, {
				label: "Deploy",
				action: Dg.UPDATE_DEPLOY_LINK,
				handleChange: e,
				value: t.actionLinks.deploy,
				error: n.deploy
			})
		]
	});
}, jg = ({ handleSuccess: e, handleClose: t }) => {
	let { controllerId: n } = Z(), [r, i] = j(structuredClone(wg)), [a, o, s, c] = hf(() => xg({ controllerId: +n }), [n], !!n), [l, u] = j(structuredClone(Tg)), [d, f] = j(!1);
	k(() => {
		n && !a && !s && o && i(o);
	}, [
		a,
		s,
		o,
		n
	]);
	let p = ({ payload: e, action: t }) => {
		let a = structuredClone(r), o = structuredClone(l);
		switch (t) {
			case Dg.UPDATE_IP_ADDRESS:
				a.ipAddress = e, o.ipAddress = Vf(e, Eg, !0).message;
				break;
			case Dg.UPDATE_USERNAME:
				a.username = e, o.username = lf(e).message;
				break;
			case Dg.UPDATE_PASSWORD:
				a.password = e, o.password = n ? "" : lf(e).message;
				break;
			case Dg.UPDATE_ANALYZE_LINK:
				a.actionLinks.analyze = e, o.analyze = e ? Vf(e, Eg).message : "";
				break;
			case Dg.UPDATE_MANAGE_LINK:
				a.actionLinks.manage = e, o.manage = e ? Vf(e, Eg).message : "";
				break;
			case Dg.UPDATE_DEPLOY_LINK:
				a.actionLinks.deploy = e, o.deploy = e ? Vf(e, Eg).message : "";
				break;
			default:
				H.showToast({
					variant: U.error,
					description: `Invalid action type: ${t}`
				});
				break;
		}
		i(a), u(o);
	}, m = async () => {
		try {
			let i = Object.values(l).some((e) => !!e), a = !lf(r.ipAddress).isValid || !lf(r.username).isValid || !n && !lf(r.password).isValid;
			if (i) {
				H.showToast({
					variant: U.error,
					description: "Please resolve the errors before saving"
				});
				return;
			}
			if (a) {
				H.showToast({
					variant: U.error,
					description: "Please fill all the required fields before saving"
				}), u({
					ipAddress: lf(r.ipAddress).message,
					username: lf(r.username).message,
					password: n ? "" : lf(r.password).message
				});
				return;
			}
			f(!0), await Sg({
				id: n ? +n : void 0,
				controllerForm: r
			}), H.showToast({
				variant: U.success,
				description: "Controller saved successfully"
			}), e(), t(), f(!1);
		} catch (e) {
			K(e), f(!1);
		}
	}, h = () => /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox dc__content-space py-12 px-20 dc__gap-8 dc__border-bottom dc__align-items-center",
		children: [/* @__PURE__ */ (0, Q.jsx)("h2", {
			className: "m-0 cn-9 fs-16 fw-6 lh-24 dc__truncate",
			children: n ? "Edit controller" : "Add controller"
		}), /* @__PURE__ */ (0, Q.jsx)("button", {
			type: "button",
			className: "p-0 flex dc__no-border dc__no-background dc__outline-none-imp dc__tab-focus h-20 w-20 dc__tab-focus",
			onClick: t,
			"aria-label": "close modal",
			"data-testid": "close modal",
			children: /* @__PURE__ */ (0, Q.jsx)(er, { className: "icon-dim-20 dc__no-shrink scn-6" })
		})]
	}), g = d || a || !!s;
	return /* @__PURE__ */ (0, Q.jsx)(xu, {
		className: "",
		onEscape: t,
		close: t,
		children: /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "bg__primary dc__position-fixed dc__right-0 dc__top-0 h-100 flexbox-col dc__content-space w-800",
			onClick: uf,
			children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox-col flex-grow-1 dc__content-space dc__overflow-auto",
				children: [h(), /* @__PURE__ */ (0, Q.jsx)($a, {
					isLoading: a,
					progressingProps: { pageLoader: !0 },
					error: s,
					errorScreenManagerProps: {
						code: s?.code,
						redirectURL: B.NETWORK_STATUS_INTERFACE.ROOT,
						reload: c
					},
					children: /* @__PURE__ */ (0, Q.jsx)(Ag, {
						handleChange: p,
						controllerForm: r,
						controllerFormError: l
					})
				})]
			}), /* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox dc__content-end dc__align-items-center py-16 px-20 dc__gap-12 dc__border-top",
				children: [/* @__PURE__ */ (0, Q.jsx)("button", {
					type: "button",
					className: "h-36 cta cancel flex",
					onClick: t,
					children: "Cancel"
				}), /* @__PURE__ */ (0, Q.jsx)(Mo, {
					isLoading: d,
					onClick: m,
					rootClassName: `h-36 cta flex ${g ? "dc__disabled" : ""}`,
					type: "button",
					disabled: g,
					children: n ? "Save" : "Add"
				})]
			})]
		})
	});
}, Mg = ({ handleClose: e, isLoadingSystemController: t, systemControllerMap: n, systemControllerError: r, refetchDetails: i }) => {
	let { controllerId: a } = Z(), o = n?.[+a || 0], s = o?.systemControllerName || "", c = o?.systemControllerDetails, l = A(() => t || r || !c ? "" : JSON.stringify(c, null, 2), [
		t,
		r,
		o
	]);
	return /* @__PURE__ */ (0, Q.jsx)(xu, {
		className: "",
		onEscape: e,
		close: e,
		children: /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "bg__primary dc__position-fixed dc__right-0 dc__top-0 h-100 flexbox-col dc__content-space w-800",
			onClick: uf,
			children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox-col flex-grow-1 dc__content-space dc__overflow-auto",
				children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "flexbox dc__content-space py-12 px-20 dc__gap-8 dc__border-bottom dc__align-items-center",
					children: [/* @__PURE__ */ (0, Q.jsxs)("h2", {
						className: "m-0 cn-9 fs-16 fw-6 lh-24 dc__truncate flex-grow-1",
						children: ["System Controller\xA0", t ? /* @__PURE__ */ (0, Q.jsx)("span", { className: "dc__loading-dots cn-0" }) : `'${s}'`]
					}), /* @__PURE__ */ (0, Q.jsx)("button", {
						type: "button",
						className: "p-0 flex dc__no-border dc__no-background dc__no-shrink dc__outline-none-imp dc__tab-focus h-20 w-20 dc__tab-focus",
						onClick: e,
						"aria-label": "close modal",
						"data-testid": "close modal",
						children: /* @__PURE__ */ (0, Q.jsx)(er, { className: "icon-dim-20 dc__no-shrink scn-6" })
					})]
				}), /* @__PURE__ */ (0, Q.jsx)($a, {
					isLoading: t,
					progressingProps: { pageLoader: !0 },
					error: r,
					errorScreenManagerProps: {
						code: r?.code,
						reload: i,
						redirectURL: B.NETWORK_STATUS_INTERFACE.ROOT
					},
					children: c ? /* @__PURE__ */ (0, Q.jsx)(Xo, {
						readOnly: !0,
						mode: Ic.JSON,
						value: l,
						theme: mo.dark,
						height: "100%"
					}) : /* @__PURE__ */ (0, Q.jsx)(R, {
						title: "Unable to retrieve data for this system controller",
						subTitle: "No data available for this system controller"
					})
				})]
			}), /* @__PURE__ */ (0, Q.jsx)("div", {
				className: "flexbox dc__content-end dc__align-items-center py-16 px-20 dc__gap-12 dc__border-top",
				children: /* @__PURE__ */ (0, Q.jsx)("button", {
					className: "h-36 cta flex",
					onClick: e,
					type: "button",
					children: "Okay"
				})
			})]
		})
	});
}, Ng = {
	...cg.columnConfig,
	subCloudColumns: JSON.stringify(cg.columnConfig.subCloudColumns, null, 2),
	systemControllerColumns: JSON.stringify(cg.columnConfig.systemControllerColumns, null, 2)
}, Pg = ["field", "label"], Fg = /* @__PURE__ */ function(e) {
	return e.SYSTEM_CONTROLLER = "System controller", e.SUB_CLOUD = "Sub cloud", e;
}({}), Ig = ({ tabName: e, currentTab: t, handleTabSwitch: n }) => {
	let r = e === t;
	return /* @__PURE__ */ (0, Q.jsx)("button", {
		className: `mr-16 dc__tab-focus pr-0 pl-0 pt-0 flexbox dc__align-items-center dc__no-border dc__no-background h-100 mb-neg-1 ${r ? "cb-5 fs-13 fw-6 dc__border-bottom-2--b5" : "cn-9 fs-13 fw-4 dc__hover-color-b500 mb-0"}`,
		onClick: () => {
			r || n(e);
		},
		type: "button",
		children: e
	});
}, Lg = ({ currentTab: e, handleTabSwitch: t }) => /* @__PURE__ */ (0, Q.jsx)("div", {
	className: "flexbox dc__align-end w-100 h-28",
	children: Object.values(Fg).map((n) => /* @__PURE__ */ (0, Q.jsx)(Ig, {
		tabName: n,
		currentTab: e,
		handleTabSwitch: t
	}, n))
}), Rg = async (e) => {
	let t = {
		id: e.id,
		key: rg.COLUMN_TEMPLATE,
		value: JSON.stringify({
			systemControllerColumns: JSON.parse(e.systemControllerColumns),
			subCloudColumns: JSON.parse(e.subCloudColumns)
		})
	};
	return e.id ? sf(_l.ATTRIBUTES_UPDATE, t) : nf(_l.ATTRIBUTES_CREATE, t);
}, zg = ({ handleClose: e, handleSuccess: t, isLoadingConfig: n, refetchConfig: r, configError: i, savedColumnConfig: a }) => {
	let [o, s] = j(Fg.SYSTEM_CONTROLLER), [c, l] = j(!1), [u, d] = j(structuredClone(Ng));
	k(() => {
		!n && !i && a && d({
			...a,
			subCloudColumns: JSON.stringify(a.subCloudColumns, null, 2),
			systemControllerColumns: JSON.stringify(a.systemControllerColumns, null, 2)
		});
	}, [
		n,
		r,
		i
	]);
	let f = (e) => {
		d((t) => ({
			...t,
			[o === Fg.SYSTEM_CONTROLLER ? "systemControllerColumns" : "subCloudColumns"]: e
		}));
	}, p = () => o === Fg.SYSTEM_CONTROLLER ? u.systemControllerColumns : u.subCloudColumns, m = (e) => {
		try {
			let t = JSON.parse(e);
			if (!Array.isArray(t) || !t.length) return {
				isValid: !1,
				message: "Config must be a valid array with at least one column"
			};
			let n = [];
			if (t.forEach((e, t) => {
				if (typeof e == "object" && !Array.isArray(e)) {
					let r = Pg.reduce((t, n) => (e?.[n] || t.push(n), t), []);
					r.length > 0 && n.push(`${r.join(",")} values are missing from object at index - ${t}`);
				} else n.push(`Please provide valid object at index - ${t}`);
			}), n?.length > 0) return {
				isValid: !1,
				message: n[0]
			};
			let r = [], i = {};
			return t.forEach((e) => {
				i[e.field] && r.push(e.field), i[e.field] = !0;
			}), r.length > 0 ? {
				isValid: !1,
				message: `Following field values are duplicated: ${r.join(",")}`
			} : { isValid: !0 };
		} catch (e) {
			return {
				isValid: !1,
				message: e.message || "Please ensure valid format."
			};
		}
	}, h = (e) => {
		let { isValid: t, message: n } = m(p());
		if (!t) {
			H.showToast({
				variant: U.error,
				description: n || "Please ensure data is valid before switching tabs"
			});
			return;
		}
		s(e);
	}, g = async () => {
		try {
			let { isValid: n, message: r } = m(u.systemControllerColumns);
			if (!n) {
				H.showToast({
					variant: U.error,
					description: r
				});
				return;
			}
			let { isValid: i, message: a } = m(u.subCloudColumns);
			if (!i) {
				H.showToast({
					variant: U.error,
					description: a
				});
				return;
			}
			l(!0), await Rg(u), H.showToast({
				variant: U.success,
				description: "Config saved successfully"
			}), t(), e(), l(!1);
		} catch (e) {
			K(e), l(!1);
		}
	}, _ = () => /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox-col px-20 dc__border-bottom",
		children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox dc__content-space dc__gap-8 py-12 dc__align-items-center",
			children: [/* @__PURE__ */ (0, Q.jsx)("h2", {
				className: "m-0 cn-9 fs-16 fw-6 lh-24 dc__truncate",
				children: "Customize columns"
			}), /* @__PURE__ */ (0, Q.jsx)("button", {
				type: "button",
				className: "p-0 flex dc__no-border dc__no-background dc__outline-none-imp dc__tab-focus h-20 w-20 dc__tab-focus",
				onClick: e,
				"aria-label": "close modal",
				"data-testid": "close modal",
				children: /* @__PURE__ */ (0, Q.jsx)(er, { className: "icon-dim-20 dc__no-shrink scn-6" })
			})]
		}), /* @__PURE__ */ (0, Q.jsx)(Lg, {
			currentTab: o,
			handleTabSwitch: h
		})]
	}), v = c || n || !!i;
	return /* @__PURE__ */ (0, Q.jsx)(xu, {
		className: "",
		onEscape: e,
		close: e,
		children: /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "bg__primary dc__position-fixed dc__right-0 dc__top-0 h-100 flexbox-col dc__content-space w-800",
			onClick: uf,
			children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox-col flex-grow-1 dc__content-space dc__overflow-auto",
				children: [_(), /* @__PURE__ */ (0, Q.jsx)($a, {
					isLoading: n,
					progressingProps: { pageLoader: !0 },
					error: i,
					errorScreenManagerProps: {
						code: i?.code,
						reload: r,
						redirectURL: B.NETWORK_STATUS_INTERFACE.ROOT
					},
					children: /* @__PURE__ */ (0, Q.jsx)(Xo, {
						mode: Ic.JSON,
						value: p(),
						theme: mo.dark,
						onChange: f,
						height: "100%"
					}, o)
				})]
			}), /* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox dc__content-end dc__align-items-center py-16 px-20 dc__gap-12 dc__border-top",
				children: [/* @__PURE__ */ (0, Q.jsx)("button", {
					type: "button",
					className: "h-36 cta cancel flex",
					onClick: e,
					children: "Cancel"
				}), /* @__PURE__ */ (0, Q.jsx)(Mo, {
					isLoading: c,
					onClick: g,
					rootClassName: `h-36 cta flex ${v ? "dc__disabled" : ""}`,
					type: "button",
					disabled: v,
					children: "Save"
				})]
			})]
		})
	});
}, Bg = () => {
	let e = X();
	return /* @__PURE__ */ (0, Q.jsxs)("button", {
		className: "cta cancel h-32 flex dc__gap-4",
		type: "button",
		onClick: () => {
			e(B.NETWORK_STATUS_INTERFACE.CUSTOMIZE_COLUMNS);
		},
		children: [/* @__PURE__ */ (0, Q.jsx)(w, { className: "dc__no-shrink icon-dim-14 scn-7 dc__fill-transparent" }), "Columns"]
	});
}, Vg = ({ field: e, label: t, width: n, isSortable: r, sortOrder: i, sortBy: a, handleSorting: o }) => /* @__PURE__ */ (0, Q.jsx)("div", {
	className: "flexbox dc__align-items-center",
	style: { width: `${n}px` },
	children: /* @__PURE__ */ (0, Q.jsx)(ql, {
		isSorted: a === e,
		sortOrder: i,
		title: t,
		triggerSorting: () => {
			o(e);
		},
		disabled: !1,
		isSortable: r,
		showTippyOnTruncate: !0
	})
}), Hg = (e) => /* @__PURE__ */ (0, Q.jsx)("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...e,
	children: /* @__PURE__ */ (0, Q.jsx)("path", {
		d: "M7.49978 12C7.49978 10.5166 7.93964 9.0666 8.76375 7.83323C9.58786 6.59986 10.7592 5.63856 12.1297 5.07091C13.5001 4.50325 15.0081 4.35472 16.463 4.64411C17.9178 4.9335 19.2542 5.64781 20.3031 6.6967C21.352 7.7456 22.0663 9.08197 22.3557 10.5368C22.6451 11.9917 22.4965 13.4997 21.9289 14.8701C21.3612 16.2406 20.3999 17.4119 19.1666 18.236C17.9332 19.0601 16.4831 19.5 14.9998 19.5H6.74978C6.00525 19.4993 5.26939 19.3402 4.59104 19.0333C3.91269 18.7265 3.30737 18.2788 2.81526 17.7201C2.32314 17.1614 1.95548 16.5045 1.73669 15.7928C1.5179 15.0812 1.45297 14.3311 1.54623 13.5924C1.63948 12.8538 1.88877 12.1434 2.27757 11.5084C2.66636 10.8735 3.18576 10.3285 3.80129 9.90964C4.41682 9.49078 5.11439 9.20762 5.84772 9.07897C6.58105 8.95033 7.33336 8.97912 8.0547 9.16346",
		stroke: "#0066CC",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ug = (e = !1) => `flexbox dc__transparent dc__hover-n50 dc__align-items-center py-6 px-8 w-100 dc__gap-8 ${e ? "dc__disabled" : ""}`, Wg = ({ isSystemController: e, handleShowDeleteModal: t, id: n, analyze: r, manage: i, deploy: a }) => {
	let o = X(), s = (e) => {
		window.open(e, "_blank", "noopener,noreferrer");
	};
	return /* @__PURE__ */ (0, Q.jsxs)(sl, {
		autoPosition: !0,
		autoClose: !0,
		children: [/* @__PURE__ */ (0, Q.jsx)(sl.Button, {
			isKebab: !0,
			rootClassName: "icon-dim-24 dc__no-shrink p-4 dc__no-background dc__no-border dc__outline-none-imp flex dc__tab-focus dc__hover-n50",
			children: /* @__PURE__ */ (0, Q.jsx)(Ri, { className: "flex icon-dim-16 dc__no-shrink icon-color-n6" })
		}), /* @__PURE__ */ (0, Q.jsxs)(sl.Body, {
			rootClassName: "br-4 py-4 w-120 flexbox-col dc__gap-4 dc__overflow-hidden dc__border dc__box-shadow--menu",
			children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox-col",
				children: [
					/* @__PURE__ */ (0, Q.jsxs)("button", {
						type: "button",
						className: Ug(!r),
						onClick: () => {
							s(r);
						},
						disabled: !r,
						children: [/* @__PURE__ */ (0, Q.jsx)(Nt, { className: "icon-dim-16 dc__no-shrink fcn-8" }), /* @__PURE__ */ (0, Q.jsx)("span", {
							className: "cn-9 fs-13 fw-4 lh-20",
							children: "Analyze"
						})]
					}),
					/* @__PURE__ */ (0, Q.jsxs)("button", {
						type: "button",
						className: Ug(!i),
						onClick: () => {
							s(i);
						},
						disabled: !i,
						children: [/* @__PURE__ */ (0, Q.jsx)(w, { className: "icon-dim-16 dc__no-shrink scn-8" }), /* @__PURE__ */ (0, Q.jsx)("span", {
							className: "cn-9 fs-13 fw-4 lh-20",
							children: "Manage"
						})]
					}),
					/* @__PURE__ */ (0, Q.jsxs)("button", {
						type: "button",
						className: Ug(!a),
						onClick: () => {
							s(a);
						},
						disabled: !a,
						children: [/* @__PURE__ */ (0, Q.jsx)(Yi, { className: "icon-dim-16 scn-8 dc__no-shrink" }), /* @__PURE__ */ (0, Q.jsx)("span", {
							className: "cn-9 fs-13 fw-4 lh-20",
							children: "Deploy"
						})]
					})
				]
			}), e && /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsx)("div", { className: "dc__border-bottom-n1" }), /* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox-col",
				children: [
					/* @__PURE__ */ (0, Q.jsxs)("button", {
						type: "button",
						className: Ug(),
						onClick: () => {
							o(Y(B.NETWORK_STATUS_INTERFACE.CONTROLLER_DETAILS, { controllerId: String(n) }));
						},
						children: [/* @__PURE__ */ (0, Q.jsx)(Bt, { className: "icon-dim-16 dc__no-shrink scn-8" }), /* @__PURE__ */ (0, Q.jsx)("span", {
							className: "cn-9 fs-13 fw-4 lh-20",
							children: "Details"
						})]
					}),
					/* @__PURE__ */ (0, Q.jsxs)("button", {
						type: "button",
						className: Ug(),
						onClick: () => {
							o(Y(B.NETWORK_STATUS_INTERFACE.EDIT_CONTROLLER, { controllerId: String(n) }));
						},
						children: [/* @__PURE__ */ (0, Q.jsx)(Ee, { className: "icon-dim-16 scn-8 dc__no-shrink" }), /* @__PURE__ */ (0, Q.jsx)("span", {
							className: "cn-9 fs-13 fw-4 lh-20",
							children: "Edit"
						})]
					}),
					/* @__PURE__ */ (0, Q.jsxs)("button", {
						type: "button",
						className: Ug(),
						onClick: () => {
							t();
						},
						children: [/* @__PURE__ */ (0, Q.jsx)(Be, { className: "icon-dim-16 scr-5 dc__no-shrink" }), /* @__PURE__ */ (0, Q.jsx)("span", {
							className: "cr-5 fs-13 fw-4 lh-20",
							children: "Delete"
						})]
					})
				]
			})] })]
		})]
	});
}, Gg = ({ id: e, reloadData: t, controllerData: n, isOpen: r, handleToggleControllerExpansion: i, searchText: a, systemControllerColumnConfig: o, subCloudColumnConfig: s, subCloudPageSize: c, handleChangeSubCloudPageNumber: l, subCloudPageNumber: u }) => {
	let [d, f] = j(!1), p = () => {
		f(!0);
	}, m = () => {
		f(!1);
	}, h = async () => {
		await Cg(e), t();
	}, g = () => {
		i(e);
	}, { actionLinks: { analyze: _, manage: v, deploy: y }, subclouds: b, activeController: x, systemControllerName: S } = n, C = b?.length || 0, w = C > c, T = b?.slice(c * (u - 1), c * u) || [];
	return /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox-col dc_width-max-content mw-100p",
		children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "display-grid network-status-interface__controller-list-row dc__border-bottom-n1 dc_width-max-content mw-100p dc__visible-hover dc__visible-hover--parent dc__hover-n50",
			children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "pl-16 pr-8 py-10 flexbox dc__gap-12 dc__content-space flex-grow-1 dc__border-right cn-9 fs-13 fw-4 lh-20 sticky-header-hover dc__position-sticky dc__zi-4 dc__left-0 bg__primary",
				children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "flex left dc__gap-12",
					children: [
						!r && /* @__PURE__ */ (0, Q.jsx)(Hg, { className: "icon-dim-24 scn-6 dc__no-shrink dc__visible-hover--hide-child" }),
						/* @__PURE__ */ (0, Q.jsx)("button", {
							className: `dc__transparent icon-dim-24 ${r ? "" : "dc__visible-hover--child"}`,
							type: "button",
							onClick: g,
							"aria-label": `Toggle ${S || ""} expansion`,
							children: /* @__PURE__ */ (0, Q.jsx)(wt, { className: `dc__no-shrink icon-dim-20 dc__transition--transform fcn-6 ${r ? "" : "dc__flip-90--neg"}` })
						}),
						S ? /* @__PURE__ */ (0, Q.jsx)(ft, {
							content: S,
							arrow: !1,
							className: "default-tt dc__word-break dc__mxw-200",
							children: /* @__PURE__ */ (0, Q.jsx)("span", {
								className: "dc__truncate cn-9 fs-13 fw-4 lh-20",
								dangerouslySetInnerHTML: { __html: Ne.sanitize(Gd({
									searchText: a,
									text: S,
									highlightClasses: "dc__search-highlight-bg"
								})) }
							})
						}) : /* @__PURE__ */ (0, Q.jsx)(hg, {})
					]
				}), /* @__PURE__ */ (0, Q.jsx)(Wg, {
					isSystemController: !0,
					handleShowDeleteModal: p,
					id: e,
					analyze: _,
					manage: v,
					deploy: y
				})]
			}), /* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox flex-grow-1 px-20 py-12 dc__gap-12",
				children: [/* @__PURE__ */ (0, Q.jsx)("span", {
					className: "w-180 cn-9 fs-13 fw-4 lh-20 dc__truncate",
					children: C
				}), o.map((t, n) => {
					let { field: r } = t;
					if (x?.[r] === void 0) return /* @__PURE__ */ (0, Q.jsx)(hg, { style: { width: `${t.width}px` } }, `system-controller-row-field-${r}-${e}_${n}`);
					let i = x[r] || "-";
					return /* @__PURE__ */ (0, Q.jsx)("div", {
						style: { width: `${t.width}px` },
						children: /* @__PURE__ */ (0, Q.jsx)(ft, {
							content: i,
							arrow: !1,
							className: "default-tt dc__word-break",
							children: /* @__PURE__ */ (0, Q.jsx)("span", {
								className: "dc__truncate cn-9 fs-13 fw-4 lh-20 dc_max-width__max-content",
								children: i
							}, `system-controller-row-field-${r}-${e}_${n}`)
						})
					});
				})]
			})]
		}), r && (T?.length ? /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [
			/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "display-grid network-status-interface__controller-list-row dc__border-bottom dc_width-max-content mw-100p",
				children: [/* @__PURE__ */ (0, Q.jsx)("div", {
					className: "dc__border-right flexbox dc__align-items-center dc__gap-4 pl-28 pr-8 cn-7 fs-12 fw-6 lh-18 dc__position-sticky dc__zi-4 dc__left-0 bg__secondary",
					children: /* @__PURE__ */ (0, Q.jsx)("div", {
						className: "pl-24 dc__border-left py-8 flexbox dc__align-items-center dc__gap-4",
						children: /* @__PURE__ */ (0, Q.jsx)("span", {
							className: "dc__uppercase dc__truncate",
							children: "Sub cloud"
						})
					})
				}), /* @__PURE__ */ (0, Q.jsx)("div", {
					className: "flexbox flex-grow-1 px-20 py-8 dc__gap-12 cn-7 fw-6 lh-18 bg__secondary",
					children: s.map((t, n) => {
						let r = t.label;
						return /* @__PURE__ */ (0, Q.jsx)("div", {
							style: { width: `${t.width}px` },
							children: /* @__PURE__ */ (0, Q.jsx)(ft, {
								content: r,
								arrow: !1,
								className: "default-tt dc__word-break dc__mxw-200",
								children: /* @__PURE__ */ (0, Q.jsx)("span", {
									className: "dc__uppercase dc__truncate dc_max-width__max-content",
									children: r
								})
							})
						}, `sub-cloud-${e}_${n}-${t.field}-header`);
					})
				})]
			}),
			T.map((t, n) => /* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "display-grid network-status-interface__controller-list-row dc__border-bottom dc_width-max-content mw-100p dc__hover-n50 bg__secondary",
				children: [/* @__PURE__ */ (0, Q.jsx)("div", {
					className: "pl-28 pr-8 flexbox dc__content-space dc__gap-16 dc__position-sticky sticky-header-hover dc__zi-4 dc__left-0 bg__secondary flex-grow-1 dc__border-right",
					children: /* @__PURE__ */ (0, Q.jsxs)("div", {
						className: "py-10 pl-24 dc__border-left flexbox dc__content-space dc__gap-16 flex-grow-1",
						children: [/* @__PURE__ */ (0, Q.jsx)(ft, {
							className: "default-tt dc__mxw-200 dc__word-break",
							arrow: !1,
							content: t.name || "-",
							children: /* @__PURE__ */ (0, Q.jsx)("span", {
								className: "dc__truncate cn-9 fs-13 fw-4 lh-20",
								dangerouslySetInnerHTML: { __html: Ne.sanitize(Gd({
									searchText: a,
									text: t.name || "-",
									highlightClasses: "dc__search-highlight-bg"
								})) }
							})
						}), /* @__PURE__ */ (0, Q.jsx)(Wg, {
							isSystemController: !1,
							analyze: _,
							manage: v,
							deploy: y
						})]
					})
				}), /* @__PURE__ */ (0, Q.jsx)("div", {
					className: "flexbox flex-grow-1 px-20 py-12 dc__gap-12",
					children: s.map((n, r) => {
						let { field: i } = n;
						if (t[i] === void 0) return /* @__PURE__ */ (0, Q.jsx)(hg, { style: { width: `${n.width}px` } }, `sub-cloud-row-field-${i}-${e}_${r}`);
						let a = t[i] || "-";
						return /* @__PURE__ */ (0, Q.jsx)("div", {
							style: { width: `${n.width}px` },
							children: /* @__PURE__ */ (0, Q.jsx)(ft, {
								content: a,
								arrow: !1,
								className: "default-tt dc__mxw-200 dc__word-break",
								children: /* @__PURE__ */ (0, Q.jsx)("span", {
									className: "dc__truncate cn-9 fs-13 fw-4 lh-20 dc_max-width__max-content",
									children: a
								})
							})
						}, `sub-cloud-row-field-${i}-${e}_${r}`);
					})
				})]
			}, `subcloud-row-${e}_${n}-${t.name || ""}`)),
			w && /* @__PURE__ */ (0, Q.jsx)("div", {
				className: "display-grid network-status-interface__sub-cloud-pagination-container dc__border-bottom",
				children: /* @__PURE__ */ (0, Q.jsx)($c, {
					size: C,
					pageSize: c,
					offset: c * (u - 1),
					changePage: (t) => {
						l(e, t);
					},
					isPageSizeFix: !0,
					rootClassName: "flexbox dc__content-space bg__primary px-20 m-0 dc__align-items-center network-status-interface__pagination-container dc__position-sticky dc__zi-4 dc__left-0"
				})
			})
		] }) : /* @__PURE__ */ (0, Q.jsx)("div", {
			className: "display-grid network-status-interface__controller-list-row dc__border-bottom dc_width-max-content mw-100p bg__secondary dc__hover-n50",
			children: /* @__PURE__ */ (0, Q.jsx)("div", {
				className: "dc__border-right flexbox dc__align-items-center dc__gap-4 pl-28 pr-8 cn-7 fs-13 fw-4 lh-20 sticky-header-hover dc__position-sticky dc__zi-4 dc__left-0 bg__secondary",
				children: /* @__PURE__ */ (0, Q.jsx)("div", {
					className: "pl-24 dc__border-left py-8 flexbox dc__align-items-center dc__gap-4",
					children: /* @__PURE__ */ (0, Q.jsx)("span", { children: a ? "No matching sub cloud found" : "No sub cloud found" })
				})
			})
		}))]
	}), d && /* @__PURE__ */ (0, Q.jsx)(Ts, {
		title: S,
		component: "system controller",
		subtitle: "System controller will be removed from Devtron.",
		closeConfirmationModal: m,
		onDelete: h,
		successToastMessage: "System controller deleted successfully",
		children: /* @__PURE__ */ (0, Q.jsx)("p", {
			className: "m-0 fs-13 cn-7",
			children: "Are you sure?"
		})
	})] });
}, Kg = () => /* @__PURE__ */ (0, Q.jsx)(tg, {}), qg = () => {
	let e = X(), t = Ja(new AbortController()), [n, r, i, a] = hf(() => Du(() => bg({ signal: t.current.signal }), t)), o = n || pd(i), [s, c] = j({}), [l, u] = j({}), d = () => {
		u({});
	}, f = (e, t) => {
		u((n) => ({
			...n,
			[e]: t
		}));
	}, { sortBy: p, sortOrder: m, handleSorting: h, searchKey: g, handleSearch: _, clearFilters: v, pageSize: y, offset: b, changePageSize: x, changePage: S, subCloudPageSize: C } = Pf({
		initialSortKey: ig.SYSTEM_CONTROLLER_NAME,
		parseSearchParams: _g
	}), w = !!g || !!b, T = A(() => {
		try {
			if (!r) return structuredClone(cg);
			let { systemControllerMap: e, ids: t, columnConfig: n } = r, i = t.reduce((t, n) => {
				let r = e[n], { systemControllerName: i } = r, a = g.toLowerCase(), o = r.subclouds?.filter((e) => e?.name && e.name.toLowerCase().includes(a)) || [];
				if (!o.length && !(i && i.toLowerCase().includes(a))) return t;
				let s = {
					...r,
					subclouds: o
				};
				return {
					...t,
					[n]: s
				};
			}, {}), a = n.systemControllerColumns.find((e) => e.field === p), o = p === ig.SYSTEM_CONTROLLER_NAME || p === ig.NUMBER_OF_SUB_CLOUDS, s = !!a || o, c = !!a && !a.isSortable;
			if (!s || !p || c) return {
				...r,
				systemControllerMap: i,
				ids: t
			};
			let l = o ? gg(p) : a?.type || "string", u = Object.keys(i).map(Number);
			return u.sort((e, t) => {
				if (o) return p === ig.SYSTEM_CONTROLLER_NAME ? df(i[e].systemControllerName || "", i[t].systemControllerName || "", m) : p === ig.NUMBER_OF_SUB_CLOUDS ? ef(i[e].subclouds?.length || 0, i[t].subclouds?.length || 0, m) : 0;
				let n = i[+e].activeController?.[p], r = i[+t].activeController?.[p];
				return l === "number" ? ef(n || 0, r || 0, m) : df(n ? JSON.stringify(n) : "", r ? JSON.stringify(r) : "", m);
			}), {
				...r,
				systemControllerMap: i,
				ids: u
			};
		} catch (e) {
			return H.showToast({
				variant: U.error,
				description: "Something went wrong while sorting/searching the data"
			}), Xd(e), r;
		}
	}, [
		g,
		p,
		m,
		r,
		n,
		i
	]), { showPagination: ee, currentPageIds: E } = A(() => {
		if (!T?.ids) return {
			showPagination: !1,
			currentPageIds: []
		};
		let e = structuredClone(T.ids);
		return {
			showPagination: e.length > y,
			currentPageIds: e.slice(b, b + y)
		};
	}, [
		T.ids,
		y,
		b
	]);
	k(() => () => {
		t.current.abort();
	}, []);
	let D = () => {
		e("..");
	}, te = () => {
		h(ig.SYSTEM_CONTROLLER_NAME);
	}, ne = () => {
		a();
	}, re = A(() => T?.ids ? T.ids.every((e) => s[e]) : !1, [T?.ids, s]), ie = () => {
		if (T?.ids) {
			if (re) {
				c({});
				return;
			}
			c(T.ids.reduce((e, t) => ({
				...e,
				[t]: !0
			}), {}));
		}
	}, ae = (e) => {
		c((t) => {
			if (t[e]) {
				let n = { ...t };
				return delete n[e], n;
			}
			return {
				...t,
				[e]: !0
			};
		});
	}, oe = () => {
		d(), v();
	}, se = (e) => {
		d(), _(e);
	}, ce = (e) => /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "display-grid network-status-interface__controller-list-row dc__border-bottom dc_width-max-content mw-100p",
		children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "pl-16 pr-8 py-6 flexbox dc__gap-12 flex-grow-1 dc__border-right cn-7 fs-12 fw-6 lh-20 dc__position-sticky dc__zi-4 dc__left-0 bg__primary",
			children: [/* @__PURE__ */ (0, Q.jsx)("button", {
				className: `dc__transparent icon-dim-24 ${o ? "dc__disabled" : ""}`,
				type: "button",
				onClick: ie,
				"aria-label": "Toggle all controllers expansion",
				disabled: o,
				children: /* @__PURE__ */ (0, Q.jsx)(wt, { className: `dc__no-shrink icon-dim-20 dc__transition--transform fcn-6 ${re ? "" : "dc__flip-90--neg"}` })
			}), e ? /* @__PURE__ */ (0, Q.jsx)("div", { className: "shimmer-loading h-20 w-236" }) : /* @__PURE__ */ (0, Q.jsx)(ql, {
				isSorted: p === ig.SYSTEM_CONTROLLER_NAME,
				sortOrder: m,
				title: "System Controller",
				triggerSorting: te,
				disabled: !1
			})]
		}), /* @__PURE__ */ (0, Q.jsx)("div", {
			className: "flexbox flex-grow-1 px-20 py-8 dc__gap-12 cn-7 fs-12 fw-6 lh-20",
			children: e ? [
				,
				,
				,
			].fill(0).map((e, t) => /* @__PURE__ */ (0, Q.jsx)("div", {
				className: "flexbox w-150",
				children: /* @__PURE__ */ (0, Q.jsx)("div", { className: "shimmer-loading h-20 w-100px" })
			}, `system-controller-header-column-shimmer-${t}`)) : /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsx)(Vg, {
				field: ig.NUMBER_OF_SUB_CLOUDS,
				label: "NO. OF SUB CLOUDS",
				width: 180,
				isSortable: !0,
				sortOrder: m,
				sortBy: p,
				handleSorting: h
			}), T.columnConfig.systemControllerColumns.map(({ field: e, label: t, width: n, isSortable: r }, i) => /* @__PURE__ */ (0, Q.jsx)(Vg, {
				field: e,
				label: t,
				width: n,
				isSortable: r,
				sortOrder: m,
				sortBy: p,
				handleSorting: h
			}, `system-controller-${i}-${e}-header`))] })
		})]
	}), le = i && !pd(i), ue = (e) => /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "display-grid network-status-interface__controller-list-row dc__border-bottom-n1",
		children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "py-10 pl-16 pr-8 flexbox dc__gap-12 dc__border-right dc__align-items-center",
			children: [/* @__PURE__ */ (0, Q.jsx)("div", { className: "icon-dim-24 dc__no-shrink shimmer-loading" }), /* @__PURE__ */ (0, Q.jsx)("div", { className: "flex-grow-1 shimmer-loading h-20" })]
		}), /* @__PURE__ */ (0, Q.jsx)("div", {
			className: "flexbox flex-grow-1 px-20 py-12 dc__gap-12",
			children: [
				,
				,
				,
			].fill(0).map((e, t) => /* @__PURE__ */ (0, Q.jsx)("div", {
				className: "flexbox w-150",
				children: /* @__PURE__ */ (0, Q.jsx)("div", { className: "shimmer-loading h-20 w-150" })
			}, `system-controller-shimmer-column-${t}`))
		})]
	}, `system-controller-shimmer-%${e}`), de = () => o ? /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox-col flex-grow-1 dc__overflow-auto",
		children: [ce(!0), /* @__PURE__ */ (0, Q.jsx)("div", {
			className: "flexbox-col flex-grow-1 dc__overflow-auto",
			children: [
				,
				,
				,
				,
				,
			].fill(0).map((e, t) => ue(t))
		})]
	}) : le ? /* @__PURE__ */ (0, Q.jsx)(Ks, {
		code: i.code,
		reload: a
	}) : E?.length ? /* @__PURE__ */ (0, Q.jsx)("div", {
		className: "flexbox-col flex-grow-1 dc__overflow-auto",
		children: /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "mw-100p dc_width-max-content",
			children: [ce(), E.map((e) => /* @__PURE__ */ (0, Q.jsx)(Gg, {
				id: e,
				reloadData: a,
				controllerData: T.systemControllerMap[e],
				isOpen: !!s[e],
				handleToggleControllerExpansion: ae,
				searchText: g,
				subCloudColumnConfig: T.columnConfig.subCloudColumns,
				systemControllerColumnConfig: T.columnConfig.systemControllerColumns,
				subCloudPageSize: C,
				handleChangeSubCloudPageNumber: f,
				subCloudPageNumber: l[e] || 1
			}, `${e}-system-controller-list-row`))]
		})
	}) : w ? /* @__PURE__ */ (0, Q.jsx)(oc, {
		handleClearFilters: oe,
		imageType: yc.Large,
		classname: "flex-grow-1"
	}) : /* @__PURE__ */ (0, Q.jsx)(R, {
		title: "No System Controllers",
		subTitle: "Add a system controller to view its subclouds",
		classname: "flex-grow-1",
		isButtonAvailable: !0,
		imageType: yc.Large,
		image: np,
		renderButton: Kg
	}), fe = !o && !w && !T?.ids?.length;
	return /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [
		/* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox-col flex-grow-1",
			children: [!(le || fe) && /* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "py-12 px-20 flexbox dc__align-items-center dc__content-space w-100",
				children: [/* @__PURE__ */ (0, Q.jsx)(Il, {
					containerClassName: "w-250",
					inputProps: { placeholder: "Search controller or subcloud" },
					initialSearchText: g,
					handleEnter: se
				}), /* @__PURE__ */ (0, Q.jsx)(Bg, {})]
			}), de()]
		}),
		ee && /* @__PURE__ */ (0, Q.jsx)($c, {
			size: T.ids.length,
			pageSize: y,
			offset: b,
			changePage: S,
			changePageSize: x,
			isPageSizeFix: !0,
			rootClassName: "flexbox dc__content-space bg__primary px-20 m-0 dc__border-top dc__align-items-center dc__position-sticky dc__bottom-0 dc__zi-5 network-status-interface__pagination-container"
		}),
		/* @__PURE__ */ (0, Q.jsxs)(qf, { children: [
			/* @__PURE__ */ (0, Q.jsx)(J, {
				path: vo.NETWORK_STATUS_INTERFACE.CREATE_CONTROLLER,
				element: /* @__PURE__ */ (0, Q.jsx)(jg, {
					handleClose: D,
					handleSuccess: ne
				})
			}),
			/* @__PURE__ */ (0, Q.jsx)(J, {
				path: vo.NETWORK_STATUS_INTERFACE.EDIT_CONTROLLER,
				element: /* @__PURE__ */ (0, Q.jsx)(jg, {
					handleClose: D,
					handleSuccess: ne
				})
			}),
			/* @__PURE__ */ (0, Q.jsx)(J, {
				path: vo.NETWORK_STATUS_INTERFACE.CUSTOMIZE_COLUMNS,
				element: /* @__PURE__ */ (0, Q.jsx)(zg, {
					handleClose: D,
					handleSuccess: ne,
					isLoadingConfig: n,
					refetchConfig: a,
					configError: i,
					savedColumnConfig: T?.columnConfig
				})
			}),
			/* @__PURE__ */ (0, Q.jsx)(J, {
				path: vo.NETWORK_STATUS_INTERFACE.CONTROLLER_DETAILS,
				element: /* @__PURE__ */ (0, Q.jsx)(Mg, {
					handleClose: D,
					isLoadingSystemController: n,
					refetchDetails: a,
					systemControllerError: i,
					systemControllerMap: T?.systemControllerMap
				})
			})
		] })
	] });
}, Jg = () => {
	let { isSuperAdmin: e } = Tf();
	return /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox-col flex-grow-1 h-100 bg__primary dc__overflow-auto",
		children: [/* @__PURE__ */ (0, Q.jsx)(Qc, {
			headerName: "Network Status Interface",
			renderActionButtons: () => e ? /* @__PURE__ */ (0, Q.jsx)(tg, {}) : null
		}), e ? /* @__PURE__ */ (0, Q.jsx)(qg, {}) : /* @__PURE__ */ (0, Q.jsx)(Ks, { code: eo.PERMISSION_DENIED })]
	});
}, Yg = (e) => /* @__PURE__ */ (0, Q.jsx)("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...e,
	children: /* @__PURE__ */ (0, Q.jsx)("g", {
		fill: "none",
		fillRule: "evenodd",
		children: /* @__PURE__ */ (0, Q.jsx)("path", {
			fill: "#959BA1",
			d: "M20 13a1 1 0 0 1 1 1v4a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3v-4a1 1 0 0 1 2 0v4a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-4a1 1 0 0 1 1-1zm-8-8.5a1 1 0 0 1 1 1v8.085l2.293-2.292a1 1 0 0 1 1.32-.083l.094.083a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414 0l-4-4a1 1 0 0 1 1.414-1.414L11 13.585V5.5a1 1 0 0 1 .883-.993z"
		})
	})
}), Xg = (e) => /* @__PURE__ */ (0, Q.jsx)("svg", {
	width: 28,
	height: 28,
	viewBox: "0 0 28 28",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ (0, Q.jsx)("path", {
		d: "M4.30769 22.75L4.3055 23.5H4.30769V22.75ZM3.5 21.9423H2.75L2.75 21.9445L3.5 21.9423ZM24.5 21.9722H25.25H24.5ZM4.375 5.25V6V5.25ZM10.1376 5.25V6V5.25ZM10.7563 5.50628L10.226 6.03661L10.226 6.03661L10.7563 5.50628ZM13.4697 9.28033C13.7626 9.57322 14.2374 9.57322 14.5303 9.28033C14.8232 8.98744 14.8232 8.51256 14.5303 8.21967L13.4697 9.28033ZM16.3333 10.0417C15.9191 10.0417 15.5833 10.3775 15.5833 10.7917C15.5833 11.2059 15.9191 11.5417 16.3333 11.5417V10.0417ZM18.0833 11.5417H18.8333V10.0417H18.0833V11.5417ZM16.3333 19.375C15.9191 19.375 15.5833 19.7108 15.5833 20.125C15.5833 20.5392 15.9191 20.875 16.3333 20.875V19.375ZM18.0833 20.875H18.8333V19.375H18.0833V20.875ZM16.3333 14.7083C15.9191 14.7083 15.5833 15.0441 15.5833 15.4583C15.5833 15.8725 15.9191 16.2083 16.3333 16.2083V14.7083ZM18.0833 16.2083H18.8333V14.7083H18.0833V16.2083ZM18.6667 12.375H17.9167V13.875H18.6667V12.375ZM20.4167 13.875C20.8309 13.875 21.1667 13.5392 21.1667 13.125C21.1667 12.7108 20.8309 12.375 20.4167 12.375V13.875ZM18.6667 17.0417H17.9167V18.5417H18.6667V17.0417ZM20.4167 18.5417C20.8309 18.5417 21.1667 18.2059 21.1667 17.7917C21.1667 17.3775 20.8309 17.0417 20.4167 17.0417V18.5417ZM19.125 10.2083V9.45833H17.625V10.2083H19.125ZM17.625 21.2917V22.0417H19.125V21.2917H17.625ZM23.7222 22H4.30769V23.5H23.7222V22ZM4.30989 22C4.29402 22 4.27881 21.9936 4.26759 21.9824L3.20693 23.0431C3.49838 23.3345 3.89333 23.4988 4.3055 23.5L4.30989 22ZM4.26759 21.9824C4.25637 21.9712 4.25004 21.956 4.25 21.9401L2.75 21.9445C2.75121 22.3567 2.91548 22.7516 3.20693 23.0431L4.26759 21.9824ZM4.25 21.9423V8.75H2.75V21.9423H4.25ZM3.5 9.5H23.625V8H3.5V9.5ZM23.625 9.5C23.6582 9.5 23.6899 9.51317 23.7134 9.53661L24.774 8.47595C24.4693 8.1712 24.056 8 23.625 8V9.5ZM23.7134 9.53661C23.7368 9.56005 23.75 9.59185 23.75 9.625H25.25C25.25 9.19402 25.0788 8.7807 24.774 8.47595L23.7134 9.53661ZM23.75 9.625V21.9722H25.25V9.625H23.75ZM23.75 21.9722C23.75 21.9796 23.7471 21.9867 23.7419 21.9919L24.8025 23.0525C25.089 22.766 25.25 22.3774 25.25 21.9722H23.75ZM23.7419 21.9919C23.7367 21.9971 23.7296 22 23.7222 22V23.5C24.1274 23.5 24.516 23.339 24.8025 23.0525L23.7419 21.9919ZM4.25 8.75V6.125H2.75V8.75H4.25ZM4.25 6.125C4.25 6.09185 4.26317 6.06005 4.28661 6.03661L3.22595 4.97595C2.92121 5.2807 2.75 5.69402 2.75 6.125H4.25ZM4.28661 6.03661C4.31005 6.01317 4.34185 6 4.375 6L4.375 4.5C3.94402 4.5 3.5307 4.67121 3.22595 4.97595L4.28661 6.03661ZM4.375 6H10.1376V4.5H4.375V6ZM10.1376 6C10.154 6 10.1702 6.00323 10.1854 6.00951L10.7594 4.6237C10.5623 4.54203 10.351 4.5 10.1376 4.5V6ZM10.1854 6.00951C10.2006 6.0158 10.2143 6.025 10.226 6.03661L11.2866 4.97595C11.1357 4.82506 10.9566 4.70536 10.7594 4.6237L10.1854 6.00951ZM10.226 6.03661L13.4697 9.28033L14.5303 8.21967L11.2866 4.97595L10.226 6.03661ZM16.3333 11.5417H18.0833V10.0417H16.3333V11.5417ZM16.3333 20.875H18.0833V19.375H16.3333V20.875ZM16.3333 16.2083H18.0833V14.7083H16.3333V16.2083ZM18.6667 13.875H20.4167V12.375H18.6667V13.875ZM18.6667 18.5417H20.4167V17.0417H18.6667V18.5417ZM17.625 10.2083V21.2917H19.125V10.2083H17.625Z",
		fill: "#0066CC"
	})
}), Zg = (e) => /* @__PURE__ */ (0, Q.jsx)("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ (0, Q.jsx)("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M11.635 1.35049C11.867 1.21651 12.1529 1.2165 12.385 1.35048L14.55 2.60048C14.9088 2.80759 15.0317 3.26628 14.8246 3.625C14.6175 3.98372 14.1588 4.10663 13.8 3.89952L12.01 2.86603L10.22 3.89951C9.86127 4.10663 9.40257 3.98373 9.19546 3.62501C8.98835 3.26629 9.11125 2.8076 9.46997 2.60049L11.635 1.35049ZM6.16449 5.37499C6.3716 5.73371 6.2487 6.1924 5.88998 6.39951L4.09998 7.43301V9.5C4.09998 9.91421 3.76419 10.25 3.34998 10.25C2.93576 10.25 2.59998 9.91421 2.59998 9.5V7C2.59998 6.73205 2.74292 6.48446 2.97497 6.35049L5.13997 5.10049C5.49868 4.89337 5.95738 5.01628 6.16449 5.37499ZM17.8556 5.375C18.0628 5.01628 18.5214 4.89337 18.8802 5.10048L21.0452 6.35048C21.2773 6.48445 21.4202 6.73204 21.4202 6.99998L21.4203 9.49998C21.4203 9.91419 21.0845 10.25 20.6703 10.25C20.2561 10.25 19.9203 9.91423 19.9203 9.50002L19.9202 7.43302L18.1302 6.39952C17.7714 6.19241 17.6485 5.73372 17.8556 5.375ZM11.605 6.35049C11.837 6.21651 12.1229 6.2165 12.355 6.35048L13.4375 6.97548C13.7962 7.18259 13.9191 7.64128 13.712 8C13.5049 8.35872 13.0462 8.48163 12.6875 8.27452L11.98 7.86603L11.2725 8.27451C10.9138 8.48163 10.4551 8.35873 10.248 8.00001C10.0408 7.64129 10.1637 7.1826 10.5225 6.97549L11.605 6.35049ZM14.5781 8.5C14.7852 8.14128 15.2439 8.01837 15.6026 8.22548L16.6851 8.85048C16.9171 8.98445 17.0601 9.23204 17.0601 9.49998L17.0601 10.75C17.0601 11.1642 16.7244 11.5 16.3102 11.5C15.8959 11.5 15.5601 11.1642 15.5601 10.75L15.5601 9.93302L14.8526 9.52452C14.4939 9.31741 14.3709 8.85872 14.5781 8.5ZM9.38199 8.49999C9.5891 8.85871 9.4662 9.3174 9.10748 9.52451L8.39998 9.93301V10.75C8.39998 11.1642 8.06419 11.5 7.64998 11.5C7.23576 11.5 6.89998 11.1642 6.89998 10.75V9.5C6.89998 9.23205 7.04292 8.98446 7.27497 8.85049L8.35747 8.22549C8.71618 8.01837 9.17488 8.14127 9.38199 8.49999ZM7.64998 12.5C8.06419 12.5 8.39998 12.8358 8.39998 13.25V14.067L9.10751 14.4755C9.46623 14.6826 9.58913 15.1413 9.38203 15.5C9.17492 15.8587 8.71623 15.9816 8.35751 15.7745L7.27498 15.1495C7.04292 15.0155 6.89998 14.7679 6.89998 14.5V13.25C6.89998 12.8358 7.23576 12.5 7.64998 12.5ZM16.3102 12.5C16.7244 12.5 17.0602 12.8358 17.0602 13.25L17.0602 14.5C17.0602 14.7679 16.9173 15.0155 16.6852 15.1495L15.6027 15.7745C15.244 15.9816 14.7853 15.8587 14.5782 15.5C14.3711 15.1413 14.494 14.6826 14.8527 14.4755L15.5602 14.067L15.5602 13.25C15.5602 12.8358 15.896 12.5 16.3102 12.5ZM3.34998 13.75C3.76419 13.75 4.09998 14.0858 4.09998 14.5V16.567L5.89004 17.6005C6.24876 17.8076 6.37167 18.2663 6.16456 18.625C5.95745 18.9837 5.49876 19.1066 5.14004 18.8995L2.97498 17.6495C2.74292 17.5155 2.59998 17.2679 2.59998 17V14.5C2.59998 14.0858 2.93576 13.75 3.34998 13.75ZM20.6704 13.75C21.0846 13.75 21.4204 14.0858 21.4204 14.5L21.4205 17C21.4205 17.2679 21.2775 17.5155 21.0455 17.6495L18.8804 18.8995C18.5217 19.1066 18.063 18.9837 17.8559 18.625C17.6488 18.2663 17.7717 17.8076 18.1304 17.6005L19.9205 16.567L19.9204 14.5C19.9204 14.0858 20.2562 13.75 20.6704 13.75ZM10.2481 16C10.4552 15.6413 10.9139 15.5184 11.2726 15.7255L11.9801 16.134L12.6876 15.7255C13.0464 15.5184 13.505 15.6413 13.7122 16C13.9193 16.3587 13.7964 16.8174 13.4376 17.0245L12.3551 17.6495C12.1231 17.7835 11.8372 17.7835 11.6051 17.6495L10.5226 17.0245C10.1639 16.8174 10.0409 16.3587 10.2481 16ZM9.19565 20.375C9.40275 20.0163 9.86145 19.8934 10.2202 20.1005L12.0102 21.134L13.8003 20.1005C14.159 19.8934 14.6177 20.0163 14.8248 20.375C15.0319 20.7337 14.909 21.1924 14.5503 21.3995L12.3852 22.6495C12.1532 22.7835 11.8673 22.7835 11.6352 22.6495L9.47017 21.3995C9.11145 21.1924 8.98854 20.7337 9.19565 20.375Z",
		fill: "#596168"
	})
}), Qg = /* @__PURE__ */ t({ default: () => $g }), $g = ({ isVirtualIcon: e, showVirtualText: t }) => /* @__PURE__ */ (0, Q.jsx)(Cc, {
	heading: e || t ? ve.isolatedEnvironment : ve.generateHelmManifest,
	infoText: `${e || t ? ve.isolatedEnvTippy : Re.deploymentToIsolatedEnvironment}`,
	children: /* @__PURE__ */ (0, Q.jsx)("div", { children: e ? /* @__PURE__ */ (0, Q.jsx)(Zg, {
		"data-testid": "virtual-environment",
		className: "flex cursor icon-dim-24 fcb-5 ml-16"
	}) : /* @__PURE__ */ (0, Q.jsx)("div", {
		"data-testid": "virtual-environment-help",
		className: "ml-4 flex",
		children: /* @__PURE__ */ (0, Q.jsx)(m, { className: "icon-dim-16 cursor mandatory-tag-info-icon" })
	}) })
}), e_ = /* @__PURE__ */ t({ default: () => t_ }), t_ = ({ params: e }) => {
	let { isDownloading: t, handleDownload: n } = yf(), r = Oe(e);
	return /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "app-details-info-card flex left bg__primary br-8 w-200 dc__overflow-initial--imp",
		"data-testid": "app-details-manifest-download-card",
		children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "app-details-info-card__top-container flexbox dc__gap-12",
			children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "app-details-info-card__top-container__content",
				children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "app-details-info-card__top-container__content__title-wrapper",
					children: [/* @__PURE__ */ (0, Q.jsx)("p", {
						className: "m-0 fs-12 lh-20 fw-4 cn-7",
						children: ve.generateHelmManifest
					}), /* @__PURE__ */ (0, Q.jsx)($g, { isVirtualIcon: e.isVirtualIcon })]
				}), /* @__PURE__ */ (0, Q.jsx)(W, {
					content: e.appName,
					children: /* @__PURE__ */ (0, Q.jsx)("p", {
						className: "m-0 dc__truncate",
						children: e.appName
					})
				})]
			}), /* @__PURE__ */ (0, Q.jsx)(Xg, { className: "icon-dim-24 dc__no-shrink" })]
		}), /* @__PURE__ */ (0, Q.jsx)("div", {
			className: "app-details-info-card__bottom-container",
			children: /* @__PURE__ */ (0, Q.jsx)("button", {
				type: "button",
				className: `dc__transparent p-0 flex left dc__gap-4 ${t ? "cursor-not-allowed" : "cursor"}`,
				"data-testid": "virtual-app-detail-dowload-button",
				onClick: () => {
					n({
						downloadUrl: r,
						fileName: e.appName,
						downloadSuccessToastContent: "Manifest Downloaded Successfully"
					});
				},
				disabled: t,
				children: t ? /* @__PURE__ */ (0, Q.jsx)("span", {
					className: "dc__loading-dots fs-12 lh-18 fw-6 cn-7",
					children: "Downloading"
				}) : /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsx)("span", {
					className: "fs-12 lh-18 fw-6 cb-5",
					children: "Download"
				}), /* @__PURE__ */ (0, Q.jsx)(Yg, { className: "icon-dim-14 fcb-5" })] })
			})
		})]
	});
}, n_ = (e) => /* @__PURE__ */ (0, Q.jsxs)("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [
		/* @__PURE__ */ (0, Q.jsx)("path", {
			d: "M12.5 14H3.49951C3.3669 14 3.23973 13.9473 3.14596 13.8536C3.05219 13.7598 2.99951 13.6326 2.99951 13.5V2.5C2.99951 2.36739 3.05219 2.24021 3.14596 2.14645C3.23973 2.05268 3.3669 2 3.49951 2H9.5L13 5.5V13.5C13 13.5657 12.9871 13.6307 12.9619 13.6913C12.9368 13.752 12.9 13.8071 12.8536 13.8536C12.8071 13.9 12.752 13.9368 12.6913 13.9619C12.6307 13.9871 12.5657 14 12.5 14Z",
			stroke: "#596168",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			d: "M9.5 2V5.5H13.0005",
			stroke: "#596168",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			d: "M6.25 9.75L8 11.5L9.75 9.75",
			stroke: "#596168",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			d: "M8 7.5V11.5",
			stroke: "#596168",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
}), r_ = /* @__PURE__ */ t({ default: () => i_ }), i_ = () => /* @__PURE__ */ (0, Q.jsxs)("div", {
	"data-testid": "generated-helm-download-card",
	className: "fs-13",
	children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flex left cn-7",
		children: [ve.generateHelmManifest, /* @__PURE__ */ (0, Q.jsx)($g, {})]
	}), /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "cn-9 flex left",
		children: [/* @__PURE__ */ (0, Q.jsx)(n_, { className: "icon-dim-16 mr-8" }), "Download on deployment"]
	})]
}), a_ = /* @__PURE__ */ function(e) {
	return e.PUSH = "PUSH", e.DO_NOT_PUSH = "DO_NOT_PUSH", e;
}({}), o_ = /* @__PURE__ */ t({ default: () => s_ }), s_ = ({ generatedHelmPushAction: e, onChangeSetGeneratedHelmPush: t, dockerRegistries: n, selectedRegistry: r, handleRegistryChange: i, repositoryName: a, handleOnRepository: o, containerRegistryName: s, containerRegistryErrorForm: c, repositoryErrorForm: l }) => {
	let u = n.map((e) => ({
		...e,
		value: e.id,
		label: e.id,
		startIcon: /* @__PURE__ */ (0, Q.jsx)(xl, { registryType: e.registryType })
	})), d = (e) => e?.isValid ? null : e.message;
	return /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "fs-13",
		children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flex left",
			children: [/* @__PURE__ */ (0, Q.jsx)("span", { children: ve.pushGeneratedHelmPackage }), /* @__PURE__ */ (0, Q.jsx)($g, {})]
		}), /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "pt-12",
			children: [/* @__PURE__ */ (0, Q.jsx)("div", {
				className: "flex left mb-12",
				children: /* @__PURE__ */ (0, Q.jsxs)(vl, {
					className: "radio-group-no-border",
					value: e,
					name: "helmAction",
					onChange: (e) => {
						t(e.target.value);
					},
					children: [/* @__PURE__ */ (0, Q.jsx)(yl, {
						value: a_.DO_NOT_PUSH,
						children: "Do not push"
					}), /* @__PURE__ */ (0, Q.jsx)(yl, {
						value: a_.PUSH,
						children: "Push to registry"
					})]
				})
			}), e === a_.PUSH ? /* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "mb-4 form__row--two-third fs-13",
				children: [/* @__PURE__ */ (0, Q.jsx)(V, {
					label: "Registry",
					required: !0,
					inputId: "container-registry",
					classNamePrefix: "cd-trigger__select-container-registry",
					isClearable: !1,
					options: u,
					value: (() => {
						if (r?.id) return {
							...r,
							startIcon: /* @__PURE__ */ (0, Q.jsx)(xl, { registryType: r.registryType })
						};
						let e = n.find((e) => e.isDefault === !0);
						return e?.id && i(e), e;
					})(),
					onChange: i,
					placeholder: "Select registry",
					size: I.large,
					error: d(c)
				}), (s || r || n.find((e) => e.isDefault === !0)) && /* @__PURE__ */ (0, Q.jsx)(os, {
					placeholder: r && ml[r.registryType]?.placeholderText || "Enter repository name",
					label: /* @__PURE__ */ (0, Q.jsxs)("div", { children: ["Repository", /* @__PURE__ */ (0, Q.jsx)("span", {
						className: "ml-4",
						children: r && ml[r.registryType]?.desiredFormat
					})] }),
					name: "repository_name",
					value: a,
					onChange: o,
					"data-testid": "container-repository-textbox",
					required: !0,
					helperText: `'${a || "repoName"}' repo must exist in the selected ECR
                                    registry.`,
					error: d(l)
				})]
			}) : /* @__PURE__ */ (0, Q.jsx)(xc, { description: "The helm chart package will be generated and downloaded when you trigger the deployment. The package can be used to deploy to clusters not connected to Devtron." })]
		})]
	});
}, c_ = /* @__PURE__ */ t({ default: () => l_ }), l_ = ({ handleOCIRegistryStorageAction: e, disabledFields: t, isOCIRegistryHelmPush: n }) => /* @__PURE__ */ (0, Q.jsx)(Wo, {
	rootClassName: `${t.some((e) => e === Tl.CHART_PUSH) ? "registry-disabled-checkbox" : ""} docker-default mb-12 mt-12`,
	id: Tl.CHART_PUSH,
	isChecked: n,
	value: Io.CHECKED,
	onChange: (t) => e(t, Tl.CHART_PUSH),
	dataTestId: "store-container-and-chart",
	disabled: t.some((e) => e === Tl.CHART_PUSH),
	children: "Push helm packages"
});
//#endregion
//#region src/Components/VirtualDeployment/virtual.service.ts
function u_(e) {
	return nf(O.virtual_cluster, e);
}
function d_(e) {
	return sf(O.virtual_cluster, e);
}
function f_(e) {
	return nf(O.virtual_env, e);
}
function p_(e) {
	return sf(O.virtual_env, e);
}
function m_(e) {
	return ff(O.virtual_cluster, e);
}
function h_(e) {
	return e ? p_ : f_;
}
//#endregion
//#region src/Components/VirtualDeployment/VirtualAppDetailsEmptyState.tsx
var g_ = /* @__PURE__ */ t({ default: () => __ }), __ = ({ environmentName: e = "" }) => /* @__PURE__ */ (0, Q.jsx)("div", {
	"data-testid": "virtual-app-details-empty-state-modal",
	className: "bg__primary h-100 dc__position-rel",
	children: /* @__PURE__ */ (0, Q.jsx)(R, {
		image: rp,
		title: `${e} ${Te.TITLE}`,
		subTitle: Te.SUBTITLE,
		imageClassName: "empty-medium-image"
	})
}), v_ = ({ id: e, clusterName: t = "", reload: n, handleModalClose: r, category: i, isProd: a }) => {
	let { serverMode: o } = Tf();
	k(() => {
		o === Ml.EA_ONLY && r();
	}, []);
	let [s, c] = j(!1), [l, u] = j(!1), { data: d, errors: f, register: p, handleSubmit: m } = xf({
		initialValues: {
			cluster_name: t,
			category: i,
			isProd: a ?? !1
		},
		validations: { cluster_name: {
			required: !0,
			pattern: [
				{
					message: "Name is required",
					value: /^.*$/
				},
				{
					message: "Use only lowercase alphanumeric characters, '-', '_' or '.'",
					value: /^[a-z0-9-._]+$/
				},
				{
					message: "Cannot start/end with '-', '_' or '.'",
					value: /^(?![-._]).*[^-._]$/
				},
				{
					message: "Minimum 3 and Maximum 63 characters required",
					value: /^.{3,63}$/
				}
			]
		} }
	}), h = !!e, g = {
		id: e,
		clusterName: d.cluster_name
	}, _ = async () => {
		let t = {
			id: e,
			clusterName: d.cluster_name,
			IsVirtualCluster: !0,
			category: nT(d.category).category,
			isProd: d.isProd
		}, i = h ? d_ : u_;
		try {
			c(!0), await i(t), H.showToast({
				variant: U.success,
				description: `Successfully ${h ? "updated" : "saved"}.`
			}), n(), r();
		} catch (e) {
			K(e);
		} finally {
			c(!1);
		}
	}, v = () => {
		u(!0);
	}, y = async () => {
		await m_(g), n(), r();
	}, b = () => {
		u(!1);
	};
	return /* @__PURE__ */ (0, Q.jsxs)("form", {
		onSubmit: m(_),
		className: "flexbox-col flex-grow-1",
		children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox flex-grow-1",
			children: [/* @__PURE__ */ (0, Q.jsx)(yu, {}), /* @__PURE__ */ (0, Q.jsx)("div", {
				className: "p-20 flexbox-col flex-grow-1 dc__overflow-auto bg__secondary",
				children: /* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "flexbox-col dc__gap-16 br-8 bg__primary p-20 border__secondary",
					children: [
						/* @__PURE__ */ (0, Q.jsx)(os, {
							name: Re.clusterNameInputName,
							label: Re.clusterNameInputLabel,
							placeholder: Re.clusterNameInputPlaceholder,
							value: d.cluster_name,
							error: f.cluster_name,
							...p("cluster_name"),
							disabled: h,
							required: !0,
							autoFocus: !0
						}),
						/* @__PURE__ */ (0, Q.jsx)("div", {
							className: "w-250",
							children: /* @__PURE__ */ (0, Q.jsx)(cT, {
								selectedCategory: d.category,
								setSelectedCategory: p("category", { isCustomComponent: !0 }).onChange
							})
						}),
						/* @__PURE__ */ (0, Q.jsxs)("div", {
							className: "flex left dc__gap-24 fs-13",
							children: [/* @__PURE__ */ (0, Q.jsx)("div", {
								className: "dc__required-field cn-7",
								children: "Type of Clusters"
							}), /* @__PURE__ */ (0, Q.jsxs)(vl, {
								name: "isProd",
								className: "radio-group-no-border",
								value: String(d.isProd),
								onChange: p("isProd", { sanitizeFn: (e) => e === "true" }).onChange,
								children: [/* @__PURE__ */ (0, Q.jsx)(yl, {
									value: "true",
									children: "Production"
								}), /* @__PURE__ */ (0, Q.jsx)(yl, {
									value: "false",
									children: "Non - Production"
								})]
							})]
						}),
						/* @__PURE__ */ (0, Q.jsx)(xc, { description: Re.isolatedClusterInfoMessage })
					]
				})
			})]
		}), /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: `dc__border-top flexbox dc__align-items-center py-12 px-20 ${h ? "dc__content-space" : "dc__content-end"}`,
			children: [
				h && /* @__PURE__ */ (0, Q.jsx)(M, {
					dataTestId: "delete-virtual-cluster-button",
					style: P.negative,
					onClick: v,
					variant: F.secondary,
					size: I.large,
					text: Re.deleteButtonLabel
				}),
				/* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "flexbox dc__gap-12",
					children: [/* @__PURE__ */ (0, Q.jsx)(M, {
						dataTestId: "close-virtual-cluster-tab",
						style: P.neutral,
						onClick: r,
						variant: F.secondary,
						size: I.large,
						text: Re.cancelButtonLabel,
						disabled: s
					}), /* @__PURE__ */ (0, Q.jsx)(M, {
						dataTestId: "save-virtual-cluster-button",
						style: P.default,
						buttonProps: { type: "submit" },
						variant: F.primary,
						isLoading: s,
						size: I.large,
						text: h ? "Update cluster" : "Save Cluster"
					})]
				}),
				l && /* @__PURE__ */ (0, Q.jsx)(Ts, {
					title: t,
					component: S.Cluster,
					onDelete: y,
					closeConfirmationModal: b,
					subtitle: ls.DELETE_CLUSTER_SUBTITLES,
					errorCodeToShowCannotDeleteDialog: Us.INTERNAL_SERVER_ERROR
				})
			]
		})]
	});
}, y_ = /* @__PURE__ */ t({ default: () => b_ });
function b_() {
	return /* @__PURE__ */ (0, Q.jsx)("div", {
		className: "fs-11 fw-4",
		children: ve.isolatedEnvironment
	});
}
//#endregion
//#region src/Assets/Icons/ic-clean-brush.svg?react
var x_ = (e) => /* @__PURE__ */ (0, Q.jsx)("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ (0, Q.jsx)("path", {
		d: "M10.4456 7.21004L13.4956 4.7645C13.8018 4.44416 13.9828 4.01911 13.9988 3.58285C14.0149 3.1466 13.8646 2.73488 13.5811 2.43826C13.2976 2.14165 12.9041 1.98444 12.4872 2.00122C12.0702 2.018 11.664 2.20739 11.3578 2.52773L9.02041 5.71886M11.2295 11.609L4.81604 4.89872M3.64023 9.93144L5.2436 8.25386M3.85325 14L2 14M2.66667 12L2 12M7.07047 13.5204L2.11459 8.33521C2.03727 8.25431 1.99615 8.14217 2.00028 8.02344C2.00441 7.90472 2.05345 7.78914 2.13661 7.70214L6.21274 3.43736C6.2959 3.35035 6.40637 3.29905 6.51984 3.29472C6.63331 3.2904 6.7405 3.33342 6.81782 3.41432L12.6483 9.5146C12.7256 9.59549 12.7667 9.70764 12.7626 9.82636C12.7584 9.94508 12.7094 10.0607 12.6262 10.1477L9.49075 13.4283C9.15812 13.7763 8.71626 13.9815 8.26236 13.9988C7.80847 14.0161 7.37973 13.844 7.07047 13.5204Z",
		stroke: "#3B444C",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round",
		vectorEffect: "non-scaling-stroke"
	})
}), S_ = (e) => /* @__PURE__ */ (0, Q.jsx)("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ (0, Q.jsx)("path", {
		d: "M14.2593 7.57363L5.26073 2.07434C5.18494 2.02802 5.09817 2.00273 5.00936 2.00106C4.92055 1.9994 4.8329 2.02143 4.75542 2.06488C4.67795 2.10833 4.61345 2.17163 4.56856 2.24828C4.52366 2.32493 4.5 2.41215 4.5 2.50098V13.4996C4.5 13.5884 4.52366 13.6756 4.56856 13.7523C4.61345 13.8289 4.67795 13.8922 4.75542 13.9357C4.8329 13.9791 4.92055 14.0011 5.00936 13.9995C5.09817 13.9978 5.18494 13.9725 5.26073 13.9262L14.2593 8.4269C14.3324 8.38224 14.3927 8.31955 14.4346 8.24484C14.4765 8.17014 14.4985 8.08592 14.4985 8.00027C14.4985 7.91461 14.4765 7.8304 14.4346 7.75569C14.3927 7.68098 14.3324 7.61829 14.2593 7.57363Z",
		stroke: "#3B444C",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round",
		vectorEffect: "non-scaling-stroke"
	})
}), C_ = ({ bulkActionsData: { showNodeListingOptions: e, showBulkRestartOption: t, isResourceRecommendationView: n }, onActionClick: r }) => /* @__PURE__ */ (0, Q.jsx)("div", {
	className: "flexbox dc__gap-4",
	children: n ? /* @__PURE__ */ (0, Q.jsx)(M, {
		dataTestId: "open-resource-recommendation-modal",
		size: I.small,
		text: "Apply Changes",
		"data-key": "applyResourceRecommendation",
		endIcon: /* @__PURE__ */ (0, Q.jsx)(z, {
			name: "ic-caret-right",
			color: null
		}),
		onClick: r
	}) : /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [
		e && /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [
			/* @__PURE__ */ (0, Q.jsx)(M, {
				icon: /* @__PURE__ */ (0, Q.jsx)(Mr, {}),
				dataTestId: "rb-bulk-action__action-widget--cordon",
				component: N.button,
				style: P.negativeGrey,
				variant: F.borderLess,
				ariaLabel: "Cordon node(s)",
				size: I.small,
				"data-key": "cordon",
				onClick: r,
				showAriaLabelInTippy: !0
			}),
			/* @__PURE__ */ (0, Q.jsx)(M, {
				icon: /* @__PURE__ */ (0, Q.jsx)(S_, {}),
				dataTestId: "rb-bulk-action__action-widget--uncordon",
				component: N.button,
				style: P.neutral,
				variant: F.borderLess,
				ariaLabel: "Uncordon node(s)",
				"data-key": "uncordon",
				size: I.small,
				onClick: r,
				showAriaLabelInTippy: !0
			}),
			/* @__PURE__ */ (0, Q.jsx)(M, {
				icon: /* @__PURE__ */ (0, Q.jsx)(x_, {}),
				dataTestId: "rb-bulk-action__action-widget--drain",
				component: N.button,
				style: P.negativeGrey,
				variant: F.borderLess,
				ariaLabel: "Drain node(s)",
				"data-key": "drain",
				size: I.small,
				onClick: r,
				showAriaLabelInTippy: !0
			})
		] }),
		t && /* @__PURE__ */ (0, Q.jsx)(M, {
			icon: /* @__PURE__ */ (0, Q.jsx)(z, {
				name: "ic-arrows-clockwise",
				color: null
			}),
			dataTestId: "rb-bulk-action__action-widget--restart",
			component: N.button,
			style: P.neutral,
			variant: F.borderLess,
			ariaLabel: "Restart workload(s)",
			"data-key": "restart",
			size: I.small,
			onClick: r,
			showAriaLabelInTippy: !0
		}),
		/* @__PURE__ */ (0, Q.jsx)(M, {
			icon: /* @__PURE__ */ (0, Q.jsx)(Be, {}),
			dataTestId: "rb-bulk-action__action-widget--delete",
			component: N.button,
			style: P.negativeGrey,
			variant: F.borderLess,
			ariaLabel: `Delete ${e ? "node" : "resource"}(s)`,
			"data-key": "delete",
			size: I.small,
			onClick: r,
			showAriaLabelInTippy: !0
		})
	] })
}), w_ = {
	[Ol.API_VERSION]: "API Version",
	[Ol.CONTAINER_NAME]: "Container Name",
	[Ol.CPU_LIMIT]: "CPU Limits",
	[Ol.CPU_REQUEST]: "CPU Requests",
	[Ol.KIND]: "Kind",
	[Ol.MEMORY_LIMIT]: "Mem Limits",
	[Ol.MEMORY_REQUEST]: "Mem Requests",
	[Ol.NAME]: "Workload",
	[Ol.NAMESPACE]: "Namespace"
}, T_ = {
	[Ol.API_VERSION]: 180,
	[Ol.CONTAINER_NAME]: 150,
	[Ol.CPU_LIMIT]: 150,
	[Ol.CPU_REQUEST]: 150,
	[Ol.KIND]: 150,
	[Ol.MEMORY_LIMIT]: 150,
	[Ol.MEMORY_REQUEST]: 150,
	[Ol.NAME]: 314,
	[Ol.NAMESPACE]: 150
}, E_ = [
	{
		label: "Container Name",
		key: Ol.CONTAINER_NAME
	},
	{
		label: "Workload Name",
		key: Ol.NAME
	},
	{
		label: "Kind",
		key: Ol.KIND
	},
	{
		label: "Namespace",
		key: Ol.NAMESPACE
	},
	{
		label: "Current → Recommended CPU (Req)",
		key: Ol.CPU_REQUEST
	},
	{
		label: "Current → Recommended CPU (Lim)",
		key: Ol.CPU_LIMIT
	},
	{
		label: "Current → Recommended memory (Req)",
		key: Ol.MEMORY_REQUEST
	},
	{
		label: "Current → Recommended memory (Lim)",
		key: Ol.MEMORY_LIMIT
	}
], D_ = (e, t) => ({
	id: t,
	name: "Resource Recommender",
	title: "Resource Recommendation",
	url: e,
	isSelected: !1,
	type: "fixed",
	showNameOnSelect: !0,
	isAlive: !1,
	defaultUrl: e
}), O_ = ({ clusterId: e, apiVersion: t, kind: n, namespace: r }) => {
	let { group: i, version: a } = od(t), o = !!(t && n);
	return {
		clusterId: e,
		...o || r ? { k8sRequest: { resourceIdentifier: {
			...o ? { groupVersionKind: {
				Group: i,
				Version: a,
				Kind: n
			} } : {},
			...r ? { namespace: r } : {}
		} } } : {}
	};
}, k_ = (e) => {
	let t = (e.headers || []).filter((e) => !!e), { data: n } = e;
	return { resourceList: {
		headers: t,
		data: (n || []).filter((e) => e.kind && e.apiVersion && e.namespace && e.containerName && e.name).map((e) => {
			let t = {
				cpuLimit: null,
				cpuRequest: null,
				memoryLimit: null,
				memoryRequest: null
			}, n = { id: `${e.name}-${e.apiVersion}-${e.kind}-${e.namespace}-${e.containerName}` };
			return Object.keys(e).forEach((r) => {
				if (r in t) {
					n[r] = e[r].delta, t[r] = e[r];
					return;
				}
				n[r] = e[r] || "";
			}), n.additionalMetadata = t, n;
		})
	} };
}, A_ = (e) => e ? e === "none" ? "None" : e : "NA", j_ = (e) => (e || []).map((e) => E_.reduce((t, { key: n }) => {
	let r = e?.additionalMetadata?.[n];
	return t[n] = r ? `${A_(r.current?.value)} -> ${A_(r.recommended?.value)} ${r.delta ? `(${r.delta})%` : ""}` : e?.[n] || "", t;
}, {})), M_ = ({ delta: e, recommended: t, current: n, isTooltipView: r = !1 }) => {
	let i = t?.value, a = n?.value, o = !i || i === "none", s = !a || a === "none";
	return e === 0 || s && o ? {
		class: "cn-3",
		badgeProps: {
			variant: "custom",
			bgColor: "N100",
			fontColor: "N700"
		},
		iconProps: {
			color: r ? "N300" : "N700",
			name: "ic-minus"
		}
	} : e > 0 || !o && s ? {
		class: "cr-5",
		badgeProps: { variant: "negative" },
		iconProps: {
			color: r ? "R500" : "R700",
			name: "ic-arrow-right",
			rotateBy: 270
		}
	} : {
		class: "cg-5",
		badgeProps: { variant: "positive" },
		iconProps: {
			color: r ? "G500" : "G700",
			name: "ic-arrow-right",
			rotateBy: 90
		}
	};
}, N_ = (e) => {
	let t = (e || []).map((e) => ({
		kind: e.Kind,
		apiVersion: e.Group ? `${e.Group}/${e.Version}` : e.Version
	})), n = {};
	return t.forEach(({ apiVersion: e, kind: t }) => {
		n[e] || (n[e] = []), n[e].push({
			kind: t,
			apiVersion: e
		});
	}), [{ options: [{
		label: "All Kinds",
		value: null
	}] }, ...Object.keys(n).sort(df).map((e) => ({
		label: e,
		options: n[e].map((e) => ({
			label: e.kind,
			value: {
				apiVersion: e.apiVersion,
				kind: e.kind
			}
		})).sort((e, t) => df(e.label, t.label))
	}))];
}, P_ = (e) => ({
	...e.has(ac) ? { selectedKindGVKFilter: e.get(ac) } : {},
	...e.has(ic) ? { selectedAPIVersionGVKFilter: e.get(ic) } : {},
	...e.has("namespace") ? { selectedNamespace: e.get("namespace") } : {}
}), F_ = (e, t) => !t.searchKey || Object.entries(e.data).some(([e, n]) => e !== "id" && n != null && String(n).toLowerCase().includes(t.searchKey.toLowerCase())), I_ = async ({ clusterId: e, namespace: t, apiVersion: n, kind: r, resourceListAbortControllerRef: i }) => {
	try {
		let { result: a } = await nf(O.K8S_RESOURCE_RECOMMENDATION_LIST, O_({
			clusterId: e,
			apiVersion: n,
			kind: r,
			namespace: t
		}), { abortControllerRef: i });
		return k_(a);
	} catch (e) {
		throw pd(e) || K(e), e;
	}
}, L_ = async (e) => {
	let { result: t } = await G(`${O.K8S_RESOURCE}/${e}/${O.RECOMMENDATION_DETAILS}`);
	return {
		lastScannedOn: t.lastScannedOn || "",
		gvkList: N_(t.supportedGVKs)
	};
}, R_ = async (e, t, n) => {
	try {
		return (await fo(e.map((e) => () => Un({
			name: e.name,
			namespace: e.namespace,
			clusterId: t,
			gvk: {
				Group: od(e.apiVersion).group,
				Version: od(e.apiVersion).version,
				Kind: e.kind
			},
			isResourceRecommender: !0,
			abortControllerRef: n
		})))).reduce((t, n, r) => {
			let i = e[r];
			if (n.status === dl.FULFILLED) {
				let e = n.value?.manifestResponse;
				return t[i.id] = {
					currentManifest: e?.manifest ? Tu(e.manifest) : null,
					recommendedManifest: e?.recommendedManifest ? Tu(e.recommendedManifest) : null
				}, t;
			}
			return t[i.id] = null, t;
		}, {});
	} catch (e) {
		throw K(e), e;
	}
}, z_ = async (e) => {
	try {
		await nf(O.K8S_RESOURCE_RECOMMENDATION_SYNC, { clusterId: e }), H.showToast({
			variant: U.success,
			title: "Checking again",
			description: "Hang tight! We’re looking for the latest data to generate recommendations."
		});
	} catch (e) {
		K(e);
	}
}, B_ = ({ handleClose: e, clusterId: t, resourceList: n, handleReloadDataAfterBulkOperation: r }) => {
	let i = Ja(new AbortController()), [a, o, s, c] = hf(() => R_(n, t, i)), [l, u] = j({}), [d, f] = j(null), [p, m] = j(!1), h = (e) => {
		f(e);
	}, g = (e) => {
		u((t) => ({
			...t,
			[e]: !t[e]
		}));
	}, _ = A(() => {
		let e = n.reduce((e, t) => {
			let n = `${t.apiVersion}/${t.kind}`;
			return e[n] || (e[n] = []), e[n].push(t), e;
		}, {}), t = Object.keys(e).sort(df);
		return Object.keys(e).forEach((t) => {
			e[t].sort((e, t) => df(e.name, t.name));
		}), t.map((t, n) => ({
			header: t,
			id: t,
			isExpanded: !l[t],
			items: e[t].map((e, t) => ({
				title: e.name,
				id: e.id,
				isActive: d === e.id || n === 0 && t === 0 && !d,
				onClick: () => h(e.id),
				iconConfig: !a && !o?.[e.id]?.recommendedManifest ? {
					Icon: Et,
					props: { className: "icon-dim-16 alert-icon-r5-imp dc__no-svg-stroke mt-2" }
				} : null
			}))
		}));
	}, [
		l,
		d,
		a,
		o
	]), v = A(() => n.reduce((e, t) => (e[t.id] = t, e), {}), []), y = A(() => o ? n.filter((e) => !!o[e.id]?.recommendedManifest).map((e) => ({
		name: e.name,
		additionalKeys: [{
			label: "Kind",
			value: e.kind,
			isSortable: !0,
			width: "150px"
		}],
		operation: (n) => wn({
			name: e.name,
			namespace: e.namespace,
			clusterId: t,
			gvk: {
				Group: od(e.apiVersion).group,
				Version: od(e.apiVersion).version,
				Kind: e.kind
			},
			manifest: o[e.id].recommendedManifest
		}, n)
	})) : [], [o]), b = () => {
		if (y.length === 0) {
			H.showToast({
				variant: U.error,
				description: "No resource recommendations available to apply."
			});
			return;
		}
		m(!0);
	}, x = d || _[0].items[0].id, S = o?.[x];
	return k(() => () => {
		i.current.abort();
	}, []), p ? /* @__PURE__ */ (0, Q.jsx)(Oo, {
		data: null,
		operations: y,
		textConfig: {
			prompt: ds,
			resultsHeader: "Apply resource recommendation changes"
		},
		shouldSkipConfirmation: !0,
		handleModalClose: e,
		handleReloadDataAfterBulkOperation: r,
		getResultsChartSummaryText: (e) => {
			let { Pending: t, Progressing: n, Completed: r } = e;
			return t || n ? /* @__PURE__ */ (0, Q.jsx)("span", {
				className: "cn-8 fs-12 fw-4 lh-20",
				children: "Applying recommended changes"
			}) : `${r} resource(s) recommendation changes applied`;
		},
		disableTransition: !0
	}) : /* @__PURE__ */ (0, Q.jsx)(Rs, {
		position: "right",
		width: "1024px",
		onEscape: e,
		onClose: e,
		children: /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox-col dc__content-space h-100 bg__modal--primary shadow__modal dc__overflow-auto",
			onClick: uf,
			children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox-col dc__overflow-auto flex-grow-1",
				children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "px-20 py-12 flexbox dc__content-space dc__align-items-center border__primary--bottom",
					children: [/* @__PURE__ */ (0, Q.jsx)("h2", {
						className: "m-0 fs-16 fw-6 lh-24 cn-9",
						children: "Apply resource recommendation changes"
					}), /* @__PURE__ */ (0, Q.jsx)(M, {
						dataTestId: "header-close-button",
						ariaLabel: "Close",
						showAriaLabelInTippy: !1,
						onClick: e,
						variant: F.borderLess,
						style: P.negativeGrey,
						icon: /* @__PURE__ */ (0, Q.jsx)(z, {
							name: "ic-close-large",
							color: null
						}),
						size: I.xs
					})]
				}), /* @__PURE__ */ (0, Q.jsx)("div", {
					className: "flexbox flex-grow-1 dc__overflow-auto w-100",
					children: s ? /* @__PURE__ */ (0, Q.jsx)(Ks, {
						code: s.code,
						reload: c
					}) : /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [n.length > 1 && /* @__PURE__ */ (0, Q.jsx)("div", {
						className: "flexbox-col dc__overflow-auto dc__no-shrink w-250 p-8 border__primary--right",
						children: /* @__PURE__ */ (0, Q.jsx)(Qo, {
							config: _,
							tabType: "button",
							onCollapseBtnClick: g
						})
					}), /* @__PURE__ */ (0, Q.jsxs)("div", {
						className: "flexbox-col dc__overflow-auto flex-grow-1",
						children: [/* @__PURE__ */ (0, Q.jsx)("h3", {
							className: "m-0 px-16 py-8 cn-9 fs-13 fw-6 lh-1-5 flexbox dc__gap-4",
							children: v[x] ? /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [
								v[x].kind,
								"\xA0",
								/* @__PURE__ */ (0, Q.jsx)("span", {
									className: "cn-6 fs-13 fw-4 lh-1-5",
									children: "/"
								}),
								v[x].name,
								"\xA0",
								/* @__PURE__ */ (0, Q.jsx)("span", {
									className: "cn-6 fs-13 fw-4 lh-1-5",
									children: "/"
								}),
								/* @__PURE__ */ (0, Q.jsxs)("span", {
									className: "px-6 py-2 bcb-1 br-4 dc__gap-4 dc__align-items-center flexbox dc__mxw-200",
									children: [/* @__PURE__ */ (0, Q.jsx)(z, {
										name: "ic-container",
										color: "B700",
										size: 14
									}), /* @__PURE__ */ (0, Q.jsx)(W, {
										content: `${v[x].containerName}`,
										children: /* @__PURE__ */ (0, Q.jsx)("span", {
											className: "dc__truncate cb-7 fs-12 fw-5 lh-16",
											children: `${v[x].containerName}`
										})
									})]
								})
							] }) : "Resource Details"
						}), a ? n.length === 1 ? /* @__PURE__ */ (0, Q.jsx)("div", {
							className: "flex w-100 h-100 flex-grow-1",
							children: /* @__PURE__ */ (0, Q.jsx)(ul, { pageLoader: !0 })
						}) : /* @__PURE__ */ (0, Q.jsx)(R, {
							classname: "dc__text-center",
							title: "Fetching recommendations",
							subTitle: "Fetching resource recommendation for the selected resources",
							SvgImage: vm,
							imageType: yc.Large
						}) : S ? S.recommendedManifest ? /* @__PURE__ */ (0, Q.jsx)("div", {
							className: "flexbox-col dc__overflow-auto flex-grow-1",
							children: /* @__PURE__ */ (0, Q.jsx)(Xo, {
								mode: Ic.YAML,
								noParsing: !0,
								diffView: !0,
								readOnly: !0,
								originalValue: S.currentManifest || "",
								modifiedValue: S.recommendedManifest,
								height: "fitToParent",
								collapseUnchangedDiffView: !0,
								children: /* @__PURE__ */ (0, Q.jsxs)(Xo.Header, {
									hideDefaultSplitHeader: !0,
									children: [/* @__PURE__ */ (0, Q.jsx)("h4", {
										className: "m-0 cn-9 fs-12 fw-6 lh-20 px-16",
										children: "Current"
									}), /* @__PURE__ */ (0, Q.jsx)("h4", {
										className: "m-0 cn-9 fs-12 fw-6 lh-20 px-16",
										children: "Recommended"
									})]
								})
							})
						}) : /* @__PURE__ */ (0, Q.jsx)(R, {
							title: "No resource recommendation available",
							subTitle: "There is no resource recommendation available for the selected resource."
						}) : /* @__PURE__ */ (0, Q.jsx)(R, {
							title: "Manifest details not available",
							subTitle: "Please try again later or contact support if the issue persists."
						})]
					})] })
				})]
			}), /* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox dc__content-end dc__gap-12 py-16 px-20 border__primary--top dc__no-shrink",
				children: [/* @__PURE__ */ (0, Q.jsx)(M, {
					dataTestId: "footer-cancel-button",
					variant: F.secondary,
					text: "Cancel",
					style: P.neutral,
					size: I.large,
					onClick: e
				}), /* @__PURE__ */ (0, Q.jsx)(M, {
					dataTestId: "footer-apply-button",
					variant: F.primary,
					size: I.large,
					disabled: !o,
					text: "Apply Changes",
					onClick: b
				})]
			})]
		})
	});
}, V_ = async ({ resource: e, getManifestResource: t, updateManifestResourceHelmApps: n, abortControllerRef: r }) => {
	let { result: { manifestResponse: { manifest: i } } } = await t(null, "", "", !0, e, r.current.signal);
	if (!i) return;
	let a = "/spec/template/metadata", o = `${a}/annotations`, s = "devtron/restart", c = {
		json: i,
		wrap: !1,
		resultType: "value"
	}, l = (/* @__PURE__ */ new Date()).toISOString();
	hr({
		path: Mu(a),
		...c
	}) ? hr({
		path: Mu(o),
		...c
	}) ? Ma(i, {
		op: "add",
		path: `${o}/${Pa(s)}t`,
		value: l
	}, !1, !0) : Ma(i, {
		op: "add",
		path: o,
		value: { [s]: l }
	}, !1, !0) : Ma(i, {
		op: "add",
		path: a,
		value: { annotations: { [s]: l } }
	}, !1, !0), await n(null, "", "", JSON.stringify(i), !0, e, r.current.signal);
}, H_ = ({ selection: e, operationType: t, clusterId: n }) => async (r) => {
	await Pu({
		kind: e.kind,
		name: e.name,
		version: e.version,
		clusterId: n,
		nodeCordonOptions: { unschedulableDesired: t === "cordon" }
	}, r);
}, U_ = ({ selection: e, clusterId: t }) => async (n, r) => {
	await Bu({
		kind: e.kind,
		name: e.name,
		version: e.version,
		clusterId: t,
		nodeDrainOptions: r
	}, n);
}, W_ = ({ selection: e, selectedResource: t, clusterId: n, getManifestResource: r, updateManifestResourceHelmApps: i }) => async (a) => {
	await V_({
		resource: {
			clusterId: n,
			group: t.gvk.Group,
			kind: t.gvk.Kind,
			version: t.gvk.Version,
			namespace: e.namespace,
			containers: [],
			name: e.name
		},
		getManifestResource: r,
		updateManifestResourceHelmApps: i,
		abortControllerRef: a
	});
}, G_ = ({ selection: e, clusterId: t }) => async (n) => {
	await Ru({
		clusterId: Number(t),
		name: String(e.name),
		version: String(e.version),
		kind: String(e.kind)
	}, n);
}, K_ = ({ selection: e, clusterId: t, selectedResource: n }) => async (r, i) => {
	await zu({
		clusterId: Number(t),
		k8sRequest: {
			resourceIdentifier: {
				groupVersionKind: n.gvk,
				namespace: String(e.namespace),
				name: String(e.name)
			},
			forceDelete: i
		}
	}, r);
}, q_ = (e) => /* @__PURE__ */ (0, Q.jsxs)("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 48,
	height: 48,
	viewBox: "0 0 48 48",
	fill: "none",
	...e,
	children: [/* @__PURE__ */ (0, Q.jsx)("circle", {
		cx: 24,
		cy: 24,
		r: 20,
		fill: "#0066CC",
		fillOpacity: .3,
		stroke: "#0066CC",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ (0, Q.jsx)("path", {
		d: "M29.0087 21.2096H34M34 21.2096V16.2183M34 21.2096L30.4706 17.6802C29.6208 16.8305 28.6121 16.1564 27.5018 15.6966C26.3916 15.2367 25.2017 15 24 15C22.7983 15 21.6084 15.2367 20.4982 15.6966C19.3879 16.1564 18.3792 16.8305 17.5294 17.6802M18.9913 27.0919H14M14 27.0919V32.0832M14 27.0919L17.5294 30.6213C18.3792 31.471 19.3879 32.1451 20.4982 32.6049C21.6084 33.0648 22.7983 33.3015 24 33.3015C25.2017 33.3015 26.3916 33.0648 27.5018 32.6049C28.6121 32.1451 29.6208 31.471 30.4706 30.6213",
		stroke: "#0066CC",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
}), J_ = (e) => {
	switch (e) {
		case "delete": return "deleted";
		case "restart": return "restarted";
		case "cordon": return "cordoned";
		case "uncordon": return "uncordoned";
		case "drain": return "drained";
		default: return Xd(`Unknown operation type ${e} en-countered`), e;
	}
}, Y_ = (e) => {
	switch (e) {
		case "delete": return "Deleting";
		case "restart": return "Restarting";
		case "cordon": return "Cordoning";
		case "uncordon": return "Uncordoning";
		default: return "In progress";
	}
}, X_ = (e, t) => (n) => {
	let { Pending: r, Progressing: i, Completed: a } = n;
	return r || i ? /* @__PURE__ */ (0, Q.jsx)("span", {
		className: "dc__loading-dots",
		children: Y_(e)
	}) : `${a} ${t}(s) ${J_(e)}`;
}, Z_ = (e, t) => {
	if (e === "delete" && t.toLowerCase() === "node") return ps.subtitle;
	switch (e) {
		case "cordon": return Vo.cordonInfoText;
		case "uncordon": return Vo.uncordonInfoText;
		case "drain": return vs.Actions.infoText;
		default: return `Selected ${t}(s) will be ${J_(e)}. Are you sure?`;
	}
}, Q_ = ({ numberOfOperations: e, selectedResource: t, action: n, clusterName: r, isNodeListing: i, renderAdditionalOptionsForConfirmationModal: a }) => {
	let o = t.gvk.Kind, s = Au(n), c = {
		title: `${s} ${e} ${o}(s) of cluster ‘${r}’`,
		subtitle: Z_(n, o),
		buttonConfig: {
			primaryButtonConfig: { text: s },
			secondaryButtonConfig: { text: "Cancel" }
		},
		confirmationConfig: {
			identifier: `${n}-confirmation`,
			confirmationKeyword: r
		}
	}, { CordonIcon: l, UncordonIcon: u } = Vo, { DrainIcon: d } = vs;
	switch (n) {
		case "delete": return {
			variant: rs.delete,
			...c,
			...i ? {} : {
				children: a(nc),
				buttonConfig: {
					...c.buttonConfig,
					primaryButtonConfig: { ...c.buttonConfig.primaryButtonConfig }
				}
			}
		};
		case "restart": return {
			variant: rs.custom,
			Icon: /* @__PURE__ */ (0, Q.jsx)(q_, {}),
			...c
		};
		case "cordon": return {
			...c,
			variant: rs.custom,
			Icon: /* @__PURE__ */ (0, Q.jsx)(l, {}),
			buttonConfig: {
				...c.buttonConfig,
				primaryButtonConfig: {
					...c.buttonConfig.primaryButtonConfig,
					style: P.negative
				}
			}
		};
		case "uncordon": return {
			variant: rs.custom,
			Icon: /* @__PURE__ */ (0, Q.jsx)(u, {}),
			...c
		};
		case "drain": return {
			variant: rs.custom,
			Icon: /* @__PURE__ */ (0, Q.jsx)(d, { className: "scr-5" }),
			children: a(Gc),
			...c,
			buttonConfig: {
				...c.buttonConfig,
				primaryButtonConfig: {
					...c.buttonConfig.primaryButtonConfig,
					style: P.negative
				}
			}
		};
		default: throw Error(`Unknown operation type ${n} found`);
	}
}, $_ = ({ action: e, bulkOperationModalData: { selectedResource: t, clusterId: n, clusterName: r, isNodeListing: i, handleReloadDataAfterBulkOperation: a, getManifestResource: o, updateManifestResourceHelmApps: s }, selections: c, onClose: l }) => {
	let [u, d] = j(null), f = X(), p = Yf(), { isBulkSelectionApplied: m, selectedIdentifiers: h, handleBulkSelection: g } = _f(), _ = () => (m ? c : Object.values(h)) ?? [], v = A(() => {
		let r = _().map(({ data: e }) => e);
		return e === "cordon" || e === "uncordon" ? r.map((t) => ({
			name: t.name,
			operation: H_({
				selection: t,
				operationType: e,
				clusterId: n
			})
		})) : e === "drain" ? r.map((e) => ({
			name: e.name,
			operation: U_({
				selection: e,
				clusterId: n
			})
		})) : e === "restart" ? r.map((e) => ({
			name: e.name,
			operation: W_({
				clusterId: n,
				getManifestResource: o,
				updateManifestResourceHelmApps: s,
				selectedResource: t,
				selection: e
			})
		})) : r.map((e) => ({
			name: e.name,
			operation: i ? G_({
				selection: e,
				clusterId: n
			}) : K_({
				clusterId: n,
				selectedResource: t,
				selection: e
			})
		}));
	}, [
		i,
		m,
		c,
		h,
		n,
		t
	]), y = (e) => /* @__PURE__ */ (0, Q.jsx)(e, {
		optionsData: u,
		setOptionsData: d
	}), b = () => {
		g({ action: Ao.CLEAR_ALL_SELECTIONS });
		let e = new URLSearchParams(p.search);
		e.delete(hu.PAGE_NUMBER), f(`${p.pathname}?${e.toString()}`, { replace: !0 }), a();
	};
	return e === "applyResourceRecommendation" ? /* @__PURE__ */ (0, Q.jsx)(B_, {
		resourceList: _().map(({ data: e }) => e),
		clusterId: n,
		handleClose: l,
		handleReloadDataAfterBulkOperation: b
	}) : /* @__PURE__ */ (0, Q.jsx)(Oo, {
		data: u,
		operations: v,
		textConfig: {
			prompt: ds,
			resultsHeader: `${e} ${t.gvk.Kind} status`
		},
		confirmationModalConfig: Q_({
			numberOfOperations: v.length,
			renderAdditionalOptionsForConfirmationModal: y,
			clusterName: r,
			isNodeListing: i,
			action: e,
			selectedResource: t
		}),
		handleModalClose: l,
		handleReloadDataAfterBulkOperation: b,
		getResultsChartSummaryText: X_(e, t.gvk.Kind)
	});
}, ev = {
	Group: "crd.devtron.ai",
	Kind: "GuiSchema",
	Version: kl.alpha1
}, tv = {
	Group: "crd.devtron.ai",
	Kind: "LockSchema",
	Version: kl.alpha1
}, nv = "drag-selector", rv = {
	BulkSelectionWidgetClicked: {
		category: "Resource Browser",
		action: "RESOURCE_BROWSER_GET_KUBECONFIG_BULK_CLICKED"
	},
	IndividualKubeConfig: {
		category: "Resource Browser",
		action: "RESOURCE_BROWSER_GET_KUBECONFIG_INDIVIDUAL_CLICKED"
	},
	CopyButton: {
		category: "Resource Browser",
		action: "RESOURCE_BROWSER_GET_KUBECONFIG_COPYCOMMAND_CLICKED"
	},
	ReachableClusterToggleEnabled: {
		category: "Resource Browser",
		action: "RESOURCE_BROWSER_GET_KUBECONFIG_BULK_REACHABLE_CLUSTERS_ENABLED"
	},
	ReachableClusterToggleDisabled: {
		category: "Resource Browser",
		action: "RESOURCE_BROWSER_GET_KUBECONFIG_BULK_REACHABLE_CLUSTERS_DISABLED"
	},
	DoNotSetContextSelect: {
		category: "Resource Browser",
		action: "RESOURCE_BROWSER_GET_KUBECONFIG_BULK_SETCONTEXT_OPTION_DONOTSET_CHANGED"
	},
	SetContextSelect: {
		category: "Resource Browser",
		action: "RESOURCE_BROWSER_GET_KUBECONFIG_BULK_SETCONTEXT_OPTION_SELECTED_CLUSTER_CHANGED"
	}
}, iv = {
	label: "Do not set context",
	value: ""
}, av = ({ onChangeShowKubeConfigModal: e, isBulkWidgetButton: t = !1, setSelectedClusterName: n, clusterName: r }) => {
	let i = () => {
		e(), n?.(r), Mn.event(t ? rv.BulkSelectionWidgetClicked : rv.IndividualKubeConfig);
	};
	return t ? /* @__PURE__ */ (0, Q.jsx)(M, {
		text: "Get kubeconfig",
		dataTestId: "rb-cluster-bulk-selection-kube-config",
		onClick: i,
		size: I.medium
	}) : /* @__PURE__ */ (0, Q.jsx)(M, {
		icon: /* @__PURE__ */ (0, Q.jsx)(z, {
			name: "ic-file-key",
			color: null
		}),
		onClick: i,
		dataTestId: "rb-cluster-bulk-selection-kube-config",
		variant: F.borderLess,
		ariaLabel: "Get kubeconfig",
		size: I.xs,
		style: P.neutral
	});
}, ov = ({ clusterData: e }) => {
	let { selectedIdentifiers: t, handleBulkSelection: n, getSelectedIdentifiersCount: r } = _f(), i = r(), a = !!t[e.name];
	return /* @__PURE__ */ (0, Q.jsx)("div", {
		className: a || i > 0 ? "dc__visible" : "dc__visible-hover--child flex left",
		children: /* @__PURE__ */ (0, Q.jsx)(Wo, {
			disabled: !e.id,
			isChecked: a,
			onChange: () => {
				let { name: r } = e;
				t[r] ? n({
					action: Ao.CLEAR_IDENTIFIERS,
					data: { identifierIds: [r] }
				}) : n({
					action: Ao.SELECT_IDENTIFIER,
					data: { identifierObject: {
						...t,
						[r]: e
					} }
				});
			},
			rootClassName: "icon-dim-20 m-0",
			dataTestId: `activate-${e.name}`,
			value: Io.CHECKED
		})
	});
}, sv = (e) => [iv, {
	label: "Set Context of",
	options: (e || []).map((e) => ({
		label: e,
		value: e
	}))
}], cv = (e) => `kubectl config use-context devtron-${e}`, lv = (e) => {
	let t = ed(tu);
	return `kubectl config set-cluster devtron-${e} --server=https://${window.location.host}/orchestrator/k8s/proxy/cluster/${e} --insecure-skip-tls-verify
kubectl config set-credentials devtron-${e} --token=${t}
kubectl config set-context devtron-${e} --cluster=devtron-${e} --user=devtron-${e}`;
}, uv = (e, t) => {
	let n = Array.isArray(e) ? e : [e], r = n.map(lv), i = n.length === 1 ? n[0] : void 0, a = t || i;
	return [r.join("\n"), a ? cv(i || t) : ""].filter(Boolean).join("\n");
}, dv = ({ clusterName: e = "", handleModalClose: t, isSingleClusterButton: n = !1, isClusterDetailListLoading: r, identifierMap: i }) => {
	let [a, o] = j(iv), [s, c] = j(!1), [l, u] = j(null), { selectedIdentifiers: d } = _f(), f = Object.keys(d) || [], p = Object.keys(d || {}).filter((e) => {
		let t = i[e];
		return t && t.status !== Yo.CONNECTION_FAILED;
	}), m = A(() => e ? uv(e, a.value || e) : uv(s ? p : f, a.value), [
		s,
		p,
		f,
		a.value,
		e
	]);
	return /* @__PURE__ */ (0, Q.jsx)(xu, {
		className: "visible-modal__body",
		onEscape: t,
		children: /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox-col dc__border dc__m-auto mt-40 br-8 bg__primary w-600 cn-9",
			children: [
				/* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "flexbox dc__gap-10 dc__align-items-center dc__border-bottom-n1 p-12 dc__content-space px-20 py-16",
					children: [/* @__PURE__ */ (0, Q.jsx)("span", {
						className: "fs-16 fw-6 lh-20 cn-9",
						children: "Get kubeconfig"
					}), /* @__PURE__ */ (0, Q.jsx)(M, {
						variant: F.borderLess,
						ariaLabel: "Close",
						showAriaLabelInTippy: !1,
						onClick: t,
						icon: /* @__PURE__ */ (0, Q.jsx)(z, {
							name: "ic-close-large",
							color: null
						}),
						dataTestId: "close-kubeconfig-modal",
						size: I.xs,
						style: P.negativeGrey
					})]
				}),
				/* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "flexbox-col dc__gap-12 p-20",
					children: [f.length > 1 && !n && /* @__PURE__ */ (0, Q.jsxs)("div", {
						className: "flexbox-col border__secondary bw-1 px-16 py-12 fs-13 br-8 dc__gap-12",
						children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
							className: "flex dc__gap-16 dc__content-space top",
							children: [/* @__PURE__ */ (0, Q.jsxs)("p", {
								className: "m-0",
								children: [/* @__PURE__ */ (0, Q.jsx)("div", {
									className: "lh-20",
									children: "Get access for reachable clusters only"
								}), /* @__PURE__ */ (0, Q.jsx)("div", {
									className: "fs-12 lh-18 cn-7",
									children: r ? "Checking cluster status…" : `${p.length}/${f.length} selected clusters are
                            reachable`
								})]
							}), /* @__PURE__ */ (0, Q.jsx)(bs, {
								name: "toggle-selective-cluster",
								ariaLabel: "Toggle access reachable clusters",
								isChecked: s,
								onChange: () => {
									c(!s), s ? Mn.event(rv.ReachableClusterToggleDisabled) : (o(p.includes(a.value) ? a : iv), Mn.event(rv.ReachableClusterToggleEnabled));
								},
								isLoading: r
							})]
						}), (p.length > 1 || !s) && /* @__PURE__ */ (0, Q.jsxs)("div", {
							className: "flex dc__gap-16 dc__content-space border__secondary--top pt-12",
							children: [/* @__PURE__ */ (0, Q.jsx)("span", {
								className: "lh-20",
								children: "Set current cluster context"
							}), /* @__PURE__ */ (0, Q.jsx)(V, {
								inputId: "cluster-kube-config",
								options: sv(s ? p : f),
								size: I.medium,
								onChange: (e) => {
									o(e), Mn.event(e.value === iv.value ? rv.DoNotSetContextSelect : rv.SetContextSelect);
								},
								value: a
							})]
						})]
					}), !p.length && s ? /* @__PURE__ */ (0, Q.jsxs)("div", {
						className: "flex column dc__gap-12 dc__align-items-center p-20 mh-170 border__secondary--top pt-12",
						children: [/* @__PURE__ */ (0, Q.jsx)(z, {
							name: "ic-info-outline",
							size: 24,
							color: null
						}), /* @__PURE__ */ (0, Q.jsx)("div", {
							className: "flex fs-13 lh-20 dc__mxw-250 dc__text-center",
							children: "None of the selected clusters are reachable."
						})]
					}) : /* @__PURE__ */ (0, Q.jsxs)("ol", {
						className: `steps-with-trail--normal ${f.length > 1 ? "border__secondary--top pt-12" : ""} px-0`,
						children: [/* @__PURE__ */ (0, Q.jsx)("li", { children: /* @__PURE__ */ (0, Q.jsxs)("span", {
							className: "fs-13 lh-20",
							children: [
								/* @__PURE__ */ (0, Q.jsx)("b", {
									className: "fw-6",
									children: "Prerequisites:"
								}),
								"\xA0",
								/* @__PURE__ */ (0, Q.jsx)("a", {
									href: "https://kubernetes.io/docs/reference/kubectl/",
									target: "_blank",
									rel: "noreferrer noopener",
									className: "dc__underline dc__link-n9",
									children: "kubectl"
								}),
								"\xA0must be installed"
							]
						}) }), /* @__PURE__ */ (0, Q.jsx)("li", { children: /* @__PURE__ */ (0, Q.jsxs)("div", {
							className: "flexbox-col dc__overflow-hidden dc__gap-4",
							children: [/* @__PURE__ */ (0, Q.jsx)("span", {
								className: "fs-13 lh-20",
								children: "Run below command on terminal to get server URI & bearer token"
							}), /* @__PURE__ */ (0, Q.jsx)("pre", {
								className: "mono p-10 br-8 fs-13 m-0 p-0 dc__overflow-auto bg__secondary dc__border-n1 mxh-100",
								children: m
							})]
						}) })]
					})]
				}),
				/* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "flexbox dc__content-space dc__align-items-center dc__border-top-n1 p-12 dc__gap-12 px-20 py-16",
					children: [/* @__PURE__ */ (0, Q.jsx)(Ns, {
						docLinkKey: "KUBE_CONFIG",
						text: "View documentation",
						dataTestId: "kubeconfig-modal-view-documentation",
						showExternalIcon: !0,
						openInNewTab: !0
					}), /* @__PURE__ */ (0, Q.jsx)(M, {
						dataTestId: "copy-kubeconfig-commands",
						size: I.medium,
						onClick: () => {
							Mn.event({
								category: "Resource Browser",
								action: "Get kubeconfig copy button clicked"
							}), u(Nu(m));
						},
						startIcon: /* @__PURE__ */ (0, Q.jsx)(qo, {
							content: m,
							copyToClipboardPromise: l
						}),
						disabled: !p?.length && s,
						text: "Copy command"
					})]
				})
			]
		})
	});
}, fv = ({ parentRef: e, count: t, handleClearBulkSelection: n, onChangeShowKubeConfigModal: r, selectedIdentifiersIds: i = [] }) => {
	let a = t !== 2;
	return /* @__PURE__ */ (0, Q.jsx)(Ls, {
		dragSelector: `.${nv}`,
		positionVariant: Is.PARENT_BOTTOM_CENTER,
		zIndex: "calc(var(--modal-index) - 1)",
		parentRef: e,
		children: /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "dc__separated-flexbox dc__separated-flexbox--gap-8 p-12 bulk-selection-widget br-8",
			children: [
				/* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "flexbox dc__gap-8",
					children: [/* @__PURE__ */ (0, Q.jsx)(Fs, { dragClassName: nv }), /* @__PURE__ */ (0, Q.jsxs)("div", {
						className: "fs-13 lh-20 fw-6 flex dc__gap-12",
						children: [/* @__PURE__ */ (0, Q.jsx)("span", {
							className: "flex dc__gap-2 bcb-5 cn-0 br-4 px-6",
							children: t
						}), /* @__PURE__ */ (0, Q.jsx)("span", {
							className: "cn-9",
							children: "Selected"
						})]
					})]
				}),
				/* @__PURE__ */ (0, Q.jsx)(av, {
					isBulkWidgetButton: !0,
					onChangeShowKubeConfigModal: r
				}),
				/* @__PURE__ */ (0, Q.jsx)(M, {
					icon: /* @__PURE__ */ (0, Q.jsx)(z, {
						name: "ic-arrows-left-right",
						color: null
					}),
					dataTestId: "rb-bulk-action__action-widget--compare-clusters",
					component: N.link,
					style: P.neutral,
					variant: F.borderLess,
					ariaLabel: a ? "Select 2 clusters to compare & sync resources between the clusters" : "Compare & sync resources in selected clusters",
					size: I.small,
					disabled: a,
					linkProps: { to: {
						pathname: B.RESOURCE_BROWSER.COMPARE_CLUSTERS,
						search: `sourceClusterId=${i[0]}&targetClusterId=${i[1]}`
					} }
				}),
				/* @__PURE__ */ (0, Q.jsx)(M, {
					icon: /* @__PURE__ */ (0, Q.jsx)(z, {
						name: "ic-close-large",
						color: null
					}),
					dataTestId: "rb-bulk-action__action-widget--close",
					component: N.button,
					style: P.negativeGrey,
					variant: F.borderLess,
					ariaLabel: "Clear selection(s)",
					size: I.small,
					onClick: n,
					showAriaLabelInTippy: !0
				})
			]
		})
	});
}, pv = ({ sourceClusterId: e, isIconButton: t = !1 }) => {
	let n = {
		sourceClusterId: e,
		targetClusterId: null
	}, r = Rd(B.RESOURCE_BROWSER.COMPARE_CLUSTERS, n);
	return window._env_.FEATURE_RB_SYNC_CLUSTER_ENABLE ? t ? /* @__PURE__ */ (0, Q.jsx)(M, {
		dataTestId: "compare-cluster-button",
		ariaLabel: "Compare & sync clusters",
		icon: /* @__PURE__ */ (0, Q.jsx)(Ar, {}),
		component: N.link,
		linkProps: { to: r },
		variant: F.borderLess,
		style: P.neutral,
		size: I.xs
	}) : /* @__PURE__ */ (0, Q.jsx)(M, {
		dataTestId: "compare-cluster-button",
		text: "Compare & Sync",
		component: N.link,
		linkProps: { to: r },
		variant: F.secondary,
		size: I.small,
		startIcon: /* @__PURE__ */ (0, Q.jsx)(Ar, {}),
		onClick: () => {
			Vd({
				category: "RB Cluster Action",
				action: "RB_CLUSTER_COMPARE_SYNC"
			});
		}
	}) : null;
}, mv = "compatibilityType", hv = "compatibilitySubType", gv = (e) => (e ?? []).map(({ title: e, type: t, summaryAndValidationData: n }) => ({
	type: t,
	title: e,
	summaryAndValidationData: (n ?? []).map((e) => ({
		type: e.type,
		title: e.title,
		subTitle: e.subTitle ?? "",
		k8sObjectsSummaryReport: {
			headers: e.k8sObjectsSummaryReport?.headers ?? [],
			data: (e.k8sObjectsSummaryReport?.data ?? []).map((e, t) => ({
				id: t,
				...e
			}))
		}
	}))
})), _v = {}, vv = async ({ clusterId: e, targetK8sVersion: t }, n) => {
	try {
		let r = `${e}/${t}`, i = _v[r];
		if (i && ((/* @__PURE__ */ new Date()).getTime() - i.timestamp) / 1e3 < 120) return i.data;
		let { result: a } = await G(Rd(O.CLUSTER_PRE_UPGRADE_CHECK, {
			targetK8sVersion: t,
			clusterId: e
		}), {
			timeout: window._env_.CONFIGURABLE_TIMEOUT ? parseInt(window._env_.CONFIGURABLE_TIMEOUT, 10) : null,
			abortControllerRef: n
		}), o = gv(a);
		return _v[r] = {
			timestamp: (/* @__PURE__ */ new Date()).getTime(),
			data: o
		}, gv(a);
	} catch (e) {
		throw pd(e) || K(e), e;
	}
}, yv = ({ clusterId: e, targetK8sVersion: t, updateTabUrl: n }) => {
	let r = Ja(new AbortController()), i = Yf(), a = X(), o = new URLSearchParams(i.search), s = o.get(mv), c = o.get(hv), [l, u, d, f] = hf(() => vv({
		targetK8sVersion: t,
		clusterId: e
	}, r), [e, t], !!t), [p, m] = j({}), h = (e, t) => {
		let n = new URLSearchParams(o);
		return e ? n.set(mv, e) : n.delete(mv), t ? n.set(hv, t) : n.delete(hv), `${i.pathname}?${n.toString()}`;
	};
	k(() => () => r.current.abort(), []), k(() => {
		u?.length > 0 && m(Object.fromEntries(u.map(({ type: e }) => [e, !0])));
	}, [u]), k(() => {
		if (u?.length > 0 && (!s || !c)) {
			let e = s ?? u[0].type, t = h(e, c ?? u.find((t) => t.type === e)?.summaryAndValidationData?.[0]?.type);
			n({ url: t }), a(t, { replace: !0 });
		} else n({ url: h(s, c) });
	}, [
		s,
		c,
		u
	]);
	let g = (e) => {
		let t = structuredClone(p);
		t[e] ? delete t[e] : t[e] = !0, m(t);
	}, _ = u?.find(({ type: e }) => e === s)?.summaryAndValidationData.find(({ type: e }) => e === c)?.k8sObjectsSummaryReport ?? {
		headers: [],
		data: []
	}, v = (u ?? []).map(({ title: e, type: t, summaryAndValidationData: r }) => ({
		header: e,
		id: t,
		isExpanded: p[t],
		items: r.map((e) => {
			let r = h(t, e.type);
			return {
				title: e.title,
				subtitle: e.subTitle,
				href: r,
				isActive: () => s === t && c === e.type,
				onClick: () => {
					n({ url: r });
				}
			};
		})
	}));
	return {
		isLoading: l || pd(d),
		compatibilityInfoData: u,
		compatibilityError: d,
		refetchCompatibilityList: f,
		resourceListForCurrentData: _,
		sidebarConfig: v,
		onCollapseBtnClick: g
	};
}, bv = ({ semanticPrefix: e, variant: t = "dropdown", selectInputId: n, clusterOptions: r, selectedClusterOption: i, handleClusterSelect: a, handleReload: o, areCurrentViewActionsDisabled: s, showBulkSelectionCheckbox: c = !1, isBulkSelectionDisabled: l = !1 }) => /* @__PURE__ */ (0, Q.jsxs)("div", {
	className: "flexbox dc__content-space dc__align-items-center dc__gap-12 px-16",
	children: [
		c && /* @__PURE__ */ (0, Q.jsx)(ko, {
			showPagination: !1,
			disabled: l,
			showChevronDownIcon: !1,
			selectAllIfNotPaginated: !0
		}),
		/* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox dc__gap-8 flex-grow-1",
			children: [/* @__PURE__ */ (0, Q.jsx)("label", {
				className: "m-0 cn-7 fs-13 fw-4 lh-20",
				htmlFor: n,
				children: "Cluster"
			}), /* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox dc__align-items-center dc__gap-8",
				children: [t === "dropdown" ? /* @__PURE__ */ (0, Q.jsx)("div", {
					className: "dc__mxw-300",
					children: /* @__PURE__ */ (0, Q.jsx)(V, {
						classNamePrefix: "compare-cluster__cluster-select",
						inputId: n,
						options: r,
						value: i,
						placeholder: "Select Cluster",
						onChange: a,
						variant: Hl.COMPACT,
						isDisabled: s
					})
				}) : i?.label && /* @__PURE__ */ (0, Q.jsx)(W, {
					content: i.label,
					children: /* @__PURE__ */ (0, Q.jsx)("h3", {
						className: "m-0 fs-13 lh-20 fw-6 dc__truncate",
						children: i.label
					})
				}), i?.isProd && /* @__PURE__ */ (0, Q.jsx)(So, {
					label: "Production",
					size: I.xxs
				})]
			})]
		}),
		t === "dropdown" && i && /* @__PURE__ */ (0, Q.jsx)(M, {
			dataTestId: `${e}-refetch-cluster-data-button`,
			icon: /* @__PURE__ */ (0, Q.jsx)(ir, {}),
			style: P.neutral,
			variant: F.borderLess,
			ariaLabel: "Reload resources",
			onClick: o,
			disabled: s,
			size: I.xs
		})
	]
}), xv = /* @__PURE__ */ function(e) {
	return e.SOURCE = "source", e.TARGET = "target", e;
}({}), Sv = /* @__PURE__ */ function(e) {
	return e.VIEW_ALL = "view-all", e.ONLY_MATCHING = "only-matching", e.ONLY_NON_MATCHING = "only-non-matching", e.VIEW_LEFT_JOIN = "view-left-join", e.VIEW_RIGHT_JOIN = "view-right-join", e;
}({}), Cv = [Kc.Event, Kc.Node], wv = "source-cluster-select-id", Tv = "target-cluster-select-id", Ev = [
	{
		label: "View all",
		value: Sv.VIEW_ALL,
		description: "Displays all resources from both clusters without any filters"
	},
	{
		label: "Only matching",
		value: Sv.ONLY_MATCHING,
		description: "Shows resources that exist in both clusters"
	},
	{
		label: "Only non-matching",
		value: Sv.ONLY_NON_MATCHING,
		description: "Shows resources that are present in one cluster but not the other"
	}
], Dv = (e, t) => [
	...Ev,
	{
		label: "View left join",
		value: Sv.VIEW_LEFT_JOIN,
		description: `Displays all resources from '${e.label}' and only matching resources from '${t.label}'`
	},
	{
		label: "View right join",
		value: Sv.VIEW_RIGHT_JOIN,
		description: `Displays all resources from '${t.label}' and only matching resources from '${e.label}'`
	}
], Ov = Ev[0], kv = {
	RESOURCE_DOES_NOT_EXIST: "This resource no longer exists",
	MANIFEST_NOT_AVAILABLE: "Manifest not available"
}, Av = (e) => /* @__PURE__ */ (0, Q.jsxs)("svg", {
	width: 250,
	height: 200,
	viewBox: "0 0 250 200",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [
		/* @__PURE__ */ (0, Q.jsx)("style", { children: "@keyframes moving-border{0%{stroke-dashoffset:12}to{stroke-dashoffset:0}}" }),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			fill: "#202020",
			d: "M26 7h180v119H26z"
		}),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			d: "M78.504 39.7h-3.16V42h9.28v-2.3h-3.16V27.2h-6.12v2.3h3.16zm38.257 2.3q-1.6 0-2.38-.84t-.78-2.14v-5.04h-2.8v-2.3h1.82q.66 0 .94-.26t.28-.96v-2.42h2.72v3.64h4.02v2.3h-4.02v5.72h4.02V42z",
			fill: "#fff"
		}),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M142.205 41.54q.56.46 1.48.46h1.7v-2.14h-1.14v-4.52q0-1.96-1.2-2.92-1.179-.98-3.3-.98-1.74 0-2.86.58-1.1.56-1.62 1.44l1.62 1.44q.42-.58 1-.94t1.52-.36q1.02 0 1.44.48.44.46.44 1.38v.52h-1.66q-2.28 0-3.46.78t-1.18 2.4q0 1.46.9 2.28.92.8 2.42.8 1.2 0 2.02-.52.84-.52 1.12-1.54h.1q.1.88.66 1.36m-1.46-1.62q-.54.38-1.32.38-.7 0-1.12-.28t-.42-.82v-.4q0-1.22 1.82-1.22h1.58v1.24q0 .72-.54 1.1",
			fill: "#fff"
		}),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			d: "M66.512 65.7h-3.16V68h9.28v-2.3h-3.16V53.2h-6.12v2.3h3.16zm38.257 2.3q-1.6 0-2.38-.84t-.78-2.14v-5.04h-2.8v-2.3h1.82q.66 0 .94-.26t.28-.96v-2.42h2.72v3.64h4.02v2.3h-4.02v5.72h4.02V68z",
			fill: "#fff"
		}),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M112.301 66.8q1.34 1.44 3.94 1.44 1.66 0 2.74-.54t1.68-1.28l-1.6-1.74q-.48.58-1.14.94-.66.34-1.58.34-1.2 0-1.82-.6-.62-.62-.62-1.62v-.18h7.06v-.88q0-1.2-.36-2.16a4.6 4.6 0 0 0-.98-1.66 4.2 4.2 0 0 0-1.56-1.04q-.92-.38-2.08-.38t-2.1.38q-.92.36-1.58 1.08-.64.7-1 1.72-.34 1-.34 2.26 0 2.48 1.34 3.92m2.16-6.64q.58-.6 1.54-.6t1.5.58q.56.58.56 1.6v.16h-4.16v-.16q0-1 .56-1.58",
			fill: "#fff"
		}),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			d: "M125.813 65.7h-2.38V68h8.74v-2.3h-3.4v-3.06q0-.94.56-1.58.56-.66 1.66-.66h2.2v-2.72h-.98q-.76 0-1.32.24t-.96.66q-.38.4-.64.94a6 6 0 0 0-.38 1.08h-.14v-2.92h-5.34v2.3h2.38zm-36.956 2.02q1.28.52 3 .52 2.3 0 3.54-.94 1.26-.94 1.26-2.56 0-.74-.26-1.26a2.56 2.56 0 0 0-.72-.88 3.2 3.2 0 0 0-1.04-.56 6.4 6.4 0 0 0-1.3-.32l-1.64-.26q-.6-.1-.94-.26-.34-.18-.34-.64 0-1.04 1.72-1.04 1.02 0 1.74.34t1.18.84l1.48-1.68q-.64-.76-1.72-1.16-1.06-.42-2.58-.42-2.241 0-3.48.92-1.24.92-1.24 2.54 0 .74.26 1.26t.7.88 1.04.58q.6.2 1.3.3l1.66.26q.6.1.94.28.34.16.34.6 0 .56-.5.84-.501.26-1.38.26-1.041 0-1.86-.36-.8-.38-1.4-1.04l-1.66 1.54q.64.9 1.9 1.42m-7.133-1.6h-.12a3.64 3.64 0 0 1-1.08 1.5q-.72.62-1.96.62-.74 0-1.36-.24a2.9 2.9 0 0 1-1.06-.76 3.8 3.8 0 0 1-.7-1.22q-.24-.72-.24-1.66v-6.68h2.96v6.28q0 2 1.74 2 .34 0 .66-.08.34-.1.58-.28.261-.2.42-.48.16-.28.16-.66v-6.78h2.96V68h-2.96zM56.42 68.24q-1.22 0-2.2-.36a4.6 4.6 0 0 1-1.64-1.08 4.8 4.8 0 0 1-1.02-1.7q-.36-1-.36-2.26t.36-2.26 1.02-1.7q.68-.7 1.64-1.06.98-.38 2.18-.38 1.7 0 2.72.7a4.36 4.36 0 0 1 1.58 1.82l-2.28 1.24a3 3 0 0 0-.74-1q-.44-.4-1.28-.4-1.02 0-1.58.6-.54.58-.54 1.6v1.68q0 1.02.54 1.62.56.58 1.62.58.86 0 1.34-.4.5-.4.84-1.04l2.24 1.28a4.55 4.55 0 0 1-1.64 1.84q-1.06.68-2.8.68m45.769-26.36q.98.36 2.2.36 1.74 0 2.8-.68a4.55 4.55 0 0 0 1.64-1.84l-2.24-1.28a3.3 3.3 0 0 1-.84 1.04q-.48.4-1.34.4-1.06 0-1.62-.58-.54-.6-.54-1.62V36q0-1.02.54-1.6.56-.6 1.58-.6.84 0 1.28.4.46.4.74 1l2.28-1.24a4.36 4.36 0 0 0-1.58-1.82q-1.02-.7-2.72-.7-1.2 0-2.18.38-.96.36-1.64 1.06a4.8 4.8 0 0 0-1.02 1.7q-.36 1-.36 2.26t.36 2.26 1.02 1.7q.68.7 1.64 1.08",
			fill: "#fff"
		}),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M92.257 42.24q-2.6 0-3.94-1.44t-1.34-3.92q0-1.26.34-2.26.36-1.02 1-1.72.66-.72 1.58-1.08.939-.38 2.1-.38 1.16 0 2.08.38.92.36 1.56 1.04t.98 1.66q.36.96.36 2.16v.88h-7.06v.18q0 1 .62 1.62.62.6 1.82.6.92 0 1.58-.34.66-.36 1.14-.94l1.6 1.74q-.6.74-1.68 1.28t-2.74.54m-.24-8.68q-.96 0-1.54.6-.56.58-.56 1.58v.16h4.16v-.16q0-1.02-.56-1.6-.54-.58-1.5-.58m-23.745 8.68q-2.6 0-3.94-1.44t-1.34-3.92q0-1.26.34-2.26.36-1.02 1-1.72.66-.72 1.58-1.08.94-.38 2.1-.38t2.08.38q.92.36 1.56 1.04a4.6 4.6 0 0 1 .98 1.66q.36.96.36 2.16v.88h-7.06v.18q0 1 .62 1.62.62.6 1.82.6.92 0 1.58-.34.66-.36 1.14-.94l1.6 1.74q-.6.74-1.68 1.28t-2.74.54m-.24-8.68q-.96 0-1.54.6-.56.58-.56 1.58v.16h4.16v-.16q0-1.02-.56-1.6-.54-.58-1.5-.58",
			fill: "#fff"
		}),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			d: "M52.72 41.66q1.3.58 3.06.58 1.32 0 2.3-.34 1-.34 1.68-.94a4 4 0 0 0 1.02-1.44q.34-.84.34-1.82 0-1.66-.92-2.64t-2.62-1.28l-1.46-.26q-1.02-.18-1.48-.54-.44-.36-.44-1.08 0-1.66 2.02-1.66.96 0 1.72.36.76.34 1.32.96l1.7-1.9q-.74-.86-1.94-1.36t-2.82-.5q-2.38 0-3.7 1.12-1.32 1.1-1.32 3.12 0 1.54.84 2.62.84 1.06 2.72 1.38l1.46.24q1.02.16 1.44.54.44.38.44 1.12 0 .9-.56 1.38t-1.64.48a4.6 4.6 0 0 1-1.86-.4q-.9-.4-1.66-1.24l-1.74 1.92q.8 1 2.1 1.58",
			fill: "#fff"
		}),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			d: "M33.288 80.908c.044-2.656.044-3.972.483-6.603-1.2-.367-3.732.042-5.716.092.034 1.322-.122 3.999-1.133 5.876q1.25 2.35 3.232 2.3t3.134-1.665",
			fill: "#F3A29D"
		}),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			d: "M33.624 61.563c1.323.698 2.475 1.944 3.212 3.48.23.482.101.729.563 1.497q.663 1.105 1.78 2.648l-1.459 1.02q-.761 3.694-3.37 4.894-2.607 1.198-4.755-.011-4.531-2.675-2.951-7.405t6.98-6.123",
			fill: "#FAB6AF"
		}),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			d: "M33.523 68.567c-.34-1.044.07-2.129.94-2.412.676-.22 1.41.116 1.864.766q.216-.277.438-.451l.106-.077q.2-.134.36-.19c-.24-.829.063-1.666.726-1.881.683-.222 1.443.313 1.72 1.165s-.024 1.731-.706 1.953c-.608.197-1.276-.205-1.611-.896a1.3 1.3 0 0 0-.287.152q-.264.175-.536.55l-.011.017q.066.14.115.291c.34 1.045-.07 2.13-.94 2.412s-1.838-.354-2.178-1.399m4.547-3.899c-.466.152-.693.816-.472 1.494.22.68.794 1.083 1.26.931.466-.15.693-.815.472-1.493-.22-.68-.794-1.083-1.26-.932m-3.494 1.834c-.66.214-.989 1.084-.706 1.953.282.868 1.059 1.38 1.719 1.165s.988-1.085.706-1.953-1.06-1.38-1.72-1.165",
			fill: "#222768"
		}),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			d: "M43.858 105.444c-1.754-1.404-4.824-4.094-6.14-5.263l-2.193 10.964 15.79.878 1.315-2.193c-2.193-.877-7.017-2.983-8.772-4.386",
			fill: "#FBB4AD"
		}),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			d: "m41.665 115.093 2.193-17.544c-2.924 0-9.56-.877-12.719-4.385-3.947-4.386-2.631-10.088-5.701-9.65-3.07.44-7.456 18.421-5.263 25.439 1.754 5.614 15.058 6.432 21.49 6.14",
			fill: "url(#paint0_linear_4305_3090)"
		}),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			d: "M35.087 97.988c-1.404-5.263-1.755-13.888-1.755-17.543-2.193.438-7.192 1.14-9.649.438-5.701 13.158-15.788 21.491-15.788 27.631 0 2.456 1.17 3.947 1.754 4.386 1.462.585 6.316 1.754 14.035 1.754s13.742-3.509 15.788-5.263c-.877-1.608-2.982-6.14-4.385-11.403",
			fill: "url(#paint1_linear_4305_3090)"
		}),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			d: "m0 200 3.899-11.793h8.576c.244 1.445 3.948 4.018 5.507 4.954 1.95 1.169 5.799 2.94 7.358 4.11 1.248.936 2.34 2.209 2.73 2.729z",
			fill: "url(#paint2_linear_4305_3090)"
		}),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			d: "m21.052 200 4.21-11.793h8.265c.244 1.445 3.947 4.018 5.507 4.954 1.95 1.169 5.799 2.94 7.358 4.11 1.248.936 2.34 2.209 2.73 2.729z",
			fill: "url(#paint3_linear_4305_3090)"
		}),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			d: "M17.105 133.513c1.754-7.368 1.316-19.736.877-24.999h14.912c-.146 4.386-.351 14.649 0 20.613.35 5.965-13.304 42.251-20.175 59.648h-9.21c-.585-2.778-1.58-9.649-.878-14.912.878-6.579 12.28-31.14 14.474-40.35",
			fill: "url(#paint4_linear_4305_3090)"
		}),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			d: "M17.105 118.601c-.702-3.508-.293-8.186 0-10.087h15.789c2.339 9.795 7.105 30.701 7.456 35.964.35 5.263-4.24 31.724-6.58 44.297H25c-1.024-1.462-3.159-5.263-3.51-8.772-.438-4.386.878-8.333 1.316-10.965s-.438-7.294-.438-10.964 2.193-12.28 1.754-17.543-6.14-17.544-7.017-21.93",
			fill: "url(#paint5_linear_4305_3090)"
		}),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			fill: "#F04C49",
			d: "m16.627 148.942 57.887-59.943 4.416 4.265-57.886 59.943z"
		}),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			d: "M14.691 144.633 72.578 84.69l1.936 4.309-57.887 59.943z",
			fill: "url(#paint6_linear_4305_3090)"
		}),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			d: "m21.044 153.207 57.887-59.943 4.373 1.785-57.886 59.943z",
			fill: "url(#paint7_linear_4305_3090)"
		}),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			d: "m85.07 78.462 7.495-3.736-3.473 7.62z",
			fill: "#ffffff"
		}),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			d: "M85.07 78.462 72.577 84.69l1.937 4.309 4.416 4.265 4.374 1.785 5.788-12.702z",
			fill: "#D2D2D2"
		}),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			d: "M42.981 126.934c-3.158-.701-9.795-4.97-12.719-7.017l3.947-10.087c.731 1.169 2.895 4.473 5.702 8.333 2.807 3.859 6.14 5.409 7.456 5.701 1.754-2.193 4.649-3.508 6.842-5.263.146.293.526 1.053.175 1.755-.438.877-3.07 2.193-1.754 3.07 1.053.702 3.947-.877 5.263-1.755 0 1.462-.614 4.649-3.07 5.702-3.07 1.316-7.895.439-11.842-.439",
			fill: "#FBB4AD"
		}),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			d: "m31.578 126.057 7.017-17.982c-2.924-.438-9.122-2.543-10.526-7.456-1.403-4.912 2.924-15.496 5.263-20.174 0 0-2.876.737-4.824.877-1.717.123-4.386 0-4.386 0-1.754 1.9-5.702 6.315-7.456 8.772-2.193 3.07-7.017 12.718-5.702 18.42s4.825 5.263 8.333 8.333c3.51 3.07 3.948 6.14 7.018 7.895 2.456 1.403 4.532 1.461 5.263 1.315",
			fill: "#428DFB"
		}),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M30.949 70.649c-.278.795-.467 1.812-.467 3.217 0 2.92 2.05 5.31 2.965 6.375l.052.06-.333.286-.067-.077c-.911-1.062-3.056-3.559-3.056-6.644 0-1.446.195-2.512.492-3.362s.694-1.472 1.083-2.027l.215-.304c.31-.435.596-.836.822-1.31.273-.572.458-1.252.458-2.207h.439c0 1.018-.2 1.763-.502 2.397-.243.511-.556.95-.867 1.386q-.104.144-.206.29c-.38.541-.75 1.125-1.028 1.92",
			fill: "#000"
		}),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			d: "M29.824 60.007c2.063-.042 3.369.084 4.524.842l.055.047c.883.747 1.565 1.325 1.936 3.272-.59-.999-1.527-1.276-1.948-1.255.192 1.222-.281 3.314-1.497 4.375-2.265 1.976-3.333 3.07-3.333 5.263 0 4.385 1.579 7.017 2.894 8.771 0 0-3.196 1.672-7.894 2.193s-7.774-.454-7.774-.454c-.564-1.33-.713-4.252-.22-5.846q-.107.162-.206.327c-.482.803-.791 1.64-.791 2.464 0 1.379.288 2.28.415 2.534l-.392.196c-.165-.33-.462-1.302-.462-2.73 0-.931.349-1.848.854-2.69.506-.842 1.177-1.624 1.842-2.29.698-.697 1.374-1.377 1.857-2.17.134-.357.223-.748.25-1.182.046-.732.063-1.39.079-2 .058-2.239.098-3.81 1.478-5.895 1.884-2.848 5.526-3.713 8.333-3.772",
			fill: "#23286B"
		}),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			d: "M56.577 116.409c0 1.754 1.17 3.654 1.755 4.385.73-.438 2.193-.877 3.508-2.193 1.316-1.315 1.9-2.631 2.193-3.508-.438-.877-1.491-2.544-2.193-2.193s0 2.193.439 3.07c-1.17-1.17-3.684-3.421-4.386-3.07-.877.438-1.316 1.316-1.316 3.509",
			fill: "#FBB4AD"
		}),
		/* @__PURE__ */ (0, Q.jsx)("circle", {
			cx: 217,
			cy: 175,
			r: 15,
			fill: "url(#paint8_radial_4305_3090)"
		}),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			d: "M122.5 91c8 7 31 13 43.5 9.5 32.861-9.201 37.392-48.707 17-53-19-4-20 27.5 4.5 29 36.216 2.217 47.5-43.5 51.5-65",
			stroke: "#FF7E5B",
			strokeWidth: 3,
			strokeLinecap: "round",
			style: {
				strokeDasharray: "4 8",
				animation: "moving-border .5s infinite linear"
			}
		}),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			d: "m232 9.065 8.27-5.793a1 1 0 0 1 1.449.334l4.893 8.833c.419.757-.256 1.653-1.1 1.459l-13.163-3.04c-.844-.194-1.058-1.296-.349-1.793",
			fill: "#FF7E5B"
		}),
		/* @__PURE__ */ (0, Q.jsxs)("defs", { children: [
			/* @__PURE__ */ (0, Q.jsxs)("linearGradient", {
				id: "paint0_linear_4305_3090",
				x1: 32.894,
				y1: 99.742,
				x2: 33.481,
				y2: 116.403,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ (0, Q.jsx)("stop", { stopColor: "#428DFC" }), /* @__PURE__ */ (0, Q.jsx)("stop", {
					offset: 1,
					stopColor: "#1D72D9"
				})]
			}),
			/* @__PURE__ */ (0, Q.jsxs)("linearGradient", {
				id: "paint1_linear_4305_3090",
				x1: 31.139,
				y1: 79.129,
				x2: 22.225,
				y2: 116.32,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ (0, Q.jsx)("stop", {
					offset: .218,
					stopColor: "#428DFC"
				}), /* @__PURE__ */ (0, Q.jsx)("stop", {
					offset: 1,
					stopColor: "#0C5FC4"
				})]
			}),
			/* @__PURE__ */ (0, Q.jsxs)("linearGradient", {
				id: "paint2_linear_4305_3090",
				x1: 25.999,
				y1: 188.43,
				x2: 17.366,
				y2: 207.757,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ (0, Q.jsx)("stop", {
					offset: .091,
					stopColor: "#2C7DE7"
				}), /* @__PURE__ */ (0, Q.jsx)("stop", {
					offset: .492,
					stopColor: "#1D72D9"
				})]
			}),
			/* @__PURE__ */ (0, Q.jsxs)("linearGradient", {
				id: "paint3_linear_4305_3090",
				x1: 47.051,
				y1: 188.43,
				x2: 38.419,
				y2: 207.757,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ (0, Q.jsx)("stop", {
					offset: .075,
					stopColor: "#428DFC"
				}), /* @__PURE__ */ (0, Q.jsx)("stop", {
					offset: 1,
					stopColor: "#428DFC"
				})]
			}),
			/* @__PURE__ */ (0, Q.jsxs)("linearGradient", {
				id: "paint4_linear_4305_3090",
				x1: 19.706,
				y1: 108.514,
				x2: -6.254,
				y2: 181.066,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ (0, Q.jsx)("stop", {
					offset: .332,
					stopColor: "#181D55"
				}), /* @__PURE__ */ (0, Q.jsx)("stop", {
					offset: 1,
					stopColor: "#1A1F58"
				})]
			}),
			/* @__PURE__ */ (0, Q.jsxs)("linearGradient", {
				id: "paint5_linear_4305_3090",
				x1: 26.662,
				y1: 108.514,
				x2: 26.341,
				y2: 188.774,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ (0, Q.jsx)("stop", { stopColor: "#191D52" }),
					/* @__PURE__ */ (0, Q.jsx)("stop", {
						offset: .537,
						stopColor: "#272D78"
					}),
					/* @__PURE__ */ (0, Q.jsx)("stop", {
						offset: 1,
						stopColor: "#23286B"
					})
				]
			}),
			/* @__PURE__ */ (0, Q.jsxs)("linearGradient", {
				id: "paint6_linear_4305_3090",
				x1: 74.471,
				y1: 86.518,
				x2: 79.212,
				y2: 91.945,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ (0, Q.jsx)("stop", { stopColor: "#D53B3A" }), /* @__PURE__ */ (0, Q.jsx)("stop", {
					offset: 1,
					stopColor: "#E64542"
				})]
			}),
			/* @__PURE__ */ (0, Q.jsxs)("linearGradient", {
				id: "paint7_linear_4305_3090",
				x1: 82.042,
				y1: 93.83,
				x2: 86.784,
				y2: 99.257,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ (0, Q.jsx)("stop", { stopColor: "#E24442" }), /* @__PURE__ */ (0, Q.jsx)("stop", {
					offset: 1,
					stopColor: "#CC3434"
				})]
			}),
			/* @__PURE__ */ (0, Q.jsxs)("radialGradient", {
				id: "paint8_radial_4305_3090",
				cx: 0,
				cy: 0,
				r: 1,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "matrix(-3 29.99997 -27.0259 -2.7026 220 160)",
				children: [/* @__PURE__ */ (0, Q.jsx)("stop", { stopColor: "#A0C2FC" }), /* @__PURE__ */ (0, Q.jsx)("stop", {
					offset: .88,
					stopColor: "#78A5E6"
				})]
			})
		] })
	]
}), jv = ({ name: e, namespace: t, onChange: n = $d, isResourcePresentInCluster: r, direction: i, showBgOnHover: a = !1, isChecked: o = !1, isDisabled: s = !1, resourceCopyButtonConfig: c }) => {
	let l = i === "end", u = () => /* @__PURE__ */ (0, Q.jsx)("div", {
		className: c.isVisible ? null : "dc__visibility-hidden",
		children: /* @__PURE__ */ (0, Q.jsx)(M, {
			dataTestId: "resource-copy-button",
			ariaLabel: c.tooltip || "copy-resource",
			icon: /* @__PURE__ */ (0, Q.jsx)(Kn, { className: l ? "dc__flip-180" : null }),
			variant: F.borderLess,
			onClick: c.onClick,
			size: I.xs,
			isOpacityHoverChild: !0
		})
	});
	return /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: `flexbox dc__align-items-center dc__content-space py-8 dc__gap-8 ${l ? "pl-28 pr-16" : "pl-16 pr-28"} ${a ? "dc__hover-n50" : ""}`,
		children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox dc__align-items-center dc__gap-12",
			children: [l ? u() : /* @__PURE__ */ (0, Q.jsx)(Wo, {
				disabled: s,
				isChecked: o,
				onChange: n,
				value: Io.CHECKED,
				rootClassName: "m-0"
			}), /* @__PURE__ */ (0, Q.jsx)(W, {
				content: e,
				children: /* @__PURE__ */ (0, Q.jsx)("span", {
					className: `${r ? "cb-5" : "cr-5 dc__opacity-0_6"} fs-13 fw-4 lh-20 dc__truncate`,
					children: e
				})
			})]
		}), /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox dc__align-items-center dc__gap-12",
			children: [t && /* @__PURE__ */ (0, Q.jsx)(W, {
				content: t,
				children: /* @__PURE__ */ (0, Q.jsx)("span", {
					className: `cn-7 fs-13 fw-4 lh-20 dc__truncate ${r ? "" : "dc__opacity-0_6"}`,
					children: t
				})
			}), !l && u()]
		})]
	});
}, Mv = ({ rootClassName: e, showSelectionCheckbox: t = !0, isDisabled: n, isChecked: r, resourceGroupIdentifier: i, clusterResourceCount: a, onChange: o = $d }) => /* @__PURE__ */ (0, Q.jsxs)("div", {
	className: `flexbox dc__gap-12 pt-8 pb-7 px-16 dc__border-bottom-n1 ${e || ""}`,
	children: [t ? /* @__PURE__ */ (0, Q.jsx)(Wo, {
		disabled: n,
		isChecked: r,
		onChange: o,
		value: Io.CHECKED,
		rootClassName: "m-0"
	}) : /* @__PURE__ */ (0, Q.jsx)("div", { className: "icon-dim-20 dc__no-shrink" }), /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox dc__gap-6",
		children: [/* @__PURE__ */ (0, Q.jsx)(W, {
			content: i,
			children: /* @__PURE__ */ (0, Q.jsx)("h3", {
				className: "m-0 cn-7 fs-12 fw-6 lh-18 dc__truncate",
				children: i
			})
		}), (!!a || a === 0) && /* @__PURE__ */ (0, Q.jsx)(qc, { count: a })]
	})]
}), Nv = /* @__PURE__ */ function(e) {
	return e.SOURCE_CLUSTER_ID = "sourceClusterId", e.TARGET_CLUSTER_ID = "targetClusterId", e.RESOURCE_LIST_FILTER = "resourceListFilter", e.COMPARE_RESOURCE_IDENTIFIER = "compareResourceIdentifier", e.COMPARE_RESOURCE_LIST_IDENTIFIER = "compareResourceListIdentifier", e;
}({}), Pv = () => ({ alias: {
	...ld(),
	"resource-browser": {
		component: /* @__PURE__ */ (0, Q.jsx)(To, { heading: "Resource Browser" }),
		linked: !0
	},
	"compare-clusters": {
		component: /* @__PURE__ */ (0, Q.jsx)("span", {
			className: "cn-9 fs-16 fw-6 lh-24",
			children: "Compare & Sync Clusters"
		}),
		linked: !1
	}
} }), Fv = ({ id: e, name: t, isProd: n }) => ({
	label: t,
	value: e,
	isProd: n
}), Iv = (e) => {
	let t = Number(e.get(Nv.SOURCE_CLUSTER_ID) || 0), n = Number(e.get(Nv.TARGET_CLUSTER_ID) || 0);
	return {
		sourceClusterId: t,
		targetClusterId: t === n ? 0 : n,
		resourceListFilter: e.get(Nv.RESOURCE_LIST_FILTER) || Ov.value,
		compareResourceIdentifier: t && n ? e.get(Nv.COMPARE_RESOURCE_IDENTIFIER) : "",
		compareResourceListIdentifier: t && n ? e.get(Nv.COMPARE_RESOURCE_LIST_IDENTIFIER) : ""
	};
}, Lv = (e, t) => e ? `${e}/${t}` : t, Rv = ({ name: e, kind: t, group: n = "", namespace: r = "" }) => `${n}/${t}/${e}/${r}`, zv = ({ resourceFilterType: e, resourceItemIdentifier: t, sourceKindResourceMap: n, targetKindResourceMap: r }) => {
	switch (e) {
		case Sv.ONLY_MATCHING: return !!n[t] && !!r[t];
		case Sv.ONLY_NON_MATCHING: return !n[t] || !r[t];
		case Sv.VIEW_LEFT_JOIN: return !!n[t];
		case Sv.VIEW_RIGHT_JOIN: return !!r[t];
		default: return !0;
	}
}, Bv = ({ sourceClusterDataStore: e, targetClusterDataStore: t, resourceFilterType: n = Sv.VIEW_ALL, selectedResourceGroupIdentifierOptionsList: r = [] }) => {
	let i = structuredClone(e), a = structuredClone(t), o = r?.reduce((e, { value: t }) => (e[t] = !0, e), {}) || {}, { resourceDataStore: s, identifiersMap: c, areAllResourcesPresentInBothClusters: l, totalResourceCount: u } = Array.from(new Set(Object.keys(i.resourceDataStore).concat(Object.keys(a.resourceDataStore)))).filter((e) => !!o[e] || !r?.length).reduce((e, t) => {
		let r = i.resourceDataStore[t], o = a.resourceDataStore[t], s = r?.gvk.Group || o?.gvk.Group, c = r?.gvk.Kind || o?.gvk.Kind, l = r?.resources || [], u = o?.resources || [], d = r?.resourceMap || {}, f = o?.resourceMap || {}, p = {}, m = l.concat(u).reduce((e, t) => {
			let r = Rv({
				name: t.name,
				namespace: t.namespace,
				group: s,
				kind: c
			});
			return !p[r] && zv({
				resourceFilterType: n,
				resourceItemIdentifier: r,
				sourceKindResourceMap: d,
				targetKindResourceMap: f
			}) && (p[r] = !0, e.push(t)), e;
		}, []).sort((e, t) => {
			let n = e.namespace || "", r = t.namespace || "";
			return n === r ? df(e.name, t.name) : df(n, r);
		});
		return e.resourceDataStore[t] = {
			resources: m,
			identifier: t,
			group: s,
			kind: c,
			areAllResourcesPresentInBothClusters: m.every(({ name: e, namespace: t }) => {
				let n = Rv({
					name: e,
					namespace: t,
					group: s,
					kind: c
				});
				return !!d[n] && !!f[n];
			})
		}, e.totalResourceCount += m.length, m.forEach(({ name: t, namespace: n }) => {
			let r = Rv({
				name: t,
				namespace: n,
				group: s,
				kind: c
			});
			if (!d[r] || !f[r]) {
				e.areAllResourcesPresentInBothClusters = !1;
				let i = d[r] ? xv.TARGET : xv.SOURCE;
				e.identifiersMap[r] = {
					name: t,
					namespace: n,
					resourceListIdentifier: Lv(s, c),
					clusterType: i
				};
			}
		}), e;
	}, {
		resourceDataStore: {},
		identifiersMap: {},
		areAllResourcesPresentInBothClusters: !0,
		totalResourceCount: 0
	});
	return {
		sourceClusterDataStore: i,
		targetClusterDataStore: a,
		resourceDataStore: s,
		resourceGroupIdentifierList: Object.keys(s).sort(df),
		identifiersMap: c,
		areAllResourcesPresentInBothClusters: l,
		totalResourceCount: u
	};
}, Vv = (e) => {
	let t = structuredClone(e);
	return t?.metadata?.resourceVersion && delete t.metadata.resourceVersion, Tu(t);
}, Hv = (e, t) => ({
	sourceClusterDataStore: {
		clusterId: e,
		resourceDataStore: {},
		totalCount: 0
	},
	targetClusterDataStore: {
		clusterId: t,
		resourceDataStore: {},
		totalCount: 0
	},
	resourceDataStore: {},
	resourceGroupIdentifierList: [],
	identifiersMap: {},
	areAllResourcesPresentInBothClusters: !0,
	totalResourceCount: 0
}), Uv = ({ resourceGroupIdentifierList: e, combinedResourcesDataStore: t, clusterResourceDataStore: n = {} }) => e.reduce((e, r) => {
	let { resources: i, group: a, kind: o } = t[r], s = n[r];
	if (i?.length) {
		let t = i.map(({ name: e, namespace: t }) => Rv({
			group: a,
			name: e,
			namespace: t,
			kind: o
		}));
		e[r] = {
			id: r,
			isGroup: !0,
			name: r,
			clusterResourceCount: i.length,
			children: t,
			height: 36,
			depth: 0
		};
		let n = s?.resourceMap || {};
		i.forEach(({ name: i, namespace: a }, o) => {
			let s = t[o];
			e[s] = {
				id: s,
				name: i,
				namespace: a,
				resourceIdentifier: s,
				resourceGroupIdentifier: r,
				isResourcePresentInCluster: !!n[s],
				height: 40,
				depth: 1
			};
		});
	}
	return e;
}, {}), Wv = ({ filteredCompareClusterDataStore: e, resourceIdentifier: t, resourceListIdentifier: n }) => {
	let { sourceClusterDataStore: r, targetClusterDataStore: i } = e, a = r.resourceDataStore[n]?.resourceMap?.[t] ?? null, o = i.resourceDataStore[n]?.resourceMap?.[t] ?? null, { name: s, namespace: c } = a ?? o ?? {}, { gvk: l } = e[a ? "sourceClusterDataStore" : "targetClusterDataStore"].resourceDataStore[n] ?? {};
	return {
		gvk: l,
		name: s,
		namespace: c,
		isResourcePresentInSourceCluster: !!a,
		isResourcePresentInTargetCluster: !!o
	};
}, Gv = ({ clusterDataStore: e, resource: t, resourceListIdentifier: n, resourceIdentifier: r }) => {
	let i = e;
	return i.resourceDataStore[n].resources.push(t), i.resourceDataStore[n].resources.sort((e, t) => {
		let n = e.namespace || "", r = t.namespace || "";
		return n === r ? df(e.name, t.name) : df(n, r);
	}), i.resourceDataStore[n].resourceMap[r] = t, i.totalCount += 1, i;
}, Kv = ({ compareClusterDataStore: e, resourceListIdentifier: t, gvk: n, clusterType: r, resourceManifest: i }) => {
	let { sourceClusterDataStore: a, targetClusterDataStore: o } = e, s = Qf.parse(i).metadata ?? {
		name: "",
		namespace: ""
	}, c = Rv({
		...s,
		group: n.Group,
		kind: n.Kind
	});
	return r === xv.SOURCE && !a.resourceDataStore[t].resourceMap[c] ? a = Gv({
		clusterDataStore: a,
		resource: s,
		resourceIdentifier: c,
		resourceListIdentifier: t
	}) : r === xv.TARGET && !o.resourceDataStore[t].resourceMap[c] && (o = Gv({
		clusterDataStore: o,
		resource: s,
		resourceIdentifier: c,
		resourceListIdentifier: t
	})), Bv({
		sourceClusterDataStore: a,
		targetClusterDataStore: o
	});
}, qv = ({ clusterName: e }) => /* @__PURE__ */ (0, Q.jsx)("div", {
	className: "flexbox-col flex-grow-1 dc__align-items-center dc__content-center dc__gap-12 w-100",
	children: /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "w-300 flexbox-col dc__gap-12",
		children: [/* @__PURE__ */ (0, Q.jsx)(ul, { size: 20 }), /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox-col dc__gap-4",
			children: [/* @__PURE__ */ (0, Q.jsxs)("h3", {
				className: "m-0 cn-9 fs-14 fw-6 lh-20 dc__truncate dc__align-center",
				children: ["Connecting to ", `'${e}'`]
			}), /* @__PURE__ */ (0, Q.jsx)("p", {
				className: "m-0 cn-8 fs-13 fw-4 lh-20 dc__align-center",
				children: "Trying to connect to the Kubernetes cluster and fetch resources"
			})]
		})]
	})
}), Jv = ({ combinedResourcesDataStore: e, clusterResourceDataStore: t, isClusterSelected: n, clusterFetchInfo: r, clusterName: i, reloadClusterData: a, resourceGroupIdentifierList: o, showSelectionCheckbox: s = !0, originalResourceCount: c, filteredResourceCount: l, handleClearFilters: u }) => {
	let d = A(() => Uv({
		combinedResourcesDataStore: e,
		resourceGroupIdentifierList: o,
		clusterResourceDataStore: t
	}), [
		e,
		o,
		t
	]);
	return n ? r.isLoading ? /* @__PURE__ */ (0, Q.jsx)(qv, { clusterName: i }) : r.error ? /* @__PURE__ */ (0, Q.jsx)(R, {
		title: `‘${i}’ is not reachable`,
		subTitle: r.error.errors?.[0]?.userMessage,
		isButtonAvailable: !0,
		renderButton: () => /* @__PURE__ */ (0, Q.jsx)(M, {
			dataTestId: "cluster-not-reachable-retry-btn",
			onClick: a,
			text: "Retry"
		})
	}) : l ? /* @__PURE__ */ (0, Q.jsx)(bu, {
		items: d,
		renderItem: (e) => {
			let { node: t } = e;
			if (t.isGroup) {
				let { name: e, clusterResourceCount: n } = t;
				return /* @__PURE__ */ (0, Q.jsx)(Mv, {
					isDisabled: !0,
					showSelectionCheckbox: s,
					resourceGroupIdentifier: e,
					clusterResourceCount: n
				});
			}
			let { name: n, namespace: r, isResourcePresentInCluster: i } = t;
			return /* @__PURE__ */ (0, Q.jsx)(jv, {
				name: n,
				namespace: r,
				isResourcePresentInCluster: i,
				direction: s ? "start" : "end",
				resourceCopyButtonConfig: { isVisible: !1 },
				isDisabled: !0,
				showBgOnHover: !0
			});
		}
	}) : c ? /* @__PURE__ */ (0, Q.jsx)(oc, { handleClearFilters: u }) : /* @__PURE__ */ (0, Q.jsx)(R, {
		title: "No resources found",
		subTitle: "No resources found or you do not have the required permission"
	}) : /* @__PURE__ */ (0, Q.jsx)("div", {
		className: "flex",
		children: /* @__PURE__ */ (0, Q.jsx)(R, {
			title: "Select a cluster to compare with",
			SvgImage: Av
		})
	});
}, Yv = async (e, t, n) => {
	let r = t.filter((e) => !!e?.gvk && !Cv.includes(e.gvk.Kind)), { resourceDataStore: i, totalCount: a } = (await fo(r.map((t) => () => md(hd(String(e), Qa.value, t, {}), n)))).reduce((e, t, n) => {
		if (t.status === dl.FULFILLED) {
			let i = (t.value?.result?.data || []).filter((e) => e.name).map((e) => ({
				name: e.name,
				namespace: e.namespace || ""
			})), { gvk: a } = r[n], o = i.reduce((e, t) => {
				let n = Rv({
					name: t.name,
					namespace: t.namespace,
					group: a.Group,
					kind: a.Kind
				});
				return e[n] = t, e;
			}, {});
			return e.resourceDataStore[Lv(a.Group, a.Kind)] = {
				gvk: a,
				resources: i,
				resourceMap: o
			}, e.totalCount += i.length, e;
		}
		return e.resourceDataStore[Lv(r[n].gvk.Group, r[n].gvk.Kind)] = {
			gvk: r[n].gvk,
			resources: [],
			resourceMap: {}
		}, e;
	}, {
		resourceDataStore: {},
		totalCount: 0
	});
	return {
		clusterId: e,
		resourceDataStore: i,
		totalCount: a
	};
}, Xv = async ({ sourceClusterId: e, targetClusterId: t, compareClusterDataStore: n, signal: r }) => {
	let i = structuredClone(n);
	if (!e && !t) return {
		sourceClusterDataStore: i.sourceClusterDataStore,
		targetClusterDataStore: i.targetClusterDataStore
	};
	let a = await Promise.allSettled([e ? Sd(String(e)) : null, t ? Sd(String(t)) : null]);
	if ((!e || a[0].status === "rejected") && (!t || a[1].status === "rejected")) {
		if (a[0].status === "rejected") throw a[0].reason;
		if (a[1].status === "rejected") throw a[1].reason;
	}
	let o = a[0].status === "fulfilled" ? a[0].value?.result?.apiResources : [], s = a[1].status === "fulfilled" ? a[1].value?.result?.apiResources : [];
	return {
		sourceClusterDataStore: e ? await Yv(e, o, r) : i.sourceClusterDataStore,
		targetClusterDataStore: t ? await Yv(t, s, r) : i.targetClusterDataStore
	};
}, Zv = async ({ sourceClusterId: e, targetClusterId: t, compareClusterDataStore: n, signal: r }) => {
	let i = structuredClone(n) || Hv(e, t);
	if (!e && !t) return i;
	let { sourceClusterDataStore: a, targetClusterDataStore: o } = await Xv({
		sourceClusterId: e,
		targetClusterId: t,
		compareClusterDataStore: i,
		signal: r
	});
	return Bv({
		sourceClusterDataStore: a,
		targetClusterDataStore: o
	});
}, Qv = async (e, { name: t, namespace: n, manifestSourceClusterId: r, creationTargetClusterId: i, gvk: a }) => {
	let o = Iu({
		clusterId: r,
		group: a.Group,
		version: a.Version,
		kind: a.Kind,
		name: t,
		namespace: n
	}), { result: { manifestResponse: { manifest: s } } } = await nf(_l.K8S_RESOURCE, o, { abortControllerRef: e });
	Kt(await Fu({
		clusterId: i,
		manifest: Vv(s)
	}));
}, $v = async ({ name: e, namespace: t, clusterId: n, gvk: r }, i) => {
	try {
		let { manifestResponse: { manifest: a } } = await Un({
			name: e,
			namespace: t,
			clusterId: n,
			gvk: r,
			abortControllerRef: i
		});
		return a ? Tu(a) : "";
	} catch (e) {
		if (!pd(e)) {
			if (e.errors?.[0]?.code && +e.errors[0].code === eo.NOT_FOUND) return null;
			K(e);
		}
		throw e;
	}
}, ey = ({ isResourcePresentInCluster: e, clusterId: t, manifest: n, gvk: r, name: i, namespace: a }) => e ? wn({
	clusterId: t,
	gvk: r,
	name: i,
	namespace: a,
	manifest: n
}) : St({
	clusterId: t,
	manifest: n
}), ty = ({ compareClusterDataStore: e, resourceGroupIdentifier: t }) => {
	let { selectedIdentifiers: n, handleBulkSelection: r } = _f(), { resources: i, areAllResourcesPresentInBothClusters: a, group: o, kind: s } = e.resourceDataStore[t], c = e.sourceClusterDataStore.resourceDataStore[t], l = e.targetClusterDataStore.resourceDataStore[t], u = c?.resourceMap || {}, d = l?.resourceMap || {}, f = i.filter((e) => !!u[Rv({
		group: o,
		kind: s,
		...e
	})]).length, p = i.filter((e) => !!d[Rv({
		group: o,
		kind: s,
		...e
	})]).length, m = !a && i.every(({ name: e, namespace: t }) => {
		let r = Rv({
			name: e,
			namespace: t,
			group: o,
			kind: s
		});
		return !u[r] || !d[r] ? !!n[r] : !0;
	});
	return /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "dc__grid-half",
		children: [/* @__PURE__ */ (0, Q.jsx)(Mv, {
			isDisabled: a,
			isChecked: m,
			resourceGroupIdentifier: t,
			clusterResourceCount: f,
			onChange: () => {
				if (m) {
					r({
						action: Ao.CLEAR_IDENTIFIERS,
						data: { identifierIds: i.map(({ name: e, namespace: t }) => Rv({
							name: e,
							namespace: t,
							group: o,
							kind: s
						})) }
					});
					return;
				}
				let e = i.reduce((e, { name: t, namespace: n }) => {
					let r = Rv({
						name: t,
						namespace: n,
						group: o,
						kind: s
					});
					if (!u[r] || !d[r]) {
						let i = u[r] ? xv.TARGET : xv.SOURCE;
						e[r] = {
							name: t,
							namespace: n,
							resourceListIdentifier: Lv(o, s),
							clusterType: i
						};
					}
					return e;
				}, {});
				r({
					action: Ao.SELECT_IDENTIFIER,
					data: { identifierObject: e }
				});
			}
		}), /* @__PURE__ */ (0, Q.jsx)(Mv, {
			showSelectionCheckbox: !1,
			resourceGroupIdentifier: t,
			clusterResourceCount: p
		})]
	});
}, ny = ({ compareClusterDataStore: e, name: t, namespace: n, resourceIdentifier: r, resourceGroupIdentifier: i, handleOpenSourceClusterSingleResourceCreationDialog: a, handleOpenTargetClusterSingleResourceCreationDialog: o, handleCompareResource: s, sourceClusterName: c, targetClusterName: l }) => {
	let { selectedIdentifiers: u, handleBulkSelection: d } = _f(), { group: f, kind: p } = e.resourceDataStore[i], m = e.sourceClusterDataStore.resourceDataStore[i], h = e.targetClusterDataStore.resourceDataStore[i], g = m?.resourceMap || {}, _ = h?.resourceMap || {}, v = () => {
		if (u[r]) {
			d({
				action: Ao.CLEAR_IDENTIFIERS,
				data: { identifierIds: [r] }
			});
			return;
		}
		if (!g[r] || !_[r]) {
			let e = g[r] ? xv.TARGET : xv.SOURCE;
			d({
				action: Ao.SELECT_IDENTIFIER,
				data: { identifierObject: { [r]: {
					name: t,
					namespace: n,
					resourceListIdentifier: Lv(f, p),
					clusterType: e
				} } }
			});
		}
	}, y = (e = !0) => () => e ? a(r) : o(r), b = () => {
		s({
			resourceIdentifier: r,
			resourceListIdentifier: Lv(f, p)
		});
	}, x = !!g[r], S = !!_[r], C = !!u[r];
	return /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: `dc__grid-half dc__hover-n50 dc__opacity-hover dc__opacity-hover--parent ${C ? "bc-b50" : ""}`,
		children: [
			/* @__PURE__ */ (0, Q.jsx)(jv, {
				name: t,
				namespace: n,
				onChange: v,
				isResourcePresentInCluster: x,
				direction: "start",
				isChecked: C,
				isDisabled: x && S,
				resourceCopyButtonConfig: {
					isVisible: x && !S,
					onClick: y(!1),
					tooltip: `Create resource in ${l}`
				}
			}),
			/* @__PURE__ */ (0, Q.jsx)("div", {
				className: "dc__align-reload-center dc__zi-20 dc__opacity-hover--child bg__primary",
				children: /* @__PURE__ */ (0, Q.jsx)(M, {
					dataTestId: "compare-resources-button",
					ariaLabel: "Compare manifest",
					icon: /* @__PURE__ */ (0, Q.jsx)(Ar, {}),
					variant: F.secondary,
					style: P.neutral,
					size: I.xs,
					onClick: b
				})
			}),
			/* @__PURE__ */ (0, Q.jsx)(jv, {
				name: t,
				namespace: n,
				isResourcePresentInCluster: S,
				direction: "end",
				resourceCopyButtonConfig: {
					isVisible: !x && S,
					onClick: y(),
					tooltip: `Create resource in ${c}`
				}
			})
		]
	});
}, ry = ({ filteredCompareClusterDataStore: e, handleOpenSourceClusterSingleResourceCreationDialog: t, handleOpenTargetClusterSingleResourceCreationDialog: n, handleCompareResource: r, sourceClusterName: i, targetClusterName: a }) => {
	let o = A(() => Uv({
		combinedResourcesDataStore: e.resourceDataStore,
		resourceGroupIdentifierList: e.resourceGroupIdentifierList
	}), [e.resourceDataStore, e.resourceGroupIdentifierList]);
	return /* @__PURE__ */ (0, Q.jsx)(bu, {
		className: "flex-grow-1 vertical-divider vertical-divider--zi-2 dc__zi-0",
		items: o,
		renderItem: ({ node: o }) => {
			if (o.isGroup) {
				let { name: t } = o;
				return /* @__PURE__ */ (0, Q.jsx)(ty, {
					resourceGroupIdentifier: t,
					compareClusterDataStore: e
				});
			}
			let { name: s, namespace: c, resourceGroupIdentifier: l, resourceIdentifier: u } = o;
			return /* @__PURE__ */ (0, Q.jsx)(ny, {
				name: s,
				namespace: c,
				resourceGroupIdentifier: l,
				resourceIdentifier: u,
				compareClusterDataStore: e,
				handleOpenSourceClusterSingleResourceCreationDialog: t,
				handleOpenTargetClusterSingleResourceCreationDialog: n,
				handleCompareResource: r,
				sourceClusterName: i,
				targetClusterName: a
			});
		}
	});
}, iy = ({ sourceClusterFetchInfo: e, targetClusterFetchInfo: t, handleFetchSourceClusterData: n, handleFetchTargetClusterData: r, clusterOptions: i, selectedSourceClusterOption: a, selectedTargetClusterOption: o, compareClusterDataStore: s, filteredCompareClusterDataStore: c, selectedResourceGroupIdentifierOptionsList: l, setSelectedResourceGroupIdentifierOptionsList: u, resourceListFilter: d, setResourceListFilter: f, handleCompareResource: p }) => {
	let { selectedIdentifiers: m, handleBulkSelection: h } = _f(), [g, _] = j(null), [v, y] = j(null), b = A(() => {
		let e = s.resourceGroupIdentifierList || [], t = s.sourceClusterDataStore.resourceDataStore, n = s.targetClusterDataStore.resourceDataStore, r = e.reduce((e, r) => {
			let i = t[r], a = n[r], o = i?.gvk || a?.gvk, s = o?.Group || "K8sEmptyGroup", c = o?.Kind || r;
			return e[s] || (e[s] = []), e[s].push({
				label: c,
				value: r,
				tooltipProps: {
					content: c,
					placement: "right"
				}
			}), e;
		}, {});
		return Object.keys(r).map((e) => ({
			label: e,
			options: r[e].sort((e, t) => df(e.label, t.label))
		}));
	}, [s]), x = A(() => a && o ? Dv(a, o) : [], [a, o]), S = () => {
		h({ action: Ao.CLEAR_ALL_SELECTIONS });
	}, C = (e) => {
		S(), f(e.value);
	}, w = (e) => {
		S(), u(e || []);
	}, T = () => {
		S(), d !== Ov.value && C(Ov), w([]);
	}, ee = async (e) => {
		e.value !== a?.value && (S(), await n(e.value));
	}, E = async (e) => {
		e.value !== o?.value && (S(), await r(e.value));
	}, D = async () => {
		S(), await n(+a.value);
	}, te = async () => {
		o && (S(), await r(+o.value));
	}, ne = () => {
		y(xv.TARGET);
	}, re = () => {
		y(xv.SOURCE);
	}, ie = () => {
		_(null), y(null);
	}, ae = (e) => {
		_(e), re();
	}, oe = (e) => {
		_(e), ne();
	}, se = (e) => {
		let t = e.kind.reduce((e, t) => (e[t] = !0, e), {});
		w(l.filter(({ label: e }) => t[e]));
	}, ce = () => {
		w([]);
	}, le = Object.keys(m || {}), ue = le.length, { sourceClusterSelectedIdentifiers: de, targetClusterSelectedIdentifiers: fe } = le.reduce((e, t) => {
		let n = m[t];
		return n.clusterType === xv.SOURCE ? e.sourceClusterSelectedIdentifiers.push(t) : n.clusterType === xv.TARGET && e.targetClusterSelectedIdentifiers.push(t), e;
	}, {
		sourceClusterSelectedIdentifiers: [],
		targetClusterSelectedIdentifiers: []
	}), pe = () => {
		let e = v === xv.SOURCE ? a.value : o.value, t = v === xv.SOURCE ? o.value : a.value, n = v === xv.SOURCE ? de : fe, r = g ? [g] : n, i = v === xv.SOURCE ? s.targetClusterDataStore.resourceDataStore : s.sourceClusterDataStore.resourceDataStore;
		return r.map((n) => {
			let { name: r, namespace: a, resourceListIdentifier: o } = c.identifiersMap[n], { gvk: s } = i[o];
			return {
				name: r,
				additionalKeys: [{
					label: "Namespace",
					value: a,
					isSortable: !0,
					width: "150px"
				}, {
					label: "Kind",
					value: s.Kind,
					isSortable: !0,
					width: "150px"
				}],
				operation: (n) => Qv(n, {
					name: r,
					namespace: a,
					manifestSourceClusterId: t,
					creationTargetClusterId: e,
					gvk: s
				})
			};
		});
	}, me = !!a && !!o, he = e.isLoading || t.isLoading, ge = e.error || t.error, _e = me && !he && !ge && !c.areAllResourcesPresentInBothClusters, ve = (e) => e.Pending || e.Progressing ? /* @__PURE__ */ (0, Q.jsx)("span", {
		className: "dc__loading-dots",
		children: "Creating"
	}) : `${e.Completed} resource(s) created`;
	return /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flex-grow-1 flexbox-col mh-0",
		children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flex-grow-1 flexbox-col mh-0",
			children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox-col px-16 py-12 dc__gap-6",
				children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "flexbox dc__gap-12 dc__align-items-center",
					children: [/* @__PURE__ */ (0, Q.jsx)($s, {
						isDisabled: !1,
						isLoading: !1,
						placeholder: "Kind",
						inputId: "compare-clusters__resource-group-identifier-select",
						options: b,
						appliedFilterOptions: l,
						handleApplyFilter: w
					}), a && o && /* @__PURE__ */ (0, Q.jsx)(V, {
						inputId: "compare-clusters__resource-filter-select",
						options: x,
						value: Dd(x, d, null),
						onChange: C,
						isClearable: !1,
						menuSize: I.large
					})]
				}), /* @__PURE__ */ (0, Q.jsx)(Zs, {
					filterConfig: { kind: l.map(({ label: e }) => e) },
					onRemoveFilter: se,
					clearFilters: ce
				})]
			}), /* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox-col flex-grow-1 mh-0",
				children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "dc__grid-half vertical-divider pt-8 pb-7 dc__border-bottom-n1",
					children: [/* @__PURE__ */ (0, Q.jsx)(bv, {
						semanticPrefix: "source-cluster",
						selectInputId: wv,
						clusterOptions: i.filter((e) => e.value !== o?.value),
						selectedClusterOption: a,
						handleClusterSelect: ee,
						handleReload: D,
						showBulkSelectionCheckbox: !0,
						isBulkSelectionDisabled: !_e,
						areCurrentViewActionsDisabled: e.isLoading || t.isLoading
					}), /* @__PURE__ */ (0, Q.jsx)(bv, {
						semanticPrefix: "target-cluster",
						selectInputId: Tv,
						clusterOptions: i.filter((e) => e.value !== a?.value),
						selectedClusterOption: o,
						handleClusterSelect: E,
						handleReload: te,
						areCurrentViewActionsDisabled: t.isLoading || e.isLoading
					})]
				}), (() => {
					let n = !me || !!ge, r = s.totalResourceCount, i = c.totalResourceCount;
					return n || he ? /* @__PURE__ */ (0, Q.jsxs)("div", {
						className: "dc__grid-half vertical-divider vertical-divider--zi-2 flex-grow-1 dc__zi-0 mh-0",
						children: [/* @__PURE__ */ (0, Q.jsx)(Jv, {
							resourceGroupIdentifierList: c.resourceGroupIdentifierList,
							combinedResourcesDataStore: c.resourceDataStore,
							clusterResourceDataStore: c.sourceClusterDataStore.resourceDataStore,
							isClusterSelected: !!a,
							clusterFetchInfo: e,
							clusterName: a?.label,
							reloadClusterData: D,
							originalResourceCount: r,
							filteredResourceCount: i,
							handleClearFilters: T
						}), /* @__PURE__ */ (0, Q.jsx)(Jv, {
							resourceGroupIdentifierList: c.resourceGroupIdentifierList,
							combinedResourcesDataStore: c.resourceDataStore,
							clusterResourceDataStore: c.targetClusterDataStore.resourceDataStore,
							isClusterSelected: !!o,
							clusterFetchInfo: t,
							clusterName: o?.label,
							reloadClusterData: te,
							showSelectionCheckbox: !1,
							originalResourceCount: r,
							filteredResourceCount: i,
							handleClearFilters: T
						})]
					}) : r ? i ? /* @__PURE__ */ (0, Q.jsx)(ry, {
						filteredCompareClusterDataStore: c,
						handleOpenSourceClusterSingleResourceCreationDialog: ae,
						handleOpenTargetClusterSingleResourceCreationDialog: oe,
						handleCompareResource: p,
						sourceClusterName: a.label,
						targetClusterName: o.label
					}) : /* @__PURE__ */ (0, Q.jsx)(oc, { handleClearFilters: T }) : /* @__PURE__ */ (0, Q.jsx)(R, {
						title: "No resources found",
						subTitle: "No resources found or you do not have the required permission"
					});
				})()]
			})]
		}), ue > 0 && /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "dc__grid-half vertical-divider dc__border-top dc__no-shrink",
			children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox dc__content-space dc__align-items-center px-16 py-12",
				children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "flexbox dc__gap-12 dc__align-items-center",
					children: [/* @__PURE__ */ (0, Q.jsx)(M, {
						dataTestId: "deselect-all-resources-button",
						variant: F.borderLess,
						style: P.negative,
						onClick: S,
						icon: /* @__PURE__ */ (0, Q.jsx)(tr, {}),
						ariaLabel: "Deselect all resources",
						showAriaLabelInTippy: !1,
						size: I.small
					}), /* @__PURE__ */ (0, Q.jsxs)("span", {
						className: "cn-9 fs-13 fw-6 lh-20 dc__word-break",
						children: [ue, " resources selected"]
					})]
				}), fe.length > 0 && /* @__PURE__ */ (0, Q.jsx)(M, {
					dataTestId: "create-resources-in-target-cluster-button",
					text: `Create ${fe.length} resources`,
					size: I.small,
					endIcon: /* @__PURE__ */ (0, Q.jsx)(Kn, {}),
					onClick: ne
				})]
			}), /* @__PURE__ */ (0, Q.jsx)("div", {
				className: "flexbox dc__align-items-center px-16 py-10",
				children: de.length > 0 && /* @__PURE__ */ (0, Q.jsx)(M, {
					dataTestId: "create-resources-in-source-cluster-button",
					text: `Create ${de.length} resources`,
					size: I.small,
					startIcon: /* @__PURE__ */ (0, Q.jsx)(Kn, { className: "dc__flip-180" }),
					onClick: re
				})
			})]
		})]
	}), !!v && (() => {
		let e = v === xv.SOURCE ? a.label : o.label, t = pe(), n = t.length === 1;
		return /* @__PURE__ */ (0, Q.jsx)(Oo, {
			confirmationModalConfig: {
				title: n ? `Create resource in '${e}'` : `Create ${t.length} resources in '${e}'`,
				subtitle: `${n ? `This will create the ${t[0].additionalKeys.find(({ label: e }) => e === "Kind").value} / ${t[0].name} in the ${e}.` : `This will create the selected resources in the ${e}.`}. Are you sure?`,
				variant: rs.info,
				confirmationConfig: {
					identifier: "resource-creation-confirmation",
					confirmationKeyword: e
				},
				buttonConfig: {
					primaryButtonConfig: { text: n ? "Create resource" : "Create resources" },
					secondaryButtonConfig: { text: "Cancel" }
				}
			},
			getResultsChartSummaryText: ve,
			handleModalClose: ie,
			handleReloadDataAfterBulkOperation: v === xv.SOURCE ? D : te,
			textConfig: {
				resultsHeader: "Resource creation status",
				prompt: ds
			},
			operations: t
		});
	})()] });
}, ay = (e) => /* @__PURE__ */ (0, Q.jsx)("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 20 20",
	...e,
	children: /* @__PURE__ */ (0, Q.jsx)("path", {
		fill: "#B1B7BC",
		className: "fill-color",
		fillRule: "evenodd",
		d: "M10 18.333c4.6 0 8.333-3.733 8.333-8.333S14.6 1.667 10 1.667 1.667 5.4 1.667 10 5.4 18.333 10 18.333zm0-1.666c-3.68 0-6.667-2.987-6.667-6.667 0-3.68 2.987-6.667 6.667-6.667 3.68 0 6.667 2.987 6.667 6.667 0 3.68-2.987 6.667-6.667 6.667zm0-5.834c.46 0 .833-.373.833-.833V6.667c0-.46-.373-.834-.833-.834-.46 0-.833.373-.833.834V10c0 .46.373.833.833.833zm0 3.334c.46 0 .833-.373.833-.834 0-.46-.373-.833-.833-.833-.46 0-.833.373-.833.833 0 .46.373.834.833.834z"
	})
}), oy = ({ errorMsg: e }) => /* @__PURE__ */ (0, Q.jsxs)("div", {
	className: "dc__text-center flex-grow-1 flexbox-col dc__align-items-center dc__content-center",
	children: [/* @__PURE__ */ (0, Q.jsx)(ay, { className: "fcn-7 icon-dim-32" }), /* @__PURE__ */ (0, Q.jsx)("p", {
		className: "m-0 fs-14",
		children: e
	})]
}), sy = ({ resourceIdentifier: e, resourceListIdentifier: t, filteredCompareClusterDataStore: n, selectedSourceClusterOption: r, selectedTargetClusterOption: i, handleGoBack: a, setCompareClusterDataStore: o }) => {
	let [s, c] = j(!0), [l, u] = j(!1), [d, f] = j({
		value: "",
		hasError: !1,
		isSuccess: !1,
		hasUnsavedChanges: !1
	}), [p, m] = j({
		value: "",
		hasError: !1,
		isSuccess: !1,
		hasUnsavedChanges: !1
	}), h = Ja(new AbortController()), g = Ja(new AbortController()), _ = Ja(!0), v = Ja({
		source: !1,
		target: !1
	}), y = r.value, b = i.value, x = s || l, { gvk: S, isResourcePresentInSourceCluster: C, isResourcePresentInTargetCluster: w, name: T, namespace: ee } = Wv({
		filteredCompareClusterDataStore: n,
		resourceIdentifier: e,
		resourceListIdentifier: t
	}), [E, D, te, ne] = hf(() => Du(() => $v({
		gvk: S,
		name: T,
		clusterId: y,
		namespace: ee
	}, h), h), [], C), [re, ie, ae, oe] = hf(() => Du(() => $v({
		gvk: S,
		name: T,
		clusterId: b,
		namespace: ee
	}, g), g), [], w), se = C || w, ce = !E && !re && !te && !ae, le = E || re, ue = le || l;
	Of({
		shouldPrompt: d.hasUnsavedChanges || p.hasUnsavedChanges,
		message: fu
	}), k(() => () => {
		h.current.abort(), g.current.abort();
	}, []), k(() => {
		E || (f({
			value: D ?? "",
			hasError: !1,
			hasUnsavedChanges: !1,
			isSuccess: v.current.source
		}), v.current.source = !1);
	}, [E, D]), k(() => {
		re || (m({
			value: ie ?? "",
			hasError: !1,
			hasUnsavedChanges: !1,
			isSuccess: v.current.target
		}), v.current.target = !1);
	}, [re, ie]);
	let de = () => {
		c(!1);
	}, fe = (e) => {
		m({
			...p,
			value: e,
			hasError: !1,
			hasUnsavedChanges: e !== (ie ?? "")
		});
	}, pe = (e) => {
		f({
			...d,
			value: e,
			hasError: !1,
			hasUnsavedChanges: e !== (D ?? "")
		});
	}, me = () => {
		c(!0), f({
			value: D ?? "",
			hasUnsavedChanges: !1,
			hasError: !1,
			isSuccess: !1
		}), m({
			value: ie ?? "",
			hasUnsavedChanges: !1,
			hasError: !1,
			isSuccess: !1
		});
	}, ge = ({ clusterType: e, resourceManifest: n }) => {
		o((r) => Kv({
			compareClusterDataStore: r,
			clusterType: e,
			gvk: S,
			resourceListIdentifier: t,
			resourceManifest: n
		}));
	}, _e = async () => {
		try {
			u(!0);
			let [e, t] = await Promise.allSettled([d.hasUnsavedChanges ? ey({
				isResourcePresentInCluster: C,
				clusterId: y,
				manifest: d.value,
				gvk: S,
				name: T,
				namespace: ee
			}) : null, p.hasUnsavedChanges ? ey({
				isResourcePresentInCluster: w,
				clusterId: b,
				manifest: p.value,
				gvk: S,
				name: T,
				namespace: ee
			}) : null]);
			e.status === "fulfilled" && t.status === "fulfilled" ? (H.showToast({
				variant: U.success,
				description: "Changes applied successfully"
			}), e.value && (ge({
				clusterType: xv.SOURCE,
				resourceManifest: d.value
			}), ne()), t.value && (ge({
				clusterType: xv.TARGET,
				resourceManifest: p.value
			}), oe()), u(!1), c(!0)) : e.status === "fulfilled" && e.value ? (v.current.source = !0, ge({
				clusterType: xv.SOURCE,
				resourceManifest: d.value
			}), ne()) : t.status === "fulfilled" && t.value && (v.current.target = !0, ge({
				clusterType: xv.TARGET,
				resourceManifest: p.value
			}), oe()), e.status === "rejected" && (f((e) => ({
				...e,
				hasError: !0,
				isSuccess: !1
			})), K(e.reason)), t.status === "rejected" && (m((e) => ({
				...e,
				hasError: !0,
				isSuccess: !1
			})), K(t.reason)), (e.status === "rejected" || t.status === "rejected") && u(!1);
		} catch (e) {
			u(!1), K(e);
		}
	}, ve = () => s ? /* @__PURE__ */ (0, Q.jsx)(M, {
		dataTestId: "edit-yaml-button",
		startIcon: /* @__PURE__ */ (0, Q.jsx)(Ee, {}),
		variant: F.borderLess,
		size: I.small,
		text: "Edit YAML",
		disabled: le,
		onClick: de
	}) : /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flex dc__gap-12",
		children: [/* @__PURE__ */ (0, Q.jsx)(M, {
			dataTestId: "apply-yaml-changes-button",
			startIcon: /* @__PURE__ */ (0, Q.jsx)(he, {}),
			variant: F.borderLess,
			size: I.small,
			text: "Apply Changes",
			isLoading: ue,
			disabled: ue,
			onClick: _e
		}), /* @__PURE__ */ (0, Q.jsx)(M, {
			dataTestId: "cancel-yaml-changes-button",
			variant: F.text,
			style: P.neutral,
			size: I.small,
			text: "Cancel",
			disabled: ue,
			onClick: me
		})]
	}), ye = ({ hasError: e, isSuccess: t, hasUnsavedChanges: n }) => e ? /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flex dc__gap-6 mr-16",
		children: [/* @__PURE__ */ (0, Q.jsx)(mt, { className: "icon-dim-16" }), /* @__PURE__ */ (0, Q.jsx)("p", {
			className: "m-0 fs-13 lh-20 cr-5",
			children: "Failed to apply changes"
		})]
	}) : n ? /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flex dc__gap-6 mr-16",
		children: [/* @__PURE__ */ (0, Q.jsx)("span", { className: "w-8 h-8 dc__border-radius-50-per bcy-5" }), /* @__PURE__ */ (0, Q.jsx)("p", {
			className: "m-0 fs-13 lh-20 cn-7",
			children: "Unsaved changes"
		})]
	}) : t ? /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flex dc__gap-6 mr-16",
		children: [/* @__PURE__ */ (0, Q.jsx)(he, { className: "icon-dim-16 scg-5" }), /* @__PURE__ */ (0, Q.jsx)("p", {
			className: "m-0 fs-13 lh-20 cg-7",
			children: "Changes applied"
		})]
	}) : null, be = (e, t, n, r) => e ? /* @__PURE__ */ (0, Q.jsx)(ul, { pageLoader: !0 }) : t ? /* @__PURE__ */ (0, Q.jsx)(oy, { errorMsg: kv.MANIFEST_NOT_AVAILABLE }) : /* @__PURE__ */ (0, Q.jsx)(Xo, {
		mode: Ic.YAML,
		noParsing: !0,
		readOnly: x,
		value: n,
		height: "100%",
		onChange: r
	});
	return /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flex-grow-1 flexbox-col mh-0",
		children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox dc__align-items-center dc__content-space px-16 py-10",
			children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flex left dc__gap-12 py-2",
				children: [/* @__PURE__ */ (0, Q.jsx)(M, {
					dataTestId: "go-back-to-clusters-resource-list",
					ariaLabel: "go-back-to-clusters-resource-list",
					icon: /* @__PURE__ */ (0, Q.jsx)(Kn, { className: "dc__flip-180" }),
					variant: F.secondary,
					style: P.neutral,
					size: I.xs,
					showAriaLabelInTippy: !1,
					onClick: a,
					disabled: l
				}), se && /* @__PURE__ */ (0, Q.jsx)("h2", {
					className: "m-0 fs-14 lh-20 fw-6",
					children: `${S.Kind} / ${T}`
				})]
			}), se && ce && ve()]
		}), se ? /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flex",
			children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flex-grow-1 dc__grid-half vertical-divider pt-8 pb-7 dc__border-bottom-n1",
				children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "flexbox dc__align-items-center dc__content-space",
					children: [/* @__PURE__ */ (0, Q.jsx)(bv, {
						variant: "text",
						semanticPrefix: "source-cluster",
						selectedClusterOption: r
					}), ye(d)]
				}), /* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "flexbox dc__align-items-center dc__content-space",
					children: [/* @__PURE__ */ (0, Q.jsx)(bv, {
						variant: "text",
						semanticPrefix: "target-cluster",
						selectedClusterOption: i
					}), ye(p)]
				})]
			}), /* @__PURE__ */ (0, Q.jsx)("div", { className: `dc__align-self-stretch ${s ? "px-15" : "px-5"}` })]
		}), _.current && (E || re) ? (_.current = !1, /* @__PURE__ */ (0, Q.jsx)(ul, { pageLoader: !0 })) : ce ? /* @__PURE__ */ (0, Q.jsx)(Xo, {
			mode: Ic.YAML,
			noParsing: !0,
			diffView: !0,
			readOnly: x,
			originalValue: d.value,
			modifiedValue: p.value,
			height: "fitToParent",
			isOriginalModifiable: !0,
			onOriginalValueChange: pe,
			onModifiedValueChange: fe
		}) : /* @__PURE__ */ (0, Q.jsx)("div", {
			className: "flex h-100",
			children: /* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "dc__align-self-stretch flex-grow-1 dc__grid-half vertical-divider",
				children: [be(E, te, d.value, pe), be(re, ae, p.value, fe)]
			})
		})] }) : /* @__PURE__ */ (0, Q.jsx)(oy, { errorMsg: kv.RESOURCE_DOES_NOT_EXIST })]
	});
}, cy = () => Vl.CLOSED, ly = ({ clusterList: e }) => {
	let { sourceClusterId: t, targetClusterId: n, resourceListFilter: r, compareResourceIdentifier: i, compareResourceListIdentifier: a, updateSearchParams: o } = Pf({ parseSearchParams: Iv }), [s, c] = j([]), [l, u] = j({
		isLoading: !1,
		error: null
	}), [d, f] = j({
		isLoading: !1,
		error: null
	}), p = Ja(new AbortController()), [m, h, g, _, v] = hf(() => Zv({
		sourceClusterId: t,
		targetClusterId: n,
		signal: p.current.signal
	}));
	k(() => () => {
		p.current.abort();
	}, []), k(() => {
		u({
			isLoading: m && !!t,
			error: null
		}), f({
			isLoading: m && !!n,
			error: null
		});
	}, [m]);
	let y = !!(i && a), b = A(() => h ? Bv({
		sourceClusterDataStore: h.sourceClusterDataStore,
		targetClusterDataStore: h.targetClusterDataStore,
		resourceFilterType: r,
		selectedResourceGroupIdentifierOptionsList: s
	}) : Hv(t, n), [
		h,
		r,
		s
	]), x = e.map(({ id: e, name: t, isProd: n }) => Fv({
		id: e,
		name: t,
		isProd: n
	})).sort((e, t) => df(e.label.toString(), t.label.toString())), { selectedSourceClusterOption: S, selectedTargetClusterOption: C } = e.reduce((e, { id: r, name: i, isProd: a }) => (r === t ? e.selectedSourceClusterOption = Fv({
		id: t,
		name: i || "",
		isProd: a
	}) : r === n && (e.selectedTargetClusterOption = Fv({
		id: n,
		name: i || "",
		isProd: a
	})), e), {
		selectedSourceClusterOption: null,
		selectedTargetClusterOption: null
	}), w = (e) => {
		o({ sourceClusterId: e });
	}, T = (e) => {
		o({ targetClusterId: e });
	};
	return /* @__PURE__ */ (0, Q.jsx)($a, {
		isLoading: y && m,
		progressingProps: { pageLoader: !0 },
		error: g,
		errorScreenManagerProps: {
			code: g?.code,
			reload: _,
			redirectURL: B.RESOURCE_BROWSER.ROOT
		},
		children: y ? /* @__PURE__ */ (0, Q.jsx)(sy, {
			resourceIdentifier: i,
			resourceListIdentifier: a,
			filteredCompareClusterDataStore: b,
			selectedSourceClusterOption: S,
			selectedTargetClusterOption: C,
			handleGoBack: () => {
				o({
					compareResourceIdentifier: null,
					compareResourceListIdentifier: null
				});
			},
			setCompareClusterDataStore: v
		}) : /* @__PURE__ */ (0, Q.jsx)(jo, {
			identifiers: b.identifiersMap,
			getSelectAllDialogStatus: cy,
			children: /* @__PURE__ */ (0, Q.jsx)(iy, {
				sourceClusterFetchInfo: l,
				targetClusterFetchInfo: d,
				handleFetchSourceClusterData: async (e) => {
					u({
						isLoading: !0,
						error: null
					}), w(e), v(Bv({
						sourceClusterDataStore: {
							clusterId: e,
							resourceDataStore: {},
							totalCount: 0
						},
						targetClusterDataStore: h.targetClusterDataStore
					}));
					try {
						let t = await Zv({
							sourceClusterId: e,
							compareClusterDataStore: h,
							signal: p.current.signal
						});
						p.current = new AbortController(), v(t), u({
							isLoading: !1,
							error: null
						});
					} catch (e) {
						u({
							isLoading: !1,
							error: e
						});
					}
				},
				handleFetchTargetClusterData: async (e) => {
					f({
						isLoading: !0,
						error: null
					}), T(e), v(Bv({
						sourceClusterDataStore: h.sourceClusterDataStore,
						targetClusterDataStore: {
							clusterId: e,
							resourceDataStore: {},
							totalCount: 0
						}
					}));
					try {
						let t = await Zv({
							targetClusterId: e,
							compareClusterDataStore: h,
							signal: p.current.signal
						});
						p.current = new AbortController(), v(t), f({
							isLoading: !1,
							error: null
						});
					} catch (e) {
						f({
							isLoading: !1,
							error: e
						});
					}
				},
				clusterOptions: x,
				selectedSourceClusterOption: S,
				selectedTargetClusterOption: C,
				compareClusterDataStore: h ?? Hv(t, n),
				filteredCompareClusterDataStore: b,
				selectedResourceGroupIdentifierOptionsList: s,
				setSelectedResourceGroupIdentifierOptionsList: c,
				resourceListFilter: r,
				setResourceListFilter: (e) => {
					o({ resourceListFilter: e });
				},
				handleCompareResource: ({ resourceIdentifier: e, resourceListIdentifier: t }) => {
					o({
						compareResourceIdentifier: e,
						compareResourceListIdentifier: t
					}, { redirectionMethod: "push" });
				}
			})
		})
	});
}, uy = () => {
	let [e, t, n, r] = hf(() => Xu()), { breadcrumbs: i } = gf(B.RESOURCE_BROWSER.COMPARE_CLUSTERS, Pv()), a = () => /* @__PURE__ */ (0, Q.jsx)(Co, {
		breadcrumbs: i,
		path: B.RESOURCE_BROWSER.COMPARE_CLUSTERS
	}), o = (t?.result || []).filter((e) => !e.isVirtualCluster);
	return /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "bg__primary flexbox-col h-100 dc__overflow-auto",
		children: [/* @__PURE__ */ (0, Q.jsx)(Qc, {
			isBreadcrumbs: !0,
			breadCrumbs: a,
			docPath: gs.INFRA_MANAGEMENT
		}), /* @__PURE__ */ (0, Q.jsx)($a, {
			isLoading: e,
			progressingProps: { pageLoader: !0 },
			error: n,
			errorScreenManagerProps: {
				code: n?.code,
				redirectURL: B.RESOURCE_BROWSER.ROOT,
				reload: r
			},
			children: o.length ? /* @__PURE__ */ (0, Q.jsx)(ly, { clusterList: o }) : /* @__PURE__ */ (0, Q.jsx)(R, {
				classname: "flex-grow-1",
				title: "No Clusters Found",
				subTitle: "Please add a cluster to compare"
			})
		})]
	});
}, dy = {
	Group: "pincher.devtron.ai",
	Version: "v1alpha1",
	Kind: "Hibernator"
}, fy = async (e, t) => {
	try {
		let n = ((await md({
			clusterId: +e,
			k8sRequest: { resourceIdentifier: { groupVersionKind: dy } }
		}))?.result?.data || []).map((e) => ({
			name: e?.name,
			namespace: e?.namespace
		})).filter((e) => e.name && e.namespace);
		return (await fo(n.map((n) => () => Un({
			name: n.name,
			namespace: n.namespace,
			abortControllerRef: t,
			gvk: dy,
			clusterId: +e
		})))).reduce((e, t, r) => {
			let { name: i, namespace: a } = n[r], o = Id(), s = t?.status === dl.FULFILLED ? t?.value?.manifestResponse?.manifest : null;
			return s && (e[o] = {
				id: o,
				name: i,
				data: s,
				namespace: a,
				isSelected: r === 0
			}), e;
		}, {});
	} catch {
		return {};
	}
}, py = (e) => ({
	$schema: "http://json-schema.org/draft-07/schema#",
	type: "object",
	title: "Hibernator Configuration",
	description: "Configuration for Hibernator resource to manage hibernation of Kubernetes workloads",
	properties: {
		metadata: {
			type: "object",
			title: "Metadata",
			properties: {
				name: {
					type: "string",
					title: "Name",
					description: "Name of the hibernator resource",
					minLength: 1,
					readOnly: e
				},
				namespace: {
					type: "string",
					title: "Namespace",
					description: "Namespace where the hibernator resource will be created",
					default: "default",
					minLength: 1,
					readOnly: e
				}
			},
			required: ["name", "namespace"]
		},
		spec: {
			type: "object",
			title: "Hibernator Specification",
			properties: {
				action: {
					type: "string",
					title: "Action",
					description: "Action to be performed by the hibernator",
					enum: [
						"hibernate",
						"unhibernate",
						"pause"
					],
					default: "hibernate"
				},
				hibernate: {
					type: "boolean",
					title: "Hibernate",
					description: "Enable hibernation for selected resources",
					default: !1
				},
				unHibernate: {
					type: "boolean",
					title: "Un-Hibernate",
					description: "Disable hibernation for selected resources",
					default: !1
				},
				pause: {
					type: "boolean",
					title: "Pause",
					description: "Pause hibernation operations",
					default: !1
				},
				pauseUntil: {
					type: "object",
					title: "Pause Until",
					description: "Pause hibernation until specified date and time",
					properties: {
						dateTime: {
							type: "string",
							title: "Date Time",
							description: "Date and time until which hibernation should be paused",
							format: "date-time"
						},
						timeZone: {
							type: "string",
							title: "Time Zone",
							description: "Time zone for the specified date time",
							default: "UTC"
						}
					},
					required: ["dateTime", "timeZone"]
				},
				deleteStore: {
					type: "boolean",
					title: "Delete Store",
					description: "Delete persistent storage when hibernating",
					default: !1
				},
				reSyncInterval: {
					type: "integer",
					title: "Re-sync Interval",
					description: "Interval in seconds for re-syncing hibernator state",
					minimum: 1,
					default: 300
				},
				revisionHistoryLimit: {
					type: "integer",
					title: "Revision History Limit",
					description: "Number of revision history entries to keep",
					minimum: 0,
					default: 10
				},
				targetReplicas: {
					type: "array",
					title: "Target Replicas",
					description: "Array of target replica counts for different resources",
					items: {
						type: "integer",
						minimum: 0
					}
				},
				selectors: {
					type: "array",
					title: "Resource Selectors",
					description: "Selectors to identify resources for hibernation",
					items: {
						type: "object",
						title: "Selector",
						properties: {
							inclusions: {
								type: "array",
								title: "Inclusions",
								description: "Resources to include in hibernation",
								items: {
									type: "object",
									title: "Inclusion Rule",
									properties: {
										namespaceSelector: {
											type: "object",
											title: "Namespace Selector",
											properties: {
												name: {
													type: "string",
													title: "Namespace Name",
													description: "Specific namespace name to target"
												},
												labels: {
													type: "array",
													title: "Labels",
													description: "Label selectors for namespace",
													items: { type: "string" }
												},
												fieldSelector: {
													type: "array",
													title: "Field Selectors",
													description: "Field selectors for namespace",
													items: { type: "string" }
												}
											}
										},
										objectSelector: {
											type: "object",
											title: "Object Selector",
											properties: {
												type: {
													type: "string",
													title: "Resource Type",
													description: "Kubernetes resource type (e.g., Deployment, StatefulSet)",
													enum: [
														"Deployment",
														"StatefulSet",
														"DaemonSet",
														"ReplicaSet",
														"Job",
														"CronJob"
													]
												},
												name: {
													type: "string",
													title: "Resource Name",
													description: "Specific resource name to target"
												},
												labels: {
													type: "array",
													title: "Labels",
													description: "Label selectors for the resource",
													items: { type: "string" }
												},
												fieldSelector: {
													type: "array",
													title: "Field Selectors",
													description: "Field selectors for the resource",
													items: { type: "string" }
												}
											},
											required: ["type"]
										}
									},
									required: ["objectSelector"]
								},
								minItems: 1
							},
							exclusions: {
								type: "array",
								title: "Exclusions",
								description: "Resources to exclude from hibernation",
								items: {
									type: "object",
									title: "Exclusion Rule",
									properties: {
										namespaceSelector: {
											type: "object",
											title: "Namespace Selector",
											properties: {
												name: {
													type: "string",
													title: "Namespace Name",
													description: "Specific namespace name to exclude"
												},
												labels: {
													type: "array",
													title: "Labels",
													description: "Label selectors for namespace",
													items: { type: "string" }
												},
												fieldSelector: {
													type: "array",
													title: "Field Selectors",
													description: "Field selectors for namespace",
													items: { type: "string" }
												}
											}
										},
										objectSelector: {
											type: "object",
											title: "Object Selector",
											properties: {
												type: {
													type: "string",
													title: "Resource Type",
													description: "Kubernetes resource type to exclude",
													enum: [
														"Deployment",
														"StatefulSet",
														"DaemonSet",
														"ReplicaSet",
														"Job",
														"CronJob"
													]
												},
												name: {
													type: "string",
													title: "Resource Name",
													description: "Specific resource name to exclude"
												},
												labels: {
													type: "array",
													title: "Labels",
													description: "Label selectors for the resource",
													items: { type: "string" }
												},
												fieldSelector: {
													type: "array",
													title: "Field Selectors",
													description: "Field selectors for the resource",
													items: { type: "string" }
												}
											},
											required: ["type"]
										}
									},
									required: ["objectSelector"]
								}
							}
						},
						required: ["inclusions"]
					},
					minItems: 1
				},
				timeRangesWithZone: {
					type: "object",
					title: "Time Ranges with Zone",
					description: "Time-based hibernation configuration",
					properties: {
						timeZone: {
							type: "string",
							title: "Time Zone",
							description: "Default time zone for time ranges",
							default: "UTC"
						},
						timeRanges: {
							type: "array",
							title: "Time Ranges",
							description: "Array of time ranges for hibernation scheduling",
							items: {
								type: "object",
								title: "Time Range",
								properties: {
									timeFrom: {
										type: "string",
										title: "Time From",
										description: "Start time (HH:MM format)",
										pattern: "^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$"
									},
									timeTo: {
										type: "string",
										title: "Time To",
										description: "End time (HH:MM format)",
										pattern: "^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$"
									},
									weekdayFrom: {
										type: "string",
										title: "Weekday From",
										description: "Starting day of the week",
										enum: [
											"monday",
											"tuesday",
											"wednesday",
											"thursday",
											"friday",
											"saturday",
											"sunday"
										]
									},
									weekdayTo: {
										type: "string",
										title: "Weekday To",
										description: "Ending day of the week",
										enum: [
											"monday",
											"tuesday",
											"wednesday",
											"thursday",
											"friday",
											"saturday",
											"sunday"
										]
									},
									timeZone: {
										type: "string",
										title: "Time Zone Override",
										description: "Override the default time zone for this range"
									},
									cronExpressionFrom: {
										type: "string",
										title: "Cron Expression From",
										description: "Cron expression for start time (alternative to timeFrom/weekdayFrom)"
									},
									cronExpressionTo: {
										type: "string",
										title: "Cron Expression To",
										description: "Cron expression for end time (alternative to timeTo/weekdayTo)"
									}
								},
								required: [
									"timeFrom",
									"timeTo",
									"weekdayFrom",
									"weekdayTo"
								]
							}
						}
					},
					required: ["timeRanges"]
				}
			},
			required: ["action", "selectors"]
		}
	},
	required: ["metadata", "spec"]
}), my = (e, t) => {
	let n = {};
	return Object.entries(e).forEach(([e, r]) => {
		jl.validateFormData(r.data, py(!!t[e]))?.errors?.length && (n[e] = !0);
	}), n;
}, hy = (e, t, n) => {
	let r = Object.keys(n || {}).filter((e) => !t[e]).map((t) => {
		let r = n[t];
		return {
			name: r.name,
			operation: (t) => zu({
				clusterId: +e,
				k8sRequest: { resourceIdentifier: {
					groupVersionKind: dy,
					namespace: r.namespace,
					name: r.name
				} }
			}, t)
		};
	});
	return [...Object.values(t).map((t) => {
		let r = n[t.id], i = {
			kind: dy.Kind,
			apiVersion: "pincher.devtron.ai/v1alpha1",
			...t.data
		};
		return r ? {
			name: t.name,
			operation: (t) => wn({
				name: r.name,
				namespace: r.namespace,
				clusterId: +e,
				gvk: dy,
				manifest: Tu(i)
			}, t)
		} : {
			name: t.name,
			operation: (t) => St({
				clusterId: +e,
				manifest: Tu(i)
			}, t)
		};
	}), ...r];
}, gy = ({ handleClose: e, clusterId: t }) => {
	let [n, r] = j({}), i = Ja(new AbortController()), [a, o] = hf(() => fy(+t, i), [t], !!t), [s, c] = j({}), [l, u] = j(!1);
	k(() => () => {
		i.current.abort();
	}, []), k(() => {
		!a && o && r(o);
	}, [a, o]);
	let d = Object.keys(o || {}), f = Object.keys(n), p = f.find((e) => n[e].isSelected) || n[f[0]]?.id || null, m = () => {
		let e = Id();
		r((t) => {
			let n = structuredClone(t);
			return Object.keys(n).forEach((e) => {
				n[e].isSelected = !1;
			}), n[e] = {
				id: e,
				name: "",
				namespace: "",
				data: {},
				isSelected: !0
			}, n;
		});
	}, h = (e) => (t) => {
		t.stopPropagation(), r((t) => {
			let n = structuredClone(t);
			return delete n[e], n;
		});
	}, g = ({ formData: e, errors: t }) => {
		c((e) => {
			let n = structuredClone(e);
			return t?.length ? n[p] = !0 : delete n[p], n;
		}), r((t) => {
			let n = structuredClone(t);
			return p && (n[p].name = e.metadata?.name || "", n[p].namespace = e.metadata?.namespace || "", n[p].data = e), n;
		});
	}, _ = () => {
		if (f.length === 0 && d.length === 0) {
			H.showToast({
				variant: U.error,
				description: "Please add at least one hibernation rule."
			});
			return;
		}
		let e = my(n, o);
		if (c(e), Object.keys(e).length) {
			H.showToast({
				variant: U.error,
				description: "Please fix the errors in the form before applying changes."
			});
			return;
		}
		u(!0);
	}, v = () => /* @__PURE__ */ (0, Q.jsx)("div", {
		className: "flexbox-col dc__gap-20 bg__primary br-8 border__secondary",
		children: /* @__PURE__ */ (0, Q.jsx)(gl, {
			className: "w-100",
			schema: py(!!o[p]),
			formData: n[p].data || {},
			onChange: g,
			experimental_defaultFormStateBehavior: { emptyObjectFields: "skipDefaults" },
			liveValidate: !0,
			uiSchema: mc
		})
	}), y = () => /* @__PURE__ */ (0, Q.jsx)(M, {
		dataTestId: "add-rule-button-empty-state",
		variant: F.secondary,
		size: I.medium,
		startIcon: /* @__PURE__ */ (0, Q.jsx)(z, {
			name: "ic-add",
			color: null
		}),
		text: "Add Rule",
		onClick: m
	}), b = (e) => (t) => {
		t.stopPropagation(), !("key" in t && t.key !== "Enter" && t.key !== " ") && r((t) => {
			let n = structuredClone(t);
			return Object.keys(n).forEach((t) => {
				n[t].isSelected = t === e;
			}), n;
		});
	};
	return l ? /* @__PURE__ */ (0, Q.jsx)(Oo, {
		data: null,
		operations: hy(t, n, o),
		textConfig: {
			prompt: ds,
			resultsHeader: "Hibernation Rules"
		},
		shouldSkipConfirmation: !0,
		handleModalClose: e,
		handleReloadDataAfterBulkOperation: e,
		getResultsChartSummaryText: (e) => {
			let { Pending: t, Progressing: n, Completed: r } = e;
			return t || n ? /* @__PURE__ */ (0, Q.jsx)("span", {
				className: "cn-8 fs-12 fw-4 lh-20",
				children: "Applying hibernation rules"
			}) : `${r} resource(s) hibernation rules applied`;
		},
		disableTransition: !0
	}) : /* @__PURE__ */ (0, Q.jsx)(Rs, {
		position: "right",
		width: "1024px",
		onEscape: e,
		onClose: e,
		children: /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox-col dc__content-space h-100 bg__modal--primary shadow__modal dc__overflow-auto",
			onClick: uf,
			children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox-col dc__overflow-auto flex-grow-1",
				children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "px-20 py-12 flexbox dc__content-space dc__align-items-center border__primary--bottom",
					children: [/* @__PURE__ */ (0, Q.jsx)("h2", {
						className: "m-0 fs-16 fw-6 lh-24 cn-9",
						children: "Hibernation Rules"
					}), /* @__PURE__ */ (0, Q.jsx)(M, {
						dataTestId: "header-close-button",
						ariaLabel: "Close",
						showAriaLabelInTippy: !1,
						onClick: e,
						variant: F.borderLess,
						style: P.negativeGrey,
						icon: /* @__PURE__ */ (0, Q.jsx)(z, {
							name: "ic-close-large",
							color: null
						}),
						size: I.xs
					})]
				}), a ? /* @__PURE__ */ (0, Q.jsx)(R, {
					title: "Loading Hibernation Rules",
					subTitle: "Please wait while we fetch the hibernation rules.",
					SvgImage: vm,
					imageType: yc.Large
				}) : p ? /* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "flexbox flex-grow-1 dc__overflow-auto w-100",
					children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
						className: "flexbox-col w-240 dc__no-shrink dc__overflow-auto border__primary--right",
						children: [/* @__PURE__ */ (0, Q.jsx)("div", {
							className: "p-12",
							children: /* @__PURE__ */ (0, Q.jsx)(M, {
								dataTestId: "add-rule-button",
								variant: F.secondary,
								size: I.medium,
								startIcon: /* @__PURE__ */ (0, Q.jsx)(z, {
									name: "ic-add",
									color: null
								}),
								text: "Add Rule",
								onClick: m,
								fullWidth: !0
							})
						}), /* @__PURE__ */ (0, Q.jsx)("div", {
							className: "flexbox-col dc__overflow-auto px-12 py-8 w-100",
							children: f.map((e) => /* @__PURE__ */ (0, Q.jsxs)("div", {
								role: "button",
								onClick: b(e),
								onKeyDown: b(e),
								tabIndex: 0,
								className: `flexbox dc__gap-8 w-100 h-32 br-4 px-8 py-6 dc__align-items-center dc__visible-hover dc__visible-hover--parent ${p === e ? "bcb-1" : "dc__hover-n50"}`,
								children: [
									s[e] ? /* @__PURE__ */ (0, Q.jsx)(z, {
										name: "ic-error",
										color: "R500"
									}) : /* @__PURE__ */ (0, Q.jsx)(z, {
										name: "ic-gavel",
										color: p === e ? "B500" : "N800"
									}),
									/* @__PURE__ */ (0, Q.jsx)("h3", {
										className: `m-0 fs-13 fw-6 lh-1-5 dc__truncate flex-grow-1 ${p === e ? "cb-5" : "cn-9"}`,
										children: n[e].name || "Unnamed Rule"
									}),
									/* @__PURE__ */ (0, Q.jsx)("div", {
										className: "dc__visible-hover--child",
										children: /* @__PURE__ */ (0, Q.jsx)(M, {
											dataTestId: `delete-rule-button-${e}`,
											icon: /* @__PURE__ */ (0, Q.jsx)(z, {
												name: "ic-delete",
												color: null
											}),
											ariaLabel: `Delete ${n[e].name || "Unnamed"} Rule`,
											showAriaLabelInTippy: !1,
											variant: F.borderLess,
											style: P.negative,
											size: I.xs,
											onClick: h(e)
										})
									})
								]
							}, e))
						})]
					}), /* @__PURE__ */ (0, Q.jsx)("div", {
						className: "flexbox-col p-20 dc__overflow-auto flex-grow-1 bg__secondary",
						children: v()
					})]
				}) : /* @__PURE__ */ (0, Q.jsx)(R, {
					title: "Hibernation Rules",
					subTitle: "Add a rule to start hibernating your resources.",
					isButtonAvailable: !0,
					renderButton: y
				})]
			}), /* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox dc__content-end dc__gap-12 py-16 px-20 border__primary--top dc__no-shrink",
				children: [/* @__PURE__ */ (0, Q.jsx)(M, {
					dataTestId: "footer-cancel-button",
					variant: F.secondary,
					text: "Cancel",
					style: P.neutral,
					size: I.large,
					onClick: e
				}), /* @__PURE__ */ (0, Q.jsx)(M, {
					dataTestId: "footer-apply-button",
					variant: F.primary,
					size: I.large,
					text: "Save Changes",
					isLoading: a,
					onClick: _
				})]
			})]
		})
	});
}, _y = ({ guiSchema: e, handleChange: t, manifestYAMLString: n, handleSwitchToYAMLMode: r, manifestGUIFormRef: i }) => {
	let a = A(() => {
		try {
			return Qf.parse(n);
		} catch {
			return {};
		}
	}, [n]);
	return Object.keys(e || {}).length ? /* @__PURE__ */ (0, Q.jsx)("div", {
		className: "dc__overflow-auto flexbox-col flex-grow-1",
		children: /* @__PURE__ */ (0, Q.jsx)(gl, {
			className: "w-100 dc__mxw-1200",
			schema: e,
			formData: a || {},
			onChange: t,
			experimental_defaultFormStateBehavior: { emptyObjectFields: "skipDefaults" },
			liveValidate: !0,
			uiSchema: mc,
			ref: i
		})
	}) : /* @__PURE__ */ (0, Q.jsx)(R, {
		image: $f,
		title: "GUI schema not found",
		subTitle: "The GUI view is generated by a schema. Please provide GUI schema through CRD.",
		children: /* @__PURE__ */ (0, Q.jsx)(M, {
			endIcon: /* @__PURE__ */ (0, Q.jsx)(Kn, {}),
			onClick: r,
			variant: F.secondary,
			text: "Switch to advanced",
			dataTestId: "switch-to-advanced-view"
		})
	});
}, vy = "Monitoring Dashboard", yy = "rb-monitoring-dashboard__grid-layout--title", by = (e) => /* @__PURE__ */ (0, Q.jsx)("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...e,
	children: /* @__PURE__ */ (0, Q.jsx)("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M15.5 8C16.3284 8 17 7.32843 17 6.5C17 5.67157 16.3284 5 15.5 5C14.6716 5 14 5.67157 14 6.5C14 7.32843 14.6716 8 15.5 8ZM10 12.5C10 13.3284 9.32843 14 8.5 14C7.67157 14 7 13.3284 7 12.5C7 11.6716 7.67157 11 8.5 11C9.32843 11 10 11.6716 10 12.5ZM17 12.5C17 13.3284 16.3284 14 15.5 14C14.6716 14 14 13.3284 14 12.5C14 11.6716 14.6716 11 15.5 11C16.3284 11 17 11.6716 17 12.5ZM10 6.5C10 7.32843 9.32843 8 8.5 8C7.67157 8 7 7.32843 7 6.5C7 5.67157 7.67157 5 8.5 5C9.32843 5 10 5.67157 10 6.5ZM15.5 20C16.3284 20 17 19.3284 17 18.5C17 17.6716 16.3284 17 15.5 17C14.6716 17 14 17.6716 14 18.5C14 19.3284 14.6716 20 15.5 20ZM10 18.5C10 19.3284 9.32843 20 8.5 20C7.67157 20 7 19.3284 7 18.5C7 17.6716 7.67157 17 8.5 17C9.32843 17 10 17.6716 10 18.5Z",
		fill: "#3B444C"
	})
}), xy = (e) => /* @__PURE__ */ (0, Q.jsx)("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "0 0 24 24",
	...e,
	children: /* @__PURE__ */ (0, Q.jsx)("path", {
		stroke: "#3B444C",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M20 15.733V19a1 1 0 0 1-1 1h-3.267M5 20h4.4a1 1 0 0 0 1-1v-4.4a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1V19a1 1 0 0 0 1 1Zm9.6-9.6H19a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1h-4.4a1 1 0 0 0-1 1v4.4a1 1 0 0 0 1 1Zm-9.6 0h4.4a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v4.4a1 1 0 0 0 1 1Z",
		vectorEffect: "non-scaling-stroke"
	})
}), Sy = (e) => /* @__PURE__ */ (0, Q.jsxs)("svg", {
	"data-style-override": "false",
	width: 250,
	height: 200,
	viewBox: "0 0 250 200",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [
		/* @__PURE__ */ (0, Q.jsx)("style", { children: "\n    @keyframes scale-bar {\n\n      0%,\n      27%,\n      to {\n        transform: scaleY(0)\n      }\n\n      18%,\n      9% {\n        transform: scaleY(1)\n      }\n    }\n\n    @keyframes appear-line {\n\n      0%,\n      34%,\n      61%,\n      to {\n        transform: scaleX(0)\n      }\n\n      43%,\n      52% {\n        transform: scaleX(1)\n      }\n    }\n\n    @keyframes donut-light {\n\n      0%,\n      68%,\n      95%,\n      to {\n        stroke-dasharray: 0, 251.32\n      }\n\n      77%,\n      86% {\n        stroke-dasharray: 83.775, 167.55\n      }\n    }\n\n    @keyframes donut-med {\n\n      0%,\n      68%,\n      95%,\n      to {\n        stroke-dasharray: 0, 251.32\n      }\n\n      77%,\n      86% {\n        stroke-dasharray: 167.55, 251.32\n      }\n    }\n\n    @keyframes donut-dark {\n\n      0%,\n      68%,\n      95%,\n      to {\n        stroke-dasharray: 0, 251.32\n      }\n\n      77%,\n      86% {\n        stroke-dasharray: 251.32, 0\n      }\n    }\n\n    .bar-rect {\n      animation: scale-bar 12s infinite ease-out;\n      transform-origin: 0 147px;\n      fill: #e5f2ff;\n      stroke: #06c\n    }\n  " }),
		/* @__PURE__ */ (0, Q.jsx)("circle", {
			cx: 16,
			cy: 175,
			r: 15,
			fill: "#A0C3FB"
		}),
		/* @__PURE__ */ (0, Q.jsxs)("g", {
			className: "bar-chart",
			children: [
				/* @__PURE__ */ (0, Q.jsx)("path", {
					className: "bar-rect",
					strokeDasharray: "20,170",
					d: "M57 72h20v75H57z"
				}),
				/* @__PURE__ */ (0, Q.jsx)("path", {
					className: "bar-rect",
					strokeDasharray: "20,130",
					d: "M83 92h20v55H83z"
				}),
				/* @__PURE__ */ (0, Q.jsx)("path", {
					className: "bar-rect",
					strokeDasharray: "20,152",
					d: "M109 81h20v66h-20z"
				}),
				/* @__PURE__ */ (0, Q.jsx)("path", {
					className: "bar-rect",
					strokeDasharray: "20,212",
					d: "M135 51h20v96h-20z"
				}),
				/* @__PURE__ */ (0, Q.jsx)("path", {
					className: "bar-rect",
					strokeDasharray: "20,256",
					d: "M161 29h20v118h-20z"
				}),
				/* @__PURE__ */ (0, Q.jsx)("path", {
					className: "bar-rect",
					strokeDasharray: "20,171",
					d: "M187 71h20v76h-20z"
				}),
				/* @__PURE__ */ (0, Q.jsx)("path", {
					className: "bar-rect",
					strokeDasharray: "20,192",
					d: "M213 61h20v86h-20z"
				})
			]
		}),
		/* @__PURE__ */ (0, Q.jsxs)("g", {
			clipPath: "url(#clip1_7117_41560)",
			children: [/* @__PURE__ */ (0, Q.jsx)("path", {
				d: "M70 79.5 45 112v35h200V60l-25-22.5L195 50l-25-25-25 69-25-44-25 35z",
				fill: "#E5F2FF"
			}), /* @__PURE__ */ (0, Q.jsx)("path", {
				d: "m45 112 25-32.5L95 85l25-35 25 44 25-69 25 25 25-12.5L245 60",
				stroke: "#06c"
			})]
		}),
		/* @__PURE__ */ (0, Q.jsxs)("g", {
			className: "donut",
			children: [
				/* @__PURE__ */ (0, Q.jsx)("circle", {
					cx: 145,
					cy: 76,
					r: 40,
					stroke: "#72ACE6",
					strokeWidth: 30,
					style: {
						opacity: 1,
						animation: "donut-dark 12s infinite ease-out"
					}
				}),
				/* @__PURE__ */ (0, Q.jsx)("circle", {
					cx: 145,
					cy: 76,
					r: 40,
					stroke: "#ABCFF3",
					strokeWidth: 30,
					style: { animation: "donut-med 12s infinite ease-out" }
				}),
				/* @__PURE__ */ (0, Q.jsx)("circle", {
					cx: 145,
					cy: 76,
					r: 40,
					stroke: "#E5F2FF",
					strokeWidth: 30,
					style: { animation: "donut-light 12s infinite ease-out" }
				})
			]
		}),
		/* @__PURE__ */ (0, Q.jsx)("rect", {
			x: 45,
			y: 5,
			width: 200,
			height: 142,
			rx: 8,
			stroke: "#B1B7BC",
			strokeLinecap: "round",
			strokeDasharray: "5 5"
		}),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			d: "M223.579 144.255c4.156 11.418-1.731 24.042-13.149 28.198s-24.042-1.731-28.198-13.149z",
			fill: "#1E2462"
		}),
		/* @__PURE__ */ (0, Q.jsx)("rect", {
			x: 199,
			y: 174,
			width: 50,
			height: 16,
			rx: 8,
			fill: "#A0C3FB"
		}),
		/* @__PURE__ */ (0, Q.jsxs)("g", {
			className: "person",
			children: [
				/* @__PURE__ */ (0, Q.jsx)("path", {
					d: "M55.665 61.593c.048-2.845.048-4.255.517-7.074-1.285-.393-3.998.045-6.123.099.036 1.416-.131 4.284-1.215 6.295q1.339 2.518 3.464 2.465 2.123-.052 3.357-1.785",
					fill: "#F3A29D"
				}),
				/* @__PURE__ */ (0, Q.jsx)("path", {
					d: "M56.027 40.867c1.417.748 2.652 2.083 3.441 3.729.247.516.109.78.603 1.604q.711 1.182 1.908 2.837l-1.563 1.093q-.817 3.957-3.61 5.243-2.795 1.284-5.096-.012-4.854-2.865-3.162-7.933 1.694-5.069 7.479-6.56",
					fill: "#FAB6AF"
				}),
				/* @__PURE__ */ (0, Q.jsx)("path", {
					d: "M55.919 48.371c-.364-1.12.074-2.28 1.007-2.584.724-.235 1.511.124 1.997.82q.23-.297.469-.483l.114-.082q.213-.144.385-.204c-.256-.888.068-1.784.779-2.015.73-.238 1.545.335 1.842 1.248.296.913-.026 1.855-.757 2.092-.65.212-1.367-.219-1.726-.96q-.107.033-.307.164-.283.187-.574.589l-.012.018q.07.15.124.312c.363 1.12-.075 2.281-1.007 2.584-.933.303-1.97-.379-2.334-1.499m4.872-4.177c-.5.162-.743.873-.506 1.6.236.728.85 1.16 1.35.998.499-.162.742-.873.506-1.6-.237-.728-.852-1.16-1.35-.998m-3.744 1.964c-.708.23-1.06 1.162-.757 2.093.302.93 1.135 1.478 1.842 1.248s1.059-1.162.756-2.092-1.134-1.478-1.841-1.249",
					fill: "#222768"
				}),
				/* @__PURE__ */ (0, Q.jsx)("path", {
					d: "M66.989 87.883c-1.88-1.504-5.17-4.386-6.579-5.639l-2.35 11.748 16.917.94 1.41-2.35c-2.35-.94-7.519-3.195-9.398-4.699",
					fill: "#FBB4AD"
				}),
				/* @__PURE__ */ (0, Q.jsx)("path", {
					d: "m64.639 98.22 2.35-18.796c-3.133 0-10.245-.94-13.628-4.7-4.23-4.698-2.82-10.807-6.109-10.337s-7.988 19.736-5.639 27.255c1.88 6.015 16.134 6.892 23.026 6.579",
					fill: "url(#paint1_linear_7117_41560)"
				}),
				/* @__PURE__ */ (0, Q.jsx)("path", {
					d: "M57.593 79.895c-1.503-5.64-1.88-14.88-1.88-18.797-2.349.47-7.706 1.222-10.337.47-6.11 14.097-16.917 23.026-16.917 29.605 0 2.631 1.253 4.229 1.88 4.699 1.566.626 6.766 1.88 15.037 1.88 8.27 0 14.724-3.76 16.916-5.64-.94-1.723-3.195-6.578-4.699-12.217",
					fill: "url(#paint2_linear_7117_41560)"
				}),
				/* @__PURE__ */ (0, Q.jsx)("path", {
					d: "m19.999 189.193 4.177-12.636h9.189c.261 1.548 4.23 4.305 5.9 5.308 2.088 1.253 6.213 3.151 7.884 4.404 1.337 1.002 2.506 2.367 2.924 2.924z",
					fill: "url(#paint3_linear_7117_41560)"
				}),
				/* @__PURE__ */ (0, Q.jsx)("path", {
					d: "m42.556 189.193 4.511-12.636h8.856c.26 1.548 4.229 4.305 5.9 5.308 2.088 1.253 6.213 3.151 7.884 4.404 1.336 1.002 2.506 2.367 2.924 2.924z",
					fill: "url(#paint4_linear_7117_41560)"
				}),
				/* @__PURE__ */ (0, Q.jsx)("path", {
					d: "M38.327 117.957c1.88-7.894 1.41-21.146.94-26.785h15.977c-.157 4.7-.376 15.695 0 22.086s-14.254 45.268-21.616 63.908H23.76c-.627-2.976-1.692-10.338-.94-15.977.94-7.048 13.158-33.363 15.507-43.232",
					fill: "url(#paint5_linear_7117_41560)"
				}),
				/* @__PURE__ */ (0, Q.jsx)("path", {
					d: "M38.326 101.98c-.752-3.759-.314-8.771 0-10.808h16.916c2.507 10.495 7.613 32.894 7.989 38.533s-4.543 33.99-7.049 47.461h-9.398c-1.096-1.566-3.383-5.639-3.76-9.398-.47-4.699.94-8.928 1.41-11.748s-.47-7.816-.47-11.748 2.35-13.157 1.88-18.796-6.579-18.797-7.519-23.496",
					fill: "url(#paint6_linear_7117_41560)"
				}),
				/* @__PURE__ */ (0, Q.jsx)("path", {
					fill: "#F04C49",
					d: "m37.814 134.488 62.021-64.225 4.733 4.57-62.021 64.225z"
				}),
				/* @__PURE__ */ (0, Q.jsx)("path", {
					d: "m35.742 129.871 62.022-64.225 2.074 4.616-62.021 64.225z",
					fill: "url(#paint7_linear_7117_41560)"
				}),
				/* @__PURE__ */ (0, Q.jsx)("path", {
					d: "m42.547 139.058 62.022-64.225 4.686 1.912-62.022 64.225z",
					fill: "url(#paint8_linear_7117_41560)"
				}),
				/* @__PURE__ */ (0, Q.jsx)("path", {
					d: "m111.147 58.973 8.031-4.003-3.721 8.165z",
					fill: "#171C54"
				}),
				/* @__PURE__ */ (0, Q.jsx)("path", {
					d: "m111.149 58.973-13.385 6.672 2.075 4.616 4.732 4.57 4.686 1.912 6.201-13.609z",
					fill: "#D2D2D2"
				}),
				/* @__PURE__ */ (0, Q.jsx)("path", {
					d: "M66.052 110.908c-3.383-.752-10.495-5.326-13.627-7.519l4.229-10.808c.783 1.253 3.101 4.793 6.109 8.928s6.578 5.796 7.988 6.109c1.88-2.349 4.981-3.759 7.33-5.639.157.314.565 1.128.189 1.88-.47.94-3.29 2.35-1.88 3.289 1.128.752 4.23-.939 5.64-1.879 0 1.566-.659 4.981-3.29 6.109-3.29 1.409-8.459.469-12.688-.47",
					fill: "#FBB4AD"
				}),
				/* @__PURE__ */ (0, Q.jsx)("path", {
					d: "m53.832 109.969 7.519-19.266c-3.133-.47-9.774-2.726-11.278-7.989s3.133-16.603 5.64-21.616c0 0-3.083.79-5.17.94-1.84.132-4.7 0-4.7 0-1.879 2.036-6.108 6.767-7.988 9.398-2.35 3.29-7.518 13.628-6.108 19.736 1.41 6.11 5.169 5.64 8.928 8.929s4.23 6.579 7.519 8.458c2.631 1.504 4.855 1.567 5.638 1.41",
					fill: "#428DFB"
				}),
				/* @__PURE__ */ (0, Q.jsx)("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M53.16 50.603c-.298.852-.5 1.94-.5 3.446 0 3.129 2.196 5.689 3.176 6.83l.056.066-.357.306-.071-.083c-.977-1.137-3.275-3.813-3.275-7.119 0-1.548.209-2.691.527-3.602.32-.91.744-1.577 1.16-2.171l.231-.326c.332-.466.638-.896.88-1.403.293-.613.492-1.342.492-2.366h.47c0 1.091-.213 1.89-.537 2.568-.262.548-.597 1.018-.93 1.485q-.111.155-.22.311c-.407.58-.804 1.206-1.102 2.058",
					fill: "#000"
				}),
				/* @__PURE__ */ (0, Q.jsx)("path", {
					d: "M51.952 39.2c2.21-.046 3.61.09 4.847.902l.059.05c.946.801 1.677 1.42 2.075 3.506-.633-1.07-1.637-1.367-2.088-1.344.206 1.309-.301 3.55-1.604 4.687-2.426 2.117-3.571 3.289-3.571 5.639 0 4.699 1.692 7.518 3.101 9.398 0 0-3.424 1.79-8.458 2.35-5.034.558-8.33-.487-8.33-.487-.603-1.425-.763-4.556-.234-6.264a9 9 0 0 0-.222.35c-.516.861-.848 1.758-.848 2.64 0 1.478.31 2.442.446 2.715l-.42.21c-.178-.354-.495-1.394-.495-2.924 0-.998.373-1.98.914-2.882.542-.903 1.261-1.74 1.974-2.454.748-.748 1.472-1.476 1.99-2.325.143-.383.24-.802.268-1.267.049-.784.067-1.49.084-2.142.062-2.4.106-4.082 1.583-6.316 2.02-3.052 5.922-3.979 8.929-4.042",
					fill: "#23286B"
				}),
				/* @__PURE__ */ (0, Q.jsx)("path", {
					d: "M80.617 99.63c0 1.879 1.254 3.915 1.88 4.698.783-.469 2.35-.939 3.76-2.349s2.036-2.82 2.349-3.76c-.47-.94-1.598-2.725-2.35-2.349s0 2.35.47 3.29c-1.253-1.254-3.947-3.666-4.699-3.29-.94.47-1.41 1.41-1.41 3.76",
					fill: "#FBB4AD"
				})
			]
		}),
		/* @__PURE__ */ (0, Q.jsxs)("defs", { children: [
			/* @__PURE__ */ (0, Q.jsxs)("linearGradient", {
				id: "paint1_linear_7117_41560",
				x1: 55.241,
				y1: 81.773,
				x2: 55.87,
				y2: 99.625,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ (0, Q.jsx)("stop", { stopColor: "#428DFC" }), /* @__PURE__ */ (0, Q.jsx)("stop", {
					offset: 1,
					stopColor: "#1D72D9"
				})]
			}),
			/* @__PURE__ */ (0, Q.jsxs)("linearGradient", {
				id: "paint2_linear_7117_41560",
				x1: 53.364,
				y1: 59.688,
				x2: 43.813,
				y2: 99.536,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ (0, Q.jsx)("stop", {
					offset: .218,
					stopColor: "#428DFC"
				}), /* @__PURE__ */ (0, Q.jsx)("stop", {
					offset: 1,
					stopColor: "#0C5FC4"
				})]
			}),
			/* @__PURE__ */ (0, Q.jsxs)("linearGradient", {
				id: "paint3_linear_7117_41560",
				x1: 47.854,
				y1: 176.796,
				x2: 38.606,
				y2: 197.503,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ (0, Q.jsx)("stop", {
					offset: .091,
					stopColor: "#2C7DE7"
				}), /* @__PURE__ */ (0, Q.jsx)("stop", {
					offset: .492,
					stopColor: "#1D72D9"
				})]
			}),
			/* @__PURE__ */ (0, Q.jsxs)("linearGradient", {
				id: "paint4_linear_7117_41560",
				x1: 70.412,
				y1: 176.796,
				x2: 61.163,
				y2: 197.503,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ (0, Q.jsx)("stop", {
					offset: .075,
					stopColor: "#428DFC"
				}), /* @__PURE__ */ (0, Q.jsx)("stop", {
					offset: 1,
					stopColor: "#428DFC"
				})]
			}),
			/* @__PURE__ */ (0, Q.jsxs)("linearGradient", {
				id: "paint5_linear_7117_41560",
				x1: 41.115,
				y1: 91.172,
				x2: 13.3,
				y2: 168.907,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ (0, Q.jsx)("stop", {
					offset: .332,
					stopColor: "#181D55"
				}), /* @__PURE__ */ (0, Q.jsx)("stop", {
					offset: 1,
					stopColor: "#1A1F58"
				})]
			}),
			/* @__PURE__ */ (0, Q.jsxs)("linearGradient", {
				id: "paint6_linear_7117_41560",
				x1: 48.566,
				y1: 91.172,
				x2: 48.221,
				y2: 177.165,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ (0, Q.jsx)("stop", { stopColor: "#191D52" }),
					/* @__PURE__ */ (0, Q.jsx)("stop", {
						offset: .537,
						stopColor: "#272D78"
					}),
					/* @__PURE__ */ (0, Q.jsx)("stop", {
						offset: 1,
						stopColor: "#23286B"
					})
				]
			}),
			/* @__PURE__ */ (0, Q.jsxs)("linearGradient", {
				id: "paint7_linear_7117_41560",
				x1: 99.792,
				y1: 67.605,
				x2: 104.872,
				y2: 73.419,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ (0, Q.jsx)("stop", { stopColor: "#D53B3A" }), /* @__PURE__ */ (0, Q.jsx)("stop", {
					offset: 1,
					stopColor: "#E64542"
				})]
			}),
			/* @__PURE__ */ (0, Q.jsxs)("linearGradient", {
				id: "paint8_linear_7117_41560",
				x1: 107.903,
				y1: 75.439,
				x2: 112.982,
				y2: 81.254,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ (0, Q.jsx)("stop", { stopColor: "#E24442" }), /* @__PURE__ */ (0, Q.jsx)("stop", {
					offset: 1,
					stopColor: "#CC3434"
				})]
			}),
			/* @__PURE__ */ (0, Q.jsx)("clipPath", {
				id: "clip0_7117_41560",
				children: /* @__PURE__ */ (0, Q.jsx)("path", {
					fill: "#fff",
					d: "M45 5h200v142H45z"
				})
			}),
			/* @__PURE__ */ (0, Q.jsx)("clipPath", {
				id: "clip1_7117_41560",
				children: /* @__PURE__ */ (0, Q.jsx)("rect", {
					x: 45,
					y: 5,
					rx: 8,
					width: 200,
					height: 142,
					fill: "#fff",
					style: {
						animation: "appear-line 12s infinite ease-out",
						transformOrigin: "45px 0"
					}
				})
			})
		] })
	]
}), Cy = ({ useDefaultStyles: e = !0, handleOpenAddPanelModal: t }) => /* @__PURE__ */ (0, Q.jsx)(M, {
	dataTestId: "open-add-panel-modal",
	variant: e ? F.primary : F.text,
	text: "Add Panel",
	startIcon: /* @__PURE__ */ (0, Q.jsx)(E, {}),
	onClick: t,
	size: e ? I.large : I.small
}), wy = async ({ clusterId: e, id: t, panelName: n, embedIframe: r }) => {
	let i = `${O.CLUSTER}/${e}/${O.PANEL}`, a = t ? `/${t}` : "", o = t ? sf : nf, s = {
		name: n,
		embedIframe: cd(r, n)
	};
	return o(`${i}${a}`, s);
}, Ty = (e) => {
	let { isValid: t, message: n } = zf(e);
	return {
		isValid: () => t,
		message: n
	};
}, Ey = (e) => ({
	panelName: { required: !0 },
	embedIframe: {
		required: !0,
		custom: Ty(e.embedIframe)
	}
}), Dy = ({ initialFormData: e, onClose: t, handleSuccess: n }) => {
	let { clusterId: r } = Z(), { data: i, errors: a, register: o, handleSubmit: s } = xf({
		initialValues: e,
		validations: Ey
	}), [c, l] = j(!1), u = async ({ id: e, panelName: t, embedIframe: i }) => {
		try {
			l(!0), await wy({
				clusterId: +r,
				id: e,
				panelName: t,
				embedIframe: i
			}), l(!1), H.showToast({
				variant: U.success,
				description: `Panel '${t}' has been successfully ${e ? "updated" : "created"}.`
			}), n();
		} catch (e) {
			K(e), l(!1);
		}
	};
	return /* @__PURE__ */ (0, Q.jsx)(xu, {
		className: "monitoring-panel-crud-modal",
		onEscape: t,
		close: t,
		children: /* @__PURE__ */ (0, Q.jsxs)("div", {
			onClick: uf,
			className: "monitoring-panel-crud-modal__container bg__primary dc__border br-8 dc__mxw-600 flexbox-col",
			children: [
				/* @__PURE__ */ (0, Q.jsxs)("header", {
					className: "flexbox dc__align-items-center dc__content-space px-20 py-12 dc__border-bottom",
					children: [/* @__PURE__ */ (0, Q.jsx)("h2", {
						className: "m-0 fs-16 lh-1-5 fw-6",
						children: `${e.panelName ? "Edit" : "Add"} panel`
					}), /* @__PURE__ */ (0, Q.jsx)(M, {
						dataTestId: "monitoring-panel-crud-modal-close-btn",
						ariaLabel: "close-button",
						showAriaLabelInTippy: !1,
						icon: /* @__PURE__ */ (0, Q.jsx)(tr, {}),
						onClick: t,
						variant: F.borderLess,
						style: P.negativeGrey,
						size: I.xs
					})]
				}),
				/* @__PURE__ */ (0, Q.jsxs)("form", {
					className: "px-20 py-16 flex-grow-1 flexbox-col dc__gap-16",
					onSubmit: af,
					children: [
						/* @__PURE__ */ (0, Q.jsx)(os, {
							value: i.panelName,
							...o("panelName"),
							label: "Panel name",
							placeholder: "Enter panel name",
							error: a.panelName,
							required: !0,
							autoFocus: !0,
							shouldTrim: !1
						}),
						/* @__PURE__ */ (0, Q.jsx)(ou, {
							value: i.embedIframe,
							...o("embedIframe"),
							placeholder: "Enter embed code",
							label: "Embed iframe",
							required: !0,
							error: a.embedIframe?.[0]
						}),
						/* @__PURE__ */ (0, Q.jsx)(xc, { description: "Please ensure that the embedded iframe has required permission to connect from external webpages." })
					]
				}),
				/* @__PURE__ */ (0, Q.jsxs)("footer", {
					className: "flex right dc__gap-12 px-20 py-16 dc__border-top",
					children: [/* @__PURE__ */ (0, Q.jsx)(M, {
						dataTestId: "monitoring-panel-crud-modal-cancel-btn",
						text: "Cancel",
						variant: F.secondary,
						style: P.neutral,
						onClick: t,
						disabled: c
					}), /* @__PURE__ */ (0, Q.jsx)(M, {
						dataTestId: "monitoring-panel-crud-modal-save-btn",
						text: "Save",
						isLoading: c,
						onClick: s(u)
					})]
				})
			]
		})
	});
}, Oy = (e, t) => ({
	id: t,
	name: vy,
	url: e,
	isSelected: !1,
	type: "fixed",
	showNameOnSelect: !1,
	hideName: !0
}), ky = (e) => `panel-template-clusterId-${e}`, Ay = (e) => ({
	i: `${e}`,
	x: 0,
	y: 0,
	w: 6,
	h: 6,
	minH: 3,
	minW: 3
}), jy = (e, t) => {
	let { ids: n, panelDetails: r } = e.reduce((e, t) => (e.ids.push(t.id), e.panelDetails[t.id] = t, e), {
		ids: [],
		panelDetails: {}
	}), i = n.reduce((e, n) => (e[n] = t.panelConfiguration[n] || structuredClone(Ay(n)), e), {});
	return {
		ids: n,
		panelDetails: r,
		templateConfigurationId: t.templateConfigurationId,
		panelConfiguration: i
	};
}, My = ({ panelConfiguration: e }) => {
	let t = structuredClone(e) || {};
	return Object.values(t);
}, Ny = async ({ clusterId: e, shouldShowError: t = !0 }) => {
	try {
		let { result: t } = await G(`${O.CLUSTER}/${e}/${O.PANELS}`);
		return t ? t.filter((e) => e.embedIframe && e.id).map(({ id: e, name: t, embedIframe: n }, r) => ({
			id: e,
			embedIframe: cd(n, t),
			name: t || `Panel ${r + 1}`
		})) : [];
	} catch (e) {
		throw t && K(e), e;
	}
}, Py = async ({ clusterId: e, shouldShowError: t = !0 }) => {
	try {
		let { result: t } = await G(Rd(O.CLUSTER_PANEL_TEMPLATE, { key: ky(e) }));
		return t ? {
			panelConfiguration: JSON.parse(t.value),
			templateConfigurationId: t.id
		} : { panelConfiguration: {} };
	} catch (e) {
		return t && K(e), { panelConfiguration: {} };
	}
}, Fy = async ({ clusterId: e, shouldShowError: t = !0 }) => {
	try {
		let [t, n] = await Promise.all([Ny({
			clusterId: e,
			shouldShowError: !1
		}), Py({
			clusterId: e,
			shouldShowError: !1
		})]);
		return jy(t, n);
	} catch (e) {
		throw t && K(e), e;
	}
}, Iy = async ({ clusterId: e, panelLayoutConfig: t, templateConfigurationId: n }) => {
	let r = t.reduce((e, { i: t, x: n, y: r, w: i, h: a }) => ({
		...e,
		[t]: {
			i: t,
			x: n,
			y: r,
			w: i,
			h: a
		}
	}), {}), i = {
		id: n,
		key: ky(e),
		value: JSON.stringify(r)
	};
	return sf(O.CLUSTER_PANEL_TEMPLATE, i);
}, Ly = async ({ panelId: e, clusterId: t }) => ff(`${O.CLUSTER}/${t}/${O.PANEL}/${e}`), Ry = /* @__PURE__ */ function(e) {
	return e.UPDATE = "UPDATE", e.DELETE = "DELETE", e;
}({}), zy = () => {
	let { clusterId: e } = Z(), [t, n, r, i] = hf(() => Fy({ clusterId: +e }), [e], !!+e), [a, o] = j([]), [s, c] = j({ isOpen: !1 }), [l, u] = j(!1), [d, f] = j(!1), { width: p, containerRef: m, mounted: h } = Na();
	k(() => {
		!t && !r && n && o(My({ panelConfiguration: n.panelConfiguration }));
	}, [
		t,
		n,
		r
	]);
	let g = (e) => {
		c({
			isOpen: !0,
			panelId: e,
			type: Ry.UPDATE
		});
	}, _ = (e) => {
		c({
			isOpen: !0,
			panelId: e,
			type: Ry.DELETE
		});
	}, v = () => {
		c({ isOpen: !1 });
	}, y = () => {
		u(!0);
	}, b = () => {
		u(!1), o(My({ panelConfiguration: n.panelConfiguration }));
	}, x = () => {
		i(), v(), u(!1);
	}, S = (e) => {
		o([...e]);
	}, C = async () => {
		f(!0);
		try {
			await Iy({
				clusterId: +e,
				panelLayoutConfig: a,
				templateConfigurationId: n.templateConfigurationId
			}), H.showToast({
				variant: U.success,
				description: "Layout is successfully saved."
			}), x();
		} catch (e) {
			K(e);
		} finally {
			f(!1);
		}
	}, w = async () => {
		await Ly({
			clusterId: +e,
			panelId: s.panelId
		}), x();
	}, T = () => g(), ee = (e) => () => g(e), E = (e) => () => _(e);
	return /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsx)("div", {
		className: "flex-grow-1 dc__overflow-hidden flexbox-col w-100",
		children: /* @__PURE__ */ (0, Q.jsx)($a, {
			isLoading: t,
			progressingProps: { pageLoader: !0 },
			error: r,
			errorScreenManagerProps: {
				code: r?.code,
				reload: i,
				redirectURL: B.RESOURCE_BROWSER.ROOT
			},
			children: n?.ids?.length ? /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "px-16 py-6 flexbox dc__gap-12 dc__border-bottom",
				children: [
					/* @__PURE__ */ (0, Q.jsx)("h3", {
						className: "m-0 cn-9 fs-12 fw-6 lh-20",
						children: "Monitoring Dashboard"
					}),
					/* @__PURE__ */ (0, Q.jsx)("div", { className: "dc__border-left h-16" }),
					l ? /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsx)(M, {
						dataTestId: "save-panel-layout-config",
						startIcon: /* @__PURE__ */ (0, Q.jsx)(z, {
							name: "ic-check",
							color: null
						}),
						text: "Save Changes",
						variant: F.text,
						onClick: C,
						isLoading: d,
						size: I.small
					}), /* @__PURE__ */ (0, Q.jsx)(M, {
						dataTestId: "cancel-panel-layout-config",
						text: "Cancel",
						variant: F.text,
						onClick: b,
						style: P.neutral,
						size: I.small,
						disabled: d
					})] }) : /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsx)(Cy, {
						useDefaultStyles: !1,
						handleOpenAddPanelModal: T
					}), /* @__PURE__ */ (0, Q.jsx)(M, {
						dataTestId: "re-arrange-layout",
						variant: F.text,
						text: "Rearrange",
						startIcon: /* @__PURE__ */ (0, Q.jsx)(xy, {}),
						onClick: y,
						size: I.small
					})] })
				]
			}), /* @__PURE__ */ (0, Q.jsx)("div", {
				ref: m,
				className: "rb-monitoring-dashboard dc__overflow-auto h-100",
				children: h && /* @__PURE__ */ (0, Q.jsx)(Ia, {
					className: "rb-monitoring-dashboard dc__overflow-auto h-100",
					width: p,
					layout: a,
					onLayoutChange: S,
					gridConfig: {
						cols: 12,
						rowHeight: 30,
						containerPadding: [16, 16]
					},
					dragConfig: {
						enabled: l,
						handle: ".rb-monitoring-dashboard__grid-layout--title"
					},
					resizeConfig: { enabled: l },
					children: n.ids.map((e) => {
						let { embedIframe: t, name: r } = n.panelDetails[e];
						return /* @__PURE__ */ (0, Q.jsxs)("div", {
							className: "flexbox-col dc__border br-4 bg__primary",
							children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
								className: `rb-monitoring-dashboard__grid-layout--title br-4 flexbox dc__align-items-center ${l ? "p-12 bg__secondary dc__grabbable" : "px-12 pt-12 bg__primary"} dc__gap-12`,
								children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
									className: "flexbox dc__align-items-center dc__gap-4 flex-grow-1",
									children: [l && /* @__PURE__ */ (0, Q.jsx)(by, { className: "icon-dim-16 dc__no-shrink scn-7" }), /* @__PURE__ */ (0, Q.jsx)(W, {
										content: r,
										children: /* @__PURE__ */ (0, Q.jsx)("h4", {
											className: "dc__truncate m-0 cn-9 fs-13 fw-6 lh-20",
											children: r
										})
									})]
								}), !l && /* @__PURE__ */ (0, Q.jsxs)(sl, {
									autoClose: !0,
									children: [/* @__PURE__ */ (0, Q.jsx)(sl.Button, {
										rootClassName: "flex dc__no-shrink icon-dim-20 p-0 dc__no-background dc__no-border dc__outline-none-imp dc__tab-focus dc__hover-n50",
										isKebab: !0,
										dataTestId: "panel-more-options-popup",
										children: /* @__PURE__ */ (0, Q.jsx)(Ri, { className: "flex icon-dim-16 dc__no-shrink icon-color-n6" })
									}), /* @__PURE__ */ (0, Q.jsx)(sl.Body, {
										rootClassName: "br-4 dc__overflow-hidden dc__border dc__box-shadow--menu mt-8",
										children: /* @__PURE__ */ (0, Q.jsxs)("div", {
											className: "flexbox-col p-4 dc__gap-4",
											children: [/* @__PURE__ */ (0, Q.jsxs)("button", {
												type: "button",
												"data-testid": `edit-panel-${r}`,
												onClick: ee(e),
												className: "dc__transparent flexbox dc__align-items-center dc__gap-8 px-8 py-6 dc__hover-n50",
												children: [/* @__PURE__ */ (0, Q.jsx)(Ee, { className: "icon-dim-16 dc__no-shrink scn-8" }), /* @__PURE__ */ (0, Q.jsx)("span", {
													className: "cn-9 fs-13 fw-4 lh-20",
													children: "Edit"
												})]
											}), /* @__PURE__ */ (0, Q.jsxs)("button", {
												type: "button",
												"data-testid": `delete-panel-${r}`,
												className: "dc__transparent flexbox dc__align-items-center dc__gap-8 px-8 py-6 dc__hover-n50",
												onClick: E(e),
												children: [/* @__PURE__ */ (0, Q.jsx)(Be, { className: "icon-dim-16 dc__no-shrink scr-5" }), /* @__PURE__ */ (0, Q.jsx)("span", {
													className: "cr-5 fs-13 fw-4 lh-20",
													children: "Delete"
												})]
											})]
										})
									})]
								})]
							}), /* @__PURE__ */ (0, Q.jsx)("div", {
								className: "dc__overflow-auto p-12 h-100",
								dangerouslySetInnerHTML: { __html: Cd(t) }
							})]
						}, e);
					})
				})
			})] }) : /* @__PURE__ */ (0, Q.jsx)(R, {
				title: "Setup your monitoring dashboard",
				subTitle: "Elevate your Kubernetes visibility by embedding the metrics that matter to you",
				SvgImage: Sy,
				imageType: yc.Large,
				isButtonAvailable: !0,
				renderButton: () => /* @__PURE__ */ (0, Q.jsx)(Cy, { handleOpenAddPanelModal: T })
			})
		})
	}), s.isOpen ? s.type === Ry.UPDATE ? /* @__PURE__ */ (0, Q.jsx)(Dy, {
		initialFormData: (() => {
			let e = s.panelId;
			if (e) {
				let { id: t, name: r, embedIframe: i } = n.panelDetails[e];
				return {
					id: t,
					panelName: r,
					embedIframe: i
				};
			}
			return {
				id: null,
				panelName: "",
				embedIframe: ""
			};
		})(),
		onClose: v,
		handleSuccess: x
	}) : s.type === Ry.DELETE && /* @__PURE__ */ (0, Q.jsx)(Ts, {
		title: n?.panelDetails[s.panelId]?.name,
		component: "panel",
		onDelete: w,
		closeConfirmationModal: v,
		successToastMessage: "Panel deleted successfully"
	}) : null] });
}, By = ({ shrinkHeightToContent: e, heading: t, description: n, children: r, hideBorderBottom: i, hideChildrenPadding: a, status: o }) => /* @__PURE__ */ (0, Q.jsxs)("div", {
	className: `br-4 border__primary bg__primary flexbox-col dc__overflow-auto ${e ? "dc__h-min-content" : ""}`,
	children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
		className: `flexbox dc__content-space dc__gap-8 px-16 py-8 dc__align-items-center ${i ? "" : "border__secondary--bottom"}`,
		children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox-col",
			children: [/* @__PURE__ */ (0, Q.jsx)("h3", {
				className: "m-0 cn-9 fs-14 fw-6 lh-1-5 dc__truncate",
				children: t
			}), !!n && /* @__PURE__ */ (0, Q.jsx)("p", {
				className: "m-0 fs-13 cn-7 fw-4 lh-1-5",
				children: n
			})]
		}), o && /* @__PURE__ */ (0, Q.jsx)("span", {
			className: "px-6 py-2 br-4 dc__truncate fs-13 fw-5 lh-20 dc__text-center bcg-1 cg-7",
			children: o
		})]
	}), /* @__PURE__ */ (0, Q.jsx)("div", {
		className: `flexbox-col dc__gap-16 dc__overflow-auto ${a ? "" : "p-16"}`,
		children: r
	})]
}), Vy = ({ heading: e, items: t }) => /* @__PURE__ */ (0, Q.jsxs)("div", {
	className: "py-4 flexbox-col",
	children: [/* @__PURE__ */ (0, Q.jsx)("h4", {
		className: "m-0 cn-7 fs-14 fw-6 lh-1-5 dc__truncate px-16 py-6",
		children: e
	}), t.map(({ key: t, value: n }) => /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "px-16 py-6 flexbox dc__content-space dc__gap-4 dc__hover-n50",
		children: [/* @__PURE__ */ (0, Q.jsx)("span", {
			className: "cn-7 fs-13 fw-4 lh-1-5",
			children: t
		}), /* @__PURE__ */ (0, Q.jsx)("span", {
			className: "cn-9 fs-13 fw-6 lh-1-5 dc__truncate",
			children: n
		})]
	}, `${t}-${e}-${n}`))]
}), Hy = ({ heading: e, items: t }) => /* @__PURE__ */ (0, Q.jsxs)("div", {
	className: "flexbox-col dc__gap-6",
	children: [/* @__PURE__ */ (0, Q.jsx)("h4", {
		className: "m-0 cn-7 fs-13 fw-6 lh-1-5 dc__truncate",
		children: e
	}), /* @__PURE__ */ (0, Q.jsx)("div", {
		className: "br-4 border__secondary py-4 flexbox-col",
		children: t.map(({ key: t, value: n, subText: r }) => /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "px-16 py-6 flexbox dc__content-space dc__gap-4 dc__hover-n50",
			children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox-col",
				children: [/* @__PURE__ */ (0, Q.jsx)("span", {
					className: `fs-13 ${r ? "cn-8 fw-6" : "cn-7 fw-4"} lh-1-5`,
					children: t
				}), /* @__PURE__ */ (0, Q.jsx)("span", {
					className: "cn-7 fs-13 fw-4 lh-1-5",
					children: r
				})]
			}), /* @__PURE__ */ (0, Q.jsx)("span", {
				className: "cn-9 fs-13 fw-6 lh-1-5 dc__truncate",
				children: n
			})]
		}, `${t}-${e}-${n}`))
	})]
}), Uy = ({ heading: e, description: t, status: n, itemGroups: r, containItemGroupWithBorder: i }) => /* @__PURE__ */ (0, Q.jsx)(By, {
	heading: e,
	description: t,
	status: n,
	hideChildrenPadding: !i,
	children: /* @__PURE__ */ (0, Q.jsx)("div", {
		className: `flexbox-col ${i ? "dc__gap-16" : ""}`,
		children: r.map((t, n) => i ? /* @__PURE__ */ (0, Q.jsx)(Hy, {
			heading: t.heading,
			items: t.items
		}, `${t.heading}-${e}`) : /* @__PURE__ */ (0, Q.jsxs)(Va, { children: [/* @__PURE__ */ (0, Q.jsx)(Vy, {
			heading: t.heading,
			items: t.items
		}), n !== r.length - 1 && /* @__PURE__ */ (0, Q.jsx)("div", { className: "divider divider--n1" })] }, `${t.heading}-${e}`))
	})
}), Wy = {
	heading: "Hardware Details",
	description: "Detailed system hardware information",
	status: "OK",
	itemGroups: [
		{
			heading: "System",
			items: [
				{
					key: "Model",
					value: "PowerEdge XR8620t"
				},
				{
					key: "Manufacturer",
					value: "Dell Inc."
				},
				{
					key: "Service Tag",
					value: "4TW3H04"
				},
				{
					key: "Express Service Code",
					value: "10514558164"
				},
				{
					key: "Part Number",
					value: "0HG7X2A01"
				},
				{
					key: "System Type",
					value: "Physical"
				},
				{
					key: "Chassis",
					value: "PowerEdge XR8000"
				},
				{
					key: "Chassis Height",
					value: "2U"
				}
			]
		},
		{
			heading: "Processor",
			items: [
				{
					key: "Model",
					value: "Inter(R) Xeon(R) Gold 6433N"
				},
				{
					key: "Cores",
					value: "32"
				},
				{
					key: "Threads",
					value: "64"
				},
				{
					key: "L2 Cache",
					value: "32x2 MB"
				},
				{
					key: "L3 Cache",
					value: "60 MB"
				}
			]
		},
		{
			heading: "Memory",
			items: [
				{
					key: "Total Memory",
					value: "256 GB"
				},
				{
					key: "Memory Type",
					value: "ECC DDR5"
				},
				{
					key: "Memory Speed",
					value: "4400 MT/s"
				},
				{
					key: "DIMM Slots",
					value: "8 of 8"
				}
			]
		}
	]
}, Gy = {
	heading: "Firmware Versions",
	description: "Current firmware for system components",
	status: "OK",
	itemGroups: [
		{
			heading: "BIOS",
			items: [{
				key: "Version",
				value: "2.4.4"
			}, {
				key: "Release Date",
				value: "09/27/2024"
			}]
		},
		{
			heading: "iDRAC",
			items: [{
				key: "Version",
				value: "7.10.90.00"
			}, {
				key: "Previous",
				value: "7.10.50.00"
			}]
		},
		{
			heading: "Network Interfaces",
			items: [{
				key: "Intel(R) ethernet 100G 2P E810-C Adapter",
				subText: "40:A6:B7:B2:8D:00",
				value: "22.0.9"
			}]
		},
		{
			heading: "Other Components",
			items: [{
				key: "System CPLD",
				value: "1.1.3"
			}, {
				key: "TPM",
				value: "7.2.2.0"
			}]
		}
	]
}, Ky = () => /* @__PURE__ */ (0, Q.jsxs)("div", {
	className: `dc__grid-cols-2 dc__gap-16 ${cb}`,
	children: [/* @__PURE__ */ (0, Q.jsx)(Uy, { ...Wy }), /* @__PURE__ */ (0, Q.jsx)(Uy, {
		...Gy,
		containItemGroupWithBorder: !0
	})]
}), qy = [
	{
		heading: "Intel(R) Ethernet 100G 2P E810-C Adapter",
		description: "NIC.Slot.1-1-1",
		status: "OK",
		items: [{
			key: "Firmware",
			value: "22.0.9"
		}, {
			key: "Mac address",
			value: "40:A6:B7:B2:8D:00"
		}]
	},
	{
		heading: "Embedded NIC 1",
		description: "NIC.Embedded.1-1-1",
		status: "OK",
		items: [{
			key: "Status",
			value: "Enabled"
		}, {
			key: "Boot Protocol",
			value: "IPv4"
		}]
	},
	{
		heading: "Embedded NIC 2",
		description: "NIC.Embedded.2-1-1",
		status: "OK",
		items: [{
			key: "Status",
			value: "Enabled"
		}, {
			key: "Boot Protocol",
			value: "IPv4"
		}]
	}
], Jy = [
	"Successfully logged in using windriver, from 128.224.75.204 and REDFISH",
	"the session for windriver from 128.224.75.204 using GUI is logged off.",
	"Successfully logged in using windriver, from 128.224.75.104 and REDFISH",
	"Successfully logged in using windriver, from 128.224.75.105 and REDFISH",
	"The previous lof entry was repeated 5 times",
	"Successfully logged in using windriver, from 128.224.207.127 and RedFish",
	"The previous lof entry was repeated 2 times",
	"The previous lof entry was repeated 2 times",
	"The previous lof entry was repeated 2 times",
	"The previous lof entry was repeated 2 times",
	"The previous lof entry was repeated 2 times",
	"The previous lof entry was repeated 2 times",
	"The previous lof entry was repeated 2 times",
	"The previous lof entry was repeated 2 times",
	"The previous lof entry was repeated 2 times",
	"The previous lof entry was repeated 2 times",
	"The previous lof entry was repeated 2 times"
], Yy = Array(100).fill({
	time: /* @__PURE__ */ new Date(),
	severity: "OK",
	message: ""
}).map((e, t) => ({
	time: (/* @__PURE__ */ new Date(Date.now() - t * 1e3)).toLocaleString(),
	severity: "OK",
	message: Jy[t % Jy.length]
})), Xy = () => /* @__PURE__ */ (0, Q.jsxs)("div", {
	className: `dc__grid dc__gap-16 network-and-logs__container ${cb}`,
	children: [/* @__PURE__ */ (0, Q.jsx)(By, {
		heading: "Network Interfaces",
		description: "System network adapters",
		children: /* @__PURE__ */ (0, Q.jsx)("div", {
			className: "flexbox-col dc__gap-16",
			children: qy.map((e) => /* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox-col dc__gap-6",
				children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "flexbox dc__gap-8 dc__align-items-center dc__content-space",
					children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
						className: "flexbox-col",
						children: [/* @__PURE__ */ (0, Q.jsx)("h4", {
							className: "m-0 cn-9 fs-13 fw-6 lh-1-5",
							children: e.heading
						}), /* @__PURE__ */ (0, Q.jsx)("span", {
							className: "cn-7 fs-13 fw-4 lh-1-5",
							children: e.description
						})]
					}), /* @__PURE__ */ (0, Q.jsx)("span", {
						className: `${lb} bcg-1 cg-7`,
						children: e.status
					})]
				}), /* @__PURE__ */ (0, Q.jsx)("div", {
					className: "flexbox-col py-4 br-4 border__secondary ",
					children: e.items.map((t) => /* @__PURE__ */ (0, Q.jsxs)("div", {
						className: "flexbox dc__content-space dc__gap-8 dc__hover-n50 px-16 py-6",
						children: [/* @__PURE__ */ (0, Q.jsx)("span", {
							className: "cn-7 fs-13 fw-4 lh-1-5",
							children: t.key
						}), /* @__PURE__ */ (0, Q.jsx)("span", {
							className: "cn-9 fs-13 fw-6 lh-1-5",
							children: t.value
						})]
					}, `${t.key}-${t.value}-${e.heading}`))
				})]
			}, `${e.heading}-network-interface`))
		})
	}), /* @__PURE__ */ (0, Q.jsx)(By, {
		heading: "System Event Logs",
		description: "Recent system events and alerts",
		hideBorderBottom: !0,
		hideChildrenPadding: !0,
		children: /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox-col dc__overflow-auto",
			children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "network-and-logs__system-events-logs--row dc__grid dc__column-gap-12 px-16 py-6 cn-7 fs-12 fw-6 lh-20 dc__position-sticky dc__top-0 bg__primary dc__zi-1",
				children: [
					/* @__PURE__ */ (0, Q.jsx)(ql, {
						isSortable: !1,
						title: "Time"
					}),
					/* @__PURE__ */ (0, Q.jsx)(ql, {
						isSortable: !1,
						title: "Severity"
					}),
					/* @__PURE__ */ (0, Q.jsx)(ql, {
						isSortable: !1,
						title: "Message"
					})
				]
			}), Yy.map((e) => /* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "network-and-logs__system-events-logs--row dc__grid dc__column-gap-12 dc__hover-n50 px-16 py-8",
				children: [
					/* @__PURE__ */ (0, Q.jsx)("span", {
						className: "cn-9 fs-13 fw-4 lh-20 dc__word-break",
						children: e.time
					}),
					/* @__PURE__ */ (0, Q.jsx)("div", {
						className: "flexbox dc__align-start",
						children: /* @__PURE__ */ (0, Q.jsx)("span", {
							className: `${lb} bcg-1 cg-7`,
							children: e.severity
						})
					}),
					/* @__PURE__ */ (0, Q.jsx)("span", {
						className: "cn-9 fs-13 fw-4 lh-20",
						children: e.message
					})
				]
			}, `${e.time}-${e.message}`))]
		})
	})]
}), Zy = [{
	heading: "PSU 1",
	headingVariant: I.large,
	value: 167,
	status: "OK",
	statusBadgeClass: "bcg-1 cg-7",
	infoListItems: [
		{
			key: "Input",
			value: "175W"
		},
		{
			key: "Voltage",
			value: "232V"
		},
		{
			key: "Type",
			value: "AC240V"
		},
		{
			key: "Efficiency",
			value: "85%"
		}
	]
}, {
	heading: "PSU 2",
	headingVariant: I.large,
	value: 167,
	status: "OK",
	statusBadgeClass: "bcg-1 cg-7",
	infoListItems: [
		{
			key: "Input",
			value: "176W"
		},
		{
			key: "Voltage",
			value: "228V"
		},
		{
			key: "Type",
			value: "AC240V"
		},
		{
			key: "Efficiency",
			value: "85%"
		}
	]
}], Qy = [
	{
		heading: "Current consumption",
		headingVariant: I.medium,
		value: 207,
		progressData: {
			minValue: 0,
			maxValue: 1957
		}
	},
	{
		heading: "Power Metrics (1 min)",
		headingVariant: I.medium,
		infoListItems: [
			{
				key: "Min",
				value: "189W"
			},
			{
				key: "Max",
				value: "221W"
			},
			{
				key: "Average",
				value: "206W"
			}
		]
	},
	{
		heading: "Power Allocation",
		headingVariant: I.medium,
		infoListItems: [
			{
				key: "Allocated",
				value: "1351W"
			},
			{
				key: "Capacity",
				value: "1957W"
			},
			{
				key: "Requested",
				value: "903W"
			},
			{
				key: "Power Cap",
				value: "32767W"
			}
		]
	}
], $y = ({ items: e, infoBlockProps: t, heading: n, description: r }) => {
	let i = (e) => e.value ? /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: `flexbox dc__content-space dc__gap-8 ${e.infoListItems?.length ? "px-16 py-8" : ""}`,
		children: [/* @__PURE__ */ (0, Q.jsxs)("h5", {
			className: "m-0 cn-9 fs-16 fw-6 lh-1-5",
			children: [e.value, "W"]
		}), e.status && /* @__PURE__ */ (0, Q.jsx)("span", {
			className: `px-6 py-2 br-4 dc__truncate fs-13 fw-5 lh-20 dc__text-center ${e.statusBadgeClass}`,
			children: e.status
		})]
	}) : null;
	return /* @__PURE__ */ (0, Q.jsxs)(By, {
		shrinkHeightToContent: !0,
		heading: n,
		description: r,
		children: [e.map((e) => /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox-col dc__gap-6 dc__overflow-auto",
			children: [/* @__PURE__ */ (0, Q.jsx)("h4", {
				className: `m-0 cn-7 lh-1-5 ${e.headingVariant === I.large ? "fs-14 fw-6" : "fs-13 fw-4"}`,
				children: e.heading
			}), /* @__PURE__ */ (0, Q.jsxs)("div", {
				className: `flexbox-col br-4 border__secondary dc__overflow-auto ${e.infoListItems?.length ? "py-4" : "p-12 dc__gap-12"}`,
				children: [
					i(e),
					e.progressData && /* @__PURE__ */ (0, Q.jsxs)("div", {
						className: "flexbox-col dc__gap-6",
						children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
							className: "flexbox dc__content-space dc__gap-8",
							children: [/* @__PURE__ */ (0, Q.jsxs)("span", {
								className: "cn-7 fs-13 fw-4 lh-1-5",
								children: [e.progressData.minValue, "W"]
							}), /* @__PURE__ */ (0, Q.jsxs)("span", {
								className: "cn-7 fs-13 fw-4 lh-1-5",
								children: [e.progressData.maxValue, "W"]
							})]
						}), /* @__PURE__ */ (0, Q.jsx)(zl, {
							entities: [{
								value: e.value - e.progressData.minValue,
								color: "var(--G300)"
							}, {
								value: e.progressData.maxValue - e.value,
								color: "var(--N100)"
							}],
							showAnimationOnBar: !0,
							hideLegend: !0
						})]
					}),
					e.infoListItems?.length && /* @__PURE__ */ (0, Q.jsx)(Q.Fragment, { children: e.infoListItems.map((t) => /* @__PURE__ */ (0, Q.jsxs)("div", {
						className: "flexbox dc__content-space dc__gap-8 px-16 py-8 dc__hover-n50",
						children: [/* @__PURE__ */ (0, Q.jsx)("span", {
							className: "cn-7 fs-13 fw-4 lh-1-5",
							children: t.key
						}), /* @__PURE__ */ (0, Q.jsx)("span", {
							className: "cn-9 fs-13 fw-6 lh-1-5",
							children: t.value
						})]
					}, `${e.heading}-${t.key}-${n}`)) })
				]
			})]
		}, e.heading)), /* @__PURE__ */ (0, Q.jsx)(xc, { ...t })]
	});
}, eb = () => /* @__PURE__ */ (0, Q.jsxs)("div", {
	className: `dc__grid-cols-2 dc__gap-16 ${cb}`,
	children: [/* @__PURE__ */ (0, Q.jsx)($y, {
		heading: "Power supplies",
		description: "PSU status and readings",
		infoBlockProps: {
			heading: "Power supply Information",
			description: "Both power supplies are operating normally in a redundant configuration. Total system power consumption is 207W"
		},
		items: Zy
	}), /* @__PURE__ */ (0, Q.jsx)($y, {
		heading: "Power Metrics",
		description: "System power consumption details",
		infoBlockProps: {
			variant: "warning",
			heading: "Power cap status",
			description: "Power capping is currently disabled. enable power capping to limit system power consumption"
		},
		items: Qy
	})]
}), tb = /* @__PURE__ */ function(e) {
	return e.SYSTEM_INFORMATION = "System Information", e.HEALTH_STATUS = "Health Status", e.POWER_CONSUMPTION = "Power Consumption", e.PROCESSOR = "Processor", e.MEMORY = "Memory", e.STORAGE = "Storage", e;
}({}), nb = [
	{
		heading: tb.SYSTEM_INFORMATION,
		items: [
			{
				key: "Model",
				value: "PowerEdge XR8620t"
			},
			{
				key: "Manufacturer",
				value: "Dell Inc."
			},
			{
				key: "Service Tag",
				value: "4TW3H04"
			},
			{
				key: "Serial Number",
				value: "MXFC4003BO0020"
			},
			{
				key: "BIOS Version",
				value: "2.4.4"
			},
			{
				key: "iDRAC Version",
				value: "7.10.90.00"
			},
			{
				key: "Power State",
				value: "On",
				valueBadgeClass: "bcg-1 cg-7"
			}
		]
	},
	{
		heading: tb.HEALTH_STATUS,
		infoBlockProps: {
			variant: "success",
			layout: "column",
			heading: "System Status",
			description: "All components operating normally"
		},
		items: [
			{
				key: "CPU",
				value: "OK",
				valueBadgeClass: "bcg-1 cg-7"
			},
			{
				key: "Memory",
				value: "OK",
				valueBadgeClass: "bcg-1 cg-7"
			},
			{
				key: "Cores",
				value: "OK",
				valueBadgeClass: "bcg-1 cg-7"
			},
			{
				key: "Temperature",
				value: "OK",
				valueBadgeClass: "bcg-1 cg-7"
			},
			{
				key: "Power Supplies",
				value: "OK",
				valueBadgeClass: "bcg-1 cg-7"
			},
			{
				key: "Storage",
				value: "OK",
				valueBadgeClass: "bcg-1 cg-7"
			}
		]
	},
	{
		heading: tb.POWER_CONSUMPTION,
		items: [
			{
				key: "207W",
				useKeyAsHeading: !0,
				value: "Current",
				valueBadgeClass: "bg__secondary cn-7"
			},
			{
				key: "Min",
				value: "189W"
			},
			{
				key: "Max",
				value: "221W"
			},
			{
				key: "Average",
				value: "206W"
			},
			{
				key: "Capacity",
				value: "1957W"
			},
			{
				key: "Current Usage",
				value: "11%",
				progressDetails: {
					value: 11,
					color: "var(--B300)"
				}
			}
		]
	},
	{
		heading: tb.PROCESSOR,
		items: [
			{
				key: "Model",
				value: "Intel(R) Xeon(R) Gold 6433N"
			},
			{
				key: "Count",
				value: "1"
			},
			{
				key: "Cores",
				value: "32 (64 Threads)"
			},
			{
				key: "Base Speed",
				value: "1.40 GHz"
			},
			{
				key: "Temperature",
				value: "38°C"
			},
			{
				key: "Status",
				value: "OK",
				valueBadgeClass: "bcg-1 cg-7"
			}
		]
	},
	{
		heading: tb.MEMORY,
		items: [
			{
				key: "Total Memory",
				value: "256 GB"
			},
			{
				key: "Type",
				value: "ECC DDR5"
			},
			{
				key: "Speed",
				value: "4400 MT/s"
			},
			{
				key: "DIMM Slots",
				value: "8 of 8 populated"
			},
			{
				key: "Operation Mode",
				value: "OptimizerMode"
			},
			{
				key: "Status",
				value: "OK",
				valueBadgeClass: "bcg-1 cg-7"
			}
		]
	},
	{
		heading: tb.STORAGE,
		items: [
			{
				key: "Storage Mode",
				value: "NonRaid"
			},
			{
				key: "Boot Device",
				value: "PCleSSD.Integrated.1-0"
			},
			{
				key: "Status",
				value: "OK",
				valueBadgeClass: "bcg-1 cg-7"
			}
		]
	}
], rb = ({ heading: e, infoBlockProps: t, items: n }) => /* @__PURE__ */ (0, Q.jsx)(By, {
	heading: e,
	hideChildrenPadding: !0,
	children: /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox-col dc__overflow-auto py-4",
		children: [t && /* @__PURE__ */ (0, Q.jsx)("div", {
			className: "px-16 py-8",
			children: /* @__PURE__ */ (0, Q.jsx)(xc, { ...t })
		}), n.map(({ key: t, useKeyAsHeading: n, valueBadgeClass: r, progressDetails: i, value: a }) => /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: `flexbox-col dc__gap-6 ${n ? "" : "dc__hover-n50"}`,
			children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox dc__align-items-center dc__content-space dc__gap-8 px-16 py-6",
				children: [/* @__PURE__ */ (0, Q.jsx)("span", {
					className: n ? "cn-9 fs-16 fw-6 lh-26" : "cn-7 fs-13 fw-4 lh-1-5",
					children: t
				}), r ? /* @__PURE__ */ (0, Q.jsx)("span", {
					className: `${lb} ${r}`,
					children: a
				}) : /* @__PURE__ */ (0, Q.jsx)("span", {
					className: "fs-13 fw-6 lh-1-5 cn-9 dc__truncate",
					children: a
				})]
			}), i && /* @__PURE__ */ (0, Q.jsx)(zl, {
				entities: [{
					value: i.value,
					color: i.color
				}, {
					value: 100 - i.value,
					color: "var(--N100)"
				}],
				rootClassName: "px-16 pb-6",
				showAnimationOnBar: !0,
				hideLegend: !0
			})]
		}, `${t}-${e}`))]
	})
}), ib = () => /* @__PURE__ */ (0, Q.jsx)("div", {
	className: `dc__grid dc__gap-16 system-overview__container ${cb}`,
	children: nb.map((e) => /* @__PURE__ */ (0, Q.jsx)(rb, { ...e }, e.heading))
}), ab = [{
	heading: "CPU1 Temperature",
	icon: "ic-cpu",
	value: 38,
	status: "OK",
	minValue: 3,
	maxValue: 96
}, {
	heading: "Inlet Temperature",
	icon: "ic-thermometer",
	value: 22,
	status: "OK",
	minValue: -22,
	maxValue: 62
}], ob = [
	{
		heading: "System Board Fan 1A",
		value: 6e3,
		status: "OK",
		minValue: 480,
		maxValue: 1e4
	},
	{
		heading: "System Board Fan 1B",
		value: 5280,
		status: "OK",
		minValue: 480,
		maxValue: 1e4
	},
	{
		heading: "System Board Fan 2A",
		value: 6e3,
		status: "OK",
		minValue: 480,
		maxValue: 1e4
	},
	{
		heading: "System Board Fan 2B",
		value: 5280,
		status: "OK",
		minValue: 480,
		maxValue: 1e4
	}
], sb = () => /* @__PURE__ */ (0, Q.jsxs)("div", {
	className: `dc__grid-cols-2 dc__gap-16 ${cb}`,
	children: [/* @__PURE__ */ (0, Q.jsxs)(By, {
		shrinkHeightToContent: !0,
		heading: "Temperature Sensors",
		description: "Current temperature readings",
		children: [ab.map((e) => /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox-col dc__gap-12 br-4 border__secondary p-12",
			children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox dc__content-space dc__gap-8",
				children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "flexbox dc__gap-8 dc__align-items-center",
					children: [/* @__PURE__ */ (0, Q.jsx)(z, {
						name: e.icon,
						color: "N700",
						size: 16
					}), /* @__PURE__ */ (0, Q.jsx)("h4", {
						className: "m-0 cn-7 fs-14 fw-6 lh-1-5",
						children: e.heading
					})]
				}), /* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "flexbox dc__gap-8",
					children: [/* @__PURE__ */ (0, Q.jsxs)("span", {
						className: "cn-7 fs-14 fw-6 lh-1-5",
						children: [e.value, "°C"]
					}), /* @__PURE__ */ (0, Q.jsx)("span", {
						className: `${lb} bcg-1 cg-7`,
						children: e.status
					})]
				})]
			}), /* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox-col dc__gap-6",
				children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "flexbox dc__content-space dc__gap-8",
					children: [/* @__PURE__ */ (0, Q.jsxs)("span", {
						className: "cn-7 fs-13 fw-4 lh-1-5",
						children: [
							"Critical: ",
							e.minValue,
							"°C"
						]
					}), /* @__PURE__ */ (0, Q.jsxs)("span", {
						className: "cn-7 fs-13 fw-4 lh-1-5",
						children: [
							"Warning: ",
							e.maxValue,
							"°C"
						]
					})]
				}), /* @__PURE__ */ (0, Q.jsx)(zl, {
					entities: [{
						value: e.value - e.minValue,
						color: "var(--G500)"
					}, {
						value: e.maxValue - e.value,
						color: "var(--N100)"
					}],
					showAnimationOnBar: !0,
					hideLegend: !0
				})]
			})]
		}, `${e.heading}-temperature`)), /* @__PURE__ */ (0, Q.jsx)(xc, {
			heading: "Temperature Status",
			description: "All temperature sensors are within normal operating ranges. The system is running at optimal temperature"
		})]
	}), /* @__PURE__ */ (0, Q.jsx)(By, {
		shrinkHeightToContent: !0,
		heading: "Cooling Fans",
		description: "Fan speeds and status",
		children: ob.map((e) => /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox-col dc__gap-6",
			children: [/* @__PURE__ */ (0, Q.jsx)("h4", {
				className: "m-0 cn-7 fs-13 fw-4 lh-1-5",
				children: e.heading
			}), /* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox-col dc__gap-12 br-4 border__secondary p-12",
				children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "flexbox dc__content-space dc__gap-8",
					children: [/* @__PURE__ */ (0, Q.jsxs)("h5", {
						className: "m-0 cn-9 fs-16 fw-6 lh-1-5",
						children: [e.value, " RPM"]
					}), /* @__PURE__ */ (0, Q.jsx)("span", {
						className: `${lb} bcg-1 cg-7`,
						children: e.status
					})]
				}), /* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "flexbox-col dc__gap-6",
					children: [/* @__PURE__ */ (0, Q.jsx)("div", {
						className: "flexbox dc__content-space dc__gap-8",
						children: /* @__PURE__ */ (0, Q.jsxs)("span", {
							className: "cn-7 fs-13 fw-4 lh-1-5",
							children: [
								"Min: ",
								e.minValue,
								" RPM"
							]
						})
					}), /* @__PURE__ */ (0, Q.jsx)(zl, {
						entities: [{
							value: e.value - e.minValue,
							color: "var(--G500)"
						}, {
							value: e.maxValue - (e.value - e.minValue),
							color: "var(--N100)"
						}],
						showAnimationOnBar: !0,
						hideLegend: !0
					})]
				})]
			})]
		}, `${e.heading}-cooling-fans`))
	})]
}), cb = "py-12 px-20 bg__primary h-100 w-100 dc__overflow-auto flex-grow-1", lb = "px-6 py-2 br-4 dc__truncate fs-13 fw-5 lh-20 dc__text-center", ub = [
	{
		id: "system-overview",
		label: "System Overview",
		renderComponent: () => /* @__PURE__ */ (0, Q.jsx)(ib, {})
	},
	{
		id: "hardware",
		label: "Hardware",
		renderComponent: () => /* @__PURE__ */ (0, Q.jsx)(Ky, {})
	},
	{
		id: "thermal",
		label: "Thermal",
		renderComponent: () => /* @__PURE__ */ (0, Q.jsx)(sb, {})
	},
	{
		id: "power",
		label: "Power",
		renderComponent: () => /* @__PURE__ */ (0, Q.jsx)(eb, {})
	},
	{
		id: "network-and-logs",
		label: "Network & Logs",
		renderComponent: () => /* @__PURE__ */ (0, Q.jsx)(Xy, {})
	}
], db = "?chartCategoryId=1", fb = 5e3, pb = {
	name: { "ui:disabled": !0 },
	region: { "ui:disabled": !0 },
	vpc_cidr: { "ui:disabled": !0 },
	availability_zones: { "ui:disabled": !0 },
	private_access_cidrs: { "ui:disabled": !0 }
}, mb = ({ version: e, isLatest: t }) => {
	let n = `v${e}`;
	return {
		label: t ? `${n} (Latest)` : n,
		value: e
	};
}, hb = ({ valuesSchema: e, values: t, installationType: n, installationId: r, name: i, installationStatus: a, installedEntityId: o, conditions: s }) => ({
	schema: JSON.parse(e || "{}"),
	values: Qf.parse(t || "{}"),
	installationType: n,
	status: a,
	installationId: r,
	name: i,
	conditions: s ?? [],
	correspondingClusterId: o > 0 ? o : 0
}), gb = (e) => {
	switch (e) {
		case "True": return {
			name: "ic-check",
			color: "G500"
		};
		case "Unknown": return {
			name: "ic-in-progress",
			color: null
		};
		default: return {
			name: "ic-close-large",
			color: "R500"
		};
	}
}, _b = (e) => {
	switch (e) {
		case wc.Deleted: return {
			header: "Cluster deleted",
			icon: "ic-delete",
			color: "R500"
		};
		case wc.Deleting: return {
			header: "Deleting cluster",
			icon: "ic-delete-dots",
			color: "R500"
		};
		case wc.Updating: return {
			header: "Updating cluster",
			icon: "ic-circle-loader",
			color: "O500"
		};
		case wc.Failed: return {
			header: "Cluster creation failed",
			icon: "ic-close-large",
			color: "R500"
		};
		case wc.Installed: return {
			header: "Cluster created",
			icon: "ic-success",
			color: null
		};
		case wc.Creating:
		default: return {
			header: "Creating cluster",
			icon: "ic-circle-loader",
			color: "O500"
		};
	}
}, vb = async (e) => {
	let t = { sourceK8sVersion: e[0] === "v" ? e.slice(1) : e }, { result: n } = await G(Rd(O.CLUSTER_K8S_VERSIONS_LIST, t)), r = n?.filter((e) => !!e.version)?.map(({ version: e, isLatest: t }) => ({
		version: e,
		isLatest: t || !1
	})) || [];
	return {
		versionList: r,
		latestVersion: r.find((e) => e.isLatest)?.version || r[0]?.version
	};
}, yb = async (e) => {
	await ff(`${xd({
		baseUrl: O.INFRASTRUCTURE,
		kind: Dl.infrastructureInstallation,
		version: kl.v1
	})}/${e}`);
}, bb = async ({ abortControllerRef: e }) => G(xd({
	baseUrl: O.INFRASTRUCTURE,
	kind: Dl.infrastructureInstallation,
	version: kl.v1
}), { abortControllerRef: e }), xb = async ({ abortControllerRef: e }) => {
	try {
		let { result: t } = await bb({ abortControllerRef: e });
		return (t ?? []).map(hb);
	} catch (e) {
		throw pd(e) || K(e), e;
	}
}, Sb = async ({ id: e, name: t, abortControllerRef: n }) => G(Rd(xd({
	baseUrl: O.INFRASTRUCTURE,
	kind: Dl.infrastructureInstallation,
	version: kl.v1
}), e ? { id: e } : { name: t }), { abortControllerRef: n }), Cb = async ({ clusterName: e, installationId: t, abortControllerRef: n }) => {
	try {
		let { result: r } = await Sb({
			abortControllerRef: n,
			...t ? { id: t } : { name: e }
		});
		return r.installationId ? hb(r) : null;
	} catch (e) {
		throw pd(e) || K(e), e;
	}
}, wb = async ({ data: e, installationId: t, installationType: r }) => {
	try {
		return await n({
			installationId: t,
			chartValues: Tu(e),
			installationType: r
		}), H.showToast({
			variant: U.success,
			description: "Cluster update initiated successfully"
		}), !0;
	} catch (e) {
		return K(e), !1;
	}
}, Tb = async (e, t) => (await G(Rd(O.RECOMMENDED_CHARTS_STATUS, {
	clusterId: t,
	appStoreId: e
}))).result || {}, Eb = () => /* @__PURE__ */ (0, Q.jsxs)("div", {
	className: "flexbox-col p-12 br-8 bg__primary border__primary dc__overflow-hidden dc__gap-8 mw-232",
	children: [/* @__PURE__ */ (0, Q.jsx)("div", { className: "h-32 w-32 shimmer" }), /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox-col dc__gap-8",
		children: [/* @__PURE__ */ (0, Q.jsx)("span", { className: "shimmer h-16 w-100px" }), /* @__PURE__ */ (0, Q.jsx)("span", { className: "shimmer h-16 w-100px" })]
	})]
}), Db = ({ name: e, id: t, icon: n, statusDetails: r, statusLoading: i }) => {
	let { status: a, installedAppId: o, environmentId: s } = r, c = o && s, l = c ? Y(B.INFRASTRUCTURE_MANAGEMENT_APP_DETAIL.DEVTRON_CHART, {
		appId: String(o),
		envId: String(s)
	}) : `${B.CHART_STORE}/chart/${t}/deploy-chart`;
	return /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox-col p-12 br-8 bg__primary border__primary dc__overflow-hidden dc__gap-8 mw-232 dc__hover-n50 dc__opacity-hover dc__opacity-hover--parent",
		onClick: sd(`${window.__BASE_URL__}${l}`),
		role: "button",
		tabIndex: 0,
		children: [/* @__PURE__ */ (0, Q.jsx)(bc, {
			imageProps: {
				src: n,
				height: 36,
				width: 36,
				alt: `${e} icon`,
				className: "dc__chart-grid-item__icon"
			},
			fallbackImage: /* @__PURE__ */ (0, Q.jsx)(z, {
				name: "ic-helm",
				size: 36,
				color: "N500"
			})
		}), /* @__PURE__ */ (0, Q.jsxs)("div", { children: [/* @__PURE__ */ (0, Q.jsx)("span", {
			className: "fs-13 fw-6 cn-9 lh-1-5 dc__truncate dc__w-fit-content",
			children: e
		}), /* @__PURE__ */ (0, Q.jsx)("div", {
			className: "flex fs-12 dc__content-start lh-20 dc__gap-4",
			children: i ? /* @__PURE__ */ (0, Q.jsx)("span", { className: "shimmer w-100px h-20" }) : /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [
				/* @__PURE__ */ (0, Q.jsx)("div", {
					className: `flex left ${a === "Installed" ? "cg-5" : ""}`,
					children: /* @__PURE__ */ (0, Q.jsx)(Xl, {
						hideIcon: a === "Installed",
						status: a
					})
				}),
				/* @__PURE__ */ (0, Q.jsx)("span", {
					className: "dc__opacity-hover--child",
					children: "/"
				}),
				/* @__PURE__ */ (0, Q.jsx)("span", {
					className: "fw-6 cb-5 dc__opacity-hover--child",
					children: `${c ? "Details" : "Deploy"}`
				})
			] })
		})] })]
	});
}, Ob = ({ clusterId: e, getAvailableCharts: t }) => {
	let [n, r, i, a] = hf(() => t(db), []), o = (r?.result || []).map((e) => e.id).join(), [s, c] = hf(() => Tb(o, e), [], !!o);
	return r && !r.result?.length ? null : /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox-col br-4 bg__primary border__primary dc__overflow-hidden mb-16",
		children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox px-16 py-10 dc__gap-8",
			children: [/* @__PURE__ */ (0, Q.jsx)(La, { className: "icon-dim-20" }), /* @__PURE__ */ (0, Q.jsx)("span", {
				className: "fs-13 lh-20 fw-6 cn-9",
				children: "Recommended Add-ons"
			})]
		}), /* @__PURE__ */ (0, Q.jsx)("div", {
			className: "flexbox p-16 dc__gap-12 dc__overflow-auto",
			children: n ? /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsx)(Eb, {}), /* @__PURE__ */ (0, Q.jsx)(Eb, {})] }) : i ? /* @__PURE__ */ (0, Q.jsx)(lc, {
				rootClassName: "flex flex-grow-1",
				title: "Could not load recommended add ons",
				subTitle: "",
				reload: a
			}) : (r?.result ?? []).map(({ name: e, id: t, icon: n }) => /* @__PURE__ */ (0, Q.jsx)(Db, {
				name: e,
				id: t,
				icon: n,
				statusDetails: c?.[t] ?? {
					status: "Installed",
					installedAppId: 0,
					environmentId: 0
				},
				statusLoading: s
			}, `${e}-${t}`))
		})]
	});
}, kb = ({ values: e, schema: t }) => {
	let [n, r] = j({});
	return /* @__PURE__ */ (0, Q.jsx)(ka, {
		value: {
			jsonViewExpansionMap: n,
			updateJsonViewExpansionMap: (e, t) => {
				r((n) => ({
					...n,
					[e]: t
				}));
			},
			currentView: Object.entries(n).every(([, e]) => e) ? Or : ii
		},
		children: /* @__PURE__ */ (0, Q.jsx)(Jr, {
			originalFormData: e,
			originalSchema: t
		})
	});
}, Ab = ({ values: e, setIsEditModalOpen: t, schema: n, installationId: r, installationType: i, pollClusterConfig: a }) => {
	let o = Ja(null), [s, c] = j(!1), [l, u] = j(e), d = () => {
		t(!1);
	}, f = async ({ formData: e }) => {
		c(!0), u(e);
		let t = await wb({
			installationId: r,
			installationType: i,
			data: e
		});
		c(!1), t && (a(e.name), d());
	}, p = (e = []) => {
		K(Error(ke)), console.error("Form Validation Error", e);
	}, m = () => {
		o.current.submit();
	};
	return /* @__PURE__ */ (0, Q.jsx)(Rs, {
		position: "right",
		width: "800px",
		onEscape: d,
		onClose: d,
		children: /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "h-100 bg__primary flexbox-col dc__overflow-hidden",
			onClick: uf,
			children: [
				/* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "flex dc__content-space py-16 px-20 dc__border-bottom",
					children: [/* @__PURE__ */ (0, Q.jsx)("h2", {
						className: "fs-16 cn-9 fw-6 m-0",
						children: "Edit cluster configuration"
					}), /* @__PURE__ */ (0, Q.jsx)(M, {
						icon: /* @__PURE__ */ (0, Q.jsx)(tr, {}),
						dataTestId: "close-create-cluster-modal-button",
						component: N.button,
						style: P.negativeGrey,
						size: I.xs,
						variant: F.borderLess,
						ariaLabel: "Close new cluster drawer",
						showTooltip: s,
						tooltipProps: { content: ds },
						disabled: s,
						onClick: d,
						showAriaLabelInTippy: !1
					})]
				}),
				/* @__PURE__ */ (0, Q.jsx)("div", {
					className: "dc__overflow-auto flex-grow-1",
					children: /* @__PURE__ */ (0, Q.jsx)(gl, {
						ref: o,
						uiSchema: {
							...mc,
							...structuredClone(pb)
						},
						schema: n,
						onSubmit: f,
						formData: l,
						onError: p
					})
				}),
				/* @__PURE__ */ (0, Q.jsxs)("footer", {
					className: "dc__border-top flex dc__gap-8 right bg__primary pt-16 pr-20 pb-16 pl-20",
					children: [/* @__PURE__ */ (0, Q.jsx)(M, {
						text: "Cancel",
						size: I.large,
						dataTestId: "close-create-cluster-button",
						disabled: s,
						onClick: d,
						variant: F.secondary,
						style: P.neutral
					}), /* @__PURE__ */ (0, Q.jsx)(M, {
						text: "Update Cluster",
						size: I.large,
						dataTestId: "update-create-cluster-button",
						buttonProps: { type: "submit" },
						isLoading: s,
						onClick: m
					})]
				})
			]
		})
	});
}, jb = ({ type: e, status: t, isExpanded: n, toggleExpandStage: r }) => {
	let { name: i, color: a } = gb(t);
	return /* @__PURE__ */ (0, Q.jsxs)("button", {
		"data-testId": `installation status ${e} state`,
		className: "flexbox dc__unset-button-styles dc__align-items-center dc__gap-8 px-8 py-6 br-4 bg__overlay--primary",
		type: "button",
		onClick: r,
		"aria-label": `expand collapse ${e} details`,
		children: [/* @__PURE__ */ (0, Q.jsx)(hn, { className: `icon-dim-16 dc__transition--transform icon-stroke__white ${n ? "" : "dc__flip-n90 dc__opacity-0_5"}` }), /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox dc__align-items-center dc__gap-12",
			children: [/* @__PURE__ */ (0, Q.jsx)(z, {
				name: i,
				color: a
			}), /* @__PURE__ */ (0, Q.jsx)("span", {
				className: "fs-13 fw-6 lh-20 cn-9",
				children: e
			})]
		})]
	});
}, Mb = ({ index: e, title: t, description: n }) => /* @__PURE__ */ (0, Q.jsxs)("div", {
	className: "flexbox dc__gap-8",
	children: [/* @__PURE__ */ (0, Q.jsx)("span", {
		className: "w-36 dc__text-align-end dc__no-shrink",
		children: e
	}), /* @__PURE__ */ (0, Q.jsxs)("span", { children: [
		t,
		": ",
		n
	] })]
}), Nb = ({ stageDetails: e, type: t }) => {
	let [n, r] = j(!0);
	return /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox-col dc__gap-4",
		children: [/* @__PURE__ */ (0, Q.jsx)(jb, {
			status: e.status,
			type: t,
			isExpanded: n,
			toggleExpandStage: () => {
				r((e) => !e);
			}
		}), n && /* @__PURE__ */ (0, Q.jsx)("div", {
			className: "fs-13 fw-4 lh-24 cn-9 mono",
			children: Object.keys(e).map((t, n) => /* @__PURE__ */ (0, Q.jsx)(Mb, {
				index: n + 1,
				title: t,
				description: e[t]
			}, n))
		})]
	});
}, Pb = ({ conditions: e = [] }) => /* @__PURE__ */ (0, Q.jsx)("div", {
	className: `p-8 flexbox-col dc__gap-4 flex-grow-1 dc__overflow-auto ${Qu(mo.dark)}`,
	style: { backgroundColor: "var(--terminal-bg)" },
	children: e.length ? e.map((e, t) => {
		let { type: n, lastProbeTime: r, ...i } = e;
		return /* @__PURE__ */ (0, Q.jsx)(Nb, {
			stageDetails: i,
			type: n
		}, t);
	}) : /* @__PURE__ */ (0, Q.jsx)(ul, { size: 24 })
}), Fb = ({ clusterId: e }) => {
	let t = `${B.RESOURCE_BROWSER.ROOT}/${e}/${Qa.value}/${Kc.Overview.toLowerCase()}/k8sEmptyGroup`;
	return /* @__PURE__ */ (0, Q.jsx)(M, {
		dataTestId: "go-to-cluster-overview",
		text: "Go to cluster overview",
		endIcon: /* @__PURE__ */ (0, Q.jsx)(z, {
			name: "ic-arrow-right",
			color: "B500"
		}),
		variant: F.text,
		component: N.link,
		linkProps: { to: t }
	});
}, Ib = ({ installationId: e, handleClose: t, hideEditButton: n }) => {
	let [r, i] = j(!0), [a, o] = j(null), [s, c] = j(null), [l, u] = j(!1), d = Ja(new AbortController()), f = Ja(null), { schema: p, values: m } = s ?? {}, h = () => Cb({
		installationId: +e,
		abortControllerRef: d
	}).then((e) => {
		if (!e) throw new Wl({
			code: Us.NOT_FOUND,
			errors: [new Ul({ userMessage: "No matching installation cluster found" })]
		});
		c(e), o(null);
	}).catch((e) => {
		throw pd(e) || K(e), o(e), clearTimeout(f.current), d.current.abort(), e;
	}).finally(() => {
		i(!1);
	}), g = () => {
		f.current === null && (f.current = setTimeout(() => {
			h().then(() => {
				f.current = null, g();
			}).catch($d);
		}, fb));
	}, _ = () => {
		d.current = new AbortController(), h().catch($d), g();
	};
	k(() => (_(), () => {
		d.current.abort(), clearTimeout(f.current);
	}), []);
	let v = s?.status !== wc.Deleting && s?.status !== wc.Deleted, y = () => t ? /* @__PURE__ */ (0, Q.jsx)(M, {
		dataTestId: "close-installation-status-dialog",
		icon: /* @__PURE__ */ (0, Q.jsx)(z, {
			name: "ic-close-small",
			color: null
		}),
		ariaLabel: "close installation status dialog",
		showAriaLabelInTippy: !1,
		size: I.xs,
		variant: F.borderLess,
		style: P.negativeGrey,
		onClick: t
	}) : s.correspondingClusterId && v ? /* @__PURE__ */ (0, Q.jsx)(Fb, { clusterId: s.correspondingClusterId }) : null, b = () => {
		u(!0);
	};
	return /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox w-800 h-500 bg__primary border__primary br-12  dc__overflow-hidden",
		children: [(() => {
			if (r) return /* @__PURE__ */ (0, Q.jsx)(ul, { size: 32 });
			if (a && !s || !s) return /* @__PURE__ */ (0, Q.jsx)(lc, {
				title: "Could not load installation status",
				subTitle: "",
				rootClassName: "flex-grow-1",
				reload: _
			});
			let { header: e, icon: t, color: i } = _b(s.correspondingClusterId && s.status === wc.Creating ? wc.Installed : s.status);
			return /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox-col w-300 bg__secondary dc__no-shrink",
				children: [
					/* @__PURE__ */ (0, Q.jsxs)("div", {
						className: "flexbox-col dc__gap-12 cn-9 p-24 border__secondary--bottom",
						children: [/* @__PURE__ */ (0, Q.jsx)("div", {
							className: "flex p-8 br-8 bcn-1 dc__w-fit-content",
							children: /* @__PURE__ */ (0, Q.jsx)(z, {
								name: "ic-amazon-eks",
								size: 32,
								color: null
							})
						}), /* @__PURE__ */ (0, Q.jsx)("span", {
							className: "dc__truncate fs-16 fw-7 lh-1-5 font-merriweather",
							children: s.name
						})]
					}),
					/* @__PURE__ */ (0, Q.jsx)("div", {
						className: "flexbox-col dc__gap-12 dc__overflow-auto p-24 catalog__cluster-config flex-grow-1",
						children: /* @__PURE__ */ (0, Q.jsx)(kb, {
							schema: p,
							values: m
						})
					}),
					!n && v && /* @__PURE__ */ (0, Q.jsx)("div", {
						className: "border__secondary--top flexbox px-24 py-16",
						children: /* @__PURE__ */ (0, Q.jsx)(M, {
							dataTestId: "edit-cluster-config-button",
							startIcon: /* @__PURE__ */ (0, Q.jsx)(z, {
								name: "ic-pencil",
								color: null
							}),
							text: "Edit Configurations",
							variant: F.text,
							size: I.large,
							onClick: b
						})
					})
				]
			}), /* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox-col flex-grow-1",
				children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "flexbox p-24 dc__content-space",
					children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
						className: "flex dc__gap-8",
						children: [/* @__PURE__ */ (0, Q.jsx)(z, {
							name: t,
							color: i,
							size: 20
						}), /* @__PURE__ */ (0, Q.jsx)("span", {
							"data-testid": "cluster-installation-status",
							className: "fs-16 fw-6 lh-1-5",
							children: e
						})]
					}), y()]
				}), /* @__PURE__ */ (0, Q.jsx)(Pb, { conditions: s.conditions })]
			})] });
		})(), l && /* @__PURE__ */ (0, Q.jsx)(Ab, {
			installationId: s.installationId,
			installationType: s.installationType,
			schema: s.schema,
			setIsEditModalOpen: u,
			values: s.values,
			pollClusterConfig: _
		})]
	});
}, Lb = ({ installationId: e, handleClose: t }) => /* @__PURE__ */ (0, Q.jsx)(yo, {
	onEscape: t,
	children: /* @__PURE__ */ (0, Q.jsx)("div", {
		className: "dc__m-auto mt-40",
		children: /* @__PURE__ */ (0, Q.jsx)(Ib, {
			installationId: e,
			handleClose: t,
			hideEditButton: !0
		})
	})
}), Rb = ({ clusterConfig: e, pollClusterConfig: t }) => {
	let [n, r] = j(!1), [i, a] = j(!1), { schema: o = {}, values: s = {}, installationType: c, status: l, installationId: u, name: d = "" } = e ?? {}, f = l === wc.Updating;
	return k(() => {
		f && t(d);
	}, [f]), /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [
		/* @__PURE__ */ (0, Q.jsxs)("section", {
			className: "bg__primary en-2 br-4 bw-1 fs-13 fw-4 lh-20 cn-7 mb-12",
			children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "dc__border-bottom dc__top-radius-4 bg__secondary flex flex-justify px-16 py-8",
				children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "flexbox flex-align-center dc__gap-6",
					children: [/* @__PURE__ */ (0, Q.jsx)(z, {
						name: "ic-sliders-vertical",
						color: "N900",
						size: 16
					}), /* @__PURE__ */ (0, Q.jsx)("span", {
						className: "fw-6 cn-9 mr-8",
						children: "Cluster Configuration"
					})]
				}), /* @__PURE__ */ (0, Q.jsx)(M, {
					dataTestId: "edit-cluster-config-button",
					startIcon: /* @__PURE__ */ (0, Q.jsx)(z, {
						name: "ic-pencil",
						size: 16,
						color: "N700"
					}),
					size: I.small,
					text: "Edit",
					variant: F.borderLess,
					onClick: () => {
						r(!0);
					}
				})]
			}), /* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox-col dc__gap-16 p-16",
				children: [/* @__PURE__ */ (0, Q.jsx)("div", {
					className: "dc__overflow-auto mxh-504",
					children: /* @__PURE__ */ (0, Q.jsx)("div", {
						className: "flexbox dc__gap-20 catalog__cluster-config catalog__cluster-config--wrap flex-wrap",
						children: /* @__PURE__ */ (0, Q.jsx)(kb, {
							values: s,
							schema: o
						})
					})
				}), f && /* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "flexbox px-12 py-8 dc__gap-8 br-4 bg__secondary",
					children: [
						/* @__PURE__ */ (0, Q.jsx)(Xl, {
							status: Zl.PROGRESSING,
							hideMessage: !0
						}),
						/* @__PURE__ */ (0, Q.jsx)("span", {
							className: "fw-6 lh-20 fs-13 co-5",
							children: "Update in progress"
						}),
						/* @__PURE__ */ (0, Q.jsx)(M, {
							dataTestId: "view-update-cluster-config-button",
							text: "View details",
							variant: F.text,
							onClick: () => {
								a(!0), t(d);
							}
						})
					]
				})]
			})]
		}),
		u && i && /* @__PURE__ */ (0, Q.jsx)(Lb, {
			installationId: u?.toString(),
			handleClose: () => {
				a(!1);
			}
		}),
		n && /* @__PURE__ */ (0, Q.jsx)(Ab, {
			installationId: u,
			installationType: c,
			schema: o,
			setIsEditModalOpen: r,
			values: s,
			pollClusterConfig: t
		})
	] });
}, zb = (e) => /* @__PURE__ */ (0, Q.jsxs)("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 48,
	height: 48,
	viewBox: "0 0 48 48",
	fill: "none",
	...e,
	children: [
		/* @__PURE__ */ (0, Q.jsx)("rect", {
			x: 6,
			y: 30,
			width: 36,
			height: 14,
			rx: 2,
			fill: "#0066CC",
			fillOpacity: .3,
			stroke: "#0066CC",
			strokeWidth: 2
		}),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M18.2 16H8C6.89543 16 6 16.8954 6 18V28C6 29.1046 6.89543 30 8 30H40C41.1046 30 42 29.1046 42 28V18C42 16.8954 41.1046 16 40 16H37.8C36.8734 20.5645 32.8379 24 28 24C23.1621 24 19.1266 20.5645 18.2 16Z",
			fill: "#0066CC",
			fillOpacity: .3
		}),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			d: "M18.2 16L19.18 15.8011L19.0174 15H18.2V16ZM37.8 16V15H36.9826L36.82 15.8011L37.8 16ZM8 17H18.2V15H8V17ZM7 18C7 17.4477 7.44772 17 8 17V15C6.34315 15 5 16.3431 5 18H7ZM7 28V18H5V28H7ZM8 29C7.44772 29 7 28.5523 7 28H5C5 29.6569 6.34315 31 8 31V29ZM40 29H8V31H40V29ZM41 28C41 28.5523 40.5523 29 40 29V31C41.6569 31 43 29.6569 43 28H41ZM41 18V28H43V18H41ZM40 17C40.5523 17 41 17.4477 41 18H43C43 16.3431 41.6569 15 40 15V17ZM37.8 17H40V15H37.8V17ZM36.82 15.8011C35.9861 19.9087 32.353 23 28 23V25C33.3229 25 37.7607 21.2203 38.78 16.1989L36.82 15.8011ZM28 23C23.647 23 20.0139 19.9087 19.18 15.8011L17.22 16.1989C18.2393 21.2203 22.6771 25 28 25V23Z",
			fill: "#0066CC"
		}),
		/* @__PURE__ */ (0, Q.jsx)("circle", {
			cx: 28,
			cy: 14,
			r: 10,
			fill: "#1DAD70",
			fillOpacity: .15,
			stroke: "#1DAD70",
			strokeWidth: 2
		}),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			d: "M27.9991 19V9M27.9991 9L23.9082 13.0909M27.9991 9L32.09 13.0909",
			stroke: "#1DAD70",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			d: "M11 23H15",
			stroke: "#0066CC",
			strokeWidth: 2,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			d: "M11 37H15",
			stroke: "#0066CC",
			strokeWidth: 2,
			strokeLinecap: "round"
		})
	]
}), Bb = ({ currentVersion: e, latestVersion: t, clusterListOptions: n, targetVersion: r, setTargetVersion: i, clusterName: a, handleCloseClusterDialog: o, handleOpenScanClusterTab: s }) => {
	let c = e === t, l = (e) => {
		i(e.value);
	}, u = () => {
		Vd({
			category: "RB Upgrade Cluster",
			action: "RB_CLUSTER_CHECK_UPGRADE_COMPATIBILITY_SCAN_CLUSTER"
		}), s(r), o();
	}, d = () => /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox-col dc__gap-12 w-100",
		children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox-col dc__gap-4",
			children: [/* @__PURE__ */ (0, Q.jsxs)("span", {
				className: "cn-8 fs-13 fw-4 lh-20 dc__truncate dc_max-width__max-content",
				children: ["Current version: ", e]
			}), c && /* @__PURE__ */ (0, Q.jsxs)("span", {
				className: "cn-8 fs-13 fw-4 lh-20 dc__truncate dc_max-width__max-content",
				children: ["Latest version available: ", e]
			})]
		}), !c && /* @__PURE__ */ (0, Q.jsx)(V, {
			inputId: "scan-cluster-version-input",
			label: "Select target version",
			required: !0,
			options: n,
			value: mb({
				version: r,
				isLatest: r === t
			}),
			onChange: l
		})]
	});
	return /* @__PURE__ */ (0, Q.jsx)(ns, {
		variant: rs.custom,
		Icon: /* @__PURE__ */ (0, Q.jsx)(zb, {}),
		title: c ? `Cluster ${a} is running the latest Kubernetes version` : `Upgrade Kubernetes version for cluster ${a}`,
		handleClose: o,
		buttonConfig: {
			secondaryButtonConfig: {
				text: c ? "Close" : "Cancel",
				onClick: o
			},
			...c ? {} : { primaryButtonConfig: {
				text: "Scan Cluster",
				onClick: u
			} }
		},
		children: d()
	});
}, Vb = ({ handleOpenScanClusterTab: e, clusterName: t, currentVersion: n }) => {
	let [r, i, a, o] = hf(() => vb(n), [n], !!n), [s, c] = j(!1), [l, u] = j(null), d = i?.latestVersion, f = () => {
		if (Vd({
			category: "RB Upgrade Cluster",
			action: "RB_CLUSTER_CHECK_UPGRADE_COMPATIBILITY"
		}), a?.code === eo.PERMISSION_DENIED) {
			H.showToast({
				variant: U.notAuthorized,
				title: eu.TITLE,
				description: eu.SUBTITLE
			});
			return;
		}
		c(!0);
	};
	k(() => {
		!r && !a && i?.latestVersion && u(i.latestVersion);
	}, [
		r,
		i,
		a
	]);
	let p = A(() => i?.versionList?.map(mb) || [], [i]), m = () => {
		c(!1);
	};
	return /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "py-8 px-12 flexbox-col dc__gap-8 br-4 eb-2 bw-1 bcb-1",
		children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox dc__content-space dc__gap-8",
			children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox-col dc__gap-4",
				children: [/* @__PURE__ */ (0, Q.jsx)("h6", {
					className: "m-0 cn-9 fs-13 fw-6 lh-20",
					children: "Migrating to another K8s version?"
				}), /* @__PURE__ */ (0, Q.jsx)("p", {
					className: "m-0 fs-13 fw-4 lh-20 cn-9",
					children: "Check Kubernetes objects api-version compatibility and get migration path for K8s objects and prepare it for cluster upgrades."
				})]
			}), /* @__PURE__ */ (0, Q.jsx)(Ln, { className: "icon-dim-20 dc__no-shrink" })]
		}), /* @__PURE__ */ (0, Q.jsx)(M, {
			dataTestId: "check-cluster-upgrade-compatibility",
			text: "Check compatibility",
			variant: F.text,
			size: I.medium,
			onClick: f,
			...r ? {
				disabled: !0,
				endIcon: /* @__PURE__ */ (0, Q.jsx)(z, {
					name: "ic-circle-loader",
					color: null
				})
			} : {}
		})]
	}), s && /* @__PURE__ */ (0, Q.jsx)(Bb, {
		currentVersion: n,
		latestVersion: d || n,
		clusterListOptions: p,
		targetVersion: l,
		setTargetVersion: u,
		clusterName: t,
		handleCloseClusterDialog: m,
		handleOpenScanClusterTab: e,
		...a ? {
			hasError: !!a,
			reload: o
		} : {}
	})] });
}, Hb = /* @__PURE__ */ function(e) {
	return e.DELETE = "DELETE", e.POD_SPREAD = "POD_SPREAD", e.HIBERNATION_RULES = "HIBERNATION_RULES", e;
}({}), Ub = [{ items: [{
	id: Hb.POD_SPREAD,
	label: "Set Pod spread",
	startIcon: {
		name: "ic-two-cubes",
		color: "N800"
	},
	componentType: "button"
}, {
	id: Hb.HIBERNATION_RULES,
	label: "Hibernation rules",
	startIcon: {
		name: "ic-hibernate-circle",
		color: "N800"
	},
	componentType: "button"
}] }, { items: [{
	id: Hb.DELETE,
	label: "Delete",
	startIcon: { name: "ic-delete" },
	componentType: "button",
	type: "negative"
}] }], Wb = ({ handleDelete: e, handleHibernationRules: t, handlePodSpread: n }) => /* @__PURE__ */ (0, Q.jsx)(io, {
	id: "resource-browser-page-header-popup",
	onClick: (r) => {
		switch (r.id) {
			case Hb.DELETE:
				e();
				break;
			case Hb.POD_SPREAD:
				n();
				break;
			case Hb.HIBERNATION_RULES:
				t();
				break;
			default: $d();
		}
	},
	options: Ub,
	buttonProps: {
		dataTestId: "resource-browser-page-header-popup-button",
		icon: /* @__PURE__ */ (0, Q.jsx)(z, {
			name: "ic-more-vertical",
			color: "N700"
		}),
		variant: F.borderLess,
		style: P.neutral,
		showAriaLabelInTippy: !1,
		ariaLabel: "Edit Cluster options",
		size: I.medium
	}
}), Gb = ({ resourceInfo: e, columnName: t, showAbsoluteValuesInResourceRecommender: n }) => {
	let { delta: r, recommended: i, current: a } = e, { badgeProps: o, iconProps: s } = M_(e);
	return /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox-col dc__gap-4 py-12",
		children: [/* @__PURE__ */ (0, Q.jsx)(W, {
			alwaysShowTippyOnHover: !0,
			className: "no-content-padding",
			content: (() => {
				let { iconProps: n, class: o } = M_({
					...e,
					isTooltipView: !0
				});
				return /* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "flexbox-col",
					children: [/* @__PURE__ */ (0, Q.jsx)("div", {
						className: "flexbox border__white-10--bottom px-8",
						children: /* @__PURE__ */ (0, Q.jsx)("h6", {
							className: "m-0 fs-12 fw-6 lh-18 dc__word-break p-8",
							children: w_[t] || t
						})
					}), /* @__PURE__ */ (0, Q.jsxs)("div", {
						className: "flexbox-col dc__gap-4 px-16 py-8",
						children: [
							/* @__PURE__ */ (0, Q.jsxs)("div", {
								className: "flexbox dc__gap-8 dc__content-space w-100",
								children: [/* @__PURE__ */ (0, Q.jsx)("span", {
									className: "fs-12 fw-4 lh-18",
									children: "Current"
								}), /* @__PURE__ */ (0, Q.jsx)("span", {
									className: "fs-12 fw-6 lh-18 dc__word-break",
									children: A_(a?.value)
								})]
							}),
							/* @__PURE__ */ (0, Q.jsxs)("div", {
								className: "flexbox dc__gap-8 dc__content-space w-100",
								children: [/* @__PURE__ */ (0, Q.jsx)("span", {
									className: "fs-12 fw-4 lh-18",
									children: "Recommended"
								}), /* @__PURE__ */ (0, Q.jsx)("span", {
									className: "fs-12 fw-6 lh-18 dc__word-break",
									children: A_(i?.value)
								})]
							}),
							Jd(i?.value) ? /* @__PURE__ */ (0, Q.jsx)("span", {
								className: "fs-11 fw-4 lh-1-5",
								children: "No recommendation available due to insufficient data"
							}) : /* @__PURE__ */ (0, Q.jsxs)("div", {
								className: "flexbox dc__gap-8 dc__content-space w-100",
								children: [/* @__PURE__ */ (0, Q.jsx)("span", {
									className: "fs-12 fw-4 lh-18",
									children: "Change"
								}), /* @__PURE__ */ (0, Q.jsxs)("div", {
									className: "flexbox dc__gap-2 dc__align-items-center",
									children: [/* @__PURE__ */ (0, Q.jsx)(z, {
										...n,
										size: 12
									}), /* @__PURE__ */ (0, Q.jsx)("span", {
										className: `fs-12 fw-6 lh-18 ${o}`,
										children: !Jd(r) && `${Math.abs(r)}%`
									})]
								})]
							})
						]
					})]
				});
			})(),
			children: Jd(i?.value) ? /* @__PURE__ */ (0, Q.jsx)("span", { children: "No Recommendation" }) : /* @__PURE__ */ (0, Q.jsx)("div", {
				className: "dc__inline-block",
				children: /* @__PURE__ */ (0, Q.jsx)(So, {
					label: !Jd(r) && `${Math.abs(r)}%`,
					endIconProps: s,
					size: I.xxs,
					...o
				})
			})
		}), n && /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox dc__align-items-center dc__gap-4 dc__word-break",
			children: [
				/* @__PURE__ */ (0, Q.jsx)("span", {
					className: "cn-7 fs-12 fw-5 lh-1-5 dc__word-break",
					children: A_(a?.value)
				}),
				/* @__PURE__ */ (0, Q.jsx)(z, {
					name: "ic-arrow-right",
					color: "N700",
					size: 12
				}),
				/* @__PURE__ */ (0, Q.jsx)("span", {
					className: "cn-7 fs-12 fw-5 lh-1-5 dc__word-break",
					children: A_(i?.value)
				})
			]
		})]
	});
}, Kb = (e) => /* @__PURE__ */ (0, Q.jsxs)("svg", {
	width: 250,
	height: 200,
	viewBox: "0 0 250 200",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [/* @__PURE__ */ (0, Q.jsxs)("g", {
		clipPath: "url(#clip0_7839_3659)",
		children: [
			/* @__PURE__ */ (0, Q.jsx)("path", {
				d: "M54.0977 121.532L59.3503 117.611C61.5247 117.419 64.9922 117.654 62.9169 119.846C60.8416 122.038 59.0261 123.348 58.8964 124.904L54.0977 121.532Z",
				fill: "url(#paint0_linear_7839_3659)"
			}),
			/* @__PURE__ */ (0, Q.jsx)("path", {
				d: "M64.2147 131.649C66.1935 133.628 69.4025 135.28 73.4228 135.54C73.4228 136.188 73.8118 145.526 73.8118 146.434C63.8255 145.008 54.0987 140.209 51.5046 134.243C47.1297 124.181 51.8937 122.182 52.5422 121.922C53.1907 121.663 55.655 121.014 57.4705 121.922C58.9003 122.637 59.4653 124.909 60.5833 126.98C61.4276 128.544 62.7881 130.222 64.2147 131.649Z",
				fill: "url(#paint1_linear_7839_3659)"
			}),
			/* @__PURE__ */ (0, Q.jsx)("path", {
				d: "M73.0347 126.33C73.0347 127.679 72.7754 132.944 72.6457 135.409V143.579C74.3317 143.968 77.7038 143.45 80.2976 141.634C81.0758 138.262 80.6867 133.723 80.2976 131.388C79.9085 129.054 79.0007 125.941 77.9631 123.347C76.9256 120.753 74.8505 116.344 74.3317 115.176C73.813 114.009 73.4239 112.194 73.0347 110.508C72.6456 108.822 70.4409 107.914 68.4955 109.729C66.5501 111.545 69.0143 114.139 69.533 114.658C70.0518 115.176 71.7378 117.77 72.3863 119.327C73.0347 120.883 73.0347 124.644 73.0347 126.33Z",
				fill: "url(#paint2_linear_7839_3659)"
			}),
			/* @__PURE__ */ (0, Q.jsx)("path", {
				d: "M23.8806 169.39L29.5871 177.301C29.198 179.419 28.1605 183.63 27.1229 183.526C25.826 183.396 21.0274 183.785 18.0444 184.304C15.0615 184.823 11.1707 185.99 8.18773 185.99C5.80137 185.99 3.73493 185.299 3 184.953L23.8806 169.39Z",
				fill: "#428DFC"
			}),
			/* @__PURE__ */ (0, Q.jsx)("path", {
				d: "M50.2058 172.89L35.2911 151.88L48.6495 147.081C55.3071 155.684 69.0113 173.357 70.5677 175.225C72.5131 177.559 73.1615 180.542 71.4755 183.395C70.1267 185.678 65.1205 186.076 62.7861 185.989H24.6562L28.4174 170.945C29.4117 170.815 31.8153 170.634 33.4754 170.945C35.5505 171.334 38.6631 173.279 39.9601 173.279C41.5164 173.279 43.8508 171.853 45.4072 171.853C46.8338 171.853 49.0818 172.544 50.2058 172.89Z",
				fill: "url(#paint3_linear_7839_3659)"
			}),
			/* @__PURE__ */ (0, Q.jsx)("path", {
				d: "M62.2705 185.99L66.4207 174.058H72.9054C73.6403 174.966 75.577 177.119 77.4446 178.468C79.7791 180.154 83.2808 181.321 85.0965 182.618C86.5491 183.656 87.9498 185.298 88.4685 185.99H62.2705Z",
				fill: "#428DFC"
			}),
			/* @__PURE__ */ (0, Q.jsx)("path", {
				d: "M41.6488 162.126C37.1873 160.155 35.0344 154.129 34.5156 151.362C45.6692 146.866 68.184 137.796 69.014 137.485C70.0516 137.096 75.1096 135.28 77.8332 137.485C80.5567 139.689 80.1676 146.304 80.1676 148.119C80.1676 149.572 79.2166 166.968 78.741 175.485H61.1027C60.973 174.188 60.7396 171.283 60.8434 170.038C60.973 168.481 62.9184 166.536 63.1778 164.85C63.4372 163.164 62.6591 162.515 62.6591 160.181C62.6591 158.313 64.2154 156.117 64.9935 155.253C62.6158 156.679 57.5751 159.662 56.4338 160.181C55.0072 160.829 47.2256 164.59 41.6488 162.126Z",
				fill: "url(#paint4_linear_7839_3659)"
			}),
			/* @__PURE__ */ (0, Q.jsx)("path", {
				d: "M87.04 125.033C87.6885 125.552 88.9854 129.054 88.4667 131.129C88.9422 130.999 90.023 129.598 90.023 129.183C90.023 128.665 90.023 127.497 89.7636 126.849C89.5042 126.201 88.8557 125.293 88.337 124.904C87.8968 124.573 87.1697 124.644 87.04 125.033Z",
				fill: "url(#paint5_linear_7839_3659)"
			}),
			/* @__PURE__ */ (0, Q.jsx)("path", {
				d: "M73.8112 152.529L71.6064 154.215C69.5314 148.897 69.1422 144.618 68.8828 140.857C71.6064 140.727 80.4255 137.225 81.7224 136.447C83.0194 135.669 85.4835 133.464 86.0023 132.945C86.5211 132.426 88.4665 130.222 88.5962 129.444C88.7259 128.665 88.3368 128.276 89.2446 126.59C90.1525 124.904 92.487 123.348 92.7464 123.089C93.0057 122.829 93.3948 122.31 93.9136 121.532C94.3286 120.91 94.4324 120.322 94.4324 120.106C94.9511 120.365 95.9887 121.195 95.9887 122.44C95.9887 123.996 93.5245 125.553 93.1354 126.979C92.7464 128.406 93.7839 131.648 93.2651 132.556C92.7464 133.464 89.6337 135.02 88.9853 135.669C88.3368 136.317 86.2617 139.17 82.1115 144.229C78.7914 148.275 75.1945 151.448 73.8112 152.529Z",
				fill: "url(#paint6_linear_7839_3659)"
			}),
			/* @__PURE__ */ (0, Q.jsx)("path", {
				d: "M57.0806 122.44C58.4678 123.654 59.4151 129.443 59.8041 131.129C61.5101 138.522 59.5448 149.935 53.5789 152.01C48.3911 153.437 42.944 153.955 40.4798 153.955C35.5515 153.955 29.845 151.88 28.0293 149.675C28.4184 145.655 29.0668 141.245 31.1419 138.522C33.217 135.798 36.134 134.438 38.0157 132.556C39.9611 130.611 41.258 128.146 44.8894 125.552C48.6072 122.897 53.4557 121.624 54.0976 121.532C55.0055 121.402 56.043 121.532 57.0806 122.44Z",
				fill: "url(#paint7_linear_7839_3659)"
			}),
			/* @__PURE__ */ (0, Q.jsx)("path", {
				d: "M63.1771 138.911C64.9928 140.337 66.16 140.986 68.8836 140.856C69.1983 140.841 69.5944 140.781 70.0508 140.686C71.8665 146.044 73.4429 151.348 75.1089 156.679C74.201 157.414 71.7887 158.91 69.4023 159.013C66.4194 159.143 61.4911 154.604 59.1566 153.566C56.8677 152.549 55.6549 153.436 53.5798 152.01C46.8362 147.211 44.7613 139.689 45.4095 130.74C45.7997 125.353 53.5798 121.791 57.0815 123.996C58.6413 124.978 59.416 129.443 59.805 131.129C60.1941 132.815 61.3614 137.484 63.1771 138.911Z",
				fill: "url(#paint8_linear_7839_3659)"
			}),
			/* @__PURE__ */ (0, Q.jsx)("path", {
				d: "M56.4336 113.881C55.6555 113.924 53.8916 113.803 53.0616 112.973C52.2316 112.143 52.2834 111.071 52.4131 110.639",
				stroke: "#23286B",
				strokeWidth: .3
			}),
			/* @__PURE__ */ (0, Q.jsx)("path", {
				d: "M64.4728 121.531C66.3404 121.531 68.1042 119.975 68.7527 119.197C68.7527 119.197 70.1794 119.456 70.3091 119.067C70.4388 118.678 70.4565 116.863 70.3091 115.566C70.1532 114.195 69.9468 113.348 69.6605 112.712C68.4934 110.118 66.8074 108.86 64.862 108.173C62.6572 107.395 59.4111 108.108 57.8587 110.507C56.432 112.712 58.1178 117.381 59.1554 118.678C60.1929 119.975 62.1383 121.531 64.4728 121.531Z",
				fill: "#FFBEB6"
			}),
			/* @__PURE__ */ (0, Q.jsx)("path", {
				d: "M66.9375 114.787C67.8454 115.392 70.1539 116.162 72.1252 114.398C73.5519 113.122 73.8112 110.81 73.4222 110.118",
				stroke: "#23286B",
				strokeWidth: .3
			}),
			/* @__PURE__ */ (0, Q.jsx)("path", {
				d: "M56.1762 118.549C54.4123 116.889 55.6142 114.745 56.4355 113.88C53.712 113.88 53.0635 111.805 53.0635 110.638C53.0635 109.471 54.7495 107.266 56.8246 107.007C58.4847 106.799 59.7643 107.439 60.1966 107.785C60.0237 107.179 60.015 105.917 61.3638 105.71C62.7127 105.502 63.828 106.488 64.2171 107.007C64.2603 106.099 64.0874 104.542 64.9953 104.153C65.9031 103.764 67.004 104.087 68.3673 105.45C69.4048 106.488 69.3616 108.52 69.1454 109.471C69.7939 109.038 71.2983 108.355 72.1284 109.082C73.1659 109.989 73.0362 111.935 72.1284 113.491C71.2205 115.048 68.7564 115.566 66.9407 114.788C66.0328 116.474 64.4765 116.474 63.828 115.566C62.4014 118.679 58.3809 120.624 56.1762 118.549Z",
				fill: "#23286B"
			}),
			/* @__PURE__ */ (0, Q.jsx)("path", {
				d: "M66.2891 120.105C67.0672 119.846 68.1048 119.923 68.1048 120.753",
				stroke: "#23286B",
				strokeWidth: .5
			}),
			/* @__PURE__ */ (0, Q.jsx)("path", {
				d: "M232.315 105.459C250.792 125.98 249.135 157.595 228.614 176.073C208.092 194.55 176.478 192.893 158 172.372C167.201 164.087 210.374 125.214 232.315 105.459Z",
				fill: "#1F2463"
			}),
			/* @__PURE__ */ (0, Q.jsx)("path", {
				d: "M171.674 27.0825L129.227 62.6204C128.547 63.1891 128.03 63.9266 127.726 64.7587C127.423 65.5909 127.343 66.4883 127.497 67.3608C127.65 68.2332 128.031 69.0499 128.6 69.7287C129.169 70.4074 129.907 70.9242 130.739 71.2272L182.86 90.1976C183.692 90.5005 184.59 90.5789 185.462 90.4249C186.334 90.2708 187.151 89.8897 187.829 89.32C188.507 88.7502 189.024 88.0118 189.326 87.1792C189.628 86.3465 189.706 85.4489 189.551 84.5767L179.878 30.0684C179.723 29.1976 179.342 28.3828 178.774 27.7056C178.205 27.0284 177.468 26.5127 176.637 26.2102C175.806 25.9077 174.91 25.8291 174.039 25.9822C173.168 26.1353 172.352 26.5147 171.674 27.0825Z",
				fill: "#F33E3E"
			}),
			/* @__PURE__ */ (0, Q.jsx)("path", {
				d: "M167.168 44.9985C167.608 43.6995 169.03 43.0165 170.319 43.4855C171.608 43.9546 172.258 45.392 171.76 46.6698L165.4 62.9795C164.997 64.0153 163.839 64.5391 162.795 64.1588C161.75 63.7785 161.2 62.6335 161.556 61.5803L167.168 44.9985Z",
				fill: "white"
			}),
			/* @__PURE__ */ (0, Q.jsx)("path", {
				d: "M159.553 73.0644C160.851 73.5366 162.285 72.8677 162.757 71.5702C163.23 70.2728 162.561 68.8382 161.263 68.3659C159.966 67.8937 158.531 68.5627 158.059 69.8601C157.587 71.1576 158.256 72.5922 159.553 73.0644Z",
				fill: "white"
			}),
			/* @__PURE__ */ (0, Q.jsx)("circle", {
				cx: 142,
				cy: 124.5,
				r: 46,
				fill: "#E6522C"
			}),
			/* @__PURE__ */ (0, Q.jsx)("path", {
				d: "M144.669 150.859C147.128 155.119 153.303 156.16 158.459 153.183C163.615 150.206 165.801 144.338 163.342 140.078L144.669 150.859Z",
				fill: "white"
			}),
			/* @__PURE__ */ (0, Q.jsx)("path", {
				d: "M137.108 151.818L167.951 134.011L164.714 128.401L133.869 146.209L137.108 151.818Z",
				fill: "white"
			}),
			/* @__PURE__ */ (0, Q.jsx)("path", {
				d: "M132.291 143.272L162.936 125.579C164.52 119.249 163.107 114.442 163.107 114.442L156.865 119.882C156.865 119.882 155.581 121.113 153.65 122.772C154.252 119.413 153.713 115.872 151.941 112.803C149.299 108.226 146.79 106.448 143.112 104.313C140.832 102.989 136.792 99.8304 136.34 95.7034C134.567 100.211 138.048 108.295 140.853 113.593C138.836 111.426 136.657 107.433 134.562 105.522C128.98 100.436 125.298 99.2132 125.379 95.2599C123.46 96.5282 123.501 101.191 125.248 104.216C126.936 107.139 128.899 112.36 128.523 116.057C125.141 110.495 121.165 107.984 119.31 108.862C123.82 112.471 122.103 121.148 125.912 127.745C127.647 130.75 130.512 133.015 133.815 134.192C131.55 135 129.96 135.484 129.96 135.484C126.882 136.442 122.549 137.805 122.6 137.866C124.503 139.494 126.405 141.072 131.782 143.094C131.949 143.157 132.121 143.212 132.291 143.272Z",
				fill: "white"
			})
		]
	}), /* @__PURE__ */ (0, Q.jsxs)("defs", { children: [
		/* @__PURE__ */ (0, Q.jsxs)("linearGradient", {
			id: "paint0_linear_7839_3659",
			x1: 60.6124,
			y1: 119.846,
			x2: 57.7479,
			y2: 122.46,
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ (0, Q.jsx)("stop", { stopColor: "#FBA19B" }),
				/* @__PURE__ */ (0, Q.jsx)("stop", {
					offset: .349149,
					stopColor: "#F9ADA7"
				}),
				/* @__PURE__ */ (0, Q.jsx)("stop", {
					offset: 1,
					stopColor: "#F9AFA9"
				})
			]
		}),
		/* @__PURE__ */ (0, Q.jsxs)("linearGradient", {
			id: "paint1_linear_7839_3659",
			x1: 65.344,
			y1: 146.534,
			x2: 70.852,
			y2: 122.658,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ (0, Q.jsx)("stop", { stopColor: "#171B4D" }), /* @__PURE__ */ (0, Q.jsx)("stop", {
				offset: .683307,
				stopColor: "#1D225F"
			})]
		}),
		/* @__PURE__ */ (0, Q.jsxs)("linearGradient", {
			id: "paint2_linear_7839_3659",
			x1: 78.0928,
			y1: 143.709,
			x2: 68.6252,
			y2: 108.692,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ (0, Q.jsx)("stop", {
				offset: .625896,
				stopColor: "#FFBEB6"
			}), /* @__PURE__ */ (0, Q.jsx)("stop", {
				offset: .768502,
				stopColor: "#F5A7A1"
			})]
		}),
		/* @__PURE__ */ (0, Q.jsxs)("linearGradient", {
			id: "paint3_linear_7839_3659",
			x1: 48.5505,
			y1: 162.644,
			x2: 48.5505,
			y2: 186,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ (0, Q.jsx)("stop", {
				offset: .509448,
				stopColor: "#87B2F4"
			}), /* @__PURE__ */ (0, Q.jsx)("stop", {
				offset: 1,
				stopColor: "#9BBFFA"
			})]
		}),
		/* @__PURE__ */ (0, Q.jsxs)("linearGradient", {
			id: "paint4_linear_7839_3659",
			x1: 57.3512,
			y1: 136.412,
			x2: 57.3512,
			y2: 175.485,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ (0, Q.jsx)("stop", {
				offset: .142369,
				stopColor: "#7BABF0"
			}), /* @__PURE__ */ (0, Q.jsx)("stop", {
				offset: .668615,
				stopColor: "#A1C3FC"
			})]
		}),
		/* @__PURE__ */ (0, Q.jsxs)("linearGradient", {
			id: "paint5_linear_7839_3659",
			x1: 87.0401,
			y1: 131.153,
			x2: 92.0479,
			y2: 127.454,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ (0, Q.jsx)("stop", { stopColor: "#FFBEB6" }), /* @__PURE__ */ (0, Q.jsx)("stop", {
				offset: 1,
				stopColor: "#F5A7A1"
			})]
		}),
		/* @__PURE__ */ (0, Q.jsxs)("linearGradient", {
			id: "paint6_linear_7839_3659",
			x1: 68.8829,
			y1: 154.345,
			x2: 95.8933,
			y2: 120.133,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ (0, Q.jsx)("stop", {
				offset: .47747,
				stopColor: "#FFBEB6"
			}), /* @__PURE__ */ (0, Q.jsx)("stop", {
				offset: .890647,
				stopColor: "#F5A7A1"
			})]
		}),
		/* @__PURE__ */ (0, Q.jsxs)("linearGradient", {
			id: "paint7_linear_7839_3659",
			x1: 49.0396,
			y1: 154.085,
			x2: 55.9994,
			y2: 122.958,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ (0, Q.jsx)("stop", { stopColor: "#171B4D" }), /* @__PURE__ */ (0, Q.jsx)("stop", {
				offset: .683307,
				stopColor: "#1D225F"
			})]
		}),
		/* @__PURE__ */ (0, Q.jsxs)("linearGradient", {
			id: "paint8_linear_7839_3659",
			x1: 75.1093,
			y1: 159.013,
			x2: 47.1299,
			y2: 121.826,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ (0, Q.jsx)("stop", { stopColor: "#2A318C" }), /* @__PURE__ */ (0, Q.jsx)("stop", {
				offset: .811178,
				stopColor: "#1D225F"
			})]
		}),
		/* @__PURE__ */ (0, Q.jsx)("clipPath", {
			id: "clip0_7839_3659",
			children: /* @__PURE__ */ (0, Q.jsx)("rect", {
				width: 250,
				height: 200,
				fill: "white"
			})
		})
	] })]
}), qb = (e) => /* @__PURE__ */ (0, Q.jsxs)("svg", {
	width: 250,
	height: 200,
	viewBox: "0 0 250 200",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [
		/* @__PURE__ */ (0, Q.jsx)("style", { children: "\n        @keyframes write {\n            0% {\n                transform: translateX(-3px)\n            }\n\n            to {\n                transform: translateX(0)\n            }\n        }\n\n        @keyframes swingboard {\n            0% {\n                transform: rotate(-2deg)\n            }\n\n            to {\n                transform: rotate(2deg)\n            }\n        }\n\n        @keyframes head {\n            0% {\n                transform: rotate(0deg)\n            }\n\n            to {\n                transform: rotate(-8deg)\n            }\n        }\n    " }),
		/* @__PURE__ */ (0, Q.jsxs)("g", {
			clipPath: "url(#clip0_726_3640)",
			children: [
				/* @__PURE__ */ (0, Q.jsxs)("g", {
					style: {
						animation: "swingboard 3s infinite alternate ease-in-out",
						transformOrigin: "top center",
						transformBox: "fill-box"
					},
					children: [
						/* @__PURE__ */ (0, Q.jsx)("path", {
							d: "m41 11 58-9 58 9",
							stroke: "#D6D7D8"
						}),
						/* @__PURE__ */ (0, Q.jsx)("path", {
							fill: "#EEE",
							d: "M21 10h156v80H21z"
						}),
						/* @__PURE__ */ (0, Q.jsx)("path", {
							d: "M133.014 50.024a14.9 14.9 0 0 0-3.575-7.332c-1.15-1.295-2.453-2.4-4.054-3.12-3.803-1.71-7.512.76-8.152 4.29-.337 1.863-.029 3.62.952 5.226 1.888 3.091 4.737 4.693 8.27 5.126 2.248.276 4.344-.223 6.268-1.446.393-.25.544-.545.487-.99-.075-.584-.131-1.17-.196-1.754m.099 3.785c-.612.284-1.148.583-1.718.787-3.889 1.393-7.51.733-10.881-1.53-1.803-1.21-3.149-2.83-3.907-4.882-.718-1.947-.758-3.915.003-5.867a6.74 6.74 0 0 1 8.443-3.975c1.55.511 2.866 1.412 4.045 2.518 2.816 2.641 4.504 5.871 5.036 9.7.032.23.08.459.138.79.179-.166.32-.27.427-.4 1.456-1.79 2.147-3.877 2.148-6.148.002-6.288-2.65-11.189-8.011-14.485-2.943-1.81-6.201-2.478-9.634-1.684a21.7 21.7 0 0 0-6.983 2.962c-.197.128-.38.277-.564.423-.071.057-.127.133-.249.264.197.052.336.117.477.122.893.036 1.787.053 2.679.088.258.01.529.016.765.101.143.052.338.267.322.383-.023.169-.203.327-.343.461-.052.05-.18.032-.272.029-1.645-.056-3.291-.107-4.935-.174-.827-.034-1.036-.336-.817-1.134.049-.181.103-.364.177-.536.716-1.664 1.422-3.334 2.165-4.986.23-.512.545-.99.86-1.457.138-.206.352-.39.574-.5.13-.064.397-.018.501.083.104.099.091.329.106.503.005.059-.054.13-.097.185-1.06 1.355-1.623 2.964-2.298 4.516-.175.402-.339.81-.575 1.374.234-.12.314-.147.379-.196 2.065-1.543 4.402-2.536 6.852-3.246 5.252-1.523 9.875-.125 13.929 3.312 3.303 2.8 5.222 6.444 5.876 10.723.309 2.016.266 4.034-.318 6.015-.502 1.705-1.354 3.209-2.635 4.443-.368.355-.505.72-.566 1.217-.121.976-.257 1.968-.552 2.901-1.288 4.087-4.534 6.544-8.807 6.528-4.038-.016-7.279-1.71-9.534-5.11-.423-.637-.68-1.389-.975-2.104-.104-.252-.123-.55-.126-.828-.002-.227.145-.434.391-.41.158.015.309.158.449.264.046.034.052.128.067.196.479 2.145 1.808 3.702 3.525 4.944 2.291 1.655 4.848 2.336 7.674 1.884 2.438-.39 4.248-1.69 5.515-3.78.758-1.25 1.253-2.913 1.274-4.284m-60.76 5.914q-5.342.166-10.671.554l-9.67.172-10.612.188c-.342.006-.872.257-.924.636-.057.42.46.49.752.484l6.894-.122q-1.434.182-2.866.38c-.332.046-.794.202-.9.563-.094.324.2.553.513.558l15.925.273 3.389.059a148 148 0 0 0-12.446 1.9c-.271.053-.657.29-.698.597-.04.291.28.481.538.484l18.11.157 5.105.045c.39.004.89-.108 1.086-.49.177-.343-.153-.628-.488-.631l-17.433-.153.486-.073q3.295-.489 6.607-.826a147 147 0 0 1 13.298-.752l.593-.005 6.753.116c.39.007.891-.11 1.087-.49.179-.35-.157-.618-.49-.632a151 151 0 0 0-6.894-.118l-9.03-.155-15.924-.273-1.284-.022q4.17-.444 8.35-.75l17.435-.308 10.61-.188c.324-.006.802-.23.9-.564.095-.327-.202-.545-.514-.558a258 258 0 0 0-17.587-.056M42.731 49.89c-.01.004-.011.005.006.001l.009.003c-.047.017-.1-.026-.015-.004m.009-.003-.008.002c-.025-.008-.014-.007.008-.002m.015.002-.009.005-.008-.003.011-.003zm-.007.005.008-.004.017.003c-.029.02-.12.06-.025.001m5.398 1.248c.039-.013.08-.028 0 0m39.869-.464.034-.01zm3.523-1.565c-.075.034-.035.015 0 0m-48.984 1.606c-.102-.295-.031-.602.171-.784l.056-.04.063.013c.431.085.817.417 1.149.686.37.3.724.624 1.134.87 1.958 1.166 4.223-.112 5.972-1.071.926-.508 1.475-.773 2.498-.819 1.19-.053 2.4.101 3.585.186 2.497.18 4.999.435 7.5.528 1.3.048 2.595-.01 3.873-.263 1.144-.228 2.17-.562 3.313-.646 1.085-.078 2.05.25 3.038.663.992.414 1.979.827 3.075.809 1.235-.021 2.357-.539 3.34-1.254.405-.296.797-.628 1.236-.874.084-.047.223-.115.281-.14.122-.051.122-.056.206-.066-.045.005-.12.005.04-.003-.053.003-.044-.008.058.001.064.006.16.023.237.043.77.208 1.211 1.01 1.654 1.605.532.715 1.138 1.22 2.075 1.214 1.206-.009 2.223-.626 3.134-1.353.342-.273.677-.561 1.053-.789.12-.072.05-.028.024-.014a5 5 0 0 1 .245-.118l.127-.048.008-.003h.002a1 1 0 0 0 .138-.038h.003q.108-.02.215-.036c-.004.003.193-.015.221-.017l.082-.003h.08q.172.005.342.02c.342.034.714.125 1.06.247a4.6 4.6 0 0 1 1.902 1.301c.256.295.458.628.618.983.19.422 1.793-.123 1.65-.442-.707-1.573-2.258-2.53-3.93-2.763-.997-.139-2.026.004-2.972.336-.965.339-1.688.969-2.487 1.579a6 6 0 0 1-.56.389l-.066.036-.053.028-.056-.011a1.2 1.2 0 0 1-.256-.077 1.8 1.8 0 0 1-.472-.326c-.597-.543-.93-1.314-1.526-1.859-.903-.824-2.24-.651-3.302-.26a6.8 6.8 0 0 0-1.622.89c-.44.319-.863.678-1.34.943a3 3 0 0 1-.24.12c.06-.027-.095.023-.13.038l-.046.01q-.008 0-.015.002l-.039.001a2 2 0 0 1-.335-.008c-.488-.045-.967-.215-1.422-.39-1.055-.406-2.055-.91-3.191-1.047-1.296-.157-2.606.118-3.864.402-1.127.254-2.239.488-3.448.5-1.256.013-2.514-.111-3.765-.204q-1.958-.146-3.914-.287c-1.268-.092-2.542-.224-3.813-.245-1.363-.022-2.677.182-3.93.732-.948.415-1.81 1-2.754 1.424l-.059.025-.13.05-.137.05-.026.007-.124.032-.072.014-.032.006-.03.002c-.02 0-.152.006-.145.007-.38-.004-.822-.182-1.17-.411-.79-.519-1.462-1.404-2.44-1.572-.6-.103-1.23 0-1.802.2-.431.15-.893.377-1.187.74-.235.288-.33.632-.206.991.14.41 1.776-.075 1.65-.442M57.34 40.124c.033-.006.078-.017 0 0m-14.6 1.51c.013-.011.02-.016 0 0m43.193-.276c-.095-.004-.036 0 0 0m1.25-.317q-.012.008 0 0m-9.384-1.661c.462.022.897.12 1.333.274 1.81.636 3.27 2.017 5.146 2.503 1.687.437 3.801.074 4.82-1.477.194-.293.313-.642.345-.99.064-.7-1.378-.486-1.434.122a1.5 1.5 0 0 1-.085.405q-.049.119-.114.23c-.065.113-.028.058-.114.16q-.076.089-.16.172l-.028.026-.075.06q-.098.073-.2.141l-.017.012q-.075.041-.153.08-.116.055-.233.103l-.015.006-.012.003-.123.038a5 5 0 0 1-.283.07h-.002.004l-.005.001-.06.007a3 3 0 0 1-.385.032h-.015l-.123-.006a4 4 0 0 1-.624-.094C83.3 40.801 81.815 39.4 80 38.749c-.986-.353-2.022-.454-3.05-.242-.826.17-1.59.572-2.288 1.035-.653.434-1.254.938-1.888 1.399a14 14 0 0 1-.667.455l-.142.087-.017.011-.028.015a7 7 0 0 1-.506.256q-.137.061-.278.115c.035-.013.122-.04-.035.012q-.097.032-.197.061c-.458.133-.78.172-1.29.183-.37.01-.899-.052-1.326-.13-.947-.17-1.867-.509-2.756-.868-1.79-.724-3.502-1.574-5.418-1.927-1.896-.35-3.865-.085-5.433 1.094-.658.494-1.21 1.068-1.789 1.538a6 6 0 0 1-.67.484c.04-.026-.152.083-.178.097a5 5 0 0 1-.313.138l-.079.026a4 4 0 0 1-.229.059l-.072.013q-.126.015-.253.024c-.856.064-1.823-.407-2.588-.831-.857-.475-1.689-1.008-2.618-1.336-.912-.323-1.925-.427-2.856-.121-.809.266-1.647.783-2.015 1.586a1.87 1.87 0 0 0-.145 1.108c.054.333.594.34.832.269.288-.087.644-.301.587-.65a1.13 1.13 0 0 1 .178-.784 4 4 0 0 1 .144-.173q.042-.044.086-.087l.024-.021q.094-.076.195-.145l.068-.044c.012-.004.105-.055.111-.058q.101-.048.205-.09c-.043.02.16-.047.198-.057l.12-.028h.011c.055-.002.11-.013.164-.016l.103-.005.099.005q.081.005.162.013c.089.01.206.024.278.038.237.046.471.122.698.206.885.325 1.668.865 2.497 1.305.905.48 1.89.888 2.93.907.99.016 1.906-.292 2.726-.838a9 9 0 0 0 .936-.74 48 48 0 0 0 .476-.425c.158-.142.27-.244.382-.34.297-.257.605-.503.937-.712l.08-.049.092-.05q.136-.07.277-.134l.141-.06.047-.02q.17-.06.344-.105.146-.038.294-.07l.035-.007q.09-.014.182-.026.34-.042.684-.048c.083-.001.378.012.552.027q.354.03.703.09c1.828.306 3.529 1.193 5.249 1.888 1.878.76 3.898 1.324 5.931.938 1.732-.329 3.038-1.454 4.413-2.468a10 10 0 0 1 .946-.633l.143-.077q.114-.06.232-.115.132-.06.267-.116l.04-.016.11-.037q.14-.045.283-.079c.047-.01.278-.048.13-.03.207-.026.438-.05.6-.043m-1.699-11.83q.021-.014.042-.024l-.035.02zm-16.875 2.075c.024-.014.044-.026.047-.024a.2.2 0 0 1-.047.024m-.025.012c.021-.019.015-.013 0 0m-.233.068.032.013-.035-.013zm-.024-.01h.002zM54.81 33.86c.032-.056.091-.07.095-.06a.3.3 0 0 0-.095.06m.257-.079c-.022-.003-.016-.004 0 0m.023 0-.006.002h-.009l-.014-.007c.043-.006.082-.01.029.006m-4.98-3.98c-.09.017-.049-.016 0 0m.003 0h-.003c-.04-.017-.02-.01.003 0m-3.376 3.643c.018.002.013.001 0 0m36.448-1.564-.014.009c-.033.02-.025.012-.01 0zm.02-.007h-.002c.047-.015.113-.037.001 0m.007.001h-.006c.037-.007.151.007.006 0m3.203-4.017v.003l-.001.001.007.003q-.004 0-.007-.003h-.009c-.035.004-.04-.005-.032-.012-.031-.013-.058-.03.005-.003.01-.006.029-.007.037.01m5.792 4.814c.004.003.003.005-.013.007zm-16.115-5.114c-.018.013-.026.02.007 0l.027.001.058.004.105.016c.26.052.577.197.84.401.716.553 1.239 1.348 1.758 2.075.52.73 1.046 1.523 1.777 2.061.788.58 1.696.813 2.661.601.984-.216 1.673-.892 2.078-1.785.326-.72.483-1.5.76-2.238a4 4 0 0 1 .18-.42 3 3 0 0 1 .221-.349l.02.01c.776.396 1.207 1.338 1.55 2.088.702 1.54 1.431 3.643 3.475 3.584a3.46 3.46 0 0 0 2.69-1.411c.506-.698.762-1.581.853-2.43.092-.873.033-1.776-.242-2.613-.11-.332-.688-.26-.938-.186-.214.063-.83.295-.72.63.28.847.34 1.752.21 2.632-.11.757-.345 1.61-.899 2.172a1.1 1.1 0 0 1-.316.25c.043-.018.015-.004-.016.009q-.006.004-.013.006l.013-.006-.025.01h-.003l.043-.018c.02-.012-.016.005-.044.017l-.01-.002.009.003-.01.005.01-.005h.002l-.006.003h-.004.013l-.012.006h-.006l-.013.001c-.078.026-.047.012-.008 0a.8.8 0 0 1-.285-.049 1.5 1.5 0 0 1-.492-.293c-.65-.57-.998-1.418-1.343-2.188-.385-.863-.755-1.78-1.424-2.468-.727-.747-1.716-.949-2.68-.522-1.622.718-1.527 2.755-2.263 4.113-.081.15-.175.31-.288.433q-.039.041-.082.08l-.07.059-.045.03-.01-.001q.01-.008-.002 0-.035 0-.068-.003l-.02-.004-.134-.027c-.1-.023-.105-.026-.217-.072-.788-.328-1.338-1.028-1.835-1.693-.991-1.327-1.965-3.191-3.793-3.417-1.003-.124-2.055.217-2.727.986-.513.587-.717 1.387-.859 2.135-.144.761-.218 1.54-.43 2.287-.08.283-.161.514-.309.736-.32-.195-.571-.53-.778-.828-.272-.392-.47-.823-.676-1.251-.358-.744-.725-1.61-1.365-2.16-.773-.665-1.864-.592-2.717-.106-.772.44-1.293 1.217-1.714 1.977-.466.841-.82 1.74-1.366 2.538a4.5 4.5 0 0 1-.384.5q-.063.07-.136.136l-.11.099-.022.02-.102-.052-.042-.02-.032-.028q-.063-.051-.123-.106a2.5 2.5 0 0 1-.275-.313 4.3 4.3 0 0 1-.421-.71c-.286-.578-.514-1.182-.783-1.767-.24-.52-.51-1.095-.944-1.486-.485-.438-1.116-.547-1.746-.422-1.238.246-1.913 1.286-2.471 2.32-.278.514-.537 1.038-.832 1.543a8 8 0 0 1-.425.658c-.067.091-.14.177-.21.265l-.048.048-.092.083a1.2 1.2 0 0 1-.274-.18c-.653-.576-1.01-1.447-1.38-2.214-.396-.822-.867-1.746-1.675-2.233-.812-.49-1.98-.198-2.638.428-1.047.996-1.151 2.589-2.042 3.692l-.036.041a2 2 0 0 1-.1.096c.001-.002-.102.09-.05.041l-.025.017q-.002-.003-.02.005c-.03 0-.066.002-.026.008h-.001l-.03-.003a2.3 2.3 0 0 1-1.028-.47c-.792-.607-1.398-1.416-2.128-2.091-.773-.715-1.71-1.238-2.794-1.12a2.89 2.89 0 0 0-2.297 1.574c-.386.764-.53 1.651-.305 2.487.153.568 1.811.127 1.658-.444a2.93 2.93 0 0 1 .372-2.334c.094-.14.188-.253.265-.322.008-.007.04-.033.058-.05h.016l.034.002c.041.007.17.033.225.05.21.065.412.18.596.297 1.616 1.034 2.525 3.27 4.675 3.35a3.07 3.07 0 0 0 2.663-1.35c.411-.619.664-1.333.957-2.01.13-.302.268-.6.445-.878q.056-.087.117-.17l.065-.08q.156.094.289.228c.327.315.587.706.805 1.102.761 1.379 1.412 3.72 3.41 3.485 1.29-.151 2.06-1.157 2.649-2.211.285-.511.543-1.037.828-1.548.133-.238.272-.473.426-.699q.099-.145.208-.283l.095-.115.056-.056.03-.027.06.032c.003.005.078.057.097.074.095.081.18.174.26.27.174.216.299.433.42.672.297.581.527 1.192.796 1.785.242.535.513 1.107.93 1.53.629.635 1.546.688 2.354.379.88-.337 1.497-1.087 1.971-1.871.497-.823.845-1.723 1.345-2.544.21-.342.441-.694.723-.954l.08-.07.036-.03a1.3 1.3 0 0 1 .213.117c.16.116.296.272.418.426.264.334.467.71.658 1.088.423.841.775 1.75 1.429 2.447.303.323.678.592 1.116.69.575.128 1.217-.027 1.71-.335.64-.401.947-1.095 1.122-1.802.186-.748.26-1.518.414-2.272.075-.365.166-.73.308-1.076a2.2 2.2 0 0 1 .367-.598q.05-.049.103-.093a1 1 0 0 1 .087-.062z",
							fill: "#8F9CCC"
						}),
						/* @__PURE__ */ (0, Q.jsx)("circle", {
							cx: 99,
							cy: 2,
							r: 2,
							fill: "#E94A47"
						})
					]
				}),
				/* @__PURE__ */ (0, Q.jsx)("path", {
					d: "M160.119 71.024c.952.952 3.571 5.158 4.762 7.142 7.143 1.905 7.341-3.571 6.547-6.547-.992-.397-3.571-1.786-5.952-4.167-2.976-2.976-6.547 2.381-5.357 3.572",
					fill: "#F3A29D"
				}),
				/* @__PURE__ */ (0, Q.jsx)("path", {
					d: "M184.524 76.38H250l-19.048 60.715h-44.047z",
					fill: "url(#paint0_linear_726_3640)"
				}),
				/* @__PURE__ */ (0, Q.jsx)("path", {
					d: "M186.905 137.095h44.047l1.494-4.762h-45.728z",
					fill: "url(#paint1_linear_726_3640)"
				}),
				/* @__PURE__ */ (0, Q.jsx)("path", {
					d: "M225 137.095h5.952l1.191 63.095h-3.572z",
					fill: "url(#paint2_linear_726_3640)"
				}),
				/* @__PURE__ */ (0, Q.jsx)("path", {
					d: "M28.572 79.952h51.19l16.667 30.953h-51.19z",
					fill: "#A1C3FC"
				}),
				/* @__PURE__ */ (0, Q.jsx)("path", {
					d: "M79.762 79.952h3.57L100 110.905h-3.572zm-38.095 23.81h46.428l-7.143 7.143H34.524z",
					fill: "#428DFC"
				}),
				/* @__PURE__ */ (0, Q.jsx)("path", {
					d: "M138.69 185.465h11.255c1.841-4.918 2.559-7.094 3.626-15.632.499-3.987-.595-24.197-.595-26.19s.498-3.489.997-4.485c.498-.997.996-1.495 2.491-1.994s15.726-1.384 24.696-2.381 12.458-1.993 15.947-5.482c2.791-2.79 1.495-11.129.498-14.95-7.724 0-28.411 2.762-42.871 3.696-18.424 1.191-21.535 4.527-23.186 8.929-1.786 4.762 2.197 23.718 2.976 29.167.595 4.166 3.571 21.428 4.166 29.322",
					fill: "url(#paint3_linear_726_3640)"
				}),
				/* @__PURE__ */ (0, Q.jsx)("path", {
					d: "M211.309 129.952c3.588-4.784 1.661-14.95.498-18.438-15.379.581-54.531 7.447-61.309 9.441-8.471 2.491-9.967 5.481-10.465 7.475s-.261 3.917.498 6.976c4.112 16.57 16.612 43.951 19.02 50.06h11.96c.997-2.491 2.665-9.244 2.298-15.038-.982-15.476-8.251-21.797-8.251-29.152 0-1.495 1.496-2.492 3.489-2.99s18.535.332 24.017-.166c5.482-.499 13.76-2.187 18.245-8.168",
					fill: "url(#paint4_linear_726_3640)"
				}),
				/* @__PURE__ */ (0, Q.jsxs)("g", {
					style: { animation: "write 1s infinite alternate" },
					children: [/* @__PURE__ */ (0, Q.jsx)("path", {
						d: "M143.5 100c2.857 0 15.5-1.829 17.833-2.5v11.024c-5.158-1.389-17.881-3.572-19.666-3.572s-5.357-.595-7.738 0c-2.381.596-7.143 2.977-7.738 2.381-.596-.595-1.191-6.547-.596-7.738.596-1.19 4.762-2.976 6.548-2.976S139.929 100 143.5 100",
						fill: "url(#paint5_linear_726_3640)"
					}), /* @__PURE__ */ (0, Q.jsx)("path", {
						d: "m135.621 90.473 2.019 1.261-10.093 16.154-2.272 1.388.252-2.65z",
						fill: "#23286B"
					})]
				}),
				/* @__PURE__ */ (0, Q.jsx)("path", {
					d: "M164.286 91.857c3.809-4.762 1.984-11.111.595-13.69 2.976 1.984 9.286 7.976 10.714 16.071 1.786 10.119-1.19 13.691-5.357 16.667-3.333 2.381-9.722 1.785-12.5 1.19l-1.786-14.285c1.048-.31 4.524-1.191 8.334-5.953",
					fill: "#D62929"
				}),
				/* @__PURE__ */ (0, Q.jsx)("path", {
					d: "M170.833 101.976c.476-8.095-3.77-19.246-5.952-23.81 1.389-.198 4.405-.952 5.357-2.38.952-1.429 1.19-3.373 1.19-4.167 4.762.595 14.286 3.572 20.239 7.738 5.559 3.892 9.523 10.12 11.904 13.096s7.738 6.547 9.524 10.118 3.572 8.334 1.786 13.096c-3.572 4.166-22.024 9.524-27.976 9.524-2.381 0-16.072 1.19-17.262-4.762-1.191-5.953.595-8.334 1.19-18.453",
					fill: "url(#paint6_linear_726_3640)"
				}),
				/* @__PURE__ */ (0, Q.jsx)("path", {
					fill: "#E94A47",
					d: "M107.143 108.524h28.571v2.381h-28.571z"
				}),
				/* @__PURE__ */ (0, Q.jsx)("path", {
					d: "m154.928 199.419-4.984-13.953H138.69c-1.495 1.329-4.692 4.286-6.686 5.482-2.492 1.495-7.475 3.488-9.468 4.983-1.595 1.196-2.99 2.824-3.489 3.488z",
					fill: "#1A2256"
				}),
				/* @__PURE__ */ (0, Q.jsx)("path", {
					d: "m176.495 199.419-4.984-13.953h-11.96c-.83 1.163-3.09 3.887-5.482 5.482-2.99 1.993-5.98 2.491-8.97 4.485-1.483.989-3.654 2.99-4.485 3.986z",
					fill: "#28306D"
				}),
				/* @__PURE__ */ (0, Q.jsx)("path", {
					fill: "url(#paint7_linear_726_3640)",
					d: "M0 110.905h89.286v4.762H0z"
				}),
				/* @__PURE__ */ (0, Q.jsx)("path", {
					fill: "url(#paint8_linear_726_3640)",
					d: "M0 115.667h3.571v84.524H0z"
				}),
				/* @__PURE__ */ (0, Q.jsx)("path", {
					fill: "url(#paint9_linear_726_3640)",
					d: "M89.286 115.667h3.571v84.524h-3.571z"
				}),
				/* @__PURE__ */ (0, Q.jsx)("path", {
					fill: "url(#paint10_linear_726_3640)",
					d: "M89.286 110.905h52.381v4.762H89.286z"
				}),
				/* @__PURE__ */ (0, Q.jsx)("path", {
					fill: "url(#paint11_linear_726_3640)",
					d: "M138.095 115.667h3.571v84.524h-3.571z"
				}),
				/* @__PURE__ */ (0, Q.jsx)("path", {
					d: "M137.5 106.738c2.381 0 16 3.762 23.81 3.571 2.777 6.151 7.023 17.5 1.785 13.691-6.547-4.762-17.262-11.905-23.809-11.905-.979 0-2.381.595-4.762.595-4.167 0-10.119-1.785-12.5-1.785 6.548-5.358 12.5-4.167 15.476-4.167",
					fill: "url(#paint12_linear_726_3640)"
				}),
				/* @__PURE__ */ (0, Q.jsx)("path", {
					d: "m162.5 134.714-1.191-24.404c4.365-.199 13.452-2.739 14.881-11.31 1.786-10.714-8.929-19.643-11.309-20.833 2.38 0 4.166-1.19 4.761-1.786.596-.595 1.786-1.786 1.786-4.762 30.357 5.357 28.572 37.5 25.595 44.048-2.976 6.547-11.904 8.333-14.285 10.119s-4.167 5.357-8.334 7.143c-3.333 1.428-9.325 1.785-11.904 1.785",
					fill: "url(#paint13_linear_726_3640)"
				}),
				/* @__PURE__ */ (0, Q.jsxs)("g", {
					style: {
						animation: "head 2s infinite alternate ease-in-out",
						transformOrigin: "center",
						transformBox: "fill-box"
					},
					children: [
						/* @__PURE__ */ (0, Q.jsx)("path", {
							d: "M159.523 72.214c-2.882-.1-4.993-2.335-5.952-3.571 0 0-2.797.425-2.976-.183-.179-.607.298-6.157.595-8.15.384-2.573 2.798-6.152 5.953-7.143 3.445-1.083 9.637-.215 11.904 3.571 2.495 4.166-.114 9.364-1.786 11.31s-4.134 4.292-7.738 4.166",
							fill: "#FFBEB6"
						}),
						/* @__PURE__ */ (0, Q.jsx)("path", {
							d: "M150.595 60.905c-4.762 0-8.73-4.762-10.119-7.143 8.532-1.389 27.143-4.286 33.333-4.762 2.381 10.952-3.373 17.262-6.547 19.048-.397-.596-.953-2.024 0-2.977 1.19-1.19 2.38-4.761.595-5.952-1.786-1.19-2.381 1.786-4.167 1.786-1.428 0-3.77-1.984-4.762-2.976-.793.992-3.571 2.976-8.333 2.976",
							fill: "#23286B"
						}),
						/* @__PURE__ */ (0, Q.jsx)("path", {
							d: "M157.115 63.507c-.435-1.62-1.861-2.669-3.209-2.307-1.049.28-1.712 1.32-1.752 2.53a4 4 0 0 0-.935-.213l-.199-.01a2.6 2.6 0 0 0-.619.055c-.384-1.26-1.466-2.08-2.496-1.804-1.057.283-1.585 1.6-1.232 2.922.355 1.32 1.471 2.197 2.529 1.913.941-.252 1.464-1.323 1.317-2.487.102-.028.269-.046.494-.043q.484.006 1.143.259l.029.012q.032.233.094.468c.435 1.62 1.861 2.669 3.21 2.307 1.35-.361 2.06-1.982 1.626-3.602m-9.065-1.212c.722-.193 1.565.468 1.847 1.52s-.117 2.047-.839 2.24-1.565-.467-1.847-1.52.117-2.046.839-2.24m6-.558c1.023-.274 2.167.566 2.527 1.914s-.208 2.647-1.232 2.922c-1.023.273-2.168-.568-2.528-1.915-.361-1.346.209-2.646 1.233-2.922z",
							fill: "#F7453E"
						})
					]
				})
			]
		}),
		/* @__PURE__ */ (0, Q.jsxs)("defs", { children: [
			/* @__PURE__ */ (0, Q.jsxs)("linearGradient", {
				id: "paint0_linear_726_3640",
				x1: 228.572,
				y1: 76.381,
				x2: 228.572,
				y2: 137.095,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ (0, Q.jsx)("stop", { stopColor: "#D6D7D8" }), /* @__PURE__ */ (0, Q.jsx)("stop", {
					offset: .909,
					stopColor: "#EAEAEB"
				})]
			}),
			/* @__PURE__ */ (0, Q.jsxs)("linearGradient", {
				id: "paint1_linear_726_3640",
				x1: 232.446,
				y1: 135.19,
				x2: 186.718,
				y2: 135.19,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ (0, Q.jsx)("stop", { stopColor: "#D7D8D9" }), /* @__PURE__ */ (0, Q.jsx)("stop", {
					offset: .529,
					stopColor: "#E4E4E5"
				})]
			}),
			/* @__PURE__ */ (0, Q.jsxs)("linearGradient", {
				id: "paint2_linear_726_3640",
				x1: 229.762,
				y1: 137.095,
				x2: 229.762,
				y2: 200.19,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ (0, Q.jsx)("stop", { stopColor: "#DFDFE1" }), /* @__PURE__ */ (0, Q.jsx)("stop", {
					offset: .22,
					stopColor: "#EEE"
				})]
			}),
			/* @__PURE__ */ (0, Q.jsxs)("linearGradient", {
				id: "paint3_linear_726_3640",
				x1: 171.678,
				y1: 116.197,
				x2: 171.523,
				y2: 185.466,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ (0, Q.jsx)("stop", { stopColor: "#1479F2" }), /* @__PURE__ */ (0, Q.jsx)("stop", {
					offset: 1,
					stopColor: "#2F84F7"
				})]
			}),
			/* @__PURE__ */ (0, Q.jsxs)("linearGradient", {
				id: "paint4_linear_726_3640",
				x1: 168.645,
				y1: 113.705,
				x2: 168.645,
				y2: 185.466,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ (0, Q.jsx)("stop", { stopColor: "#428DFC" }),
					/* @__PURE__ */ (0, Q.jsx)("stop", {
						offset: .311,
						stopColor: "#438FFF"
					}),
					/* @__PURE__ */ (0, Q.jsx)("stop", {
						offset: 1,
						stopColor: "#428DFC"
					})
				]
			}),
			/* @__PURE__ */ (0, Q.jsxs)("linearGradient", {
				id: "paint5_linear_726_3640",
				x1: 127.152,
				y1: 98.256,
				x2: 156.724,
				y2: 102.909,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ (0, Q.jsx)("stop", {
					offset: .529,
					stopColor: "#FFBEB6"
				}), /* @__PURE__ */ (0, Q.jsx)("stop", {
					offset: 1,
					stopColor: "#F9B0AA"
				})]
			}),
			/* @__PURE__ */ (0, Q.jsxs)("linearGradient", {
				id: "paint6_linear_726_3640",
				x1: 215.476,
				y1: 115.667,
				x2: 165.476,
				y2: 78.762,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ (0, Q.jsx)("stop", {
					offset: .261,
					stopColor: "#D62929"
				}), /* @__PURE__ */ (0, Q.jsx)("stop", {
					offset: 1,
					stopColor: "#E74844"
				})]
			}),
			/* @__PURE__ */ (0, Q.jsxs)("linearGradient", {
				id: "paint7_linear_726_3640",
				x1: 89.286,
				y1: 113.762,
				x2: 0,
				y2: 113.762,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ (0, Q.jsx)("stop", { stopColor: "#E9EBED" }), /* @__PURE__ */ (0, Q.jsx)("stop", {
					offset: .102,
					stopColor: "#EEE"
				})]
			}),
			/* @__PURE__ */ (0, Q.jsxs)("linearGradient", {
				id: "paint8_linear_726_3640",
				x1: 2.381,
				y1: 115.667,
				x2: 2.381,
				y2: 200.19,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ (0, Q.jsx)("stop", { stopColor: "#E5E9EC" }), /* @__PURE__ */ (0, Q.jsx)("stop", {
					offset: .22,
					stopColor: "#EEE"
				})]
			}),
			/* @__PURE__ */ (0, Q.jsxs)("linearGradient", {
				id: "paint9_linear_726_3640",
				x1: 91.666,
				y1: 115.667,
				x2: 91.666,
				y2: 200.19,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ (0, Q.jsx)("stop", { stopColor: "#DDE4EB" }), /* @__PURE__ */ (0, Q.jsx)("stop", {
					offset: .506,
					stopColor: "#EEE"
				})]
			}),
			/* @__PURE__ */ (0, Q.jsxs)("linearGradient", {
				id: "paint10_linear_726_3640",
				x1: 141.667,
				y1: 113.762,
				x2: 89.286,
				y2: 113.762,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ (0, Q.jsx)("stop", { stopColor: "#E6E9EC" }), /* @__PURE__ */ (0, Q.jsx)("stop", {
					offset: .331,
					stopColor: "#DCE3EA"
				})]
			}),
			/* @__PURE__ */ (0, Q.jsxs)("linearGradient", {
				id: "paint11_linear_726_3640",
				x1: 140.476,
				y1: 115.667,
				x2: 140.476,
				y2: 200.19,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ (0, Q.jsx)("stop", { stopColor: "#E5E9EC" }), /* @__PURE__ */ (0, Q.jsx)("stop", {
					offset: .22,
					stopColor: "#EEE"
				})]
			}),
			/* @__PURE__ */ (0, Q.jsxs)("linearGradient", {
				id: "paint12_linear_726_3640",
				x1: 124.405,
				y1: 109.119,
				x2: 163.691,
				y2: 114.476,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ (0, Q.jsx)("stop", {
					offset: .529,
					stopColor: "#FFBEB6"
				}), /* @__PURE__ */ (0, Q.jsx)("stop", {
					offset: 1,
					stopColor: "#F9B0AA"
				})]
			}),
			/* @__PURE__ */ (0, Q.jsxs)("linearGradient", {
				id: "paint13_linear_726_3640",
				x1: 198.566,
				y1: 134.709,
				x2: 147.177,
				y2: 86.438,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ (0, Q.jsx)("stop", {
					offset: .062,
					stopColor: "#E94A47"
				}), /* @__PURE__ */ (0, Q.jsx)("stop", {
					offset: .829,
					stopColor: "#E94A47"
				})]
			}),
			/* @__PURE__ */ (0, Q.jsx)("clipPath", {
				id: "clip0_726_3640",
				children: /* @__PURE__ */ (0, Q.jsx)("path", {
					fill: "#fff",
					d: "M0 0h250v200H0z"
				})
			})
		] })
	]
}), Jb = ({ field: e, row: { id: t, data: n }, filterData: { searchKey: r }, signals: i, handleReloadDataAfterBulkOperation: a, resourceRecommenderConfig: { showAbsoluteValuesInResourceRecommender: o } }) => {
	let s = n, c = X(), { clusterId: l } = Z(), [u, d] = j(null);
	return k(() => {
		let n = ({ detail: { activeRowData: e } }) => {
			e.id === t && d(e.data);
		};
		return e === "name" && i.addEventListener(iu.ENTER_PRESSED, n), () => {
			e === "name" && i.removeEventListener(iu.ENTER_PRESSED, n);
		};
	}, []), s.additionalMetadata?.[e] ? /* @__PURE__ */ (0, Q.jsx)(Gb, {
		resourceInfo: s.additionalMetadata[e],
		columnName: e,
		showAbsoluteValuesInResourceRecommender: o
	}) : /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [e === "name" ? /* @__PURE__ */ (0, Q.jsx)("div", {
		className: "flexbox dc__align-items-center dc__gap-4 dc__content-space py-10 pr-6",
		"data-testid": "created-resource-name",
		children: /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox dc__align-start dc__content-space dc__gap-8 flex-grow-1",
			children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox dc__align-start dc__gap-4 flex-grow-1 dc__visible-hover dc__visible-hover--parent",
				children: [/* @__PURE__ */ (0, Q.jsx)(W, {
					content: `${s.name}`,
					children: /* @__PURE__ */ (0, Q.jsx)("button", {
						type: "button",
						className: "dc__unset-button-styles dc__align-left dc__truncate cursor-default",
						"data-name": s.name,
						"data-namespace": s.namespace,
						"data-kind": s.kind,
						"data-api-version": s.apiVersion,
						onClick: (e) => {
							let { name: t, namespace: n = Qa.value, kind: r, apiVersion: i } = e.currentTarget.dataset, a = od(i).group.toLowerCase() || Dc;
							c(`${Y(B.RESOURCE_BROWSER.CLUSTER_DETAILS.K8S_RESOURCE_DETAIL, {
								clusterId: l,
								namespace: n,
								name: t,
								kind: r.toLowerCase(),
								group: a
							})}/${El.manifest}`);
						},
						children: /* @__PURE__ */ (0, Q.jsx)("span", {
							className: "dc__link cursor",
							dangerouslySetInnerHTML: { __html: Ne.sanitize(Gd({
								searchText: r,
								text: String(s.name),
								highlightClasses: "p-0 fw-6 bcy-2"
							})) }
						})
					})
				}), /* @__PURE__ */ (0, Q.jsx)(qo, {
					content: String(s.name),
					rootClassName: "mt-4 dc__visible-hover--child"
				})]
			}), /* @__PURE__ */ (0, Q.jsx)("div", {
				className: "generic-table__row__hover-item",
				children: /* @__PURE__ */ (0, Q.jsx)(M, {
					dataTestId: `apply-recommendation-${s.id}`,
					text: "Apply",
					endIcon: /* @__PURE__ */ (0, Q.jsx)(z, {
						name: "ic-caret-right",
						color: null
					}),
					onClick: () => {
						d(s);
					},
					size: I.medium,
					variant: F.text,
					isOpacityHoverChild: !0
				})
			})]
		})
	}) : /* @__PURE__ */ (0, Q.jsx)("div", {
		className: "flexbox py-10 dc__align-items-center",
		children: /* @__PURE__ */ (0, Q.jsx)(W, {
			content: s[e]?.toString(),
			children: /* @__PURE__ */ (0, Q.jsx)("span", {
				className: e === "status" ? "dc__no-shrink" : "dc__truncate dc__ellipsis-right",
				"data-testid": `${e}-count`,
				dangerouslySetInnerHTML: { __html: Ne.sanitize(Gd({
					searchText: r,
					text: s[e]?.toString(),
					highlightClasses: "p-0 fw-6 bcy-2"
				})) }
			})
		})
	}), u && /* @__PURE__ */ (0, Q.jsx)(B_, {
		handleClose: () => {
			d(null);
		},
		clusterId: +l,
		resourceList: [u],
		handleReloadDataAfterBulkOperation: a
	})] });
}, Yb = ({ selectedCluster: e, dynamicSort: t, ResourceRecommenderTableViewWrapper: n }) => {
	let r = Ja(new AbortController()), { clusterId: i } = Z(), [a, o] = j(!1), [s, c] = j(!0), [l, u] = j(!1), { selectedAPIVersionGVKFilter: d, selectedKindGVKFilter: f, selectedNamespace: p } = Pf({ parseSearchParams: P_ }), [m, h, g, _] = hf(() => Du(() => I_({
		clusterId: +i,
		namespace: p === Qa.value ? null : p,
		apiVersion: d,
		kind: f,
		resourceListAbortControllerRef: r
	}), r), [
		i,
		p,
		f,
		d
	], !!i);
	k(() => () => {
		r.current.abort();
	}, []);
	let v = m || pd(g), y = !pd(g) && !v ? g : null, [b, x, S, C] = hf(() => L_(+i), [i], !!i), w = x?.gvkList || [], { resourceList: T } = h || {}, ee = A(() => T?.headers.map((e) => ({
		field: e,
		label: w_[e],
		size: { range: {
			maxWidth: 600,
			minWidth: 70,
			startWidth: T_[e]
		} },
		CellComponent: Jb,
		comparator: t(e),
		isSortable: !0,
		horizontallySticky: e === Ol.NAME
	})) ?? [], [h]), E = A(() => (T?.data || []).map((e) => ({
		data: e,
		id: e.id
	})), [h]), D = async () => {
		u(!0), await z_(+i), u(!1);
	}, te = () => /* @__PURE__ */ (0, Q.jsx)(M, {
		dataTestId: "configure-prometheus-button",
		text: "Configure Prometheus",
		endIcon: /* @__PURE__ */ (0, Q.jsx)(z, {
			name: "ic-arrow-right",
			color: null
		}),
		component: N.link,
		linkProps: {
			to: Y(mu.GLOBAL_CONFIG_EDIT_CLUSTER, { clusterId: i }),
			target: "_blank",
			rel: "noopener noreferrer"
		}
	}), ne = () => /* @__PURE__ */ (0, Q.jsx)(M, {
		dataTestId: "initiate-resource-recommender-scan-button",
		text: "Check for recommendations",
		startIcon: /* @__PURE__ */ (0, Q.jsx)(z, {
			name: "ic-arrows-clockwise",
			color: null
		}),
		size: I.large,
		onClick: D,
		isLoading: l
	});
	return /* @__PURE__ */ (0, Q.jsx)("div", {
		className: "flexbox-col dc__content-space h-100 w-100 dc__overflow-auto",
		children: y?.code === eo.PRE_CONDITION_FAILED ? /* @__PURE__ */ (0, Q.jsx)(R, {
			title: "Set up Prometheus to monitor this cluster",
			subTitle: "Configure Prometheus to analyze resource usage and recommend resource configurations for this cluster",
			isButtonAvailable: !0,
			renderButton: te,
			SvgImage: Kb,
			imageType: yc.Large
		}) : x && !x.lastScannedOn ? /* @__PURE__ */ (0, Q.jsx)(R, {
			title: "No recommendations yet",
			subTitle: "We haven’t collected any data for recommendations in this cluster yet. Start a request to analyze usage and generate helpful configuration suggestions.",
			SvgImage: qb,
			imageType: yc.Large,
			isButtonAvailable: !0,
			renderButton: ne
		}) : /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [s && /* @__PURE__ */ (0, Q.jsx)(xc, {
			description: "This is an experimental feature. Apply recommendations with caution.",
			size: I.medium,
			buttonProps: {
				dataTestId: "collapse-is-experimental-warning-button",
				icon: /* @__PURE__ */ (0, Q.jsx)(z, {
					name: "ic-close-small",
					color: null
				}),
				ariaLabel: "Close is experimental feature warning",
				onClick: () => {
					c(!1);
				},
				variant: F.borderLess,
				style: P.neutral,
				showAriaLabelInTippy: !1
			},
			borderConfig: {
				top: !1,
				right: !1,
				left: !1
			},
			borderRadiusConfig: {
				top: !1,
				right: !1,
				left: !1,
				bottom: !1
			}
		}), /* @__PURE__ */ (0, Q.jsx)(ru, {
			columns: ee,
			rows: E,
			filtersVariant: tc.URL,
			id: "table__resource-recommender",
			paginationVariant: el.PAGINATED,
			ViewWrapper: n,
			loading: v,
			pageSizeOptions: Ac,
			filter: F_,
			additionalFilterProps: {
				initialSortKey: "namespace",
				parseSearchParams: P_,
				defaultPageSize: Ac[0].value
			},
			bulkSelectionConfig: {
				BulkActionsComponent: C_,
				bulkActionsData: { isResourceRecommendationView: !0 },
				getSelectAllDialogStatus: () => Vl.CLOSED,
				BulkOperationModal: $_,
				bulkOperationModalData: {
					selectedResource: {
						gvk: {
							Group: "",
							Version: "",
							Kind: Kc.ResourceRecommender
						},
						namespaced: !0
					},
					isNodeListing: !1,
					getManifestResource: $d,
					updateManifestResourceHelmApps: $d,
					clusterId: +i,
					clusterName: e?.label ?? "",
					handleReloadDataAfterBulkOperation: _
				}
			},
			emptyStateConfig: { noRowsConfig: {
				title: "No recommendations yet",
				subTitle: "Start a request to analyze usage and generate helpful configuration suggestions.",
				SvgImage: qb,
				imageType: yc.Large,
				isButtonAvailable: !0,
				renderButton: ne
			} },
			additionalProps: {
				selectedCluster: e,
				selectedResource: {
					gvk: {
						Group: "",
						Version: "",
						Kind: Kc.ResourceRecommender
					},
					namespaced: !0
				},
				resourceListError: y,
				reloadResourceList: _,
				resourceRecommenderConfig: {
					setShowAbsoluteValuesInResourceRecommender: o,
					showAbsoluteValuesInResourceRecommender: a,
					resourceLastScannedOnDetails: x ? { lastScannedOn: x.lastScannedOn } : null
				},
				gvkFilterConfig: {
					gvkOptions: w,
					areGVKOptionsLoading: b,
					reloadGVKOptions: C,
					gvkOptionsError: S
				}
			}
		})] })
	});
}, Xb = ({ lastScannedOn: e, filteredRows: t }) => {
	let { clusterId: n } = Z(), [r, i] = j(e), [a, o] = j(!1), s = Ja(null), { open: c, overlayProps: l, popoverProps: u, triggerProps: d, scrollableRef: f, closePopover: p } = Df({
		id: "resource-recommender-action-menu",
		width: 240,
		alignment: "end"
	}), m = () => Pd({
		startTime: e,
		endTime: (/* @__PURE__ */ new Date()).toISOString(),
		fallbackString: ""
	});
	return k(() => (e && (i(m()), s.current = setInterval(() => {
		i(m());
	}, 1e3)), () => {
		s.current &&= (clearInterval(s.current), null);
	}), [e]), /* @__PURE__ */ (0, Q.jsx)(ol, {
		open: c,
		overlayProps: l,
		popoverProps: u,
		triggerProps: d,
		triggerElement: null,
		buttonProps: {
			dataTestId: "open-resource-recommender-action-menu",
			variant: F.secondary,
			style: P.neutral,
			size: I.medium,
			icon: /* @__PURE__ */ (0, Q.jsx)(z, {
				name: "ic-more-vertical",
				color: null
			}),
			ariaLabel: "Open resource recommender action menu",
			showAriaLabelInTippy: !1
		},
		children: /* @__PURE__ */ (0, Q.jsxs)("div", {
			ref: f,
			className: "dc__overflow-auto p-4",
			onClick: p,
			children: [/* @__PURE__ */ (0, Q.jsxs)("button", {
				type: "button",
				className: "bg__hover dc__transparent flexbox dc__gap-8 px-8 py-6 w-100",
				disabled: a,
				onClick: async (e) => {
					e.stopPropagation(), o(!0), await z_(+n), o(!1), p();
				},
				children: [/* @__PURE__ */ (0, Q.jsx)("span", {
					className: "mt-2 flex dc__no-shrink dc__align-start",
					children: a ? /* @__PURE__ */ (0, Q.jsx)(z, {
						name: "ic-circle-loader",
						color: "O500",
						size: 16
					}) : /* @__PURE__ */ (0, Q.jsx)(z, {
						name: "ic-arrows-clockwise",
						color: "N800",
						size: 16
					})
				}), /* @__PURE__ */ (0, Q.jsxs)("span", {
					className: "flexbox-col",
					children: [/* @__PURE__ */ (0, Q.jsx)("span", {
						className: "cn-9 fs-13 fw-4 lh-1-5 dc__align-left",
						children: "Re-scan for recommendations"
					}), r && /* @__PURE__ */ (0, Q.jsxs)("span", {
						className: "cn-7 fs-12 fw-4 lh-1-5 dc__align-left",
						children: [
							"Last scanned ",
							r,
							" ago"
						]
					})]
				})]
			}), /* @__PURE__ */ (0, Q.jsx)(Ys, {
				fileName: "Devtron Resource Recommendations",
				headers: E_,
				triggerElementConfig: { customButton: {
					className: "bg__hover flexbox dc__gap-8 px-8 py-6 w-100",
					content: /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsx)("span", {
						className: "mt-2 flex dc__no-shrink",
						children: /* @__PURE__ */ (0, Q.jsx)(z, {
							name: "ic-download",
							size: 16,
							color: "N800"
						})
					}), /* @__PURE__ */ (0, Q.jsx)("span", {
						className: "cn-9 fs-13 fw-4 lh-1-5",
						children: "Export CSV"
					})] })
				} },
				apiPromise: () => Promise.resolve(j_((t || []).map((e) => e.data))),
				disabled: !t.length,
				modalConfig: { hideDialog: !0 }
			})]
		})
	});
}, Zb = ({ resource: e, getManifestResource: t, updateManifestResourceHelmApps: n, onClose: r, onSuccess: i }) => {
	let [a, o] = j(!1), s = Ja(new AbortController()), c = async () => {
		o(!0);
		let a = Au(e.kind);
		try {
			await V_({
				resource: e,
				getManifestResource: t,
				updateManifestResourceHelmApps: n,
				abortControllerRef: s
			}), H.showToast({
				variant: U.success,
				description: `${a} '${e.name}' restarted successfully`
			}), i?.(), r();
		} catch {
			H.showToast({
				variant: U.error,
				description: `Failed to restart ${a} '${e.name}'`
			});
		} finally {
			o(!1);
		}
	}, l = () => {
		a && s.current.abort(), r();
	};
	return /* @__PURE__ */ (0, Q.jsx)(ns, {
		variant: rs.custom,
		Icon: /* @__PURE__ */ (0, Q.jsx)(q_, {}),
		title: `Restart ${e.kind} '${e.name}'?`,
		subtitle: "Selected workload will be restarted. Are you sure?",
		buttonConfig: {
			primaryButtonConfig: {
				text: "Restart",
				onClick: c,
				isLoading: a
			},
			secondaryButtonConfig: {
				text: "Cancel",
				onClick: l,
				disabled: a
			}
		},
		handleClose: l
	});
}, Qb = async ({ clusterId: e, gvk: t, signal: n }) => {
	try {
		let { result: r } = await md({
			clusterId: e,
			filter: `self.spec.applyTo.exists(a, a.group == ${JSON.stringify(t.Group)} && a.kind == ${JSON.stringify(t.Kind)} && a.version == ${JSON.stringify(t.Version)})`,
			k8sRequest: { resourceIdentifier: { groupVersionKind: ev } }
		}, n), i = r?.data?.[0]?.spec?.schema || "{}";
		return JSON.parse(i);
	} catch {
		return {};
	}
}, $b = async ({ clusterId: e, gvk: t, signal: n }) => {
	try {
		let { result: r } = await md({
			clusterId: e,
			filter: `self.spec.applyTo.exists(a, a.group == ${JSON.stringify(t.Group)} && a.kind == ${JSON.stringify(t.Kind)} && a.version == ${JSON.stringify(t.Version)})`,
			k8sRequest: { resourceIdentifier: { groupVersionKind: tv } }
		}, n);
		return r?.data?.[0]?.spec?.lockedPaths ?? null;
	} catch {
		return null;
	}
}, ex = (e) => /* @__PURE__ */ (0, Q.jsx)("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "0 0 24 24",
	...e,
	children: /* @__PURE__ */ (0, Q.jsx)("path", {
		stroke: "#1DAD70",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "m17 9-6.667 6.666L7 12.333M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z",
		vectorEffect: "non-scaling-stroke"
	})
}), tx = (e) => /* @__PURE__ */ (0, Q.jsxs)("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [/* @__PURE__ */ (0, Q.jsx)("circle", {
		cx: 10.0001,
		cy: 10.0001,
		r: 8.33333,
		stroke: "#F33E3E",
		strokeWidth: 1.5
	}), /* @__PURE__ */ (0, Q.jsx)("path", {
		d: "M13.3334 6.66675L6.66675 13.3334M13.3334 13.3334L6.66675 6.66675",
		stroke: "#F33E3E",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
}), nx = (e, t, n) => {
	try {
		let r = kS({
			edited: e,
			unedited: t,
			patches: Fa(t, e)
		}, n, !0);
		return JSON.stringify(ja(t, r, !1, !1).newDocument);
	} catch {
		throw Error("Unable to apply eligibe changes");
	}
}, rx = (e, t, n) => {
	let r = MS({
		edited: t,
		unedited: e,
		patches: Fa(e, t)
	}, n);
	return !!Object.keys(r ?? {}).length;
}, ix = ({ content: e = "", type: t }) => {
	let [n, r] = j(!e), i = t === "eligible", a = i ? "Eligible" : "Not eligible";
	return /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "br-4 dc__border flexbox-col w-100",
		children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
			className: `flexbox dc__content-space dc__align-items-center px-12 py-8 dc__gap-8 dc__border-bottom ${i ? "bcg-1" : "bcr-1"}`,
			children: [
				i ? /* @__PURE__ */ (0, Q.jsx)(ex, { className: "dc__no-shrink icon-dim-16 scg-6" }) : /* @__PURE__ */ (0, Q.jsx)(tx, { className: "dc__no-shrink icon-dim-16 scr-5" }),
				/* @__PURE__ */ (0, Q.jsx)("span", {
					className: `flex-grow-1 fs-13 fw-6 lh-16 ${i ? "cg-6" : "cr-5"}`,
					children: a
				}),
				/* @__PURE__ */ (0, Q.jsx)("button", {
					type: "button",
					className: "dc__unset-button-styles flex",
					onClick: () => {
						r((e) => !e);
					},
					"aria-label": `${n ? "Reveal" : "Hide"} content`,
					"data-testid": "ineligible-changes-modal__toggle-collapse",
					children: /* @__PURE__ */ (0, Q.jsx)(He, { className: `dc__transition--transform ${n ? "dc__flip-270" : "dc__flip-90"}` })
				})
			]
		}), /* @__PURE__ */ (0, Q.jsx)(Zo, {
			expand: !n,
			children: /* @__PURE__ */ (0, Q.jsx)("pre", {
				className: "flexbox-col p-8 fs-13 lh-20 dc__align-start m-0 read-only-expression dark dc__no-border mono text__white dc__bottom-left-radius dc__bottom-right-radius",
				children: e.split("\n").map((e, t) => /* @__PURE__ */ (0, Q.jsx)("span", { children: e }, t))
			})
		})]
	});
}, ax = ({ uneditedManifest: e, editedManifest: t, handleCallApplyChangesAPI: n, handleModalClose: r, lockedKeys: i = [] }) => {
	let [a, o] = j(!1), [s, c] = j(!1), { eligibleChanges: l, unEligibleChanges: u } = A(() => {
		let n = [{
			edited: t,
			unedited: e,
			patches: Fa(e, t)
		}, i], r = MS(...n), a = NS(...n);
		return {
			unEligibleChanges: Object.keys(r).length ? Tu(r) : "",
			eligibleChanges: Object.keys(a).length ? Tu(a) : ""
		};
	}, []), d = () => {
		o((e) => !e);
	}, f = async () => {
		try {
			if (!a) return;
			let o = nx(t, e, i);
			c(!0), await n(o), r();
		} catch (e) {
			K(e);
		}
	}, p = s ? $d : r;
	return /* @__PURE__ */ (0, Q.jsx)(Rs, {
		width: "800px",
		position: "right",
		parentClassName: "h-100",
		onEscape: p,
		onClose: p,
		children: /* @__PURE__ */ (0, Q.jsxs)("dialog", {
			className: "bg__primary h-100 cn-9 w-100 flexbox-col dc__overflow-hidden p-0",
			onClick: uf,
			children: [
				/* @__PURE__ */ (0, Q.jsxs)("header", {
					className: "flexbox dc__content-space dc__align-items-center dc__border-bottom px-20 py-12",
					children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
						className: "flexbox dc__gap-8",
						children: [/* @__PURE__ */ (0, Q.jsx)(gi, { className: "dc__no-shrink icon-dim-24" }), /* @__PURE__ */ (0, Q.jsx)("span", {
							className: "fs-16 fw-6 lh-24 cn-9",
							children: "Some changes are not eligible for update"
						})]
					}), /* @__PURE__ */ (0, Q.jsx)(M, {
						dataTestId: "ineligible-changes-modal__close",
						disabled: s,
						onClick: p,
						size: I.xs,
						icon: /* @__PURE__ */ (0, Q.jsx)(er, {}),
						ariaLabel: "Close drawer",
						showAriaLabelInTippy: !1,
						style: P.neutral,
						variant: F.borderLess
					})]
				}),
				/* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "flexbox-col dc__gap-12 flex-grow-1 dc__overflow-auto py-12 px-16",
					children: [
						/* @__PURE__ */ (0, Q.jsx)("span", {
							className: "fs-14 lh-22 cn-9",
							children: "Some of the keys are locked and prohibited to change by non-super admin users."
						}),
						/* @__PURE__ */ (0, Q.jsx)(ix, {
							content: u,
							type: "unEligible"
						}),
						!!l && /* @__PURE__ */ (0, Q.jsx)(ix, {
							content: l,
							type: "eligible"
						})
					]
				}),
				/* @__PURE__ */ (0, Q.jsx)("footer", {
					className: "flexbox dc__content-space p-16 dc__align-items-center dc__border-top dc__gap-12",
					children: l ? /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsx)(Wo, {
						isChecked: a,
						onChange: d,
						value: Io.CHECKED,
						name: "Save eligible changes",
						rootClassName: "m-0",
						disabled: !l,
						children: /* @__PURE__ */ (0, Q.jsx)("span", {
							className: "fs-14 lh-22 cn-9",
							children: "Save eligible changes"
						})
					}), /* @__PURE__ */ (0, Q.jsxs)("div", {
						className: "flexbox dc__gap-12",
						children: [/* @__PURE__ */ (0, Q.jsx)(M, {
							dataTestId: "ineligible-changes-modal__cancel",
							size: I.medium,
							variant: F.secondary,
							disabled: s,
							onClick: p,
							text: "Cancel"
						}), /* @__PURE__ */ (0, Q.jsx)(M, {
							dataTestId: "ineligible-changes-modal__save",
							size: I.medium,
							disabled: !a,
							variant: F.primary,
							isLoading: s,
							onClick: f,
							text: "Save changes"
						})]
					})] }) : /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsx)("div", {
						className: "flex-grow-1",
						children: /* @__PURE__ */ (0, Q.jsx)(xc, { description: Oi })
					}), /* @__PURE__ */ (0, Q.jsx)(M, {
						dataTestId: "ineligible-changes-modal__okay",
						size: I.medium,
						variant: F.primary,
						onClick: p,
						text: "Okay"
					})] })
				})
			]
		})
	});
}, ox = ({ mode: e, handleToggle: t, isDisabled: n }) => /* @__PURE__ */ (0, Q.jsx)(Bl, {
	value: e,
	onChange: t,
	disabled: n,
	segments: zo,
	size: I.xs,
	name: "-manifest-gui-yaml-segmented-control"
}), sx = /* @__PURE__ */ t({ default: () => dx }), cx = Wa(() => import("./InterceptedEvents-C9WctFGH.js")), lx = Wa(() => import("./WatchEvents-NY3eGHto.js")), ux = vo.INFRASTRUCTURE_MANAGEMENT.RESOURCE_WATCHER, dx = () => /* @__PURE__ */ (0, Q.jsx)("div", {
	className: "event-watcher-container flexbox-col flex-grow-1 h-100 bg__primary dc__overflow-hidden",
	children: /* @__PURE__ */ (0, Q.jsx)("div", {
		className: "flexbox-col flex-grow-1 dc__overflow-hidden",
		children: /* @__PURE__ */ (0, Q.jsxs)(qf, { children: [
			/* @__PURE__ */ (0, Q.jsx)(J, {
				path: ux.WATCHERS,
				element: /* @__PURE__ */ (0, Q.jsx)(lx, {})
			}),
			/* @__PURE__ */ (0, Q.jsx)(J, {
				path: ux.INTERCEPTED_CHANGES,
				element: /* @__PURE__ */ (0, Q.jsx)(cx, {})
			}),
			/* @__PURE__ */ (0, Q.jsx)(J, {
				path: "*",
				element: /* @__PURE__ */ (0, Q.jsx)(Kf, {
					to: ux.WATCHERS,
					replace: !0
				})
			})
		] })
	})
}), fx = ({ email: e, handleToggleEmailSelection: t, isSelected: n }) => /* @__PURE__ */ (0, Q.jsx)(Wo, {
	isChecked: n,
	onChange: () => {
		t(e);
	},
	rootClassName: "icon-dim-20 w-100 dc_max-width__max-content mb-0 br-4",
	dataTestId: `toggle-notify-user-${e}`,
	tabIndex: 0,
	value: Io.CHECKED,
	children: /* @__PURE__ */ (0, Q.jsx)(gu, { identifier: e })
}), px = ({ groupName: e, handleToggleEmailSelection: t, handleToggleGroupSelection: n, emailList: r, searchKey: i, selectedEmails: a, requiredCount: o, approvalType: s }) => {
	let c = r.length > 0 && r.every((e) => a[e]), l = (t = !1) => /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox dc__gap-8 dc__content-space flex-grow-1",
		children: [i ? /* @__PURE__ */ (0, Q.jsx)(W, {
			content: e,
			children: /* @__PURE__ */ (0, Q.jsx)("h4", {
				className: "m-0 dc__truncate cn-7 fs-12 fw-6 lh-20 dc__uppercase flex-grow-1",
				children: e
			})
		}) : /* @__PURE__ */ (0, Q.jsx)(Wo, {
			isChecked: c,
			onChange: n,
			rootClassName: "icon-dim-20 mb-0 w-100 dc_max-width__max-content br-4",
			dataTestId: `toggle-notify-group-${e}`,
			tabIndex: 0,
			value: Io.CHECKED,
			disabled: t,
			children: /* @__PURE__ */ (0, Q.jsx)(W, {
				content: e,
				children: /* @__PURE__ */ (0, Q.jsx)("span", {
					className: "m-0 dc__truncate cn-7 fs-12 fw-6 lh-20 dc__uppercase",
					children: e
				})
			})
		}), /* @__PURE__ */ (0, Q.jsx)(Aa, { requiredApprovalCount: o })]
	});
	if (r.length === 0) return /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox-col dc__gap-8",
		children: [l(!0), /* @__PURE__ */ (0, Q.jsx)("span", {
			className: "cn-7 fs-13 fw-4 lh-20",
			children: Zn[s].noUsersFound
		})]
	});
	let u = i.toLowerCase(), d = kr(r).filter((e) => e.toLowerCase().includes(u));
	return d.length ? /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox-col dc__gap-8",
		children: [l(), d.map((n) => /* @__PURE__ */ (0, Q.jsx)(fx, {
			isSelected: a[n] || !1,
			email: n,
			handleToggleEmailSelection: t
		}, `${e}-${n}-checkbox`))]
	}) : null;
}, mx = ({ children: e, selectedEmails: t, setSelectedEmails: n, approvalConfigData: r, approvalType: i }) => {
	let { email: a } = Ff(), { searchKey: o, handleSearch: s, clearFilters: c } = Mf(), { allEmailList: l, anyUsersEmails: u, specificUsersEmails: d } = A(() => {
		let e = ai(r.anyUserApprovedInfo.approverList, a), t = ai(r.specificUsersApprovedInfo.approverList, a), n = ai(r.userGroupsApprovedInfo.userGroups.flatMap(({ approverList: e }) => e), a);
		return {
			allEmailList: kr([...new Set([
				...e,
				...t,
				...n
			])]),
			anyUsersEmails: e,
			specificUsersEmails: t
		};
	}, [r]), f = Object.keys(t).length, p = f === l.length, m = (e) => {
		if (!o) return e;
		let t = o.toLowerCase();
		return e.filter((e) => e.toLowerCase().includes(t));
	}, h = () => {
		if (p) {
			n({});
			return;
		}
		n((e) => {
			let t = structuredClone(e);
			return l.forEach((e) => {
				t[e] = !0;
			}), t;
		});
	}, g = (e) => {
		n((t) => {
			let n = structuredClone(t);
			return n[e] ? (delete n[e], n) : (n[e] = !0, n);
		});
	}, _ = (e) => {
		s(e);
	}, v = (e) => {
		let r = kr(e);
		if (r.every((e) => t[e])) {
			n((e) => {
				let t = structuredClone(e);
				return r.forEach((e) => {
					delete t[e];
				}), t;
			});
			return;
		}
		n((e) => {
			let t = structuredClone(e);
			return r.forEach((e) => {
				t[e] = !0;
			}), t;
		});
	}, y = (e, t) => () => {
		if (e !== "group") {
			v(e === "specific" ? d : u);
			return;
		}
		v(ai(r.userGroupsApprovedInfo.userGroups.find(({ groupIdentifier: e }) => e === t).approverList, a));
	};
	return /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "h-100 dc__overflow-hidden dc__align-left flexbox-col dc__content-space",
		children: [/* @__PURE__ */ (0, Q.jsx)("div", {
			className: "h-100 mxh-250 dc__overflow-auto flexbox-col dc__gap-12 py-12 px-16",
			children: l.length > 0 ? /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [
				/* @__PURE__ */ (0, Q.jsx)(Il, {
					initialSearchText: o,
					handleEnter: _,
					inputProps: {
						placeholder: "Search users to notify",
						autoFocus: !0
					},
					containerClassName: "w-100"
				}),
				!o && /* @__PURE__ */ (0, Q.jsx)(Wo, {
					isChecked: p,
					onChange: h,
					rootClassName: "icon-dim-20 w-100 dc_max-width__max-content mb-0 br-4",
					dataTestId: "toggle-notify-all-users",
					tabIndex: 0,
					value: Io.CHECKED,
					children: /* @__PURE__ */ (0, Q.jsx)("span", {
						className: "cn-9 fs-13 fw-4 lh-20",
						children: "Notify all users"
					})
				}),
				m(l).length === 0 ? /* @__PURE__ */ (0, Q.jsx)(lc, {
					useInfoIcon: !0,
					title: "No users found",
					subTitle: "No users found for the search query",
					description: null,
					reload: c,
					buttonText: "Clear search"
				}) : /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "flexbox-col dc__gap-16",
					children: [
						d.length > 0 && /* @__PURE__ */ (0, Q.jsx)(px, {
							groupName: oa.specificUsersHeading,
							handleToggleEmailSelection: g,
							handleToggleGroupSelection: y("specific"),
							emailList: d,
							searchKey: o,
							selectedEmails: t,
							requiredCount: r.specificUsersApprovedInfo.requiredCount,
							approvalType: i
						}),
						r.userGroupsApprovedInfo.userGroups.map(({ groupName: e, groupIdentifier: n, approverList: r, requiredCount: s }) => {
							let c = ai(r, a);
							return /* @__PURE__ */ (0, Q.jsx)(px, {
								groupName: e,
								handleToggleEmailSelection: g,
								handleToggleGroupSelection: y("group", n),
								emailList: c,
								searchKey: o,
								selectedEmails: t,
								requiredCount: s,
								approvalType: i
							}, `group-${n}`);
						}),
						u.length > 0 && /* @__PURE__ */ (0, Q.jsx)(px, {
							groupName: oa.anyBelowUsers,
							handleToggleEmailSelection: g,
							handleToggleGroupSelection: y("any"),
							emailList: u,
							searchKey: o,
							selectedEmails: t,
							requiredCount: r.anyUserApprovedInfo.requiredCount,
							approvalType: i
						})
					]
				}), /* @__PURE__ */ (0, Q.jsxs)("p", {
					className: "m-0 fw-4 fs-13 cn-9",
					children: [
						"Users must have '",
						/* @__PURE__ */ (0, Q.jsx)("span", {
							className: "dc__lowercase",
							children: Zn[i].title
						}),
						"' permission."
					]
				})] })
			] }) : /* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "fs-13 fw-4 cn-7 lh-20",
				children: [
					/* @__PURE__ */ (0, Q.jsx)("span", { children: oa.noApproverInfoMsg }),
					"\xA0",
					/* @__PURE__ */ (0, Q.jsx)(Wf, {
						to: B.GLOBAL_CONFIG_AUTH.USERS,
						target: "_blank",
						className: "anchor",
						children: oa.permissions
					})
				]
			})
		}), /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox dc__content-space dc__gap-12 py-12 px-16 dc__border-top-n1",
			children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox dc__gap-8 py-6 dc__align-items-center",
				children: [/* @__PURE__ */ (0, Q.jsx)(lr, { className: "dc__no-shrink icon-dim-16" }), /* @__PURE__ */ (0, Q.jsxs)("span", {
					className: "cn-9 fs-13 fw-4 lh-20 dc__truncate",
					children: [f, " users will be notified"]
				})]
			}), e]
		})]
	});
}, hx = (e) => /* @__PURE__ */ (0, Q.jsx)("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ (0, Q.jsx)("g", {
		id: "Icon/ic-ses",
		children: /* @__PURE__ */ (0, Q.jsxs)("g", {
			id: "Group",
			children: [
				/* @__PURE__ */ (0, Q.jsx)("path", {
					id: "Vector",
					d: "M8.68854 2.57435C8.73854 2.67102 8.79021 2.76768 8.84438 2.86268C8.88521 2.93435 8.93271 3.01185 8.96104 3.08935C8.89521 3.10102 8.82604 3.13685 8.76438 3.16268C8.67188 3.20268 8.57688 3.23685 8.48438 3.27602C8.31438 3.34935 8.14021 3.40935 7.96938 3.47935C7.81521 3.54185 7.65938 3.61935 7.49938 3.66518V14.4327C7.49938 14.491 7.52021 14.5977 7.48438 14.6452C7.51271 14.6952 7.49938 14.7702 7.49938 14.8268V17.0527C7.49938 17.101 7.48438 17.181 7.50438 17.2252C7.52188 17.2652 7.60687 17.2885 7.64354 17.3077C7.78104 17.3793 7.92104 17.4468 8.06021 17.516C8.41021 17.6877 8.75771 17.8635 9.10521 18.041C9.27854 18.1293 9.45354 18.2318 9.63521 18.3027V2.83185C9.69854 2.92102 9.74437 3.02435 9.79604 3.12018C9.88937 3.29185 9.98521 3.46352 10.081 3.63518C10.3827 4.17602 10.6827 4.71852 10.9777 5.26268C11.6135 6.43602 12.2769 7.59518 12.911 8.76852C13.1402 9.19185 13.3785 9.61018 13.6085 10.0335C13.7752 10.3418 13.9394 10.6552 14.1177 10.9568H14.1327C14.2394 10.7335 14.3552 10.5135 14.4644 10.2902C14.9735 9.24518 15.5035 8.20935 16.0127 7.16352C16.1744 6.83185 16.3402 6.50185 16.5044 6.17185C16.5877 6.00602 16.6819 5.84268 16.7527 5.67185C16.621 5.67768 16.4885 5.71268 16.3594 5.73518C16.1927 5.76435 16.026 5.78518 15.8594 5.81852C15.7802 5.83435 15.6969 5.83685 15.6177 5.85435C15.5927 5.86018 15.5585 5.86102 15.5369 5.87602C15.5177 5.88935 15.5077 5.91685 15.496 5.93685C15.4685 5.98435 15.4419 6.03268 15.416 6.08102C15.3269 6.24518 15.2344 6.40852 15.1452 6.57268C14.916 6.99602 14.6802 7.41602 14.4485 7.83768L14.2477 8.20102C14.2085 8.27018 14.156 8.34435 14.1327 8.42018H14.1177C14.096 8.34435 14.0485 8.27185 14.0135 8.20102L13.8302 7.83018C13.6352 7.43852 13.4385 7.04852 13.2477 6.65602C12.7044 5.53602 12.1435 4.42268 11.5869 3.30935C11.4035 2.94352 11.2235 2.57685 11.0419 2.21102C10.9519 2.03018 10.8485 1.85268 10.771 1.66602C10.6494 1.69935 10.5294 1.76602 10.4152 1.81935C10.2527 1.89435 10.086 1.96102 9.92354 2.03435C9.51354 2.21935 9.09438 2.38268 8.68854 2.57435Z",
					fill: "#876929"
				}),
				/* @__PURE__ */ (0, Q.jsx)("path", {
					id: "Vector_2",
					d: "M9.63638 2.83286V18.3029C10.4422 17.8904 11.2572 17.4937 12.0672 17.0887C12.9605 16.6412 13.8514 16.1862 14.7472 15.7437C15.228 15.507 15.7064 15.2645 16.1864 15.0254C16.3222 14.9579 16.4605 14.892 16.5947 14.8204C16.6372 14.7987 16.718 14.7779 16.7464 14.7387C16.7572 14.7237 16.7547 14.7004 16.7547 14.6829V5.67953C16.7039 5.74036 16.6739 5.8287 16.638 5.89953C16.5714 6.03536 16.5014 6.17036 16.4355 6.30786C16.2389 6.71953 16.0322 7.12703 15.8289 7.53453C15.4555 8.2812 15.088 9.03036 14.7155 9.7762C14.5905 10.0262 14.4689 10.2762 14.3447 10.5262C14.2739 10.6662 14.1839 10.8087 14.1339 10.957H14.1189C14.078 10.8604 14.0172 10.7695 13.9664 10.677C13.883 10.5262 13.8005 10.3737 13.7164 10.2229C13.4855 9.80703 13.258 9.38953 13.0272 8.97286C12.3705 7.78953 11.7239 6.5987 11.0664 5.41453C10.7347 4.81703 10.4055 4.2187 10.078 3.61953C9.98471 3.45036 9.88971 3.28203 9.79721 3.11286L9.70555 2.9462C9.68638 2.90703 9.66805 2.86286 9.63638 2.83203V2.83286ZM5.87305 4.3162V15.062C6.27305 14.9629 6.67138 14.862 7.06888 14.757C7.17221 14.7295 7.27638 14.7037 7.37971 14.677C7.41221 14.6687 7.47138 14.6687 7.49305 14.6395C7.50388 14.6254 7.50138 14.602 7.50138 14.5845V4.73286C7.23888 4.68286 6.97888 4.60203 6.72055 4.53453C6.43971 4.45953 6.14971 4.4062 5.87305 4.3162Z",
					fill: "#D9A741"
				}),
				/* @__PURE__ */ (0, Q.jsx)("path", {
					id: "Vector_3",
					d: "M10.7715 1.66602C10.7915 1.73685 10.8348 1.80435 10.8682 1.87018C10.9282 1.99185 10.9907 2.11185 11.0498 2.23435C11.2665 2.67935 11.4915 3.12268 11.7107 3.56685C12.2423 4.64018 12.7723 5.71352 13.3082 6.78518C13.4832 7.13518 13.6557 7.48685 13.8307 7.83768C13.9265 8.03018 14.0357 8.22102 14.1182 8.42102H14.1332C14.1957 8.27685 14.2857 8.14018 14.3615 8.00435C14.484 7.78518 14.6032 7.56435 14.7248 7.34602C15.0715 6.72018 15.4165 6.09268 15.7615 5.46768C15.8965 5.22268 16.0365 4.98018 16.1657 4.73268C16.2157 4.63768 16.2848 4.54602 16.3215 4.44518C16.1632 4.34518 15.9815 4.27352 15.8148 4.18852C15.4148 3.98518 15.0115 3.78768 14.6107 3.58685C13.3307 2.94685 12.044 2.32018 10.7715 1.66602Z",
					fill: "#D9A741"
				}),
				/* @__PURE__ */ (0, Q.jsx)("path", {
					id: "Vector_4",
					d: "M5.86501 4.31641C5.78001 4.44141 5.70418 4.57391 5.62334 4.70141C5.37418 5.09807 5.12584 5.49557 4.87584 5.89141C4.38001 6.67891 3.88584 7.46641 3.39251 8.25474C3.17418 8.60307 2.95334 8.95057 2.73584 9.29891C2.67751 9.39307 2.61668 9.48474 2.55918 9.57974C2.53918 9.61141 2.50084 9.65224 2.50001 9.69141C2.49918 9.72891 2.54501 9.77724 2.56418 9.80807C2.62584 9.90641 2.68584 10.0064 2.74918 10.1039C2.97084 10.4431 3.17834 10.7922 3.39751 11.1331C3.83751 11.8189 4.26418 12.5147 4.69501 13.2064C5.08251 13.8289 5.48168 14.4439 5.86501 15.0697L5.90251 15.0614C5.88918 15.0572 5.88668 15.0581 5.87251 15.0614V4.41641C5.87251 4.38307 5.87751 4.34724 5.86418 4.31724L5.86501 4.31641Z",
					fill: "#876929"
				})
			]
		})
	})
}), gx = (e) => /* @__PURE__ */ (0, Q.jsxs)("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [
		/* @__PURE__ */ (0, Q.jsx)("path", {
			d: "M18.3327 3.33398H1.66602L9.99935 10.0007L18.3327 3.33398Z",
			fill: "#18BC9C"
		}),
		/* @__PURE__ */ (0, Q.jsx)("rect", {
			x: 1.66602,
			y: 3.33398,
			width: 16.6667,
			height: 13.3333,
			stroke: "#231F20"
		}),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			d: "M1.66602 3.33398L9.99935 10.0007",
			stroke: "#231F20"
		}),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			d: "M1.66602 16.6673L18.3327 3.33398",
			stroke: "#231F20"
		}),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			d: "M8.33203 16.668L12.4987 13.3346L14.582 11.668",
			stroke: "#231F20"
		})
	]
}), _x = ({ isDefaultConfigPresent: e, isConfigured: t, nonConfiguredClassNames: n = "" }) => /* @__PURE__ */ (0, Q.jsxs)("div", {
	className: `flex column p-12 dc__align-start dc__border-dashed br-4 bg__secondary ${n}`,
	children: [
		/* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flex dc__align-start",
			children: [
				/* @__PURE__ */ (0, Q.jsx)(hx, {
					className: "icon-dim-36 p-8 dc__border bg__primary",
					style: { borderRadius: "18px" }
				}),
				/* @__PURE__ */ (0, Q.jsx)(gx, {
					className: "icon-dim-36 p-8 dc__border bg__primary",
					style: {
						borderRadius: "18px",
						marginLeft: "-12px"
					}
				}),
				/* @__PURE__ */ (0, Q.jsx)(w, {
					className: "icon-dim-36 p-8 dc__border bg__primary scn-6",
					style: {
						borderRadius: "18px",
						marginLeft: "-12px"
					}
				})
			]
		}),
		/* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "mt-8 flex column",
			children: [/* @__PURE__ */ (0, Q.jsx)("span", {
				className: "w-100 fs-12 fw-6 lh-18",
				children: t && !e ? fr.noDefaultStateTitle : fr.notConfiguredTitle
			}), /* @__PURE__ */ (0, Q.jsx)("span", {
				className: "fs-12 fw-4 lh-18 mt-4",
				children: t && !e ? fr.noDefaultStateInfo : fr.notConfiguredInfo
			})]
		}),
		/* @__PURE__ */ (0, Q.jsx)("div", {
			className: "dc__link mt-8 dc__align-center",
			children: /* @__PURE__ */ (0, Q.jsx)(Wf, {
				to: v.NOTIFIER_CONFIG,
				target: "_blank",
				children: /* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "flex row dc__align-start ml-0",
					children: [/* @__PURE__ */ (0, Q.jsx)("span", { children: "Take me there" }), /* @__PURE__ */ (0, Q.jsx)("span", {
						className: "ml-5 mt-3 fcb-5 icon-fill-blue-imp path",
						children: /* @__PURE__ */ (0, Q.jsx)(Kn, { className: "scb-5 icon-dim-14" })
					})]
				})
			})
		})
	]
}), vx = (e) => {
	switch (e) {
		case le.CANCEL: return {
			style: P.negative,
			variant: F.secondary
		};
		case le.APPROVE: return {
			style: P.positive,
			variant: F.primary
		};
		default: return {
			style: P.default,
			variant: F.primary
		};
	}
}, yx = (e) => {
	let t = Dr[e].toLowerCase().split(" ").join("-");
	return e === le.SUBMIT ? `${t}-approval` : `submit-${t}`;
}, bx = ({ approvalRequestType: e, isLoading: t, onClick: n }) => {
	let r = yx(e), i = (t) => {
		n(t, e);
	};
	return /* @__PURE__ */ (0, Q.jsx)(M, {
		...vx(e),
		dataTestId: r,
		onClick: i,
		isLoading: t,
		text: Dr[e],
		size: I.medium
	});
}, xx = ({ configs: e, isDefaultConfigPresent: t, requestButtonProps: n, isTippyVisible: r, handleTippyClose: i, toggleTippyVisibility: a, selectedEmails: o, setSelectedEmails: s, approvalConfigData: c, envName: l, approvalRequestType: u, approvalType: d }) => {
	let f = () => /* @__PURE__ */ (0, Q.jsx)(mx, {
		selectedEmails: o,
		setSelectedEmails: s,
		approvalConfigData: c,
		approvalType: d,
		children: /* @__PURE__ */ (0, Q.jsx)(bx, {
			approvalRequestType: u,
			...n
		})
	}, Number(r)), p = () => /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flex column p-16 dc__align-start dc__border-bottom-n1",
		children: [/* @__PURE__ */ (0, Q.jsx)("div", {
			className: "flex column fs-13 fw-4",
			children: Zn[d].usersWithPermission
		}), /* @__PURE__ */ (0, Q.jsx)(_x, {
			isDefaultConfigPresent: t,
			isConfigured: e,
			nonConfiguredClassNames: "mt-12"
		})]
	}), /* @__PURE__ */ (0, Q.jsx)("div", {
		className: "flex right py-12 px-16",
		children: /* @__PURE__ */ (0, Q.jsx)(bx, {
			approvalRequestType: u,
			...n
		})
	})] }), { heading: m, additionalContent: h, infoText: g, buttonProps: _ } = (() => {
		switch (u) {
			case le.SUBMIT: return {
				heading: Fr.requestApproval.heading,
				additionalContent: e && t ? f() : p(),
				buttonProps: {
					dataTestId: "request-approval",
					text: Fr.requestApproval.label
				}
			};
			case le.APPROVE: return {
				heading: Fr.approveRequest.heading,
				infoText: `${Fr.approveRequest.infoText} ${l}?`,
				additionalContent: /* @__PURE__ */ (0, Q.jsx)("div", {
					className: "flex right pt-4 pb-16 px-16",
					children: /* @__PURE__ */ (0, Q.jsx)(bx, {
						approvalRequestType: u,
						...n
					})
				}),
				buttonProps: {
					dataTestId: "approve-approval",
					text: Fr.approveRequest.label,
					style: P.positive
				}
			};
			case le.CANCEL: return {
				heading: Fr.cancelRequest.heading,
				infoText: Fr.cancelRequest.infoText,
				additionalContent: /* @__PURE__ */ (0, Q.jsx)("div", {
					className: "flex right pt-4 pb-16 px-16",
					children: /* @__PURE__ */ (0, Q.jsx)(bx, {
						approvalRequestType: u,
						...n
					})
				}),
				buttonProps: {
					dataTestId: "cancel-approval",
					text: Fr.cancelRequest.label,
					style: P.negative
				}
			};
			default: return {};
		}
	})();
	return /* @__PURE__ */ (0, Q.jsx)(su, {
		theme: cu.white,
		className: "w-350 h-100 dc__align-left",
		placement: "auto",
		iconClass: "fcv-5",
		heading: m,
		infoText: g,
		additionalContent: h,
		showCloseButton: !0,
		onClose: i,
		trigger: "click",
		interactive: !0,
		visible: r,
		children: /* @__PURE__ */ (0, Q.jsx)("div", { children: /* @__PURE__ */ (0, Q.jsx)(M, {
			..._,
			onClick: a,
			variant: F.text
		}) })
	});
}, Sx = /* @__PURE__ */ t({ default: () => Cx }), Cx = ({ material: e, envName: t, stageType: n, appId: r, pipelineId: i, parentEnvironmentName: a, selectedApprovalTab: o, getModuleInfo: s, ciPipelineId: c, appReleaseTagNames: l, setAppReleaseTagNames: u, tagsEditable: d, setTagsEditable: f, hideImageTaggingHardDelete: p, configs: m, isDefaultConfigPresent: h, triggerType: g, nodeRequestedUserId: _, isSuperAdmin: v, closeModal: y, handleReloadOnApprovalSuccess: b, isIsolatedEnvironment: x, environmentId: S, deploymentApprovalInfo: C }) => {
	let [w, T] = j({}), [ee, E] = j(!1), [D, te] = j(!1), [ne, re] = j(/* @__PURE__ */ new Map()), [ie, ae] = j(/* @__PURE__ */ new Map()), [oe, se] = j({});
	k(() => {
		s && s(Hc.SECURITY).then((e) => {
			te(e.result?.status?.toLowerCase() === qr);
		}).catch($d);
	}, []), k(() => {
		let t = /* @__PURE__ */ new Map();
		e.forEach((e) => {
			t.set(e.id, e);
		}), ae(t);
	}, [e]);
	let ce = (e, t, n) => {
		let r = new Map(ie), i = ie.get(e);
		t && (i.imageReleaseTags = t), n && (i.imageComment = n), r.set(e, i), ae(r);
	}, ue = (e) => {
		let t = new Map(ne);
		t.set(e, !t.get(e)), re(t);
	}, de = (e) => {
		T((t) => ({
			...t,
			[e]: !t[e]
		}));
	}, fe = ({ id: e, approvalRequestId: t, noConfirmation: n }) => (a, s) => {
		E(!0);
		let c = Object.keys(oe);
		jr({
			appId: +r,
			actionType: si[s.toLowerCase()],
			pipelineId: +i,
			artifactId: +e,
			approvalRequestId: s === le.SUBMIT ? 0 : t,
			approvalNotificationConfig: { emailIds: c }
		}).then(() => {
			H.showToast({
				variant: U.success,
				description: s === le.APPROVE && g === uu.automatic ? Nr[`${s}_AUTO_CD`] : Nr[s]
			}), n || de(e), E(!1), o === Zi.APPROVAL ? y(a) : b();
		}).catch((e) => {
			K(e), E(!1);
		});
	}, pe = (e) => {
		ee || (T((t) => ({
			...t,
			[e]: !1
		})), se({}));
	}, me = (e, t) => /* @__PURE__ */ (0, Q.jsx)("div", {
		className: "flex dc__gap-12 ml-12",
		children: /* @__PURE__ */ (0, Q.jsx)(ft, {
			className: "default-tt w-200",
			arrow: !1,
			placement: "top",
			content: t,
			children: /* @__PURE__ */ (0, Q.jsx)("i", {
				className: `cr-5 fs-13 fw-4 lh-24 m-0 ${e ? "" : "cursor-not-allowed"}`,
				children: "Excluded"
			})
		})
	}), he = (e, n) => /* @__PURE__ */ (0, Q.jsx)(xx, {
		approvalRequestType: n,
		configs: m,
		isDefaultConfigPresent: h,
		requestButtonProps: {
			onClick: fe({
				id: e.id,
				approvalRequestId: e.userApprovalMetadata?.approvalRequestId
			}),
			isLoading: ee
		},
		isTippyVisible: w[e.id],
		handleTippyClose: () => pe(e.id),
		toggleTippyVisibility: () => de(e.id),
		selectedEmails: oe,
		setSelectedEmails: se,
		approvalConfigData: C?.approvalConfigData,
		envName: t,
		approvalType: ye.Image
	}), ge = (e) => {
		let t = _, n = e.userApprovalMetadata?.requestedUserData?.userId;
		return e.vulnerable ? /* @__PURE__ */ (0, Q.jsx)("span", {
			className: "material-history__scan-error",
			children: Fr.vulnerability.found
		}) : e.userApprovalMetadata?.approvalRuntimeState === _o.requested ? n !== t && e.triggeredBy === t ? e.filterState === ec.ALLOWED ? /* @__PURE__ */ (0, Q.jsx)(ft, {
			className: "default-tt w-200",
			arrow: !1,
			placement: "top",
			content: Fr.imageBuilderTippy,
			children: /* @__PURE__ */ (0, Q.jsx)("span", {
				className: "cb-5 dc__opacity-0_5 cursor-default",
				"data-testid": "builder-approve-disabled",
				children: Fr.approveRequest.label
			})
		}) : me(!1, Ws) : e.userApprovalMetadata.hasCurrentUserApproved ? e.filterState === ec.ALLOWED ? /* @__PURE__ */ (0, Q.jsx)("span", {
			className: "cg-5 cursor-default",
			"data-testid": "approved-by-you",
			children: Fr.approvedByYou
		}) : me(!0, Ws) : n && t && n === t ? /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [he(e, le.CANCEL), e.filterState !== ec.ALLOWED && /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flex dc__gap-12 ml-12",
			children: [/* @__PURE__ */ (0, Q.jsx)("div", { className: "h-20 dc__border-left" }), /* @__PURE__ */ (0, Q.jsx)(ft, {
				className: "default-tt w-200",
				arrow: !1,
				placement: "top",
				content: Ws,
				children: /* @__PURE__ */ (0, Q.jsx)("i", {
					className: "cr-5 fs-13 fw-4 lh-24 m-0",
					children: "Excluded"
				})
			})]
		})] }) : e.userApprovalMetadata.canCurrentUserApprove && n !== t ? e.filterState === ec.ALLOWED ? he(e, le.APPROVE) : me(!1, Ws) : e.filterState === ec.ALLOWED ? /* @__PURE__ */ (0, Q.jsx)("span", {
			className: "cn-5 cursor-default",
			"data-testid": "awaiting-approval",
			children: Fr.awaiting
		}) : me(!1, Ws) : e.filterState === ec.ALLOWED ? he(e, le.SUBMIT) : me(!1, Ws);
	}, _e = (e) => /* @__PURE__ */ (0, Q.jsx)(Lr, {
		requestedUserId: _,
		userApprovalMetadata: e.userApprovalMetadata,
		cancelRequest: fe({
			id: e.id,
			approvalRequestId: e.userApprovalMetadata?.approvalRequestId,
			noConfirmation: !0
		}),
		isLoading: ee,
		approvalType: ye.Image
	}), ve = (e) => {
		let { promotionApprovalMetadata: r } = e, i = r?.approvedUsersData?.map((e) => e.userEmail);
		return {
			isLatest: e.latest,
			isRunningOnParentCD: e.runningOnParentCd,
			artifactStatus: e.artifactStatus,
			environmentName: t,
			parentEnvironmentName: a,
			stageType: n,
			showLatestTag: !1,
			isVirtualEnvironment: x,
			targetPlatforms: e.targetPlatforms,
			additionalInfo: r?.promotedFromType ? /* @__PURE__ */ (0, Q.jsx)(ea, {
				promotedTo: t,
				promotedFrom: r.promotedFrom,
				promotedFromType: r.promotedFromType,
				promotedBy: r.requestedUserData?.userEmail,
				approvedBy: i,
				promotionPolicyName: r.policy?.name,
				showBackgroundColor: !0
			}) : null
		};
	}, be = (e) => ({
		imagePath: e.imagePath,
		registryName: e.registryName,
		registryType: e.registryType,
		image: e.image,
		deployedTime: null,
		deployedBy: e.deployedBy,
		isRollbackTrigger: !1,
		excludedImagePathNode: e.filterState === ec.ALLOWED ? null : /* @__PURE__ */ (0, Q.jsx)(Js, { image: e.image }),
		approvalChecksNode: o === Zi.PENDING ? _e(e) : null
	}), xe = (e) => ({
		ciPipelineId: c,
		artifactId: +e.id,
		imageComment: ie.get(+e.id)?.imageComment,
		imageReleaseTags: ie.get(+e.id)?.imageReleaseTags,
		appReleaseTagNames: l,
		setAppReleaseTagNames: u,
		tagsEditable: d,
		toggleCardMode: ue,
		setTagsEditable: f,
		hideHardDelete: p,
		updateCurrentAppMaterial: ce,
		isSuperAdmin: v,
		forceReInit: !0
	});
	return /* @__PURE__ */ (0, Q.jsx)(Q.Fragment, { children: e.map((e) => {
		let t = fd(e.materialInfo), n = !ne.get(+e.id);
		return /* @__PURE__ */ (0, Q.jsx)(_c, {
			testIdLocator: String(e.index),
			cta: ge(e),
			sequentialCDCardTitleProps: ve(e),
			artifactInfoProps: be(e),
			imageTagContainerProps: xe(e),
			children: e.materialInfo.length > 0 && n && t && /* @__PURE__ */ (0, Q.jsx)(vc, {
				environmentId: S,
				isSecurityModuleInstalled: D,
				artifactId: +e.id,
				applicationId: r,
				changesCard: /* @__PURE__ */ (0, Q.jsx)(Rr, { materialInformationList: e.materialInfo }),
				isScanned: e.scanned,
				isScanEnabled: e.scanEnabled,
				SecurityModalSidebar: _i
			})
		}, `material-history-${e.index}`);
	}) });
}, wx = "data:image/svg+xml,%3c!--%20-%20Copyright%20(c)%202024.%20Devtron%20Inc.%20--%3e%3csvg%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%3e%3cdefs%3e%3cpath%20id='ic-close-lib'%20class='stroke-color'%20d='M18.295%205.705a.997.997%200%200%200-1.41%200L12%2010.59%207.115%205.705a.997.997%200%201%200-1.41%201.41L10.59%2012l-4.885%204.885a.997.997%200%201%200%201.41%201.41L12%2013.41l4.885%204.885a.997.997%200%200%200%201.41-1.41L13.41%2012l4.885-4.885a.997.997%200%200%200%200-1.41z'/%3e%3c/defs%3e%3cg%20fill='none'%20fill-rule='evenodd'%3e%3cpath%20d=''/%3e%3cuse%20fill='%23999'%20xlink:href='%23ic-close-lib'/%3e%3c/g%3e%3c/svg%3e", Tx = (e) => /* @__PURE__ */ (0, Q.jsxs)("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	...e,
	children: [/* @__PURE__ */ (0, Q.jsx)("path", {
		d: "M15.334 4.66699C15.334 5.77156 14.4386 6.66699 13.334 6.66699C12.2294 6.66699 11.334 5.77156 11.334 4.66699C11.334 3.56242 12.2294 2.66699 13.334 2.66699C14.4386 2.66699 15.334 3.56242 15.334 4.66699Z",
		fill: "#F33E3E"
	}), /* @__PURE__ */ (0, Q.jsx)("path", {
		d: "M4.00065 8H10.6673M1.33398 5L9.33398 5M6.50065 11H9.50065",
		stroke: "#596168",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
}), Ex = /* @__PURE__ */ t({ default: () => Dx });
function Dx({ tabs: e, initialTab: t = e?.[0].value, onChange: n, handleEnableFiltersView: r }) {
	return /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox dc__align-items-center dc__gap-8",
		children: [/* @__PURE__ */ (0, Q.jsx)(ft, {
			content: mn,
			placement: "top",
			arrow: !1,
			className: "default-tt",
			children: /* @__PURE__ */ (0, Q.jsx)("button", {
				type: "button",
				onClick: r,
				className: "h-24 dc__no-background dc__no-border dc__outline-none-imp flex",
				children: /* @__PURE__ */ (0, Q.jsx)(Tx, { className: "icon-dim-16" })
			})
		}), /* @__PURE__ */ (0, Q.jsx)(Bl, {
			segments: e,
			value: t,
			onChange: n,
			name: "filter-action-bar-segmented-control"
		})]
	});
}
//#endregion
//#region src/Components/ApprovalNode/ApprovalImageEmptyState.tsx
function Ox({ title: e, actionHandler: t }) {
	return /* @__PURE__ */ (0, Q.jsx)(oc, {
		title: e,
		handleClearFilters: t
	});
}
//#endregion
//#region src/Components/ApprovalNode/ApprovalMaterialModal.utils.tsx
var kx = (e, t) => (e.current.abort(), e.current = new AbortController(), t()), Ax = ({ deploymentApprovalInfo: e, approvalType: t }) => {
	let n = gr(e), { eligibleApprovers: { specificUsers: r, anyUsers: i, userGroups: a } } = e, o = A(() => ({
		currentCount: null,
		requiredCount: null,
		kind: null,
		anyUserApprovedInfo: {
			...i,
			currentCount: null,
			requiredCount: null
		},
		specificUsersApprovedInfo: {
			...r,
			currentCount: null,
			requiredCount: null
		},
		userGroupsApprovedInfo: {
			currentCount: null,
			requiredCount: null,
			userGroups: a.map((e) => ({
				...e,
				currentCount: null,
				requiredCount: null
			}))
		},
		isExceptionUser: null
	}), [e]);
	return n === 0 ? /* @__PURE__ */ (0, Q.jsx)("div", {
		className: "h-100 mxh-210 dc__overflow-auto dc__align-left flexbox-col dc__gap-12 p-12",
		children: /* @__PURE__ */ (0, Q.jsx)(lc, {
			title: "No eligible approvers found",
			subTitle: "",
			description: "",
			useInfoIcon: !0
		})
	}) : /* @__PURE__ */ (0, Q.jsx)("div", {
		className: "h-100 mxh-210 dc__overflow-auto dc__align-left flexbox-col",
		children: /* @__PURE__ */ (0, Q.jsx)("div", {
			className: "p-12",
			children: /* @__PURE__ */ (0, Q.jsx)(Yr, {
				approvalConfigData: o,
				showApprovalCountBadge: !1,
				showUserApprovalStatus: !1,
				approvalType: t
			})
		})
	});
}, jx = ({ deploymentApprovalInfo: e }) => {
	let t = e.approvalConfigData.requiredCount;
	return /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox dc__gap-4",
		children: [/* @__PURE__ */ (0, Q.jsx)("span", {
			className: "cn-9 fs-13 fw-4 lh-20",
			children: t === 1 ? `${t} approval is required.` : `${t} approvals are required.`
		}), /* @__PURE__ */ (0, Q.jsx)(su, {
			theme: cu.white,
			className: "w-300 h-100",
			placement: "bottom",
			Icon: Tt,
			iconClass: "fcv-5 dc__no-shrink",
			heading: "Eligible approvers",
			additionalContent: /* @__PURE__ */ (0, Q.jsx)(Ax, {
				deploymentApprovalInfo: e,
				approvalType: ye.Image
			}),
			showCloseButton: !0,
			trigger: "click",
			interactive: !0,
			children: /* @__PURE__ */ (0, Q.jsx)("button", {
				type: "button",
				className: "dc__transparent p-0 cn-9 fs-13 fw-6 lh-20 dc__underline",
				"data-testid": "show-eligible-approver-tippy",
				children: "Eligible approvers"
			})
		})]
	});
}, Mx = /* @__PURE__ */ t({ default: () => Nx }), Nx = ({ node: e, materialType: t, stageType: n, closeApprovalModal: r, appId: i, pipelineId: a, getModuleInfo: o, ciPipelineId: s }) => {
	let c = X(), { searchParams: l } = jf(), { isSuperAdmin: u } = Cf(), d = l.search, f = l["approval-state"] || Zi.APPROVAL, [p, m] = j(d), [h, g] = j(d?.length > 0), [_, v] = j([]), [y, b] = j([]), [x, S] = j([]), [C, w] = j([]), [T, ee] = j(!1), [E, D] = j(!1), [te, ne] = j(ze.ELIGIBLE), [re, ie] = j(!1), [ae, oe] = j([]), [se, ce] = j(!1), [le, ue] = j(!1), [de, fe] = j(!1), [pe, me] = j(!1), [he, ge] = j({
		configs: !1,
		isDefaultConfigPresent: !1
	}), _e = Ja(new AbortController()), ve = Ja(new AbortController()), [ye, be, xe, Se] = hf(() => kx(_e, () => Wu(Po.CD_MATERIALS, a, Ds.APPROVAL, _e.current.signal, {
		offset: 0,
		size: 20,
		search: d
	})), [
		a,
		n,
		t,
		d
	], !!a), [Ce, we, Te, O] = hf(() => kx(ve, () => Wu(Po.CD_MATERIALS, a, Ds.APPROVAL, ve.current.signal, {
		offset: 0,
		size: 20,
		search: d,
		resource: No.PENDING_APPROVAL
	})), [
		a,
		n,
		t,
		d
	], !!a), Ee = async () => {
		fe(!0);
		try {
			let [{ result: e }] = await Promise.all([td()]);
			ge({
				...he,
				configs: e.isConfigured,
				isDefaultConfigPresent: e.is_default_configured
			});
		} finally {
			fe(!1);
		}
	};
	k(() => {
		Ee();
	}, []);
	let De = f === Zi.APPROVAL ? be?.resourceFilters : we?.resourceFilters, Oe = f === Zi.APPROVAL ? be?.hideImageTaggingHardDelete ?? !1 : we?.hideImageTaggingHardDelete ?? !1, ke = f === Zi.APPROVAL ? be?.requestedUserId : we?.requestedUserId, Ae = f === Zi.APPROVAL ? be?.deploymentApprovalInfo : we?.deploymentApprovalInfo;
	k(() => {
		!ye && be && (w(be.materials), ie(be.tagsEditable), oe(be.appReleaseTagNames), ue(be.materials.length >= be.totalCount), be.resourceFilters?.length && !h ? (ne(ze.ELIGIBLE), b(be.materials.filter((e) => e.filterState === ec.ALLOWED))) : b(be.materials));
	}, [be, ye]), k(() => {
		!Ce && we && (S(we.materials), ie(we.tagsEditable), oe(we.appReleaseTagNames), ce(we.materials.length >= we.totalCount), we.resourceFilters?.length && !h ? (ne(ze.ELIGIBLE), v(we.materials.filter((e) => e.filterState === ec.ALLOWED))) : v(we.materials));
	}, [we, Ce]);
	let je = () => /* @__PURE__ */ (0, Q.jsxs)("div", {
		"data-testid": "approval-for-deployment-heading",
		className: "trigger-modal__header dc__no-border pb-12 cn-9",
		children: [/* @__PURE__ */ (0, Q.jsxs)("h1", {
			className: "modal__title",
			children: [
				oa.heading,
				"\xA0",
				/* @__PURE__ */ (0, Q.jsx)("span", {
					className: "fw-6",
					children: e.environmentName || ""
				})
			]
		}), /* @__PURE__ */ (0, Q.jsx)("button", {
			"data-testid": "close-approval-node-box",
			type: "button",
			className: "dc__transparent",
			onClick: r,
			children: /* @__PURE__ */ (0, Q.jsx)("img", {
				alt: "close",
				src: wx
			})
		})]
	}), Me = () => {
		O();
	}, Ne = (e) => {
		if (e !== f) {
			me(!1), e === Zi.APPROVAL ? Se() : O(), g(!1), ee(!1), m("");
			let t = {
				...l,
				[di]: e
			};
			delete t.search, c({ search: new URLSearchParams(t).toString() });
		}
	}, Pe = () => {
		let e = !!x?.filter((e) => e.filterState === ec.ALLOWED).length;
		return /* @__PURE__ */ (0, Q.jsx)("div", {
			className: "pl-20 dc__border-bottom",
			children: /* @__PURE__ */ (0, Q.jsx)(nu, {
				tabs: [{
					id: "all-images-tab",
					label: oa.tab.first,
					tabType: "button",
					props: {
						onClick: () => Ne(Zi.APPROVAL),
						"data-testid": "all-images-tab",
						"data-selected-tab": 0
					},
					active: f === Zi.APPROVAL
				}, {
					id: "approval-requested-tab",
					label: oa.tab.second,
					tabType: "button",
					props: {
						onClick: () => Ne(Zi.PENDING),
						"data-testid": "approval-requested-tab",
						"data-selected-tab": 1
					},
					active: f === Zi.PENDING,
					showIndicator: e
				}],
				hideTopPadding: !0
			})
		});
	}, Fe = (e) => {
		m(e), g(e.length > 0);
		let t = {
			...l,
			search: e
		};
		e || delete t.search, c({ search: new URLSearchParams(t).toString() });
	}, Ie = () => {
		g(!1), v(x), b(C), m("");
		let e = { ...l };
		delete e.search, c({ search: new URLSearchParams(e).toString() });
	}, Le = () => {
		f === Zi.APPROVAL ? Se() : O(), h && ee(!1);
	}, Re = () => {
		ee(!0);
	}, Be = (e, t) => [{
		label: `Eligible images ${e}/${t}`,
		value: ze.ELIGIBLE
	}, {
		label: `Latest ${t} images`,
		value: ze.ALL
	}], Ve = () => {
		D(!0);
	}, He = () => {
		D(!1);
	}, Ue = (e) => {
		if (De?.length) {
			if (f === Zi.APPROVAL) {
				let t = C.filter((e) => e.filterState === ec.ALLOWED);
				b(e === ze.ELIGIBLE ? t : C);
				return;
			}
			let t = x.filter((e) => e.filterState === ec.ALLOWED);
			v(e === ze.ELIGIBLE ? t : x);
		}
	}, We = (e) => {
		uf(e), ne(ze.ALL), Ue(ze.ALL);
	}, Ge = (e) => {
		let { value: t } = e;
		ne(t), Ue(t);
	}, Ke = () => f === Zi.APPROVAL ? C.filter((e) => e.filterState === ec.ALLOWED).length : x.filter((e) => e.filterState === ec.ALLOWED).length, qe = () => {
		if (!pe) {
			me(!0);
			let e = f === Zi.APPROVAL ? C.length : x.length;
			f === Zi.APPROVAL ? (_e.current.abort(), _e.current = new AbortController()) : (ve.current.abort(), ve.current = new AbortController()), Wu(Po.CD_MATERIALS, a, Ds.APPROVAL, f === Zi.APPROVAL ? _e.current.signal : ve.current.signal, {
				offset: e,
				size: 20,
				search: d,
				resource: f === Zi.PENDING ? No.PENDING_APPROVAL : null
			}).then((e) => {
				if (e) {
					let t = [...e.materials], n = (f === Zi.APPROVAL ? C : x).concat(t), r = n.filter((e) => e.filterState === ec.ALLOWED), i = De?.length && !h && te === ze.ELIGIBLE;
					f === Zi.APPROVAL ? (w(n), b(i ? r : n), ue(n.length >= e.totalCount)) : (S(n), v(i ? r : n), ce(n.length >= e.totalCount));
					let a = `Fetched ${e.materials.length} images.`;
					if (De?.length && !h) {
						let t = e.materials.filter((e) => e.filterState === ec.ALLOWED).length, n = t === 0 ? "No new eligible images found." : `${t} new eligible images found.`;
						te === ze.ELIGIBLE ? H.showToast({
							variant: U.info,
							description: `${a} ${n}`
						}) : H.showToast({
							variant: U.success,
							description: `${a} ${n}`
						});
					} else H.showToast({
						variant: U.success,
						description: a
					});
				}
			}).catch((e) => {
				K(e);
			}).finally(() => {
				me(!1);
			});
		}
	}, Je = () => {
		let e = f === Zi.PENDING ? x.length : C.length, t = Ke();
		return De?.length && !E && !h ? /* @__PURE__ */ (0, Q.jsx)(Dx, {
			tabs: Be(t, e),
			onChange: Ge,
			handleEnableFiltersView: Ve,
			initialTab: te
		}) : f === Zi.APPROVAL ? "Request approval for an image to deploy or rollback to" : Ae ? /* @__PURE__ */ (0, Q.jsx)(jx, { deploymentApprovalInfo: Ae }) : null;
	}, Ye = () => /* @__PURE__ */ (0, Q.jsx)(M, {
		dataTestId: "fetch-more-images",
		text: "Fetch more images",
		onClick: qe,
		disabled: pe,
		isLoading: pe,
		fullWidth: !0,
		variant: F.secondary
	}), Xe = () => {
		let e = f === Zi.APPROVAL ? C.length : x.length;
		return /* @__PURE__ */ (0, Q.jsxs)("p", {
			className: "m-0 flex cn-8 fs-13 fw-4 lh-20",
			children: [
				/* @__PURE__ */ (0, Q.jsx)("button", {
					className: "dc__no-background p-0 dc__outline-none-imp dc__no-border dc__border-bottom-imp mr-4",
					type: "button",
					onClick: Ve,
					children: "Filter"
				}),
				"is applied on",
				/* @__PURE__ */ (0, Q.jsx)("button", {
					className: "dc__no-background p-0 dc__outline-none-imp dc__no-border dc__border-bottom-imp ml-4 mb-neg-1",
					type: "button",
					onClick: We,
					children: ` latest ${e} images`
				})
			]
		});
	}, Ze = (e) => e ? /* @__PURE__ */ (0, Q.jsx)(R, {
		image: Zf,
		title: pi.noEligibleImages.title,
		subTitle: Xe(),
		isButtonAvailable: !(f === Zi.APPROVAL && le || f === Zi.PENDING && se),
		renderButton: Ye
	}) : /* @__PURE__ */ (0, Q.jsx)(Ox, { actionHandler: Ie }), Qe = () => /* @__PURE__ */ (0, Q.jsx)("div", {
		className: "w-100 flexbox-col pb-24",
		children: (f === Zi.APPROVAL ? !le && !!y?.length : !se && !!_?.length) && /* @__PURE__ */ (0, Q.jsx)(Br, {
			isLoading: pe,
			handleFetchMoreData: qe
		})
	});
	return f === Zi.APPROVAL && (ye || xe?.code === 0) || f === Zi.PENDING && (Ce || Te?.code === 0) ? /* @__PURE__ */ (0, Q.jsx)(xu, {
		className: "",
		parentClassName: "dc__overflow-hidden",
		close: r,
		children: /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "modal-body--cd-material h-100 contains-diff-view",
			onClick: uf,
			children: [
				je(),
				Pe(),
				/* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "flexbox-col dc__gap-12 dc__align-items-center h-100 w-100 pl-20 pr-20",
					children: [
						/* @__PURE__ */ (0, Q.jsx)("div", {
							className: "flexbox dc__align-items-center dc__content-space pt-20 pb-16 w-100",
							children: /* @__PURE__ */ (0, Q.jsx)("div", {
								className: "shimmer-loading",
								style: {
									width: "100px",
									height: "20px"
								}
							})
						}),
						/* @__PURE__ */ (0, Q.jsx)("div", {
							className: "shimmer-loading w-100",
							style: { height: "150px" }
						}),
						/* @__PURE__ */ (0, Q.jsx)("div", {
							className: "shimmer-loading w-100",
							style: { height: "150px" }
						}),
						/* @__PURE__ */ (0, Q.jsx)("div", {
							className: "shimmer-loading w-100",
							style: { height: "150px" }
						}),
						/* @__PURE__ */ (0, Q.jsx)("div", {
							className: "shimmer-loading w-100",
							style: { height: "150px" }
						})
					]
				})
			]
		})
	}) : f === Zi.APPROVAL && xe || f === Zi.PENDING && Te ? (K(f === Zi.APPROVAL ? xe : Te), /* @__PURE__ */ (0, Q.jsx)(xu, {
		className: "",
		parentClassName: "dc__overflow-hidden",
		close: r,
		children: /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "modal-body--cd-material h-100 contains-diff-view",
			onClick: uf,
			children: [
				je(),
				Pe(),
				/* @__PURE__ */ (0, Q.jsx)(Sl, { reload: f === Zi.APPROVAL ? Se : O })
			]
		})
	})) : /* @__PURE__ */ (0, Q.jsx)(xu, {
		className: "",
		parentClassName: "dc__overflow-hidden",
		close: r,
		children: E && De?.length ? /* @__PURE__ */ (0, Q.jsx)("div", {
			className: "modal-body--cd-material h-100 contains-diff-view",
			onClick: uf,
			children: /* @__PURE__ */ (0, Q.jsx)(Xi, {
				isFromBulkCD: !1,
				resourceFilters: De,
				handleDisableFiltersView: He,
				envName: e.environmentName,
				closeModal: r
			})
		}) : /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "modal-body--cd-material h-100 contains-diff-view flexbox-col",
			onClick: uf,
			children: [
				je(),
				Pe(),
				de ? /* @__PURE__ */ (0, Q.jsx)(ul, {
					size: 32,
					fillColor: "var(--N500)"
				}) : h || (f === Zi.PENDING ? x.length > 0 : C.length > 0) ? (() => {
					let t = f === Zi.PENDING && _.length === 0 || f === Zi.APPROVAL && y.length === 0, c = De?.length && t && !h;
					return /* @__PURE__ */ (0, Q.jsxs)("div", {
						className: "trigger-modal__body flex-grow-1 dc__overflow-auto",
						children: [
							/* @__PURE__ */ (0, Q.jsxs)("div", {
								className: "flex dc__align-center dc__content-space material-list__title pb-16",
								children: [/* @__PURE__ */ (0, Q.jsx)("div", {
									className: "flex dc__align-start",
									children: Je()
								}), /* @__PURE__ */ (0, Q.jsxs)("div", {
									className: "h-32 flex dc__content-end dc__align-center dc__column-gap-8",
									children: [/* @__PURE__ */ (0, Q.jsx)("div", {
										className: `flex dc__align-center dc__position-rel margin-right-0 ${T || h ? "" : "w-28 mt-4"} h-32 cursor-text mr-8`,
										children: T || h ? /* @__PURE__ */ (0, Q.jsx)(Il, {
											initialSearchText: p,
											handleEnter: Fe,
											inputProps: {
												placeholder: "Search image tag",
												autoFocus: !0
											},
											dataTestId: "Search-by-approver-name"
										}) : /* @__PURE__ */ (0, Q.jsx)("div", {
											className: "cursor",
											onClick: Re,
											children: /* @__PURE__ */ (0, Q.jsx)(Nn, { className: "search__icon icon-dim-18 icon-color-n6" })
										})
									}), /* @__PURE__ */ (0, Q.jsx)("button", {
										className: "pb-0 pl-0 pr-0 flexbox dc__content-end dc__align-center dc__outline-none-imp dc__no-background dc__no-border",
										onClick: Le,
										type: "button",
										"aria-label": "Refetch images",
										children: /* @__PURE__ */ (0, Q.jsx)(Wr, { className: "icon-dim-16 scn-6 cursor" })
									})]
								})]
							}),
							t ? Ze(c) : /* @__PURE__ */ (0, Q.jsx)(Cx, {
								material: f === Zi.PENDING ? _ : y,
								envName: e.environmentName,
								stageType: n,
								appId: i,
								pipelineId: a,
								parentEnvironmentName: e.parentEnvironmentName,
								selectedApprovalTab: f,
								getModuleInfo: o,
								ciPipelineId: s,
								appReleaseTagNames: ae,
								setAppReleaseTagNames: oe,
								tagsEditable: re,
								setTagsEditable: ie,
								configs: he.configs,
								isDefaultConfigPresent: he.isDefaultConfigPresent,
								hideImageTaggingHardDelete: Oe,
								triggerType: e?.triggerType,
								nodeRequestedUserId: ke,
								isSuperAdmin: u,
								closeModal: r,
								handleReloadOnApprovalSuccess: Me,
								isIsolatedEnvironment: e.isVirtualEnvironment,
								environmentId: e.environmentId,
								deploymentApprovalInfo: Ae
							}),
							Qe()
						]
					});
				})() : f === Zi.APPROVAL ? /* @__PURE__ */ (0, Q.jsx)(R, {
					image: Zf,
					title: pi.noImage.title,
					subTitle: pi.noImage.subTitle,
					isButtonAvailable: !1
				}) : /* @__PURE__ */ (0, Q.jsx)(R, {
					image: ip,
					title: pi.noPendingImages.title,
					subTitle: pi.noPendingImages.subTitle,
					isButtonAvailable: !0,
					renderButton: () => /* @__PURE__ */ (0, Q.jsx)("button", {
						className: "cta ghosted flex h-36",
						"data-selected-tab": "0",
						type: "button",
						onClick: () => Ne(Zi.APPROVAL),
						children: pi.noPendingImages.label
					})
				})
			]
		})
	});
}, Px = ({ approvalConfigData: e, approvalType: t }) => e.requiredCount ? /* @__PURE__ */ (0, Q.jsx)("div", {
	className: "h-100 mxh-210 dc__overflow-auto dc__align-left p-12",
	children: /* @__PURE__ */ (0, Q.jsx)(Yr, {
		approvalConfigData: e,
		showUserApprovalStatus: !1,
		approvalType: t
	})
}) : /* @__PURE__ */ (0, Q.jsx)("div", {
	className: "h-100 mxh-210 dc__overflow-auto dc__align-left flexbox-col dc__gap-12 p-12",
	children: /* @__PURE__ */ (0, Q.jsx)(lc, {
		useInfoIcon: !0,
		title: "Approval policy not configured",
		subTitle: "",
		description: ""
	})
}), Fx = ({ children: e, pipelineId: t, onClose: n, visible: r, appendTo: i, approvalType: a }) => {
	let [o, s, c, l] = hf(() => Tr(t), [t]), u = A(() => s ? {
		...s,
		currentCount: null,
		anyUserApprovedInfo: {
			...s.anyUserApprovedInfo,
			currentCount: null
		},
		specificUsersApprovedInfo: {
			...s.specificUsersApprovedInfo,
			currentCount: null
		},
		userGroupsApprovedInfo: {
			...s.userGroupsApprovedInfo,
			currentCount: null,
			userGroups: s.userGroupsApprovedInfo.userGroups.map((e) => ({
				...e,
				currentCount: null
			}))
		}
	} : null, [s]);
	return /* @__PURE__ */ (0, Q.jsx)(su, {
		theme: cu.white,
		className: "default-tt w-300 h-100",
		placement: "bottom",
		Icon: vr,
		iconClass: "icon-stroke-n7 dc__no-shrink",
		heading: `${o || c ? "--" : u.requiredCount} approvals required`,
		additionalContent: o ? [
			"90",
			"70",
			"50"
		].map((e) => /* @__PURE__ */ (0, Q.jsx)("div", {
			className: `p-8 h-32 w-${e}`,
			children: /* @__PURE__ */ (0, Q.jsx)("div", { className: "shimmer-loading w-100 h-100" })
		}, e)) : c ? /* @__PURE__ */ (0, Q.jsx)(lc, { reload: l }) : /* @__PURE__ */ (0, Q.jsx)(Px, {
			approvalConfigData: u,
			approvalType: a
		}),
		showCloseButton: !0,
		onClose: n,
		interactive: !0,
		visible: r,
		appendTo: i,
		children: e
	});
}, Ix = /* @__PURE__ */ t({ default: () => Lx }), Lx = ({ edges: e, startNode: t, endNode: n, onClickEdge: r, addCDButtons: i, handleCDSelect: a, workflowId: o, ciPipelineId: s, isWebhookCD: c, isParallelEdge: l, leftTooltipContent: u, showApprovalConfigInfoTippy: d = !1, isTemplateView: f }) => {
	let [p, m] = j(!1), h = e.some((e) => dd(e.endNode.approvalConfigData)), g = dd(n.approvalConfigData), _ = () => {
		m((e) => !e);
	}, v = () => {
		let e = t.x + t.width, r = t.y + t.height / 2, i = n.x, a = n.y + t.height / 2;
		return {
			lineStartX: e,
			lineStartY: r,
			lineEndX: i,
			lineEndY: a,
			midPointX: (e + i) / 2,
			midPointY: (r + a) / 2
		};
	}, y = () => {
		let { lineStartX: e, lineStartY: t, lineEndX: n, lineEndY: r, midPointX: i, midPointY: a } = v();
		return e > n ? `M${e} ${t} H ${e + 15} V ${a} H${n - 15} V ${r} H ${n}` : t === r ? `M${e} ${t} L ${n} ${r}` : `M${e} ${t} H ${h ? i - 14 : i} V ${r} H ${n}`;
	}, b = (e, t, n) => {
		let r = {
			x: (n ? 10 : -10) + (e.x + t.x) / 2,
			y: e.y
		}, i = {
			x: n ? r.x - 10 : r.x + 10,
			y: e.y
		}, a = {
			x: n ? i.x - 10 : i.x + 10,
			y: e.y
		}, o = {
			x: a.x,
			y: e.y - 10
		}, s = {
			x: a.x,
			y: e.y + 10
		};
		return {
			pathD: `M${r.x} ${r.y} L ${o.x} ${o.y} L ${i.x} ${i.y} L ${s.x} ${s.y} Z`,
			pointX: o.x,
			pointY: o.y
		};
	}, x = () => {
		let { lineStartX: e, lineStartY: t, lineEndX: n, lineEndY: r, midPointX: i, midPointY: a } = v();
		return e > n ? b({
			x: i,
			y: a
		}, {
			x: e,
			y: r
		}, e < n) : b({
			x: i,
			y: r
		}, {
			x: n,
			y: t
		}, e < n);
	}, S = (e) => {
		Bd({
			position: e,
			handleCDSelect: a,
			startNode: t,
			endNode: n,
			workflowId: o,
			ciPipelineId: s,
			isWebhookCD: c,
			isParallelEdge: l
		});
	}, C = x();
	return /* @__PURE__ */ (0, Q.jsxs)("g", {
		className: "edge-group",
		children: [/* @__PURE__ */ (0, Q.jsx)("path", {
			className: "color-path",
			d: y(),
			fill: "transparent",
			stroke: ca.strokeSolid,
			strokeWidth: 2
		}), g && !i?.length ? ((e) => d && p && !f ? /* @__PURE__ */ (0, Q.jsx)(Fx, {
			pipelineId: +n.id,
			onClose: _,
			visible: d && p,
			appendTo: document.getElementById(Ql.WORKFLOW_EDITOR_CONTAINER),
			approvalType: ye.Image,
			children: e
		}) : /* @__PURE__ */ (0, Q.jsx)(W, {
			alwaysShowTippyOnHover: !0,
			content: "Approvals required for image deployment",
			children: e
		}))(/* @__PURE__ */ (0, Q.jsxs)("g", {
			style: { transform: `translate(${C.pointX - 13}px, ${C.pointY - 7}px)` },
			onClick: d ? _ : r,
			"data-testid": "approval-node-button",
			className: "dc__outline-none-imp cursor",
			width: "32",
			height: "32",
			children: [/* @__PURE__ */ (0, Q.jsx)("rect", {
				x: "0.5",
				y: "0.5",
				width: "31",
				height: "31",
				rx: "7.5",
				stroke: "var(--N200)",
				fill: "var(--bg-primary)"
			}), /* @__PURE__ */ (0, Q.jsx)("path", {
				d: "M10.6667 22.6663H21.3333M11.3333 19.9997H20.6667C21.0349 19.9997 21.3333 19.7012 21.3333 19.333V17.333C21.3333 16.9648 21.0349 16.6663 20.6667 16.6663H11.3333C10.9651 16.6663 10.6667 16.9648 10.6667 17.333V19.333C10.6667 19.7012 10.9651 19.9997 11.3333 19.9997ZM17 16.6663L18.2965 10.9618C18.4861 10.1275 17.8519 9.33301 16.9963 9.33301H15.0037C14.1481 9.33301 13.5139 10.1275 13.7035 10.9618L15 16.6663H17Z",
				stroke: "var(--V500)",
				fill: "var(--bg-primary)",
				strokeWidth: "1.5",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})]
		})) : /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [
			!i?.length && /* @__PURE__ */ (0, Q.jsx)("path", {
				d: C.pathD,
				fill: ca.arrowColor
			}),
			/* @__PURE__ */ (0, Q.jsx)(so, {
				position: co.LEFT,
				addCDButtons: i,
				endNode: n,
				startNode: t,
				handleAddCD: S,
				tooltipContent: u
			}),
			/* @__PURE__ */ (0, Q.jsx)(so, {
				position: co.RIGHT,
				addCDButtons: i,
				endNode: n,
				startNode: t,
				handleAddCD: S
			})
		] })]
	});
}, Rx = /* @__PURE__ */ t({ default: () => zx });
function zx({ viewAllImages: e }) {
	return /* @__PURE__ */ (0, Q.jsxs)("span", { children: ["Not finding the image you’re looking for? Images will be available here for deployment after approval.\xA0", /* @__PURE__ */ (0, Q.jsx)("span", {
		className: "cb-5 cursor",
		onClick: e,
		children: "View images for approval"
	})] });
}
//#endregion
//#region src/Components/ApprovalNode/ExpireApproval.tsx
var Bx = /* @__PURE__ */ t({ default: () => Vx }), Vx = ({ matId: e, appId: t, pipelineId: n, userApprovalMetadata: r, reloadMaterials: i }) => {
	let [a, o] = j(!1);
	return /* @__PURE__ */ (0, Q.jsx)(su, {
		theme: cu.white,
		className: "w-300 h-100 dc__align-left",
		placement: "bottom-end",
		iconClass: "fcv-5",
		heading: "Expire approval",
		infoText: "Are you sure you want to expire the deployment approval for this image? A new approval request would need to be raised if you want to deploy this image.",
		additionalContent: /* @__PURE__ */ (0, Q.jsx)("div", {
			className: "flex right px-16 pb-16 pt-4",
			children: /* @__PURE__ */ (0, Q.jsx)(M, {
				text: "Expire approval",
				dataTestId: `expire-approval-${e}`,
				"data-request-id": r?.approvalRequestId,
				"data-id": e,
				onClick: (e) => {
					e.stopPropagation(), o(!0), jr({
						appId: t,
						actionType: si.cancel,
						pipelineId: +n,
						artifactId: +e.currentTarget.dataset.id,
						approvalRequestId: +e.currentTarget.dataset.requestId
					}).then(() => {
						H.showToast({
							variant: U.success,
							description: "Image approval expired"
						}), i?.();
					}).catch((e) => {
						K(e);
					}).finally(() => {
						o(!1);
					});
				},
				isLoading: a,
				variant: F.secondary,
				style: P.negative,
				size: I.medium
			})
		}),
		showCloseButton: !0,
		trigger: "click",
		interactive: !0,
		children: /* @__PURE__ */ (0, Q.jsx)("span", {
			className: "mr-16 cr-5 cursor",
			"data-id": e,
			children: "Expire approval"
		})
	});
}, Hx = ({ draftId: e, draftVersionId: t, resourceName: n, envName: r, reload: i, children: a, onClose: o, handleLockConfigError: s }) => {
	let [c, l] = j(!1);
	return /* @__PURE__ */ (0, Q.jsx)(su, {
		theme: cu.white,
		placement: "top-end",
		heading: "Approve changes",
		infoText: `Are you sure you want to approve changes${n ? ` to the ${n}` : ""}${r ? ` for ${r}` : ""}?`,
		showCloseButton: !0,
		additionalContent: /* @__PURE__ */ (0, Q.jsx)("div", {
			className: "flex right pt-4 px-16 pb-16",
			children: /* @__PURE__ */ (0, Q.jsx)(M, {
				text: "Approve",
				onClick: () => {
					l(!0), Ei(e, t).then(() => {
						i(), H.showToast({
							variant: U.success,
							description: "You have successfully approved the changes"
						});
					}).catch((e) => {
						e.code === eo.UNPROCESSABLE_ENTITY && s?.(), Xr(e);
					}).finally(() => {
						l(!1);
					});
				},
				dataTestId: "approve-changes-confirm-button",
				isLoading: c,
				style: P.positive,
				size: I.medium
			})
		}),
		interactive: !0,
		className: "w-300",
		...n === "deployment template" ? {
			showOnCreate: !0,
			trigger: "manual"
		} : { trigger: "click" },
		onClose: o,
		children: /* @__PURE__ */ (0, Q.jsx)("div", { children: a })
	});
}, Ux = ({ value: e, onChange: t }) => /* @__PURE__ */ (0, Q.jsx)(vl, {
	className: "approval-action-type__radio-group flex left column",
	value: e,
	name: "delete-action-type",
	onChange: t,
	children: Object.keys(Sr).filter((e) => e !== Sr.Draft).map((e) => /* @__PURE__ */ (0, Q.jsx)(yl, {
		dataTestId: `${e}-type`,
		value: Sr[e],
		children: /* @__PURE__ */ (0, Q.jsxs)("span", {
			className: "flexbox-col dc__no-text-transform",
			children: [/* @__PURE__ */ (0, Q.jsx)("span", {
				className: "cn-9 fs-13 lh-20",
				children: _r[e].label
			}), /* @__PURE__ */ (0, Q.jsx)("span", {
				className: "cn-7 fs-12 lh-18",
				children: _r[e].description
			})]
		})
	}, e))
}), Wx = ({ appId: e, envId: t, resourceType: n, resourceName: r, setSelectedApprovals: i, selectedApprovals: a }) => {
	let { email: o } = Ff(), [s, c] = j(!1), [l, u, d, f] = hf(() => Promise.all([mi(e, t, n, r), td()])), { approvalConfigData: p, config: m } = A(() => u ? {
		config: {
			configs: u[1].result.isConfigured ?? !1,
			isDefaultConfigPresent: u[1].result.is_default_configured ?? !1
		},
		approvalConfigData: u[0].result.userApprovalMetadata.approvalConfigData
	} : {
		config: {
			configs: !1,
			isDefaultConfigPresent: !1
		},
		approvalConfigData: null
	}, [u]), h = !!(m.configs && m.isDefaultConfigPresent), g = A(() => {
		if (h) {
			let e = Ca(ai(p.anyUserApprovedInfo.approverList, o)), t = Ca(ai(p.specificUsersApprovedInfo.approverList, o));
			return [
				...p.userGroupsApprovedInfo.userGroups.map(({ approverList: e, groupName: t }) => ({
					label: t,
					options: Ca(ai(e, o))
				})),
				{
					label: oa.specificUsersHeading,
					options: t
				},
				{
					label: oa.anyBelowUsers,
					options: e
				}
			];
		}
		return [];
	}, [p, h]);
	return !h && !l ? /* @__PURE__ */ (0, Q.jsx)(_x, {
		isDefaultConfigPresent: m.isDefaultConfigPresent,
		isConfigured: m.configs
	}) : /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox-col dc__gap-8 fs-13",
		children: [!s && /* @__PURE__ */ (0, Q.jsx)(V, {
			label: "Select approvers to notify",
			value: a,
			options: g,
			fullWidth: !0,
			inputId: "select-approval",
			onChange: (e) => {
				i(e);
			},
			isMulti: !0,
			placeholder: "Search people",
			isSearchable: !0,
			isClearable: !0,
			optionListError: d,
			reloadOptionList: f,
			isLoading: l,
			isDisabled: l,
			multiSelectProps: { isGroupHeadingSelectable: !0 }
		}), /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flex left dc__gap-4",
			children: [/* @__PURE__ */ (0, Q.jsx)(Wo, {
				isChecked: s,
				onChange: () => {
					c((e) => (i(e ? [] : [...new Set(g.flatMap((e) => "options" in e ? e.options : [e]))]), !e));
				},
				value: Io.CHECKED,
				rootClassName: "mb-0 w-20 p-2 dc__align-self-start dc__no-shrink",
				id: "notify-all-users"
			}), /* @__PURE__ */ (0, Q.jsx)("label", {
				htmlFor: "notify-all-users",
				className: "m-0 fs-13 fw-4 lh-20 cn-9 cursor",
				children: "Notify all users"
			})]
		})]
	});
}, Gx = /* @__PURE__ */ t({ default: () => Kx }), Kx = ({ id: e, appId: t, envId: n, resourceType: r, resourceName: i, latestDraft: a, handleClose: o, reload: s, expressDeleteConfig: c }) => {
	let [l, u] = j(""), [d, f] = j(!1), [p, m] = j([]), [h, g] = j(Sr.Propose), _ = h === Sr.Express, v = (e) => {
		u(e.target.value);
	}, y = (e) => {
		g(e.target.value);
	}, b = () => {
		let e = [];
		if (p && p?.length > 0) for (let t = 0; t < p.length; t++) e.push(p[t].label);
		return e;
	};
	return /* @__PURE__ */ (0, Q.jsx)(ns, {
		title: (() => {
			let e = "";
			return r === 1 ? e = "ConfigMap" : r === 2 && (e = "Secret"), `Delete ${e} ‘${i}’?`;
		})(),
		subtitle: c?.showExpressDelete ? `The ${r === 1 ? "ConfigMap" : "Secret"} will be permanently removed.` : /* @__PURE__ */ (0, Q.jsxs)("p", {
			className: "m-0 fs-13 lh-20",
			children: [
				"The file will be permanently removed after the deletion request is approved.",
				/* @__PURE__ */ (0, Q.jsx)("br", {}),
				"Are you sure you want to raise a deletion request?"
			]
		}),
		Icon: /* @__PURE__ */ (0, Q.jsx)(z, {
			name: "ic-medium-delete",
			color: null,
			size: 48
		}),
		variant: rs.custom,
		buttonConfig: {
			secondaryButtonConfig: {
				text: "Cancel",
				onClick: o,
				disabled: d
			},
			primaryButtonConfig: {
				text: _ ? "Delete" : "Propose change",
				onClick: _ ? c?.onClick : async () => {
					f(!0);
					try {
						a ? await bi({
							draftId: a.draftId,
							lastDraftVersionId: a.draftVersionId,
							action: 3,
							data: JSON.stringify({ id: e }),
							userComment: l,
							changeProposed: !0
						}) : await Ea({
							appId: t,
							envId: n,
							resource: r,
							resourceName: i,
							action: 3,
							data: JSON.stringify({ id: e }),
							userComment: l,
							changeProposed: !0,
							protectNotificationConfig: { emailIds: b() }
						}), H.showToast({
							variant: U.success,
							description: "Draft created successfully! Resource will be deleted after it is approved."
						}), s();
					} catch (e) {
						Xr(e);
					} finally {
						f(!0), o();
					}
				},
				style: _ ? P.negative : P.default,
				isLoading: _ ? c?.isLoading : d
			}
		},
		handleClose: o,
		shouldCloseOnEscape: !0,
		..._ ? { confirmationConfig: {
			identifier: "express-edit-delete",
			confirmationKeyword: "delete"
		} } : {},
		children: /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox-col dc__gap-12",
			children: [c?.showExpressDelete && /* @__PURE__ */ (0, Q.jsx)(Ux, {
				value: h,
				onChange: y
			}), !_ && /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsx)(Wx, {
				appId: t,
				envId: n,
				resourceType: r,
				resourceName: i,
				setSelectedApprovals: m,
				selectedApprovals: p
			}), /* @__PURE__ */ (0, Q.jsx)(ou, {
				label: "Comment",
				placeholder: "Leave a comment",
				"data-testid": "save-draft-comment-textbox",
				value: l,
				name: "comment",
				onChange: v
			})] })]
		})
	});
}, qx = /* @__PURE__ */ t({ default: () => Jx }), Jx = ({ appId: e, envId: t, resourceType: n, resourceName: r, prepareDataToSave: i, handleClose: a, latestDraft: o, reload: s, expressDeleteConfig: c }) => {
	let [l, u] = j(""), [d, f] = j(!1), [p, m] = j([]), [h, g] = j(Sr.Propose), _ = h === Sr.Express, v = (e) => {
		u(e.target.value);
	}, y = () => (p ?? []).map((e) => e.label), b = (e) => {
		g(e.target.value);
	};
	return /* @__PURE__ */ (0, Q.jsx)(ns, {
		title: "Delete all overrides from this file",
		subtitle: c?.showExpressDelete ? "This action will delete the override for this file, and the inherited configurations from the base will be used as-is." : /* @__PURE__ */ (0, Q.jsxs)("p", {
			className: "m-0 fs-13 lh-20",
			children: [
				"This action will result in the removal of all overrides, and the original base configurations for this file will be reinstated.",
				/* @__PURE__ */ (0, Q.jsx)("br", {}),
				"Changes will be published after they’re approved."
			]
		}),
		variant: rs.warning,
		buttonConfig: {
			secondaryButtonConfig: {
				text: "Cancel",
				onClick: a,
				disabled: d
			},
			primaryButtonConfig: {
				text: _ ? "Delete override" : "Propose change",
				onClick: _ ? c?.onClick : async () => {
					f(!0);
					try {
						o ? await bi({
							draftId: o.draftId,
							lastDraftVersionId: o.draftVersionId,
							action: 3,
							data: JSON.stringify(i()),
							userComment: l,
							changeProposed: !0
						}) : await Ea({
							appId: e,
							envId: t,
							resource: n,
							resourceName: r,
							action: 3,
							data: JSON.stringify(i()),
							userComment: l,
							changeProposed: !0,
							protectNotificationConfig: { emailIds: y() }
						}), H.showToast({
							variant: U.success,
							description: "Override will be deleted after it is approved."
						}), s();
					} catch (e) {
						Xr(e);
					} finally {
						f(!1), a();
					}
				},
				isLoading: _ ? c?.isLoading : d
			}
		},
		handleClose: a,
		shouldCloseOnEscape: !0,
		..._ ? { confirmationConfig: {
			identifier: "express-edit-delete-override",
			confirmationKeyword: "delete override"
		} } : {},
		children: /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox-col dc__gap-12",
			children: [c?.showExpressDelete && /* @__PURE__ */ (0, Q.jsx)(Ux, {
				value: h,
				onChange: b
			}), !_ && /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsx)(Wx, {
				appId: e,
				envId: t,
				resourceType: n,
				resourceName: r,
				setSelectedApprovals: m,
				selectedApprovals: p
			}), /* @__PURE__ */ (0, Q.jsx)(ou, {
				label: "Comment",
				placeholder: "Leave a comment",
				value: l,
				name: "comment",
				onChange: v
			})] })]
		})
	});
}, Yx = /* @__PURE__ */ t({ default: () => Xx }), Xx = ({ draftId: e, draftVersionId: t, toggleDraftComments: n, handleUpdateAreCommentsPresent: r }) => {
	let [i, a] = j(!0), [o, s] = j(!1), [c, l] = j([]), [u, d] = j(""), [f, p] = j(-1), m = () => {
		a(!0), va(e).then((e) => {
			e.result && l(e.result.versionComments?.flatMap((e) => e.userComments).sort((e, t) => t.commentId - e.commentId) ?? []), r?.(e.result?.versionComments?.length > 0);
		}).catch((e) => {
			K(e);
		}).finally(() => {
			a(!1);
		});
	};
	k(() => {
		m();
	}, [e, t]);
	let h = (e) => {
		d(e.target.value);
	}, g = () => {
		s(!0), bi({
			draftId: e,
			lastDraftVersionId: t,
			action: 1,
			data: "",
			userComment: u
		}).then(() => {
			d(""), m(), H.showToast({
				variant: U.success,
				description: "Comment added successfully"
			});
		}).catch((e) => {
			K(e);
		}).finally(() => {
			s(!1);
		});
	}, _ = (t) => {
		s(!0), Ai(e, Number(t.currentTarget.dataset.commentId)).then(() => {
			p(-1), m(), H.showToast({
				variant: U.success,
				description: "Comment deleted successfully"
			});
		}).catch((e) => {
			K(e);
		}).finally(() => {
			s(!1);
		});
	}, v = (e) => /* @__PURE__ */ (0, Q.jsx)("div", {
		className: "flex right pt-4 pb-16 px-16",
		children: /* @__PURE__ */ (0, Q.jsx)(M, {
			text: "Delete comment",
			isLoading: o,
			dataTestId: "delete-comment-confirm-button",
			"data-comment-id": e,
			onClick: _,
			size: I.medium,
			variant: F.secondary,
			style: P.negative
		})
	}), y = (e) => {
		p(f === -1 ? e : -1);
	}, b = () => (e, t) => {
		uf(t), e.id === "delete" && y(e.dataAttributesId);
	}, x = (e) => /* @__PURE__ */ (0, Q.jsx)(io, {
		id: "draft-comments-action-menu",
		onClick: b,
		options: [{ items: [{
			id: "delete",
			label: "Delete comment",
			startIcon: { name: "ic-delete" },
			type: "negative",
			dataAttributesId: e
		}] }],
		buttonProps: {
			dataTestId: "draft-comments-action-menu-button",
			icon: /* @__PURE__ */ (0, Q.jsx)(z, {
				name: "ic-more-vertical",
				color: null
			}),
			variant: F.borderLess,
			ariaLabel: "Open action menu",
			style: P.neutral,
			size: I.xs
		}
	});
	return /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "deployment-config__comments-view w-300 dc__no-shrink draft-comments-container bg__primary dc__border-left dc__overflow-hidden flexbox-col",
		children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flex dc__content-space w-100 pt-12 pb-12 pl-16 pr-16 m-0 dc__border-bottom",
			children: [/* @__PURE__ */ (0, Q.jsxs)("h3", {
				className: "fs-13 fw-6 lh-20 m-0",
				children: [i ? "" : c.length, " Comments"]
			}), /* @__PURE__ */ (0, Q.jsx)(tr, {
				className: "icon-dim-24 cursor",
				"data-testid": "save-changes-modal-close",
				onClick: n
			})]
		}), i ? /* @__PURE__ */ (0, Q.jsx)(ul, { size: 36 }) : /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox-col flex-grow-1 dc__overflow-auto",
			children: [c.length > 0 ? /* @__PURE__ */ (0, Q.jsx)("div", {
				className: "p-16 dc__overflow-auto flex-grow-1",
				children: c.map((e, t) => /* @__PURE__ */ (0, Q.jsx)(su, {
					theme: cu.white,
					className: "w-300 h-100 dc__align-left mr-4 mt--56",
					placement: "top-end",
					iconClass: "fcv-5",
					heading: "Delete comment",
					infoText: "Are you sure you want to delete this comment?",
					additionalContent: v(e.commentId),
					showCloseButton: !0,
					onClose: () => y(e.commentId),
					trigger: "manual",
					interactive: !0,
					visible: f === e.commentId,
					children: /* @__PURE__ */ (0, Q.jsxs)("div", {
						className: "flex left top dc__gap-8 w-100 mb-16",
						"data-testid": `comment-${t}`,
						children: [/* @__PURE__ */ (0, Q.jsx)("div", {
							className: "icon-dim-20",
							children: Ku(e.userEmail)
						}), /* @__PURE__ */ (0, Q.jsxs)("div", {
							className: "w-100",
							children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
								className: "flex top dc__content-space mb-8",
								children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
									className: "flex column left",
									children: [/* @__PURE__ */ (0, Q.jsx)("span", {
										className: "fs-13 fw-6 lh-20 dc__ellipsis-right",
										children: e.userEmail
									}), /* @__PURE__ */ (0, Q.jsx)("span", {
										className: "fs-12 fw-4 lh-20 ",
										children: (0, Op.default)(e.commentedAt).format("HH:mm A, DD MMMM YYYY")
									})]
								}), x(e.commentId)]
							}), /* @__PURE__ */ (0, Q.jsx)("p", {
								className: "fs-13 fw-4 lh-20 cn-9 dc__word-break m-0",
								children: e.comment
							})]
						})]
					}, `comment-${t}`)
				}))
			}) : /* @__PURE__ */ (0, Q.jsx)(R, {
				classname: "dc__skip-align-reload-center flex-grow-1",
				image: ap,
				title: "No comments",
				isButtonAvailable: !1
			}), /* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flex top dc__content-space dc__gap-8 pt-14 pb-14 pl-12 pr-12 dc__border-top mxh-210 dc__overflow-auto dc__no-shrink",
				children: [/* @__PURE__ */ (0, Q.jsx)(ou, {
					placeholder: "Add a comment",
					value: u,
					onChange: h,
					name: "add-new-comment-textarea",
					fullWidth: !0
				}), /* @__PURE__ */ (0, Q.jsx)("div", {
					className: "dc__align-self-end",
					children: /* @__PURE__ */ (0, Q.jsx)(M, {
						isLoading: o,
						disabled: o || !u,
						onClick: g,
						icon: /* @__PURE__ */ (0, Q.jsx)(he, { className: "icon-dim-16 dc__no-svg-fill" }),
						ariaLabel: "Add comment",
						showAriaLabelInTippy: !1,
						dataTestId: "add-new-comment"
					})
				})]
			})]
		})]
	});
}, Zx = ({ value: e, onChange: t, showExpressCreate: n = !1 }) => /* @__PURE__ */ (0, Q.jsx)(vl, {
	className: "approval-action-type__radio-group flex left column",
	value: e,
	name: "save-action-type",
	onChange: t,
	children: Object.keys(Sr).filter((e) => n || e !== Sr.Express).map((e) => /* @__PURE__ */ (0, Q.jsx)(yl, {
		dataTestId: `${e}-type`,
		value: Sr[e],
		children: /* @__PURE__ */ (0, Q.jsxs)("span", {
			className: "flexbox-col dc__no-text-transform",
			children: [/* @__PURE__ */ (0, Q.jsx)("span", {
				className: "cn-9 fs-13 lh-20",
				children: xa[e].label
			}), /* @__PURE__ */ (0, Q.jsx)("span", {
				className: "cn-7 fs-12 lh-18",
				children: xa[e].description
			})]
		})
	}, e))
}), Qx = ({ envName: e, resourceName: t, resourceType: n, handleClose: r, isCreate: i }) => {
	let a = () => i ? `${e || "Base Configurations"} / Create ${n === 1 ? "ConfigMap" : "Secret"}` : `${e || "Base Configurations"} / ${n === 3 ? "Deployment Template" : t}`;
	return /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flex dc__content-space dc__gap-8 px-16 pt-12 pb-11 border__primary--bottom",
		children: [/* @__PURE__ */ (0, Q.jsx)(W, {
			content: a(),
			children: /* @__PURE__ */ (0, Q.jsx)("p", {
				className: "m-0 fs-16 lh-24 fw-6 dc__ellipsis-right",
				children: a()
			})
		}), /* @__PURE__ */ (0, Q.jsx)(M, {
			dataTestId: "close-save-changes-modal",
			ariaLabel: "close-save-changes-modal",
			icon: /* @__PURE__ */ (0, Q.jsx)(z, {
				name: "ic-close-large",
				color: "N600"
			}),
			showAriaLabelInTippy: !1,
			variant: F.borderLess,
			style: P.negativeGrey,
			size: I.xs,
			onClick: r
		})]
	});
}, $x = /* @__PURE__ */ t({ default: () => tS }), eS = (e) => /* @__PURE__ */ (0, Q.jsx)(xu, { children: e }), tS = ({ appId: e, envId: t, envName: n, resourceType: r, resourceName: i, prepareDataToSave: a, latestDraft: o, handleClose: s, reload: c, showAsModal: l, saveEligibleChangesCb: u, handleProcessSaveResponse: d, isCreate: f, showExpressCreate: p, expressCreateConfig: m = {} }) => {
	let [h, g] = j(o?.draftState === Ps.AwaitApproval ? Sr.Propose : Sr.Draft), [_, v] = j(""), [y, b] = j(!1), [x, S] = j([]), [C, w] = j(""), T = h === Sr.Draft, ee = h === Sr.Express, { registerShortcut: E, unregisterShortcut: D } = Af();
	k(() => (E({
		keys: ["Enter"],
		callback: m?.onClick || $d
	}), () => {
		D(["Enter"]);
	}), [m]);
	let te = (e) => {
		v(e.target.value);
	}, ne = (e) => {
		g(e.target.value);
	}, re = (e) => {
		w(e.target.value);
	}, ie = () => {
		let e = "";
		return r === 1 ? e = "ConfigMap" : r === 2 && (e = "Secret"), `Create ${e}`;
	}, ae = () => x.map((e) => e.label);
	return /* @__PURE__ */ (0, Q.jsx)(es, {
		condition: l,
		wrap: eS,
		children: /* @__PURE__ */ (0, Q.jsx)("div", {
			className: `w-400 bg__primary border__primary br-8 dc__m-auto mt-40 ${l ? "" : "position-bottom-right"}`,
			children: /* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox-col",
				children: [
					/* @__PURE__ */ (0, Q.jsx)(Qx, {
						envName: n,
						resourceName: i,
						resourceType: r,
						handleClose: s,
						isCreate: f
					}),
					/* @__PURE__ */ (0, Q.jsxs)("div", {
						className: "mxh-500 dc__overflow-auto p-16 flex-grow-1 flexbox-col dc__gap-16",
						children: [
							/* @__PURE__ */ (0, Q.jsxs)("div", {
								className: "flexbox py-8 px-12 dc__gap-8 bcv-1 ev-2 bw-1 br-4",
								children: [/* @__PURE__ */ (0, Q.jsx)(z, {
									name: "ic-stamp",
									color: "V500",
									size: 20
								}), /* @__PURE__ */ (0, Q.jsxs)("div", {
									className: "flexbox-col fs-13 lh-20 cn-9",
									children: [/* @__PURE__ */ (0, Q.jsx)("p", {
										className: "m-0 fw-6",
										children: "Approval policy"
									}), /* @__PURE__ */ (0, Q.jsxs)("p", {
										className: "m-0 fw-4",
										children: ["Configuration change requires approval based on", /* @__PURE__ */ (0, Q.jsx)(Wf, {
											to: B.APPLICATION_MANAGEMENT_POLICIES.APPROVAL_POLICY.APPLIED_POLICY.ROOT,
											target: "_blank",
											children: "\xA0applied approval policy"
										})]
									})]
								})]
							}),
							/* @__PURE__ */ (0, Q.jsxs)("div", {
								className: "flexbox-col dc__gap-12",
								children: [o?.draftState !== Ps.AwaitApproval && /* @__PURE__ */ (0, Q.jsx)(Zx, {
									value: h,
									onChange: ne,
									showExpressCreate: p
								}), !ee && /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [h === Sr.Propose && /* @__PURE__ */ (0, Q.jsx)(Wx, {
									appId: e,
									envId: t,
									resourceType: r,
									resourceName: i,
									setSelectedApprovals: S,
									selectedApprovals: x
								}), /* @__PURE__ */ (0, Q.jsx)(ou, {
									label: "Comment",
									placeholder: "Leave a comment",
									value: _,
									name: "comment",
									onChange: te
								})] })]
							}),
							ee && /* @__PURE__ */ (0, Q.jsx)(os, {
								name: "express-create-confirmation-input",
								value: C,
								onChange: re,
								label: $u("Create without approval"),
								fullWidth: !0,
								placeholder: "Type to confirm",
								required: !0,
								autoFocus: !0
							})
						]
					}),
					/* @__PURE__ */ (0, Q.jsxs)("div", {
						className: "flex right p-16 dc__gap-12",
						children: [/* @__PURE__ */ (0, Q.jsx)(M, {
							text: "Cancel",
							dataTestId: "cancel-changes",
							onClick: s,
							disabled: y,
							variant: F.secondary,
							style: P.neutral,
							size: I.medium
						}), ee && m ? /* @__PURE__ */ (0, Q.jsx)(M, {
							text: ie(),
							dataTestId: "express-create",
							onClick: m.onClick,
							isLoading: m.isLoading,
							disabled: C.trim() !== $r,
							style: P.warning,
							size: I.medium
						}) : /* @__PURE__ */ (0, Q.jsx)(M, {
							text: T ? "Save as draft" : "Propose changes",
							dataTestId: "save-changes",
							onClick: async () => {
								b(!0);
								try {
									let n = a(), s = {
										action: n.id > 0 ? 2 : 1,
										data: JSON.stringify({
											...n,
											saveEligibleChanges: u
										}),
										userComment: _,
										changeProposed: h === Sr.Propose,
										protectNotificationConfig: { emailIds: h === Sr.Propose ? ae() : [] }
									}, l = null;
									if (l = o ? await bi({
										draftId: o.draftId,
										lastDraftVersionId: o.draftVersionId,
										...s
									}) : await Ea({
										appId: e,
										envId: t,
										resource: r,
										resourceName: i,
										...s
									}), d?.(l), l?.result?.isLockConfigError) {
										b(!1);
										return;
									}
									H.showToast({
										variant: U.success,
										description: T ? "Draft updated successfully" : "Draft updated successfully! Changes will be published after it is approved."
									}), c(), b(!1);
								} catch (e) {
									Xr(e), b(!1);
								}
							},
							isLoading: y,
							disabled: y,
							size: I.medium
						})]
					})
				]
			})
		})
	});
}, nS = () => /* @__PURE__ */ (0, Q.jsxs)("p", {
	className: "flex left dc__gap-8 px-12 py-8 m-0",
	children: [/* @__PURE__ */ (0, Q.jsx)(he, { className: "dc__no-shrink icon-dim-16 scg-5" }), /* @__PURE__ */ (0, Q.jsx)("span", {
		className: "fs-13 fw-4 lh-20 fw-6 cg-5",
		children: "Approved by you"
	})]
}), rS = ({ componentName: e, configMapSecretData: t, draftData: n, parentName: r, updateCMSecret: i }) => {
	if (t && Wd(t.externalType) || n.draftState !== Ps.AwaitApproval) return null;
	if (n.userApprovalMetadata.hasCurrentUserApproved) return /* @__PURE__ */ (0, Q.jsx)(nS, {});
	let a = n.userApprovalMetadata.canCurrentUserApprove;
	return /* @__PURE__ */ (0, Q.jsx)("div", {
		className: "py-12 px-16 dc__border-top-n1 flex right dc__gap-12 configmap-secret-container__approval-tippy",
		children: n.canApprove && a ? /* @__PURE__ */ (0, Q.jsx)(Hx, {
			draftId: n.draftId,
			draftVersionId: n.draftVersionId,
			resourceName: e,
			reload: i,
			envName: r,
			children: /* @__PURE__ */ (0, Q.jsx)(M, {
				dataTestId: "cm-secret-approve-btn",
				text: "Approve Changes",
				size: I.medium,
				style: P.positive
			})
		}) : /* @__PURE__ */ (0, Q.jsx)(M, {
			dataTestId: "cm-secret-approve-btn",
			text: "Approve Changes",
			size: I.medium,
			style: P.positive,
			disabled: !0,
			showTooltip: !0,
			tooltipProps: {
				placement: "top-end",
				content: a ? "You have made changes to this file. Users who have edited cannot approve the changes." : "You do not have permission to approve configuration changes for this application - environment combination."
			}
		})
	});
}, iS = "Cannot change data type for this file as it is overridden with Patch strategy in some environment(s)", aS = "Cannot delete this file as it is overridden with Patch strategy in some environment(s)", oS = ({ draftChartVersion: e, currentEditorChartVersion: t }) => {
	let n = e ? ` (v${e})` : "", r = t ? ` (v${t})` : "";
	return [{
		label: "Values generated from",
		options: [{
			label: `Approval Pending ${n}`,
			value: $o.APPROVAL_PENDING
		}, {
			label: `Values from draft ${r}`,
			value: $o.VALUES_FROM_DRAFT
		}]
	}];
}, sS = ({ selectedOptionValue: e = $o.APPROVAL_PENDING, handleCompareFromOptionSelection: t, draftChartVersion: n, currentEditorChartVersion: r, isDeleteOverrideView: i }) => {
	let a = oS({
		draftChartVersion: n,
		currentEditorChartVersion: r
	}), o = a[0].options.find((t) => t.value === e);
	return /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox dc__gap-8 dc__align-items-center",
		children: [/* @__PURE__ */ (0, Q.jsx)(Qt, { className: "icon-dim-16 scn-9 dc__no-shrink" }), i ? /* @__PURE__ */ (0, Q.jsx)("span", {
			className: "cn-9 fs-12 fw-6 lh-20",
			children: "Approval pending"
		}) : /* @__PURE__ */ (0, Q.jsx)(V, {
			inputId: "compare-template-values-select",
			options: a,
			value: o,
			variant: Hl.COMPACT,
			onChange: t,
			isSearchable: !1,
			size: I.small
		})]
	});
}, cS = ({ isAppMetricsEnabled: e, showApplicationMetrics: t, isLoading: n, selectedChart: r, isDisabled: i, toggleAppMetrics: a, parsingError: o, restoreLastSavedYAML: s, handleExpressEditPublish: c, handleExpressEditCancel: l }) => /* @__PURE__ */ (0, Q.jsxs)("div", {
	className: `flexbox ${t ? "dc__content-space" : "dc__content-end"} dc__align-items-center p-12 bg__primary dc__border-top`,
	children: [/* @__PURE__ */ (0, Q.jsx)(ys, {
		showApplicationMetrics: t,
		isLoading: n,
		selectedChart: r,
		isDisabled: i,
		toggleAppMetrics: a,
		isAppMetricsEnabled: e,
		parsingError: o,
		restoreLastSavedYAML: s
	}), /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flex right dc__gap-12",
		children: [/* @__PURE__ */ (0, Q.jsx)(M, {
			dataTestId: "base-deployment-template-express-edit-cancel-button",
			disabled: i,
			onClick: l,
			text: "Cancel",
			variant: F.secondary,
			style: P.neutral,
			size: I.medium
		}), /* @__PURE__ */ (0, Q.jsx)(Ec, {
			parsingError: o,
			restoreLastSavedYAML: s,
			children: /* @__PURE__ */ (0, Q.jsx)("div", { children: /* @__PURE__ */ (0, Q.jsx)(M, {
				dataTestId: "base-deployment-template-express-edit-publish-button",
				disabled: i,
				onClick: c,
				text: "Publish Changes",
				size: I.medium,
				style: P.warning
			}) })
		})]
	})]
}), lS = /* @__PURE__ */ function(e) {
	return e.OBJECT = "OBJECT", e.LEAF = "LEAF", e;
}({}), uS = (e, t) => {
	if (e >= t.length) return { "ui:widget": "hidden" };
	if (t[e] === "$") return uS(e + 1, t);
	let n = t[e];
	return !Number.isNaN(Number(n)) || n === "*" ? { items: uS(e + 1, t) } : { [n]: uS(e + 1, t) };
}, dS = (e) => {
	let t = e.reduce((e, t) => (t.selectionStatus ? e[t.selectionStatus] += 1 : e[t.isChecked ? "all-selected" : "none-selected"] += 1, e), {
		"none-selected": 0,
		"all-selected": 0,
		"some-selected": 0
	});
	return t["all-selected"] === e.length ? "all-selected" : t["none-selected"] === e.length ? "none-selected" : "some-selected";
}, fS = (e, t) => {
	try {
		return hr({
			json: e,
			path: Mu(t),
			resultType: "value",
			wrap: !1
		}) !== void 0;
	} catch {
		return null;
	}
}, pS = (e) => {
	let t = e.lastIndexOf("*");
	return {
		firstPart: e.slice(0, t + 1),
		lastPart: e.slice(t + 1)
	};
}, mS = (e, t) => {
	try {
		let n = [];
		if (t.op === "add") {
			let { firstPart: r, lastPart: i } = pS(t.path);
			n = hr({
				json: e,
				path: Mu(r),
				resultType: "pointer"
			}).map((e) => `${e}${i}`);
		} else n = hr({
			json: e,
			path: Mu(t.path),
			resultType: "pointer"
		});
		if (!Array.isArray(n)) return;
		n.forEach((n) => Ma(e, {
			...t,
			path: n
		}, !0, !0));
	} catch (e) {
		K(e);
	}
}, hS = (e) => e.replace(/\*/g, "0"), gS = (e, t) => {
	(Object.hasOwn(e, "isChecked") && !e.isChecked || e.selectionStatus === "none-selected") && t.push(e.path);
}, _S = class {
	constructor(e, t) {
		Xt(this, "schema", null), Xt(this, "json", null), Xt(this, "schemaPathToUpdatePathMap", {}), Xt(this, "totalCheckedCount", 0), Xt(this, "root", void 0), Xt(this, "_constructTree", (e, t, n) => {
			if (!n) throw new rc("Problem constructing the tree", "In traversal found an undefined json object");
			if (n.type === "object" && n.properties && typeof n.properties == "object") {
				let r = Object.entries(n.properties).sort(([, e]) => e && typeof e == "object" && e.type === "boolean" ? -1 : 0).map(([e, n]) => this._constructTree(e, `${t}/${e}`, n));
				return {
					key: e,
					selectionStatus: dS(r),
					type: lS.OBJECT,
					fieldType: n.type,
					title: n.title ?? e,
					path: t,
					children: r
				};
			}
			let r = this.schemaPathToUpdatePathMap[t] && this.schemaPathToUpdatePathMap[t] !== t ? this.schemaPathToUpdatePathMap[t] : null, i = fS(this.json, r ?? t);
			return i && (this.totalCheckedCount += 1), {
				key: e,
				type: lS.LEAF,
				fieldType: n.type,
				isChecked: i,
				title: n.title,
				path: t,
				...r ? { updatePath: r } : {}
			};
		}), Xt(this, "constructTree", () => {
			if (this.schema.type !== "object" || !this.schema.properties || typeof this.schema.properties != "object" || !Object.keys(this.schema.properties).length) throw new rc("Invalid GUI schema found", "The saved GUI schema is probably invalid. Please conform your schema to json schema draft-07");
			return this._constructTree("", "", this.schema);
		}), Xt(this, "inOrder", (e) => {
			let { node: t, wf: n } = e;
			e.node && (n(t, e.data), t.children?.forEach((t) => this.inOrder({
				...e,
				node: t
			})));
		}), Xt(this, "postOrder", (e) => {
			let { node: t, wf: n } = e;
			e.node && (t.children?.forEach((t) => this.postOrder({
				...e,
				node: t
			})), n(t, e.data));
		}), Xt(this, "updateNodeWherePathMatches", (e, t) => {
			if (e.path === t.path) {
				if (e.type !== lS.LEAF) throw Error("None leaf is being updated!");
				e.isChecked = !e.isChecked;
				let n = e.updatePath ?? e.path;
				e.isChecked ? (this.totalCheckedCount += 1, t.json = Yd([t.json, ku(hS(n), gd(e.fieldType))])) : (--this.totalCheckedCount, mS(t.json, {
					op: "remove",
					path: n
				}));
			}
			e.children && (e.selectionStatus = dS(e.children));
		}), Xt(this, "getUncheckedNodes", () => {
			let e = [];
			return this.inOrder({
				node: this.root,
				wf: gS,
				data: e
			}), e;
		}), Xt(this, "updateNodeForPath", ({ path: e, json: t }) => {
			let n = {
				path: e,
				json: structuredClone(t)
			};
			return this.postOrder({
				node: this.root,
				wf: this.updateNodeWherePathMatches,
				data: n
			}), n.json;
		}), Xt(this, "getUISchema", () => Yd(this.getUncheckedNodes().map((e) => uS(0, hr.toPathArray(Mu(e)))))), this.schema = Qf.parse(e), this.schemaPathToUpdatePathMap = wd(this.schema), this.json = Qf.parse(t), this.totalCheckedCount = 0, this.root = this.constructTree();
	}
}, vS = ({ node: e, updateNodeForPath: t, disabled: n, hasParent: r }) => {
	let i = () => {
		Mn.event({
			category: "Deployment Template",
			action: "GUI Checkbox clicked"
		}), t(e.path);
	}, a = !!e.children?.length, o = e.title ?? e.key;
	return /* @__PURE__ */ (0, Q.jsx)("div", {
		className: "flexbox-col dc__gap-4",
		children: a ? /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsx)("span", {
			className: "fs-13 lh-20 fw-6 cn-9",
			children: o
		}), /* @__PURE__ */ (0, Q.jsx)("div", {
			className: "flexbox-col pl-12 mt-8 mb-8 dc__border-left-n1 dc__gap-8",
			children: e.children.map((e) => /* @__PURE__ */ (0, Q.jsx)(vS, {
				disabled: n,
				node: e,
				updateNodeForPath: t,
				hasParent: !0
			}, e.key))
		})] }) : /* @__PURE__ */ (0, Q.jsx)(Wo, {
			value: Io.CHECKED,
			disabled: n,
			isChecked: e.isChecked,
			onChange: i,
			rootClassName: "mb-0 fs-13 cn-7 lh-20",
			name: o,
			children: /* @__PURE__ */ (0, Q.jsx)("span", {
				className: r ? "" : "fw-6",
				children: o
			})
		})
	});
}, yS = ({ disabled: e, node: t, updateNodeForPath: n }) => /* @__PURE__ */ (0, Q.jsx)("div", {
	className: "dc__overflow-auto py-20 pl-32 pr-20 flexbox-col dc__gap-12",
	children: t.children.map((t) => /* @__PURE__ */ (0, Q.jsx)(vS, {
		disabled: e,
		node: t,
		updateNodeForPath: n,
		hasParent: !1
	}, t.key))
}), bS = {
	isKey: !1,
	next: {}
}, xS = (e) => e.split("/").slice(1), SS = (e) => {
	let t = xS(e), n = bS;
	for (let e = 0; e < t.length; e++) {
		let r = t[e];
		n.next[r] || (n.next[r] = { next: {} }), n = n.next[r];
	}
	n.isKey = !0;
}, CS = (e) => {
	let t = xS(e), n = bS;
	for (let e = 0; e < t.length; e++) {
		if (n = n.next[t[e]], !n) return !1;
		if (n.isKey) return !0;
	}
	return !!n?.isKey;
}, wS = ({ patches: e }) => Yd(e.map(({ path: e, value: t }) => ku(e, t))), TS = (e, t) => (bS.next = {}, t.forEach((e) => SS(e)), e.map((e) => CS(e))), ES = (e, t, n) => {
	let r = TS(e.map((e) => e.path), t);
	return e.filter((e, t) => n ? !r[t] : r[t]);
}, DS = (e) => {
	let { path: t, value: n } = e;
	return !n || typeof n != "object" || !Object.keys(n).length ? [e] : Object.entries(n).flatMap(([n, r]) => DS({
		...e,
		path: `${t}/${Pa(n)}`,
		value: r
	}));
}, OS = (e, t) => ({
	...e,
	id: t
}), kS = ({ edited: e, unedited: t, patches: n }, r, i) => {
	let a = [...new Set([...Hu(r, t, "pointer"), ...Hu(r, e, "pointer")])], o = ES(n.flatMap((e, n) => e.op === "add" ? DS(e).map((e) => OS(e, n)) : e.op === "remove" ? DS({
		...e,
		value: hr({
			path: Mu(e.path),
			json: t,
			resultType: "value",
			wrap: !0
		})[0]
	}).map((e) => OS(e, n)) : OS(e, n)), a, !i), s = /* @__PURE__ */ new Set(), c = {};
	return o.forEach(({ id: e, op: r, path: i }) => {
		let a = n[e];
		if (r !== "add" && r !== "remove" || a.path === i) {
			s.add(e);
			return;
		}
		if (r === "add") {
			Ma(a.value, {
				op: "remove",
				path: i.slice(a.path.length)
			});
			return;
		}
		c[a.path] = [...c[a.path] ?? [], ku(i, hr({
			json: t,
			path: Mu(i),
			wrap: !1,
			resultType: "value"
		}))];
	}), n.filter((e, t) => !s.has(t)).concat(Object.entries(c).map(([e, t]) => ({
		op: "add",
		path: e,
		value: hr({
			json: Yd(t),
			path: Mu(e),
			resultType: "value",
			wrap: !1
		})
	})));
}, AS = ({ edited: e, unedited: t, patches: n }, r, i) => {
	let a = [...new Set([...Hu(r, t, "pointer"), ...Hu(r, e, "pointer")])];
	return ES(n.flatMap((e) => e.op === "add" ? DS(e) : e.op === "remove" ? DS({
		...e,
		value: hr({
			path: Mu(e.path),
			json: t,
			resultType: "value",
			wrap: !0
		})[0]
	}) : e), a, i);
}, jS = (e, t, n) => {
	let r = AS(e, t, n);
	return wS({
		...e,
		patches: r
	});
}, MS = (e, t) => cf(jS(e, t, !1), du), NS = (e, t) => cf(jS(e, t, !0), du), PS = (e) => e ? Object.values(e).some((e) => typeof e == "object" && e ? Array.isArray(e) ? !0 : PS(e) : !1) : !1, FS = (e, t) => {
	let n = Qf.parse(e) ?? {}, r = structuredClone(n), i = Hu(t, n, "pointer").map((e) => ({
		op: "remove",
		path: e
	})).sort(({ path: e }, { path: t }) => {
		let n = xS(e), r = xS(t), i = 0;
		for (let e = 0; e < n.length && e < r.length; e++) {
			let t = Number(n[e]), a = Number(r[e]);
			if (!Number.isNaN(t) && !Number.isNaN(a) && (i = a - t, i)) break;
			if (n[e] < r[e]) {
				i = -1;
				break;
			}
			if (n[e] > r[e]) {
				i = 1;
				break;
			}
			i = 0;
		}
		return i;
	}).reduce((e, t) => {
		try {
			return Ma(e, t).newDocument;
		} catch {
			return e;
		}
	}, n);
	return {
		document: i,
		addOperations: Fa(i ?? {}, r ?? {})
	};
}, IS = (e, t) => {
	let n = structuredClone(e);
	return t.forEach((e) => {
		try {
			Ma(n, e);
		} catch {}
	}), n;
}, LS = ({ hideLockedKeys: e, lhs: t, rhs: n, lockedConfigKeysWithLockType: r, removedPatches: i, hideLockKeysToggled: a, unableToParseYaml: o, readOnly: s, uneditedDocument: c }) => {
	let l = t, u = n;
	if (e) {
		if (l) {
			let { document: e } = FS(l, r.config);
			l = Tu(e);
		}
		if (u && (a.current || s) && !o) {
			let { document: e, addOperations: t } = FS(u, r.config);
			u = Tu(e), t.length && (i.current = t);
		}
		a.current = !1;
	} else if ((a.current || s) && !e && !o && i.current.length && u) {
		let e = Qf.parse(u);
		u = Tu(Ou(Qf.parse(c), IS(e, i.current))), i.current = [], a.current = !1;
	}
	return {
		updatedLHS: l,
		updatedRHS: u
	};
}, RS = ({ documents: e, lockedConfigKeysWithLockType: t }) => {
	let n = {
		...e,
		patches: Fa(e.unedited ?? {}, e.edited ?? {})
	}, r = MS(n, t.config), i = NS(n, t.config);
	return {
		ineligibleChanges: t.allowed ? i : r,
		eligibleChanges: t.allowed ? r : i
	};
}, zS = async (e, t, n) => {
	try {
		let r = await G(Rd(O.LOCK_CONFIG_API_ROUTE, {
			appId: e,
			envId: t
		}), { signal: n });
		return {
			...r,
			result: {
				id: r?.result?.id ?? 0,
				allowed: r?.result?.allowed ?? !1,
				config: r?.result?.config ?? []
			}
		};
	} catch (e) {
		throw K(e), e;
	}
}, BS = /* @__PURE__ */ t({ default: () => HS }), VS = ({ message: e, variant: t = "information", closeModal: n }) => /* @__PURE__ */ (0, Q.jsxs)("div", {
	className: "flexbox dc__gap-12 flex-grow-1",
	children: [/* @__PURE__ */ (0, Q.jsx)("div", {
		className: "flex-grow-1",
		children: /* @__PURE__ */ (0, Q.jsx)(xc, {
			description: e,
			variant: t
		})
	}), /* @__PURE__ */ (0, Q.jsx)(M, {
		dataTestId: "close-diff-modal",
		text: "Okay",
		onClick: n
	})]
}), HS = ({ closeModal: e, showLockedDiffForApproval: t, onSave: n, documents: r, appId: i, envId: a, isSaving: o }) => {
	let [s, c, l, u] = hf(() => zS(i, a), [i, a]), [d, f] = j(!1), { ineligibleChanges: p, eligibleChanges: m } = RS({
		documents: r,
		lockedConfigKeysWithLockType: c?.result || us
	}), h = PS(m), g = Object.values(m).length === 0;
	return /* @__PURE__ */ (0, Q.jsx)(Rs, {
		position: "right",
		width: "800px",
		onEscape: e,
		onClose: e,
		children: /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "h-100 bg__primary flexbox-col locked-diff-modal",
			onClick: uf,
			children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox dc__content-space pt-16 pb-16 pl-16 pr-16 dc__border-bottom",
				children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "flexbox dc__gap-8 ",
					children: [/* @__PURE__ */ (0, Q.jsx)(z, {
						name: "ic-warning",
						color: null,
						size: 24
					}), /* @__PURE__ */ (0, Q.jsx)("div", {
						className: "fs-16 fw-6",
						children: "Some changes are not eligible for update"
					})]
				}), /* @__PURE__ */ (0, Q.jsx)(M, {
					dataTestId: "close-deployment-diff",
					icon: /* @__PURE__ */ (0, Q.jsx)(z, {
						name: "ic-close-large",
						color: null
					}),
					size: I.xs,
					onClick: e,
					ariaLabel: "close deployment diff drawer",
					showAriaLabelInTippy: !1,
					style: P.negativeGrey,
					variant: F.borderLess
				})]
			}), s ? /* @__PURE__ */ (0, Q.jsx)(ul, { pageLoader: !0 }) : l ? /* @__PURE__ */ (0, Q.jsx)(Ks, {
				code: l.code,
				reload: u
			}) : /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [(() => {
				let e = Tu(p, {
					sortMapEntries: !0,
					simpleKeys: !0
				}), t = Tu(m, {
					sortMapEntries: !0,
					simpleKeys: !0
				});
				return /* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "flexbox-col py-12 px-16 dc__gap-12 flex-grow-1 dc__overflow-auto",
					children: [/* @__PURE__ */ (0, Q.jsx)("div", {
						className: "fs-14 fw-4",
						children: "Some of the keys are locked and prohibited to change by non-super admin users."
					}), /* @__PURE__ */ (0, Q.jsxs)("div", {
						className: "dc__border dc__grid-half h-100",
						children: [/* @__PURE__ */ (0, Q.jsx)("div", {
							className: "flexbox-col flex-grow-1 dc__border-right",
							children: /* @__PURE__ */ (0, Q.jsx)(Xo, {
								mode: Ic.YAML,
								readOnly: !0,
								value: e,
								height: "fitToParent",
								children: /* @__PURE__ */ (0, Q.jsx)("div", {
									className: "pl-12 pt-12 pb-12 pr-12 bcr-2 fw-6",
									style: { backgroundColor: "var(--code-editor-red)" },
									children: "NOT eligible for update"
								})
							})
						}), /* @__PURE__ */ (0, Q.jsxs)("div", {
							className: "flexbox-col flex-grow-1",
							children: [/* @__PURE__ */ (0, Q.jsx)("div", {
								className: "pl-12 pt-12 pb-12 pr-12 fw-6",
								style: { backgroundColor: "var(--code-editor-green)" },
								children: "Eligible for update"
							}), g ? /* @__PURE__ */ (0, Q.jsx)("div", {
								className: "flex flex-grow-1",
								children: "No Changes"
							}) : /* @__PURE__ */ (0, Q.jsx)(Xo, {
								mode: Ic.YAML,
								readOnly: !0,
								value: t,
								height: "fitToParent"
							})]
						})]
					})]
				});
			})(), /* @__PURE__ */ (0, Q.jsx)("div", {
				className: "pt-16 pb-16 pl-16 pr-16 flex  dc__border-top",
				children: t ? /* @__PURE__ */ (0, Q.jsx)(VS, {
					message: li,
					closeModal: e
				}) : g ? /* @__PURE__ */ (0, Q.jsx)(VS, {
					message: Oi,
					closeModal: e
				}) : h ? /* @__PURE__ */ (0, Q.jsx)(VS, {
					message: ma,
					variant: "warning",
					closeModal: e
				}) : /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsx)("div", {
					className: "flex dc__gap-8",
					children: /* @__PURE__ */ (0, Q.jsx)(Wo, {
						isChecked: d,
						value: Io.CHECKED,
						onChange: () => {
							f((e) => !e);
						},
						rootClassName: "mb-0 icon-dim-24 w-100",
						dataTestId: "save-eligible-changes",
						children: /* @__PURE__ */ (0, Q.jsx)("span", {
							className: "fs-14",
							children: "Save changes which are eligible to update"
						})
					})
				}), /* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "ml-auto flex dc__gap-12",
					children: [/* @__PURE__ */ (0, Q.jsx)(M, {
						dataTestId: "close-modal-diff",
						text: "Cancel",
						onClick: e,
						variant: F.secondary
					}), /* @__PURE__ */ (0, Q.jsx)(M, {
						dataTestId: "save-modal-diff",
						text: "Save Changes",
						isLoading: o,
						disabled: !d || o,
						onClick: async () => {
							await n(!0);
						}
					})]
				})] })
			})] })]
		})
	});
}, US = () => /* @__PURE__ */ (0, Q.jsxs)("li", {
	className: "m-0 fs-13 lh-20 cn-9 fw-4",
	children: [/* @__PURE__ */ (0, Q.jsx)("strong", {
		className: "m-0 fw-6",
		children: "Patch:"
	}), "\xA0Updates only specified fields, keeping other inherited values intact. Ideal for making minor adjustments to inherited configurations."]
}), WS = ({ isAppMetricsEnabled: e, showApplicationMetrics: t, isLoading: n, selectedChart: r, isDisabled: i, toggleAppMetrics: a, latestDraft: o, isCiPipeline: s, handleTriggerSaveDraft: c, validateApprovalState: l, handleReload: u, showApproveButton: d, isPublishedView: f, parsingError: p, restoreLastSavedYAML: m, isDryRunView: h, handleApprovalLockConfigError: g }) => {
	let { envId: _ } = Z(), [v, y] = j(!1), b = !!o?.userApprovalMetadata?.canCurrentUserApprove, x = !b || !o?.canApprove, S = !_ && !s, C = () => {
		l() && y(!0);
	}, w = () => {
		y(!1);
	};
	return /* @__PURE__ */ (0, Q.jsxs)("footer", {
		className: `flexbox ${t ? "dc__content-space" : "dc__content-end"} dc__align-items-center p-12 bg__primary dc__border-top ${v ? "deployment-template__approval-tippy" : ""}`,
		children: [d || h ? /* @__PURE__ */ (0, Q.jsx)(ys, {
			isAppMetricsEnabled: e,
			showApplicationMetrics: t,
			onlyShowCurrentStatus: !0
		}) : /* @__PURE__ */ (0, Q.jsx)(ys, {
			showApplicationMetrics: t,
			isLoading: n,
			selectedChart: r,
			isDisabled: i,
			toggleAppMetrics: a,
			isAppMetricsEnabled: e,
			parsingError: p,
			restoreLastSavedYAML: m
		}), !f && (() => {
			if (d) {
				if (o?.userApprovalMetadata?.hasCurrentUserApproved) return /* @__PURE__ */ (0, Q.jsx)(nS, {});
				if (x) {
					let e = b ? "You have made changes to this file. Users who have edited cannot approve the changes." : "You do not have permission to approve configuration changes for this application - environment combination.";
					return /* @__PURE__ */ (0, Q.jsx)(M, {
						showTooltip: !!e,
						tooltipProps: { content: e },
						style: P.positive,
						isLoading: n,
						disabled: !0,
						dataTestId: "validate-approval-btn",
						text: "Approve changes",
						size: I.medium
					});
				}
				return v ? /* @__PURE__ */ (0, Q.jsx)(Hx, {
					draftId: o.draftId,
					draftVersionId: o.draftVersionId,
					resourceName: "deployment template",
					reload: u,
					onClose: w,
					handleLockConfigError: g,
					children: /* @__PURE__ */ (0, Q.jsx)(M, {
						style: P.positive,
						isLoading: n,
						disabled: i,
						dataTestId: "placeholder-approve-changes-btn",
						text: "Approve changes",
						size: I.medium
					})
				}) : /* @__PURE__ */ (0, Q.jsx)(M, {
					style: P.positive,
					isLoading: n,
					disabled: i,
					onClick: C,
					dataTestId: "validate-approval-btn",
					text: "Approve changes",
					size: I.medium
				});
			}
			return /* @__PURE__ */ (0, Q.jsx)(Ec, {
				parsingError: p,
				restoreLastSavedYAML: m,
				children: /* @__PURE__ */ (0, Q.jsx)("div", { children: /* @__PURE__ */ (0, Q.jsx)(M, {
					onClick: c,
					disabled: i,
					isLoading: n,
					text: S ? "Save & Next" : "Save changes...",
					dataTestId: S ? "base-deployment-template-save-and-next-button" : "base-deployment-template-save-changes-button",
					endIcon: S ? /* @__PURE__ */ (0, Q.jsx)(Kn, { className: `icon-dim-16 dc__no-shrink ${i ? "scn-4" : "scn-0"}` }) : null,
					size: I.medium
				}) })
			});
		})()]
	});
}, GS = [
	{
		label: "Published values",
		value: zs.PUBLISHED_VALUES
	},
	{
		label: "Approval Pending",
		value: zs.APPROVAL_PENDING
	},
	{
		label: "Values from draft",
		value: zs.VALUES_FROM_DRAFT
	}
], KS = ({ selectedOptionValue: e = zs.PUBLISHED_VALUES, handleChangeDryRunEditorMode: t }) => /* @__PURE__ */ (0, Q.jsx)(V, {
	options: GS,
	value: GS.find((t) => t.value === e),
	onChange: (e) => {
		t(e.value);
	},
	inputId: "dry-run-editor-mode-select",
	variant: Hl.COMPACT,
	isSearchable: !1,
	size: I.small
}), qS = async (e) => {
	try {
		let { result: { versionMetadata: t } } = await G(`${O.CONFIG_DRAFTS_VERSION}/${e}`);
		return t?.sort((e, t) => ef(e.draftVersionId, t.draftVersionId, Jl.DESC)) || [];
	} catch (e) {
		throw K(e), e;
	}
}, JS = (e, t, n) => sf(Rd(O.CONFIG_DRAFTS, {
	draftId: e,
	draftVersionId: t,
	state: n
}), {}), YS = ({ requestedUserId: e, userApprovalMetadata: t, draftId: n, draftVersionId: r, handleReload: i }) => {
	let [a, o] = j(!1);
	return /* @__PURE__ */ (0, Q.jsx)(Lr, {
		placement: "bottom-end",
		showOnlyCountInButton: !0,
		userApprovalMetadata: t,
		cancelRequest: async () => {
			o(!0);
			try {
				await JS(n, r, Ps.Discarded), H.showToast({
					variant: U.success,
					description: "Draft discarded successfully"
				}), i();
			} catch (e) {
				Xr(e);
			} finally {
				o(!1);
			}
		},
		isLoading: a,
		requestedUserId: e,
		approvalType: ye.Config
	});
}, XS = ({ shouldMergeTemplateWithPatches: e, handleToggleShowTemplateMergedWithPatch: t, isDisabled: n }) => /* @__PURE__ */ (0, Q.jsx)(Wo, {
	value: Io.CHECKED,
	onChange: t,
	isChecked: e,
	disabled: n,
	rootClassName: "mb-0",
	children: "Show merged"
}), ZS = (e) => /* @__PURE__ */ (0, Q.jsx)("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "0 0 24 24",
	...e,
	children: /* @__PURE__ */ (0, Q.jsx)("path", {
		stroke: "#3B444C",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M7.75 8.75h8.5m-8.5 4h5.5M12 22l-3-4H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-4l-3 4Z",
		vectorEffect: "non-scaling-stroke"
	})
}), QS = (e) => /* @__PURE__ */ (0, Q.jsxs)("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [/* @__PURE__ */ (0, Q.jsxs)("g", {
		clipPath: "url(#clip0_9140_68210)",
		children: [
			/* @__PURE__ */ (0, Q.jsx)("path", {
				d: "M2.5 4.5C2.5 3.39543 3.39543 2.5 4.5 2.5H15.5C16.6046 2.5 17.5 3.39543 17.5 4.5V12.1667C17.5 13.2712 16.6046 14.1667 15.5 14.1667H10L5.83333 18.3333V14.1667H4.5C3.39543 14.1667 2.5 13.2712 2.5 12.1667V4.5Z",
				stroke: "#596168",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ (0, Q.jsx)("line", {
				x1: 6.5835,
				y1: 6.3335,
				x2: 13.4168,
				y2: 6.3335,
				stroke: "#596168",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ (0, Q.jsx)("line", {
				x1: 6.5835,
				y1: 9.6665,
				x2: 10.9168,
				y2: 9.6665,
				stroke: "#596168",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ (0, Q.jsx)("circle", {
				cx: 16,
				cy: 4,
				r: 5,
				fill: "#F33E3E",
				stroke: "white",
				strokeWidth: 2
			})
		]
	}), /* @__PURE__ */ (0, Q.jsx)("defs", { children: /* @__PURE__ */ (0, Q.jsx)("clipPath", {
		id: "clip0_9140_68210",
		children: /* @__PURE__ */ (0, Q.jsx)("rect", {
			width: 20,
			height: 20,
			fill: "white"
		})
	}) })]
}), $S = ({ areCommentsPresent: e, handleToggleCommentsView: t }) => /* @__PURE__ */ (0, Q.jsx)(M, {
	ariaLabel: "View / Add Comment",
	dataTestId: "toggle-comments-view",
	showAriaLabelInTippy: !0,
	variant: F.borderLess,
	style: P.neutral,
	onClick: t,
	icon: e ? /* @__PURE__ */ (0, Q.jsx)(QS, { className: "icon-dim-20 dc__no-shrink" }) : /* @__PURE__ */ (0, Q.jsx)(ZS, { className: "icon-dim-20 dc__no-shrink" }),
	size: I.xs
}), eC = (e) => /* @__PURE__ */ (0, Q.jsxs)("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	...e,
	children: [/* @__PURE__ */ (0, Q.jsx)("rect", {
		x: 1.33301,
		y: 1.33331,
		width: 13.3333,
		height: 13.3333,
		rx: 4,
		fill: "#596168"
	}), /* @__PURE__ */ (0, Q.jsx)("path", {
		d: "M10 6L6 10M10 10L6 6",
		stroke: "white",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
}), tC = (e) => /* @__PURE__ */ (0, Q.jsx)("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "0 0 24 24",
	...e,
	children: /* @__PURE__ */ (0, Q.jsx)("path", {
		stroke: "#3B444C",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M12 7.5V12l3.897 2.25M6.734 9.348h-3.75m0 0v-3.75m0 3.75 3.182-3.182a8.25 8.25 0 1 1 0 11.668",
		vectorEffect: "non-scaling-stroke"
	})
}), nC = (e) => /* @__PURE__ */ (0, Q.jsxs)("svg", {
	width: "24px",
	height: "24px",
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...e,
	children: [/* @__PURE__ */ (0, Q.jsx)("title", { children: "6605A5D1-3E7E-49E0-A6B7-0384A91D2569" }), /* @__PURE__ */ (0, Q.jsx)("g", {
		id: "Final-UI",
		stroke: "none",
		strokeWidth: 1,
		fill: "none",
		fillRule: "evenodd",
		children: /* @__PURE__ */ (0, Q.jsx)("g", {
			id: "App-List",
			transform: "translate(-24.000000, -790.000000)",
			fill: "#FFFFFF",
			children: /* @__PURE__ */ (0, Q.jsx)("g", {
				id: "Primary-Nav/Item/Hover",
				transform: "translate(16.000000, 782.000000)",
				children: /* @__PURE__ */ (0, Q.jsx)("g", {
					id: "Icon/ic-more-hor",
					transform: "translate(8.000000, 8.000000)",
					children: /* @__PURE__ */ (0, Q.jsx)("path", {
						d: "M12,8 C13.1,8 14,7.1 14,6 C14,4.9 13.1,4 12,4 C10.9,4 10,4.9 10,6 C10,7.1 10.9,8 12,8 Z M12,10 C10.9,10 10,10.9 10,12 C10,13.1 10.9,14 12,14 C13.1,14 14,13.1 14,12 C14,10.9 13.1,10 12,10 Z M12,16 C10.9,16 10,16.9 10,18 C10,19.1 10.9,20 12,20 C13.1,20 14,19.1 14,18 C14,16.9 13.1,16 12,16 Z",
						id: "Shape",
						transform: "translate(12.000000, 12.000000) rotate(90.000000) translate(-12.000000, -12.000000) "
					})
				})
			})
		})
	})]
}), rC = (e) => /* @__PURE__ */ (0, Q.jsx)("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "0 0 24 24",
	...e,
	children: /* @__PURE__ */ (0, Q.jsx)("path", {
		stroke: "#3B444C",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "m4.5 3.75 15 16.5m-4.977-5.475a3.75 3.75 0 0 1-5.046-5.55m-2.54-2.794C3.115 8.366 1.5 12 1.5 12s3 6.75 10.5 6.75a11.088 11.088 0 0 0 5.062-1.181m2.495-1.716C21.601 14.023 22.5 12 22.5 12s-3-6.75-10.5-6.75a11.75 11.75 0 0 0-1.939.157m2.645 2.91a3.752 3.752 0 0 1 3.028 3.33",
		vectorEffect: "non-scaling-stroke"
	})
}), iC = ({ selectedTab: e, isApprovalPending: t, hasPublishedConfig: n }) => {
	switch (e) {
		case pl.COMPARE: return {
			label: t ? "Compare & Approve" : "Compare",
			icon: "ic-arrows-left-right"
		};
		case pl.EDIT_DRAFT: return {
			label: "Edit Draft",
			icon: "ic-pencil"
		};
		case pl.PUBLISHED: return {
			label: n ? "Published" : "Yet to Publish",
			icon: n ? "ic-check" : "ic-timeout-dash"
		};
		default: return {
			label: "Values",
			icon: null
		};
	}
}, aC = (e, t, n, r) => e ? {
	text: t ? "Show locked keys" : "Hide locked keys",
	dataTestId: `${t ? "show" : "hide"}-locked-keys-popup-button`,
	icon: t ? /* @__PURE__ */ (0, Q.jsx)(Qt, { className: "icon-dim-16 scn-8 dc__no-shrink" }) : /* @__PURE__ */ (0, Q.jsx)(rC, { className: "icon-dim-16 scn-8 dc__no-shrink" }),
	onClick: () => r(!t),
	disabled: n
} : null, oC = (e, t) => ({
	text: "Discard draft",
	dataTestId: "discard-draft-popup-button",
	icon: /* @__PURE__ */ (0, Q.jsx)(eC, { className: "icon-dim-16 dc__no-shrink" }),
	onClick: (t) => {
		uf(t), e();
	},
	disabled: t
}), sC = (e, t) => ({
	text: "Show activity history",
	dataTestId: "show-activity-history-popup-button",
	icon: /* @__PURE__ */ (0, Q.jsx)(tC, { className: "icon-dim-16 dc__no-shrink scn-8" }),
	onClick: (t) => {
		uf(t), e();
	},
	disabled: t
}), cC = () => /* @__PURE__ */ (0, Q.jsx)("button", {
	className: "flex dc__no-shrink icon-dim-20 p-0 dc__no-background dc__no-border dc__outline-none-imp dc__tab-focus dc__hover-n50",
	type: "button",
	"aria-label": "Open/Close Config toolbar options menu",
	children: /* @__PURE__ */ (0, Q.jsx)(nC, {
		className: "icon-dim-16 fcn-6 dc__flip-90",
		"data-testid": "config-more-options-popup"
	})
}), lC = (e, t) => ({
	text: `Express delete${t ? " override" : ""}`,
	dataTestId: "express-delete-popup-button",
	icon: /* @__PURE__ */ (0, Q.jsx)(z, {
		name: "ic-delete-lightning",
		color: "R500"
	}),
	variant: "negative",
	onClick: (t) => {
		uf(t), e();
	}
}), uC = ({ selectedTab: e, handleProtectionViewTabChange: t, isApprovalPending: n = !1, hasPublishedConfig: r = !1, isDisabled: i, parsingError: a, restoreLastSavedYAML: o }) => {
	let s = (e) => () => {
		t(e);
	}, c = Object.values(pl).map((t) => {
		let { icon: c, label: l } = iC({
			selectedTab: t,
			isApprovalPending: n,
			hasPublishedConfig: r
		});
		return {
			icon: c,
			label: l,
			id: `visit-${t}`,
			active: e === t,
			tabType: "button",
			disabled: i,
			shouldWrapTooltip: !!a,
			tooltipProps: {
				alwaysShowTippyOnHover: !0,
				interactive: !0,
				content: ud({
					parsingError: a,
					restoreLastSavedYAML: o
				})
			},
			props: {
				onClick: s(t),
				"data-testid": `visit-${t}`
			}
		};
	});
	return /* @__PURE__ */ (0, Q.jsx)(nu, {
		size: I.medium,
		tabs: c
	});
}, dC = ({ activityList: e, loadingActivityList: t, reloadActivityList: n, activityListError: r, handleClearPopupNode: i }) => {
	let { email: a } = Ff();
	return /* @__PURE__ */ (0, Q.jsx)(su, {
		theme: cu.white,
		heading: "Activity history",
		className: "w-300 h-100",
		iconClass: "scv-5",
		showCloseButton: !0,
		interactive: !0,
		visible: !0,
		onClose: i,
		additionalContent: /* @__PURE__ */ (0, Q.jsx)("div", {
			className: "dc__overflow-auto mxh-250 br-4 bg__primary flexbox-col",
			children: /* @__PURE__ */ (0, Q.jsx)($a, {
				isLoading: t,
				error: r,
				genericSectionErrorProps: { reload: n },
				children: e?.length ? /* @__PURE__ */ (0, Q.jsx)("ol", {
					className: "pt-8 pl-0 mb-0 ml-12 pr-12 dc__list-style-none dc__border-left",
					children: e.map((t, n) => /* @__PURE__ */ (0, Q.jsxs)("li", {
						className: "flex left dc__gap-12 top pb-8 fs-12 fw-4 lh-20 cn-9",
						children: [/* @__PURE__ */ (0, Q.jsx)("div", { className: "icon-dim-8 bcn-3 br-16 mt-6 ml--4" }), /* @__PURE__ */ (0, Q.jsxs)("div", {
							className: "flex top left dc__content-space dc__gap-8 w-100",
							children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
								className: "flex column left",
								children: [/* @__PURE__ */ (0, Q.jsx)("span", {
									className: "fw-6",
									children: n === e.length - 1 ? "Draft created" : "Updated"
								}), /* @__PURE__ */ (0, Q.jsx)("span", { children: t.userEmail === a ? "You" : t.userEmail })]
							}), /* @__PURE__ */ (0, Q.jsx)("span", {
								className: "cn-7",
								children: (0, Op.default)(t.activityTime).format(ss.TWELVE_HOURS_FORMAT)
							})]
						})]
					}, `${t.activityTime.toString()}-${n}`))
				}) : /* @__PURE__ */ (0, Q.jsx)(lc, {
					title: "No activity found",
					description: "No activity found for this draft. Activity will be recorded when you make changes to the draft.",
					reload: n,
					useInfoIcon: !0
				})
			})
		}),
		placement: "bottom-end",
		children: cC()
	});
}, fC = ({ popupNodeType: e, handleClearPopupNode: t, draftId: n, draftVersionId: r, handleReload: i }) => {
	let [a, o] = j(!1), [s, c, l, u] = hf(() => qS(+n), [n, e], !!n && e === ts.EDIT_HISTORY);
	return e ? e === ts.DISCARD_DRAFT ? /* @__PURE__ */ (0, Q.jsx)(vi, {
		handleDiscardDraft: async () => {
			o(!0);
			try {
				await JS(n, r, Ps.Discarded), H.showToast({
					variant: U.success,
					description: "Draft discarded successfully"
				}), t(), i();
			} catch (e) {
				Xr(e);
			} finally {
				o(!1);
			}
		},
		handleClearPopupNode: t,
		isDraftDeleting: a,
		placement: "bottom-end",
		approvalType: ye.Config,
		children: cC()
	}) : e === ts.EDIT_HISTORY ? /* @__PURE__ */ (0, Q.jsx)(dC, {
		activityList: c,
		loadingActivityList: s,
		reloadActivityList: u,
		activityListError: l,
		handleClearPopupNode: t
	}) : null : null;
}, pC = async ({ values: e, mergeStrategy: t = Zc.PATCH, resourceType: n, appId: r, envId: i, resourceId: a, resourceName: o, signal: s, shouldShowError: c = !0 }) => {
	try {
		let { result: c } = await nf(O.CONFIG_OPERATIONS, {
			values: e,
			mergeStrategy: t,
			resourceType: n,
			appId: r,
			resourceId: a,
			resourceName: o,
			envId: i
		}, { signal: s });
		return c?.mergedValues || [];
	} catch (e) {
		throw !pd(e) && c && K(e), e;
	}
}, mC = ({ isInheriting: e, handleSetIsInheriting: t, useRemoteCache: n, handleSetUseRemoteCache: r, isBlobStorageConfigured: i }) => /* @__PURE__ */ (0, Q.jsxs)("div", {
	className: "flexbox-col dc__gap-4",
	children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox dc__content-space dc__align-items-center",
		children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flex dc__gap-6",
			children: [/* @__PURE__ */ (0, Q.jsx)("h3", {
				className: "dc__uppercase cn-6 fs-12 lh-20 fw-6 m-0",
				children: "Docker layer caching"
			}), /* @__PURE__ */ (0, Q.jsx)(su, {
				theme: cu.white,
				className: "flex w-300 h-100",
				placement: "bottom",
				Icon: jt,
				iconClass: "fcb-5",
				heading: "Docker layer caching",
				infoText: "\n                            Docker images are built layer by layer.\n                            Docker's layer caching mechanism allows unchanged layers to be\n                            reused across pipeline runs, drastically reducing build times.\n                        ",
				showCloseButton: !0,
				trigger: "click",
				interactive: !0,
				children: /* @__PURE__ */ (0, Q.jsx)("div", { children: /* @__PURE__ */ (0, Q.jsx)(m, { className: "icon-dim-16 fcn-6 cursor dc__no-shrink flex" }) })
			})]
		}), /* @__PURE__ */ (0, Q.jsx)(bs, {
			name: "workflow-cache-inheriting-toggle",
			ariaLabel: "Toggle to inherit cache settings from global configuration",
			tooltipContent: `${e ? "Inheriting" : "Not inheriting"} from global`,
			isChecked: e,
			shape: "square",
			variant: "theme",
			iconName: "ic-world-globe",
			onChange: t
		})]
	}), /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox-col dc__gap-8",
		children: [/* @__PURE__ */ (0, Q.jsx)(Wo, {
			value: Io.CHECKED,
			isChecked: n,
			onChange: r,
			rootClassName: "mb-0 py-6",
			name: "use-remote-cache-checkbox",
			dataTestId: "use-remote-cache-checkbox",
			disabled: e,
			children: /* @__PURE__ */ (0, Q.jsx)(W, {
				content: "Using remote cache reduces pipeline run time",
				alwaysShowTippyOnHover: !0,
				placement: "right",
				children: /* @__PURE__ */ (0, Q.jsx)("span", {
					className: "dc__underline-dotted fs-13 cn-9 lh-20",
					children: "Use remote cache"
				})
			})
		}), !i && /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox-col dc__gap-8 py-8 px-12 br-4 ey-2 bcy-1 dc__align-start",
			children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox dc__gap-8 dc__align-start",
				children: [/* @__PURE__ */ (0, Q.jsx)("span", {
					className: "cn-9 fs-13 fw-4 lh-20",
					children: "Setup blob storage to use cache"
				}), /* @__PURE__ */ (0, Q.jsx)(gi, { className: "icon-dim-20 m-2 dc__no-shrink flex" })]
			}), /* @__PURE__ */ (0, Q.jsx)(Ns, {
				docLinkKey: "BLOB_STORAGE",
				text: Hs.ARTIFACTS_EMPTY_STATE_TEXTS.ConfigureBlobStorage,
				dataTestId: "configure-blob-storage",
				showExternalIcon: !0,
				openInNewTab: !0
			})]
		})]
	})]
}), hC = (e) => /* @__PURE__ */ (0, Q.jsxs)("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...e,
	children: [
		/* @__PURE__ */ (0, Q.jsx)("path", {
			d: "M7.97088 6.80426L7.24512 3.89338L4.33423 4.61914",
			stroke: "#1DAD70",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			d: "M7.75093 19.0716C6.82227 18.5136 6.01261 17.7781 5.36818 16.9072C4.72375 16.0363 4.25716 15.047 3.99506 13.9958C3.73296 12.9446 3.68048 11.852 3.84062 10.7805C4.00076 9.70899 4.37037 8.67952 4.92837 7.75086L7.24604 3.89361",
			stroke: "#1DAD70",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			d: "M16.0281 17.1954L16.7539 20.1063L19.6648 19.3806",
			stroke: "#1DAD70",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			d: "M16.2491 4.92825C17.1777 5.48625 17.9874 6.22169 18.6318 7.0926C19.2763 7.9635 19.7428 8.95281 20.0049 10.004C20.267 11.0553 20.3195 12.1478 20.1594 13.2193C19.9993 14.2908 19.6296 15.3203 19.0716 16.2489L16.754 20.1062",
			stroke: "#1DAD70",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			d: "M15 9.75049L11 13.7503L9 11.7505",
			stroke: "#1DAD70",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
}), gC = ({ areConfigurationsDrifted: e, appName: t, appId: n, envId: r }) => {
	let { setTempAppWindowConfig: i } = Tf(), a = /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox-col",
		children: [/* @__PURE__ */ (0, Q.jsx)("span", {
			className: "fs-12 fw-6 lh-18",
			children: e ? "Configuration drift" : "Configurations in sync"
		}), /* @__PURE__ */ (0, Q.jsx)("span", {
			className: "fs-12 fw-4 lh-18 dc__word-break",
			children: e ? "Config drift detected between live & desired manifests" : "Live & desired manifests are in sync"
		})]
	});
	return /* @__PURE__ */ (0, Q.jsx)(M, {
		ariaLabel: "config-drift-status",
		dataTestId: "config-drift-status",
		icon: e ? /* @__PURE__ */ (0, Q.jsx)(ga, {}) : /* @__PURE__ */ (0, Q.jsx)(hC, {}),
		variant: F.borderLess,
		size: I.xl,
		showTooltip: !0,
		tooltipProps: {
			content: a,
			placement: "top",
			className: "w-250"
		},
		style: e ? P.warning : P.positive,
		onClick: (e) => {
			e.stopPropagation(), i({
				open: !0,
				title: `${t} / Live and desired manifest comparison`,
				component: /* @__PURE__ */ (0, Q.jsx)($i, {
					appId: n,
					envId: r
				})
			});
		}
	});
}, _C = (e) => /* @__PURE__ */ (0, Q.jsxs)("svg", {
	width: 100,
	height: 60,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [
		/* @__PURE__ */ (0, Q.jsx)("style", { children: "\n    .svg__rhombus-group {\n      animation: animate 2s infinite linear;\n    }\n\n    @keyframes animate {\n      0% {\n    transform: translateX(0px);\n      }\n      100% {\n    transform: translateX(15px);\n      }\n    }\n  " }),
		/* @__PURE__ */ (0, Q.jsxs)("g", {
			clipPath: "url(#clip0_10756_14127)",
			children: [/* @__PURE__ */ (0, Q.jsx)("rect", {
				width: 240,
				height: 60,
				fill: "var(--Y200)"
			}), /* @__PURE__ */ (0, Q.jsxs)("g", {
				className: "svg__rhombus-group",
				children: [
					/* @__PURE__ */ (0, Q.jsx)("path", {
						d: "M-27.5 0H-20L-32.5 60H-40L-27.5 0Z",
						fill: "var(--border-secondary-translucent)"
					}),
					/* @__PURE__ */ (0, Q.jsx)("path", {
						d: "M-12.5 0H-5L-17.5 60H-25L-12.5 0Z",
						fill: "var(--border-secondary-translucent)"
					}),
					/* @__PURE__ */ (0, Q.jsx)("path", {
						d: "M2.5 0H10L-2.5 60H-10L2.5 0Z",
						fill: "var(--border-secondary-translucent)"
					}),
					/* @__PURE__ */ (0, Q.jsx)("path", {
						d: "M17.5 0H25L12.5 60H5L17.5 0Z",
						fill: "var(--border-secondary-translucent)"
					}),
					/* @__PURE__ */ (0, Q.jsx)("path", {
						d: "M32.5 0H40L27.5 60H20L32.5 0Z",
						fill: "var(--border-secondary-translucent)"
					}),
					/* @__PURE__ */ (0, Q.jsx)("path", {
						d: "M47.5 0H55L42.5 60H35L47.5 0Z",
						fill: "var(--border-secondary-translucent)"
					}),
					/* @__PURE__ */ (0, Q.jsx)("path", {
						d: "M62.5 0H70L57.5 60H50L62.5 0Z",
						fill: "var(--border-secondary-translucent)"
					}),
					/* @__PURE__ */ (0, Q.jsx)("path", {
						d: "M77.5 0H85L72.5 60H65L77.5 0Z",
						fill: "var(--border-secondary-translucent)"
					}),
					/* @__PURE__ */ (0, Q.jsx)("path", {
						d: "M92.5 0H100L87.5 60H80L92.5 0Z",
						fill: "var(--border-secondary-translucent)"
					}),
					/* @__PURE__ */ (0, Q.jsx)("path", {
						d: "M107.5 0H115L102.5 60H95L107.5 0Z",
						fill: "var(--border-secondary-translucent)"
					}),
					/* @__PURE__ */ (0, Q.jsx)("path", {
						d: "M122.5 0H130L117.5 60H110L122.5 0Z",
						fill: "var(--border-secondary-translucent)"
					}),
					/* @__PURE__ */ (0, Q.jsx)("path", {
						d: "M137.5 0H145L132.5 60H125L137.5 0Z",
						fill: "var(--border-secondary-translucent)"
					}),
					/* @__PURE__ */ (0, Q.jsx)("path", {
						d: "M152.5 0H160L147.5 60H140L152.5 0Z",
						fill: "var(--border-secondary-translucent)"
					}),
					/* @__PURE__ */ (0, Q.jsx)("path", {
						d: "M167.5 0H175L162.5 60H155L167.5 0Z",
						fill: "var(--border-secondary-translucent)"
					}),
					/* @__PURE__ */ (0, Q.jsx)("path", {
						d: "M182.5 0H190L177.5 60H170L182.5 0Z",
						fill: "var(--border-secondary-translucent)"
					}),
					/* @__PURE__ */ (0, Q.jsx)("path", {
						d: "M197.5 0H205L192.5 60H185L197.5 0Z",
						fill: "var(--border-secondary-translucent)"
					}),
					/* @__PURE__ */ (0, Q.jsx)("path", {
						d: "M212.5 0H220L207.5 60H200L212.5 0Z",
						fill: "var(--border-secondary-translucent)"
					}),
					/* @__PURE__ */ (0, Q.jsx)("path", {
						d: "M227.5 0H235L222.5 60H215L227.5 0Z",
						fill: "var(--border-secondary-translucent)"
					}),
					/* @__PURE__ */ (0, Q.jsx)("path", {
						d: "M242.5 0H250L237.5 60H230L242.5 0Z",
						fill: "var(--border-secondary-translucent)"
					})
				]
			})]
		}),
		/* @__PURE__ */ (0, Q.jsx)("defs", { children: /* @__PURE__ */ (0, Q.jsx)("clipPath", {
			id: "clip0_10756_14127",
			children: /* @__PURE__ */ (0, Q.jsx)("rect", {
				width: 240,
				height: 60,
				fill: "var(--border-secondary-translucent)"
			})
		}) })
	]
}), vC = ({ currentRolloutWeight: e, currentSetWeight: t }) => /* @__PURE__ */ (0, Q.jsxs)("div", {
	className: "dc__position-abs dc__top-0 dc__left-0 w-100 h-100",
	children: [!!e && /* @__PURE__ */ (0, Q.jsx)("div", {
		style: {
			width: `${e}%`,
			background: "linear-gradient(90deg, var(--G100, #E9FBF4) 0%, var(--G200, #B6E9D3) 100%)"
		},
		className: "h-100"
	}), !!t && /* @__PURE__ */ (0, Q.jsx)(_C, {
		style: {
			width: `${t - e}%`,
			left: `${e}%`
		},
		className: "dc__position-abs dc__top-0"
	})]
}), yC = ({ title: e, status: t, subTitle: n, iconName: r, actionButtonConfig: i, renderActionButton: a, currentSetWeight: o, currentRolloutWeight: s }) => {
	let c = window._env_.FEATURE_CANARY_ROLLOUT_PROGRESS_ENABLE;
	return /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox-col bg__primary w-220 br-8 border__primary dc__overflow-hidden shadow__card--10",
		children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox px-12 pt-12 pb-8 dc__content-space dc__position-rel",
			children: [
				(c || s === 100) && !!(s || o) && /* @__PURE__ */ (0, Q.jsx)(vC, {
					currentRolloutWeight: s,
					currentSetWeight: o
				}),
				/* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "dc__position-rel w-100",
					children: [/* @__PURE__ */ (0, Q.jsx)("span", {
						className: "fs-12 fw-4 lh-20 cn-7",
						children: e
					}), /* @__PURE__ */ (0, Q.jsx)("div", {
						className: "fs-13 fw-6 lh-20 cn-9",
						children: t
					})]
				}),
				/* @__PURE__ */ (0, Q.jsx)("div", {
					className: "dc__zi-1",
					children: /* @__PURE__ */ (0, Q.jsx)(z, {
						name: r,
						size: 24,
						color: null
					})
				})
			]
		}), /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "py-7 px-12 flexbox dc__content-space dc__align-item-center border__secondary--top",
			children: [
				n && /* @__PURE__ */ (0, Q.jsx)("span", {
					className: "fs-12 fw-4 lh-20 cn-9 dc__mxw-100 dc__truncate",
					children: n
				}),
				a?.(),
				i && /* @__PURE__ */ (0, Q.jsx)(M, {
					dataTestId: "strategy-action-button",
					text: i.text,
					variant: F.text,
					size: I.small,
					onClick: i.onClick
				})
			]
		})]
	});
}, bC = ({ appId: e, envId: t, appName: n, envName: r, renderRollbackButton: i }) => {
	let [a, o] = j(null), [s, c] = j(!1), { isFetching: l, data: u, error: d, refetch: f } = q({
		queryKey: [
			"app-details-deployment-strategy",
			e,
			t
		],
		queryFn: ({ signal: n }) => Ch({
			appId: e,
			envId: t,
			options: { signal: n }
		}),
		refetchInterval: Number(window._env_.DEVTRON_APP_DETAILS_POLLING_INTERVAL)
	}), p = u?.[0]?.strategy, m = u?.[0]?.error;
	if (l && (!u || m)) return /* @__PURE__ */ (0, Q.jsx)(Nc, {});
	if (p !== "BLUE-GREEN" && p !== "CANARY" || sm(m?.code) || m?.code == eo.FAILED_DEPENDENCY) return null;
	if (d || !u?.length || m) return /* @__PURE__ */ (0, Q.jsx)(yC, {
		title: `${p ? Pl[p] : "Deployment"} Strategy`,
		status: "--",
		subTitle: "Failed to load",
		iconName: p ? fm[p] : "ic-cube",
		actionButtonConfig: {
			text: "Retry",
			onClick: f
		}
	});
	let { phase: h, steps: g, currentStepIndex: _, rolloutIdentifier: v, currentPodHash: y, autoPromotionEnabled: b, promoteFull: x } = u[0], S = h === "Healthy", C = () => {
		o(null);
	}, w = async ({ promoteAction: n, toastConfig: r }) => {
		try {
			c(!0), await wh({
				appId: e,
				envId: t,
				promoteAction: n,
				currentStepIndex: _,
				rolloutName: v.name,
				currentPodHash: y
			}), C(), H.showToast({
				variant: U.success,
				title: r.title,
				description: r.description
			}), await f();
		} catch (e) {
			K(e);
		} finally {
			c(!1);
		}
	}, T = () => {
		Mn.event({
			category: "App details",
			action: "DA_APP_DETAILS_SWAP_TRAFFIC_CLICKED"
		}), o("swapTraffic");
	}, ee = (e) => () => w({
		promoteAction: e,
		toastConfig: {
			title: "Traffic Swap Initiated",
			description: "Switching live traffic from blue to green deployment"
		}
	});
	if (p === "BLUE-GREEN") {
		let e = lm({
			phase: h,
			promoteFull: x,
			autoPromotionEnabled: b,
			renderRollbackButton: i,
			handleOpenSwapTrafficDialog: T
		}), t = h === "Paused" && b || h === "Progressing" && !x;
		return /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsx)(yC, { ...e }), a === "swapTraffic" && /* @__PURE__ */ (0, Q.jsx)(MC, {
			appName: n,
			envName: r,
			handleClose: C,
			handleSwitchTraffic: ee(t ? "promoteFull" : "promoteToNext"),
			isLoading: s,
			...t ? {
				title: `Skip & Promote Full for ${r} on ${n}`,
				primaryButtonText: "Promote to Full"
			} : {}
		})] });
	}
	let { currentRolloutWeight: E, parsedSteps: D, currentSetWeight: te } = am(g, _, h), ne = window._env_.FEATURE_CANARY_ROLLOUT_PROGRESS_ENABLE, re = D[_]?.message || "", ie = ne ? `Live for ${E}% users` : `Completed ${_} of ${D.length} steps`;
	return /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsx)(yC, {
		title: "Canary Strategy",
		iconName: "ic-strategy-canary-color",
		...S ? {
			renderActionButton: i,
			status: "Live for 100% users",
			currentRolloutWeight: 100
		} : {
			actionButtonConfig: {
				text: "Manage Traffic",
				onClick: () => {
					o("manageTraffic");
				}
			},
			status: te ? `Increasing to ${te}%` : ie,
			subTitle: te ? "In Progress" : re,
			currentSetWeight: te,
			currentRolloutWeight: E
		}
	}), a === "manageTraffic" && /* @__PURE__ */ (0, Q.jsx)(SC, {
		appName: n,
		envName: r,
		parsedSteps: D,
		currentStepIndex: _,
		handleClose: C,
		isRolloutComplete: S,
		currentRolloutStatus: ie,
		handleDeploymentPromotion: w
	})] });
}, xC = ({ icon: e, message: t, statusColor: n, promoteFull: r, promoteToNext: i, triggeredState: a }) => {
	let o = n === "O500", s = !!r, c = s ? a === "fullRollout" : a === "nextItem", l = a === "nextStep" || (s ? a === "nextItem" : a === "fullRollout");
	return /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox dc__gap-12",
		children: [/* @__PURE__ */ (0, Q.jsx)("div", {
			className: `flex p-8 br-6 ${o ? "eo-2" : "border__secondary"} bg__modal--primary`,
			children: /* @__PURE__ */ (0, Q.jsx)(z, {
				name: e,
				size: 20,
				color: n
			})
		}), /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: `flexbox dc__content-space px-12 py-8 br-6 w-100 ${o ? "eo-2" : "border__secondary"} bg__modal--primary fs-13 fw-4 lh-1-5 cn-9`,
			children: [/* @__PURE__ */ (0, Q.jsxs)("span", {
				className: "flex dc__gap-4",
				children: [/* @__PURE__ */ (0, Q.jsx)("span", { children: t }), o && /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsx)("span", { children: "•" }), /* @__PURE__ */ (0, Q.jsx)("span", {
					className: "co-5",
					children: "In Progress"
				})] })]
			}), (!o && s || !!i) && /* @__PURE__ */ (0, Q.jsx)(M, {
				dataTestId: s ? "Rollout full" : "Rollout to next",
				text: s ? "Rollout to 100%" : "Trigger step",
				variant: F.text,
				size: I.medium,
				startIcon: /* @__PURE__ */ (0, Q.jsx)(z, {
					name: s ? "ic-fast-forward" : "ic-play-outline",
					color: null
				}),
				onClick: s ? r : i,
				isLoading: c,
				disabled: l
			})]
		})]
	});
}, SC = ({ appName: e, envName: t, isRolloutComplete: n, handleClose: r, parsedSteps: i, currentStepIndex: a, currentRolloutStatus: o, handleDeploymentPromotion: s }) => {
	let [c, l] = j(null), u = async () => {
		Mn.event({
			category: "App Details Manage Traffic",
			action: "DA_APP_DETAILS_MANAGE_TRAFFIC_FULL_CLICKED"
		}), l("fullRollout"), await s({
			promoteAction: "promoteFull",
			toastConfig: { description: "Triggered Rollout to last step" }
		}), l(null);
	}, d = async () => {
		Mn.event({
			category: "App Details Manage Traffic",
			action: "DA_APP_DETAILS_MANAGE_TRAFFIC_NEXT_CLICKED"
		}), await s({
			promoteAction: "promoteToNext",
			toastConfig: { description: "Triggered rollout to next step" }
		});
	}, f = async () => {
		l("nextItem"), await d(), l(null);
	}, p = async () => {
		l("nextStep"), await d(), l(null);
	}, m = i.length, h = n ? m : a;
	return /* @__PURE__ */ (0, Q.jsx)(Rs, {
		position: "right",
		width: "800px",
		onClose: r,
		children: /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox-col h-100 bg__modal--primary",
			onClick: uf,
			children: [
				/* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "flexbox dc__content-space dc__align-items-center px-20 py-12 border__primary--bottom",
					children: [/* @__PURE__ */ (0, Q.jsxs)("div", { children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
						className: "flexbox dc__gap-4 fs-12 lh-1-5 fw-4 cn-7",
						children: [
							/* @__PURE__ */ (0, Q.jsx)("span", {
								className: "dc__mxw-120 dc__truncate",
								children: e
							}),
							/* @__PURE__ */ (0, Q.jsx)("span", {
								className: "cn-6",
								children: "/"
							}),
							/* @__PURE__ */ (0, Q.jsx)("span", { children: t })
						]
					}), /* @__PURE__ */ (0, Q.jsx)("span", {
						className: "fs-16 fw-6 lh-1-5 cn-9",
						children: "Manage Canary Traffic"
					})] }), /* @__PURE__ */ (0, Q.jsx)(M, {
						dataTestId: "close-manage-traffic",
						icon: /* @__PURE__ */ (0, Q.jsx)(z, {
							name: "ic-close-large",
							color: null
						}),
						style: P.negativeGrey,
						ariaLabel: "close manage traffic drawer",
						showAriaLabelInTippy: !1,
						size: I.xs,
						variant: F.borderLess,
						onClick: r
					})]
				}),
				/* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "flexbox-col dc__gap-24 p-20 flex-grow-1 mh-0 dc__overflow-auto bg__modal--secondary",
					children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
						className: `${n ? "" : "dc__grid-half"} br-8 border__primary bg__modal--primary shadow__card--20`,
						children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
							className: "p-20 flexbox dc__content-space",
							children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
								className: "flexbox-col",
								children: [/* @__PURE__ */ (0, Q.jsx)("span", {
									className: "fs-13 fw-4 lh-1-5 cn-7",
									children: "Rollout Status"
								}), /* @__PURE__ */ (0, Q.jsx)("span", {
									className: "fs-20 fw-6 lh-1-5 cn-9",
									children: o
								})]
							}), /* @__PURE__ */ (0, Q.jsx)(z, {
								name: "ic-users",
								color: "B500",
								size: 24
							})]
						}), !n && /* @__PURE__ */ (0, Q.jsxs)("div", {
							className: "p-20 flexbox dc__content-space border__secondary--left",
							children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
								className: "flexbox-col",
								children: [/* @__PURE__ */ (0, Q.jsx)("span", {
									className: "fs-13 fw-4 lh-1-5 cn-7",
									children: "Canary Step in progress"
								}), /* @__PURE__ */ (0, Q.jsx)("span", {
									className: "fs-20 fw-6 lh-1-5 cn-9",
									children: i[h].message
								})]
							}), /* @__PURE__ */ (0, Q.jsx)(z, {
								name: i[h].iconName,
								color: "O500",
								size: 24
							})]
						})]
					}), /* @__PURE__ */ (0, Q.jsxs)("div", {
						className: "flexbox-col dc__gap-16",
						children: [/* @__PURE__ */ (0, Q.jsxs)("span", {
							className: "flexbox dc__gap-4 fs-13 fw-6 lh-1-5",
							children: [
								/* @__PURE__ */ (0, Q.jsx)("span", { children: "Canary Steps" }),
								/* @__PURE__ */ (0, Q.jsx)("span", { children: "•" }),
								/* @__PURE__ */ (0, Q.jsx)("span", { children: `Completed ${h} of ${m}` })
							]
						}), /* @__PURE__ */ (0, Q.jsx)("div", { children: i.map(({ message: e, iconName: t, isFullRollout: n }, r) => /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsx)(xC, {
							icon: t,
							message: e,
							statusColor: om(r, h),
							triggeredState: c,
							...r === h + 1 ? { promoteToNext: f } : {},
							...n ? { promoteFull: u } : {}
						}, `${e}-${r}`), r !== m - 1 && /* @__PURE__ */ (0, Q.jsx)("div", { className: `ml-18 h-16 border__primary${r < h ? "" : "--dashed"}--left` })] })) })]
					})]
				}),
				" ",
				!n && h < m - 1 && /* @__PURE__ */ (0, Q.jsx)("div", {
					className: "px-20 py-16 flexbox dc__content-end border__primary--top",
					children: /* @__PURE__ */ (0, Q.jsx)(M, {
						dataTestId: "rollout-to-next-step",
						text: "Trigger next step",
						startIcon: /* @__PURE__ */ (0, Q.jsx)(z, {
							name: "ic-play-outline",
							color: null
						}),
						onClick: p,
						isLoading: c === "nextStep",
						disabled: c === "nextItem" || c === "fullRollout"
					})
				})
			]
		})
	});
}, CC = ({ chartName: e, handleClose: t }) => {
	let n = X();
	return /* @__PURE__ */ (0, Q.jsx)(ns, {
		variant: rs.info,
		title: `Hibernation patch not available for ‘${e}’ chart`,
		subtitle: "Hibernation patch is applied on the deployment template to perform hibernation actions.",
		buttonConfig: {
			secondaryButtonConfig: {
				text: "Cancel",
				onClick: t
			},
			primaryButtonConfig: {
				text: "Configure patch",
				onClick: () => {
					n(`${B.APPLICATION_MANAGEMENT_CONFIGURATIONS.DEPLOYMENT_CHARTS}/${e}/${D.HIBERNATION_PATCH}`);
				}
			}
		},
		handleClose: t,
		children: /* @__PURE__ */ (0, Q.jsx)("span", {
			className: "fs-13",
			children: "Please update the hibernation patch and try again."
		})
	});
}, wC = (e) => /* @__PURE__ */ (0, Q.jsx)("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	...e,
	children: /* @__PURE__ */ (0, Q.jsx)("path", {
		d: "M8.00001 14C10.4853 14 12.5 11.9853 12.5 9.50001V6.5C12.5 4.01472 10.4853 2 8 2C5.51472 2 3.5 4.01472 3.5 6.5V9.50001C3.5 11.9853 5.51472 14 8.00001 14ZM8.00001 14L8 8.5M2 10.5H3.61153M2 6.5H14M12.3885 10.5H14M3.49561 1.75L4.98094 3.16303M12.4956 1.75L11.0146 3.15896",
		stroke: "#3B444C",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), TC = "Check vulnerabilities", EC = ({ handleShowVulnerabilityModal: e }) => /* @__PURE__ */ (0, Q.jsx)(ft, {
	className: "default-tt",
	arrow: !1,
	content: TC,
	placement: "left",
	children: /* @__PURE__ */ (0, Q.jsx)("button", {
		type: "button",
		className: "dc__unset-button-styles",
		onClick: e,
		"data-testid": "open-vulnerability-modal-button",
		children: /* @__PURE__ */ (0, Q.jsxs)("span", {
			className: "flex left h-32 cursor pl-12 pr-12 dc__hover-n50 dc__no-decor dc__gap-8",
			children: [/* @__PURE__ */ (0, Q.jsx)(wC, { className: "icon-dim-16 dc__no-shrink" }), /* @__PURE__ */ (0, Q.jsx)("span", {
				className: "cn-9 dc__ellipsis-right",
				children: TC
			})]
		})
	})
});
//#endregion
//#region src/Pages/App/AppDetails/Security/utils.tsx
$e();
var DC = (e) => {
	let t = kd(e?.vulnerabilities || []);
	return {
		...e || {},
		lastExecution: e?.executionTime && e.executionTime !== Eu ? l(e.executionTime).format(cs) : "",
		severityCount: {
			critical: e?.severityCount?.critical ?? 0,
			high: e?.severityCount?.high ?? 0,
			medium: e?.severityCount?.medium ?? 0,
			low: e?.severityCount?.low ?? 0,
			unknown: e?.severityCount?.unknown ?? 0
		},
		vulnerabilities: t.map((e) => ({
			name: e.cveName,
			severity: e.severity,
			package: e.package,
			version: e.currentVersion,
			fixedVersion: e.fixedVersion,
			policy: e.permission
		}))
	};
}, OC = async ({ name: e, namespace: t, clusterId: n, group: r, version: i, kind: a, appId: o, appType: s, deploymentType: c, isAppDetailView: l }) => {
	let u = {
		k8sRequest: { resourceIdentifier: {
			groupVersionKind: {
				Group: r || "",
				Version: i || "v1",
				Kind: a
			},
			namespace: t,
			name: e
		} },
		clusterId: n ? +n : 0
	}, d = l ? {
		...u,
		appId: o,
		appType: s,
		deploymentType: c
	} : u, f = await nf(O.K8S_RESOURCE_SECURITY, d), p = f.result?.map((e) => ({
		...e,
		scanResult: DC(e.scanResult)
	})) ?? [];
	return f.result = tf({
		...Fd(p),
		imageVulnerabilities: p
	}), f;
}, kC = async ({ appId: e, envId: t, abortControllerRef: n }) => {
	let r = {
		appId: e,
		envId: t
	};
	return (await G(Rd(O.POLICY_CONSEQUENCES, r), { abortControllerRef: n })).result;
}, AC = ({ appId: e, envId: t, pcoId: n }) => nf(O.SWITCH_TRAFFIC, {
	appId: e,
	envId: t,
	pcoId: n
}), jC = (e) => /* @__PURE__ */ (0, Q.jsxs)("svg", {
	width: 48,
	height: 48,
	viewBox: "0 0 48 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [
		/* @__PURE__ */ (0, Q.jsx)("rect", {
			x: 4,
			y: 24,
			width: 16,
			height: 10,
			rx: 2,
			fill: "#0066CC",
			fillOpacity: .3,
			stroke: "#0066CC",
			strokeWidth: 2
		}),
		/* @__PURE__ */ (0, Q.jsx)("rect", {
			x: 4,
			y: 34,
			width: 16,
			height: 10,
			rx: 2,
			fill: "#0066CC",
			fillOpacity: .3,
			stroke: "#0066CC",
			strokeWidth: 2
		}),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			d: "M9 29H11",
			stroke: "#0066CC",
			strokeWidth: 2,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			d: "M9 39H11",
			stroke: "#0066CC",
			strokeWidth: 2,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ (0, Q.jsx)("rect", {
			x: 28,
			y: 24,
			width: 16,
			height: 10,
			rx: 2,
			fill: "#1DAD70",
			fillOpacity: .15,
			stroke: "#1DAD70",
			strokeWidth: 2,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ (0, Q.jsx)("rect", {
			x: 28,
			y: 34,
			width: 16,
			height: 10,
			rx: 2,
			fill: "#1DAD70",
			fillOpacity: .15,
			stroke: "#1DAD70",
			strokeWidth: 2,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			d: "M33 29H35",
			stroke: "#1DAD70",
			strokeWidth: 2,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			d: "M33 39H35",
			stroke: "#1DAD70",
			strokeWidth: 2,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			d: "M27.812 13.7026H35M35 13.7026V6.51465M35 13.7026L31.406 10.1087C29.8981 8.60082 27.9769 7.57394 25.8854 7.15791C23.7939 6.74189 21.626 6.95541 19.6559 7.77147C17.6857 8.58753 16.0018 9.96948 14.8171 11.7426C13.6323 13.5156 13 15.6002 13 17.7327",
			stroke: "#3B444C",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
}), MC = ({ appName: e, envName: t, title: n, isLoading: r, handleClose: i, handleSwitchTraffic: a, primaryButtonText: o }) => /* @__PURE__ */ (0, Q.jsx)(ns, {
	variant: rs.custom,
	Icon: /* @__PURE__ */ (0, Q.jsx)(jC, {}),
	title: n ?? `Swap live traffic for ‘${e}’ on ‘${t}’`,
	subtitle: "This will route the end user traffic to the application’s new deployment on this environment. Are you sure?",
	confirmationConfig: {
		confirmationKeyword: t,
		identifier: "swap-traffic-confirmation-input"
	},
	buttonConfig: {
		secondaryButtonConfig: {
			text: "Cancel",
			onClick: i
		},
		primaryButtonConfig: {
			text: o ?? "Swap traffic",
			onClick: a,
			isLoading: r
		}
	},
	handleClose: i
}), NC = ({ appId: e, envId: t, appName: n, envName: r, pcoId: i }) => {
	let [a, o] = j(!1), [s, c] = j(!1), [l, u] = j(!1), d = () => {
		o(!0);
	}, f = () => {
		o(!1);
	}, p = () => {
		u(!0), H.showToast({
			variant: U.success,
			title: "Traffic swap initiated",
			description: "Switching live traffic from blue to green deployment"
		}), f();
	};
	return /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [!l && /* @__PURE__ */ (0, Q.jsx)(M, {
		dataTestId: "app-details-swap-traffic",
		size: I.medium,
		variant: F.secondary,
		text: "Swap traffic",
		startIcon: /* @__PURE__ */ (0, Q.jsx)(Ar, {}),
		onClick: d,
		component: N.button,
		style: P.default
	}), a && !l && /* @__PURE__ */ (0, Q.jsx)(MC, {
		appName: n,
		envName: r,
		isLoading: s,
		handleClose: f,
		handleSwitchTraffic: async () => {
			c(!0);
			try {
				await AC({
					appId: e,
					envId: t,
					pcoId: i
				}), p();
			} catch (e) {
				K(e);
			} finally {
				c(!1);
			}
		}
	})] });
}, PC = ({ handleTemplateClick: e }) => {
	let { searchKey: t, handleSearch: n, clearFilters: r } = Mf(), { isTemplateListLoading: i, templateList: a, templateListError: o, reloadTemplateList: s } = b({ handleTemplateClick: e });
	return /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flex-grow-1 flexbox-col dc__overflow-auto",
		children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox-col dc__gap-12 pt-20 px-20",
			children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flex dc__content-space",
				children: [/* @__PURE__ */ (0, Q.jsx)("h2", {
					className: "m-0 fs-15 lh-1-5 fw-6 cn-9",
					children: "Choose an application template"
				}), /* @__PURE__ */ (0, Q.jsx)(M, {
					dataTestId: "create-app-modal-create-template-btn",
					component: N.link,
					variant: F.text,
					text: "Create Template",
					linkProps: {
						to: B.APP_TEMPLATE_CREATE,
						target: "_blank"
					},
					startIcon: /* @__PURE__ */ (0, Q.jsx)(E, {})
				})]
			}), !o && !!a.length && /* @__PURE__ */ (0, Q.jsx)(Il, {
				dataTestId: "template-list-search",
				initialSearchText: t,
				size: I.medium,
				handleEnter: n,
				inputProps: { placeholder: "Search templates" }
			})]
		}), /* @__PURE__ */ (0, Q.jsx)("div", {
			className: "flex-grow-1 flexbox-col dc__gap-12 p-20 dc__overflow-auto",
			children: /* @__PURE__ */ (0, Q.jsx)(g, {
				borderVariant: sc.ROUNDED,
				list: a,
				searchKey: t,
				isLoading: i,
				error: o,
				reloadList: s,
				handleClearFilters: r,
				emptyStateConfig: {
					title: "Add your first app template",
					subTitle: De.FEATURE_DESCRIPTION
				}
			})
		})]
	});
}, FC = "Promote", IC = {
	APPROVER_INFO_MESSAGE: "'Approver' role can be provided to users via",
	PERMISSIONS: "User Permissions.",
	NO_APPROVER_INFO_MESSAGE: "No users have 'Approver' permission for this application and environment. 'Approver' role can be provided to users via",
	APPROVER_GROUPS: {
		USER: "Users",
		TOKEN: "API Tokens"
	},
	getTotalApproversText: (e) => `${e} approver(s)`,
	getRequiredApproversText: (e) => `At least ${e} approval(s) are required.`
}, LC = "workflow/:workflowId/:useImageListType/:imageListTab", RC = ({ workflowId: e }) => {
	let t = Y(`${Yf().pathname}/${LC}`, {
		workflowId: e,
		imageListTab: ae.REQUEST,
		useImageListType: Ze.BULK_DEPLOY
	});
	return /* @__PURE__ */ (0, Q.jsx)(Wf, {
		to: t,
		onClick: () => {
			Mn.event({
				category: "devtron-apps-workflow",
				action: "deploy-to-button-clicked"
			});
		},
		className: "flexbox dc__gap-4 dc__align-items-start anchor",
		"data-testid": "bulk-deploy__link",
		children: /* @__PURE__ */ (0, Q.jsx)("span", {
			className: "m-0 fs-13 fw-6 lh-20 flex",
			children: "Deploy to..."
		})
	});
}, zC = ({ pipelineIds: e, deploymentStrategy: t, setDeploymentStrategy: n, isBulkStrategyChange: r, possibleStrategyOptions: i, pipelineStrategiesLoading: a, pipelineStrategiesError: o, reloadPipelineStrategies: s }) => {
	let [c, l, u, d] = hf(() => dm(e), [], !!r), f = A(() => {
		if (r) {
			let e = (l ?? []).flatMap(({ strategies: e, error: t }) => t ? [] : e.map((e) => e.deploymentTemplate));
			return [{
				label: "",
				options: [{
					label: Pl.DEFAULT,
					value: "DEFAULT",
					description: "Default strategy for selected deployments will be used",
					startIcon: /* @__PURE__ */ (0, Q.jsx)(z, {
						name: pm.DEFAULT,
						color: "N800"
					})
				}]
			}, {
				label: "",
				options: Array.from(new Set(e)).map((e) => ({
					label: Pl[e] ?? e,
					value: e,
					startIcon: /* @__PURE__ */ (0, Q.jsx)(z, {
						name: pm[e] ?? "ic-rocket-gear",
						color: "N800"
					})
				}))
			}];
		}
		return [{
			label: "Deployment Strategy",
			options: (i ?? []).map(({ deploymentTemplate: e, default: t }) => ({
				label: `${Pl[e] ?? e} ${t ? " (Default)" : ""}`,
				value: e,
				startIcon: /* @__PURE__ */ (0, Q.jsx)(z, {
					name: pm[e] ?? "ic-rocket-gear",
					color: "N800"
				})
			}))
		}];
	}, [l, i]), p = (e) => {
		Mn.event({
			category: "Deployment strategy selection",
			action: r ? "APP_GROUP_DEPLOY_CHANGED_DEPLOYMENT_STRATEGY" : "DA_DEPLOY_CHANGED_DEPLOYMENT_STRATEGY"
		}), n(e.value);
	};
	k(() => {
		if (!r && i?.length) {
			let e = i.find((e) => e.default)?.deploymentTemplate;
			e && n(e);
		}
	}, [i]);
	let m = c || a;
	return /* @__PURE__ */ (0, Q.jsx)(V, {
		inputId: "select-deployment-strategy",
		options: f,
		size: I.large,
		isLoading: m,
		isDisabled: m,
		placeholder: "Select strategy",
		optionListError: r ? u : o,
		reloadOptionList: r ? d : s,
		value: Dd(f, t, null),
		onChange: p,
		menuSize: I.medium
	});
}, BC = ({ isConfigured: e, isApprovalPendingForPromotion: t, workflowId: n }) => {
	let r = Yf();
	return e ? /* @__PURE__ */ (0, Q.jsxs)(Wf, {
		to: Y(`${r.pathname}/${LC}`, {
			workflowId: n,
			useImageListType: Ze.IMAGE_PROMOTION,
			imageListTab: ae.REQUEST
		}),
		className: "flexbox dc__gap-4 dc__align-items-start anchor",
		children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox dc__align-items-center dc__gap-4",
			children: [/* @__PURE__ */ (0, Q.jsx)(ei, { className: "icon-dim-16 dc__no-shrink" }), /* @__PURE__ */ (0, Q.jsx)("span", {
				className: "m-0 fs-13 fw-6 lh-20 flex",
				children: FC
			})]
		}), t && /* @__PURE__ */ (0, Q.jsx)(oo, { rootClassName: "mt-4" })]
	}) : null;
}, VC = (e) => /* @__PURE__ */ (0, Q.jsx)("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ (0, Q.jsx)("path", {
		d: "M4.00016 8H12.0002M1.3335 5H14.3335M6.50016 11H9.50016",
		stroke: "#596168",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), HC = ({ environmentListResponse: e, shutterOptionTitle: t, handleEnvironmentChange: n }) => {
	let { useImageListType: r, imageListTab: i } = Z(), { environment: a } = Pf({ parseSearchParams: xi }), o = ya(i, a, r), s = hi(e, i, t, r), c = s.filter((e) => e.label).flatMap((e) => e.options).find((e) => e.value === a);
	return /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox dc__gap-8 dc__align-items-center",
		children: [o && /* @__PURE__ */ (0, Q.jsx)("p", {
			className: "m-0 cn-9 fs-13 fw-6 lh-20",
			children: o
		}), /* @__PURE__ */ (0, Q.jsx)("div", {
			className: "w-200",
			children: /* @__PURE__ */ (0, Q.jsx)(V, {
				inputId: "image-list-environment-selector",
				options: s,
				icon: /* @__PURE__ */ (0, Q.jsx)(VC, {}),
				placeholder: wa.ENVIRONMENT_SELECTOR_PLACEHOLDER,
				value: c ?? s[0].options[0],
				onChange: n,
				size: I.medium
			})
		})]
	});
}, UC = (e) => /* @__PURE__ */ (0, Q.jsxs)("svg", {
	width: 21,
	height: 21,
	viewBox: "0 0 21 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [/* @__PURE__ */ (0, Q.jsx)("path", {
		d: "M7.64279 10.076C7.1369 8.81413 7.08221 7.41633 7.48795 6.11883C7.89369 4.82133 8.73499 3.70372 9.86963 2.9549C11.0043 2.20608 12.3627 1.87199 13.7152 2.0091C15.0677 2.14621 16.3314 2.74611 17.2927 3.70739C18.254 4.66868 18.8539 5.93239 18.991 7.28492C19.1281 8.63745 18.794 9.99584 18.0452 11.1305C17.2964 12.2651 16.1787 13.1064 14.8812 13.5121C13.5837 13.9179 12.1859 13.8632 10.9241 13.3573L10.9242 13.3572L9.84399 14.4373H7.87524V16.4061H5.90649V18.3748H2.62524V15.0936L7.64293 10.0759L7.64279 10.076Z",
		stroke: "#3B444C",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ (0, Q.jsx)("path", {
		d: "M14.7656 7.21875C15.3093 7.21875 15.75 6.77803 15.75 6.23438C15.75 5.69072 15.3093 5.25 14.7656 5.25C14.222 5.25 13.7812 5.69072 13.7812 6.23438C13.7812 6.77803 14.222 7.21875 14.7656 7.21875Z",
		fill: "#3B444C"
	})]
}), WC = ({ approverEmails: e }) => {
	let { users: t, apiTokens: n } = e.reduce((e, t) => t.startsWith(to) ? (e.apiTokens.push(t.split(":")[1]), e) : {
		...e,
		users: [...e.users, t]
	}, {
		users: [],
		apiTokens: []
	}), r = () => /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "fs-12 fw-4 bcv-1 cn-9 lh-20 pt-8 pb-8 pl-12 pr-12",
		children: [
			IC.APPROVER_INFO_MESSAGE,
			"\xA0",
			/* @__PURE__ */ (0, Q.jsx)(Wf, {
				to: B.GLOBAL_CONFIG_AUTH.USERS,
				className: "fs-13 cb-5 lh-20 anchor",
				target: "_blank",
				rel: "noopener noreferrer",
				children: IC.PERMISSIONS
			})
		]
	}), i = (e, t) => /* @__PURE__ */ (0, Q.jsx)("ol", {
		className: "pt-8 pl-12 pr-12 dc__list-style-none",
		children: e.sort((e, t) => df(e, t, Jl.ASC, !1)).map((e) => /* @__PURE__ */ (0, Q.jsxs)("li", {
			className: "flex left mb-8 fs-13 fw-4 dc__ellipsis-right",
			children: [t ? /* @__PURE__ */ (0, Q.jsx)(UC, { className: "icon-dim-20 mr-8 dc__no-shrink" }) : Ku(e, "dc__no-shrink"), e.approver ? e.approver : e]
		}, e))
	});
	return /* @__PURE__ */ (0, Q.jsx)("div", {
		className: "h-100 dc__overflow-hidden dc__align-left ",
		children: /* @__PURE__ */ (0, Q.jsx)("div", {
			className: "h-100 mxh-210 dc__overflow-auto",
			children: e.length > 0 ? /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [
				r(),
				t.length > 0 && /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsx)("div", {
					className: "fs-13 fs-13 fw-6 cn-9 pt-12 pl-12",
					children: IC.APPROVER_GROUPS.USER
				}), i(t)] }),
				n.length > 0 && /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsx)("div", {
					className: "fs-13 fw-6 cn-9 mt-12 pl-12",
					children: IC.APPROVER_GROUPS.TOKEN
				}), i(n, !0)] })
			] }) : /* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "fs-13 fw-4 cn-7 lh-20 pl-12 pr-12",
				children: [
					IC.NO_APPROVER_INFO_MESSAGE,
					"\xA0",
					/* @__PURE__ */ (0, Q.jsx)(Wf, {
						to: B.GLOBAL_CONFIG_AUTH.USERS,
						className: "fs-13 cb-5 lh-20 anchor",
						target: "_blank",
						rel: "noopener noreferrer",
						children: IC.PERMISSIONS
					})
				]
			})
		})
	});
}, GC = ({ approverEmails: e = [], requiredApprovalCount: t }) => /* @__PURE__ */ (0, Q.jsxs)("div", {
	className: "flexbox dc__gap-4 pb-12",
	children: [/* @__PURE__ */ (0, Q.jsx)("p", {
		className: "m-0 cn-9 fs-13 fw-4 lh-20",
		children: IC.getRequiredApproversText(t)
	}), /* @__PURE__ */ (0, Q.jsx)(su, {
		theme: cu.white,
		className: "w-300 h-100",
		placement: "bottom",
		Icon: Tt,
		iconClass: "fcv-5",
		heading: IC.getTotalApproversText(e.length),
		additionalContent: /* @__PURE__ */ (0, Q.jsx)(WC, { approverEmails: e }),
		showCloseButton: !0,
		trigger: "click",
		interactive: !0,
		children: /* @__PURE__ */ (0, Q.jsx)("button", {
			type: "button",
			className: "p-0 dc__no-border dc__no-background dc__outline-none-imp dc__tab-focus dc__underline cn-9 fs-13 fw-6 lh-20",
			"data-testid": "configured-approvers-info",
			children: IC.getTotalApproversText(e.length)
		})
	})]
}), KC = ({ promotionRequestedBy: e, currentUserEmail: t, approvedUsersData: n, handleArtifactAction: r, artifactId: i, isLoading: a, promotionRequestId: o }) => {
	let [s, c] = j(!1);
	return /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "h-200 dc__overflow-auto flexbox-col p-12 dc__gap-12",
		children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox-col dc__gap-8",
			children: [
				/* @__PURE__ */ (0, Q.jsx)("h2", {
					className: "m-0 cn-9 fs-13 fw-6 lh-20",
					children: tt.APPROVAL_REQUESTED_BY
				}),
				/* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "flexbox dc__content-space",
					children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
						className: "flexbox dc__gap-8",
						children: [Ku(e, "dc__no-shrink m-0-imp"), /* @__PURE__ */ (0, Q.jsx)("span", {
							className: "fs-13 fw-4 lh-20 m-0 ",
							children: e === t ? tt.SELF_ACTION : e
						})]
					}), !s && e === t && /* @__PURE__ */ (0, Q.jsx)("button", {
						type: "button",
						className: "p-0 cr-5 fs-13 fw-6 lh-20 flex dc__no-border dc__no-background dc__outline-none-imp dc__tab-focus dc__tab-focus",
						onClick: () => {
							c(!0);
						},
						"data-testid": "open-cancel-approval-request-confirmation",
						children: tt.CANCEL
					})]
				}),
				s && /* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "flexbox dc__gap-12",
					children: [
						/* @__PURE__ */ (0, Q.jsx)("p", {
							className: "m-0 flexbox flex-grow-1 cn-9 fs-13 fw-4 lh-20",
							children: tt.CANCEL_CONFIRMATION
						}),
						/* @__PURE__ */ (0, Q.jsx)("button", {
							type: "button",
							className: "cb-5 fs-13 fw-6 lh-20 dc__align-center dc__outline-none-imp dc__no-background dc__no-border dc__tab-focus",
							disabled: a,
							onClick: () => {
								r({
									action: Li.CANCEL,
									artifactId: i,
									promotionRequestId: o,
									successMessage: tt.CANCEL_TOAST
								});
							},
							"data-testid": "confirm-cancel-approval-request",
							children: a ? /* @__PURE__ */ (0, Q.jsx)(ul, {}) : tt.YES
						}),
						/* @__PURE__ */ (0, Q.jsx)("button", {
							type: "button",
							className: "cn-6 fs-13 fw-6 lh-20 dc__align-center dc__outline-none-imp dc__no-background dc__no-border dc__tab-focus",
							onClick: () => {
								c(!1);
							},
							disabled: a,
							"data-testid": "cancel-approval-request",
							children: tt.NO
						})
					]
				})
			]
		}), n?.length > 0 ? /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox-col dc__gap-8",
			children: [/* @__PURE__ */ (0, Q.jsx)("h2", {
				className: "m-0 cn-9 fs-13 fw-6 lh-20",
				children: tt.APPROVED_BY
			}), /* @__PURE__ */ (0, Q.jsx)("div", {
				className: "flexbox-col dc__gap-8",
				children: n.map((e) => /* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "flexbox dc__content-space dc__align-items-center",
					children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
						className: "flexbox dc__gap-8 dc__ellipsis-right",
						children: [Ku(e.userEmail, "dc__no-shrink m-0-imp"), /* @__PURE__ */ (0, Q.jsx)("span", {
							className: "fs-13 fw-4 lh-20 m-0",
							children: e.userEmail === t ? tt.SELF_ACTION : e.userEmail
						})]
					}), /* @__PURE__ */ (0, Q.jsx)(he, { className: "icon-dim-16 scg-5 dc__no-shrink" })]
				}, e.userEmail))
			})]
		}) : /* @__PURE__ */ (0, Q.jsx)("span", {
			className: "fs-13 fw-4 lh-20 cn-7",
			children: tt.NO_APPROVAL
		})]
	});
}, qC = (e) => e?.reduce((e, t) => (e[t.name] = t, e), {}) ?? {}, JC = async ({ workflowId: e, artifactId: t, abortControllerRef: n }) => {
	try {
		let { result: { ciSource: r, environments: i } } = await G(Rd(O.APP_ARTIFACT_PROMOTE_ENV_LIST, {
			workflowId: e,
			artifactId: t
		}), { abortControllerRef: n });
		return {
			ciSource: r,
			environments: qC(i)
		};
	} catch (e) {
		throw pd(e) || K(e), e;
	}
}, YC = async ({ workflowId: e, imagePromotionTab: t, appId: n, ciSource: r, environment: i, search: a, offset: o = 0, signal: s }) => {
	try {
		let c = {
			...ji({
				imagePromotionTab: t,
				environment: i,
				ciSource: r
			}),
			appId: n,
			workflowId: e,
			pendingForCurrentUser: t === ae.PENDING && !i,
			search: a,
			offset: o,
			size: 20
		}, l = await Wu(Po.IMAGE_PROMOTION, null, null, s, c), u = l?.materials || [];
		return {
			...l,
			materials: t === ae.PENDING ? u.map((e) => ({
				...e,
				isSelected: !1
			})) : u
		};
	} catch (e) {
		throw pd(e) || K(e), e;
	}
}, XC = async () => {
	try {
		let { result: e } = await td(), t = !!e?.is_default_configured, n = !!e?.isConfigured;
		return t || n;
	} catch (e) {
		throw K(e), e;
	}
}, ZC = async ({ environment: e, action: t, artifactId: n, appId: r, destinationObjectNames: i, ciSource: a, promotionRequestId: o, workflowId: s, imagePromotionTab: c }) => {
	try {
		let l = {
			...Ji({
				environment: e,
				ciSource: a,
				imagePromotionTab: c
			}),
			action: t,
			promotionRequestId: o,
			artifactId: n,
			appId: r,
			destinationObjectNames: i,
			workflowId: s
		}, { result: u } = await nf(O.APP_ARTIFACT_PROMOTE, l);
		return qC(u);
	} catch (e) {
		throw K(e), e;
	}
}, QC = async (e, t) => {
	try {
		let { result: n } = await G(Rd(O.APP_ARTIFACT_PROMOTE_ENV_APPROVAL_META_DATA, {
			artifactId: e,
			environmentName: t
		}));
		return n?.reduce((e, t) => (e[t.name] = t, e), {}) ?? {};
	} catch (e) {
		throw K(e), e;
	}
}, $C = ({ title: e, subTitle: t, subtitleClassName: n }) => /* @__PURE__ */ (0, Q.jsxs)("div", {
	className: "flexbox-col pl-4",
	children: [/* @__PURE__ */ (0, Q.jsx)("h4", {
		className: "m-0 cn-9 fs-13 fw-4 lh-20",
		children: e
	}), t && /* @__PURE__ */ (0, Q.jsx)("p", {
		className: `m-0 cn-7 fs-12 fw-4 lh-18 dc__first-letter-capitalize ${n || ""}`,
		children: t
	})]
}), ew = ({ isChecked: e, title: t, subTitle: n, isDisabled: r, onChange: i, subtitleClassName: a }) => /* @__PURE__ */ (0, Q.jsx)("div", {
	className: "py-6 w-100",
	"data-testid": `${t}-check-container`,
	children: /* @__PURE__ */ (0, Q.jsx)(Wo, {
		name: t,
		onChange: i,
		isChecked: e,
		value: Io.CHECKED,
		disabled: !!r,
		rootClassName: "m-0 w-100 dc__align-start",
		children: /* @__PURE__ */ (0, Q.jsx)($C, {
			title: t,
			subTitle: n,
			subtitleClassName: a
		})
	})
}), tw = ({ material: e, environmentName: t, handleArtifactAction: n, isLoadingAction: r }) => {
	let [i, a, o, s] = hf(() => QC(+e.id, t), [e.id, e.isSelected], e.isSelected), [c, l] = j({});
	k(() => {
		!i && a && l(_a(a));
	}, [i, a]);
	let u = (e) => {
		let { name: t } = e.target, n = { ...c };
		n[t] ? delete n[t] : n[t] = a[t], l(n);
	}, d = () => {
		let t = Object.keys(c);
		n({
			action: Li.APPROVE,
			artifactId: +e.id,
			destinationObjectNames: t,
			promotionRequestId: e?.promotionApprovalMetadata?.approvalRequestId,
			successMessage: tt.getApprovalSuccessMessage(t)
		});
	}, f = Object.keys(a || {}), p = Object.keys(c), m = r || i, h = da(m, p.length), g = (e) => /* @__PURE__ */ (0, Q.jsx)(ft, {
		className: "default-tt",
		arrow: !1,
		content: h,
		children: /* @__PURE__ */ (0, Q.jsx)("span", { children: e })
	}), _ = () => /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox-col pl-16 pr-16 pt-20 dc__gap-16",
		children: [
			/* @__PURE__ */ (0, Q.jsx)("div", { className: "shimmer-loading w-200 h-16" }),
			/* @__PURE__ */ (0, Q.jsx)("div", { className: "shimmer-loading w-250 h-16" }),
			/* @__PURE__ */ (0, Q.jsx)("div", { className: "shimmer-loading w-100px h-16" })
		]
	}), v = (e) => !a[e].approvalAllowed && a[e].reason?.length > 0 ? a[e].reason[0] : null;
	return /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox-col dc__content-space h-100 mh-200 bg__primary",
		children: [/* @__PURE__ */ (0, Q.jsx)("div", {
			className: "flexbox-col flex-grow-1",
			children: /* @__PURE__ */ (0, Q.jsx)($a, {
				isLoading: i,
				customLoader: _(),
				error: o,
				genericSectionErrorProps: { reload: s },
				children: /* @__PURE__ */ (0, Q.jsx)("div", {
					className: "flexbox-col pt-12 pb-12 pl-16 pr-16 h-200 dc__overflow-auto",
					children: f?.map((e) => /* @__PURE__ */ (0, Q.jsx)(ew, {
						isChecked: !!c[e],
						isDisabled: !a[e].approvalAllowed || m,
						subTitle: v(e),
						title: e,
						onChange: u
					}, e))
				})
			})
		}), /* @__PURE__ */ (0, Q.jsx)("div", {
			className: "dc__no-shrink flexbox dc__content-end dc__align-items-center pt-12 pb-12 pl-16 pr-16",
			children: /* @__PURE__ */ (0, Q.jsx)(es, {
				condition: !!h,
				wrap: g,
				children: /* @__PURE__ */ (0, Q.jsx)("button", {
					type: "button",
					className: "h-32 cta flex success",
					disabled: !!h,
					onClick: d,
					"data-testid": "approve-promotion-request",
					children: m ? /* @__PURE__ */ (0, Q.jsx)(ul, {}) : tt.APPROVE
				})
			})
		})]
	});
}, nw = ({ isLoadingAction: e, handleCancelApprovalRequest: t }) => /* @__PURE__ */ (0, Q.jsx)("div", {
	className: "flexbox dc__content-end pr-12 pb-12",
	children: /* @__PURE__ */ (0, Q.jsx)("button", {
		className: "cta flex h-32 delete",
		type: "button",
		disabled: e,
		onClick: t,
		"data-testid": "cancel-approval-request-text",
		children: e ? /* @__PURE__ */ (0, Q.jsx)(ul, { fillColor: "var(--R500)" }) : tt.CTA.CANCEL_REQUEST
	})
}), rw = ({ material: e, environment: t, handleCurrentMaterialSelection: n, handleArtifactAction: r, isLoadingAction: i }) => /* @__PURE__ */ (0, Q.jsx)(su, {
	theme: cu.white,
	className: "w-300 h-100 dc__align-left",
	iconClass: "fcv-5",
	heading: tt.APPROVE_ARTIFACT_HEADING,
	placement: "bottom-end",
	additionalContent: /* @__PURE__ */ (0, Q.jsx)(tw, {
		material: e,
		environmentName: t || null,
		handleArtifactAction: r,
		isLoadingAction: i
	}),
	showCloseButton: !0,
	trigger: "click",
	interactive: !0,
	children: /* @__PURE__ */ (0, Q.jsx)("button", {
		className: "p-0 flex dc__no-border dc__no-background dc__outline-none-imp dc__tab-focus dc__tab-focus",
		type: "button",
		onClick: n,
		"data-testid": "approve-artifact-button",
		children: tt.CTA.APPROVE_FOR
	})
}), iw = () => /* @__PURE__ */ (0, Q.jsx)("span", {
	className: "cg-5 cursor-default",
	"data-testid": "approved-by-you",
	children: tt.CTA.APPROVED_BY_YOU
}), aw = ({ materialResponse: e, handleImageSelection: t, material: n, handleArtifactAction: r, isLoadingAction: i }) => {
	let { useImageListType: a, imageListTab: o } = Z(), { environment: s } = Pf({ parseSearchParams: xi }), { email: c } = Ff(), { requestedUserId: l, imagePromotionApproverEmails: u } = e, d = o === ae.PENDING && !s, f = u?.includes(c) || d, { promotionApprovalMetadata: p } = n, m = p?.approvedUsersData?.some((e) => e.userId === l), h = p?.requestedUserData?.userId === l, g = () => {
		t(n.id);
	};
	return n.vulnerable && a === Ze.IMAGE_PROMOTION ? /* @__PURE__ */ (0, Q.jsx)("span", {
		className: "material-history__scan-error",
		"data-testid": `cd-artifact-vulnerability-disabled-${n.id}`,
		children: tt.CTA.SECURITY_ISSUES_FOUND
	}) : o === ae.REQUEST ? n.isSelected ? /* @__PURE__ */ (0, Q.jsx)(z, {
		name: "ic-selected",
		color: "B500",
		size: 24
	}) : /* @__PURE__ */ (0, Q.jsx)("button", {
		className: "p-0 flex dc__no-border dc__no-background dc__outline-none-imp dc__tab-focus dc__tab-focus",
		type: "button",
		onClick: g,
		"data-testid": `cd-artifact-select-${n.id}`,
		children: tt.CTA.SELECT
	}) : h ? /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox dc__gap-12",
		children: [/* @__PURE__ */ (0, Q.jsx)(su, {
			theme: cu.white,
			className: "w-300 h-100 dc__align-left",
			placement: "auto",
			iconClass: "fcv-5",
			heading: tt.CANCEL_REQUEST_OVERLAY.HEADING,
			infoText: tt.CANCEL_REQUEST_OVERLAY.INFO_TEXT,
			additionalContent: /* @__PURE__ */ (0, Q.jsx)(nw, {
				isLoadingAction: i,
				handleCancelApprovalRequest: () => {
					r({
						action: Li.CANCEL,
						artifactId: +n.id,
						promotionRequestId: p?.approvalRequestId,
						successMessage: tt.CANCEL_TOAST
					});
				}
			}),
			showCloseButton: !0,
			trigger: "click",
			interactive: !0,
			children: /* @__PURE__ */ (0, Q.jsxs)("button", {
				className: "p-0 flex dc__no-border dc__no-background dc__outline-none-imp dc__tab-focus dc__tab-focus cr-5",
				type: "button",
				"data-testid": "open-cancel-approval-request-confirmation",
				children: [/* @__PURE__ */ (0, Q.jsx)(ue, { className: "icon-dim-16 fcr-5 scr-5 mr-4" }), tt.CTA.CANCEL_REQUEST]
			})
		}), f && /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsx)("div", { className: "dc__border-right-n1" }), m ? iw() : /* @__PURE__ */ (0, Q.jsx)(rw, {
			material: n,
			environment: s,
			handleCurrentMaterialSelection: g,
			handleArtifactAction: r,
			isLoadingAction: i
		})] })]
	}) : m ? iw() : f ? /* @__PURE__ */ (0, Q.jsx)(rw, {
		material: n,
		environment: s,
		handleCurrentMaterialSelection: g,
		handleArtifactAction: r,
		isLoadingAction: i
	}) : /* @__PURE__ */ (0, Q.jsx)("span", {
		className: "cn-5 cursor-default",
		"data-testid": "awaiting-approval",
		children: tt.CTA.AWAITING_APPROVAL
	});
}, ow = ({ materialResponse: e, environmentId: t, getModuleInfo: n, isVirtualEnvironment: r, ciPipelineId: i, handleFetchMoreImages: a, isFetchingMoreImages: o, handleImageSelection: s, parentEnvironmentName: c, handleTabSwitch: l, ciSource: u, handleClearSearch: d, handleRefresh: f }) => {
	let { searchKey: p, environment: m } = Pf({ parseSearchParams: xi }), { appId: h, workflowId: g, useImageListType: _, imageListTab: v = ae.REQUEST } = Z(), { isSuperAdmin: y } = Cf(), { email: b } = Ff(), [x, S] = j(/* @__PURE__ */ new Map()), [C, w] = j(!1), [T, ee] = j(!1), E = e?.materials ?? [], D = E.length < e?.totalCount, te = async () => {
		try {
			let { result: e } = await n(Hc.SECURITY);
			e?.status === Uc.INSTALLED && w(!0);
		} catch (e) {
			K(e);
		}
	};
	k(() => {
		te();
	}, []);
	let ne = async ({ action: e, artifactId: t, destinationObjectNames: n, promotionRequestId: r, successMessage: i }) => {
		try {
			ee(!0), await ZC({
				environment: m,
				action: e,
				artifactId: t,
				appId: +h,
				workflowId: +g,
				destinationObjectNames: n,
				ciSource: u,
				promotionRequestId: r,
				imagePromotionTab: v
			}), f(), H.showToast({
				variant: U.success,
				description: i
			});
		} catch {
			$d();
		} finally {
			ee(!1);
		}
	}, re = () => {
		l(ae.REQUEST);
	}, ie = (e) => {
		let t = new Map(x);
		t.set(e, !t.get(e)), S(t);
	}, oe = (e) => ({
		isLatest: e.latest,
		isRunningOnParentCD: e.runningOnParentCd,
		artifactStatus: e.artifactStatus,
		environmentName: m || null,
		parentEnvironmentName: c,
		stageType: Nl.CD,
		showLatestTag: !1,
		isVirtualEnvironment: r,
		deployedOn: e.deployedOnEnvironments,
		targetPlatforms: e.targetPlatforms
	}), se = (t) => ({
		ciPipelineId: i,
		artifactId: +t.id,
		imageComment: t.imageComment,
		imageReleaseTags: t.imageReleaseTags,
		appReleaseTagNames: e?.appReleaseTagNames,
		setAppReleaseTagNames: null,
		tagsEditable: e?.tagsEditable,
		setTagsEditable: null,
		toggleCardMode: ie,
		hideHardDelete: e?.hideImageTaggingHardDelete,
		updateCurrentAppMaterial: null,
		isSuperAdmin: y,
		forceReInit: !0
	}), ce = (e) => {
		let { promotionApprovalMetadata: t } = e, n = `${t?.approvedUsersData?.length ?? 0}/${t?.policy?.approvalMetadata?.approverCount ?? 0} Approvals`;
		return m ? /* @__PURE__ */ (0, Q.jsx)(su, {
			theme: cu.white,
			className: "w-300 h-100",
			placement: "top-start",
			Icon: vr,
			heading: n,
			additionalContent: /* @__PURE__ */ (0, Q.jsx)(KC, {
				promotionRequestedBy: t?.requestedUserData?.userEmail,
				currentUserEmail: b,
				approvedUsersData: t?.approvedUsersData ?? [],
				handleArtifactAction: ne,
				artifactId: +e.id,
				isLoading: T,
				promotionRequestId: t?.approvalRequestId
			}),
			showCloseButton: !0,
			trigger: "click",
			interactive: !0,
			children: /* @__PURE__ */ (0, Q.jsxs)("button", {
				type: "button",
				className: "p-0 dc__gap-6 flex dc__no-border dc__no-background dc__outline-none-imp dc__tab-focus",
				"data-testid": "open-approval-checks-overlay",
				children: [/* @__PURE__ */ (0, Q.jsx)(vr, { className: "icon-dim-16 scv-5 dc__no-shrink" }), /* @__PURE__ */ (0, Q.jsx)("p", {
					className: "m-0 fs-13 fw-4 lh-20",
					children: n
				})]
			})
		}) : null;
	}, le = (e) => ({
		imagePath: e.imagePath,
		registryName: e.registryName,
		registryType: e.registryType,
		image: e.image,
		deployedTime: null,
		deployedBy: e.deployedBy,
		isRollbackTrigger: !1,
		excludedImagePathNode: null,
		approvalChecksNode: v === ae.PENDING ? ce(e) : null
	});
	return E.length === 0 ? p ? /* @__PURE__ */ (0, Q.jsx)(R, {
		title: wa.EMPTY_STATES.NO_ARTIFACT_SEARCH.TITLE,
		subTitle: wa.EMPTY_STATES.NO_ARTIFACT_SEARCH.SUBTITLE,
		isButtonAvailable: !0,
		renderButton: () => /* @__PURE__ */ (0, Q.jsx)("button", {
			className: "cta secondary h-36 flex",
			type: "button",
			onClick: d,
			"data-testid": "clear-filters",
			children: wa.CLEAR_FILTERS
		})
	}) : v === ae.PENDING ? /* @__PURE__ */ (0, Q.jsx)(R, {
		title: m ? wa.EMPTY_STATES[v].ENV.getTitle(m) : wa.EMPTY_STATES[v].SELF.TITLE,
		subTitle: m ? wa.EMPTY_STATES[v].ENV.SUBTITLE : wa.EMPTY_STATES[v].SELF.SUBTITLE,
		image: ip,
		isButtonAvailable: !0,
		renderButton: () => /* @__PURE__ */ (0, Q.jsx)("button", {
			className: "cta secondary h-36 flex",
			type: "button",
			onClick: re,
			"data-testid": "view-other-requests",
			children: wa.VIEW_OTHER_REQUESTS
		}),
		contentClassName: "dc__align-center"
	}) : /* @__PURE__ */ (0, Q.jsx)(R, {
		title: m ? wa.EMPTY_STATES[v].ENV.getTitle(m) : wa.EMPTY_STATES[v].SOURCE.TITLE,
		subTitle: m ? wa.EMPTY_STATES[v].ENV.getSubtitle(m, _) : wa.EMPTY_STATES[v].SOURCE.SUBTITLE,
		image: Zf,
		contentClassName: "dc__align-center"
	}) : /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox-col pb-12",
		children: [
			v === ae.PENDING && m && /* @__PURE__ */ (0, Q.jsx)(GC, {
				approverEmails: e.imagePromotionApproverEmails ?? [],
				requiredApprovalCount: E?.[0]?.promotionApprovalMetadata?.policy?.approvalMetadata?.approverCount ?? 1
			}),
			E.map((n) => {
				let r = fd(n.materialInfo), i = x.get(+n.id);
				return /* @__PURE__ */ (0, Q.jsx)(_c, {
					testIdLocator: String(n.index),
					cta: /* @__PURE__ */ (0, Q.jsx)(aw, {
						materialResponse: e,
						handleImageSelection: s,
						material: n,
						handleArtifactAction: ne,
						isLoadingAction: T
					}, n.id),
					sequentialCDCardTitleProps: oe(n),
					artifactInfoProps: le(n),
					imageTagContainerProps: se(n),
					children: n.materialInfo.length > 0 && !i && r && /* @__PURE__ */ (0, Q.jsx)(vc, {
						environmentId: t,
						isSecurityModuleInstalled: C,
						artifactId: +n.id,
						applicationId: +h,
						changesCard: /* @__PURE__ */ (0, Q.jsx)(Rr, { materialInformationList: n.materialInfo }),
						isScanned: n.scanned,
						isScanEnabled: n.scanEnabled,
						SecurityModalSidebar: _i
					})
				}, n.id);
			}),
			D && /* @__PURE__ */ (0, Q.jsx)(Br, {
				isLoading: o,
				handleFetchMoreData: a
			})
		]
	});
}, sw = ({ loadingMaterials: e, materialsError: t, reloadMaterials: n, materialResponseState: r, setMaterialResponseState: i, getModuleInfo: a, isSearchActive: o, setIsSearchActive: s, environmentsError: c, loadingEnvironments: l, selectedWorkflow: u, environmentListResponse: d, reloadEnvironments: f, getMaterialsWrapper: p, handleRefresh: m, handleTabSwitch: h = $d, redeployActiveImagesConfig: g }) => {
	let { searchKey: _, handleSearch: v, updateSearchParams: y, environment: b } = Pf({ parseSearchParams: xi }), { useImageListType: x, imageListTab: S = ae.REQUEST } = Z(), { isRedeployActiveImagesActive: C, setIsRedeployActiveImagesActive: w } = g ?? {}, [T, ee] = j(!1);
	k(() => {
		_ && !o && s(!0);
	}, [_]);
	let E = b ? !!d?.environments[b]?.isVirtualEnvironment : !1, D = Pi(u, b), te = Da(S, u, d?.ciSource);
	return /* @__PURE__ */ (0, Q.jsx)("div", {
		className: "flexbox-col dc__overflow-auto flex-grow-1 image-list",
		children: x === Ze.IMAGE_PROMOTION && (!u || !u.artifactPromotionMetadata?.isConfigured) ? /* @__PURE__ */ (0, Q.jsx)(R, {
			title: wa.NOT_CONFIGURED_EMPTY_STATE.TITLE,
			subTitle: wa.NOT_CONFIGURED_EMPTY_STATE.SUB_TITLE
		}) : l || pd(c) ? /* @__PURE__ */ (0, Q.jsx)(wr, {
			count: 4,
			areFiltersLoading: !0
		}) : c ? /* @__PURE__ */ (0, Q.jsx)(Ks, {
			code: c?.code,
			reload: f
		}) : /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox-col px-20 flex-grow-1",
			children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox dc__content-space dc__align-items-center dc__position-sticky dc__top-0 bg__tertiary dc__zi-1 py-12",
				children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "dc__separated-flexbox h-32",
					children: [g && /* @__PURE__ */ (0, Q.jsx)(Wo, {
						value: Io.CHECKED,
						isChecked: C,
						onChange: () => {
							w(!C);
						},
						dataTestId: "bulk-trigger__redeploy-active-images",
						name: "redeploy-active-images",
						rootClassName: "m-0 dc__align-start",
						children: /* @__PURE__ */ (0, Q.jsx)("h3", {
							className: "m-0 fs-13 lh-20 fw-6",
							children: "Redeploy active images"
						})
					}), !C && /* @__PURE__ */ (0, Q.jsx)(HC, {
						environmentListResponse: d,
						shutterOptionTitle: te,
						handleEnvironmentChange: (e) => {
							y(e.value === wa.ENVIRONMENT_SELECTOR_SHUTTER_VALUE[S] ? { environment: null } : { environment: e.value });
						}
					})]
				}), !C && /* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "flexbox dc__gap-8",
					children: [o ? /* @__PURE__ */ (0, Q.jsx)(Il, {
						initialSearchText: _ ?? "",
						containerClassName: "dc__mxw-250 flex-grow-1",
						handleEnter: v,
						inputProps: {
							placeholder: wa.SEARCH_IMAGE_TAG_PLACEHOLDER,
							autoFocus: !0
						}
					}) : /* @__PURE__ */ (0, Q.jsx)("button", {
						type: "button",
						className: "flex dc__align-center dc__outline-none-imp dc__no-background dc__no-border dc__tab-focus",
						onClick: () => {
							s(!0);
						},
						"aria-label": wa.SHOW_SEARCH_BAR,
						"data-testid": "show-search-bar",
						children: /* @__PURE__ */ (0, Q.jsx)(Nn, { className: `icon-dim-18 ${o ? "" : "icon-color-n6"}` })
					}), /* @__PURE__ */ (0, Q.jsx)("button", {
						className: "py-0 pl-0 pr-8 flex dc__outline-none-imp dc__no-background dc__no-border dc__tab-focus",
						onClick: m,
						type: "button",
						"aria-label": wa.REFRESH_LABEL,
						children: /* @__PURE__ */ (0, Q.jsx)(Wr, { className: "icon-dim-16 scn-6 cursor" })
					})]
				})]
			}), e || pd(t) ? /* @__PURE__ */ (0, Q.jsx)(wr, { count: 4 }) : t ? /* @__PURE__ */ (0, Q.jsx)(Ks, {
				code: t.code,
				reload: n
			}) : C ? /* @__PURE__ */ (0, Q.jsx)(R, {
				title: "Redeploy currently active image",
				subTitle: "Deploy the currently active image using the last saved configuration for the desired environments.",
				imageType: yc.Large,
				image: op
			}) : /* @__PURE__ */ (0, Q.jsx)(ow, {
				materialResponse: r,
				parentEnvironmentName: D ? D.parentEnvironmentName : null,
				isVirtualEnvironment: E,
				ciPipelineId: d.ciSource?.id,
				getModuleInfo: a,
				handleFetchMoreImages: async () => {
					try {
						ee(!0);
						let e = await p(r?.materials?.length);
						i({
							...e,
							materials: [...r.materials, ...e.materials]
						});
					} catch (e) {
						K(e);
					} finally {
						ee(!1);
					}
				},
				isFetchingMoreImages: T,
				handleImageSelection: (e) => {
					let t = r?.materials.map((t) => t.id === e ? {
						...t,
						isSelected: !0
					} : {
						...t,
						isSelected: !1
					});
					i({
						...r,
						materials: t
					});
				},
				handleTabSwitch: h,
				ciSource: d.ciSource,
				handleClearSearch: () => {
					v("");
				},
				handleRefresh: m
			})]
		})
	});
}, cw = (e, t) => e.reduce((e, n) => {
	let r = n.feasibility.code === Mi.CanTrigger || n.feasibility.code === Mi.ExceptionUser, i = t.find(({ name: e }) => e === n.envName), a = {
		...n,
		...i,
		artifactId: n.artifactId ?? null,
		isSelected: !1
	};
	return r ? e.eligibleEnvironments.push(a) : e.inEligibleEnvironments.push(a), e;
}, {
	eligibleEnvironments: [],
	inEligibleEnvironments: []
}), lw = (e, t) => e ? e === t ? {
	value: Io.CHECKED,
	isChecked: !0
} : {
	value: Io.INTERMEDIATE,
	isChecked: !0
} : {
	value: Io.CHECKED,
	isChecked: !1
}, uw = (e, t) => {
	let n = t.toUpperCase();
	return e.filter((e) => e.name.toUpperCase().includes(n));
}, dw = async ({ environments: e, appId: t, artifactId: n, reDeployActiveImages: r, abortControllerRef: i }) => {
	try {
		let { result: a } = await nf(Rd(Y(O.CD_PIPELINE_TRIGGER_FEASIBILITY, { appId: t }), { reDeployActiveImages: r }), e.map(({ pipelineId: e }) => ({
			...n && !r ? { artifactId: n } : {},
			pipelineId: e
		})), { abortControllerRef: i });
		return cw(a, e);
	} catch (e) {
		throw pd(e) || K(e), e;
	}
}, fw = async ({ abortControllerRef: e, workflowId: t, environments: n }) => {
	try {
		let { result: { ciSource: r, environments: i } } = await G(Rd(O.APP_ARTIFACT_PROMOTE_ENV_LIST, { workflowId: t }), { abortControllerRef: e }), a = qC(n);
		return {
			ciSource: r,
			environments: qC(i.filter((e) => !!a[e.name]).map((e) => ({
				...e,
				...a[e.name]
			})))
		};
	} catch (e) {
		throw pd(e) || K(e), e;
	}
}, pw = async ({ pipelineId: e, signal: t, offset: n, search: r }) => {
	try {
		let i = await Wu(Po.CD_MATERIALS, e, Ds.CD, t, {
			offset: n > 20 ? n - 1 : n,
			search: r,
			size: 20
		}), a = n > 20 ? i.materials.filter((e) => !qd(e)) : i.materials;
		return {
			...i,
			materials: a.map((e, t) => ({
				...e,
				isSelected: n <= 20 && t === 0
			}))
		};
	} catch (e) {
		throw pd(e) || K(e), e;
	}
}, mw = ({ environments: e = null }) => {
	let { appId: t, workflowId: n, imageListTab: r = ae.REQUEST, useImageListType: i } = Z(), { searchKey: a, environment: o } = Pf({ parseSearchParams: xi }), s = Ja(new AbortController()), c = Ja(new AbortController()), [l, u] = j(null), [d, f] = j(!1), [p, m, h, g] = hf(() => Du(() => {
		switch (i) {
			case Ze.IMAGE_PROMOTION: return JC({
				workflowId: n,
				abortControllerRef: c
			});
			case Ze.BULK_DEPLOY: return fw({
				workflowId: n,
				abortControllerRef: c,
				environments: e
			});
			default: return Xd(`Invalid type ${i} found for use image list hook`), null;
		}
	}, c), [n]), _ = Ka((e) => Du(() => i === Ze.BULK_DEPLOY && o ? pw({
		pipelineId: m.environments[o].pipelineId,
		signal: s.current.signal,
		offset: e ?? 0,
		search: a
	}) : YC({
		workflowId: +n,
		imagePromotionTab: r,
		appId: +t,
		ciSource: m.ciSource,
		environment: o,
		search: a,
		offset: e ?? 0,
		signal: s.current.signal
	}), s), [
		r,
		n,
		t,
		a,
		o,
		m,
		i
	]), [v, y, b, x] = hf(_, [
		n,
		r,
		t,
		m,
		o,
		a
	], !!m);
	return k(() => {
		!v && y && u(y);
	}, [v, y]), k(() => () => {
		s.current?.abort(), c.current?.abort();
	}, []), {
		loadingMaterials: v,
		materialsError: b,
		reloadMaterials: x,
		materialResponse: y,
		reloadEnvironments: g,
		environmentsError: h,
		loadingEnvironments: p,
		environmentListResponse: m,
		getMaterialsWrapper: _,
		materialResponseState: l,
		isSearchActive: d,
		setIsSearchActive: f,
		setMaterialResponseState: u
	};
}, hw = (e) => /* @__PURE__ */ (0, Q.jsxs)("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	...e,
	children: [/* @__PURE__ */ (0, Q.jsx)("defs", { children: /* @__PURE__ */ (0, Q.jsx)("path", {
		id: "hrh6rt6fka",
		d: "M8 1.333c3.682 0 6.667 2.985 6.667 6.667S11.682 14.667 8 14.667 1.333 11.682 1.333 8 4.318 1.333 8 1.333zM3.787 4.73c-.702.903-1.12 2.038-1.12 3.27 0 2.946 2.387 5.333 5.333 5.333 1.232 0 2.367-.418 3.27-1.12zM8 2.667c-1.232 0-2.367.418-3.27 1.12l7.483 7.483c.702-.903 1.12-2.038 1.12-3.27 0-2.946-2.387-5.333-5.333-5.333z"
	}) }), /* @__PURE__ */ (0, Q.jsx)("g", {
		fill: "none",
		fillRule: "evenodd",
		children: /* @__PURE__ */ (0, Q.jsx)("g", { children: /* @__PURE__ */ (0, Q.jsx)("g", { children: /* @__PURE__ */ (0, Q.jsx)("g", { children: /* @__PURE__ */ (0, Q.jsx)("g", { children: /* @__PURE__ */ (0, Q.jsx)("g", {
			transform: "translate(-120 -226) translate(64 186) translate(0 32) translate(20 6) translate(36 2)",
			children: /* @__PURE__ */ (0, Q.jsx)("use", {
				fill: "#959BA1",
				xlinkHref: "#hrh6rt6fka"
			})
		}) }) }) }) })
	})]
}), gw = ({ handleDownload: e, ...t }) => {
	let [n, r] = j(!1), [i, a] = j(!1);
	return /* @__PURE__ */ (0, Q.jsx)(M, {
		onClick: async (n) => {
			n?.stopPropagation(), a(!0), await um({
				...t,
				handleDownload: e
			}) || r(!0), a(!1);
		},
		text: "Download",
		startIcon: i ? /* @__PURE__ */ (0, Q.jsx)(ul, { size: 14 }) : /* @__PURE__ */ (0, Q.jsx)(yi, {}),
		dataTestId: "download-manifest-virtual-env",
		disabled: i,
		variant: F.text,
		style: n ? P.neutral : P.default,
		size: I.xs
	});
}, _w = ({ title: e, handleClose: t }) => /* @__PURE__ */ (0, Q.jsxs)("div", {
	className: "w-100 flexbox dc__align-items-center dc__content-space py-12 dc__border-bottom-n1 px-16",
	children: [/* @__PURE__ */ (0, Q.jsx)("h2", {
		className: "cn-9 m-0 fs-14 fw-6 lh-20",
		children: e
	}), /* @__PURE__ */ (0, Q.jsx)(M, {
		icon: /* @__PURE__ */ (0, Q.jsx)(tr, {}),
		dataTestId: "rb-bulk-action__cross",
		component: N.button,
		style: P.negativeGrey,
		size: I.xs,
		variant: F.borderLess,
		ariaLabel: `Close ${e} drawer`,
		onClick: t,
		showAriaLabelInTippy: !1
	})]
}), vw = ({ handleCloseOverlay: e, selectedMaterial: t, environments: n, setTriggerCallbacks: r, isRedeployActiveImagesActive: i }) => {
	let { appId: a } = Z(), { handleDownload: o } = yf(), s = Ja(new AbortController()), [c, l, u, d, f] = hf(() => dw({
		environments: n,
		appId: +a,
		abortControllerRef: s,
		artifactId: i ? null : +t.id,
		reDeployActiveImages: i
	}));
	k(() => () => {
		s.current.abort();
	}, []);
	let { searchKey: p, handleSearch: m } = Mf(), { eligibleEnvironments: h, inEligibleEnvironments: g } = A(() => !p || !l ? l ?? {
		inEligibleEnvironments: [],
		eligibleEnvironments: []
	} : {
		eligibleEnvironments: uw(l.eligibleEnvironments, p),
		inEligibleEnvironments: uw(l.inEligibleEnvironments, p)
	}, [p, l]), _ = h.reduce((e, t) => e + +!!t.isSelected, 0), v = !_, { isChecked: y, value: b } = lw(_, h.length), x = () => {
		m("");
	}, S = (e) => {
		let { name: t } = e.target;
		f((e) => ({
			...e,
			eligibleEnvironments: e.eligibleEnvironments.map((e) => e.name === t ? {
				...e,
				isSelected: !e.isSelected
			} : e)
		}));
	};
	return /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "dc__position-abs flexbox-col dc__content-space w-400 h-365 bg__primary dc__bottom-16 dc__right-20 br-4 dc__border dc__box-shadow--overlay dc__zi-2",
		onClick: uf,
		children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "w-100 h-100 flexbox-col dc__overflow-auto dc__gap-12",
			children: [/* @__PURE__ */ (0, Q.jsx)(_w, {
				title: "Select environments",
				handleClose: e
			}), c || pd(u) ? /* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox-col px-16 pt-8 dc__gap-16",
				children: [
					/* @__PURE__ */ (0, Q.jsx)("div", { className: "shimmer-loading w-200 h-16" }),
					/* @__PURE__ */ (0, Q.jsx)("div", { className: "shimmer-loading w-250 h-16" }),
					/* @__PURE__ */ (0, Q.jsx)("div", { className: "shimmer-loading w-100px h-16" })
				]
			}) : u ? /* @__PURE__ */ (0, Q.jsx)(lc, {
				rootClassName: "flex-grow-1",
				reload: d
			}) : /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsx)("div", {
				className: "w-100 flex px-16",
				children: /* @__PURE__ */ (0, Q.jsx)(Il, {
					containerClassName: "w-100 flex-grow-1",
					handleEnter: m,
					inputProps: {
						placeholder: tt.SEARCH_ENVIRONMENT_PLACEHOLDER,
						autoFocus: !0
					},
					initialSearchText: p
				})
			}), p && g.length === 0 && h.length === 0 ? /* @__PURE__ */ (0, Q.jsx)(lc, {
				title: tt.REQUEST_PROMOTION_EMPTY_SEARCH.TITLE,
				subTitle: tt.REQUEST_PROMOTION_EMPTY_SEARCH.SUB_TITLE,
				description: "",
				buttonText: tt.REQUEST_PROMOTION_EMPTY_SEARCH.BUTTON_TEXT,
				reload: x,
				rootClassName: "flex-grow-1",
				useInfoIcon: !0
			}) : /* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox-col px-16 h-100 dc__overflow-auto",
				children: [
					!!h.length && /* @__PURE__ */ (0, Q.jsx)("div", {
						className: "dc__position-sticky dc__left-0 dc__top-0 bg__primary dc__zi-1 py-6 w-100",
						children: /* @__PURE__ */ (0, Q.jsx)(Wo, {
							name: "select-all-eligible-environments",
							onChange: () => {
								let e = b !== Io.CHECKED || !y;
								f((t) => ({
									...t,
									eligibleEnvironments: t.eligibleEnvironments.map((t) => ({
										...t,
										isSelected: e
									}))
								}));
							},
							isChecked: y,
							value: b,
							rootClassName: "m-0 w-100 dc__align-start",
							children: /* @__PURE__ */ (0, Q.jsx)("h3", {
								className: "m-0 cn-9 fs-13 fw-6 lh-20 pl-4",
								children: "Select all eligible environments"
							})
						})
					}),
					h.map((e) => /* @__PURE__ */ (0, Q.jsx)(ew, {
						isChecked: !!e.isSelected,
						title: e.name,
						onChange: S,
						subTitle: e.feasibility.userMessage ?? "",
						subtitleClassName: "cy-7"
					}, e.name)),
					!!(h.length && g.length) && /* @__PURE__ */ (0, Q.jsx)("div", {
						className: "flex py-12",
						children: /* @__PURE__ */ (0, Q.jsx)("div", { className: "dc__border-bottom-n1 w-100" })
					}),
					g.length > 0 && /* @__PURE__ */ (0, Q.jsxs)("div", {
						className: "flex column w-100",
						children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
							className: "flexbox dc__gap-8 w-100 dc__align-items-center pb-8",
							children: [/* @__PURE__ */ (0, Q.jsx)("div", {
								className: "flex p-2",
								children: /* @__PURE__ */ (0, Q.jsx)(hw, { className: "fcr-5" })
							}), /* @__PURE__ */ (0, Q.jsx)("h3", {
								className: "m-0 cn-9 fs-13 fw-6 lh-20",
								children: "Cannot deploy to environments"
							})]
						}), g.map((e) => /* @__PURE__ */ (0, Q.jsx)(ew, {
							isChecked: e.isSelected,
							title: e.name,
							subTitle: e.feasibility.userMessage,
							subtitleClassName: "cr-5",
							isDisabled: !0,
							onChange: $d
						}, e.name))]
					})
				]
			})] })]
		}), /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "py-12 px-16 flex dc__content-space dc__gap-12 dc__border-top-n1",
			children: [/* @__PURE__ */ (0, Q.jsx)("div", {
				className: "flex dc__gap-8",
				children: _ ? /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsx)(lr, { className: "dc__no-shrink icon-dim-20" }), /* @__PURE__ */ (0, Q.jsxs)("span", { children: [
					"Trigger ",
					_,
					" deployment(s)"
				] })] }) : null
			}), /* @__PURE__ */ (0, Q.jsx)(M, {
				startIcon: /* @__PURE__ */ (0, Q.jsx)(Yi, {}),
				text: "Deploy",
				variant: F.primary,
				size: I.medium,
				disabled: v,
				showTooltip: v,
				tooltipProps: { content: "Please select at least one environment" },
				dataTestId: "bulk-trigger__deploy",
				onClick: () => {
					Mn.event({
						category: "devtron-apps-workflow",
						action: "bulk-deploy-button-clicked"
					}), r(h.filter((e) => e.isSelected).map(({ name: e, pipelineId: t, envId: n, isVirtualEnvironment: r, artifactId: i }) => ({
						name: e,
						operation: async (e) => {
							let { result: { helmPackageName: s } } = await pf({
								pipelineId: t,
								appId: Number(a),
								ciArtifactId: i,
								stageType: Ds.CD,
								abortControllerRef: e,
								skipIfHibernated: !1
							});
							return r ? {
								appId: Number(a),
								envId: n,
								handleDownload: o,
								helmPackageName: s,
								cdWorkflowType: Ds.CD,
								showSuccessfulToast: !1
							} : null;
						},
						...r ? { renderContentAtResultRowEnd: (e) => /* @__PURE__ */ (0, Q.jsx)(gw, { ...e }) } : {}
					})));
				}
			})]
		})]
	});
}, yw = ({ workflows: e, getModuleInfo: t, appName: n, reloadWorkflowStatus: r }) => {
	let i = X(), { workflowId: a } = Z(), { environment: o, updateSearchParams: s } = Pf({ parseSearchParams: xi }), { searchKey: c } = Pf(), { environments: l, selectedWorkflow: u } = A(() => {
		let t = e.find((e) => e.id === a);
		return {
			selectedWorkflow: t,
			environments: t.nodes.reduce((e, t) => (t.type === "CD" && e.push({
				envId: Number(t.environmentId),
				pipelineId: Number(t.id),
				name: t.environmentName,
				isVirtualEnvironment: t.isVirtualEnvironment ?? !1
			}), e), [])
		};
	}, [a]);
	k(() => {
		l && l.every(({ name: e }) => e !== o) && s({ environment: null });
	}, [o, l]);
	let { loadingMaterials: d, materialsError: f, reloadMaterials: p, reloadEnvironments: m, environmentsError: h, loadingEnvironments: g, environmentListResponse: _, getMaterialsWrapper: v, isSearchActive: y, setIsSearchActive: b, materialResponseState: x, setMaterialResponseState: S } = mw({ environments: l }), C = (x?.materials ?? []).find((e) => e.isSelected), [w, T] = j(!1), [ee, E] = j(null), [D, te] = j(!1), ne = !C && !D, re = () => {
		i("..");
	}, ie = () => {
		m(), c || b(!1);
	}, ae = (e) => {
		e.stopPropagation(), T(!0);
	}, oe = () => {
		T(!1);
	}, se = (e) => {
		e.stopPropagation(), T(!1);
	}, ce = (e) => e.Pending || e.Progressing ? /* @__PURE__ */ (0, Q.jsx)("span", {
		className: "dc__loading-dots",
		children: "Deploying"
	}) : `Image deployed on ${e.Completed} environment(s)`, le = `Deploy '${n}'`, ue = w && (C || D);
	return ee ? /* @__PURE__ */ (0, Q.jsx)(Oo, {
		operations: ee,
		handleReloadDataAfterBulkOperation: r,
		handleModalClose: re,
		getResultsChartSummaryText: ce,
		textConfig: {
			prompt: ds,
			resultsHeader: `Deploy '${n}'`
		},
		shouldSkipConfirmation: !0,
		disableTransition: !0
	}) : /* @__PURE__ */ (0, Q.jsx)(Rs, {
		onClose: re,
		width: "1024px",
		onEscape: re,
		position: "right",
		children: /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "bg__primary flexbox-col dc__content-space h-100",
			onClick: se,
			children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox-col flex-grow-1 w-100 bg__tertiary dc__overflow-auto",
				children: [/* @__PURE__ */ (0, Q.jsxs)("header", {
					className: "px-20 py-12 lh-24 flexbox dc__content-space dc__align-items-center dc__border-bottom bg__primary",
					children: [/* @__PURE__ */ (0, Q.jsx)("span", {
						className: "fs-16 fw-6 dc__first-letter-capitalize",
						children: le.toLocaleLowerCase()
					}), /* @__PURE__ */ (0, Q.jsx)(M, {
						icon: /* @__PURE__ */ (0, Q.jsx)(er, {}),
						dataTestId: "rb-bulk-action__cross",
						component: N.button,
						style: P.negativeGrey,
						variant: F.borderLess,
						size: I.xs,
						ariaLabel: `Close ${le} drawer`,
						onClick: re,
						showAriaLabelInTippy: !1
					})]
				}), /* @__PURE__ */ (0, Q.jsx)(sw, {
					loadingMaterials: d,
					materialsError: f,
					reloadMaterials: p,
					materialResponseState: x,
					setMaterialResponseState: S,
					getModuleInfo: t,
					isSearchActive: y,
					setIsSearchActive: b,
					reloadEnvironments: m,
					environmentsError: h,
					loadingEnvironments: g,
					environmentListResponse: _,
					selectedWorkflow: u,
					getMaterialsWrapper: v,
					handleRefresh: ie,
					type: Ze.BULK_DEPLOY,
					redeployActiveImagesConfig: {
						isRedeployActiveImagesActive: D,
						setIsRedeployActiveImagesActive: te
					}
				})]
			}), /* @__PURE__ */ (0, Q.jsxs)("div", {
				className: `px-20 pt-15 pb-16 flexbox w-100 ${ue ? "dc__content-start" : "dc__content-space"} dc__align-items-center dc__no-shrink dc__border-top h-68 bg__primary`,
				children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "flex dc__gap-8",
					children: [/* @__PURE__ */ (0, Q.jsx)(Ln, { className: "dc__no-shrink icon-dim-20" }), /* @__PURE__ */ (0, Q.jsx)("h3", {
						className: "fs-13 fw-6 lh-20 cn-9 m-0",
						children: "Select environments to deploy image"
					})]
				}), ue ? /* @__PURE__ */ (0, Q.jsx)(vw, {
					environments: l,
					handleCloseOverlay: oe,
					setTriggerCallbacks: E,
					selectedMaterial: C,
					isRedeployActiveImagesActive: D
				}) : /* @__PURE__ */ (0, Q.jsx)(M, {
					variant: F.primary,
					onClick: ae,
					disabled: ne,
					isLoading: g,
					dataTestId: "open-bulk-trigger-overlay",
					size: I.large,
					text: "Select environments...",
					showTooltip: ne,
					tooltipProps: { content: "Please select a material to deploy" }
				})]
			})]
		})
	});
}, bw = {
	INFO_TEXT: "Hotfix Deployment Policy enables direct deployments to specific environments (eg. production), bypassing intermediate environments (eg. staging).",
	HEADING: "Promote image",
	ARIA_LABEL: "Image Promotion Info"
}, xw = () => /* @__PURE__ */ (0, Q.jsx)(su, {
	theme: cu.white,
	className: "w-300 h-100 dc__align-left",
	placement: "auto",
	Icon: jt,
	iconClass: "fcv-5",
	infoText: bw.INFO_TEXT,
	heading: bw.HEADING,
	documentationLink: "IMAGE_PROMOTION",
	showCloseButton: !0,
	trigger: "click",
	interactive: !0,
	openInNewTab: !0,
	children: /* @__PURE__ */ (0, Q.jsx)("button", {
		className: "p-0 h-20 dc__no-background dc__no-border dc__outline-none-imp",
		type: "button",
		"aria-label": bw.ARIA_LABEL,
		children: /* @__PURE__ */ (0, Q.jsx)(m, { className: "icon-dim-20" })
	})
}), Sw = ({ activeTab: e, currentTab: t, isApprovalPendingForPromotion: n, handleTabSwitch: r }) => {
	let i = e === t;
	return /* @__PURE__ */ (0, Q.jsxs)("button", {
		className: `mr-16 dc__tab-focus pr-0 pl-0 pt-0 flexbox dc__gap-4 dc__no-border dc__no-background h-100 mb-neg-1 pb-6 ${i ? "cb-5 fs-13 fw-6 dc__border-bottom-2--b5" : "cn-9 fs-13 fw-4 dc__hover-color-b500"}`,
		onClick: () => {
			i || r(t);
		},
		type: "button",
		"data-testid": `image-promotion-tab-${t}`,
		children: [tt.TABS_TEXT[t], n && t === ae.PENDING && /* @__PURE__ */ (0, Q.jsx)(oo, { rootClassName: "mt-4" })]
	});
}, Cw = ({ activeTab: e, isApprovalPendingForPromotion: t, handleTabSwitch: n }) => /* @__PURE__ */ (0, Q.jsx)("div", {
	className: "w-100 flexbox dc__border-bottom pl-20 pr-20",
	children: Object.values(ae).map((r) => /* @__PURE__ */ (0, Q.jsx)(Sw, {
		activeTab: e,
		currentTab: r,
		isApprovalPendingForPromotion: t,
		handleTabSwitch: n
	}, r))
}), ww = ({ isNotificationConfigured: e }) => {
	let { imageListTab: t } = Z();
	return t === ae.PENDING ? e && /* @__PURE__ */ (0, Q.jsx)("div", {
		className: "flexbox dc__gap-8 dc__ellipsis-right",
		children: tt.NOTIFICATION_INFO.SUCCESS_TEXT
	}) : /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox dc__gap-8 dc__ellipsis-right",
		children: [/* @__PURE__ */ (0, Q.jsx)(lr, { className: "icon-dim-20 dc__no-shrink" }), e ? /* @__PURE__ */ (0, Q.jsx)("p", {
			className: "m-0 cn-9 fs-13 fw-4 lh-20 dc__ellipsis-right",
			children: tt.NOTIFICATION_INFO.CONFIGURED.TEXT
		}) : /* @__PURE__ */ (0, Q.jsx)(ft, {
			className: "default-tt w-200",
			content: /* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox-col",
				children: [/* @__PURE__ */ (0, Q.jsx)("h2", {
					className: "m-0 text__white fs-12 fw-6 lh-18",
					children: tt.NOTIFICATION_INFO.NOT_CONFIGURED.TOOLTIP_HEADING
				}), /* @__PURE__ */ (0, Q.jsx)("p", {
					className: "m-0 text__white fs-12 fw-4 lh-18",
					children: tt.NOTIFICATION_INFO.NOT_CONFIGURED.TOOLTIP_CONTENT
				})]
			}),
			arrow: !1,
			placement: "left",
			children: /* @__PURE__ */ (0, Q.jsxs)("p", {
				className: "m-0 cn-9 fs-13 fw-4 lh-20 dc__ellipsis-right",
				children: [
					/* @__PURE__ */ (0, Q.jsx)(Wf, {
						to: v.NOTIFIER_CONFIG,
						className: "m-0 anchor",
						target: "_blank",
						rel: "noopener noreferrer",
						children: tt.NOTIFICATION_INFO.NOT_CONFIGURED.LINK_TEXT
					}),
					"\xA0",
					tt.NOTIFICATION_INFO.NOT_CONFIGURED.TEXT
				]
			})
		})]
	});
}, Tw = ({ title: e, handleClose: t }) => /* @__PURE__ */ (0, Q.jsxs)("div", {
	className: "w-100 flexbox dc__align-items-center dc__content-space pt-12 pb-12 dc__border-bottom-n1 pl-16 pr-16",
	children: [/* @__PURE__ */ (0, Q.jsx)("h2", {
		className: "cn-9 m-0 fs-14 fw-6 lh-20",
		children: e
	}), /* @__PURE__ */ (0, Q.jsx)("button", {
		type: "button",
		className: "p-0 flex dc__no-border dc__no-background dc__outline-none-imp dc__tab-focus",
		"aria-label": tt.CLOSE_IMAGE_PROMOTION_OVERLAY,
		onClick: t,
		"data-testid": "close-request-promotion-overlay",
		children: /* @__PURE__ */ (0, Q.jsx)(tr, { className: "icon-dim-20 fcn-6" })
	})]
}), Ew = ({ name: e, status: t, message: n }) => {
	let r = ra(t);
	return /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox dc__gap-12 pt-6 pb-6",
		children: [/* @__PURE__ */ (0, Q.jsx)("span", {
			className: "m-0 cn-9 dc__ellipsis-right fs-13 fw-4 lh-20 flex-grow-1 dc__mxw-178",
			children: e
		}), /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "dc__gap-6 flexbox flex-grow-1 dc__mxw-178 dc__align-start",
			children: [r, /* @__PURE__ */ (0, Q.jsx)("p", {
				className: "m-0 cn-9 fs-13 fw-4 lh-20 dc__first-letter-capitalize",
				children: n
			})]
		})]
	});
}, Dw = ({ handleClose: e, selectedMaterial: t, loadingIsNotificationConfigured: n, isNotificationConfigured: r, handleRefresh: i }) => {
	let { appId: a, workflowId: o, imageListTab: s } = Z(), c = Ja(new AbortController()), { environment: l } = Pf({ parseSearchParams: xi }), [u, d, f, p] = hf(() => JC({
		workflowId: o,
		artifactId: t.id,
		abortControllerRef: c
	})), [m, h] = j(!1), [g, _] = j(!1), [v, y] = j({}), [b, x] = j({}), [S, C] = j("");
	k(() => {
		!u && d && (y(Di(d.environments ?? {})), x(d.environments ?? {}));
	}, [u, d]);
	let w = (e) => {
		let t = e.toLowerCase();
		x(Object.keys(d?.environments ?? {}).filter((e) => e.toLowerCase().includes(t)).reduce((e, t) => (e[t] = d?.environments?.[t], e), {})), C(e);
	}, T = () => {
		w("");
	}, ee = (e) => {
		let { name: t } = e.target, n = { ...v };
		n[t] ? delete n[t] : n[t] = b[t], y(n);
	}, E = async () => {
		try {
			h(!0);
			let e = await ZC({
				environment: l,
				action: Li.PROMOTE,
				artifactId: +t.id,
				appId: +a,
				destinationObjectNames: Object.keys(v),
				ciSource: d?.ciSource,
				workflowId: +o,
				imagePromotionTab: s
			});
			_(!0), y(e), i();
		} catch {
			$d();
		} finally {
			h(!1);
		}
	}, D = Object.keys(v), te = Object.keys(b), { eligibleEnvironmentsNames: ne, inEligibleEnvironmentsNames: re } = Ki(b, te), ie = !n && D.length > 0, ae = da(m, D.length), oe = g ? tt.REQUEST_PROMOTION_HEADINGS.RESPONSE : tt.REQUEST_PROMOTION_HEADINGS.REQUEST;
	return /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "dc__position-abs flexbox-col dc__content-space w-400 h-365 bg__primary dc__bottom-16 br-4 dc__border dc__box-shadow--overlay dc__zi-2",
		onClick: uf,
		children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
			className: `w-100 h-100 flexbox-col dc__overflow-auto ${g ? "" : "dc__gap-12"}`,
			children: [/* @__PURE__ */ (0, Q.jsx)(Tw, {
				title: oe,
				handleClose: e
			}), u || pd(f) ? /* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox-col pl-16 pr-16 pt-8 dc__gap-16",
				children: [
					/* @__PURE__ */ (0, Q.jsx)("div", { className: "shimmer-loading w-200 h-16" }),
					/* @__PURE__ */ (0, Q.jsx)("div", { className: "shimmer-loading w-250 h-16" }),
					/* @__PURE__ */ (0, Q.jsx)("div", { className: "shimmer-loading w-100px h-16" })
				]
			}) : f ? /* @__PURE__ */ (0, Q.jsx)(lc, { reload: p }) : g ? /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsx)("div", {
				className: "pt-8 pb-8 pl-16 pr-16 flexbox dc__gap-12",
				children: tt.IMAGE_PROMOTION_OVERLAY_RESPONSE_HEADINGS.map((e) => /* @__PURE__ */ (0, Q.jsx)("h3", {
					className: "m-0 flexbox flex-grow-1 dc__mxw-178 cn-7 fs-12 fw-6 lh-18",
					children: e
				}, e))
			}), /* @__PURE__ */ (0, Q.jsx)("div", {
				className: "pl-16 pr-16 pb-12 flexbox-col dc__overflow-auto",
				children: D.map((e) => /* @__PURE__ */ (0, Q.jsx)(Ew, {
					name: e,
					status: v[e].promotionValidationState,
					message: v[e].promotionValidationMessage
				}, e))
			})] }) : /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsx)("div", {
				className: "w-100 flex pl-16 pr-16",
				children: /* @__PURE__ */ (0, Q.jsx)(Il, {
					containerClassName: "w-100 flex-grow-1",
					handleEnter: w,
					inputProps: {
						placeholder: tt.SEARCH_ENVIRONMENT_PLACEHOLDER,
						autoFocus: !0
					},
					initialSearchText: S
				})
			}), S && te.length === 0 ? /* @__PURE__ */ (0, Q.jsx)(lc, {
				title: tt.REQUEST_PROMOTION_EMPTY_SEARCH.TITLE,
				subTitle: tt.REQUEST_PROMOTION_EMPTY_SEARCH.SUB_TITLE,
				description: "",
				buttonText: tt.REQUEST_PROMOTION_EMPTY_SEARCH.BUTTON_TEXT,
				reload: T,
				rootClassName: "flex-grow-1",
				useInfoIcon: !0
			}) : /* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox-col pl-16 pr-16 h-100 dc__overflow-auto",
				children: [ne.map((e) => /* @__PURE__ */ (0, Q.jsx)(ew, {
					isChecked: !!v[e],
					title: e,
					subTitle: b[e].promotionValidationMessage,
					isDisabled: !b[e].promotionPossible || m,
					onChange: ee
				}, e)), re.length > 0 && /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsx)("div", {
					className: "flex pt-12 pb-12",
					children: /* @__PURE__ */ (0, Q.jsx)("div", { className: "dc__border-bottom-n1 w-100" })
				}), /* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "flex column w-100",
					children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
						className: "flexbox dc__gap-8 w-100 dc__align-items-center pb-8",
						children: [/* @__PURE__ */ (0, Q.jsx)("div", {
							className: "flex p-2",
							children: /* @__PURE__ */ (0, Q.jsx)(hw, { className: "fcr-5" })
						}), /* @__PURE__ */ (0, Q.jsx)("h3", {
							className: "m-0 cn-9 fs-13 fw-6 lh-20",
							children: tt.PROHIBITED_ENVIRONMENT_LIST_HEADING
						})]
					}), re.map((e) => /* @__PURE__ */ (0, Q.jsx)(ew, {
						isChecked: !!v[e],
						title: e,
						subTitle: b[e].promotionValidationMessage,
						subtitleClassName: "cr-5",
						isDisabled: !b[e].promotionPossible || m,
						onChange: $d
					}, e))]
				})] })]
			})] })]
		}), /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: `pt-12 pb-12 pl-16 pr-16 flex ${ie ? "dc__content-space" : "dc__content-end"} dc__gap-12 dc__border-top-n1`,
			children: [ie && /* @__PURE__ */ (0, Q.jsx)(ww, { isNotificationConfigured: r }), g ? /* @__PURE__ */ (0, Q.jsx)("button", {
				type: "button",
				className: "flex h-36 cta dc__no-shrink",
				onClick: e,
				"data-testid": "close-request-promotion-modal",
				children: tt.REQUEST_PROMOTION_CTA.RESPONSE
			}) : /* @__PURE__ */ (0, Q.jsx)(es, {
				condition: !!ae,
				wrap: (e) => /* @__PURE__ */ (0, Q.jsx)(ft, {
					className: "default-tt",
					arrow: !1,
					content: ae,
					children: /* @__PURE__ */ (0, Q.jsx)("span", { children: e })
				}),
				children: /* @__PURE__ */ (0, Q.jsx)("button", {
					type: "button",
					className: "flex h-36 cta dc__no-shrink",
					onClick: E,
					disabled: !!ae,
					"data-testid": "request-promotion-cta",
					children: m ? /* @__PURE__ */ (0, Q.jsx)(ul, {}) : tt.REQUEST_PROMOTION_CTA.REQUEST
				})
			})]
		})]
	});
}, Ow = ({ workflows: e, getModuleInfo: t }) => {
	let n = X(), r = Yf(), { workflowId: i, imageListTab: a } = Z(), { searchKey: o, clearFilters: s } = Pf({ parseSearchParams: xi }), [c, l, , u] = hf(XC), [d, f] = j(!1), { loadingMaterials: p, materialsError: m, reloadMaterials: h, materialResponse: g, reloadEnvironments: _, environmentsError: v, loadingEnvironments: y, environmentListResponse: b, getMaterialsWrapper: x, isSearchActive: S, setIsSearchActive: C, materialResponseState: w, setMaterialResponseState: T } = mw({}), ee = () => {
		n("..");
	}, E = (e) => {
		s(), C(!1), n(r.pathname.replace(a, e));
	}, D = (e) => {
		e.stopPropagation(), f(!0);
	}, te = () => {
		f(!1);
	}, ne = (e) => {
		e.stopPropagation(), f(!1);
	}, re = () => {
		_(), u(), o || C(!1);
	}, ie = e.find((e) => e.id === i), oe = (w?.materials ?? []).find((e) => e.isSelected), se = w?.isApprovalPendingForPromotion ?? !!ie?.artifactPromotionMetadata?.isApprovalPendingForPromotion, ce = wi(y, !!oe);
	return /* @__PURE__ */ (0, Q.jsx)(xu, {
		className: "",
		close: ee,
		children: /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "bg__primary dc__position-fixed dc__right-0 dc__top-0 h-100 flexbox-col dc__content-space w-1024",
			onClick: ne,
			children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox-col flex-grow-1 w-100 bg__tertiary dc__overflow-auto",
				children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "flexbox-col w-100 dc__no-shrink bg__primary",
					children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
						className: "flexbox dc__content-space dc__align-items-center pt-12 pb-12 pl-20 pr-20",
						children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
							className: "flexbox dc__align-items-center dc__gap-8",
							children: [/* @__PURE__ */ (0, Q.jsx)("h2", {
								className: "m-0 cn-9 fs-16 fw-6 lh-24",
								children: `${tt.HEADER} '${ie?.name ?? ""}'`
							}), /* @__PURE__ */ (0, Q.jsx)(xw, {})]
						}), /* @__PURE__ */ (0, Q.jsx)("button", {
							type: "button",
							className: "p-0 flex dc__no-border dc__no-background dc__outline-none-imp dc__tab-focus h-20 w-20 dc__tab-focus",
							onClick: ee,
							"aria-label": tt.CLOSE_MODAL_LABEL,
							"data-testid": "close-image-promotion-modal",
							children: /* @__PURE__ */ (0, Q.jsx)(tr, { className: "icon-dim-20 fcn-6" })
						})]
					}), /* @__PURE__ */ (0, Q.jsx)(Cw, {
						activeTab: a,
						isApprovalPendingForPromotion: se,
						handleTabSwitch: E
					})]
				}), /* @__PURE__ */ (0, Q.jsx)(sw, {
					type: Ze.IMAGE_PROMOTION,
					loadingMaterials: p,
					materialsError: m,
					reloadMaterials: h,
					materialResponse: g,
					materialResponseState: w,
					setMaterialResponseState: T,
					getModuleInfo: t,
					isSearchActive: S,
					setIsSearchActive: C,
					reloadIsNotificationConfigured: u,
					reloadEnvironments: _,
					environmentsError: v,
					loadingEnvironments: y,
					environmentListResponse: b,
					handleTabSwitch: E,
					selectedWorkflow: ie,
					imagePromotionTab: a,
					getMaterialsWrapper: x,
					handleRefresh: re
				})]
			}), a === ae.REQUEST && !m && /* @__PURE__ */ (0, Q.jsx)("div", {
				className: "px-20 pt-15 pb-16 flexbox w-100 dc__content-end dc__align-items-center dc__no-shrink dc__border-top h-68 bg__primary",
				children: !d || !oe ? /* @__PURE__ */ (0, Q.jsx)(es, {
					condition: !!ce,
					wrap: (e) => /* @__PURE__ */ (0, Q.jsx)(ft, {
						className: "default-tt",
						arrow: !1,
						content: ce,
						children: /* @__PURE__ */ (0, Q.jsx)("span", { children: e })
					}),
					children: /* @__PURE__ */ (0, Q.jsxs)("button", {
						type: "button",
						className: "cta flex dc__gap-8 dc__no-text-transform h-36 dc__no-svg-fill",
						onClick: D,
						disabled: !!ce,
						"data-testid": "open-request-promotion-overlay",
						children: [/* @__PURE__ */ (0, Q.jsx)(Yi, { className: "icon-dim-16 scn-0" }), tt.REQUEST_PROMOTION_CTA.OPEN_OVERLAY]
					})
				}) : /* @__PURE__ */ (0, Q.jsx)(Dw, {
					selectedMaterial: oe,
					handleClose: te,
					loadingIsNotificationConfigured: c,
					isNotificationConfigured: l,
					handleRefresh: re
				})
			})]
		})
	});
}, kw = ({ onClick: e, dataTestId: t }) => /* @__PURE__ */ (0, Q.jsx)(M, {
	dataTestId: `add-webhook-image-${t}`,
	variant: F.secondary,
	style: P.neutral,
	size: I.medium,
	text: "Add Image",
	onClick: e,
	fullWidth: !0
}), Aw = async (e, t) => {
	let n = {
		method: "POST",
		headers: {
			Accept: "application/json",
			"Content-Type": "application/json",
			"Access-Control-Allow-Credentials": "true",
			"api-token": ed(tu)
		},
		body: JSON.stringify(t),
		credentials: "include"
	}, r = await fetch(e, n), i = await r.json();
	if (i?.code !== eo.OK) throw new Wl({
		code: i.code,
		errors: i.errors
	});
	return r;
}, jw = {
	title: "Add image (External)",
	description: "You can use this to deploy a new image through this workflow",
	type: "object",
	required: ["dockerImage"],
	properties: {
		dockerImage: {
			type: "string",
			title: "External Image",
			description: "Deploy an image from an external container registry. Ex: docker.io/username/repo:v1.0.0"
		},
		digest: {
			type: "string",
			title: "Image Digest",
			description: "Image digest values are used to create immutable addresses for container images. Ex: sha256:a3d96b9a5b5a01da9c38446ef2807a2f3109492d792424674bca180edd33e3a2"
		},
		ciProjectDetails: {
			type: "array",
			title: "Commit Details",
			description: "Add commit details with which this image was built",
			items: {
				type: "object",
				properties: {
					commitHash: {
						type: "string",
						title: "Commit Hash",
						description: "Add your commit hash"
					},
					message: {
						type: "string",
						title: "Add your commit message",
						description: "Add your commit message if available"
					},
					author: {
						type: "string",
						title: "Commit Author",
						description: "Add the author of this commit"
					},
					commitTime: {
						type: "string",
						title: "Commit Time",
						description: "Add the commited timestamp"
					}
				}
			}
		}
	}
}, Mw = ({ onClose: e, getWebhookDetails: t }) => {
	let [n, r] = j({}), [i, a] = j(!1), o = Ja(null), [s, c, l, u] = hf(t, []);
	return /* @__PURE__ */ (0, Q.jsx)(xu, {
		onEscape: e,
		close: e,
		children: /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "bg__primary w-600 mxh-600 dc__m-auto mt-40 flexbox-col br-8",
			onClick: uf,
			children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flex dc__content-space border__secondary--bottom px-20 pt-16 pb-15",
				children: [/* @__PURE__ */ (0, Q.jsx)("h2", {
					className: "m-0 fs-16 lh-20 fw-6",
					children: "Add image (External)"
				}), /* @__PURE__ */ (0, Q.jsx)(M, {
					icon: /* @__PURE__ */ (0, Q.jsx)(z, {
						name: "ic-close-small",
						color: null
					}),
					dataTestId: "webhook-add-image-modal-close",
					ariaLabel: "webhook-add-image-modal-close",
					variant: F.borderLess,
					style: P.negativeGrey,
					size: I.xs,
					showAriaLabelInTippy: !1,
					onClick: e
				})]
			}), /* @__PURE__ */ (0, Q.jsxs)($a, {
				isLoading: s,
				error: l,
				errorScreenManagerProps: {
					code: l?.code,
					reload: u
				},
				customLoader: /* @__PURE__ */ (0, Q.jsx)("div", {
					className: "mh-300 flex",
					children: /* @__PURE__ */ (0, Q.jsx)(ul, { pageLoader: !0 })
				}),
				children: [/* @__PURE__ */ (0, Q.jsx)("div", {
					className: "flex-grow-1 dc__overflow-auto",
					children: /* @__PURE__ */ (0, Q.jsx)(gl, {
						ref: o,
						schema: jw,
						formData: n,
						onChange: (e) => {
							r(e.formData);
						},
						uiSchema: mc,
						liveValidate: !0
					})
				}), /* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "flex right dc__gap-12 border__secondary--top px-20 pt-15 pb-16",
					children: [/* @__PURE__ */ (0, Q.jsx)(M, {
						dataTestId: "webhook-add-image-modal-cancel",
						variant: F.secondary,
						style: P.neutral,
						size: I.medium,
						onClick: e,
						text: "Cancel"
					}), /* @__PURE__ */ (0, Q.jsx)(M, {
						dataTestId: "webhook-add-image-modal-save",
						size: I.medium,
						isLoading: i,
						disabled: s,
						onClick: async () => {
							if (!(!o.current?.validateForm || o.current.validateForm())) {
								H.showToast({
									variant: U.error,
									description: "Some required fields are missing"
								});
								return;
							}
							a(!0);
							try {
								await Aw(c.result.webhookUrl, n), e(), H.showToast({
									variant: U.success,
									description: "Image is added"
								});
							} catch (e) {
								K(e);
							} finally {
								a(!1);
							}
						},
						text: "Add Image"
					})]
				})]
			})]
		})
	});
}, Nw = ({ workflows: e, getModuleInfo: t, appName: n, reloadWorkflowStatus: r }) => {
	let { useImageListType: i } = Z();
	return i === Ze.BULK_DEPLOY ? /* @__PURE__ */ (0, Q.jsx)(yw, {
		workflows: e,
		getModuleInfo: t,
		appName: n,
		reloadWorkflowStatus: r
	}) : /* @__PURE__ */ (0, Q.jsx)(Ow, {
		workflows: e,
		getModuleInfo: t
	});
}, Pw = ({ ...e }) => /* @__PURE__ */ (0, Q.jsx)(qf, { children: /* @__PURE__ */ (0, Q.jsx)(J, {
	path: LC,
	element: /* @__PURE__ */ (0, Q.jsx)(Nw, { ...e })
}) }), Fw = ({ installedAppVersionHistoryId: e }) => {
	let [t, n, r, i] = hf(() => Ed({ installedAppVersionHistoryId: e }), [e]);
	return t ? /* @__PURE__ */ (0, Q.jsx)(ul, { pageLoader: !0 }) : r ? /* @__PURE__ */ (0, Q.jsx)(Ks, {
		code: r.code,
		reload: i
	}) : n.result.scanned ? /* @__PURE__ */ (0, Q.jsx)("div", {
		className: "p-20 h-100 bg__primary",
		children: /* @__PURE__ */ (0, Q.jsx)(Rl, {
			scanResult: n?.result,
			Sidebar: _i
		})
	}) : /* @__PURE__ */ (0, Q.jsx)(R, {
		SvgImage: $p,
		title: Hs.CI_DETAILS_IMAGE_NOT_SCANNED.TITLE
	});
}, Iw = ({ appDetails: e, appId: t, envId: n }) => e.appType === ho.DEVTRON_APP ? {
	appIdentifier: `${e.clusterId}|${t}|${n}`,
	appType: Oc.DEVTRON_APP
} : e.appType === ho.EXTERNAL_ARGO_APP ? {
	appIdentifier: `${e.clusterId}`,
	appType: Oc.EXTERNAL_ARGO_APP
} : e.appType === ho.EXTERNAL_FLUX_APP ? {
	appIdentifier: `${e.clusterId}|${e.namespace}|${e.appName}|${e.fluxTemplateType === "Kustomization"}`,
	appType: Oc.EXTERNAL_FLUX_APP
} : {
	appIdentifier: `${e.clusterId}|${e.namespace}|${e.appName}`,
	appType: Oc.HELM_APP
}, Lw = (e, t) => e ? t || null : "Please enter a file path", Rw = ({ handleClose: e, appDetails: t, isResourceBrowserView: n, isClusterTerminalView: r, containerName: i, clusterViewPodName: a }) => {
	let { appId: o, envId: s, clusterId: c, namespace: l, podName: u, name: d } = Z(), f = jf(), [p, m] = j(""), [h, g] = j(""), { handleDownload: _, isDownloading: v } = yf(), y = () => {
		if (n) return Rd(`${O.K8S_DOWNLOAD_POD_CONTENT}/${c}/${l}/${d}/${i}`, { path: p });
		if (r) {
			let { namespace: e } = f.searchParams;
			return Rd(`${O.K8S_DOWNLOAD_POD_CONTENT}/${c}/${e}/${a}/${i}`, { path: p });
		}
		let { appIdentifier: e, appType: m } = Iw({
			appDetails: t,
			appId: o,
			envId: s
		}), h = t.resourceTree?.nodes?.find((e) => e.name === u)?.namespace, g = t.appType === ho.EXTERNAL_ARGO_APP;
		return Rd(`${O.K8S_DOWNLOAD_POD_CONTENT}/${e}/${h}/${u}/${i}`, {
			path: p,
			appType: m,
			...g && { externalArgoApplicationName: t.appName }
		});
	}, b = (e) => e ? e[0] === "/" ? (g(""), !0) : (g("File path must start with /"), !1) : (g("You must provide a valid file path."), !1), x = (e) => {
		let t = e.target.value;
		m(t), b(t);
	}, S = Lw(p, h);
	return /* @__PURE__ */ (0, Q.jsx)(Su, {
		className: "visible-modal__body",
		close: e,
		children: /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox-col bg__primary w-500 dc__m-auto mt-40 dc__border-radius-8-imp dc__overflow-hidden",
			onClick: uf,
			children: [
				/* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "flexbox dc__align-items-center dc__content-space py-12 px-20 dc__border-bottom",
					children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
						className: "flexbox dc__align-items-center dc__gap-12",
						children: [/* @__PURE__ */ (0, Q.jsx)(yi, { className: "icon-dim-20 dc__no-shrink" }), /* @__PURE__ */ (0, Q.jsx)("span", {
							className: "fs-16 fw-6 lh-24 dc__content-space",
							children: "Download file/folder"
						})]
					}), /* @__PURE__ */ (0, Q.jsx)("button", {
						type: "button",
						className: "dc__transparent p-0-imp h-20",
						onClick: e,
						"aria-label": "close-button",
						children: /* @__PURE__ */ (0, Q.jsx)(tr, { className: "icon-dim-20 dc__no-shrink" })
					})]
				}),
				/* @__PURE__ */ (0, Q.jsx)("div", {
					className: "px-20 py-16 h-200",
					children: /* @__PURE__ */ (0, Q.jsx)(os, {
						name: "file-path",
						value: p,
						onChange: x,
						label: "File Path",
						required: !0,
						error: h,
						placeholder: "/home/dir/filename.txt",
						disabled: v,
						helperText: "Please provide absolute file path"
					})
				}),
				/* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "px-20 py-16 flexbox dc__align-item-center flex-justify-end dc__gap-12",
					children: [/* @__PURE__ */ (0, Q.jsx)(M, {
						dataTestId: "cancel-download",
						text: "Close",
						variant: F.secondary,
						style: P.neutral,
						onClick: e
					}), /* @__PURE__ */ (0, Q.jsx)("div", { children: /* @__PURE__ */ (0, Q.jsx)(M, {
						dataTestId: "download-content",
						text: "Download",
						isLoading: v,
						disabled: !!S,
						onClick: async () => {
							S || (await _({
								downloadUrl: y(),
								showFilePreparingToast: !0
							}), e());
						},
						showTooltip: !!S,
						tooltipProps: { content: S }
					}) })]
				})
			]
		})
	});
}, zw = (e) => {
	let [t, n] = j(!1), r = () => {
		n(!0), Mn.event({
			category: "Terminal",
			action: "Download File"
		});
	}, i = () => {
		n(!1);
	};
	return /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [
		/* @__PURE__ */ (0, Q.jsx)("span", { className: "dc__border-right h-16" }),
		/* @__PURE__ */ (0, Q.jsx)(M, {
			dataTestId: "download-file-folder",
			onClick: r,
			text: "Download file/folder",
			variant: F.text,
			size: I.small,
			startIcon: /* @__PURE__ */ (0, Q.jsx)(z, {
				name: "ic-arrow-right",
				color: null,
				rotateBy: 90
			})
		}),
		t && /* @__PURE__ */ (0, Q.jsx)(Rw, {
			...e,
			handleClose: i
		})
	] });
}, Bw = ({ ttl: e, isTrial: t, licenseStatus: n, isFreemium: r }) => {
	if (r) return null;
	if (n === Mc.EXPIRED) return {
		message: "You’re using unlicensed version of Devtron",
		iconName: "ic-error",
		type: Sc.ERROR
	};
	let i = jd(e);
	return n === Mc.REMINDER_THRESHOLD_REACHED ? {
		message: `Your enterprise license expires in ${i}.`,
		iconName: "ic-warning",
		type: Sc.WARNING
	} : t ? {
		message: `Your trial license will expire in ${i}.`,
		iconName: "ic-calendar",
		type: Sc.INFORMATION
	} : null;
}, Vw = () => {
	let { handleOpenLicenseInfoDialog: e, licenseData: t, setLicenseData: n } = Tf(), [, r] = hf(Fn, []);
	if (k(() => {
		r && r.showLicenseData && n(r);
	}, [r]), !t || t.licenseStatusError) return null;
	let { ttl: i, licenseStatus: a, isTrial: o, isFreemium: s } = t, c = Bw({
		ttl: i,
		licenseStatus: a,
		isTrial: o,
		isFreemium: s
	});
	if (!c) return null;
	let l = () => {
		e(jc.LICENSE);
	}, { message: u, type: d, iconName: f } = c;
	return {
		message: u,
		type: d,
		iconName: f,
		handleOpenLicenseDialog: l
	};
}, Hw = (e) => /* @__PURE__ */ (0, Q.jsx)("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	...e,
	children: /* @__PURE__ */ (0, Q.jsx)("path", {
		d: "M3.33334 5H17.0833M3.33334 8.33333H16.25M3.33334 11.6667H12.0833M3.33334 15H14.5833",
		stroke: "#3B444C",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Uw = (e) => /* @__PURE__ */ (0, Q.jsxs)("svg", {
	"data-style-override": "false",
	width: 250,
	height: 200,
	viewBox: "0 0 250 200",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [/* @__PURE__ */ (0, Q.jsxs)("g", {
		clipPath: "url(#clip0_3754_4493)",
		children: [
			/* @__PURE__ */ (0, Q.jsxs)("g", {
				clipPath: "url(#clip1_3754_4493)",
				children: [
					/* @__PURE__ */ (0, Q.jsx)("rect", {
						width: 202.366,
						height: 12.6479,
						transform: "translate(40.6343 15.0001)",
						fill: "#A1C3FC"
					}),
					/* @__PURE__ */ (0, Q.jsx)("circle", {
						cx: 216.439,
						cy: 21.3241,
						r: 2.52957,
						fill: "white"
					}),
					/* @__PURE__ */ (0, Q.jsx)("circle", {
						cx: 225.293,
						cy: 21.3241,
						r: 2.52957,
						fill: "white"
					}),
					/* @__PURE__ */ (0, Q.jsx)("circle", {
						cx: 234.147,
						cy: 21.3241,
						r: 2.52957,
						fill: "white"
					}),
					/* @__PURE__ */ (0, Q.jsx)("rect", {
						width: 202.366,
						height: 126.479,
						transform: "translate(40.6343 27.648)",
						fill: "url(#paint0_linear_3754_4493)"
					}),
					/* @__PURE__ */ (0, Q.jsx)("rect", {
						x: 55.8118,
						y: 42.8254,
						width: 27.8253,
						height: 5.05914,
						rx: 1.26479,
						fill: "white"
					}),
					/* @__PURE__ */ (0, Q.jsx)("rect", {
						x: 91.2258,
						y: 42.8254,
						width: 63.2393,
						height: 5.05914,
						rx: 1.26479,
						fill: "white"
					}),
					/* @__PURE__ */ (0, Q.jsx)("rect", {
						x: 164.583,
						y: 78.2394,
						width: 63.2393,
						height: 7.58872,
						rx: 1.26479,
						fill: "white"
					}),
					/* @__PURE__ */ (0, Q.jsx)("rect", {
						x: 169.643,
						y: 93.4169,
						width: 53.121,
						height: 7.58872,
						rx: 1.26479,
						fill: "white"
					}),
					/* @__PURE__ */ (0, Q.jsx)("rect", {
						x: 55.8118,
						y: 58.0029,
						width: 88.535,
						height: 5.05914,
						rx: 1.26479,
						fill: "white"
					}),
					/* @__PURE__ */ (0, Q.jsx)("rect", {
						x: 55.8118,
						y: 73.1803,
						width: 98.6533,
						height: 5.05914,
						rx: 1.26479,
						fill: "white"
					}),
					/* @__PURE__ */ (0, Q.jsx)("rect", {
						x: 55.8118,
						y: 88.3577,
						width: 70.828,
						height: 5.05914,
						rx: 1.26479,
						fill: "white"
					}),
					/* @__PURE__ */ (0, Q.jsx)("rect", {
						x: 55.8118,
						y: 103.535,
						width: 82.2111,
						height: 5.05914,
						rx: 1.26479,
						fill: "white"
					}),
					/* @__PURE__ */ (0, Q.jsx)("rect", {
						x: 55.8118,
						y: 118.713,
						width: 172.011,
						height: 20.2366,
						rx: 2.52957,
						fill: "white",
						stroke: "#A1C3FC",
						strokeWidth: 1.26479,
						strokeDasharray: "2.53 2.53"
					}),
					/* @__PURE__ */ (0, Q.jsx)("circle", {
						cx: 196.203,
						cy: 52.9437,
						r: 15.1774,
						fill: "white"
					})
				]
			}),
			/* @__PURE__ */ (0, Q.jsx)("rect", {
				x: 188.82,
				y: 195.728,
				width: 36.5383,
				height: 4.21595,
				rx: 1.26479,
				fill: "url(#paint1_linear_3754_4493)"
			}),
			/* @__PURE__ */ (0, Q.jsx)("path", {
				d: "M194.441 195.728H219.737L217.98 188.701H196.198L194.441 195.728Z",
				fill: "url(#paint2_linear_3754_4493)"
			}),
			/* @__PURE__ */ (0, Q.jsx)("path", {
				d: "M212.71 167.621H201.468L202.394 163.916C202.675 162.79 203.687 162 204.848 162H209.33C210.49 162 211.502 162.79 211.784 163.916L212.71 167.621Z",
				fill: "url(#paint3_linear_3754_4493)"
			}),
			/* @__PURE__ */ (0, Q.jsx)("path", {
				d: "M197.954 181.674L199.711 174.648H214.467L216.223 181.674H197.954Z",
				fill: "url(#paint4_linear_3754_4493)"
			}),
			/* @__PURE__ */ (0, Q.jsx)("path", {
				d: "M199.711 174.648L201.468 167.621H212.71L214.467 174.648H199.711Z",
				fill: "url(#paint5_linear_3754_4493)"
			}),
			/* @__PURE__ */ (0, Q.jsx)("path", {
				d: "M196.198 188.7L197.954 181.674H216.223L217.98 188.7H196.198Z",
				fill: "url(#paint6_linear_3754_4493)"
			}),
			/* @__PURE__ */ (0, Q.jsx)("rect", {
				x: 168.17,
				y: 200.365,
				width: 36.5383,
				height: 4.21595,
				rx: 1.26479,
				transform: "rotate(-112 168.17 200.365)",
				fill: "url(#paint7_linear_3754_4493)"
			}),
			/* @__PURE__ */ (0, Q.jsx)("path", {
				d: "M166.065 195.153L156.589 171.699L150.732 175.96L158.892 196.157L166.065 195.153Z",
				fill: "url(#paint8_linear_3754_4493)"
			}),
			/* @__PURE__ */ (0, Q.jsx)("path", {
				d: "M133.161 188.744L137.372 199.168L133.59 199.697C132.44 199.858 131.329 199.215 130.894 198.139L129.215 193.984C128.78 192.907 129.134 191.673 130.072 190.99L133.161 188.744Z",
				fill: "url(#paint9_linear_3754_4493)"
			}),
			/* @__PURE__ */ (0, Q.jsx)("path", {
				d: "M151.718 197.161L144.545 198.164L139.017 184.483L144.874 180.222L151.718 197.161Z",
				fill: "url(#paint10_linear_3754_4493)"
			}),
			/* @__PURE__ */ (0, Q.jsx)("path", {
				d: "M144.545 198.164L137.372 199.167L133.161 188.743L139.018 184.482L144.545 198.164Z",
				fill: "url(#paint11_linear_3754_4493)"
			}),
			/* @__PURE__ */ (0, Q.jsx)("path", {
				d: "M158.891 196.157L151.718 197.161L144.874 180.222L150.731 175.961L158.891 196.157Z",
				fill: "url(#paint12_linear_3754_4493)"
			}),
			/* @__PURE__ */ (0, Q.jsx)("path", {
				d: "M56.0381 74.3616L59.9031 66.8605C62.3103 65.4102 66.4555 63.7262 65.2912 67.4336C64.1269 71.1411 62.7654 73.6812 63.4936 75.5553L56.0381 74.3616Z",
				fill: "url(#paint13_linear_3754_4493)"
			}),
			/* @__PURE__ */ (0, Q.jsx)("path", {
				d: "M68.0421 68.5041C70.203 67.4501 71.3657 64.6539 71.6768 63.3875C71.6768 63.3875 73.4742 62.8828 73.4047 62.3595C73.3352 61.8361 72.331 59.7251 71.4285 58.3076C70.4744 56.8091 69.7579 55.9463 69.0677 55.3718C66.2535 53.0295 63.5923 52.5245 60.9537 52.8279C57.9634 53.1717 54.6099 55.8291 54.1676 59.4812C53.761 62.8374 58.3466 67.2884 60.2791 68.2035C62.2115 69.1186 65.3409 69.8216 68.0421 68.5041Z",
				fill: "#FFBEB6"
			}),
			/* @__PURE__ */ (0, Q.jsx)("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M70.4299 60.7937C70.5993 60.9567 70.8536 61.0868 71.1945 61.0868C71.5354 61.0868 71.7897 60.9567 71.9591 60.7937C72.1367 60.6229 72.2063 60.432 72.2063 60.3278H72.7122C72.7122 60.6029 72.5596 60.9179 72.3099 61.1583C72.0519 61.4065 71.6739 61.5927 71.1945 61.5927C70.7151 61.5927 70.3371 61.4065 70.0791 61.1583C69.8294 60.9179 69.6768 60.6029 69.6768 60.3278H70.1827C70.1827 60.432 70.2523 60.6229 70.4299 60.7937Z",
				fill: "#23286B"
			}),
			/* @__PURE__ */ (0, Q.jsx)("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M54.3563 64.4234C53.9517 65.967 53.9328 68.8578 56.7591 69.7362C60.4814 70.893 64.0355 66.373 63.9296 61.9663C65.1618 62.6342 66.9063 61.814 67.0819 59.4852C68.5229 59.6729 71.7099 59.2426 73.0327 55.998C73.515 54.8149 73.4933 53.5008 73.248 52.4138C73.1252 51.8692 72.9451 51.3765 72.7397 50.9801C72.5367 50.5883 72.3002 50.2736 72.0556 50.1046L71.8574 50.3915C72.0332 50.5129 72.2375 50.7687 72.4301 51.1405C72.6204 51.5077 72.7909 51.9719 72.9079 52.4905C73.1424 53.5298 73.1578 54.7674 72.7098 55.8664C71.7234 58.286 69.6286 59.0401 68.1302 59.1572C70.288 58.6338 72.2143 56.8773 72.3628 54.8809C72.535 52.5677 71.5872 50.2435 69.8743 49.7786C68.504 49.4066 67.1487 51.046 66.6423 51.9122C66.3557 50.6898 65.2591 48.3145 63.473 47.6994C61.1261 46.8912 59.6702 47.1392 58.8393 48.1017C58.1483 48.9021 58.7776 50.2146 59.2751 51.2522C59.3759 51.4623 59.4712 51.6612 59.5491 51.8423C58.8061 51.4616 56.9593 50.9505 55.5157 51.9518C54.0721 52.9531 54.7945 54.4089 55.3362 55.0116C54.6408 54.8554 52.799 54.8373 50.9953 56.0143C48.7406 57.4855 48.034 60.9881 48.6927 62.3387C49.2258 63.4317 50.5858 64.9729 52.7554 64.7066C52.6321 64.7453 52.5062 64.7818 52.3785 64.8152C51.5743 65.0258 50.7306 65.1065 50.0651 64.8773C48.7145 64.4123 48.1995 63.2097 48.1126 62.6788L47.7685 62.7351C47.8693 63.351 48.4444 64.6881 49.9516 65.207C50.7149 65.4699 51.6403 65.3689 52.4669 65.1525C53.2112 64.9576 53.8982 64.663 54.3563 64.4234ZM54.4232 64.191L54.4243 64.1874L54.4218 64.1886L54.4232 64.191Z",
				fill: "#23286B"
			}),
			/* @__PURE__ */ (0, Q.jsx)("path", {
				d: "M57.2817 199.194L61.2727 187.811H68.8564L71.0335 189.625C72.8473 191.167 81.0933 195.558 82.1445 196.156C82.8443 196.554 83.7689 197.566 84.916 199.194C64.8065 199.164 57.2817 199.194 57.2817 199.194Z",
				fill: "url(#paint14_linear_3754_4493)"
			}),
			/* @__PURE__ */ (0, Q.jsx)("path", {
				d: "M35.7805 199.194L39.7714 187.811H48.62L50.7971 189.625C52.6109 191.167 60.8569 195.558 61.9081 196.156C62.6079 196.554 63.5325 197.566 64.6796 199.194C44.5701 199.164 35.7805 199.194 35.7805 199.194Z",
				fill: "url(#paint15_linear_3754_4493)"
			}),
			/* @__PURE__ */ (0, Q.jsx)("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M107.526 49.1114C108.037 48.635 108.837 48.663 109.313 49.1738L110.176 50.0989C110.652 50.6097 110.624 51.41 110.113 51.8864L96.2383 64.8252L116.94 87.0253L130.815 74.0866C131.326 73.6102 132.127 73.6382 132.603 74.149L133.466 75.074C133.942 75.5849 133.914 76.3852 133.403 76.8616L29.8025 173.471C29.2916 173.947 28.4913 173.919 28.0149 173.408L27.1523 172.483C26.6759 171.973 26.7038 171.172 27.2147 170.696L36.4648 162.07L15.7628 139.87L6.51274 148.496C6.00188 148.972 5.20155 148.944 4.72516 148.433L3.86257 147.508C3.38618 146.997 3.41413 146.197 3.925 145.721L107.526 49.1114ZM18.5378 137.282L39.2398 159.482L55.8899 143.956L35.1879 121.756L37.963 119.168L58.6649 141.368L75.315 125.842L54.6131 103.641L18.5378 137.282ZM57.3881 101.054L78.09 123.254L94.7402 107.727L74.0382 85.5271L57.3881 101.054ZM114.165 89.6131L97.5152 105.14L76.8132 82.9394L93.4633 67.4129L114.165 89.6131Z",
				fill: "#428DFC"
			}),
			/* @__PURE__ */ (0, Q.jsx)("path", {
				d: "M75.518 109.158C78.8961 110.668 81.1393 111.579 82.2472 111.891C83.5719 112.247 84.3477 112.118 87.3521 111.051C87.7392 110.922 89.0644 110.114 90.2922 109.339C93.3616 107.303 94.0724 108.273 91.52 110.954C90.8411 111.698 90.3566 112.505 90.486 112.763C90.5823 112.99 92.4246 113.022 94.5244 112.796C95.2254 112.556 96.9613 110.497 97.1226 110.659C97.5102 111.046 96.0429 116.059 94.5894 116.673C93.943 116.996 88.7418 117.222 82.9905 117.222C79.1565 117.223 73.7491 117.019 66.7678 116.612L75.518 109.158Z",
				fill: "#FAB6AF"
			}),
			/* @__PURE__ */ (0, Q.jsx)("path", {
				d: "M73.092 141.646C72.5631 135.329 64.8708 108.129 64.8708 108.129H49.6934C49.4826 111.08 49.1875 117.868 49.6934 121.409C50.3258 125.836 53.4878 133.425 53.4878 136.587C53.4878 139.749 54.7525 151.132 54.7525 154.926C54.7525 158.721 54.1202 161.25 53.4878 163.78C52.8554 166.309 52.8554 172.001 53.4878 176.428C53.9937 179.969 55.8065 185.703 56.6497 187.811H71.8272C71.8272 187.811 73.5691 147.345 73.092 141.646Z",
				fill: "#1D225F"
			}),
			/* @__PURE__ */ (0, Q.jsx)("path", {
				d: "M66.7677 137.852C66.7677 140.381 64.9242 151.778 64.2381 154.294C62.3409 161.25 55.3846 177.06 51.5902 187.811H34.5156C34.7264 184.438 36.0334 177.06 37.0452 174.53C38.31 171.368 42.1873 166.967 42.7367 165.045C44.0015 160.618 44.0015 156.191 45.2663 153.029C46.5311 149.867 49.6931 144.176 49.6931 141.014C49.6931 137.852 47.1635 134.057 45.8987 129.631C44.6339 125.204 44.6339 119.512 44.6339 116.983C44.6339 114.313 44.8447 110.237 45.2663 108.129H66.7677V137.852Z",
				fill: "url(#paint16_linear_3754_4493)"
			}),
			/* @__PURE__ */ (0, Q.jsx)("path", {
				d: "M66.135 80.3042C66.6409 81.822 70.9833 96.1141 73.0913 103.07C73.7237 106.233 71.1942 108.129 68.6646 108.762C66.135 109.394 51.59 109.394 49.0604 109.394C45.2662 109.394 42.104 108.762 38.9421 106.864C35.7801 104.967 37.2451 99.0087 38.9421 96.7462C40.8395 94.2165 44.0012 91.6871 45.8984 88.5251C47.7956 85.3631 49.6928 80.9364 50.3252 79.6716C50.9576 78.4068 52.6056 76.2227 54.7519 74.6127C57.2815 72.7151 60.4434 72.7155 62.3406 73.3479C63.8852 73.8628 65.5026 78.4071 66.135 80.3042Z",
				fill: "url(#paint17_linear_3754_4493)"
			}),
			/* @__PURE__ */ (0, Q.jsx)("path", {
				d: "M80.6804 123.939V104.335C67.4002 104.335 64.8706 96.1138 64.2382 94.2166C63.6058 92.3194 62.341 87.2603 62.341 83.4659C62.341 79.6716 60.4094 77.991 57.9143 78.4068C54.1199 79.0391 50.9579 83.4658 49.6931 87.8926C48.4284 92.3193 47.1636 98.011 47.1636 101.805C47.1636 105.6 49.6931 109.394 51.5903 111.291C53.4875 113.188 57.9143 113.821 60.4438 115.718C62.9734 117.615 66.1354 120.777 69.2973 122.674C71.8269 124.192 77.94 124.15 80.6804 123.939Z",
				fill: "url(#paint18_linear_3754_4493)"
			})
		]
	}), /* @__PURE__ */ (0, Q.jsxs)("defs", { children: [
		/* @__PURE__ */ (0, Q.jsxs)("linearGradient", {
			id: "paint0_linear_3754_4493",
			x1: 101.183,
			y1: 0,
			x2: 101.183,
			y2: 126.479,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ (0, Q.jsx)("stop", { stopColor: "#F3F3F3" }), /* @__PURE__ */ (0, Q.jsx)("stop", {
				offset: 1,
				stopColor: "#EEEEEE"
			})]
		}),
		/* @__PURE__ */ (0, Q.jsxs)("linearGradient", {
			id: "paint1_linear_3754_4493",
			x1: 188.82,
			y1: 199.944,
			x2: 225.358,
			y2: 199.944,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ (0, Q.jsx)("stop", { stopColor: "#D99D05" }), /* @__PURE__ */ (0, Q.jsx)("stop", {
				offset: .315157,
				stopColor: "#EFB305"
			})]
		}),
		/* @__PURE__ */ (0, Q.jsxs)("linearGradient", {
			id: "paint2_linear_3754_4493",
			x1: 194.441,
			y1: 195.728,
			x2: 219.737,
			y2: 195.728,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ (0, Q.jsx)("stop", { stopColor: "#D99D05" }), /* @__PURE__ */ (0, Q.jsx)("stop", {
				offset: 1,
				stopColor: "#EFB305"
			})]
		}),
		/* @__PURE__ */ (0, Q.jsxs)("linearGradient", {
			id: "paint3_linear_3754_4493",
			x1: 201.468,
			y1: 167.621,
			x2: 212.71,
			y2: 167.621,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ (0, Q.jsx)("stop", { stopColor: "#D99D05" }), /* @__PURE__ */ (0, Q.jsx)("stop", {
				offset: 1,
				stopColor: "#EFB305"
			})]
		}),
		/* @__PURE__ */ (0, Q.jsxs)("linearGradient", {
			id: "paint4_linear_3754_4493",
			x1: 197.954,
			y1: 181.674,
			x2: 216.223,
			y2: 181.674,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ (0, Q.jsx)("stop", { stopColor: "#D99D05" }), /* @__PURE__ */ (0, Q.jsx)("stop", {
				offset: 1,
				stopColor: "#EFB305"
			})]
		}),
		/* @__PURE__ */ (0, Q.jsxs)("linearGradient", {
			id: "paint5_linear_3754_4493",
			x1: 199.36,
			y1: 176.053,
			x2: 214.818,
			y2: 176.053,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ (0, Q.jsx)("stop", { stopColor: "#EFEFEF" }), /* @__PURE__ */ (0, Q.jsx)("stop", {
				offset: 1,
				stopColor: "white"
			})]
		}),
		/* @__PURE__ */ (0, Q.jsxs)("linearGradient", {
			id: "paint6_linear_3754_4493",
			x1: 195.846,
			y1: 190.106,
			x2: 218.331,
			y2: 190.106,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ (0, Q.jsx)("stop", { stopColor: "#EFEFEF" }), /* @__PURE__ */ (0, Q.jsx)("stop", {
				offset: 1,
				stopColor: "white"
			})]
		}),
		/* @__PURE__ */ (0, Q.jsxs)("linearGradient", {
			id: "paint7_linear_3754_4493",
			x1: 168.17,
			y1: 204.581,
			x2: 204.708,
			y2: 204.581,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ (0, Q.jsx)("stop", { stopColor: "#D99D05" }), /* @__PURE__ */ (0, Q.jsx)("stop", {
				offset: .315157,
				stopColor: "#EFB305"
			})]
		}),
		/* @__PURE__ */ (0, Q.jsxs)("linearGradient", {
			id: "paint8_linear_3754_4493",
			x1: 166.065,
			y1: 195.153,
			x2: 156.589,
			y2: 171.699,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ (0, Q.jsx)("stop", { stopColor: "#D99D05" }), /* @__PURE__ */ (0, Q.jsx)("stop", {
				offset: 1,
				stopColor: "#EFB305"
			})]
		}),
		/* @__PURE__ */ (0, Q.jsxs)("linearGradient", {
			id: "paint9_linear_3754_4493",
			x1: 137.372,
			y1: 199.168,
			x2: 133.161,
			y2: 188.744,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ (0, Q.jsx)("stop", { stopColor: "#D99D05" }), /* @__PURE__ */ (0, Q.jsx)("stop", {
				offset: 1,
				stopColor: "#EFB305"
			})]
		}),
		/* @__PURE__ */ (0, Q.jsxs)("linearGradient", {
			id: "paint10_linear_3754_4493",
			x1: 151.718,
			y1: 197.161,
			x2: 144.874,
			y2: 180.222,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ (0, Q.jsx)("stop", { stopColor: "#D99D05" }), /* @__PURE__ */ (0, Q.jsx)("stop", {
				offset: 1,
				stopColor: "#EFB305"
			})]
		}),
		/* @__PURE__ */ (0, Q.jsxs)("linearGradient", {
			id: "paint11_linear_3754_4493",
			x1: 145.98,
			y1: 197.963,
			x2: 140.189,
			y2: 183.63,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ (0, Q.jsx)("stop", { stopColor: "#EFEFEF" }), /* @__PURE__ */ (0, Q.jsx)("stop", {
				offset: 1,
				stopColor: "white"
			})]
		}),
		/* @__PURE__ */ (0, Q.jsxs)("linearGradient", {
			id: "paint12_linear_3754_4493",
			x1: 160.325,
			y1: 195.957,
			x2: 151.902,
			y2: 175.109,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ (0, Q.jsx)("stop", { stopColor: "#EFEFEF" }), /* @__PURE__ */ (0, Q.jsx)("stop", {
				offset: 1,
				stopColor: "white"
			})]
		}),
		/* @__PURE__ */ (0, Q.jsxs)("linearGradient", {
			id: "paint13_linear_3754_4493",
			x1: 62.6244,
			y1: 68.7334,
			x2: 60.785,
			y2: 73.3745,
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ (0, Q.jsx)("stop", { stopColor: "#FBA19B" }),
				/* @__PURE__ */ (0, Q.jsx)("stop", {
					offset: .349149,
					stopColor: "#F9ADA7"
				}),
				/* @__PURE__ */ (0, Q.jsx)("stop", {
					offset: 1,
					stopColor: "#F9AFA9"
				})
			]
		}),
		/* @__PURE__ */ (0, Q.jsxs)("linearGradient", {
			id: "paint14_linear_3754_4493",
			x1: 59.3203,
			y1: 188.026,
			x2: 67.5424,
			y2: 206.802,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ (0, Q.jsx)("stop", {
				offset: .090505,
				stopColor: "#2C7DE7"
			}), /* @__PURE__ */ (0, Q.jsx)("stop", {
				offset: .492038,
				stopColor: "#1D72D9"
			})]
		}),
		/* @__PURE__ */ (0, Q.jsxs)("linearGradient", {
			id: "paint15_linear_3754_4493",
			x1: 37.9124,
			y1: 188.026,
			x2: 45.8844,
			y2: 207.064,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ (0, Q.jsx)("stop", {
				offset: .0747083,
				stopColor: "#428DFC"
			}), /* @__PURE__ */ (0, Q.jsx)("stop", {
				offset: 1,
				stopColor: "#428DFC"
			})]
		}),
		/* @__PURE__ */ (0, Q.jsxs)("linearGradient", {
			id: "paint16_linear_3754_4493",
			x1: 52.2575,
			y1: 108.129,
			x2: 27.1092,
			y2: 180.661,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ (0, Q.jsx)("stop", { stopColor: "#2A318C" }), /* @__PURE__ */ (0, Q.jsx)("stop", {
				offset: 1,
				stopColor: "#1D225F"
			})]
		}),
		/* @__PURE__ */ (0, Q.jsxs)("linearGradient", {
			id: "paint17_linear_3754_4493",
			x1: 55.135,
			y1: 72.9696,
			x2: 55.135,
			y2: 109.394,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ (0, Q.jsx)("stop", { stopColor: "#A1C3FC" }), /* @__PURE__ */ (0, Q.jsx)("stop", {
				offset: 1,
				stopColor: "#91B9F7"
			})]
		}),
		/* @__PURE__ */ (0, Q.jsxs)("linearGradient", {
			id: "paint18_linear_3754_4493",
			x1: 63.922,
			y1: 78.3449,
			x2: 63.922,
			y2: 124.046,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ (0, Q.jsx)("stop", { stopColor: "#9FC2FC" }), /* @__PURE__ */ (0, Q.jsx)("stop", {
				offset: 1,
				stopColor: "#A1C3FC"
			})]
		}),
		/* @__PURE__ */ (0, Q.jsx)("clipPath", {
			id: "clip0_3754_4493",
			children: /* @__PURE__ */ (0, Q.jsx)("rect", {
				width: 250,
				height: 200,
				fill: "white"
			})
		}),
		/* @__PURE__ */ (0, Q.jsx)("clipPath", {
			id: "clip1_3754_4493",
			children: /* @__PURE__ */ (0, Q.jsx)("rect", {
				x: 40.6343,
				y: 15.0001,
				width: 202.366,
				height: 139.126,
				rx: 2.52957,
				fill: "white"
			})
		})
	] })]
}), Ww = "draggable-ai-widget", Gw = "Do not ask any follow up questions.", Kw = async (e, t, n) => {
	let r = {
		clusterId: e.toString(),
		ask: `${t} ${Gw} `
	};
	return (await nf(O.INTELLIGENCE, r, { signal: n })).result;
}, qw = () => {
	let e = Ja(new AbortController()), { intelligenceConfig: t, setIntelligenceConfig: n } = Tf(), [r, i] = j(""), a = Object.keys(t.metadata), o = r === "loading", s = r === "submitted", c = () => {
		n(null), e.current.abort();
	}, [l, u, d, f] = hf(() => Du(() => Kw(t.clusterId, t.prompt, e.current.signal), e), [t]), p = l || pd(d), m = (e) => {
		i("loading"), Mn.event({
			category: "AI Integration Feedback",
			action: `${t.analyticsCategory}_${e}`
		}), setTimeout(() => {
			i("submitted");
		}, 1e3);
	};
	return /* @__PURE__ */ (0, Q.jsx)("div", {
		className: "events-ai-widget br-14 p-2",
		children: /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox-col br-12 w-400 dc__h-fit-content bg__overlay--primary h-500",
			children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: `${Ww} flexbox dc__content-space p-16 dc__align-items-center dc__grabbable dc__border-bottom`,
				children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "flexbox dc__gap-8 dc__align-items-center",
					children: [/* @__PURE__ */ (0, Q.jsx)(Hw, { className: "icon-dim-20" }), /* @__PURE__ */ (0, Q.jsx)("span", {
						className: "fs-14 cn-9 lh-20 fw-6",
						children: "AI Analysis"
					})]
				}), /* @__PURE__ */ (0, Q.jsx)(M, {
					ariaLabel: "events-ai-drawer-close",
					dataTestId: "events-ai-drawer-close",
					icon: /* @__PURE__ */ (0, Q.jsx)(er, { className: Za }),
					variant: F.borderLess,
					size: I.xs,
					style: P.negativeGrey,
					onClick: c,
					showAriaLabelInTippy: !1
				})]
			}), !p && d ? d.code === eo.UNPROCESSABLE_ENTITY ? /* @__PURE__ */ (0, Q.jsx)(R, {
				title: "AI Integration not configured",
				subTitle: "For AI-powered insights on this cluster, please follow this documentation or contact the Devtron team.",
				SvgImage: Uw,
				imageType: yc.Medium,
				isButtonAvailable: !0,
				renderButton: () => /* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "flexbox-col dc__gap-12",
					children: [/* @__PURE__ */ (0, Q.jsx)(M, {
						dataTestId: "open-ai-integration-ticket",
						size: I.medium,
						component: N.anchor,
						text: "Open Ticket",
						anchorProps: { href: Jc }
					}), /* @__PURE__ */ (0, Q.jsx)(M, {
						dataTestId: "contact-support",
						component: N.anchor,
						text: "Contact Support",
						anchorProps: { href: Bo },
						variant: F.text
					})]
				})
			}) : /* @__PURE__ */ (0, Q.jsx)(Ks, {
				imageType: yc.Medium,
				code: d.code,
				reload: f
			}) : /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "p-16 flexbox-col dc__gap-16 dc__overflow-auto flex-grow-1",
				children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "flexbox-col dc__gap-8",
					children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
						className: "flexbox dc__gap-6 dc__align-items-center",
						children: [/* @__PURE__ */ (0, Q.jsx)("span", {
							className: "cn-9 fs-13 fw-6 lh-20",
							children: p ? "Analyzing" : "Summary"
						}), /* @__PURE__ */ (0, Q.jsx)(z, {
							name: "ic-sparkle-ai-color",
							color: null
						})]
					}), p ? /* @__PURE__ */ (0, Q.jsxs)("div", {
						className: "flexbox-col dc__gap-8",
						children: [
							/* @__PURE__ */ (0, Q.jsx)("span", { className: "w-250 purple-shimmer-loading" }),
							/* @__PURE__ */ (0, Q.jsx)("span", { className: "w-150 purple-shimmer-loading" }),
							/* @__PURE__ */ (0, Q.jsx)("span", { className: "w-200 purple-shimmer-loading" }),
							/* @__PURE__ */ (0, Q.jsx)("span", { className: "w-100px purple-shimmer-loading" })
						]
					}) : /* @__PURE__ */ (0, Q.jsx)(Lc, {
						markdown: u,
						className: "fs-13 fw-4 lh-20 cn-9 p-0 m-0 dc__no-border bg__overlay--primary dc__word-break dc__text-wrap dc__open-sans p-0-imp"
					})]
				}), a.length && /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsx)("div", { className: "dc__border-bottom" }), /* @__PURE__ */ (0, Q.jsx)("div", {
					className: "flexbox-col dc__gap-8 fs-13 fw-4 lh-20",
					children: a.map((e) => {
						let n = t.metadata[e];
						return n ? /* @__PURE__ */ (0, Q.jsxs)("div", {
							className: "event-metadata",
							children: [/* @__PURE__ */ (0, Q.jsx)("span", {
								className: "cn-7 dc__capitalize",
								children: e.replace(/([a-z])([A-Z])/g, "$1 $2")
							}), /* @__PURE__ */ (0, Q.jsx)("span", {
								className: "cn-9 dc__word-break-all",
								children: n
							})]
						}) : null;
					})
				})] })]
			}), !(p || d) && /* @__PURE__ */ (0, Q.jsxs)("div", {
				className: `${s ? "flex" : "flexbox dc__content-space dc__align-items-center"}  px-16 py-8 border__secondary--top`,
				children: [/* @__PURE__ */ (0, Q.jsx)("span", {
					className: "fs-13 fw-4 lh-1-5 cn-7",
					children: s ? "Thanks for your feedback!" : "Was this insight helpful?"
				}), !s && /* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "flex dc__gap-4",
					children: [/* @__PURE__ */ (0, Q.jsx)(M, {
						dataTestId: "upvote-insight",
						icon: /* @__PURE__ */ (0, Q.jsx)(z, {
							name: "ic-thumb-up",
							color: null
						}),
						ariaLabel: "helpful event",
						showAriaLabelInTippy: !1,
						variant: F.borderLess,
						style: P.positive,
						size: I.small,
						onClick: () => m("UPVOTE"),
						disabled: o
					}), /* @__PURE__ */ (0, Q.jsx)(M, {
						dataTestId: "downvote-insight",
						icon: /* @__PURE__ */ (0, Q.jsx)(z, {
							name: "ic-thumb-down",
							color: null
						}),
						ariaLabel: "not helpful event",
						showAriaLabelInTippy: !1,
						variant: F.borderLess,
						style: P.negative,
						size: I.small,
						onClick: () => m("DOWNVOTE"),
						disabled: o
					})]
				})]
			})] })]
		})
	});
}, Jw = ({ parentRef: e }) => /* @__PURE__ */ (0, Q.jsx)(Ls, {
	parentRef: e,
	dragSelector: `.${Ww}`,
	positionVariant: Is.SCREEN_BOTTOM_RIGHT,
	zIndex: 30,
	children: /* @__PURE__ */ (0, Q.jsx)(qw, {})
}), Yw = [{
	label: "About",
	value: jc.ABOUT
}, {
	label: "License",
	value: jc.LICENSE
}], Xw = ({ handleUpdateLicenseClick: e, licenseData: t }) => {
	let { enterpriseName: n, licenseSuffix: r, expiryDate: i, isTrial: a, licenseStatus: o, ttl: s, isFreemium: c, licenseStatusError: l } = t, { appTheme: u } = Nf();
	return /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox-col dc__gap-20",
		children: [
			/* @__PURE__ */ (0, Q.jsx)(js, {
				enterpriseName: n,
				licenseSuffix: r,
				ttl: s,
				licenseStatus: o,
				isTrial: a,
				expiryDate: i,
				appTheme: u,
				isFreemium: c,
				licenseStatusError: l,
				isSaasInstance: t?.isSaasInstance
			}),
			/* @__PURE__ */ (0, Q.jsx)(Tc, {
				fingerprint: t?.fingerprint,
				showHelpTooltip: !0
			}),
			/* @__PURE__ */ (0, Q.jsx)("div", { className: "border__secondary--bottom h-1" }),
			/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox-col dc__gap-12",
				children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "flex dc__content-space",
					children: [/* @__PURE__ */ (0, Q.jsx)("span", {
						className: "fs-13",
						children: "Have a new license?"
					}), /* @__PURE__ */ (0, Q.jsx)(M, {
						dataTestId: "update-license",
						text: "Update license",
						variant: F.text,
						onClick: e
					})]
				}), /* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "flex dc__content-space",
					children: [/* @__PURE__ */ (0, Q.jsx)("span", {
						className: "fs-13",
						children: "Need help?"
					}), /* @__PURE__ */ (0, Q.jsx)(M, {
						dataTestId: "contact-support",
						text: "Contact Support",
						variant: F.text,
						component: N.anchor,
						anchorProps: { href: Bo }
					})]
				})]
			})
		]
	});
}, Zw = ({ dialogType: e, licenseData: t, handleChangeDialogType: n, handleUpdateLicenseClick: r, handleCloseLicenseInfoDialog: i, isLoading: a, licenseDataError: o, reloadLicenseData: s }) => /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [
	/* @__PURE__ */ (0, Q.jsx)("div", {
		className: "px-24 pt-24 pb-8",
		children: /* @__PURE__ */ (0, Q.jsx)(Bl, {
			name: "about-devtron-segmented-control",
			segments: Yw,
			value: e,
			onChange: n,
			fullWidth: !0
		})
	}),
	/* @__PURE__ */ (0, Q.jsx)("div", {
		className: "p-24 mxh-500 dc__overflow-auto",
		children: e === jc.ABOUT ? /* @__PURE__ */ (0, Q.jsx)(ro, {}) : a ? /* @__PURE__ */ (0, Q.jsx)(Ms, {
			parentClasses: "flex h-200",
			classes: "icon-dim-48"
		}) : o ? /* @__PURE__ */ (0, Q.jsx)(lc, {
			rootClassName: "h-200",
			reload: s
		}) : /* @__PURE__ */ (0, Q.jsx)(Xw, {
			licenseData: t,
			handleUpdateLicenseClick: r
		})
	}),
	/* @__PURE__ */ (0, Q.jsx)("div", {
		className: "flex px-24 py-20 dc__content-end",
		children: /* @__PURE__ */ (0, Q.jsx)(M, {
			dataTestId: "license-info-okay",
			text: "Okay",
			size: I.medium,
			onClick: i
		})
	})
] }), Qw = ({ handleCloseLicenseInfoDialog: e, initialDialogType: t = jc.ABOUT }) => {
	let { setLicenseData: n } = Tf(), [r, i] = j(t), a = (e) => {
		let t = e.value;
		t === jc.LICENSE && Mn.event({
			category: "about-devtron__license",
			action: "ABOUT_DEVTRON_LICENSE_TAB_CLICKED"
		}), i(t);
	}, o = () => {
		Mn.event({
			category: "about-devtron__license",
			action: "ABOUT_DEVTRON_UPDATE_LICENSE_CLICKED"
		}), i(jc.UPDATE);
	}, [s, c, l, u] = hf(Fn, []);
	return k(() => {
		c && c.showLicenseData && n(c);
	}, [c]), /* @__PURE__ */ (0, Q.jsx)(yo, {
		onEscape: e,
		children: /* @__PURE__ */ (0, Q.jsx)("div", {
			className: "flexbox-col w-400 br-12 bg__primary border__primary dc__m-auto mt-40",
			children: r === jc.UPDATE ? /* @__PURE__ */ (0, Q.jsx)(ao, {
				fingerprint: c.fingerprint,
				enterpriseName: c.enterpriseName,
				handleClose: e,
				handleLicenseActivateSuccess: async () => {
					await u(), e();
				}
			}) : /* @__PURE__ */ (0, Q.jsx)(Zw, {
				dialogType: r,
				licenseData: c,
				handleChangeDialogType: a,
				handleUpdateLicenseClick: o,
				handleCloseLicenseInfoDialog: e,
				isLoading: s,
				licenseDataError: l,
				reloadLicenseData: u
			})
		})
	});
}, $w = (e) => ({
	data: {
		categories: {
			value: e?.name || "",
			type: Vs.TEXT,
			props: { placeholder: "Eg. staging" },
			disabled: !!e?.id,
			tooltip: e?.name ? { content: "Category name is unique and cannot be changed" } : null
		},
		description: {
			value: e?.description || "",
			type: Vs.TEXT,
			props: { placeholder: "Enter description" }
		}
	},
	id: e?.id || Id()
}), eT = (e) => e?.length ? e.map($w) : [$w()], tT = (e) => (e || [])?.map((e) => ({
	label: e.name || "",
	value: e.id,
	description: e.description || ""
})), nT = (e) => ({ category: e?.value ? {
	id: e.value,
	name: e.label
} : { id: 0 } }), rT = (e, t) => {
	let { categories: n, description: r } = e.data, i = n.value.trim(), a = r.value.trim();
	if (i) {
		let n = Bf(i);
		if (!n.isValid) return {
			isValid: !1,
			errorMessages: [n.message]
		};
		if (t?.filter((t) => t.data.categories.value === e.data.categories.value && t.id !== e.id).length) return {
			isValid: !1,
			errorMessages: ["Duplicate category name"]
		};
	} else if (a) return {
		isValid: !1,
		errorMessages: ["Category name is required"]
	};
	return {
		isValid: !0,
		errorMessages: []
	};
}, iT = (e) => {
	let { description: t } = e.data, n = t.value.trim(), r = Rf(n);
	return n && !r.isValid ? {
		isValid: !1,
		errorMessages: [r.message]
	} : {
		isValid: !0,
		errorMessages: []
	};
}, aT = async () => {
	try {
		return (await G(O.CLUSTER_CATEGORIES)).result?.categories || [];
	} catch (e) {
		throw K(e), e;
	}
}, oT = async (e) => {
	try {
		let t = await nf(O.CLUSTER_CATEGORIES, e);
		return H.showToast({
			variant: U.success,
			description: "Category updated successfully"
		}), t.result;
	} catch (e) {
		throw K(e), e;
	}
}, sT = async () => eT(await aT()), cT = ({ selectedCategory: e, setSelectedCategory: t }) => {
	let [n, r, i, a] = hf(aT);
	return /* @__PURE__ */ (0, Q.jsx)(V, {
		label: "Assign Category",
		inputId: "assign-category-menu-list",
		name: "assign-category-menu-list",
		classNamePrefix: "assign-category-menu-list",
		options: tT(r),
		onChange: (n) => {
			if (n?.value !== e?.value) {
				if (!n) {
					t(null);
					return;
				}
				t(n);
			}
		},
		value: e,
		size: I.medium,
		fullWidth: !0,
		isClearable: !!r?.length,
		isLoading: n,
		optionListError: i,
		reloadOptionList: a
	});
}, lT = [{
	label: "CATEGORIES",
	key: "categories",
	width: "250px"
}, {
	label: "DESCRIPTION",
	key: "description",
	width: "1fr"
}], uT = () => {
	let { search: e } = Yf(), { searchKey: t, handleSearch: n, clearFilters: r } = Mf(), [i, a, o, s, c] = hf(sT), [l, u] = j({}), [d, f] = j(!1), p = X(), m = t.toLowerCase(), h = a?.filter((e) => e.data.categories.value.toLowerCase().includes(m)), g = () => {
		p({
			pathname: B.GLOBAL_CONFIG_CLUSTER_ENV,
			search: e
		});
	};
	return /* @__PURE__ */ (0, Q.jsx)(Rs, {
		position: "right",
		width: "1024px",
		onEscape: g,
		onClose: g,
		children: /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "bg__primary h-100 cn-9 w-100 flexbox-col dc__overflow-hidden p-0 create-cluster",
			onClick: uf,
			children: [/* @__PURE__ */ (0, Q.jsxs)("header", {
				className: "px-20 py-12 lh-24 flexbox dc__content-space dc__align-items-center dc__border-bottom",
				children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "flexbox dc__gap-8",
					children: [/* @__PURE__ */ (0, Q.jsx)("h3", {
						className: "m-0 fs-16 fw-6 lh-1-43",
						children: "Cluster & Environment Categories"
					}), /* @__PURE__ */ (0, Q.jsx)(Cc, {
						heading: "Categories",
						infoText: "Create categories to organize your clusters and environments. Example: stage, qa, dev, etc.",
						iconClassName: "icon-dim-20 fcn-6"
					})]
				}), /* @__PURE__ */ (0, Q.jsx)(M, {
					icon: /* @__PURE__ */ (0, Q.jsx)(z, {
						name: "ic-close-large",
						color: null
					}),
					dataTestId: "close-create-cluster-modal-button",
					component: N.button,
					style: P.negativeGrey,
					size: I.xs,
					variant: F.borderLess,
					ariaLabel: "Close new cluster drawer",
					onClick: g,
					showAriaLabelInTippy: !1
				})]
			}), o ? /* @__PURE__ */ (0, Q.jsx)(Ks, {
				code: o?.code,
				reload: s
			}) : i ? /* @__PURE__ */ (0, Q.jsx)(ul, { pageLoader: !0 }) : /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flex dc__content-space px-20 py-12",
				children: [/* @__PURE__ */ (0, Q.jsx)(Il, {
					initialSearchText: t,
					containerClassName: "w-250",
					inputProps: {
						autoFocus: !0,
						placeholder: "Search categories"
					},
					handleEnter: n,
					dataTestId: "search-category-input"
				}), !t && /* @__PURE__ */ (0, Q.jsx)(M, {
					dataTestId: "add_categories_button",
					variant: F.secondary,
					component: N.button,
					startIcon: /* @__PURE__ */ (0, Q.jsx)(z, {
						name: "ic-add",
						color: null
					}),
					size: I.medium,
					text: "Add Category",
					onClick: () => {
						c([$w(), ...a]);
					}
				})]
			}), h.length ? /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsx)("div", {
				className: "flexbox-col flex-grow-1 dc__overflow-auto px-20 pb-12",
				children: /* @__PURE__ */ (0, Q.jsx)(Bs, {
					headers: lT,
					rows: h,
					onRowEdit: (e, t, n) => {
						let r = null, i = a.map((i) => i.id === e.id ? (r = {
							...i,
							data: {
								...i.data,
								[t]: {
									...i.data[t],
									value: n
								}
							}
						}, r) : i), o = structuredClone(l);
						o[e.id] = {
							categories: rT(r, i),
							description: iT(r)
						}, u(o), c(i);
					},
					onRowDelete: (e) => {
						let t = a.filter(({ id: t }) => t !== e?.id);
						if (t.length === 0) {
							c([$w()]);
							return;
						}
						c(t);
					},
					onRowAdd: $d,
					isAdditionNotAllowed: !0,
					shouldAutoFocusOnMount: !0,
					cellError: l
				})
			}), /* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flex right w-100 dc__gap-12 px-20 py-12 dc__border-top",
				children: [/* @__PURE__ */ (0, Q.jsx)(M, {
					text: "Cancel",
					variant: F.secondary,
					style: P.neutral,
					dataTestId: "cancel-category-btn",
					onClick: g
				}), /* @__PURE__ */ (0, Q.jsx)(M, {
					text: a.length === 0 ? "Save" : "Update",
					dataTestId: "save-category-btn",
					isLoading: d,
					disabled: d,
					onClick: async () => {
						let e = !1, t = structuredClone(l);
						if (a.forEach((n) => {
							let r = rT(n, a), i = iT(n);
							t[n.id] = {
								categories: r,
								description: i
							}, (!r.isValid || !i.isValid) && (e = !0);
						}), u(t), e) {
							H.showToast({
								variant: U.error,
								description: "Please resolve errors and try again"
							});
							return;
						}
						let n = a.filter((e) => !!e.data.categories.value), r = n.length ? n.map((e) => ({
							id: +e.id,
							name: e.data.categories.value.trim(),
							description: e.data.description.value
						})) : [];
						f(!0);
						try {
							await oT({ categories: r }), g(), f(!1);
						} catch {
							f(!1);
						}
					},
					buttonProps: { type: "submit" }
				})]
			})] }) : /* @__PURE__ */ (0, Q.jsx)(oc, { handleClearFilters: r })] })]
		})
	});
}, dT = ({ search: e }) => /* @__PURE__ */ (0, Q.jsx)(M, {
	dataTestId: "manage_categories_button",
	linkProps: { to: {
		pathname: vo.GLOBAL_CONFIG.CLUSTER_ENV.MANAGE_CATEGORIES,
		search: e
	} },
	component: N.link,
	startIcon: /* @__PURE__ */ (0, Q.jsx)(z, {
		name: "ic-shapes",
		color: null
	}),
	size: I.medium,
	text: "Manage Categories",
	variant: F.secondary
}), fT = {
	$schema: "http://json-schema.org/draft-07/schema#",
	type: "object",
	properties: { podGroups: {
		type: "array",
		title: "Pod Groups",
		description: "List of pod groups with their spread configuration",
		items: {
			type: "object",
			title: "Pod Group",
			properties: {
				name: {
					type: "string",
					title: "Pod Group Name",
					description: "Name of the pod group (can be any descriptive name)",
					minLength: 1
				},
				selector: {
					type: "object",
					title: "Pod Selector",
					description: "Label selector to identify pods in this group",
					additionalProperties: { type: "string" },
					minProperties: 1
				},
				baseValue: {
					type: "integer",
					title: "Base Value",
					description: "Base value for pod distribution calculation",
					minimum: 1,
					default: 1
				},
				onDemandWeight: {
					type: "integer",
					title: "On-Demand Weight (%)",
					description: "Percentage of pods to be placed on on-demand nodes",
					minimum: 0,
					maximum: 100,
					default: 80
				},
				spotWeight: {
					type: "integer",
					title: "Spot Weight (%)",
					description: "Percentage of pods to be placed on spot nodes",
					minimum: 0,
					maximum: 100,
					default: 20
				},
				onDemandNodeSelector: {
					type: "object",
					title: "On-Demand Node Selector",
					description: "Node selector for on-demand nodes",
					additionalProperties: { type: "string" }
				},
				spotNodeSelector: {
					type: "object",
					title: "Spot Node Selector",
					description: "Node selector for spot nodes",
					additionalProperties: { type: "string" }
				},
				onDemandTolerations: {
					type: "array",
					title: "On-Demand Tolerations",
					description: "Tolerations for on-demand nodes",
					items: {
						type: "object",
						title: "Toleration",
						properties: {
							key: {
								type: "string",
								title: "Key",
								description: "Taint key to tolerate"
							},
							operator: {
								type: "string",
								title: "Operator",
								description: "Operator for the toleration",
								enum: ["Exists", "Equal"],
								default: "Equal"
							},
							value: {
								type: "string",
								title: "Value",
								description: "Value to match (when operator is Equal)"
							},
							effect: {
								type: "string",
								title: "Effect",
								description: "Taint effect to tolerate",
								enum: [
									"NoSchedule",
									"PreferNoSchedule",
									"NoExecute"
								],
								default: "NoSchedule"
							}
						},
						required: [
							"key",
							"operator",
							"effect"
						],
						additionalProperties: !1
					}
				},
				spotTolerations: {
					type: "array",
					title: "Spot Tolerations",
					description: "Tolerations for spot nodes",
					items: {
						type: "object",
						title: "Toleration",
						properties: {
							key: {
								type: "string",
								title: "Key",
								description: "Taint key to tolerate"
							},
							operator: {
								type: "string",
								title: "Operator",
								description: "Operator for the toleration",
								enum: ["Exists", "Equal"],
								default: "Equal"
							},
							value: {
								type: "string",
								title: "Value",
								description: "Value to match (when operator is Equal)"
							},
							effect: {
								type: "string",
								title: "Effect",
								description: "Taint effect to tolerate",
								enum: [
									"NoSchedule",
									"PreferNoSchedule",
									"NoExecute"
								],
								default: "NoSchedule"
							}
						},
						required: [
							"key",
							"operator",
							"effect"
						],
						additionalProperties: !1
					}
				}
			},
			required: [
				"name",
				"selector",
				"baseValue",
				"onDemandWeight",
				"spotWeight"
			],
			additionalProperties: !1
		},
		minItems: 1
	} }
}, pT = (e) => ({
	name: "pod-spread-webhook-config",
	namespace: "pod-spread-system",
	clusterId: +e,
	gvk: {
		Group: "",
		Kind: "ConfigMap",
		Version: "v1"
	}
}), mT = async (e, t) => {
	try {
		let n = (await Un({
			...pT(e),
			abortControllerRef: t
		})).manifestResponse.manifest.data["config.yaml"];
		return n && Qf.parse(n) || {};
	} catch {
		return {};
	}
}, hT = async (e, t, n) => {
	let r = pT(e), i = {
		apiVersion: "v1",
		kind: "ConfigMap",
		data: { "config.yaml": Qf.stringify(t) },
		metadata: {
			name: r.name,
			namespace: r.namespace
		}
	};
	n ? await wn({
		...r,
		manifest: Tu(i)
	}) : await St({
		clusterId: +e,
		manifest: Tu(i)
	}), H.showToast({
		variant: U.success,
		description: "Successfully applied pod spread configuration."
	});
}, gT = ({ clusterId: e, handleClose: t }) => {
	let n = Ja(null), r = Ja(new AbortController()), i = Ja(!1), [a, o, , , s] = hf(async () => {
		let t = await mT(e, r);
		return i.current = Object.keys(t || {}).length > 0, t;
	}, [e], !!e), [c, l] = j(!1);
	return k(() => () => {
		r.current.abort();
	}, []), /* @__PURE__ */ (0, Q.jsx)(Rs, {
		position: "right",
		width: "1024px",
		onEscape: t,
		onClose: t,
		children: /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox-col dc__content-space h-100 bg__modal--primary shadow__modal dc__overflow-auto",
			onClick: uf,
			children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox-col dc__overflow-auto flex-grow-1",
				children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "px-20 py-12 flexbox dc__content-space dc__align-items-center border__primary--bottom",
					children: [/* @__PURE__ */ (0, Q.jsx)("h2", {
						className: "m-0 fs-16 fw-6 lh-24 cn-9",
						children: "Apply Pod Spread"
					}), /* @__PURE__ */ (0, Q.jsx)(M, {
						dataTestId: "header-close-button",
						ariaLabel: "Close",
						showAriaLabelInTippy: !1,
						onClick: t,
						variant: F.borderLess,
						style: P.negativeGrey,
						icon: /* @__PURE__ */ (0, Q.jsx)(z, {
							name: "ic-close-large",
							color: null
						}),
						size: I.xs
					})]
				}), /* @__PURE__ */ (0, Q.jsx)("div", {
					className: "flexbox flex-grow-1 dc__overflow-auto w-100",
					children: /* @__PURE__ */ (0, Q.jsx)($a, {
						isLoading: a,
						progressingProps: { pageLoader: !0 },
						children: /* @__PURE__ */ (0, Q.jsx)(gl, {
							className: "w-100",
							schema: fT,
							formData: o,
							onChange: (e) => {
								s(e.formData);
							},
							experimental_defaultFormStateBehavior: { emptyObjectFields: "skipDefaults" },
							liveValidate: !0,
							uiSchema: mc,
							ref: n
						})
					})
				})]
			}), /* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox dc__content-end dc__gap-12 py-16 px-20 border__primary--top dc__no-shrink",
				children: [/* @__PURE__ */ (0, Q.jsx)(M, {
					dataTestId: "footer-cancel-button",
					variant: F.secondary,
					text: "Cancel",
					style: P.neutral,
					size: I.large,
					onClick: t
				}), /* @__PURE__ */ (0, Q.jsx)(M, {
					dataTestId: "footer-apply-button",
					variant: F.primary,
					size: I.large,
					text: "Apply Changes",
					disabled: a,
					isLoading: c,
					onClick: async () => {
						if (!(!n.current?.validateForm || n.current.validateForm())) {
							H.showToast({
								variant: U.error,
								description: "Validation failed for some input fields, please rectify and apply changes again."
							});
							return;
						}
						l(!0);
						try {
							await hT(e, o, i.current), l(!1), t();
						} catch (e) {
							K(e), l(!1);
						}
					}
				})]
			})]
		})
	});
}, _T = ({ tabs: e, initialTab: t, onChange: n, hasError: r }) => /* @__PURE__ */ (0, Q.jsx)(Bl, {
	segments: e.map((e) => ({
		label: e.label,
		value: e.value,
		isError: r?.[e.value] || !1
	})),
	value: t,
	onChange: n,
	name: "runtime-param-tabs",
	fullWidth: !0
}), vT = ({ endTime: e, showClockIcon: t, reloadAfterTimeEnd: n, callbackAfterTimeEnd: r, rootClassName: i = "fs-12", isActive: a }) => {
	let o = Ja(null), [s, c] = j(an(e));
	return k(() => () => {
		o.current && clearTimeout(o.current);
	}, []), o.current = setTimeout(() => {
		c(an(e));
	}, 1e3), s ? /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: `${i} flex left dc__gap-4`,
		children: [/* @__PURE__ */ (0, Q.jsx)("span", { children: a ? "Ends in" : "Starts in" }), /* @__PURE__ */ (0, Q.jsxs)("span", {
			className: "flex fw-6",
			children: [t && /* @__PURE__ */ (0, Q.jsx)(Ue, { className: "mr-6 icon-dim-16 mw-16" }), /* @__PURE__ */ (0, Q.jsx)("span", { children: s })]
		})]
	}) : a ? (n ? window.location.reload() : r && r(), null) : (o.current && clearTimeout(o.current), /* @__PURE__ */ (0, Q.jsx)("span", {
		className: "fs-12 cn-9 fw-6",
		children: "Invalid Profile"
	}));
}, yT = ({ isManifestScanEnabled: e, handleToggleSecurityScan: t }) => /* @__PURE__ */ (0, Q.jsxs)("div", {
	className: "flexbox-col dc__gap-16",
	children: [/* @__PURE__ */ (0, Q.jsx)("div", { className: "dc__border-bottom-n1" }), /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox dc__content-space dc__align-items-center",
		children: [/* @__PURE__ */ (0, Q.jsx)(ft, {
			className: "default-tt",
			arrow: !1,
			placement: "top-end",
			content: /* @__PURE__ */ (0, Q.jsxs)("div", { children: [/* @__PURE__ */ (0, Q.jsx)("span", {
				className: "fw-6 lh-18",
				children: "Security scan"
			}), /* @__PURE__ */ (0, Q.jsxs)("ul", {
				className: "m-0 pl-20",
				children: [/* @__PURE__ */ (0, Q.jsx)("li", { children: "Scans image(s) in chart for vulnerabilities and license risks." }), /* @__PURE__ */ (0, Q.jsx)("li", { children: "Scans generated Kubernetes manifests for misconfigurations and exposed secrets." })]
			})] }),
			maxWidth: 200,
			children: /* @__PURE__ */ (0, Q.jsx)("span", {
				className: "fs-13 fw-6 lh-20 dc__border-bottom-dashed--n3",
				children: "Security scan"
			})
		}), /* @__PURE__ */ (0, Q.jsx)(bs, {
			name: "security-scan-toggle",
			ariaLabel: "Toggle security scan",
			onChange: t,
			isChecked: e
		})]
	})]
}), bT = "data:image/svg+xml,%3c!--%20-%20Copyright%20(c)%202024.%20Devtron%20Inc.%20--%3e%3csvg%20width='16'%20height='16'%20viewBox='0%200%2016%2016'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M13.5%206.25L13.4995%202.5005L9.75%202.5M8.99821%207.00179L13.4982%202.50179M11.5%209V13C11.5%2013.1326%2011.4473%2013.2598%2011.3536%2013.3536C11.2598%2013.4473%2011.1326%2013.5%2011%2013.5H3C2.86739%2013.5%202.74021%2013.4473%202.64645%2013.3536C2.55268%2013.2598%202.5%2013.1326%202.5%2013V5C2.5%204.86739%202.55268%204.74021%202.64645%204.64645C2.74021%204.55268%202.86739%204.5%203%204.5H7'%20stroke='%23FFF'%20stroke-width='1.5'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/svg%3e", xT = "data:image/svg+xml,%3c!--%20-%20Copyright%20(c)%202024.%20Devtron%20Inc.%20--%3e%3csvg%20width='250'%20height='200'%20viewBox='0%200%20250%20200'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20clip-path='url(%23clip0_726_3575)'%3e%3cpath%20d='M157.23%2067L161%2071.3413L23.7701%20196L20%20191.659L157.23%2067Z'%20fill='%237A7562'/%3e%3crect%20x='140'%20y='7.00012'%20width='80'%20height='80'%20rx='4'%20fill='%23FDE7E7'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M163.094%2032.9218C159.913%2036.7368%20158%2041.6449%20158%2046.9999C158%2059.1501%20167.85%2068.9999%20180%2068.9999C185.355%2068.9999%20190.263%2067.0866%20194.078%2063.9064L163.094%2032.9218ZM165.922%2030.0933L196.907%2061.078C200.087%2057.263%20202%2052.3549%20202%2046.9999C202%2034.8496%20192.151%2024.9999%20180%2024.9999C174.645%2024.9999%20169.737%2026.9131%20165.922%2030.0933ZM198.385%2065.3847C203.09%2060.6796%20206%2054.1796%20206%2046.9999C206%2032.6405%20194.36%2020.9999%20180%2020.9999C165.641%2020.9999%20154%2032.6405%20154%2046.9999C154%2061.3593%20165.641%2072.9999%20180%2072.9999C187.18%2072.9999%20193.68%2070.0897%20198.385%2065.3847Z'%20fill='%23F33E3E'/%3e%3cpath%20d='M153%20154L178%20192H128L153%20154Z'%20fill='%23FDE7E7'/%3e%3cpath%20d='M189.171%20137.681C194.158%20151.382%20187.094%20166.531%20173.393%20171.518C159.692%20176.505%20144.542%20169.44%20139.556%20155.74L189.171%20137.681Z'%20fill='%231E2462'/%3e%3crect%20x='159.677'%20y='173.375'%20width='60'%20height='19.1999'%20rx='9.59997'%20fill='%23A0C3FB'/%3e%3cpath%20d='M77.1136%2067.9289L81.1717%2060.0529C83.6992%2058.5301%2088.0517%2056.7618%2086.8292%2060.6546C85.6066%2064.5474%2084.1771%2067.2145%2084.9417%2069.1821L77.1136%2067.9289Z'%20fill='url(%23paint0_linear_726_3575)'/%3e%3cpath%20d='M89.7178%2061.7789C91.9868%2060.6723%2093.2075%2057.7363%2093.5342%2056.4066C93.5342%2056.4066%2095.4215%2055.8767%2095.3485%2055.3272C95.2755%2054.7776%2094.2211%2052.5612%2093.2735%2051.0729C92.2717%2049.4995%2091.5194%2048.5935%2090.7947%2047.9903C87.8398%2045.5309%2085.0457%2045.0007%2082.2752%2045.3192C79.1354%2045.6802%2075.6144%2048.4704%2075.1499%2052.305C74.723%2055.829%2079.5378%2060.5025%2081.5668%2061.4633C83.5959%2062.4242%2086.8816%2063.1622%2089.7178%2061.7789Z'%20fill='%23FFBEB6'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M92.2244%2053.6828C92.4022%2053.8539%2092.6693%2053.9905%2093.0272%2053.9905C93.3851%2053.9905%2093.6521%2053.8539%2093.83%2053.6828C94.0164%2053.5034%2094.0896%2053.303%2094.0896%2053.1936H94.6208C94.6208%2053.4824%2094.4606%2053.8132%2094.1983%2054.0656C93.9275%2054.3262%2093.5305%2054.5217%2093.0272%2054.5217C92.5239%2054.5217%2092.1269%2054.3262%2091.8561%2054.0656C91.5938%2053.8132%2091.4336%2053.4824%2091.4336%2053.1936H91.9648C91.9648%2053.303%2092.0379%2053.5034%2092.2244%2053.6828Z'%20fill='%2323286B'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M75.3483%2057.4944C74.9234%2059.1151%2074.9036%2062.1504%2077.8712%2063.0726C81.7794%2064.2873%2085.5112%2059.5414%2085.4%2054.9144C86.6938%2055.6158%2088.5255%2054.7546%2088.7099%2052.3093C90.2229%2052.5065%2093.5692%2052.0546%2094.958%2048.6479C95.4645%2047.4056%2095.4417%2046.0258%2095.1842%2044.8845C95.0552%2044.3127%2094.8661%2043.7954%2094.6504%2043.3791C94.4373%2042.9677%2094.189%2042.6373%2093.9322%2042.4599L93.7241%2042.7611C93.9086%2042.8886%2094.1231%2043.1572%2094.3254%2043.5476C94.5252%2043.9331%2094.7042%2044.4205%2094.8271%2044.965C95.0733%2046.0563%2095.0895%2047.3557%2094.619%2048.5096C93.5833%2051.0501%2091.3838%2051.8419%2089.8106%2051.9649C92.0762%2051.4153%2094.0987%2049.5711%2094.2547%2047.4749C94.4355%2045.0461%2093.4403%2042.6057%2091.6418%2042.1176C90.203%2041.727%2088.78%2043.4484%2088.2483%2044.3579C87.9474%2043.0743%2086.796%2040.5803%2084.9206%2039.9345C82.4564%2039.0859%2080.9278%2039.3463%2080.0553%2040.3569C79.3298%2041.1973%2079.9906%2042.5754%2080.5129%2043.6648C80.6187%2043.8855%2080.7188%2044.0943%2080.8006%2044.2844C80.0205%2043.8847%2078.0813%2043.3481%2076.5656%2044.3994C75.0498%2045.4508%2075.8084%2046.9793%2076.3771%2047.6122C75.6469%2047.4482%2073.7131%2047.4291%2071.8192%2048.6649C69.4518%2050.2096%2068.7099%2053.8874%2069.4016%2055.3055C69.9613%2056.4531%2071.3893%2058.0713%2073.6673%2057.7916C73.5379%2057.8323%2073.4057%2057.8706%2073.2716%2057.9057C72.4272%2058.1268%2071.5413%2058.2115%2070.8426%2057.971C69.4245%2057.4827%2068.8838%2056.22%2068.7925%2055.6625L68.4312%2055.7217C68.5371%2056.3683%2069.1409%2057.7722%2070.7234%2058.3171C71.5249%2058.5931%2072.4965%2058.4871%2073.3644%2058.2599C74.1459%2058.0553%2074.8673%2057.7459%2075.3483%2057.4944ZM75.4185%2057.2503L75.4197%2057.2465L75.4171%2057.2478L75.4185%2057.2503Z'%20fill='%2323286B'/%3e%3cpath%20d='M78.4194%20199L82.6098%20187.048H90.5726L92.8585%20188.953C94.763%20190.572%20103.421%20195.183%20104.525%20195.81C105.26%20196.228%20106.23%20197.291%20107.435%20199C86.3203%20198.969%2078.4194%20199%2078.4194%20199Z'%20fill='url(%23paint1_linear_726_3575)'/%3e%3cpath%20d='M55.8442%20199L60.0346%20187.048H69.3254L71.6113%20188.953C73.5158%20190.572%2082.1739%20195.183%2083.2777%20195.81C84.0124%20196.228%2084.9832%20197.291%2086.1876%20199C65.0731%20198.969%2055.8442%20199%2055.8442%20199Z'%20fill='url(%23paint2_linear_726_3575)'/%3e%3cpath%20d='M96.4595%20104.673C100.404%20106.436%20103.024%20107.5%20104.317%20107.865C105.864%20108.28%20106.77%20108.129%20110.279%20106.884C110.731%20106.733%20112.278%20105.79%20113.712%20104.885C117.296%20102.508%20118.126%20103.64%20115.145%20106.771C114.353%20107.639%20113.787%20108.582%20113.938%20108.883C114.051%20109.148%20116.202%20109.185%20118.654%20108.921C119.472%20108.641%20121.499%20106.237%20121.688%20106.426C122.14%20106.878%20120.427%20112.731%20118.73%20113.449C117.975%20113.826%20111.901%20114.09%20105.185%20114.09C100.708%20114.09%2094.394%20113.852%2086.2417%20113.378L96.4595%20104.673Z'%20fill='%23FAB6AF'/%3e%3cpath%20d='M95.02%20138.576C94.4647%20131.944%2086.388%20103.384%2086.388%20103.384H70.452C70.2307%20106.483%2069.9208%20113.61%2070.452%20117.328C71.116%20121.976%2074.436%20129.944%2074.436%20133.264C74.436%20136.584%2075.764%20148.536%2075.764%20152.52C75.764%20156.504%2075.1%20159.16%2074.436%20161.816C73.772%20164.472%2073.772%20170.448%2074.436%20175.096C74.9672%20178.815%2076.8707%20184.835%2077.756%20187.048H93.692C93.692%20187.048%2095.521%20144.56%2095.02%20138.576Z'%20fill='%231D225F'/%3e%3cpath%20d='M88.3796%20134.592C88.3796%20137.248%2086.444%20149.215%2085.7236%20151.856C83.7316%20159.16%2076.4276%20175.76%2072.4436%20187.048H54.5156C54.737%20183.507%2056.1092%20175.76%2057.1716%20173.104C58.4996%20169.784%2062.5708%20165.163%2063.1476%20163.144C64.4756%20158.496%2064.4756%20153.848%2065.8036%20150.528C67.1316%20147.208%2070.4516%20141.232%2070.4516%20137.912C70.4516%20134.592%2067.7956%20130.608%2066.4676%20125.96C65.1396%20121.312%2065.1396%20115.336%2065.1396%20112.68C65.1396%20109.877%2065.361%20105.598%2065.8036%20103.384H88.3796V134.592Z'%20fill='url(%23paint3_linear_726_3575)'/%3e%3cpath%20d='M87.7153%2074.1685C88.2465%2075.7621%2092.806%2090.7685%2095.0193%2098.0725C95.6832%20101.393%2093.0273%20103.384%2090.3713%20104.048C87.7153%20104.712%2072.4433%20104.712%2069.7873%20104.712C65.8035%20104.712%2062.4833%20104.048%2059.1633%20102.056C55.8433%20100.064%2057.3815%2093.8078%2059.1633%2091.4322C61.1555%2088.7761%2064.4753%2086.1202%2066.4673%2082.8002C68.4593%2079.4802%2070.4513%2074.8322%2071.1153%2073.5042C71.7793%2072.1762%2073.5098%2069.883%2075.7633%2068.1925C78.4193%2066.2001%2081.7393%2066.2005%2083.7313%2066.8645C85.3531%2067.4051%2087.0513%2072.1765%2087.7153%2074.1685Z'%20fill='url(%23paint4_linear_726_3575)'/%3e%3cpath%20d='M102.988%20119.984V99.4004C89.0441%2099.4004%2086.3881%2090.7684%2085.7241%2088.7764C85.0601%2086.7844%2083.7321%2081.4724%2083.7321%2077.4884C83.7321%2073.5044%2081.704%2071.7398%2079.0841%2072.1764C75.1001%2072.8403%2071.7801%2077.4883%2070.4521%2082.1363C69.1241%2086.7843%2067.7961%2092.7604%2067.7961%2096.7444C67.7961%20100.728%2070.4521%20104.712%2072.4441%20106.704C74.4361%20108.696%2079.0841%20109.36%2081.7401%20111.352C84.3961%20113.344%2087.7161%20116.664%2091.0361%20118.656C93.6921%20120.25%20100.111%20120.206%20102.988%20119.984Z'%20fill='url(%23paint5_linear_726_3575)'/%3e%3c/g%3e%3cdefs%3e%3clinearGradient%20id='paint0_linear_726_3575'%20x1='84.029'%20y1='62.0194'%20x2='82.0977'%20y2='66.8924'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%23FBA19B'/%3e%3cstop%20offset='0.349149'%20stop-color='%23F9ADA7'/%3e%3cstop%20offset='1'%20stop-color='%23F9AFA9'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint1_linear_726_3575'%20x1='80.5599'%20y1='187.274'%20x2='89.1929'%20y2='206.988'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20offset='0.090505'%20stop-color='%232C7DE7'/%3e%3cstop%20offset='0.492038'%20stop-color='%231D72D9'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint2_linear_726_3575'%20x1='58.0827'%20y1='187.274'%20x2='66.4531'%20y2='207.264'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20offset='0.0747083'%20stop-color='%23428DFC'/%3e%3cstop%20offset='1'%20stop-color='%23428DFC'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint3_linear_726_3575'%20x1='73.1442'%20y1='103.384'%20x2='46.739'%20y2='179.541'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%232A318C'/%3e%3cstop%20offset='1'%20stop-color='%231D225F'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint4_linear_726_3575'%20x1='76.1655'%20y1='66.4673'%20x2='76.1655'%20y2='104.712'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%23A1C3FC'/%3e%3cstop%20offset='1'%20stop-color='%2391B9F7'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint5_linear_726_3575'%20x1='85.3921'%20y1='72.1115'%20x2='85.3921'%20y2='120.097'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%239FC2FC'/%3e%3cstop%20offset='1'%20stop-color='%23A1C3FC'/%3e%3c/linearGradient%3e%3cclipPath%20id='clip0_726_3575'%3e%3crect%20width='250'%20height='200'%20fill='white'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", ST = ({ appId: e, stageType: t }) => /* @__PURE__ */ (0, Q.jsx)(R, {
	title: `${Ad(t)} trigger is blocked!`,
	subTitle: `Some mandatory tags are not configured for this application. Configure the tags to unblock ${Ad(t).toLowerCase()} trigger.`,
	SvgImage: xT,
	isButtonAvailable: !0,
	renderButton: () => /* @__PURE__ */ (0, Q.jsx)(M, {
		dataTestId: "configure-mandatory-tags",
		component: N.link,
		variant: F.secondary,
		style: P.default,
		text: "Configure mandatory tags",
		endIcon: /* @__PURE__ */ (0, Q.jsx)(bT, {}),
		size: I.medium,
		linkProps: { to: Y(B.DEVTRON_APP_DETAILS.OVERVIEW, { appId: String(e) }) }
	})
}), CT = ({ stageType: e }) => {
	let t = Ad(e);
	return /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox dc__gap-4 dc__align-items-center",
		children: [/* @__PURE__ */ (0, Q.jsx)(xt, { className: "icon-dim-12 dc__no-shrink" }), /* @__PURE__ */ (0, Q.jsxs)("span", {
			className: "fs-12 fw-4 lh-16 cr-5",
			children: [t.substring(0, t.length - 4), " trigger is blocked!"]
		})]
	});
}, wT = async (e, t = !1) => await mf({
	path: "pipelineRBACViewSelectedTab",
	value: { pipelineRBACViewSelectedTab: e },
	shouldThrowError: t
}), TT = async (e) => {
	if (!e) {
		await wT(window._env_.FEATURE_DEFAULT_AUTHENTICATED_VIEW_ENABLE ? vu.ACCESS_ONLY : vu.ALL_ENVIRONMENTS, !0);
		let e = await zd();
		if (!e) throw new Wl({
			code: eo.NOT_FOUND,
			errors: []
		});
		return e;
	}
	return e;
}, ET = (e, t) => /* @__PURE__ */ (0, Q.jsxs)("div", {
	className: "flexbox dc__gap-4 dc__align-items-center",
	children: [/* @__PURE__ */ (0, Q.jsx)("span", {
		className: "dc__truncate",
		children: e
	}), t && /* @__PURE__ */ (0, Q.jsx)(ul, { size: 16 })]
}), DT = ({ userPreferences: e, userPreferencesError: t, handleUpdatePipelineRBACViewSelectedTab: n }) => {
	let { pipelineRBACViewSelectedTab: r } = e || {}, [i, a] = j(!1), o = [vu.ALL_ENVIRONMENTS, vu.ACCESS_ONLY].map((e) => ({
		label: ET(e, i && r !== e),
		value: e,
		tooltipProps: { content: e === vu.ALL_ENVIRONMENTS ? "View all environments" : "View environments that I have access to" }
	}));
	return /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flex column left dc__gap-4 py-6 px-8",
		children: [/* @__PURE__ */ (0, Q.jsx)("p", {
			className: "m-0 fs-13 lh-1-5 fw-4 cn-9",
			children: "View environments"
		}), /* @__PURE__ */ (0, Q.jsx)(Bl, {
			segments: o,
			value: t ? null : r,
			onChange: async (e) => {
				let t = e.value;
				if (r === t || i) return;
				a(!0);
				let o = await wT(t);
				a(!1), o && (n(t), window.location.reload());
			},
			disabled: i,
			name: "Configure Pipeline RBAC",
			size: I.small
		})]
	});
}, OT = ({ handleClose: e, handleDelete: t, isLoading: n, isOverride: r }) => /* @__PURE__ */ (0, Q.jsx)(ns, {
	variant: rs.custom,
	Icon: /* @__PURE__ */ (0, Q.jsx)(z, {
		name: "ic-warning",
		color: null,
		size: 48
	}),
	title: `Express Delete${r ? " Override" : ""}`,
	subtitle: /* @__PURE__ */ (0, Q.jsxs)("p", {
		className: "m-0 fs-13 lh-20 cn-8",
		children: [
			r ? "This action will delete the override for this file , and the inherited configurations from the base will be used as-is." : "This action will delete this file.",
			/* @__PURE__ */ (0, Q.jsx)("br", {}),
			/* @__PURE__ */ (0, Q.jsx)("br", {}),
			"This action would not require any approval."
		]
	}),
	buttonConfig: {
		secondaryButtonConfig: {
			text: "Cancel",
			onClick: e
		},
		primaryButtonConfig: {
			text: `Delete${r ? " Override" : ""}`,
			style: P.warning,
			onClick: t,
			isLoading: n
		}
	},
	confirmationConfig: {
		confirmationKeyword: `delete${r ? " override" : ""}`,
		identifier: r ? "express-delete-override" : "express-delete"
	},
	handleClose: e,
	shouldCloseOnEscape: !0
}), kT = ({ disabled: e, showPromptTooltip: t, onClick: n, onClose: r, onDoNotShowAgainClose: i }) => {
	let a = {
		arrow: !0,
		interactive: !0,
		visible: t,
		className: `express-edit-btn-prompt-tooltip dc__mxw-250 br-8 ${Qu(mo.light)}`,
		placement: "bottom-end",
		content: /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox-col dc__gap-12 p-16 bcn-8 br-8",
			children: [
				/* @__PURE__ */ (0, Q.jsxs)("div", {
					className: `flex top dc__content-space ${Qu(mo.dark)}`,
					children: [/* @__PURE__ */ (0, Q.jsx)(z, {
						name: "ic-lightning-fill",
						size: 40,
						color: "Y500"
					}), /* @__PURE__ */ (0, Q.jsx)(M, {
						dataTestId: "express-edit-prompt-tooltip-close",
						ariaLabel: "express-edit-prompt-tooltip-close",
						variant: F.borderLess,
						style: P.neutral,
						icon: /* @__PURE__ */ (0, Q.jsx)(z, {
							name: "ic-close-large",
							color: null
						}),
						size: I.xs,
						onClick: r,
						showAriaLabelInTippy: !1
					})]
				}),
				/* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "flexbox-col dc__gap-4 text__white",
					children: [/* @__PURE__ */ (0, Q.jsx)("p", {
						className: "m-0 fs-14 lh-20",
						children: "Express edit"
					}), /* @__PURE__ */ (0, Q.jsx)("p", {
						className: "m-0 fs-13 lh-20",
						children: "You can make direct changes in published & save without approval"
					})]
				}),
				/* @__PURE__ */ (0, Q.jsx)("div", {
					className: "express-edit-btn-prompt-tooltip__do-not-show-again",
					children: /* @__PURE__ */ (0, Q.jsx)(M, {
						dataTestId: "express-edit-prompt-do-not-show-again",
						variant: F.secondary,
						style: P.neutral,
						size: I.small,
						onClick: i,
						text: "Do not show me again",
						fullWidth: !0
					})
				})
			]
		})
	}, o = {
		placement: "bottom-end",
		interactive: !0,
		content: /* @__PURE__ */ (0, Q.jsxs)("p", {
			className: "m-0 fs-13 lh-20 text__white",
			children: [
				/* @__PURE__ */ (0, Q.jsx)("span", {
					className: "fw-6",
					children: e ? "Cannot express edit" : "Express edit"
				}),
				/* @__PURE__ */ (0, Q.jsx)("br", {}),
				e ? "You can make changes and save them without approval only in the published version." : "Make changes in published & save without approval"
			]
		})
	};
	return /* @__PURE__ */ (0, Q.jsx)(M, {
		dataTestId: "express-edit-button",
		variant: F.secondary,
		style: P.neutral,
		text: "Edit",
		startIcon: /* @__PURE__ */ (0, Q.jsx)(z, {
			name: "ic-lightning-fill",
			color: null
		}),
		size: I.xs,
		disabled: e,
		onClick: n,
		showTooltip: !0,
		tooltipProps: t && !e ? a : o
	}, t.toString());
}, AT = ({ handleClose: e, handleSave: t, isLoading: n }) => /* @__PURE__ */ (0, Q.jsx)(ns, {
	variant: rs.warning,
	title: "Existing draft will be discarded",
	subtitle: /* @__PURE__ */ (0, Q.jsxs)("p", {
		className: "m-0 fs-13 lh-20 cn-8",
		children: [
			"Once published, existing draft will be discarded.",
			/* @__PURE__ */ (0, Q.jsx)("br", {}),
			/* @__PURE__ */ (0, Q.jsx)("br", {}),
			"Are you sure?"
		]
	}),
	buttonConfig: {
		secondaryButtonConfig: {
			text: "Cancel",
			onClick: e
		},
		primaryButtonConfig: {
			text: "Discard Draft & Publish",
			onClick: t,
			isLoading: n
		}
	},
	handleClose: e,
	shouldCloseOnEscape: !0
}), jT = [{
	label: "Draft",
	value: "draft"
}, {
	label: "Published",
	value: "published"
}], MT = ({ showDraftOption: e = !1, handleCompareWithChange: t }) => {
	let [n, r] = j(jT[0]);
	return /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "dc__grid-half vertical-divider border__secondary--bottom py-8",
		children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flex left dc__gap-4 px-12",
			children: [/* @__PURE__ */ (0, Q.jsx)("p", {
				className: "m-0 fs-13 lh-20 cn-9",
				children: `Comparing with ${e ? "" : "Published"}`
			}), e && /* @__PURE__ */ (0, Q.jsx)(V, {
				inputId: "express-edit-compare-with-dropdown",
				variant: Hl.COMPACT,
				value: n,
				options: jT,
				onChange: (e) => {
					r(e), t(e.value === jT[0].value);
				}
			})]
		}), /* @__PURE__ */ (0, Q.jsx)("div", {
			className: "px-12",
			children: /* @__PURE__ */ (0, Q.jsxs)("p", {
				className: "m-0 fs-13 lh-20 cn-9 flex left dc__gap-6",
				children: [/* @__PURE__ */ (0, Q.jsx)(z, {
					name: "ic-pencil",
					color: "N700"
				}), /* @__PURE__ */ (0, Q.jsx)("span", { children: "Editing Published" })]
			})
		})]
	});
}, NT = ({ title: e, lhs: t, rhs: n }) => {
	let r = (t.value ?? t.displayValue) !== (n.value ?? n.displayValue);
	return /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "dc__grid-half",
		children: [t.displayValue ? /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: `py-8 px-16 ${r ? "bcr-1" : ""}`,
			children: [/* @__PURE__ */ (0, Q.jsx)("p", {
				className: "m-0 fs-12 lh-18 cn-7",
				children: e
			}), /* @__PURE__ */ (0, Q.jsx)("p", {
				className: "m-0 fs-13 lh-20 cn-9 dc__capitalize",
				children: t.displayValue
			})]
		}) : /* @__PURE__ */ (0, Q.jsx)("div", {}), !Jd(n.displayValue || n.value) && /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: `py-8 px-16 ${r ? "bcg-1" : ""}`,
			children: [/* @__PURE__ */ (0, Q.jsx)("p", {
				className: "m-0 fs-12 lh-18 cn-7",
				children: e
			}), n.dropdownConfig ? /* @__PURE__ */ (0, Q.jsx)("div", {
				className: "flex left",
				children: /* @__PURE__ */ (0, Q.jsx)(V, {
					inputId: `express-edit-comparison-rhs-${e}-dropdown`,
					variant: Hl.COMPACT,
					...n.dropdownConfig ?? {},
					value: Dd(n.dropdownConfig.options, n.value),
					isSearchable: !1
				})
			}) : /* @__PURE__ */ (0, Q.jsx)("p", {
				className: "m-0 fs-13 lh-20 cn-9 dc__capitalize",
				children: n.displayValue
			})]
		})]
	});
}, PT = ({ lhsEditor: e, rhsEditor: t, readOnly: n, showDraftOption: r, handleCompareWithChange: i, dataDiffConfig: a = [], hideEditor: o = {} }) => {
	let s = !o.lhs && o.rhs, c = o.lhs && !o.rhs;
	return /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flex-grow-1 flexbox-col dc__overflow-auto",
		children: [/* @__PURE__ */ (0, Q.jsx)(MT, {
			showDraftOption: r,
			handleCompareWithChange: i
		}), /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flex-grow-1 flexbox-col dc__gap-16 p-16",
			children: [!!a.length && /* @__PURE__ */ (0, Q.jsx)("div", {
				className: "border__primary br-4 py-4 vertical-divider",
				children: a.map((e) => /* @__PURE__ */ (0, Q.jsx)(NT, { ...e }, e.title))
			}), !o.lhs && !o.rhs ? /* @__PURE__ */ (0, Q.jsx)(Xo.Container, {
				flexExpand: !0,
				children: /* @__PURE__ */ (0, Q.jsx)(Xo, {
					mode: Ic.YAML,
					readOnly: n,
					noParsing: !0,
					diffView: !0,
					height: "fitToParent",
					originalValue: e.value,
					modifiedValue: t.value,
					onModifiedValueChange: t.onChange,
					children: /* @__PURE__ */ (0, Q.jsx)("p", {
						className: "m-0 px-16 py-6 border__primary--bottom",
						children: "Data"
					})
				})
			}) : /* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flex-grow-1 dc__grid-half",
				children: [
					c && /* @__PURE__ */ (0, Q.jsx)("div", {}),
					/* @__PURE__ */ (0, Q.jsx)(Xo.Container, {
						flexExpand: !0,
						children: /* @__PURE__ */ (0, Q.jsx)(Xo, {
							mode: Ic.YAML,
							readOnly: s || n,
							noParsing: !0,
							diffView: !1,
							height: "fitToParent",
							...c ? t : {},
							...s ? e : {},
							children: /* @__PURE__ */ (0, Q.jsx)("p", {
								className: "m-0 px-16 py-6 border__primary--bottom",
								children: "Data"
							})
						})
					}),
					s && /* @__PURE__ */ (0, Q.jsx)("div", {})
				]
			})]
		})]
	});
}, FT = ({ isComparisonView: e, handleClose: t, toggleComparison: n }) => /* @__PURE__ */ (0, Q.jsxs)("div", {
	className: "flexbox dc__align-items-center border__primary-warning--bottom bcy-1",
	children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flex-grow-1 flexbox dc__align-items-center dc__gap-12 px-8 pt-6 pb-5",
		children: [/* @__PURE__ */ (0, Q.jsx)(M, {
			dataTestId: "express-edit-close-btn",
			ariaLabel: "express-edit-close-btn",
			icon: /* @__PURE__ */ (0, Q.jsx)(z, {
				name: "ic-close-small",
				color: null
			}),
			showAriaLabelInTippy: !1,
			variant: F.secondary,
			style: P.negativeGrey,
			size: I.xs,
			onClick: t
		}), /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flex dc__gap-6",
			children: [
				/* @__PURE__ */ (0, Q.jsx)(z, {
					name: "ic-lightning-fill",
					color: "Y500"
				}),
				/* @__PURE__ */ (0, Q.jsx)("h3", {
					className: "m-0 fs-13 lh-20 fw-6 cn-9",
					children: "Express Edit"
				}),
				/* @__PURE__ */ (0, Q.jsx)(Cc, {
					heading: "Express edit",
					infoText: "Using Express Edit, you can make changes directly in the published version and save them without approval."
				})
			]
		})]
	}), /* @__PURE__ */ (0, Q.jsx)("div", {
		className: "px-8 pt-4 pb-3",
		children: /* @__PURE__ */ (0, Q.jsx)(M, {
			dataTestId: "express-edit-compare-btn",
			startIcon: /* @__PURE__ */ (0, Q.jsx)(z, {
				name: e ? "ic-close-small" : "ic-arrows-left-right",
				color: null
			}),
			variant: F.borderLess,
			style: P.neutral,
			size: I.small,
			text: e ? "Hide comparison" : "Compare values",
			onClick: n
		})
	})]
}), IT = (e) => /* @__PURE__ */ (0, Q.jsx)("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ (0, Q.jsx)("path", {
		d: "M1.50024 8H3.50024L6.00024 2.5L10.0002 13L12.5002 8H14.5002",
		stroke: "#596168",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), LT = (e) => /* @__PURE__ */ (0, Q.jsxs)("svg", {
	"data-style-override": "false",
	width: 250,
	height: 200,
	viewBox: "0 0 250 200",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [
		/* @__PURE__ */ (0, Q.jsx)("style", { children: "\n .svg__connector {\n  stroke-dasharray: 4 5;\n  stroke-linecap: round;\n  animation: moving-border 0.5s infinite linear;\n    }\n\n    @keyframes moving-border {\n      0% {\n    stroke-dashoffset: 9;\n      }\n      100% {\n    stroke-dashoffset: 0;\n      }\n    }\n" }),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			className: "svg__connector",
			d: "M116 50V55C116 60.5228 120.477 65 126 65H156C161.523 65 166 69.4772 166 75V80",
			stroke: "#B1B7BC",
			strokeWidth: 2,
			strokeDasharray: "4 5"
		}),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			className: "svg__connector",
			d: "M216 50V55C216 60.5228 211.523 65 206 65H176C170.477 65 166 69.4772 166 75V80",
			stroke: "#B1B7BC",
			strokeWidth: 2,
			strokeDasharray: "4 5"
		}),
		/* @__PURE__ */ (0, Q.jsxs)("g", {
			filter: "url(#filter0_b_2663_4657)",
			children: [
				/* @__PURE__ */ (0, Q.jsx)("rect", {
					x: 96,
					y: 10,
					width: 40,
					height: 40,
					rx: 8,
					fill: "white"
				}),
				/* @__PURE__ */ (0, Q.jsx)("rect", {
					x: 97,
					y: 11,
					width: 38,
					height: 38,
					rx: 7,
					stroke: "#D0D4D9",
					strokeWidth: 2
				}),
				/* @__PURE__ */ (0, Q.jsx)("path", {
					d: "M124.66 25C124.582 24.864 124.468 24.7485 124.327 24.6672L116.454 20.1218C116.173 19.9594 115.827 19.9594 115.545 20.1218L107.673 24.6672C107.532 24.7485 107.418 24.8641 107.34 25L116 30L124.66 25Z",
					fill: "#A5DEC6"
				}),
				/* @__PURE__ */ (0, Q.jsx)("path", {
					d: "M116 40C116.157 40 116.314 39.9594 116.455 39.8782L124.327 35.3327C124.609 35.1703 124.782 34.8702 124.782 34.5454V25.4545C124.782 25.2921 124.739 25.1359 124.66 25L116 30V40Z",
					fill: "#61C69B"
				}),
				/* @__PURE__ */ (0, Q.jsx)("path", {
					d: "M115.545 39.8782C115.686 39.9594 115.843 40 116 40V30L107.34 25C107.261 25.1359 107.218 25.2921 107.218 25.4545V34.5454C107.218 34.8702 107.391 35.1704 107.672 35.3327L115.545 39.8782Z",
					fill: "#1DAD70"
				})
			]
		}),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			className: "svg__connector",
			d: "M166 120L166 150",
			stroke: "#B1B7BC",
			strokeWidth: 2,
			strokeDasharray: "4 5"
		}),
		/* @__PURE__ */ (0, Q.jsxs)("g", {
			filter: "url(#filter1_b_2663_4657)",
			children: [
				/* @__PURE__ */ (0, Q.jsx)("rect", {
					x: 146,
					y: 80,
					width: 40,
					height: 40,
					rx: 8,
					fill: "white"
				}),
				/* @__PURE__ */ (0, Q.jsx)("rect", {
					x: 147,
					y: 81,
					width: 38,
					height: 38,
					rx: 7,
					stroke: "#D0D4D9",
					strokeWidth: 2
				}),
				/* @__PURE__ */ (0, Q.jsx)("path", {
					d: "M174.66 95C174.582 94.864 174.468 94.7485 174.327 94.6672L166.454 90.1218C166.173 89.9594 165.827 89.9594 165.545 90.1218L157.673 94.6672C157.532 94.7485 157.418 94.8641 157.34 95L166 100L174.66 95Z",
					fill: "#F33E3E",
					fillOpacity: .4
				}),
				/* @__PURE__ */ (0, Q.jsx)("path", {
					d: "M166 110C166.157 110 166.314 109.959 166.455 109.878L174.327 105.333C174.609 105.17 174.782 104.87 174.782 104.545V95.4545C174.782 95.2921 174.739 95.1359 174.66 95L166 100V110Z",
					fill: "#F33E3E",
					fillOpacity: .7
				}),
				/* @__PURE__ */ (0, Q.jsx)("path", {
					d: "M165.545 109.878C165.686 109.959 165.843 110 166 110V100L157.34 95C157.261 95.1359 157.218 95.2921 157.218 95.4545V104.545C157.218 104.87 157.391 105.17 157.672 105.333L165.545 109.878Z",
					fill: "#F33E3E"
				})
			]
		}),
		/* @__PURE__ */ (0, Q.jsxs)("g", {
			filter: "url(#filter2_b_2663_4657)",
			children: [
				/* @__PURE__ */ (0, Q.jsx)("rect", {
					x: 146,
					y: 150,
					width: 40,
					height: 40,
					rx: 8,
					fill: "white"
				}),
				/* @__PURE__ */ (0, Q.jsx)("rect", {
					x: 147,
					y: 151,
					width: 38,
					height: 38,
					rx: 7,
					stroke: "#D0D4D9",
					strokeWidth: 2
				}),
				/* @__PURE__ */ (0, Q.jsx)("path", {
					d: "M174.66 165C174.582 164.864 174.468 164.748 174.327 164.667L166.454 160.122C166.173 159.959 165.827 159.959 165.545 160.122L157.673 164.667C157.532 164.748 157.418 164.864 157.34 165L166 170L174.66 165Z",
					fill: "#F33E3E",
					fillOpacity: .4
				}),
				/* @__PURE__ */ (0, Q.jsx)("path", {
					d: "M166 180C166.157 180 166.314 179.959 166.455 179.878L174.327 175.333C174.609 175.17 174.782 174.87 174.782 174.545V165.455C174.782 165.292 174.739 165.136 174.66 165L166 170V180Z",
					fill: "#F33E3E",
					fillOpacity: .7
				}),
				/* @__PURE__ */ (0, Q.jsx)("path", {
					d: "M165.545 179.878C165.686 179.959 165.843 180 166 180V170L157.34 165C157.261 165.136 157.218 165.292 157.218 165.455V174.545C157.218 174.87 157.391 175.17 157.672 175.333L165.545 179.878Z",
					fill: "#F33E3E"
				})
			]
		}),
		/* @__PURE__ */ (0, Q.jsxs)("g", {
			filter: "url(#filter3_b_2663_4657)",
			children: [
				/* @__PURE__ */ (0, Q.jsx)("rect", {
					x: 196,
					y: 10,
					width: 40,
					height: 40,
					rx: 8,
					fill: "white"
				}),
				/* @__PURE__ */ (0, Q.jsx)("rect", {
					x: 197,
					y: 11,
					width: 38,
					height: 38,
					rx: 7,
					stroke: "#D0D4D9",
					strokeWidth: 2
				}),
				/* @__PURE__ */ (0, Q.jsx)("path", {
					d: "M224.66 25C224.582 24.864 224.468 24.7485 224.327 24.6672L216.454 20.1218C216.173 19.9594 215.827 19.9594 215.545 20.1218L207.673 24.6672C207.532 24.7485 207.418 24.8641 207.34 25L216 30L224.66 25Z",
					fill: "#F33E3E",
					fillOpacity: .4
				}),
				/* @__PURE__ */ (0, Q.jsx)("path", {
					d: "M216 40C216.157 40 216.314 39.9594 216.455 39.8782L224.327 35.3327C224.609 35.1703 224.782 34.8702 224.782 34.5454V25.4545C224.782 25.2921 224.739 25.1359 224.66 25L216 30V40Z",
					fill: "#F33E3E",
					fillOpacity: .7
				}),
				/* @__PURE__ */ (0, Q.jsx)("path", {
					d: "M215.545 39.8782C215.686 39.9594 215.843 40 216 40V30L207.34 25C207.261 25.1359 207.218 25.2921 207.218 25.4545V34.5454C207.218 34.8702 207.391 35.1704 207.672 35.3327L215.545 39.8782Z",
					fill: "#F33E3E"
				})
			]
		}),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			d: "M29.8984 199.906C29.8984 199.811 30.8413 197.217 31.974 194.104L34.0495 188.443L39.3324 188.302L44.5686 188.16L46.8322 190.047C48.7197 191.651 57.2966 196.219 58.3891 196.84C59.1178 197.254 60.0795 198.307 61.2726 200C40.3562 199.969 29.8984 199.937 29.8984 199.906V199.906Z",
			fill: "#80AEF2"
		}),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			d: "M2.45312 199.906C2.45312 199.811 3.39685 197.217 4.52866 194.104L6.60419 188.443L11.8871 188.302L17.1233 188.16L19.3878 190.047C21.2744 191.651 29.8513 196.219 30.9446 196.84C31.6725 197.254 32.6342 198.307 33.8273 200C12.9109 199.969 2.45312 199.937 2.45312 199.906Z",
			fill: "#94BBF8"
		}),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			d: "M38.1534 133.28C39.0448 135.862 39.6467 138.103 39.9591 140.002C40.2699 141.9 42.0183 158.12 45.2019 188.66H30.4998C29.3189 186.519 28.7285 185.015 28.7285 184.147C28.7285 182.847 29.4751 181.064 29.4751 179.185C29.4751 177.932 27.8118 173.605 24.4834 166.206L27.6981 134.027L38.1534 133.28V133.28Z",
			fill: "#1D225F"
		}),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M17.6261 188.659H3.89231C3.56519 187.526 3.24462 185.998 2.93141 184.074C2.31808 180.159 2.78421 177.565 5.42565 172.187C8.06708 166.857 9.40497 163.95 9.40497 160.931C9.4524 156.214 10.4043 151.677 12.9051 146.771C14.8383 142.903 15.7632 142.612 15.9513 140.254L16.2948 135.182H33.532C33.9507 136.354 34.1012 138.514 33.9818 141.663C33.8632 144.811 28.411 160.476 17.6253 188.659H17.6261Z",
			fill: "url(#paint0_linear_2663_4657)"
		}),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			d: "M54.7422 85.0158L68.5136 67.9814H85.0255L70.7642 85.0158H54.7422Z",
			fill: "#98BDF9"
		}),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			d: "M72.8971 65.8521C74.024 65.8521 74.9464 66.7271 75.0209 67.8352L75.0258 67.9816H74.5531C74.5531 67.0665 73.8114 66.3255 72.8971 66.3255C71.982 66.3255 71.2411 67.0665 71.2411 67.9816C71.2411 68.85 71.91 69.5631 72.7613 69.6318L72.8971 69.6376V70.1102C71.7211 70.1102 70.7676 69.1575 70.7676 67.9816C70.7676 66.8056 71.7211 65.8521 72.8971 65.8521V65.8521ZM78.5749 65.8521C79.7018 65.8521 80.6243 66.7271 80.6995 67.8352L80.7044 67.9816H80.2309C80.2309 67.0665 79.49 66.3255 78.5749 66.3255C77.6607 66.3255 76.9189 67.0665 76.9189 67.9816C76.9189 68.85 77.5879 69.5631 78.4392 69.6318L78.5749 69.6376V70.1102C77.399 70.1102 76.4454 69.1575 76.4454 67.9816C76.4454 66.8056 77.399 65.8521 78.5749 65.8521V65.8521Z",
			fill: "#2174DB"
		}),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			d: "M53.5419 88.2962C55.8374 87.5095 58.0838 86.4162 60.282 85.0161H65.901C63.9588 86.7907 62.6528 88.0468 61.983 88.7861C61.3124 89.5245 59.9312 90.9434 57.8385 93.0426C56.9463 97.7702 55.9952 99.7566 54.9869 99.0002C53.474 97.8667 48.4945 90.0888 53.5419 88.2954V88.2962Z",
			fill: "#F3A29D"
		}),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			d: "M56.6346 93.0595C60.2026 91.6955 62.5055 90.7231 63.5425 90.1425C64.7691 89.4351 65.241 88.7743 66.6558 85.8025C66.8438 85.4255 67.2217 83.8685 67.552 82.4063C68.3068 78.6796 69.5335 78.8685 69.6276 82.6892C69.675 83.7278 69.9105 84.6707 70.1935 84.7648C70.429 84.8596 71.7971 83.5381 73.1653 81.8404C74.5334 80.1418 75.8542 78.7737 76.0897 78.7737C76.6556 78.7737 76.6556 83.1136 76.0431 84.6233C75.8067 85.3307 72.175 89.2928 67.9765 93.4913C65.178 96.2906 61.0817 100.089 55.6885 104.889L56.6346 93.0595V93.0595Z",
			fill: "#FAB6AF"
		}),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			d: "M40.5465 72.7131C41.1778 70.1894 41.8083 68.6119 42.4397 67.9806C41.4935 67.0344 40.5465 66.0883 38.6533 65.1421C38.0237 66.4039 36.761 67.6658 34.8687 68.9276C34.8687 70.8199 35.4992 72.0818 36.761 72.7131C38.0228 73.3436 39.2847 73.3436 40.5473 72.7131H40.5465Z",
			fill: "#F3A29D"
		}),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			d: "M16.6078 135.851C14.6737 135.709 11.513 135.049 9.67298 134.435L6.23012 133.303L6.13608 129.765C5.89974 120.001 6.60794 112.878 8.82494 103.774C11.8434 91.2736 20.5233 78.4908 31.0424 70.9901C35.0986 68.0657 35.1935 68.0657 36.3727 70.0472C36.8912 70.9901 37.9756 71.9338 38.7312 72.2168L40.4985 72.7025C38.0075 96.6832 38.9692 116.56 43.386 132.333C42.4399 133.28 41.7946 133.708 41.0897 134.011C40.24 134.34 39.1557 134.671 38.5898 134.718C38.023 134.766 36.1364 135.143 34.2964 135.567C30.8535 136.322 23.3528 136.463 16.6078 135.85V135.851Z",
			fill: "url(#paint1_linear_2663_4657)"
		}),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M53.542 88.2952L54.987 97.5452L38.6543 99.7082L39.5588 86.9075C41.3096 88.3263 43.1112 89.1776 44.9627 89.4614C46.8133 89.746 49.6731 89.3567 53.5412 88.2952H53.542Z",
			fill: "#D6D7D8"
		}),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			d: "M56.6344 93.0587L60.644 111.986C60.1795 112.932 59.0002 113.564 57.1079 113.879C52.8489 114.352 48.5907 112.459 43.3855 112.459C38.1803 112.459 38.4052 115.771 30.8342 112.933C25.7869 111.04 23.7359 102.523 24.682 87.3808L39.4463 85.9661C39.3825 90.6945 39.9819 93.5322 41.2438 94.4784C42.4802 95.4057 47.4335 94.9698 56.1028 93.1699L56.6344 93.0587V93.0587Z",
			fill: "#E9E9E9"
		}),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			d: "M50.1345 56.0872C51.0095 57.3303 51.3514 58.9789 51.1592 61.034C51.1085 61.5705 50.8517 61.7561 50.8517 62.7121C50.8517 63.628 50.9089 64.7614 51.0251 66.1116L49.1303 66.2433C47.3132 68.2158 45.3897 69.0891 43.3608 68.8659C41.3327 68.641 39.8844 67.7676 39.0184 66.2433C37.2356 62.9533 37.6928 60.1557 40.3882 57.8512C43.0836 55.5467 46.3326 54.9587 50.1345 56.0872V56.0872Z",
			fill: "#FAB6AF"
		}),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M41.4178 50C43.5424 50 46.0931 50.8317 47.9552 52.2407C49.8173 53.6489 51.0996 54.7104 51.6761 56.409C52.0605 57.5408 51.8789 59.1191 51.1331 61.1447C51.2394 59.227 51.0938 58.1623 50.6972 57.9505C50.1493 59.3023 49.3929 59.5754 48.4868 60.2296C47.9797 60.596 46.2043 60.6532 44.4657 60.9632C42.3166 62.3714 40.9468 63.6864 40.4856 64.9376C40.1192 65.9337 40.1568 67.0704 40.6066 68.3535L40.7096 68.6307L40.268 68.8024C39.6842 67.3034 39.6056 65.9582 40.0415 64.7749C40.4684 63.6161 41.5544 62.454 43.226 61.2412C42.3346 61.4923 41.5487 61.8578 41.0719 62.4262C40.026 63.6741 39.4135 65.5051 39.2352 67.9184C36.9732 67.5095 34.8969 66.7465 33.0061 65.6286C31.1154 64.5115 29.3711 63.0166 27.774 61.1447C28.0978 60.4627 28.5132 59.8984 29.0178 59.4519C29.5666 58.9678 30.6002 58.5458 31.6094 57.9619L31.5562 57.9791L30.5716 58.307C29.5412 58.6538 28.972 58.8901 28.613 59.151C27.9343 59.6425 27.5826 60.1937 27.5393 60.8127L27.5352 60.9689L27.0617 60.9746C27.0519 60.125 27.4837 59.3857 28.335 58.7674C28.6842 58.5139 29.1634 58.2989 29.9566 58.0184L31.3927 57.5359L31.8915 57.3617C32.3773 57.1875 32.7616 57.0337 33.0683 56.8841C34.1281 55.74 34.8429 53.6367 36.413 52.2407C38.1426 50.6992 39.2933 50 41.417 50H41.4178Z",
			fill: "#E94A47"
		}),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			d: "M45.2725 61.1015C45.7608 59.7604 47.0471 58.9778 48.1634 59.3842C49.0311 59.6999 49.516 60.6305 49.4604 61.6584C49.7548 61.584 50.0239 61.5464 50.2684 61.5472L50.4385 61.5529C50.647 61.5693 50.8196 61.5987 50.9586 61.6462C51.3773 60.6068 52.3554 59.9918 53.2075 60.3017C54.0825 60.6207 54.4325 61.7762 54.0351 62.8696C53.6368 63.963 52.626 64.6229 51.7502 64.304C50.9709 64.0202 50.6078 63.074 50.8179 62.0984C50.7337 62.0673 50.5939 62.0395 50.4025 62.0248C50.1294 62.0044 49.7998 62.0485 49.4146 62.1597L49.3893 62.1679C49.3598 62.2979 49.3214 62.428 49.2748 62.558C48.7866 63.8992 47.5002 64.6818 46.3831 64.2753C45.266 63.8689 44.7843 62.4427 45.2725 61.1015V61.1015ZM53.0447 60.7466C52.4478 60.5291 51.684 61.0271 51.3667 61.8981C51.0502 62.7698 51.3143 63.6416 51.9121 63.8591C52.5099 64.0766 53.2729 63.5786 53.5902 62.7077C53.9075 61.8367 53.6425 60.9641 53.0447 60.7466ZM48.0015 59.8291C47.1543 59.5208 46.123 60.148 45.7174 61.2635C45.3118 62.3781 45.6978 63.5222 46.545 63.8313C47.3922 64.1388 48.4243 63.5107 48.8299 62.3961C49.2355 61.2814 48.8487 60.1374 48.0015 59.8282V59.8291Z",
			fill: "#222768"
		}),
		/* @__PURE__ */ (0, Q.jsxs)("defs", { children: [
			/* @__PURE__ */ (0, Q.jsxs)("filter", {
				id: "filter0_b_2663_4657",
				x: -30.72,
				y: -116.72,
				width: 293.44,
				height: 293.44,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ (0, Q.jsx)("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ (0, Q.jsx)("feGaussianBlur", {
						in: "BackgroundImageFix",
						stdDeviation: 63.36
					}),
					/* @__PURE__ */ (0, Q.jsx)("feComposite", {
						in2: "SourceAlpha",
						operator: "in",
						result: "effect1_backgroundBlur_2663_4657"
					}),
					/* @__PURE__ */ (0, Q.jsx)("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect1_backgroundBlur_2663_4657",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ (0, Q.jsxs)("filter", {
				id: "filter1_b_2663_4657",
				x: 19.28,
				y: -46.72,
				width: 293.44,
				height: 293.44,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ (0, Q.jsx)("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ (0, Q.jsx)("feGaussianBlur", {
						in: "BackgroundImageFix",
						stdDeviation: 63.36
					}),
					/* @__PURE__ */ (0, Q.jsx)("feComposite", {
						in2: "SourceAlpha",
						operator: "in",
						result: "effect1_backgroundBlur_2663_4657"
					}),
					/* @__PURE__ */ (0, Q.jsx)("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect1_backgroundBlur_2663_4657",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ (0, Q.jsxs)("filter", {
				id: "filter2_b_2663_4657",
				x: 19.28,
				y: 23.28,
				width: 293.44,
				height: 293.44,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ (0, Q.jsx)("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ (0, Q.jsx)("feGaussianBlur", {
						in: "BackgroundImageFix",
						stdDeviation: 63.36
					}),
					/* @__PURE__ */ (0, Q.jsx)("feComposite", {
						in2: "SourceAlpha",
						operator: "in",
						result: "effect1_backgroundBlur_2663_4657"
					}),
					/* @__PURE__ */ (0, Q.jsx)("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect1_backgroundBlur_2663_4657",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ (0, Q.jsxs)("filter", {
				id: "filter3_b_2663_4657",
				x: 69.28,
				y: -116.72,
				width: 293.44,
				height: 293.44,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ (0, Q.jsx)("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ (0, Q.jsx)("feGaussianBlur", {
						in: "BackgroundImageFix",
						stdDeviation: 63.36
					}),
					/* @__PURE__ */ (0, Q.jsx)("feComposite", {
						in2: "SourceAlpha",
						operator: "in",
						result: "effect1_backgroundBlur_2663_4657"
					}),
					/* @__PURE__ */ (0, Q.jsx)("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect1_backgroundBlur_2663_4657",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ (0, Q.jsxs)("linearGradient", {
				id: "paint0_linear_2663_4657",
				x1: 19.9258,
				y1: 135.182,
				x2: 7.5723,
				y2: 186.753,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ (0, Q.jsx)("stop", { stopColor: "#2A318C" }), /* @__PURE__ */ (0, Q.jsx)("stop", {
					offset: 1,
					stopColor: "#1D225F"
				})]
			}),
			/* @__PURE__ */ (0, Q.jsxs)("linearGradient", {
				id: "paint1_linear_2663_4657",
				x1: 24.7394,
				y1: 68.6619,
				x2: 24.7394,
				y2: 136.234,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ (0, Q.jsx)("stop", { stopColor: "#EEEEEE" }), /* @__PURE__ */ (0, Q.jsx)("stop", {
					offset: 1,
					stopColor: "#D6D7D8"
				})]
			})
		] })
	]
}), RT = Array.from([
	,
	,
	,
].keys()).map((e) => ({
	environmentId: e,
	environmentName: "",
	appStatus: "",
	appName: "",
	appId: e + 1
})), zT = {
	DEPENDENCIES_TITLE: "Dependencies provide better visibility into your application ecosystem",
	DEPENDENCIES_SUB_TITLE: "Clever decisions start with knowing dependencies. From design to deployment and troubleshooting, it powers an efficient application ecosystem."
}, BT = {
	UPSTREAM: Es.UPSTREAM,
	DOWNSTREAM: Es.DOWNSTREAM
}, VT = {
	ADD_DEPENDENCY: "addDependency",
	MAP_ENVIRONMENT: "mapEnvironment"
}, HT = "dependency-list", UT = Ua({}), WT = (e) => /* @__PURE__ */ (0, Q.jsx)(UT.Provider, { ...e }), GT = () => qa(UT), KT = (e) => {
	switch (e) {
		case "app": return "application/devtron-application";
		default: throw Error(`Invalid resource type: ${e}`);
	}
};
async function qT({ resourceType: e, resourceId: t, version: n }) {
	let { result: { dependencies: r, childDependencies: i } } = await G(Rd(`resource/dependencies/${KT(e)}/${n}`, { id: t })), a = r.reduce((e, t) => (e[t.index] = {
		...t,
		environmentDependencyMap: i.reduce((e, n) => (e[n.index] = (n.dependencies ?? []).filter((e) => e.dependentOnParentIndex === t.index), e), {})
	}, e), {}), o = Object.values(a), s = i.map(({ dependencies: e, ...t }) => t);
	return Promise.resolve({
		dependencyMapByDependencyIndex: a,
		appDependencies: o,
		appEnvironments: s
	});
}
var JT = () => G("app/autocomplete/all"), YT = async (e) => G(`app/cd-pipeline/env/lite/${e}`), XT = async () => {
	try {
		let { result: e } = await G("resource/list"), t = e.reduce((e, t) => {
			let n = structuredClone(t);
			return e[t.kind] = {
				...n,
				versionSchemaDetails: (n.versionSchemaDetails ?? []).filter((e) => e.version === kl.v1)
			}, e;
		}, {});
		return {
			devtronResourceId: t[tn.DEVTRON_APPLICATION].devtronResourceId,
			devtronResourceSchemaId: t[tn.DEVTRON_APPLICATION].versionSchemaDetails[0].devtronResourceSchemaId,
			cdResourceId: t[tn.CD_PIPELINE].devtronResourceId,
			cdResourceSchemaId: t[tn.CD_PIPELINE].versionSchemaDetails[0].devtronResourceSchemaId
		};
	} catch (e) {
		throw K(e), e;
	}
}, ZT = ({ dependencyMapByDependencyIndex: e, appEnvironments: t, resourceId: n, resourceType: r, version: i }) => {
	let a = Object.values(e).map(({ environmentDependencyMap: e, ...t }) => t), o = t.reduce((e, t) => (e[t.index] = {
		...t,
		dependencies: []
	}, e), {});
	return Object.values(e).forEach((e) => {
		Object.entries(e.environmentDependencyMap).forEach(([e, t]) => {
			o[e].dependencies.push(...t);
		});
	}), sf(`resource/dependencies/${KT(r)}/${i}`, {
		id: n,
		dependencies: a,
		childDependencies: Object.values(o)
	});
}, QT = () => /* @__PURE__ */ (0, Q.jsx)("svg", {
	height: "40",
	width: "100%",
	xmlns: "http://www.w3.org/2000/svg",
	children: /* @__PURE__ */ (0, Q.jsx)("line", {
		x1: "50%",
		y1: "0",
		x2: "50%",
		y2: "100%",
		className: "svg__moving-line"
	})
}), $T = () => /* @__PURE__ */ (0, Q.jsxs)("svg", {
	width: "24",
	height: "36",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	children: [/* @__PURE__ */ (0, Q.jsx)("circle", {
		cx: "12",
		cy: "12",
		r: "5",
		fill: "var(--B500)",
		className: "svg__pulse-animation"
	}), /* @__PURE__ */ (0, Q.jsx)("circle", {
		cx: "12",
		cy: "12",
		r: "4",
		fill: "var(--N0)",
		stroke: "var(--B500)",
		strokeWidth: "2"
	})]
}), eE = ({ handleEnvironmentChange: e, applicationId: t, selectedEnvironment: n, dependencyIndex: r }) => {
	let i = {
		...n,
		displayName: n?.metadata?.environmentName || n?.displayName
	}, { resourceKindConfig: { cdResourceId: a, cdResourceSchemaId: o } } = GT(), [s, c] = j([]), [l, u] = j(!1), d = async () => {
		try {
			u(!0);
			let { result: e } = await YT(t);
			c(e.map((e, t) => ({
				devtronResourceId: a,
				devtronResourceSchemaId: o,
				dependentOnParentIndex: r,
				name: e.pipelineName,
				id: e.pipelineId,
				index: t + 1,
				typeOfDependency: BT.UPSTREAM,
				displayName: e.environmentName,
				label: e.environmentName,
				value: e.pipelineId
			})));
		} catch (e) {
			K(e);
		} finally {
			u(!1);
		}
	};
	return /* @__PURE__ */ (0, Q.jsx)("div", {
		className: "w-200",
		children: /* @__PURE__ */ (0, Q.jsx)(V, {
			inputId: "map-environment",
			options: s,
			isLoading: l,
			onMenuOpen: async () => {
				s.length === 0 && await d();
			},
			placeholder: "Map environment",
			onChange: e,
			value: i.displayName === void 0 ? i.displayName : i,
			getOptionLabel: (e) => e.displayName,
			getOptionValue: (e) => e.id,
			isSearchable: !0
		})
	});
};
//#endregion
//#region src/Components/Dependency/Update/DependencyItem.tsx
function tE({ id: e, name: t, isCurrentApp: n = !1, dependencyIndex: r, dependencyData: i, mode: a, currentAppSelectedEnvironmentIndex: o, handleDeleteDependency: s, handleEnvironmentChange: c }) {
	return /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: `flexbox dc__align-items-center w-100 h-40 ${n ? "bcy-1 br-4" : ""}`,
		children: [/* @__PURE__ */ (0, Q.jsx)("div", {
			className: "w-40 svg-height-100 dc__no-shrink",
			children: n ? /* @__PURE__ */ (0, Q.jsxs)("span", {
				className: "dc__position-rel",
				children: [/* @__PURE__ */ (0, Q.jsx)("span", {
					className: "dc__position-abs",
					style: {
						left: "8px",
						bottom: "-2px"
					},
					children: /* @__PURE__ */ (0, Q.jsx)($T, {})
				}), /* @__PURE__ */ (0, Q.jsx)(QT, {})]
			}) : /* @__PURE__ */ (0, Q.jsx)(QT, {})
		}), /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox dc__align-items-center w-100 dc__content-space",
			children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "h-20 flexbox dc__align-items-center fs-13 fw-4 dc__gap-16 ",
				children: [/* @__PURE__ */ (0, Q.jsx)(rn, { className: "icon-dim-24" }), /* @__PURE__ */ (0, Q.jsx)("span", {
					className: n ? "fw-6" : "",
					children: t
				})]
			}), /* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox dc__align-items-center dc__gap-16",
				children: [a === VT.MAP_ENVIRONMENT && /* @__PURE__ */ (0, Q.jsx)(eE, {
					applicationId: e,
					dependencyIndex: r,
					handleEnvironmentChange: (e) => {
						c(r, e);
					},
					selectedEnvironment: i[r]?.environmentDependencyMap[o]?.[0]
				}, `${e}-${o}`), !n && /* @__PURE__ */ (0, Q.jsx)(ue, {
					className: "icon-dim-16 cursor",
					onClick: () => {
						s(r);
					}
				})]
			})]
		})]
	});
}
//#endregion
//#region src/Components/Dependency/Update/DependencySelector.tsx
function nE({ options: e, handleAddDependency: t, toggleSelector: n, isAppListDataLoading: r }) {
	return /* @__PURE__ */ (0, Q.jsx)("div", {
		className: "w-250 pt-12",
		children: /* @__PURE__ */ (0, Q.jsx)(V, {
			inputId: "dependency-selector",
			autoFocus: !0,
			isSearchable: !0,
			isLoading: r,
			menuIsOpen: !0,
			placeholder: "Search Application",
			options: e,
			getOptionLabel: (e) => e.label,
			getOptionValue: (e) => e.value,
			onChange: t,
			onBlur: n,
			variant: Hl.COMPACT
		})
	});
}
//#endregion
//#region src/Components/Dependency/Update/DependencyEditor.tsx
var rE = ({ title: e, tooltip: t }) => /* @__PURE__ */ (0, Q.jsxs)("div", {
	className: "flexbox dc__align-items-center dc__gap-6 dc__border-bottom-n1 pt-8 pb-8",
	children: [/* @__PURE__ */ (0, Q.jsx)("div", {
		className: "fw-6 cn-7 fs-12 dc__uppercase",
		children: e
	}), /* @__PURE__ */ (0, Q.jsx)(ft, {
		content: t,
		className: "default-tt",
		placement: "auto",
		arrow: !1,
		children: /* @__PURE__ */ (0, Q.jsx)("div", {
			className: "flex cursor",
			children: /* @__PURE__ */ (0, Q.jsx)(m, { className: "icon-dim-16 cn-6" })
		})
	})]
});
function iE({ appList: e, dependencyData: t, mode: n, selectedEnvironmentIndex: r, setDependencyData: i, setAppList: a, trackDependenciesUpdate: o, isAppListDataLoading: s }) {
	let [c, l] = j(!1), { resourceName: u, resourceId: d } = GT(), f = () => {
		l(!c);
	}, p = (n) => {
		o();
		let r = Object.keys(t || {}).map(Number), s = r.length ? Math.max(...r) + 1 : 0;
		i({
			...t,
			[s]: {
				...n,
				index: s
			}
		}), a(e.filter((e) => e.id !== n.id)), l(!1);
	}, m = (n) => {
		o();
		let r = t[n];
		a([...e, r]);
		let s = { ...t };
		delete s[n], i(s);
	}, h = (e, n) => {
		o(), i({
			...t,
			[e]: {
				...t[e],
				environmentDependencyMap: {
					...t[e].environmentDependencyMap,
					[r]: [n]
				}
			}
		});
	};
	return /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "w-100 flexbox-col w-100",
		children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox-col w-100",
			children: [
				/* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "flexbox",
					children: [/* @__PURE__ */ (0, Q.jsx)("div", {
						className: "w-40 svg-height-100 dc__no-shrink",
						children: /* @__PURE__ */ (0, Q.jsx)(QT, {})
					}), /* @__PURE__ */ (0, Q.jsxs)("div", {
						className: "flexbox-col w-100",
						children: [/* @__PURE__ */ (0, Q.jsx)(rE, {
							title: "Upstream Dependency",
							tooltip: `Applications providing data to ${u}`
						}), /* @__PURE__ */ (0, Q.jsx)("div", {
							className: "h-48",
							children: c ? /* @__PURE__ */ (0, Q.jsx)(nE, {
								options: e,
								handleAddDependency: p,
								toggleSelector: f,
								isAppListDataLoading: s
							}) : /* @__PURE__ */ (0, Q.jsxs)("button", {
								onClick: f,
								className: "fw-6 flexbox dc__align-items-center pt-12 pl-0 pb-16 bg__primary dc__no-border dc__gap-4",
								type: "button",
								children: [/* @__PURE__ */ (0, Q.jsx)(E, { className: "icon-dim-16 icon-fill-blue-imp" }), /* @__PURE__ */ (0, Q.jsx)("span", {
									className: "cb-5",
									children: "Add Dependency"
								})]
							})
						})]
					})]
				}),
				Object.keys(t ?? {}).length > 0 && /* @__PURE__ */ (0, Q.jsx)("div", {
					className: "flexbox-col",
					children: Object.values(t).map((e) => e.typeOfDependency === BT.UPSTREAM && /* @__PURE__ */ (0, Q.jsx)(tE, {
						id: e.metadata?.appId || e.id,
						dependencyIndex: e.index,
						name: e.metadata?.appName || e.name,
						dependencyData: t,
						mode: n,
						currentAppSelectedEnvironmentIndex: r,
						handleEnvironmentChange: h,
						handleDeleteDependency: m
					}, e.metadata?.appId || e.id))
				}),
				/* @__PURE__ */ (0, Q.jsx)(tE, {
					id: d,
					name: u,
					isCurrentApp: !0,
					handleEnvironmentChange: h,
					handleDeleteDependency: m
				})
			]
		}), /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox pb-16",
			children: [/* @__PURE__ */ (0, Q.jsx)("div", {
				className: "w-40 svg-height-100 dc__no-shrink",
				children: /* @__PURE__ */ (0, Q.jsx)(QT, {})
			}), /* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox-col",
				children: [/* @__PURE__ */ (0, Q.jsx)(rE, {
					title: "Downstream Dependency",
					tooltip: `Applications consuming data from ${u}`
				}), /* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "fs-13 fw-4 pt-8",
					children: [
						"Downstream dependencies are auto-populated if ",
						u,
						" is added as an upstream dependency in applications."
					]
				})]
			})]
		})]
	});
}
//#endregion
//#region src/Components/Dependency/Update/EnvironmentSelectionSidebar.tsx
var aE = ({ environmentList: e, selectedEnvironmentIndex: t, setSelectedEnvironmentIndex: n }) => {
	let { appName: r } = GT();
	return /* @__PURE__ */ (0, Q.jsxs)("aside", {
		className: "flexbox-col dc__gap-8 w-200",
		children: [
			/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "fs-12 lh-20 pl-8 pr-8",
				children: [/* @__PURE__ */ (0, Q.jsx)("div", {
					className: "cn-9 fw-4",
					children: r
				}), /* @__PURE__ */ (0, Q.jsx)("div", {
					className: "cn-7 fw-6 dc__uppercase",
					children: "Deployments"
				})]
			}),
			/* @__PURE__ */ (0, Q.jsx)("div", { className: "dc__border-top-n1" }),
			/* @__PURE__ */ (0, Q.jsx)("div", {
				className: "fs-13 lh-20 fw-4 cn-9 cursor",
				children: e.map((e) => /* @__PURE__ */ (0, Q.jsx)("div", {
					onClick: () => n(e.index),
					className: `pt-6 pb-6 pr-8 pl-8 br-4 dc__ellipsis-right dc__word-break ${t === e.index ? "cb-5 bcb-1" : "dc__hover-n50"}`,
					children: e.metadata.environmentName
				}, `${e.id}-${e.index}`))
			})
		]
	});
}, oE = {
	addDependency: { width: "600px" },
	mapEnvironment: { width: "800px" }
}, sE = ({ mode: e, selectedEnvironmentIndexInList: t, isListDataLoading: n }) => {
	let r = Ja(null), { appName: i, resourceId: a, dependencyMapByDependencyIndex: o, filteredEnvironmentList: s, resourceKindConfig: { devtronResourceId: c, devtronResourceSchemaId: l }, reloadDependencyList: u, toggleUpdateModalOpen: d, allEnvironmentList: f } = GT(), [p, m] = j(!1), [h, g] = j([]), [_, v] = j(o), [y, b] = j(t), [x, S] = j(!1), [C, w] = j(!1), T = x || n, ee = e === VT.ADD_DEPENDENCY && s.length > 0;
	k(() => {
		o && (v(Object.fromEntries(Object.entries(o).filter(([, e]) => e.typeOfDependency === BT.UPSTREAM))), m(!0), JT().then(({ result: e }) => {
			let t = Object.values(o).map((e) => ({
				id: e.id,
				typeOfDependency: e.typeOfDependency
			}));
			g(e.filter((e) => e.id !== a && !t.some((t) => t.id === e.id && t.typeOfDependency === BT.UPSTREAM)).map((e) => ({
				...e,
				devtronResourceId: c,
				devtronResourceSchemaId: l,
				environmentDependencyMap: {},
				typeOfDependency: BT.UPSTREAM,
				label: e.name,
				value: e.id
			})));
		}).catch((e) => {
			K(e);
		}).finally(() => {
			m(!1);
		}));
	}, [o, c]);
	let E = oE[e];
	return /* @__PURE__ */ (0, Q.jsx)(Rs, {
		position: "right",
		width: E.width,
		children: /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "h-100 bg__primary dc__position-rel flexbox-col dc__content-space dc__overflow-hidden",
			ref: r,
			children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox-col flex-grow-1 dc__overflow-auto",
				children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "flex dc__content-space pt-16 pb-16 pl-20 pr-20 dc__border-bottom",
					children: [/* @__PURE__ */ (0, Q.jsxs)("h2", {
						className: "fs-16 cn-9 fw-6 m-0",
						children: ["Manage application dependencies for ", i]
					}), /* @__PURE__ */ (0, Q.jsx)(ue, {
						className: "icon-dim-20 cursor",
						onClick: d
					})]
				}), n ? /* @__PURE__ */ (0, Q.jsx)(ul, {}) : /* @__PURE__ */ (0, Q.jsx)("div", {
					className: "flexbox-col flex-grow-1 dc__overflow-auto p-16",
					children: /* @__PURE__ */ (0, Q.jsxs)("div", {
						className: "flexbox",
						children: [e === VT.MAP_ENVIRONMENT && /* @__PURE__ */ (0, Q.jsx)(aE, {
							environmentList: s,
							selectedEnvironmentIndex: y,
							setSelectedEnvironmentIndex: b
						}), _ && /* @__PURE__ */ (0, Q.jsx)(iE, {
							appList: h,
							dependencyData: _,
							mode: e,
							selectedEnvironmentIndex: y,
							setDependencyData: v,
							setAppList: g,
							trackDependenciesUpdate: () => {
								C || w(!0);
							},
							isAppListDataLoading: p
						})]
					})
				})]
			}), !n && /* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "dc__border-top flex right dc__gap-12 bg__primary py-16 px-20 w-100 dc__no-shrink",
				children: [/* @__PURE__ */ (0, Q.jsx)(M, {
					text: "Cancel",
					variant: F.secondary,
					style: P.neutral,
					onClick: d,
					disabled: T,
					dataTestId: "dependency-modal-cancel-button"
				}), /* @__PURE__ */ (0, Q.jsx)(M, {
					isLoading: T,
					disabled: !C,
					onClick: () => {
						S(!0), ZT({
							dependencyMapByDependencyIndex: _,
							appEnvironments: f,
							resourceId: a,
							resourceType: "app",
							version: kl.v1
						}).then(() => {
							H.showToast({
								variant: U.success,
								description: "Dependencies updated successfully"
							}), (e === VT.MAP_ENVIRONMENT || e === VT.ADD_DEPENDENCY && !s.length) && d(), u();
						}).catch((e) => {
							K(e);
						}).finally(() => {
							S(!1);
						});
					},
					text: "Save",
					...ee && {
						endIcon: /* @__PURE__ */ (0, Q.jsx)(Kn, {}),
						text: "Map Environments"
					},
					dataTestId: "dependency-modal-save-button"
				})]
			})]
		})
	});
}, cE = (e) => /* @__PURE__ */ (0, Q.jsx)("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 16 16",
	fill: "none",
	...e,
	children: /* @__PURE__ */ (0, Q.jsx)("path", {
		d: "M15.2064 6.95138C15.1695 6.92099 14.8352 6.66706 14.1179 6.66706C13.9324 6.66706 13.7403 6.68551 13.5547 6.71698C13.4191 5.7707 12.6334 5.31275 12.6019 5.28888L12.4098 5.1771L12.2861 5.35616C12.132 5.59707 12.0138 5.86945 11.9465 6.14726C11.8162 6.68551 11.8966 7.19229 12.1689 7.62528C11.8412 7.81084 11.3095 7.85425 11.1977 7.86076H2.4153C2.18632 7.86076 2.00076 8.04633 2.00076 8.2753C1.98882 9.04253 2.11796 9.80867 2.38383 10.5325C2.68659 11.3236 3.13803 11.9118 3.71969 12.2699C4.37514 12.6714 5.44513 12.9004 6.65077 12.9004C7.19445 12.9004 7.73921 12.8504 8.27746 12.7517C9.02624 12.616 9.74355 12.3556 10.4044 11.979C10.9492 11.6632 11.4375 11.2617 11.8521 10.7918C12.5509 10.0062 12.9655 9.12826 13.2682 8.3491C13.3116 8.3491 13.3485 8.3491 13.3919 8.3491C14.1527 8.3491 14.6225 8.04633 14.8819 7.78589C15.0555 7.62528 15.1847 7.42669 15.278 7.20423L15.3333 7.04362L15.2064 6.95138ZM9.77068 7.60683H10.9459C11.0013 7.60683 11.0512 7.56342 11.0512 7.50157V6.45002C11.0512 6.39468 11.0078 6.34476 10.9459 6.34476H9.77068C9.71533 6.34476 9.66542 6.38817 9.66542 6.45002V7.50157C9.67193 7.56342 9.71533 7.60683 9.77068 7.60683ZM8.13205 4.59544H9.3073C9.36265 4.59544 9.41257 4.55204 9.41257 4.49018V3.43864C9.41257 3.38329 9.36265 3.33337 9.3073 3.33337H8.13205C8.07671 3.33337 8.02679 3.37678 8.02679 3.43864V4.49018C8.02679 4.54552 8.07562 4.59544 8.13205 4.59544ZM8.13205 6.10385H9.3073C9.36265 6.10385 9.41257 6.05393 9.41257 5.99859V4.94704C9.41257 4.8917 9.36265 4.84178 9.3073 4.84178H8.13205C8.07671 4.84178 8.02679 4.88519 8.02679 4.94704V5.99859C8.02679 6.05502 8.07562 6.10385 8.13205 6.10385ZM6.50536 6.10385H7.68061C7.73596 6.10385 7.78588 6.05393 7.78588 5.99859V4.94704C7.78588 4.8917 7.74247 4.84178 7.68061 4.84178H6.50536C6.45001 4.84178 6.40009 4.88519 6.40009 4.94704V5.99859C6.40009 6.05502 6.4435 6.10385 6.50536 6.10385ZM4.85371 6.10385H6.02896C6.08431 6.10385 6.13423 6.05393 6.13423 5.99859V4.94704C6.13423 4.8917 6.09082 4.84178 6.02896 4.84178H4.85371C4.79836 4.84178 4.74844 4.88519 4.74844 4.94704V5.99859C4.75496 6.05502 4.79836 6.10385 4.85371 6.10385ZM8.13205 7.60683H9.3073C9.36265 7.60683 9.41257 7.56342 9.41257 7.50157V6.45002C9.41257 6.39468 9.36916 6.34476 9.3073 6.34476H8.13205C8.07671 6.34476 8.02679 6.38817 8.02679 6.45002V7.50157C8.02679 7.56342 8.07562 7.60683 8.13205 7.60683ZM6.50536 7.60683H7.68061C7.73596 7.60683 7.78588 7.56342 7.78588 7.50157V6.45002C7.78588 6.39468 7.74247 6.34476 7.68061 6.34476H6.50536C6.45001 6.34476 6.40009 6.38817 6.40009 6.45002V7.50157C6.40009 7.56342 6.4435 7.60683 6.50536 7.60683ZM4.85371 7.60683H6.02896C6.08431 7.60683 6.13423 7.56342 6.13423 7.50157V6.45002C6.13423 6.39468 6.09082 6.34476 6.02896 6.34476H4.85371C4.79836 6.34476 4.74844 6.38817 4.74844 6.45002V7.50157C4.75496 7.56342 4.79836 7.60683 4.85371 7.60683ZM3.23353 7.60683H4.40878C4.46413 7.60683 4.51404 7.56342 4.51404 7.50157V6.45002C4.51404 6.39468 4.47064 6.34476 4.40878 6.34476H3.23353C3.17818 6.34476 3.12826 6.38817 3.12826 6.45002V7.50157C3.13478 7.56342 3.17818 7.60683 3.23353 7.60683Z",
		fill: "#0091E2"
	})
}), lE = () => {
	let { selectedEnvironmentIndex: e, handleEnvironmentChange: t, filteredEnvironmentList: n, resourceId: r } = GT(), i = n.map((e) => ({
		label: e.metadata.environmentName,
		value: e.index
	})), a = i.find((t) => t.value === e);
	return n.length ? /* @__PURE__ */ (0, Q.jsx)(V, {
		inputId: HT,
		options: i,
		placeholder: "Select environment",
		hideSelectedOptions: !0,
		onChange: (e) => {
			t(e.value);
		},
		value: a,
		variant: Hl.COMPACT
	}) : /* @__PURE__ */ (0, Q.jsx)(Wf, {
		to: `${mu.APPLICATION_MANAGEMENT_APP}/${r}/edit`,
		className: "anchor cursor",
		children: /* @__PURE__ */ (0, Q.jsx)(ft, {
			content: "Configure environments for the application",
			className: "default-tt",
			placement: "auto",
			arrow: !1,
			children: /* @__PURE__ */ (0, Q.jsx)("span", { children: "Configure" })
		})
	});
}, uE = ({ dependency: e, isCurrentApp: t }) => {
	let { lastDeployedClassName: n, isLastDeployedExpanded: r, showAppStatus: i, filteredEnvironmentList: a, toggleUpdateModalOpen: o } = GT(), s = t ? "dependencies-row__current-app" : "";
	return /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: `dependencies-row ${n} ${s}`,
		children: [
			/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "dc__position-rel flexbox",
				children: [/* @__PURE__ */ (0, Q.jsx)(QT, {}), t && /* @__PURE__ */ (0, Q.jsx)("div", {
					className: "dc__align-reload-center flexbox",
					children: /* @__PURE__ */ (0, Q.jsx)($T, {})
				})]
			}),
			i && /* @__PURE__ */ (0, Q.jsx)(po, {
				status: e.metadata.lastDeployed ? e.metadata.appStatus : Zl.NOT_DEPLOYED,
				isVirtualEnv: e.metadata.isVirtualEnvironment,
				hideMessage: !0
			}),
			/* @__PURE__ */ (0, Q.jsx)(Wf, {
				to: `${mu.APPLICATION_MANAGEMENT_APP}/${e.metadata.appId}/details/${e.metadata.environmentId === -1 || e.metadata.environmentId === void 0 ? "" : `${e.metadata.environmentId}/`}`,
				className: `anchor fs-13 dc__ellipsis-right ${t ? "cn-9 fw-6" : ""}`,
				children: e.metadata.appName
			}),
			/* @__PURE__ */ (0, Q.jsx)("div", {
				className: "fs-13 dc__ellipsis-right",
				children: t ? /* @__PURE__ */ (0, Q.jsx)(lE, {}) : a.length ? e.metadata.environmentName ? e.metadata.environmentName : e.typeOfDependency === BT.UPSTREAM ? /* @__PURE__ */ (0, Q.jsx)("span", {
					className: "fs-13 lh-20 fw-4 cb-5 cursor",
					onClick: o,
					children: "Map Environment"
				}) : /* @__PURE__ */ (0, Q.jsxs)(Wf, {
					to: `${mu.APPLICATION_MANAGEMENT_APP}/${e.metadata.appId}/overview?tab=dependencies`,
					className: "anchor cursor flexbox flex-align-center dc__gap-4",
					children: ["Map Environment", /* @__PURE__ */ (0, Q.jsx)(aa, { className: "icon-dim-14 mw-14 scb-5" })]
				}) : "-"
			}),
			e.metadata.lastDeployedImage ? /* @__PURE__ */ (0, Q.jsx)("div", {
				className: "cn-7 fs-14 flexbox",
				children: /* @__PURE__ */ (0, Q.jsx)(ft, {
					content: e.metadata.lastDeployedImage,
					className: "default-tt",
					placement: "auto",
					arrow: !1,
					children: /* @__PURE__ */ (0, Q.jsxs)("div", {
						className: `dependencies-row__last-deployed-cell bcn-1 br-6 pl-6 pr-6 ${n}`,
						children: [/* @__PURE__ */ (0, Q.jsx)(cE, { className: "icon-dim-16" }), r ? /* @__PURE__ */ (0, Q.jsx)("div", {
							className: "mono dc__ellipsis-left direction-left",
							children: e.metadata.lastDeployedImage
						}) : /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsx)("div", { children: "..." }), /* @__PURE__ */ (0, Q.jsx)("div", {
							className: "mono dc__ellipsis-left direction-left text-overflow-clip",
							children: e.metadata.lastDeployedImage.split(":").at(-1)
						})] })]
					})
				})
			}) : e.metadata.lastDeployedImage === void 0 ? "" : /* @__PURE__ */ (0, Q.jsx)(po, { status: Zl.NOT_DEPLOYED }),
			e.metadata.lastDeployed && /* @__PURE__ */ (0, Q.jsxs)("span", {
				className: "fs-13 fw-4 cn-9 dc__ellipsis-right dc__word-break flex left dc__gap-6",
				children: [/* @__PURE__ */ (0, Q.jsxs)("span", {
					className: "flex left dc__gap-8",
					children: [/* @__PURE__ */ (0, Q.jsx)("span", {
						className: "icon-dim-20 mw-20 flex dc__border-radius-50-per dc__uppercase cn-0 fw-4",
						style: { backgroundColor: bd(e.metadata.lastDeployedBy) },
						children: e.metadata.lastDeployedBy[0]
					}), /* @__PURE__ */ (0, Q.jsx)("span", { children: e.metadata.lastDeployedBy })]
				}), /* @__PURE__ */ (0, Q.jsx)(Wf, {
					to: `${mu.APPLICATION_MANAGEMENT_APP}/${e.metadata.appId}/cd-details/${e.metadata.environmentId}/${e.metadata.pipelineId}/${e.metadata.latestCdWorkflowRunnerId ?? ""}`,
					className: "anchor cursor",
					children: of(e.metadata.lastDeployed, i)
				})]
			})
		]
	}, `dep-row-${e.metadata.appId}-${e.metadata.environmentId}-${e.index}`);
}, dE = ({ dependencyList: e, isCurrentApp: t }) => {
	let { selectedEnvironmentIndex: n } = GT();
	return /* @__PURE__ */ (0, Q.jsx)(Q.Fragment, { children: e.map((e) => {
		let r = e.environmentDependencyMap[n] ?? [];
		return r.length ? r.map((n) => /* @__PURE__ */ (0, Q.jsx)(uE, {
			dependency: {
				...n,
				typeOfDependency: e.typeOfDependency,
				metadata: {
					...n.metadata,
					...e.metadata
				}
			},
			isCurrentApp: t
		}, `${n.index}-${n.id}-${n.metadata.environmentId}`)) : /* @__PURE__ */ (0, Q.jsx)(uE, { dependency: {
			...e,
			dependentOnParentIndex: -1,
			metadata: {
				environmentId: -1,
				environmentName: "",
				...e.metadata
			}
		} }, `${e.index}-${e.metadata.appId}`);
	}) });
}, fE = /* @__PURE__ */ t({ default: () => hE }), { DEPENDENCIES_TITLE: pE, DEPENDENCIES_SUB_TITLE: mE } = zT, hE = ({ resourceId: e, isArgoInstalled: t, resourceName: n, resourceType: r, isUpdateModalOpen: i, filteredEnvIds: a, toggleUpdateModalOpen: o, toggleButtonDisabledState: s }) => {
	let [c, l, u, d] = hf(() => qT({
		resourceId: e,
		resourceType: r,
		version: kl.v1
	}), [e]), [f, p] = hf(XT), [m, h] = j(!1), [g, _] = j(!1), [v, y] = j(), b = m ? "last-deployed-expanded" : "", { appDependencies: x = [], appEnvironments: S = [], dependencyMapByDependencyIndex: C = {} } = l ?? {}, w = A(() => a?.split(","), [a]), T = A(() => a ? S.filter((e) => e.metadata?.environmentId && w?.includes(e.metadata.environmentId.toString())).sort((e, t) => e.metadata.environmentName.localeCompare(t.metadata.environmentName)) : S, [S, w]), ee = Ja(w), D = c || g, te = T.find((e) => e.index === v) ?? {}, ne = t && T.length > 0, { upstreamDependencies: re, downstreamDependencies: ie } = A(() => ({
		upstreamDependencies: x.filter((e) => e.typeOfDependency === BT.UPSTREAM),
		downstreamDependencies: x.filter((e) => e.typeOfDependency === BT.DOWNSTREAM)
	}), [l]), ae = T.length && re.length ? VT.MAP_ENVIRONMENT : VT.ADD_DEPENDENCY;
	k(() => {
		T.length && (y((e) => e === void 0 || w !== ee.current ? T[0].index : e), ee.current = w);
	}, [T]), k(() => {
		s(x.length === 0 || D);
	}, [D]);
	let oe = () => {
		h(!m);
	}, se = (e) => {
		_(!0), y(e), setTimeout(() => {
			_(!1);
		}, 500);
	}, ce = () => {
		Mn.event({
			category: "Application Dependency",
			action: "Add Dependency click",
			label: "Add Dependency click"
		}), o();
	};
	return u ? /* @__PURE__ */ (0, Q.jsx)(Sl, { reload: d }) : /* @__PURE__ */ (0, Q.jsx)("div", {
		className: "flex column left",
		children: /* @__PURE__ */ (0, Q.jsxs)(WT, {
			value: {
				lastDeployedClassName: b,
				isLastDeployedExpanded: m,
				showAppStatus: ne,
				selectedEnvironmentIndex: v,
				handleEnvironmentChange: se,
				filteredEnvironmentList: T,
				allEnvironmentList: S,
				resourceId: e,
				appName: n,
				dependencyMapByDependencyIndex: C,
				toggleUpdateModalOpen: o,
				resourceName: n,
				resourceKindConfig: p ?? {},
				reloadDependencyList: d
			},
			children: [x.length > 0 || D ? /* @__PURE__ */ (0, Q.jsxs)("div", {
				className: `dependencies-wrapper ${ne ? "dependencies-wrapper--show-app-status" : ""} w-100`,
				children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
					className: `dependencies-header display-grid dc__align-items-center dc__border-bottom dc__uppercase fs-12 fw-6 cn-7 pr-16 pl-16 ${b}`,
					children: [
						/* @__PURE__ */ (0, Q.jsx)("span", {}),
						ne && /* @__PURE__ */ (0, Q.jsx)(IT, { className: "icon-dim-16" }),
						/* @__PURE__ */ (0, Q.jsx)("span", { children: "Dependent Applications" }),
						/* @__PURE__ */ (0, Q.jsx)("span", { children: "Environment" }),
						/* @__PURE__ */ (0, Q.jsxs)("span", {
							className: `flex left dc__gap-4 ${b}`,
							children: ["Last deployed", /* @__PURE__ */ (0, Q.jsx)("button", {
								type: "button",
								className: "dc__outline-none-imp p-0 dc__transparent flex",
								onClick: oe,
								"aria-label": "Expand last deployment",
								children: /* @__PURE__ */ (0, Q.jsx)(yi, {
									className: "icon-dim-14 scn-5 rotate",
									style: { "--rotateBy": m ? "90deg" : "-90deg" }
								})
							})]
						}),
						/* @__PURE__ */ (0, Q.jsx)("span", { children: "Deployed by" })
					]
				}), /* @__PURE__ */ (0, Q.jsx)("div", {
					className: "dependencies-body show-shimmer-loading",
					id: HT,
					children: D ? RT.map((e) => /* @__PURE__ */ (0, Q.jsxs)("div", {
						className: `dependencies-row ${b}`,
						children: [
							/* @__PURE__ */ (0, Q.jsx)("span", { className: "child child-shimmer-loading" }),
							ne && /* @__PURE__ */ (0, Q.jsx)("div", { className: "child child-shimmer-loading" }),
							/* @__PURE__ */ (0, Q.jsx)("div", { className: "child child-shimmer-loading" }),
							/* @__PURE__ */ (0, Q.jsx)("div", { className: "child child-shimmer-loading" }),
							/* @__PURE__ */ (0, Q.jsx)("div", { className: "child child-shimmer-loading" }),
							/* @__PURE__ */ (0, Q.jsx)("div", { className: "child child-shimmer-loading" })
						]
					}, `${e.appId}-${e.environmentId}`)) : /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [
						/* @__PURE__ */ (0, Q.jsx)(dE, { dependencyList: re }),
						/* @__PURE__ */ (0, Q.jsx)(dE, {
							dependencyList: [{
								...te,
								typeOfDependency: te.typeOfDependency,
								environmentDependencyMap: { [v]: [{
									index: te.index,
									name: te.name,
									id: te.id,
									devtronResourceId: te.devtronResourceId,
									typeOfDependency: te.typeOfDependency,
									metadata: {
										...te.metadata,
										appId: e,
										appName: n
									},
									dependentOnParentIndex: v,
									label: te.name,
									value: te.id
								}] }
							}],
							isCurrentApp: !0
						}),
						/* @__PURE__ */ (0, Q.jsx)(dE, { dependencyList: ie }),
						/* @__PURE__ */ (0, Q.jsx)("div", {
							className: "dependencies-row dependencies-row__info-bar",
							children: /* @__PURE__ */ (0, Q.jsxs)("div", {
								className: "fs-13 lh-20 fw-4 cn-7",
								children: [
									"Downstream dependent applications are populated when ",
									n,
									" is added as an upstream dependency in other applications."
								]
							})
						})
					] })
				})]
			}) : /* @__PURE__ */ (0, Q.jsx)("div", {
				className: "w-100 mh-500 bg__primary flex en-2 bw-1 br-4",
				children: /* @__PURE__ */ (0, Q.jsx)(R, {
					layout: "row",
					title: pE,
					subTitle: mE,
					contentClassName: "empty-state-content",
					SvgImage: LT,
					isButtonAvailable: !0,
					renderButton: () => /* @__PURE__ */ (0, Q.jsxs)("button", {
						type: "button",
						className: "flex flex-align-center cta dc__gap-4 dependencies-wrapper__empty-state-button",
						onClick: ce,
						children: [/* @__PURE__ */ (0, Q.jsx)(E, { className: "icon-dim-12" }), /* @__PURE__ */ (0, Q.jsx)("span", { children: "Add Dependency" })]
					})
				})
			}), i && /* @__PURE__ */ (0, Q.jsx)(sE, {
				mode: ae,
				selectedEnvironmentIndexInList: v,
				isListDataLoading: D || f
			}, `dependency-modal-${v}`)]
		})
	});
}, gE = ({ excludedUserEmails: e, rootClassName: t = "" }) => /* @__PURE__ */ (0, Q.jsx)("div", {
	className: t,
	children: e?.sort((e, t) => e > t ? 1 : -1).map((e) => /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flex left fs-13 mb-8 lh-20",
		children: [Ku(e, "dc__no-shrink"), /* @__PURE__ */ (0, Q.jsx)("span", {
			className: "dc__truncate",
			children: e
		})]
	}))
}), _E = (e) => /* @__PURE__ */ (0, Q.jsx)("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	...e,
	children: /* @__PURE__ */ (0, Q.jsx)("path", {
		d: "M9.50989 2.89918C9.1112 3.01151 8.87905 3.42578 8.99139 3.82447C9.10372 4.22316 9.51798 4.4553 9.91667 4.34297L9.50989 2.89918ZM10.5951 10L10.5946 9.25001C10.1805 9.25031 9.84496 9.5862 9.84513 10.0003C9.8453 10.4145 10.1811 10.7501 10.5952 10.75L10.5951 10ZM0.386205 11.906C0.147982 12.2448 0.22956 12.7126 0.568415 12.9509C0.90727 13.1891 1.37508 13.1075 1.61331 12.7686L0.386205 11.906ZM9.38652 12.7683C9.62477 13.1072 10.0926 13.1887 10.4314 12.9505C10.7703 12.7122 10.8518 12.2444 10.6136 11.9056L9.38652 12.7683ZM14.4813 12.7679C14.7193 13.1069 15.1871 13.1888 15.5261 12.9508C15.8651 12.7128 15.947 12.245 15.709 11.906L14.4813 12.7679ZM8.00002 6.75001C8.00002 8.13072 6.88073 9.25001 5.50002 9.25001V10.75C7.70916 10.75 9.50002 8.95915 9.50002 6.75001H8.00002ZM5.50002 9.25001C4.11931 9.25001 3.00002 8.13072 3.00002 6.75001H1.50002C1.50002 8.95915 3.29088 10.75 5.50002 10.75V9.25001ZM3.00002 6.75001C3.00002 5.3693 4.11931 4.25001 5.50002 4.25001V2.75001C3.29088 2.75001 1.50002 4.54087 1.50002 6.75001H3.00002ZM5.50002 4.25001C6.88073 4.25001 8.00002 5.3693 8.00002 6.75001H9.50002C9.50002 4.54087 7.70916 2.75001 5.50002 2.75001V4.25001ZM9.91667 4.34297C10.2605 4.24608 10.6212 4.22401 10.9743 4.27824L11.202 2.79562C10.637 2.70886 10.06 2.74417 9.50989 2.89918L9.91667 4.34297ZM10.9743 4.27824C11.3274 4.33247 11.6648 4.46174 11.9638 4.65734L12.785 3.40215C12.3067 3.08921 11.7669 2.88239 11.202 2.79562L10.9743 4.27824ZM11.9638 4.65734C12.2627 4.85295 12.5163 5.11035 12.7074 5.4122L13.9747 4.60985C13.669 4.12691 13.2633 3.7151 12.785 3.40215L11.9638 4.65734ZM12.7074 5.4122C12.8985 5.71405 13.0226 6.05334 13.0716 6.40723L14.5574 6.20182C14.4792 5.63563 14.2805 5.09279 13.9747 4.60985L12.7074 5.4122ZM13.0716 6.40723C13.1205 6.76112 13.093 7.12139 12.991 7.46376L14.4285 7.89218C14.5917 7.34441 14.6357 6.76802 14.5574 6.20182L13.0716 6.40723ZM12.991 7.46376C12.8889 7.80614 12.7147 8.12267 12.4801 8.39205L13.6111 9.37735C13.9865 8.94637 14.2652 8.43995 14.4285 7.89218L12.991 7.46376ZM12.4801 8.39205C12.2454 8.66142 11.9557 8.87738 11.6306 9.02538L12.2519 10.3906C12.7722 10.1538 13.2356 9.80832 13.6111 9.37735L12.4801 8.39205ZM11.6306 9.02538C11.3054 9.17337 10.9523 9.24997 10.595 9.25001L10.5952 10.75C11.1668 10.7499 11.7317 10.6274 12.2519 10.3906L11.6306 9.02538ZM1.61331 12.7686C2.05169 12.1451 2.63367 11.6361 3.31011 11.2848L2.61872 9.95365C1.72871 10.4159 0.962991 11.0855 0.386205 11.906L1.61331 12.7686ZM3.31011 11.2848C3.98652 10.9335 4.73778 10.75 5.50005 10.75L5.49999 9.25001C4.49712 9.25005 3.50875 9.49137 2.61872 9.95365L3.31011 11.2848ZM5.50005 10.75C6.26226 10.75 7.01311 10.9333 7.68961 11.2846L8.3809 9.95343C7.49088 9.49125 6.50291 9.24997 5.49999 9.25001L5.50005 10.75ZM7.68961 11.2846C8.36607 11.6359 8.94809 12.1448 9.38652 12.7683L10.6136 11.9056C10.0367 11.0852 9.27094 10.4156 8.3809 9.95343L7.68961 11.2846ZM10.5957 10.75C11.3578 10.7495 12.1089 10.9326 12.7852 11.2838L13.4766 9.95262C12.5863 9.49029 11.5977 9.24929 10.5946 9.25001L10.5957 10.75ZM12.7852 11.2838C13.4616 11.6351 14.0434 12.1441 14.4813 12.7679L15.709 11.906C15.1326 11.085 14.3668 10.415 13.4766 9.95262L12.7852 11.2838Z",
		fill: "#596168"
	})
}), vE = (e, t) => e?.length ? e.includes(t) ? e.length - 1 : e.length : 0, yE = (e, t) => `/dashboard${mu.APPLICATION_MANAGEMENT_APP}/${e}/overview?tab=about&envId=${t}`, bE = ({ excludedUserEmails: e, userActionState: t, withoutTippy: n, currentUserEmail: r, isUserExcludedInProfile: i }) => {
	let a = vE(e, r) === 0, o = vE(e, r), s = /* @__PURE__ */ (0, Q.jsx)(gE, {
		excludedUserEmails: e,
		userActionState: t,
		rootClassName: "p-12 mxh-350 dc__overflow-auto"
	}), c = () => /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flex left",
		children: [/* @__PURE__ */ (0, Q.jsx)(_E, { className: "icon-dim-20 mr-8 fcv-5" }), "Users allowed to take action"]
	}), l = (e) => /* @__PURE__ */ (0, Q.jsx)(su, {
		theme: cu.white,
		className: "w-300",
		placement: "bottom",
		showCloseButton: !0,
		trigger: "click",
		interactive: !0,
		heading: c(),
		additionalContent: s,
		children: /* @__PURE__ */ (0, Q.jsx)("div", {
			onClick: uf,
			children: e
		})
	});
	return /* @__PURE__ */ (0, Q.jsx)(es, {
		condition: !n && !a,
		wrap: (e) => l(e),
		children: /* @__PURE__ */ (0, Q.jsx)("div", {
			className: `${a || n ? "" : "cb-5 cursor"} ${i ? "ml-4" : ""} mr-4`,
			children: (() => {
				let e = "";
				return i ? o >= 1 && (e += ` ${o} other ${o > 1 ? "users" : "user"}`) : o > 0 ? e += `${o} ${o === 1 ? "user" : "users"}` : a && (e = "No user"), e;
			})()
		})
	});
}, xE = /* @__PURE__ */ t({ default: () => SE }), SE = ({ excludedUserEmails: e, hideUserIcon: t, windowType: n, rootClassName: r = "", iconClass: i = "", withoutTippy: a }) => {
	let { email: o } = Ff(), s = e.includes(o), c = vE(e, o);
	return /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: `flex left ${r}`,
		children: [!t && /* @__PURE__ */ (0, Q.jsx)(_E, { className: `icon-dim-16 mr-8 ${n === ms.BLACKOUT ? "fcy-7" : n === ms.MAINTENANCE ? "fcg-5" : ""} ${i}` }), /* @__PURE__ */ (0, Q.jsx)("div", {
			className: "flex left",
			children: /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [
				s ? "You" : "",
				s && c > 0 && " and ",
				/* @__PURE__ */ (0, Q.jsx)(bE, {
					excludedUserEmails: e,
					userActionState: Ya.ALLOWED,
					currentUserEmail: o,
					isUserExcludedInProfile: s,
					withoutTippy: a
				}),
				!s && c === 0 ? " is " : " are ",
				"allowed to take action"
			] })
		})]
	});
}, CE = (e) => /* @__PURE__ */ (0, Q.jsxs)("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [/* @__PURE__ */ (0, Q.jsx)("path", {
		d: "M3 10.4167C3 7.21907 3 5.62028 3.37752 5.08241C3.75503 4.54454 5.25832 4.02996 8.26491 3.00079L8.83772 2.80472C10.405 2.26824 11.1886 2 12 2C12.8114 2 13.595 2.26824 15.1623 2.80472L15.7351 3.00079C18.7417 4.02996 20.245 4.54454 20.6225 5.08241C21 5.62028 21 7.21907 21 10.4167V11.9914C21 17.6294 16.761 20.3655 14.1014 21.5273C13.38 21.8424 13.0193 22 12 22C10.9807 22 10.62 21.8424 9.89856 21.5273C7.23896 20.3655 3 17.6294 3 11.9914V10.4167Z",
		fill: "#F33E3E"
	}), /* @__PURE__ */ (0, Q.jsx)("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12.9 7.5499C12.9 7.05285 12.4971 6.6499 12 6.6499C11.503 6.6499 11.1 7.05285 11.1 7.5499V12.3499C11.1 12.8469 11.503 13.2499 12 13.2499C12.4971 13.2499 12.9 12.8469 12.9 12.3499V7.5499ZM13.2 15.9499C13.2 16.6127 12.6628 17.1499 12 17.1499C11.3373 17.1499 10.8 16.6127 10.8 15.9499C10.8 15.2871 11.3373 14.7499 12 14.7499C12.6628 14.7499 13.2 15.2871 13.2 15.9499Z",
		fill: "white"
	})]
}), wE = (e) => /* @__PURE__ */ (0, Q.jsx)("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...e,
	children: /* @__PURE__ */ (0, Q.jsxs)("g", {
		fill: "none",
		fillRule: "evenodd",
		children: [/* @__PURE__ */ (0, Q.jsx)("path", { d: "M0 0h24v24H0z" }), /* @__PURE__ */ (0, Q.jsx)("path", {
			fill: "#000",
			fillRule: "nonzero",
			d: "M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6z"
		})]
	})
}), TE = ({ deploymentWindowProfile: e, key: t, isActive: n }) => {
	let r = e.type === ms.BLACKOUT;
	return /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: `confirmation-window-card-wrapper p-16 cn-9 ${e.type === ms.BLACKOUT ? " ey-2 confirmation-blackout" : "eg-2 confirmation-maintenance"} br-4 bw-1`,
		"data-testId": "confirmation-window-card",
		children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flex dc__content-space top pb-16 dc__gap-12",
			children: [/* @__PURE__ */ (0, Q.jsxs)("div", { children: [
				/* @__PURE__ */ (0, Q.jsxs)("div", {
					className: `${r ? "cy-7" : "cg-5"} fw-6`,
					children: [
						n ? "ACTIVE " : "NEXT ",
						r ? ms.BLACKOUT : ms.MAINTENANCE,
						"\xA0WINDOW"
					]
				}),
				/* @__PURE__ */ (0, Q.jsx)("div", {
					className: "fw-6 mt-8 fs-13 dc__truncate",
					"data-testId": "window-name",
					children: e.name
				}),
				/* @__PURE__ */ (0, Q.jsx)("div", {
					className: "fs-12 dc__truncate",
					"data-testId": "window-description",
					children: e.description
				})
			] }), r ? /* @__PURE__ */ (0, Q.jsx)(se, { className: "dc__align-start icon-dim-40" }) : /* @__PURE__ */ (0, Q.jsx)(je, { className: "dc__align-start icon-dim-40" })]
		}), e.deploymentWindowList.map((t, r) => /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "window-card-wrapper fs-12",
			"data-testId": `window-${r}`,
			children: [/* @__PURE__ */ (0, Q.jsx)("div", { className: `br-4 mw-4 fw-6 ${e.type === ms.BLACKOUT ? "bcy-5" : "bcg-5"}` }), /* @__PURE__ */ (0, Q.jsxs)("div", { children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "cn-7 ln-16",
				children: [
					" ",
					n ? "Active" : "Next",
					" Window "
				]
			}), /* @__PURE__ */ (0, Q.jsx)(_e, {
				deploymentWindow: t,
				timeZone: e.timeZone
			})] })]
		}, e.id))]
	}, t);
}, EE = ({ profiles: e, className: t }) => {
	let [n, r] = j(1), i = (t) => {
		t > e.length ? r(1) : r(t < 1 ? e.length : t);
	};
	return /* @__PURE__ */ (0, Q.jsxs)("div", {
		onClick: uf,
		className: `deployment-carousel__wrapper deployment-carousel-container ${t || ""}`,
		"data-testId": "deployment-carousel",
		children: [e.map((e, t) => /* @__PURE__ */ (0, Q.jsx)("div", {
			className: `carousel-slide pb-12 ${t === n - 1 ? "active-slide" : ""}`,
			children: /* @__PURE__ */ (0, Q.jsx)(TE, {
				deploymentWindowProfile: e.deploymentWindowProfile,
				isActive: e.isActive
			}, e.deploymentWindowProfile.id)
		}, `carousel-slide-${e.deploymentWindowProfile.name}`)), e.length > 1 && /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "carousel-slide__action-buttons flex dc__content-space bg__primary",
			children: [/* @__PURE__ */ (0, Q.jsxs)("span", {
				className: "fw-6",
				children: [e.length > 1 && e.length, " Active"]
			}), /* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flex right",
				children: [
					/* @__PURE__ */ (0, Q.jsx)(wE, {
						className: "icon-dim-20 action-prev__icon carousel-slide__action flex cursor",
						style: { transform: "rotate(90deg)" },
						onClick: () => {
							i(n - 1);
						}
					}),
					/* @__PURE__ */ (0, Q.jsx)("div", { className: "carousel-slide__slide-count ml-4 mr-4" }),
					/* @__PURE__ */ (0, Q.jsx)(wE, {
						className: "icon-dim-20 action-prev__icon carousel-slide__action flex cursor",
						style: { transform: "rotate(-90deg)" },
						onClick: () => {
							i(n + 1);
						}
					})
				]
			})]
		})]
	});
}, DE = ({ environmentState: e, calculatedTimestamp: t, environmentProfileDetails: n, envId: r, isActive: i }) => {
	let [a, o] = j(!1), s = n[r].blackoutWindows.filter((e) => e.isActive), c = s?.length > 0 ? [] : n[r].maintenanceWindows.filter((e) => !e.isActive), l = [...s, ...c];
	return l?.length ? /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: `${a ? "restriction-card__expanded" : "restriction-card__wrapper"} ${e.userActionState === Ya.BLOCKED && !a ? "h-48" : ""} ${l.length > 1 && a ? "restriction-card__multiple-carousel-cards " : ""} br-4 fs-13 lh-20 cursor`,
		onClick: (e) => {
			e.stopPropagation(), o(!a);
		},
		children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flex dc__content-space top p-12",
			children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flex left",
				children: [/* @__PURE__ */ (0, Q.jsx)(CE, {}), /* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "ml-12",
					children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
						className: "fw-6 flex left",
						children: ["Restriction\xA0", /* @__PURE__ */ (0, Q.jsx)(vT, {
							endTime: t,
							showClockIcon: !1,
							reloadAfterTimeEnd: !0,
							rootClassName: "fs-13 dc__lowercase",
							isActive: e.appliedProfile.deploymentWindowProfile.type === ms.MAINTENANCE ? !i : i
						})]
					}), e.userActionState === Ya.PARTIAL && e.excludedUserEmails.length > 0 && /* @__PURE__ */ (0, Q.jsx)(SE, {
						excludedUserEmails: e.excludedUserEmails,
						userActionState: e.userActionState
					})]
				})]
			}), /* @__PURE__ */ (0, Q.jsx)(we, { className: `icon-dim-20 rotate cursor ${a ? "dc__flip-180" : ""}` })]
		}), a && /* @__PURE__ */ (0, Q.jsx)(EE, {
			profiles: l,
			className: "restriction-window-card dc__overflow-auto pl-12 pr-12"
		})]
	}) : /* @__PURE__ */ (0, Q.jsx)("div", {
		className: "flex column mt-16 dc__align-center h-200 bg__secondary br-4",
		children: /* @__PURE__ */ (0, Q.jsx)("div", {
			className: "w-100 flex center",
			children: /* @__PURE__ */ (0, Q.jsx)("span", {
				className: "w-300",
				children: "No window active"
			})
		})
	});
}, OE = (e) => /* @__PURE__ */ (0, Q.jsx)("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ (0, Q.jsx)("g", {
		id: "Icon/ic-hibernate",
		children: /* @__PURE__ */ (0, Q.jsx)("path", {
			id: "Subtract",
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M11 7.1162C10.2498 7.73283 9.28938 8.10303 8.24249 8.10303C5.84255 8.10303 3.89702 6.1575 3.89702 3.75755C3.89702 2.71064 4.26723 1.7502 4.88389 1.00001C2.656 1.53391 1 3.53871 1 5.93029C1 8.73022 3.26979 11 6.06972 11C8.46128 11 10.4661 9.34405 11 7.1162Z",
			fill: "#3B444C"
		})
	})
}), kE = (e) => /* @__PURE__ */ (0, Q.jsx)("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ (0, Q.jsx)("g", {
		id: "Icon/ic-unhibernate",
		children: /* @__PURE__ */ (0, Q.jsx)("path", {
			id: "Vector",
			d: "M6 1.4V1M2.74731 2.74731L2.46447 2.46447M1.4 6H1M2.74731 9.25269L2.46447 9.53553M6 10.6V11M9.25269 9.25269L9.53553 9.53553M10.6 6H11M9.25269 2.74731L9.53553 2.46447M9 6C9 7.65685 7.65685 9 6 9C4.34315 9 3 7.65685 3 6C3 4.34315 4.34315 3 6 3C7.65685 3 9 4.34315 9 6Z",
			stroke: "#3B444C",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	})
}), AE = ({ type: e }) => {
	switch (e) {
		case Fc.HIBERNATE: return /* @__PURE__ */ (0, Q.jsx)(OE, { className: "icon-dim-16  scn-0 mr-8" });
		case Fc.UNHIBERNATE: return /* @__PURE__ */ (0, Q.jsx)(kE, { className: "icon-dim-16 scn-0 mr-8" });
		case Fc.RESTART: return /* @__PURE__ */ (0, Q.jsx)(dn, { className: "icon-dim-16 dc__no-svg-fill scn-0 mr-8" });
		case Fc.DEPLOY: return /* @__PURE__ */ (0, Q.jsx)(Yi, { className: "icon-dim-16 dc__no-svg-fill scn-0 mr-8" });
		case Fc.PIPELINE:
		case Fc.RESOURCE: return /* @__PURE__ */ (0, Q.jsx)(Be, { className: "icon-dim-16 dc__no-svg-fill mr-8" });
		default: return null;
	}
}, jE = /* @__PURE__ */ t({ default: () => ME }), ME = ({ onClose: e, isLoading: t = !1, type: n, onClickActionButton: r, appName: i, envName: a, strategyName: o, appId: s, envId: c, resourceName: l, forceDelete: u, apiCallInProgress: d, forceDeleteHandler: f }) => {
	let { environmentProfileDetails: p, environmentStateMap: m, appliedProfile: h, loading: g } = Se({
		appId: s,
		envId: c
	}), [_, v] = j(!0), [y, b] = j(!1);
	return /* @__PURE__ */ (0, Q.jsx)(Su, {
		className: "app-status__material-modal",
		children: /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "deployment-window-confirmation modal__body br-8 bg__primary p-0 mt-40 w-500",
			children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flex dc__content-space pt-16 pb-16 pl-20 pr-20 dc__border-bottom-n1",
				children: [
					y && /* @__PURE__ */ (0, Q.jsx)(Vr, {
						className: "icon-dim-20 cursor",
						onClick: () => {
							b(!y);
						}
					}),
					/* @__PURE__ */ (0, Q.jsxs)("h2", {
						className: "fs-16 cn-9 fw-6 m-0",
						children: [ct[n], " is blocked"]
					}),
					/* @__PURE__ */ (0, Q.jsx)(M, {
						dataTestId: "close-window-confirmation",
						onClick: e,
						icon: /* @__PURE__ */ (0, Q.jsx)(z, {
							name: "ic-close-large",
							color: null
						}),
						size: I.xxs,
						ariaLabel: "close deployment window confirmation",
						showAriaLabelInTippy: !1,
						style: P.negativeGrey,
						variant: F.borderLess
					})
				]
			}), t || g ? /* @__PURE__ */ (0, Q.jsx)("div", {
				className: "flex mh-250",
				children: /* @__PURE__ */ (0, Q.jsx)(ul, { pageLoader: !0 })
			}) : !m[c] || m[c].userActionState === Ya.ALLOWED ? /* @__PURE__ */ (0, Q.jsx)(lc, { reload: () => window.location.reload() }) : /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "deployment-window__confirmation-body p-16 dc__overflow-auto mxh-350 mh-250",
				children: [
					/* @__PURE__ */ (0, Q.jsx)(DE, {
						environmentState: m[c],
						calculatedTimestamp: h.calculatedTimestamp,
						environmentProfileDetails: p,
						envId: c,
						isActive: h.isActive
					}),
					m[c].userActionState === Ya.BLOCKED && /* @__PURE__ */ (0, Q.jsx)(SE, {
						excludedUserEmails: m[c].excludedUserEmails,
						rootClassName: "fs-13 fw-6 mt-16 mb-12",
						iconClass: "icon-dim-20",
						withoutTippy: !0
					}),
					m[c].userActionState === Ya.BLOCKED ? m[c].excludedUserEmails.length ? /* @__PURE__ */ (0, Q.jsx)(gE, {
						excludedUserEmails: m[c].excludedUserEmails || [],
						userActionState: m[c].userActionState
					}) : /* @__PURE__ */ (0, Q.jsxs)("div", {
						className: "flex column mt-16 dc__align-center h-200 bg__secondary br-4 fs-13",
						children: [
							/* @__PURE__ */ (0, Q.jsx)(at, { className: "icon-dim-24 mb-4" }),
							/* @__PURE__ */ (0, Q.jsx)("div", {
								className: "fw-6 cn-9 mb-8",
								children: "No users are allowed to take action"
							}),
							/* @__PURE__ */ (0, Q.jsx)("div", {
								className: "w-100 flex center",
								children: /* @__PURE__ */ (0, Q.jsx)("span", {
									className: "w-300",
									children: "No users are allowed to take action during the restricted period"
								})
							})
						]
					}) : /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsx)(oi, {
						type: n,
						setActionButtonDisabled: v,
						rootClassName: "mt-16 mb-16"
					}), (() => {
						let e = "";
						return n === Fc.HIBERNATE ? e = `Pods for application '${i}' will be scaled down to 0 on environment '${a}'.` : n === Fc.UNHIBERNATE ? e = `Pods for application '${i}' will be scaled up to its original count on environment '${a}'.` : n === Fc.RESTART ? e = `Pods for selected workloads will be restarted. Configured deployment strategy "${o}" will be used to restart selected workloads.` : n === Fc.RESOURCE ? e = `Deleting the resource ‘${l}’ may impact the active service.` : n === Fc.DEPLOY ? e = `A deployment will be triggered for this application on environment '${a}'.` : n === Fc.PIPELINE && (e = `Deleting the deployment pipeline will delete the service and may impact traffic for application ‘${i}’.`), e ? /* @__PURE__ */ (0, Q.jsx)(xc, { description: e }) : null;
					})()] })
				]
			}), m[c].userActionState === Ya.PARTIAL && /* @__PURE__ */ (0, Q.jsxs)("div", {
				className: `flex ${n === Fc.RESOURCE ? "dc__content-space" : "right"} dc__border-top-n1 p-16`,
				children: [n === Fc.RESOURCE ? /* @__PURE__ */ (0, Q.jsx)(Wo, {
					isChecked: u,
					value: Io.CHECKED,
					disabled: d,
					onChange: f,
					dataTestId: "force-delete-checkbox",
					rootClassName: "fs-13",
					children: "Force delete resource"
				}) : null, /* @__PURE__ */ (0, Q.jsxs)("button", {
					type: "button",
					className: `${_ ? "dc__disabled" : ""} pl-12 cta flex fw-6 fs-13 cn-9 ${n === Fc.PIPELINE || n === Fc.RESOURCE ? "delete" : ""}`,
					onClick: !_ && r,
					"data-testid": "deployment-window-confirmation-dialog-action-button",
					children: [
						/* @__PURE__ */ (0, Q.jsx)(AE, { type: n }),
						n === Fc.PIPELINE || n === Fc.RESOURCE ? "Delete" : "",
						"\xA0",
						Au(n),
						n === Fc.RESTART ? " workloads" : ""
					]
				})]
			})] })]
		})
	});
}, NE = /* @__PURE__ */ t({ default: () => PE }), PE = ({ excludedUserEmails: e, userActionState: t, warningMessage: n }) => /* @__PURE__ */ (0, Q.jsx)(xc, {
	description: /* @__PURE__ */ (0, Q.jsxs)("span", {
		className: "fs-13 cn-9 flex",
		children: [
			n,
			".\xA0",
			/* @__PURE__ */ (0, Q.jsx)(SE, {
				excludedUserEmails: e,
				userActionState: t,
				hideUserIcon: !0
			})
		]
	}),
	variant: "warning",
	borderConfig: {
		top: !1,
		left: !1,
		right: !1
	},
	borderRadiusConfig: {
		top: !1,
		left: !1,
		right: !1,
		bottom: !1
	}
});
//#endregion
//#region src/Components/PullImageDigest/Service.ts
function FE() {
	return G(O.ENVIRONMENT_LIST_MIN);
}
function IE() {
	return G(O.DIGEST_POLICY);
}
function LE(e) {
	return nf(O.DIGEST_POLICY, e);
}
//#endregion
//#region src/Components/DeploymentWindow/DeploymentWindowShimmerRow.tsx
var RE = () => {
	let e = (e) => /* @__PURE__ */ (0, Q.jsx)("div", {
		className: "shimmer-loading h-16 pt-8 pb-8",
		style: { width: e }
	});
	return /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "overview-window-card-row overview-window-card--shimmer-row pt-8 pb-8",
		children: [e("100%"), e("100%")]
	});
}, zE = ({ deploymentWindowProfile: e, type: t, isActive: n, calculatedTimestamp: r, excludedUserEmails: i, rootClassName: a, windowType: o, userActionState: s, key: c }) => {
	let l = e.type === ms.BLACKOUT, u = (n) => e.deploymentWindowList.map((r) => /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: `flexbox fs-12 mb-4 dc__gap-8 ${t === Fc.APP_DETAILS_STATUS || t === Fc.OVERVIEW ? "" : "mr-32"}`,
		"data-testId": "window-card__timestamp",
		children: [/* @__PURE__ */ (0, Q.jsx)("span", {
			className: "flex",
			children: _(r.frequency, l, t)
		}), /* @__PURE__ */ (0, Q.jsx)(_e, {
			deploymentWindow: r,
			timeZone: e.timeZone,
			rootClassName: n || ""
		})]
	}, e.id)), d = () => l ? /* @__PURE__ */ (0, Q.jsx)(se, { className: "icon-dim-32" }) : /* @__PURE__ */ (0, Q.jsx)(je, { className: "icon-dim-32" }), f = () => /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "w-90",
		"data-testId": "window-card__meta-data",
		children: [/* @__PURE__ */ (0, Q.jsx)("div", {
			className: "fw-6 fs-13 lh-20",
			children: e.name
		}), /* @__PURE__ */ (0, Q.jsx)("div", {
			className: "fs-12",
			children: e.description
		})]
	});
	return /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "window-card-wrapper cn-9 mb-8",
		"data-testId": "window-info-card-wrapper",
		children: [/* @__PURE__ */ (0, Q.jsx)("div", { className: `br-4 mw-4 fw-6 ${e.type === ms.BLACKOUT ? "bcy-5" : "bcg-5"}` }), /* @__PURE__ */ (0, Q.jsx)("div", {
			"data-testId": "window-card__info",
			className: `window-card__info br-4 p-12 bw-1 w-100 ${e.type === ms.BLACKOUT ? "bcy-1 ey-2" : "bcg-1 eg-2 "} `,
			children: t === Fc.OVERVIEW ? /* @__PURE__ */ (0, Q.jsxs)("div", {
				"data-testId": "window-card__overview",
				children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "flex top dc__content-space pb-12",
					children: [f(), d()]
				}), u()]
			}) : /* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "window-card__modal-status lh-18",
				"data-testId": "window-card__modal-status",
				children: [d(), /* @__PURE__ */ (0, Q.jsxs)("div", { children: [
					/* @__PURE__ */ (0, Q.jsxs)("div", {
						className: "flex top dc__content-space",
						children: [f(), /* @__PURE__ */ (0, Q.jsx)("div", { children: t === Fc.APP_DETAILS_STATUS && /* @__PURE__ */ (0, Q.jsxs)("div", {
							className: `flex right dc__align-items-center fw-6 min-w-200 ${n ? "cg-5" : "cn-9"}`,
							"data-testId": "window-care__timer",
							children: [n ? /* @__PURE__ */ (0, Q.jsx)("div", { className: "dc__bullet icon-dim-8-imp mr-6 bcg-5" }) : /* @__PURE__ */ (0, Q.jsx)(Ue, { className: "mr-6" }), /* @__PURE__ */ (0, Q.jsx)(vT, {
								endTime: r,
								showClockIcon: !1,
								reloadAfterTimeEnd: !0,
								isActive: n
							})]
						}) })]
					}),
					/* @__PURE__ */ (0, Q.jsx)("div", { className: "h-1 bg__primary mt-12 mb-12" }),
					/* @__PURE__ */ (0, Q.jsxs)("div", {
						className: `${a} dc__gap-4`,
						children: [u("fs-13-imp"), /* @__PURE__ */ (0, Q.jsx)(SE, {
							excludedUserEmails: i,
							windowType: o,
							userActionState: s,
							rootClassName: "fs-13-imp"
						})]
					})
				] })]
			})
		})]
	}, c);
}, BE = /* @__PURE__ */ t({ default: () => VE }), VE = ({ appId: e, filteredEnvIds: t }) => {
	let { loading: n, environmentProfileDetails: r, reloadData: i } = Se({
		appId: e,
		modalType: Fc.OVERVIEW,
		filteredEnvIds: t
	}), [a, o] = j(!0), [s, c] = j({}), { searchParams: l } = jf(), u = X(), d = !Object.keys(r).length, f = () => {
		FE().then((e) => {
			let t = {};
			e.result.forEach((e) => {
				t[e.id] = e.environment_name;
			}), c(t);
		}).catch((e) => {
			K(e);
		}).finally(() => {
			o(!1);
		});
	};
	k(() => {
		f();
	}, []);
	let p = (e) => {
		let t = {
			...l,
			envId: e
		};
		e === l.envId && delete t.envId, u({ search: new URLSearchParams(t).toString() });
	}, h = () => /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "p-12 fs-13 fw-4 lh-20",
		children: [/* @__PURE__ */ (0, Q.jsx)("span", { children: "Deployment windows enforce durations during which deployments are:" }), /* @__PURE__ */ (0, Q.jsxs)("ol", {
			className: "dc__list-style-disc m-0 pl-20",
			children: [/* @__PURE__ */ (0, Q.jsx)("li", { children: "Blocked (Blackout window)" }), /* @__PURE__ */ (0, Q.jsx)("li", { children: "Allowed (Maintenance window)" })]
		})]
	}), g = () => /* @__PURE__ */ (0, Q.jsx)(su, {
		theme: cu.white,
		className: "w-300",
		placement: "bottom",
		Icon: jt,
		iconClass: "fcv-5",
		heading: "Deployment Window",
		additionalContent: h(),
		showCloseButton: !0,
		trigger: "click",
		interactive: !0,
		children: /* @__PURE__ */ (0, Q.jsx)("div", {
			"data-testid": "deployment-window-help-tippy",
			className: "flex ml-8",
			children: /* @__PURE__ */ (0, Q.jsx)(m, { className: "icon-dim-20 cursor" })
		})
	}), _ = () => /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "overview-window-card-row dc__border-bottom-n1 pt-8 pb-8 cn-7",
		children: [
			/* @__PURE__ */ (0, Q.jsx)("div", {
				className: "fs-12 fw-6 w-200",
				children: "ENVIRONMENT"
			}),
			/* @__PURE__ */ (0, Q.jsx)("div", {
				className: "fs-12 fw-6",
				children: "DEPLOYMENT WINDOWS"
			}),
			/* @__PURE__ */ (0, Q.jsx)("div", {})
		]
	}), v = (e) => e.map((e) => /* @__PURE__ */ (0, Q.jsx)("div", {
		className: "window-card-column",
		children: /* @__PURE__ */ (0, Q.jsx)(zE, {
			deploymentWindowProfile: e.deploymentWindowProfile,
			type: Fc.OVERVIEW,
			reloadData: i
		})
	}, e.deploymentWindowProfile.id)), y = (e) => /* @__PURE__ */ (0, Q.jsx)("div", {
		className: "dc__border-dashed lh-20 cursor bc-b50 flex column center dc__align-center p-20 br-4 cn-7 fs-12 mh-98",
		children: /* @__PURE__ */ (0, Q.jsxs)("span", {
			className: "w-200 lh-18",
			children: [
				"No ",
				e,
				" windows are configured for this environment"
			]
		})
	}), b = (e) => /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "overview-window-card",
		children: [/* @__PURE__ */ (0, Q.jsx)("div", {
			className: "ml-12",
			children: r[e].blackoutWindows.length ? v(r[e].blackoutWindows) : y("blackout")
		}), /* @__PURE__ */ (0, Q.jsx)("div", { children: r[e].maintenanceWindows.length ? v(r[e].maintenanceWindows) : y("maintenance") })]
	}), x = (e) => /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "dc__border-left mb-8",
		children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "overview-window-card cn-7 fw-6 mb-12 pt-8",
			children: [/* @__PURE__ */ (0, Q.jsx)("div", {
				className: "ml-12",
				children: "BLACKOUT WINDOW"
			}), /* @__PURE__ */ (0, Q.jsx)("div", { children: "MAINTENANCE WINDOW" })]
		}), b(e)]
	});
	return d ? null : /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "deployment-window-overview pt-16 pl-16 pr-16 pb-8 bg__primary en-2 bw-1 br-4 fs-13 mb-12",
		"data-testId": "deployment-window-overview",
		children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "",
			children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "fs-13 fw-6 flex left mb-8",
				children: ["Deployment Window", g()]
			}), _()]
		}), n || a ? /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [
			/* @__PURE__ */ (0, Q.jsx)(RE, {}),
			/* @__PURE__ */ (0, Q.jsx)(RE, {}),
			/* @__PURE__ */ (0, Q.jsx)(RE, {})
		] }) : Object.keys(r).map((e) => /* @__PURE__ */ (0, Q.jsxs)("div", { children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "overview-window-card-row overview-window-card-row pt-8 pb-8 lh-20 fw-12 cursor dc__gap-20",
			"data-testid": "deployment-window-overview-row",
			onClick: () => p(e),
			children: [
				/* @__PURE__ */ (0, Q.jsx)("div", {
					className: "dc__ellipsis-right w-200 fw-6 dc__align-self-center",
					children: s[e]
				}),
				l.envId === e ? /* @__PURE__ */ (0, Q.jsx)("div", {}) : /* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "flex left",
					children: [
						/* @__PURE__ */ (0, Q.jsxs)("span", { children: [r[e].blackoutWindows.length, " Blackout window "] }),
						/* @__PURE__ */ (0, Q.jsx)("div", { className: "dc__bullet ml-4 dc__bullet--d2 mr-4" }),
						/* @__PURE__ */ (0, Q.jsxs)("span", { children: [r[e].maintenanceWindows.length, " Maintenance window"] })
					]
				}),
				/* @__PURE__ */ (0, Q.jsx)(we, { className: `icon-dim-20 rotate cursor ${l.envId === e ? "dc__flip-180" : ""}` })
			]
		}), l.envId === e && x(e)] }))]
	});
}, HE = ({ type: e, rootClassName: t, id: n }) => {
	let r = e === ms.BLACKOUT;
	return /* @__PURE__ */ (0, Q.jsxs)("div", {
		"data-testid": "deployment-window-card__shadow",
		className: `app-details-info-card app-details-info__shadow-card pointer deployment-window-card__shadow flex left br-8 mr-6 lh-20 mh-95 ${t} ${r ? "bcy-1" : "bcg-1"}`,
		children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "app-details-info-card__top-container flex h-60",
			children: [/* @__PURE__ */ (0, Q.jsx)("div", { className: "app-details-info-card__top-container__content" }), r ? /* @__PURE__ */ (0, Q.jsx)(se, { className: "icon-dim-24" }) : /* @__PURE__ */ (0, Q.jsx)(je, { className: "icon-dim-24" })]
		}), /* @__PURE__ */ (0, Q.jsx)("div", { className: `app-details-info-card__bottom-container ${r ? ms.BLACKOUT.toLowerCase() : ms.MAINTENANCE.toLowerCase()}` })]
	}, n);
}, UE = /* @__PURE__ */ t({ default: () => WE }), WE = ({ cardLoading: e, appId: t, envId: n }) => {
	let { appliedProfile: r, loading: i, reloadData: a, statusCardStack: o } = Se({
		appId: t,
		envId: n
	}), s = !r?.deploymentWindowProfile, c = r?.deploymentWindowProfile.type === ms.BLACKOUT, l = X();
	return r === void 0 || s || Object.keys(r).length === 0 ? null : i || e ? /* @__PURE__ */ (0, Q.jsx)(Nc, {}) : /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "deployment-window-card cn-9 flex left",
		onClick: (e) => {
			e.stopPropagation(), l({ search: ht });
		},
		children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
			"data-testid": "deployment-window-card",
			className: `app-details-info-card app-details-info-card__first-card pointer flex left br-8 lh-20 dc__zi-10 w-200 mh-95 ${c ? "blackout bcy-1" : "maintenance bcg-1"}`,
			children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "app-details-info-card__top-container flex",
				children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "app-details-info-card__top-container__content",
					children: [/* @__PURE__ */ (0, Q.jsx)("div", {
						className: "app-details-info-card__top-container__content__title-wrapper",
						children: /* @__PURE__ */ (0, Q.jsxs)("div", {
							className: "fs-12 fw-4 cn-7 mr-5 dc__capitalize",
							children: [c ? ms.BLACKOUT.toLowerCase() : ms.MAINTENANCE.toLowerCase(), "\xA0Window"]
						})
					}), /* @__PURE__ */ (0, Q.jsx)(ft, {
						className: "default-tt",
						content: r.deploymentWindowProfile.name,
						placement: "top",
						arrow: !1,
						children: /* @__PURE__ */ (0, Q.jsx)("div", {
							className: "fs-12 fw-4 dc__truncate cn-9 fw-6 fs-13 mw-140",
							children: r.deploymentWindowProfile.name
						})
					})]
				}), c ? /* @__PURE__ */ (0, Q.jsx)(se, { className: "icon-dim-24" }) : /* @__PURE__ */ (0, Q.jsx)(je, { className: "icon-dim-24" })]
			}), /* @__PURE__ */ (0, Q.jsxs)("div", {
				className: `app-details-info-card__bottom-container dc__content-space  lh-18 ${c ? "blackout" : "maintenance"}`,
				children: [/* @__PURE__ */ (0, Q.jsx)("span", {
					className: "app-details-info-card__bottom-container__message fs-12 flex left",
					children: /* @__PURE__ */ (0, Q.jsx)("span", {
						className: "fw-6 fw-6 fs-13",
						children: /* @__PURE__ */ (0, Q.jsx)(vT, {
							endTime: r.calculatedTimestamp,
							showClockIcon: !1,
							callbackAfterTimeEnd: a,
							isActive: r.isActive
						})
					})
				}), /* @__PURE__ */ (0, Q.jsx)("div", {
					className: "deployment-window-info-card__bottom-container__details fs-12 fw-6 cb-5",
					children: "Details"
				})]
			})]
		}), o.length > 0 && /* @__PURE__ */ (0, Q.jsx)(Q.Fragment, { children: o.filter((e) => e.name !== r.deploymentWindowProfile.name).map((e, t) => /* @__PURE__ */ (0, Q.jsx)(HE, {
			type: e.type,
			rootClassName: `indexing-window-${t + 1}`,
			id: e.id
		})) })]
	});
}, GE = /* @__PURE__ */ t({ default: () => KE }), KE = ({ appId: e, envId: t }) => {
	let n = Ja(null), r = X(), { environmentProfileDetails: i, loading: a, reloadData: o, environmentStateMap: s } = Se({
		appId: e,
		envId: t
	}), c = () => {
		r({ search: "" }, { replace: !0 });
	}, l = (e) => {
		e.keyCode === 27 && c();
	};
	k(() => (document.addEventListener("keydown", l), () => {
		document.removeEventListener("keydown", l);
	}), []);
	let u = () => /* @__PURE__ */ (0, Q.jsxs)("div", { children: ["View all deployment windows configured for this application.", /* @__PURE__ */ (0, Q.jsx)("a", {
		className: "anchor ml-6",
		href: yE(e, t),
		rel: "noreferrer noopener",
		"data-testId": "overview-link",
		children: "Go to Overview"
	})] }), d = () => /* @__PURE__ */ (0, Q.jsx)(xc, {
		description: u(),
		borderConfig: {
			top: !1,
			left: !1,
			right: !1
		},
		borderRadiusConfig: {
			top: !1,
			left: !1,
			right: !1,
			bottom: !1
		}
	}), f = (e) => /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "dc__uppercase fw-6 fs-13 lh-1-5 cn-9",
		children: [e, " WINDOW"]
	});
	return /* @__PURE__ */ (0, Q.jsx)("div", {
		className: "deployment-window-status-modal bg__primary pt-16 pb-16 pl-20 pr-20 cn-9",
		children: /* @__PURE__ */ (0, Q.jsx)(Rs, {
			position: "right",
			width: "800px",
			children: /* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "h-100 flexbox-col bg__primary",
				"data-testid": "deployment-status-drawer",
				ref: n,
				children: [/* @__PURE__ */ (0, Q.jsx)("div", {
					className: "dc__box-shadow pb-12 pt-12 bg__primary",
					children: /* @__PURE__ */ (0, Q.jsxs)("div", {
						className: "title flex dc__content-space pl-20 pr-20 show-shimmer-loading",
						"data-testid": "app-status-cross",
						children: [/* @__PURE__ */ (0, Q.jsx)("div", { children: /* @__PURE__ */ (0, Q.jsx)("div", {
							className: "cn-9 fs-16 fw-6 flexbox flex-align-center",
							children: "Deployment Window"
						}) }), /* @__PURE__ */ (0, Q.jsx)(M, {
							dataTestId: "deployment-window-modal__close-button",
							onClick: c,
							icon: /* @__PURE__ */ (0, Q.jsx)(z, {
								name: "ic-close-large",
								color: null
							}),
							size: I.xs,
							ariaLabel: "close deployment window confirmation",
							showAriaLabelInTippy: !1,
							style: P.negativeGrey,
							variant: F.borderLess
						})]
					})
				}), /* @__PURE__ */ (0, Q.jsx)("div", {
					className: "bg__primary dc__overflow-auto h-100",
					children: a ? /* @__PURE__ */ (0, Q.jsx)(ul, { pageLoader: !0 }) : /* @__PURE__ */ (0, Q.jsxs)("div", {
						className: "flexbox-col dc__gap-16",
						children: [d(), i[t] && /* @__PURE__ */ (0, Q.jsxs)("div", {
							className: "pl-20 pr-20",
							children: [i[t].blackoutWindows?.length > 0 && /* @__PURE__ */ (0, Q.jsx)("div", {
								className: "window-card-column mb-20",
								children: /* @__PURE__ */ (0, Q.jsxs)("div", { children: [
									f(ms.BLACKOUT),
									/* @__PURE__ */ (0, Q.jsx)("div", {
										className: "cn-7",
										children: "No new deployment related changes can be made to this application during the set period."
									}),
									/* @__PURE__ */ (0, Q.jsx)("div", {
										className: "mt-16",
										children: i[t].blackoutWindows.map((e) => /* @__PURE__ */ (0, Q.jsx)(zE, {
											deploymentWindowProfile: e.deploymentWindowProfile,
											type: Fc.APP_DETAILS_STATUS,
											excludedUserEmails: e.excludedUserEmails,
											calculatedTimestamp: e.calculatedTimestamp,
											isActive: e.isActive,
											reloadData: o,
											rootClassName: "fs-13 lh-1-5",
											windowType: ms.BLACKOUT,
											userActionState: s[t].userActionState
										}, e.deploymentWindowProfile.id))
									})
								] })
							}), i[t].maintenanceWindows?.length > 0 && /* @__PURE__ */ (0, Q.jsxs)("div", {
								className: "window-card-column mb-20",
								children: [
									f(ms.MAINTENANCE),
									/* @__PURE__ */ (0, Q.jsx)("div", {
										className: "cn-7",
										children: "Deployment related changes to this application can be performed only during the set period."
									}),
									/* @__PURE__ */ (0, Q.jsx)("div", {
										className: "mt-16",
										children: i[t].maintenanceWindows.map((e) => /* @__PURE__ */ (0, Q.jsx)(zE, {
											deploymentWindowProfile: e.deploymentWindowProfile,
											type: Fc.APP_DETAILS_STATUS,
											excludedUserEmails: e.excludedUserEmails ?? [],
											isActive: e.isActive,
											calculatedTimestamp: e.calculatedTimestamp,
											reloadData: o,
											rootClassName: "fs-13 lh-1-5",
											windowType: ms.MAINTENANCE,
											userActionState: s[t].userActionState
										}, e.deploymentWindowProfile.id))
									})
								]
							})]
						})]
					})
				})]
			})
		})
	});
}, qE = /* @__PURE__ */ t({ default: () => JE }), JE = ({ windowName: e, endTime: t }) => !t || !e ? null : /* @__PURE__ */ (0, Q.jsx)(xc, {
	description: /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "fs-13 flexbox dc__content-space",
		children: [/* @__PURE__ */ (0, Q.jsxs)("div", { children: [
			/* @__PURE__ */ (0, Q.jsx)("span", { children: "Maintenance window active" }),
			"\xA0",
			/* @__PURE__ */ (0, Q.jsx)("span", {
				className: "fw-6 dc__ellipsis-right cn-9",
				children: e
			})
		] }), /* @__PURE__ */ (0, Q.jsx)(vT, {
			endTime: t,
			reloadAfterTimeEnd: !0,
			isActive: !0
		})]
	}),
	variant: "success",
	borderConfig: {
		top: !1,
		left: !1,
		right: !1
	},
	borderRadiusConfig: {
		top: !1,
		left: !1,
		right: !1,
		bottom: !1
	},
	customIcon: /* @__PURE__ */ (0, Q.jsx)(je, {})
}), YE = (e) => /* @__PURE__ */ (0, Q.jsxs)("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 106,
	height: 28,
	viewBox: "0 0 106 28",
	fill: "none",
	...e,
	children: [/* @__PURE__ */ (0, Q.jsxs)("g", {
		clipPath: "url(#clip0_2228_1260)",
		children: [/* @__PURE__ */ (0, Q.jsx)("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M40.7197 18.5445C41.2465 18.5445 41.6705 18.4377 41.9908 18.2241C42.3112 18.0105 42.5603 17.7435 42.7385 17.423C42.9165 17.1026 43.0339 16.7574 43.091 16.3868C43.1478 16.0167 43.1765 15.6749 43.1765 15.3614C43.1765 15.0484 43.1478 14.7065 43.091 14.336C43.0339 13.9659 42.9165 13.6204 42.7385 13.3C42.5603 12.9795 42.3112 12.7125 41.9908 12.4989C41.6705 12.2852 41.2465 12.1785 40.7197 12.1785C40.1927 12.1785 39.7692 12.2852 39.4487 12.4989C39.1283 12.7125 38.8825 12.9795 38.7117 13.3C38.5408 13.6204 38.4267 13.9659 38.3699 14.336C38.3128 14.7065 38.2844 15.0484 38.2844 15.3614C38.2844 15.6749 38.3128 16.0167 38.3699 16.3868C38.4267 16.7574 38.5408 17.1026 38.7117 17.423C38.8825 17.7435 39.1283 18.0105 39.4487 18.2241C39.7692 18.4377 40.1927 18.5445 40.7197 18.5445ZM43.1765 11.1929V6.34644H45.7187V15.3402C45.7187 16.0808 45.6472 16.7287 45.5049 17.2841C45.3624 17.8396 45.1739 18.3202 44.9389 18.7261C44.7039 19.132 44.4369 19.4668 44.1378 19.7302C43.8388 19.9939 43.5323 20.2108 43.2191 20.3818C42.4785 20.7663 41.6454 20.9656 40.7197 20.9799C39.7654 20.9656 38.9179 20.7663 38.1775 20.3818C37.8642 20.2108 37.5544 19.9939 37.2484 19.7302C36.9419 19.4668 36.6715 19.1356 36.4365 18.7368C36.2015 18.3382 36.0126 17.861 35.8703 17.3055C35.7279 16.7501 35.6567 16.1022 35.6567 15.3614C35.6567 14.6211 35.7242 13.9729 35.8597 13.4175C35.995 12.862 36.1727 12.3814 36.3937 11.9755C36.6145 11.5696 36.8637 11.2315 37.1415 10.9607C37.4191 10.6903 37.7076 10.4693 38.0066 10.2986C38.6903 9.89992 39.4733 9.68633 40.3566 9.65766C40.7979 9.70032 41.2251 9.80718 41.6383 9.97811C41.9941 10.1349 42.3574 10.3733 42.7279 10.6937C42.9746 10.9073 43.1242 11.0737 43.1765 11.1929ZM54.4774 13.9729C54.406 13.7452 54.3171 13.5174 54.2104 13.2894C54.1035 13.0617 53.9574 12.8551 53.7725 12.6699C53.5871 12.4848 53.3666 12.3386 53.1102 12.2319C52.8538 12.1251 52.5547 12.0716 52.213 12.0716C51.8712 12.0716 51.5721 12.1251 51.3157 12.2319C51.0593 12.3386 50.8383 12.4848 50.6534 12.6699C50.4682 12.8551 50.3187 13.0617 50.2049 13.2894C50.0907 13.5174 50.0053 13.7452 49.9485 13.9729H54.4774ZM57.1692 13.9729C57.1975 14.1865 57.2226 14.4075 57.2438 14.6352C57.2652 14.8632 57.2759 15.1052 57.2759 15.3615V15.746H49.7989C49.8273 15.9884 49.863 16.234 49.9058 16.4831C49.9485 16.7324 50.0197 16.9781 50.1194 17.2201C50.2759 17.5906 50.518 17.9181 50.8458 18.2027C51.1732 18.4878 51.6288 18.63 52.213 18.63C52.7967 18.63 53.2524 18.4878 53.5801 18.2027C53.9076 17.9181 54.1496 17.5906 54.3065 17.2201H57.0837C56.9696 17.7187 56.8093 18.153 56.6031 18.5232C56.3964 18.8937 56.1684 19.2141 55.9194 19.4845C55.6701 19.7553 55.403 19.9795 55.1183 20.1574C54.8333 20.3356 54.5555 20.4815 54.2851 20.5954C53.6299 20.8518 52.9392 20.9799 52.213 20.9799C51.2587 20.9656 50.4112 20.7663 49.6708 20.3818C49.3574 20.2109 49.0475 19.9939 48.7415 19.7303C48.435 19.4669 48.1647 19.1357 47.9297 18.7369C47.6947 18.3382 47.5059 17.861 47.3636 17.3056C47.2211 16.7501 47.15 16.1022 47.15 15.3615C47.15 14.6211 47.2211 13.9729 47.3636 13.4175C47.5059 12.8621 47.6947 12.3814 47.9297 11.9755C48.1647 11.5696 48.435 11.2315 48.7415 10.9608C49.0475 10.6904 49.3574 10.4694 49.6708 10.2986C50.4112 9.89995 51.2587 9.68637 52.213 9.65769C52.996 9.68637 53.7297 9.84988 54.4134 10.1489C54.698 10.2772 54.9864 10.4448 55.2785 10.6511C55.5703 10.8577 55.8409 11.1139 56.0903 11.4201C56.3393 11.7266 56.5603 12.0897 56.7526 12.5096C56.9448 12.9299 57.0837 13.4175 57.1692 13.9729ZM61.8899 20.7662H63.6416H65.3934L68.9182 9.93528H66.2906L63.6416 18.0319L60.9927 9.93528H58.3651L61.8899 20.7662ZM72.6779 12.4775V17.2414C72.7205 17.4122 72.7987 17.5692 72.9128 17.7114C73.0123 17.8256 73.1512 17.9324 73.3294 18.0319C73.5073 18.1316 73.7387 18.1814 74.0237 18.1814H75.6472V20.7663H73.041C72.4855 20.7095 71.9869 20.5527 71.5456 20.2963C71.1751 20.0827 70.837 19.7659 70.5309 19.3457C70.2245 18.9257 70.0716 18.3452 70.0716 17.6046V8.46551H72.6779V9.9353H75.1346V12.4775H72.6779ZM77.335 11.356C77.0215 11.7762 76.865 12.3566 76.865 13.097V20.7663H79.4927V13.4601C79.5353 13.2893 79.6135 13.1327 79.7277 12.9901C79.8271 12.8764 79.966 12.7696 80.1442 12.6697C80.3221 12.5702 80.5535 12.5202 80.8385 12.5202H82.8466V9.9353H79.8558C79.3004 9.99236 78.8017 10.1489 78.3604 10.4053C77.9899 10.6189 77.648 10.936 77.335 11.356ZM89.0415 12.1784C88.5145 12.1784 88.0908 12.2853 87.7704 12.4988C87.45 12.7124 87.2043 12.9795 87.0334 13.2999C86.8626 13.6204 86.7483 13.9658 86.6916 14.3361C86.6346 14.7066 86.6062 15.0483 86.6062 15.3615C86.6062 15.675 86.6346 16.0167 86.6916 16.3869C86.7483 16.7574 86.8626 17.1025 87.0334 17.423C87.2043 17.7434 87.45 18.0104 87.7704 18.224C88.0908 18.4377 88.5145 18.5445 89.0415 18.5445C89.5683 18.5445 89.9921 18.4377 90.3126 18.224C90.633 18.0104 90.8788 17.7434 91.0495 17.423C91.2205 17.1025 91.3343 16.7574 91.3914 16.3869C91.4482 16.0167 91.4769 15.675 91.4769 15.3615C91.4769 15.0483 91.4482 14.7066 91.3914 14.3361C91.3343 13.9658 91.2205 13.6204 91.0495 13.2999C90.8788 12.9795 90.633 12.7124 90.3126 12.4988C89.9921 12.2853 89.5683 12.1784 89.0415 12.1784ZM83.9785 15.3615C83.9785 14.6212 84.0496 13.9728 84.1921 13.4174C84.3344 12.862 84.5233 12.3814 84.7583 11.9754C84.9933 11.5695 85.2637 11.2315 85.57 10.9607C85.8762 10.6903 86.1859 10.4694 86.4993 10.2985C87.2397 9.89986 88.0872 9.68627 89.0415 9.6576C89.9815 9.68627 90.8217 9.89986 91.5623 10.2985C91.8754 10.4694 92.1852 10.6903 92.4916 10.9607C92.7977 11.2315 93.0683 11.5695 93.3033 11.9754C93.5383 12.3814 93.7306 12.862 93.8802 13.4174C94.0297 13.9728 94.1045 14.6212 94.1045 15.3615C94.1045 16.1021 94.0297 16.75 93.8802 17.3055C93.7306 17.8609 93.5383 18.3383 93.3033 18.7368C93.0683 19.1357 92.7977 19.4668 92.4916 19.7302C92.1852 19.9938 91.8754 20.2108 91.5623 20.3817C90.8217 20.7662 89.9815 20.9655 89.0415 20.9798C88.0872 20.9655 87.2397 20.7662 86.4993 20.3817C86.1859 20.2108 85.8762 19.9938 85.57 19.7302C85.2637 19.4668 84.9933 19.1357 84.7583 18.7368C84.5233 18.3383 84.3344 17.8609 84.1921 17.3055C84.0496 16.75 83.9785 16.1021 83.9785 15.3615ZM100.609 9.679C100.346 9.66487 100.193 9.6576 100.15 9.6576C100.093 9.6576 99.9365 9.66487 99.6801 9.679C99.4238 9.69327 99.1173 9.75369 98.7616 9.86056C98.4053 9.96742 98.0278 10.135 97.6293 10.3626C97.2304 10.5906 96.8603 10.918 96.5184 11.3453C96.1766 11.7725 95.8953 12.3103 95.6746 12.9582C95.4536 13.6064 95.3435 14.4074 95.3435 15.3615V20.7662H97.9498V15.3615C97.9498 15.0483 97.9782 14.7279 98.0352 14.4001C98.0919 14.0727 98.1987 13.7737 98.3557 13.5029C98.5122 13.2325 98.7328 13.0083 99.0178 12.8299C99.3026 12.652 99.6801 12.5629 100.15 12.5629C100.62 12.5629 100.997 12.652 101.282 12.8299C101.567 13.0083 101.788 13.2325 101.945 13.5029C102.101 13.7737 102.208 14.0727 102.265 14.4001C102.322 14.7279 102.35 15.0483 102.35 15.3615V20.7662H104.957V15.3615C104.957 14.4074 104.846 13.6064 104.626 12.9582C104.405 12.3103 104.124 11.7725 103.782 11.3453C103.44 10.918 103.069 10.5906 102.671 10.3626C102.272 10.135 101.894 9.96742 101.539 9.86056C101.183 9.75369 100.873 9.69327 100.609 9.679Z",
			fill: "#000A14"
		}), /* @__PURE__ */ (0, Q.jsx)("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M5.77232 23.0614L0.824746 15.2722C0.39745 14.6025 0.391465 13.7473 0.808928 13.0714L7.18823 2.74574C7.59906 2.08075 8.32583 1.67718 9.10732 1.67995L18.3169 1.71288C18.3377 1.71288 18.3582 1.71352 18.3785 1.71459C19.2765 1.76076 19.769 2.78849 19.2737 3.5392L12.8822 13.2246C12.642 13.7188 12.0834 14.029 11.4744 13.8896C11.0236 13.7866 10.659 13.4185 10.5583 12.9673C10.4892 12.6576 10.5369 12.3624 10.6643 12.1155C10.6645 12.1151 10.6646 12.1147 10.6647 12.1144C10.6648 12.114 10.6649 12.1137 10.6652 12.1133L10.6667 12.111C10.7047 12.0383 10.7496 11.9697 10.8005 11.9062L11.7737 10.4185C12.0621 9.98946 11.7934 9.40762 11.2797 9.34863L8.94059 9.171C8.50645 9.13786 8.07766 9.28514 7.75532 9.57799C7.33187 10.0733 5.45147 13.1067 4.59303 14.5285C4.316 14.9875 4.34935 15.5606 4.65993 15.9975L4.64925 16.0026L7.62792 20.6804L8.18668 21.5679C8.24482 21.6427 8.29569 21.7233 8.33823 21.8088L8.35918 21.842L8.35768 21.8494C8.46734 22.088 8.51351 22.3618 8.47311 22.6493C8.38825 23.2517 7.90687 23.7508 7.30665 23.851C6.63695 23.963 6.03523 23.6089 5.77232 23.0614ZM22.2781 4.32852L27.2603 12.0957C27.6906 12.7635 27.7004 13.6187 27.2859 14.2963L20.9528 24.6504C20.545 25.3171 19.8199 25.7241 19.0384 25.7247L9.82878 25.7331C9.80805 25.7331 9.78753 25.7326 9.76722 25.7316C8.86903 25.6895 8.37205 24.6639 8.86389 23.911L15.212 14.1969C15.4501 13.7019 16.0072 13.3892 16.6168 13.5257C17.068 13.6269 17.4344 13.9932 17.537 14.444C17.6075 14.7536 17.5611 15.0487 17.4348 15.2965L17.4342 15.2984L17.4325 15.3008C17.3948 15.3739 17.3504 15.4425 17.2995 15.5062L16.3331 16.9984C16.0467 17.4287 16.318 18.0093 16.8318 18.0659L19.1716 18.2333C19.6061 18.2643 20.0341 18.1151 20.3554 17.8209C20.7764 17.3237 22.6432 14.282 23.4952 12.8563C23.7703 12.3961 23.7346 11.8232 23.4219 11.3878L23.4326 11.3824L20.4329 6.71787L19.8703 5.83293C19.8118 5.75833 19.7605 5.67795 19.7175 5.59267L19.6966 5.55975L19.6981 5.55227C19.5873 5.31414 19.5401 5.04054 19.5792 4.75282C19.6611 4.15003 20.1403 3.64899 20.7401 3.54596C21.4094 3.43096 22.0126 3.78238 22.2781 4.32852Z",
			fill: "#0066CC"
		})]
	}), /* @__PURE__ */ (0, Q.jsx)("defs", { children: /* @__PURE__ */ (0, Q.jsx)("clipPath", {
		id: "clip0_2228_1260",
		children: /* @__PURE__ */ (0, Q.jsx)("rect", {
			width: 105,
			height: 28,
			fill: "white",
			transform: "translate(0.5)"
		})
	}) })]
}), XE = "data:image/svg+xml,%3c!--%20-%20Copyright%20(c)%202024.%20Devtron%20Inc.%20--%3e%3csvg%20data-style-override='false'%20width='250'%20height='200'%20viewBox='0%200%20250%20200'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cstyle%3e%20.lock-body%20{%20animation:%20appear%206s%20ease;%20transform-origin:%20center;%20transform-box:%20fill-box;%20}%20@keyframes%20appear%20{%200%25%20{%20transform:%20translateY(50px)%20scale(0.5);%20}%2010%25%20{%20transform:%20translateY(0px)%20scale(1);%20}%20100%25%20{%20transform:%20translateY(0px)%20scale(1);%20}%20}%20.lock-shank%20{%20animation:%20locked%201s%20ease;%20transform-origin:%20right;%20transform-box:%20fill-box;%20}%20@keyframes%20locked%20{%200%25%20{%20transform:%20rotateY(90deg)%20translateY(-10px);%20}%2050%25%20{%20transform:%20rotateY(90deg)%20translateY(-10px);%20}%2070%25%20{%20transform:%20rotateY(0deg)%20translateY(0px);%20}%2080%25%20{%20transform:%20rotateY(0deg)%20translateY(5px);%20}%20100%25%20{%20transform:%20rotateY(0deg)%20translateY(0px);%20}%20}%20%3c/style%3e%3cg%20class='lock-body'%3e%3cpath%20class='lock-shank'%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M148%2082C148%2069.8497%20157.85%2060%20170%2060C182.15%2060%20192%2069.8497%20192%2082V112H184V82C184%2074.268%20177.732%2068%20170%2068C162.268%2068%20156%2074.268%20156%2082V92H148V82Z'%20fill='%23D6D7D8'/%3e%3crect%20x='140'%20y='92'%20width='60'%20height='48'%20fill='url(%23paint0_linear_2729_3841)'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M173.207%20120.072C174.886%20119.008%20176%20117.134%20176%20115C176%20111.686%20173.314%20109%20170%20109C166.686%20109%20164%20111.686%20164%20115C164%20117.134%20165.114%20119.008%20166.793%20120.072L166%20128H174L173.207%20120.072Z'%20fill='%233E3D4C'/%3e%3c/g%3e%3cpath%20d='M65.5601%20191.308C65.5601%20191.192%2066.7131%20188.02%2068.0981%20184.213L70.6361%20177.291L77.0961%20177.118L83.4991%20176.945L86.2671%20179.252C88.5751%20181.214%2099.0631%20186.799%20100.399%20187.559C101.29%20188.065%20102.466%20189.353%20103.925%20191.423C78.3481%20191.385%2065.5601%20191.346%2065.5601%20191.308V191.308Z'%20fill='%2380AEF2'/%3e%3cpath%20d='M32%20191.308C32%20191.192%2033.154%20188.02%2034.538%20184.213L37.076%20177.291L43.536%20177.118L49.939%20176.945L52.708%20179.252C55.015%20181.214%2065.503%20186.799%2066.84%20187.559C67.73%20188.065%2068.906%20189.353%2070.365%20191.423C44.788%20191.385%2032%20191.346%2032%20191.308Z'%20fill='%2394BBF8'/%3e%3cpath%20d='M75.655%20109.836C76.745%20112.994%2077.481%20115.734%2077.863%20118.056C78.243%20120.377%2080.381%20140.211%2084.274%20177.556H66.296C64.852%20174.938%2064.13%20173.099%2064.13%20172.038C64.13%20170.448%2065.043%20168.268%2065.043%20165.97C65.043%20164.438%2063.009%20159.147%2058.939%20150.099L62.87%20110.75L75.655%20109.836V109.836Z'%20fill='%231D225F'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M50.5541%20177.555H33.7601C33.3601%20176.17%2032.9681%20174.301%2032.5851%20171.949C31.8351%20167.161%2032.4051%20163.989%2035.6351%20157.413C38.8651%20150.895%2040.5011%20147.341%2040.5011%20143.649C40.5591%20137.881%2041.7231%20132.333%2044.7811%20126.334C47.1451%20121.604%2048.2761%20121.248%2048.5061%20118.364L48.9261%20112.162H70.0041C70.5161%20113.595%2070.7001%20116.237%2070.5541%20120.087C70.4091%20123.937%2063.7421%20143.093%2050.5531%20177.555H50.5541Z'%20fill='url(%23paint1_linear_2729_3841)'/%3e%3cpath%20d='M95.9399%2050.818L112.78%2029.988H132.971L115.532%2050.818H95.9399Z'%20fill='%2398BDF9'/%3e%3cpath%20d='M118.14%2027.384C119.518%2027.384%20120.646%2028.454%20120.737%2029.809L120.743%2029.988H120.165C120.165%2028.869%20119.258%2027.963%20118.14%2027.963C117.021%2027.963%20116.115%2028.869%20116.115%2029.988C116.115%2031.05%20116.933%2031.922%20117.974%2032.006L118.14%2032.013V32.591C116.702%2032.591%20115.536%2031.426%20115.536%2029.988C115.536%2028.55%20116.702%2027.384%20118.14%2027.384V27.384ZM125.083%2027.384C126.461%2027.384%20127.589%2028.454%20127.681%2029.809L127.687%2029.988H127.108C127.108%2028.869%20126.202%2027.963%20125.083%2027.963C123.965%2027.963%20123.058%2028.869%20123.058%2029.988C123.058%2031.05%20123.876%2031.922%20124.917%2032.006L125.083%2032.013V32.591C123.645%2032.591%20122.479%2031.426%20122.479%2029.988C122.479%2028.55%20123.645%2027.384%20125.083%2027.384V27.384Z'%20fill='%232174DB'/%3e%3cpath%20d='M94.4722%2054.8291C97.2792%2053.8671%20100.026%2052.5301%20102.714%2050.8181H109.585C107.21%2052.9881%20105.613%2054.5241%20104.794%2055.4281C103.974%2056.3311%20102.285%2058.0661%2099.7262%2060.6331C98.6352%2066.4141%2097.4722%2068.8431%2096.2392%2067.9181C94.3892%2066.5321%2088.3002%2057.0211%2094.4722%2054.8281V54.8291Z'%20fill='%23F3A29D'/%3e%3cpath%20d='M98.2542%2060.6541C102.617%2058.9861%20105.433%2057.7971%20106.701%2057.0871C108.201%2056.2221%20108.778%2055.4141%20110.508%2051.7801C110.738%2051.3191%20111.2%2049.4151%20111.604%2047.6271C112.527%2043.0701%20114.027%2043.3011%20114.142%2047.9731C114.2%2049.2431%20114.488%2050.3961%20114.834%2050.5111C115.122%2050.6271%20116.795%2049.0111%20118.468%2046.9351C120.141%2044.8581%20121.756%2043.1851%20122.044%2043.1851C122.736%2043.1851%20122.736%2048.4921%20121.987%2050.3381C121.698%2051.2031%20117.257%2056.0481%20112.123%2061.1821C108.701%2064.6051%20103.692%2069.2501%2097.0972%2075.1191L98.2542%2060.6541V60.6541Z'%20fill='%23FAB6AF'/%3e%3cpath%20d='M78.5812%2035.7741C79.3532%2032.6881%2080.1242%2030.7591%2080.8962%2029.9871C79.7392%2028.8301%2078.5812%2027.6731%2076.2662%2026.5161C75.4962%2028.0591%2073.9522%2029.6021%2071.6382%2031.1451C71.6382%2033.4591%2072.4092%2035.0021%2073.9522%2035.7741C75.4952%2036.5451%2077.0382%2036.5451%2078.5822%2035.7741H78.5812Z'%20fill='%23F3A29D'/%3e%3cpath%20d='M48.858%20113.16C46.493%20112.986%2042.628%20112.179%2040.378%20111.429L36.168%20110.044L36.053%20105.718C35.764%2093.778%2036.63%2085.068%2039.341%2073.936C43.032%2058.65%2053.646%2043.019%2066.509%2033.847C71.469%2030.271%2071.585%2030.271%2073.027%2032.694C73.661%2033.847%2074.987%2035.001%2075.911%2035.347L78.072%2035.941C75.5%2065%2076.202%2089.571%2081.603%20108.858C80.446%20110.016%2079.657%20110.54%2078.795%20110.91C77.756%20111.313%2076.43%20111.717%2075.738%20111.775C75.045%20111.833%2072.738%20112.294%2070.488%20112.813C66.278%20113.736%2057.106%20113.909%2048.858%20113.159V113.16Z'%20fill='url(%23paint2_linear_2729_3841)'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M94.4721%2054.828L96.2391%2066.139L76.2671%2068.784L77%2053C79.141%2054.735%2081.7171%2055.907%2083.9811%2056.254C86.2441%2056.602%2089.7421%2056.126%2094.4721%2054.828Z'%20fill='%23D6D7D8'/%3e%3cpath%20d='M98.2541%2060.653L103.157%2083.798C102.589%2084.955%20101.147%2085.727%2098.8331%2086.112C93.6251%2086.691%2088.4181%2084.376%2082.0531%2084.376C75.6881%2084.376%2075.9631%2088.426%2066.7051%2084.956C60.5331%2082.641%2058.0251%2072.226%2059.1821%2053.71L77%2052C76.922%2057.782%2077.8911%2061.232%2079.4341%2062.389C80.9461%2063.523%2087.0031%2062.99%2097.6041%2060.789L98.2541%2060.653Z'%20fill='%23E9E9E9'/%3e%3cpath%20d='M90.3051%2015.4439C91.3751%2016.9639%2091.7931%2018.9799%2091.5581%2021.4929C91.4961%2022.1489%2091.1821%2022.3759%2091.1821%2023.5449C91.1821%2024.6649%2091.2521%2026.0509%2091.3941%2027.7019L89.0771%2027.8629C86.8551%2030.2749%2084.5031%2031.3429%2082.0221%2031.0699C79.5421%2030.7949%2077.7711%2029.7269%2076.7121%2027.8629C74.5321%2023.8399%2075.0911%2020.4189%2078.3871%2017.6009C81.6831%2014.7829%2085.6561%2014.0639%2090.3051%2015.4439V15.4439Z'%20fill='%23FAB6AF'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M79.646%208C82.244%208%2085.363%209.017%2087.64%2010.74C89.917%2012.462%2091.485%2013.76%2092.19%2015.837C92.66%2017.221%2092.438%2019.151%2091.526%2021.628C91.656%2019.283%2091.478%2017.981%2090.993%2017.722C90.323%2019.375%2089.398%2019.709%2088.29%2020.509C87.67%2020.957%2085.499%2021.027%2083.373%2021.406C80.745%2023.128%2079.07%2024.736%2078.506%2026.266C78.058%2027.484%2078.104%2028.874%2078.654%2030.443L78.78%2030.782L78.24%2030.992C77.526%2029.159%2077.43%2027.514%2077.963%2026.067C78.485%2024.65%2079.813%2023.229%2081.857%2021.746C80.767%2022.053%2079.806%2022.5%2079.223%2023.195C77.944%2024.721%2077.195%2026.96%2076.977%2029.911C74.211%2029.411%2071.672%2028.478%2069.36%2027.111C67.048%2025.745%2064.915%2023.917%2062.962%2021.628C63.358%2020.794%2063.866%2020.104%2064.483%2019.558C65.154%2018.966%2066.418%2018.45%2067.652%2017.736L67.587%2017.757L66.383%2018.158C65.123%2018.582%2064.427%2018.871%2063.988%2019.19C63.158%2019.791%2062.728%2020.465%2062.675%2021.222L62.67%2021.413L62.091%2021.42C62.079%2020.381%2062.607%2019.477%2063.648%2018.721C64.075%2018.411%2064.661%2018.148%2065.631%2017.805L67.387%2017.215L67.997%2017.002C68.591%2016.789%2069.061%2016.601%2069.436%2016.418C70.732%2015.019%2071.606%2012.447%2073.526%2010.74C75.641%208.855%2077.048%208%2079.645%208H79.646Z'%20fill='%23E94A47'/%3e%3cpath%20d='M84.3598%2021.5751C84.9568%2019.9351%2086.5298%2018.9781%2087.8948%2019.4751C88.9558%2019.8611%2089.5488%2020.9991%2089.4808%2022.2561C89.8408%2022.1651%2090.1698%2022.1191%2090.4688%2022.1201L90.6768%2022.1271C90.9318%2022.1471%2091.1428%2022.1831%2091.3128%2022.2411C91.8248%2020.9701%2093.0208%2020.2181%2094.0628%2020.5971C95.1328%2020.9871%2095.5608%2022.4001%2095.0748%2023.7371C94.5878%2025.0741%2093.3518%2025.8811%2092.2808%2025.4911C91.3278%2025.1441%2090.8838%2023.9871%2091.1408%2022.7941C91.0378%2022.7561%2090.8668%2022.7221%2090.6328%2022.7041C90.2988%2022.6791%2089.8958%2022.7331%2089.4248%2022.8691L89.3938%2022.8791C89.3578%2023.0381%2089.3108%2023.1971%2089.2538%2023.3561C88.6568%2024.9961%2087.0838%2025.9531%2085.7178%2025.4561C84.3518%2024.9591%2083.7628%2023.2151%2084.3598%2021.5751V21.5751ZM93.8638%2021.1411C93.1338%2020.8751%2092.1998%2021.4841%2091.8118%2022.5491C91.4248%2023.6151%2091.7478%2024.6811%2092.4788%2024.9471C93.2098%2025.2131%2094.1428%2024.6041%2094.5308%2023.5391C94.9188%2022.4741%2094.5948%2021.4071%2093.8638%2021.1411ZM87.6968%2020.0191C86.6608%2019.6421%2085.3998%2020.4091%2084.9038%2021.7731C84.4078%2023.1361%2084.8798%2024.5351%2085.9158%2024.9131C86.9518%2025.2891%2088.2138%2024.5211%2088.7098%2023.1581C89.2058%2021.7951%2088.7328%2020.3961%2087.6968%2020.0181V20.0191Z'%20fill='%23222768'/%3e%3cdefs%3e%3clinearGradient%20id='paint0_linear_2729_3841'%20x1='140'%20y1='92'%20x2='158.924'%20y2='152.788'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%23E8B73F'/%3e%3cstop%20offset='1'%20stop-color='%23CF9F36'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint1_linear_2729_3841'%20x1='53.3662'%20y1='112.162'%20x2='38.2601'%20y2='175.224'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%232A318C'/%3e%3cstop%20offset='1'%20stop-color='%231D225F'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint2_linear_2729_3841'%20x1='58.8015'%20y1='31'%20x2='58.8015'%20y2='113.628'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%23EEEEEE'/%3e%3cstop%20offset='1'%20stop-color='%23D6D7D8'/%3e%3c/linearGradient%3e%3c/defs%3e%3c/svg%3e", ZE = (e) => /* @__PURE__ */ (0, Q.jsxs)("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 72,
	height: 72,
	viewBox: "0 0 72 72",
	fill: "none",
	...e,
	children: [
		/* @__PURE__ */ (0, Q.jsx)("circle", {
			cx: 19,
			cy: 53,
			r: 14,
			stroke: "#1DAD70",
			strokeWidth: 4
		}),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			d: "M24.5994 49.8003L17.1327 57.2666L13.3994 53.5336",
			stroke: "#1DAD70",
			strokeWidth: 4,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			d: "M36 20.25V36H51.75",
			stroke: "#FFB549",
			strokeWidth: 4,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			d: "M47.3037 63.8601C55.7586 60.4592 62.5667 53.262 65.107 43.7815C69.3952 27.7776 59.8978 11.3274 43.8938 7.03919C27.8898 2.75094 11.4397 12.2484 7.15145 28.2524C6.88939 29.2304 6.67882 30.2101 6.51807 31.1885",
			stroke: "#FFB549",
			strokeWidth: 4,
			strokeLinecap: "round"
		})
	]
}), QE = /* @__PURE__ */ function(e) {
	return e[e.APPROVED = 0] = "APPROVED", e[e.ALREADY_IMAGE_APPROVED = 1] = "ALREADY_IMAGE_APPROVED", e[e.REQUEST_CANCELLED_DISCARDED = 2] = "REQUEST_CANCELLED_DISCARDED", e[e.ALREADY_CONFIG_APPROVED = 3] = "ALREADY_CONFIG_APPROVED", e;
}({}), $E = {
	CONFIGURATION_ALREADY_APPROVED: "Configuration change is already approved",
	DEPLOYMENT_APPROVAL_ALREADY_APPROVED: "Image is already approved",
	CONFIGURATION_APPROVED_SUCCESSFULY: "Configuration change approved successfully",
	DEPLOYMENT_APPROVED_SUCCESSFULLY: "Image approved successfully",
	APPROVAL_REQUEST_INVALID: "Approval request is no longer valid",
	REQUEST_CANCELLED_SUBTITLE: "Request might have been cancelled."
}, eD = {
	TAGS: "Tags",
	COMMENT: "Comment",
	IMAGE_TAGS: "Image Tags",
	FILE_NAME: "File Name",
	FILE_TYPE: "File Type"
}, tD = new Wl({
	code: 403,
	errors: [{
		code: eo.UNAUTHORIZED,
		internalMessage: "Unauthorized",
		userMessage: "Unauthorized"
	}]
}), nD = ({ approvalNotificationData: e, approvalType: t }) => {
	let n = e.configApproval.draftState === QE.ALREADY_CONFIG_APPROVED || e.deploymentApproval.status === QE.ALREADY_IMAGE_APPROVED || e.imagePromotionApproval.status === QE.ALREADY_IMAGE_APPROVED, r = e.configApproval.draftState === QE.REQUEST_CANCELLED_DISCARDED || e.deploymentApproval.status === QE.REQUEST_CANCELLED_DISCARDED || e.imagePromotionApproval.status === QE.REQUEST_CANCELLED_DISCARDED, i = () => {
		let e = "";
		return e = n ? t === no.CONFIG ? $E.CONFIGURATION_ALREADY_APPROVED : $E.DEPLOYMENT_APPROVAL_ALREADY_APPROVED : r ? $E.APPROVAL_REQUEST_INVALID : t === no.CONFIG ? $E.CONFIGURATION_APPROVED_SUCCESSFULY : $E.DEPLOYMENT_APPROVED_SUCCESSFULLY, e;
	}, a = () => n ? /* @__PURE__ */ (0, Q.jsx)(ZE, { className: "icon-dim-72" }) : r ? /* @__PURE__ */ (0, Q.jsx)(Le, { className: "icon-dim-72" }) : /* @__PURE__ */ (0, Q.jsx)(ex, { className: "icon-dim-72" }), o = () => /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: `${n || r ? "bcy-1" : "bcg-1"} p-20 flex column fs-14 br-8 lh-20 dc__align-center`,
		children: [
			a(),
			/* @__PURE__ */ (0, Q.jsx)("div", {
				className: "fw-6 fs-16 pt-16 pb-4 lh-24",
				children: i()
			}),
			r ? $E.REQUEST_CANCELLED_SUBTITLE : /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsx)("div", {
				className: "pb-4",
				children: (0, Op.default)(e.notificationMetaData.eventTime).format(qe.TWELVE_HOURS_FORMAT)
			}), /* @__PURE__ */ (0, Q.jsxs)("div", { children: ["by\xA0", e.notificationMetaData.approvedBy] })] })
		]
	}), s = (e, t, n) => {
		let r = Array.isArray(t) ? t.join(", ") : t;
		return (e === eD.COMMENT || e === eD.TAGS) && !r ? null : /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: `mt-12 mb-12 lh-20 ${n ?? ""}`,
			children: [/* @__PURE__ */ (0, Q.jsx)("div", {
				className: "cn-7",
				children: e
			}), /* @__PURE__ */ (0, Q.jsx)("div", {
				className: "fs-14 dc__word-break-all",
				children: r
			})]
		});
	};
	return /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "approval-body p-20",
		children: [o(), /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [
			/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "approval__row--half",
				children: [s("Application", e.notificationMetaData.appName, "mt-16 mb-16"), t !== no.IMAGE_PROMOTION && s(t === no.CONFIG ? "Change Impacts" : "Environment", e.notificationMetaData.envName ? e.notificationMetaData.envName : "Base configuration", "mt-16 mb-16")]
			}),
			t === no.IMAGE_PROMOTION ? /* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "approval__row--half",
				children: [s("Source", e.imagePromotionApproval.sourceInfo, "pt-16 pb-16 m-0-imp"), s("Target Environment", e.notificationMetaData.envName, "pt-16 pb-16 m-0-imp")]
			}) : null,
			/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "dc__border-top-n1",
				children: [/* @__PURE__ */ (0, Q.jsx)("div", {
					className: "fw-6 fs-14 mt-16",
					children: t === no.CONFIG ? "File details" : "Image details"
				}), t === no.CONFIG ? /* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "dc__gap-16",
					children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
						className: "approval__row--half",
						children: [s(eD.FILE_TYPE, e.configApproval.protectConfigFileType), s(eD.FILE_NAME, e.configApproval.protectConfigFileName)]
					}), e.configApproval.protectConfigComment && s(eD.COMMENT, e.configApproval.protectConfigComment, "m-0")]
				}) : (() => {
					let { dockerImageUrl: n, imageComment: r, imageTagNames: i } = t === no.DEPLOYMENT ? e.deploymentApproval : e.imagePromotionApproval;
					return /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [
						s(eD.IMAGE_TAGS, n),
						r && s(eD.COMMENT, r, "m-0"),
						s(eD.TAGS, i)
					] });
				})()]
			})
		] })]
	});
};
//#endregion
//#region src/Components/DirectApprovalsViaEmail/Service.ts
async function rD(e, t, n, r, i) {
	let a = {
		method: t,
		headers: {
			Accept: "application/json",
			"Content-Type": "application/json",
			"api-token": n
		},
		signal: i,
		body: r ? JSON.stringify(r) : void 0,
		credentials: "include"
	};
	return fetch(`${window.__ORCHESTRATOR_ROOT__}/${e}`, a).then((e) => {
		if (e.headers.get(Al.LICENSE_STATUS) === hc) throw Hd(), tD;
		return e.json();
	}).then(async (e) => {
		if (e.code === 403) throw tD;
		if (e.code >= 300 && e.code <= 599) throw new Wl({
			code: e.code,
			errors: e.errors
		});
		return e;
	});
}
var iD = (e) => rD(O.NOTIFIER_CHANNEL_CONFIG_APPROVE, "POST", e), aD = (e) => rD(O.NOTIFIER_CHANNEL_DEPLOYMENT_APPROVE, "POST", e), oD = (e) => rD(O.NOTIFIER_CHANNEL_IMAGE_PROMOTION_APPROVE, "POST", e), sD = (e) => {
	switch (e) {
		case no.CONFIG: return iD;
		case no.DEPLOYMENT: return aD;
		case no.IMAGE_PROMOTION: return oD;
		default: throw Error(`Invalid approval modal type: ${e}`);
	}
}, cD = (e, t) => t === no.CONFIG ? {
	protectConfigFileType: e.protectConfigFileType,
	protectConfigFileName: e.protectConfigFileName,
	protectConfigComment: e.protectConfigComment,
	protectConfigLink: e.protectConfigLink,
	draftState: e.draftState
} : {
	protectConfigFileType: "",
	protectConfigFileName: "",
	protectConfigComment: "",
	protectConfigLink: "",
	draftState: ""
}, lD = (e, t) => t === no.DEPLOYMENT ? {
	imageTagNames: e.imageTagNames,
	imageComment: e.imageComment,
	imageApprovalLink: e.imageApprovalLink,
	dockerImageUrl: e.dockerImageUrl,
	status: e.status
} : {
	imageTagNames: [],
	imageComment: "",
	imageApprovalLink: "",
	dockerImageUrl: "",
	status: ""
}, uD = (e, t) => t === no.IMAGE_PROMOTION ? {
	imageTagNames: e.imageTagNames,
	imageComment: e.imageComment,
	dockerImageUrl: e.dockerImageUrl,
	status: e.status,
	sourceInfo: e.sourceInfo
} : {
	imageTagNames: [],
	imageComment: "",
	dockerImageUrl: "",
	status: "",
	sourceInfo: ""
}, dD = /* @__PURE__ */ t({ default: () => fD }), fD = ({ approvalType: e, approvalToken: t }) => {
	let [n, r] = j(!0), [i, a] = j(null), [o, s] = j(0), [c, l] = j(null), u = (t) => ({
		configApproval: cD(t, e),
		deploymentApproval: lD(t, e),
		imagePromotionApproval: uD(t, e),
		notificationMetaData: {
			appName: t.notificationMetaData.appName,
			envName: t.notificationMetaData.envName,
			eventTime: t.notificationMetaData.eventTime,
			approvedBy: t.notificationMetaData.approvedBy
		}
	}), d = async () => {
		try {
			r(!0);
			let n = await sD(e)(t);
			l(u(n.result)), s(n.code);
		} catch (e) {
			e instanceof Wl && s(e.code), a(e.errors?.[0]?.userMessage || ce.REQUEST_COULD_NOT_BE_PROCESSED);
		} finally {
			r(!1);
		}
	};
	return k(() => {
		d();
	}, []), /* @__PURE__ */ (0, Q.jsx)("div", {
		className: "bg__tertiary flex top w-100 h-100vh",
		children: /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "bg__primary w-600 m-20 fs-13",
			children: [/* @__PURE__ */ (0, Q.jsx)("div", {
				className: "approval-header flex p-16 dc__border-bottom-n1",
				children: /* @__PURE__ */ (0, Q.jsx)(YE, { className: "devtron-logo" })
			}), n ? /* @__PURE__ */ (0, Q.jsx)(R, {
				imgName: "img-mechanical-operation",
				title: ce.HOLD_ON,
				subTitle: ce.FETCHING_NOTIFICATION_DETAILS,
				imageType: yc.Large,
				classname: "mh-440"
			}) : i ? o === 403 ? /* @__PURE__ */ (0, Q.jsx)(R, {
				image: XE,
				title: ce.UNAUTHORIZED,
				subTitle: ce.UNAUTHORIZED_MESSAGE,
				classname: "mh-440"
			}) : /* @__PURE__ */ (0, Q.jsx)(R, {
				title: ce.UNABLE_TO_PROCESS,
				subTitle: /* @__PURE__ */ (0, Q.jsx)("span", {
					className: "dc__truncate--clamp-6",
					children: i
				}),
				classname: "mh-440",
				imageType: yc.Large
			}) : /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsx)(nD, {
				approvalNotificationData: c,
				approvalType: e
			}), /* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "generic-approval__footer flex dc__content-space dc__border-top-n1 p-16",
				children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "flex left",
					children: [
						/* @__PURE__ */ (0, Q.jsx)("a", {
							href: "https://twitter.com/DevtronL",
							target: "_blank",
							className: "cursor pr-12 flex",
							rel: "noreferrer",
							children: /* @__PURE__ */ (0, Q.jsx)("img", {
								src: "https://cdn.devtron.ai/images/twitter-new.png",
								className: "icon-dim-20",
								alt: "devtron-twitter"
							})
						}),
						/* @__PURE__ */ (0, Q.jsx)("a", {
							href: "https://www.linkedin.com/company/devtron-labs/mycompany/",
							target: "_blank",
							className: "cursor pr-12 flex",
							rel: "noreferrer",
							children: /* @__PURE__ */ (0, Q.jsx)("img", {
								src: "https://cdn.devtron.ai/images/linkedin_social_dark.png",
								className: "icon-dim-20",
								alt: "devtron-linkedin"
							})
						}),
						/* @__PURE__ */ (0, Q.jsx)("a", {
							href: "https://devtron.ai/blog/",
							target: "_blank",
							className: "cursor pr-12 flex",
							rel: "noreferrer",
							children: "Blog"
						}),
						/* @__PURE__ */ (0, Q.jsx)("a", {
							href: "https://devtron.ai/",
							target: "_blank",
							className: "cursor pr-12 flex",
							rel: "noreferrer",
							children: "Website"
						})
					]
				}), /* @__PURE__ */ (0, Q.jsx)("div", {
					className: "generic-approval__copyright cn-5",
					children: /* @__PURE__ */ (0, Q.jsx)(As, {})
				})]
			})] })]
		})
	});
}, pD = {
	error: 0,
	warning: 1
}, mD = (e, t) => {
	let n = String(e || "").toLowerCase(), r = String(t || "").toLowerCase(), i = pD[n] ?? 2 ** 53 - 1, a = pD[r] ?? 2 ** 53 - 1;
	return i === a ? n.localeCompare(r) : i - a;
}, hD = (e, t) => String(e || "").toLowerCase().localeCompare(String(t || "").toLowerCase()), gD = (e, t) => `recommendation-${e.code || "code"}-${t}`, _D = ({ codeSnippet: e }) => [
	...e?.before || [],
	e?.current,
	...e?.after || []
].filter(Boolean), vD = [
	{
		label: "Recommendations",
		field: "title",
		size: null,
		CellComponent: ({ row: e, isExpandedRow: t, expandRowCallback: n, registerExpandRowCallback: r }) => {
			if (k(() => {
				if (!t) return r(e.id, n), () => {
					r(e.id);
				};
			}, [
				n,
				t,
				r,
				e.id
			]), !t) return /* @__PURE__ */ (0, Q.jsx)("div", {
				className: "fs-13 fw-12 cn-9 fw-6 py-16",
				children: e.data.title
			});
			let i = _D(e.data);
			return /* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "security-scan-modal__expanded-row en-2 bw-1 br-4 mono dc__overflow-hidden",
				children: [/* @__PURE__ */ (0, Q.jsx)("div", {
					className: " bg__secondary cn-9 fs-13 dc__top-radius-4 px-12 py-8 dc__border-bottom",
					children: "Dockerfile"
				}), i.length ? /* @__PURE__ */ (0, Q.jsx)("div", {
					className: "security-scan-modal__snippet",
					children: /* @__PURE__ */ (0, Q.jsx)("div", {
						className: "mw-100 dc_width-max-content",
						children: i.map((t) => /* @__PURE__ */ (0, Q.jsxs)("div", {
							className: "security-scan-modal__snippet-line fs-13 p-6 dc__grid dc__gap-12 py-8 px-12",
							children: [/* @__PURE__ */ (0, Q.jsx)("span", {
								className: `lh-20 flex ${t.isIssue ? "security-scan-modal__snippet-line--issue" : "cn-9"}`,
								children: t.line || ""
							}), /* @__PURE__ */ (0, Q.jsx)("span", {
								className: "security-scan-modal__snippet-content",
								children: t.content
							})]
						}, `${e.id}-${t.line || "line"}-${t.content}`))
					})
				}) : /* @__PURE__ */ (0, Q.jsx)("div", {
					className: "cn-5 fs-12",
					children: "No code snippet available."
				})]
			});
		}
	},
	{
		label: "Level",
		field: "level",
		size: { fixed: 100 },
		isSortable: !0,
		comparator: mD,
		CellComponent: ({ row: e, isExpandedRow: t }) => t ? null : /* @__PURE__ */ (0, Q.jsx)("div", {
			className: "py-16",
			children: /* @__PURE__ */ (0, Q.jsx)("span", {
				className: `${e.data.level.toLowerCase()} br-4 px-6 fs-12-imp lh-20 fw-6 dc__capitalize`,
				children: e.data.level
			})
		})
	},
	{
		label: "Code",
		field: "code",
		size: { fixed: 150 },
		isSortable: !0,
		comparator: hD,
		CellComponent: ({ row: e, isExpandedRow: t }) => t ? null : /* @__PURE__ */ (0, Q.jsx)("a", {
			href: e.data.documentationUrl,
			target: "_blank",
			rel: "noreferrer",
			onClick: uf,
			className: "py-16 dc__link dc__block",
			children: e.data.code
		})
	}
], yD = "https://cdn.devtron.ai/images/Hadolint.svg", bD = () => /* @__PURE__ */ (0, Q.jsxs)("div", {
	className: "flex dc__content-space dc__border-bottom-n1 pb-8",
	children: [/* @__PURE__ */ (0, Q.jsx)("h3", {
		className: "m-0 fs-13 fw-6 lh-20",
		children: "Dockerfile Linting"
	}), /* @__PURE__ */ (0, Q.jsx)(Fl, {
		scanToolName: "Hadolint",
		scanToolUrl: yD
	})]
}), xD = ({ summary: e, handleSecurityScanModal: t, isModalView: n = !1, lastScanTime: r }) => {
	let { error: i, warning: a, info: o } = e, s = i + a + o;
	return /* @__PURE__ */ (0, Q.jsx)("div", {
		className: `security-scanner-bar__recommendations flexbox-col br-8 ${n ? "m-20" : "cursor"}`,
		onClick: t,
		children: /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox-col",
			children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: `flexbox-col ${n ? "dc__gap-12 p-16" : "dc__gap-16 p-20"}`,
				children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "flexbox dc__content-space dc__gap-2",
					children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
						className: "flexbox-col dc__gap-2",
						children: [!n && /* @__PURE__ */ (0, Q.jsx)("span", {
							className: "fs-12 cn-7 lh-1.5",
							children: "Dockerfile Best Practices"
						}), /* @__PURE__ */ (0, Q.jsxs)("span", {
							className: "fs-14 fw-6 lh-20 ",
							children: [s, " Recommendations"]
						})]
					}), /* @__PURE__ */ (0, Q.jsx)(z, {
						name: "ic-code-wrapped",
						color: "R500",
						size: 20
					})]
				}), /* @__PURE__ */ (0, Q.jsx)("div", {
					className: "flexbox-col",
					children: /* @__PURE__ */ (0, Q.jsx)(zl, {
						entities: [
							{
								color: "var(--Y500)",
								label: "Warnings",
								value: a || 0
							},
							{
								color: "var(--R500)",
								label: "Errors",
								value: i || 0
							},
							{
								color: "var(--B500)",
								label: "Info",
								value: o || 0
							}
						],
						labelClassName: "fs-13 fw-4 lh-20",
						countClassName: "fs-13 fw-6 lh-20 cn-7",
						swapLegendAndBar: !n,
						showAnimationOnBar: !0
					})
				})]
			}), n && r && r !== Eu && r !== 0 ? /* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flex dc__content-space pr-16",
				children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "flexbox dc__align-items-center dc__gap-6 py-8 dc__border-top py-8 px-16",
					children: [/* @__PURE__ */ (0, Q.jsx)(z, {
						name: "ic-clock",
						color: null,
						size: 20
					}), /* @__PURE__ */ (0, Q.jsxs)("span", {
						className: "fs-12 fw-4 cn-8 lh-20",
						children: [
							"Scanned on ",
							(0, Op.default)(r).format(ss.TWELVE_HOURS_FORMAT),
							" "
						]
					})]
				}), /* @__PURE__ */ (0, Q.jsx)(Fl, {
					scanToolName: "Hadolint",
					scanToolUrl: yD
				})]
			}) : null]
		})
	});
}, SD = "security-scan-recommendations-close", CD = ({ summary: e, recommendations: t, handleSecurityScanModal: n, lastScanTime: r }) => {
	let i = Ja({}), a = Ka((e, t) => {
		if (!t) {
			delete i.current[e];
			return;
		}
		i.current[e] = t;
	}, []), o = Ka((e, t) => {
		let n = t ? e.data.parentRowId : e.id;
		i.current[n]?.({ stopPropagation: () => {} });
	}, []), s = A(() => t.map((e, t) => {
		let n = gD(e, t), r = {
			id: n,
			parentRowId: n,
			code: e.code,
			title: e.title,
			level: e.level,
			message: e.message,
			file: e.file,
			line: e.line,
			documentationUrl: e.documentationUrl,
			codeSnippet: e.codeSnippet
		}, i = `expanded-row-${n}`;
		return {
			id: n,
			data: r,
			expandableRows: [{
				id: i,
				data: {
					...r,
					id: i
				}
			}]
		};
	}), [t]), c = A(() => ({ registerExpandRowCallback: a }), [a]);
	return /* @__PURE__ */ (0, Q.jsx)(xu, {
		className: "flex column right flex-grow-1 dc__overflow-hidden",
		close: n,
		onEscape: n,
		initialFocus: `#${SD}`,
		children: /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "security-scan-modal br-8 bg__primary mt-0-imp p-0 dc__no-top-radius flexbox-col flex-grow-1 mh-0 w-800 mr-0-imp",
			onClick: uf,
			children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flex dc__content-space dc__align-items-center px-20 pt-16 pb-12 dc__border-bottom",
				children: [/* @__PURE__ */ (0, Q.jsx)("h2", {
					className: "m-0 fs-16 fw-6 cn-9",
					children: "Dockerfile Linting"
				}), /* @__PURE__ */ (0, Q.jsx)(M, {
					id: SD,
					dataTestId: "close-security-scan-recommendations-modal",
					ariaLabel: "Close security scan recommendations modal",
					variant: F.borderLess,
					style: P.negativeGrey,
					size: I.xs,
					onClick: n,
					icon: /* @__PURE__ */ (0, Q.jsx)(z, {
						name: "ic-close-large",
						color: null
					})
				})]
			}), /* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "dc__overflow-auto flexbox-col flex-grow-1 mh-0",
				children: [/* @__PURE__ */ (0, Q.jsx)(xD, {
					summary: e,
					isModalView: !0,
					lastScanTime: r
				}), /* @__PURE__ */ (0, Q.jsx)(ru, {
					id: "table__security-scan-recommendations",
					columns: vD,
					rows: s,
					filtersVariant: tc.URL,
					paginationVariant: el.NOT_PAGINATED,
					filter: null,
					additionalProps: c,
					emptyStateConfig: { noRowsConfig: { title: "No recommendations found" } },
					onRowClick: o
				})]
			})]
		})
	});
}, wD = /* @__PURE__ */ t({ default: () => TD }), TD = ({ scanRecommendationResponse: e }) => {
	let [t, n] = j(!1), r = e?.result, { results: i, severity_summary: a, dockerfileScanEnabled: o } = r, s = !!i?.length;
	if (!s) return null;
	let { info: c, error: l, warning: u } = a, d = c || l || u;
	if (!o && !s) return /* @__PURE__ */ (0, Q.jsx)(wl, {
		title: "Dockerfile scan is disabled",
		subtitle: "Contact your administrator to enable Dockerfile scan"
	});
	let f = () => {
		n((e) => !e);
	};
	return /* @__PURE__ */ (0, Q.jsx)("div", {
		className: "security-recommendations",
		children: !d || !s ? /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: `security-scanner-bar__no-recommendations ${d ? "security-scanner-bar__recommendations" : ""}  p-16`,
			children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox dc__content-space dc__gap-2",
				children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "flexbox-col dc__gap-2",
					children: [/* @__PURE__ */ (0, Q.jsx)("span", {
						className: "fs-12 cn-7 lh-1.5",
						children: "Dockerfile Best Practices"
					}), /* @__PURE__ */ (0, Q.jsx)("span", {
						className: "fs-14 fw-6 lh-1.5",
						children: "Looks good!"
					})]
				}), /* @__PURE__ */ (0, Q.jsx)(z, {
					name: "ic-code-wrapped",
					color: "G500",
					size: 20
				})]
			}), /* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox-col dc__gap-12",
				children: [/* @__PURE__ */ (0, Q.jsx)("div", { className: "bcn-1 br-4 h-8" }), /* @__PURE__ */ (0, Q.jsx)("span", { children: "No recommendations suggested" })]
			})]
		}) : /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox-col dc__gap-12",
			children: [/* @__PURE__ */ (0, Q.jsx)(xD, {
				summary: a,
				handleSecurityScanModal: f
			}), t && /* @__PURE__ */ (0, Q.jsx)(CD, {
				summary: a,
				recommendations: r.results,
				handleSecurityScanModal: f,
				isModalView: !1,
				lastScanTime: r.createdOn
			})]
		})
	});
}, ED = /* @__PURE__ */ t({ default: () => DD });
function DD({ x: e, y: t, width: n, height: r, configDiffView: i, title: a, redirectTo: o, blockAddNewPipeline: s, toggleCDMenu: c, history: l, readOnly: u, handleSelectedNodeChange: d, selectedNode: f, id: p, isLastNode: m, deploymentAppDeleteRequest: h, appId: g, workflowId: _, getWorkflows: v, isTemplateView: y }) {
	let b = (e) => {
		if (af(e), uf(e), !s) {
			if (h) {
				H.showToast({
					variant: U.error,
					description: "Deployment pipeline cannot be attached to a pipeline being deleted."
				});
				return;
			}
			m ? c() : d({
				nodeType: Cu.CI,
				id: p
			});
		}
	}, x = (e) => {
		e.stopPropagation(), !u && o && l && l.push(o);
	}, S = `${f?.nodeType}-${f?.id}`, C = `${Cu.CI}-${p ?? ""}`;
	return /* @__PURE__ */ (0, Q.jsx)("foreignObject", {
		className: "data-hj-whitelist",
		x: e,
		y: t,
		width: n,
		height: r,
		style: { overflow: "visible" },
		children: i ? /* @__PURE__ */ (0, Q.jsx)("div", {
			className: "workflow-node",
			children: /* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "workflow-node__title flex",
				children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "workflow-node__full-width-minus-Icon",
					children: [/* @__PURE__ */ (0, Q.jsx)("span", {
						className: "workflow-node__text-light",
						children: "Build"
					}), /* @__PURE__ */ (0, Q.jsx)("div", {
						className: "dc__ellipsis-left",
						children: a
					})]
				}), /* @__PURE__ */ (0, Q.jsx)(pr, { className: "icon-dim-20" })]
			})
		}) : /* @__PURE__ */ (0, Q.jsxs)("div", {
			"data-testid": `workflow-editor-link-cd-${a}`,
			className: `dc__border br-8 bg__primary pl-12 flexbox dc__align-items-center h-100 flexbox dc__content-space ${u ? "" : "cursor node-hover-shadow"}`,
			role: u ? null : "button",
			onClick: x,
			tabIndex: -1,
			children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox dc__gap-12 dc__align-items-center pt-12 pb-12",
				children: [/* @__PURE__ */ (0, Q.jsx)(pr, { className: "icon-dim-18 dc__no-shrink" }), /* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "flexbox-col dc__ellipsis-right",
					children: [/* @__PURE__ */ (0, Q.jsx)("span", {
						className: "cn-7 m-0 fs-10 fw-4 lh-14",
						"data-testid": "linked-indication-name",
						children: "Sync with..."
					}), /* @__PURE__ */ (0, Q.jsx)(ft, {
						className: "default-tt dc__word-break-all",
						arrow: !0,
						placement: "bottom",
						content: a,
						children: /* @__PURE__ */ (0, Q.jsx)("p", {
							className: "dc__ellipsis-right m-0 cn-9 fs-12 fw-6 lh-16",
							children: a
						})
					})]
				})]
			}), !u && S !== C && /* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "h-100 dc__border-left-n1 w-24 dc__align-items-center dc__grid-rows-2 ci-node__action-button dc__right-radius-8",
				children: [/* @__PURE__ */ (0, Q.jsx)("div", {
					className: "dc__border-bottom-n1",
					children: /* @__PURE__ */ (0, Q.jsx)(M, {
						ariaLabel: s ? qm.CANT_ADD_DEPLOYMENT_PIPELINE : qm.ADD_NEW_DEPLOYMENT_PIPELINE,
						variant: F.borderLess,
						dataTestId: `sync-cd-add-deployment-pipeline-button-${a}`,
						onClick: b,
						icon: /* @__PURE__ */ (0, Q.jsx)(z, {
							size: 12,
							name: "ic-add",
							color: null
						}),
						size: I.xxs_small_icon,
						style: P.neutral,
						fullWidth: !0,
						showTooltip: !0,
						tooltipProps: {
							placement: "right",
							content: s ? qm.CANT_ADD_DEPLOYMENT_PIPELINE : qm.ADD_NEW_DEPLOYMENT_PIPELINE
						}
					})
				}), (() => {
					let e = {
						appId: g,
						appWorkflowId: Number(_),
						pipelineId: Number(p),
						pipelineName: a
					};
					return /* @__PURE__ */ (0, Q.jsx)(ws, {
						testId: `sync-cd-deployment-pipeline-button-${a}-delete`,
						deletePayloadConfig: e,
						title: a,
						getWorkflows: v,
						isTemplateView: y
					});
				})()]
			})]
		})
	});
}
//#endregion
//#region src/Components/EphemeralEnv/SyncEnvironment/service.ts
var OD = (e, t) => nf(t ? Nd({
	type: uc.CI_PIPELINE,
	queryParams: { id: e.appId }
}) : O.CI_PIPELINE_PATCH, e), kD = (e) => /* @__PURE__ */ (0, Q.jsx)("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...e,
	children: /* @__PURE__ */ (0, Q.jsx)("g", {
		fill: "none",
		fillRule: "evenodd",
		children: /* @__PURE__ */ (0, Q.jsx)("g", { children: /* @__PURE__ */ (0, Q.jsx)("g", { children: /* @__PURE__ */ (0, Q.jsx)("g", { children: /* @__PURE__ */ (0, Q.jsx)("g", { children: /* @__PURE__ */ (0, Q.jsxs)("g", { children: [/* @__PURE__ */ (0, Q.jsx)("path", {
			d: "M0 0H24V24H0z",
			transform: "translate(-792 -181) translate(88 96) translate(20 58) translate(520 10) matrix(-1 0 0 1 188 17)"
		}), /* @__PURE__ */ (0, Q.jsxs)("g", {
			fillRule: "nonzero",
			children: [
				/* @__PURE__ */ (0, Q.jsx)("path", {
					fill: "#FE636E",
					d: "M5.12 14.37c-1.534.08-4.154.95-3.9 2.767.64 4.609-4.4 6.089 2.306 6.089 3.374 0 5.5-1.48 5.821-4.586l-.91-3.521-3.318-.748z",
					transform: "translate(-792 -181) translate(88 96) translate(20 58) translate(520 10) matrix(-1 0 0 1 188 17)"
				}),
				/* @__PURE__ */ (0, Q.jsx)("path", {
					fill: "#FFD659",
					d: "M6.325 15.59c-.71.037-1.928.44-1.812 1.285.298 2.14-2.042 2.827 1.072 2.827 1.567 0 2.556-.686 2.705-2.13l-.344-1.74-1.62-.243z",
					transform: "translate(-792 -181) translate(88 96) translate(20 58) translate(520 10) matrix(-1 0 0 1 188 17)"
				}),
				/* @__PURE__ */ (0, Q.jsx)("path", {
					fill: "#FB2A39",
					d: "M7.864 18.775c-.911 1.658-2.718 2.458-5.197 2.458-.97 0-1.695-.032-2.226-.098-.716 1.523-1.065 2.09 3.085 2.09 3.374 0 5.5-1.479 5.821-4.585l-.766-.773-.26-.264c-.024.09-.049.177-.076.264-.07.355-.2.657-.381.908z",
					transform: "translate(-792 -181) translate(88 96) translate(20 58) translate(520 10) matrix(-1 0 0 1 188 17)"
				}),
				/* @__PURE__ */ (0, Q.jsx)("path", {
					fill: "#FFBF00",
					d: "M7.576 16.853c-.335 1.035-1.248 1.53-2.58 1.53-.267 0-.492-.004-.684-.015-.392.983-.954 1.334 1.273 1.334 1.04 0 1.825-.301 2.278-.927.182-.25.312-.553.382-.908.02-.095.034-.193.045-.295l-.714-.72z",
					transform: "translate(-792 -181) translate(88 96) translate(20 58) translate(520 10) matrix(-1 0 0 1 188 17)"
				}),
				/* @__PURE__ */ (0, Q.jsx)("path", {
					fill: "#99B4CD",
					d: "M6.973 11.845l-1.999 1.173c-.402.236-.335.868-.015 1.192l.16.16 1.206 1.22 1.965 1.982 1.057 1.068.551.557c.322.323.948.389 1.182-.016l1.16-2.02-1.314-5.112-3.953-.204zM23.173.063C22.212-.115 20.46.07 18.327.8l.96 3.561 3.898 1.331c.725-2.167.907-3.942.724-4.906-.107-.562-.175-.62-.736-.723z",
					transform: "translate(-792 -181) translate(88 96) translate(20 58) translate(520 10) matrix(-1 0 0 1 188 17)"
				}),
				/* @__PURE__ */ (0, Q.jsx)("path", {
					fill: "#06C",
					d: "M12.19 4.027c-2.67-.973-4.737-.53-6.833 1.386-.972.944-2.59 2.185-1.254 3.534l1.662 1.677L10.54 8.19l1.65-4.162zM19.986 11.896l-4.488 1.873-2.047 4.614 1.661 1.678c1.336 1.348 2.565-.285 3.5-1.266.97-1.082 2.697-3.143 1.374-6.9z",
					transform: "translate(-792 -181) translate(88 96) translate(20 58) translate(520 10) matrix(-1 0 0 1 188 17)"
				}),
				/* @__PURE__ */ (0, Q.jsx)("path", {
					fill: "#FFF",
					d: "M23.185 5.692c-.112.339-.239.686-.378 1.041-.635 1.608-1.555 3.38-2.821 5.162-1.59 2.24-3.727 4.5-6.535 6.489l-.33-.333-.88-.889-2.377-2.4-.257-.259-.257-.259-2.376-2.4-1.21-1.22c1.97-2.835 4.21-4.991 6.426-6.596C14.345 2.468 16.48 1.43 18.327.8l4.858 4.892z",
					transform: "translate(-792 -181) translate(88 96) translate(20 58) translate(520 10) matrix(-1 0 0 1 188 17)"
				}),
				/* @__PURE__ */ (0, Q.jsx)("path", {
					fill: "#06C",
					d: "M17.402 5.863c.152-.026.288.053.348.177l1.126 1.756c.098.15.1.344.006.497l-1.432 2.341c-.092.151-.256.243-.433.243l-2.082.002h-.014c-.203-.01-.315-.242-.204-.412l1.435-2.196c.054-.112.18-.183.318-.152.102.023.185.106.208.208.016.07.005.136-.023.192l-.015.025-.016.023-.218.337c-.065.098-.004.229.113.242l.529.038c.098.007.195-.027.267-.094.095-.112.517-.8.71-1.122.062-.104.054-.234-.016-.332l.002-.001-.678-1.055-.127-.2c-.014-.017-.025-.035-.035-.055l-.005-.007c-.024-.056-.035-.117-.026-.182.018-.137.127-.25.262-.273zm-2.63-.422l2.082.007h.014c.203.011.315.243.203.413l-1.445 2.19c-.055.112-.181.182-.319.15-.102-.023-.184-.106-.207-.208-.016-.07-.005-.137.024-.193l.03-.047.22-.336c.066-.097.005-.229-.11-.242l-.53-.04c-.098-.008-.195.025-.268.092-.095.112-.52.797-.715 1.119-.062.104-.055.233.015.332l-.002.001.674 1.058.126.2c.013.017.024.036.034.055l.005.007c.024.056.035.118.026.183-.02.136-.128.249-.264.272-.152.025-.288-.055-.347-.179l-1.119-1.761c-.096-.151-.098-.345-.003-.498l1.442-2.334c.093-.15.257-.242.434-.241z",
					transform: "translate(-792 -181) translate(88 96) translate(20 58) translate(520 10) matrix(-1 0 0 1 188 17) scale(-1 1) rotate(-45 0 46.518)"
				}),
				/* @__PURE__ */ (0, Q.jsx)("path", {
					fill: "#6C9ABB",
					d: "M22.87.021c.095 1.01-.117 2.638-.766 4.58l1.081 1.091c.725-2.167.907-3.942.724-4.906-.107-.562-.175-.62-.736-.723-.094-.018-.194-.032-.302-.042z",
					transform: "translate(-792 -181) translate(88 96) translate(20 58) translate(520 10) matrix(-1 0 0 1 188 17)"
				}),
				/* @__PURE__ */ (0, Q.jsx)("path", {
					fill: "#EBEBEB",
					d: "M21.724 5.644c-.635 1.608-1.554 3.378-2.821 5.162-.549.772-1.161 1.546-1.845 2.311-.686.77-1.443 1.527-2.275 2.264-.743.657-1.546 1.298-2.413 1.912l.751.758.33.332c2.808-1.989 4.944-4.248 6.535-6.487 1.266-1.784 2.186-3.555 2.82-5.163.14-.355.267-.703.38-1.04l-1.082-1.091c-.071.21-.147.425-.229.643-.048.131-.098.265-.151.399z",
					transform: "translate(-792 -181) translate(88 96) translate(20 58) translate(520 10) matrix(-1 0 0 1 188 17)"
				}),
				/* @__PURE__ */ (0, Q.jsx)("path", {
					fill: "#6C9ABB",
					d: "M10.924 15.832l-1.161 2.02c-.234.404-.86.338-1.182.015l.766.773.551.556c.322.323.948.39 1.182-.015l1.16-2.02-1.316-1.329z",
					transform: "translate(-792 -181) translate(88 96) translate(20 58) translate(520 10) matrix(-1 0 0 1 188 17)"
				}),
				/* @__PURE__ */ (0, Q.jsx)("path", {
					fill: "#0053A6",
					d: "M19.986 11.896c-.22.31-.452.62-.692.93.311 2.632-1.005 4.195-1.807 5.09-.768.804-1.732 2.048-2.792 1.724l.417.42c1.336 1.35 2.565-.284 3.5-1.265.97-1.082 2.697-3.143 1.374-6.9zM10.498 3.59C8.503 5.1 6.508 7.063 4.721 9.57l1.044 1.053c1.97-2.835 4.208-4.991 6.425-6.597-.59-.215-1.153-.361-1.692-.437z",
					transform: "translate(-792 -181) translate(88 96) translate(20 58) translate(520 10) matrix(-1 0 0 1 188 17)"
				}),
				/* @__PURE__ */ (0, Q.jsx)("path", {
					fill: "#EBEBEB",
					d: "M11.73 12.88l-1.864 1.88-.002.002-.257-.259-.257-.259 1.862-1.878c.142-.143.373-.144.515-.002.143.142.144.373.002.516z",
					transform: "translate(-792 -181) translate(88 96) translate(20 58) translate(520 10) matrix(-1 0 0 1 188 17)"
				})
			]
		})] }) }) }) }) })
	})
}), AD = /* @__PURE__ */ function(e) {
	return e.CREATE_NO_DEPLOY = "CREATE_NO_DEPLOY", e.CREATE_DEPLOY = "CREATE_DEPLOY", e.UPDATE = "UPDATE", e;
}({}), jD = /* @__PURE__ */ function(e) {
	return e.ALLOWED = "ALLOWED", e.CYCLIC = "CYCLIC", e.SELECTED = "SELECTED", e.PRESENT = "PRESENT", e;
}({}), MD = /* @__PURE__ */ function(e) {
	return e[e.CREATE = 0] = "CREATE", e[e.DELETE = 2] = "DELETE", e;
}({});
//#endregion
//#region src/Components/EphemeralEnv/SyncEnvironment/SyncEnvironmentActionBar.tsx
function ND({ view: e, setShowDeploymentModal: t, disableDeploy: n }) {
	return e === AD.UPDATE ? /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox pt-12 pb-12 pl-20 pr-20 dc__gap-12 dc__border-right",
		children: [/* @__PURE__ */ (0, Q.jsx)(pr, { className: "icon-dim-20" }), /* @__PURE__ */ (0, Q.jsx)("p", {
			className: "fs-12 cn-7 fw-6 lh-20 m-0",
			children: Rm[0]
		})]
	}) : e === AD.CREATE_DEPLOY ? /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox w-100",
		children: [
			/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flex pt-12 pb-12 pl-16 pr-16 dc__gap-8",
				style: { width: "387px" },
				children: [/* @__PURE__ */ (0, Q.jsx)(pr, { className: "icon-dim-20" }), /* @__PURE__ */ (0, Q.jsx)("p", {
					className: "fs-12 cn-7 fw-6 lh-20 m-0",
					children: Rm[0]
				})]
			}),
			/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox-col",
				children: [
					/* @__PURE__ */ (0, Q.jsx)("div", {
						style: { width: "13px" },
						className: "dc__border-right h-10"
					}),
					/* @__PURE__ */ (0, Q.jsx)("div", {
						className: "flex p-4 br-4 dc__border-n1 bg__secondary",
						children: /* @__PURE__ */ (0, Q.jsx)(Kn, { className: "icon-dim-16 scn-6" })
					}),
					/* @__PURE__ */ (0, Q.jsx)("div", {
						style: { width: "13px" },
						className: "dc__border-right h-10"
					})
				]
			}),
			/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flex pt-12 pb-12 pl-16 pr-16 dc__gap-8",
				style: { width: "387px" },
				children: [/* @__PURE__ */ (0, Q.jsx)(kD, { className: "icon-dim-20 flip-rocket" }), /* @__PURE__ */ (0, Q.jsx)("p", {
					className: "fs-12 cn-7 fw-6 lh-20 m-0",
					children: Rm[1]
				})]
			})
		]
	}) : e === AD.CREATE_NO_DEPLOY ? /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flex",
		children: [
			/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox pt-12 pb-12 pl-16 pr-16 dc__gap-8 flex-grow-1",
				children: [/* @__PURE__ */ (0, Q.jsx)(pr, { className: "icon-dim-20" }), /* @__PURE__ */ (0, Q.jsx)("p", {
					className: "fs-12 cn-7 fw-6 lh-20 m-0",
					children: Rm[0]
				})]
			}),
			/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox-col",
				children: [
					/* @__PURE__ */ (0, Q.jsx)("div", {
						style: { width: "13px" },
						className: "dc__border-right h-10"
					}),
					/* @__PURE__ */ (0, Q.jsx)("div", {
						className: "flex p-4 br-4 dc__border-n1 bg__secondary",
						children: /* @__PURE__ */ (0, Q.jsx)(Kn, { className: "icon-dim-16 scn-6" })
					}),
					/* @__PURE__ */ (0, Q.jsx)("div", {
						style: { width: "13px" },
						className: "dc__border-right h-10"
					})
				]
			}),
			/* @__PURE__ */ (0, Q.jsx)("div", {
				className: "flexbox pt-8 pb-8 pl-16 pr-16 dc__gap-8",
				children: /* @__PURE__ */ (0, Q.jsx)(es, {
					condition: n,
					wrap: (e) => /* @__PURE__ */ (0, Q.jsx)(ft, {
						content: qm.SELECT_SOURCE,
						placement: "top",
						className: "default-tt",
						arrow: !1,
						children: e
					}),
					children: /* @__PURE__ */ (0, Q.jsx)("div", {
						className: "flexbox",
						children: /* @__PURE__ */ (0, Q.jsx)("button", {
							className: "cta secondary pl-12 pr-12 pt-5 pb-5 h-28 flex",
							type: "button",
							onClick: (e) => {
								e.stopPropagation(), t(!0);
							},
							disabled: n,
							"data-testid": "sync-env-deploy-to-btn",
							children: Um.DEPLOY_TO
						})
					})
				})
			})
		]
	}) : null;
}
//#endregion
//#region src/Components/EphemeralEnv/SyncEnvironment/utils.tsx
var PD = (e, t, n) => {
	let r = n?.nodes?.reduce((e, t) => (t.environmentId && (e[t.environmentId] = !0), e), {}) ?? {};
	return t.map((t) => r[t.environmentId] ? {
		pipeline: t,
		environmentStatus: jD.SELECTED
	} : e[t.ciPipelineId] ? {
		pipeline: t,
		environmentStatus: jD.CYCLIC
	} : {
		pipeline: t,
		environmentStatus: jD.ALLOWED
	});
}, FD = (e, t, n) => e ? n.result.map((e) => ({
	environmentId: e.id,
	environmentStatus: t.some((t) => t.pipeline.environmentId === e.id) ? jD.PRESENT : jD.ALLOWED,
	isProd: e.default,
	envName: e.environment_name
})) : t.map((e) => ({
	environmentId: e.pipeline.environmentId,
	environmentStatus: e.environmentStatus,
	isProd: e.pipeline.isProdEnv,
	envName: e.pipeline.environmentName,
	pipelineId: e.pipeline.parentPipelineId
})), ID = (e) => e === jD.SELECTED ? qm.DISABLED_RADIO.SELECTED : e === jD.CYCLIC ? qm.DISABLED_RADIO.CYCLIC : e === jD.PRESENT ? qm.DISABLED_RADIO.PRESENT : null;
//#endregion
//#region src/Components/EphemeralEnv/SyncEnvironment/SelectEnvBlock.tsx
function LD({ selectedId: e, environmentStatus: t, handleSelect: n, isProd: r, envName: i, envId: a, groupName: o, setSelectedDeploymentIdEnvName: s }) {
	let [c, l] = j(!1), u = t === jD.ALLOWED ? "" : "dc__disabled";
	return /* @__PURE__ */ (0, Q.jsx)(es, {
		wrap: (e) => /* @__PURE__ */ (0, Q.jsx)(ft, {
			content: ID(t),
			placement: "left",
			className: "default-tt w-200",
			arrow: !1,
			children: e
		}),
		condition: t !== jD.ALLOWED,
		children: /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: `flexbox dc__align-items-center dc__gap-12 dc__hover-n50 w-100 ${c ? "bg__secondary" : ""}`,
			children: [/* @__PURE__ */ (0, Q.jsx)("input", {
				type: "radio",
				id: `${o}-${a}`,
				name: o,
				value: a,
				checked: e === a,
				onChange: (e) => {
					n(Number(e.target.value)), s?.(i);
				},
				disabled: t !== jD.ALLOWED,
				className: `h-20 cursor dc__hover-border-n300 m-0 dc__outline-none-imp ${u}`,
				onFocus: () => {
					l(!0);
				},
				onBlur: () => {
					l(!1);
				},
				"data-testid": `${o}-${a}`
			}), /* @__PURE__ */ (0, Q.jsxs)("label", {
				htmlFor: `${o}-${a}`,
				className: `m-0 w-100 pt-8 pb-8 flexbox dc__align-items-center dc__gap-6 cursor cn-9 fs-13 fw-4 lh-20 ${u}`,
				children: [i, r && /* @__PURE__ */ (0, Q.jsx)("span", {
					className: "fs-10 fw-6 cn-7 lh-12 p-4 flex br-4 dc__border bg__secondary h-20",
					children: "Prod"
				})]
			})]
		})
	});
}
//#endregion
//#region src/Components/EphemeralEnv/SyncEnvironment/SyncEnvironmentBody.tsx
function RD({ sourceCandidatePipelines: e, selectedId: t, setSelectedId: n, fetchAllEnvironments: r, setSelectedDeploymentIdEnvName: i }) {
	let [a, o, s, c] = hf($t, [r], r), [l, u] = j([]), [d, f] = j([]);
	k(() => {
		if (r) {
			if (!a && o?.result) {
				let t = FD(r, e, o);
				u(t), f(t);
			}
		} else {
			let t = FD(r, e);
			u(t), f(t);
		}
	}, [
		o,
		a,
		r,
		e
	]);
	let p = Ka((e) => {
		let t = e.toLowerCase().trim();
		f(l.filter((e) => e.envName.toLowerCase().includes(t)));
	}, [l]), m = (e) => {
		n(e);
	};
	return a ? /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox-col pl-16 pr-16 w-100",
		children: [/* @__PURE__ */ (0, Q.jsx)("div", {
			className: "pt-8 pb-8",
			children: /* @__PURE__ */ (0, Q.jsx)("div", { className: "shimmer-loading h-32 pt-8 pb-8 w-100" })
		}), ((e) => /* @__PURE__ */ (0, Q.jsx)(Q.Fragment, { children: Array.from(Array(e).keys()).map((e) => /* @__PURE__ */ (0, Q.jsx)("div", {
			className: "pt-8 pb-8 h-36",
			children: /* @__PURE__ */ (0, Q.jsx)("div", { className: "shimmer-loading h-20 w-50" })
		}, e)) }))(3)]
	}) : s ? (K(s), /* @__PURE__ */ (0, Q.jsx)("div", {
		className: "flexbox pl-16 pr-16 w-100",
		children: /* @__PURE__ */ (0, Q.jsx)(Sl, {
			reload: c,
			className: "dc__overflow-auto"
		})
	})) : /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox-col pl-16 pr-16 w-100 dc__border-right",
		children: [/* @__PURE__ */ (0, Q.jsx)("div", {
			className: "pt-8 pb-8",
			children: /* @__PURE__ */ (0, Q.jsx)(Ss, {
				onSearch: p,
				placeholder: zm,
				containerClass: "w-100 h-32 flexbox pl-6 pr-6 pt-10 pb-10 dc__gap-8 dc__align-self-stretch dc__align-items-center bg__secondary dc__border dc__border-radius-4-imp focus-within-border-b5 dc__hover-border-n300",
				inputClass: "flex-grow-1 dc__no-border dc__outline-none-imp bg__secondary lh-20 fs-13 cn-9 fw-4 p-0 placeholder-cn5",
				Icon: Nn,
				iconClass: "icon-dim-16 icon-n2",
				autoFocus: !1
			})
		}), /* @__PURE__ */ (0, Q.jsx)("div", {
			className: "flexbox-col dc__overflow-auto h-100",
			children: d.length > 0 ? d.map((e) => /* @__PURE__ */ (0, Q.jsx)(LD, {
				selectedId: t,
				environmentStatus: e.environmentStatus,
				handleSelect: m,
				isProd: e.isProd,
				envName: e.envName,
				envId: e.environmentId,
				groupName: r ? Wm.DEPLOY_TO : Wm.IMAGE_SOURCE,
				setSelectedDeploymentIdEnvName: i
			}, e.environmentId)) : /* @__PURE__ */ (0, Q.jsx)(R, {
				title: Gm.NO_SEARCH_ENV.TITLE,
				subTitle: Gm.NO_SEARCH_ENV.SUBTITLE
			})
		})]
	});
}
//#endregion
//#region src/Components/EphemeralEnv/SyncEnvironment/SyncEnvironmentHeader.tsx
var zD = ({ closeModal: e }) => /* @__PURE__ */ (0, Q.jsxs)("div", {
	className: "w-100 flexbox dc__content-space dc__align-items-center dc__border-bottom pt-12 pb-12 pr-16 pl-16",
	children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox dc__align-items-center dc__gap-8",
		children: [/* @__PURE__ */ (0, Q.jsx)("h2", {
			className: "m-0 cn-9 fs-16 fw-6 lh-24",
			children: Lm
		}), /* @__PURE__ */ (0, Q.jsx)(Cc, {
			infoText: Bm,
			heading: Vm,
			iconClassName: "icon-dim-20"
		})]
	}), /* @__PURE__ */ (0, Q.jsx)("button", {
		className: "h-20 dc__no-background dc__no-border dc__outline-none-imp p-0",
		type: "button",
		"aria-label": "close-modal",
		onClick: e,
		children: /* @__PURE__ */ (0, Q.jsx)(tr, { className: "icon-dim-20 fcn-6" })
	})]
}), BD = /* @__PURE__ */ t({ default: () => VD });
function VD({ closeModal: e, cdPipelines: t, blackListedIds: n, getWorkflows: r, workflows: i, isTemplateView: a }) {
	let o = () => {
		e();
	}, s = Ja(null);
	vf(s, o);
	let { appId: c, workflowId: l } = Z(), u = Yf(), [d, f] = j(null), [p, m] = j(null), [h, g] = j(null), [_, v] = j(!1), [y, b] = j([]), [x, S] = j(!1), [C, w, T] = A(() => {
		let e = new URLSearchParams(u.search);
		return [
			e.get("changeCi") ?? "0",
			e.get("switchFromCiPipelineId") ?? "0",
			e.get("switchFromExternalCiPipelineId") ?? "0"
		];
	}, [u.search]), ee = C === "0" && l !== "0" && w !== "0", E = x ? qm.LOADING_REQUEST : d ? null : qm.SELECT_SOURCE;
	return k(() => {
		let e = Number(w), r = PD(n, t, i.find((e) => e.id === l));
		if (b(r), e && n[e]) {
			let t = n[e].parentCiPipeline;
			f(r.find((e) => e.pipeline.id === t)?.pipeline.environmentId ?? null);
		}
	}, [
		n,
		w,
		T,
		t
	]), /* @__PURE__ */ (0, Q.jsx)(Rs, {
		position: "right",
		onEscape: o,
		children: /* @__PURE__ */ (0, Q.jsxs)("form", {
			className: `flexbox-col dc__content-space sync-environment-drawer flex-grow-1 bg__primary ${_ ? "drawer-open" : ""}`,
			ref: s,
			onClick: uf,
			onSubmit: (n) => {
				n.preventDefault();
				let i = Number(w), o = Number(T), s = Number(l), u = t.find((e) => e.environmentId === d);
				if (!u) {
					H.showToast({
						variant: U.error,
						description: Km.NO_SOURCE_SELECTED
					});
					return;
				}
				S(!0);
				let f = {
					appId: Number(c),
					action: MD.CREATE,
					parentCDPipeline: u.id
				};
				p && (f.deployEnvId = p), s > 0 && (f.appWorkflowId = s), i > 0 ? f.switchFromCiPipelineId = i : o > 0 && (f.switchFromExternalCiPipelineId = o), OD(f, a).then(() => {
					S(!1), H.showToast({
						variant: U.success,
						description: Km.CREATION
					}), f.deployEnvId ? e(!0, f.deployEnvId, h, Hm, !1) : e(), r();
				}).catch((e) => {
					S(!1), K(e);
				});
			},
			onKeyPress: (e) => {
				let t = e.key === "Enter", n = e.target instanceof HTMLInputElement && e.target.placeholder === "Search environment";
				t && n && e.preventDefault();
			},
			children: [
				/* @__PURE__ */ (0, Q.jsx)(zD, { closeModal: o }),
				/* @__PURE__ */ (0, Q.jsx)(ND, {
					view: _ ? AD.CREATE_DEPLOY : Number(l) === 0 ? AD.CREATE_NO_DEPLOY : AD.UPDATE,
					setShowDeploymentModal: v,
					disableDeploy: !d
				}),
				/* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "flexbox h-100 dc__overflow-auto",
					children: [/* @__PURE__ */ (0, Q.jsx)(RD, {
						sourceCandidatePipelines: y,
						selectedId: d,
						setSelectedId: f,
						fetchAllEnvironments: !1
					}), _ && /* @__PURE__ */ (0, Q.jsx)(RD, {
						sourceCandidatePipelines: y,
						selectedId: p,
						setSelectedId: m,
						fetchAllEnvironments: !0,
						setSelectedDeploymentIdEnvName: g
					})]
				}),
				/* @__PURE__ */ (0, Q.jsxs)("div", {
					className: `flexbox pt-16 pb-16 pl-20 pr-20 dc__gap-12 dc__align-items-center dc__border-top ${ee ? "dc__content-space" : "dc__content-end"}`,
					children: [ee && /* @__PURE__ */ (0, Q.jsx)(ws, {
						testId: "delete-linked-pipeline",
						disabled: x,
						deletePayloadConfig: {
							appId: c,
							appWorkflowId: Number(l),
							pipelineId: Number(w),
							pipelineName: n[Number(w)]?.name
						},
						title: "sync with environment",
						getWorkflows: r,
						showIconOnly: !1,
						onDelete: e,
						isTemplateView: a
					}), /* @__PURE__ */ (0, Q.jsx)(es, {
						condition: !!E,
						wrap: (e) => /* @__PURE__ */ (0, Q.jsx)(ft, {
							content: E,
							placement: "top",
							className: "default-tt",
							arrow: !1,
							children: e
						}),
						children: /* @__PURE__ */ (0, Q.jsx)("div", {
							className: "flexbox dc__align-items-center",
							children: /* @__PURE__ */ (0, Q.jsx)("button", {
								className: "cta flex pt-6 pb-6 pl-12 pr-12 fs-13 fw-6 lh-20 h-32",
								type: "submit",
								disabled: !!E,
								"data-testid": "linked-cd-create-pipeline-button",
								children: x ? /* @__PURE__ */ (0, Q.jsx)(ul, { size: 16 }) : C !== "0" || w !== "0" || T !== "0" ? Um.UPDATE_PIPELINE : Um.CREATE_PIPELINE
							})
						})
					})]
				})
			]
		})
	});
}
//#endregion
//#region src/Assets/Icons/ic-calendar-blocked.svg?react
var HD = (e) => /* @__PURE__ */ (0, Q.jsxs)("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [/* @__PURE__ */ (0, Q.jsx)("path", {
		d: "M16.5 2.25V5.25M7.5 2.25V5.25M3 9.25H21V6C21 4.89543 20.1046 4 19 4H5C3.89543 4 3 4.89543 3 6V19C3 20.1046 3.89543 21 5 21H9",
		stroke: "#596168",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ (0, Q.jsx)("path", {
		d: "M13.4645 13.4645L20.5355 20.5355M22 17C22 19.7614 19.7614 22 17 22C14.2386 22 12 19.7614 12 17C12 14.2386 14.2386 12 17 12C19.7614 12 22 14.2386 22 17Z",
		stroke: "#596168",
		strokeWidth: 1.5,
		strokeLinecap: "round"
	})]
}), UD = (e) => /* @__PURE__ */ (0, Q.jsx)("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	...e,
	children: /* @__PURE__ */ (0, Q.jsx)("g", {
		fill: "none",
		fillRule: "evenodd",
		children: /* @__PURE__ */ (0, Q.jsx)("g", { children: /* @__PURE__ */ (0, Q.jsx)("g", { children: /* @__PURE__ */ (0, Q.jsx)("g", { children: /* @__PURE__ */ (0, Q.jsxs)("g", { children: [/* @__PURE__ */ (0, Q.jsx)("path", {
			fill: "#8898A6",
			d: "M5.07 3.99l1.728 1.728c.219.22.219.575 0 .795L5.513 7.798c-.22.219-.575.219-.795 0L2.99 6.069c-.118-.118-.32-.063-.364.098-.328 1.21-.017 2.557.933 3.507 1.034 1.034 2.538 1.31 3.824.83l7.48 8.18c.767.84 2.08.87 2.885.064.809-.808.775-2.13-.074-2.895L9.476 8.459c.52-1.302.253-2.846-.802-3.9-.95-.95-2.297-1.26-3.507-.933-.161.044-.216.246-.098.364zm11.822 13.332c0 .33-.268.599-.598.599-.33 0-.599-.268-.599-.599 0-.33.268-.598.599-.598.33 0 .598.268.598.598z",
			transform: "translate(-762 -518) translate(288 288) translate(0 220) translate(474 9) matrix(-1 0 0 1 20.833 0)"
		}), /* @__PURE__ */ (0, Q.jsxs)("g", { children: [/* @__PURE__ */ (0, Q.jsx)("path", {
			fill: "#F4910D",
			d: "M3.623 3.623h2.899V16.79c0 .552-.448 1-1 1h-.899c-.552 0-1-.448-1-1V3.623z",
			transform: "translate(-762 -518) translate(288 288) translate(0 220) translate(474 9) rotate(-45 10.841 3.882)"
		}), /* @__PURE__ */ (0, Q.jsx)("path", {
			fill: "#66757F",
			d: "M1 4.076h.812l.31-.233c.262-.196.634-.143.83.118.027.036.05.074.067.115h3.624l.5-.644c.351-.45.89-.715 1.462-.715.58 0 1.136.23 1.546.64l.719.72c0-2.265-1.007-3.398-3.02-3.398H2.865c-.286 0-.558-.122-.748-.335L1.812 0H1C.448 0 0 .448 0 1v2.076c0 .552.448 1 1 1z",
			transform: "translate(-762 -518) translate(288 288) translate(0 220) translate(474 9) rotate(-45 10.841 3.882)"
		})] })] }) }) }) })
	})
}), WD = (e) => /* @__PURE__ */ (0, Q.jsxs)("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "0 0 24 24",
	...e,
	children: [/* @__PURE__ */ (0, Q.jsx)("path", {
		stroke: "#596168",
		strokeWidth: 1.5,
		d: "M12 22C6.48 22 2 17.52 2 12S6.48 2 12 2s10 4.48 10 10-4.48 10-10 10Z",
		clipRule: "evenodd"
	}), /* @__PURE__ */ (0, Q.jsx)("path", {
		fill: "#596168",
		fillRule: "evenodd",
		d: "M12 15a1 1 0 1 1 0 2 1 1 0 0 1 0-2Zm0-8a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0V8a1 1 0 0 1 1-1Z",
		clipRule: "evenodd"
	})]
}), GD = /* @__PURE__ */ t({ default: () => qD }), KD = () => /* @__PURE__ */ (0, Q.jsx)("i", {
	className: "cn-6",
	children: " (at the time image was available)"
});
function qD({ children: e, commitTimestamp: t, appliedFiltersTimestamp: n, envName: i, showConfiguredFilters: a, filterState: o, dataSource: s, deploymentWindowArtifactMetadata: c, isFilterApplied: l, triggerBlockedInfo: u }) {
	return /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox p-12 dc__gap-8",
		children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
			className: `${e ? "h-250" : "h-48"}`,
			children: [
				/* @__PURE__ */ (0, Q.jsx)("div", {
					className: "h-20 dc__border-radius-50-per dc__border flex w-20",
					children: s === Rc.EXTERNAL ? /* @__PURE__ */ (0, Q.jsx)(Ui, { className: "icon-dim-12" }) : /* @__PURE__ */ (0, Q.jsx)(UD, { className: "icon-dim-12" })
				}),
				/* @__PURE__ */ (0, Q.jsx)("div", {
					className: "flex w-100",
					children: /* @__PURE__ */ (0, Q.jsx)("div", {
						style: {
							width: "1px",
							height: e ? "205px" : "16px"
						},
						className: "bcn-2 flex"
					})
				}),
				/* @__PURE__ */ (0, Q.jsx)("div", {
					className: "h-20 dc__border-radius-50-per dc__border flex w-20",
					children: /* @__PURE__ */ (0, Q.jsx)(he, { className: "icon-dim-12" })
				})
			]
		}), /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox-col flex-grow-1",
			children: [/* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsxs)("p", {
				className: "fs-13 fw-6 lh-16 cn-6 m-0 pb-4",
				children: [s === Rc.EXTERNAL ? r.EXTERNAL : r.COMMIT, /* @__PURE__ */ (0, Q.jsxs)("span", {
					className: "cn-6 fs-12 fw-4 lh-16 m-0",
					children: [
						" ",
						t,
						" "
					]
				})]
			}), e && /* @__PURE__ */ (0, Q.jsx)("div", {
				className: "bg__primary en-2 bw-1 br-4",
				children: e
			})] }), /* @__PURE__ */ (0, Q.jsxs)("div", {
				className: `flexbox-col dc_gap-8 ${e ? "pt-24" : "pt-16"}`,
				children: [/* @__PURE__ */ (0, Q.jsx)("div", {
					className: "flexbox h-20 dc__align-items-center dc__gap-6",
					children: /* @__PURE__ */ (0, Q.jsxs)("p", {
						className: "fs-13 fw-6 lh-16 cn-6 m-0 pb-4",
						children: [
							"Image available at ",
							i,
							n !== Eu && /* @__PURE__ */ (0, Q.jsx)("span", {
								className: "cn-6 fs-12 fw-4 lh-16 m-0",
								children: n
							})
						]
					})
				}), /* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "flexbox-col pt-8 pb-8 pl-12 pr-12 dc__gap-8 br-4 dc__border bg__primary",
					children: [
						/* @__PURE__ */ (0, Q.jsxs)("div", {
							className: "flexbox dc__align-items-center dc__gap-8 dc__align-self-stretch",
							children: [/* @__PURE__ */ (0, Q.jsx)(Pr, { className: "icon-dim-16 scn-6" }), /* @__PURE__ */ (0, Q.jsxs)("p", {
								className: "m-0 fs-13 fw-4 lh-20 cn-9",
								children: ["Trigger mode was ", /* @__PURE__ */ (0, Q.jsx)("span", {
									className: "m-0 fw-6",
									children: "automatic"
								})]
							})]
						}),
						l ? /* @__PURE__ */ (0, Q.jsxs)("div", {
							className: "flexbox dc__align-items-center dc__gap-8 dc__align-self-stretch",
							children: [/* @__PURE__ */ (0, Q.jsx)(ur, { className: "icon-dim-16" }), /* @__PURE__ */ (0, Q.jsxs)("p", {
								className: "m-0 fs-13 fw-4 lh-20 cn-9",
								children: [
									/* @__PURE__ */ (0, Q.jsxs)("span", {
										className: `m-0 ${o === ec.ALLOWED ? "cg-5" : "cr-5"}`,
										children: [o === ec.ALLOWED ? "Image was eligible" : "Image was not eligible", "\xA0"]
									}),
									/* @__PURE__ */ (0, Q.jsx)("span", {
										className: "m-0",
										children: "for deployment due to "
									}),
									/* @__PURE__ */ (0, Q.jsx)("button", {
										className: "cb-5 dc__underline-onhover cursor bg__primary dc__outline-none-imp p-0 dc__no-border",
										type: "button",
										onClick: a,
										children: "configured filter"
									}),
									KD()
								]
							})]
						}) : null,
						u?.isBlocked && u?.blockedBy ? /* @__PURE__ */ (0, Q.jsxs)("div", {
							className: "flexbox dc__align-start dc__gap-8 dc__align-self-stretch fs-13 fw-4 lh-20",
							children: [/* @__PURE__ */ (0, Q.jsx)(WD, { className: "icon-dim-16 dc__no-shrink" }), /* @__PURE__ */ (0, Q.jsxs)("div", { children: [
								/* @__PURE__ */ (0, Q.jsx)("span", {
									className: "cr-5",
									children: "Auto trigger failed"
								}),
								"\xA0",
								/* @__PURE__ */ (0, Q.jsxs)("span", {
									className: "cn-9",
									children: ["because ", u.reason]
								}),
								KD()
							] })]
						}) : null,
						c?.type ? /* @__PURE__ */ (0, Q.jsxs)("div", {
							className: "flexbox dc__align-items-center dc__gap-8 dc__align-self-stretch",
							children: [/* @__PURE__ */ (0, Q.jsx)(HD, { className: "icon-dim-16" }), /* @__PURE__ */ (0, Q.jsxs)("p", {
								className: "m-0 fs-13 fw-4 lh-20 cn-9",
								children: [/* @__PURE__ */ (0, Q.jsx)("span", {
									className: "m-0 cr-5",
									children: "Deployment was blocked\xA0"
								}), /* @__PURE__ */ (0, Q.jsx)("span", {
									className: "m-0",
									children: c.type === ms.MAINTENANCE ? "as it was initiated outside maintenance window" : `as it was initiated during blackout window '${c.name}'`
								})]
							})]
						}) : null
					]
				})]
			})]
		})]
	});
}
//#endregion
//#region src/Components/Filters/FilterConditions/Descriptor.tsx
function JD({ onSearch: e }) {
	let t = X();
	return /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox pt-16 pb-8 pl-20 pr-20 dc__align-items-center dc__content-space",
		children: [/* @__PURE__ */ (0, Q.jsx)(Xs, {
			title: on.FILTER_CONDITION.title,
			renderDescriptionContent: () => In,
			showInfoIconTippy: !0,
			docLink: "GLOBAL_CONFIG_FILTER_CONDITION"
		}), !!e && /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flex dc__content-start dc__gap-8",
			children: [
				/* @__PURE__ */ (0, Q.jsx)(Ss, {
					onSearch: e,
					placeholder: "Search",
					containerClass: "w-240 h-32 flexbox pl-6 pr-6 pt-10 pb-10 dc__gap-8 dc__align-self-stretch dc__align-items-center bg__secondary dc__border dc__border-radius-4-imp focus-within-border-b5 dc__hover-border-n300",
					inputClass: "flex-grow-1 dc__no-border dc__outline-none-imp bg__secondary lh-20 fs-13 cn-9 fw-4 p-0 placeholder-cn5",
					Icon: Nn,
					iconClass: "icon-dim-16 icon-n2"
				}),
				/* @__PURE__ */ (0, Q.jsx)("div", { className: "h-20 dc__border-left" }),
				/* @__PURE__ */ (0, Q.jsxs)("button", {
					className: "cta flex h-32 pl-8-imp",
					type: "button",
					onClick: () => {
						t(B.APPLICATION_MANAGEMENT_POLICIES.FILTER_CONDITIONS.ADD);
					},
					children: [/* @__PURE__ */ (0, Q.jsx)(E, { className: "icon-dim-14 mr-6" }), "Add"]
				})
			]
		})]
	});
}
//#endregion
//#region src/Components/Filters/FilterConditions/Utils.tsx
var YD = (e, t) => {
	if (!/^.{3,50}$/.test(e)) {
		t((e) => ({
			...e,
			name: "Minimum 3 and maximum 50 characters allowed"
		}));
		return;
	}
	if (!/^[a-z0-9-._]+$/.test(e)) {
		t((e) => ({
			...e,
			name: "Only lowercase alphanumeric characters, -, _ or . allowed"
		}));
		return;
	}
	if (!/^(?![-._]).*[^-._]$/.test(e)) {
		t((e) => ({
			...e,
			name: "Cannot start/end with -, _ or ."
		}));
		return;
	}
	t((e) => ({
		...e,
		name: null
	}));
}, XD = (e, t) => {
	e.conditions?.length || t((e) => ({
		...e,
		minConditions: "At least one condition is required."
	})), t((e) => ({
		...e,
		minConditions: null
	}));
}, ZD = (e, t) => {
	(e.qualifierSelector.applicationSelectors.length === 0 || e.qualifierSelector.environmentSelectors.length === 0) && t((e) => ({
		...e,
		minScopes: "Both application and environment scopes are required."
	})), t((e) => ({
		...e,
		minScopes: null
	}));
}, QD = (e, t, n) => {
	switch (e) {
		case Dt.NAME:
			YD(t.name, n);
			break;
		case Dt.MIN_CONDITIONS:
			XD(t, n);
			break;
		default:
			YD(t.name, n), XD(t, n), ZD(t, n);
			break;
	}
}, $D = (e) => /* @__PURE__ */ (0, Q.jsx)(Ko, {
	...e,
	children: /* @__PURE__ */ (0, Q.jsx)(ba, { className: "icon-dim-16 icon-fill-n4" })
}), eO = ({ selectProps: e, children: t, ...n }) => {
	let r = e.value?.filter((e) => !e.value.startsWith(vn.AllFuture) && !e.value.startsWith(vn.AllExisting) && !e.value.startsWith(vn.AllProd) && !e.value.startsWith(vn.AllNonProd)).length ?? 0, i = {
		selectProps: e,
		children: t,
		...n
	}, a = () => {
		let t = e.value?.length === 0;
		return !e.menuIsOpen || !e.inputValue ? t ? /* @__PURE__ */ (0, Q.jsx)("span", {
			className: "cn-4 pl-4 dc__position-abs",
			children: e.placeholder
		}) : /* @__PURE__ */ (0, Q.jsxs)("span", {
			className: "cn-9 pl-4",
			children: [
				e.name,
				"\xA0",
				/* @__PURE__ */ (0, Q.jsx)("span", {
					className: "bcb-5 cn-0 fw-6 fs-12 br-8 pr-5 pl-5",
					children: r
				})
			]
		}) : null;
	};
	return /* @__PURE__ */ (0, Q.jsxs)(tp.ValueContainer, {
		...i,
		children: [a(), Ha(t[1])]
	});
};
function tO({ label: e, isProd: t, value: n, ...r }) {
	return /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox dc__align-items-center dc__gap-8",
		children: [/* @__PURE__ */ (0, Q.jsx)("p", {
			className: `flex m-0 ${n.startsWith(vn.AllFuture) || n.startsWith(vn.AllExisting) || n.startsWith(vn.AllProd) || n.startsWith(vn.AllNonProd) ? "fw-6" : "fw-4"}`,
			children: e
		}), !!t && !n.startsWith(vn.AllProd) && /* @__PURE__ */ (0, Q.jsx)("div", {
			className: "dc__border flex pt-0 pb-0 pl-8 pr-8 br-4 flex h-20 dc__no-shrink",
			children: /* @__PURE__ */ (0, Q.jsx)("i", {
				className: "m-0 cn-6 fs-12 fw-4 lh-20",
				children: "Prod"
			})
		})]
	});
}
var nO = (e) => {
	let [t, n] = j({
		application: [],
		environment: []
	}), [r, i] = j([]), [a, o] = j([]), [s, c] = j(!0), [l, u] = j(null), d = t.environment.flatMap((e) => e.options.filter((e) => e.isProd)), f = t.environment.flatMap((e) => e.options.filter((e) => !e.isProd && e.isProd !== null)), p = () => {
		let e = [];
		if (r.findIndex((e) => e.value === `${vn.AllFuture}`) !== -1) e.push({
			projectName: qn.AllFutureProject,
			applications: []
		});
		else {
			let t = r.filter((e) => e.value.startsWith(vn.AllFuture)), n = [];
			t.length > 0 && t.forEach((t) => {
				e.push({
					projectName: t.projectName,
					applications: []
				}), n.push(t.projectName);
			}), r.forEach((t) => {
				if (!t.value.startsWith(vn.AllExisting)) {
					let r = e.findIndex((e) => e.projectName === t.projectName) !== -1, i = n.includes(t.projectName);
					!r && !i ? e.push({
						projectName: t.projectName,
						applications: [t.value]
					}) : i || e[e.findIndex((e) => e.projectName === t.projectName)].applications.push(t.value);
				}
			});
		}
		let t = [], n = a.findIndex((e) => e.value === `${vn.AllProd}`) !== -1, i = a.findIndex((e) => e.value === `${vn.AllNonProd}`) !== -1, o = a;
		if (n && i) t.push({
			clusterName: qn.AllFutureProdCluster,
			environments: []
		}, {
			clusterName: qn.AllFutureNonProdCluster,
			environments: []
		});
		else if (n) {
			t.push({
				clusterName: qn.AllFutureProdCluster,
				environments: []
			});
			let e = [], n = o.filter((e) => e.value.startsWith(vn.AllFuture));
			n.length > 0 && n.forEach((n) => {
				t.push({
					clusterName: n.clusterName,
					environments: []
				}), e.push(n.clusterName);
			}), o = o.filter((t) => !t.isProd && t.isProd !== null && !e.includes(t.clusterName)), o.forEach((e) => {
				e.clusterName !== qn.AllFutureNonProdCluster && (t.findIndex((t) => t.clusterName === e.clusterName) === -1 ? t.push({
					clusterName: e.clusterName,
					environments: [e.value]
				}) : t[t.findIndex((t) => t.clusterName === e.clusterName)].environments.push(e.value));
			});
		} else if (i) {
			t.push({
				clusterName: qn.AllFutureNonProdCluster,
				environments: []
			});
			let e = [], n = o.filter((e) => e.value.startsWith(vn.AllFuture));
			n.length > 0 && n.forEach((n) => {
				t.push({
					clusterName: n.clusterName,
					environments: []
				}), e.push(n.clusterName);
			}), o = o.filter((t) => t.isProd && t.isProd !== null && !e.includes(t.clusterName)), o.forEach((e) => {
				e.clusterName !== qn.AllFutureProdCluster && (t.findIndex((t) => t.clusterName === e.clusterName) === -1 ? t.push({
					clusterName: e.clusterName,
					environments: [e.value]
				}) : t[t.findIndex((t) => t.clusterName === e.clusterName)].environments.push(e.value));
			});
		} else {
			let e = a.filter((e) => e.value.startsWith(vn.AllFuture)), n = [];
			e.length > 0 && e.forEach((e) => {
				t.push({
					clusterName: e.clusterName,
					environments: []
				}), n.push(e.clusterName);
			}), o.forEach((e) => {
				if (!e.value.startsWith(vn.AllExisting)) {
					let r = t.findIndex((t) => t.clusterName === e.clusterName) !== -1, i = n.includes(e.clusterName);
					!r && !i ? t.push({
						clusterName: e.clusterName,
						environments: [e.value]
					}) : i || t[t.findIndex((t) => t.clusterName === e.clusterName)].environments.push(e.value);
				}
			});
		}
		return {
			applicationSelectors: e,
			environmentSelectors: t
		};
	}, m = () => {
		c(!0), u(null), Promise.all([xe(), $t()]).then((t) => {
			let [r, a] = t.map((e) => e.result);
			if (r.length > 0 && a.length > 0) {
				let t = [], s = r.map((e) => ({
					label: `Project: ${e.projectName}`,
					options: [
						{
							label: `All existing + future applications in ‘${e.projectName}’`,
							value: `${vn.AllFuture}_${e.projectName}`,
							projectName: e.projectName
						},
						{
							label: `All existing applications in ‘${e.projectName}’`,
							value: `${vn.AllExisting}_${e.projectName}`,
							projectName: e.projectName
						},
						...e.appList.map((t) => ({
							label: t.name,
							value: t.name,
							projectName: e.projectName
						})).sort((e, t) => e.label.localeCompare(t.label))
					],
					projectName: e.projectName
				})), c = a.reduce((e, t) => {
					let n = e;
					return n[t.cluster_name] = n[t.cluster_name] || [], n[t.cluster_name].push({
						label: t.environment_name,
						value: t.environment_name,
						clusterName: t.cluster_name,
						isProd: !!t.default
					}), n;
				}, {});
				if (Object.keys(c).forEach((e) => {
					let n = c[e];
					t.push({
						label: `Cluster: ${e}`,
						options: [
							{
								label: `All existing + future environments in ‘${e}’`,
								value: `${vn.AllFuture}_${e}`,
								clusterName: e,
								isProd: null
							},
							{
								label: `All existing environments in ‘${e}’`,
								value: `${vn.AllExisting}_${e}`,
								clusterName: e,
								isProd: null
							},
							...n.sort((e, t) => e.label.localeCompare(t.label))
						],
						clusterName: e
					});
				}), s.sort((e, t) => e.projectName.localeCompare(t.projectName)), t.sort((e, t) => e.clusterName.localeCompare(t.clusterName)), s.unshift({
					label: "All Applications",
					options: [{
						label: "All existing + future applications",
						value: `${vn.AllFuture}`,
						projectName: qn.AllFutureProject
					}, {
						label: "All existing applications",
						value: `${vn.AllExisting}`,
						projectName: ""
					}],
					projectName: qn.ProjectGlobalLabel
				}), t.unshift({
					label: "All Environments",
					options: [{
						label: "All existing + future prod environments",
						value: `${vn.AllProd}`,
						clusterName: qn.AllFutureProdCluster,
						isProd: !0
					}, {
						label: "All existing + future non-prod environments",
						value: `${vn.AllNonProd}`,
						clusterName: qn.AllFutureNonProdCluster,
						isProd: !1
					}],
					clusterName: qn.ClusterGlobalLabel
				}), e) {
					let n = [], r = [], a = e.qualifierSelector.applicationSelectors, c = e.qualifierSelector.environmentSelectors;
					a.forEach((e) => {
						if (e.projectName === qn.AllFutureProject) s.forEach((e) => {
							e.options.forEach((e) => {
								n.push(e);
							});
						});
						else if (e.applications.length === 0) s.find((t) => t.projectName === e.projectName).options.forEach((e) => {
							n.push(e);
						});
						else {
							let t = s.find((t) => t.projectName === e.projectName).options;
							e.applications.length === t.length - 2 ? t.forEach((t) => {
								t.value !== `${vn.AllFuture}_${e.projectName}` && n.push(t);
							}) : e.applications.length === 0 ? t.forEach((e) => {
								n.push(e);
							}) : t.forEach((t) => {
								e.applications.includes(t.value) && n.push(t);
							});
						}
					});
					let l = !0, u = [...new Set(n)];
					for (let e = 1; e < s.length; e += 1) {
						let t = s[e], n = u.filter((e) => e.projectName === t.projectName);
						if (!(n && n?.findIndex((e) => e.value === `${vn.AllExisting}_${t.projectName}`) !== -1)) {
							l = !1;
							break;
						}
					}
					if (l) {
						let e = s[0].options[1];
						n.push(e);
					}
					i([...new Set(n)]);
					let d = c.findIndex((e) => e.clusterName === qn.AllFutureProdCluster) !== -1;
					c.findIndex((e) => e.clusterName === qn.AllFutureNonProdCluster) !== -1 && d ? t.forEach((e) => {
						e.options.forEach((e) => {
							r.push(e);
						});
					}) : c.forEach((e) => {
						if (e.clusterName === qn.AllFutureProdCluster) t.forEach((e) => {
							let t = 0;
							e.options.forEach((e) => {
								e.isProd && (r.push(e), t += 1);
							}), t === e.options.length - 2 && r.push(e.options[1]);
						});
						else if (e.clusterName === qn.AllFutureNonProdCluster) t.forEach((e) => {
							let t = 0;
							e.options.forEach((e) => {
								!e.isProd && e.isProd !== null && (r.push(e), t += 1);
							}), t === e.options.length - 2 && r.push(e.options[1]);
						});
						else {
							let n = t.find((t) => t.clusterName === e.clusterName).options;
							e.environments.length === n.length - 2 ? n.forEach((t) => {
								t.value !== `${vn.AllFuture}_${e.clusterName}` && r.push(t);
							}) : e.environments.length === 0 ? n.forEach((e) => {
								r.push(e);
							}) : n.forEach((t) => {
								e.environments.includes(t.value) && r.push(t);
							});
						}
					}), o([...new Set(r)]);
				}
				n({
					application: s,
					environment: t
				});
			}
		}).catch((e) => {
			u(e);
		}).finally(() => {
			c(!1);
		});
	};
	return k(m, [e]), {
		conditionSelectOptions: t,
		selectedApplications: r,
		selectedEnvironments: a,
		handleApplicationConditionChange: (e) => {
			let n = e, a = n.findIndex((e) => e.projectName === qn.AllFutureProject) !== -1, o = r.findIndex((e) => e.projectName === qn.AllFutureProject) !== -1;
			if (a && !o) {
				i(t.application.flatMap((e) => e.options));
				return;
			}
			if (!a && o) {
				i([]);
				return;
			}
			n = n.filter((e) => e.projectName !== qn.AllFutureProject);
			let s = n.findIndex((e) => e.value === `${vn.AllExisting}`) !== -1, c = r.findIndex((e) => e.value === vn.AllExisting) !== -1;
			s && !c ? (n = n.filter((e) => !e.value.startsWith(vn.AllExisting)), n = [...t.application.flatMap((e) => e.options).filter((e) => e.value.startsWith(vn.AllExisting)), ...n]) : !s && c && (n = n.filter((e) => !e.value.startsWith(vn.AllExisting))), n = n.filter((e) => e.value !== vn.AllExisting), n = [...new Set(n)];
			let l = n.reduce((e, t) => {
				let n = e;
				return n[t.projectName] = n[t.projectName] || [], n[t.projectName].push(t), n;
			}, {}), u = {}, d = [];
			Object.keys(l).forEach((e) => {
				let n = l[e], i = `${vn.AllFuture}_${e}`, a = `${vn.AllExisting}_${e}`, o = r.findIndex((t) => t.projectName === e && t.value === i) !== -1, s = r.findIndex((t) => t.projectName === e && t.value === a) !== -1, c = n.findIndex((e) => e.value === i) !== -1, f = n.findIndex((e) => e.value === a) !== -1, p = n.filter((e) => e.value !== i && e.value !== a), m = t.application.find((t) => t.projectName === e).options, h = p.length === m.length - 2;
				if (o && (!c || !f) || s && !f) u[e] = [];
				else if (s && !o && c) u[e] = m, d.push({
					projectName: e,
					appNames: []
				});
				else if (!h && (o || s)) u[e] = p, d.push({
					projectName: e,
					appNames: p.map((e) => e.value)
				});
				else if (c) u[e] = m, d.push({
					projectName: e,
					appNames: []
				});
				else if (f || h) {
					let t = m.filter((e) => e.value !== i);
					u[e] = t, d.push({
						projectName: e,
						appNames: t.map((e) => e.value).filter((e) => e !== a)
					});
				} else u[e] = n, d.push({
					projectName: e,
					appNames: p.map((e) => e.value)
				});
			});
			let f = !0;
			for (let e = 1; e < t.application.length; e += 1) {
				let n = t.application[e], r = u?.[n.projectName];
				if (!(r && r?.findIndex((e) => e.value === `${vn.AllExisting}_${n.projectName}`) !== -1)) {
					f = !1;
					break;
				}
			}
			f && (u[""] = [t.application[0].options[1]]);
			let p = !0;
			for (let e = 1; e < t.application.length; e += 1) {
				let n = t.application[e], r = u[n.projectName];
				if (!(r && r?.findIndex((e) => e.value === `${vn.AllFuture}_${n.projectName}`) !== -1)) {
					p = !1;
					break;
				}
			}
			if (p && a) {
				let e = t.application[0].options[0];
				u[qn.AllFutureProject] = [e];
			}
			i(Object.values(u).flatMap((e) => e));
		},
		handleEnvironmentConditionChange: (e) => {
			let n = e, r = n.findIndex((e) => e.clusterName === qn.AllFutureProdCluster) !== -1, i = a.findIndex((e) => e.clusterName === qn.AllFutureProdCluster) !== -1;
			r && !i ? (n = n.filter((e) => e.clusterName !== qn.AllFutureProdCluster), n = [...t.environment.flatMap((e) => e.options).filter((e) => e.isProd), ...n]) : !r && i && (n = n.filter((e) => !e.isProd || e.isProd === null)), n = n.filter((e) => e.clusterName !== qn.AllFutureProdCluster);
			let s = n.findIndex((e) => e.clusterName === qn.AllFutureNonProdCluster) !== -1, c = a.findIndex((e) => e.clusterName === qn.AllFutureNonProdCluster) !== -1;
			if (s && !c ? (n = n.filter((e) => e.clusterName !== qn.AllFutureNonProdCluster), n = [...t.environment.flatMap((e) => e.options).filter((e) => !e.isProd && e.isProd !== null), ...n]) : !s && c && (n = n.filter((e) => e.isProd || e.isProd === null)), n = n.filter((e) => e.clusterName !== qn.AllFutureNonProdCluster), r && s && !(r && s && c && i)) {
				o(t.environment.flatMap((e) => e.options));
				return;
			}
			n = [...new Set(n)];
			let l = n.reduce((e, t) => {
				let n = e;
				return n[t.clusterName] = n[t.clusterName] || [], n[t.clusterName].push(t), n;
			}, {}), u = {}, p = [];
			Object.keys(l).forEach((e) => {
				let n = l[e], r = `${vn.AllFuture}_${e}`, i = `${vn.AllExisting}_${e}`, o = a.findIndex((t) => t.clusterName === e && t.value === r) !== -1, s = a.findIndex((t) => t.clusterName === e && t.value === i) !== -1, c = n.findIndex((e) => e.value === r) !== -1, d = n.findIndex((e) => e.value === i) !== -1, f = t.environment.find((t) => t.clusterName === e).options, m = n.filter((e) => e.value !== r && e.value !== i), h = m.length === f.length - 2;
				if (o && (!c || !d) || s && !d) u[e] = [];
				else if (s && !o && c) u[e] = f, p.push({
					clusterName: e,
					envNames: []
				});
				else if (!h && (o || s)) u[e] = m, p.push({
					clusterName: e,
					envNames: m.map((e) => e.value)
				});
				else if (c) u[e] = f, p.push({
					clusterName: e,
					envNames: []
				});
				else if (d || h) {
					let t = f.filter((e) => e.value !== r);
					u[e] = t, p.push({
						clusterName: e,
						envNames: t.map((e) => e.value).filter((e) => e !== i)
					});
				} else u[e] = n, p.push({
					clusterName: e,
					envNames: m.map((e) => e.value)
				});
			});
			let m = !0, h = !0;
			if (d.forEach((e) => {
				e.clusterName !== qn.AllFutureProdCluster && (u?.[e.clusterName] && u[e.clusterName]?.findIndex((t) => t.value === e.value) !== -1 || (m = !1));
			}), f.forEach((e) => {
				e.clusterName !== qn.AllFutureNonProdCluster && (u?.[e.clusterName] && u[e.clusterName]?.findIndex((t) => t.value === e.value) !== -1 || (h = !1));
			}), r && m) {
				let e = t.environment[0].options[0];
				u[qn.AllFutureProdCluster] = [e];
			}
			if (s && h) {
				let e = t.environment[0].options[1];
				u[qn.AllFutureNonProdCluster] = [e];
			}
			o(Object.values(u).flatMap((e) => e));
		},
		scopeError: l,
		scopeLoading: s,
		fetchConditionSelectOptions: m,
		getSanitizedData: p
	};
}, rO = () => {
	let [e, t] = j([]), [n, r] = j(!0), [i, a] = j(null), o = () => {
		r(!0), a(null), Gt().then((e) => {
			e.code === 200 && t(e.result ?? []);
		}).catch((e) => {
			a(e);
		}).finally(() => {
			r(!1);
		});
	};
	return k(() => {
		o();
	}, []), {
		filterConditions: e,
		isLoading: n,
		error: i,
		fetchConditions: o
	};
}, iO = (e) => {
	let [t, n] = j(null), [r, i] = j(!0), [a, o] = j(null), s = Ka(() => {
		i(!0), o(null), fn(e).then((e) => {
			e.code === 200 && n(e.result);
		}).catch((e) => {
			o(e);
		}).finally(() => {
			i(!1);
		});
	}, [e]);
	return k(() => {
		s();
	}, [s]), {
		filterDetails: t,
		isLoading: r,
		error: a,
		fetchFilterDetails: s
	};
}, aO = [{
	value: yt.DEPLOYMENT,
	label: "Deployment pipeline",
	startIcon: /* @__PURE__ */ (0, Q.jsx)(kD, {})
}];
//#endregion
//#region src/Components/Filters/FilterConditions/FilterConditionDefineForm.tsx
function oO({ filterId: e, handleFilterSubmit: t, handleStepperUpdate: n, filterDetails: r, handleNameChange: i, filterDetailsValidationErrors: a, handleDescriptionChange: o, conditionType: s, handleEnablePassCondition: c, renderConditionStatus: l, handleEnableFailCondition: u, renderInfoBar: d, renderButtonStatus: f, handleExpressionChange: p, handleListNavigation: h, disableSave: g, isLoading: _ }) {
	return /* @__PURE__ */ (0, Q.jsxs)("form", {
		className: "flexbox-col pt-0 dc__align-start dc__align-self-stretch flex-grow-1 dc__overflow-auto dc__content-space",
		onSubmit: e ? t : n,
		children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox-col pr-20 pl-20 dc__align-start dc__align-self-stretch flex-grow-1 dc__overflow-auto pb-16",
			children: [
				/* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "w-885 flexbox-col pt-16 pb-16 pl-0 pr-0 dc__gap-16",
					children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
						className: "flexbox w-885 dc__gap-16",
						children: [/* @__PURE__ */ (0, Q.jsx)("div", {
							className: "flexbox-col w-50",
							children: /* @__PURE__ */ (0, Q.jsx)(V, {
								label: "Filter For",
								required: !0,
								options: aO,
								value: aO[0],
								isSearchable: !1,
								inputId: "filter-conditions-type-select",
								size: I.large
							})
						}), /* @__PURE__ */ (0, Q.jsx)("div", {
							className: "flexbox-col w-50",
							children: /* @__PURE__ */ (0, Q.jsx)(os, {
								required: !0,
								label: "Filter Name",
								name: "filterName",
								placeholder: "Suggest a filter name",
								value: r.name,
								onChange: i,
								error: a.name
							})
						})]
					}), /* @__PURE__ */ (0, Q.jsx)("div", {
						className: "w-885",
						children: /* @__PURE__ */ (0, Q.jsx)(ou, {
							label: "Description",
							placeholder: "Enter here",
							value: r.description,
							onChange: o,
							name: "filter-conditions-description"
						})
					})]
				}),
				/* @__PURE__ */ (0, Q.jsx)("p", {
					className: "dc__required-field fs-13 fw-4 lh-20 cn-7 m-0 pt-8 pb-8",
					children: "Filter Condition"
				}),
				/* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "w-885 flex dc__gap-8 pb-16",
					children: [
						/* @__PURE__ */ (0, Q.jsx)(ft, {
							content: /* @__PURE__ */ (0, Q.jsx)("div", {
								className: "dc__mxw-400 word-break-none",
								children: Tn
							}),
							placement: "top",
							className: "default-tt",
							arrow: !1,
							children: /* @__PURE__ */ (0, Q.jsxs)("button", {
								className: `flex flex-grow-1 pt-10 pb-10 pl-12 pr-12 br-4 dc__border dc__content-space dc__outline-none-imp ${s === Qs.PASS ? "active-filter-condition-btn bcb-1" : "dc__no-background"}`,
								type: "button",
								onClick: c,
								children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
									className: "flex",
									children: [/* @__PURE__ */ (0, Q.jsx)(Hn, { className: `icon-dim-20 mr-10 ${s === Qs.PASS ? "" : "scb-5"}` }), /* @__PURE__ */ (0, Q.jsx)("div", {
										className: `fs-13 fw-6 lh-20 ${s === Qs.PASS ? "cn-9" : "cb-5"}`,
										children: "Pass Condition"
									})]
								}), l(Qs.PASS)]
							})
						}),
						/* @__PURE__ */ (0, Q.jsx)("div", { className: "h-20 dc__border-left" }),
						/* @__PURE__ */ (0, Q.jsx)(ft, {
							content: /* @__PURE__ */ (0, Q.jsx)("div", {
								className: "dc__mxw-400 word-break-none",
								children: Ct
							}),
							placement: "top",
							className: "default-tt",
							arrow: !1,
							children: /* @__PURE__ */ (0, Q.jsxs)("button", {
								className: `flex flex-grow-1 pt-10 pb-10 pl-12 pr-12 br-4 dc__border dc__content-space dc__outline-none-imp ${s === Qs.FAIL ? "active-filter-condition-btn bcb-1" : "dc__no-background"}`,
								type: "button",
								onClick: u,
								children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
									className: "flex",
									children: [/* @__PURE__ */ (0, Q.jsx)(Hn, { className: `icon-dim-20 dc__flip-y mr-10 ${s === Qs.FAIL ? "" : "scb-5"}` }), /* @__PURE__ */ (0, Q.jsx)("div", {
										className: `fs-13 fw-6 lh-20 ${s === Qs.FAIL ? "cn-9" : "cb-5"}`,
										children: "Fail Condition"
									})]
								}), l(Qs.FAIL)]
							})
						})
					]
				}),
				/* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "w-885 flexbox-col",
					children: [
						/* @__PURE__ */ (0, Q.jsxs)("div", {
							className: "flexbox p-12 dc__gap-4 dc__align-self-stretch dc__top-radius-4 border__primary dc__no-bottom-border",
							children: [/* @__PURE__ */ (0, Q.jsx)("p", {
								className: "m-0 flex-grow-1 flexbox fs-13 fw-4 lh-20",
								children: s === Qs.PASS ? qt.PASS_CONDITION : qt.FAIL_CONDITION
							}), /* @__PURE__ */ (0, Q.jsxs)("div", {
								className: "flexbox dc__gap-8 dc__align-items-center",
								children: [
									/* @__PURE__ */ (0, Q.jsx)(su, {
										theme: cu.white,
										className: "w-236 h-100 dc__align-left",
										placement: "bottom",
										Icon: jt,
										iconClass: "fcv-5",
										heading: "Filter criteria",
										showCloseButton: !0,
										trigger: "click",
										interactive: !0,
										additionalContent: /* @__PURE__ */ (0, Q.jsx)(cn, {}),
										children: /* @__PURE__ */ (0, Q.jsx)("button", {
											className: "h-20 fs-13 fw-4 lh-20 p-0 cb-5 dc__no-background dc__no-border dc__outline-none-imp",
											type: "button",
											children: "View filter criteria"
										})
									}),
									/* @__PURE__ */ (0, Q.jsx)("div", { className: "h-12 dc__border-left bcn-2" }),
									/* @__PURE__ */ (0, Q.jsx)(Cc, {
										infoText: Ft,
										heading: "CEL Expression",
										documentationLink: "CEL",
										children: /* @__PURE__ */ (0, Q.jsxs)("button", {
											className: "flex dc__gap-8 dc__outline-none-imp p-0 dc__no-border dc__no-background",
											type: "button",
											children: [/* @__PURE__ */ (0, Q.jsx)("p", {
												className: "m-0 cb-5 fs-13 fw-4 lh-20",
												children: "CEL expression"
											}), /* @__PURE__ */ (0, Q.jsx)(m, { className: "icon-dim-16" })]
										})
									})
								]
							})]
						}),
						d(),
						/* @__PURE__ */ (0, Q.jsx)(ou, {
							name: "filter-conditions-expression",
							placeholder: Bn,
							value: (() => {
								let e = r.conditions.find((e) => e.conditionType === s);
								return e ? e.expression : "";
							})(),
							onChange: p,
							borderRadiusConfig: { top: !1 }
						})
					]
				})
			]
		}), /* @__PURE__ */ (0, Q.jsx)("div", {
			className: "flexbox dc__border-top pt-16 pb-16 pl-20 pr-20 w-100",
			children: /* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "w-885 dc__gap-16 flexbox dc__content-end",
				children: [/* @__PURE__ */ (0, Q.jsx)("button", {
					className: "cta cancel h-36 lh-36",
					type: "button",
					onClick: h,
					disabled: _,
					children: "Cancel"
				}), g && !_ ? /* @__PURE__ */ (0, Q.jsx)(ft, {
					content: "Input is required for all mandatory fields.",
					placement: "top",
					className: "default-tt",
					arrow: !1,
					children: /* @__PURE__ */ (0, Q.jsx)("div", { children: /* @__PURE__ */ (0, Q.jsx)("button", {
						className: "cta h-36 lh-36",
						type: "submit",
						disabled: !0,
						children: e ? "Update" : "Next"
					}) })
				}) : /* @__PURE__ */ (0, Q.jsx)("button", {
					className: "cta h-36 lh-36",
					type: "submit",
					disabled: _,
					children: f()
				})]
			})
		})]
	});
}
var sO = {
	container: (e) => ({
		...e,
		height: "36px",
		width: "100%"
	}),
	control: (e) => ({
		...e,
		boxShadow: "none",
		minHeight: "36px",
		backgroundColor: "var(--bg-secondary)",
		cursor: "pointer"
	}),
	menu: (e) => ({
		...e,
		backgroundColor: "var(--bg-primary)",
		top: "38px"
	}),
	singleValue: (e) => ({
		...e,
		fontWeight: 500,
		color: "var(--N900)"
	}),
	option: (e, t) => ({
		...e,
		padding: "4px 12px",
		backgroundColor: t.isFocused ? "var(--N100)" : "var(--bg-primary)",
		color: "var(--N900)",
		cursor: "pointer",
		overflow: "hidden",
		textOverflow: "ellipsis",
		whiteSpace: "nowrap"
	}),
	valueContainer: (e) => ({
		...e,
		padding: "2px 0px 2px 8px",
		display: "flex",
		height: "36px"
	}),
	dropdownIndicator: (e, t) => ({
		...e,
		transition: "all .2s ease",
		transform: t.selectProps.menuIsOpen ? "rotate(180deg)" : "rotate(0deg)"
	}),
	group: (e) => ({
		...e,
		paddingTop: 0,
		paddingBottom: 0
	}),
	groupHeading: (e) => ({
		...e,
		fontWeight: 600,
		fontSize: "12px",
		color: "var(--N900)",
		backgroundColor: "var(--N100)",
		marginBottom: 0,
		padding: "4px 8px",
		textTransform: "none",
		overflow: "hidden",
		textOverflow: "ellipsis",
		whiteSpace: "nowrap"
	})
}, cO = {
	[go.PRE_CI]: rl.PRE_STAGE,
	[go.POST_CI]: rl.POST_STAGE,
	[go.PRE_OR_POST_CI]: rl.PRE_OR_POST_STAGE,
	[go.PRE_CD]: rl.PRE_STAGE,
	[go.POST_CD]: rl.POST_STAGE
};
//#endregion
//#region src/Components/Filters/FilterConditions/FilterConditionScopeForm.tsx
function lO({ isLoading: e, filterId: t, handleFilterSubmit: n, handleListNavigation: r, renderButtonStatus: i, disableSave: a, conditionSelectOptions: o, selectedApplications: s, handleApplicationConditionChange: c, selectedEnvironments: l, handleEnvironmentConditionChange: u }) {
	return /* @__PURE__ */ (0, Q.jsxs)("form", {
		className: "flexbox-col pt-0 dc__align-start dc__align-self-stretch flex-grow-1 dc__overflow-auto dc__content-space",
		onSubmit: n,
		children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "w-885 pt-20 pl-20 flexbox-col dc__gap-12",
			children: [
				/* @__PURE__ */ (0, Q.jsx)("div", {
					className: "flexbox dc__gap-4 dc__align-items-center",
					children: /* @__PURE__ */ (0, Q.jsx)("p", {
						className: "cn-9 fs-13 fw-6 lh-20 m-0",
						children: "Apply filter condition to"
					})
				}),
				/* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "w-885 flexbox-col",
					children: [/* @__PURE__ */ (0, Q.jsx)("label", {
						className: "fs-13 fw-4 lh-20 cn-7",
						htmlFor: "filter-conditions-application-select",
						children: "Application"
					}), /* @__PURE__ */ (0, Q.jsx)(ep, {
						name: "Applications",
						placeholder: "Search by project or application name",
						options: o.application,
						value: s,
						onChange: c,
						isMulti: !0,
						closeMenuOnSelect: !1,
						hideSelectedOptions: !1,
						components: {
							IndicatorSeparator: null,
							ClearIndicator: $D,
							Option: Xc,
							ValueContainer: eO
						},
						formatOptionLabel: tO,
						styles: sO,
						id: "filter-conditions-application-select"
					})]
				}),
				/* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "w-885 flexbox-col",
					children: [/* @__PURE__ */ (0, Q.jsx)("label", {
						className: "fs-13 fw-4 lh-20 cn-7",
						htmlFor: "filter-conditions-env-select",
						children: "Environment"
					}), /* @__PURE__ */ (0, Q.jsx)(ep, {
						name: "Environments",
						placeholder: "Search by cluster or environment name",
						options: o.environment,
						value: l,
						onChange: u,
						isMulti: !0,
						closeMenuOnSelect: !1,
						hideSelectedOptions: !1,
						formatOptionLabel: tO,
						components: {
							IndicatorSeparator: null,
							ClearIndicator: $D,
							Option: Xc,
							ValueContainer: eO
						},
						styles: sO,
						id: "filter-conditions-env-select"
					})]
				})
			]
		}), /* @__PURE__ */ (0, Q.jsx)("div", {
			className: "flexbox dc__border-top pt-16 pb-16 pl-20 pr-20 w-100",
			children: /* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "w-885 dc__gap-16 flexbox dc__content-end",
				children: [/* @__PURE__ */ (0, Q.jsx)("button", {
					className: "cta cancel h-36 lh-36",
					type: "button",
					onClick: r,
					disabled: e,
					children: "Cancel"
				}), a && !e ? /* @__PURE__ */ (0, Q.jsx)(ft, {
					content: "Input is required for all mandatory fields.",
					placement: "top",
					className: "default-tt",
					arrow: !1,
					children: /* @__PURE__ */ (0, Q.jsx)("div", { children: /* @__PURE__ */ (0, Q.jsx)("button", {
						className: "cta h-36 lh-36",
						type: "submit",
						disabled: !0,
						children: t ? "Update" : "Save"
					}) })
				}) : /* @__PURE__ */ (0, Q.jsx)("button", {
					className: "cta h-36 lh-36",
					type: "submit",
					disabled: e,
					children: i()
				})]
			})
		})]
	});
}
//#endregion
//#region src/Components/Filters/FilterConditions/FilterConditionForm.tsx
function uO({ activeStep: e, existingFilterDetails: t, setActiveStep: n, setEnableToggle: r, filterId: i }) {
	let [a, o] = j(t ?? Zt), [s, c] = j(t ? un : Wn), [l, u] = j(Qs.PASS), [f, p] = j([]), [m, h] = j(!1), { conditionSelectOptions: g, selectedApplications: _, selectedEnvironments: v, scopeLoading: y, scopeError: b, handleApplicationConditionChange: x, handleEnvironmentConditionChange: S, fetchConditionSelectOptions: C, getSanitizedData: w } = nO(t), T = A(() => Object.values(s).some((e) => e !== null), [s]), ee = X(), E = () => {
		ee(B.APPLICATION_MANAGEMENT_POLICIES.FILTER_CONDITIONS.ROOT);
	}, D = (e) => {
		o({
			...a,
			name: e.currentTarget.value
		}), QD(Dt.NAME, {
			...a,
			name: e.currentTarget.value
		}, c);
	}, te = (e) => {
		o({
			...a,
			description: e.currentTarget.value
		});
	}, ne = (e) => {
		let t = e.currentTarget.value, n = [...a.conditions.filter((e) => e.conditionType !== l), {
			conditionType: l,
			expression: t
		}].filter((e) => !!e.expression);
		QD(Dt.MIN_CONDITIONS, {
			...a,
			conditions: n
		}, c), o({
			...a,
			conditions: n
		});
	}, re = (e) => {
		e.preventDefault(), h(!0), _t({ conditions: a.conditions }).then((e) => {
			e.code === 200 && (p(e.result?.conditions ?? []), (e.result?.conditions?.filter((e) => !!e.errorMsg)).length === 0 ? (n(ar.SCOPE), r(!0), p([])) : H.showToast({
				variant: U.error,
				description: "Invalid Expression provided. Please check the expression and try again."
			}));
		}).catch(() => {
			H.showToast({
				variant: U.error,
				description: "Something went wrong while sending request. Please try again."
			});
		}).finally(() => {
			h(!1);
		});
	}, ie = () => {
		if (!(_.length === 0 && v.length === 0)) {
			if (_.length === 0) return H.showToast({
				variant: U.error,
				description: "Please select at least one application"
			}), !1;
			if (v.length === 0) return H.showToast({
				variant: U.error,
				description: "Please select at least one environment"
			}), !1;
		}
		return !0;
	}, ae = (e) => {
		if (e.preventDefault(), !ie()) return;
		let t = {
			...a,
			qualifierSelector: w()
		};
		h(!0), (i ? Vt(i, t) : Lt(t)).then((e) => {
			e.code === 200 ? (ee(B.APPLICATION_MANAGEMENT_POLICIES.FILTER_CONDITIONS.ROOT), H.showToast({
				variant: U.success,
				description: i ? zt.UPDATED : zt.SAVED
			})) : e.code === 209 ? (p(e.result?.conditions ?? []), H.showToast({
				variant: U.error,
				description: "Invalid Expression provided. Please check the expression and try again."
			}), h(!1)) : (H.showToast({
				variant: U.error,
				description: "Something went wrong"
			}), h(!1));
		}).catch((e) => {
			e.code === 500 ? H.showToast({
				variant: U.error,
				description: "Internal server error. Please try again."
			}) : H.showToast({
				variant: U.error,
				description: "Something went wrong. Please ensure all fields are valid and try again."
			}), h(!1);
		});
	}, oe = () => {
		u(Qs.PASS);
	}, se = () => {
		u(Qs.FAIL);
	}, ce = () => {
		let e = f.find((e) => e.conditionType === l);
		return e?.errorMsg ? /* @__PURE__ */ (0, Q.jsx)(xc, {
			description: e.errorMsg,
			borderConfig: {
				bottom: !1,
				left: !1,
				right: !1,
				top: !1
			},
			borderRadiusConfig: {
				bottom: !1,
				left: !1,
				right: !1,
				top: !1
			},
			variant: "error"
		}) : null;
	}, le = (e) => {
		let t = f.find((t) => t.conditionType === e), n = a.conditions.find((t) => t.conditionType === e);
		return t && t.errorMsg ? Ut.ERROR : n?.expression?.length ? Ut.SUCCESS : Ut.HOLD;
	}, ue = (e) => {
		switch (le(e)) {
			case Ut.SUCCESS: return /* @__PURE__ */ (0, Q.jsx)("div", {
				className: "icon-dim-20 flex",
				children: /* @__PURE__ */ (0, Q.jsx)(d, { className: `icon-dim-20 ${l === e ? "scn-6" : "scb-5"}` })
			});
			case Ut.ERROR: return /* @__PURE__ */ (0, Q.jsx)("div", {
				className: "icon-dim-20 flex",
				children: /* @__PURE__ */ (0, Q.jsx)(Et, { className: "icon-dim-20 cn-5 alert-icon-r5-imp" })
			});
			default: return null;
		}
	}, de = () => m ? /* @__PURE__ */ (0, Q.jsx)(ul, { size: 16 }) : i ? "Update" : e === ar.SCOPE ? "Save" : "Next";
	return e === ar.SCOPE ? y ? /* @__PURE__ */ (0, Q.jsx)(ul, { pageLoader: !0 }) : b ? /* @__PURE__ */ (0, Q.jsx)(Sl, { reload: C }) : /* @__PURE__ */ (0, Q.jsx)(lO, {
		isLoading: m,
		filterId: i,
		disableSave: T,
		conditionSelectOptions: g,
		selectedApplications: _,
		selectedEnvironments: v,
		handleFilterSubmit: ae,
		handleListNavigation: E,
		handleApplicationConditionChange: x,
		handleEnvironmentConditionChange: S,
		renderButtonStatus: de
	}) : /* @__PURE__ */ (0, Q.jsx)(oO, {
		filterId: i,
		filterDetails: a,
		filterDetailsValidationErrors: s,
		conditionType: l,
		disableSave: T,
		isLoading: m,
		handleFilterSubmit: ae,
		handleStepperUpdate: re,
		handleNameChange: D,
		handleDescriptionChange: te,
		handleEnablePassCondition: oe,
		handleEnableFailCondition: se,
		handleExpressionChange: ne,
		handleListNavigation: E,
		renderConditionStatus: ue,
		renderInfoBar: ce,
		renderButtonStatus: de
	});
}
//#endregion
//#region src/Components/Filters/FilterConditions/Stepper.tsx
function dO({ activeStep: e, setStep: t, isToggleEnabled: n, editMode: r = !1 }) {
	let i = () => {
		n && t(ar.DEFINE);
	}, a = () => {
		n && t(ar.SCOPE);
	};
	return /* @__PURE__ */ (0, Q.jsx)("div", {
		className: "flexbox dc__content-start pt-0 pb-0 pl-20 pr-20 dc__align-self-stretch bg__primary dc__border-bottom",
		children: /* @__PURE__ */ (0, Q.jsx)(nu, {
			hideTopPadding: !0,
			tabs: [
				{
					id: "define-filter-condition-tab",
					label: r ? ar.REVIEW : `1. ${ar.DEFINE}`,
					tabType: "button",
					active: e === ar.DEFINE,
					props: { onClick: i },
					disabled: !n && e !== ar.DEFINE
				},
				...r ? [] : [{
					id: "edit-stepper-gap",
					label: ">",
					tabType: "button",
					active: !1,
					props: { onClick: $d }
				}],
				{
					id: "apply-to-tab",
					label: r ? ar.SCOPE : `2. ${ar.SCOPE}`,
					tabType: "button",
					active: e === ar.SCOPE,
					props: { onClick: a },
					disabled: !n && e !== ar.SCOPE
				}
			]
		})
	});
}
//#endregion
//#region src/Components/Filters/FilterConditions/AddFilter.tsx
function fO() {
	let [e, t] = j(ar.DEFINE), [n, r] = j(!1);
	return /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [
		/* @__PURE__ */ (0, Q.jsx)(JD, { path: "Add" }),
		/* @__PURE__ */ (0, Q.jsx)(dO, {
			activeStep: e,
			setStep: t,
			isToggleEnabled: n
		}),
		/* @__PURE__ */ (0, Q.jsx)(uO, {
			activeStep: e,
			setActiveStep: t,
			setEnableToggle: r,
			filterId: null
		})
	] });
}
//#endregion
//#region src/Components/Filters/FilterConditions/EditFilter.tsx
function pO() {
	let [e, t] = j(ar.DEFINE), { filterId: n } = Z(), { filterDetails: r, isLoading: i, error: a, fetchFilterDetails: o } = iO(n);
	return i ? /* @__PURE__ */ (0, Q.jsx)(ul, { pageLoader: !0 }) : a || !r ? a.code === 404 ? /* @__PURE__ */ (0, Q.jsx)(R, {
		title: "Filter condition not found",
		subTitle: "The filter condition you are looking for does not exist."
	}) : /* @__PURE__ */ (0, Q.jsx)("div", {
		className: "flex column dc__align-items-center dc__justify-content-center h-100",
		children: /* @__PURE__ */ (0, Q.jsx)(Sl, { reload: o })
	}) : /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [
		/* @__PURE__ */ (0, Q.jsx)("div", {
			className: "flex px-20 pt-16 pb-24",
			children: /* @__PURE__ */ (0, Q.jsx)(Wc, {
				redirectUrl: B.APPLICATION_MANAGEMENT_POLICIES.FILTER_CONDITIONS.ROOT,
				linkText: "Filter Conditions",
				profileName: r.name
			})
		}),
		/* @__PURE__ */ (0, Q.jsx)(dO, {
			activeStep: e,
			setStep: t,
			isToggleEnabled: !0,
			editMode: !0
		}),
		/* @__PURE__ */ (0, Q.jsx)(uO, {
			activeStep: e,
			setActiveStep: t,
			existingFilterDetails: r,
			filterId: +n
		})
	] });
}
//#endregion
//#region src/Components/Filters/FilterConditions/FilterItem.tsx
var mO = ({ name: e, description: t, conditions: n, fetchConditions: r, id: i }) => {
	let [a, o] = j(!1), [s, c] = j(!1), l = X();
	return /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox flex-wrap w-100 dc__overflow-hidden dc__hover-n50 pt-12 pb-12 pl-20 pr-20",
		onMouseEnter: () => o(!0),
		onMouseLeave: () => o(!1),
		children: [
			/* @__PURE__ */ (0, Q.jsx)(fc, {
				item: !0,
				xs: .5,
				itemClass: "dc__ellipsis-right flex dc__content-start",
				children: /* @__PURE__ */ (0, Q.jsx)(Yi, { className: "icon-dim-20" })
			}),
			/* @__PURE__ */ (0, Q.jsx)(fc, {
				item: !0,
				xs: 2,
				itemClass: "dc__ellipsis-right flex dc__content-start",
				children: /* @__PURE__ */ (0, Q.jsx)(ft, {
					content: e,
					placement: "top",
					className: "default-tt dc__word-break-all",
					children: /* @__PURE__ */ (0, Q.jsx)(Wf, {
						to: Y(B.APPLICATION_MANAGEMENT_POLICIES.FILTER_CONDITIONS.EDIT, { filterId: String(i) }),
						className: "dc__ellipsis-right cb-5 fw-4 fs-13 m-0 pr-16",
						children: e
					})
				})
			}),
			/* @__PURE__ */ (0, Q.jsx)(fc, {
				item: !0,
				xs: 7.5,
				itemClass: "dc__ellipsis-right flex dc__content-start",
				children: /* @__PURE__ */ (0, Q.jsx)(ft, {
					content: t,
					placement: "top",
					className: "default-tt dc__word-break-all",
					children: /* @__PURE__ */ (0, Q.jsx)("p", {
						className: "dc__ellipsis-right m-0 cn-9 fs-13 fw-4 pr-16",
						children: t
					})
				})
			}),
			/* @__PURE__ */ (0, Q.jsxs)(fc, {
				item: !0,
				xs: 2,
				itemClass: "dc__ellipsis-right flex dc__content-space",
				children: [(() => {
					let e = n.map((e) => e.conditionType), t = [];
					return e.includes(Qs.PASS) && t.push("Pass"), e.includes(Qs.FAIL) && t.push("Fail"), /* @__PURE__ */ (0, Q.jsx)("p", {
						className: "dc__ellipsis-right m-0 cn-9 fs-13 fw-4 pr-16",
						children: t.join(", ")
					});
				})(), a && /* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "flex dc__gap-16",
					children: [/* @__PURE__ */ (0, Q.jsx)("button", {
						type: "button",
						className: "dc__outline-none-imp dc__no-border p-0 h-20 dc__no-background",
						onClick: () => {
							l(Y(B.APPLICATION_MANAGEMENT_POLICIES.FILTER_CONDITIONS.EDIT, { filterId: String(i) }));
						},
						"aria-label": "Edit",
						children: /* @__PURE__ */ (0, Q.jsx)(Ee, { className: "icon-dim-20 scn-6" })
					}), /* @__PURE__ */ (0, Q.jsx)("button", {
						type: "button",
						className: "dc__outline-none-imp dc__no-border p-0 h-20 dc__no-background",
						onClick: () => c(!0),
						"aria-label": "Delete",
						children: /* @__PURE__ */ (0, Q.jsx)(Be, { className: "icon-dim-20 scn-6" })
					})]
				})]
			})
		]
	}), s && /* @__PURE__ */ (0, Q.jsx)(Ts, {
		title: e,
		component: "filter",
		subtitle: /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsx)("p", {
			className: "fs-13 cn-8 lh-20 m-0",
			children: "Deleting will remove the enforced filter conditions"
		}), /* @__PURE__ */ (0, Q.jsx)("p", {
			className: "fs-13 cn-8 lh-20 m-0",
			children: "Do you want to delete?"
		})] }),
		onDelete: async () => {
			await Cn(i), r();
		},
		closeConfirmationModal: () => c(!1),
		successToastMessage: `Successfully deleted ${e}`
	})] });
};
//#endregion
//#region src/Components/Filters/FilterConditions/FiltersList.tsx
function hO() {
	let [e, t] = j(""), { filterConditions: n, isLoading: r, error: i, fetchConditions: a } = rO(), o = X(), s = A(() => e ? n.filter((t) => {
		let { name: n, description: r } = t;
		return n.toLowerCase().includes(e) || r.toLowerCase().includes(e);
	}) : n, [n, e]), c = (e) => {
		t(e.toLowerCase().trim());
	}, l = () => {
		o(B.APPLICATION_MANAGEMENT_POLICIES.FILTER_CONDITIONS.ADD);
	};
	return r ? /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsx)(JD, { onSearch: c }), /* @__PURE__ */ (0, Q.jsx)(ul, { pageLoader: !0 })] }) : i ? /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flex column dc__align-items-center dc__justify-content-center h-100",
		children: [/* @__PURE__ */ (0, Q.jsx)(JD, { onSearch: c }), /* @__PURE__ */ (0, Q.jsx)(Sl, {})]
	}) : n.length ? /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsx)(JD, { onSearch: c }), s.length ? /* @__PURE__ */ (0, Q.jsx)("div", {
		className: "dc__overflow-auto flex column dc__content-start dc__align-start bg__primary dc__align-self-stretch flex-grow-1 dc__no-shrink",
		children: /* @__PURE__ */ (0, Q.jsxs)(fc, {
			container: !0,
			containerClass: "w-100 flex dc__align-self-stretch dc__align-items-center",
			children: [/* @__PURE__ */ (0, Q.jsxs)(fc, {
				container: !0,
				containerClass: "w-100 dc__overflow-hidden dc__border-bottom-n1 pt-8 pb-8 pl-20 pr-20",
				children: [
					/* @__PURE__ */ (0, Q.jsx)(fc, {
						item: !0,
						xs: .5
					}),
					/* @__PURE__ */ (0, Q.jsx)(fc, {
						item: !0,
						xs: 2,
						itemClass: "dc__ellipsis-right flex dc__content-start",
						children: /* @__PURE__ */ (0, Q.jsx)("p", {
							className: "m-0 cn-7 fs-12 fw-6 lh-20 dc__uppercase dc__ellipsis-right pr-16",
							children: xn[0]
						})
					}),
					/* @__PURE__ */ (0, Q.jsx)(fc, {
						item: !0,
						xs: 7.5,
						itemClass: "dc__ellipsis-right flex dc__content-start",
						children: /* @__PURE__ */ (0, Q.jsx)("p", {
							className: "m-0 cn-7 fs-12 fw-6 lh-20 dc__uppercase dc__ellipsis-right pr-16",
							children: xn[1]
						})
					}),
					/* @__PURE__ */ (0, Q.jsx)(fc, {
						item: !0,
						xs: 2,
						itemClass: "dc__ellipsis-right flex dc__content-start",
						children: /* @__PURE__ */ (0, Q.jsx)("p", {
							className: "m-0 cn-7 fs-12 fw-6 lh-20 dc__uppercase dc__ellipsis-right",
							children: xn[2]
						})
					})
				]
			}), s.map((e) => /* @__PURE__ */ (0, Q.jsx)(mO, {
				name: e.name,
				conditions: e.conditions,
				description: e.description?.length ? e.description : "No defined description",
				fetchConditions: a,
				id: e.id
			}, e.id))]
		})
	}) : /* @__PURE__ */ (0, Q.jsx)(R, {
		image: sp,
		title: "No results found",
		subTitle: "Try adjusting your search to find what you are looking for."
	})] }) : /* @__PURE__ */ (0, Q.jsx)(R, {
		image: sp,
		title: "No condition is defined",
		subTitle: In,
		isButtonAvailable: !0,
		renderButton: () => /* @__PURE__ */ (0, Q.jsxs)("button", {
			className: "cta flex h-36",
			onClick: l,
			type: "button",
			children: [/* @__PURE__ */ (0, Q.jsx)(E, { className: "mr-4" }), "Add filter condition"]
		})
	});
}
//#endregion
//#region src/Components/Filters/FilterConditions/FilterConditions.tsx
var gO = /* @__PURE__ */ t({
	FilterConditions: () => vO,
	default: () => yO
}), _O = vo.APPLICATION_MANAGEMENT.POLICIES.FILTER_CONDITIONS, vO = ({ isSuperAdmin: e }) => e ? /* @__PURE__ */ (0, Q.jsx)("div", {
	className: "flexbox-col bg__primary h-100",
	children: /* @__PURE__ */ (0, Q.jsxs)(qf, { children: [
		/* @__PURE__ */ (0, Q.jsx)(J, {
			index: !0,
			element: /* @__PURE__ */ (0, Q.jsx)(hO, {})
		}),
		/* @__PURE__ */ (0, Q.jsx)(J, {
			path: _O.EDIT,
			element: /* @__PURE__ */ (0, Q.jsx)(pO, {})
		}),
		/* @__PURE__ */ (0, Q.jsx)(J, {
			path: _O.ADD,
			element: /* @__PURE__ */ (0, Q.jsx)(fO, {})
		}),
		/* @__PURE__ */ (0, Q.jsx)(J, {
			path: "*",
			element: /* @__PURE__ */ (0, Q.jsx)(Kf, {
				to: "",
				replace: !0
			})
		})
	] })
}) : /* @__PURE__ */ (0, Q.jsx)(qs, {}), yO = Ga(vO), bO = ({ appName: e, envName: t, ciPipelineId: n, branchName: r }) => {
	let i = [`${Dl.devtronApplication}|identifier|${e}`];
	return t ? i.push(`${Dl.environment}|identifier|${t}`) : n && (i.push(`${Dl.ciPipeline}|id|${n}`), r && i.push(`${Dl.ciPipeline}|${_n.branchFixed}|${r}`)), { resourceIdentifier: i };
}, xO = (e, t) => {
	let n = e === Dl.ciPipeline ? "build" : "deployment";
	switch (t) {
		case rl.POST_STAGE: return `post-${n} stage`;
		case rl.PRE_STAGE: return `pre-${n} stage`;
		default: return "any stage";
	}
}, SO = (e, t, n) => t?.filter((t) => {
	if (t.stepType !== il.PLUGIN_REF || !t.pluginRefStepDetail) return !1;
	let { pluginId: r } = t.pluginRefStepDetail, { parentPluginId: i } = n.pluginVersionStore[r] || {};
	return i === e;
}).length || 0, CO = (e, t) => e?.reduce((e, n) => (n.parentPluginId === t && !e.includes(n.requiredIn) && e.push(n.requiredIn), e), []) || [], wO = ({ mandatoryPluginList: e, formData: t, targetPluginId: n, activeStageName: r, pluginDataStore: i, isFromMoveTask: a = !1 }) => {
	let o = i.pluginVersionStore[n]?.parentPluginId;
	if (!o) return { isValid: !0 };
	let s = CO(e, o);
	if (!s.length) return { isValid: !0 };
	let c = t[rl.PRE_STAGE]?.steps || [], l = t[rl.POST_STAGE]?.steps || [], u = SO(o, c, i), d = SO(o, l, i);
	return s.includes(rl.PRE_OR_POST_STAGE) && !a && !(u + d > 1) ? { isValid: !1 } : r === rl.PRE_STAGE && s.includes(rl.PRE_STAGE) ? { isValid: u > 1 } : r === rl.POST_STAGE && s.includes(rl.POST_STAGE) ? { isValid: d > 1 } : { isValid: !0 };
}, TO = (e, t, n) => {
	switch (e) {
		case "CI": return n ? "Job" : "Build";
		case "PRECD": return "Pre-deployment";
		case "POSTCD": return "Post-deployment";
		case "CD": return "Deployment";
		default: return t ?? "Event";
	}
}, EO = (e) => {
	switch (e) {
		case "CI": return "Start Build";
		case "PRECD":
		case "POSTCD": return "Trigger stage";
		default: return "Trigger";
	}
}, DO = (e, t) => {
	let n = "Apply and configure mandatory plugins", r = `Go to Workflow editor > Edit ${e === "CI" ? t ? "job" : "build" : "deployment"} pipeline`;
	switch (e) {
		case "CI": return [
			r,
			t ? "Look for mandatory plugins in 'Tasks to be executed'" : "Look for mandatory plugins at pre-build or post-build stage",
			n
		];
		case "PRECD": return [
			r,
			"Look for mandatory plugins at pre-deployment stage",
			n
		];
		case "POSTCD": return [
			r,
			"Look for mandatory plugins at post-deployment stage",
			n
		];
		default: return [
			"Go to Workflow editor > Edit pipeline",
			"Look for mandatory plugins at pre-build or post-build stage",
			n
		];
	}
}, OO = (e, t) => {
	switch (e) {
		case "PRECD": return dp;
		case "POSTCD": return up;
		default: return t ? lp : cp;
	}
}, kO = ({ parentPluginId: e, stage: t }) => `${e}-${t}`, AO = (e) => e?.definitions?.length && structuredClone(e.definitions).reduce((e, t) => {
	let n = kO({
		parentPluginId: t.parentPluginId,
		stage: t.applyToStage
	}), r = e[n]?.definitionSources || {
		policyNames: {},
		linkedCIPipelineNames: {}
	}, i = {
		pluginId: 0,
		parentPluginId: t.parentPluginId,
		applyToStage: t.applyToStage
	};
	return t.linkedPipelines?.forEach((e) => {
		let t = e.identifierDetails?.name;
		e.type === "CI" && t && (r.linkedCIPipelineNames[t] = !0);
	}), t.policyIdentifiers?.forEach((e) => {
		r.policyNames[e] = !0;
	}), {
		...e,
		[n]: {
			data: i,
			definitionSources: r
		}
	};
}, {}) || {}, jO = (e) => Object.values(e).map(({ data: e, definitionSources: t }) => ({
	data: e,
	definitionSources: {
		policyNames: Object.keys(t.policyNames),
		linkedCIPipelineNames: Object.keys(t.linkedCIPipelineNames)
	}
})), MO = /* @__PURE__ */ t({ default: () => NO }), NO = ({ consequence: e, configurePluginURL: t, onTrigger: n, showTriggerButton: r, children: i, nodeType: a, visible: o, onClose: s, trigger: c }) => {
	let [l, u] = j(!1), d = is.ALLOW_FOREVER === e.action;
	return /* @__PURE__ */ (0, Q.jsx)(su, {
		theme: cu.white,
		placement: "bottom-end",
		className: "mb-60--neg",
		Icon: gi,
		iconSize: 40,
		showCloseButton: !0,
		noHeadingBorder: !0,
		additionalContent: /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flex column left px-16 pb-16 dc__gap-20",
			children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox-col dc__gap-4",
				children: [/* @__PURE__ */ (0, Q.jsx)("div", {
					className: "fs-14 cn-9 fw-6 lh-20 dc__word-break flexbox flex-wrap",
					children: d ? /* @__PURE__ */ (0, Q.jsx)("span", { children: "Some enforced plugins are not configured" }) : /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsxs)("span", { children: [
						TO(a),
						"\xA0",
						l ? "is blocked" : "will be blocked on",
						"\xA0"
					] }), e.metadataField && /* @__PURE__ */ (0, Q.jsx)(vT, {
						endTime: e.metadataField,
						callbackAfterTimeEnd: () => {
							u(!0);
						},
						rootClassName: "cy-7 fs-14 fw-6 lh-20"
					})] })
				}), /* @__PURE__ */ (0, Q.jsx)("span", {
					className: "cn-9 fs-13 lh-20 fw-4",
					children: d ? "Please configure required plugins to comply with enforced policy." : "Some mandatory plugins are not configured. Configure the plugins to avoid blocking."
				})]
			}), /* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flex left dc__gap-12",
				children: [/* @__PURE__ */ (0, Q.jsx)(M, {
					dataTestId: "configure-plugin-with-warning",
					startIcon: /* @__PURE__ */ (0, Q.jsx)(w, {}),
					text: "Configure plugin",
					component: N.link,
					linkProps: {
						to: t,
						target: "_blank"
					},
					size: I.medium,
					variant: F.secondary
				}), r && /* @__PURE__ */ (0, Q.jsx)(M, {
					dataTestId: "trigger-with-warning",
					startIcon: /* @__PURE__ */ (0, Q.jsx)(S_, {}),
					text: EO(a),
					onClick: n,
					style: P.neutral,
					size: I.medium,
					variant: F.secondary,
					disabled: l
				})]
			})]
		}),
		interactive: !0,
		...c ? { trigger: c } : {},
		...Jd(o) ? { trigger: "click" } : { visible: o },
		...s ? { onClose: s } : {},
		children: /* @__PURE__ */ (0, Q.jsx)("div", { children: i })
	});
}, PO = ({ pluginDetail: e, rootClassName: t }) => {
	let { policyNames: n, linkedCIPipelineNames: r } = e?.definitionSources || {};
	return /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: `flexbox-col dc__gap-12 ${t || ""}`,
		children: [n?.length > 0 && /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox-col dc__gap-6",
			children: [/* @__PURE__ */ (0, Q.jsx)("span", {
				className: "cn-9 fs-13 fw-4 lh-20",
				children: "Plugin is mandatory due to plugin policy"
			}), /* @__PURE__ */ (0, Q.jsx)("div", {
				className: "flexbox flex-wrap dc__gap-8",
				children: n.map((e) => /* @__PURE__ */ (0, Q.jsx)(Wf, {
					to: Rd(B.APPLICATION_MANAGEMENT_POLICIES.PLUGIN_POLICY.APPLIED_PROFILES.ROOT, { [be.profile]: [e] }),
					target: "_blank",
					className: "dc__no-decor dc__hover-n50 cn-9 dc__hover-color-b500 dc__hover-color-b500--stroke",
					children: /* @__PURE__ */ (0, Q.jsxs)("div", {
						className: "flexbox dc__align-items-center dc__gap-4 py-2 px-6 br-4 dc__border",
						children: [/* @__PURE__ */ (0, Q.jsx)("span", {
							className: "fs-13 fw-6 dc__truncate dc__mxw-150",
							children: e
						}), /* @__PURE__ */ (0, Q.jsx)(aa, { className: "icon-dim-16 scn-7 dc__no-shrink" })]
					})
				}, e))
			})]
		}), r?.length > 0 && /* @__PURE__ */ (0, Q.jsx)("div", { className: "dc__border-bottom-n1 w-100" })] }), r?.length > 0 && /* @__PURE__ */ (0, Q.jsxs)("span", {
			className: "cn-9 fs-13 lh-20 dc__word-break",
			children: [
				/* @__PURE__ */ (0, Q.jsx)("span", {
					className: "fw-4",
					children: "Plugin is mandatory for linked CI"
				}),
				"\xA0",
				r.map((e, t) => /* @__PURE__ */ (0, Q.jsxs)("span", {
					className: "fw-6 dc__word-break",
					children: [
						t === 0 ? "" : ",",
						"\xA0",
						e
					]
				}, e))
			]
		})]
	});
}, FO = /* @__PURE__ */ t({ default: () => LO }), IO = ({ handleTogglePluginExpansion: e, pluginDetail: t, isExpanded: n, resourceKindType: r }) => /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsxs)("button", {
	type: "button",
	role: "tab",
	className: `dc__transparent dc__hover-n50 px-12 py-10 flexbox dc__gap-8 dc__visible-hover dc__visible-hover--parent ${n ? "bg__secondary" : ""}`,
	"data-testid": `toggle-expansion-for-${kO({
		parentPluginId: t.parentPluginId,
		stage: t.requiredIn
	})}`,
	onClick: () => {
		e({
			parentPluginId: t.parentPluginId,
			requiredIn: t.requiredIn
		});
	},
	children: [
		!n && /* @__PURE__ */ (0, Q.jsx)(nl, {
			fallbackImageClassName: "icon-dim-20 dc__visible-hover--hide-child",
			imageProps: {
				src: t.icon,
				alt: t.name,
				height: 20,
				width: 20,
				className: "icon-dim-20 dc__visible-hover--hide-child"
			}
		}),
		/* @__PURE__ */ (0, Q.jsx)(we, { className: `icon-dim-20 dc__no-shrink dc__transition--transform ${n ? "" : "dc__flip-90--neg dc__visible-hover--child"}` }),
		/* @__PURE__ */ (0, Q.jsx)(W, {
			content: t.name,
			children: /* @__PURE__ */ (0, Q.jsx)("span", {
				className: "cn-9 fs-13 fw-4 lh-20 dc__truncate flex-grow-1 dc__align-left",
				children: t.name
			})
		}),
		/* @__PURE__ */ (0, Q.jsx)("span", {
			className: "cn-6 fs-12 fw-4 lh-20 dc__no-shrink dc__first-letter-capitalize",
			children: xO(r, t.requiredIn)
		})
	]
}), n && /* @__PURE__ */ (0, Q.jsx)(PO, {
	pluginDetail: t,
	rootClassName: "py-10 pl-40 pr-8"
})] }), LO = ({ mandatoryPluginData: e, stage: t, formData: n, setFormData: r, formDataErrorObj: i, setFormDataErrorObj: a, handleApplyPlugin: o, resourceKindType: s }) => {
	let [c, l] = j({}), u = e?.pluginData?.filter((e) => !e.applied) || [], d = () => {
		l({});
	}, f = (e) => (e.refVariableStepIndex = 0, e.refVariableName = "", e.variableType = bl.NEW, e.variableStepIndexInPlugin = e.variableStepIndex, delete e.refVariableStage, delete e.variableStepIndex, e), p = () => {
		if (u.length) {
			let e = { ...n }, s = { ...i };
			for (let n = 0; n < u.length; n++) {
				let r = u[n], i = r.requiredIn === rl.PRE_OR_POST_STAGE ? t : r.requiredIn, a = e[i].steps.length - 1;
				e[i].steps.push({
					id: a,
					index: a,
					description: r.description,
					name: r.name,
					stepType: il.PLUGIN_REF,
					pluginRefStepDetail: {
						id: 0,
						pluginId: r.id,
						conditionDetails: [],
						inputVariables: r.inputVariables?.map(f) || [],
						outputVariables: r.outputVariables?.map(f) || []
					}
				}), s[i].steps.push({
					name: {
						isValid: !0,
						message: null
					},
					isValid: !0,
					pluginRefStepDetail: { inputVariables: [] }
				});
			}
			r(e), a(s), o(e);
		}
	}, m = ({ parentPluginId: e, requiredIn: t }) => {
		let n = structuredClone(c), r = kO({
			parentPluginId: e,
			stage: t
		});
		n[r] ? delete n[r] : n[r] = !0, l(n);
	};
	return u.length ? /* @__PURE__ */ (0, Q.jsx)("div", {
		className: "mb-12 dc__border-bottom-n1",
		children: /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "br-4 p-12 flexbox-col dc__gap-6 en-2 bw-1",
			children: [
				/* @__PURE__ */ (0, Q.jsxs)("span", {
					className: "bcy-1 br-4 ey-2 bw-1 cy-7 flex dc__gap-6 px-8 dc__w-fit-content fw-6 fs-12 h-22",
					children: [/* @__PURE__ */ (0, Q.jsx)(Et, { className: "warning-icon-y7-imp icon-dim-14 dc__no-shrink" }), "Action required"]
				}),
				/* @__PURE__ */ (0, Q.jsx)("span", {
					className: "cn-9 fs-13 fw-4 lh-20",
					children: "Mandatory plugins are not configured"
				}),
				/* @__PURE__ */ (0, Q.jsx)(su, {
					theme: cu.white,
					heading: /* @__PURE__ */ (0, Q.jsxs)("span", {
						className: "flexbox dc__gap-8",
						children: [/* @__PURE__ */ (0, Q.jsx)(Et, { className: "warning-icon-y7-imp icon-dim-20 dc__no-shrink" }), /* @__PURE__ */ (0, Q.jsx)("span", { children: "Apply mandatory plugins" })]
					}),
					headingInfo: /* @__PURE__ */ (0, Q.jsx)("span", { children: "Apply plugins & configure them. A non-configured plugin may lead to the blocking of pipeline triggers." }),
					additionalContent: /* @__PURE__ */ (0, Q.jsxs)("div", {
						className: "h-100 mxh-210 dc__overflow-auto flexbox-col dc__content-space",
						children: [/* @__PURE__ */ (0, Q.jsx)("div", {
							className: "flexbox-col h-100 dc__overflow-auto",
							children: u.map((e) => {
								let t = kO({
									parentPluginId: e.parentPluginId,
									stage: e.requiredIn
								});
								return /* @__PURE__ */ (0, Q.jsx)(IO, {
									pluginDetail: e,
									handleTogglePluginExpansion: m,
									isExpanded: c[t],
									resourceKindType: s
								}, t);
							})
						}), /* @__PURE__ */ (0, Q.jsx)("div", {
							className: "dc__border-top flex right p-12 dc__no-shrink",
							children: /* @__PURE__ */ (0, Q.jsx)(M, {
								dataTestId: "apply-mandatory-plugin-button",
								text: "Apply",
								onClick: p,
								size: I.small
							})
						})]
					}),
					className: "w-436 h-100",
					placement: "bottom",
					showCloseButton: !0,
					trigger: "click",
					interactive: !0,
					onClose: d,
					children: /* @__PURE__ */ (0, Q.jsx)("div", { children: /* @__PURE__ */ (0, Q.jsx)(M, {
						text: "View plugins",
						dataTestId: "mandatory-plugin-warning-button",
						variant: F.text
					}) })
				})
			]
		})
	}) : null;
}, RO = (e) => /* @__PURE__ */ (0, Q.jsxs)("svg", {
	width: 250,
	height: 200,
	viewBox: "0 0 250 200",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [/* @__PURE__ */ (0, Q.jsxs)("g", {
		clipPath: "url(#clip0_726_3575)",
		children: [
			/* @__PURE__ */ (0, Q.jsx)("path", {
				d: "M157.23 67L161 71.3413L23.7701 196L20 191.659L157.23 67Z",
				fill: "#7A7562"
			}),
			/* @__PURE__ */ (0, Q.jsx)("rect", {
				x: 140,
				y: 7.00012,
				width: 80,
				height: 80,
				rx: 4,
				fill: "#FDE7E7"
			}),
			/* @__PURE__ */ (0, Q.jsx)("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M163.094 32.9218C159.913 36.7368 158 41.6449 158 46.9999C158 59.1501 167.85 68.9999 180 68.9999C185.355 68.9999 190.263 67.0866 194.078 63.9064L163.094 32.9218ZM165.922 30.0933L196.907 61.078C200.087 57.263 202 52.3549 202 46.9999C202 34.8496 192.151 24.9999 180 24.9999C174.645 24.9999 169.737 26.9131 165.922 30.0933ZM198.385 65.3847C203.09 60.6796 206 54.1796 206 46.9999C206 32.6405 194.36 20.9999 180 20.9999C165.641 20.9999 154 32.6405 154 46.9999C154 61.3593 165.641 72.9999 180 72.9999C187.18 72.9999 193.68 70.0897 198.385 65.3847Z",
				fill: "#F33E3E"
			}),
			/* @__PURE__ */ (0, Q.jsx)("path", {
				d: "M153 154L178 192H128L153 154Z",
				fill: "#FDE7E7"
			}),
			/* @__PURE__ */ (0, Q.jsx)("path", {
				d: "M189.171 137.681C194.158 151.382 187.094 166.531 173.393 171.518C159.692 176.505 144.542 169.44 139.556 155.74L189.171 137.681Z",
				fill: "#1E2462"
			}),
			/* @__PURE__ */ (0, Q.jsx)("rect", {
				x: 159.677,
				y: 173.375,
				width: 60,
				height: 19.1999,
				rx: 9.59997,
				fill: "#A0C3FB"
			}),
			/* @__PURE__ */ (0, Q.jsx)("path", {
				d: "M77.1136 67.9289L81.1717 60.0529C83.6992 58.5301 88.0517 56.7618 86.8292 60.6546C85.6066 64.5474 84.1771 67.2145 84.9417 69.1821L77.1136 67.9289Z",
				fill: "url(#paint0_linear_726_3575)"
			}),
			/* @__PURE__ */ (0, Q.jsx)("path", {
				d: "M89.7178 61.7789C91.9868 60.6723 93.2075 57.7363 93.5342 56.4066C93.5342 56.4066 95.4215 55.8767 95.3485 55.3272C95.2755 54.7776 94.2211 52.5612 93.2735 51.0729C92.2717 49.4995 91.5194 48.5935 90.7947 47.9903C87.8398 45.5309 85.0457 45.0007 82.2752 45.3192C79.1354 45.6802 75.6144 48.4704 75.1499 52.305C74.723 55.829 79.5378 60.5025 81.5668 61.4633C83.5959 62.4242 86.8816 63.1622 89.7178 61.7789Z",
				fill: "#FFBEB6"
			}),
			/* @__PURE__ */ (0, Q.jsx)("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M92.2244 53.6828C92.4022 53.8539 92.6693 53.9905 93.0272 53.9905C93.3851 53.9905 93.6521 53.8539 93.83 53.6828C94.0164 53.5034 94.0896 53.303 94.0896 53.1936H94.6208C94.6208 53.4824 94.4606 53.8132 94.1983 54.0656C93.9275 54.3262 93.5305 54.5217 93.0272 54.5217C92.5239 54.5217 92.1269 54.3262 91.8561 54.0656C91.5938 53.8132 91.4336 53.4824 91.4336 53.1936H91.9648C91.9648 53.303 92.0379 53.5034 92.2244 53.6828Z",
				fill: "#23286B"
			}),
			/* @__PURE__ */ (0, Q.jsx)("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M75.3483 57.4944C74.9234 59.1151 74.9036 62.1504 77.8712 63.0726C81.7794 64.2873 85.5112 59.5414 85.4 54.9144C86.6938 55.6158 88.5255 54.7546 88.7099 52.3093C90.2229 52.5065 93.5692 52.0546 94.958 48.6479C95.4645 47.4056 95.4417 46.0258 95.1842 44.8845C95.0552 44.3127 94.8661 43.7954 94.6504 43.3791C94.4373 42.9677 94.189 42.6373 93.9322 42.4599L93.7241 42.7611C93.9086 42.8886 94.1231 43.1572 94.3254 43.5476C94.5252 43.9331 94.7042 44.4205 94.8271 44.965C95.0733 46.0563 95.0895 47.3557 94.619 48.5096C93.5833 51.0501 91.3838 51.8419 89.8106 51.9649C92.0762 51.4153 94.0987 49.5711 94.2547 47.4749C94.4355 45.0461 93.4403 42.6057 91.6418 42.1176C90.203 41.727 88.78 43.4484 88.2483 44.3579C87.9474 43.0743 86.796 40.5803 84.9206 39.9345C82.4564 39.0859 80.9278 39.3463 80.0553 40.3569C79.3298 41.1973 79.9906 42.5754 80.5129 43.6648C80.6187 43.8855 80.7188 44.0943 80.8006 44.2844C80.0205 43.8847 78.0813 43.3481 76.5656 44.3994C75.0498 45.4508 75.8084 46.9793 76.3771 47.6122C75.6469 47.4482 73.7131 47.4291 71.8192 48.6649C69.4518 50.2096 68.7099 53.8874 69.4016 55.3055C69.9613 56.4531 71.3893 58.0713 73.6673 57.7916C73.5379 57.8323 73.4057 57.8706 73.2716 57.9057C72.4272 58.1268 71.5413 58.2115 70.8426 57.971C69.4245 57.4827 68.8838 56.22 68.7925 55.6625L68.4312 55.7217C68.5371 56.3683 69.1409 57.7722 70.7234 58.3171C71.5249 58.5931 72.4965 58.4871 73.3644 58.2599C74.1459 58.0553 74.8673 57.7459 75.3483 57.4944ZM75.4185 57.2503L75.4197 57.2465L75.4171 57.2478L75.4185 57.2503Z",
				fill: "#23286B"
			}),
			/* @__PURE__ */ (0, Q.jsx)("path", {
				d: "M78.4194 199L82.6098 187.048H90.5726L92.8585 188.953C94.763 190.572 103.421 195.183 104.525 195.81C105.26 196.228 106.23 197.291 107.435 199C86.3203 198.969 78.4194 199 78.4194 199Z",
				fill: "url(#paint1_linear_726_3575)"
			}),
			/* @__PURE__ */ (0, Q.jsx)("path", {
				d: "M55.8442 199L60.0346 187.048H69.3254L71.6113 188.953C73.5158 190.572 82.1739 195.183 83.2777 195.81C84.0124 196.228 84.9832 197.291 86.1876 199C65.0731 198.969 55.8442 199 55.8442 199Z",
				fill: "url(#paint2_linear_726_3575)"
			}),
			/* @__PURE__ */ (0, Q.jsx)("path", {
				d: "M96.4595 104.673C100.404 106.436 103.024 107.5 104.317 107.865C105.864 108.28 106.77 108.129 110.279 106.884C110.731 106.733 112.278 105.79 113.712 104.885C117.296 102.508 118.126 103.64 115.145 106.771C114.353 107.639 113.787 108.582 113.938 108.883C114.051 109.148 116.202 109.185 118.654 108.921C119.472 108.641 121.499 106.237 121.688 106.426C122.14 106.878 120.427 112.731 118.73 113.449C117.975 113.826 111.901 114.09 105.185 114.09C100.708 114.09 94.394 113.852 86.2417 113.378L96.4595 104.673Z",
				fill: "#FAB6AF"
			}),
			/* @__PURE__ */ (0, Q.jsx)("path", {
				d: "M95.02 138.576C94.4647 131.944 86.388 103.384 86.388 103.384H70.452C70.2307 106.483 69.9208 113.61 70.452 117.328C71.116 121.976 74.436 129.944 74.436 133.264C74.436 136.584 75.764 148.536 75.764 152.52C75.764 156.504 75.1 159.16 74.436 161.816C73.772 164.472 73.772 170.448 74.436 175.096C74.9672 178.815 76.8707 184.835 77.756 187.048H93.692C93.692 187.048 95.521 144.56 95.02 138.576Z",
				fill: "#1D225F"
			}),
			/* @__PURE__ */ (0, Q.jsx)("path", {
				d: "M88.3796 134.592C88.3796 137.248 86.444 149.215 85.7236 151.856C83.7316 159.16 76.4276 175.76 72.4436 187.048H54.5156C54.737 183.507 56.1092 175.76 57.1716 173.104C58.4996 169.784 62.5708 165.163 63.1476 163.144C64.4756 158.496 64.4756 153.848 65.8036 150.528C67.1316 147.208 70.4516 141.232 70.4516 137.912C70.4516 134.592 67.7956 130.608 66.4676 125.96C65.1396 121.312 65.1396 115.336 65.1396 112.68C65.1396 109.877 65.361 105.598 65.8036 103.384H88.3796V134.592Z",
				fill: "url(#paint3_linear_726_3575)"
			}),
			/* @__PURE__ */ (0, Q.jsx)("path", {
				d: "M87.7153 74.1685C88.2465 75.7621 92.806 90.7685 95.0193 98.0725C95.6832 101.393 93.0273 103.384 90.3713 104.048C87.7153 104.712 72.4433 104.712 69.7873 104.712C65.8035 104.712 62.4833 104.048 59.1633 102.056C55.8433 100.064 57.3815 93.8078 59.1633 91.4322C61.1555 88.7761 64.4753 86.1202 66.4673 82.8002C68.4593 79.4802 70.4513 74.8322 71.1153 73.5042C71.7793 72.1762 73.5098 69.883 75.7633 68.1925C78.4193 66.2001 81.7393 66.2005 83.7313 66.8645C85.3531 67.4051 87.0513 72.1765 87.7153 74.1685Z",
				fill: "url(#paint4_linear_726_3575)"
			}),
			/* @__PURE__ */ (0, Q.jsx)("path", {
				d: "M102.988 119.984V99.4004C89.0441 99.4004 86.3881 90.7684 85.7241 88.7764C85.0601 86.7844 83.7321 81.4724 83.7321 77.4884C83.7321 73.5044 81.704 71.7398 79.0841 72.1764C75.1001 72.8403 71.7801 77.4883 70.4521 82.1363C69.1241 86.7843 67.7961 92.7604 67.7961 96.7444C67.7961 100.728 70.4521 104.712 72.4441 106.704C74.4361 108.696 79.0841 109.36 81.7401 111.352C84.3961 113.344 87.7161 116.664 91.0361 118.656C93.6921 120.25 100.111 120.206 102.988 119.984Z",
				fill: "url(#paint5_linear_726_3575)"
			})
		]
	}), /* @__PURE__ */ (0, Q.jsxs)("defs", { children: [
		/* @__PURE__ */ (0, Q.jsxs)("linearGradient", {
			id: "paint0_linear_726_3575",
			x1: 84.029,
			y1: 62.0194,
			x2: 82.0977,
			y2: 66.8924,
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ (0, Q.jsx)("stop", { stopColor: "#FBA19B" }),
				/* @__PURE__ */ (0, Q.jsx)("stop", {
					offset: .349149,
					stopColor: "#F9ADA7"
				}),
				/* @__PURE__ */ (0, Q.jsx)("stop", {
					offset: 1,
					stopColor: "#F9AFA9"
				})
			]
		}),
		/* @__PURE__ */ (0, Q.jsxs)("linearGradient", {
			id: "paint1_linear_726_3575",
			x1: 80.5599,
			y1: 187.274,
			x2: 89.1929,
			y2: 206.988,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ (0, Q.jsx)("stop", {
				offset: .090505,
				stopColor: "#2C7DE7"
			}), /* @__PURE__ */ (0, Q.jsx)("stop", {
				offset: .492038,
				stopColor: "#1D72D9"
			})]
		}),
		/* @__PURE__ */ (0, Q.jsxs)("linearGradient", {
			id: "paint2_linear_726_3575",
			x1: 58.0827,
			y1: 187.274,
			x2: 66.4531,
			y2: 207.264,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ (0, Q.jsx)("stop", {
				offset: .0747083,
				stopColor: "#428DFC"
			}), /* @__PURE__ */ (0, Q.jsx)("stop", {
				offset: 1,
				stopColor: "#428DFC"
			})]
		}),
		/* @__PURE__ */ (0, Q.jsxs)("linearGradient", {
			id: "paint3_linear_726_3575",
			x1: 73.1442,
			y1: 103.384,
			x2: 46.739,
			y2: 179.541,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ (0, Q.jsx)("stop", { stopColor: "#2A318C" }), /* @__PURE__ */ (0, Q.jsx)("stop", {
				offset: 1,
				stopColor: "#1D225F"
			})]
		}),
		/* @__PURE__ */ (0, Q.jsxs)("linearGradient", {
			id: "paint4_linear_726_3575",
			x1: 76.1655,
			y1: 66.4673,
			x2: 76.1655,
			y2: 104.712,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ (0, Q.jsx)("stop", { stopColor: "#A1C3FC" }), /* @__PURE__ */ (0, Q.jsx)("stop", {
				offset: 1,
				stopColor: "#91B9F7"
			})]
		}),
		/* @__PURE__ */ (0, Q.jsxs)("linearGradient", {
			id: "paint5_linear_726_3575",
			x1: 85.3921,
			y1: 72.1115,
			x2: 85.3921,
			y2: 120.097,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ (0, Q.jsx)("stop", { stopColor: "#9FC2FC" }), /* @__PURE__ */ (0, Q.jsx)("stop", {
				offset: 1,
				stopColor: "#A1C3FC"
			})]
		}),
		/* @__PURE__ */ (0, Q.jsx)("clipPath", {
			id: "clip0_726_3575",
			children: /* @__PURE__ */ (0, Q.jsx)("rect", {
				width: 250,
				height: 200,
				fill: "white"
			})
		})
	] })]
}), zO = (e) => /* @__PURE__ */ (0, Q.jsx)("span", {
	className: "flex fs-12 fw-6 cn-9 lh-20 icon-dim-24 bg__primary dc__border dc__border-radius-50-per",
	style: { marginLeft: "-13px" },
	children: e
}), BO = ({ step: e, stepLabel: t, children: n }) => /* @__PURE__ */ (0, Q.jsxs)("div", {
	className: "display-grid left fs-13 fw-4 lh-20 cn-9 dc__gap-16",
	style: { gridTemplateColumns: "24px auto" },
	children: [
		zO(e),
		t,
		n
	]
}), VO = ({ configurePluginURL: e, nodeType: t, isJobView: n = !1 }) => {
	let r = DO(t, n), i = TO(t, null, n);
	return /* @__PURE__ */ (0, Q.jsx)(R, {
		classname: "left flexbox-col dc__overflow-auto dc__gap-24 dc__skip-align-reload-center dc__align-left w-342 dc__m-auto",
		SvgImage: RO,
		imageClassName: "w-125px-imp h-100px-imp",
		title: `${i} trigger is blocked!`,
		contentClassName: "dc__align-start w-342",
		children: /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [
			/* @__PURE__ */ (0, Q.jsxs)("span", {
				className: "fs-13 fw-4 cn-9 lh-20 dc__first-letter-capitalize",
				children: [
					"Some mandatory plugins are not configured. Configure the plugins to unblock\xA0",
					i,
					" trigger."
				]
			}),
			/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox-col dc__gap-8 dc__overflow-auto",
				children: [/* @__PURE__ */ (0, Q.jsx)("h5", {
					className: "fs-14 fw-6 lh-20 cn-8",
					children: "How to unblock"
				}), /* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "flex column left top dc__border-left dc__gap-16 ml-12",
					children: [
						/* @__PURE__ */ (0, Q.jsx)(BO, {
							step: 1,
							stepLabel: r[0]
						}),
						/* @__PURE__ */ (0, Q.jsx)(BO, {
							step: 2,
							children: /* @__PURE__ */ (0, Q.jsxs)("div", {
								className: "flex column left dc__gap-8",
								children: [r[1], /* @__PURE__ */ (0, Q.jsx)("img", {
									className: "w-100-imp h-100-imp",
									src: OO(t, n),
									width: 330,
									height: 140,
									alt: "How to unblock"
								})]
							})
						}),
						/* @__PURE__ */ (0, Q.jsx)(BO, {
							step: 3,
							stepLabel: r[2]
						})
					]
				})]
			}),
			/* @__PURE__ */ (0, Q.jsx)(M, {
				dataTestId: "configure-plugins",
				endIcon: /* @__PURE__ */ (0, Q.jsx)(aa, {}),
				text: "Configure plugins to unblock",
				size: I.medium,
				component: N.link,
				variant: F.secondary,
				linkProps: { to: e }
			})
		] })
	});
}, HO = (e) => /* @__PURE__ */ (0, Q.jsxs)("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 48,
	height: 48,
	viewBox: "0 0 48 48",
	fill: "none",
	...e,
	children: [/* @__PURE__ */ (0, Q.jsx)("path", {
		d: "M24 44C12.9543 44 4 35.0457 4 24C4 12.9543 12.9543 4 24 4C35.0457 4 44 12.9543 44 24C44 35.0457 35.0457 44 24 44Z",
		fill: "#F33E3E",
		fillOpacity: .12,
		stroke: "#F33E3E",
		strokeWidth: 2
	}), /* @__PURE__ */ (0, Q.jsx)("path", {
		d: "M14 24.0021H34M34 24.0021L25.8182 15.8203M34 24.0021C34 24.0021 29.0134 28.9887 25.8182 32.1839",
		stroke: "#F33E3E",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
}), UO = ({ mandatoryPluginDetails: e }) => {
	let [t, n] = j(!1);
	return /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsxs)("button", {
		type: "button",
		onClick: () => {
			n((e) => !e);
		},
		className: `dc__transparent br-4 ev-2 bw-1 flexbox dc__gap-8 p-8 dc__align-items-center bcv-1 w-100 mt-16 ${t ? "dc__no-bottom-radius" : ""}`,
		children: [
			/* @__PURE__ */ (0, Q.jsx)(Bi, { className: "icon-dim-20 dc__no-shrink" }),
			/* @__PURE__ */ (0, Q.jsx)("span", {
				className: "cn-8 fs-13 fw-4 lh-20 flex-grow-1 dc__align-left",
				children: "Why this plugin is mandatory"
			}),
			/* @__PURE__ */ (0, Q.jsx)(hn, { className: `icon-dim-20 dc__no-shrink dc__transition--transform ${t ? "dc__flip-180--neg" : ""} ` })
		]
	}), t && /* @__PURE__ */ (0, Q.jsx)(PO, {
		pluginDetail: e,
		rootClassName: "en-2 bw-1 p-12 w-100 dc__no-border-top-imp mxh-210 dc__overflow-auto dc__bottom-left-radius dc__bottom-right-radius"
	})] });
}, WO = ({ handleClose: e, handleDelete: t, handleMoveTask: n, taskIndex: r, type: i, pluginId: a, activeStageName: o, pluginDataStore: s, resourceKindType: c, mandatoryPluginList: l }) => {
	let u = () => {
		t(r), e();
	}, d = () => {
		n(r), e();
	}, f = s.pluginVersionStore[a]?.parentPluginId, p = l.find((e) => e.parentPluginId === f && e.requiredIn === o) || l.find((e) => e.parentPluginId === f && e.requiredIn === rl.PRE_OR_POST_STAGE), m = `Plugin is mandatory for ${xO(c, o)}`;
	return i === tl.DELETE ? /* @__PURE__ */ (0, Q.jsx)(ns, {
		variant: rs.delete,
		title: m,
		subtitle: /* @__PURE__ */ (0, Q.jsxs)("p", {
			className: "m-0-imp fs-13 cn-7",
			children: [/* @__PURE__ */ (0, Q.jsx)("span", {
				className: "lh-20",
				children: "Are you sure you want to remove?"
			}), /* @__PURE__ */ (0, Q.jsx)(UO, { mandatoryPluginDetails: p })]
		}),
		buttonConfig: {
			secondaryButtonConfig: {
				onClick: e,
				text: "Cancel"
			},
			primaryButtonConfig: {
				onClick: u,
				text: "Delete"
			}
		},
		handleClose: e
	}) : i === tl.MOVE_PLUGIN ? /* @__PURE__ */ (0, Q.jsx)(ns, {
		variant: rs.custom,
		Icon: /* @__PURE__ */ (0, Q.jsx)(HO, { className: `${p.requiredIn === rl.POST_STAGE ? "dc__flip-180" : ""}` }),
		title: m,
		subtitle: "Are you sure you want to move?",
		handleClose: e,
		buttonConfig: {
			secondaryButtonConfig: {
				text: "Cancel",
				onClick: e
			},
			primaryButtonConfig: {
				text: "Move",
				onClick: d
			}
		},
		children: /* @__PURE__ */ (0, Q.jsx)(UO, { mandatoryPluginDetails: p })
	}) : null;
}, GO = /* @__PURE__ */ t({ default: () => qO }), KO = (e) => /* @__PURE__ */ (0, Q.jsxs)("span", {
	className: "flex left cr-5 fw-4 fs-12 dc__align-items-center",
	children: [/* @__PURE__ */ (0, Q.jsx)(xt, { className: "icon-dim-12 mr-4 mw-14 dc__no-shrink" }), /* @__PURE__ */ (0, Q.jsxs)("span", {
		className: "dc__block dc__ellipsis-right",
		children: [e, " is blocked"]
	})]
}), qO = ({ consequence: e, configurePluginURL: t, nodeType: n, shouldRenderAdditionalInfo: r, isJobView: i }) => {
	let a = TO(n);
	return e.action === is.BLOCK ? KO(a) : /* @__PURE__ */ (0, Q.jsx)("div", {
		className: "flex left dc__align-start dc__gap-4",
		children: /* @__PURE__ */ (0, Q.jsx)(es, {
			condition: r,
			wrap: (r) => /* @__PURE__ */ (0, Q.jsx)(NO, {
				trigger: "mouseenter focus",
				consequence: e,
				configurePluginURL: t,
				nodeType: n,
				isJobView: i,
				children: r
			}),
			children: /* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox dc__gap-4 dc__align-start",
				children: [
					/* @__PURE__ */ (0, Q.jsx)(Et, { className: "icon-dim-12 warning-icon-y7 mw-14 dc__no-shrink mt-4" }),
					/* @__PURE__ */ (0, Q.jsx)("span", {
						className: "flex left cy-7 fw-4 fs-12 flex-grow-1 dc__align-left",
						children: e.action === is.ALLOW_UNTIL_TIME ? `${i ? "Job" : a} trigger will be blocked in...` : "Plugins not configured"
					}),
					/* @__PURE__ */ (0, Q.jsx)(He, { className: "icon-dim-12 dc__no-shrink dc__flip-180 scy-7 mt-5" })
				]
			})
		})
	});
}, JO = async (e) => {
	let t = `${O.OFFENDING}/${e.resourceKind}`;
	if (e.resourceKind === Dl.cdPipeline && !e.envName) return {
		definitions: [],
		isOffendingMandatoryPlugin: !1,
		isTriggerBlocked: !1,
		pipelineBlockState: pn()
	};
	let { result: n } = await G(vd({
		kind: al.plugins,
		version: kl.alpha1,
		suffix: t,
		queryParams: bO(e)
	}));
	return {
		...n,
		pipelineBlockState: pn(n?.pipelineBlockState)
	};
}, YO = async (e, t, n, r) => {
	let { isOffendingMandatoryPlugin: i, isTriggerBlocked: a, pipelineBlockState: o } = await JO({
		appId: +t,
		appName: r,
		resourceKind: Dl.ciPipeline,
		ciPipelineId: +e || null,
		branchName: n
	});
	return {
		isOffendingMandatoryPlugin: i,
		isCITriggerBlocked: a,
		ciBlockState: o
	};
}, XO = (e, t) => {
	let n = {};
	for (let r = 0; r < e.length; r++) {
		let i = e[r].pluginRefStepDetail?.pluginId;
		i && (n[t.pluginVersionStore[i].parentPluginId] = !0);
	}
	return n;
}, ZO = (e, t, n) => {
	let r = Object.keys(n.parentPluginStore), i = Object.keys(n.pluginVersionStore);
	if (!t.length || !r.length || !i.length) return {
		pluginData: [],
		isValidPre: !0,
		isValidPost: !0
	};
	let a = XO(e?.preBuildStage?.steps || [], n), o = XO(e?.postBuildStage?.steps || [], n), s = !0, c = !0, l = r.reduce((e, t) => {
		let r = n.parentPluginStore[t].latestVersionId;
		return e[t] = n.pluginVersionStore[r], e;
	}, {}), u = [];
	return t.forEach((e) => {
		let t = !1;
		e.requiredIn === rl.PRE_STAGE && !a[e.parentPluginId] ? (t = !0, s &&= !1) : e.requiredIn === rl.POST_STAGE && !o[e.parentPluginId] ? (t = !0, c &&= !1) : e.requiredIn === rl.PRE_OR_POST_STAGE && !a[e.parentPluginId] && !o[e.parentPluginId] && (t = !0, c &&= !1, s &&= !1), t ? e.applied = !1 : e.applied = !0;
		let n = {};
		l[e.parentPluginId] && (n = { ...l[e.parentPluginId] }), u.push({
			...e,
			...n
		});
	}), {
		pluginData: u,
		isValidPre: s,
		isValidPost: c
	};
}, QO = async (e) => {
	try {
		return jO(AO(await JO(e)));
	} catch {}
	return null;
}, $O = async (e, t, n, r) => {
	if (!e.length && !t.length) return structuredClone(r);
	let { pluginStore: { parentPluginStore: i, pluginVersionStore: a } } = await _d({
		appId: n,
		parentPluginIds: t,
		pluginIds: e
	});
	return Ld(r, i, a);
}, ek = async ({ formData: e, pluginDataStoreState: t, appName: n, appId: r, ciPipelineId: i, branchName: a, requiredPluginIds: o = [], envName: s, resourceKind: c }) => {
	try {
		let l = await QO(c === Dl.ciPipeline ? {
			appId: +r,
			appName: n,
			ciPipelineId: i,
			branchName: a,
			resourceKind: c
		} : {
			appId: +r,
			appName: n,
			envName: s,
			resourceKind: c
		}), u = {
			mandatoryPluginList: [],
			requiredParentPluginIds: []
		}, { mandatoryPluginList: d, requiredParentPluginIds: f } = l?.reduce((e, n) => {
			let { parentPluginId: r } = n.data;
			e.mandatoryPluginList.push({
				id: n.data.pluginId,
				parentPluginId: r,
				requiredIn: cO[n.data.applyToStage],
				definitionSources: n.definitionSources,
				applied: !1
			});
			let i = t.parentPluginStore[r]?.latestVersionId;
			return (!i || !t.pluginVersionStore[i]) && e.requiredParentPluginIds.push(r), e;
		}, u) ?? u, p = await $O(o, f, r, t);
		return {
			mandatoryPluginData: ZO(e, d, p),
			pluginDataStore: p
		};
	} catch (e) {
		if (o.length) throw e;
		return {
			mandatoryPluginData: {
				pluginData: [],
				isValidPre: !0,
				isValidPost: !0
			},
			pluginDataStore: structuredClone(t)
		};
	}
}, tk = ({ clusterId: e, namespace: t, name: n, rbacPayload: r }) => G(Rd(O.K8S_POD, {
	clusterId: e,
	name: n,
	namespace: t,
	...r
})), nk = /* @__PURE__ */ t({ PodRestartModal: () => rk }), rk = ({ close: e, clusterId: t, namespace: n, name: r, rbacPayload: i, aiWidgetAnalyticsEvent: a }) => {
	let o = Ja(null), { aiAgentContext: s } = Tf(), [c, l] = j(""), [u, d] = j(!1), [f, p] = j(""), [m, h] = j(0), g = async () => {
		d(!0), tk({
			clusterId: t,
			namespace: n,
			name: r,
			rbacPayload: i
		}).then((e) => {
			l(e?.result), p(e?.errors);
		}).catch((e) => {
			h(e.code);
		}).finally(() => {
			d(!1);
		});
	};
	k(() => {
		g();
	}, [r]);
	let _ = (t) => {
		uf(t), t && t.key === "Escape" && (t.preventDefault(), e());
	};
	k(() => (document.addEventListener("keydown", _), () => {
		document.removeEventListener("keydown", _);
	}), [_]);
	let v = () => u ? /* @__PURE__ */ (0, Q.jsx)(ul, { pageLoader: !0 }) : m === 424 ? /* @__PURE__ */ (0, Q.jsx)(R, {
		title: "Scoop not configured",
		subTitle: "Please contact Devtron's team to configure scoop on this cluster.",
		SvgImage: Uw,
		imageType: yc.Large,
		children: /* @__PURE__ */ (0, Q.jsx)("a", {
			href: "https://enterprise.devtron.ai/portal/en/newticket",
			target: "_blank",
			rel: "noreferrer noopener",
			className: "cta secondary flex anchor",
			children: "Open ticket"
		})
	}) : m ? /* @__PURE__ */ (0, Q.jsx)(Ks, { code: m }) : f ? /* @__PURE__ */ (0, Q.jsx)(R, {
		title: "Failed to show pod restart",
		subTitle: f
	}) : /* @__PURE__ */ (0, Q.jsx)(Lc, {
		className: "pod-restart-content flexbox-col flex-grow-1 dc__overflow-auto fs-13",
		markdown: c,
		breaks: !0
	}), y = {
		clusterId: t,
		metadata: {
			namespace: n,
			name: r
		},
		prompt: c,
		analyticsCategory: a
	}, b = s ? {
		...s,
		prompt: `Why did Pod '${r}' of '${n} ns restart.`,
		data: {
			...s.data,
			podName: r,
			namespace: n
		}
	} : null;
	return /* @__PURE__ */ (0, Q.jsx)(Rs, {
		position: "right",
		width: "800px",
		children: /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox-col dc__overflow-hidden bg__primary h-100",
			ref: o,
			"data-testId": "pod-restart-modal",
			children: [/* @__PURE__ */ (0, Q.jsx)("div", {
				className: "dc__no-shrink dc__box-shadow pb-12 pt-12 bg__primary",
				children: /* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "title flex dc__content-space cn-9 fs-16 fw-6 pl-20 pr-20 ",
					"data-testid": "pods-restart-heading-after-click",
					children: ["Pod last restart snapshot", /* @__PURE__ */ (0, Q.jsxs)("div", {
						className: "flex dc__gap-12",
						children: [c && /* @__PURE__ */ (0, Q.jsx)(zi, {
							intelligenceConfig: y,
							debugAgentContext: b,
							onClick: e
						}), /* @__PURE__ */ (0, Q.jsx)(M, {
							dataTestId: "close-button",
							icon: /* @__PURE__ */ (0, Q.jsx)(z, {
								name: "ic-close-small",
								size: 24,
								color: null
							}),
							onClick: e,
							ariaLabel: "close pod restart modal",
							showAriaLabelInTippy: !1,
							variant: F.borderLess,
							style: P.negativeGrey,
							size: I.xs
						})]
					})]
				})
			}), v()]
		})
	});
}, ik = /* @__PURE__ */ t({ default: () => ak }), ak = ({ rbacPayload: e, aiWidgetAnalyticsEvent: t }) => {
	let n = X(), { searchParams: r } = jf();
	if (!r.podRestartModalParams) return null;
	let { clusterId: i, namespace: a, name: o } = JSON.parse(r.podRestartModalParams);
	return /* @__PURE__ */ (0, Q.jsx)(rk, {
		close: () => {
			delete r.podRestartModalParams, n({ search: new URLSearchParams(r).toString() }, { replace: !0 });
		},
		clusterId: +i,
		namespace: a,
		name: o,
		rbacPayload: e,
		aiWidgetAnalyticsEvent: t
	});
}, ok = (e) => /* @__PURE__ */ (0, Q.jsx)("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ (0, Q.jsx)("path", {
		d: "M10.9621 10.9625L13.9996 14.0001M5.25334 7.25333H7.25334M7.25334 7.25333H9.25334M7.25334 7.25333V5.25333M7.25334 7.25333V9.25333M12.5 7.25C12.5 10.1495 10.1495 12.5 7.25 12.5C4.35051 12.5 2 10.1495 2 7.25C2 4.35051 4.35051 2 7.25 2C10.1495 2 12.5 4.35051 12.5 7.25Z",
		stroke: "#596168",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), sk = /* @__PURE__ */ t({ default: () => ck }), ck = (e) => {
	let { searchParams: t } = jf(), n = X();
	return /* @__PURE__ */ (0, Q.jsx)(ok, {
		className: "restart-icon cursor ml-4 flex",
		onClick: () => {
			let r = {
				...t,
				podRestartModalParams: JSON.stringify(e)
			};
			n({ search: new URLSearchParams(r).toString() });
		}
	});
}, lk = (e) => /* @__PURE__ */ (0, Q.jsx)("svg", {
	width: 96,
	height: 101,
	viewBox: "0 0 96 101",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ (0, Q.jsxs)("g", {
		id: "Group 1476",
		children: [
			/* @__PURE__ */ (0, Q.jsx)("path", {
				id: "Vector",
				d: "M49.6709 16.7595V2.86954C49.6709 1.94821 48.9223 1.19955 47.9993 1.19955C47.0779 1.19955 46.3293 1.94821 46.3293 2.86954V18.3282C46.3293 19.2481 47.0779 19.9966 47.9993 19.9966C48.1036 19.9966 48.208 19.9885 48.3076 19.9672C51.8889 20.1303 54.7558 23.0854 54.7558 26.7074C54.7558 30.4289 51.7258 33.4623 47.9993 33.4623C44.2761 33.4623 41.2427 30.4306 41.2427 26.7074H37.8994C37.8994 32.2751 42.4332 36.8039 47.9976 36.8039C53.567 36.8039 58.0958 32.2751 58.0958 26.7074C58.0975 21.7123 54.4426 17.5601 49.6709 16.7595Z",
				fill: "#91ADB5"
			}),
			/* @__PURE__ */ (0, Q.jsxs)("g", {
				id: "Group",
				children: [
					/* @__PURE__ */ (0, Q.jsx)("path", {
						id: "Vector_2",
						d: "M47.9991 16.5638C48.1034 16.5638 48.2078 16.5524 48.3074 16.5328C48.7786 16.5539 49.232 16.6257 49.6707 16.7367V13.3249V2.86954C49.6707 1.94821 48.9221 1.19955 47.9991 1.19955C47.0778 1.19955 46.3291 1.94821 46.3291 2.86954V14.8938C46.3274 15.8135 47.0776 16.5638 47.9991 16.5638Z",
						fill: "#A8C6CC"
					}),
					/* @__PURE__ */ (0, Q.jsx)("path", {
						id: "Vector_3",
						d: "M57.9405 24.966C57.2262 20.8645 54.015 17.6158 49.9363 16.8183C52.7169 17.6549 54.7538 20.2235 54.7538 23.2749C54.7538 23.8651 54.6689 24.4393 54.5223 24.9873C54.6691 25.5401 54.7538 26.1126 54.7538 26.7095C54.7538 29.7672 52.7038 32.3571 49.9053 33.1824C54.0136 32.3911 57.2393 29.1082 57.9405 24.966Z",
						fill: "#A8C6CC"
					}),
					/* @__PURE__ */ (0, Q.jsx)("path", {
						id: "Vector_4",
						d: "M41.2426 26.7076H38.5159C39.7146 30.0035 42.5768 32.5068 46.0911 33.1805C43.2925 32.3552 41.2426 29.7654 41.2426 26.7076Z",
						fill: "#A8C6CC"
					})
				]
			}),
			/* @__PURE__ */ (0, Q.jsx)("path", {
				id: "Vector_5",
				d: "M54.3348 5.37456C54.3348 5.99092 53.8358 6.4901 53.2226 6.4901H42.777C42.1589 6.4901 41.6631 5.99113 41.6631 5.37456V1.61388C41.6631 0.997519 42.1589 0.5 42.777 0.5H53.2226C53.8358 0.5 54.3348 0.997312 54.3348 1.61388V5.37456Z",
				fill: "#608387"
			}),
			/* @__PURE__ */ (0, Q.jsx)("path", {
				id: "SVGCleanerId_0",
				d: "M16.5728 67.8896C15.9662 67.8896 15.3627 67.6565 14.8995 67.1948C13.9749 66.2701 13.9749 64.773 14.8995 63.8467L46.3242 32.4221C47.2488 31.4991 48.7476 31.4991 49.6722 32.4221L81.0968 63.8467C82.0215 64.7714 82.0215 66.2685 81.0968 67.1948C80.1722 68.1178 78.6751 68.1178 77.7504 67.1948L47.9993 37.4435L18.2461 67.195C17.7846 67.6581 17.178 67.8896 16.5728 67.8896Z",
				fill: "#91ADB5"
			}),
			/* @__PURE__ */ (0, Q.jsx)("path", {
				id: "Vector_6",
				d: "M95.2936 97.4161C95.2936 99.1186 93.9139 100.5 92.2097 100.5H3.79036C2.08621 100.5 0.704834 99.1186 0.704834 97.4161V63.7408C0.704834 62.0366 2.08621 60.6552 3.79036 60.6552H92.2114C93.9156 60.6552 95.2953 62.0366 95.2953 63.7408V97.4161H95.2936Z",
				fill: "#104FB5"
			}),
			/* @__PURE__ */ (0, Q.jsx)("g", {
				id: "Group_2",
				children: /* @__PURE__ */ (0, Q.jsx)("path", {
					id: "SVGCleanerId_0_1_",
					d: "M16.5728 67.8896C15.9662 67.8896 15.3627 67.6565 14.8995 67.1948C13.9749 66.2701 13.9749 64.773 14.8995 63.8467L46.3242 32.4221C47.2488 31.4991 48.7476 31.4991 49.6722 32.4221L81.0968 63.8467C82.0215 64.7714 82.0215 66.2685 81.0968 67.1948C80.1722 68.1178 78.6751 68.1178 77.7504 67.1948L47.9993 37.4435L18.2461 67.195C17.7846 67.6581 17.178 67.8896 16.5728 67.8896Z",
					fill: "#91ADB5"
				})
			}),
			/* @__PURE__ */ (0, Q.jsx)("path", {
				id: "Vector_7",
				d: "M18.1876 67.1345L49.6139 35.7082C50.5385 34.7869 52.0292 34.7869 52.9538 35.7049L49.6727 32.4221C48.748 31.4991 47.2493 31.4991 46.3246 32.4221L14.8998 63.8484C13.9751 64.773 13.9751 66.2701 14.8998 67.1964C15.3629 67.6579 15.9665 67.8913 16.5731 67.8913C17.1097 67.8913 17.6331 67.6776 18.0702 67.314C18.1174 67.2569 18.1352 67.185 18.1876 67.1345Z",
				fill: "#A8C6CC"
			}),
			/* @__PURE__ */ (0, Q.jsx)("path", {
				id: "Vector_8",
				d: "M95.2935 97.4161V63.7408C95.2935 62.0366 93.9138 60.6552 92.2096 60.6552H62.9606C61.2564 60.6552 59.8767 62.0366 59.8767 63.7408V97.4145C59.8767 99.117 61.2564 100.498 62.9606 100.498H92.2113C93.914 100.498 95.2935 99.1186 95.2935 97.4161Z",
				fill: "#3BABFF"
			}),
			/* @__PURE__ */ (0, Q.jsxs)("g", {
				id: "Group_3",
				children: [
					/* @__PURE__ */ (0, Q.jsx)("path", {
						id: "Vector_9",
						d: "M62.9606 60.6569C61.2564 60.6569 59.8767 62.0382 59.8767 63.7424V97.4161C59.8767 99.1186 61.2564 100.5 62.9606 100.5H92.2113C93.9154 100.5 95.2952 99.1186 95.2952 97.4161",
						fill: "#148DE0"
					}),
					/* @__PURE__ */ (0, Q.jsx)("path", {
						id: "Vector_10",
						d: "M8.26354 92.4111C8.26354 92.8498 7.91136 93.2003 7.4743 93.2003C7.03889 93.2003 6.68506 92.8482 6.68506 92.4111V68.7443C6.68506 68.3089 7.03889 67.955 7.4743 67.955C7.91136 67.955 8.26354 68.3105 8.26354 68.7443V92.4111Z",
						fill: "#148DE0"
					}),
					/* @__PURE__ */ (0, Q.jsx)("path", {
						id: "Vector_11",
						d: "M14.0531 92.4111C14.0531 92.8498 13.6993 93.2003 13.2638 93.2003C12.8268 93.2003 12.4746 92.8482 12.4746 92.4111V68.7443C12.4746 68.3089 12.8268 67.955 13.2638 67.955C13.6993 67.955 14.0531 68.3105 14.0531 68.7443V92.4111Z",
						fill: "#148DE0"
					}),
					/* @__PURE__ */ (0, Q.jsx)("path", {
						id: "Vector_12",
						d: "M19.836 92.4111C19.836 92.8498 19.4806 93.2003 19.0468 93.2003C18.6097 93.2003 18.2576 92.8482 18.2576 92.4111V68.7443C18.2576 68.3089 18.6097 67.955 19.0468 67.955C19.4806 67.955 19.836 68.3105 19.836 68.7443V92.4111Z",
						fill: "#148DE0"
					}),
					/* @__PURE__ */ (0, Q.jsx)("path", {
						id: "Vector_13",
						d: "M25.6239 92.4111C25.6239 92.8498 25.2701 93.2003 24.8361 93.2003C24.3974 93.2003 24.0469 92.8482 24.0469 92.4111V68.7443C24.0469 68.3089 24.3976 67.955 24.8361 67.955C25.2699 67.955 25.6239 68.3105 25.6239 68.7443V92.4111Z",
						fill: "#148DE0"
					}),
					/* @__PURE__ */ (0, Q.jsx)("path", {
						id: "Vector_14",
						d: "M31.4086 92.4111C31.4086 92.8498 31.0564 93.2003 30.6193 93.2003C30.1839 93.2003 29.8301 92.8482 29.8301 92.4111V68.7443C29.8301 68.3089 30.1839 67.955 30.6193 67.955C31.0564 67.955 31.4086 68.3105 31.4086 68.7443V92.4111Z",
						fill: "#148DE0"
					}),
					/* @__PURE__ */ (0, Q.jsx)("path", {
						id: "Vector_15",
						d: "M37.1932 92.4111C37.1932 92.8498 36.8425 93.2003 36.4054 93.2003C35.97 93.2003 35.6162 92.8482 35.6162 92.4111V68.7443C35.6162 68.3089 35.97 67.955 36.4054 67.955C36.8442 67.955 37.1932 68.3105 37.1932 68.7443V92.4111Z",
						fill: "#148DE0"
					}),
					/* @__PURE__ */ (0, Q.jsx)("path", {
						id: "Vector_16",
						d: "M42.9808 92.4111C42.9808 92.8498 42.6253 93.2003 42.1916 93.2003C41.7529 93.2003 41.4023 92.8482 41.4023 92.4111V68.7443C41.4023 68.3089 41.7531 67.955 42.1916 67.955C42.6253 67.955 42.9808 68.3105 42.9808 68.7443V92.4111Z",
						fill: "#148DE0"
					}),
					/* @__PURE__ */ (0, Q.jsx)("path", {
						id: "Vector_17",
						d: "M48.7672 92.4111C48.7672 92.8498 48.415 93.2003 47.978 93.2003C47.5426 93.2003 47.1902 92.8482 47.1902 92.4111V68.7443C47.1902 68.3089 47.5424 67.955 47.978 67.955C48.415 67.955 48.7672 68.3105 48.7672 68.7443V92.4111Z",
						fill: "#148DE0"
					}),
					/* @__PURE__ */ (0, Q.jsx)("path", {
						id: "Vector_18",
						d: "M54.5536 92.4111C54.5536 92.8498 54.2014 93.2003 53.7643 93.2003C53.3289 93.2003 52.9751 92.8482 52.9751 92.4111V68.7443C52.9751 68.3089 53.3289 67.955 53.7643 67.955C54.2014 67.955 54.5536 68.3105 54.5536 68.7443V92.4111Z",
						fill: "#148DE0"
					})
				]
			}),
			/* @__PURE__ */ (0, Q.jsx)("path", {
				id: "Vector_19",
				d: "M85.4236 76.1663L79.3455 70.0882C78.3751 69.113 76.7917 69.113 75.8196 70.0882L69.7415 76.1663C68.7678 77.1414 68.7678 78.7201 69.7415 79.6955C70.7167 80.6692 72.297 80.6692 73.2707 79.6955L75.7121 77.2541V83.6404C75.7121 84.6727 76.5505 85.5094 77.5828 85.5094C78.6151 85.5094 79.4534 84.6711 79.4534 83.6404V77.2541L81.8948 79.6955C82.3824 80.1831 83.0217 80.4245 83.6611 80.4245C84.3004 80.4245 84.9364 80.1831 85.424 79.6955C86.3973 78.7218 86.3973 77.1414 85.4236 76.1663Z",
				fill: "#3BABFF"
			}),
			/* @__PURE__ */ (0, Q.jsx)("path", {
				id: "Vector_20",
				d: "M79.3472 70.0897C78.3768 69.1145 76.7934 69.1145 75.8213 70.0897L70.3662 75.5448L73.8938 79.074L75.7122 77.2556V80.8908L79.2658 84.4478C79.3832 84.2016 79.4551 83.9341 79.4551 83.6438V77.2575L81.8965 79.6989C82.3841 80.1865 83.0234 80.4279 83.6628 80.4279C84.3021 80.4279 84.9381 80.1865 85.4257 79.6989C86.3994 78.7237 86.3994 77.145 85.4257 76.1697L79.3472 70.0897Z",
				fill: "#104FB5"
			}),
			/* @__PURE__ */ (0, Q.jsx)("path", {
				id: "Vector_21",
				d: "M82.6514 88.0519H72.519C71.4834 88.0519 70.6484 88.8918 70.6484 89.9225C70.6484 90.9565 71.4834 91.7931 72.519 91.7931H82.6514C83.6837 91.7931 84.522 90.9548 84.522 89.9225C84.5218 88.8916 83.6821 88.0519 82.6514 88.0519Z",
				fill: "#3BABFF"
			})
		]
	})
}), uk = /* @__PURE__ */ function(e) {
	return e.ENVIRONMENT = "ENVIRONMENT", e.NAMESPACE = "NAMESPACE", e;
}({}), dk = /* @__PURE__ */ function(e) {
	return e.ALL_EXISTING_AND_FUTURE_ENVIRONMENTS = "all_existing_and_future_environments", e.SPECIFIC_ENVIRONMENTS = "specific_environments", e;
}({}), fk = ({ isSuperAdmin: e }) => {
	let [t, n] = j({}), [r, i] = j(!1), [a, o] = j(!0), [s, c] = j(""), [l, u] = j(!1), [d, f] = j({}), [p, m] = j(!1), h = (e) => {
		if (!e?.length) return null;
		let t;
		return t = e.every((e) => e.isSelected) ? Io.CHECKED : e.some((e) => e.isSelected) ? Io.INTERMEDIATE : null, t;
	};
	async function g() {
		try {
			o(!0), await Promise.all([FE(), IE()]).then(([e, t]) => {
				let r = {}, a = {}, s = {};
				t.result.enableDigestForAllClusters && i(!0), t.result.clusterDetails.forEach((e) => {
					a[e.clusterId] = {
						clusterId: e.clusterId,
						policyType: e.policyType,
						environmentIds: e.environmentIds ?? [],
						envDetails: [],
						clusterName: "",
						isClusterSelected: null
					}, e.environmentIds.forEach((e) => {
						r[e] = !0;
					});
				}), e.result.forEach((e) => {
					a[e.cluster_id] || (a[e.cluster_id] = {
						clusterId: e.cluster_id,
						isClusterSelected: null,
						policyType: null,
						clusterName: e.cluster_name,
						environmentIds: [],
						envDetails: []
					}), a[e.cluster_id].clusterName || (a[e.cluster_id].clusterName = e.cluster_name), s[e.cluster_id] || (s[e.cluster_id] = []), s[e.cluster_id].push({
						environmentId: e.id,
						environmentName: e.environment_name,
						namespace: e.namespace,
						isSelected: a[e.cluster_id].policyType === dk.ALL_EXISTING_AND_FUTURE_ENVIRONMENTS || r[e.id],
						id: e.id,
						isDigestEnforcedForEnv: e.isDigestEnforcedForEnv,
						clusterId: e.cluster_id,
						clusterName: e.cluster_name
					});
				}), Object.keys(a).forEach((e) => {
					a[e].envDetails = s[e], a[e].isClusterSelected = h(a[e].envDetails);
				}), n(a), f(a), i(t.result.enableDigestForAllClusters), o(!1);
			});
		} catch (e) {
			o(!1), K(e);
		}
	}
	k(() => {
		e && g();
	}, []);
	let _ = () => {
		i(!r);
	}, v = () => /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "en-2 bw-1 px-16 py-12 flex dc__content-space br-4",
		children: [/* @__PURE__ */ (0, Q.jsxs)("div", { children: [/* @__PURE__ */ (0, Q.jsx)("div", {
			className: "fw-6",
			children: "Pull image digest for all existing & future environments"
		}), /* @__PURE__ */ (0, Q.jsxs)("div", { children: ["When enabled, image will be pulled with image digest to ensure uniqueness of image.\xA0", /* @__PURE__ */ (0, Q.jsx)(Ns, {
			dataTestId: "pull-image-digest-learn-more",
			docLinkKey: "GLOBAL_CONFIG_PULL_IMAGE_DIGEST"
		})] })] }), /* @__PURE__ */ (0, Q.jsx)(bs, {
			name: "toggle-pull-image-digest-global",
			ariaLabel: "Toggle pull image digest for all existing & future environments",
			isChecked: r,
			onChange: _
		})]
	}), y = (e) => {
		let t;
		return e === Io.CHECKED ? t = dk.ALL_EXISTING_AND_FUTURE_ENVIRONMENTS : e === Io.INTERMEDIATE && (t = dk.SPECIFIC_ENVIRONMENTS), t;
	}, b = (e) => {
		let t = (t) => {
			let n = t[e].isClusterSelected === Io.CHECKED ? null : Io.CHECKED;
			return {
				...t,
				[e]: {
					...t[e],
					isClusterSelected: n,
					policyType: y(n),
					envDetails: t[e].envDetails.map((n) => ({
						...n,
						isSelected: t[e].isClusterSelected !== Io.CHECKED
					}))
				}
			};
		};
		n(t), f(t);
	}, x = (e, t) => {
		let r = (n) => {
			let r = n[t].envDetails.map((t) => t.environmentId === e ? {
				...t,
				isSelected: !t.isSelected
			} : t), i = h(r);
			return {
				...n,
				[t]: {
					...n[t],
					envDetails: r,
					isClusterSelected: i,
					policyType: y(i)
				}
			};
		};
		n(r), f(r);
	}, S = (e) => e?.length === 0 ? null : e.map((e) => /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "image-digest-env-namespace pl-16 pr-16 pt-6 pb-6 dc__border-bottom-n1 fs-13 lh-20",
		children: [
			/* @__PURE__ */ (0, Q.jsx)(Wo, {
				rootClassName: "mt-3 mb-3",
				dataTestId: "enforce-policy",
				isChecked: e.isSelected,
				value: e.isSelected && Io.CHECKED,
				onChange: () => x(e.environmentId, e.clusterId),
				onClick: uf
			}),
			/* @__PURE__ */ (0, Q.jsx)("div", { children: e.environmentName }),
			/* @__PURE__ */ (0, Q.jsx)("div", { children: e.namespace })
		]
	})), C = (e, t, n) => /* @__PURE__ */ (0, Q.jsx)("div", {
		className: "bg__secondary pl-16 pr-16 pt-10 pb-10 dc__border-bottom",
		children: /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flex left top cursor",
			onClick: () => b(t),
			"data-testId": "enforce-cluster-checkbox",
			children: [/* @__PURE__ */ (0, Q.jsx)(Wo, {
				rootClassName: "mt-3",
				dataTestId: "enforce-policy",
				isChecked: n === Io.CHECKED || n === Io.INTERMEDIATE,
				value: n,
				onChange: () => b(t),
				onClick: uf
			}), /* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "fs-13",
				children: [/* @__PURE__ */ (0, Q.jsxs)("span", {
					className: "fw-6 mr-12",
					children: [e, " "]
				}), n === Io.CHECKED && "All existing & future environments"]
			})]
		})
	});
	return e ? /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "bg__primary flexbox-col dc__overflow-hidden dc__content-space h-100",
		children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox-col flex-grow-1 dc__overflow-auto dc__gap-12",
			children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flex dc__content-space dc__no-shrink pt-16 px-16",
				children: [/* @__PURE__ */ (0, Q.jsx)(Xs, {
					title: on.PULL_IMAGE_DIGEST.title,
					renderDescriptionContent: () => on.PULL_IMAGE_DIGEST.description,
					docLink: on.PULL_IMAGE_DIGEST.docLink,
					showInfoIconTippy: !0
				}), /* @__PURE__ */ (0, Q.jsx)(Il, {
					initialSearchText: s,
					handleSearchChange: (e) => {
						u(!0), c(e);
						let n = !0, r = {};
						Object.keys(t).forEach((i) => {
							let a = t[i].envDetails.filter((t) => t.environmentName.toLowerCase().includes(e.toLowerCase()) || t.namespace.toLowerCase().includes(e.toLowerCase()));
							a.length && (n = !1, r[i] = {
								...t[i],
								envDetails: a
							}), n &&= a.length === 0;
						}), f(r), m(n);
					},
					handleEnter: () => {
						u(!0);
					},
					containerClassName: "w-250-imp",
					inputProps: {
						placeholder: "Search environment or namespa...",
						autoFocus: !0
					}
				})]
			}), /* @__PURE__ */ (0, Q.jsx)("div", {
				className: "flexbox-col flex-grow-1 dc__overflow-auto py-16 px-16 dc__gap-12",
				children: a ? /* @__PURE__ */ (0, Q.jsx)("div", {
					className: "dc__align-reload-center bg__primary",
					children: /* @__PURE__ */ (0, Q.jsx)(ul, { pageLoader: !0 })
				}) : p && l ? /* @__PURE__ */ (0, Q.jsx)("div", {
					className: "dc__align-reload-center",
					children: /* @__PURE__ */ (0, Q.jsx)(oc, {})
				}) : /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [v(), r ? /* @__PURE__ */ (0, Q.jsx)("div", {
					className: "en-2 bw-1 br-4 flex flex-grow-1",
					children: /* @__PURE__ */ (0, Q.jsxs)("div", {
						className: "dc__mxw-300 flex column dc__text-center",
						children: [
							/* @__PURE__ */ (0, Q.jsx)(lk, { className: "mr-8 w-100px h-100px-imp mb-4" }),
							/* @__PURE__ */ (0, Q.jsx)("div", {
								className: "fs-11 fw-5 mb-16 cb-4 pl-6 pr-6 eb-2 bw-1 br-4 mono bcb-1",
								children: "sha256:2f14a…"
							}),
							/* @__PURE__ */ (0, Q.jsx)("div", {
								className: "fs-13 fw-6 lh-20 cn-9",
								children: "Image digest will be pulled from registry for deployment to all environments"
							})
						]
					})
				}) : /* @__PURE__ */ (0, Q.jsx)("div", {
					className: "flexbox-col flex-grow-1 dc__gap-12",
					children: Object.values(d).map((e) => e.envDetails?.length ? /* @__PURE__ */ (0, Q.jsxs)("div", {
						className: "en-2 bw-1 br-4",
						children: [
							C(e.clusterName, e.clusterId, e.isClusterSelected),
							/* @__PURE__ */ (0, Q.jsxs)("div", {
								className: "image-digest-env-namespace pl-16 pr-16 pt-6 pb-6 dc__border-bottom-n1 fw-6",
								children: [
									/* @__PURE__ */ (0, Q.jsx)("div", {}),
									/* @__PURE__ */ (0, Q.jsx)("div", { children: uk.ENVIRONMENT }),
									/* @__PURE__ */ (0, Q.jsx)("div", { children: uk.NAMESPACE })
								]
							}),
							S(d[e.clusterId].envDetails)
						]
					}) : null)
				})] })
			})]
		}), /* @__PURE__ */ (0, Q.jsx)("div", {
			className: "py-16 px-20 dc__border-top-n1 dc__no-shrink",
			children: /* @__PURE__ */ (0, Q.jsx)(M, {
				size: I.medium,
				onClick: async () => {
					let e = [];
					r || Object.values(t).forEach((t) => {
						if (t.policyType === dk.SPECIFIC_ENVIRONMENTS) {
							let n = t?.envDetails.filter((e) => e.isSelected).map((e) => e.environmentId);
							e.push({
								clusterId: t.clusterId,
								environmentIds: r ? [] : n,
								policyType: dk.SPECIFIC_ENVIRONMENTS
							});
						} else t.policyType === dk.ALL_EXISTING_AND_FUTURE_ENVIRONMENTS && e.push({
							clusterId: t.clusterId,
							environmentIds: [],
							policyType: dk.ALL_EXISTING_AND_FUTURE_ENVIRONMENTS
						});
					});
					let n = {
						enableDigestForAllClusters: r,
						clusterDetails: e
					};
					try {
						o(!0), await LE(n), await g(), H.showToast({
							variant: U.success,
							description: "Saved Changes"
						});
					} catch (e) {
						K(e);
					} finally {
						o(!1);
					}
				},
				disabled: p,
				dataTestId: "save-changes",
				isLoading: a,
				text: "Save Changes"
			})
		})]
	}) : /* @__PURE__ */ (0, Q.jsx)(qs, {});
}, pk = /* @__PURE__ */ function(e) {
	return e.Password = "PASSWORD", e.SSH_Private_Key = "SSH_PRIVATE_KEY", e.Password_And_SSH_Private_Key = "PASSWORD_AND_SSH_PRIVATE_KEY", e;
}({}), mk = {
	Password: "Password",
	SSHAuthKey: "SSH Private Key",
	PasswordAndSSHAuthKey: "Password & SSH Private Key"
}, hk = (e, t, n) => {
	if (!e) return {
		connectionMethod: "",
		proxyConfig: { proxyUrl: "" },
		sshConfig: {
			sshServerAddress: "",
			sshUsername: "",
			sshPassword: "",
			sshAuthKey: ""
		}
	};
	let r = Cl.Direct, i = null;
	e.proxyConfig ? (r = e.connectionMethod.value, r === Cl.Proxy && (i = e.proxyConfig.proxyUrl.value)) : t ? (r = t, r === Cl.Proxy && (i = e.proxyUrl?.value)) : e.isConnectedViaProxy && (r = Cl.Proxy, i = e.proxyUrl?.value);
	let a = null;
	return r === Cl.SSHTunnel && (a = {
		sshServerAddress: e.sshServerAddress?.value || e.sshConfig?.sshServerAddress?.value || "",
		sshUsername: e.sshUsername?.value || e.sshConfig?.sshUsername?.value || "",
		sshPassword: (n === pk.Password || n === pk.Password_And_SSH_Private_Key) && (e.sshPassword?.value || e.sshConfig?.sshPassword?.value) || "",
		sshAuthKey: (n === pk.SSH_Private_Key || n === pk.Password_And_SSH_Private_Key) && (e.sshAuthKey?.value || e.sshConfig?.sshAuthKey?.value) || ""
	}), {
		connectionMethod: r,
		proxyConfig: i ? { proxyUrl: i } : null,
		sshConfig: a
	};
}, gk = (e) => ({
	sshUsername: e?.user,
	sshPassword: e?.password,
	sshAuthKey: e?.authKey,
	sshServerAddress: e?.sshServerAddress
}), _k = ({ dataTestId: e, value: t, text: n, infoCardText: r = "" }) => /* @__PURE__ */ (0, Q.jsx)(yl, {
	dataTestId: e,
	value: t,
	children: /* @__PURE__ */ (0, Q.jsx)(W, {
		content: r,
		alwaysShowTippyOnHover: !!r,
		children: /* @__PURE__ */ (0, Q.jsx)("span", {
			className: `flex left fs-13 cn-9 ${r ? "dc__underline-dotted" : ""} m-0`,
			children: n
		})
	})
}), vk = ({ remoteConnectionType: e, handleConnectionTypeChange: t }) => /* @__PURE__ */ (0, Q.jsxs)(vl, {
	className: "radio-group-no-border",
	value: e,
	name: "cluster-connection-type",
	onChange: t,
	children: [
		/* @__PURE__ */ (0, Q.jsx)(_k, {
			dataTestId: "direct",
			value: Cl.Direct,
			text: hl[Cl.Direct],
			infoCardText: "Use this to directly connect to Remote API Server."
		}),
		/* @__PURE__ */ (0, Q.jsx)(_k, {
			dataTestId: "proxy",
			value: Cl.Proxy,
			text: hl[Cl.Proxy],
			infoCardText: "Use this to connect to remote server sitting behind a Proxy. Connections to this server will be routed via the configured Proxy URL."
		}),
		/* @__PURE__ */ (0, Q.jsx)(_k, {
			dataTestId: "ssh-tunnel",
			value: Cl.SSHTunnel,
			text: hl[Cl.SSHTunnel],
			infoCardText: "Use SSH Tunnel to connect with remote locations over an encrypted SSH connection."
		})
	]
}), yk = ({ authenticationType: e, handleAuthenticationTypeChange: t }) => /* @__PURE__ */ (0, Q.jsxs)(vl, {
	className: "radio-group-no-border",
	value: e,
	name: "authentication-type",
	onChange: t,
	children: [
		/* @__PURE__ */ (0, Q.jsx)(_k, {
			dataTestId: "authenticate_via_password",
			value: pk.Password,
			text: mk.Password
		}),
		/* @__PURE__ */ (0, Q.jsx)(_k, {
			dataTestId: "authenticate_via_ssh_private_key",
			value: pk.SSH_Private_Key,
			text: mk.SSHAuthKey
		}),
		/* @__PURE__ */ (0, Q.jsx)(_k, {
			dataTestId: "authentication_via_password_and_ssh_private_key",
			value: pk.Password_And_SSH_Private_Key,
			text: mk.PasswordAndSSHAuthKey
		})
	]
}), bk = ({ handleOnChange: e, proxyConfig: t }) => /* @__PURE__ */ (0, Q.jsx)("div", {
	className: "form__row mt-12",
	children: /* @__PURE__ */ (0, Q.jsx)(os, {
		required: !0,
		label: "Proxy URL with port number for Registry",
		name: "proxyUrl",
		value: t.proxyUrl.value,
		onChange: e,
		error: t.proxyUrl.error,
		placeholder: "eg. http://proxy.example.org:3128"
	})
}), xk = ({ handleOnChange: e, sshConfig: t }) => /* @__PURE__ */ (0, Q.jsxs)("div", { children: [/* @__PURE__ */ (0, Q.jsx)("div", {
	className: "form__row mt-12",
	children: /* @__PURE__ */ (0, Q.jsx)(os, {
		label: "SSH Server URL",
		name: "sshServerAddress",
		value: t.sshServerAddress.value,
		onChange: e,
		error: t.sshServerAddress.error,
		placeholder: "eg. http://proxy.example.org",
		helperText: "Devtron will connect to Port 22 of the SSH Server",
		required: !0
	})
}), /* @__PURE__ */ (0, Q.jsx)("div", {
	className: "form__row mt-12",
	children: /* @__PURE__ */ (0, Q.jsx)(os, {
		label: "Username",
		name: "sshUsername",
		value: t.sshUsername.value,
		onChange: e,
		error: t.sshUsername.error,
		placeholder: "Username or User Identifier",
		required: !0
	})
})] }), Sk = ({ handleOnChange: e, handleOnBlur: t, handleOnFocus: n, sshConfig: r }) => /* @__PURE__ */ (0, Q.jsx)("div", {
	className: "flex column left top mt-12",
	children: /* @__PURE__ */ (0, Q.jsx)(ou, {
		name: "sshPassword",
		value: r.sshPassword.value,
		onChange: e,
		onBlur: t,
		onFocus: n,
		placeholder: "Enter Password",
		required: !0,
		label: "Password",
		error: r.sshPassword.error,
		shouldTrim: !1,
		fullWidth: !0
	})
}), Ck = ({ handleOnChange: e, handleOnBlur: t, handleOnFocus: n, sshConfig: r }) => /* @__PURE__ */ (0, Q.jsx)("div", {
	className: "flex column left top mt-12",
	children: /* @__PURE__ */ (0, Q.jsx)(ou, {
		name: "sshAuthKey",
		value: r.sshAuthKey.value,
		onChange: e,
		onBlur: t,
		onFocus: n,
		placeholder: "Enter SSH Private Key",
		label: "SSH Private Key",
		required: !0,
		error: r.sshAuthKey.error,
		shouldTrim: !1,
		fullWidth: !0
	})
}), wk = ({ resourceType: e, connectionMethod: t, proxyConfig: n, sshConfig: r, changeRemoteConnectionType: i, changeSSHAuthenticationType: a, handleOnChange: o }) => {
	let s;
	s = t.value === Cl.Proxy ? Cl.Proxy : t.value === Cl.SSHTunnel ? Cl.SSHTunnel : Cl.Direct;
	let c;
	c = r?.sshPassword?.value && r?.sshAuthKey?.value ? pk.Password_And_SSH_Private_Key : r?.sshAuthKey?.value ? pk.SSH_Private_Key : pk.Password;
	let [l, u] = j(s), [d, f] = j(c), p = (e) => {
		let t = e.target.value;
		u(t), i(t);
	}, m = (e) => {
		let t = e.target.value;
		f(t), a(t);
	}, h = (e) => {
		e.target.value === fs && (e.target.value = "");
	}, g = (e) => {
		!e.target.value && (r.sshPassword.value || r.sshAuthKey.value) && (e.target.value = fs);
	}, _ = (e) => /* @__PURE__ */ (0, Q.jsx)("div", {
		className: "form__row mt-12",
		children: /* @__PURE__ */ (0, Q.jsx)(xc, { description: e })
	});
	return /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [
		/* @__PURE__ */ (0, Q.jsx)(vk, {
			remoteConnectionType: l,
			handleConnectionTypeChange: p
		}),
		l === Cl.Proxy && /* @__PURE__ */ (0, Q.jsxs)("div", { children: [/* @__PURE__ */ (0, Q.jsx)(bk, {
			handleOnChange: o,
			proxyConfig: n
		}), e === "cluster" && _("For clusters connected via Proxy, deployments should NOT be done via GitOps(ArgoCD)")] }),
		l === Cl.SSHTunnel && /* @__PURE__ */ (0, Q.jsxs)("div", { children: [
			/* @__PURE__ */ (0, Q.jsx)(xk, {
				handleOnChange: o,
				sshConfig: r
			}),
			/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "form__row mt-12",
				children: [
					/* @__PURE__ */ (0, Q.jsx)("span", {
						className: "form__input-header mr-20",
						children: "Authenticate using"
					}),
					/* @__PURE__ */ (0, Q.jsx)(yk, {
						authenticationType: d,
						handleAuthenticationTypeChange: m
					}),
					d === pk.Password || d === pk.Password_And_SSH_Private_Key ? /* @__PURE__ */ (0, Q.jsx)(Sk, {
						sshConfig: r,
						handleOnChange: o,
						handleOnBlur: g,
						handleOnFocus: h
					}) : null,
					d === pk.SSH_Private_Key || d === pk.Password_And_SSH_Private_Key ? /* @__PURE__ */ (0, Q.jsx)(Ck, {
						sshConfig: r,
						handleOnChange: o,
						handleOnBlur: g,
						handleOnFocus: h
					}) : null
				]
			}),
			e === "cluster" && _("For clusters connected via SSH Tunnel, deployments should NOT be done via GitOps(ArgoCD)")
		] })
	] });
}, Tk = /* @__PURE__ */ function(e) {
	return e.LABEL_SELECTOR = "labelSelector", e.FIELD_SELECTOR = "fieldSelector", e.FILTER = "filter", e;
}({}), Ek = Ua(null), Dk = () => qa(Ek), Ok = ({ nonRepeatableChild: e, repeatableChildrenWrapperClassName: t, repeatableChild: n, startingCount: r = 1 }) => {
	let [i, a] = j([...Array(r || 1).keys()].reverse()), o = (e) => () => String(e), s = (e) => () => a((t) => t.filter((t) => t !== e)), c = () => {
		let e = (i[0] || 0) + 1;
		return a([e, ...i]), e;
	}, l = A(() => ({
		addComponent: c,
		count: i.length
	}), [i]), u = Ka((e) => ({
		getComponentKey: o(e),
		deleteComponent: s(e)
	}), []);
	return /* @__PURE__ */ (0, Q.jsxs)(Ek, {
		value: l,
		children: [e, i.length ? /* @__PURE__ */ (0, Q.jsx)("div", {
			className: t,
			children: i.map((e) => /* @__PURE__ */ (0, Q.jsx)("div", { children: /* @__PURE__ */ (0, Q.jsx)(Ek, {
				value: u(e),
				children: n
			}) }, e))
		}) : null]
	});
}, kk = (e) => ({
	...e.has(Tk.LABEL_SELECTOR) ? { [Tk.LABEL_SELECTOR]: JSON.parse(e.get(Tk.LABEL_SELECTOR) || "[]") } : {},
	...e.has(Tk.FIELD_SELECTOR) ? { [Tk.FIELD_SELECTOR]: JSON.parse(e.get(Tk.FIELD_SELECTOR) || "[]") } : {},
	...e.has(Tk.FILTER) ? { [Tk.FILTER]: e.get(Tk.FILTER) } : {}
}), Ak = (e) => {
	if (!e) return null;
	let t = e.includes("==") ? "==" : "!=", n = e.split(t);
	return {
		key: n[0],
		value: n[1],
		operator: t
	};
}, jk = (e) => Object.values(e.current).filter((e) => !!e), Mk = (e) => /* @__PURE__ */ (0, Q.jsxs)("button", {
	type: "button",
	className: "flex dc__gap-4 dc__unset-button-styles fcb-5",
	onClick: e,
	children: [/* @__PURE__ */ (0, Q.jsx)(E, { className: "icon-dim-16" }), /* @__PURE__ */ (0, Q.jsx)("span", {
		className: "lh-20 fw-6 fs-13 cb-5",
		children: "Add"
	})]
}), Nk = ({ addToSelectorRef: e, getRefData: t, deleteRefData: n }) => {
	let { getComponentKey: r, deleteComponent: i } = Dk(), [a, o] = j(t(r()));
	return k(() => {
		e(r(), a);
	}, [a]), /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox w-100",
		children: [/* @__PURE__ */ (0, Q.jsx)(os, {
			name: "QuerySelector",
			value: a,
			borderRadiusConfig: { right: !1 },
			fullWidth: !0,
			onChange: (e) => {
				o(e.target.value);
			},
			placeholder: "Enter query",
			autoFocus: !0
		}), /* @__PURE__ */ (0, Q.jsx)("button", {
			type: "button",
			className: "dc__unset-button-styles",
			onClick: () => {
				n(r()), i();
			},
			"aria-label": "Delete Selector Field",
			children: /* @__PURE__ */ (0, Q.jsx)("div", {
				className: "dc__border-top dc__border-right dc__border-bottom w-100 h-100 dc__right-radius-4 p-8 flex",
				children: /* @__PURE__ */ (0, Q.jsx)(tr, { className: "icon-dim-16" })
			})
		})]
	});
}, Pk = () => {
	let { addComponent: e } = Dk();
	return /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox dc__content-space",
		children: [/* @__PURE__ */ (0, Q.jsx)("span", {
			className: "lh-20 fw-6 fs-13",
			children: "Filter by Labels"
		}), Mk(e)]
	});
}, Fk = ({ updateRef: e, getRefData: t, getRefDataCount: n, deleteRefData: r }) => /* @__PURE__ */ (0, Q.jsx)(Ok, {
	nonRepeatableChild: /* @__PURE__ */ (0, Q.jsx)(Pk, {}),
	repeatableChildrenWrapperClassName: "flexbox-col dc__gap-8",
	repeatableChild: /* @__PURE__ */ (0, Q.jsx)(Nk, {
		addToSelectorRef: e,
		getRefData: t,
		deleteRefData: r
	}),
	startingCount: n()
}), Ik = (e, t) => {
	let n = t.context === "menu";
	return /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: `flexbox dc__content-space ${n ? "w-200" : ""}`,
		children: [e.label, n && /* @__PURE__ */ (0, Q.jsx)("span", {
			className: "mono",
			children: e.value
		})]
	});
}, Lk = ({ addToSelectorRef: e, getRefData: t, deleteRefData: n }) => {
	let { getComponentKey: r, deleteComponent: i } = Dk(), a = Ak(t(r())), [o, s] = j(a?.key || ""), [c, l] = j(a?.value || ""), u = A(() => [{
		label: "==",
		value: "Equal to"
	}, {
		label: "!=",
		value: "Not equal to"
	}], []), [d, f] = j(u.find((e) => e.label === (a?.operator || "==")));
	k(() => {
		if (!o || !c) {
			n(r());
			return;
		}
		e(r(), `${o}${d.label}${c}`);
	}, [
		o,
		c,
		d
	]);
	let p = (e) => {
		s(e.target.value);
	}, m = (e) => {
		l(e.target.value);
	}, h = (e) => {
		e !== d && f(e);
	}, g = () => {
		n(r()), i();
	};
	return /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox w-100",
		children: [
			/* @__PURE__ */ (0, Q.jsx)("div", {
				className: "w-200 dc__no-shrink",
				children: /* @__PURE__ */ (0, Q.jsx)(os, {
					name: "key",
					value: o,
					borderRadiusConfig: { right: !1 },
					fullWidth: !0,
					onChange: p,
					placeholder: "Enter key"
				})
			}),
			/* @__PURE__ */ (0, Q.jsx)(ep, {
				options: u,
				components: { IndicatorSeparator: null },
				onChange: h,
				formatOptionLabel: Ik,
				className: "dc__no-border dc__no-border-radius dc__no-shrink",
				value: d,
				styles: {
					...Qd,
					menu: (e, t) => ({
						...Qd.menu(e, t),
						width: "max-content",
						minWidth: "100%"
					}),
					control: (e, t) => ({
						...Qd.control(e, t),
						borderBlock: "1px solid var(--border-primary)",
						borderRadius: 0,
						borderLeft: 0,
						borderRight: 0,
						minHeight: "36px",
						height: "36px"
					}),
					singleValue: (e) => ({
						...e,
						color: "var(--N900)"
					}),
					input: (e) => ({
						...e,
						color: "var(--N900)"
					})
				}
			}),
			/* @__PURE__ */ (0, Q.jsx)(os, {
				name: "value",
				value: c,
				fullWidth: !0,
				borderRadiusConfig: {
					left: !1,
					right: !1
				},
				onChange: m,
				placeholder: "Enter value"
			}),
			/* @__PURE__ */ (0, Q.jsx)("button", {
				type: "button",
				className: "dc__unset-button-styles",
				onClick: g,
				"aria-label": "Delete Selector Field",
				children: /* @__PURE__ */ (0, Q.jsx)("div", {
					className: "dc__border-top dc__border-right dc__border-bottom w-100 h-100 dc__right-radius-4 p-8 flex",
					children: /* @__PURE__ */ (0, Q.jsx)(tr, { className: "icon-dim-16" })
				})
			})
		]
	});
}, Rk = () => {
	let { addComponent: e } = Dk();
	return /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox dc__content-space",
		children: [/* @__PURE__ */ (0, Q.jsx)("span", {
			className: "lh-20 fw-6 fs-13",
			children: "Filter by Field Selectors"
		}), Mk(e)]
	});
}, zk = ({ updateRef: e, getRefData: t, getRefDataCount: n, deleteRefData: r }) => /* @__PURE__ */ (0, Q.jsx)(Ok, {
	nonRepeatableChild: /* @__PURE__ */ (0, Q.jsx)(Rk, {}),
	repeatableChildrenWrapperClassName: "flexbox-col dc__gap-8",
	repeatableChild: /* @__PURE__ */ (0, Q.jsx)(Lk, {
		addToSelectorRef: e,
		getRefData: t,
		deleteRefData: r
	}),
	startingCount: n()
}), Bk = ({ updateRef: e, getRefData: t }) => {
	let [n, r] = j(t);
	return bf(() => e(n), [n]), /* @__PURE__ */ (0, Q.jsx)(ou, {
		label: "Query with CEL Expression",
		value: n,
		onChange: (e) => r(e.target.value),
		placeholder: "Write CEL Expression",
		name: "cel-expression"
	});
}, Vk = ({ clusterName: e, handleClose: t }) => {
	let { setDisableShortcuts: n } = Af(), r = X(), i = Yf(), a = kk(new URLSearchParams(i.search)), o = Ja({ ...a.fieldSelector }), s = Ja({ ...a.labelSelector }), c = Ja(a.filter || "");
	k(() => (n(!0), () => {
		n(!1);
	}), []);
	let l = (e) => (t, n) => {
		e.current[t] = n;
	}, u = (e) => (t) => e.current[t], d = (e) => () => Object.keys(e.current).length, f = (e) => (t) => delete e.current[t];
	return /* @__PURE__ */ (0, Q.jsx)(Rs, {
		width: "800px",
		position: "right",
		onEscape: t,
		children: /* @__PURE__ */ (0, Q.jsxs)("main", {
			className: "flexbox-col bg__primary h-100 dc__content-space",
			children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox-col dc__overflow-auto",
				children: [/* @__PURE__ */ (0, Q.jsxs)("section", {
					className: "flexbox w-100 dc__border-bottom-n1 pt-12 pb-12 pl-20 pr-20 dc__content-space dc__align-items-center",
					children: [/* @__PURE__ */ (0, Q.jsxs)("span", {
						className: "form__section",
						children: [
							"Filter resources in '",
							e,
							"'"
						]
					}), /* @__PURE__ */ (0, Q.jsx)("button", {
						type: "button",
						onClick: t,
						className: "dc__transparent dc__no-shrink flexbox",
						"aria-label": "Close Modal",
						children: /* @__PURE__ */ (0, Q.jsx)(tr, { className: "icon-fill-n6" })
					})]
				}), /* @__PURE__ */ (0, Q.jsxs)("section", {
					className: "p-20 flexbox-col dc__gap-16 flex-grow-1 dc__overflow-auto",
					children: [
						/* @__PURE__ */ (0, Q.jsx)(Fk, {
							updateRef: l(s),
							getRefData: u(s),
							getRefDataCount: d(s),
							deleteRefData: f(s)
						}),
						/* @__PURE__ */ (0, Q.jsx)("div", { className: "dc__border-bottom-n1 w-100 h-1" }),
						/* @__PURE__ */ (0, Q.jsx)(zk, {
							updateRef: l(o),
							getRefData: u(o),
							getRefDataCount: d(o),
							deleteRefData: f(o)
						}),
						/* @__PURE__ */ (0, Q.jsx)("div", { className: "dc__border-bottom-n1 w-100 h-1" }),
						/* @__PURE__ */ (0, Q.jsx)(Bk, {
							updateRef: (e) => {
								c.current = e;
							},
							getRefData: () => c.current
						})
					]
				})]
			}), /* @__PURE__ */ (0, Q.jsxs)("section", {
				className: "dc__border-top-n1 pt-12 pb-12 pl-20 pr-20 flexbox dc__content-space dc__items-align-center dc__no-shrink",
				children: [/* @__PURE__ */ (0, Q.jsxs)("button", {
					type: "button",
					className: "cta-with-img secondary",
					onClick: () => {
						let e = new URLSearchParams(i.search);
						Object.values(Tk).forEach((t) => {
							e.delete(t);
						}), r({ search: e.toString() }, { replace: !0 }), t();
					},
					children: [/* @__PURE__ */ (0, Q.jsx)(eC, { className: "icon-dim-16 mr-8" }), "Clear all filters"]
				}), /* @__PURE__ */ (0, Q.jsx)("button", {
					type: "submit",
					className: "cta primary",
					onClick: () => {
						let e = jk(o), n = jk(s), a = c.current, l = {
							...e.length ? { fieldSelector: JSON.stringify(e) } : { fieldSelector: null },
							...n.length ? { labelSelector: JSON.stringify(n) } : { labelSelector: null },
							...a ? { filter: a } : { filter: null }
						}, u = new URLSearchParams(i.search);
						Object.entries(l).forEach(([e, t]) => {
							if (t === null) {
								u.delete(e);
								return;
							}
							u.set(e, t);
						}), r({ search: new URLSearchParams(u).toString() }, { replace: !0 }), t();
					},
					children: "Apply"
				})]
			})]
		})
	});
}, Hk = ({ clusterName: e, showModal: t, handleShowFilterModal: n, handleCloseFilterModal: r }) => {
	let i = Yf(), a = kk(new URLSearchParams(i.search));
	return /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsx)("button", {
		type: "button",
		className: "dc__unset-button-styles",
		onClick: n,
		children: /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flex bg__secondary dc__gap-6 en-2 bw-1 br-4 h-32 pl-8 pr-8 pt-6 pb-6",
			children: [
				Object.keys(a).length ? /* @__PURE__ */ (0, Q.jsx)(Tx, { className: "icon-dim-16" }) : /* @__PURE__ */ (0, Q.jsx)(VC, { className: "icon-dim-16" }),
				"Filter",
				/* @__PURE__ */ (0, Q.jsx)("div", {
					className: "flex fs-12 lh-20 icon-dim-20 bg__primary cn-7 fw-6 dc__border br-2",
					children: "f"
				})
			]
		})
	}), t && /* @__PURE__ */ (0, Q.jsx)(Vk, {
		clusterName: e,
		handleClose: r
	})] });
}, Uk = /* @__PURE__ */ t({ default: () => Wk });
function Wk() {
	return /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox-col p-12 dc__align-self-stretch dc__align-start",
		children: [
			/* @__PURE__ */ (0, Q.jsx)("p", {
				className: "m-0 cn-9 fs-13 fw-4 lh-20",
				children: u.DESCRIPTION
			}),
			/* @__PURE__ */ (0, Q.jsx)("p", {
				className: "m-0 cn-9 fs-13 fw-4 lh-20",
				children: "It can be scoped for"
			}),
			/* @__PURE__ */ (0, Q.jsx)("ul", {
				className: "m-0 cn-9 fs-13 fw-4 lh-20 pl-20",
				children: u.SCOPES.map((e) => /* @__PURE__ */ (0, Q.jsx)("li", { children: e }, e))
			})
		]
	});
}
//#endregion
//#region src/Components/Tags/MandatoryTagWarning.tsx
var Gk = /* @__PURE__ */ t({ default: () => Kk }), Kk = ({ labelTags: e, showOnlyIcon: t, handleAddTag: n, selectedProjectId: r, reloadProjectTags: i }) => {
	let [a, o] = j(!1), [s, c] = j([]), l = async () => {
		try {
			let { result: e } = await gp(r);
			c(e);
		} catch (e) {
			K(e);
		}
	};
	return k(() => {
		r && l();
	}, [r, i]), k(() => {
		if (e && s) {
			let t = Array.isArray(e) ? e.reduce((e, t) => (e[t.key] = t, e), {}) : {}, n = (e, t) => e?.blockCustomValue ? e.choices.includes(t) : !0;
			o(s.some((e) => !!(e.isMandatory && (!t[e.key] || !t[e.key].value || !n(e.valueConstraint, t[e.key]?.value)))));
		}
	}, [s, e]), a ? t ? /* @__PURE__ */ (0, Q.jsx)(Et, { className: "warning-icon-y7-imp icon-dim-16 ml-5" }) : /* @__PURE__ */ (0, Q.jsx)("div", {
		className: "mt-12",
		children: /* @__PURE__ */ (0, Q.jsx)(xc, {
			description: /* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "fs-13 fw-4 flexbox-col",
				children: [/* @__PURE__ */ (0, Q.jsx)("span", {
					className: "lh-20 cn-9",
					children: "Some mandatory tags are not configured for this application."
				}), /* @__PURE__ */ (0, Q.jsx)(M, {
					text: "Add tags",
					onClick: n,
					dataTestId: "mandatory-add-tag-warning-button",
					variant: F.text
				})]
			}),
			variant: "warning",
			borderConfig: {
				top: !1,
				left: !1,
				right: !1
			},
			borderRadiusConfig: {
				top: !1,
				left: !1,
				right: !1,
				bottom: !1
			}
		})
	}) : null;
}, qk = () => /* @__PURE__ */ (0, Q.jsx)(Cc, {
	heading: "Allow/block deployments",
	additionalContent: /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "p-12 fs-13 fw-4 flexbox-col",
		children: [
			/* @__PURE__ */ (0, Q.jsxs)("div", { children: [
				"If mandatory tags are not configured, you can either allow or block deployment stages for",
				/* @__PURE__ */ (0, Q.jsx)("span", {
					className: "fw-6",
					children: "\xA0production and non-production "
				}),
				"environments."
			] }),
			/* @__PURE__ */ (0, Q.jsx)("br", {}),
			/* @__PURE__ */ (0, Q.jsxs)("div", { children: [
				/* @__PURE__ */ (0, Q.jsx)("span", {
					className: "fw-6",
					children: "If deployments are blocked: "
				}),
				"All deployment stages—",
				/* @__PURE__ */ (0, Q.jsx)("span", {
					className: "fw-6",
					children: "pre-deploy, deploy, and post-deploy"
				}),
				" will be restricted."
			] })
		]
	})
}), Jk = (e, t = 16) => e === Os.ALLOW ? /* @__PURE__ */ (0, Q.jsx)(ex, { className: `icon-dim-${t}` }) : /* @__PURE__ */ (0, Q.jsx)(xt, { className: `icon-dim-${t}` }), Yk = (e) => {
	switch (e) {
		case Os.ALLOW: return "Allow deployments";
		case Os.BLOCK_PROD: return "Prod environments";
		case Os.BLOCK_NON_PROD: return "Non-prod environments";
		case Os.BLOCK: return "All environments";
		default: return "Allow deployments";
	}
}, Xk = (e, t) => [
	{
		label: "TAG KEY",
		key: "tagKey",
		width: "240px"
	},
	{
		label: "VALUE CHOICES",
		key: "choices",
		width: "122px"
	},
	{
		label: "DESCRIPTION",
		key: "description",
		width: "1fr"
	},
	{
		label: "ALLOW/BLOCK DEPLOYMENTS",
		key: "deploymentPolicy",
		width: `${t ? "233px" : "220px"}`,
		isHidden: !e,
		renderAdditionalContent: () => /* @__PURE__ */ (0, Q.jsx)(qk, {})
	}
], Zk = (e) => e.filter((e) => e.data.tagKey.value).map((e) => Hf(e.data.tagKey.value)), Qk = (e) => e.filter((e) => !!e.choice).length, $k = (e, t) => e.find((e) => e.value === t || e.options?.some((e) => e.value === t)), eA = (e) => {
	if (!e) return tA[0].value;
	let t = $k(tA, e);
	return t?.value === e ? t.value : t?.options?.find((t) => t.value === e)?.value || tA[0].value;
}, tA = [{
	label: Yk(Os.ALLOW),
	value: Os.ALLOW,
	startIcon: Jk(Os.ALLOW)
}, {
	label: "Block all deployment stages",
	options: [
		{
			label: Yk(Os.BLOCK_PROD),
			value: Os.BLOCK_PROD,
			startIcon: Jk(Os.BLOCK_PROD)
		},
		{
			label: Yk(Os.BLOCK_NON_PROD),
			value: Os.BLOCK_NON_PROD,
			startIcon: Jk(Os.BLOCK_NON_PROD)
		},
		{
			label: Yk(Os.BLOCK),
			value: Os.BLOCK,
			startIcon: Jk(Os.BLOCK)
		}
	]
}], nA = () => Math.floor(Math.random() * 9e15) + 0x38d7ea4c68000, rA = {
	key: "",
	value: "",
	propagate: !1,
	isInvalidKey: !1,
	isInvalidValue: !1,
	id: 0,
	description: "",
	valueConstraint: {
		choices: [],
		blockCustomValue: !1
	},
	deploymentPolicy: Os.ALLOW
}, iA = /* @__PURE__ */ function(e) {
	return e.GLOBAL_TAG_POLICY_ADD_TAG_BUTTON_CLICKED = "GLOBAL_TAG_POLICY_ADD_TAG_BUTTON_CLICKED", e.GLOBAL_TAG_POLICY_KNOW_MORE_BUTTON_CLICKED = "GLOBAL_TAG_POLICY_KNOW_MORE_BUTTON_CLICKED", e.GLOBAL_TAG_POLICY_ENFORCEMENT_SELECT_CLICKED = "GLOBAL_TAG_POLICY_ENFORCEMENT_SELECT_CLICKED", e.GLOBAL_TAG_PROPAGATE_BUTTON_CLICKED = "GLOBAL_TAG_PROPAGATE_BUTTON_CLICKED", e.GLOBAL_TAG_KEY_SETTING_CLICKED = "GLOBAL_TAG_KEY_SETTING_CLICKED", e.GLOBAL_TAG_SAVE_BUTTON_CLICKED = "GLOBAL_TAG_SAVE_BUTTON_CLICKED", e.GLOBAL_TAG_ADD_ROW_CLICKED = "GLOBAL_TAG_ADD_ROW_CLICKED", e;
}({}), aA = /* @__PURE__ */ function(e) {
	return e.MANAGE_PROJECTS = "manage-projects", e.DELETE = "delete", e;
}({}), oA = ({ isEditView: e, isMultiDelete: t, tagIDList: n, tagName: r, reload: i, closeModal: a }) => {
	let o = X(), s = async () => {
		await hp(n), e && o(B.APPLICATION_MANAGEMENT_POLICIES.TAG_POLICY.ROOT), typeof i == "function" && i();
	}, c = () => n.length > 1 ? "tags" : "tag";
	return /* @__PURE__ */ (0, Q.jsx)(Ts, {
		title: (() => {
			let e = "";
			return t ? e += `${n.length} ${c()}?` : e += `${r}`, e;
		})(),
		component: "tag",
		onDelete: s,
		closeConfirmationModal: a,
		subtitle: /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsxs)("p", {
			className: "fs-14 cn-7 lh-20",
			children: [
				"Are you sure you want to delete",
				t ? ` the selected ${c()}` : " this tag",
				" ?"
			]
		}), /* @__PURE__ */ (0, Q.jsx)("p", {
			className: "fs-14 cn-7 lh-20",
			children: "NOTE: Deleting this tag will not remove the applied tag from existing applications."
		})] })
	});
};
//#endregion
//#region src/Components/Tags/InjectTagInfoModal.tsx
function sA({ closePopup: e }) {
	return /* @__PURE__ */ (0, Q.jsx)(xu, {
		className: "",
		children: /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "modal__body w-600 p-20 mt-40 flex column",
			children: [
				/* @__PURE__ */ (0, Q.jsx)("div", {
					className: "flex left w-100 fs-16 fw-6",
					children: T.injectTagInfoModal.title
				}),
				/* @__PURE__ */ (0, Q.jsx)("img", {
					src: fp,
					className: "w-100 mt-16 mb-12",
					alt: "Inject Tag Info"
				}),
				/* @__PURE__ */ (0, Q.jsxs)("div", { children: [
					/* @__PURE__ */ (0, Q.jsx)("p", {
						className: "fs-14 fw-4",
						children: T.injectTagInfoModal.description.para1
					}),
					/* @__PURE__ */ (0, Q.jsx)("p", {
						className: "fs-14 fw-4",
						children: T.injectTagInfoModal.description.para2
					}),
					/* @__PURE__ */ (0, Q.jsx)("p", {
						className: "fs-14 fw-4",
						children: T.injectTagInfoModal.description.para3
					})
				] }),
				/* @__PURE__ */ (0, Q.jsx)("div", {
					className: "flex right w-100 dc__align-right mt-24",
					children: /* @__PURE__ */ (0, Q.jsx)("button", {
						className: "cta flex h-36",
						type: "submit",
						onClick: e,
						children: T.injectTagInfoModal.buttonText
					})
				})
			]
		})
	});
}
//#endregion
//#region src/Components/Tags/TagInfoIcon.tsx
function cA() {
	return /* @__PURE__ */ (0, Q.jsx)(Cc, {
		heading: ie.title,
		additionalContent: /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "p-12 fs-13 fw-4",
			children: [
				/* @__PURE__ */ (0, Q.jsx)("div", { children: ie.description.para1 }),
				/* @__PURE__ */ (0, Q.jsx)("div", { children: ie.description.para2 }),
				/* @__PURE__ */ (0, Q.jsx)("div", { children: ie.description.para3 })
			]
		}),
		documentationLink: "TAGS_POLICY",
		documentationLinkText: "View Documentation",
		iconClassName: "icon-dim-20 ml-4 cursor"
	});
}
//#endregion
//#region src/Assets/Icons/ic-blue-circle.svg?react
var lA = (e) => /* @__PURE__ */ (0, Q.jsx)("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 10,
	height: 10,
	viewBox: "0 0 10 10",
	fill: "none",
	...e,
	children: /* @__PURE__ */ (0, Q.jsx)("circle", {
		cx: 5,
		cy: 5,
		r: 4,
		fill: "#3385D6",
		stroke: "white",
		strokeWidth: 2
	})
}), uA = (e) => /* @__PURE__ */ (0, Q.jsx)("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "0 0 24 24",
	...e,
	children: /* @__PURE__ */ (0, Q.jsx)("path", {
		stroke: "#3B444C",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M16.124 10.875v9.375m0-9.375a2.25 2.25 0 1 0 0-4.5m0 4.5a2.25 2.25 0 0 1 0-4.5m0-2.625v2.625m-8.25 9.75v4.125m0-4.125a2.25 2.25 0 1 0 0-4.5m0 4.5a2.25 2.25 0 0 1 0-4.5m0-7.875v7.875",
		vectorEffect: "non-scaling-stroke"
	})
}), dA = (e) => /* @__PURE__ */ (0, Q.jsxs)("svg", {
	width: 48,
	height: 54,
	viewBox: "0 0 48 54",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [
		/* @__PURE__ */ (0, Q.jsx)("rect", {
			x: 1,
			y: 1,
			width: 46,
			height: 14,
			rx: 4,
			fill: "#F7FAFC"
		}),
		/* @__PURE__ */ (0, Q.jsx)("rect", {
			x: 1,
			y: 1,
			width: 46,
			height: 14,
			rx: 4,
			stroke: "#D0D4D9"
		}),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			d: "M6 8H23",
			stroke: "#767D84",
			strokeWidth: 1.5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ (0, Q.jsx)("path", {
			d: "M37 9L39.5 7L42 9",
			stroke: "#959BA1",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ (0, Q.jsxs)("g", {
			clipPath: "url(#clip0_5674_12043)",
			children: [
				/* @__PURE__ */ (0, Q.jsx)("rect", {
					x: 1,
					y: 19,
					width: 46,
					height: 34.495,
					rx: 4,
					fill: "white"
				}),
				/* @__PURE__ */ (0, Q.jsx)("path", {
					d: "M6 25H20",
					stroke: "#D0D4D9",
					strokeWidth: 1.5,
					strokeLinecap: "round"
				}),
				/* @__PURE__ */ (0, Q.jsx)("rect", {
					width: 46,
					height: 12.495,
					transform: "translate(1 30)",
					fill: "#E5F2FF"
				}),
				/* @__PURE__ */ (0, Q.jsx)("path", {
					d: "M6 36.2475H31",
					stroke: "#767D84",
					strokeWidth: 1.5,
					strokeLinecap: "round"
				}),
				/* @__PURE__ */ (0, Q.jsx)("path", {
					d: "M38.37 36.361L39.731 37.495L42 35",
					stroke: "#0066CC",
					strokeWidth: 1.4,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ (0, Q.jsx)("path", {
					d: "M6 47.495H20",
					stroke: "#D0D4D9",
					strokeWidth: 1.5,
					strokeLinecap: "round"
				})
			]
		}),
		/* @__PURE__ */ (0, Q.jsx)("rect", {
			x: 1,
			y: 19,
			width: 46,
			height: 34.495,
			rx: 4,
			stroke: "#D0D4D9"
		}),
		/* @__PURE__ */ (0, Q.jsx)("defs", { children: /* @__PURE__ */ (0, Q.jsx)("clipPath", {
			id: "clip0_5674_12043",
			children: /* @__PURE__ */ (0, Q.jsx)("rect", {
				x: 1,
				y: 19,
				width: 46,
				height: 34.495,
				rx: 4,
				fill: "white"
			})
		}) })
	]
}), fA = /* @__PURE__ */ function(e) {
	return e.AND = "AND", e.OR = "OR", e;
}({}), pA = /* @__PURE__ */ function(e) {
	return e.SUGGESTED = "suggested", e.MANDATORY = "mandatory", e;
}({}), mA = /* @__PURE__ */ function(e) {
	return e.UPDATE_ROW = "UPDATE_ROW", e.UPDATE_CHOICES = "UPDATE_CHOICES", e.UPDATE_ALLOW_CUSTOM_INPUT = "UPDATE_ALLOW_CUSTOM_INPUT", e.UPDATE_PROPAGATE = "UPDATE_PROPAGATE", e.ADD_CHOICES_TO_VALUE_COLUMN_OPTIONS = "ADD_CHOICES_TO_VALUE_COLUMN_OPTIONS", e;
}({}), hA = ({ text: e, onClickAddButton: t }) => /* @__PURE__ */ (0, Q.jsx)(M, {
	text: e,
	onClick: t,
	dataTestId: "add-choice-button",
	startIcon: /* @__PURE__ */ (0, Q.jsx)(E, {}),
	variant: F.borderLess,
	size: I.small
}), gA = ({ tagChoices: e, rowId: t, handleRowUpdateAction: n, blockCustomValue: r }) => {
	let i = () => /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "fs-12",
		children: [/* @__PURE__ */ (0, Q.jsx)("p", {
			className: "m-0 fw-6",
			children: "Allow Custom input"
		}), /* @__PURE__ */ (0, Q.jsx)("p", {
			className: "m-0",
			children: "Allow entering any value other than provided choices"
		})]
	}), a = () => {
		n({
			actionType: mA.UPDATE_ALLOW_CUSTOM_INPUT,
			rowId: t,
			headerKey: null,
			actionValue: !r
		});
	}, o = () => /* @__PURE__ */ (0, Q.jsx)("div", {
		className: "flex left w-100 h-100 p-12 dc__border-top dc__gap-8",
		children: /* @__PURE__ */ (0, Q.jsx)(Wo, {
			isChecked: !r,
			rootClassName: "mb-0 flex top dc_max-width__max-content",
			value: Io.CHECKED,
			onChange: a,
			"data-testid": "set-clone-directory",
			children: /* @__PURE__ */ (0, Q.jsx)(W, {
				alwaysShowTippyOnHover: !0,
				className: "w-200",
				placement: "bottom-start",
				content: i(),
				children: /* @__PURE__ */ (0, Q.jsx)("div", {
					className: "dc__border-dashed--n3-bottom fs-13 cn-9 lh-20",
					children: "Allow Custom input"
				})
			})
		})
	}), s = () => {
		n({
			actionType: mA.UPDATE_CHOICES,
			rowId: t,
			headerKey: null,
			actionValue: (e) => [{
				choice: "",
				id: e.length,
				error: []
			}, ...e]
		});
	}, c = () => /* @__PURE__ */ (0, Q.jsx)("div", {
		className: "p-12",
		children: /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "dc__border-dashed fs-12 br-6 dc__gap-12 flex column w-100 dc__align-center p-16",
			children: [
				/* @__PURE__ */ (0, Q.jsx)(dA, {}),
				/* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "w-100",
					children: [/* @__PURE__ */ (0, Q.jsx)("div", {
						className: "fw-6 lh-18",
						children: "Set value choices"
					}), /* @__PURE__ */ (0, Q.jsx)("div", {
						className: "lh-18 dc__align-center ",
						children: "Allow users to select a value from a pre-defined set of choices"
					})]
				}),
				/* @__PURE__ */ (0, Q.jsx)(hA, {
					text: "Add choices",
					onClickAddButton: s
				})
			]
		})
	}), l = (e) => (r) => {
		let i = r.target.value, a = Uf(i, "").errorMessages;
		n({
			actionType: mA.UPDATE_CHOICES,
			rowId: t,
			headerKey: null,
			actionValue: (t) => t.map((t) => t.id === e ? {
				id: e,
				choice: i,
				error: a
			} : t)
		});
	}, u = (e) => {
		n({
			rowId: t,
			headerKey: null,
			actionType: mA.UPDATE_CHOICES,
			actionValue: (t) => t.filter((t) => t.id !== e)
		});
	};
	return /* @__PURE__ */ (0, Q.jsx)("div", {
		className: "flexbox-col w-100",
		children: e.length ? /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox-col dc__gap-6 p-12 dc__overflow-auto mxh-220",
			children: [/* @__PURE__ */ (0, Q.jsx)(hA, {
				text: "Add choices",
				onClickAddButton: s
			}), e.map((e, t) => /* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flex left dc__gap-4 w-100 top",
				children: [/* @__PURE__ */ (0, Q.jsx)(os, {
					placeholder: "Enter choice",
					name: `tag-choice-${t}`,
					value: e.choice,
					onChange: l(e.id),
					fullWidth: !0,
					error: e.error?.length ? e.error : null,
					autoFocus: !0
				}), /* @__PURE__ */ (0, Q.jsx)("div", {
					className: "pt-4",
					children: /* @__PURE__ */ (0, Q.jsx)(M, {
						dataTestId: "delete-tag-choice",
						ariaLabel: "Delete tag choice",
						showAriaLabelInTippy: !1,
						icon: /* @__PURE__ */ (0, Q.jsx)(tr, {}),
						variant: F.borderLess,
						size: I.small,
						onClick: () => u(e.id),
						style: P.negativeGrey
					})
				})]
			}, `tag-choice-${e.id}`))]
		}), o()] }) : c()
	});
}, _A = ({ title: e, handleRowUpdateAction: t, tagChoices: n, rowId: r, blockCustomValue: i }) => {
	let [a, o] = j(!1), s = A(() => n.some((e) => e?.error?.length > 0), [n]), c = () => {
		o(!0), Mn.event({
			category: iA.GLOBAL_TAG_KEY_SETTING_CLICKED,
			action: iA.GLOBAL_TAG_KEY_SETTING_CLICKED
		});
	}, l = () => o(!1);
	return /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsx)("div", { className: `${a ? "dc__transparent-div cursor-not-allowed" : ""}` }), /* @__PURE__ */ (0, Q.jsx)(su, {
		theme: cu.white,
		className: "flexbox-col w-300 h-100 p-0",
		placement: "bottom",
		heading: e,
		showCloseButton: !0,
		additionalContent: /* @__PURE__ */ (0, Q.jsx)(gA, {
			tagChoices: n,
			rowId: r,
			handleRowUpdateAction: t,
			blockCustomValue: i
		}),
		interactive: !0,
		...s ? { visible: !0 } : { trigger: "click" },
		disableClose: s,
		onClose: l,
		children: /* @__PURE__ */ (0, Q.jsx)("button", {
			className: "dc__transparent h-100 flex top p-8 dc__hover-n50 w-100 left fs-13",
			type: "button",
			"aria-label": "row-config-button",
			onClick: c,
			children: /* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flex dc__gap-4 ",
				children: [
					Qk(n) ? /* @__PURE__ */ (0, Q.jsx)(lA, { className: "blue-circle-position" }) : null,
					/* @__PURE__ */ (0, Q.jsx)(uA, { className: "icon-dim-16 pos-relative" }),
					/* @__PURE__ */ (0, Q.jsxs)("div", {
						className: "lh-20",
						children: [Qk(n) || "Add", " choices"]
					})
				]
			})
		})
	})] });
}, vA = (e, t) => t?.map((t) => {
	let n = t.id || nA(), r = t?.valueConstraint?.choices?.length || 0;
	return {
		data: {
			deploymentPolicy: {
				value: eA(t.deploymentPolicy),
				type: Vs.DROPDOWN,
				props: {
					options: tA,
					hideSelectedOptions: !e
				}
			},
			tagKey: {
				value: t.key || null,
				type: Vs.TEXT,
				props: { placeholder: "Eg. owner-name" }
			},
			description: {
				value: t.description || "",
				type: Vs.TEXT,
				props: { placeholder: "Enter description" }
			},
			choices: {
				value: null,
				type: Vs.BUTTON,
				props: {
					text: r ? `${r} choices` : "Add Choices",
					icon: r ? /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsx)(lA, { className: "blue-circle-position" }), /* @__PURE__ */ (0, Q.jsx)(uA, { className: "icon-dim-16 pos-relative" })] }) : /* @__PURE__ */ (0, Q.jsx)(uA, { className: "icon-dim-16" })
				}
			}
		},
		id: n,
		customState: {
			tagChoices: (t?.valueConstraint?.choices || []).map((e, t) => ({
				id: t,
				choice: e
			})),
			propagate: t?.propagate || !1,
			blockCustomValue: t?.valueConstraint?.blockCustomValue || !1
		}
	};
}), yA = (e) => {
	let t = nA();
	return {
		data: {
			deploymentPolicy: {
				value: tA[0].value,
				type: Vs.DROPDOWN,
				props: {
					options: tA,
					hideSelectedOptions: !e
				}
			},
			tagKey: {
				value: null,
				type: Vs.TEXT,
				props: { placeholder: "Eg. owner-name" }
			},
			description: {
				value: "",
				type: Vs.TEXT,
				props: { placeholder: "Enter description" }
			},
			choices: {
				value: "",
				type: Vs.BUTTON,
				props: {
					text: "Add Choices",
					icon: /* @__PURE__ */ (0, Q.jsx)(uA, { className: "icon-dim-16 pos-relative" })
				}
			}
		},
		id: t,
		customState: {
			tagChoices: [],
			propagate: !1,
			blockCustomValue: !1
		}
	};
}, bA = ({ labelTags: e, setLabelTags: t, isMandatoryTags: n, isEditView: r, rows: i, setRows: a }) => {
	let [o, s] = j({}), c = ({ actionType: e, actionValue: t, rowId: n, headerKey: r }) => {
		let o = [...i];
		switch (e) {
			case mA.UPDATE_CHOICES:
				o = o.map((e) => e.id === n ? {
					...e,
					customState: {
						...e.customState,
						tagChoices: t(e.customState.tagChoices)
					}
				} : e);
				break;
			case mA.UPDATE_ALLOW_CUSTOM_INPUT:
				o = o.map((e) => e.id === n ? {
					...e,
					customState: {
						...e.customState,
						blockCustomValue: t
					}
				} : e);
				break;
			case mA.UPDATE_ROW:
				o = i.map((e) => e.id === n ? {
					...e,
					data: {
						...e.data,
						[r]: {
							...e.data[r],
							value: t
						}
					}
				} : e);
				break;
			default: break;
		}
		a(o);
	};
	k(() => {
		let t = vA(n, e);
		s({}), a(t);
	}, []), k(() => {
		i.length && t(i.map((t) => ({
			key: t.data.tagKey.value,
			description: t.data.description.value,
			propagate: t.customState.propagate,
			valueConstraint: {
				choices: t.customState.tagChoices.map((e) => e.choice).filter((e) => e !== null && e !== ""),
				blockCustomValue: t.customState.blockCustomValue
			},
			deploymentPolicy: t.data.deploymentPolicy.value,
			id: e[0].id
		})));
	}, [i]);
	let l = (n) => {
		Mn.event({
			category: iA.GLOBAL_TAG_PROPAGATE_BUTTON_CLICKED,
			action: iA.GLOBAL_TAG_PROPAGATE_BUTTON_CLICKED
		});
		let r;
		a(i.map((e) => e.id === n ? (r = e.data.tagKey.value, {
			...e,
			customState: {
				...e.customState,
				propagate: !e.customState.propagate
			}
		}) : e)), t(e.map((e) => e.key === r ? {
			...e,
			propagate: !e.propagate
		} : e));
	}, u = (e) => {
		let t = e.customState.propagate;
		return /* @__PURE__ */ (0, Q.jsx)(W, {
			content: T.propagateTippy.title,
			placement: "left",
			alwaysShowTippyOnHover: !0,
			children: /* @__PURE__ */ (0, Q.jsx)("div", {
				onClick: () => l(e.id),
				className: `pointer flex h-100 w-100 top py-8 h-36 dc__bottom-left-radius ${t ? "bcn-7" : ""} ${e.data.tagKey.value?.startsWith("devtron.ai/") ? "cursor-not-allowed bcn-1" : ""}`,
				children: /* @__PURE__ */ (0, Q.jsx)(ut, { className: `icon-dim-20 ${t ? "scn-0" : ""}` })
			})
		});
	}, d = () => {
		a([yA(n), ...i]), Mn.event({
			category: iA.GLOBAL_TAG_ADD_ROW_CLICKED,
			action: iA.GLOBAL_TAG_ADD_ROW_CLICKED
		});
	}, f = (e, t, n) => {
		let r = structuredClone(o);
		r[e.id] || (r[e.id] = { tagKey: {
			isValid: !0,
			errorMessages: []
		} }), c({
			actionType: mA.UPDATE_ROW,
			actionValue: n,
			headerKey: t,
			rowId: e.id
		}), t === "tagKey" && (r[e.id].tagKey = Hf(n), s(r));
	}, p = (e) => {
		let t = i.filter(({ id: t }) => t !== e.id);
		if (t.length === 0) {
			a([yA(n)]);
			return;
		}
		a(t);
	}, m = (e) => /* @__PURE__ */ (0, Q.jsx)(_A, {
		tagChoices: e.customState.tagChoices,
		title: "Set value choices",
		handleRowUpdateAction: c,
		rowId: +e.id,
		blockCustomValue: e.customState.blockCustomValue
	});
	return /* @__PURE__ */ (0, Q.jsx)(Bs, {
		headers: Xk(n, r),
		rows: i,
		isDeletionNotAllowed: r,
		onRowEdit: f,
		onRowDelete: p,
		onRowAdd: d,
		cellError: o,
		actionButtonConfig: {
			renderer: u,
			key: "tagKey",
			width: "32px",
			position: "start"
		},
		isAdditionNotAllowed: r,
		buttonCellWrapComponent: (e) => m(e)
	});
}, xA = ({ pageType: e }) => {
	let { tagId: t } = Z(), n = X(), [r, i] = j(!1), [a, o] = j(!1), [s, c] = j([]), [l, u] = j([]), [d, f] = j(pA.SUGGESTED), [p, m] = j([rA]), [h, g] = j(!1), [_, v] = j(!1), [y, b] = j([]), [x, S] = j({
		isValid: !0,
		message: ""
	}), C = async () => {
		i(!0);
		try {
			let [{ result: n }, { result: r }] = await Promise.all([Md(), e === Me.edit ? pp(+t) : { result: null }]), i = [], a = [], o = r?.mandatoryProjectIdsCsv ? r.mandatoryProjectIdsCsv.split(",") : [];
			n.forEach((t) => {
				let n = {
					label: t.name,
					value: `${t.id}`
				};
				i.push(n), e === Me.edit && o.indexOf(`${t.id}`) >= 0 && a.push(n);
			}), u(i), c(a), f(a.length ? pA.MANDATORY : pA.SUGGESTED), r && m([r]);
		} catch (e) {
			K(e);
		} finally {
			i(!1);
		}
	};
	k(() => {
		C();
	}, []);
	let w = () => {
		n(B.APPLICATION_MANAGEMENT_POLICIES.TAG_POLICY.ROOT, { replace: !0 });
	}, T = async (t) => {
		if (t.preventDefault(), !s.length && d === pA.MANDATORY) {
			S({
				isValid: !1,
				message: "This is required field"
			});
			return;
		}
		let n = [], r = !1, i = s.map((e) => e.value).join(",");
		for (let e = 0; e < p.length; e++) {
			let t = p[e];
			if (t.isInvalidKey || t.isInvalidValue) {
				r = !0;
				break;
			} else if (t.key) {
				let e = d === pA.MANDATORY ? i : null;
				n.push({
					id: t.id || null,
					key: t.key,
					value: t.value,
					propagate: t.propagate,
					mandatoryProjectIdsCsv: e,
					description: t.description,
					valueConstraint: {
						choices: t.valueConstraint.choices || [],
						blockCustomValue: t.valueConstraint.choices?.length ? t.valueConstraint.blockCustomValue ?? !1 : !1
					},
					deploymentPolicy: d === pA.MANDATORY ? t.deploymentPolicy ?? Os.ALLOW : Os.ALLOW
				});
			}
		}
		if (r) {
			H.showToast({
				variant: U.error,
				description: "Some required fields are missing or invalid"
			});
			return;
		}
		o(!0);
		try {
			Mn.event({
				category: iA.GLOBAL_TAG_SAVE_BUTTON_CLICKED,
				action: iA.GLOBAL_TAG_SAVE_BUTTON_CLICKED
			}), await mp(n, e === Me.edit), H.showToast({
				variant: U.success,
				description: "Successfully saved"
			}), w();
		} catch (e) {
			K(e);
		} finally {
			o(!1);
		}
	}, ee = (e) => {
		f(e.target.value);
	}, E = (e) => {
		e.length ? S({
			isValid: !0,
			message: ""
		}) : S({
			isValid: !1,
			message: "This is required field"
		}), c(e);
	}, D = () => {
		v(!0);
	}, te = () => {
		v(!1);
	}, ne = () => /* @__PURE__ */ (0, Q.jsx)(oA, {
		isEditView: !0,
		isMultiDelete: !1,
		tagIDList: [p[0].id],
		tagName: p[0].key,
		closeModal: te
	}), re = () => /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "cn-9 fs-13",
		children: [/* @__PURE__ */ (0, Q.jsx)("p", {
			className: "fw-6 m-0",
			children: "Mandatory tags"
		}), /* @__PURE__ */ (0, Q.jsxs)("ul", {
			className: "mb-0 ml-20 pl-4",
			children: [/* @__PURE__ */ (0, Q.jsx)("li", { children: "Values for mandatory tags are required for applications in selected projects. You can block deployments if tags are missing." }), /* @__PURE__ */ (0, Q.jsx)("li", { children: "Mandatory tags will appear as suggestion for other projects." })]
		})]
	}), ie = () => /* @__PURE__ */ (0, Q.jsx)("div", {
		className: "flex left",
		children: /* @__PURE__ */ (0, Q.jsxs)(vl, {
			className: "radio-group-no-border create-tag__radio-group",
			value: d,
			name: "tagType",
			onChange: ee,
			children: [/* @__PURE__ */ (0, Q.jsx)(yl, {
				value: pA.SUGGESTED,
				children: "Suggested tags"
			}), /* @__PURE__ */ (0, Q.jsx)(yl, {
				value: pA.MANDATORY,
				children: "Mandatory tags"
			})]
		})
	}), ae = () => /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox-col dc__gap-12 dc__border-bottom-n1",
		children: [ie(), d === pA.MANDATORY ? /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "dc__gap-12 flexbox-col",
			children: [/* @__PURE__ */ (0, Q.jsx)(xc, { description: re() }), /* @__PURE__ */ (0, Q.jsx)(V, {
				isMulti: !0,
				inputId: "mandatory-project-selector",
				options: l,
				size: I.large,
				placeholder: "Type to select projects",
				label: "Select project(s)",
				onChange: E,
				value: s,
				name: "Resource name",
				error: x.message
			})]
		}) : /* @__PURE__ */ (0, Q.jsx)(xc, { description: "Tags will appear as suggestions when adding them to the application." })]
	}), oe = () => {
		Mn.event({
			category: iA.GLOBAL_TAG_POLICY_KNOW_MORE_BUTTON_CLICKED,
			action: iA.GLOBAL_TAG_POLICY_KNOW_MORE_BUTTON_CLICKED
		}), g(!0);
	}, se = () => {
		g(!1);
	}, ce = () => /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox-col dc__gap-16 pt-16",
		children: [/* @__PURE__ */ (0, Q.jsx)(bA, {
			labelTags: p,
			setLabelTags: m,
			isMandatoryTags: d === pA.MANDATORY,
			isEditView: e === Me.edit,
			rows: y,
			setRows: b
		}), /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "fs-12 fw-4",
			children: [
				/* @__PURE__ */ (0, Q.jsxs)("span", { children: [/* @__PURE__ */ (0, Q.jsx)("span", {
					className: "fw-6",
					children: "Propagate tags to Kubernetes resources:"
				}), " Propagate desired tags to Kubernetes resources as labels."] }),
				"\xA0",
				/* @__PURE__ */ (0, Q.jsx)("span", {
					className: "cb-5 fs-12 fw-4 cursor",
					onClick: oe,
					children: "Learn more"
				})
			]
		})]
	}), le = () => /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "dc__border-top-n1 py-16 flex left dc__gap-12 px-20",
		children: [/* @__PURE__ */ (0, Q.jsx)(M, {
			dataTestId: "tag-save-button",
			onClick: T,
			disabled: a || Zk(y).some((e) => !e.isValid) || d === pA.MANDATORY && !x.isValid,
			text: e === Me.edit ? "Update" : "Save",
			size: I.medium
		}), /* @__PURE__ */ (0, Q.jsx)(M, {
			dataTestId: "tag-cancel-button",
			onClick: w,
			disabled: a,
			text: "cancel",
			variant: F.secondary,
			size: I.medium
		})]
	}), ue = () => /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox-col flex-grow-1 dc__overflow-auto px-20 py-16",
		children: [ae(), ce()]
	}), { breadcrumbs: de } = gf(e === Me.edit ? B.APPLICATION_MANAGEMENT_POLICIES.TAG_POLICY.EDIT : B.APPLICATION_MANAGEMENT_POLICIES.TAG_POLICY.CREATE, { alias: {
		"application-management": null,
		policies: null,
		tags: {
			component: "Tags",
			linked: !0
		},
		"tag-policy": {
			component: /* @__PURE__ */ (0, Q.jsx)(To, { heading: "Tag Policy" }),
			linked: !0
		},
		create: {
			component: "Add tag",
			linked: !1
		},
		edit: {
			component: "Edit tag",
			linked: !1
		},
		":tagId": null
	} }, []);
	return /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsx)("div", {
		className: "bg__primary flexbox-col flex-grow-1 h-100 dc__overflow-hidden",
		children: /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "create-tag-container dc__height-inherit flexbox-col flex-grow-1",
			children: [
				/* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "flex flex-justify px-20 pt-16",
					children: [/* @__PURE__ */ (0, Q.jsxs)("h2", {
						className: "flex left fs-16 cn-9 fw-6 m-0 mb-8 h-32 w-100",
						children: [/* @__PURE__ */ (0, Q.jsx)(Co, {
							breadcrumbs: de,
							path: e === Me.edit ? B.APPLICATION_MANAGEMENT_POLICIES.TAG_POLICY.EDIT : B.APPLICATION_MANAGEMENT_POLICIES.TAG_POLICY.CREATE
						}), /* @__PURE__ */ (0, Q.jsx)(cA, {})]
					}), e === Me.edit && /* @__PURE__ */ (0, Q.jsxs)("button", {
						className: "cta delete override-button flex h-32 dc__min-width-fit-content",
						type: "button",
						disabled: a,
						onClick: D,
						children: [/* @__PURE__ */ (0, Q.jsx)(Be, { className: "mr-8 icon-dim-16" }), "Delete"]
					})]
				}),
				r ? /* @__PURE__ */ (0, Q.jsx)(ul, { pageLoader: !0 }) : /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [ue(), le()] }),
				h && /* @__PURE__ */ (0, Q.jsx)(sA, { closePopup: se })
			]
		})
	}), _ && ne()] });
}, SA = ({ projectOptions: e, projectMap: t, tagList: n, reload: r, closeModal: i }) => {
	let a = Ja(null), [o, s] = j(!1), [c, l] = j([]), [u, d] = j({}), f = A(() => {
		let e = /* @__PURE__ */ new Map(), r = [];
		return n.forEach((n) => {
			n.mandatoryProjectIdsCsv && n.mandatoryProjectsText !== "Not mandatory" && n.mandatoryProjectIdsCsv.split(",").forEach((n) => {
				let i = +n;
				e.get(i) || (r.push(t.get(i)), e.set(i, !0));
			});
		}), r;
	}, [n]), p = async (e) => {
		if (e.preventDefault(), !c.length && !Object.keys(u).length) {
			i();
			return;
		}
		let t = [], a = "", o = {};
		Object.values(c).forEach((e) => {
			a += `,${e.value}`, o[+e.value] = !0;
		}), n.forEach((e) => {
			let n = a;
			if (!e.mandatoryProjectIdsCsv) {
				if (!a) return;
			} else if (!u[-1]) {
				let t = e.mandatoryProjectIdsCsv.split(",");
				for (let e = 0; e < t.length;) {
					let n = +t[e];
					u[+n] || o[+n] ? t.splice(e, 1) : e += 1;
				}
				t.length && (n += `,${t.join(",")}`);
			}
			t.push({
				id: e.id,
				key: e.key,
				value: e.value,
				propagate: e.propagate,
				mandatoryProjectIdsCsv: n ? n.substring(1) : null,
				description: e.description,
				valueConstraint: e.valueConstraint,
				deploymentPolicy: e.deploymentPolicy
			});
		}), s(!0);
		try {
			await mp(t, !0), H.showToast({
				variant: U.success,
				description: "Successfully updated"
			}), i(), r();
		} catch (e) {
			K(e);
		} finally {
			s(!1);
		}
	}, m = (e) => {
		l(e);
	}, h = (e) => {
		let t = { ...u };
		t[e.currentTarget.dataset.id] = !0, d(t);
	}, g = (e) => {
		let t = { ...u };
		delete t[e.currentTarget.dataset.id], d(t);
	}, _ = (e, t) => /* @__PURE__ */ (0, Q.jsx)("span", {
		className: `fs-12 mr-8 mb-6 pl-8 pr-8 br-4 dc__border dc__ellipsis-right ${e}`,
		children: t
	}), v = (e) => {
		let n = e.mandatoryProjectIdsCsv.split(",");
		if (!e.mandatoryProjectIdsCsv && !c.length) return /* @__PURE__ */ (0, Q.jsx)("div", { children: "none" });
		let r = {};
		return /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [n.map((e) => {
			let n = t.get(+e);
			return r[+e] = !0, n ? _(u?.[n.id] ? "bcr-1 er-2" : "bg__primary", n.name) : null;
		}), c.map((e) => r[+e.value] ? null : _("bcg-1 eg-2", e.label))] });
	};
	return /* @__PURE__ */ (0, Q.jsx)(Rs, {
		position: "right",
		width: "720px",
		children: /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox-col mh-0 h-100 flex-grow-1 bg__primary bulk-edit-tag-container",
			ref: a,
			children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flex dc__content-space pt-16 pb-16 pl-20 pr-20 dc__border-bottom",
				children: [/* @__PURE__ */ (0, Q.jsx)("h2", {
					className: "fs-16 cn-9 fw-6 m-0",
					children: "Manage mandatory projects for selected tags"
				}), /* @__PURE__ */ (0, Q.jsx)(ue, {
					className: "icon-dim-20 cursor",
					onClick: i
				})]
			}), o ? /* @__PURE__ */ (0, Q.jsx)(ul, { pageLoader: !0 }) : /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flex-grow-1 cn-7 p-20 dc__overflow-auto",
				children: [
					/* @__PURE__ */ (0, Q.jsx)("div", {
						className: "fs-13 fw-6 mb-8",
						children: "Remove/Add Projects"
					}),
					/* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [f.length > 0 && /* @__PURE__ */ (0, Q.jsx)("div", {
						className: "flex left flex-wrap bg__secondary px-8 py-5 br-4 dc__border dc__no-bottom-radius dc__no-bottom-border",
						children: f.map((e) => /* @__PURE__ */ (0, Q.jsxs)("div", {
							className: "flex fs-12 mr-8 mt-4 pl-8 pr-8 br-4 dc__border bg__primary dc__ellipsis-right",
							children: [/* @__PURE__ */ (0, Q.jsx)("div", {
								className: `dc__ellipsis-right ${u?.[e.id] ? "dc__strike-through" : ""}`,
								children: e.name
							}), u?.[e.id] ? /* @__PURE__ */ (0, Q.jsx)(ir, {
								className: "ml-4 icon-dim-12 cursor scn-6 dc__min-width-fit-content",
								"data-id": e.id,
								onClick: g
							}) : /* @__PURE__ */ (0, Q.jsx)(ue, {
								className: "ml-4 icon-dim-12 cursor scn-6 dc__min-width-fit-content",
								"data-id": e.id,
								onClick: h
							})]
						}))
					}), /* @__PURE__ */ (0, Q.jsx)(V, {
						isMulti: !0,
						inputId: "mandatory-project-selector",
						options: e,
						size: I.large,
						placeholder: "Type to select projects",
						onChange: m,
						value: c,
						name: "Resource name"
					})] }),
					/* @__PURE__ */ (0, Q.jsxs)("div", {
						className: "dc__border br-4 mt-20",
						children: [
							/* @__PURE__ */ (0, Q.jsxs)("div", {
								className: "flex left bg__secondary dc__top-radius dc__border-bottom pt-8 pr-16 pb-8 pl-16",
								children: [/* @__PURE__ */ (0, Q.jsx)(Qt, { className: "icon-dim-16 mr-4 mw-18 scn-7 dc__no-shrink" }), "Preview Changes"]
							}),
							/* @__PURE__ */ (0, Q.jsxs)("div", {
								className: "bulk-edit-tag-row pt-8 pr-16 pb-8 pl-16 dc__border-bottom fs-12 fw-6",
								children: [
									/* @__PURE__ */ (0, Q.jsx)("span", {}),
									/* @__PURE__ */ (0, Q.jsx)("span", { children: "Tag name" }),
									/* @__PURE__ */ (0, Q.jsx)("span", { children: "Mandatory for projects" })
								]
							}),
							/* @__PURE__ */ (0, Q.jsx)("div", { children: n.map((e) => /* @__PURE__ */ (0, Q.jsxs)("div", {
								className: "bulk-edit-tag-row pt-6 pr-16 pl-16 fs-13 fw-4",
								children: [
									/* @__PURE__ */ (0, Q.jsx)(st, { className: "icon-dim-14 mr-6 mw-18 mt-3" }),
									/* @__PURE__ */ (0, Q.jsx)("span", {
										className: "mr-8 dc__ellipsis-right",
										children: e.key
									}),
									/* @__PURE__ */ (0, Q.jsx)("span", {
										className: "flex left flex-wrap dc__ellipsis-right",
										children: v(e)
									})
								]
							})) })
						]
					})
				]
			}), /* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "form__buttons dc__border-top pt-16 pb-16 pl-20 pr-20 dc__gap-12",
				children: [/* @__PURE__ */ (0, Q.jsx)(M, {
					dataTestId: "tag-cancel-button",
					onClick: i,
					disabled: o,
					text: "Cancel",
					variant: F.secondary,
					style: P.neutral
				}), /* @__PURE__ */ (0, Q.jsx)(M, {
					dataTestId: "tag-save-button",
					onClick: p,
					disabled: o,
					text: "Save"
				})]
			})] })]
		})
	});
}, CA = (e) => /* @__PURE__ */ (0, Q.jsx)("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "0 0 24 24",
	...e,
	children: /* @__PURE__ */ (0, Q.jsx)("path", {
		stroke: "#3B444C",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M2 6.984v12.564a.771.771 0 0 0 .77.77h6.244M2 6.983h19.167a.833.833 0 0 1 .833.833v.88M2 6.984v-2.5a.833.833 0 0 1 .833-.834h5.488a.833.833 0 0 1 .59.244L12 6.984m5.25 6.296 2.755 2.825m-4.216 4.215H13.4a.399.399 0 0 1-.399-.398v-2.226a.4.4 0 0 1 .117-.282l5.977-5.977a.399.399 0 0 1 .563 0l2.226 2.226a.398.398 0 0 1 0 .563L15.79 20.32Z",
		vectorEffect: "non-scaling-stroke"
	})
}), wA = ({ onActionClick: e }) => /* @__PURE__ */ (0, Q.jsxs)("div", {
	className: "flex dc__gap-4",
	children: [/* @__PURE__ */ (0, Q.jsx)(M, {
		"data-key": aA.MANAGE_PROJECTS,
		dataTestId: "manage-project",
		onClick: e,
		variant: F.secondary,
		style: P.neutral,
		text: "Manage Project(s)",
		size: I.small,
		startIcon: /* @__PURE__ */ (0, Q.jsx)(CA, {})
	}), /* @__PURE__ */ (0, Q.jsx)(M, {
		"data-key": aA.DELETE,
		dataTestId: "delete-selected-tags",
		ariaLabel: "Delete selected tags",
		onClick: e,
		variant: F.borderLess,
		style: P.negativeGrey,
		size: I.xs,
		icon: /* @__PURE__ */ (0, Q.jsx)(Be, { className: "icon-dim-16 dc__no-shrink" })
	})]
}), TA = (e) => /* @__PURE__ */ (0, Q.jsx)("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...e,
	children: /* @__PURE__ */ (0, Q.jsx)("path", {
		fill: "#06C",
		fillRule: "nonzero",
		d: "M9.465 3H5a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V9a3 3 0 0 0-3-3h-6.465L11.13 3.89A2 2 0 0 0 9.465 3zM5 5h4.465l1.406 2.11a2 2 0 0 0 1.664.89H19a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1z"
	})
}), EA = ({ row: { id: e, data: t }, signals: n }) => {
	let r = X(), i = Ja(null);
	return k(() => {
		let t = ({ detail: { activeRowData: t } }) => {
			t.id === e && i.current?.click();
		};
		return n.addEventListener(iu.ENTER_PRESSED, t), () => {
			n.removeEventListener(iu.ENTER_PRESSED, t);
		};
	}, []), /* @__PURE__ */ (0, Q.jsx)("button", {
		type: "button",
		ref: i,
		className: "cb-5 fw-4 cursor dc__truncate flex left dc__no-border dc__tab-focus dc__outline-none-imp dc__no-background m-0 p-0",
		onClick: () => {
			r(Y(B.APPLICATION_MANAGEMENT_POLICIES.TAG_POLICY.EDIT, { tagId: e }));
		},
		children: t.key
	});
}, DA = ({ row: { data: e } }) => e.mandatoryProjectsText === "Not mandatory" ? /* @__PURE__ */ (0, Q.jsx)("span", {
	className: "fw-4",
	children: cr
}) : /* @__PURE__ */ (0, Q.jsxs)("div", {
	className: "flex left dc__align-items-center dc__gap-4",
	children: [
		/* @__PURE__ */ (0, Q.jsx)(TA, { className: "icon-dim-16 fcn-6 dc__no-shrink" }),
		/* @__PURE__ */ (0, Q.jsx)("span", {
			className: "dc__ellipsis-right fw-4",
			children: e.mandatoryProjectList[0]
		}),
		e.mandatoryProjectList.length > 1 && /* @__PURE__ */ (0, Q.jsx)(W, {
			placement: "right",
			content: ((e) => /* @__PURE__ */ (0, Q.jsx)("div", { children: e.map((e, t) => t === 0 ? null : /* @__PURE__ */ (0, Q.jsx)("div", { children: e }, e)) }))(e.mandatoryProjectList),
			alwaysShowTippyOnHover: !0,
			children: /* @__PURE__ */ (0, Q.jsxs)("span", {
				className: "dc_width-max-content fs-12 fw-4 dc__ellipsis-right cb-5",
				children: [
					"+",
					e.mandatoryProjectList.length - 1,
					" more"
				]
			})
		})
	]
}), OA = ({ row: { data: e } }) => /* @__PURE__ */ (0, Q.jsx)(W, {
	content: e.description,
	children: /* @__PURE__ */ (0, Q.jsx)("div", {
		className: "lh-20 cn-9 dc__truncate fw-4",
		children: e.description || "-"
	})
}), kA = ({ row: { data: e } }) => /* @__PURE__ */ (0, Q.jsxs)("div", {
	className: "flex left dc__gap-8 dc__align-items-center",
	children: [Jk(e.deploymentPolicy), /* @__PURE__ */ (0, Q.jsx)("span", {
		className: "dc__ellipsis-right fw-4",
		children: Yk(e.deploymentPolicy)
	})]
}), AA = ({ data: e, onDelete: t }) => /* @__PURE__ */ (0, Q.jsxs)("div", {
	className: "flex dc__gap-4 right",
	children: [/* @__PURE__ */ (0, Q.jsx)(M, {
		dataTestId: "edit-tag",
		component: N.link,
		linkProps: { to: Y(B.APPLICATION_MANAGEMENT_POLICIES.TAG_POLICY.EDIT, { tagId: String(e.id) }) },
		icon: /* @__PURE__ */ (0, Q.jsx)(Ee, { className: "icon-dim-20 cursor" }),
		ariaLabel: "Edit tag",
		variant: F.borderLess,
		style: P.neutral,
		size: I.xs
	}), /* @__PURE__ */ (0, Q.jsx)(M, {
		dataTestId: "delete-tag",
		onClick: (n) => {
			n.stopPropagation(), t(e.id, e.key);
		},
		icon: /* @__PURE__ */ (0, Q.jsx)(Be, { className: "icon-dim-20 cursor" }),
		ariaLabel: "Delete tag",
		variant: F.borderLess,
		style: P.negativeGrey,
		size: I.xs
	})]
}), jA = ({ children: e, searchText: t, selectedProject: n, projectOptions: r, selectedFilterCondition: i, sortOrder: a, totalTagCount: o, onSearchChange: s, onProjectChange: c, onFilterConditionChange: l, onSortOrderChange: u }) => {
	let d = X(), f = () => {
		Mn.event({
			category: iA.GLOBAL_TAG_POLICY_ADD_TAG_BUTTON_CLICKED,
			action: iA.GLOBAL_TAG_POLICY_ADD_TAG_BUTTON_CLICKED
		}), d(B.APPLICATION_MANAGEMENT_POLICIES.TAG_POLICY.CREATE);
	};
	k(() => {
		u(a);
	}, [a]);
	let p = () => /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [
		/* @__PURE__ */ (0, Q.jsx)("div", { children: ie.description.para1 }),
		/* @__PURE__ */ (0, Q.jsx)("div", { children: ie.description.para2 }),
		/* @__PURE__ */ (0, Q.jsx)("div", { children: ie.description.para3 })
	] }), m = () => /* @__PURE__ */ (0, Q.jsx)(M, {
		dataTestId: "add-tag-list",
		onClick: f,
		startIcon: /* @__PURE__ */ (0, Q.jsx)(E, { className: "icon-dim-20" }),
		text: "Add tag",
		size: I.medium
	}), h = () => /* @__PURE__ */ (0, Q.jsx)(Il, {
		initialSearchText: t,
		containerClassName: "w-250 br-4",
		handleEnter: s,
		inputProps: {
			placeholder: "Search by tags",
			autoFocus: !0
		},
		dataTestId: "tag-search"
	}), g = () => /* @__PURE__ */ (0, Q.jsx)("div", {
		className: "w-200",
		children: /* @__PURE__ */ (0, Q.jsx)(V, {
			placeholder: "Project",
			inputId: "project-select",
			value: n,
			options: r,
			onChange: c,
			controlShouldRenderValue: !1,
			isMulti: !0,
			closeMenuOnSelect: !1,
			hideSelectedOptions: !1,
			isSearchable: !1
		})
	}), _ = (e) => {
		l(e);
	}, v = (e) => {
		let t = [...n];
		t.splice(e, 1), c(t);
	};
	return /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "tag-list flexbox-col h-100 bg__primary",
		children: [
			/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "pt-16 pr-20 pb-8 pl-20 flex flex-justify dc__align-items-center",
				children: [/* @__PURE__ */ (0, Q.jsx)("div", {
					className: "flex cn-9 fw-6 fs-16 lh-18",
					children: /* @__PURE__ */ (0, Q.jsx)(Xs, {
						title: on.TAGS.title,
						renderDescriptionContent: () => p?.(),
						docLink: "GLOBAL_CONFIG_TAGS",
						showInfoIconTippy: !0
					})
				}), o > 0 && /* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "flex dc__gap-8 dc__align-items-center",
					children: [
						h(),
						g(),
						/* @__PURE__ */ (0, Q.jsx)("div", { className: "dc__border-right h-20" }),
						m()
					]
				})]
			}),
			o > 0 && (n?.length ? /* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "pt-8 pr-20 pb-2 pl-20 flex left flex-wrap",
				children: [
					/* @__PURE__ */ (0, Q.jsxs)("div", {
						className: "flex mr-8 fw-6 fs-12 mb-6",
						children: [/* @__PURE__ */ (0, Q.jsx)("div", {
							className: `flex en-2 bw-1 pr-6 pl-6 pb-2 pt-2 dc__left-radius-4 ${i === fA.AND ? "bcn-7 cn-0" : "cn-5 bg__primary cursor"}`,
							onClick: () => _(fA.AND),
							children: fA.AND
						}), /* @__PURE__ */ (0, Q.jsx)("div", {
							className: `en-2 bw-1 pr-6 pl-6 pb-2 pt-2 dc__right-radius-4 dc__no-left-border ${i === fA.OR ? "bcn-7 cn-0" : "cn-5 bg__primary cursor"}`,
							onClick: () => _(fA.OR),
							children: fA.OR
						})]
					}, "filter-condition"),
					n.map((e, t) => /* @__PURE__ */ (0, Q.jsxs)("div", {
						className: "flex mr-8 bg__secondary cn-9 fs-12 mb-6",
						children: [/* @__PURE__ */ (0, Q.jsx)("div", {
							className: "fw-6 en-2 bw-1 pr-6 pl-6 pb-2 pt-2 dc__left-radius-4",
							children: "Project"
						}), /* @__PURE__ */ (0, Q.jsxs)("div", {
							className: "flex fw-4 en-2 bw-1 pr-6 pl-6 pb-2 pt-2 dc__right-radius-4 dc__no-left-border dc__mxw-400 dc__ellipsis-right",
							children: [e.label, /* @__PURE__ */ (0, Q.jsx)(ba, {
								className: "icon-dim-16 icon-fill-n4 ml-4 cursor",
								onClick: () => v(t)
							})]
						})]
					}, e.value)),
					/* @__PURE__ */ (0, Q.jsx)("span", {
						className: "lh-24 mb-6 cb-5 fs-13 fw-6 cursor",
						onClick: () => {
							c([]);
						},
						children: "Clear"
					})
				]
			}) : null),
			e
		]
	});
}, MA = ({ row: { data: e }, onDelete: t }) => /* @__PURE__ */ (0, Q.jsx)(AA, {
	data: e,
	onDelete: t
}), NA = ({ action: e, onClose: t, selections: n, bulkOperationModalData: { reload: r, projectMap: i, projectOptions: a } }) => e === aA.MANAGE_PROJECTS ? /* @__PURE__ */ (0, Q.jsx)(SA, {
	projectOptions: a,
	projectMap: i,
	tagList: n.map((e) => e.data),
	reload: r,
	closeModal: t
}) : /* @__PURE__ */ (0, Q.jsx)(oA, {
	isEditView: !1,
	isMultiDelete: !0,
	tagIDList: n.map((e) => +e.id),
	tagName: "",
	reload: r,
	closeModal: t
}), PA = () => {
	let e = X(), [t, n] = j(!1), [r, i] = j(0), [a, o] = j([]), [s, c] = j([]), [l, u] = j(/* @__PURE__ */ new Map()), [d, f] = j([]), [p, m] = j(""), [h, g] = j(fA.AND), [_, v] = j(Jl.ASC), [y, b] = j(!1), [x, S] = j(null), C = (e) => e.length === 0 ? cr : e.join(","), w = async () => {
		try {
			n(!0);
			let [{ result: e }, { result: t }] = await Promise.all([Md(), pp()]), r = /* @__PURE__ */ new Map(), a = [];
			e.forEach((e) => {
				r.set(e.id, e), a.push({
					label: e.name,
					value: `${e.id}`
				});
			}), t.forEach((e) => {
				let t = e.mandatoryProjectIdsCsv ? e.mandatoryProjectIdsCsv.split(",").map((e) => r.get(+e)).filter((e) => !!e).map((e) => e.name) : [], n = {
					...e,
					mandatoryProjectsText: C(t),
					mandatoryProjectList: t
				};
				Object.assign(e, n);
			}), o(t), u(r), c(a), i(0);
		} catch (e) {
			i(e.code);
		} finally {
			n(!1);
		}
	};
	k(() => {
		w().catch($d);
	}, []);
	let T = async () => {
		await w(), b((e) => !e);
	}, ee = Ka(() => {
		let e = [...a];
		return (p || d.length) && (e = e.filter((e) => {
			let t = !1;
			if (p && (t = e.key.toLowerCase().indexOf(p.toLowerCase()) >= 0 || e.description.toLowerCase().indexOf(p.toLowerCase()) >= 0 || e.mandatoryProjectsText.toLowerCase().indexOf(p.toLowerCase()) >= 0), (!p || t) && d.length) {
				t = !1;
				let n = Object.fromEntries(e.mandatoryProjectList.map((e) => [e, !0]));
				t = h === fA.AND ? d.every((e) => n[e.label]) : d.some((e) => n[e.label]);
			}
			return t;
		})), e.sort((e, t) => _ === Jl.ASC ? e.key.localeCompare(t.key) : t.key.localeCompare(e.key)), e;
	}, [
		a,
		p,
		d,
		h,
		_
	]), D = () => {
		Mn.event({
			category: iA.GLOBAL_TAG_POLICY_ADD_TAG_BUTTON_CLICKED,
			action: iA.GLOBAL_TAG_POLICY_ADD_TAG_BUTTON_CLICKED
		}), e(B.APPLICATION_MANAGEMENT_POLICIES.TAG_POLICY.CREATE);
	}, te = () => {
		m(""), g(fA.AND), f([]);
	}, ne = (e) => {
		m(e);
	}, re = (e) => {
		f(e);
	}, ie = (e) => {
		g(e);
	}, ae = (e) => {
		v(e);
	}, oe = A(() => [
		{
			field: "key",
			label: "Name",
			size: { fixed: 200 },
			isSortable: !0,
			horizontallySticky: !0,
			CellComponent: EA
		},
		{
			field: "mandatoryProjectsText",
			label: "Mandatory for projects",
			size: { fixed: 250 },
			isSortable: !1,
			CellComponent: DA
		},
		{
			field: "description",
			label: "Description",
			size: { fixed: 270 },
			isSortable: !1,
			CellComponent: OA
		},
		{
			field: "deploymentPolicy",
			label: "Allow/Block Deployments",
			size: { fixed: 200 },
			isSortable: !1,
			CellComponent: kA
		}
	], []), se = Ka((e, t) => {
		S({
			tagIDList: [e],
			tagName: t
		});
	}, []), ce = () => {
		S(null);
	}, le = A(() => ee().map((e) => ({
		id: `${e.id}`,
		data: e
	})), [ee]);
	return t ? /* @__PURE__ */ (0, Q.jsx)("div", {
		className: "bg__primary h-100",
		children: /* @__PURE__ */ (0, Q.jsx)(ul, { pageLoader: !0 })
	}) : r > 0 ? /* @__PURE__ */ (0, Q.jsx)("div", {
		className: "error-screen-wrapper flex column h-100",
		children: /* @__PURE__ */ (0, Q.jsx)(Ks, { code: r })
	}) : /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "h-100 flexbox-col dc__overflow-hidden bg__primary",
		children: [/* @__PURE__ */ (0, Q.jsx)(ru, {
			id: "table__tag-list",
			columns: oe,
			filtersVariant: tc.STATE,
			additionalFilterProps: { initialSortKey: "key" },
			rows: le,
			loading: t,
			filter: null,
			paginationVariant: el.NOT_PAGINATED,
			bulkSelectionConfig: {
				BulkActionsComponent: wA,
				BulkOperationModal: NA,
				getSelectAllDialogStatus: () => Vl.CLOSED,
				bulkOperationModalData: {
					reload: T,
					projectMap: l,
					projectOptions: s
				},
				bulkActionsData: null,
				disableSelectAllAcrossEvenIfPaginated: !0
			},
			rowActionOnHoverConfig: {
				width: 68,
				Component: MA
			},
			rowStartIconConfig: {
				name: "ic-tag",
				color: "N800",
				size: 16
			},
			emptyStateConfig: {
				noRowsConfig: {
					image: sp,
					title: "Manage tags for applications",
					subTitle: /* @__PURE__ */ (0, Q.jsxs)("div", { children: ["Add tags here and make them available to be used when creating an application. You can set tags as mandatory for applications in specific projects.\xA0", /* @__PURE__ */ (0, Q.jsx)(Ns, {
						docLinkKey: "TAGS",
						dataTestId: "learn-more-about-tags-link",
						fullWidth: !0
					})] }),
					isButtonAvailable: !0,
					renderButton: () => /* @__PURE__ */ (0, Q.jsx)(M, {
						dataTestId: "add-tag-list",
						onClick: D,
						startIcon: /* @__PURE__ */ (0, Q.jsx)(E, { className: "icon-dim-20" }),
						text: "Add tag",
						size: I.medium
					})
				},
				noRowsForFilterConfig: {
					title: "No tags found",
					subTitle: "No tags found for applied filters",
					handleClearFilters: te
				}
			},
			ViewWrapper: jA,
			additionalProps: {
				selectedProject: d,
				projectOptions: s,
				selectedFilterCondition: h,
				totalTagCount: a.length,
				onProjectChange: re,
				onFilterConditionChange: ie,
				onClearFilters: te,
				onSortOrderChange: ae,
				onSearchChange: ne,
				onDelete: se,
				searchText: p,
				reload: T
			}
		}, `tag-list-${y}`), x && /* @__PURE__ */ (0, Q.jsx)(oA, {
			isMultiDelete: !1,
			isEditView: !1,
			...x,
			reload: T,
			closeModal: ce
		})]
	});
}, FA = /* @__PURE__ */ t({ default: () => LA }), IA = vo.APPLICATION_MANAGEMENT.POLICIES.TAG_POLICY, LA = () => /* @__PURE__ */ (0, Q.jsx)(wo, { children: /* @__PURE__ */ (0, Q.jsxs)(qf, { children: [
	/* @__PURE__ */ (0, Q.jsx)(J, {
		index: !0,
		element: /* @__PURE__ */ (0, Q.jsx)(PA, {})
	}),
	/* @__PURE__ */ (0, Q.jsx)(J, {
		path: IA.CREATE,
		element: /* @__PURE__ */ (0, Q.jsx)(xA, { pageType: Me.create })
	}),
	/* @__PURE__ */ (0, Q.jsx)(J, {
		path: IA.EDIT,
		element: /* @__PURE__ */ (0, Q.jsx)(xA, { pageType: Me.edit })
	}),
	/* @__PURE__ */ (0, Q.jsx)(J, {
		path: "*",
		element: /* @__PURE__ */ (0, Q.jsx)(Kf, { to: "" })
	})
] }) }), $ = /* @__PURE__ */ function(e) {
	return e.MEMORY = "memory", e.CPU = "cpu", e.STORAGE = "storage", e.GPU = "gpu", e.NETWORK = "network", e;
}({}), RA = /* @__PURE__ */ function(e) {
	return e.LAST_24_HOURS = "last24Hours", e.LAST_7_DAYS = "last7Days", e.LAST_30_DAYS = "last30Days", e.LAST_90_DAYS = "last90Days", e;
}({}), zA = /* @__PURE__ */ function(e) {
	return e.CURRENCY = "currency", e.TIME_RANGE = "timeRange", e;
}({}), BA = /* @__PURE__ */ function(e) {
	return e.OVERVIEW = "cost-overview", e.APPLICATIONS = "applications", e.DEPLOYMENT_COST = "deployment-cost", e.CUSTOM_VIEWS = "custom-views", e.AGGREGATIONS = "aggregations", e.RESOURCE_KINDS = "resource-kinds", e;
}({}), VA = /* @__PURE__ */ function(e) {
	return e.typeFilter = "typeFilter", e;
}({}), HA = /* @__PURE__ */ function(e) {
	return e.NODE_GROUPS = "node-groups", e.NAMESPACES = "namespaces", e.APPLICATIONS = "applications", e;
}({}), UA = /* @__PURE__ */ function(e) {
	return e.CLUSTER = "cluster", e.ENVIRONMENT = "environment", e.PROJECT = "project", e.APPLICATION = "application", e.K8S_RESOURCE = "K8sResource", e;
}({}), WA = {
	[RA.LAST_24_HOURS]: "last24Hours",
	[RA.LAST_7_DAYS]: "last7Days",
	[RA.LAST_90_DAYS]: "last90Days",
	[RA.LAST_30_DAYS]: "last30Days"
}, GA = {
	[HA.APPLICATIONS]: "application",
	[HA.NAMESPACES]: "namespace",
	[HA.NODE_GROUPS]: "node"
}, KA = {
	[Kc.Pod]: "pod",
	[Kc.Deployment]: "deployment",
	[Kc.DaemonSet]: "daemonSet",
	[Kc.Job]: "job",
	[Kc.Rollout]: "rollout",
	[Kc.StatefulSet]: "statefulSet",
	[Kc.Containers]: "container"
}, qA = async ({ payload: e, resource: t, signal: n }) => {
	let r = t ? `/${t}` : "";
	return G(Rd(`${O.COST_SUMMARY}${r}`, e), { signal: n });
}, JA = async ({ payload: e, resource: t, signal: n }) => {
	let r = t ? `/${t}` : "";
	return G(Rd(`${O.COST_BREAKDOWN}${r}`, e), { signal: n });
}, YA = async (e) => {
	try {
		let { result: t } = await nf(O.K8S_CAPACITY_CLUSTER_IDENTIFY, { id: e }), n = JSON.parse(t?.costModuleSchema);
		return {
			clusterProvider: t?.provider || "Unknown",
			costModuleSchema: n
		};
	} catch (e) {
		throw K(e), e;
	}
}, XA = /* @__PURE__ */ function(e) {
	return e.CLUSTERS = "cluster", e.ENVIRONMENTS = "environment", e.APPLICATIONS = "application", e.CI_PIPELINES = "ciPipeline", e.PROJECTS = "project", e.CLUSTER_PROVIDERS = "clusterProvider", e.CUSTOM_VIEWS = "customView", e;
}({}), ZA = {
	[$.CPU]: "CPU Cost",
	[$.MEMORY]: "Memory Cost",
	[$.GPU]: "GPU Cost",
	[$.STORAGE]: "Storage Cost",
	[$.NETWORK]: "Network Cost"
}, QA = {
	[$.CPU]: "LimeGreen500",
	[$.MEMORY]: "SkyBlue500",
	[$.GPU]: "Lavender500",
	[$.STORAGE]: "AquaTeal500",
	[$.NETWORK]: "GoldenYellow500"
}, $A = {
	increase: "CoralRed400",
	decrease: "LimeGreen300",
	no_change: "SkyBlue300"
}, ej = [
	{
		label: "Cost: High to Low",
		value: {
			sortBy: "totalCost",
			sortOrder: Jl.DESC
		}
	},
	{
		label: "Cost: Low to High",
		value: {
			sortBy: "totalCost",
			sortOrder: Jl.ASC
		}
	},
	{
		label: "A to Z",
		value: {
			sortBy: "name",
			sortOrder: Jl.ASC
		}
	},
	{
		label: "Z to A",
		value: {
			sortBy: "name",
			sortOrder: Jl.DESC
		}
	}
], tj = RA.LAST_30_DAYS, nj = [
	{
		group: "",
		version: "v1",
		kind: Kc.Pod
	},
	{
		group: "apps",
		version: "v1",
		kind: Kc.Deployment
	},
	{
		group: "apps",
		version: "v1",
		kind: Kc.DaemonSet
	},
	{
		group: "batch",
		version: "v1",
		kind: Kc.Job
	},
	{
		group: "argoproj.io",
		version: "v1alpha1",
		kind: Kc.Rollout
	},
	{
		group: "apps",
		version: "v1",
		kind: Kc.StatefulSet
	},
	{
		group: "",
		version: "v1",
		kind: Kc.Containers
	}
], rj = [
	{
		label: "Cluster",
		value: L.CLUSTERS
	},
	{
		label: "Application",
		value: L.APPLICATIONS
	},
	{
		label: "Environment",
		value: L.ENVIRONMENTS
	},
	{
		label: "Project",
		value: L.PROJECTS
	}
], ij = /* @__PURE__ */ function(e) {
	return e.TOTAL_COST = "totalCost", e.CPU_COST = "cpuCost", e.MEMORY_COST = "memoryCost", e.GPU_COST = "gpuCost", e.STORAGE_COST = "storageCost", e.NETWORK_COST = "networkCost", e.POTENTIAL_SAVINGS = "potentialSavings", e.NAME = "name", e.NAMESPACE = "namespace", e.ENVIRONMENT = "environment", e;
}({}), aj = {
	[UA.CLUSTER]: "clusterDetails",
	[UA.ENVIRONMENT]: "envDetails",
	[UA.PROJECT]: "projectDetails",
	[UA.APPLICATION]: "appDetails",
	[UA.K8S_RESOURCE]: "resourceDetails"
}, oj = {
	[UA.CLUSTER]: L.CLUSTERS,
	[UA.ENVIRONMENT]: L.ENVIRONMENTS,
	[UA.PROJECT]: L.PROJECTS,
	[UA.APPLICATION]: L.APPLICATIONS
}, sj = {
	[$.CPU]: ij.CPU_COST,
	[$.MEMORY]: ij.MEMORY_COST,
	[$.GPU]: ij.GPU_COST,
	[$.STORAGE]: ij.STORAGE_COST,
	[$.NETWORK]: ij.NETWORK_COST
}, cj = ({ row: e, field: t }) => {
	let { data: n } = e, r = Object.entries(sj).find(([, e]) => e === t)?.[0];
	if (!r) return null;
	let i = n[r];
	return /* @__PURE__ */ (0, Q.jsx)("span", {
		className: "cn-9 fs-13 fw-4 lh-20",
		children: i.value
	});
}, lj = ({ row: e }) => {
	let { data: t } = e, n = t.totalCost;
	return /* @__PURE__ */ (0, Q.jsx)("div", {
		className: "flexbox dc__align-items-center dc__gap-8",
		children: /* @__PURE__ */ (0, Q.jsx)("span", {
			className: "cn-9 fs-13 fw-4 lh-20",
			children: n.value
		})
	});
}, uj = ({ row: e }) => {
	let { data: t } = e, n = t.potentialSavings;
	return /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox dc__content-space dc__gap-8 dc__align-items-center",
		children: [/* @__PURE__ */ (0, Q.jsx)("span", {
			className: "fs-13 fw-6 lh-20 cg-5 ",
			children: n.value
		}), /* @__PURE__ */ (0, Q.jsxs)("span", {
			className: "cn-9 fs-13 fw-4 lh-20",
			children: [
				"Save ",
				n.savingsPercentage,
				"%"
			]
		})]
	});
}, dj = [
	...Object.values($).map((e) => ({
		field: sj[e],
		label: ZA[e],
		size: { range: {
			startWidth: 120,
			maxWidth: 250,
			minWidth: 80
		} },
		CellComponent: cj,
		isSortable: !0
	})),
	{
		field: ij.TOTAL_COST,
		label: "Total Cost",
		size: { range: {
			startWidth: 100,
			maxWidth: 250,
			minWidth: 80
		} },
		CellComponent: lj,
		isSortable: !0
	},
	{
		field: ij.POTENTIAL_SAVINGS,
		label: "Potential Savings",
		size: { range: {
			startWidth: 180,
			maxWidth: 400,
			minWidth: 80
		} },
		CellComponent: uj,
		isSortable: !0
	}
], fj = {
	[ij.CPU_COST]: "cpuCost",
	[ij.GPU_COST]: "gpuCost",
	[ij.MEMORY_COST]: "memoryCost",
	[ij.NETWORK_COST]: "networkCost",
	[ij.NAME]: "name",
	[ij.POTENTIAL_SAVINGS]: "potentialSavings",
	[ij.STORAGE_COST]: "storageCost",
	[ij.TOTAL_COST]: "totalCost",
	[ij.NAMESPACE]: "namespace",
	[ij.ENVIRONMENT]: "env"
}, pj = "namespace", mj = "environment";
//#endregion
//#region src/Pages-Devtron-2.0/CostVisibility/Shared/utils.ts
$e();
var hj = (e) => typeof e != "string" || e === "0" ? "no_change" : e.startsWith("+") ? "increase" : "decrease", gj = (e) => `${e.kind}-${e.group || Dc}-${e.version}`, _j = (e, t) => {
	if (e === BA.DEPLOYMENT_COST) return "Deployment environments";
	if (e === BA.APPLICATIONS) return "Applications";
	if (!t) return "";
	if (e === BA.AGGREGATIONS) switch (t) {
		case HA.NAMESPACES: return "Namespace";
		case HA.NODE_GROUPS: return "Node Group";
		case HA.APPLICATIONS: return "Application";
		default: return "";
	}
	if (e === BA.RESOURCE_KINDS) {
		let e = nj.find((e) => gj(e) === t);
		return e ? e.kind : "";
	}
	return t;
}, vj = (e, t, n) => {
	let r = {};
	if (t !== tj && (r[zA.TIME_RANGE] = t), n && (r[zA.CURRENCY] = n), Object.keys(r).length === 0) return e;
	let i = Rd("", r).slice(1);
	return `${e}${e.includes("?") ? "&" : "?"}${i}`;
}, yj = (e) => (t, n) => {
	let r = null, i = "";
	switch (e) {
		case RA.LAST_24_HOURS: return r = l(t, ss.WEEKDAY_DATE_MONTH_YEAR_AND_HOUR, !0), n === 0 || r.format("hh") === "12" ? [r.format("hh"), r.format("A")] : r.format("hh");
		case RA.LAST_7_DAYS: return r = l(t, ss.WEEKDAY_WITH_DATE_MONTH_AND_YEAR, !0), r.format(ss.ABBREVIATED_WEEKDAY);
		case RA.LAST_30_DAYS: return r = l(t, ss.WEEKDAY_WITH_DATE_MONTH_AND_YEAR, !0), i = r.format(ss.DAY_OF_MONTH), n === 0 || i === "01" ? [i, r.format(ss.ABBREVIATED_MONTH)] : i;
		case RA.LAST_90_DAYS: return t.split(" to ").map((e) => l(e, ss.WEEKDAY_WITH_DATE_MONTH_AND_YEAR, !0).format(ss.DATE_WITH_ABBREVIATED_MONTH)).join(" - ");
		default: return t;
	}
};
//#endregion
//#region src/Pages-Devtron-2.0/CostVisibility/Shared/API/utils.ts
$e();
var bj = (e, t) => {
	if (t === L.CLUSTERS) {
		if (e === ll.PRODUCTION) return "cluster|type|prod";
		if (e === ll.NON_PRODUCTION) return "cluster|type|non-prod";
	}
	if (t === L.ENVIRONMENTS) {
		if (e === ll.PRODUCTION) return "environment|type|prod";
		if (e === ll.NON_PRODUCTION) return "environment|type|non-prod";
	}
	return null;
}, xj = (e, t) => t ? XA.CUSTOM_VIEWS : {
	[L.APPLICATIONS]: XA.APPLICATIONS,
	[L.CLUSTERS]: XA.CLUSTERS,
	[L.ENVIRONMENTS]: XA.ENVIRONMENTS,
	[L.PROJECTS]: XA.PROJECTS
}[e] || null, Sj = (e, t) => {
	if (!e) return null;
	switch (e) {
		case BA.CUSTOM_VIEWS: return null;
		case BA.AGGREGATIONS: return t ? [GA[t]] : null;
		case BA.RESOURCE_KINDS: {
			if (!t) return null;
			let e = nj.find((e) => gj(e) === t);
			return e ? [KA[e.kind]] : (H.showToast({
				variant: U.error,
				description: "Invalid resource kind"
			}), null);
		}
		case BA.APPLICATIONS: return ["application"];
		case BA.DEPLOYMENT_COST: return ["environment"];
		default: return null;
	}
}, Cj = (e, t) => e ? `namespace|name|${e}` : t ? `environment|name|${t}` : null, wj = ({ view: e, breakdownViewType: t, itemName: n, detail: r, currency: i, timeRange: a, sortBy: o, sortOrder: s, pageSize: c, offset: l, searchKey: u, typeFilter: d, namespace: f, environment: p }) => {
	let m = {
		timeWindow: WA[a || tj],
		sortBy: fj[o],
		sortOrder: s,
		searchByName: u || "",
		size: c,
		offset: l
	}, h = xj(t, e === BA.CUSTOM_VIEWS), g = Object.values(ll).includes(d) ? d : ll.ALL, _ = Sj(e, r);
	if (!e) return {
		resource: h,
		payload: {
			...m,
			resourceName: null,
			subResource: null,
			currencyCode: i,
			filter: bj(g, t)
		}
	};
	let v = {
		currencyCode: i,
		subResource: _,
		filter: Cj(f, p),
		resourceName: e === BA.CUSTOM_VIEWS ? r : n
	};
	return {
		resource: h,
		payload: {
			...m,
			...v
		}
	};
}, Tj = (e) => !e || e.length === 0 ? null : [...e].sort((e, t) => l(t.date).valueOf() - l(e.date).valueOf())[0]?.date || null, Ej = (e) => Array.from({ length: 24 }, (t, n) => {
	let r = 23 - n;
	return (e ? l(e) : l()).subtract(r, "hours").toISOString();
}), Dj = (e) => Array.from({ length: 7 }, (t, n) => {
	let r = 6 - n;
	return (e ? l(e) : l()).subtract(r, "days").startOf("day").toISOString();
}), Oj = (e) => Array.from({ length: 30 }, (t, n) => {
	let r = 29 - n;
	return (e ? l(e) : l()).subtract(r, "days").startOf("day").toISOString();
}), kj = (e) => Array.from({ length: 13 }, (t, n) => {
	let r = 12 - n;
	return (e ? l(e) : l()).subtract(r, "weeks").startOf("week").toISOString();
}), Aj = (e) => {
	let t = /* @__PURE__ */ new Map();
	return e.forEach((e) => {
		let n = l(e.date), r = `${n.hour()}-${n.format("DD")}`;
		t.set(r, e.cost);
	}), t;
}, jj = (e) => {
	let t = /* @__PURE__ */ new Map();
	return e.forEach((e) => {
		let n = l(e.date).format("ddd");
		t.set(n, (t.get(n) || 0) + e.cost);
	}), t;
}, Mj = (e) => {
	let t = /* @__PURE__ */ new Map();
	return e.forEach((e) => {
		let n = l(e.date), r = `${n.format("DD")}-${n.format("MM")}`;
		t.set(r, (t.get(r) || 0) + e.cost);
	}), t;
}, Nj = (e) => {
	let t = ss.WEEKDAY_DATE_MONTH_YEAR_AND_HOUR, n = Ej(Tj(e)), r = Aj(e);
	return n.map((e) => {
		let n = l(e), i = `${n.hour()}-${n.format("DD")}`;
		return {
			label: n.format(t),
			value: r.get(i) ?? NaN
		};
	});
}, Pj = (e) => {
	let t = ss.WEEKDAY_WITH_DATE_MONTH_AND_YEAR, n = Dj(Tj(e)), r = jj(e);
	return n.map((e) => ({
		label: l(e).format(t),
		value: r.get(l(e).format("ddd")) ?? NaN
	}));
}, Fj = (e) => {
	let t = ss.WEEKDAY_WITH_DATE_MONTH_AND_YEAR, n = Oj(Tj(e)), r = Mj(e);
	return n.map((e) => {
		let n = l(e), i = `${n.format("DD")}-${n.format("MM")}`;
		return {
			label: n.format(t),
			value: r.get(i) ?? NaN
		};
	});
}, Ij = (e) => {
	let t = ss.WEEKDAY_WITH_DATE_MONTH_AND_YEAR;
	return kj(Tj(e)).map((n) => {
		let r = l(n), i = l(r).endOf("week"), a = 0, o = !1;
		return e.forEach((e) => {
			l(e.date).isBetween(r, i, null, "[]") && (a += e.cost, o = !0);
		}), {
			label: `${r.format(t)} to ${i.format(t)}`,
			value: o ? a : NaN
		};
	});
}, Lj = (e, t) => {
	if (!e || e.length === 0) return [];
	switch (t) {
		case "last24Hours": return Nj(e);
		case "last7Days": return Pj(e);
		case "last30Days": return Fj(e);
		case "last90Days": return Ij(e);
		default: return [];
	}
}, Rj = ({ totalCost: e = 0, potentialSavings: t = 0, potentialSavingsPercentage: n = 0, recommendedCost: r = 0, trend: i = null, trendPercent: a = 0 }, o) => ({
	totalCost: Number(e.toFixed(2)),
	recommendedCost: Number(r?.toFixed(2) ?? (e - t).toFixed(2)),
	potentialSavings: Number(t.toFixed(2)),
	potentialSavingsPercentage: Number(n.toFixed(2)),
	trend: a === 0 ? "0" : `${a > 0 ? "+" : "-"}${Math.abs(a)}`,
	plotPoints: Lj(i, o)
}), zj = (e, t) => {
	let n = WA[t];
	if (e?.subResourceSummary && Object.keys(e.subResourceSummary).length) {
		let t = {};
		return Object.entries(e.subResourceSummary).forEach(([e, r]) => {
			let { cpu: i, memory: a, gpu: o, storage: s, network: c, ...l } = r.summary ?? {};
			t[e] = {
				overall: Rj(l, n),
				cpu: Rj(i ?? {}, n),
				memory: Rj(a ?? {}, n),
				gpu: Rj(o ?? {}, n),
				storage: Rj(s ?? {}, n),
				network: Rj(c ?? {}, n)
			};
		}), { subResourceSummary: t };
	}
	let { cpu: r, memory: i, gpu: a, storage: o, network: s, ...c } = e?.summary ?? {};
	return { summary: {
		overall: Rj(c, n),
		cpu: Rj(r ?? {}, n),
		memory: Rj(i ?? {}, n),
		gpu: Rj(a ?? {}, n),
		storage: Rj(o ?? {}, n),
		network: Rj(s ?? {}, n)
	} };
}, Bj = ({ subResource: e, breakdownViewType: t, timeRange: n, typeFilter: r, resourceName: i, isCustomView: a, trendDetailType: o, currency: s }) => {
	let c = { timeWindow: WA[n || tj] };
	return {
		resource: xj(t, a),
		payload: {
			...c,
			resourceName: i,
			subResource: e,
			filter: bj(r, t),
			includeTrendForAdditionalCostTypes: o === "all",
			includeTrendForSubResources: o === "include-sub-resource-total",
			currencyCode: s
		}
	};
}, Vj = ({ breakdownViewType: e, resourceName: t, currency: n, timeRange: r, sortBy: i, sortOrder: a, pageSize: o, offset: s, searchKey: c, typeFilter: l, subResource: u, isCustomView: d }) => ({
	resource: xj(e, d),
	payload: {
		timeWindow: WA[r || tj],
		sortBy: i,
		sortOrder: a,
		searchByName: c || "",
		size: o,
		offset: s,
		resourceName: t,
		subResource: u ?? null,
		filter: bj(l, e),
		currencyCode: n
	}
}), Hj = (e, { variant: t }, n, r) => {
	let i = e.subResourceSummary ? Object.values(e.subResourceSummary)[0] : e.summary;
	if (!i) throw Error("Invalid CostSummaryType: Neither summary nor subResourceSummary found");
	let a = i.overall, o = a.trend, s = a.plotPoints || [], c = s.map((e) => e.label), l = {
		datasetName: "Cost Trend",
		yAxisValues: s.map((e) => e.value),
		color: "blue"
	}, u = {
		totalCost: Uu(a.totalCost, r),
		delta: o,
		datasets: l,
		xAxisLabels: c,
		isLoading: !1
	}, d, f;
	if (t === "expanded") {
		let { potentialSavingsPercentage: e, potentialSavings: t } = a;
		d = {
			variant: "expanded",
			props: {
				potentialSavingsPercentage: e,
				potentialSavings: Uu(t, r),
				recommendedCost: Uu(a.recommendedCost, r)
			}
		};
	} else f = Object.values($).map((e) => {
		let { potentialSavings: t, trend: n, totalCost: a, potentialSavingsPercentage: o } = i[e];
		return {
			isLoading: !1,
			variant: "mini",
			props: {
				category: e.toUpperCase(),
				delta: n,
				variant: "plain",
				categoryPotentialSavingsPercentage: o,
				categoryPotentialSavings: Uu(t, r),
				totalCategoryCost: Uu(a, r)
			}
		};
	}), f.sort(({ props: { categoryPotentialSavings: e } }, { props: { categoryPotentialSavings: t } }) => Number(t.slice(1)) - Number(e.slice(1)));
	return {
		costTrendProps: u,
		potentialSavingsCardProps: d,
		potentialSavingsMiniCardProps: f
	};
}, Uj = "cost-visibility-user-currency", Wj = Ua({
	isCostVisibilityEnabled: !1,
	refetchCostVisibilityMetadata: $d,
	isLoadingMetadata: !1,
	metadataError: null,
	currencyData: {
		currencies: [],
		defaultCurrency: "",
		globalDefaultCurrency: "",
		isLoading: !1,
		error: null,
		refetch: $d
	},
	handleCurrencyChangeForUser: $d,
	breakdownDetailsData: { selectedCluster: {
		id: null,
		handleChange: $d
	} }
}), Gj = () => {
	let e = qa(Wj);
	if (!e) throw Error("useCostVisibilityContext must be used within a CostVisibilityProvider");
	return e;
}, Kj = "cost-opportunities", qj = "costBreakdown", Jj = "costVisibilityMetadata-global-provider", Yj = "currencyData-global-provider", Xj = (e) => e ? e.enabled && e.installationStatus === "Success" : !1, Zj = () => q({
	queryKey: [Jj],
	queryFn: ({ signal: e }) => Gu(e),
	select: ({ result: e }) => (e || []).filter((e) => Xj(e.costModuleConfig))
}), Qj = () => q({
	queryKey: [Yj],
	queryFn: () => G(O.CURRENCY),
	select: (e) => {
		let { defaultCurrency: t, supportedCurrencies: n } = e?.result || {
			defaultCurrency: "",
			supportedCurrencies: []
		};
		return {
			currencies: (n || []).filter((e) => !!e.code).map((e) => e.code).sort(df),
			defaultCurrency: t
		};
	}
}), $j = async (e, t) => {
	let { result: n } = await G(`${O.CLUSTER_NAMESPACES}/${e}`, { signal: t });
	return (n || []).sort(df).map((e) => ({
		label: e,
		value: e
	}));
}, eM = ({ children: e }) => {
	let { isFetching: t, data: n, error: r, refetch: i } = Zj(), [a, o] = j(null), { isFetching: s, data: c, error: l, refetch: u } = Qj(), d = () => localStorage.getItem(Uj), f = (e) => {
		localStorage.setItem(Uj, e);
	}, [p, m] = j(d), h = (e) => {
		f(e), m(e);
	}, g = (e) => {
		o(e);
	};
	return k(() => {
		!d() && c?.defaultCurrency && h(c.defaultCurrency);
	}, [c?.defaultCurrency]), /* @__PURE__ */ (0, Q.jsx)(Wj, {
		value: A(() => ({
			isCostVisibilityEnabled: (n || []).length > 0,
			refetchCostVisibilityMetadata: i,
			isLoadingMetadata: t,
			metadataError: r,
			currencyData: {
				currencies: c?.currencies || [],
				defaultCurrency: p || "",
				globalDefaultCurrency: c?.defaultCurrency || "",
				isLoading: s,
				error: l,
				refetch: u
			},
			handleCurrencyChangeForUser: h,
			breakdownDetailsData: { selectedCluster: {
				id: a,
				handleChange: g
			} }
		}), [
			n,
			t,
			r,
			c,
			s,
			l,
			a
		]),
		children: e
	});
}, tM = () => {
	let { searchParams: e } = jf(), { currencyData: t } = Gj(), n = e[zA.TIME_RANGE], r = Object.values(RA).includes(n) ? n : tj, i = e[VA.typeFilter];
	return {
		timeRange: r,
		typeFilter: Object.values(ll).includes(i) ? i : ll.ALL,
		currency: e[zA.CURRENCY] || t.defaultCurrency
	};
}, nM = [
	{
		value: 8,
		selected: !0
	},
	{
		value: 12,
		selected: !1
	},
	{
		value: 16,
		selected: !1
	}
], rM = [
	"pod",
	"deployment",
	"daemonSet",
	"job",
	"rollout",
	"statefulSet",
	"container"
], iM = ({ datasets: e, xAxisLabels: t, orientation: n }) => {
	let { currency: r } = tM();
	return /* @__PURE__ */ (0, Q.jsx)(Uo, {
		...A(() => ({
			id: "stacked-bar-chart",
			type: n === "horizontal" ? "stackedBarHorizontal" : "stackedBar",
			datasets: Object.entries(e).map(([e, t]) => ({
				datasetName: ZA[e],
				color: QA[e],
				yAxisValues: t
			})),
			xAxisLabels: t
		}), [
			e,
			t,
			n
		]),
		yScaleTickFormat: (e) => Uu(Number(e), r),
		tooltipConfig: { datasetValueFormatter: (e) => Uu(e, r) }
	});
}, aM = {
	[RA.LAST_24_HOURS]: "Last 24 Hours",
	[RA.LAST_7_DAYS]: "Last 7 Days",
	[RA.LAST_30_DAYS]: "Last 30 Days",
	[RA.LAST_90_DAYS]: "Last 90 Days"
}, oM = Object.values(RA).map((e) => ({
	label: aM[e],
	value: e
})), sM = ({ shouldMenuAlignRight: e = !0, stateConfig: t, variant: n, size: r, analyticsAction: i }) => {
	let { searchParams: a } = jf(), o = X(), s = a[zA.TIME_RANGE], c = oM.find((e) => e.value === (t?.timeRange ?? s)) ?? {
		label: aM[tj],
		value: tj
	};
	return /* @__PURE__ */ (0, Q.jsx)(V, {
		inputId: "cost-visibility-time-range-select",
		value: c,
		options: oM,
		onChange: (e) => {
			if (i && Vd({
				category: "cost_visibility_timeframe",
				action: i
			}), t) {
				t.setTimeRange(e.value);
				return;
			}
			let n = structuredClone(a);
			o({ search: new URLSearchParams({
				...n,
				[zA.TIME_RANGE]: e.value
			}).toString() });
		},
		shouldMenuAlignRight: e,
		variant: n,
		size: r
	});
}, cM = ({ paginationProps: e, chartProps: t, isLoading: n, hideFilters: r, hideCategoryFilter: i, selectedCategoryOption: a, setSelectedCategoryOption: o, setSortOrderOption: s, sortOrderOption: c, categoryLabel: l = "", orientation: u = "horizontal", errorConfig: d, timeSelectStateConfig: f, cardVariant: p, timeframeAnalyticsAction: m }) => {
	let { timeRange: h } = tM(), g = aM[h ?? tj];
	return /* @__PURE__ */ (0, Q.jsxs)(Ho, {
		variant: p,
		children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox dc__content-space px-16 py-12 dc__gap-16 border__secondary--bottom",
			children: [/* @__PURE__ */ (0, Q.jsx)("div", {
				className: "flexbox dc__gap-4 lh-1-5 fs-13",
				children: f ? /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsx)("span", {
					className: "cn-9 fw-6",
					children: "Cost breakdown for"
				}), /* @__PURE__ */ (0, Q.jsx)(sM, {
					stateConfig: f,
					variant: Hl.COMPACT,
					size: I.small,
					analyticsAction: m
				})] }) : /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [
					/* @__PURE__ */ (0, Q.jsxs)("span", {
						className: "cn-9 fw-6",
						children: ["Cost breakdown ", l && `by ${Au(l)}`]
					}),
					/* @__PURE__ */ (0, Q.jsx)("span", {
						className: "cn-9 fw-4",
						children: "·"
					}),
					/* @__PURE__ */ (0, Q.jsx)("span", {
						className: "cn-7 fw-4",
						children: g
					})
				] })
			}), !r && /* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "dc__separated-flexbox",
				children: [!i && /* @__PURE__ */ (0, Q.jsx)(V, {
					inputId: "overview-cost-breakdown-select",
					value: a,
					onChange: o,
					options: rj,
					variant: Hl.COMPACT,
					size: I.small,
					shouldMenuAlignRight: !0
				}), /* @__PURE__ */ (0, Q.jsx)(V, {
					inputId: "overview-cost-breakdown-sort-select",
					value: c,
					onChange: s,
					options: ej,
					variant: Hl.COMPACT,
					size: I.small,
					shouldMenuAlignRight: !0
				})]
			})]
		}), (() => {
			let r = "456px";
			if (n) return /* @__PURE__ */ (0, Q.jsx)("div", {
				style: { height: r },
				className: "p-16",
				children: /* @__PURE__ */ (0, Q.jsx)("div", { className: "shimmer w-100 h-100" })
			});
			if (d) return /* @__PURE__ */ (0, Q.jsx)("div", {
				style: { height: r },
				className: "flex p-16",
				children: /* @__PURE__ */ (0, Q.jsx)(lc, { reload: d.refetch })
			});
			let { size: i } = e ?? {};
			return /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsx)("div", {
				style: { height: r },
				className: "p-16",
				children: /* @__PURE__ */ (0, Q.jsx)(iM, {
					orientation: u,
					...t
				})
			}), e && i > nM[0].value && /* @__PURE__ */ (0, Q.jsx)($c, {
				rootClassName: "flex dc__content-space px-20",
				...e,
				pageSizeOptions: nM
			})] });
		})()]
	});
}, lM = (e) => {
	let t = e.summary || e.subResourceSummary && Object.values(e.subResourceSummary)[0]?.summary;
	if (!t) return {
		datasets: {
			[$.CPU]: [],
			[$.MEMORY]: [],
			[$.GPU]: [],
			[$.STORAGE]: [],
			[$.NETWORK]: []
		},
		xAxisLabels: []
	};
	if (e.subResourceSummary) {
		let t = Object.keys(e.subResourceSummary), n = t;
		return {
			datasets: {
				[$.CPU]: t.map((t) => e.subResourceSummary[t].summary.cpu.totalCost),
				[$.MEMORY]: t.map((t) => e.subResourceSummary[t].summary.memory.totalCost),
				[$.GPU]: t.map((t) => e.subResourceSummary[t].summary.gpu.totalCost),
				[$.STORAGE]: t.map((t) => e.subResourceSummary[t].summary.storage.totalCost),
				[$.NETWORK]: t.map((t) => e.subResourceSummary[t].summary.network.totalCost)
			},
			xAxisLabels: n
		};
	}
	return {
		datasets: {
			[$.CPU]: [t.cpu.totalCost],
			[$.MEMORY]: [t.memory.totalCost],
			[$.GPU]: [t.gpu.totalCost],
			[$.STORAGE]: [t.storage.totalCost],
			[$.NETWORK]: [t.network.totalCost]
		},
		xAxisLabels: ["Total"]
	};
}, uM = ({ items: e, totalCount: t }) => {
	let n = e.map((e) => e.name);
	return {
		chartProps: {
			datasets: {
				[$.CPU]: e.map((e) => e.cpuCost),
				[$.MEMORY]: e.map((e) => e.memoryCost),
				[$.GPU]: e.map((e) => e.gpuCost),
				[$.STORAGE]: e.map((e) => e.storageCost),
				[$.NETWORK]: e.map((e) => e.networkCost)
			},
			xAxisLabels: n
		},
		totalItems: t
	};
}, dM = ({ breakdownViewType: e, itemName: t }) => {
	let { view: n } = Z(), { timeRange: r, currency: i, typeFilter: a } = tM(), { isLoading: o, data: s, error: c, refetch: l } = q({
		queryKey: [
			"costBreakdown",
			"resourceKind",
			e,
			i,
			r,
			a,
			t,
			n
		],
		queryFn: ({ signal: o }) => qA({
			...Bj({
				breakdownViewType: e,
				currency: i,
				timeRange: r,
				resourceName: t,
				isCustomView: n === BA.CUSTOM_VIEWS,
				typeFilter: a,
				subResource: rM,
				trendDetailType: "total_only"
			}),
			signal: o
		}),
		select: (e) => lM(e.result)
	}), u = A(() => s ?? {}, [s]);
	return /* @__PURE__ */ (0, Q.jsx)(cM, { ...o ? { isLoading: !0 } : {
		chartProps: u,
		hideFilters: !0,
		categoryLabel: "Resource Kind",
		orientation: "vertical",
		errorConfig: c ? { refetch: l } : null
	} });
}, fM = ({ breakdownViewType: e, itemName: t, subResource: n }) => {
	let { view: r } = Z(), [i, a] = j(ej[0]), { pageSize: o, changePage: s, changePageSize: c, offset: l } = Mf({ defaultPageSize: nM[0].value }), { timeRange: u, currency: d, typeFilter: f } = tM(), { isLoading: p, data: m, error: h, refetch: g } = q({
		queryKey: [
			"costBreakdown",
			o,
			t,
			e,
			l,
			i,
			f,
			u,
			d,
			JSON.stringify(n),
			r
		],
		queryFn: ({ signal: a }) => JA({
			...Vj({
				breakdownViewType: e,
				currency: d,
				pageSize: o,
				offset: l,
				sortOrder: i.value.sortOrder,
				timeRange: u,
				typeFilter: f,
				resourceName: t,
				isCustomView: r === BA.CUSTOM_VIEWS,
				searchKey: "",
				sortBy: i.value.sortBy,
				subResource: n
			}),
			signal: a
		}),
		select: (e) => uM(e.result.breakdownsBySubResource[n[0]])
	}), { chartProps: _, totalItems: v } = A(() => m ?? {}, [m]);
	return /* @__PURE__ */ (0, Q.jsx)(cM, { ...p ? { isLoading: !0 } : {
		chartProps: _,
		paginationProps: {
			changePage: s,
			offset: l,
			pageSize: o,
			size: v,
			changePageSize: c
		},
		categoryLabel: n[0],
		setSortOrderOption: a,
		sortOrderOption: i,
		hideCategoryFilter: !0,
		orientation: "horizontal",
		errorConfig: h ? { refetch: g } : null
	} });
}, pM = ({ type: e, props: t }) => e === "resourceKind" ? /* @__PURE__ */ (0, Q.jsx)(dM, { ...t }) : /* @__PURE__ */ (0, Q.jsx)(fM, { ...t }), mM = ({ hideCategoryFilter: e = !1, timeframeAnalyticsAction: t, breakdownCategoryAnalyticsAction: n }) => {
	let { pageSize: r, changePage: i, offset: a, changePageSize: o } = Mf({ defaultPageSize: nM[0].value }), [s, c] = j(ej[0]), [l, u] = j(rj[0]), [d, f] = j(tj), { currency: p, typeFilter: m } = tM(), { data: h, isFetching: g, error: _, refetch: v } = q({
		queryKey: [qj, {
			pageSize: r,
			offset: a,
			sortOrder: s,
			selectedCategoryOption: l,
			currency: p,
			timeRange: d,
			typeFilter: m
		}],
		queryFn: ({ signal: e }) => JA({
			...Vj({
				breakdownViewType: l.value,
				currency: p,
				pageSize: r,
				offset: a,
				sortOrder: s.value.sortOrder,
				timeRange: d,
				typeFilter: m,
				resourceName: null,
				isCustomView: !1,
				searchKey: "",
				sortBy: s.value.sortBy,
				subResource: null
			}),
			signal: e
		}),
		select: (e) => uM(e?.result?.overallBreakdown ?? {
			items: [],
			totalCount: 0
		})
	}), { chartProps: y, totalItems: b } = A(() => h ?? {}, [h]);
	return /* @__PURE__ */ (0, Q.jsx)(cM, { ...g ? { isLoading: !0 } : {
		chartProps: y,
		paginationProps: {
			changePage: i,
			offset: a,
			pageSize: r,
			size: b,
			changePageSize: o
		},
		isLoading: !1,
		sortOrderOption: s,
		setSortOrderOption: c,
		orientation: "horizontal",
		errorConfig: _ ? { refetch: v } : null,
		...e ? { hideCategoryFilter: !0 } : {
			selectedCategoryOption: l,
			setSelectedCategoryOption: (e) => {
				n && Vd({
					category: "cost_visibility_breakdown",
					action: `${n}_BY_${e.value.toUpperCase()}`
				}), u(e);
			}
		},
		timeSelectStateConfig: {
			timeRange: d,
			setTimeRange: f
		},
		cardVariant: "secondary--outlined",
		timeframeAnalyticsAction: t
	} });
}, hM = (e) => {
	let { serverMode: t } = Tf(), { variant: n } = e;
	return n === "overview" ? /* @__PURE__ */ (0, Q.jsx)(mM, {
		hideCategoryFilter: t === Ml.EA_ONLY,
		timeframeAnalyticsAction: "COST_OVERVIEW_COST_BREAKDOWN_TIMEFRAME",
		breakdownCategoryAnalyticsAction: "COST_OVERVIEW_COST_BREAKDOWN"
	}) : /* @__PURE__ */ (0, Q.jsx)(pM, { ...e });
}, gM = async (e) => {
	try {
		return await sf(O.CURRENCY, { defaultCurrency: e }), !0;
	} catch (e) {
		return K(e), !1;
	}
}, _M = ({ variant: e = Hl.DEFAULT, useDefaultValue: t = !1, analyticsAction: n }) => {
	let { searchParams: r } = jf(), i = X(), { currencyData: { isLoading: a, error: o, refetch: s, currencies: c, globalDefaultCurrency: l, defaultCurrency: u }, handleCurrencyChangeForUser: d } = Gj(), [f, p] = j(!1), m = r[zA.CURRENCY], h = () => a ? null : !t && m ? {
		label: m,
		value: m
	} : t ? {
		label: l,
		value: l
	} : u ? {
		label: u,
		value: u
	} : null, g = (c || []).map((e) => ({
		label: e === l ? `${e} (Default)` : e,
		value: e
	})), _ = h();
	return /* @__PURE__ */ (0, Q.jsx)(V, {
		inputId: "cost-visibility-currency-select",
		value: _,
		options: g,
		variant: e,
		onChange: async (e) => {
			if (n && Vd({
				category: "cost-configurations",
				action: n
			}), t) {
				p(!0);
				let t = await gM(e.value);
				p(!1), t && (d(""), s());
				return;
			}
			d(e.value);
			let a = structuredClone(r);
			i({ search: new URLSearchParams({
				...a,
				[zA.CURRENCY]: e.value
			}).toString() });
		},
		isLoading: a || f,
		optionListError: o,
		reloadOptionList: s,
		isClearable: !1
	});
}, vM = () => /* @__PURE__ */ (0, Q.jsxs)("div", {
	className: "enable-cost-visibility-empty-state flex-grow-1 h-100 dc__grid dc__content-center pt-40 px-20 dc__overflow-hidden bg__primary",
	children: [/* @__PURE__ */ (0, Q.jsx)("div", {
		className: "enable-cost-visibility-empty-state__illustration flex",
		children: /* @__PURE__ */ (0, Q.jsx)(gc, {
			name: "no-cluster-cost-enabled",
			imageProps: {
				alt: "",
				role: "presentation",
				width: "100%",
				height: "100%",
				className: "br-8 border__secondary bg__primary dc__blend-luminosity"
			}
		})
	}), /* @__PURE__ */ (0, Q.jsx)("div", {
		className: "enable-cost-visibility-empty-state__content flex dc__zi-1",
		children: /* @__PURE__ */ (0, Q.jsx)("div", {
			className: "w-400 flex",
			children: /* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox-col dc__gap-24 dc__align-items-center",
				children: [
					/* @__PURE__ */ (0, Q.jsx)("div", {
						className: "flex",
						children: /* @__PURE__ */ (0, Q.jsx)("div", {
							className: "br-12 border__primary bg__primary flex",
							children: /* @__PURE__ */ (0, Q.jsx)(z, {
								name: "ic-coins-color-animated",
								color: null,
								size: 64
							})
						})
					}),
					/* @__PURE__ */ (0, Q.jsxs)("div", {
						className: "flexbox-col dc__gap-12 dc__text-center",
						children: [/* @__PURE__ */ (0, Q.jsx)("h3", {
							className: "m-0 cn-9 fs-20 fw-6 lh-1-5",
							children: "Track your Infra Spend"
						}), /* @__PURE__ */ (0, Q.jsx)("p", {
							className: "m-0 cn-8 fs-16 fw-4 lh-1-5",
							children: "Get insights into your infrastructure spending and cost optimization opportunity for this cluster"
						})]
					}),
					/* @__PURE__ */ (0, Q.jsx)(M, {
						dataTestId: "enable-cost-visibility-button",
						component: N.link,
						linkProps: { to: B.COST_VISIBILITY_CONFIGURATIONS },
						text: "Enable Cost Tracking",
						endIcon: /* @__PURE__ */ (0, Q.jsx)(z, {
							name: "ic-arrow-right",
							color: null
						}),
						size: I.xl
					})
				]
			})
		})
	})]
}), yM = () => {
	let { breakdownViewType: e } = Z(), { timeRange: t } = tM(), { searchParams: n } = jf(), r = n[zA.CURRENCY] || "";
	return /* @__PURE__ */ (0, Q.jsx)(Wf, {
		to: vj(Y(B.COST_VISIBILITY_BREAKDOWN.ROUTE, { breakdownViewType: e }), t, r),
		children: /* @__PURE__ */ (0, Q.jsx)(To, {
			isActive: !1,
			heading: Au(e)
		})
	});
}, bM = async (e, t) => {
	switch (e) {
		case L.CLUSTERS: {
			let { result: e } = await Gu(t);
			return (e || []).filter((e) => Xj(e.costModuleConfig)).map((e) => ({
				name: e.cluster_name,
				id: e.id
			})).sort((e, t) => df(e.name, t.name));
		}
		case L.APPLICATIONS: return (await qu() || []).flatMap((e) => e.appList || []).map((e) => ({ name: e.name })).sort((e, t) => df(e.name, t.name));
		case L.ENVIRONMENTS: return (await id() || []).flatMap((e) => e.envList || []).map((e) => ({ name: e.name })).sort((e, t) => df(e.name, t.name));
		case L.PROJECTS: {
			let { result: e } = await Md();
			return (e || []).map((e) => ({ name: e.name })).sort((e, t) => df(e.name, t.name));
		}
		default: return [];
	}
}, xM = () => {
	let { itemName: e, breakdownViewType: t } = Z(), { breakdownDetailsData: n } = Gj(), r = X(), i = Yf(), { data: a, isLoading: o, error: s, refetch: c } = q({
		queryFn: ({ signal: e }) => bM(t, e),
		queryKey: ["breakdownViewItemSelectorOptions", t]
	}), l = A(() => (a || []).map((e) => ({
		label: e.name,
		value: e.name,
		id: e.id
	})).sort((e, t) => df(e.label, t.label)), [a]);
	return k(() => () => {
		n.selectedCluster.handleChange(null);
	}, []), k(() => {
		if (e && a) {
			let t = (a || []).find((t) => t.name === e) || null;
			n.selectedCluster.handleChange(t?.id);
		} else n.selectedCluster.handleChange(null);
	}, [e, a]), /* @__PURE__ */ (0, Q.jsx)(V, {
		inputId: `breakdown-view-${t}-selector`,
		options: l || [],
		value: {
			label: e,
			value: e
		},
		isLoading: o,
		optionListError: s,
		reloadOptionList: c,
		placeholder: `Select ${t}`,
		onChange: (e) => {
			let n = i.pathname.split("/"), a = n.findIndex((e) => e === t);
			a !== -1 && (n[a + 1] = e.value, r({
				pathname: n.join("/"),
				search: i.search
			}));
		},
		variant: Hl.BORDER_LESS,
		size: I.xl
	});
}, SM = [
	{
		key: "overview",
		route: B.COST_VISIBILITY_OVERVIEW,
		heading: "Overview"
	},
	{
		key: "configurations",
		route: B.COST_VISIBILITY_CONFIGURATIONS,
		heading: "Configurations"
	},
	{
		key: "breakdown",
		route: B.COST_VISIBILITY_BREAKDOWN.ROUTE,
		heading: "Cost Breakdown"
	}
], CM = (e, t, n) => {
	let r = e.split("?")[0].split("#")[0], i = { "cost-visibility": {
		component: /* @__PURE__ */ (0, Q.jsx)(M, {
			dataTestId: "redirect-to-overview-btn",
			component: N.link,
			size: I.xs,
			icon: /* @__PURE__ */ (0, Q.jsx)(z, {
				name: "ic-cost-visibility",
				color: null
			}),
			variant: F.borderLess,
			linkProps: { to: vj(B.COST_VISIBILITY_OVERVIEW, t, n) },
			ariaLabel: "Cost Visibility",
			showAriaLabelInTippy: !1
		}),
		linked: !0
	} };
	return SM.forEach(({ key: e, route: a, heading: o }) => {
		let s = !!Jf({ path: a }, r);
		if (e === "breakdown" && !s) {
			i[e] = {
				component: /* @__PURE__ */ (0, Q.jsx)(Wf, {
					to: vj(Y(a, { breakdownViewType: L.CLUSTERS }), t, n),
					children: /* @__PURE__ */ (0, Q.jsx)(To, {
						isActive: s,
						heading: o
					})
				}),
				linked: !1
			};
			return;
		}
		i[e] = {
			component: /* @__PURE__ */ (0, Q.jsx)(To, {
				isActive: s,
				heading: o
			}),
			linked: !s
		};
	}), i[":breakdownViewType"] = Jf({ path: B.COST_VISIBILITY_BREAKDOWN.ROUTE }, r) ? null : {
		component: /* @__PURE__ */ (0, Q.jsx)(yM, {}),
		linked: !1
	}, Object.values(as).forEach((e) => {
		let t = e === as.DETAIL ? `:${e}?` : `:${e}`;
		i[t] = {
			component: null,
			linked: !1
		};
	}), i[`:${as.ITEM_NAME}`] = {
		component: /* @__PURE__ */ (0, Q.jsx)(xM, {}),
		linked: !1
	}, { alias: i };
}, wM = ({ pathPattern: e }) => {
	let { pathname: t } = Yf(), { timeRange: n } = tM(), { searchParams: r } = jf(), i = r[zA.CURRENCY] || "", { breadcrumbs: a } = gf(e, CM(t, n, i), [
		t,
		n,
		i
	]);
	return /* @__PURE__ */ (0, Q.jsx)(Qc, {
		isBreadcrumbs: !0,
		breadCrumbs: () => /* @__PURE__ */ (0, Q.jsx)(Co, {
			breadcrumbs: a,
			path: e
		}),
		tippyProps: {
			isTippyCustomized: !0,
			tippyHeader: "How is cost being calculated?",
			tippyMessage: "Costs are displayed only for clusters with cost module enabled. For multi-cluster projects or applications, data reflects only for the enabled clusters.",
			additionalContent: t === B.COST_VISIBILITY_CONFIGURATIONS ? null : /* @__PURE__ */ (0, Q.jsx)("div", {
				className: "flex left pb-12 px-12",
				children: /* @__PURE__ */ (0, Q.jsx)(M, {
					dataTestId: "go-to-config-page-header-info-tippy",
					component: N.link,
					variant: F.text,
					text: "Go to Configurations",
					endIcon: /* @__PURE__ */ (0, Q.jsx)(z, {
						name: "ic-arrow-right",
						color: null
					}),
					linkProps: { to: B.COST_VISIBILITY_CONFIGURATIONS }
				})
			}),
			tippyRedirectLink: "COST_CALCULATION"
		},
		docPath: gs.COST_BREAKDOWN
	});
}, TM = () => /* @__PURE__ */ (0, Q.jsxs)("div", {
	className: "flexbox-col dc__gap-16",
	children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flex dc__content-space",
		children: [/* @__PURE__ */ (0, Q.jsx)("span", { className: "shimmer h-20 w-40" }), /* @__PURE__ */ (0, Q.jsx)("span", { className: "shimmer h-20 w-40" })]
	}), /* @__PURE__ */ (0, Q.jsx)("div", { className: "shimmer h-8 br-4" })]
}), EM = ({ title: e, value: t, coveragePercent: n, backgroundColor: r = "LimeGreen500" }) => {
	let { appTheme: i } = Nf(), a = Fo[i][r];
	return /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox-col dc__gap-8",
		children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flex dc__content-space",
			children: [/* @__PURE__ */ (0, Q.jsx)("span", {
				className: "fs-13 fw-4 lh-1-5 cn-9",
				children: e
			}), /* @__PURE__ */ (0, Q.jsx)("span", {
				className: "fs-14 lh-1-5 fw-6 cn-9",
				children: t
			})]
		}), /* @__PURE__ */ (0, Q.jsx)("div", {
			className: "h-8 br-4 bcb-1",
			children: /* @__PURE__ */ (0, Q.jsx)("div", {
				className: "h-100 br-4",
				style: {
					width: `${n}%`,
					backgroundColor: a
				}
			})
		})]
	});
}, DM = ({ resourceType: e, resourceName: t, cost: n }) => /* @__PURE__ */ (0, Q.jsxs)("div", {
	className: "flexbox-col px-10 py-6 fs-12 fw-4 lh-18",
	children: [/* @__PURE__ */ (0, Q.jsxs)("span", { children: [
		e === XA.APPLICATIONS ? "App" : "Pipeline",
		": ",
		t
	] }), /* @__PURE__ */ (0, Q.jsxs)("span", { children: ["Cost: ", n] })]
}), OM = () => q({
	queryKey: ["approvalConfig"],
	queryFn: ({ signal: e }) => G(O.APPROVAL_POLICY, { signal: e }),
	select: ({ result: e }) => e
}), kM = ({ resourceType: e, timeWindow: t, currency: n }) => q({
	queryKey: [
		"appOverviewCostBreakdown",
		e,
		t,
		n
	],
	queryFn: ({ signal: r }) => JA({
		payload: {
			currencyCode: n,
			offset: 0,
			size: 10,
			sortBy: "totalCost",
			sortOrder: Jl.DESC,
			timeWindow: t,
			searchByName: ""
		},
		resource: e,
		signal: r
	}),
	select: ({ result: e }) => {
		let t = e?.overallBreakdown?.items?.[0]?.totalCost;
		return t ? (e?.overallBreakdown?.items || []).map((e) => ({
			name: e.name,
			totalCost: Uu(e.totalCost, n, 5),
			formattedCost: Uu(e.totalCost, n),
			percentage: e.totalCost / t * 100
		})) : [];
	},
	enabled: !!n
}), AM = ({ title: e, coveredCount: t, totalCount: n }) => {
	let r = n ? (t / n * 100).toFixed(2) : 0;
	return /* @__PURE__ */ (0, Q.jsx)("div", {
		className: "p-16",
		children: /* @__PURE__ */ (0, Q.jsx)(EM, {
			title: e,
			value: `${r}%`,
			coveragePercent: Number(r)
		})
	});
}, jM = () => {
	let { isFetching: e, data: t, isError: n, refetch: r } = OM(), { totalProdPipelineCount: i, pipelineCountWithConfigApproval: a, pipelineCountWithDeploymentApproval: o } = t ?? {
		totalPipelineCount: 0,
		pipelineCountWithConfigApproval: 0,
		pipelineCountWithDeploymentApproval: 0
	};
	return /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox-col dc__gap-12",
		children: [/* @__PURE__ */ (0, Q.jsx)("h2", {
			className: "m-0 fs-20 lh-1-5 fw-4 cn-9",
			children: "Best Practices"
		}), /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox-col br-8 bg__primary border__secondary",
			children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "py-12 px-16 flexbox-col border__secondary--bottom",
				children: [/* @__PURE__ */ (0, Q.jsx)("span", {
					className: "fs-13 fw-6 lh-20 cn-9",
					children: "Approval Coverage"
				}), /* @__PURE__ */ (0, Q.jsx)("span", { children: "Production pipelines with active approval policies" })]
			}), e ? /* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "dc__grid-half",
				children: [/* @__PURE__ */ (0, Q.jsx)("div", {
					className: "p-16",
					children: /* @__PURE__ */ (0, Q.jsx)(TM, {})
				}), /* @__PURE__ */ (0, Q.jsx)("div", {
					className: "p-16",
					children: /* @__PURE__ */ (0, Q.jsx)(TM, {})
				})]
			}) : n ? /* @__PURE__ */ (0, Q.jsx)(lc, {
				subTitle: "",
				reload: r
			}) : /* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "dc__grid-half",
				children: [/* @__PURE__ */ (0, Q.jsx)(AM, {
					title: "Config change approval",
					totalCount: i,
					coveredCount: a
				}), /* @__PURE__ */ (0, Q.jsx)(AM, {
					title: "Deployment approval",
					totalCount: i,
					coveredCount: o
				})]
			})]
		})]
	});
}, MM = ({ isMetadataFetching: e, resourceType: t, timeWindow: n, currency: r }) => {
	let { isFetching: i, isError: a, data: o, refetch: s } = kM({
		resourceType: t,
		timeWindow: n,
		currency: r
	}), c = t === XA.APPLICATIONS ? "applications" : "build pipelines";
	return /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox-col bg__primary border__secondary br-8",
		children: [/* @__PURE__ */ (0, Q.jsx)("div", {
			className: "px-16 py-12 border__secondary--bottom",
			children: /* @__PURE__ */ (0, Q.jsxs)("span", {
				className: "fs-14 fw-6 lh-1-5 cn-9",
				children: ["Top 10 costly\xA0", t === XA.APPLICATIONS ? "applications" : "build pipelines"]
			})
		}), /* @__PURE__ */ (0, Q.jsx)("div", {
			className: "flexbox-col dc__gap-12 px-16 pt-12 pb-16",
			children: i || e ? Array.from({ length: 5 }).map((e, t) => /* @__PURE__ */ (0, Q.jsx)(TM, {}, t)) : a ? /* @__PURE__ */ (0, Q.jsx)(lc, {
				subTitle: "",
				reload: s
			}) : !o || o.length === 0 ? /* @__PURE__ */ (0, Q.jsx)(Ll, {
				iconName: "ic-info-outline",
				title: `No ${c} cost data available`,
				subtitle: `${Au(c)} costs are not available for the selected duration`
			}) : o.map((e, n) => /* @__PURE__ */ (0, Q.jsx)(W, {
				content: /* @__PURE__ */ (0, Q.jsx)(DM, {
					resourceType: t,
					resourceName: e.name,
					cost: e.totalCost
				}),
				alwaysShowTippyOnHover: !0,
				followCursor: !0,
				children: /* @__PURE__ */ (0, Q.jsx)("div", { children: /* @__PURE__ */ (0, Q.jsx)(EM, {
					title: e.name,
					value: e.formattedCost,
					coveragePercent: e.percentage,
					backgroundColor: "SkyBlue400"
				}) })
			}, `${n}-${e.name}`))
		})]
	});
}, NM = () => {
	let { isCostVisibilityEnabled: e, isLoadingMetadata: t, currencyData: n } = Gj(), [r, i] = j(RA.LAST_30_DAYS), a = (e) => {
		i(e.value);
	}, o = n?.defaultCurrency;
	return /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox-col dc__gap-12",
		children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flex dc__content-space",
			children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flex dc__gap-8",
				children: [/* @__PURE__ */ (0, Q.jsx)("h2", {
					className: "m-0 fs-20 lh-1-5 fw-4 cn-9",
					children: "Cost Visibility"
				}), e && /* @__PURE__ */ (0, Q.jsx)(Cc, {
					heading: "How costs are calculated?",
					infoText: "Costs are displayed only for clusters with cost module enabled. For multi-cluster projects or applications, data reflects only for the enabled clusters.",
					additionalContent: /* @__PURE__ */ (0, Q.jsx)("div", {
						className: "flex left pb-12 px-12",
						children: /* @__PURE__ */ (0, Q.jsx)(M, {
							dataTestId: "go-to-config-page-header-info-tippy",
							component: N.link,
							variant: F.text,
							text: "Go to Configurations",
							endIcon: /* @__PURE__ */ (0, Q.jsx)(z, {
								name: "ic-arrow-right",
								color: null
							}),
							linkProps: { to: B.COST_VISIBILITY_CONFIGURATIONS }
						})
					}),
					buttonPadding: "p-6"
				})]
			}), e && /* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flex dc__gap-12",
				children: [
					/* @__PURE__ */ (0, Q.jsx)(V, {
						inputId: "select-cost-time-range",
						options: oM,
						onChange: a,
						shouldMenuAlignRight: !0,
						variant: Hl.COMPACT,
						value: Dd(oM, r)
					}),
					/* @__PURE__ */ (0, Q.jsx)("div", { className: "dc__divider" }),
					/* @__PURE__ */ (0, Q.jsx)(M, {
						dataTestId: "cost-visibility-details",
						text: "Details",
						size: I.medium,
						variant: F.text,
						component: N.link,
						linkProps: { to: B.COST_VISIBILITY_OVERVIEW },
						endIcon: /* @__PURE__ */ (0, Q.jsx)(z, {
							name: "ic-caret-right",
							color: null
						})
					})
				]
			})]
		}), t || e ? /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "dc__grid-half dc__gap-8",
			children: [/* @__PURE__ */ (0, Q.jsx)(MM, {
				timeWindow: r,
				resourceType: XA.APPLICATIONS,
				isMetadataFetching: t,
				currency: o
			}), /* @__PURE__ */ (0, Q.jsx)(MM, {
				timeWindow: r,
				resourceType: XA.CI_PIPELINES,
				isMetadataFetching: t,
				currency: o
			})]
		}) : /* @__PURE__ */ (0, Q.jsx)("div", {
			className: "border__secondary bg__primary br-8 flex column dc__gap-12 h-200",
			children: /* @__PURE__ */ (0, Q.jsx)(Ll, {
				iconName: "ic-cost-visibility",
				title: "Cost visibility is not enabled",
				subtitle: "Get insights into your infrastructure spending and cost optimization opportunities",
				buttonConfig: {
					dataTestId: "redirect-to-cost-visibility",
					text: "Go to configurations",
					endIcon: /* @__PURE__ */ (0, Q.jsx)(z, {
						name: "ic-arrow-right",
						color: null
					}),
					size: I.small,
					variant: F.borderLess,
					component: N.link,
					linkProps: { to: B.COST_VISIBILITY_CONFIGURATIONS }
				}
			})
		})]
	});
}, PM = () => /* @__PURE__ */ (0, Q.jsx)(eM, { children: /* @__PURE__ */ (0, Q.jsx)(NM, {}) }), FM = vo.APPLICATION_MANAGEMENT.POLICIES, IM = [
	{
		title: "Deployment Window",
		dataTestId: "click-on-policies-deployment-window",
		id: "application-management-policies-deployment-window",
		href: FM.DEPLOYMENT_WINDOW.ROOT
	},
	{
		title: "Approval Policy",
		dataTestId: "click-on-policies-approval-policy",
		id: "application-management-policies-approval-policy",
		href: FM.APPROVAL_POLICY.ROOT
	},
	{
		title: "Plugin Policy",
		dataTestId: "click-on-policies-plugin-policy",
		id: "application-management-policies-plugin-policy",
		href: FM.PLUGIN_POLICY.ROOT
	},
	{
		title: "Pull Image Digest",
		dataTestId: "click-on-policies-pull-image-digest",
		id: "application-management-policies-pull-image-digest",
		href: FM.PULL_IMAGE_DIGEST
	},
	{
		title: "Tag Policy",
		dataTestId: "click-on-policies-tag-policy",
		id: "application-management-policies-tag-policy",
		href: FM.TAG_POLICY.ROOT
	},
	{
		title: "Filter Conditions",
		dataTestId: "click-on-policies-filter-conditions",
		id: "application-management-policies-filter-conditions",
		href: FM.FILTER_CONDITIONS.ROOT
	},
	...window._env_?.FEATURE_IMAGE_PROMOTION_ENABLE ? [{
		title: "Image Promotion",
		dataTestId: "click-on-policies-image-promotion",
		id: "application-management-policies-image-promotion",
		href: FM.IMAGE_PROMOTION.ROOT
	}] : [],
	{
		title: "Lock Deployment Configuration",
		dataTestId: "click-on-policies-lock-deployment-configuration",
		id: "application-management-policies-lock-deployment-configuration",
		href: FM.LOCK_DEPLOYMENT_CONFIGURATION.ROOT
	}
], LM = vo.APPLICATION_MANAGEMENT.POLICIES, RM = ({ OfflinePipelineModalAppView: e }) => {
	let { isSuperAdmin: t, serverMode: n } = Tf(), { pathname: r } = Yf(), { breadcrumbs: i } = gf(B.APPLICATION_MANAGEMENT_POLICIES.ROOT, { alias: {
		...Ju(),
		policies: { component: /* @__PURE__ */ (0, Q.jsx)(To, {
			heading: "Policies",
			isActive: !0
		}) }
	} }, [r]);
	return n !== Ml.EA_ONLY && /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsx)(Qc, {
		isBreadcrumbs: !0,
		breadCrumbs: () => /* @__PURE__ */ (0, Q.jsx)(Co, {
			breadcrumbs: i,
			path: B.APPLICATION_MANAGEMENT_POLICIES.ROOT
		}),
		docPath: gs.APP_MANAGEMENT
	}), /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "application-management-policies dc__grid flex-grow-1 dc__overflow-auto",
		children: [/* @__PURE__ */ (0, Q.jsx)("div", {
			className: "py-12 pl-8 pr-7 border__primary--right",
			children: /* @__PURE__ */ (0, Q.jsx)(Gl, { list: IM })
		}), /* @__PURE__ */ (0, Q.jsx)("div", {
			className: "bg__secondary dc__overflow-auto",
			children: /* @__PURE__ */ (0, Q.jsxs)(qf, { children: [
				/* @__PURE__ */ (0, Q.jsx)(J, {
					path: `${LM.DEPLOYMENT_WINDOW.ROOT}/*`,
					element: /* @__PURE__ */ (0, Q.jsx)(a, { isSuperAdmin: t })
				}, LM.DEPLOYMENT_WINDOW.ROOT),
				/* @__PURE__ */ (0, Q.jsx)(J, {
					path: `${LM.APPROVAL_POLICY.ROOT}/*`,
					element: /* @__PURE__ */ (0, Q.jsx)(Ce, {})
				}, LM.APPROVAL_POLICY.ROOT),
				window._env_.FEATURE_IMAGE_PROMOTION_ENABLE && /* @__PURE__ */ (0, Q.jsx)(J, {
					path: `${LM.IMAGE_PROMOTION.ROOT}/*`,
					element: /* @__PURE__ */ (0, Q.jsx)(kt, {})
				}, LM.IMAGE_PROMOTION.ROOT),
				/* @__PURE__ */ (0, Q.jsx)(J, {
					path: `${LM.PLUGIN_POLICY.ROOT}/*`,
					element: /* @__PURE__ */ (0, Q.jsx)(Yt, { OfflinePipelineModalAppView: e })
				}),
				/* @__PURE__ */ (0, Q.jsx)(J, {
					path: LM.PULL_IMAGE_DIGEST,
					element: /* @__PURE__ */ (0, Q.jsx)(fk, { isSuperAdmin: t })
				}),
				/* @__PURE__ */ (0, Q.jsx)(J, {
					path: `${LM.TAG_POLICY.ROOT}/*`,
					element: /* @__PURE__ */ (0, Q.jsx)(LA, {})
				}),
				/* @__PURE__ */ (0, Q.jsx)(J, {
					path: `${LM.FILTER_CONDITIONS.ROOT}/*`,
					element: /* @__PURE__ */ (0, Q.jsx)(vO, { isSuperAdmin: t })
				}),
				/* @__PURE__ */ (0, Q.jsx)(J, {
					path: `${LM.LOCK_DEPLOYMENT_CONFIGURATION.ROOT}/*`,
					element: /* @__PURE__ */ (0, Q.jsx)(Pn, {})
				}),
				/* @__PURE__ */ (0, Q.jsx)(J, {
					path: "*",
					element: /* @__PURE__ */ (0, Q.jsx)(Kf, { to: vo.APPLICATION_MANAGEMENT.POLICIES.DEPLOYMENT_WINDOW.ROOT })
				})
			] })
		})]
	})] });
}, zM = /* @__PURE__ */ function(e) {
	return e.TYPE = "actionType", e.MODULE = "module", e;
}({}), BM = /* @__PURE__ */ function(e) {
	return e.FROM = "from", e.TO = "to", e;
}({}), VM = ({ row: e }) => /* @__PURE__ */ (0, Q.jsx)("div", {
	className: "flex left py-12",
	children: /* @__PURE__ */ (0, Q.jsx)("span", {
		className: "fs-13 fw-4 cn-9 lh-20",
		children: e.data.formattedTimeStamp
	})
}), HM = ({ row: e }) => {
	let t = `${Au(e.data.action)}`;
	return /* @__PURE__ */ (0, Q.jsx)("div", {
		className: "flex left py-12",
		children: /* @__PURE__ */ (0, Q.jsx)(W, {
			content: t,
			children: /* @__PURE__ */ (0, Q.jsx)("span", {
				className: "dc__link fs-13 lh-20 dc__truncate",
				children: t
			})
		})
	});
}, UM = ({ row: e }) => /* @__PURE__ */ (0, Q.jsx)(gu, { identifier: e.data.user }), WM = ({ row: e }) => /* @__PURE__ */ (0, Q.jsx)("div", {
	className: "flex left py-12",
	children: /* @__PURE__ */ (0, Q.jsx)("span", {
		className: "flex dc__gap-6 fs-13 fw-4 cn-9 lh-20",
		children: Au(e.data.module)
	})
}), GM = ({ row: e }) => /* @__PURE__ */ (0, Q.jsx)("div", {
	className: "flex left py-12",
	children: /* @__PURE__ */ (0, Q.jsx)("span", {
		className: "flex dc__gap-6 fs-13 fw-4 cn-9 lh-20",
		children: Au(e.data.actionType)
	})
}), KM = ({ row: e }) => /* @__PURE__ */ (0, Q.jsx)("div", {
	className: "flexbox-col left py-12",
	children: (e.data.resourceNames ?? []).slice(0, 2).map((e, t) => /* @__PURE__ */ (0, Q.jsx)("span", {
		className: "flex left fs-13 fw-4 cn-9 lh-20 dc__truncate",
		children: e
	}, `${e}-${t}`))
}), qM = () => [
	{
		field: "timeStamp",
		label: "Timestamp",
		size: { fixed: 220 },
		isSortable: !0,
		CellComponent: VM
	},
	{
		field: "action",
		label: "Action",
		size: null,
		isSortable: !0,
		CellComponent: HM
	},
	{
		field: "actionType",
		label: "Type",
		size: { fixed: 130 },
		isSortable: !0,
		CellComponent: GM
	},
	{
		field: "user",
		label: "User",
		size: { fixed: 180 },
		isSortable: !0,
		CellComponent: UM
	},
	{
		field: "resourceType",
		label: "Resource Type",
		size: { fixed: 180 },
		isSortable: !0
	},
	{
		field: "resourceNames",
		label: "Resource Name",
		size: { fixed: 200 },
		CellComponent: KM
	},
	{
		field: "module",
		label: "Module",
		size: { fixed: 190 },
		isSortable: !0,
		CellComponent: WM
	}
], JM = 15, YM = () => ({
	from: (0, Op.default)().subtract(JM, "day").startOf("day").toDate(),
	to: (0, Op.default)().endOf("day").toDate()
}), XM = (e) => {
	let t = YM();
	return {
		[zM.TYPE]: e.getAll(zM.TYPE),
		[zM.MODULE]: e.getAll(zM.MODULE),
		[BM.FROM]: e.get(BM.FROM) ?? t.from.toISOString(),
		[BM.TO]: e.get(BM.TO) ?? t.to.toISOString()
	};
}, ZM = [
	{
		label: "Timestamp",
		key: "timestamp"
	},
	{
		label: "Action",
		key: "action"
	},
	{
		label: "Type",
		key: "actionType"
	},
	{
		label: "User",
		key: "user"
	},
	{
		label: "Resource Type",
		key: "resourceType"
	},
	{
		label: "Resource Name",
		key: "resourceNames"
	},
	{
		label: "Module",
		key: "module"
	}
], QM = (e) => {
	switch (e) {
		case zM.TYPE: return "Type";
		case zM.MODULE: return "Module";
		default: return e;
	}
}, $M = (e) => ({
	label: `Last ${e} month${e > 1 ? "s" : ""}`,
	value: {
		from: (0, Op.default)().subtract(e, "month").toDate(),
		to: (0, Op.default)().toDate()
	}
}), eN = () => [{
	label: "Last 15 days",
	value: {
		from: (0, Op.default)().subtract(15, "day").toDate(),
		to: (0, Op.default)().toDate()
	}
}, ...[
	1,
	2,
	3,
	4,
	5,
	6
].map((e) => $M(e))], tN = 10, nN = (e, t = 0) => {
	if (t >= tN) return e;
	if (typeof e == "string") {
		let n = e.trim();
		if (!n || !["{", "["].includes(n[0])) return e;
		try {
			return nN(JSON.parse(n), t + 1);
		} catch {
			return e;
		}
	}
	return Array.isArray(e) ? e.map((e) => nN(e, t + 1)) : e && typeof e == "object" ? Object.fromEntries(Object.entries(e).map(([e, n]) => [e, nN(n, t + 1)])) : e;
}, rN = [{
	label: "JSON",
	value: Ic.JSON
}, {
	label: "YAML",
	value: Ic.YAML
}], iN = (e) => {
	if (!e) return null;
	if (typeof e != "string") return nN(e);
	try {
		return nN(JSON.parse(e));
	} catch {
		return null;
	}
}, aN = (e) => e ? typeof e == "string" ? e : JSON.stringify(e, null, 2) : "", oN = (e, t, n) => e === null ? t : n === Ic.YAML ? Tu(e) : JSON.stringify(e, null, 2), sN = ({ auditLog: e, onClose: t }) => {
	let [n, r] = j(Ic.JSON), i = e.jsonFormatLog || e.payload, a = aN(i), o = iN(i), s = oN(o, a, n);
	return /* @__PURE__ */ (0, Q.jsx)(Rs, {
		position: "right",
		width: "800px",
		onClose: t,
		onEscape: t,
		children: /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox-col h-100 bg__primary fs-13 cn-9",
			onClick: uf,
			children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flex dc__content-space px-20 py-12 dc__border-bottom",
				children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "flex left dc__gap-8",
					children: [/* @__PURE__ */ (0, Q.jsx)(z, {
						name: "ic-file-log-search",
						color: "B500",
						size: 20
					}), /* @__PURE__ */ (0, Q.jsx)("h2", {
						className: "m-0 fs-16 fw-6 cn-9 lh-1-5 dc__truncate",
						children: "Audit Details"
					})]
				}), /* @__PURE__ */ (0, Q.jsx)(M, {
					dataTestId: "audit-log-detail-close",
					ariaLabel: "Close",
					icon: /* @__PURE__ */ (0, Q.jsx)(z, {
						name: "ic-close-large",
						color: null
					}),
					onClick: t,
					variant: F.borderLess,
					style: P.negativeGrey,
					size: I.xs,
					showAriaLabelInTippy: !1
				})]
			}), /* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "p-20 flexbox-col dc__gap-16 flex-grow-1 dc__overflow-hidden",
				children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "dc__grid dc__gap-12 en-2 bw-1 br-8 p-16",
					children: [/* @__PURE__ */ (0, Q.jsx)("h3", {
						className: "m-0 fw-6 cn-9 lh-20 dc__border-bottom-n1 pb-16",
						children: e.action
					}), /* @__PURE__ */ (0, Q.jsxs)("div", { children: [
						/* @__PURE__ */ (0, Q.jsxs)("div", {
							className: "audit-logs__grid dc__grid dc__gap-16",
							children: [/* @__PURE__ */ (0, Q.jsx)("p", {
								className: "m-0 lh-20",
								children: "Timestamp"
							}), /* @__PURE__ */ (0, Q.jsx)("p", {
								className: "m-0 cn-9 lh-20",
								children: e.formattedTimeStamp
							})]
						}),
						/* @__PURE__ */ (0, Q.jsxs)("div", {
							className: "audit-logs__grid dc__grid dc__gap-16",
							children: [/* @__PURE__ */ (0, Q.jsx)("p", {
								className: "m-0 lh-20",
								children: "Type"
							}), /* @__PURE__ */ (0, Q.jsx)("p", {
								className: "m-0 lh-20",
								children: e.actionType || "-"
							})]
						}),
						/* @__PURE__ */ (0, Q.jsxs)("div", {
							className: "audit-logs__grid dc__grid dc__gap-16",
							children: [/* @__PURE__ */ (0, Q.jsx)("p", {
								className: "m-0 lh-20",
								children: "Module"
							}), /* @__PURE__ */ (0, Q.jsx)("p", {
								className: "m-0 lh-20",
								children: e.module || "-"
							})]
						}),
						/* @__PURE__ */ (0, Q.jsxs)("div", {
							className: "audit-logs__grid dc__grid dc__gap-16",
							children: [/* @__PURE__ */ (0, Q.jsx)("p", {
								className: "m-0 lh-20",
								children: "User"
							}), /* @__PURE__ */ (0, Q.jsx)("p", {
								className: "m-0 lh-20",
								children: e.user || "-"
							})]
						}),
						/* @__PURE__ */ (0, Q.jsxs)("div", {
							className: "audit-logs__grid dc__grid dc__gap-16",
							children: [/* @__PURE__ */ (0, Q.jsx)("p", {
								className: "m-0 lh-20",
								children: "Resource Name"
							}), /* @__PURE__ */ (0, Q.jsx)("p", {
								className: "m-0 lh-20 dc__word-break",
								children: (e.resourceNames ?? []).join(" · ") || "-"
							})]
						}),
						/* @__PURE__ */ (0, Q.jsxs)("div", {
							className: "audit-logs__grid dc__grid dc__gap-16",
							children: [/* @__PURE__ */ (0, Q.jsx)("p", {
								className: "m-0 lh-20",
								children: "Resource Type"
							}), /* @__PURE__ */ (0, Q.jsx)("p", {
								className: "m-0 lh-20",
								children: e.resourceType || "-"
							})]
						})
					] })]
				}), /* @__PURE__ */ (0, Q.jsx)(Xo.Container, {
					flexExpand: !0,
					children: /* @__PURE__ */ (0, Q.jsx)(Xo, {
						readOnly: !0,
						mode: o === null ? Ic.JSON : n,
						noParsing: !0,
						value: s,
						height: "fitToParent",
						children: /* @__PURE__ */ (0, Q.jsx)(Xo.Header, {
							className: "px-16 py-12 dc__border-bottom bg__secondary",
							children: /* @__PURE__ */ (0, Q.jsxs)("div", {
								className: "flex dc__content-space w-100",
								children: [/* @__PURE__ */ (0, Q.jsx)("h3", {
									className: "m-0 fw-6 cn-9 lh-20",
									children: "Payload"
								}), o !== null && /* @__PURE__ */ (0, Q.jsx)(Bl, {
									name: "audit-log-payload-mode",
									segments: rN,
									value: n,
									onChange: (e) => {
										r(e.value);
									},
									size: I.xs
								})]
							})
						})
					}, `${e.id}-${n}`)
				})]
			})]
		})
	});
}, cN = async (e, t) => {
	let { offset: n = 0, pageSize: r, searchKey: i, sortBy: a, sortOrder: o, actionType: s, module: c, from: l, to: u } = e ?? {}, { result: d } = await G(Rd(O.AUDIT_LOG, {
		offset: n,
		size: r,
		searchKey: i,
		sortBy: a,
		sortOrder: o,
		actionType: s,
		module: c,
		from: l,
		to: u
	}), {
		signal: t,
		isProxyHost: !0
	});
	return d?.auditLogs;
}, lN = async (e, t, n) => ((await cN({
	...e,
	offset: 0,
	pageSize: t || 1
}, n)).data ?? []).map((e) => ({
	timestamp: e.timeStamp ? (0, Op.default)(e.timeStamp).format(ss.TWELVE_HOURS_FORMAT_WITH_SECONDS) : "-",
	action: e.action ?? "-",
	actionType: e.actionType ?? "-",
	user: e.user ?? "-",
	resourceType: e.resourceType ?? "-",
	resourceNames: (e.resourceNames ?? []).join(", ") || "-",
	module: e.module ?? "-"
})), uN = async ({ offset: e, pageSize: t, searchKey: n, sortBy: r, sortOrder: i, actionType: a = [], module: o = [], from: s, to: c }, l) => {
	let u = await cN({
		offset: e,
		pageSize: t,
		searchKey: n,
		sortBy: r,
		sortOrder: i,
		actionType: a,
		module: o,
		from: s,
		to: c
	}, l);
	return {
		rows: u.data.map((t, n) => ({
			id: `${t.id}-${e + n}`,
			data: {
				...t,
				formattedTimeStamp: t.timeStamp ? (0, Op.default)(t.timeStamp).format(ss.TWELVE_HOURS_FORMAT_WITH_SECONDS) : "-"
			}
		})),
		totalRows: u.totalCount
	};
}, dN = ({ children: e, searchKey: t, handleSearch: n, updateSearchParams: r, clearFilters: i, areRowsLoading: a, filteredRows: o, areFiltersApplied: s, lastSyncTimestamp: c, onSyncNow: l, totalRows: u, ...d }) => {
	let f = !a && o?.length === 0 && !s, [p, m] = j(() => Ud(c, !0)), h = Ja(null), [g, _] = j(() => {
		let e = d[BM.FROM], t = d[BM.TO];
		return e && t ? {
			from: new Date(e),
			to: new Date(t)
		} : YM();
	}), { isFetching: v, data: y, error: b, refetch: x } = q({
		queryKey: ["audit-log-filters"],
		queryFn: ({ signal: e }) => G(O.AUDIT_LOG_FILTERS, {
			signal: e,
			isProxyHost: !0
		}),
		select: (e) => ({
			[zM.TYPE]: (e.result?.actionTypes ?? []).map((e) => ({
				label: e,
				value: e
			})),
			[zM.MODULE]: (e.result?.moduleTypes ?? []).map((e) => ({
				label: e,
				value: e
			}))
		})
	});
	k(() => (m(Ud(c, !0)), h.current = setInterval(() => {
		m(Ud(c, !0));
	}, 6e4), () => {
		h.current && clearInterval(h.current);
	}), [c]);
	let S = ({ from: e, to: t }) => {
		let n = (0, Op.default)(e).startOf("day").toDate(), i = (0, Op.default)(t ?? e).endOf("day").toDate();
		_({
			from: n,
			to: i
		}), r({
			[BM.FROM]: n.toISOString(),
			[BM.TO]: i.toISOString()
		});
	}, C = (e) => (0, Op.default)(e).isAfter((0, Op.default)(), "day"), w = {
		[zM.TYPE]: d[zM.TYPE] ?? [],
		[zM.MODULE]: d[zM.MODULE] ?? []
	}, T = (e) => (t) => {
		r({ [e]: t.map((e) => String(e.value)) });
	}, ee = {
		[zM.TYPE]: {
			placeholder: "Type",
			inputId: "audit-logs-type-filter",
			options: y?.[zM.TYPE] ?? [],
			appliedFilterOptions: (y?.[zM.TYPE] ?? []).filter((e) => w[zM.TYPE].includes(String(e.value))),
			handleApplyFilter: T(zM.TYPE),
			isDisabled: !1,
			isLoading: v,
			optionListError: b,
			reloadOptionList: x
		},
		[zM.MODULE]: {
			placeholder: "Module",
			inputId: "audit-logs-module-filter",
			options: y?.[zM.MODULE] ?? [],
			appliedFilterOptions: (y?.[zM.MODULE] ?? []).filter((e) => w[zM.MODULE].includes(String(e.value))),
			handleApplyFilter: T(zM.MODULE),
			isDisabled: !1,
			isLoading: v,
			optionListError: b,
			reloadOptionList: x
		}
	};
	return /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "h-100 dc__overflow-hidden w-100 flexbox-col",
		children: [
			/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox dc__align-items-center p-16 w-100 dc__content-space dc__zi-5",
				children: [/* @__PURE__ */ (0, Q.jsx)("div", {
					className: "flexbox dc__gap-8 dc__align-items-center",
					children: !f && /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsx)(Il, {
						dataTestId: "audit-logs-search",
						handleEnter: n,
						initialSearchText: t,
						inputProps: { placeholder: "Search" },
						keyboardShortcut: "/"
					}), /* @__PURE__ */ (0, Q.jsx)(pc, {
						id: "audit-log-filters",
						width: 220,
						isFilterApplied: !!w[zM.TYPE].length || !!w[zM.MODULE].length,
						options: [{
							groupLabel: "Filter by",
							items: [{
								id: zM.TYPE,
								label: "Type"
							}, {
								id: zM.MODULE,
								label: "Module"
							}]
						}],
						filterSelectPickerPropsMap: ee
					})] })
				}), /* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "display flex dc__gap-12",
					children: [
						/* @__PURE__ */ (0, Q.jsx)(M, {
							dataTestId: "sync-audit-list",
							startIcon: /* @__PURE__ */ (0, Q.jsx)(z, {
								name: "ic-arrow-clockwise",
								color: null
							}),
							text: p,
							variant: F.borderLess,
							style: P.neutral,
							onClick: l,
							size: I.medium,
							disabled: a
						}),
						/* @__PURE__ */ (0, Q.jsx)(Ys, {
							headers: ZM,
							apiPromise: ({ signal: e }) => lN({
								searchKey: t,
								sortBy: d.sortBy,
								sortOrder: d.sortOrder,
								actionType: w[zM.TYPE],
								module: w[zM.MODULE],
								[BM.FROM]: d[BM.FROM],
								[BM.TO]: d[BM.TO]
							}, u, e),
							fileName: "Audit Logs",
							disabled: a || !o?.length
						}),
						/* @__PURE__ */ (0, Q.jsx)(xs, {
							id: "audit-logs-date-range-picker",
							hideTimeSelect: !0,
							isRangePicker: !0,
							dateRange: g,
							onChange: S,
							rangeShortcutOptions: eN(),
							blockPreviousDates: !1,
							isOutsideRange: C
						})
					]
				})]
			}),
			!f && /* @__PURE__ */ (0, Q.jsx)(Zs, {
				filterConfig: w,
				onRemoveFilter: r,
				clearFilters: i,
				className: "px-20",
				getFormattedLabel: QM,
				getFormattedValue: (e, t) => t
			}),
			e
		]
	});
}, fN = () => {
	let e = A(() => qM(), []), [t, n] = j(null), [r, i] = j(!1), [a, o] = j(Date()), s = X(), c = `${B.AUDIT_LOGS}?sortBy=timeStamp&sortOrder=DESC`, { breadcrumbs: l } = gf(B.AUDIT_LOGS, { alias: { "audit-logs": {
		component: /* @__PURE__ */ (0, Q.jsx)("span", {
			className: "fs-16 fw-6 cn-9 lh-1-5",
			children: "Audit Logs"
		}),
		linked: !1
	} } }), u = Ka((e) => {
		n(e);
	}, []), d = Ka(() => {
		n(null);
	}, []), f = Ka((e) => u(e.data), [u]), p = Ka((e, t) => uN(e, t), [r]), m = Ka(() => {
		i((e) => !e), o(Date());
	}, []), h = () => s(c);
	return /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox-col flex-grow-1 dc__overflow-hidden bg__primary",
		children: [
			/* @__PURE__ */ (0, Q.jsx)(Qc, {
				breadCrumbs: () => /* @__PURE__ */ (0, Q.jsx)(Co, {
					breadcrumbs: l,
					path: c
				}),
				isBreadcrumbs: !0
			}),
			/* @__PURE__ */ (0, Q.jsx)(ru, {
				id: "table__audit-logs",
				columns: e,
				ViewWrapper: dN,
				filtersVariant: tc.URL,
				additionalFilterProps: {
					initialSortKey: "timeStamp",
					parseSearchParams: XM
				},
				paginationVariant: el.PAGINATED,
				getRows: p,
				filter: null,
				onRowClick: f,
				clearFilters: h,
				emptyStateConfig: {
					noRowsConfig: {
						title: "No audit logs found",
						subTitle: "Audit trail entries will show up here once actions are performed."
					},
					noRowsForFilterConfig: {
						title: "No audit logs found",
						subTitle: "Try adjusting your search or filters",
						clearFilters: h
					}
				},
				additionalProps: {
					onSelectAuditLog: u,
					onSyncNow: m,
					lastSyncTimestamp: a
				}
			}),
			t && /* @__PURE__ */ (0, Q.jsx)(sN, {
				auditLog: t,
				onClose: d
			})
		]
	});
}, pN = () => {
	let { isSuperAdmin: e } = Tf();
	return /* @__PURE__ */ (0, Q.jsx)(qf, { children: /* @__PURE__ */ (0, Q.jsx)(J, {
		index: !0,
		element: e ? /* @__PURE__ */ (0, Q.jsx)(fN, {}) : /* @__PURE__ */ (0, Q.jsx)(qs, {})
	}) });
}, mN = Ua(null), hN = ({ children: e, renderClusterForm: t }) => /* @__PURE__ */ (0, Q.jsx)(mN, {
	value: A(() => ({ renderClusterForm: t }), [t]),
	children: e
}), gN = () => {
	let e = qa(mN);
	if (!e) throw Error("CostVisibilityRenderContext cannot be used outside CostVisibilityRender scope");
	return e;
}, _N = ({ children: e, pathPattern: t }) => /* @__PURE__ */ (0, Q.jsxs)("div", {
	className: "flexbox-col dc__content-space dc__overflow-auto bg__primary flex-grow-1 w-100",
	children: [/* @__PURE__ */ (0, Q.jsx)(wM, { pathPattern: t }), e]
}), vN = ({ row: e, signals: t }) => {
	let { timeRange: n } = tM(), { searchParams: r } = jf(), i = r[zA.CURRENCY] || "", { name: a } = e.data[aj[e.data.variant]], { itemName: o, breakdownViewType: s } = Z(), c = !!o, l = Ja(null), u = e.data.variant !== UA.K8S_RESOURCE;
	return k(() => {
		let n = ({ detail: { activeRowData: t } }) => {
			u && t.id === e.id && l.current?.click();
		};
		return t.addEventListener(iu.ENTER_PRESSED, n), () => {
			t.removeEventListener(iu.ENTER_PRESSED, n);
		};
	}, []), u ? /* @__PURE__ */ (0, Q.jsx)(Wf, {
		to: vj(Y(B.COST_VISIBILITY_BREAKDOWN_DETAIL, {
			breakdownViewType: oj[e.data.variant],
			itemName: a,
			view: BA.OVERVIEW,
			detail: null
		}), n, i),
		className: "dc__link dc__truncate",
		ref: l,
		onClick: () => {
			c && Vd({
				category: "cost-breakdown-item",
				action: `COST_BREAKDOWN_BY_${s.toUpperCase()}_LIST_ITEM`
			});
		},
		children: a
	}) : /* @__PURE__ */ (0, Q.jsx)("span", {
		className: "cn-9 fs-13 fw-4 lh-20 dc__truncate",
		children: a
	});
}, yN = ({ row: e }) => e.data.variant !== UA.CLUSTER && e.data.variant !== UA.ENVIRONMENT ? null : /* @__PURE__ */ (0, Q.jsx)(So, {
	label: e.data[aj[e.data.variant]].type,
	size: I.xxs
}), bN = () => /* @__PURE__ */ (0, Q.jsx)(z, {
	name: "ic-bg-cluster",
	color: null,
	size: 24
}), xN = () => /* @__PURE__ */ (0, Q.jsx)(z, {
	name: "ic-bg-environment",
	color: null,
	size: 24
}), SN = () => /* @__PURE__ */ (0, Q.jsx)(z, {
	name: "ic-folder-color",
	color: null,
	size: 24
}), CN = () => /* @__PURE__ */ (0, Q.jsx)(z, {
	name: "ic-devtron-app",
	color: null,
	size: 24
}), wN = ({ row: e }) => /* @__PURE__ */ (0, Q.jsxs)("span", { children: [
	e.data.appDetails.envCount || 0,
	" ",
	e.data.appDetails.envCount === 1 ? "Environment" : "Environments"
] }), TN = ({ row: e }) => {
	if (e.data.variant !== UA.ENVIRONMENT && e.data.variant !== UA.PROJECT) return null;
	let t = e.data[aj[e.data.variant]].appCount || 0;
	return /* @__PURE__ */ (0, Q.jsxs)("span", {
		className: "cn-9 fs-13 fw-4 lh-20",
		children: [
			t,
			" ",
			t === 1 ? "Application" : "Applications"
		]
	});
}, EN = ({ row: e }) => {
	if (e.data.variant !== UA.CLUSTER) return null;
	let t = e.data.clusterDetails.clusterProvider, n = Lo[t];
	return /* @__PURE__ */ (0, Q.jsx)(So, {
		startIconProps: n ? { name: n } : null,
		label: Ro[t] || t,
		variant: "neutral",
		size: I.xxs
	});
}, DN = ({ row: e }) => e.data.variant === UA.K8S_RESOURCE ? /* @__PURE__ */ (0, Q.jsx)("span", {
	className: "cn-9 fs-13 fw-4 lh-20 dc__truncate",
	children: e.data.resourceDetails.kind || "--"
}) : null, ON = ({ row: e }) => e.data.variant === UA.K8S_RESOURCE ? /* @__PURE__ */ (0, Q.jsx)("span", {
	className: "cn-9 fs-13 fw-4 lh-20 dc__truncate",
	children: e.data.resourceDetails.namespace || "--"
}) : null, kN = (e, t) => /* @__PURE__ */ (0, Q.jsxs)("div", {
	className: "flexbox-col dc__gap-2",
	children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox dc__gap-2",
		children: [/* @__PURE__ */ (0, Q.jsx)("span", {
			className: "fs-13 fw-4 lh-20",
			children: "Cluster:"
		}), /* @__PURE__ */ (0, Q.jsx)("span", {
			className: "fs-13 fw-6 lh-20",
			children: e || "--"
		})]
	}), /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox dc__gap-2",
		children: [/* @__PURE__ */ (0, Q.jsx)("span", {
			className: "fs-13 fw-4 lh-20",
			children: "Namespace:"
		}), /* @__PURE__ */ (0, Q.jsx)("span", {
			className: "fs-13 fw-6 lh-20",
			children: t || "--"
		})]
	})]
}), AN = ({ row: e }) => e.data.variant === UA.K8S_RESOURCE ? /* @__PURE__ */ (0, Q.jsx)(W, {
	content: kN(e.data.resourceDetails.clusterName, e.data.resourceDetails.namespace),
	alwaysShowTippyOnHover: !0,
	children: /* @__PURE__ */ (0, Q.jsx)("span", {
		className: "cn-9 fs-13 fw-4 lh-20 dc__truncate",
		children: e.data.resourceDetails.environmentName || "--"
	})
}) : null, jN = ({ variant: e, detailViewItemName: t, isDetailView: n, isCustomView: r, breakdownViewType: i, view: a }) => {
	switch (e) {
		case UA.CLUSTER: return [
			{
				field: "clusterIcon",
				label: "",
				size: { fixed: 24 },
				CellComponent: bN,
				horizontallySticky: !0
			},
			{
				field: ij.NAME,
				label: "Cluster",
				size: { range: {
					startWidth: t ? 336 : 390,
					maxWidth: 500,
					minWidth: 100
				} },
				CellComponent: vN,
				isSortable: !0,
				horizontallySticky: !0
			},
			{
				field: "clusterProvider",
				label: "Provider",
				size: { range: {
					startWidth: 150,
					maxWidth: 250,
					minWidth: 120
				} },
				CellComponent: EN
			},
			{
				field: "type",
				label: "Type",
				size: { range: {
					startWidth: 120,
					maxWidth: 250,
					minWidth: 80
				} },
				CellComponent: yN
			},
			...dj
		];
		case UA.ENVIRONMENT: return [
			{
				field: "envIcon",
				label: "",
				size: { fixed: 24 },
				CellComponent: xN,
				horizontallySticky: !0
			},
			{
				field: ij.NAME,
				label: "Environment",
				size: { range: {
					startWidth: t ? 336 : 390,
					maxWidth: 500,
					minWidth: 100
				} },
				CellComponent: vN,
				isSortable: !0,
				horizontallySticky: !0
			},
			{
				field: "type",
				label: "Type",
				size: { range: {
					startWidth: 120,
					maxWidth: 250,
					minWidth: 80
				} },
				CellComponent: yN
			},
			...n ? [] : [{
				field: "appCount",
				label: "Applications Count",
				size: { range: {
					startWidth: 150,
					maxWidth: 250,
					minWidth: 80
				} },
				CellComponent: TN
			}],
			...dj
		];
		case UA.APPLICATION: return [
			{
				field: "appIcon",
				label: "",
				size: { fixed: 24 },
				CellComponent: CN,
				horizontallySticky: !0
			},
			{
				field: ij.NAME,
				label: "App Name",
				size: { range: {
					startWidth: t ? 336 : 390,
					maxWidth: 500,
					minWidth: 100
				} },
				CellComponent: vN,
				isSortable: !0,
				horizontallySticky: !0
			},
			...n ? [] : [{
				field: "envCount",
				label: "Environments",
				size: { range: {
					startWidth: 150,
					maxWidth: 250,
					minWidth: 80
				} },
				CellComponent: wN
			}],
			...dj
		];
		case UA.PROJECT: return [
			{
				field: "projectIcon",
				label: "",
				size: { fixed: 24 },
				CellComponent: SN,
				horizontallySticky: !0
			},
			{
				field: ij.NAME,
				label: "Project Name",
				size: { range: {
					startWidth: t ? 336 : 390,
					maxWidth: 500,
					minWidth: 100
				} },
				CellComponent: vN,
				isSortable: !0,
				horizontallySticky: !0
			},
			...n ? [] : [{
				field: "appCount",
				label: "Applications Count",
				size: { range: {
					startWidth: 150,
					maxWidth: 250,
					minWidth: 80
				} },
				CellComponent: TN
			}],
			...dj
		];
		case UA.K8S_RESOURCE: return [
			{
				field: ij.NAME,
				label: r || !t ? "Resource Name" : t,
				size: { range: {
					startWidth: 300,
					maxWidth: 450,
					minWidth: 100
				} },
				CellComponent: vN,
				isSortable: !0,
				horizontallySticky: !0
			},
			...r || i === L.CLUSTERS && a === BA.RESOURCE_KINDS ? [{
				field: ij.NAMESPACE,
				label: "Namespace",
				size: { range: {
					startWidth: 120,
					maxWidth: 250,
					minWidth: 80
				} },
				isSortable: !0,
				CellComponent: ON
			}] : [],
			...a === BA.RESOURCE_KINDS && (i === L.APPLICATIONS || i === L.PROJECTS) ? [{
				field: ij.ENVIRONMENT,
				label: "Environment",
				size: { range: {
					startWidth: 120,
					maxWidth: 250,
					minWidth: 80
				} },
				isSortable: !0,
				CellComponent: AN
			}] : [],
			...r ? [{
				field: "kind",
				label: "Kind",
				size: { range: {
					startWidth: 120,
					maxWidth: 250,
					minWidth: 80
				} },
				CellComponent: DN
			}] : [],
			...dj
		];
		default: return null;
	}
}, MN = (e) => {
	let t = e.get(VA.typeFilter);
	return {
		currency: e.get(zA.CURRENCY),
		timeRange: e.get(zA.TIME_RANGE),
		typeFilter: t,
		[pj]: e.get(pj),
		[mj]: e.get(mj)
	};
}, NN = (e) => {
	let t = e.metadata?.clusterType === "prod" ? "Production" : "Non-Production", n = e.metadata ? t : null, r = e.metadata?.envType === "prod" ? "Production" : "Non-Production", i = e.metadata ? r : null, a = e.name || "-";
	return {
		clusterDetails: {
			name: a,
			type: n,
			clusterProvider: e.metadata?.clusterProvider || "Unknown"
		},
		appDetails: {
			name: a,
			envCount: e.metadata?.envCount || null
		},
		resourceDetails: {
			name: a,
			namespace: e.metadata?.namespace || "",
			kind: e.metadata?.kind || "",
			environmentName: e.metadata?.envName || "",
			clusterName: e.metadata?.clusterName || ""
		},
		envDetails: {
			name: a,
			type: i,
			appCount: e.metadata?.applicationCount || null
		},
		projectDetails: {
			name: a,
			appCount: e.metadata?.applicationCount || null
		}
	};
}, PN = (e, t, n) => e.map((e) => {
	let r = {
		variant: t,
		id: Id(),
		[$.CPU]: { value: Uu(e.cpuCost, n) },
		[$.MEMORY]: { value: Uu(e.memoryCost, n) },
		[$.GPU]: { value: Uu(e.gpuCost, n) },
		[$.STORAGE]: { value: Uu(e.storageCost, n) },
		[$.NETWORK]: { value: Uu(e.networkCost, n) },
		totalCost: { value: Uu(e.totalCost, n) },
		potentialSavings: {
			value: Uu(e.potentialSavings, n),
			savingsPercentage: e.savingsPercent.toFixed(2)
		}
	};
	switch (t) {
		case UA.CLUSTER: return {
			...r,
			variant: UA.CLUSTER,
			clusterDetails: NN(e).clusterDetails
		};
		case UA.ENVIRONMENT: return {
			...r,
			variant: UA.ENVIRONMENT,
			envDetails: NN(e).envDetails
		};
		case UA.APPLICATION: return {
			...r,
			variant: UA.APPLICATION,
			appDetails: NN(e).appDetails
		};
		case UA.PROJECT: return {
			...r,
			variant: UA.PROJECT,
			projectDetails: NN(e).projectDetails
		};
		case UA.K8S_RESOURCE: return {
			...r,
			variant: UA.K8S_RESOURCE,
			resourceDetails: NN(e).resourceDetails
		};
		default: throw Error(`Encountered unsupported ${t} variant type while parsing breakdown list data`);
	}
}), FN = (e, t, n) => {
	if (!e?.overallBreakdown) return {
		data: [],
		totalCount: 0
	};
	let r = PN(e.overallBreakdown.items || [], t, n);
	return {
		totalCount: e.overallBreakdown.totalCount || 0,
		data: r
	};
}, IN = (e, t, n, r) => {
	if (!e?.breakdownsBySubResource?.[n]) return {
		data: [],
		totalCount: 0
	};
	let i = e.breakdownsBySubResource[n], a = PN(i.items || [], t, r);
	return {
		totalCount: i.totalCount || 0,
		data: a
	};
}, LN = async ({ view: e, breakdownViewType: t, itemName: n, detail: r, currency: i, timeRange: a, sortBy: o, sortOrder: s, pageSize: c, offset: l, signal: u, searchKey: d, typeFilter: f, tableVariant: p, namespace: m, environment: h }) => {
	let { payload: g, resource: _ } = wj({
		view: e,
		breakdownViewType: t,
		itemName: n,
		detail: r,
		currency: i,
		timeRange: a,
		sortBy: o,
		sortOrder: s,
		pageSize: c,
		offset: l,
		searchKey: d,
		typeFilter: f,
		namespace: m,
		environment: h
	}), { result: v } = await JA({
		payload: g,
		resource: _,
		signal: u
	});
	return g.subResource?.[0] ? IN(v, p, g.subResource?.[0], i) : FN(v, p, i);
}, RN = async ({ resource: e, resourceName: t, signal: n }) => {
	let { result: r } = await G(Rd(O.ENV_LIST_BY_RESOURCE, {
		resource: e,
		resourceName: t
	}), { signal: n });
	return (r || []).filter((e) => !!e.envName).sort((e, t) => df(e.envName, t.envName)).map(({ envId: e, envName: t, clusterId: n, clusterName: r, namespace: i }) => ({
		envName: t,
		envId: e || 0,
		clusterName: r || "",
		clusterId: n || 0,
		namespace: i || ""
	}));
}, zN = async ({ showEnvironmentFilter: e, showNamespaceFilter: t, clusterId: n, resourceName: r, viewType: i, signal: a }) => t ? [{
	label: "All Namespaces",
	value: ""
}, ...await $j(n, a)] : e ? [{
	label: "All Environments",
	value: ""
}, ...(await RN({
	resource: i === L.APPLICATIONS ? "application" : "project",
	resourceName: r || "",
	signal: a
})).map(({ envName: e, clusterName: t, namespace: n }) => ({
	label: e,
	value: e,
	tooltipProps: { content: kN(t, n) }
}))] : [], BN = ({ children: e, searchKey: t, handleSearch: n, areNoResourcesAvailableGlobally: r }) => {
	let { view: i, breakdownViewType: a, itemName: o } = Z(), { breakdownDetailsData: s } = Gj(), { searchParams: c } = jf(), l = Yf(), u = X(), d = c[pj], f = c[mj], p = s.selectedCluster.id, m = i === BA.CUSTOM_VIEWS || i === BA.RESOURCE_KINDS, h = !r && m && !!p, g = !r && m && (a === L.APPLICATIONS || a === L.PROJECTS) && !!o, { data: _, isFetching: v, error: y, refetch: b } = q({
		queryKey: [
			"filter-options",
			p,
			o,
			a,
			h,
			g
		],
		queryFn: ({ signal: e }) => zN(h ? {
			showNamespaceFilter: !0,
			clusterId: p,
			signal: e
		} : {
			showEnvironmentFilter: !0,
			resourceName: o,
			viewType: a === L.APPLICATIONS || a === L.PROJECTS ? a : null,
			signal: e
		}),
		enabled: h || g
	});
	return /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox-col dc__overflow-hidden flex-grow-1",
		children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox dc__gap-8 dc__content-space p-16",
			children: [r ? /* @__PURE__ */ (0, Q.jsx)("div", {}) : /* @__PURE__ */ (0, Q.jsx)(Il, {
				containerClassName: "w-250",
				initialSearchText: t,
				handleEnter: n,
				keyboardShortcut: "/"
			}), (h || g) && /* @__PURE__ */ (0, Q.jsx)(V, {
				inputId: "cost-breakdown-table-resource-filter",
				classNamePrefix: "cost-breakdown-table-resource-filter",
				value: h ? {
					label: d || "All Namespaces",
					value: d || ""
				} : {
					label: f || "All Environments",
					value: f || ""
				},
				options: _,
				placeholder: `Select ${h ? "Namespace" : "Environment"}`,
				onChange: (e) => {
					let t = new URLSearchParams(l.search), n = h ? pj : mj;
					e.value ? t.set(n, e.value) : t.delete(n), u({
						pathname: l.pathname,
						search: t.toString()
					});
				},
				isLoading: v,
				optionListError: y,
				reloadOptionList: b,
				shouldMenuAlignRight: !0
			})]
		}), e]
	});
}, VN = ({ variant: e, globalResourceCountConfig: t }) => {
	let { view: n, breakdownViewType: r, itemName: i, detail: a } = Z(), o = _j(n, a), { areNoResourcesAvailable: s, setAreNoResourcesAvailable: c } = t || {
		setAreNoResourcesAvailable: $d,
		areNoResourcesAvailable: !1
	}, { currencyData: { defaultCurrency: l } } = Gj(), u = A(() => jN({
		variant: e,
		detailViewItemName: o,
		isDetailView: !!i,
		isCustomView: n === BA.CUSTOM_VIEWS,
		breakdownViewType: r,
		view: n
	}), [e, o]), d = Ka(async ({ sortBy: t, sortOrder: o, searchKey: s, offset: u, pageSize: d, currency: f, timeRange: p, typeFilter: m, namespace: h, environment: g }, _) => {
		c?.(!1);
		let v = await LN({
			view: n,
			breakdownViewType: r,
			itemName: i,
			detail: a,
			currency: f || l,
			timeRange: p,
			sortBy: t,
			sortOrder: o,
			pageSize: d,
			offset: u,
			signal: _,
			searchKey: s,
			typeFilter: m,
			tableVariant: e,
			namespace: h,
			environment: g
		});
		return c?.(!(s || u > 0 || h || g) && !v.data?.length), {
			rows: (v.data || []).map((e) => ({
				id: e.id,
				data: e
			})),
			totalRows: v.totalCount || 0
		};
	}, [e, o]);
	return /* @__PURE__ */ (0, Q.jsx)(ru, {
		id: `table__cost-breakdown-${e}-${o}`,
		columns: u,
		emptyStateConfig: {
			noRowsConfig: {
				image: Zf,
				title: "No results found",
				subTitle: "We couldn't find any matching results"
			},
			noRowsForFilterConfig: {
				title: "No results",
				subTitle: "We couldn't find any matching results"
			}
		},
		paginationVariant: el.PAGINATED,
		additionalFilterProps: {
			initialSortKey: ij.NAME,
			parseSearchParams: MN
		},
		getRows: d,
		filtersVariant: tc.URL,
		ViewWrapper: BN,
		additionalProps: { areNoResourcesAvailableGlobally: s },
		filter: null
	});
}, HN = /* @__PURE__ */ function(e) {
	return e.Equality = "Equality", e.Inequality = "Inequality", e.Contains = "Contains", e.NotContains = "NotContains", e.ContainsPrefix = "ContainsPrefix", e.NotContainsPrefix = "NotContainsPrefix", e.ContainsSuffix = "ContainsSuffix", e.NotContainsSuffix = "NotContainsSuffix", e;
}({}), UN = /* @__PURE__ */ function(e) {
	return e.SHOW_CUSTOM_VIEW_MODAL = "showCustomViewModal", e.CUSTOM_VIEW_NAME = "customViewName", e;
}({}), WN = /* @__PURE__ */ function(e) {
	return e.KEY = "KEY", e.OPERATOR = "OPERATOR", e.VALUE = "VALUE", e;
}({}), GN = [
	{
		label: "KEY",
		key: WN.KEY,
		width: "300px"
	},
	{
		label: "OPERATOR",
		key: WN.OPERATOR,
		width: "160px"
	},
	{
		label: "VALUE",
		key: WN.VALUE,
		width: "1fr"
	}
], KN = {
	[HN.Equality]: "equals",
	[HN.Inequality]: "does not equal",
	[HN.Contains]: "contains",
	[HN.NotContains]: "does not contain",
	[HN.ContainsPrefix]: "starts with",
	[HN.NotContainsPrefix]: "does not start with",
	[HN.ContainsSuffix]: "ends with",
	[HN.NotContainsSuffix]: "does not end with"
}, qN = Object.values(HN).map((e) => ({
	label: KN[e],
	value: e
})), JN = {
	label: "Cost Overview",
	id: BA.OVERVIEW,
	iconName: "ic-world-globe"
}, YN = {
	label: "Applications",
	id: BA.APPLICATIONS,
	iconName: "ic-grid-view"
}, XN = {
	label: "Deployment Cost",
	id: BA.DEPLOYMENT_COST,
	iconName: "ic-env"
}, ZN = {
	[L.APPLICATIONS]: [JN, XN],
	[L.CLUSTERS]: [JN],
	[L.ENVIRONMENTS]: [JN, YN],
	[L.PROJECTS]: [JN, YN]
}, QN = {
	[BA.AGGREGATIONS]: UA.K8S_RESOURCE,
	[BA.APPLICATIONS]: UA.APPLICATION,
	[BA.CUSTOM_VIEWS]: UA.K8S_RESOURCE,
	[BA.DEPLOYMENT_COST]: UA.ENVIRONMENT,
	[BA.OVERVIEW]: null,
	[BA.RESOURCE_KINDS]: UA.K8S_RESOURCE
}, $N = HN.Equality, eP = {
	[L.CLUSTERS]: ["namespace"],
	[L.ENVIRONMENTS]: ["application"],
	[L.PROJECTS]: ["application"],
	[L.APPLICATIONS]: ["deployment"]
}, tP = /* @__PURE__ */ function(e) {
	return e.EDIT_CUSTOM_VIEW = "edit-custom-view", e.DELETE_CUSTOM_VIEW = "delete-custom-view", e;
}({}), nP = [{ items: [{
	id: "edit-custom-view",
	label: "Edit",
	startIcon: {
		name: "ic-pencil",
		color: "N700"
	}
}, {
	id: "delete-custom-view",
	label: "Delete",
	type: "negative",
	startIcon: {
		name: "ic-delete",
		color: "R500"
	}
}] }], rP = (e, t = !1) => ({
	data: {
		[WN.KEY]: {
			value: e?.key || "",
			type: Vs.TEXT,
			props: {
				placeholder: "Key",
				autoFocus: t
			}
		},
		[WN.OPERATOR]: {
			type: Vs.DROPDOWN,
			value: e?.operator || $N,
			props: { options: qN }
		},
		[WN.VALUE]: {
			value: e?.value || "",
			type: Vs.TEXT,
			props: { placeholder: "Enter value or variable" }
		}
	},
	id: e?.id || Id()
}), iP = (e, t) => ({
	id: e.id || void 0,
	name: e.name,
	description: e.description,
	clusterName: t,
	filters: e.labelRows.map((e) => ({
		key: e.data[WN.KEY].value.trim(),
		operator: e.data[WN.OPERATOR].value,
		value: e.data[WN.VALUE].value.trim()
	})).filter((e) => e.key && e.value)
}), aP = (e) => Bf(e), oP = (e) => Rf(e), sP = (e, t) => {
	let n = e[t].data, r = n[WN.KEY].value.trim(), i = n[WN.OPERATOR].value, a = n[WN.VALUE].value.trim();
	if (!(r !== "" && a !== "")) return e.length === 1 ? {
		isValid: !1,
		message: "At-least one label with key and value is required"
	} : { isValid: !0 };
	let o = {};
	e.forEach((e) => {
		let t = `${e.data[WN.KEY].value.trim()}-${e.data[WN.OPERATOR].value}-${e.data[WN.VALUE].value.trim()}`;
		o[t] = (o[t] || 0) + 1;
	});
	let s = o[`${r}-${i}-${a}`] === 1;
	return {
		isValid: s,
		message: s ? "" : "Combination of key, operator, and value must be unique"
	};
}, cP = (e) => {
	let t = {};
	return e.labelRows.forEach((n, r) => {
		let i = sP(e.labelRows, r);
		i.isValid || (t[n.id] = {
			[WN.KEY]: {
				isValid: !1,
				errorMessages: [i.message]
			},
			[WN.VALUE]: {
				isValid: !1,
				errorMessages: [i.message]
			},
			[WN.OPERATOR]: {
				isValid: !1,
				errorMessages: [i.message]
			}
		});
	}), t;
}, lP = (e) => {
	let t = aP(e.name), n = oP(e.description);
	return {
		name: t.message,
		description: n.message,
		labelRows: cP(e)
	};
}, uP = (e) => !e.name && !e.description && Object.values(e.labelRows).every((e) => !e[WN.KEY]?.errorMessages?.length && !e[WN.VALUE]?.errorMessages?.length && !e[WN.OPERATOR]?.errorMessages?.length), dP = async (e, t) => {
	try {
		let n = iP(e, t);
		await nf(O.COST_CUSTOM_VIEW, n);
	} catch (e) {
		throw K(e), e;
	}
}, fP = ({ handleClose: e, refetchCustomViews: t, customViews: n, customViewError: r, isLoadingViewData: i }) => {
	let { itemName: a } = Z(), { searchParams: o } = jf(), s = o[UN.CUSTOM_VIEW_NAME], c = n.find((e) => e.name === s), [l, u] = j({
		id: c?.id,
		name: "",
		description: "",
		labelRows: [rP()]
	}), [d, f] = j({
		name: "",
		description: "",
		labelRows: {}
	}), [p, m] = j(!1), h = async () => {
		let n = lP(l);
		if (f(n), !uP(n)) {
			H.showToast({
				variant: U.error,
				description: "Please fix the errors before saving."
			});
			return;
		}
		Vd({
			category: "cost-breakdown-item-details",
			action: "COST_BREAKDOWN_CLUSTER_SAVE_CUSTOM_VIEW"
		}), m(!0);
		try {
			await dP(l, a), t(l.name), m(!1), e();
		} catch {
			m(!1);
		}
	};
	k(() => {
		s && c && u({
			id: c.id,
			name: c.name,
			description: c.description,
			labelRows: [rP(), ...c.labels.map((e) => rP(e, !0))]
		});
	}, [s, n]);
	let g = () => {
		u((e) => ({
			...e,
			labelRows: [rP(null, !0), ...e.labelRows]
		})), Vd({
			category: "cost-breakdown-item-details",
			action: "COST_BREAKDOWN_CLUSTER_ADD_CUSTOM_VIEW_ADD_LABEL"
		});
	}, _ = (e) => {
		u((t) => ({
			...t,
			name: e.target.value
		})), f((t) => ({
			...t,
			name: aP(e.target.value).message || ""
		}));
	}, v = (e) => {
		u((t) => ({
			...t,
			description: e.target.value
		})), f((t) => ({
			...t,
			description: oP(e.target.value).message || ""
		}));
	}, y = (e) => {
		let t = {
			...l,
			labelRows: [...e]
		};
		u(t), f((e) => ({
			...e,
			labelRows: cP(t)
		}));
	};
	return /* @__PURE__ */ (0, Q.jsx)(Rs, {
		position: "right",
		width: "800px",
		onClose: e,
		children: /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox-col dc__content-space h-100 bg__modal--primary shadow__modal dc__overflow-auto",
			onClick: uf,
			children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox-col dc__overflow-auto flex-grow-1",
				children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "px-20 py-12 flexbox dc__content-space dc__align-items-center border__primary--bottom",
					children: [/* @__PURE__ */ (0, Q.jsxs)("h2", {
						className: "m-0 fs-16 fw-6 lh-1-5 cn-9 dc__truncate",
						children: ["Custom View ", s ? `'${s}'` : ""]
					}), /* @__PURE__ */ (0, Q.jsx)(M, {
						dataTestId: "header-close-button",
						ariaLabel: "Close",
						showAriaLabelInTippy: !1,
						onClick: e,
						variant: F.borderLess,
						style: P.negativeGrey,
						icon: /* @__PURE__ */ (0, Q.jsx)(z, {
							name: "ic-close-large",
							color: null
						}),
						size: I.xs
					})]
				}), /* @__PURE__ */ (0, Q.jsx)("div", {
					className: "flex-grow-1 dc__overflow-auto w-100",
					children: /* @__PURE__ */ (0, Q.jsx)($a, {
						isLoading: s && i,
						progressingProps: { pageLoader: !0 },
						error: r,
						errorScreenManagerProps: s ? {
							code: r?.code,
							reload: t,
							on404Redirect: e
						} : null,
						children: /* @__PURE__ */ (0, Q.jsxs)("div", {
							className: "flexbox-col p-20 dc__overflow-auto dc__gap-16 flex-grow-1",
							children: [
								/* @__PURE__ */ (0, Q.jsx)(os, {
									name: "view-name",
									label: "Name",
									placeholder: "Logistics EU",
									value: l.name,
									onChange: _,
									error: d.name,
									required: !0,
									fullWidth: !0,
									autoFocus: !!s
								}),
								/* @__PURE__ */ (0, Q.jsx)(ou, {
									label: "Description",
									name: "custom-view-description",
									placeholder: "Aggregates resources operating logistics services",
									value: l.description,
									onChange: v,
									error: d.description
								}),
								/* @__PURE__ */ (0, Q.jsx)("div", { className: "divider divider--n1" }),
								/* @__PURE__ */ (0, Q.jsxs)("div", {
									className: "flexbox dc__content-space dc__gap-8 dc__align-items-center",
									children: [/* @__PURE__ */ (0, Q.jsx)("h3", {
										className: "m-0 fs-14 fw-6 lh-20 cn-9",
										children: "Filter resources by labels"
									}), /* @__PURE__ */ (0, Q.jsx)(M, {
										dataTestId: "heading-add-label-button",
										variant: F.secondary,
										size: I.small,
										startIcon: /* @__PURE__ */ (0, Q.jsx)(z, {
											name: "ic-add",
											color: null
										}),
										text: "Add Label",
										onClick: g
									})]
								}),
								/* @__PURE__ */ (0, Q.jsx)(Bs, {
									headers: GN,
									rows: l.labelRows,
									onRowAdd: g,
									onRowEdit: (e, t, n) => {
										y(l.labelRows.map((r) => r.id === e.id ? {
											...r,
											data: {
												...r.data,
												[t]: {
													...r.data[t],
													value: n
												}
											}
										} : r));
									},
									onRowDelete: (e) => {
										l.labelRows.length <= 1 || y(l.labelRows.filter((t) => t.id !== e.id));
									},
									cellError: d.labelRows
								}),
								/* @__PURE__ */ (0, Q.jsx)(xc, {
									variant: "neutral",
									description: "Filter will be applied as AND"
								})
							]
						})
					})
				})]
			}), /* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox dc__content-end dc__gap-12 py-16 px-20 border__primary--top dc__no-shrink",
				children: [/* @__PURE__ */ (0, Q.jsx)(M, {
					dataTestId: "footer-cancel-button",
					variant: F.secondary,
					text: "Cancel",
					style: P.neutral,
					size: I.large,
					onClick: e
				}), /* @__PURE__ */ (0, Q.jsx)(M, {
					dataTestId: "footer-apply-button",
					variant: F.primary,
					size: I.large,
					text: "Apply Changes",
					disabled: s ? i || !!r : !1,
					isLoading: p,
					onClick: h
				})]
			})]
		})
	});
}, pP = ({ datasets: e, isLoading: t, errorConfig: n }) => {
	let { currency: r } = tM(), i = A(() => t ? null : {
		type: "pie",
		xAxisLabels: Object.keys(e).map((e) => ZA[e]),
		datasets: {
			datasetName: "Cost Breakdown",
			colors: [
				"LimeGreen400",
				"Lavender400",
				"SkyBlue400",
				"GoldenYellow600"
			],
			yAxisValues: Object.values(e)
		},
		id: "cost-breakdown-doughnut"
	}, [e]);
	return /* @__PURE__ */ (0, Q.jsxs)(Ho, {
		isLoading: t,
		shimmerVariant: "C",
		children: [/* @__PURE__ */ (0, Q.jsx)("div", {
			className: "flexbox py-12 px-16 border__secondary--bottom",
			children: /* @__PURE__ */ (0, Q.jsx)("span", {
				className: "fs-13 fw-6 lh-1-5 cn-9",
				children: "Cost Breakdown"
			})
		}), /* @__PURE__ */ (0, Q.jsx)("div", {
			className: "flex-grow-1 p-16",
			children: n ? /* @__PURE__ */ (0, Q.jsx)("div", {
				className: "flex-grow-1 p-16",
				children: /* @__PURE__ */ (0, Q.jsx)(lc, { reload: n.refetch })
			}) : /* @__PURE__ */ (0, Q.jsx)(Uo, {
				...i,
				tooltipConfig: { datasetValueFormatter: (e) => Uu(e, r) }
			})
		})]
	});
}, mP = ({ isLoading: e, totalCost: t, delta: n, xAxisLabels: r, datasets: i, errorConfig: a }) => {
	let { currency: o } = tM(), s = A(() => ({
		...i,
		color: $A[hj(n)]
	}), [i, n]);
	return /* @__PURE__ */ (0, Q.jsx)(Ho, {
		shimmerVariant: "C",
		isLoading: e,
		variant: "primary--outlined",
		children: a ? /* @__PURE__ */ (0, Q.jsx)(lc, {
			reload: a.refetch,
			rootClassName: "h-100"
		}) : /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsx)("div", {
			className: "flexbox dc__gap-12 dc__align-start px-16 pt-16",
			children: /* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox-col flex-grow-1",
				children: [/* @__PURE__ */ (0, Q.jsx)("span", {
					className: "fs-13 lh-1-5 cn-9",
					children: "Total Cost"
				}), /* @__PURE__ */ (0, Q.jsx)("span", {
					className: "fs-24 fw-6 cn-9 dc__truncate lh-1-5 font-ibm-plex-sans",
					children: t
				})]
			})
		}), /* @__PURE__ */ (0, Q.jsx)("div", {
			className: "flex-grow-1 w-100 dc__overflow-hidden",
			children: /* @__PURE__ */ (0, Q.jsx)(Uo, {
				id: "cost-trend-chart",
				type: "area",
				xAxisLabels: r,
				datasets: s,
				hideAxis: !0,
				yScaleTickFormat: (e) => Uu(Number(e), o),
				tooltipConfig: { datasetValueFormatter: (e) => Uu(e, o) }
			})
		})] })
	});
}, hP = ({ isLoading: e, recommendedCost: t, potentialSavings: n, potentialSavingsPercentage: r, cardVariant: i }) => {
	let a = Math.min(100, Math.ceil(r));
	return /* @__PURE__ */ (0, Q.jsx)(Ho, {
		shimmerVariant: "B",
		isLoading: e,
		variant: i,
		children: /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "dc__grid dc__overflow-hidden",
			style: { gridTemplateColumns: "minmax(50%, max-content) 1fr" },
			children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "dc__grid-cols-2 dc__gap-16 p-16 border__secondary--right",
				children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "flexbox-col dc__content-space",
					children: [/* @__PURE__ */ (0, Q.jsx)("span", {
						className: "fs-13 fw-4 lh-1-5 cn-9",
						children: "Recommended Cost"
					}), /* @__PURE__ */ (0, Q.jsx)("span", {
						className: "cn-9 fs-24 fw-6 lh-1-5 font-ibm-plex-sans dc__truncate",
						children: t
					})]
				}), /* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "flexbox-col dc__content-space",
					children: [/* @__PURE__ */ (0, Q.jsx)("span", {
						className: "fs-13 fw-4 lh-1-5 cn-9",
						children: "Potential Savings"
					}), /* @__PURE__ */ (0, Q.jsx)("span", {
						className: "cg-5 fs-24 fw-6 lh-1-5 font-ibm-plex-sans dc__truncate",
						children: n
					})]
				})]
			}), /* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox-col dc__gap-16 p-16",
				children: [/* @__PURE__ */ (0, Q.jsxs)("p", {
					className: "m-0 p-0 fs-13 fw-4 cn-9",
					children: ["Estimated cost reduction\xA0", /* @__PURE__ */ (0, Q.jsxs)("span", {
						className: "fw-6",
						children: [r, "%"]
					})]
				}), /* @__PURE__ */ (0, Q.jsx)(zl, {
					hideLegend: !0,
					entities: [{
						value: a,
						color: "var(--G500)"
					}, {
						value: 100 - a,
						color: "var(--N200)"
					}],
					showAnimationOnBar: !0,
					size: I.large
				})]
			})]
		})
	});
}, gP = ({ category: e, categoryPotentialSavings: t, categoryPotentialSavingsPercentage: n, isLoading: r, totalCategoryCost: i }) => {
	if (r) return /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox-col p-16 dc__gap-8 br-8 border__primary bg__primary",
		children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox dc__gap-12 dc__align-start dc__content-space",
			children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox-col dc__gap-4",
				children: [/* @__PURE__ */ (0, Q.jsx)("div", { className: "shimmer h-16 w-80" }), /* @__PURE__ */ (0, Q.jsx)("div", { className: "shimmer h-24 w-100" })]
			}), /* @__PURE__ */ (0, Q.jsx)("div", { className: "shimmer h-20 w-40 br-4" })]
		}), /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox-col dc__gap-6",
			children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox dc__gap-8",
				children: [/* @__PURE__ */ (0, Q.jsx)("div", { className: "shimmer h-13 w-90" }), /* @__PURE__ */ (0, Q.jsx)("div", { className: "shimmer h-13 w-60" })]
			}), /* @__PURE__ */ (0, Q.jsx)("div", { className: "shimmer h-8 w-100 br-4" })]
		})]
	});
	let a = Math.min(100, Math.ceil(n));
	return /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox-col p-16 dc__gap-8 br-8 border__primary bg__primary",
		children: [/* @__PURE__ */ (0, Q.jsx)("div", {
			className: "flexbox dc__gap-12 dc__align-start dc__content-space",
			children: /* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox-col",
				children: [/* @__PURE__ */ (0, Q.jsx)("span", {
					className: "fs-13 fw-4 lh-1-5",
					children: e
				}), /* @__PURE__ */ (0, Q.jsx)("span", {
					className: "fs-24 fw-6 lh-1-5 font-ibm-plex-sans cn-9",
					children: i
				})]
			})
		}), /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox-col dc__gap-6",
			children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox dc__gap-8 font-ibm-plex-sans dc__content-space",
				children: [/* @__PURE__ */ (0, Q.jsx)("span", {
					className: "fs-13 lh-20 cn-7",
					children: "Potential Savings"
				}), /* @__PURE__ */ (0, Q.jsx)("span", {
					className: "fs-13 fw-6 lh-20 cn-9",
					children: t
				})]
			}), /* @__PURE__ */ (0, Q.jsx)(zl, {
				hideLegend: !0,
				size: I.xs,
				entities: [{
					value: a,
					color: "var(--G500)"
				}, {
					value: 100 - a,
					color: "var(--N200)"
				}]
			})]
		})]
	});
}, _P = ({ variant: e, props: t }) => {
	switch (e) {
		case "expanded": return /* @__PURE__ */ (0, Q.jsx)(hP, { ...t });
		case "mini": return /* @__PURE__ */ (0, Q.jsx)(gP, { ...t });
		default: return null;
	}
}, vP = [
	{
		label: "Total Cost",
		value: "total"
	},
	{
		label: ZA.cpu,
		value: $.CPU
	},
	{
		label: ZA.memory,
		value: $.MEMORY
	},
	{
		label: ZA.storage,
		value: $.STORAGE
	},
	{
		label: ZA.gpu,
		value: $.GPU
	},
	{
		label: ZA.network,
		value: $.NETWORK
	}
], yP = {
	[$.CPU]: "cpuCost",
	[$.MEMORY]: "memoryCost",
	[$.GPU]: "gpuCost",
	[$.STORAGE]: "storageCost",
	[$.NETWORK]: "networkCost",
	total: "totalCost"
}, bP = ({ maxValue: e, name: t, cost: n, scaledValue: r, currency: i, breakdownViewType: a, timeRange: o, isNavigationDisabled: s }) => {
	let c = X();
	return /* @__PURE__ */ (0, Q.jsxs)("div", {
		...s ? {} : {
			role: "button",
			tabIndex: 0,
			onClick: () => {
				c(vj(Y(B.COST_VISIBILITY_BREAKDOWN_DETAIL, {
					breakdownViewType: a ?? L.CLUSTERS,
					view: BA.OVERVIEW,
					itemName: t,
					detail: null
				}), o, i));
			}
		},
		className: `dc__position-rel w-100 h-40 dc__no-shrink p-4 br-4 ${s ? "" : "dc__hover-n50 top10-card__bar--clickable dc__transition--background"}`,
		children: [/* @__PURE__ */ (0, Q.jsx)("div", {
			className: "h-100 br-4 bcb-1 bar__visual dc__transition--background",
			style: { width: `${r / e * 100}%` }
		}), /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox dc__content-space dc__gap-12 dc__position-abs dc__zi-1 w-100 h-100 dc__top-0 dc__left-0 dc__align-items-center px-8",
			children: [/* @__PURE__ */ (0, Q.jsx)("span", {
				className: "fs-13 lh-1-5 cn-9 dc__truncate",
				children: t
			}), /* @__PURE__ */ (0, Q.jsx)("span", {
				className: "fs-16 lh-1-5 fw-6 cn-9 font-ibm-plex-sans dc__no-shrink",
				children: Uu(n, i)
			})]
		})]
	});
}, xP = (e, t) => e.map((e) => ({
	name: e.name,
	cost: Number(e[yP[t]].toFixed(2)),
	scaledValue: e[yP[t]] * 100
})), SP = (e) => {
	switch (e) {
		case $.CPU: return "cpuCost";
		case $.MEMORY: return "memoryCost";
		case $.STORAGE: return "storageCost";
		case $.GPU: return "gpuCost";
		default: return "totalCost";
	}
}, CP = ({ breakdownViewType: e, resourceName: t, subComponent: n, subResource: r, timeRange: i }) => {
	let { view: a } = Z(), { currency: o, typeFilter: s } = tM(), { isLoading: c, data: l, error: u, refetch: d } = q({
		queryKey: [
			"top10Resources",
			n,
			s,
			t,
			JSON.stringify(r),
			e,
			o,
			i,
			a
		],
		queryFn: ({ signal: c }) => JA({
			...Vj({
				pageSize: 10,
				offset: 0,
				resourceName: t,
				isCustomView: a === BA.CUSTOM_VIEWS,
				breakdownViewType: e,
				subResource: r,
				currency: o,
				searchKey: "",
				sortBy: SP(n),
				sortOrder: Jl.DESC,
				timeRange: i,
				typeFilter: s
			}),
			signal: c
		}),
		select: ({ result: e }) => xP(r ? e?.breakdownsBySubResource?.[r[0]]?.items ?? [] : e?.overallBreakdown?.items ?? [], n)
	}), f = A(() => l?.reduce((e, t) => Math.max(e, t.scaledValue), 1) ?? 1, [l, n]);
	return u ? /* @__PURE__ */ (0, Q.jsx)(lc, {
		reload: d,
		rootClassName: "h-100"
	}) : /* @__PURE__ */ (0, Q.jsx)("div", {
		className: "py-8 px-12 flexbox-col dc__overflow-auto",
		children: c ? /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsx)("div", {
			className: "shimmer br-4 h-20 mb-8 p-4",
			style: { width: "60%" }
		}), /* @__PURE__ */ (0, Q.jsx)("div", {
			className: "shimmer br-4 h-20 p-4",
			style: { width: "40%" }
		})] }) : l.map((n, r) => /* @__PURE__ */ (0, Q.jsx)(bP, {
			maxValue: f,
			name: n.name,
			cost: n.cost,
			scaledValue: n.scaledValue,
			currency: o,
			breakdownViewType: e,
			isNavigationDisabled: !!t,
			timeRange: i
		}, r))
	});
}, wP = ({ variant: e, hideCategoryFilter: t = !1, ...n }) => {
	let { serverMode: r } = Tf(), { subResource: i, breakdownViewType: a } = n, { timeRange: o } = tM(), [s, c] = j(a ?? L.CLUSTERS), [l, u] = j(tj);
	bf(() => {
		a && c(a);
	}, [a]);
	let [d, f] = j("total"), p = A(() => rj.find((e) => e.value === s), [s]), m = A(() => vP.find((e) => e.value === d), [d]), h = (e) => {
		f(e.value);
	}, g = (e) => {
		Vd({
			category: "cost_visibility_most_expensive",
			action: `COST_OVERVIEW_MOST_EXPENSIVE_${e.value.toUpperCase()}`
		}), c(e.value);
	}, _ = i?.[0] ?? s;
	return /* @__PURE__ */ (0, Q.jsx)(Ho, {
		variant: e === "overview" ? "secondary--outlined" : "primary--outlined",
		children: /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox-col dc__overflow-hidden top10-card",
			children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox py-12 px-16 dc__gap-16 dc__content-space border__secondary--bottom",
				children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "flexbox dc__gap-4",
					children: [/* @__PURE__ */ (0, Q.jsx)("span", {
						className: "fs-13 lh-1-5 fw-6 cn-9",
						children: e === "overview" ? "Most Expensive" : `Top 10 Costly ${_}`
					}), e === "overview" && /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [
						r === Ml.EA_ONLY ? /* @__PURE__ */ (0, Q.jsx)("span", {
							className: "fs-13 lh-1-5 fw-6 cn-9",
							children: "Cluster"
						}) : /* @__PURE__ */ (0, Q.jsx)(V, {
							inputId: "top-10-overview-cost-breakdown-select",
							value: p,
							onChange: g,
							options: rj,
							variant: Hl.COMPACT,
							size: I.small,
							shouldMenuAlignRight: !0
						}),
						/* @__PURE__ */ (0, Q.jsx)("span", {
							className: "fs-13 lh-1-5 fw-6 cn-9",
							children: "in"
						}),
						/* @__PURE__ */ (0, Q.jsx)(sM, {
							stateConfig: {
								timeRange: l,
								setTimeRange: u
							},
							size: I.small,
							variant: Hl.COMPACT,
							analyticsAction: "COST_OVERVIEW_MOST_EXPENSIVE_TIMEFRAME"
						})
					] })]
				}), !t && /* @__PURE__ */ (0, Q.jsx)(V, {
					inputId: `top-10-${_}-category-filter`,
					value: m,
					onChange: h,
					options: vP,
					variant: Hl.COMPACT,
					size: I.small,
					shouldMenuAlignRight: !0
				})]
			}), /* @__PURE__ */ (0, Q.jsx)(CP, {
				...n,
				breakdownViewType: s,
				subComponent: d,
				timeRange: e === "overview" ? l : o
			})]
		})
	});
}, TP = (e) => () => {
	Vd({
		category: "cost-breakdown-details-nav",
		action: `COST_BREAKDOWN_CLUSTER_BY_${e.toUpperCase()}`
	});
}, EP = (e, t, n, r) => [{
	title: "Aggregations",
	id: "cost-visibility-aggregations",
	type: "heading",
	items: [
		{
			type: "item",
			id: HA.NODE_GROUPS,
			title: "Node Groups",
			as: "link",
			href: vj(Y(e, {
				...t,
				view: BA.AGGREGATIONS,
				detail: HA.NODE_GROUPS
			}), n, r),
			onClick: TP(HA.NODE_GROUPS)
		},
		{
			type: "item",
			id: HA.NAMESPACES,
			title: "Namespaces",
			as: "link",
			href: vj(Y(e, {
				...t,
				view: BA.AGGREGATIONS,
				detail: HA.NAMESPACES
			}), n, r),
			onClick: TP(HA.NAMESPACES)
		},
		{
			type: "item",
			id: HA.APPLICATIONS,
			title: "Applications",
			as: "link",
			href: vj(Y(e, {
				...t,
				view: BA.AGGREGATIONS,
				detail: HA.APPLICATIONS
			}), n, r),
			onClick: TP(HA.APPLICATIONS)
		}
	]
}], DP = (e, t) => (n) => {
	let r = zj(n.result, e), i = Hj(r, { variant: "expanded" }, e, t), a = r.subResourceSummary ? Object.values(r.subResourceSummary)[0] : r.summary;
	return {
		...i,
		costBreakdownDoughnutCardProps: { datasets: Object.values($).reduce((e, t) => ({
			...e,
			[t]: a[t].totalCost
		}), {}) }
	};
}, OP = () => {
	let { itemName: e, breakdownViewType: t, view: n, detail: r } = Z(), { timeRange: i, currency: a } = tM(), o = n === BA.CUSTOM_VIEWS ? r : e, s = A(() => Sj(n, r), [n, r]), { isLoading: c, data: l, error: u, refetch: d } = q({
		queryFn: ({ signal: e }) => qA({
			signal: e,
			...Bj({
				breakdownViewType: t,
				resourceName: o,
				subResource: s,
				currency: a,
				timeRange: i,
				typeFilter: ll.ALL,
				isCustomView: n === BA.CUSTOM_VIEWS,
				trendDetailType: "include-sub-resource-total"
			})
		}),
		queryKey: [
			"breakdownViewDetailsCharts",
			t,
			JSON.stringify(s),
			a,
			i,
			n,
			o
		],
		select: DP(i, a)
	}), f = u ? { refetch: d } : null, p = () => n === BA.CUSTOM_VIEWS || n === BA.DEPLOYMENT_COST || n === BA.APPLICATIONS && t !== L.CLUSTERS ? /* @__PURE__ */ (0, Q.jsx)(pP, { ...c ? { isLoading: !0 } : {
		...l?.costBreakdownDoughnutCardProps,
		errorConfig: f
	} }) : /* @__PURE__ */ (0, Q.jsx)(wP, {
		breakdownViewType: t,
		resourceName: o,
		subResource: s
	});
	return /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "dc__grid-cols-2 dc__gap-12 p-16",
		style: { gridTemplateRows: "356px" },
		children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "dc__grid dc__gap-12",
			style: { gridTemplateRows: "1fr min-content" },
			children: [/* @__PURE__ */ (0, Q.jsx)(mP, { ...c ? { isLoading: !0 } : {
				...l?.costTrendProps,
				errorConfig: f
			} }), /* @__PURE__ */ (0, Q.jsx)(_P, { ...c || f ? {
				variant: "expanded",
				props: { isLoading: !0 }
			} : l.potentialSavingsCardProps })]
		}), p()]
	});
}, kP = () => {
	let { itemName: e, breakdownViewType: t } = Z(), { timeRange: n, currency: r } = tM(), { isLoading: i, data: a, error: o, refetch: s } = q({
		queryKey: [
			"getCostBreakdownViewDetail",
			t,
			e,
			r,
			n
		],
		queryFn: ({ signal: i }) => qA({
			...Bj({
				breakdownViewType: t,
				resourceName: e,
				isCustomView: !1,
				currency: r,
				timeRange: n,
				typeFilter: ll.ALL,
				subResource: null,
				trendDetailType: "total_only"
			}),
			signal: i
		}),
		select: ({ result: e }) => Hj(zj(e, n), { variant: "mini" }, n, r)
	});
	return /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox-col p-16 dc__gap-16 dc__overflow-auto",
		children: [
			/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox dc__gap-8",
				children: [
					/* @__PURE__ */ (0, Q.jsx)("div", {
						className: "flex-grow-1 flexbox dc__align-items-center",
						children: /* @__PURE__ */ (0, Q.jsxs)("h2", {
							className: "m-0 p-0 fs-16 lh-1-5 fw-6",
							children: [
								"Cost Overview `",
								e,
								"`"
							]
						})
					}),
					/* @__PURE__ */ (0, Q.jsx)(_M, {}),
					/* @__PURE__ */ (0, Q.jsx)(sM, {})
				]
			}),
			/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "dc__grid-cols-2 dc__gap-12 breakdown-view-item-details__overview-charts",
				children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "dc__grid dc__gap-12",
					style: { gridTemplateRows: "168px auto" },
					children: [/* @__PURE__ */ (0, Q.jsx)(mP, { ...i ? { isLoading: !0 } : {
						...a?.costTrendProps,
						errorConfig: o ? { refetch: s } : null
					} }), /* @__PURE__ */ (0, Q.jsx)("div", {
						className: "dc__grid-cols-2 dc__grid-rows-2 dc__no-shrink dc__gap-12",
						children: i || o ? [
							,
							,
							,
						].fill(0).map((e, t) => /* @__PURE__ */ (0, Q.jsx)(_P, {
							variant: "mini",
							props: { isLoading: !0 }
						}, t)) : a.potentialSavingsMiniCardProps.slice(0, 4).map((e) => /* @__PURE__ */ (0, Q.jsx)(_P, { ...e }, e.props.category))
					})]
				}), /* @__PURE__ */ (0, Q.jsx)(wP, {
					breakdownViewType: t,
					resourceName: e,
					subResource: eP[t]
				})]
			}),
			t === L.CLUSTERS && /* @__PURE__ */ (0, Q.jsx)(hM, {
				props: {
					subResource: ["namespace"],
					itemName: e,
					breakdownViewType: t
				},
				type: "specific",
				variant: "detail"
			}),
			/* @__PURE__ */ (0, Q.jsx)(hM, {
				props: {
					subResource: [t === L.APPLICATIONS ? "deployment" : "application"],
					itemName: e,
					breakdownViewType: t
				},
				type: "specific",
				variant: "detail"
			}),
			/* @__PURE__ */ (0, Q.jsx)(hM, {
				type: "resourceKind",
				props: {
					breakdownViewType: t,
					itemName: e
				},
				variant: "detail"
			})
		]
	});
}, AP = (e) => G(Rd(O.COST_CUSTOM_VIEW, { clusterName: e })), jP = async (e) => {
	try {
		return await ff(Rd(O.COST_CUSTOM_VIEW, { id: e })), H.showToast({
			variant: U.success,
			description: "Custom view deleted successfully"
		}), !0;
	} catch (e) {
		return K(e), !1;
	}
}, MP = ({ customViews: e, refetchCustomViews: t }) => {
	let { view: n, breakdownViewType: r, detail: i, itemName: a } = Z(), o = X(), { timeRange: s } = tM(), { searchParams: c } = jf(), l = c[zA.CURRENCY] || "", [u, d] = j(null), [f, p] = j(!1), m = {
		itemName: a,
		breakdownViewType: r
	}, h = (e) => vj(Y(B.COST_VISIBILITY_BREAKDOWN_DETAIL, {
		...m,
		view: e.id,
		[as.DETAIL]: void 0
	}), s, l), g = () => {
		let e = vj(Rd("", { [UN.SHOW_CUSTOM_VIEW_MODAL]: !0 }), s, l);
		Vd({
			category: "cost-breakdown-item-details",
			action: "COST_BREAKDOWN_CLUSTER_ADD_CUSTOM_VIEW"
		}), o({ search: e.slice(1) });
	}, _ = (e) => () => {
		Vd({
			category: "cost-breakdown-details-nav",
			action: `COST_BREAKDOWN_${r.toUpperCase()}_BY_${e.toUpperCase()}`
		});
	}, v = () => [{
		type: "heading",
		id: "resource-kinds",
		title: "Resource Kinds",
		items: nj.map((e) => {
			let t = gj(e);
			return {
				type: "item",
				id: t,
				title: e.kind,
				as: "link",
				href: vj(Y(B.COST_VISIBILITY_BREAKDOWN_DETAIL, {
					...m,
					view: BA.RESOURCE_KINDS,
					detail: t
				}), s, l),
				onClick: _(e.kind)
			};
		})
	}], y = (e) => (t) => {
		if (t.id === tP.EDIT_CUSTOM_VIEW) {
			o({ search: vj(Rd("", {
				[UN.SHOW_CUSTOM_VIEW_MODAL]: !0,
				[UN.CUSTOM_VIEW_NAME]: e.name
			}), s, l).slice(1) });
			return;
		}
		t.id === tP.DELETE_CUSTOM_VIEW && d(e || null);
	}, b = () => {
		Vd({
			category: "cost-breakdown-details-nav",
			action: "COST_BREAKDOWN_CLUSTER_BY_CUSTOM_VIEW"
		});
	}, x = () => [{
		type: "heading",
		id: "cost-visibility-custom-views",
		title: "Custom Views",
		trailingItem: {
			type: "button",
			config: {
				dataTestId: "add-custom-view-btn",
				ariaLabel: "Add Custom View",
				icon: /* @__PURE__ */ (0, Q.jsx)(z, {
					name: "ic-add",
					color: null
				}),
				onClick: g
			}
		},
		items: e.map((e) => {
			let t = e.identifier;
			return {
				type: "item",
				id: t,
				title: e.name,
				as: "link",
				href: vj(Y(B.COST_VISIBILITY_BREAKDOWN_DETAIL, {
					...m,
					view: BA.CUSTOM_VIEWS,
					detail: t
				}), s, l),
				trailingItem: {
					type: "action-menu",
					config: {
						id: `custom-view-action-menu-${e.id}`,
						onClick: y(e),
						options: nP,
						buttonProps: {
							dataTestId: `custom-view-action-menu-btn-${e.id}`,
							ariaLabel: `Custom View Action Menu ${e.name}`,
							showAriaLabelInTippy: !1,
							icon: /* @__PURE__ */ (0, Q.jsx)(z, {
								name: "ic-more-vertical",
								color: "N900",
								size: 16
							}),
							variant: F.borderLess,
							style: P.neutral,
							size: I.xxs
						}
					}
				},
				onClick: b
			};
		})
	}], S = () => {
		d(null);
	}, C = async () => {
		p(!0);
		let e = await jP(u.id);
		p(!1), e && (S(), t(), n === BA.CUSTOM_VIEWS && i === u.identifier && o(h(JN)));
	}, w = r === L.CLUSTERS ? EP(B.COST_VISIBILITY_BREAKDOWN_DETAIL, m, s, l) : [], T = v(), ee = r === L.CLUSTERS ? x() : [], E = (e, t) => /* @__PURE__ */ (0, Q.jsx)(lu, {
		nodes: e,
		defaultExpandedMap: { [e[0].id]: !0 },
		selectedId: t ? e[0].items.find((e) => e.type === "item" && e.id === i)?.id : null,
		useOverflowAuto: !1
	}), D = (e) => () => {
		Vd({
			category: "cost-breakdown-details-nav",
			action: `COST_BREAKDOWN_${r.toUpperCase()}_BY_${e.id.toUpperCase()}`
		});
	};
	return /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsx)("div", {
		className: "flexbox-col dc__overflow-auto border__primary--right dc__gap-8 px-8 pt-12",
		children: /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "dc__separated-flexbox dc__separated-flexbox--vertical dc__separated-flexbox--vertical-gap-8",
			children: [
				/* @__PURE__ */ (0, Q.jsx)("div", {
					className: "flexbox-col w-100",
					children: ZN[r]?.map((e) => /* @__PURE__ */ (0, Q.jsxs)(Gf, {
						to: h(e),
						className: `flexbox flex-grow-1 dc__gap-8 dc__align-items-center px-8 py-6 br-4 ${n === e.id ? "bcb-1" : "bg__hover"}`,
						onClick: D(e),
						children: [/* @__PURE__ */ (0, Q.jsx)(z, {
							name: e.iconName,
							size: 16,
							color: n === e.id ? "B500" : "N800"
						}), /* @__PURE__ */ (0, Q.jsx)("span", {
							className: `dc__truncate fs-13 fw-4 lh-1-5 ${n === e.id ? "cb-5" : "cn-9"}`,
							children: e.label
						})]
					}, e.id))
				}),
				r === L.CLUSTERS && E(w, n === BA.AGGREGATIONS),
				E(T, n === BA.RESOURCE_KINDS),
				r === L.CLUSTERS && E(ee, n === BA.CUSTOM_VIEWS)
			]
		})
	}), u && /* @__PURE__ */ (0, Q.jsx)(ns, {
		title: "Delete Custom View",
		subtitle: "Are you sure you want to delete this custom view? This action cannot be undone.",
		variant: rs.delete,
		handleClose: S,
		buttonConfig: {
			primaryButtonConfig: {
				text: "Delete",
				onClick: C,
				isLoading: f
			},
			secondaryButtonConfig: {
				text: "Cancel",
				onClick: S
			}
		}
	})] });
}, NP = ({ keyData: e, value: t, operator: n }) => /* @__PURE__ */ (0, Q.jsxs)("div", {
	className: "flexbox dc__align-items-center border__primary bg__primary br-4",
	children: [
		/* @__PURE__ */ (0, Q.jsx)("div", {
			className: "flexbox py-2 px-6 border__secondary--right",
			children: /* @__PURE__ */ (0, Q.jsx)(W, {
				content: e,
				children: /* @__PURE__ */ (0, Q.jsx)("span", {
					className: "cn-9 fs-12 fw-6 lh-20 dc__truncate dc__mxw-100",
					children: e
				})
			})
		}),
		/* @__PURE__ */ (0, Q.jsx)("div", {
			className: "flexbox py-2 px-6 border__secondary--right",
			children: /* @__PURE__ */ (0, Q.jsx)("span", {
				className: "cn-7 fs-12 fw-4 lh-20",
				children: KN[n] || n
			})
		}),
		/* @__PURE__ */ (0, Q.jsx)("div", {
			className: "flexbox py-2 px-6",
			children: /* @__PURE__ */ (0, Q.jsx)(W, {
				content: t,
				children: /* @__PURE__ */ (0, Q.jsx)("span", {
					className: "cn-9 fs-12 fw-4 lh-20 dc__truncate dc__mxw-100",
					children: t
				})
			})
		})
	]
}), PP = () => {
	let { itemName: e, breakdownViewType: t, view: n, detail: r } = Z(), { searchParams: i } = jf(), a = i[zA.CURRENCY] || "", o = X(), s = Yf(), { timeRange: c } = tM(), l = !!(t === L.CLUSTERS && e), [u, d] = j(!1), { data: f, isFetching: p, error: m, refetch: h } = q({
		queryKey: [
			"getGVKsAndCustomViewList",
			t,
			e
		],
		queryFn: () => AP(t === L.CLUSTERS ? e : ""),
		select: ({ result: e }) => (e?.items || []).map((e) => ({
			name: e.name || "",
			description: e.description || "",
			identifier: e.identifier || "",
			id: e.id,
			labels: (e.filters || []).map((e) => ({
				id: Id(),
				key: e.key || "",
				operator: e.operator || $N,
				value: e.value || ""
			}))
		})).sort((e, t) => df(e.name, t.name)),
		enabled: l
	}), g = l ? p : !1, _ = () => {
		let e = vj("", c, a);
		o({ search: e.length ? e.slice(1) : "" });
	}, v = () => {
		if (n !== BA.CUSTOM_VIEWS) return /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox dc__gap-12 px-16 pt-16",
			children: [
				/* @__PURE__ */ (0, Q.jsx)("div", {
					className: "flexbox flex-grow-1 dc__align-items-center",
					children: /* @__PURE__ */ (0, Q.jsxs)("h2", {
						className: "m-0 fs-16 fw-6 lh-1-5 cn-9",
						children: ["Cost breakdown\xA0", _j(n, r) ? `by ${_j(n, r)}` : ""]
					})
				}),
				/* @__PURE__ */ (0, Q.jsx)(_M, {}),
				/* @__PURE__ */ (0, Q.jsx)(sM, {})
			]
		});
		let e = f?.find((e) => e.identifier === r);
		return /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox-col dc__gap-16 pt-16 px-16",
			children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox dc__content-space dc__gap-8 dc__align-start",
				children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "flexbox-col",
					children: [/* @__PURE__ */ (0, Q.jsxs)("h2", {
						className: "m-0 cn-9 fs-16 fw-6 lh-1-5 dc__truncate",
						children: ["Cost Overview ", e ? `'${e.name}'` : ""]
					}), e?.description && /* @__PURE__ */ (0, Q.jsx)("p", {
						className: "m-0 cn-7 fs-13 fw-4 dc__truncate lh-1-5",
						children: e.description
					})]
				}), /* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "flexbox dc__gap-8",
					children: [
						/* @__PURE__ */ (0, Q.jsx)(_M, {}),
						/* @__PURE__ */ (0, Q.jsx)(sM, {}),
						/* @__PURE__ */ (0, Q.jsx)(M, {
							dataTestId: "edit-selected-custom-view",
							icon: /* @__PURE__ */ (0, Q.jsx)(z, {
								name: "ic-pencil",
								color: null
							}),
							ariaLabel: "Edit Selected Custom View",
							showAriaLabelInTippy: !1,
							style: P.neutral,
							variant: F.secondary,
							component: N.link,
							size: I.medium,
							linkProps: { to: Rd(s.pathname, {
								[UN.SHOW_CUSTOM_VIEW_MODAL]: !0,
								[UN.CUSTOM_VIEW_NAME]: e?.name
							}) }
						})
					]
				})]
			}), e?.labels?.length > 0 && /* @__PURE__ */ (0, Q.jsx)("div", {
				className: "flexbox flex-wrap dc__gap-8",
				children: e.labels.map(({ id: e, key: t, operator: n, value: r }) => /* @__PURE__ */ (0, Q.jsx)(NP, {
					keyData: t,
					operator: n,
					value: r
				}, e))
			})]
		});
	};
	return /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsx)(_N, {
		pathPattern: B.COST_VISIBILITY_BREAKDOWN_DETAIL,
		children: /* @__PURE__ */ (0, Q.jsx)($a, {
			isLoading: g,
			progressingProps: { pageLoader: !0 },
			children: /* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "dc__grid breakdown-view-item-details__container flex-grow-1 h-100 dc__overflow-hidden dc__position-rel bg__primary w-100",
				children: [/* @__PURE__ */ (0, Q.jsx)(MP, {
					customViews: f || [],
					refetchCustomViews: h
				}), n === BA.OVERVIEW ? /* @__PURE__ */ (0, Q.jsx)(kP, {}) : n === BA.RESOURCE_KINDS && !nj.find((e) => gj(e) === r) ? /* @__PURE__ */ (0, Q.jsx)(R, { title: "Invalid resource kind" }) : /* @__PURE__ */ (0, Q.jsx)("div", {
					className: "flexbox-col dc__overflow-auto flex-grow-1 h-100",
					children: (() => {
						let i = n === BA.AGGREGATIONS && r === HA.APPLICATIONS ? UA.APPLICATION : QN[n];
						return i ? /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [
							v(),
							!u && /* @__PURE__ */ (0, Q.jsx)(OP, {}),
							/* @__PURE__ */ (0, Q.jsx)(VN, {
								variant: i,
								globalResourceCountConfig: {
									areNoResourcesAvailable: u,
									setAreNoResourcesAvailable: d
								}
							}, `${t}-${e}-${n}-${r}-table`)
						] }) : null;
					})()
				})]
			})
		})
	}), !!i[UN.SHOW_CUSTOM_VIEW_MODAL] && /* @__PURE__ */ (0, Q.jsx)(fP, {
		handleClose: _,
		refetchCustomViews: async (n) => {
			try {
				let { data: r } = await h(), i = r?.find((e) => e.name === n);
				i && o(vj(Y(B.COST_VISIBILITY_BREAKDOWN_DETAIL, {
					breakdownViewType: t,
					itemName: e,
					view: BA.CUSTOM_VIEWS,
					detail: i.identifier
				}), c, a));
			} catch (e) {
				K(e);
			}
		},
		customViews: f || [],
		customViewError: m,
		isLoadingViewData: g
	})] });
}, FP = {
	[L.APPLICATIONS]: UA.APPLICATION,
	[L.CLUSTERS]: UA.CLUSTER,
	[L.ENVIRONMENTS]: UA.ENVIRONMENT,
	[L.PROJECTS]: UA.PROJECT
}, IP = ({ analyticsAction: e }) => {
	let { breakdownViewType: t } = Z(), { searchParams: n } = jf(), r = X();
	if (t !== L.CLUSTERS && t !== L.ENVIRONMENTS) return null;
	let i = Object.values(ll).map((e) => ({
		label: `${e} ${t === L.CLUSTERS ? "Clusters" : "Environments"}`,
		value: e
	})), a = n[VA.typeFilter], o = i.find((e) => e.value === a) || {
		label: `All ${t === L.CLUSTERS ? "Clusters" : "Environments"}`,
		value: ll.ALL
	};
	return /* @__PURE__ */ (0, Q.jsx)(V, {
		inputId: "prod-non-prod-select",
		value: o,
		options: i,
		onChange: (i) => {
			e && Vd({
				category: "cost_visibility_prod_non_prod_select",
				action: `${e}_BY_${i.value.toUpperCase()}_${t.toUpperCase()}`
			});
			let a = structuredClone(n);
			r({ search: new URLSearchParams({
				...a,
				[VA.typeFilter]: i.value
			}).toString() });
		}
	});
}, LP = () => {
	let { serverMode: e } = Tf(), { breakdownViewType: t } = Z(), n = X(), { searchParams: r } = jf(), [i, a] = j(!1), o = e === Ml.EA_ONLY, s = Object.values(L).map((e) => ({
		label: Au(e),
		value: e
	})), { currency: c, timeRange: l, typeFilter: u } = tM(), d = (e) => {
		Vd({
			category: "cost_visibility_breakdown_segment",
			action: `COST_BREAKDOWN_BY_${e.value.toUpperCase()}`
		}), n(Rd(Y(B.COST_VISIBILITY_BREAKDOWN.ROUTE, { breakdownViewType: String(e.value) }), {
			[zA.TIME_RANGE]: r[zA.TIME_RANGE],
			[zA.CURRENCY]: r[zA.CURRENCY]
		}));
	}, { isLoading: f, data: p, error: m, refetch: h } = q({
		queryKey: [
			"getCostBreakdownViewDetail",
			t,
			c,
			l,
			u
		],
		queryFn: ({ signal: e }) => qA({
			...Bj({
				subResource: null,
				breakdownViewType: t,
				timeRange: l,
				currency: c,
				typeFilter: u,
				resourceName: null,
				isCustomView: !1,
				trendDetailType: "total_only"
			}),
			signal: e
		}),
		select: (e) => Hj(zj(e.result, l), { variant: "expanded" }, l, c)
	});
	return /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox-col dc__overflow-auto flex-grow-1",
		children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "px-16 pt-16 flexbox-col dc__gap-16",
			children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: `flex ${o ? "right" : "dc__content-space"}`,
				children: [!o && /* @__PURE__ */ (0, Q.jsx)(Bl, {
					name: "cost-breakdown-view-type",
					segments: s,
					value: t,
					onChange: d
				}), /* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "flexbox dc__gap-8",
					children: [
						t === L.CLUSTERS || t === L.ENVIRONMENTS ? /* @__PURE__ */ (0, Q.jsx)(IP, { analyticsAction: "COST_BREAKDOWN" }) : null,
						/* @__PURE__ */ (0, Q.jsx)(_M, {}),
						/* @__PURE__ */ (0, Q.jsx)(sM, { analyticsAction: "COST_BREAKDOWN_TIMEFRAME" })
					]
				})]
			}), !i && /* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "dc__grid-cols-2 dc__gap-12 cost-breakdown-view__charts-container",
				children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "dc__grid dc__gap-12",
					style: { gridTemplateRows: "1fr min-content" },
					children: [/* @__PURE__ */ (0, Q.jsx)(mP, { ...f ? { isLoading: !0 } : {
						...p?.costTrendProps,
						errorConfig: m ? { refetch: h } : null
					} }), /* @__PURE__ */ (0, Q.jsx)(_P, { ...f || m ? {
						variant: "expanded",
						props: { isLoading: !0 }
					} : p.potentialSavingsCardProps })]
				}), /* @__PURE__ */ (0, Q.jsx)(wP, {
					breakdownViewType: t,
					resourceName: null
				})]
			})]
		}), /* @__PURE__ */ (0, Q.jsx)("div", {
			className: "dc__position-sticky dc__top-0 bg__primary dc__zi-1 h-100 dc__no-shrink flexbox-col",
			children: /* @__PURE__ */ (0, Q.jsx)(VN, {
				variant: FP[t],
				globalResourceCountConfig: {
					areNoResourcesAvailable: i,
					setAreNoResourcesAvailable: a
				}
			}, `${t}-table`)
		})]
	});
}, RP = () => {
	let e = X(), { serverMode: t } = Tf(), { breakdownViewType: n } = Z(), { isCostVisibilityEnabled: r, metadataError: i, isLoadingMetadata: a, refetchCostVisibilityMetadata: o } = Gj();
	return k(() => {
		t === Ml.EA_ONLY && n !== L.CLUSTERS && e(B.COST_VISIBILITY_BREAKDOWN.CLUSTERS);
	}, [n]), a ? /* @__PURE__ */ (0, Q.jsx)(_N, {
		pathPattern: B.COST_VISIBILITY_BREAKDOWN.ROUTE,
		children: /* @__PURE__ */ (0, Q.jsx)("div", {
			className: "flex column flex-grow-1",
			children: /* @__PURE__ */ (0, Q.jsx)(Ms, {})
		})
	}) : i ? /* @__PURE__ */ (0, Q.jsx)(_N, {
		pathPattern: B.COST_VISIBILITY_BREAKDOWN.ROUTE,
		children: /* @__PURE__ */ (0, Q.jsx)(Ks, {
			code: i.code,
			reload: o
		})
	}) : r ? /* @__PURE__ */ (0, Q.jsxs)(qf, { children: [/* @__PURE__ */ (0, Q.jsx)(J, {
		path: vo.COST_VISIBILITY.BREAKDOWN.DETAIL,
		element: /* @__PURE__ */ (0, Q.jsx)(PP, {})
	}, vo.COST_VISIBILITY.BREAKDOWN.DETAIL), /* @__PURE__ */ (0, Q.jsx)(J, {
		index: !0,
		element: /* @__PURE__ */ (0, Q.jsx)(_N, {
			pathPattern: B.COST_VISIBILITY_BREAKDOWN.ROUTE,
			children: /* @__PURE__ */ (0, Q.jsx)(LP, {})
		})
	})] }) : /* @__PURE__ */ (0, Q.jsx)(_N, {
		pathPattern: B.COST_VISIBILITY_BREAKDOWN.ROUTE,
		children: /* @__PURE__ */ (0, Q.jsx)(vM, {})
	});
}, zP = (e) => e?.enabled ? e.installationStatus === "Installing" || e.installationStatus === "Upgrading" ? {
	style: P.warning,
	text: e.installationStatus
} : e.installationStatus === "Failed" ? {
	style: P.negative,
	text: "Installation Failed"
} : {
	style: P.neutral,
	text: "Enabled"
} : {
	style: P.neutral,
	text: "Off"
}, BP = () => {
	let { searchParams: e } = jf(), t = X(), { data: n, isFetching: r, error: i, refetch: a } = q({
		queryKey: ["get-cluster-list"],
		queryFn: ({ signal: e }) => nd(null, e),
		select: (e) => (e || []).filter((e) => !e.isVirtualCluster)
	}), { renderClusterForm: o } = gN(), s = +e.clusterId, c = (n || []).find((e) => e.clusterId === s), l = (e) => () => {
		Vd({
			category: "cost-visibility-cluster-config",
			action: "COST_CONFIG_CLUSTER_CONFIG"
		}), t({ search: `?clusterId=${e}` });
	}, u = () => {
		t({ search: "" });
	}, d = async () => {
		await a();
	}, f = (e, t) => {
		let n = zP(e?.costModuleConfig);
		return /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "py-12 px-16 dc__align-items-center dc__content-space flexbox dc__gap-16",
			children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox dc__gap-16 dc__align-items-center",
				children: [r ? /* @__PURE__ */ (0, Q.jsx)("div", { className: "shimmer-loading icon-dim-24" }) : /* @__PURE__ */ (0, Q.jsx)(Jo, {
					clusterStatus: e.status,
					isVirtualCluster: e.isVirtualCluster
				}), /* @__PURE__ */ (0, Q.jsx)("div", {
					className: `flexbox-col ${r ? "dc__gap-4" : ""}`,
					children: r ? /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsx)("div", { className: "shimmer-loading h-18 w-120" }), /* @__PURE__ */ (0, Q.jsx)("div", { className: "shimmer-loading h-16 w-180" })] }) : /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsx)(W, {
						content: e.clusterName,
						children: /* @__PURE__ */ (0, Q.jsx)("span", {
							className: "fs-13 fw-4 lh-1-5 dc__truncate",
							children: e.clusterName
						})
					}), /* @__PURE__ */ (0, Q.jsx)("span", {
						className: "cn-7 fs-12 fw-4 lh-1-5",
						children: e.isProd ? "Production" : "Non Production"
					})] })
				})]
			}), /* @__PURE__ */ (0, Q.jsx)(M, {
				dataTestId: "open-cluster-edit-modal",
				style: n.style,
				text: n.text,
				onClick: l(e?.clusterId),
				endIcon: /* @__PURE__ */ (0, Q.jsx)(z, {
					name: "ic-caret-right",
					color: null
				}),
				isLoading: r,
				variant: F.borderLess,
				size: I.medium
			})]
		}, t);
	};
	return /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flex-grow-1 h-100 dc__overflow-hidden flexbox-col dc__content-space bg__secondary",
		children: [/* @__PURE__ */ (0, Q.jsx)(wM, { pathPattern: B.COST_VISIBILITY_CONFIGURATIONS }), /* @__PURE__ */ (0, Q.jsx)("div", {
			className: "flexbox dc__content-center p-16 flex-grow-1 dc__overflow-auto",
			children: /* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox-col dc__gap-20 flex-grow-1 dc__mxw-600",
				children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "flexbox-col dc__gap-12",
					children: [/* @__PURE__ */ (0, Q.jsx)("h2", {
						className: "m-0 cn-9 fs-15 fw-6 lh-1-5",
						children: "Preference"
					}), /* @__PURE__ */ (0, Q.jsxs)("div", {
						className: "flexbox dc__content-space dc__gap-16 px-16 py-12 dc__align-items-center br-8 border__secondary bg__primary",
						children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
							className: "flexbox-col",
							children: [/* @__PURE__ */ (0, Q.jsx)("h3", {
								className: "m-0 cn-9 fs-13 fw-6 lh-1-5",
								children: "Currency (Default)"
							}), /* @__PURE__ */ (0, Q.jsx)("p", {
								className: "m-0 cn-7 fs-12 fw-4 lh-1-5",
								children: "Cost will be displayed in the default currency"
							})]
						}), /* @__PURE__ */ (0, Q.jsx)(_M, {
							useDefaultValue: !0,
							variant: Hl.COMPACT,
							analyticsAction: "COST_CONFIG_CURRENCY_CHANGED"
						})]
					})]
				}), /* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "flexbox-col dc__gap-12",
					children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
						className: "flexbox dc__content-space dc__align-items-center",
						children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
							className: "flexbox-col",
							children: [/* @__PURE__ */ (0, Q.jsx)("h2", {
								className: "m-0 cn-9 fs-15 fw-6 lh-1-5",
								children: "Cost tracking"
							}), /* @__PURE__ */ (0, Q.jsx)("p", {
								className: "m-0 cn-7 fs-13 fw-4 lh-1-5",
								children: "Manage infra cost tracking for connected clusters"
							})]
						}), /* @__PURE__ */ (0, Q.jsx)(M, {
							dataTestId: "reload-cluster-list",
							icon: /* @__PURE__ */ (0, Q.jsx)(z, {
								name: "ic-arrow-clockwise",
								color: null
							}),
							onClick: d,
							isLoading: r,
							ariaLabel: "Reload Cluster List",
							showAriaLabelInTippy: !1,
							variant: F.borderLess,
							size: I.medium,
							style: P.neutral
						})]
					}), /* @__PURE__ */ (0, Q.jsx)("div", {
						className: "flexbox-col br-8 border__secondary bg__primary",
						children: r ? /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [
							f(null, 1),
							f(null, 2),
							f(null, 3)
						] }) : i ? /* @__PURE__ */ (0, Q.jsx)(lc, {
							title: "Error loading cluster list",
							subTitle: i.errors?.[0]?.userMessage || "Something went wrong while fetching the cluster list",
							description: "",
							reload: a
						}) : n.length === 0 ? /* @__PURE__ */ (0, Q.jsx)(R, {
							title: "No clusters found",
							subTitle: "No clusters are connected to track infra costs."
						}) : n.map((e) => f(e, e.clusterId))
					})]
				})]
			})
		})]
	}), !!s && /* @__PURE__ */ (0, Q.jsx)(Rs, {
		position: "right",
		width: "1000px",
		onClose: u,
		onEscape: u,
		children: /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox-col h-100 bg__primary",
			onClick: uf,
			children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flex flex-align-center dc__border-bottom flex-justify bg__primary py-12 px-20",
				children: [/* @__PURE__ */ (0, Q.jsx)("h2", {
					"data-testid": "add_cluster_header",
					className: "fs-16 fw-6 lh-1-43 m-0 title-padding fw-6 fs-16 cn-9",
					children: "Edit Cluster"
				}), /* @__PURE__ */ (0, Q.jsx)(M, {
					icon: /* @__PURE__ */ (0, Q.jsx)(z, {
						name: "ic-close-large",
						color: null
					}),
					dataTestId: "header-close-icon",
					style: P.negativeGrey,
					size: I.xs,
					variant: F.borderLess,
					ariaLabel: "Close edit cluster drawer",
					onClick: u,
					showAriaLabelInTippy: !1
				})]
			}), c ? o({
				clusterDetails: c,
				handleClose: u,
				handleSuccess: a
			}) : /* @__PURE__ */ (0, Q.jsx)(R, { title: "Cluster not found" })]
		})
	})] });
}, VP = ({ isLoading: e, category: t, value: n, delta: r, yAxisValues: i, xAxisLabels: a, additionalContext: o }) => {
	let { currency: s } = tM(), c = A(() => e ? null : {
		id: `at-a-glance-${t.toLowerCase()}-chart`,
		type: "area",
		datasets: {
			datasetName: t,
			color: $A[hj(r)],
			yAxisValues: i
		},
		hideAxis: !0,
		xAxisLabels: a
	}, [
		r,
		t,
		i,
		a
	]);
	return /* @__PURE__ */ (0, Q.jsxs)(Ho, {
		shimmerVariant: "A",
		isLoading: e,
		variant: "secondary--outlined",
		children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox p-16 dc__gap-12 dc__overflow-hidden flex-grow-1",
			children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox-col dc__gap-4 flex-grow-1",
				children: [/* @__PURE__ */ (0, Q.jsx)(W, {
					content: t,
					children: /* @__PURE__ */ (0, Q.jsx)("span", {
						className: "fs-13 fw-4 cn-9 lh-1-5 dc__truncate",
						children: t
					})
				}), /* @__PURE__ */ (0, Q.jsx)(W, {
					content: n,
					children: /* @__PURE__ */ (0, Q.jsx)("span", {
						className: "dc__truncate font-ibm-plex-sans fw-6 lh-1-5 fs-24 cn-9",
						children: n
					})
				})]
			}), /* @__PURE__ */ (0, Q.jsx)("div", {
				className: "w-120",
				children: /* @__PURE__ */ (0, Q.jsx)(Uo, {
					...c,
					yScaleTickFormat: (e) => Uu(Number(e), s),
					tooltipConfig: { datasetValueFormatter: (e) => Uu(e, s) }
				})
			})]
		}), o && /* @__PURE__ */ (0, Q.jsx)("div", {
			className: "border__secondary--top py-12 px-16 flexbox dc__gap-12 dc__content-space dc__align-items-center",
			children: /* @__PURE__ */ (0, Q.jsx)("span", {
				className: "fs-12 cn-7 fw-4 lh-1-5",
				children: o
			})
		})]
	});
}, HP = (e) => {
	let t = e.summary;
	if (!t?.overall) return {
		datasets: [],
		xAxisLabels: []
	};
	let { plotPoints: n } = t.overall, r = n.map((e) => e.label);
	return {
		datasets: [
			{
				datasetName: "Total",
				yAxisValues: t.overall.plotPoints.map((e) => e.value),
				color: "CharcoalGray500"
			},
			{
				datasetName: "CPU",
				yAxisValues: t.cpu.plotPoints.map((e) => e.value),
				color: QA[$.CPU]
			},
			{
				datasetName: "Memory",
				yAxisValues: t.memory.plotPoints.map((e) => e.value),
				color: QA[$.MEMORY]
			},
			{
				datasetName: "Storage",
				yAxisValues: t.storage.plotPoints.map((e) => e.value),
				color: QA[$.STORAGE]
			},
			{
				datasetName: "Network",
				yAxisValues: t.network.plotPoints.map((e) => e.value),
				color: QA[$.NETWORK]
			},
			{
				datasetName: "GPU",
				yAxisValues: t.gpu.plotPoints.map((e) => e.value),
				color: QA[$.GPU]
			}
		],
		xAxisLabels: r
	};
}, UP = ({ cardVariant: e }) => {
	let { currency: t } = tM(), [n, r] = j(tj), { isFetching: i, data: a, error: o, refetch: s } = q({
		queryKey: [
			t,
			n,
			"cost-trend-by-time"
		],
		queryFn: ({ signal: e }) => qA({
			...Bj({
				breakdownViewType: L.CLUSTERS,
				currency: t,
				timeRange: n,
				resourceName: null,
				isCustomView: !1,
				subResource: null,
				typeFilter: null,
				trendDetailType: "all"
			}),
			signal: e
		}),
		select: ({ result: e }) => HP(zj(e, n))
	});
	return /* @__PURE__ */ (0, Q.jsxs)(Ho, {
		variant: e,
		children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox dc__gap-4 px-16 py-12 border__secondary--bottom",
			children: [/* @__PURE__ */ (0, Q.jsx)("span", {
				className: "fs-13 lh-1-5 fw-6",
				children: "Cost trend for"
			}), /* @__PURE__ */ (0, Q.jsx)(sM, {
				stateConfig: {
					timeRange: n,
					setTimeRange: r
				},
				variant: Hl.COMPACT,
				size: I.small,
				analyticsAction: "COST_OVERVIEW_COST_TREND_TIMEFRAME"
			})]
		}), /* @__PURE__ */ (0, Q.jsx)("div", {
			style: { height: "456px" },
			className: "p-16",
			children: i ? /* @__PURE__ */ (0, Q.jsx)("div", { className: "shimmer w-100 h-100" }) : o ? /* @__PURE__ */ (0, Q.jsx)(lc, {
				reload: s,
				rootClassName: "h-100"
			}) : /* @__PURE__ */ (0, Q.jsx)(Uo, {
				id: "cost-trend-overview-chart",
				type: "line",
				...a,
				yScaleTickFormat: (e) => Uu(Number(e), t),
				xScaleTickFormat: yj(n),
				tooltipConfig: { datasetValueFormatter: (e) => Uu(e, t) }
			})
		})]
	});
}, WP = ({ name: e, totalCost: t, currency: n, timeRange: r, efficiencyPercent: i, breakdownViewType: a }) => {
	let o = X(), s = () => {
		o(vj(Y(B.COST_VISIBILITY_BREAKDOWN_DETAIL, {
			breakdownViewType: a ?? L.CLUSTERS,
			view: BA.OVERVIEW,
			itemName: e,
			detail: null
		}), r, n));
	};
	return /* @__PURE__ */ (0, Q.jsxs)("div", {
		onClick: s,
		tabIndex: 0,
		role: "button",
		onKeyDown: (e) => {
			(e.key === "Enter" || e.key === " ") && s();
		},
		className: "flexbox px-12 py-8 br-4 dc__align-start dc__gap-12 dc__hover-n50 dc__transition--background dc__tab-focus",
		children: [
			/* @__PURE__ */ (0, Q.jsx)(z, {
				name: "ic-coins",
				color: "B500",
				size: 20
			}),
			/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flex-grow-1 flexbox-col",
				children: [/* @__PURE__ */ (0, Q.jsx)("span", {
					className: "fs-13 fw-4 cn-9 lh-1-5",
					children: e
				}), /* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "fs-12 fw-4 cn-7 lh-1-5",
					children: [
						"Cost\xA0",
						aM[r].toLowerCase(),
						"\xA0",
						Uu(t, n)
					]
				})]
			}),
			/* @__PURE__ */ (0, Q.jsx)("span", {
				className: "cn-9 fs-13 fw-6 lh-1-5",
				children: i
			})
		]
	});
}, GP = (e) => e.map((e) => ({
	name: e.name,
	totalCost: e.totalCost,
	efficiencyPercent: `${(100 - e.savingsPercent).toFixed(1)}%`
})), KP = ({ breakdownViewType: e, timeRange: t }) => {
	let { view: n } = Z(), { currency: r, typeFilter: i } = tM(), { isLoading: a, data: o, error: s, refetch: c } = q({
		queryKey: [
			"mostEfficientResources",
			e,
			i,
			r,
			t,
			n
		],
		queryFn: ({ signal: n }) => JA({
			...Vj({
				pageSize: 5,
				offset: 0,
				isCustomView: !1,
				breakdownViewType: e,
				resourceName: null,
				subResource: null,
				currency: r,
				searchKey: "",
				sortBy: "efficiencyPercentage",
				sortOrder: Jl.DESC,
				timeRange: t,
				typeFilter: i
			}),
			signal: n
		}),
		select: (e) => GP(e?.result?.overallBreakdown?.items ?? [])
	});
	return s ? /* @__PURE__ */ (0, Q.jsx)(lc, {
		reload: c,
		rootClassName: "h-100"
	}) : /* @__PURE__ */ (0, Q.jsx)("div", {
		className: "p-8 flexbox-col dc__overflow-auto",
		children: a ? /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsx)("div", {
			className: "shimmer br-4 h-20 mb-8",
			style: { width: "60%" }
		}), /* @__PURE__ */ (0, Q.jsx)("div", {
			className: "shimmer br-4 h-20",
			style: { width: "40%" }
		})] }) : o.map((n, i) => /* @__PURE__ */ (0, Q.jsx)(WP, {
			name: n.name,
			totalCost: n.totalCost,
			efficiencyPercent: n.efficiencyPercent,
			currency: r,
			timeRange: t,
			breakdownViewType: e
		}, i))
	});
}, qP = ({ cardVariant: e }) => {
	let { serverMode: t } = Tf(), [n, r] = j(tj), [i, a] = j(t === Ml.EA_ONLY ? L.CLUSTERS : L.PROJECTS), o = A(() => rj.find((e) => e.value === i), [i]);
	return /* @__PURE__ */ (0, Q.jsxs)(Ho, {
		variant: e,
		children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox py-12 px-16 dc__gap-4 border__secondary--bottom",
			children: [
				/* @__PURE__ */ (0, Q.jsx)("span", {
					className: "fs-13 lh-1-5 fw-6 cn-9",
					children: "Most cost efficient"
				}),
				t === Ml.EA_ONLY ? /* @__PURE__ */ (0, Q.jsx)("span", {
					className: "fs-13 lh-1-5 fw-6 cn-9",
					children: "Cluster"
				}) : /* @__PURE__ */ (0, Q.jsx)(V, {
					inputId: "most-efficient-overview-cost-breakdown-select",
					value: o,
					onChange: (e) => {
						Vd({
							category: "cost_visibility_most_efficient",
							action: `COST_OVERVIEW_COST_EFFICIENT_${e.value.toUpperCase()}`
						}), a(e.value);
					},
					options: rj,
					variant: Hl.COMPACT,
					size: I.small,
					shouldMenuAlignRight: !0
				}),
				/* @__PURE__ */ (0, Q.jsx)("span", {
					className: "fs-13 lh-1-5 fw-6 cn-9",
					children: "in"
				}),
				/* @__PURE__ */ (0, Q.jsx)(sM, {
					stateConfig: {
						timeRange: n,
						setTimeRange: r
					},
					variant: Hl.COMPACT,
					size: I.small,
					analyticsAction: "COST_OVERVIEW_COST_EFFICIENT_TIMEFRAME"
				})
			]
		}), /* @__PURE__ */ (0, Q.jsx)(KP, {
			breakdownViewType: i,
			timeRange: n
		})]
	});
}, JP = (e, t) => !e || !e.totalCount || !e.items ? {
	totalCount: 0,
	items: []
} : {
	totalCount: e.totalCount,
	items: e.items.map((e) => ({
		name: e.name,
		cost: Uu(e.potentialSavings, t),
		potentialSavings: Math.round(e.savingsPercent)
	}))
}, YP = 5, XP = ({ category: e, currency: t, timeRange: n = RA.LAST_30_DAYS, typeFilter: r = ll.ALL, isCurrencyLoading: i = !1 }) => {
	let { isFetching: a, isError: o, data: s, refetch: c } = q({
		queryKey: [
			Kj,
			e,
			t,
			r,
			n,
			i
		],
		queryFn: ({ signal: e }) => JA({
			...Vj({
				breakdownViewType: L.CLUSTERS,
				resourceName: null,
				isCustomView: !1,
				subResource: null,
				currency: t,
				timeRange: n,
				typeFilter: r,
				offset: 0,
				pageSize: YP,
				sortBy: "potentialSavings",
				sortOrder: Jl.DESC,
				searchKey: ""
			}),
			signal: e
		}),
		select: (e) => JP(e?.result?.overallBreakdown ?? {
			totalCount: 0,
			items: []
		}, t),
		enabled: !i
	});
	return /* @__PURE__ */ (0, Q.jsxs)(Ho, {
		variant: "secondary--outlined",
		children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "py-12 px-16 flexbox dc__gap-8 border__secondary--bottom",
			children: [/* @__PURE__ */ (0, Q.jsx)("h4", {
				className: "fw-6 fs-13 m-0 cn-9 lh-1-5",
				children: "Top saving opportunities"
			}), /* @__PURE__ */ (0, Q.jsx)(z, {
				tooltipProps: {
					alwaysShowTippyOnHover: !0,
					content: `Cluster list sorted by highest potential savings based on ${aM[n].toLowerCase()} of usage`
				},
				name: "ic-help-outline",
				size: 16,
				color: "N700"
			})]
		}), /* @__PURE__ */ (0, Q.jsx)("div", {
			className: "flexbox-col p-8",
			children: a || i ? [
				,
				,
				,
			].fill(0).map((e, t) => /* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "dc__grid py-8 px-12 dc__gap-12",
				style: { gridTemplateColumns: "1fr 48px" },
				children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "flexbox-col flex-grow-1",
					children: [/* @__PURE__ */ (0, Q.jsx)("div", { className: "shimmer-loading h-16 w-75 br-4 mb-6" }), /* @__PURE__ */ (0, Q.jsx)("div", { className: "shimmer-loading h-14 w-50 br-4" })]
				}), /* @__PURE__ */ (0, Q.jsx)("div", { className: "shimmer-loading h-16 w-100 br-4" })]
			}, `shimmer-${t}`)) : o ? /* @__PURE__ */ (0, Q.jsx)(lc, {
				subTitle: "",
				reload: c
			}) : s.items.length ? /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [s.items.map((e, t) => /* @__PURE__ */ (0, Q.jsxs)(Wf, {
				to: Y(B.COST_VISIBILITY_BREAKDOWN_DETAIL, {
					breakdownViewType: L.CLUSTERS,
					view: BA.OVERVIEW,
					itemName: e.name,
					detail: null
				}),
				className: "dc__grid py-8 px-12 dc__gap-12 pointer dc__hover-n50 br-8 dc__no-decor dc__transition--background",
				style: { gridTemplateColumns: "1fr 64px" },
				children: [/* @__PURE__ */ (0, Q.jsxs)("span", {
					className: "flexbox-col flex-grow-1",
					children: [/* @__PURE__ */ (0, Q.jsx)("span", {
						className: "fs-13 fw-4 cn-9 lh-1-5 dc__truncate",
						children: e.name
					}), /* @__PURE__ */ (0, Q.jsxs)("span", {
						className: "fs-12 fw-4 cg-7 lh-1-5 dc__truncate",
						children: [
							"Potential savings ",
							e.potentialSavings,
							"%"
						]
					})]
				}), /* @__PURE__ */ (0, Q.jsx)("span", {
					className: "fw-6 lh-1-5 cn-9 font-ibm-plex-sans fs-13 dc__align-right",
					children: e.cost
				})]
			}, t)), s.totalCount > YP && /* @__PURE__ */ (0, Q.jsx)("div", {
				className: "flex border__secondary--top py-8",
				children: /* @__PURE__ */ (0, Q.jsx)(M, {
					dataTestId: "view-all-opportunities",
					text: "View all",
					variant: F.text,
					component: N.link,
					linkProps: { to: B.COST_VISIBILITY_BREAKDOWN.CLUSTERS }
				})
			})] }) : /* @__PURE__ */ (0, Q.jsx)(Ll, {
				iconName: "ic-coins",
				title: "Cost tracking is not enabled",
				subtitle: "Get insights into your infrastructure spending and cost optimization opportunities.",
				buttonConfig: {
					dataTestId: "enable-cost",
					variant: F.secondary,
					text: "Enable cost tracking",
					size: I.xs,
					component: N.link,
					linkProps: { to: B.COST_VISIBILITY_CONFIGURATIONS }
				}
			})
		})]
	});
}, ZP = {
	cpu: "CPU Cost",
	gpu: "GPU Cost",
	memory: "RAM Cost",
	network: "Network Cost",
	storage: "PV Cost",
	overall: "Total Cost"
}, QP = {
	Installed: "enabled",
	"Installation failed": "failed",
	"In Progress": "inProgress",
	"Not enabled": "notEnabled"
}, $P = {
	Installed: "bcg-5",
	"Installation failed": "bcr-5",
	"In Progress": "bco-5",
	"Not enabled": "bcn-5"
}, eF = (e, t, n) => e === "overall" ? aM[n] : t > .01 && t < 100 ? `${t.toFixed(2)}% of total cost` : `No cost ${aM[n].toLowerCase()}`, tF = ({ summary: { cpu: e, gpu: t, memory: n, overall: r, storage: i, network: a } }, o, s) => {
	let { potentialSavingsPercentage: c, potentialSavings: l, recommendedCost: u } = r;
	return {
		atAGlanceCardProps: Object.entries({
			overall: r,
			cpu: e,
			memory: n,
			storage: i,
			gpu: t,
			network: a
		}).map(([e, { totalCost: t, plotPoints: n, trend: i }]) => ({
			category: ZP[e],
			value: Uu(t, s),
			delta: i,
			yAxisValues: n.map(({ value: e }) => e),
			xAxisLabels: n.map(({ label: e }) => e),
			additionalContext: eF(e, t / r.totalCost * 100, o)
		})),
		potentialSavingsCardProp: {
			potentialSavingsPercentage: c,
			recommendedCost: Uu(u, s),
			potentialSavings: Uu(l, s)
		}
	};
}, nF = (e) => (e || []).filter((e) => !e.isVirtualCluster).reduce((e, t) => {
	if (e.total += 1, !t.costModuleConfig?.enabled) return e.notEnabled += 1, e;
	switch (t.costModuleConfig?.installationStatus) {
		case "Success":
			e.enabled += 1;
			break;
		case "Upgrading":
		case "Installing":
			e.inProgress += 1;
			break;
		case "Failed":
			e.failed += 1;
			break;
		case "NotInstalled":
			e.notEnabled += 1;
			break;
		default: break;
	}
	return e;
}, {
	enabled: 0,
	total: 0,
	inProgress: 0,
	failed: 0,
	notEnabled: 0
}), rF = () => {
	let { data: e, isFetching: t, error: n, refetch: r } = q({
		queryKey: ["cost-enablement-info"],
		queryFn: ({ signal: e }) => Gu(e),
		select: ({ result: e }) => nF(e || [])
	});
	return e && e.enabled === e.total ? null : /* @__PURE__ */ (0, Q.jsx)("div", {
		className: "flexbox-col br-8 border__secondary bg__primary",
		children: n ? /* @__PURE__ */ (0, Q.jsx)(lc, { reload: r }) : /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "dc__separated-flexbox dc__separated-flexbox--vertical dc__separated-flexbox--vertical-gap-12 p-16 dc__gap-12",
			children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox-col dc__gap-4",
				children: [/* @__PURE__ */ (0, Q.jsx)("span", {
					className: "fs-13 fw-4 cn-9 lh-1-5",
					children: "Cost visibility enabled for "
				}), t ? /* @__PURE__ */ (0, Q.jsx)("div", { className: "shimmer h-24" }) : /* @__PURE__ */ (0, Q.jsxs)("span", {
					className: "fs-15 fw-6 cn-9 lh-1-5",
					children: [
						e.enabled,
						" of ",
						e.total,
						" Clusters"
					]
				})]
			}), t ? /* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox-col dc__gap-8",
				children: [/* @__PURE__ */ (0, Q.jsx)("div", { className: "shimmer h-12 w-100" }), /* @__PURE__ */ (0, Q.jsx)("div", { className: "shimmer h-12 w-80" })]
			}) : /* @__PURE__ */ (0, Q.jsx)("div", {
				className: "flexbox-col dc__gap-8",
				children: Object.keys(QP).map((t) => /* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "flexbox dc__content-space dc__gap-8 dc__align-items-center",
					children: [
						/* @__PURE__ */ (0, Q.jsx)("div", { className: `icon-dim-12 ${$P[t]} br-4 dc__no-shrink` }),
						/* @__PURE__ */ (0, Q.jsx)("span", {
							className: "flex-grow-1 fs-13 lh-1-5 cn-9 fw-6",
							children: t
						}),
						/* @__PURE__ */ (0, Q.jsxs)("span", {
							className: "dc__no-shrink fs-13 lh-1-5 cn-9 fw-4",
							children: [e[QP[t]], " clusters"]
						})
					]
				}, t))
			})]
		}), /* @__PURE__ */ (0, Q.jsx)("div", {
			className: "flex left py-12 px-16 border__secondary--top",
			children: /* @__PURE__ */ (0, Q.jsx)(M, {
				component: N.link,
				linkProps: { to: B.COST_VISIBILITY_CONFIGURATIONS },
				dataTestId: "cost-overview-go-to-configurations",
				text: "Go to Configurations",
				endIcon: /* @__PURE__ */ (0, Q.jsx)(z, {
					name: "ic-arrow-right",
					color: null
				}),
				variant: F.text,
				onClick: () => {
					Vd({
						category: "cost_visibility_overview",
						action: "COST_OVERVIEW_GO_TO_CONFIGURATIONS"
					});
				}
			})
		})] })
	});
}, iF = () => {
	let [e, t] = j(!0), { currency: n } = tM(), [r, i] = j(tj), { isCostVisibilityEnabled: a, isLoadingMetadata: o, metadataError: s, refetchCostVisibilityMetadata: c } = Gj(), { isLoading: l, data: u, error: d, refetch: f } = q({
		queryKey: [
			r,
			n,
			"getCostVisibilityOverviewCostSummary"
		],
		queryFn: ({ signal: e }) => qA({
			...Bj({
				breakdownViewType: L.CLUSTERS,
				currency: n,
				timeRange: r,
				resourceName: null,
				isCustomView: !1,
				subResource: null,
				typeFilter: null,
				trendDetailType: "all"
			}),
			signal: e
		}),
		select: (e) => tF(zj(e.result, r), r, n)
	}), p = () => {
		t(!1);
	};
	return /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox-col dc__content-space dc__overflow-auto bg__secondary flex-grow-1",
		children: [/* @__PURE__ */ (0, Q.jsx)(wM, { pathPattern: B.COST_VISIBILITY_OVERVIEW }), /* @__PURE__ */ (0, Q.jsx)("div", {
			className: "flexbox-col flex-grow-1 dc__overflow-auto",
			children: o ? /* @__PURE__ */ (0, Q.jsx)("div", {
				className: "flex column flex-grow-1",
				children: /* @__PURE__ */ (0, Q.jsx)(Ms, {})
			}) : s || d ? /* @__PURE__ */ (0, Q.jsx)(Ks, {
				code: s?.code || d?.code,
				reload: s ? c : f,
				on404Redirect: $d
			}) : a ? /* @__PURE__ */ (0, Q.jsxs)("div", {
				className: `flex-grow-1 dc__grid cost-visibility__overview cost-visibility__overview${e ? "--expanded" : "--collapsed"} dc__overflow-auto`,
				children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "flexbox-col dc__content-space dc__overflow-auto",
					children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
						className: "flexbox px-16 py-12 dc__content-space border__secondary--bottom dc__align-items-center",
						children: [/* @__PURE__ */ (0, Q.jsx)("div", {
							className: "flexbox dc__align-items-center dc__gap-8",
							children: /* @__PURE__ */ (0, Q.jsx)(_M, {})
						}), /* @__PURE__ */ (0, Q.jsxs)("div", {
							className: "flexbox dc__gap-6 dc__align-items-center",
							children: [
								/* @__PURE__ */ (0, Q.jsx)("span", {
									className: "fs-13 fw-4 lh-1-5 cn-9",
									children: "Updates every hour"
								}),
								/* @__PURE__ */ (0, Q.jsx)(M, {
									icon: /* @__PURE__ */ (0, Q.jsx)(z, {
										name: "ic-help-outline",
										color: null
									}),
									ariaLabel: "Info on hourly update of cost data",
									showAriaLabelInTippy: !1,
									dataTestId: "cost-visibility-overview-hourly-update-info",
									variant: F.borderLess,
									size: I.xxxs,
									component: N.anchor,
									anchorProps: { href: _s },
									style: P.neutral
								}),
								!e && /* @__PURE__ */ (0, Q.jsx)(M, {
									dataTestId: "cost-visibility-overview-open-sidebar",
									onClick: () => {
										t(!0);
									},
									variant: F.borderLess,
									style: P.neutral,
									icon: /* @__PURE__ */ (0, Q.jsx)(z, {
										name: "ic-right-panel-collapse",
										rotateBy: 180,
										color: null
									}),
									ariaLabel: "Close sidebar",
									showAriaLabelInTippy: !1,
									size: I.medium
								})
							]
						})]
					}), /* @__PURE__ */ (0, Q.jsxs)("div", {
						className: "flexbox-col dc__gap-32 dc__overflow-auto p-20 flex-grow-1",
						children: [
							/* @__PURE__ */ (0, Q.jsxs)("div", {
								className: "flexbox-col dc__gap-16",
								children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
									className: "flexbox dc__content-space dc__gap-16",
									children: [/* @__PURE__ */ (0, Q.jsx)("h3", {
										className: "m-0 cn-9 fs-20 fw-4 lh-1-5",
										children: "At a Glance"
									}), /* @__PURE__ */ (0, Q.jsx)(sM, { stateConfig: {
										timeRange: r,
										setTimeRange: i
									} })]
								}), /* @__PURE__ */ (0, Q.jsx)("div", {
									className: "dc__grid dc__gap-8 at-a-glance",
									children: l ? [
										,
										,
										,
										,
										,
										,
									].fill(0).map((e, t) => /* @__PURE__ */ (0, Q.jsx)(VP, { isLoading: !0 }, t)) : u.atAGlanceCardProps.map((e, t) => /* @__PURE__ */ (0, Q.jsx)(VP, { ...e }, t))
								})]
							}),
							/* @__PURE__ */ (0, Q.jsxs)("div", {
								className: "flexbox-col dc__gap-16",
								children: [/* @__PURE__ */ (0, Q.jsx)("h3", {
									className: "m-0 cn-9 fs-20 fw-4 lh-1-5",
									children: "Potential Savings"
								}), /* @__PURE__ */ (0, Q.jsx)(_P, {
									variant: "expanded",
									props: { ...l ? { isLoading: !0 } : {
										...u.potentialSavingsCardProp,
										cardVariant: "secondary--outlined"
									} }
								})]
							}),
							/* @__PURE__ */ (0, Q.jsxs)("div", {
								className: "flexbox-col dc__gap-16",
								children: [
									/* @__PURE__ */ (0, Q.jsx)("h3", {
										className: "m-0 cn-9 fs-20 fw-4 lh-1-5",
										children: "Track Performance"
									}),
									/* @__PURE__ */ (0, Q.jsx)(UP, { cardVariant: "secondary--outlined" }),
									/* @__PURE__ */ (0, Q.jsx)(hM, { variant: "overview" }),
									/* @__PURE__ */ (0, Q.jsxs)("div", {
										className: "dc__grid dc__grid-cols-2 dc__gap-16 optimality-insights",
										children: [/* @__PURE__ */ (0, Q.jsx)(qP, { cardVariant: "secondary--outlined" }), /* @__PURE__ */ (0, Q.jsx)(wP, { variant: "overview" })]
									})
								]
							})
						]
					})]
				}), e && /* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "flexbox-col dc__content-space dc__overflow-auto border__secondary--left bg__primary",
					children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
						className: "flexbox dc__content-space py-12 px-16 border__secondary--bottom dc__align-items-center",
						children: [/* @__PURE__ */ (0, Q.jsx)("h4", {
							className: "m-0 cn-9 fs-14 fw-6 lh-1-5",
							children: "Actions & Insights"
						}), /* @__PURE__ */ (0, Q.jsx)(M, {
							dataTestId: "cost-visibility-overview-close-sidebar",
							onClick: p,
							variant: F.borderLess,
							style: P.neutral,
							icon: /* @__PURE__ */ (0, Q.jsx)(z, {
								name: "ic-right-panel-collapse",
								color: null
							}),
							ariaLabel: "Close sidebar",
							showAriaLabelInTippy: !1,
							size: I.medium
						})]
					}), /* @__PURE__ */ (0, Q.jsxs)("div", {
						className: "flex-grow-1 dc__overflow-auto flexbox-col p-16 dc__gap-16",
						children: [/* @__PURE__ */ (0, Q.jsx)(rF, {}), /* @__PURE__ */ (0, Q.jsx)(XP, {
							category: L.CLUSTERS,
							currency: n
						})]
					})]
				})]
			}) : /* @__PURE__ */ (0, Q.jsx)(vM, {})
		})]
	});
}, aF = vo.COST_VISIBILITY, oF = () => {
	let { isSuperAdmin: e } = Tf();
	return /* @__PURE__ */ (0, Q.jsxs)(qf, { children: [
		/* @__PURE__ */ (0, Q.jsx)(J, {
			path: aF.OVERVIEW,
			element: /* @__PURE__ */ (0, Q.jsx)(eM, { children: /* @__PURE__ */ (0, Q.jsx)(iF, {}) })
		}, aF.OVERVIEW),
		/* @__PURE__ */ (0, Q.jsx)(J, {
			path: `${aF.BREAKDOWN.ROOT}/*`,
			element: /* @__PURE__ */ (0, Q.jsx)(eM, { children: /* @__PURE__ */ (0, Q.jsx)(RP, {}) })
		}, aF.BREAKDOWN.ROOT),
		/* @__PURE__ */ (0, Q.jsx)(J, {
			path: aF.CONFIGURATIONS,
			element: e ? /* @__PURE__ */ (0, Q.jsx)(eM, { children: /* @__PURE__ */ (0, Q.jsx)(BP, {}) }) : /* @__PURE__ */ (0, Q.jsx)(qs, {})
		}, aF.CONFIGURATIONS),
		/* @__PURE__ */ (0, Q.jsx)(J, {
			path: "*",
			element: /* @__PURE__ */ (0, Q.jsx)(Kf, { to: aF.OVERVIEW })
		})
	] });
}, sF = /* @__PURE__ */ function(e) {
	return e.VOLUME_SNAPSHOT = "volume-snapshot", e.STORAGE_LOCATION = "storage-location", e.RESTORE = "restore", e.BACKUP = "backup", e.BACKUP_SCHEDULE = "backup-schedule", e;
}({}), cF = {
	[sF.RESTORE]: "Restore Deletion Status",
	[sF.BACKUP]: "Backup Deletion Status",
	[sF.BACKUP_SCHEDULE]: "Backup Schedule Deletion Status",
	[sF.STORAGE_LOCATION]: "Storage Location Deletion Status",
	[sF.VOLUME_SNAPSHOT]: "Volume Snapshot Deletion Status"
}, lF = {
	[sF.RESTORE]: {
		title: "Delete Restores",
		subtitle: "",
		confirmationKeyword: "Restores"
	},
	[sF.STORAGE_LOCATION]: {
		title: "Delete Storage Locations",
		subtitle: "",
		confirmationKeyword: "Storage Locations"
	},
	[sF.VOLUME_SNAPSHOT]: {
		title: "Delete Volume Snapshots",
		subtitle: "",
		confirmationKeyword: "Volume Snapshots"
	},
	[sF.BACKUP]: {
		title: "Delete Backups",
		subtitle: "",
		confirmationKeyword: "Backups"
	},
	[sF.BACKUP_SCHEDULE]: {
		title: "Delete Backup Schedules",
		subtitle: "",
		confirmationKeyword: "Backup Schedules"
	}
}, uF = (e) => {
	let { Pending: t, Progressing: n, Completed: r } = e;
	return t || n ? /* @__PURE__ */ (0, Q.jsx)("span", {
		className: "dc__loading-dots",
		children: "Deleting"
	}) : `${r} item(s) deleted successfully`;
}, dF = ({ action: e, selections: t, onClose: n, isBulkSelectionApplied: r, bulkOperationModalData: { reloadDataAfterBulkOperation: i, handleDelete: a } }) => {
	let { handleBulkSelection: o } = _f(), s = A(() => r ? [{
		name: "All Selected Items",
		operation: (e) => a(e.current, "*")
	}] : (Object.values(t) || []).map(({ data: e }) => e).map((e) => ({
		name: e.name,
		operation: (t) => a(t.current, e.id)
	})), [
		e,
		t,
		r
	]);
	return /* @__PURE__ */ (0, Q.jsx)(Oo, {
		operations: s,
		textConfig: {
			prompt: ds,
			resultsHeader: cF[e]
		},
		confirmationModalConfig: {
			title: lF[e].title,
			subtitle: lF[e].subtitle,
			variant: rs.delete,
			buttonConfig: {
				primaryButtonConfig: { text: "Initiate Delete" },
				secondaryButtonConfig: { text: "Cancel" }
			},
			confirmationConfig: {
				identifier: `${e}-confirmation`,
				confirmationKeyword: lF[e].confirmationKeyword
			}
		},
		handleModalClose: n,
		handleReloadDataAfterBulkOperation: () => {
			o({ action: Ao.CLEAR_ALL_SELECTIONS }), i();
		},
		getResultsChartSummaryText: uF
	});
}, fF = ({ children: e }) => /* @__PURE__ */ (0, Q.jsx)("div", {
	className: "flexbox-col dc__gap-16 p-20 br-8 border__secondary bg__primary",
	children: e
}), pF = ({ heading: e, subHeading: t, children: n }) => /* @__PURE__ */ (0, Q.jsxs)("div", {
	className: "flexbox dc__content-space dc__gap-16 dc__align-items-center",
	children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox-col",
		children: [/* @__PURE__ */ (0, Q.jsx)("span", {
			className: "cn-9 fs-13 fw-4 lh-1-5",
			children: e
		}), /* @__PURE__ */ (0, Q.jsx)("span", {
			className: "cn-7 fs-12 fw-4 lh-1-5",
			children: t
		})]
	}), n]
}), mF = /* @__PURE__ */ function(e) {
	return e.EQUALS = "Equals", e.EXISTS = "Exists", e.DOES_NOT_EXIST = "DoesNotExist", e.IN = "In", e.NOT_IN = "NotIn", e;
}({}), hF = /* @__PURE__ */ function(e) {
	return e.KEY = "key", e.OPERATOR = "operator", e.VALUE = "value", e;
}({}), gF = /* @__PURE__ */ function(e) {
	return e.IN = "In", e.NOT_IN = "NotIn", e.EXISTS = "Exists", e.DOES_NOT_EXIST = "DoesNotExist", e;
}({}), _F = mF.EQUALS, vF = [
	{
		label: "Key",
		key: hF.KEY,
		width: "264px"
	},
	{
		label: "Operator",
		key: hF.OPERATOR,
		width: "140px"
	},
	{
		label: "Value",
		key: hF.VALUE,
		width: "1fr"
	}
], yF = [mF.EXISTS, mF.DOES_NOT_EXIST], bF = {
	[mF.DOES_NOT_EXIST]: gF.DOES_NOT_EXIST,
	[mF.EXISTS]: gF.EXISTS,
	[mF.IN]: gF.IN,
	[mF.NOT_IN]: gF.NOT_IN
}, xF = {
	[gF.DOES_NOT_EXIST]: mF.DOES_NOT_EXIST,
	[gF.EXISTS]: mF.EXISTS,
	[gF.IN]: mF.IN,
	[gF.NOT_IN]: mF.NOT_IN
}, SF = () => ({
	key: "",
	value: "",
	operator: _F,
	id: Id()
}), CF = (e) => ({
	data: {
		[hF.KEY]: {
			value: e?.key || "",
			type: Vs.TEXT,
			props: { placeholder: "Key" }
		},
		[hF.OPERATOR]: {
			value: e?.operator || mF.EQUALS,
			type: Vs.DROPDOWN,
			props: {
				options: Object.values(mF).map((e) => ({
					label: e,
					value: e
				})),
				placeholder: "Select operator"
			}
		},
		[hF.VALUE]: {
			value: e?.value || "",
			type: Vs.TEXT,
			disabled: yF.includes(e?.operator),
			tooltip: { content: yF.includes(e?.operator) ? "Value not required for this operator" : "" },
			props: { placeholder: "Enter value or variable" }
		}
	},
	id: e?.id || Id()
}), wF = (e) => e.reduce((e, t) => {
	let n = t.key?.trim();
	if (!n || !t.operator) return e;
	if (t.operator === mF.EQUALS) e.matchLabels[n] = t.value.trim();
	else {
		let r = yF.includes(t.operator) ? {
			key: n,
			operator: bF[t.operator]
		} : {
			key: n,
			operator: bF[t.operator],
			values: t.value.trim().split(",").map((e) => e.trim())
		};
		e.matchExpressions.push(r);
	}
	return e;
}, {
	matchLabels: {},
	matchExpressions: []
}), TF = (e) => {
	let t = [];
	return Object.entries(e.matchLabels || {}).forEach(([e, n]) => {
		!e || !n || t.push({
			key: e,
			value: n,
			operator: mF.EQUALS,
			id: Id()
		});
	}), (e.matchExpressions || []).forEach((e) => {
		let n = xF[e.operator];
		if (!(!n || !e.key)) if (yF.includes(n)) {
			let r = n;
			t.push({
				key: e.key,
				operator: r,
				id: Id()
			});
		} else {
			let r = n;
			t.push({
				key: e.key,
				value: (e.values || []).join(", "),
				operator: r,
				id: Id()
			});
		}
	}), t;
}, EF = ({ labelSelectors: e, orLabelSelectors: t }) => {
	let n = (t || []).concat([e]).map(wF).filter((e) => e.matchExpressions.length > 0 || Object.keys(e.matchLabels).length > 0);
	return {
		labelSelectors: n.length === 1 ? n[0] : void 0,
		orLabelSelectors: n.length > 1 ? n : void 0
	};
}, DF = ({ selectors: e, handleSelectorChange: t, shouldDeleteSelectorGroupOnEmpty: n }) => {
	let r = e.map(CF);
	return /* @__PURE__ */ (0, Q.jsx)(Bs, {
		headers: vF,
		rows: r,
		onRowAdd: () => {
			t([SF(), ...e]);
		},
		onRowEdit: (n, r, i) => {
			t(e.map((e) => {
				if (e.id === n.id) {
					let t = { ...e };
					switch (r) {
						case hF.KEY:
							t.key = i || "";
							break;
						case hF.VALUE:
							t.value = i || "";
							break;
						case hF.OPERATOR: {
							let e = i || _F;
							yF.includes(e) && (t.value = ""), t.operator = e;
							break;
						}
						default: break;
					}
					return t;
				}
				return e;
			}));
		},
		onRowDelete: (r) => {
			let i = e.length === 1;
			if (i && n) {
				t(null);
				return;
			}
			t(i ? [{
				id: r.id,
				key: "",
				value: "",
				operator: _F
			}] : e.filter((e) => e.id !== r.id));
		},
		shouldAutoFocusOnMount: !1
	});
}, OF = ({ labelSelectors: e, handleLabelSelectorChange: t, orLabelSelectors: n, handleOrLabelSelectorsChange: r }) => {
	let i = (e) => (t) => {
		if (!t) {
			r(n.filter((t, n) => n !== e));
			return;
		}
		r(n.map((n, r) => r === e ? t : n));
	};
	return /* @__PURE__ */ (0, Q.jsxs)(fF, { children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox-col dc__gap-2",
		children: [/* @__PURE__ */ (0, Q.jsx)("span", {
			className: "cn-9 fs-14 fw-6 lh-1-5",
			children: "Filter resources using label selectors"
		}), /* @__PURE__ */ (0, Q.jsx)("span", {
			className: "cn-7 fs-12 fw-4 lh-18",
			children: "Use label selectors to define precise resource filters. Labels within the same group are evaluated with AND logic, and separate groups are evaluated with OR logic. The 'in' and 'not in' operators accept multiple comma-separated values."
		})]
	}), /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox-col dc__gap-12",
		children: [
			/* @__PURE__ */ (0, Q.jsx)(DF, {
				selectors: e,
				handleSelectorChange: t
			}),
			/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox dc__gap-8 dc__align-items-center",
				children: [/* @__PURE__ */ (0, Q.jsx)("span", {
					className: "cn-7 fs-13 fw-6 lh-1-5",
					children: "OR"
				}), /* @__PURE__ */ (0, Q.jsx)("div", { className: "divider divider--secondary w-100" })]
			}),
			n.map((e, t) => /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsx)("div", {
				className: "flexbox-col dc__gap-12",
				children: /* @__PURE__ */ (0, Q.jsx)(DF, {
					selectors: e,
					handleSelectorChange: i(t),
					shouldDeleteSelectorGroupOnEmpty: !0
				})
			}, t), /* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox dc__gap-8 dc__align-items-center",
				children: [/* @__PURE__ */ (0, Q.jsx)("span", {
					className: "cn-7 fs-13 fw-6 lh-1-5",
					children: "OR"
				}), /* @__PURE__ */ (0, Q.jsx)("div", { className: "divider divider--secondary w-100" })]
			})] })),
			/* @__PURE__ */ (0, Q.jsx)(M, {
				dataTestId: "add-or-label-selector-button",
				text: "OR label selector",
				size: I.medium,
				variant: F.text,
				startIcon: /* @__PURE__ */ (0, Q.jsx)(z, {
					name: "ic-add",
					color: null
				}),
				onClick: () => {
					r([...n, [SF()]]);
				}
			})
		]
	})] });
}, kF = ({ signal: e }) => G(O.SCHEDULE_LIST_MIN, { signal: e }), AF = ({ signal: e }) => G(O.BACKUP_LIST_MIN, { signal: e }), jF = ({ clusterId: e, signal: t }) => G(Y(O.CONFIG_MAP_LIST_MIN, { clusterId: e }), { signal: t }), MF = ({ signal: e }) => G(O.VOLUME_SNAPSHOT_LIST_MIN, { signal: e }), NF = ({ signal: e }) => G(O.STORAGE_LOCATION_LIST_MIN, { signal: e }), PF = /* @__PURE__ */ function(e) {
	return e.NANOSECONDS = "ns", e.MICROSECONDS = "us", e.MICROSECONDS_ALT = "µs", e.MILLISECONDS = "ms", e.SECONDS = "s", e.MINUTES = "m", e.HOURS = "h", e;
}({}), FF = {
	[PF.NANOSECONDS]: 1e-9,
	[PF.MICROSECONDS]: 1e-6,
	[PF.MICROSECONDS_ALT]: 1e-6,
	[PF.MILLISECONDS]: .001,
	[PF.SECONDS]: 1,
	[PF.MINUTES]: 60,
	[PF.HOURS]: 3600
}, IF = [
	{
		label: "Seconds",
		value: PF.SECONDS
	},
	{
		label: "Minutes",
		value: PF.MINUTES
	},
	{
		label: "Hours",
		value: PF.HOURS
	}
], LF = ({ idPrefix: e, value: t, unit: n, onUnitChange: r, onValueChange: i }) => /* @__PURE__ */ (0, Q.jsxs)("div", {
	className: "flexbox",
	children: [/* @__PURE__ */ (0, Q.jsx)(os, {
		name: `${e}-timeout-value`,
		type: "number",
		value: t || "",
		placeholder: "Eg. 30",
		onChange: (e) => {
			i(e.target.value === "" ? null : Number(e.target.value));
		},
		borderRadiusConfig: { right: !1 },
		borderConfig: { right: !1 }
	}), /* @__PURE__ */ (0, Q.jsx)(V, {
		inputId: `${e}-timeout-unit-select`,
		classNamePrefix: `${e}-timeout-unit-select`,
		options: IF,
		value: IF.find((e) => e.value === n) || null,
		onChange: (e) => {
			r(e.value);
		},
		isSearchable: !1,
		size: I.large,
		menuSize: I.small,
		borderRadiusConfig: { left: !1 },
		shouldMenuAlignRight: !0
	})]
}), RF = (e) => {
	let t = Object.values(PF).join("|"), n = RegExp(`(-?\\d+(?:\\.\\d+)?)(${t})`, "g"), r = n.exec(e), i = 0;
	for (; r !== null;) {
		let t = parseFloat(r[1]), a = r[2], o = FF[a];
		if (o === void 0) return Xd(/* @__PURE__ */ Error(`Unknown unit: ${a}`)), 0;
		i += t * o, r = n.exec(e);
	}
	return i;
};
function zF(e) {
	return !e || typeof e != "string" ? {
		value: null,
		unit: PF.SECONDS
	} : {
		value: RF(e),
		unit: PF.SECONDS
	};
}
function BF(e, t) {
	return Number.isNaN(e) ? null : `${e * FF[t]}s`;
}
//#endregion
//#region src/Pages-Devtron-2.0/DataProtectionManagement/Shared/types.ts
var VF = /* @__PURE__ */ function(e) {
	return e.GCP = "gcp", e;
}({}), HF = () => ({ "data-protection-management": {
	component: /* @__PURE__ */ (0, Q.jsx)(M, {
		linkProps: { to: B.DATA_PROTECTION_MANAGEMENT_OVERVIEW },
		component: N.link,
		variant: F.borderLess,
		dataTestId: "data-protection-mgm-overview-btn",
		icon: /* @__PURE__ */ (0, Q.jsx)(z, {
			name: "ic-database-backup",
			color: null
		}),
		showAriaLabelInTippy: !1,
		size: I.xs,
		ariaLabel: "Navigate to Data Protection Management Overview"
	}),
	linked: !0
} }), UF = /* @__PURE__ */ function(e) {
	return e.CONFIG_MAP = "config-map", e.JSON_PATCH = "json-patch", e;
}({}), WF = /* @__PURE__ */ function(e) {
	return e.ALL = "all", e.SPECIFIC = "specific", e;
}({}), GF = /* @__PURE__ */ function(e) {
	return e.BACKUP = "backup", e.SCHEDULE = "schedule", e;
}({}), KF = /* @__PURE__ */ function(e) {
	return e.ALL = "all-resources", e.SPECIFIC = "specific-resources", e;
}({}), qF = /* @__PURE__ */ function(e) {
	return e.EXISTING = "ExistingResourceModifier", e.NEW = "CreateResourceModifier", e;
}({}), JF = ({ basicDetails: e, setFormData: t, basicDetailsError: n, setFormError: r, metadata: i }) => /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsxs)(fF, { children: [
	/* @__PURE__ */ (0, Q.jsx)(os, {
		name: "restore-name",
		value: e.name,
		label: "Restore Name",
		placeholder: "Enter Restore Name",
		onChange: (e) => {
			let { value: n } = e.target;
			t((e) => ({
				...e,
				basicDetails: {
					...e.basicDetails,
					name: n
				}
			})), r((e) => ({
				...e,
				basicDetails: {
					...e.basicDetails,
					name: Bf(n).message
				}
			}));
		},
		error: n.name,
		required: !0
	}),
	/* @__PURE__ */ (0, Q.jsx)(ou, {
		label: "Description",
		name: "restore-description",
		placeholder: "Enter a description",
		value: e.description,
		onChange: (e) => {
			let { value: n } = e.target;
			t((e) => ({
				...e,
				basicDetails: {
					...e.basicDetails,
					description: n
				}
			})), r((e) => ({
				...e,
				basicDetails: {
					...e.basicDetails,
					description: Rf(n).message
				}
			}));
		},
		error: n.description
	}),
	/* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox-col dc__gap-12",
		children: [/* @__PURE__ */ (0, Q.jsx)("span", {
			className: "cn-9 fs-13 fw-6 lh-20",
			children: "Labels"
		}), /* @__PURE__ */ (0, Q.jsx)(kc, {
			headerLabel: {
				key: "Key",
				value: "Value"
			},
			placeholder: {
				key: "Enter key",
				value: "Enter value"
			},
			rows: e.labels.map(({ key: e, value: t, id: n }) => ({
				data: {
					key: { value: e },
					value: { value: t }
				},
				id: n
			})),
			showError: !0,
			onChange: (e) => {
				t((t) => ({
					...t,
					basicDetails: {
						...t.basicDetails,
						labels: e
					}
				}));
			},
			onError: (e) => {
				r((t) => ({
					...t,
					basicDetails: {
						...t.basicDetails,
						labels: e
					}
				}));
			},
			validateEmptyKeys: !0,
			validateDuplicateKeys: !0,
			isSortable: !0
		})]
	})
] }), /* @__PURE__ */ (0, Q.jsxs)(fF, { children: [
	/* @__PURE__ */ (0, Q.jsx)("span", {
		className: "cn-9 fs-14 fw-6 lh-1-5",
		children: "Restore Source"
	}),
	/* @__PURE__ */ (0, Q.jsxs)(vl, {
		name: "restore-source-type",
		className: "radio-group-no-border",
		value: e.source.type,
		onChange: (e) => {
			let n = e.target.value;
			t((e) => ({
				...e,
				basicDetails: {
					...e.basicDetails,
					source: {
						details: null,
						type: n
					}
				}
			})), r((e) => ({
				...e,
				basicDetails: {
					...e.basicDetails,
					source: null
				}
			}));
		},
		children: [/* @__PURE__ */ (0, Q.jsx)(yl, {
			value: GF.BACKUP,
			children: "Specific backup"
		}), /* @__PURE__ */ (0, Q.jsx)(yl, {
			value: GF.SCHEDULE,
			children: "Latest backup created by a schedule"
		})]
	}),
	/* @__PURE__ */ (0, Q.jsx)(V, {
		inputId: "restore-source-backup-select",
		label: "Backup to be restored",
		placeholder: "Select a backup",
		value: e.source.details ? {
			value: e.source.details.id,
			label: e.source.details.name
		} : null,
		options: e.source.type === GF.BACKUP ? i.backupOptions : i.scheduleOptions,
		onChange: (e) => {
			t((t) => ({
				...t,
				basicDetails: {
					...t.basicDetails,
					source: {
						...t.basicDetails.source,
						details: {
							id: e.value,
							name: e.label
						}
					}
				}
			})), r((e) => ({
				...e,
				basicDetails: {
					...e.basicDetails,
					source: null
				}
			}));
		},
		helperText: e.source.type === GF.SCHEDULE ? "Restore will be created from the latest successful or partially-failed backup created by the schedule" : null,
		error: n.source,
		required: !0,
		fullWidth: !0
	})
] })] }), YF = {
	basicDetails: "Basic Details",
	restoreTarget: "Restore Target",
	restoreSettings: "Restore Settings",
	executionControls: "Timeout & Execution Controls"
}, XF = {
	basicDetails: {
		name: "",
		description: "",
		labels: [{
			key: "",
			value: "",
			id: Id()
		}],
		source: {
			type: GF.BACKUP,
			details: null
		}
	},
	restoreTarget: {
		clusterDetails: null,
		namespaceDetails: { type: WF.ALL },
		resourceSelection: { type: KF.ALL },
		labelSelectors: [SF()],
		orLabelSelectors: [[SF()]]
	},
	restoreSettings: {
		resourceStatus: {
			includedResources: [],
			excludedResources: []
		},
		namespaceMapping: [{
			key: "",
			value: "",
			id: Id()
		}],
		clusterScopedResourcesPolicy: "auto",
		restoreVolumes: !1,
		preserveNodePorts: !1,
		existingResourcePolicy: "skip-resources",
		restoreModifierConfig: {
			isEnabled: !1,
			type: UF.CONFIG_MAP,
			configMap: null
		}
	},
	executionControls: {
		parallelFilesDownload: null,
		writeSparseFiles: !1,
		itemTimeout: {
			value: null,
			unit: PF.SECONDS
		}
	}
}, ZF = {
	basicDetails: {
		name: null,
		description: null,
		labels: !1,
		source: null
	},
	restoreTarget: {
		clusterDetails: null,
		specificNamespaces: null,
		resourceSelection: null
	},
	restoreSettings: {
		namespaceMapping: !1,
		restoreModifierConfig: null
	},
	executionControls: { parallelFilesDownload: null }
}, QF = Object.entries({
	auto: {
		label: "Auto (Recommended)",
		subHeading: "Include cluster resources for full backups; exclude for namespaced backups"
	},
	"include-all": {
		label: "Include all",
		subHeading: "Always include all cluster-scoped resources"
	},
	"exclude-all": {
		label: "Exclude all",
		subHeading: "Always exclude cluster-scoped resources"
	}
}).map(([e, { label: t, subHeading: n }]) => ({
	label: t,
	value: e,
	subHeading: n
})), $F = Object.entries({
	"skip-resources": {
		label: "Skip resources",
		subHeading: "Skip resources that already exist in the cluster"
	},
	"update-resources": {
		label: "Update resources",
		subHeading: "Patch existing resources to match the backup"
	}
}).map(([e, { label: t, subHeading: n }]) => ({
	label: t,
	value: e,
	subHeading: n
})), eI = (/* @__PURE__ */ "agents.kagent.dev,alertmanagers.monitoring.coreos.com,alerts.notification.toolkit.fluxcd.io,allowlistsynchronizers.auto.gke.io,analysisruns.argoproj.io,apisixclusterconfigs.apisix.apache.org,apisixconsumers.apisix.apache.org,apisixglobalrules.apisix.apache.org,apisixpluginconfigs.apisix.apache.org,apisixroutes.apisix.apache.org,apisixtlses.apisix.apache.org,apisixupstreams.apisix.apache.org,applications.argoproj.io,applicationsets.argoproj.io,appprojects.argoproj.io,audits.warden.gke.io,authorizationpolicies.security.istio.io,backuprepositories.velero.io,backups.postgresql.cnpg.io,backups.velero.io,backupstoragelocations.velero.io,buckets.source.toolkit.fluxcd.io,canaries.flagger.app,capacityrequests.internal.autoscaling.gke.io,certificaterequests.cert-manager.io,certificates.cert-manager.io,challenges.acme.cert-manager.io,cleanuppolicies.kyverno.io,cloudeventsources.eventing.keda.sh,clustercleanuppolicies.kyverno.io,clusterexternalsecrets.external-secrets.io,clusterissuers.cert-manager.io,clusternodemonitorings.monitoring.googleapis.com,clusterpodmonitorings.monitoring.googleapis.com,clusterpolicies.kyverno.io,clusterpushsecrets.external-secrets.io,clusterrules.monitoring.googleapis.com,clusters.postgresql.cnpg.io,clustersecretstores.external-secrets.io,clustertriggerauthentications.keda.sh,computeclasses.cloud.google.com,connectors.tailscale.com,cronworkflows.argoproj.io,databases.postgresql.cnpg.io,datadownloads.velero.io,datauploads.velero.io,deletebackuprequests.velero.io,destinationrules.networking.istio.io,dnsconfigs.tailscale.com,downloadrequests.velero.io,ec2nodeclasses.karpenter.k8s.aws,envoyfilters.networking.istio.io,eventbus.argoproj.io,eventsources.argoproj.io,experiments.argoproj.io,externalartifacts.source.toolkit.fluxcd.io,externalsecrets.external-secrets.io,failoverquorums.postgresql.cnpg.io,gateways.networking.istio.io,gcpdatasources.datalayer.gke.io,gcpresourceallowlists.node.gke.io,generatorstates.generators.external-secrets.io,gitrepositories.source.toolkit.fluxcd.io,gkenetworkparamsets.networking.gke.io,globalrules.monitoring.googleapis.com,helmcharts.source.toolkit.fluxcd.io,helmreleases.helm.toolkit.fluxcd.io,helmrepositories.source.toolkit.fluxcd.io,hibernators.pincher.devtron.ai,httpscaledobjects.http.keda.sh,imagepolicies.image.toolkit.fluxcd.io,imagerepositories.image.toolkit.fluxcd.io,imageupdateautomations.image.toolkit.fluxcd.io,issuers.cert-manager.io,kustomizations.kustomize.toolkit.fluxcd.io,memories.kagent.dev,modelconfigs.kagent.dev,mongodbcommunity.mongodbcommunity.mongodb.com,networks.networking.gke.io,nificonnections.nifi.konpyutaika.com,nifidataflows.nifi.konpyutaika.com,nifinodegroupautoscalers.nifi.konpyutaika.com,nifiparametercontexts.nifi.konpyutaika.com,nifiregistryclients.nifi.konpyutaika.com,nifiresources.nifi.konpyutaika.com,nifiusergroups.nifi.konpyutaika.com,nifiusers.nifi.konpyutaika.com,nodeclaims.karpenter.sh,nodepools.karpenter.sh,nodetopologies.networking.gke.io,ocirepositories.source.toolkit.fluxcd.io,orders.acme.cert-manager.io,peerauthentications.security.istio.io,podmonitorings.monitoring.googleapis.com,podvolumebackups.velero.io,podvolumerestores.velero.io,policies.kyverno.io,poolers.postgresql.cnpg.io,prometheusagents.monitoring.coreos.com,prometheuses.monitoring.coreos.com,providers.notification.toolkit.fluxcd.io,provisioningrequests.autoscaling.x-k8s.io,proxyclasses.tailscale.com,proxyconfigs.networking.istio.io,proxygroups.tailscale.com,publications.postgresql.cnpg.io,pushsecrets.external-secrets.io,receivers.notification.toolkit.fluxcd.io,recorders.tailscale.com,requestauthentications.security.istio.io,restores.velero.io,rules.monitoring.googleapis.com,scaledjobs.keda.sh,scaledobjects.keda.sh,scheduledbackups.postgresql.cnpg.io,schedules.velero.io,secretstores.external-secrets.io,sensors.argoproj.io,serverstatusrequests.velero.io,serviceentries.networking.istio.io,servicefunctionchains.networking.gke.io,sidecars.networking.istio.io,subscriptions.postgresql.cnpg.io,teams.kagent.dev,telemetries.telemetry.istio.io,terraforms.infra.contrib.fluxcd.io,thanosrulers.monitoring.coreos.com,toolservers.kagent.dev,trafficselectors.networking.gke.io,triggerauthentications.keda.sh,trustconfigs.security.cloud.google.com,turndownschedules.kubecost.com,updaterequests.kyverno.io,virtualservices.networking.istio.io,vmrules.operator.victoriametrics.com,vmservicescrapes.operator.victoriametrics.com,volumesnapshotcontents.snapshot.storage.k8s.io,volumesnapshotlocations.velero.io,volumesnapshots.snapshot.storage.k8s.io,wasmplugins.extensions.istio.io,workflowartifactgctasks.argoproj.io,workflowtasksets.argoproj.io,workloadcertificateconfigs.security.cloud.google.com,workloadentries.networking.istio.io,workloadgroups.networking.istio.io,pods.v1,nodes.v1,services.v1,endpoints.v1,persistentvolumes.v1,persistentvolumeclaims.v1,namespaces.v1,events.v1,configmaps.v1,secrets.v1,deployments.apps,statefulsets.apps,daemonsets.apps,replicasets.apps,jobs.batch,cronjobs.batch,horizontalpodautoscalers.autoscaling,ingresses.networking.k8s.io,networkpolicies.networking.k8s.io".split(",")).map((e) => ({
	label: e,
	value: e
})), tI = {
	"skip-resources": "none",
	"update-resources": "update"
}, nI = "# Example:\nversion: v1\nresourceModifierRules:\n- conditions:\n    groupResource: pods\n    namespaces:\n    - ns1\n  mergePatches:\n  - patchData: |\n      {\n        \"metadata\": {\n          \"annotations\": {\n            \"foo\": null\n          }\n        }\n      }", rI = (e) => !Jd(e) && e !== !1, iI = (e, t) => {
	let n = { ...t };
	n.name = n.name || lf(e.name).message;
	let r = e.source.details?.id ? null : "Please select a backup source.";
	return n.source = n.source || r, n;
}, aI = (e, t) => {
	let n = { ...t }, r = e.clusterDetails?.id ? null : "Please select a cluster.";
	if (n.clusterDetails = n.clusterDetails || r, e.namespaceDetails.type === WF.SPECIFIC) {
		let t = (e.namespaceDetails.includedNamespaces.length || 0) + (e.namespaceDetails.excludedNamespaces.length || 0) > 0 ? null : "Please select at least one namespace.";
		n.specificNamespaces = n.specificNamespaces || t;
	}
	if (e.resourceSelection.type === KF.SPECIFIC) {
		let t = (e.resourceSelection.includedResources.length || 0) + (e.resourceSelection.excludedResources.length || 0) > 0 ? null : "Please select at least one resource.";
		n.resourceSelection = n.resourceSelection || t;
	}
	return n;
}, oI = (e, t) => {
	let n = { ...t }, r = e.restoreModifierConfig.type === UF.CONFIG_MAP ? e.restoreModifierConfig.configMap?.value : e.restoreModifierConfig.jsonPatch, i = !e.restoreModifierConfig.isEnabled || r ? null : "This field is required.";
	return n.restoreModifierConfig = n.restoreModifierConfig || i, n;
}, sI = (e, t) => {
	let n = structuredClone(t);
	return n.basicDetails = iI(e.basicDetails, t.basicDetails), n.restoreTarget = aI(e.restoreTarget, t.restoreTarget), n.restoreSettings = oI(e.restoreSettings, t.restoreSettings), {
		isErrorPresent: Object.keys(n).some((e) => {
			let t = n[e];
			return Object.values(t).some(rI);
		}),
		updatedErrorState: n
	};
}, cI = (e) => e === WF.ALL ? { type: WF.ALL } : {
	type: WF.SPECIFIC,
	includedNamespaces: [],
	excludedNamespaces: []
}, lI = (e) => e === KF.ALL ? { type: KF.ALL } : {
	type: KF.SPECIFIC,
	includedResources: [],
	excludedResources: []
}, uI = (e) => e.isEnabled ? e.type === UF.CONFIG_MAP ? {
	type: qF.EXISTING,
	name: e.configMap.value
} : {
	type: qF.NEW,
	data: e.jsonPatch
} : null, dI = (e) => e === "auto" ? null : e !== "exclude-all", fI = (e) => e.type === WF.ALL ? { isAllNamespacesIncluded: !0 } : {
	isAllNamespacesIncluded: !1,
	includedNamespaces: (e.includedNamespaces || []).map((e) => e.value),
	excludedNamespaces: (e.excludedNamespaces || []).map((e) => e.value)
}, pI = (e) => ({
	name: e.name,
	description: e.description,
	labels: (e.labels || []).reduce((e, t) => {
		let n = t.key.trim(), r = t.value.trim();
		return n && (e[n] = r), e;
	}, {}),
	clusterBackupId: e.source.type === GF.BACKUP ? e.source.details.id : null,
	clusterScheduleId: e.source.type === GF.SCHEDULE ? e.source.details.id : null
}), mI = (e) => ({
	...EF({
		labelSelectors: e.labelSelectors,
		orLabelSelectors: e.orLabelSelectors
	}),
	...fI(e.namespaceDetails),
	targetClusterId: e.clusterDetails.id,
	includedResources: e.resourceSelection.includedResources?.map((e) => e.value),
	excludedResources: e.resourceSelection.excludedResources?.map((e) => e.value)
}), hI = (e) => ({
	restoreStatus: {
		includedResources: e.resourceStatus.includedResources?.map((e) => e.value) || null,
		excludedResources: e.resourceStatus.excludedResources?.map((e) => e.value) || null
	},
	namespaceMapping: (e.namespaceMapping || []).reduce((e, t) => {
		let n = t.key.trim(), r = t.value.trim();
		return n && r && (e[n] = r), e;
	}, {}),
	includeClusterResources: dI(e.clusterScopedResourcesPolicy),
	restorePVs: e.restoreVolumes,
	preserveNodePorts: e.preserveNodePorts,
	existingResourcePolicy: tI[e.existingResourcePolicy],
	resourceModifierConfig: uI(e.restoreModifierConfig)
}), gI = (e) => ({
	itemOperationTimeout: Jd(e.itemTimeout.value) ? null : BF(e.itemTimeout.value, e.itemTimeout.unit),
	uploaderConfig: {
		writeSparseFiles: e.writeSparseFiles,
		parallelFilesDownload: e.parallelFilesDownload
	}
}), _I = (e) => ({
	...pI(e.basicDetails),
	...mI(e.restoreTarget),
	...hI(e.restoreSettings),
	...gI(e.executionControls)
}), vI = ({ currentTab: e, setCurrentTab: t, formError: n }) => {
	let r = (e) => !Object.values(n[e]).some((e) => rI(e)), i = (e) => () => {
		t(e);
	};
	return /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox-col py-20 px-12 dc__gap-12 bg__modal--primary dc__overflow-auto",
		children: [
			/* @__PURE__ */ (0, Q.jsx)("div", {
				className: "flexbox-col",
				children: Object.entries(YF).map(([t, n]) => /* @__PURE__ */ (0, Q.jsx)("div", {
					className: `py-6 px-8 br-4 flexbox dc__gap-8 dc__align-items-center ${t === e ? "bcb-1" : "bg__hover"}`,
					children: /* @__PURE__ */ (0, Q.jsxs)("button", {
						type: "button",
						className: "dc__transparent flexbox dc__content-space flex-grow-1 dc__align-items-center dc__gap-8",
						"data-testid": `move-to-${t}-tab`,
						onClick: i(t),
						children: [/* @__PURE__ */ (0, Q.jsx)("span", {
							className: `${t === e ? "fw-6 cb-5" : "fw-4 cn-9"} fs-13 lh-1-5 dc__truncate`,
							children: n
						}), !r(t) && /* @__PURE__ */ (0, Q.jsx)(z, {
							name: "ic-warning-fill",
							size: 16,
							color: "R500"
						})]
					})
				}, t))
			}),
			/* @__PURE__ */ (0, Q.jsx)("div", { className: "divider divider--n1" }),
			/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox-col dc__gap-4 dc__align-start",
				children: [/* @__PURE__ */ (0, Q.jsx)("span", {
					className: "fs-13 fw-6 lh-20 cn-9",
					children: "📙 Need help?"
				}), /* @__PURE__ */ (0, Q.jsx)(Ns, {
					docLinkKey: "DOC_HOME_PAGE",
					text: "View documentation",
					dataTestId: "restore-doc-link",
					showExternalIcon: !0,
					openInNewTab: !0
				})]
			})
		]
	});
}, yI = ({ executionControls: e, executionControlsError: t, setFormData: n, setFormError: r }) => /* @__PURE__ */ (0, Q.jsxs)(fF, { children: [
	/* @__PURE__ */ (0, Q.jsx)(os, {
		name: "parallelFilesDownload",
		label: "Parallel Files Download",
		type: "number",
		value: e.parallelFilesDownload,
		error: t.parallelFilesDownload,
		placeholder: "Eg. 10",
		onChange: (e) => {
			let t = e.target.value ? parseInt(e.target.value, 10) : null;
			n((e) => ({
				...e,
				executionControls: {
					...e.executionControls,
					parallelFilesDownload: t
				}
			})), r((e) => ({
				...e,
				executionControls: {
					...e.executionControls,
					parallelFilesDownload: t < 0 ? "Parallel files download must be a non-negative number" : null
				}
			}));
		},
		helperText: "Number of restore operations to run at once. Set to 0 to use the CPU count of the node running the node agent pod."
	}),
	/* @__PURE__ */ (0, Q.jsx)("div", { className: "divider divider--secondary" }),
	/* @__PURE__ */ (0, Q.jsx)(pF, {
		heading: "Write Sparse Files",
		subHeading: "Whether to write sparse files during restoring volumes",
		children: /* @__PURE__ */ (0, Q.jsx)(bs, {
			name: "writeSparseFiles",
			ariaLabel: "write-sparse-files-switch",
			isChecked: e.writeSparseFiles,
			onChange: () => {
				n((e) => ({
					...e,
					executionControls: {
						...e.executionControls,
						writeSparseFiles: !e.executionControls.writeSparseFiles
					}
				}));
			}
		})
	}),
	/* @__PURE__ */ (0, Q.jsx)("div", { className: "divider divider--secondary" }),
	/* @__PURE__ */ (0, Q.jsx)(pF, {
		heading: "Item Operation Timeout",
		subHeading: "How long to wait for async plugin operations before timeout",
		children: /* @__PURE__ */ (0, Q.jsx)(LF, {
			idPrefix: "execution-control",
			value: e.itemTimeout.value,
			unit: e.itemTimeout.unit,
			onUnitChange: (e) => {
				n((t) => ({
					...t,
					executionControls: {
						...t.executionControls,
						itemTimeout: {
							...t.executionControls.itemTimeout,
							unit: e
						}
					}
				}));
			},
			onValueChange: (e) => {
				n((t) => ({
					...t,
					executionControls: {
						...t.executionControls,
						itemTimeout: {
							...t.executionControls.itemTimeout,
							value: e
						}
					}
				}));
			}
		})
	})
] }), bI = () => /* @__PURE__ */ (0, Q.jsxs)("div", {
	className: "flexbox-col dc__gap-8",
	children: [
		/* @__PURE__ */ (0, Q.jsx)("span", {
			className: "cn-9 fs-13 fw-4 lh-20",
			children: "A resource modifier ConfigMap lets you customize Kubernetes resources during a restore by applying JSON patch rules before they are recreated on the target cluster. This helps make backups portable and ensures smooth restores across different environments."
		}),
		/* @__PURE__ */ (0, Q.jsx)("span", {
			className: "cn-9 fs-13 fw-6 lh-20",
			children: "Example use cases:"
		}),
		/* @__PURE__ */ (0, Q.jsx)("span", {
			className: "cn-9 fs-13 fw-4 lh-20",
			children: "Cluster migrations: Change storageClassNames in PVCs to match storage classes available in the new cluster. How to use: Create a ConfigMap with JSON patch rules defining the changes you want. Velero will automatically apply these rules to your resources during the restore, allowing you to tailor them for your target cluster's setup."
		})
	]
}), xI = ({ restoreSettings: e, restoreSettingsError: t, setFormData: n, setFormError: r, configMapOptions: i }) => /* @__PURE__ */ (0, Q.jsx)(fF, { children: /* @__PURE__ */ (0, Q.jsxs)("div", {
	className: "flexbox-col dc__gap-8",
	children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox dc__gap-8 dc__align-items-center dc__content-space",
		children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox dc__gap-6",
			children: [/* @__PURE__ */ (0, Q.jsx)("span", {
				className: "cn-9 fs-14 fw-6 lh-1-5",
				children: "Modify resources during restore"
			}), /* @__PURE__ */ (0, Q.jsx)(Cc, {
				heading: "Modify resources during restore",
				infoText: bI()
			})]
		}), /* @__PURE__ */ (0, Q.jsx)(bs, {
			name: "toggle-enable-modify-resources-switch",
			ariaLabel: "Enable Modify Resources Switch",
			isChecked: e.restoreModifierConfig.isEnabled,
			onChange: () => {
				n((e) => ({
					...e,
					restoreSettings: {
						...e.restoreSettings,
						restoreModifierConfig: {
							...e.restoreSettings.restoreModifierConfig,
							isEnabled: !e.restoreSettings.restoreModifierConfig.isEnabled
						}
					}
				}));
			}
		})]
	}), /* @__PURE__ */ (0, Q.jsx)(Zo, {
		expand: e.restoreModifierConfig.isEnabled,
		children: /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox-col dc__gap-8",
			children: [/* @__PURE__ */ (0, Q.jsxs)(vl, {
				className: "no-border",
				value: e.restoreModifierConfig.type,
				name: "restore-modifier-config-radio-group",
				onChange: (e) => {
					let t = e.target.value === UF.CONFIG_MAP ? {
						type: UF.CONFIG_MAP,
						configMap: null
					} : {
						type: UF.JSON_PATCH,
						jsonPatch: ""
					};
					n((e) => ({
						...e,
						restoreSettings: {
							...e.restoreSettings,
							restoreModifierConfig: {
								isEnabled: e.restoreSettings.restoreModifierConfig.isEnabled,
								...t
							}
						}
					})), r((e) => ({
						...e,
						restoreSettings: {
							...e.restoreSettings,
							restoreModifierConfig: null
						}
					}));
				},
				children: [/* @__PURE__ */ (0, Q.jsx)(yl, {
					value: UF.CONFIG_MAP,
					dataTestId: "restore-target-namespace-all-checkbox",
					children: /* @__PURE__ */ (0, Q.jsx)("span", {
						className: "cn-9 fs-13 fw-4 lh-20",
						children: "Select ConfigMap"
					})
				}), /* @__PURE__ */ (0, Q.jsx)(yl, {
					value: UF.JSON_PATCH,
					dataTestId: "restore-target-namespace-specific-checkbox",
					children: /* @__PURE__ */ (0, Q.jsx)("span", {
						className: "cn-9 fs-13 fw-4 lh-20",
						children: "Provide Resource Modifier"
					})
				})]
			}), e.restoreModifierConfig.type === UF.CONFIG_MAP ? /* @__PURE__ */ (0, Q.jsx)(V, {
				inputId: "restore-modifier-config-config-map",
				options: i.options || [],
				value: e.restoreModifierConfig.configMap,
				onChange: (e) => {
					let t = {
						type: UF.CONFIG_MAP,
						configMap: e
					};
					n((e) => ({
						...e,
						restoreSettings: {
							...e.restoreSettings,
							restoreModifierConfig: {
								isEnabled: e.restoreSettings.restoreModifierConfig.isEnabled,
								...t
							}
						}
					})), r((e) => ({
						...e,
						restoreSettings: {
							...e.restoreSettings,
							restoreModifierConfig: null
						}
					}));
				},
				placeholder: "Select a ConfigMap",
				label: "Resource Modifier ConfigMap",
				required: !0,
				fullWidth: !0,
				error: t.restoreModifierConfig,
				isLoading: i.isLoading,
				optionListError: i.error,
				reloadOptionList: i.refetch
			}) : /* @__PURE__ */ (0, Q.jsx)(Xo, {
				value: e.restoreModifierConfig.jsonPatch,
				mode: Ic.YAML,
				height: 300,
				onChange: (e) => {
					let t = {
						type: UF.JSON_PATCH,
						jsonPatch: e
					};
					n((e) => ({
						...e,
						restoreSettings: {
							...e.restoreSettings,
							restoreModifierConfig: {
								isEnabled: e.restoreSettings.restoreModifierConfig.isEnabled,
								...t
							}
						}
					})), r((t) => ({
						...t,
						restoreSettings: {
							...t.restoreSettings,
							restoreModifierConfig: lf(e).message
						}
					}));
				},
				placeholder: nI,
				children: t.restoreModifierConfig && /* @__PURE__ */ (0, Q.jsx)(Xo.ErrorBar, { text: t.restoreModifierConfig })
			})]
		})
	})]
}) }), SI = ({ restoreSettings: e, setFormData: t }) => {
	let n = (e) => (n) => {
		t((t) => ({
			...t,
			restoreSettings: {
				...t.restoreSettings,
				resourceStatus: {
					...t.restoreSettings.resourceStatus,
					includedResources: e ? t.restoreSettings.resourceStatus.includedResources : n || [],
					excludedResources: e ? n || [] : t.restoreSettings.resourceStatus.excludedResources || []
				}
			}
		}));
	}, r = (t) => (r) => {
		let i = {
			label: r,
			value: r
		}, a = t ? [...e.resourceStatus.excludedResources || [], i] : [...e.resourceStatus.includedResources || [], i];
		n(t)(a);
	}, i = (t) => /* @__PURE__ */ (0, Q.jsx)(V, {
		inputId: t ? "status-excluded-resources-select" : "status-included-resources-select",
		isMulti: !0,
		label: t ? "Status Excluded Resources" : "Status Included Resources",
		helperText: `Resources to ${t ? "exclude" : "include"} in the restore status, formatted as resourceKind.group, such as storageclasses.storage.k8s.io`,
		placeholder: `Type resource to ${t ? "exclude" : "include"}`,
		options: eI,
		value: t ? e.resourceStatus.excludedResources : e.resourceStatus.includedResources,
		isCreatable: !0,
		onCreateOption: r(t),
		onChange: n(t)
	});
	return /* @__PURE__ */ (0, Q.jsxs)(fF, { children: [
		/* @__PURE__ */ (0, Q.jsx)("span", {
			className: "cn-9 fs-14 fw-6 lh-1-5",
			children: "Resource Status"
		}),
		i(!1),
		i(!0)
	] });
}, CI = ({ restoreSettings: e, restoreSettingsError: t, setFormData: n, setFormError: r, configMapOptions: i }) => /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [
	/* @__PURE__ */ (0, Q.jsx)(SI, {
		restoreSettings: e,
		setFormData: n
	}),
	/* @__PURE__ */ (0, Q.jsxs)(fF, { children: [/* @__PURE__ */ (0, Q.jsx)("span", {
		className: "cn-9 fs-14 fw-6 lh-1-5",
		children: "Namespace Mapping"
	}), /* @__PURE__ */ (0, Q.jsx)(kc, {
		headerLabel: {
			key: "Source Namespace",
			value: "Target Namespace"
		},
		placeholder: {
			key: "Eg. prod",
			value: "Eg. prod-2"
		},
		rows: e.namespaceMapping.map(({ key: e, value: t, id: n }) => ({
			data: {
				key: { value: e },
				value: { value: t }
			},
			id: n
		})),
		showError: !0,
		onChange: (e) => {
			n((t) => ({
				...t,
				restoreSettings: {
					...t.restoreSettings,
					namespaceMapping: e
				}
			}));
		},
		onError: (e) => {
			r((t) => ({
				...t,
				restoreSettings: {
					...t.restoreSettings,
					namespaceMapping: e
				}
			}));
		},
		validateEmptyKeys: !0,
		validateDuplicateKeys: !0,
		isSortable: !0
	})] }),
	/* @__PURE__ */ (0, Q.jsxs)(fF, { children: [
		/* @__PURE__ */ (0, Q.jsx)("span", {
			className: "cn-9 fs-14 fw-6 lh-1-5",
			children: "More Settings"
		}),
		/* @__PURE__ */ (0, Q.jsx)(pF, {
			heading: "Include cluster resources",
			subHeading: "Whether to include cluster-scoped resources in the restore",
			children: /* @__PURE__ */ (0, Q.jsx)(V, {
				inputId: "cluster-resource-policy",
				options: QF,
				value: QF.find((t) => t.value === e.clusterScopedResourcesPolicy) || null,
				onChange: (e) => {
					n((t) => ({
						...t,
						restoreSettings: {
							...t.restoreSettings,
							clusterScopedResourcesPolicy: e.value
						}
					}));
				},
				variant: Hl.COMPACT,
				shouldMenuAlignRight: !0
			})
		}),
		/* @__PURE__ */ (0, Q.jsx)("div", { className: "divider divider--secondary" }),
		/* @__PURE__ */ (0, Q.jsx)(pF, {
			heading: "Restore Volume",
			subHeading: "Whether to restore volumes from snapshot",
			children: /* @__PURE__ */ (0, Q.jsx)(bs, {
				name: "restore-volume-switch",
				ariaLabel: "Restore Volume Switch",
				isChecked: e.restoreVolumes,
				onChange: () => {
					n((e) => ({
						...e,
						restoreSettings: {
							...e.restoreSettings,
							restoreVolumes: !e.restoreSettings.restoreVolumes
						}
					}));
				}
			})
		}),
		/* @__PURE__ */ (0, Q.jsx)("div", { className: "divider divider--secondary" }),
		/* @__PURE__ */ (0, Q.jsx)(pF, {
			heading: "Preserve Node Ports",
			subHeading: "Whether to preserve node ports of services during restore",
			children: /* @__PURE__ */ (0, Q.jsx)(bs, {
				name: "preserve-node-ports-switch",
				ariaLabel: "Preserve Node Ports Switch",
				isChecked: e.preserveNodePorts,
				onChange: () => {
					n((e) => ({
						...e,
						restoreSettings: {
							...e.restoreSettings,
							preserveNodePorts: !e.restoreSettings.preserveNodePorts
						}
					}));
				}
			})
		}),
		/* @__PURE__ */ (0, Q.jsx)("div", { className: "divider divider--secondary" }),
		/* @__PURE__ */ (0, Q.jsx)(pF, {
			heading: "Existing Resource Policy",
			subHeading: "Defines how to handle resources if they already exist in the cluster during restore",
			children: /* @__PURE__ */ (0, Q.jsx)(V, {
				inputId: "existing-resource-policy",
				options: $F,
				value: $F.find((t) => t.value === e.existingResourcePolicy) || null,
				onChange: (e) => {
					n((t) => ({
						...t,
						restoreSettings: {
							...t.restoreSettings,
							existingResourcePolicy: e.value
						}
					}));
				},
				variant: Hl.COMPACT,
				shouldMenuAlignRight: !0
			})
		})
	] }),
	/* @__PURE__ */ (0, Q.jsx)(xI, {
		restoreSettings: e,
		restoreSettingsError: t,
		setFormData: n,
		setFormError: r,
		configMapOptions: i
	})
] }), wI = ({ restoreTarget: e, setFormData: t, restoreTargetError: n, setFormError: r, metadata: i }) => {
	let a = (e) => {
		t((t) => {
			let n = {
				...t.restoreTarget,
				clusterDetails: {
					id: e.value,
					name: e.label
				}
			};
			return {
				...t,
				restoreTarget: n
			};
		}), r((e) => ({
			...e,
			restoreTarget: {
				...e.restoreTarget,
				clusterDetails: null
			}
		}));
	}, o = (e) => {
		let n = e.target.value;
		t((e) => {
			let t = {
				...e.restoreTarget,
				namespaceDetails: cI(n)
			};
			return {
				...e,
				restoreTarget: t
			};
		}), r((e) => ({
			...e,
			restoreTarget: {
				...e.restoreTarget,
				specificNamespaces: null
			}
		}));
	}, s = (n) => (i) => {
		let a = {
			...e,
			namespaceDetails: {
				type: WF.SPECIFIC,
				includedNamespaces: n ? e.namespaceDetails.includedNamespaces : i || [],
				excludedNamespaces: n ? i || [] : e.namespaceDetails.excludedNamespaces
			}
		}, o = (a.namespaceDetails.includedNamespaces.length || 0) + (a.namespaceDetails.excludedNamespaces.length || 0);
		t((e) => ({
			...e,
			restoreTarget: a
		})), r((e) => ({
			...e,
			restoreTarget: {
				...e.restoreTarget,
				specificNamespaces: o > 0 ? null : "Please enter namespaces to include or exclude"
			}
		}));
	}, c = (t) => (n) => {
		let r = {
			label: n,
			value: n
		}, i = t ? [...e.namespaceDetails.excludedNamespaces || [], r] : [...e.namespaceDetails.includedNamespaces || [], r];
		s(t)(i);
	};
	return /* @__PURE__ */ (0, Q.jsxs)(fF, { children: [
		/* @__PURE__ */ (0, Q.jsx)("span", {
			className: "cn-9 fs-14 fw-6 lh-1-5",
			children: "Restore to"
		}),
		/* @__PURE__ */ (0, Q.jsx)(V, {
			inputId: "restore-target-cluster",
			label: "Restore to",
			options: i.clusterOptions || [],
			value: e.clusterDetails ? {
				label: e.clusterDetails.name,
				value: e.clusterDetails.id
			} : null,
			required: !0,
			placeholder: "Select a Cluster",
			isClearable: !1,
			onChange: a,
			error: n.clusterDetails
		}),
		/* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox-col dc__gap-8",
			children: [/* @__PURE__ */ (0, Q.jsx)(vl, {
				className: "no-border",
				value: e.namespaceDetails.type,
				name: "restore-target-namespace-type",
				onChange: o,
				children: /* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "flexbox-col dc__gap-6",
					children: [/* @__PURE__ */ (0, Q.jsx)(yl, {
						value: WF.ALL,
						dataTestId: "restore-target-namespace-all-checkbox",
						children: /* @__PURE__ */ (0, Q.jsx)("span", {
							className: "cn-9 fs-13 fw-4 lh-20",
							children: "All Namespaces"
						})
					}), /* @__PURE__ */ (0, Q.jsxs)(yl, {
						value: WF.SPECIFIC,
						dataTestId: "restore-target-namespace-specific-checkbox",
						children: [/* @__PURE__ */ (0, Q.jsx)("span", {
							className: "cn-9 fs-13 fw-4 lh-20",
							children: "Specific Namespaces"
						}), n.specificNamespaces && /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsx)("br", {}), /* @__PURE__ */ (0, Q.jsx)("span", {
							className: "cr-5 fs-12 fw-4 lh-18",
							children: n.specificNamespaces
						})] })]
					})]
				})
			}), e.namespaceDetails.type === WF.SPECIFIC && /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsx)(V, {
				inputId: "included-namespaces-select",
				isMulti: !0,
				label: "Included Namespaces",
				placeholder: "Type and Enter to include namespace",
				options: [],
				value: e.namespaceDetails.includedNamespaces,
				isCreatable: !0,
				onCreateOption: c(!1),
				onChange: s(!1)
			}), /* @__PURE__ */ (0, Q.jsx)(V, {
				inputId: "excluded-namespaces-select",
				label: "Excluded Namespaces",
				placeholder: "Type and Enter to exclude namespace",
				isMulti: !0,
				options: [],
				value: e.namespaceDetails.excludedNamespaces,
				isCreatable: !0,
				onCreateOption: c(!0),
				onChange: s(!0)
			})] })]
		})
	] });
}, TI = ({ restoreTarget: e, setFormData: t, restoreTargetError: n, setFormError: r }) => {
	let i = (e) => {
		let n = e.target.value;
		t((e) => {
			let t = {
				...e.restoreTarget,
				resourceSelection: lI(n)
			};
			return {
				...e,
				restoreTarget: t
			};
		}), r((e) => ({
			...e,
			restoreTarget: {
				...e.restoreTarget,
				resourceSelection: null
			}
		}));
	}, a = (n) => (i) => {
		let a = {
			...e,
			resourceSelection: {
				type: KF.SPECIFIC,
				includedResources: n ? e.resourceSelection.includedResources : i || [],
				excludedResources: n ? i || [] : e.resourceSelection.excludedResources || []
			}
		}, o = (a.resourceSelection.includedResources.length || 0) + (a.resourceSelection.excludedResources.length || 0);
		t((e) => ({
			...e,
			restoreTarget: a
		})), r((e) => ({
			...e,
			restoreTarget: {
				...e.restoreTarget,
				resourceSelection: o > 0 ? null : "Please enter resources to include or exclude"
			}
		}));
	}, o = (t) => (n) => {
		let r = {
			label: n,
			value: n
		}, i = t ? [...e.resourceSelection.excludedResources || [], r] : [...e.resourceSelection.includedResources || [], r];
		a(t)(i);
	};
	return /* @__PURE__ */ (0, Q.jsxs)(fF, { children: [/* @__PURE__ */ (0, Q.jsx)("span", {
		className: "cn-9 fs-14 fw-6 lh-1-5",
		children: "Resources to restore based on resource kind"
	}), /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox-col dc__gap-8",
		children: [/* @__PURE__ */ (0, Q.jsx)(vl, {
			className: "no-border",
			value: e.resourceSelection.type,
			name: "restore-target-resource-selection-type",
			onChange: i,
			children: /* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox-col dc__gap-6",
				children: [/* @__PURE__ */ (0, Q.jsx)(yl, {
					value: KF.ALL,
					dataTestId: "restore-target-resource-selection-all-checkbox",
					children: /* @__PURE__ */ (0, Q.jsx)("span", {
						className: "cn-9 fs-13 fw-4 lh-20",
						children: "All Resources"
					})
				}), /* @__PURE__ */ (0, Q.jsxs)(yl, {
					value: KF.SPECIFIC,
					dataTestId: "restore-target-resource-selection-specific-checkbox",
					children: [
						/* @__PURE__ */ (0, Q.jsx)("span", {
							className: "cn-9 fs-13 fw-4 lh-20",
							children: "Specific Resource"
						}),
						/* @__PURE__ */ (0, Q.jsx)("br", {}),
						/* @__PURE__ */ (0, Q.jsx)("span", {
							className: "cn-7 fs-12 fw-4 lh-18",
							children: "Select resource kinds or enter specific resources, formatted as resourceKind.group, such as storageclasses.storage.k8s.io"
						}),
						n.resourceSelection && /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsx)("br", {}), /* @__PURE__ */ (0, Q.jsx)("span", {
							className: "cr-5 fs-12 fw-4 lh-18",
							children: n.resourceSelection
						})] })
					]
				})]
			})
		}), e.resourceSelection.type === KF.SPECIFIC && /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsx)(V, {
			inputId: "included-resources-select",
			isMulti: !0,
			label: "Included Resources",
			placeholder: "Type and Enter to include resource",
			options: [],
			value: e.resourceSelection.includedResources,
			isCreatable: !0,
			onCreateOption: o(!1),
			onChange: a(!1)
		}), /* @__PURE__ */ (0, Q.jsx)(V, {
			inputId: "excluded-resources-select",
			label: "Excluded Resources",
			placeholder: "Type and Enter to exclude resource",
			isMulti: !0,
			options: [],
			value: e.resourceSelection.excludedResources,
			isCreatable: !0,
			onCreateOption: o(!0),
			onChange: a(!0)
		})] })]
	})] });
}, EI = ({ restoreTarget: e, setFormData: t, restoreTargetError: n, setFormError: r, metadata: i }) => /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [
	/* @__PURE__ */ (0, Q.jsx)(wI, {
		restoreTarget: e,
		setFormData: t,
		restoreTargetError: n,
		setFormError: r,
		metadata: i
	}),
	/* @__PURE__ */ (0, Q.jsx)(TI, {
		restoreTarget: e,
		setFormData: t,
		restoreTargetError: n,
		setFormError: r
	}),
	/* @__PURE__ */ (0, Q.jsx)(OF, {
		labelSelectors: e.labelSelectors,
		handleLabelSelectorChange: (e) => {
			t((t) => ({
				...t,
				restoreTarget: {
					...t.restoreTarget,
					labelSelectors: e
				}
			}));
		},
		handleOrLabelSelectorsChange: (e) => {
			t((t) => ({
				...t,
				restoreTarget: {
					...t.restoreTarget,
					orLabelSelectors: e
				}
			}));
		},
		orLabelSelectors: e.orLabelSelectors
	})
] }), DI = async (e) => {
	try {
		return await nf(O.CLUSTER_BACKUP_RESTORE, _I(e)), !0;
	} catch (e) {
		return K(e), !1;
	}
}, OI = async ({ signal: e }) => {
	let [t, n, r] = await Promise.all([
		AF({ signal: e }),
		kF({ signal: e }),
		Zu(e)
	]);
	return {
		backupOptions: (t.result || []).sort((e, t) => df(e.name, t.name)).map((e) => ({
			label: e.name,
			value: e.id
		})),
		scheduleOptions: (n.result || []).sort((e, t) => df(e.name, t.name)).map((e) => ({
			label: e.name,
			value: e.id
		})),
		clusterOptions: r.sort((e, t) => df(e.name, t.name)).map((e) => ({
			label: e.name,
			value: e.id
		}))
	};
}, kI = ({ handleClose: e, onSuccess: t }) => {
	let [n, r] = j(structuredClone(XF)), [i, a] = j(structuredClone(ZF)), [o, s] = j("basicDetails"), [c, l] = j(!1), { isFetching: u, error: d, data: f, refetch: p } = q({
		queryKey: ["get-restore-creation-metadata"],
		queryFn: ({ signal: e }) => OI({ signal: e })
	}), { isFetching: m, data: h, error: g, refetch: _ } = q({
		queryKey: ["get-config-map-list", n.restoreTarget.clusterDetails?.id],
		queryFn: ({ signal: e }) => jF({
			signal: e,
			clusterId: n.restoreTarget.clusterDetails?.id
		}),
		select: (e) => (e.result || []).map((e) => ({
			label: e,
			value: e
		})).sort((e, t) => df(e.label, t.label)),
		enabled: !!n.restoreTarget.clusterDetails?.id,
		meta: { showToastError: !1 }
	});
	return /* @__PURE__ */ (0, Q.jsx)(Rs, {
		position: "right",
		width: "1024px",
		onEscape: e,
		onClose: e,
		children: /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox-col dc__content-space h-100 bg__modal--primary shadow__modal dc__overflow-auto",
			onClick: uf,
			children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox-col dc__overflow-auto flex-grow-1",
				children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "px-20 py-12 flexbox dc__content-space dc__align-items-center border__primary--bottom",
					children: [/* @__PURE__ */ (0, Q.jsx)("h2", {
						className: "m-0 fs-16 fw-6 lh-24 cn-9",
						children: "Create Restore"
					}), /* @__PURE__ */ (0, Q.jsx)(M, {
						dataTestId: "header-close-button",
						ariaLabel: "Close",
						showAriaLabelInTippy: !1,
						onClick: e,
						variant: F.borderLess,
						style: P.negativeGrey,
						icon: /* @__PURE__ */ (0, Q.jsx)(z, {
							name: "ic-close-large",
							color: null
						}),
						size: I.xs
					})]
				}), /* @__PURE__ */ (0, Q.jsx)($a, {
					isLoading: u,
					error: d,
					progressingProps: { pageLoader: !0 },
					errorScreenManagerProps: {
						code: d?.code,
						reload: p,
						on404Redirect: e
					},
					children: /* @__PURE__ */ (0, Q.jsxs)("div", {
						className: "dc__grid create-restore-modal__container dc__overflow-auto flex-grow-1",
						children: [/* @__PURE__ */ (0, Q.jsx)(vI, {
							currentTab: o,
							setCurrentTab: s,
							formError: i
						}), /* @__PURE__ */ (0, Q.jsx)("div", {
							className: "dc__overflow-auto flexbox-col flex-grow-1 dc__overflow-auto w-100 p-20 dc__gap-20 bg__modal--secondary",
							children: (() => {
								switch (o) {
									case "basicDetails": return /* @__PURE__ */ (0, Q.jsx)(JF, {
										basicDetails: n.basicDetails,
										setFormData: r,
										basicDetailsError: i.basicDetails,
										setFormError: a,
										metadata: f
									});
									case "restoreTarget": return /* @__PURE__ */ (0, Q.jsx)(EI, {
										restoreTarget: n.restoreTarget,
										setFormData: r,
										restoreTargetError: i.restoreTarget,
										setFormError: a,
										metadata: f
									});
									case "restoreSettings": return /* @__PURE__ */ (0, Q.jsx)(CI, {
										restoreSettings: n.restoreSettings,
										restoreSettingsError: i.restoreSettings,
										setFormData: r,
										setFormError: a,
										configMapOptions: {
											isLoading: m,
											error: g,
											refetch: _,
											options: h
										}
									});
									case "executionControls": return /* @__PURE__ */ (0, Q.jsx)(yI, {
										executionControls: n.executionControls,
										executionControlsError: i.executionControls,
										setFormData: r,
										setFormError: a
									});
									default: return null;
								}
							})()
						})]
					})
				})]
			}), /* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox dc__content-end dc__gap-12 py-16 px-20 border__primary--top dc__no-shrink",
				children: [/* @__PURE__ */ (0, Q.jsx)(M, {
					dataTestId: "footer-cancel-button",
					variant: F.secondary,
					text: "Cancel",
					style: P.neutral,
					size: I.large,
					onClick: e
				}), /* @__PURE__ */ (0, Q.jsx)(M, {
					dataTestId: "footer-apply-button",
					variant: F.primary,
					disabled: u || !!d,
					size: I.large,
					text: "Save",
					isLoading: c,
					onClick: async () => {
						let { isErrorPresent: r, updatedErrorState: o } = sI(n, i);
						if (r) {
							a(o), H.showToast({
								variant: U.error,
								description: "Please resolve all the errors before saving."
							});
							return;
						}
						l(!0), await DI(n) && (e(), t()), l(!1);
					}
				})]
			})]
		})
	});
}, AI = {
	CREATE_FROM_SCRATCH: "create/:type",
	EDIT_SCHEDULE: "edit/schedule/:id",
	CREATE_FROM_SCHEDULE: "create/from-schedule/:id?",
	CREATE_RESTORE: "create-restore"
}, jI = ({ name: e, metadata: t, icon: n, additionalInfo: r, primaryButtonProps: i, secondaryButtonProps: a, actionMenuProps: o }) => /* @__PURE__ */ (0, Q.jsxs)("div", {
	className: "flexbox-col px-16 py-20 dc__separated-flexbox dc__separated-flexbox--vertical w-300 dc__no-shrink border__primary--right dc__overflow-auto",
	children: [
		/* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox-col dc__gap-20",
			children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox-col dc__gap-12",
				children: [/* @__PURE__ */ (0, Q.jsx)("div", {
					className: "bg__tertiary br-12 dc__align-self-start flex left p-8",
					children: n
				}), /* @__PURE__ */ (0, Q.jsx)("h2", {
					className: "fs-16 fw-7 cn-9 m-0 font-merriweather p-0",
					children: e
				})]
			}), /* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox dc__gap-8 flex-wrap",
				children: [
					/* @__PURE__ */ (0, Q.jsx)(M, { ...i }),
					a?.map((e) => /* @__PURE__ */ (0, Q.jsx)(M, { ...e }, e.dataTestId)),
					o && /* @__PURE__ */ (0, Q.jsx)(io, {
						id: "backup-additional-options",
						buttonProps: {
							dataTestId: "restore-backup-more-options-btn",
							variant: F.secondary,
							ariaLabel: "More Options",
							style: P.neutral,
							showAriaLabelInTippy: !1,
							icon: /* @__PURE__ */ (0, Q.jsx)(z, {
								name: "ic-more-vertical",
								color: null
							})
						},
						alignment: "end",
						...o
					})
				]
			})]
		}),
		r && /* @__PURE__ */ (0, Q.jsx)("div", {
			className: "flexbox-col dc__gap-12",
			children: r.map(({ label: e, content: t }, n) => /* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "dc__grid dc__gap-12",
				style: { gridTemplateColumns: "140px 1fr" },
				children: [/* @__PURE__ */ (0, Q.jsx)("span", {
					className: "fs-13 fw-4 cn-7 lh-1-5",
					children: e
				}), t]
			}, n))
		}),
		/* @__PURE__ */ (0, Q.jsx)("div", {
			className: "flexbox-col dc__gap-12",
			children: t.map(({ label: e, value: t, component: n }, r) => /* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox-col dc__gap-4",
				children: [/* @__PURE__ */ (0, Q.jsx)("span", {
					className: "cn-7 fs-13 fw-4 lh-20",
					children: e
				}), t ? /* @__PURE__ */ (0, Q.jsx)("span", {
					className: "fs-13 lh-20 fw-4 cn-9 dc__truncate",
					children: t
				}) : n]
			}, r))
		})
	]
}), MI = /* @__PURE__ */ function(e) {
	return e.BACKUP = "backup", e.SCHEDULE = "schedule", e;
}({}), NI = "backup-detail-meta-container", PI = [
	{
		label: "Resources",
		value: "resources",
		isDisabled: !0,
		tooltipProps: { content: "Coming soon" }
	},
	{
		label: "Volume Backup",
		value: "volume-backup",
		isDisabled: !0,
		tooltipProps: { content: "Coming soon" }
	},
	{
		label: "Logs",
		value: "logs"
	},
	{
		label: "Manifest",
		value: "manifest"
	}
], FI = {
	Completed: "Completed",
	InProgress: "In Progress",
	Failed: "Failed",
	PartiallyFailed: "Partially Failed",
	Deleting: "Deleting",
	FailedValidation: "Failed",
	New: "In Progress",
	InstallationPending: "Installation Pending",
	InstallationFailed: "Installation Failed",
	InstallationSuccess: "Installation Success"
}, II = {
	Completed: "Completed",
	"In Progress": "InProgress",
	Failed: "Failed",
	"Partially Failed": "PartiallyFailed",
	"Failed Validation": "FailedValidation",
	Deleting: "Deleting",
	"Installation Pending": "InstallationPending",
	"Installation Failed": "InstallationFailed",
	"Installation Success": "InstallationSuccess"
}, LI = {
	backupDate: "startedOn",
	name: "name",
	cluster: "clusterName",
	expiresIn: "expiresAt",
	status: "status"
}, RI = {
	cluster: "clusterName",
	scheduleName: "name",
	lastBackup: "lastBackupTime",
	status: "pauseState"
}, zI = async ({ createdBy: e, offset: t, pageSize: n, scheduleId: r, searchKey: i, signal: a, sortBy: o, sortOrder: s, status: c }) => {
	try {
		let { result: l } = await nf(O.BACKUP_LIST, {
			searchByName: i,
			sortBy: LI[o],
			sortOrder: s,
			size: n,
			offset: t,
			filters: [
				{
					key: "createdBy",
					values: e
				},
				{
					key: "scheduleId",
					values: r
				},
				{
					key: "status",
					values: c.map((e) => II[e])
				}
			].filter(({ values: e }) => !!e && Array.isArray(e) && e.length > 0)
		}, { signal: a }), u = l?.data?.map((e) => hL(e)) ?? null;
		return u === null ? {
			totalRows: 0,
			rows: []
		} : {
			totalRows: l.totalCount,
			rows: u.map((e) => ({
				data: e,
				id: e.id.toString()
			}))
		};
	} catch (e) {
		if (!pd(e)) throw e;
		return null;
	}
}, BI = async ({ signal: e, pageSize: t, lastBackupStatus: n, offset: r, pauseState: i, searchKey: a, snapshotLocationId: o, sortBy: s, sortOrder: c, storageLocationId: l }) => {
	try {
		let { result: u } = await nf(O.SCHEDULE_LIST, {
			offset: r,
			searchByName: a,
			sortBy: RI[s],
			sortOrder: c,
			size: t,
			filters: [
				{
					key: "storageLocationId",
					values: l
				},
				{
					key: "snapshotLocationId",
					values: o
				},
				{
					key: "pauseState",
					values: i
				},
				{
					key: "lastBackupStatus",
					values: n.map((e) => II[e])
				}
			].filter(({ values: e }) => !!e?.length)
		}, { signal: e }), d = u?.data?.map((e) => _L(e)) ?? null;
		return d === null ? {
			totalRows: 0,
			rows: []
		} : {
			totalRows: u.totalCount,
			rows: d.map((e) => ({
				data: e,
				id: e.id.toString()
			}))
		};
	} catch (e) {
		if (!pd(e)) throw e;
		return null;
	}
}, VI = async (e) => ff(Y(O.BACKUP_DETAIL, { id: e })), HI = async (e) => ff(Y(O.SCHEDULE_DETAIL, { id: e })), UI = ({ row: { data: { status: e } } }) => /* @__PURE__ */ (0, Q.jsx)("div", {
	className: "flex left",
	children: /* @__PURE__ */ (0, Q.jsx)(Xl, {
		status: uL(e),
		message: e,
		showAnimatedIcon: !0
	})
}), WI = ({ row: { data: { status: e } } }) => {
	let t = null, n = {
		label: e,
		size: I.xs
	};
	switch (e) {
		case "Enabled":
			t = {
				...n,
				variant: "positive"
			};
			break;
		case "FailedValidation":
			t = {
				...n,
				variant: "negative"
			};
			break;
		case "Paused":
			t = {
				...n,
				variant: "warning"
			};
			break;
		case "Unknown":
			t = {
				...n,
				variant: "custom",
				bgColor: "N50",
				startIconProps: { name: "ic-unknown" },
				fontColor: "N700"
			};
			break;
		default: return Xd(`Unknown Backup Schedule status type ${e}`), e;
	}
	return /* @__PURE__ */ (0, Q.jsx)("div", {
		className: "flex left",
		children: /* @__PURE__ */ (0, Q.jsx)(So, { ...t })
	});
}, GI = ({ row: { data: { lastBackup: { status: e } } } }) => /* @__PURE__ */ (0, Q.jsx)("div", {
	className: "flex left",
	children: /* @__PURE__ */ (0, Q.jsx)(Xl, {
		status: uL(e),
		message: e === "Never" ? "Never run yet" : e,
		showAnimatedIcon: !0,
		hideIcon: e === "Never"
	})
}), KI = ({ field: e, signals: t, value: n, row: { id: r, data: { id: i } }, filterData: { searchKey: a } }) => {
	let o = Ja(null), s = X(), c = e === "scheduleName";
	k(() => {
		let e = ({ detail: { activeRowData: e } }) => {
			e.id === r && o.current?.click();
		};
		return t.addEventListener(iu.ENTER_PRESSED, e), () => {
			t.removeEventListener(iu.ENTER_PRESSED, e);
		};
	}, []);
	let l = n;
	return /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flex left dc__gap-4 dc__visible-hover dc__visible-hover--parent",
		children: [/* @__PURE__ */ (0, Q.jsx)(W, {
			content: l,
			children: /* @__PURE__ */ (0, Q.jsx)("button", {
				type: "button",
				className: "dc__unset-button-styles dc__align-left dc__truncate",
				onClick: () => {
					s(Y(B.DATA_PROTECTION_MANAGEMENT_BACKUP_AND_SCHEDULE_DETAIL, {
						id: String(i),
						view: c ? "schedules" : "backups"
					}));
				},
				ref: o,
				children: /* @__PURE__ */ (0, Q.jsx)("span", {
					className: "dc__link cursor",
					dangerouslySetInnerHTML: { __html: Ne.sanitize(Gd({
						searchText: a,
						text: String(l),
						highlightClasses: "p-0 fw-6 bcy-2"
					})) }
				})
			})
		}), /* @__PURE__ */ (0, Q.jsx)(qo, {
			content: String(l),
			rootClassName: "p-2 dc__visible-hover--child",
			iconSize: 16
		})]
	});
}, qI = ({ row: { data: { createdBy: { type: e, label: t } } } }) => /* @__PURE__ */ (0, Q.jsx)(W, {
	alwaysShowTippyOnHover: !0,
	content: fL(e),
	children: /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flex left dc__gap-6",
		children: [(() => {
			switch (e) {
				case "user": return Ku(t, "dc__no-shrink m-0-imp");
				case "schedule": return /* @__PURE__ */ (0, Q.jsx)(z, {
					name: "ic-clock-counterclockwise",
					color: "N700",
					size: 16
				});
				case "external": return /* @__PURE__ */ (0, Q.jsx)(z, {
					name: "ic-arrow-square-out",
					color: "N700",
					size: 16
				});
				default: return null;
			}
		})(), /* @__PURE__ */ (0, Q.jsx)("span", {
			className: "dc__truncate fs-13 cn-9 lh-20",
			children: t
		})]
	})
}), JI = ({ row: { data: { cron: e } } }) => /* @__PURE__ */ (0, Q.jsx)(W, {
	alwaysShowTippyOnHover: !0,
	content: Vu(e),
	children: /* @__PURE__ */ (0, Q.jsx)("div", {
		className: "flex left",
		children: /* @__PURE__ */ (0, Q.jsx)("span", {
			className: "dc__underline-dotted cn-9 fs-13 lh-1-5 dc__truncate",
			children: e
		})
	})
}), YI = ({ reloadTableData: e, row: { data: t } }) => {
	let { view: n } = Z(), [r, i] = j(!1), a = X(), { search: o, pathname: s } = Yf(), c = () => {
		i(!1);
	}, l = () => {
		i(!0);
	};
	if (Object.hasOwn(t, "scheduleName") && n === bo.Schedules) {
		let n = t;
		return /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox px-4 dc__gap-4 dc__content-end dc__align-items-center",
			children: [/* @__PURE__ */ (0, Q.jsx)(M, {
				dataTestId: "edit-schedule-button",
				icon: /* @__PURE__ */ (0, Q.jsx)(z, {
					name: "ic-pencil",
					color: null
				}),
				component: N.link,
				style: P.neutral,
				variant: F.borderLess,
				ariaLabel: `Edit ${n.scheduleName}`,
				showAriaLabelInTippy: !1,
				size: I.small,
				linkProps: { to: {
					pathname: `${s}/${Y(AI.EDIT_SCHEDULE, { id: String(n.id) })}`,
					search: o
				} }
			}), /* @__PURE__ */ (0, Q.jsx)(M, {
				dataTestId: "delete-schedule-button",
				icon: /* @__PURE__ */ (0, Q.jsx)(z, {
					name: "ic-delete",
					color: null
				}),
				component: N.button,
				style: P.negative,
				variant: F.borderLess,
				ariaLabel: `Delete ${n.scheduleName} schedule`,
				showAriaLabelInTippy: !1,
				size: I.small,
				onClick: l
			})]
		}), r && /* @__PURE__ */ (0, Q.jsx)(Ts, {
			title: n.scheduleName,
			component: "schedule",
			subtitle: "Are you sure you want to delete this backup schedule?",
			closeConfirmationModal: c,
			onDelete: async () => {
				await HI(n.id), e();
			},
			successToastMessage: "Schedule deleted successfully"
		})] });
	}
	let { id: u, name: d } = t;
	return /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox px-4 dc__gap-4 dc__content-end dc__align-items-center",
		children: [/* @__PURE__ */ (0, Q.jsx)(M, {
			dataTestId: "restore-backup-button",
			icon: /* @__PURE__ */ (0, Q.jsx)(z, {
				name: "ic-clock-counterclockwise",
				color: null
			}),
			component: N.button,
			style: P.neutral,
			variant: F.borderLess,
			ariaLabel: `Restore ${d} backup`,
			showAriaLabelInTippy: !1,
			size: I.small,
			onClick: () => {
				a({
					pathname: AI.CREATE_RESTORE,
					search: o
				});
			}
		}), /* @__PURE__ */ (0, Q.jsx)(M, {
			dataTestId: "delete-backup-button",
			icon: /* @__PURE__ */ (0, Q.jsx)(z, {
				name: "ic-delete",
				color: null
			}),
			component: N.button,
			style: P.negative,
			variant: F.borderLess,
			ariaLabel: `Delete ${d} backup`,
			showAriaLabelInTippy: !1,
			size: I.small,
			onClick: l
		})]
	}), r && /* @__PURE__ */ (0, Q.jsx)(Ts, {
		title: d,
		component: "backup",
		subtitle: "Are you sure you want to delete this backup?",
		closeConfirmationModal: c,
		onDelete: async () => {
			await VI(u), e();
		},
		successToastMessage: "Backup deleted successfully"
	})] });
}, XI = /* @__PURE__ */ function(e) {
	return e.STATUS = "status", e.CREATED_BY_USER = "createdBy", e.CREATED_BY_SCHEDULE = "scheduleId", e;
}({}), ZI = /* @__PURE__ */ function(e) {
	return e.SCHEDULE_STATUS = "pauseState", e.STORAGE_LOCATION = "storageLocationId", e.LAST_BACKUP_STATUS = "lastBackupStatus", e.SNAPSHOT_LOCATION = "snapshotLocationId", e;
}({}), QI = (e) => ({
	[XI.STATUS]: e.getAll(XI.STATUS),
	[XI.CREATED_BY_USER]: e.getAll(XI.CREATED_BY_USER),
	[XI.CREATED_BY_SCHEDULE]: e.getAll(XI.CREATED_BY_SCHEDULE)
}), $I = (e) => ({
	[ZI.SCHEDULE_STATUS]: e.getAll(ZI.SCHEDULE_STATUS),
	[ZI.LAST_BACKUP_STATUS]: e.getAll(ZI.LAST_BACKUP_STATUS),
	[ZI.STORAGE_LOCATION]: e.getAll(ZI.STORAGE_LOCATION)
}), eL = {
	Completed: "Completed",
	Failed: "Failed",
	"Partially Failed": "PartiallyFailed",
	"Failed Validation": "FailedValidation",
	Deleting: "Deleting",
	"In Progress": "InProgress",
	"Installation Pending": "InstallationPending",
	"Installation Failed": "InstallationFailed",
	"Installation Success": "InstallationSuccess"
}, tL = (e) => e === bo.Backups ? [
	{
		field: "name",
		label: "Name",
		size: { range: {
			startWidth: 242,
			minWidth: 80,
			maxWidth: 600
		} },
		horizontallySticky: !0,
		isSortable: !0,
		CellComponent: KI
	},
	{
		field: "cluster",
		label: "Cluster",
		size: { range: {
			startWidth: 120,
			minWidth: 80,
			maxWidth: 600
		} },
		isSortable: !0
	},
	{
		field: "createdBy",
		label: "Created By",
		size: { range: {
			startWidth: 200,
			minWidth: 80,
			maxWidth: 600
		} },
		isSortable: !0,
		CellComponent: qI
	},
	{
		field: "status",
		label: "Status",
		size: { range: {
			startWidth: 120,
			minWidth: 80,
			maxWidth: 600
		} },
		isSortable: !0,
		CellComponent: UI
	},
	{
		field: "backupDate",
		label: "Backup Date",
		size: { range: {
			startWidth: 200,
			minWidth: 80,
			maxWidth: 600
		} },
		isSortable: !0
	},
	{
		field: "expiresIn",
		label: "Expires In",
		size: { range: {
			startWidth: 80,
			minWidth: 80,
			maxWidth: 600
		} }
	}
] : [
	{
		field: "scheduleName",
		label: "Schedule Name",
		size: { range: {
			startWidth: 242,
			minWidth: 80,
			maxWidth: 600
		} },
		horizontallySticky: !0,
		isSortable: !0,
		CellComponent: KI
	},
	{
		field: "status",
		label: "Status",
		size: { range: {
			startWidth: 180,
			minWidth: 80,
			maxWidth: 600
		} },
		isSortable: !0,
		CellComponent: WI
	},
	{
		field: "cluster",
		label: "Cluster",
		size: { range: {
			startWidth: 120,
			minWidth: 80,
			maxWidth: 600
		} },
		isSortable: !0
	},
	{
		field: "storageLocation",
		label: "Storage Location",
		size: { range: {
			startWidth: 200,
			minWidth: 80,
			maxWidth: 600
		} },
		isSortable: !0
	},
	{
		field: "cron",
		label: "Cron",
		CellComponent: JI,
		size: { range: {
			startWidth: 120,
			minWidth: 80,
			maxWidth: 600
		} }
	},
	{
		field: "lastBackup",
		label: "Last Backup",
		size: { range: {
			startWidth: 200,
			minWidth: 80,
			maxWidth: 600
		} },
		isSortable: !0,
		CellComponent: GI
	},
	{
		field: "lastSkipped",
		label: "Last Skipped",
		size: { range: {
			startWidth: 120,
			minWidth: 80,
			maxWidth: 600
		} },
		isSortable: !0
	}
], nL = (e) => ({
	[XI.STATUS]: e[XI.STATUS] ?? [],
	[XI.CREATED_BY_USER]: e[XI.CREATED_BY_USER] ?? "",
	[XI.CREATED_BY_SCHEDULE]: e[XI.CREATED_BY_SCHEDULE] ?? ""
}), rL = (e) => ({
	[ZI.SCHEDULE_STATUS]: e[ZI.SCHEDULE_STATUS] ?? [],
	[ZI.STORAGE_LOCATION]: e[ZI.STORAGE_LOCATION] ?? [],
	[ZI.LAST_BACKUP_STATUS]: e[ZI.LAST_BACKUP_STATUS] ?? [],
	[ZI.SNAPSHOT_LOCATION]: e[ZI.SNAPSHOT_LOCATION] ?? []
}), iL = (e, t) => {
	let { updateSearchParams: n } = e, r = nL(e), i = r[XI.STATUS].map((e) => ({
		label: e,
		value: e
	})), a = t.userFilterOptions.options?.filter((e) => r[XI.CREATED_BY_USER].includes(String(e.value))) ?? [], o = t.scheduleFilterOptions.options?.filter((e) => r[XI.CREATED_BY_SCHEDULE].includes(String(e.value))) ?? [], s = (e) => (t) => {
		n({ [e]: t.map((e) => String(e.value)) });
	}, c = {
		[XI.STATUS]: {
			placeholder: "Status",
			inputId: "backup-list-status-select",
			options: Object.entries(eL).map(([e, t]) => ({
				label: e,
				value: t
			})),
			appliedFilterOptions: i,
			handleApplyFilter: s(XI.STATUS),
			isDisabled: !1,
			isLoading: !1
		},
		[XI.CREATED_BY_USER]: {
			placeholder: "Created By User",
			inputId: "backup-list-created-by-user-select",
			options: t.userFilterOptions.options,
			appliedFilterOptions: a,
			handleApplyFilter: s(XI.CREATED_BY_USER),
			isDisabled: !1,
			isLoading: t.userFilterOptions.isLoading,
			optionListError: t.userFilterOptions.error,
			reloadOptionList: t.userFilterOptions.refetch
		},
		[XI.CREATED_BY_SCHEDULE]: {
			placeholder: "Created By Schedule",
			inputId: "backup-list-created-by-schedule-select",
			options: t.scheduleFilterOptions.options,
			appliedFilterOptions: o,
			handleApplyFilter: s(XI.CREATED_BY_SCHEDULE),
			isDisabled: !1,
			isLoading: t.scheduleFilterOptions.isLoading,
			optionListError: t.scheduleFilterOptions.error,
			reloadOptionList: t.scheduleFilterOptions.refetch
		}
	};
	return {
		options: [{
			groupLabel: "Filter by",
			items: [
				{
					id: XI.STATUS,
					label: "Status"
				},
				{
					id: XI.CREATED_BY_USER,
					label: "Created By"
				},
				{
					id: XI.CREATED_BY_SCHEDULE,
					label: "Created By Schedule"
				}
			]
		}],
		filterSelectPickerPropsMap: c,
		isFilterApplied: !!(i.length || a.length)
	};
}, aL = (e, t) => {
	let { updateSearchParams: n } = e, r = rL(e), i = r[ZI.SCHEDULE_STATUS].map((e) => ({
		label: e,
		value: e
	})), a = t.storageLocationOptions.options?.filter((e) => r[ZI.STORAGE_LOCATION].includes(String(e.value))) ?? [], o = r[ZI.LAST_BACKUP_STATUS].map((e) => ({
		label: e,
		value: e
	})), s = t.snapshotLocationOptions.options?.filter((e) => r[ZI.SNAPSHOT_LOCATION].includes(String(e.value))) ?? [], c = (e) => (t) => {
		n({ [e]: t.map((e) => String(e.value)) });
	}, l = {
		Enabled: !1,
		Paused: !0
	}, u = {
		[ZI.SCHEDULE_STATUS]: {
			placeholder: "Schedule Status",
			inputId: "backup-schedule-list-schedule-status-select",
			options: Object.entries(l).map(([e, t]) => ({
				label: e,
				value: `${t}`
			})),
			appliedFilterOptions: i,
			handleApplyFilter: c(ZI.SCHEDULE_STATUS),
			isDisabled: !1,
			isLoading: !1
		},
		[ZI.STORAGE_LOCATION]: {
			placeholder: "Storage Location",
			inputId: "backup-schedule-list-storage-location-select",
			options: t.storageLocationOptions.options,
			appliedFilterOptions: a,
			handleApplyFilter: c(ZI.STORAGE_LOCATION),
			isDisabled: !1,
			isLoading: t.storageLocationOptions.isLoading,
			optionListError: t.storageLocationOptions.error,
			reloadOptionList: t.storageLocationOptions.refetch
		},
		[ZI.SNAPSHOT_LOCATION]: {
			placeholder: "Snapshot Location",
			inputId: "backup-schedule-list-snapshot-location-select",
			options: t.snapshotLocationOptions.options,
			appliedFilterOptions: s,
			handleApplyFilter: c(ZI.SNAPSHOT_LOCATION),
			isDisabled: !1,
			isLoading: t.snapshotLocationOptions.isLoading,
			optionListError: t.snapshotLocationOptions.error,
			reloadOptionList: t.snapshotLocationOptions.refetch
		},
		[ZI.LAST_BACKUP_STATUS]: {
			placeholder: "Last Backup Status",
			inputId: "backup-schedule-list-last-backup-status-select",
			options: Object.entries(eL).map(([e, t]) => ({
				label: e,
				value: t
			})),
			appliedFilterOptions: o,
			handleApplyFilter: c(ZI.LAST_BACKUP_STATUS),
			isDisabled: !1,
			isLoading: !1
		}
	};
	return {
		options: [{
			groupLabel: "Filter by",
			items: [
				{
					id: ZI.SCHEDULE_STATUS,
					label: "Schedule Status"
				},
				{
					id: ZI.STORAGE_LOCATION,
					label: "Storage Location"
				},
				{
					id: ZI.SNAPSHOT_LOCATION,
					label: "Snapshot Location"
				},
				{
					id: ZI.LAST_BACKUP_STATUS,
					label: "Last Backup Status"
				}
			]
		}],
		filterSelectPickerPropsMap: u,
		isFilterApplied: !!(i.length || a.length || o.length)
	};
}, oL = (e) => {
	switch (e) {
		case XI.CREATED_BY_USER: return "Created By";
		default: return e;
	}
}, sL = (e) => {
	switch (e) {
		case ZI.LAST_BACKUP_STATUS: return "Last Backup Status";
		case ZI.SCHEDULE_STATUS: return "Schedule Status";
		case ZI.STORAGE_LOCATION: return "Storage Location";
		case ZI.SNAPSHOT_LOCATION: return "Snapshot Location";
		default: return e;
	}
}, cL = (e, t, { scheduleFilterOptions: n }) => {
	switch (e) {
		case XI.CREATED_BY_SCHEDULE: return n.options.find((e) => String(e.value) === t)?.label.toString() ?? "";
		default: return t;
	}
}, lL = (e, t, { snapshotLocationOptions: n, storageLocationOptions: r }) => {
	switch (e) {
		case ZI.STORAGE_LOCATION: return r.options.find((e) => String(e.value) === t)?.label.toString() ?? t;
		case ZI.SNAPSHOT_LOCATION: return n.options.find((e) => String(e.value) === t)?.label.toString() ?? t;
		case ZI.SCHEDULE_STATUS: return t === "true" ? "Paused" : "Enabled";
		default: return t;
	}
}, uL = (e) => {
	switch (e) {
		case "Completed":
		case "Installation Success": return Zl.SUCCEEDED;
		case "In Progress":
		case "Installation Pending": return Zl.PROGRESSING;
		case "Failed":
		case "Installation Failed":
		case "Failed Validation": return Zl.FAILED;
		case "Deleting": return Zl.DEGRADED;
		case "Partially Failed": return "warning";
		default: return Zl.UNKNOWN;
	}
}, dL = (e) => [{
	groupLabel: "Create backup",
	items: [{
		id: "created-backup__from-scratch",
		label: "From Scratch",
		componentType: "link",
		to: {
			pathname: Y(AI.CREATE_FROM_SCRATCH, { type: MI.BACKUP }),
			search: e
		}
	}, {
		id: "create-backup__from-schedule",
		label: "From Schedule",
		componentType: "link",
		to: {
			pathname: Y(AI.CREATE_FROM_SCHEDULE),
			search: e
		}
	}]
}, { items: [{
	id: "create-backup-schedule",
	label: "Create Backup Schedule",
	componentType: "link",
	to: {
		pathname: Y(AI.CREATE_FROM_SCRATCH, { type: MI.SCHEDULE }),
		search: e
	}
}] }], fL = (e) => {
	switch (e) {
		case "user": return "Backup created by user";
		case "schedule": return "Backup created by schedule";
		case "external": return "Backup created by external system";
		default: return null;
	}
}, pL = (e) => {
	if (!e) return "Unknown";
	let t = (0, Op.default)(e), n = (0, Op.default)(), r = t.diff(n, "days");
	return r <= 0 ? "Expired" : r === 1 ? "1 day" : `${r} days`;
}, mL = (e) => {
	if (!e) return "Unknown";
	switch (e.phase) {
		case "InstallationPending": return "Installation Pending";
		case "InstallationFailed": return "Installation Failed";
		case "InstallationSuccess": return "Installation Success";
		case "New":
		case "InProgress": return "In Progress";
		case "Completed": return "Completed";
		case "PartiallyFailed": return "Partially Failed";
		case "Failed":
		case "FailedValidation": return "Failed";
		case "Deleting": return "Deleting";
		default: return "Failed";
	}
}, hL = (e) => {
	let t = e.scheduleName ? {
		label: e.scheduleName,
		type: "schedule"
	} : {
		label: e.createdBy || "Unknown",
		type: "user"
	};
	return {
		id: e.id,
		name: e.name,
		cluster: e.clusterName,
		expiresIn: pL(e.status?.expiration),
		backupDate: e.status?.startTimestamp ? (0, Op.default)(e.status.startTimestamp).format(ss.DD_MMM_YYYY_HH_MM) : "Unknown",
		status: mL(e.status),
		createdBy: t
	};
}, gL = (e) => e.paused ? "Paused" : e.status?.phase ?? "Unknown", _L = (e) => ({
	id: e.id,
	scheduleName: e.name,
	status: gL(e),
	cluster: e.clusterName,
	storageLocation: e.storageLocationName,
	cron: e.schedule,
	lastBackup: e.status?.lastBackup ? {
		time: (0, Op.default)(e.status.lastBackup).format("llll"),
		status: "Completed"
	} : { status: "Never" },
	lastSkipped: e.status?.lastSkippedTime ? (0, Op.default)(e.status.lastSkippedTime).format(ss.DD_MMM_YYYY_HH_MM) : "Never"
}), vL = ({ label: e }) => /* @__PURE__ */ (0, Q.jsx)(Go, {
	size: I.xs,
	label: e,
	startIconProps: {
		name: "ic-storage",
		color: "N700"
	},
	style: "neutral"
}), yL = ({ backupDetail: e, onActionMenuClick: t, onBackupRestoreClick: n }) => ({
	name: e.name,
	icon: /* @__PURE__ */ (0, Q.jsx)(z, {
		name: "ic-backup-color",
		size: 40,
		color: null
	}),
	primaryButtonProps: {
		text: "Restore Backup",
		dataTestId: "restore-backup-btn",
		startIcon: /* @__PURE__ */ (0, Q.jsx)(z, {
			name: "ic-clock-counterclockwise",
			color: null
		}),
		variant: F.primary,
		onClick: n
	},
	actionMenuProps: {
		onClick: t,
		options: [{ items: [{
			label: "Delete",
			id: "delete-backup",
			type: "negative",
			startIcon: { name: "ic-delete" }
		}] }]
	},
	metadata: [
		{
			label: "Backup for",
			value: e.backupFor
		},
		{
			label: "Created by",
			component: e.createdBy.type === "schedule" ? /* @__PURE__ */ (0, Q.jsx)(M, {
				variant: F.text,
				dataTestId: "created-by-schedule-btn",
				size: I.xs,
				component: N.link,
				text: e.createdBy.label,
				linkProps: { to: Y(B.DATA_PROTECTION_MANAGEMENT_BACKUP_AND_SCHEDULE_DETAIL, {
					view: "schedules",
					id: String(e.id)
				}) }
			}) : /* @__PURE__ */ (0, Q.jsx)("span", {
				className: "fs-13 fw-4 cn-9",
				children: e.createdBy.label
			})
		},
		{
			label: "Duration",
			value: e.duration
		},
		{
			label: "Snapshot locations",
			component: /* @__PURE__ */ (0, Q.jsx)("div", {
				className: "flexbox dc__gap-4",
				children: e.snapshotLocations.map((e) => /* @__PURE__ */ (0, Q.jsx)(vL, { label: e }, e))
			})
		},
		...e.backupScope.map(([e, t]) => ({
			label: e,
			value: t
		}))
	],
	additionalInfo: [
		{
			label: "Status",
			content: /* @__PURE__ */ (0, Q.jsx)("div", {
				className: "flex right",
				children: /* @__PURE__ */ (0, Q.jsx)(Xl, {
					status: uL(e.status),
					message: e.status,
					showAnimatedIcon: !0
				})
			})
		},
		...e.warningsAndErrors.length > 0 ? [{
			label: "Warnings & Errors",
			content: /* @__PURE__ */ (0, Q.jsx)("div", {
				className: "flex right dc__gap-6",
				children: e.warningsAndErrors.map((e) => /* @__PURE__ */ (0, Q.jsx)(So, {
					label: e.count.toString(),
					variant: e.type === "error" ? "negative" : "warning",
					startIconProps: { name: e.type === "error" ? "ic-close-small" : "ic-warning" }
				}, `${e.type}-${e.count}`))
			})
		}] : [],
		{
			label: "Resources",
			content: /* @__PURE__ */ (0, Q.jsx)("div", {
				className: "flex right",
				children: /* @__PURE__ */ (0, Q.jsxs)("span", {
					className: "fs-13 fw-4 cn-9 lh-1-5",
					children: [
						e.completedResources,
						"/",
						e.totalResources
					]
				})
			})
		}
	]
}), bL = (e) => e.sourceType === "schedule" && e.scheduleName ? {
	label: e.scheduleName,
	type: "schedule"
} : e.createdBy ? {
	label: e.createdBy,
	type: "user"
} : {
	label: "External",
	type: "external"
}, xL = (e) => {
	let t = [];
	e.status.warnings && e.status.warnings > 0 && t.push({
		type: "warning",
		message: "Backup completed with warnings",
		count: e.status.warnings
	}), e.status.errors && e.status.errors > 0 && t.push({
		type: "error",
		message: "Backup completed with errors",
		count: e.status.errors
	}), e.status.validationErrors?.length && t.push({
		type: "error",
		message: `Validation failed: ${e.status.validationErrors.join(", ")}`,
		count: e.status.validationErrors.length
	});
	let n = [];
	if (e.includedNamespaces?.length && n.push(["Included Namespaces", e.includedNamespaces.join(", ")]), e.excludedNamespaces?.length && n.push(["Excluded Namespaces", e.excludedNamespaces.join(", ")]), e.includedResources?.length && n.push(["Included Resources", e.includedResources.join(", ")]), e.excludedResources?.length && n.push(["Excluded Resources", e.excludedResources.join(", ")]), e.labelSelector?.matchLabels && Object.keys(e.labelSelector.matchLabels).length > 0) {
		let t = Object.entries(e.labelSelector.matchLabels).map(([e, t]) => `${e}=${t}`).join(", ");
		n.push(["Label Selector", t]);
	}
	return {
		id: e.id,
		name: e.name,
		status: FI[e.status?.phase] ?? "Unknown",
		warningsAndErrors: t,
		completedResources: e.status?.progress?.itemsBackedUp || 0,
		totalResources: e.status?.progress?.totalItems || 0,
		backupFor: e.clusterName,
		createdBy: bL(e),
		duration: Pd({
			startTime: e.status?.startTimestamp,
			endTime: e.status?.completionTimestamp
		}),
		snapshotLocations: e.snapshotLocationNames || [],
		backupScope: n,
		k8sManifestDetail: {
			clusterId: e.clusterId,
			gvk: e.manifestGvk.gvk,
			namespace: e.manifestGvk.veleroNamespace,
			name: e.name
		}
	};
}, SL = async ({ id: e, signal: t }) => {
	let { result: n } = await G(Y(O.BACKUP_DETAIL, { id: e }), { signal: t });
	return xL(n);
}, CL = async ({ id: e, signal: t }) => {
	let { result: { logs: n } } = await G(Y(O.BACKUP_LOGS, { id: e }), { signal: t });
	return n;
}, wL = () => {
	let { id: e } = Z(), { data: t, isFetching: n, error: r, refetch: i } = q({
		queryFn: ({ signal: t }) => CL({
			signal: t,
			id: +e
		}),
		queryKey: ["backup-log", e]
	});
	return /* @__PURE__ */ (0, Q.jsx)("div", {
		className: "flexbox-col flex-grow-1",
		children: n ? /* @__PURE__ */ (0, Q.jsx)(ul, { size: 32 }) : r ? /* @__PURE__ */ (0, Q.jsx)(Ks, {
			code: r.code,
			reload: i
		}) : /* @__PURE__ */ (0, Q.jsx)(Xo, {
			mode: Ic.PLAINTEXT,
			value: t,
			height: "fitToParent",
			theme: mo.dark,
			readOnly: !0
		})
	});
}, TL = ({ detail: e, isDetailLoading: t, detailError: n, refetchDetail: r }) => {
	let i = X(), { search: a } = Yf(), { view: o, id: s } = Z(), { searchParams: c } = jf(), l = c.tab ?? "manifest", u = ({ value: e }) => {
		let t = new URLSearchParams(a);
		t.set("tab", e), i({ search: t.toString() });
	}, { data: d, isLoading: f, error: p, refetch: m } = q({
		queryKey: ["backup-manifest", e],
		queryFn: ({ signal: t }) => Un({
			clusterId: e.k8sManifestDetail.clusterId,
			gvk: e.k8sManifestDetail.gvk,
			name: e.k8sManifestDetail.name,
			namespace: e.k8sManifestDetail.namespace,
			signal: t
		}),
		select: (e) => Tu(e.manifestResponse.manifest),
		enabled: l === "manifest" && !!e
	}), h = () => {
		i(Y(B.DATA_PROTECTION_MANAGEMENT_BACKUP_AND_SCHEDULE, { view: bo.Backups }), { replace: !0 });
	};
	if (t) return /* @__PURE__ */ (0, Q.jsx)(ul, { pageLoader: !0 });
	if (n) return /* @__PURE__ */ (0, Q.jsx)(Ks, {
		reload: r,
		on404Redirect: h,
		code: n.code
	});
	let g = () => {
		switch (l) {
			case "resources": return /* @__PURE__ */ (0, Q.jsx)("div", { children: "Resources View" });
			case "volume-backup": return /* @__PURE__ */ (0, Q.jsx)("div", { children: "Volume Backup View" });
			case "logs": return /* @__PURE__ */ (0, Q.jsx)(wL, {});
			case "manifest": return p ? /* @__PURE__ */ (0, Q.jsx)(Ks, {
				reload: m,
				code: p.code
			}) : /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsx)(Xo, {
				loading: f,
				readOnly: !0,
				height: "100%",
				mode: Ic.YAML,
				value: d ?? ""
			}), d && /* @__PURE__ */ (0, Q.jsx)(cl, {
				portalParentId: "backup-detail-meta-container",
				children: /* @__PURE__ */ (0, Q.jsx)(qo, {
					variant: "button--secondary",
					size: I.small,
					content: d
				})
			})] });
			default: return null;
		}
	}, _ = async (t) => {
		switch (t.id) {
			case "delete-backup":
				try {
					await ff(Y(O.BACKUP_DETAIL, { id: e.id })), H.showToast({
						variant: U.success,
						description: "Backup deleted successfully"
					});
				} catch (e) {
					K(e);
				}
				break;
			default:
		}
	}, v = () => {
		i(`${Y(B.DATA_PROTECTION_MANAGEMENT_BACKUP_AND_SCHEDULE_DETAIL, {
			id: s,
			view: o
		})}/${AI.CREATE_RESTORE}`);
	}, y = () => {
		i({
			pathname: Y(B.DATA_PROTECTION_MANAGEMENT_BACKUP_AND_SCHEDULE_DETAIL, {
				id: s,
				view: o
			}),
			search: a
		}, { replace: !0 });
	}, b = () => {
		r(), y();
	};
	return /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox h-100 w-100 dc__overflow-hidden",
		children: [/* @__PURE__ */ (0, Q.jsx)(jI, { ...yL({
			backupDetail: e,
			onActionMenuClick: _,
			onBackupRestoreClick: v
		}) }), /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox-col flex-grow-1 dc__overflow-hidden",
			children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox dc__content-space dc__gap-16 py-12 px-16 border__secondary--bottom dc__no-shrink",
				children: [/* @__PURE__ */ (0, Q.jsx)(Bl, {
					name: "backup-view-control",
					value: l,
					segments: PI,
					onChange: u
				}), /* @__PURE__ */ (0, Q.jsx)("div", { id: NI })]
			}), /* @__PURE__ */ (0, Q.jsx)("div", {
				className: "flex-grow-1 dc__overflow-hidden flexbox-col",
				children: g()
			})]
		})]
	}), /* @__PURE__ */ (0, Q.jsx)(qf, { children: /* @__PURE__ */ (0, Q.jsx)(J, {
		path: AI.CREATE_RESTORE,
		element: /* @__PURE__ */ (0, Q.jsx)(kI, {
			onSuccess: b,
			handleClose: y
		})
	}) })] });
}, EL = ({ backupScheduleDetail: e, onCreateBackupFromThisScheduleClick: t, onUpdateScheduleEnabledState: n, isPauseUnpauseScheduleAPICallInProgress: r, onActionMenuClick: i }) => ({
	name: e.name,
	icon: /* @__PURE__ */ (0, Q.jsx)(z, {
		name: "ic-backup-schedule-color",
		size: 40,
		color: null
	}),
	primaryButtonProps: e.status === "Paused" ? {
		text: "Resume Schedule",
		dataTestId: "resume-schedule-btn",
		startIcon: /* @__PURE__ */ (0, Q.jsx)(z, {
			name: "ic-play-outline",
			color: null
		}),
		variant: F.primary,
		isLoading: r,
		onClick: n
	} : {
		text: "Pause Schedule",
		dataTestId: "pause-schedule-btn",
		startIcon: /* @__PURE__ */ (0, Q.jsx)(z, {
			name: "ic-pause",
			color: null
		}),
		variant: F.primary,
		isLoading: r,
		style: P.warning,
		onClick: n
	},
	secondaryButtonProps: [{
		dataTestId: "backup-schedule-upload-btn",
		variant: F.secondary,
		ariaLabel: "Create backup from this schedule",
		showAriaLabelInTippy: !0,
		tooltipProps: { placement: "bottom" },
		style: P.neutral,
		icon: /* @__PURE__ */ (0, Q.jsx)(z, {
			name: "ic-cloud-upload",
			color: null
		}),
		onClick: t
	}],
	actionMenuProps: {
		onClick: i,
		options: [{ items: [{
			label: "Edit",
			startIcon: { name: "ic-pencil" },
			id: "edit"
		}, {
			label: "Delete",
			startIcon: { name: "ic-delete" },
			id: "delete-schedule",
			type: "negative"
		}] }]
	},
	metadata: [
		{
			label: "Cluster to backup",
			value: e.backupFor
		},
		{
			label: "Created by",
			value: e.createdBy.label
		},
		{
			label: "Last backup",
			value: e.lastBackup ? `${(0, Op.default)(e.lastBackup.timestamp).format(ss.TWELVE_HOURS_FORMAT_WITHOUT_WEEKDAY)} (${e.lastBackup.status})` : "No backups yet"
		},
		{
			label: "Last skipped",
			value: e.lastSkipped ? (0, Op.default)(e.lastSkipped).format(ss.TWELVE_HOURS_FORMAT_WITHOUT_WEEKDAY) : "No backups yet"
		},
		...e.snapshotLocations ? [{
			label: "Snapshot locations",
			component: /* @__PURE__ */ (0, Q.jsx)("div", {
				className: "flexbox-col dc__gap-4 flex-wrap",
				children: e.snapshotLocations.map((e) => /* @__PURE__ */ (0, Q.jsx)(vL, { label: e }, e))
			})
		}] : [],
		{
			label: "Included namespaces",
			value: e.backupScope.includedNamespaces
		},
		{
			label: "Excluded namespaces",
			value: e.backupScope.excludedNamespaces
		}
	]
}), DL = (e) => {
	let t;
	t = e.paused ? "Paused" : e.status.phase === "FailedValidation" ? "FailedValidation" : "Enabled";
	let n = e.lastBackup ? {
		name: e.lastBackup.name,
		status: mL(e.lastBackup.status),
		timestamp: e.lastBackup.status?.completionTimestamp || e.lastBackup.status?.startTimestamp || ""
	} : null, r = t === "Enabled" ? Vu(e.schedule) : null, i = {
		includedNamespaces: e.includedNamespaces?.join(", ") || "All namespaces",
		excludedNamespaces: e.excludedNamespaces?.join(", ") || "None"
	}, a = {
		label: e.createdBy || "Unknown",
		type: "user"
	};
	return {
		id: e.id,
		name: e.name,
		status: t,
		schedule: e.schedule,
		lastBackup: n,
		nextBackup: r,
		backupFor: e.clusterName,
		createdBy: a,
		backupScope: i,
		snapshotLocations: e.snapshotLocationNames,
		retentionPolicy: e.ttl || "No retention policy",
		lastSkipped: null,
		k8sManifestDetail: {
			clusterId: e.clusterId,
			gvk: e.manifestGvk.gvk,
			namespace: e.manifestGvk.veleroNamespace,
			name: e.name
		}
	};
}, OL = async ({ id: e, signal: t }) => {
	let { result: n } = await G(Y(O.SCHEDULE_DETAIL, { id: e }), { signal: t });
	return DL(n);
}, kL = ({ state: e, setState: t }) => {
	let n = e.advancedTimeoutsAndTuning.CSISnapshotTimeout, r = e.advancedTimeoutsAndTuning.ItemOperationTimeout;
	return /* @__PURE__ */ (0, Q.jsx)(Ho, {
		padding: 16,
		flexGap: 16,
		variant: "secondary--outlined",
		children: /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "dc__separated-flexbox dc__separated-flexbox--vertical",
			children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox dc__gap-16",
				children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "flex-grow-1",
					children: [/* @__PURE__ */ (0, Q.jsx)("h4", {
						className: "fs-13 fw-4 lh-20 cn-9 m-0",
						children: "CSI Snapshot Timeout"
					}), /* @__PURE__ */ (0, Q.jsx)("p", {
						className: "fs-12 fw-4 lh-16 cn-7 m-0",
						children: "How long to wait for CSI snapshot creation before timeout"
					})]
				}), /* @__PURE__ */ (0, Q.jsx)(LF, {
					idPrefix: "csi-snapshot-timeout",
					value: n.value,
					unit: n.unit,
					onUnitChange: (e) => {
						t((t) => ({
							...t,
							advancedTimeoutsAndTuning: {
								...t.advancedTimeoutsAndTuning,
								CSISnapshotTimeout: {
									...t.advancedTimeoutsAndTuning.CSISnapshotTimeout,
									unit: e
								}
							}
						}));
					},
					onValueChange: (e) => {
						t((t) => ({
							...t,
							advancedTimeoutsAndTuning: {
								...t.advancedTimeoutsAndTuning,
								CSISnapshotTimeout: {
									...t.advancedTimeoutsAndTuning.CSISnapshotTimeout,
									value: e
								}
							}
						}));
					}
				})]
			}), /* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox dc__gap-16",
				children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "flex-grow-1",
					children: [/* @__PURE__ */ (0, Q.jsx)("h4", {
						className: "fs-13 fw-4 lh-20 cn-9 m-0",
						children: "Item Operation Timeout"
					}), /* @__PURE__ */ (0, Q.jsx)("p", {
						className: "fs-12 fw-4 lh-16 cn-7 m-0",
						children: "How long to wait for async plugin operations before timeout"
					})]
				}), /* @__PURE__ */ (0, Q.jsx)(LF, {
					idPrefix: "item-operation-timeout",
					value: r.value,
					unit: r.unit,
					onUnitChange: (e) => {
						t((t) => ({
							...t,
							advancedTimeoutsAndTuning: {
								...t.advancedTimeoutsAndTuning,
								ItemOperationTimeout: {
									...t.advancedTimeoutsAndTuning.ItemOperationTimeout,
									unit: e
								}
							}
						}));
					},
					onValueChange: (e) => {
						t((t) => ({
							...t,
							advancedTimeoutsAndTuning: {
								...t.advancedTimeoutsAndTuning,
								ItemOperationTimeout: {
									...t.advancedTimeoutsAndTuning.ItemOperationTimeout,
									value: e
								}
							}
						}));
					}
				})]
			})]
		})
	});
}, AL = {
	all: "all",
	"all-non-prod": "non-prod",
	"all-prod": "prod",
	specific: "specific"
}, jL = {
	all: "all",
	"non-prod": "all-non-prod",
	prod: "all-prod",
	specific: "specific"
}, ML = {
	basicDetails: "basicDetails",
	backupScopeAndPolicy: "backupScopeAndPolicy",
	storageAndSnapshotLocation: "storageAndSnapshotSettings",
	advancedTimeoutsAndTuning: null
}, NL = "# currently only supports v1 version, Example:\nversion: v1\nvolumePolicies:\n# each policy consists of a list of conditions and an action\n# we could have lots of policies, but if the resource matched the first policy, the latters will be ignored\n# each key in the object is one condition, and one policy will apply to resources that meet ALL conditions\n# NOTE: capacity or storageClass is suited for [Persistent Volumes](https://kubernetes.io/docs/concepts/storage/persistent-volumes), and pod [Volume](https://kubernetes.io/docs/concepts/storage/volumes) not support it.\n- conditions:\n    # capacity condition matches the volumes whose capacity falls into the range\n    capacity: \"10,100Gi\"\n    # pv matches specific csi driver\n    csi:\n      driver: ebs.csi.aws.com\n    # pv matches one of the storage class list\n    storageClass:\n    - gp2\n    - standard\n  action:\n    type: skip\n- conditions:\n    capacity: \"0,100Gi\"\n    # nfs volume source with specific server and path (nfs could be empty or only config server or path)\n    nfs:\n      server: 192.168.200.90\n      path: /mnt/data\n  action:\n    type: skip\n- conditions:\n    nfs:\n      server: 192.168.200.90\n  action:\n    type: skip\n- conditions:\n    # nfs could be empty which matches any nfs volume source\n    nfs: {}\n  action:\n    type: skip\n- conditions:\n    # csi could be empty which matches any csi volume source\n    csi: {}\n  action:\n    type: skip", PL = ({ state: e, setState: t }) => {
	let n = (n) => {
		let r = n.target.value;
		if (r === "specific") {
			t({
				...e,
				backupScopeAndPolicy: {
					...e.backupScopeAndPolicy,
					resources: "specific",
					resourcesScope: {
						clusterScopedResources: {
							isSelected: !1,
							includedResources: [],
							excludedResources: []
						},
						namespaceScopedResources: {
							isSelected: !1,
							includedResources: [],
							excludedResources: []
						}
					}
				}
			});
			return;
		}
		let i = e.backupScopeAndPolicy;
		delete i.resourcesScope, t({
			...e,
			backupScopeAndPolicy: {
				...i,
				resources: r
			}
		});
	}, r = () => {
		t((e) => ({
			...e,
			backupScopeAndPolicy: {
				...e.backupScopeAndPolicy,
				resources: "specific",
				resourcesScope: {
					...e.backupScopeAndPolicy.resourcesScope,
					clusterScopedResources: {
						isSelected: !e.backupScopeAndPolicy.resourcesScope.clusterScopedResources.isSelected,
						includedResources: [],
						excludedResources: []
					}
				}
			}
		}));
	}, i = () => {
		t((e) => ({
			...e,
			backupScopeAndPolicy: {
				...e.backupScopeAndPolicy,
				resources: "specific",
				resourcesScope: {
					...e.backupScopeAndPolicy.resourcesScope,
					namespaceScopedResources: {
						isSelected: !e.backupScopeAndPolicy.resourcesScope.namespaceScopedResources.isSelected,
						includedResources: [],
						excludedResources: []
					}
				}
			}
		}));
	}, a = (e) => (n) => {
		t((t) => ({
			...t,
			backupScopeAndPolicy: {
				...t.backupScopeAndPolicy,
				resources: "specific",
				resourcesScope: {
					...t.backupScopeAndPolicy.resourcesScope,
					clusterScopedResources: {
						...t.backupScopeAndPolicy.resourcesScope.clusterScopedResources,
						includedResources: e ? t.backupScopeAndPolicy.resourcesScope.clusterScopedResources.includedResources : n || [],
						excludedResources: e ? n || [] : t.backupScopeAndPolicy.resourcesScope.clusterScopedResources.excludedResources
					}
				}
			}
		}));
	}, o = (t) => (n) => {
		let r = {
			label: n,
			value: n
		}, i = [...t ? e.backupScopeAndPolicy.resourcesScope.clusterScopedResources.excludedResources : e.backupScopeAndPolicy.resourcesScope.clusterScopedResources.includedResources, r];
		a(t)(i);
	}, s = (e) => (n) => {
		t((t) => ({
			...t,
			backupScopeAndPolicy: {
				...t.backupScopeAndPolicy,
				resources: "specific",
				resourcesScope: {
					...t.backupScopeAndPolicy.resourcesScope,
					namespaceScopedResources: {
						...t.backupScopeAndPolicy.resourcesScope.namespaceScopedResources,
						includedResources: e ? t.backupScopeAndPolicy.resourcesScope.namespaceScopedResources.includedResources : n || [],
						excludedResources: e ? n || [] : t.backupScopeAndPolicy.resourcesScope.namespaceScopedResources.excludedResources
					}
				}
			}
		}));
	}, c = (t) => (n) => {
		let r = {
			label: n,
			value: n
		}, i = [...t ? e.backupScopeAndPolicy.resourcesScope.namespaceScopedResources.excludedResources : e.backupScopeAndPolicy.resourcesScope.namespaceScopedResources.includedResources, r];
		s(t)(i);
	};
	return /* @__PURE__ */ (0, Q.jsxs)(Ho, {
		padding: 16,
		flexGap: 16,
		variant: "secondary--outlined",
		children: [
			/* @__PURE__ */ (0, Q.jsx)("h3", {
				className: "fs-13 fw-6 lh-20 cn-9 m-0",
				children: "Resources to backup"
			}),
			/* @__PURE__ */ (0, Q.jsxs)(vl, {
				value: e.backupScopeAndPolicy.resources,
				name: "resource-radio-group",
				onChange: n,
				className: "radio-group-no-border",
				children: [/* @__PURE__ */ (0, Q.jsx)(yl, {
					dataTestId: "all-resources",
					value: "all",
					children: "All Resources"
				}), /* @__PURE__ */ (0, Q.jsx)(yl, {
					dataTestId: "specific-resources",
					value: "specific",
					children: "Specific Resources"
				})]
			}),
			e.backupScopeAndPolicy.resources === "specific" && /* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox-col dc__gap-8",
				children: [
					/* @__PURE__ */ (0, Q.jsx)(Wo, {
						isChecked: e.backupScopeAndPolicy.resourcesScope.clusterScopedResources.isSelected,
						onChange: r,
						rootClassName: "icon-dim-20 w-100 dc_max-width__max-content mb-0 br-4",
						dataTestId: "toggle-cluster-scoped-resources",
						value: Io.CHECKED,
						children: /* @__PURE__ */ (0, Q.jsx)("span", {
							className: "cn-9 fs-13 fw-4 lh-20",
							children: "Cluster Scoped"
						})
					}),
					e.backupScopeAndPolicy.resourcesScope.clusterScopedResources.isSelected && /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsx)(V, {
						inputId: "cluster-scoped-included-resources-select",
						isMulti: !0,
						label: "Included Resources",
						placeholder: "Type and Enter to include resources",
						options: [],
						value: e.backupScopeAndPolicy.resourcesScope.clusterScopedResources.includedResources,
						isCreatable: !0,
						onCreateOption: o(!1),
						onChange: a(!1)
					}), /* @__PURE__ */ (0, Q.jsx)(V, {
						inputId: "cluster-scoped-excluded-resources-select",
						label: "Excluded Resources",
						placeholder: "Type and Enter to exclude resources",
						isMulti: !0,
						options: [],
						value: e.backupScopeAndPolicy.resourcesScope.clusterScopedResources.excludedResources,
						isCreatable: !0,
						onCreateOption: o(!0),
						onChange: a(!0)
					})] }),
					/* @__PURE__ */ (0, Q.jsx)(Wo, {
						isChecked: e.backupScopeAndPolicy.resourcesScope.namespaceScopedResources.isSelected,
						onChange: i,
						rootClassName: "icon-dim-20 w-100 dc_max-width__max-content mb-0 br-4",
						dataTestId: "toggle-namespace-scoped-resources",
						value: Io.CHECKED,
						children: /* @__PURE__ */ (0, Q.jsx)("span", {
							className: "cn-9 fs-13 fw-4 lh-20",
							children: "Namespace Scoped"
						})
					}),
					e.backupScopeAndPolicy.resourcesScope.namespaceScopedResources.isSelected && /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsx)(V, {
						inputId: "namespace-scoped-included-resources-select",
						label: "Included Resources",
						placeholder: "Type and Enter to include resources",
						isMulti: !0,
						options: [],
						value: e.backupScopeAndPolicy.resourcesScope.namespaceScopedResources.includedResources,
						isCreatable: !0,
						onCreateOption: c(!1),
						onChange: s(!1)
					}), /* @__PURE__ */ (0, Q.jsx)(V, {
						inputId: "namespace-scoped-excluded-resources-select",
						label: "Excluded Resources",
						placeholder: "Type and Enter to exclude resources",
						isMulti: !0,
						options: [],
						value: e.backupScopeAndPolicy.resourcesScope.namespaceScopedResources.excludedResources,
						isCreatable: !0,
						onCreateOption: c(!0),
						onChange: s(!0)
					})] })
				]
			})
		]
	});
}, FL = ({ state: e, setState: t, clusterListConfig: n, namespaceListConfig: r, formError: i, setFormError: a }) => {
	let { backupScopeAndPolicy: o } = e, s = A(() => n.options.filter((t) => t.value === e.backupScopeAndPolicy.selectedClusterId), [e.backupScopeAndPolicy.selectedClusterId]), c = (n) => {
		a((e) => ({
			...e,
			backupScopeAndPolicy: {
				...e.backupScopeAndPolicy,
				namespaceSelection: null
			}
		}));
		let r = n.target.value;
		if (r === "specific") {
			t({
				...e,
				backupScopeAndPolicy: {
					...e.backupScopeAndPolicy,
					namespaces: "specific",
					excludedNamespace: [],
					includedNamespace: []
				}
			});
			return;
		}
		let i = { ...e.backupScopeAndPolicy };
		delete i.includedNamespace, delete i.excludedNamespace, t({
			...e,
			backupScopeAndPolicy: {
				...i,
				namespaces: r
			}
		});
	}, l = (n) => (r) => {
		let i = {
			...e,
			backupScopeAndPolicy: {
				...e.backupScopeAndPolicy,
				namespaces: "specific",
				includedNamespace: n ? e.backupScopeAndPolicy.includedNamespace : r.map((e) => e.value),
				excludedNamespace: n ? r.map((e) => e.value) : e.backupScopeAndPolicy.excludedNamespace
			}
		}, o = i.backupScopeAndPolicy.includedNamespace.length + i.backupScopeAndPolicy.excludedNamespace.length;
		t(i), a((e) => ({
			...e,
			backupScopeAndPolicy: {
				...e.backupScopeAndPolicy,
				namespaceSelection: o === 0 ? "At least one namespace must be selected." : null
			}
		}));
	};
	return /* @__PURE__ */ (0, Q.jsxs)(Ho, {
		padding: 16,
		flexGap: 16,
		variant: "secondary--outlined",
		children: [
			/* @__PURE__ */ (0, Q.jsx)("h3", {
				className: "fs-13 fw-6 lh-20 cn-9 m-0",
				children: "Namespaces to backup"
			}),
			/* @__PURE__ */ (0, Q.jsx)(V, {
				label: "Select cluster to backup",
				inputId: "cluster-selection",
				options: n.options,
				value: s,
				optionListError: n.error,
				reloadOptionList: n.refetch,
				onChange: (n) => {
					let r = n.value, i = { ...e.backupScopeAndPolicy };
					delete i.includedNamespace, delete i.excludedNamespace, t({
						...e,
						backupScopeAndPolicy: {
							...i,
							selectedClusterId: r,
							namespaces: "all"
						}
					}), a((e) => ({
						...e,
						backupScopeAndPolicy: {
							...e.backupScopeAndPolicy,
							selectedClusterId: null
						}
					}));
				},
				placeholder: "Select a cluster",
				size: I.large,
				isSearchable: !0,
				isLoading: n.isLoading,
				required: !0,
				error: i.backupScopeAndPolicy.selectedClusterId
			}),
			/* @__PURE__ */ (0, Q.jsxs)(vl, {
				value: e.backupScopeAndPolicy.namespaces,
				name: "namespace-option-radio-group",
				onChange: c,
				className: "radio-group-no-border",
				children: [
					/* @__PURE__ */ (0, Q.jsx)(yl, {
						dataTestId: "all-namespace",
						value: "all",
						children: "All Namespaces"
					}),
					/* @__PURE__ */ (0, Q.jsx)(yl, {
						dataTestId: "all-prod-namespace",
						value: "all-prod",
						children: "All Production Environments"
					}),
					/* @__PURE__ */ (0, Q.jsx)(yl, {
						dataTestId: "all-non-prod-namespace",
						value: "all-non-prod",
						children: "All Non-Production Environments"
					}),
					/* @__PURE__ */ (0, Q.jsxs)(yl, {
						dataTestId: "specific-namespace",
						value: "specific",
						children: ["Specific Namespaces", i.backupScopeAndPolicy.namespaceSelection && /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsx)("br", {}), /* @__PURE__ */ (0, Q.jsx)("span", {
							className: "cr-5 fs-12 fw-4 lh-18",
							children: i.backupScopeAndPolicy.namespaceSelection
						})] })]
					})
				]
			}),
			o?.namespaces === "specific" && /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsx)(V, {
				inputId: "include-namespace-select",
				isMulti: !0,
				label: "Included Namespaces",
				placeholder: "Select namespaces to include",
				value: e.backupScopeAndPolicy.includedNamespace.map((e) => ({
					label: e,
					value: e
				})),
				onChange: l(!1),
				options: r.options,
				optionListError: r.error,
				isLoading: r.isLoading,
				reloadOptionList: r.refetch
			}), /* @__PURE__ */ (0, Q.jsx)(V, {
				inputId: "exclude-namespace-select",
				isMulti: !0,
				label: "Excluded Namespaces",
				placeholder: "Select namespaces to exclude",
				value: e.backupScopeAndPolicy.excludedNamespace.map((e) => ({
					label: e,
					value: e
				})),
				onChange: l(!0),
				options: r.options,
				optionListError: r.error,
				isLoading: r.isLoading,
				reloadOptionList: r.refetch
			})] })
		]
	});
}, IL = /* @__PURE__ */ function(e) {
	return e.SELECT_CM = "select-cm", e.PROVIDE_YAML = "provide-yaml", e;
}({}), LL = ({ state: e, setState: t, clusterListConfig: n, namespaceListConfig: r, formError: i, setFormError: a, configMapListConfig: o }) => /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [
	/* @__PURE__ */ (0, Q.jsx)(FL, {
		state: e,
		setState: t,
		clusterListConfig: n,
		namespaceListConfig: r,
		formError: i,
		setFormError: a
	}),
	/* @__PURE__ */ (0, Q.jsx)(PL, {
		state: e,
		setState: t
	}),
	/* @__PURE__ */ (0, Q.jsx)(Ho, {
		padding: 16,
		flexGap: 16,
		variant: "secondary--outlined",
		children: /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox dc__gap-16",
			children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flex-grow-1",
				children: [/* @__PURE__ */ (0, Q.jsx)("h4", {
					className: "fs-13 fw-4 lh-20 cn-9 m-0",
					children: "Backup TTL"
				}), /* @__PURE__ */ (0, Q.jsx)("p", {
					className: "fs-12 fw-4 lh-16 cn-7 m-0",
					children: "How long before the backup can be garbage collected"
				})]
			}), /* @__PURE__ */ (0, Q.jsx)(LF, {
				idPrefix: "backup-ttl",
				value: e.backupScopeAndPolicy.backupTTL.value,
				unit: e.backupScopeAndPolicy.backupTTL.unit,
				onUnitChange: (e) => {
					t((t) => ({
						...t,
						backupScopeAndPolicy: {
							...t.backupScopeAndPolicy,
							backupTTL: {
								...t.backupScopeAndPolicy.backupTTL,
								unit: e
							}
						}
					}));
				},
				onValueChange: (e) => {
					t((t) => ({
						...t,
						backupScopeAndPolicy: {
							...t.backupScopeAndPolicy,
							backupTTL: {
								...t.backupScopeAndPolicy.backupTTL,
								value: e
							}
						}
					}));
				}
			})]
		})
	}),
	/* @__PURE__ */ (0, Q.jsx)(Ho, {
		padding: 16,
		flexGap: 16,
		variant: "secondary--outlined",
		children: /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox-col dc__gap-16",
			children: [/* @__PURE__ */ (0, Q.jsx)("div", {
				className: "flex-grow-1",
				children: /* @__PURE__ */ (0, Q.jsx)("h4", {
					className: "fs-13 fw-4 lh-20 cn-9 m-0",
					children: "Ordered Resources"
				})
			}), /* @__PURE__ */ (0, Q.jsx)(kc, {
				headerLabel: {
					key: "Key",
					value: "Value"
				},
				placeholder: {
					key: "Enter key",
					value: "Enter value"
				},
				rows: e.backupScopeAndPolicy.orderedResources.map(({ key: e, value: t, id: n }) => ({
					data: {
						key: { value: e },
						value: { value: t }
					},
					id: n
				})),
				showError: !0,
				onChange: (e) => {
					t((t) => ({
						...t,
						backupScopeAndPolicy: {
							...t.backupScopeAndPolicy,
							orderedResources: e
						}
					}));
				},
				onError: (e) => {
					a((t) => ({
						...t,
						backupScopeAndPolicy: {
							...t.backupScopeAndPolicy,
							orderedResources: e ? "Please fix errors in ordered resources." : null
						}
					}));
				},
				validateEmptyKeys: !0,
				validateDuplicateKeys: !0,
				isSortable: !0
			})]
		})
	}),
	/* @__PURE__ */ (0, Q.jsx)(Ho, {
		padding: 16,
		flexGap: 16,
		variant: "secondary--outlined",
		children: /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox-col dc__gap-16",
			children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox dc__content-space",
				children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "flexbox-col flex-grow-1",
					children: [/* @__PURE__ */ (0, Q.jsx)("h4", {
						className: "fs-13 fw-4 lh-20 cn-9 m-0",
						children: "Resources Policy"
					}), /* @__PURE__ */ (0, Q.jsx)("p", {
						className: "fs-12 fw-4 lh-16 cn-7 m-0",
						children: "Specify the referenced resource policies that backup should follow"
					})]
				}), /* @__PURE__ */ (0, Q.jsx)(bs, {
					isChecked: e.backupScopeAndPolicy.resourcePolicy.isEnabled,
					onChange: () => {
						let n = e.backupScopeAndPolicy.resourcePolicy.isEnabled ? { isEnabled: !1 } : {
							isEnabled: !0,
							type: IL.SELECT_CM,
							configMapName: null
						};
						t((e) => ({
							...e,
							backupScopeAndPolicy: {
								...e.backupScopeAndPolicy,
								resourcePolicy: n
							}
						})), a((e) => ({
							...e,
							backupScopeAndPolicy: {
								...e.backupScopeAndPolicy,
								resourcePolicy: null
							}
						}));
					},
					name: "enable-resource-policy-switch",
					ariaLabel: "Enable Resource Policy Switch"
				})]
			}), /* @__PURE__ */ (0, Q.jsx)(Zo, {
				expand: e.backupScopeAndPolicy.resourcePolicy.isEnabled,
				children: /* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "flexbox-col dc__gap-8",
					children: [/* @__PURE__ */ (0, Q.jsx)(vl, {
						className: "no-border",
						value: e.backupScopeAndPolicy.resourcePolicy.type,
						name: "modify-resources-config-radio-group",
						onChange: (e) => {
							let n = e.target.value === IL.SELECT_CM ? {
								type: IL.SELECT_CM,
								configMapName: null
							} : {
								type: IL.PROVIDE_YAML,
								data: ""
							};
							t((e) => ({
								...e,
								backupScopeAndPolicy: {
									...e.backupScopeAndPolicy,
									resourcePolicy: {
										...n,
										isEnabled: !0
									}
								}
							})), a((e) => ({
								...e,
								backupScopeAndPolicy: {
									...e.backupScopeAndPolicy,
									resourcePolicy: null
								}
							}));
						},
						children: /* @__PURE__ */ (0, Q.jsxs)("div", { children: [/* @__PURE__ */ (0, Q.jsx)(yl, {
							value: IL.SELECT_CM,
							dataTestId: "modify-resources-config-select-cm-checkbox",
							children: /* @__PURE__ */ (0, Q.jsx)("span", {
								className: "cn-9 fs-13 fw-4 lh-20",
								children: "Select ConfigMap"
							})
						}), /* @__PURE__ */ (0, Q.jsx)(yl, {
							value: IL.PROVIDE_YAML,
							dataTestId: "restore-target-namespace-specific-checkbox",
							children: /* @__PURE__ */ (0, Q.jsx)("span", {
								className: "cn-9 fs-13 fw-4 lh-20",
								children: "Provide Policy YAML"
							})
						})] })
					}), e.backupScopeAndPolicy.resourcePolicy.type === IL.SELECT_CM ? /* @__PURE__ */ (0, Q.jsx)(V, {
						inputId: "backup-resource-policy-config-map",
						options: o.options || [],
						value: e.backupScopeAndPolicy.resourcePolicy.configMapName ? {
							label: e.backupScopeAndPolicy.resourcePolicy.configMapName,
							value: e.backupScopeAndPolicy.resourcePolicy.configMapName || ""
						} : null,
						onChange: (e) => {
							let n = {
								type: IL.SELECT_CM,
								configMapName: e.value
							};
							t((e) => ({
								...e,
								backupScopeAndPolicy: {
									...e.backupScopeAndPolicy,
									resourcePolicy: {
										...n,
										isEnabled: !0
									}
								}
							})), a((e) => ({
								...e,
								backupScopeAndPolicy: {
									...e.backupScopeAndPolicy,
									resourcePolicy: null
								}
							}));
						},
						placeholder: "Select a ConfigMap",
						label: "Resource Policy ConfigMap",
						required: !0,
						fullWidth: !0,
						isLoading: o.isLoading,
						optionListError: o.error,
						reloadOptionList: o.refetch,
						error: i.backupScopeAndPolicy.resourcePolicy
					}) : /* @__PURE__ */ (0, Q.jsx)(Xo, {
						value: e.backupScopeAndPolicy.resourcePolicy.data,
						mode: Ic.YAML,
						height: 300,
						onChange: (e) => {
							let n = {
								type: IL.PROVIDE_YAML,
								data: e
							};
							t((e) => ({
								...e,
								backupScopeAndPolicy: {
									...e.backupScopeAndPolicy,
									resourcePolicy: {
										...n,
										isEnabled: !0
									}
								}
							})), a((t) => ({
								...t,
								backupScopeAndPolicy: {
									...t.backupScopeAndPolicy,
									resourcePolicy: e.trim() ? null : "Resource policy YAML cannot be empty."
								}
							}));
						},
						placeholder: NL,
						children: i.backupScopeAndPolicy.resourcePolicy && /* @__PURE__ */ (0, Q.jsx)(Xo.ErrorBar, { text: i.backupScopeAndPolicy.resourcePolicy })
					})]
				})
			})]
		})
	}),
	/* @__PURE__ */ (0, Q.jsx)(OF, {
		labelSelectors: e.backupScopeAndPolicy.labelSelectors,
		handleLabelSelectorChange: (e) => {
			t((t) => ({
				...t,
				backupScopeAndPolicy: {
					...t.backupScopeAndPolicy,
					labelSelectors: e
				}
			}));
		},
		handleOrLabelSelectorsChange: (e) => {
			t((t) => ({
				...t,
				backupScopeAndPolicy: {
					...t.backupScopeAndPolicy,
					orLabelSelectors: e
				}
			}));
		},
		orLabelSelectors: e.backupScopeAndPolicy.orLabelSelectors
	})
] }), RL = ({ label: e, description: t, isChecked: n, onChange: r }) => /* @__PURE__ */ (0, Q.jsxs)("div", {
	className: "flexbox dc__gap-16 dc__align-start",
	children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flex-grow-1",
		children: [/* @__PURE__ */ (0, Q.jsx)("p", {
			className: "fs-13 lh-1-5 fw-4 cn-9 m-0",
			children: e
		}), /* @__PURE__ */ (0, Q.jsx)("p", {
			className: "fs-12 lh-1-5 fw-4 cn-7 m-0",
			children: t
		})]
	}), /* @__PURE__ */ (0, Q.jsx)(bs, {
		name: "snapshot-move-data",
		isChecked: n,
		ariaLabel: "Snapshot move data",
		onChange: r
	})]
}), zL = (e, t) => [
	{
		key: "basicDetails",
		label: t === MI.BACKUP ? "Basic Details" : "Basic & Scheduling",
		isActive: e === "basicDetails"
	},
	{
		key: "backupScopeAndPolicy",
		label: "Backup Scope & Policy",
		isActive: e === "backupScopeAndPolicy"
	},
	{
		key: "storageAndSnapshotLocation",
		label: "Storage & Snapshot location",
		isActive: e === "storageAndSnapshotLocation"
	},
	{
		key: "advancedTimeoutsAndTuning",
		label: "Advanced Timeouts & Tuning",
		isActive: e === "advancedTimeoutsAndTuning"
	}
], BL = (e) => {
	let t = {
		advancedTimeoutsAndTuning: {
			CSISnapshotTimeout: {
				value: null,
				unit: PF.SECONDS
			},
			ItemOperationTimeout: {
				value: null,
				unit: PF.SECONDS
			}
		},
		storageAndSnapshotSettings: {
			volumeSnapshotLocation: null,
			storageLocation: null,
			volumeSnapshotEnabled: !1
		},
		backupScopeAndPolicy: {
			selectedClusterId: 0,
			backupTTL: {
				value: null,
				unit: PF.SECONDS
			},
			resourcePolicy: { isEnabled: !1 },
			labelSelectors: [SF()],
			orLabelSelectors: [[SF()]],
			resources: "all",
			namespaces: "all",
			orderedResources: []
		}
	};
	return e === "backup" ? {
		...t,
		basicBackupDetails: {
			backupName: "",
			labels: []
		}
	} : {
		...t,
		basicScheduleDetails: {
			scheduleName: "",
			description: "",
			labels: [],
			cronExpression: "",
			paused: !1,
			skipUpcomingRun: !1,
			deleteBackupsOnScheduleDeletion: !1
		}
	};
}, VL = (e) => e.map(({ key: e, value: t, id: n }) => ({
	id: n,
	data: {
		key: { value: e },
		value: { value: t }
	}
})), HL = ({ state: e, formError: t, type: n }) => {
	let r = n === MI.BACKUP, i = structuredClone(t.basicDetails), a = r ? e.basicBackupDetails.backupName : e.basicScheduleDetails.scheduleName, o = r ? "" : e.basicScheduleDetails.cronExpression;
	return i.name = i.name || lf(a).message, r || (i.cronExpression = i.cronExpression || lf(o).message), i;
}, UL = ({ state: e, formError: t }) => {
	let n = structuredClone(t.backupScopeAndPolicy), { backupScopeAndPolicy: r } = e, i = r.selectedClusterId ? null : "Cluster selection is required.";
	n.selectedClusterId = n.selectedClusterId || i;
	let a = r.resourcePolicy.type === IL.PROVIDE_YAML ? r.resourcePolicy.data : r.resourcePolicy.configMapName, o = r.resourcePolicy.isEnabled ? lf(a).message : null;
	n.resourcePolicy = n.resourcePolicy || o;
	let s = r.namespaces === "specific", c = (r.includedNamespace?.length || 0) + (r.excludedNamespace?.length || 0), l = s && c === 0 ? "At least one namespace must be selected." : null;
	return n.namespaceSelection = n.namespaceSelection || l, n;
}, WL = ({ state: e, formError: t }) => {
	let n = structuredClone(t.storageAndSnapshotSettings), { storageAndSnapshotSettings: r } = e, i = r.storageLocation ? null : "Storage location is required.";
	return n.storageLocation = n.storageLocation || i, n;
}, GL = ({ state: e, formError: t, type: n }) => {
	let r = structuredClone(t);
	return r.basicDetails = HL({
		state: e,
		formError: t,
		type: n
	}), r.backupScopeAndPolicy = UL({
		state: e,
		formError: t
	}), r.storageAndSnapshotSettings = WL({
		state: e,
		formError: t
	}), {
		isFormValid: !Object.values(r).some((e) => Object.values(e).some((e) => !!e)),
		updatedFormErrors: r
	};
}, KL = (e, t, n) => ({
	name: e,
	description: t,
	labels: n.reduce((e, { key: t, value: n }) => {
		let r = t.trim();
		return r && (e[r] = n.trim()), e;
	}, {})
}), qL = (e) => {
	let { basicScheduleDetails: t } = e;
	return {
		...KL(t.scheduleName, t.description, t.labels),
		schedule: t.cronExpression,
		paused: t.paused,
		skipImmediately: t.skipUpcomingRun,
		useOwnerReferencesInBackup: t.deleteBackupsOnScheduleDeletion
	};
}, JL = (e) => e.isEnabled ? e.type === IL.PROVIDE_YAML ? {
	type: "CreateResourcePolicy",
	data: e.data
} : {
	type: "ExistingResourcePolicy",
	name: e.configMapName
} : null, YL = (e) => e.resources === "all" ? { isAllResourcesIncluded: !0 } : {
	isAllResourcesIncluded: !1,
	includedClusterScopedResources: (e.resourcesScope.clusterScopedResources.includedResources || []).map((e) => e.value),
	excludedClusterScopedResources: (e.resourcesScope.clusterScopedResources.excludedResources || []).map((e) => e.value),
	includedNamespaceScopedResources: (e.resourcesScope.namespaceScopedResources.includedResources || []).map((e) => e.value),
	excludedNamespaceScopedResources: (e.resourcesScope.namespaceScopedResources.excludedResources || []).map((e) => e.value)
}, XL = (e) => ({
	...YL(e),
	...EF({
		labelSelectors: e.labelSelectors,
		orLabelSelectors: e.orLabelSelectors
	}),
	clusterId: e.selectedClusterId,
	namespaceGroup: AL[e.namespaces],
	includedNamespaces: e.includedNamespace || [],
	excludedNamespaces: e.excludedNamespace || [],
	ttl: BF(e.backupTTL.value, e.backupTTL.unit),
	orderedResources: (e.orderedResources || []).reduce((e, { key: t, value: n }) => {
		let r = t.trim();
		return r && (e[r] = n.trim()), e;
	}, {}),
	resourcePolicyConfig: JL(e.resourcePolicy)
}), ZL = (e) => {
	if (!e.volumeSnapshotEnabled) return { snapshotVolumes: !1 };
	let t = e.snapshotVolumeSettings;
	return {
		snapshotVolumes: !0,
		snapshotMoveData: t.moveData,
		defaultVolumesToFsBackup: t.defaultVolumesToFSBackup,
		dataMover: t.dataMover,
		uploaderConfig: { parallelFilesUpload: t.parallelFilesUpload }
	};
}, QL = (e) => ({
	...ZL(e),
	storageLocationId: e.storageLocation,
	snapshotLocationIds: e.volumeSnapshotLocation
}), $L = (e) => ({
	csiSnapshotTimeout: BF(e.CSISnapshotTimeout.value, e.CSISnapshotTimeout.unit),
	itemOperationTimeout: BF(e.ItemOperationTimeout.value, e.ItemOperationTimeout.unit)
}), eR = (e) => ({
	...qL(e),
	...XL(e.backupScopeAndPolicy),
	...QL(e.storageAndSnapshotSettings),
	...$L(e.advancedTimeoutsAndTuning)
}), tR = (e) => ({
	...KL(e.basicBackupDetails.backupName, void 0, e.basicBackupDetails.labels),
	...XL(e.backupScopeAndPolicy),
	...QL(e.storageAndSnapshotSettings),
	...$L(e.advancedTimeoutsAndTuning),
	sourceType: "manual"
}), nR = (e) => {
	let t = jL[e.namespaceGroup];
	return t === "specific" ? {
		namespaces: "specific",
		includedNamespace: e.includedNamespaces || [],
		excludedNamespace: e.excludedNamespaces || []
	} : { namespaces: t };
}, rR = (e) => e.isAllResourcesIncluded ? { resources: "all" } : {
	resources: "specific",
	resourcesScope: {
		clusterScopedResources: {
			isSelected: (e.includedClusterScopedResources || []).length > 0 || (e.excludedClusterScopedResources || []).length > 0,
			includedResources: (e.includedClusterScopedResources || []).map((e) => ({
				label: e,
				value: e
			})),
			excludedResources: (e.excludedClusterScopedResources || []).map((e) => ({
				label: e,
				value: e
			}))
		},
		namespaceScopedResources: {
			isSelected: (e.includedNamespaceScopedResources || []).length > 0 || (e.excludedNamespaceScopedResources || []).length > 0,
			includedResources: (e.includedNamespaceScopedResources || []).map((e) => ({
				label: e,
				value: e
			})),
			excludedResources: (e.excludedNamespaceScopedResources || []).map((e) => ({
				label: e,
				value: e
			}))
		}
	}
}, iR = (e) => e.resourcePolicyConfig ? e.resourcePolicyConfig.type === "CreateResourcePolicy" ? {
	isEnabled: !0,
	type: IL.PROVIDE_YAML,
	data: e.resourcePolicyConfig.data
} : {
	isEnabled: !0,
	type: IL.SELECT_CM,
	configMapName: e.resourcePolicyConfig.name
} : { isEnabled: !1 }, aR = (e) => ({
	basicScheduleDetails: {
		scheduleName: e.name || "",
		description: e.description || "",
		labels: Object.entries(e.labels || {}).map(([e, t]) => ({
			id: Id(),
			key: e,
			value: t
		})),
		cronExpression: e.schedule || "",
		paused: e.paused || !1,
		skipUpcomingRun: e.skipImmediately || !1,
		deleteBackupsOnScheduleDeletion: e.useOwnerReferencesInBackup || !1
	},
	backupScopeAndPolicy: {
		...rR(e),
		...nR(e),
		labelSelectors: e.labelSelectors ? TF(e.labelSelectors) : [SF()],
		orLabelSelectors: e.orLabelSelectors?.length ? e.orLabelSelectors.map(TF) : [[SF()]],
		selectedClusterId: e.clusterId,
		backupTTL: zF(e.ttl),
		orderedResources: Object.entries(e.orderedResources || {}).map(([e, t]) => ({
			key: e,
			value: t,
			id: Id()
		})),
		resourcePolicy: iR(e)
	},
	storageAndSnapshotSettings: {
		storageLocation: e.storageLocationId || null,
		volumeSnapshotLocation: e.snapshotLocationIds || null,
		...e.snapshotVolumes ? {
			volumeSnapshotEnabled: !0,
			snapshotVolumeSettings: {
				moveData: e.snapshotMoveData || !1,
				defaultVolumesToFSBackup: e.defaultVolumesToFsBackup || !1,
				dataMover: e.dataMover || "",
				parallelFilesUpload: e.uploaderConfig?.parallelFilesUpload || null
			}
		} : { volumeSnapshotEnabled: !1 }
	},
	advancedTimeoutsAndTuning: {
		CSISnapshotTimeout: zF(e.csiSnapshotTimeout),
		ItemOperationTimeout: zF(e.itemOperationTimeout)
	}
}), oR = (e) => Object.values(e).some((e) => !!e), sR = ({ state: e, setState: t, formError: n, setFormError: r }) => {
	let { type: i, id: a } = Z(), o = !!a, s = i === "backup", c = (e, t) => {
		switch (e) {
			case "backupName":
			case "scheduleName":
				r((e) => ({
					...e,
					basicDetails: {
						...e.basicDetails,
						name: Bf(t).message
					}
				}));
				break;
			case "cronExpression":
				r((e) => ({
					...e,
					basicDetails: {
						...e.basicDetails,
						cronExpression: Lf(t).message
					}
				}));
				break;
			case "description":
				r((e) => ({
					...e,
					basicDetails: {
						...e.basicDetails,
						description: Rf(t).message
					}
				}));
				break;
			default: break;
		}
	}, l = (e) => {
		r((t) => ({
			...t,
			basicDetails: {
				...t.basicDetails,
				labels: e ? "Please fix the errors in labels" : ""
			}
		}));
	}, u = (n) => (r) => {
		let { value: i } = r.target;
		t(s ? {
			...e,
			basicBackupDetails: {
				...e.basicBackupDetails,
				[n]: i
			},
			basicScheduleDetails: void 0
		} : {
			...e,
			basicBackupDetails: void 0,
			basicScheduleDetails: {
				...e.basicScheduleDetails,
				[n]: i
			}
		}), c(n, i);
	}, d = (n) => () => {
		s || t({
			...e,
			basicBackupDetails: void 0,
			basicScheduleDetails: {
				...e.basicScheduleDetails,
				[n]: !e.basicScheduleDetails[n]
			}
		});
	}, f = (n) => {
		if (s) {
			t({
				...e,
				basicScheduleDetails: void 0,
				basicBackupDetails: {
					...e.basicBackupDetails,
					labels: n
				}
			});
			return;
		}
		t({
			...e,
			basicBackupDetails: void 0,
			basicScheduleDetails: {
				...e.basicScheduleDetails,
				labels: n
			}
		});
	}, p = s ? "" : ((e) => {
		try {
			return Vu(e);
		} catch {
			return "";
		}
	})(e.basicScheduleDetails.cronExpression);
	return /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsxs)(Ho, {
		padding: 16,
		flexGap: 16,
		variant: "secondary--outlined",
		children: [
			/* @__PURE__ */ (0, Q.jsx)(os, {
				name: s ? "backup-name" : "schedule-name",
				label: s ? "Backup Name" : "Schedule Name",
				placeholder: s ? "Enter backup name" : "Enter schedule name",
				value: s ? e.basicBackupDetails.backupName : e.basicScheduleDetails.scheduleName,
				onChange: u(s ? "backupName" : "scheduleName"),
				required: !0,
				autoFocus: !0,
				disabled: o,
				size: I.large,
				error: n.basicDetails.name
			}),
			!s && /* @__PURE__ */ (0, Q.jsx)("div", {
				className: "flexbox-col dc__gap-4",
				children: /* @__PURE__ */ (0, Q.jsx)(ou, {
					label: "Description",
					name: "description",
					placeholder: "Enter a brief description for this schedule",
					value: e.basicScheduleDetails.description || "",
					onChange: u("description"),
					error: n.basicDetails.description
				})
			}),
			/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox-col dc__gap-12",
				children: [/* @__PURE__ */ (0, Q.jsx)("span", {
					className: "fs-13 fw-6 lh-1-5 cn-9",
					children: "Labels"
				}), /* @__PURE__ */ (0, Q.jsx)(kc, {
					headerLabel: {
						key: "Key",
						value: "Value"
					},
					rows: VL(s ? e.basicBackupDetails.labels : e.basicScheduleDetails.labels),
					showError: !0,
					validateEmptyKeys: !0,
					validateDuplicateKeys: !0,
					isSortable: !0,
					placeholder: {
						key: "Enter label key",
						value: "Enter label value"
					},
					onChange: f,
					onError: l
				})]
			})
		]
	}), !s && /* @__PURE__ */ (0, Q.jsxs)(Ho, {
		padding: 16,
		flexGap: 16,
		variant: "secondary--outlined",
		children: [/* @__PURE__ */ (0, Q.jsx)("h3", {
			className: "fs-13 fw-6 lh-20 cn-9 m-0",
			children: "Backup Schedule Preferences"
		}), /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "dc__separated-flexbox dc__separated-flexbox--vertical",
			children: [
				/* @__PURE__ */ (0, Q.jsx)(os, {
					name: "cron-expression",
					label: "Backup Schedule",
					placeholder: "Type cron expression",
					value: e.basicScheduleDetails.cronExpression,
					onChange: u("cronExpression"),
					error: n.basicDetails.cronExpression,
					required: !0,
					size: I.large,
					helperText: p ? /* @__PURE__ */ (0, Q.jsxs)("span", { children: ["Cron expression will be evaluated and shown here:\xA0", /* @__PURE__ */ (0, Q.jsx)("span", {
						className: "cg-7",
						children: p
					})] }) : null
				}),
				/* @__PURE__ */ (0, Q.jsx)(RL, {
					label: "Pause schedule",
					description: "Pauses this backup schedule. Pausing this schedule will not create backups.",
					isChecked: e.basicScheduleDetails.paused,
					ariaLabel: "Pause schedule",
					name: "pause-schedule-b&s",
					onChange: d("paused")
				}),
				/* @__PURE__ */ (0, Q.jsx)(RL, {
					label: "Skip upcoming backup",
					description: "Skip the next scheduled backup immediately.",
					isChecked: e.basicScheduleDetails.skipUpcomingRun,
					onChange: d("skipUpcomingRun"),
					name: "skip-upcoming-backup-b&s",
					ariaLabel: "Skip upcoming backup toggle"
				}),
				/* @__PURE__ */ (0, Q.jsx)(RL, {
					label: "Delete backups on schedule deletion",
					description: "If set to true, deleting this schedule will also delete all the backups that were created by this schedule",
					isChecked: e.basicScheduleDetails.deleteBackupsOnScheduleDeletion,
					onChange: d("deleteBackupsOnScheduleDeletion"),
					name: "delete-backups-on-schedule-deletion",
					ariaLabel: "Delete backups on schedule deletion toggle"
				})
			]
		})]
	})] });
}, cR = async (e) => {
	try {
		return await nf(O.BACKUP_CREATE, tR(e)), !0;
	} catch (e) {
		return K(e), !1;
	}
}, lR = async (e) => {
	try {
		return await nf(O.CLUSTER_BACKUP_SCHEDULE, eR(e)), !0;
	} catch (e) {
		return K(e), !1;
	}
}, uR = async (e, t) => {
	try {
		return await sf(O.CLUSTER_BACKUP_SCHEDULE, {
			id: e,
			...eR(t)
		}), !0;
	} catch (e) {
		return K(e), !1;
	}
}, dR = async (e, t) => {
	let { result: n } = await G(`${O.CLUSTER_BACKUP_SCHEDULE}/${e}`, { signal: t });
	return aR(n);
}, fR = ({ state: e, setState: t, storageLocationConfig: n, volumeSnapshotLocationConfig: r, formError: i, setFormError: a }) => {
	let o = (n) => {
		let { value: r } = n;
		t({
			...e,
			storageAndSnapshotSettings: {
				...e.storageAndSnapshotSettings,
				storageLocation: r
			}
		}), a((e) => ({
			...e,
			storageAndSnapshotSettings: { storageLocation: "" }
		}));
	}, s = (n) => {
		t({
			...e,
			storageAndSnapshotSettings: {
				...e.storageAndSnapshotSettings,
				volumeSnapshotLocation: n.map((e) => e.value) || null
			}
		});
	}, c = (n) => {
		let r = n.target.value === "true";
		t({
			...e,
			storageAndSnapshotSettings: {
				...e.storageAndSnapshotSettings,
				...r ? {
					volumeSnapshotEnabled: !0,
					snapshotVolumeSettings: {
						moveData: !1,
						defaultVolumesToFSBackup: !1
					}
				} : {
					volumeSnapshotEnabled: !1,
					snapshotVolumeSettings: void 0
				}
			}
		});
	}, l = () => {
		e.storageAndSnapshotSettings.volumeSnapshotEnabled && t({
			...e,
			storageAndSnapshotSettings: {
				...e.storageAndSnapshotSettings,
				snapshotVolumeSettings: {
					...e.storageAndSnapshotSettings.snapshotVolumeSettings,
					moveData: !e.storageAndSnapshotSettings.snapshotVolumeSettings.moveData
				}
			}
		});
	}, u = () => {
		e.storageAndSnapshotSettings.volumeSnapshotEnabled && t({
			...e,
			storageAndSnapshotSettings: {
				...e.storageAndSnapshotSettings,
				snapshotVolumeSettings: {
					...e.storageAndSnapshotSettings.snapshotVolumeSettings,
					defaultVolumesToFSBackup: !e.storageAndSnapshotSettings.snapshotVolumeSettings.defaultVolumesToFSBackup
				}
			}
		});
	}, d = (n) => {
		e.storageAndSnapshotSettings.volumeSnapshotEnabled && t({
			...e,
			storageAndSnapshotSettings: {
				...e.storageAndSnapshotSettings,
				snapshotVolumeSettings: {
					...e.storageAndSnapshotSettings.snapshotVolumeSettings,
					dataMover: n.target.value
				}
			}
		});
	}, f = (n) => {
		if (!e.storageAndSnapshotSettings.volumeSnapshotEnabled) return;
		let r = parseInt(n.target.value, 10);
		t({
			...e,
			storageAndSnapshotSettings: {
				...e.storageAndSnapshotSettings,
				snapshotVolumeSettings: {
					...e.storageAndSnapshotSettings.snapshotVolumeSettings,
					parallelFilesUpload: Number.isNaN(r) ? void 0 : r
				}
			}
		});
	}, p = e.storageAndSnapshotSettings, m = p?.volumeSnapshotEnabled ? p.snapshotVolumeSettings : {
		moveData: !1,
		defaultVolumesToFSBackup: !1,
		dataMover: "",
		parallelFilesUpload: ""
	};
	return /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsxs)(Ho, {
		padding: 16,
		flexGap: 16,
		variant: "secondary--outlined",
		children: [
			/* @__PURE__ */ (0, Q.jsx)("h3", {
				className: "m-0 p-0 fs-13 cn-9 fw-6 lh-1-5",
				children: "Volume Snapshot & Storage Location"
			}),
			/* @__PURE__ */ (0, Q.jsx)(V, {
				label: "Volume Snapshot Location",
				inputId: "volume-snapshot-location",
				isMulti: !0,
				options: r.options,
				value: r.options.filter((e) => p?.volumeSnapshotLocation?.includes(e.value)),
				onChange: s,
				placeholder: "Select snapshot location",
				size: I.large,
				isSearchable: !0,
				optionListError: r.error,
				reloadOptionList: r.refetch,
				isLoading: r.isLoading,
				isClearable: !0,
				helperText: "List of locations (at most one per provider) where volume snapshots should be stored"
			}),
			/* @__PURE__ */ (0, Q.jsx)(V, {
				required: !0,
				label: "Storage Location",
				inputId: "storage-location",
				options: n.options,
				value: n.options.find((e) => e.value === p?.storageLocation),
				onChange: o,
				placeholder: "Select storage location",
				size: I.large,
				optionListError: n.error,
				reloadOptionList: n.refetch,
				isLoading: n.isLoading,
				isSearchable: !0,
				helperText: "Location in which to store the backup",
				error: i.storageAndSnapshotSettings.storageLocation
			})
		]
	}), /* @__PURE__ */ (0, Q.jsxs)(Ho, {
		padding: 16,
		flexGap: 16,
		variant: "secondary--outlined",
		children: [/* @__PURE__ */ (0, Q.jsx)("h3", {
			className: "m-0 p-0 fs-13 cn-9 fw-6 lh-1-5",
			children: "Snapshot Volume Settings"
		}), /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "dc__separated-flexbox dc__separated-flexbox--vertical",
			children: [/* @__PURE__ */ (0, Q.jsxs)(vl, {
				value: `${e.storageAndSnapshotSettings.volumeSnapshotEnabled}`,
				name: "snapshot-volume-radio-group",
				onChange: c,
				className: "radio-group-no-border",
				children: [/* @__PURE__ */ (0, Q.jsx)(yl, {
					dataTestId: "take-snapshot",
					value: "true",
					children: "Take snapshot"
				}), /* @__PURE__ */ (0, Q.jsx)(yl, {
					dataTestId: "skip-volume-snapshot",
					value: "false",
					children: "Skip volume snapshot"
				})]
			}), e.storageAndSnapshotSettings.volumeSnapshotEnabled && /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [
				/* @__PURE__ */ (0, Q.jsx)(RL, {
					label: "Snapshot Move Data",
					description: "Specify if snapshot data should be moved",
					isChecked: !!m.moveData,
					ariaLabel: "Snapshot move data toggle",
					name: "snapshot-move-data-toggle",
					onChange: l
				}),
				/* @__PURE__ */ (0, Q.jsx)(RL, {
					label: "Default Volumes to FS Backup",
					description: "Use pod volume file system backup by default for volumes",
					isChecked: !!m.defaultVolumesToFSBackup,
					ariaLabel: "Default volumes to FS backup toggle",
					name: "default-volumes-to-fs-backup-toggle",
					onChange: u
				}),
				/* @__PURE__ */ (0, Q.jsx)(os, {
					name: "data-mover-input",
					onChange: d,
					placeholder: "Type data mover",
					label: "Data Mover",
					value: m.dataMover,
					helperText: "Specify the data mover to be used by the backup. If the parameter is not set or set as 'velero', the built-in data mover will be used"
				}),
				/* @__PURE__ */ (0, Q.jsx)(os, {
					name: "parallel-files-upload-input",
					onChange: f,
					placeholder: "Eg. 10",
					label: "Parallel Files Upload",
					value: m.parallelFilesUpload,
					helperText: "Number of files uploads simultaneously when running a backup. This is only applicable for the kopia uploader"
				})
			] })]
		})]
	})] });
}, pR = ({ reloadOnClose: e, onClose: t }) => {
	let { type: n, id: r } = Z(), i = r ? MI.SCHEDULE : n, a = !!r, [o, s] = j(A(() => BL(i), [i])), [c, l] = j({
		storageAndSnapshotSettings: { storageLocation: null },
		backupScopeAndPolicy: {
			selectedClusterId: null,
			namespaceSelection: null,
			resourcePolicy: null,
			orderedResources: null
		},
		basicDetails: {
			name: null,
			description: null,
			labels: null,
			cronExpression: null
		}
	}), [u, d] = j("basicDetails"), [f, p] = j(!1), { isFetching: m, data: h, error: g, refetch: _ } = q({
		queryKey: ["edit-backup-schedule-form-state", r],
		queryFn: ({ signal: e }) => dR(+r, e),
		enabled: a
	}), { data: v, isFetching: y, error: b, refetch: x } = q({
		queryFn: ({ signal: e }) => Zu(e),
		queryKey: ["create-backup-and-schedule-cluster-list"],
		select: (e) => (e || []).filter(({ isVirtual: e }) => !e).map((e) => ({
			label: e.name,
			value: e.id
		}))
	}), { data: S, isFetching: C, error: w, refetch: T } = q({
		queryFn: ({ signal: e }) => $j(o.backupScopeAndPolicy.selectedClusterId, e),
		enabled: o.backupScopeAndPolicy.selectedClusterId > 0,
		queryKey: ["create-backup-and-schedule-namespace-list", o.backupScopeAndPolicy.selectedClusterId]
	}), { data: ee, isFetching: E, error: D, refetch: te } = q({
		queryFn: ({ signal: e }) => NF({ signal: e }),
		select: (e) => (e?.result || []).map((e) => ({
			label: e.name,
			value: e.id
		})),
		queryKey: ["create-backup-and-schedule-storage-location-list"]
	}), { data: ne, isFetching: re, error: ie, refetch: ae } = q({
		queryFn: ({ signal: e }) => MF({ signal: e }),
		select: (e) => (e.result || []).map((e) => ({
			label: e.name,
			value: e.id
		})),
		queryKey: ["create-backup-and-schedule-volume-snapshot-location-list"]
	}), { isFetching: oe, data: se, error: ce, refetch: le } = q({
		queryKey: ["get-config-map-list", o.backupScopeAndPolicy.selectedClusterId],
		queryFn: ({ signal: e }) => jF({
			signal: e,
			clusterId: o.backupScopeAndPolicy.selectedClusterId
		}),
		select: (e) => (e.result || []).map((e) => ({
			label: e,
			value: e
		})).sort((e, t) => df(e.label, t.label)),
		enabled: !!o.backupScopeAndPolicy.selectedClusterId,
		meta: { showToastError: !1 }
	});
	k(() => {
		a && h && s(h);
	}, [h, a]), Of({ shouldPrompt: f });
	let ue = () => a ? "Edit Backup Schedule" : i === "backup" ? "Create Backup" : "Create Backup Schedule", de = (e) => {
		d(e);
	}, fe = () => {
		switch (u) {
			case "basicDetails": return /* @__PURE__ */ (0, Q.jsx)(sR, {
				state: o,
				setState: s,
				formError: c,
				setFormError: l
			});
			case "backupScopeAndPolicy": return /* @__PURE__ */ (0, Q.jsx)(LL, {
				state: o,
				setState: s,
				formError: c,
				setFormError: l,
				clusterListConfig: {
					options: v,
					error: b,
					isLoading: y,
					refetch: x
				},
				namespaceListConfig: {
					options: S,
					error: w,
					isLoading: C,
					refetch: T
				},
				configMapListConfig: {
					isLoading: oe,
					error: ce,
					options: se,
					refetch: le
				}
			});
			case "storageAndSnapshotLocation": return /* @__PURE__ */ (0, Q.jsx)(fR, {
				state: o,
				setState: s,
				formError: c,
				setFormError: l,
				storageLocationConfig: {
					error: D,
					isLoading: E,
					options: ee,
					refetch: te
				},
				volumeSnapshotLocationConfig: {
					error: ie,
					isLoading: re,
					options: ne,
					refetch: ae
				}
			});
			case "advancedTimeoutsAndTuning": return /* @__PURE__ */ (0, Q.jsx)(kL, {
				state: o,
				setState: s
			});
			default: return null;
		}
	}, pe = (e) => () => {
		de(e);
	}, me = async () => {
		let { isFormValid: n, updatedFormErrors: s } = GL({
			state: o,
			formError: c,
			type: i
		});
		if (l(s), !n) {
			H.showToast({
				description: "Please resolve the errors before saving.",
				variant: U.error
			});
			return;
		}
		p(!0);
		let u = a ? await uR(+r, o) : await (i === MI.BACKUP ? cR : lR)(o);
		p(!1), u && (H.showToast({
			description: `Successfully created backup ${i === MI.SCHEDULE ? "schedule" : ""}`,
			variant: U.success
		}), e?.(), t());
	}, he = (e) => {
		let t = c[ML[e]];
		return t ? oR(t) : !1;
	};
	return /* @__PURE__ */ (0, Q.jsx)(Rs, {
		onClose: t,
		onEscape: t,
		position: "right",
		width: "1024px",
		parentClassName: "h-100",
		children: /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "bg__primary h-100 cn-9 w-100 flexbox-col dc__overflow-hidden p-0",
			onClick: uf,
			children: [
				/* @__PURE__ */ (0, Q.jsxs)("header", {
					className: "px-20 py-12 lh-24 flexbox dc__content-space dc__align-items-center dc__border-bottom",
					children: [/* @__PURE__ */ (0, Q.jsx)("span", {
						className: "fs-16 fw-6 dc__first-letter-capitalize",
						children: ue()
					}), /* @__PURE__ */ (0, Q.jsx)(M, {
						icon: /* @__PURE__ */ (0, Q.jsx)(z, {
							name: "ic-close-large",
							color: null
						}),
						dataTestId: "backup-schedule-create__cross",
						component: N.button,
						style: P.negativeGrey,
						size: I.xs,
						variant: F.borderLess,
						ariaLabel: `Close ${ue().toLowerCase()} drawer`,
						showTooltip: f,
						tooltipProps: { content: `${i === "backup" ? "Backup" : "Backup Schedule"} creation in progress` },
						disabled: f,
						onClick: t,
						showAriaLabelInTippy: !1
					})]
				}),
				/* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "flexbox flex-grow-1 dc__overflow-hidden",
					children: [/* @__PURE__ */ (0, Q.jsx)("div", {
						className: "w-250 bg__primary flexbox-col dc__no-shrink border__secondary--right",
						children: /* @__PURE__ */ (0, Q.jsxs)("div", {
							className: "p-16 flexbox-col dc__gap-12",
							children: [
								/* @__PURE__ */ (0, Q.jsx)("div", {
									className: "flexbox-col",
									children: zL(u, i).map((e) => /* @__PURE__ */ (0, Q.jsxs)("button", {
										type: "button",
										className: `dc__transparent dc__transition flex left dc__content-space dc__gap-8 py-6 px-8 br-4 ${e.isActive ? "bcb-1" : "dc__hover-n50"}`,
										onClick: pe(e.key),
										"aria-label": `View: ${e.label}`,
										children: [/* @__PURE__ */ (0, Q.jsx)("span", {
											className: `fs-13 lh-20 dc__truncate ${e.isActive ? "cb-5 fw-6" : "cn-9"}`,
											children: e.label
										}), he(e.key) && /* @__PURE__ */ (0, Q.jsx)(z, {
											name: "ic-error",
											color: "R500"
										})]
									}, e.key))
								}),
								/* @__PURE__ */ (0, Q.jsx)("div", { className: "divider__secondary--horizontal" }),
								/* @__PURE__ */ (0, Q.jsx)(Vc, {
									heading: null,
									documentationLink: "DOC_HOME_PAGE",
									rootClassName: "w-100 dc__no-background-imp"
								})
							]
						})
					}), /* @__PURE__ */ (0, Q.jsx)("div", {
						className: "flexbox-col flex-grow-1 bg__secondary dc__overflow-auto p-20 dc__gap-16 backup-and-schedule-create-form",
						children: /* @__PURE__ */ (0, Q.jsx)($a, {
							isLoading: a && m,
							error: g,
							errorScreenManagerProps: {
								code: g?.code,
								reload: _,
								on404Redirect: t
							},
							progressingProps: { pageLoader: !0 },
							children: fe()
						})
					})]
				}),
				/* @__PURE__ */ (0, Q.jsxs)("footer", {
					className: "flexbox dc__content-end border__secondary--top px-20 pt-15 pb-16 dc__gap-12 dc__no-shrink",
					children: [/* @__PURE__ */ (0, Q.jsx)(M, {
						dataTestId: "cancel-backup-schedule-creation-button",
						text: "Cancel",
						variant: F.secondary,
						style: P.neutral,
						size: I.large,
						onClick: t,
						disabled: f
					}), /* @__PURE__ */ (0, Q.jsx)(M, {
						dataTestId: "create-backup-schedule-button",
						onClick: me,
						size: I.large,
						...i === "backup" ? {
							startIcon: /* @__PURE__ */ (0, Q.jsx)(z, {
								name: "ic-play-outline",
								color: null
							}),
							text: "Start Backup"
						} : { text: "Save" },
						isLoading: f || a && m
					})]
				})
			]
		})
	});
}, mR = ({ reloadOnClose: e, onClose: t }) => {
	let { id: n } = Z(), [r, i] = j(null), [a, o] = j(!1), [s, c] = j(null), l = r === null ? null : Bf(r), { data: u, isFetching: d, error: f, refetch: p } = q({
		queryKey: ["schedules"],
		queryFn: ({ signal: e }) => kF({ signal: e }),
		select: (e) => (e?.result || []).map(({ name: e, id: t }) => ({
			label: e,
			value: t
		})).sort((e, t) => df(e.label, t.label))
	});
	return k(() => {
		n && u && c(u.find((e) => e.value === +n) ?? null);
	}, [n, u]), /* @__PURE__ */ (0, Q.jsxs)(cc, {
		name: "create-backup-from-schedule-modal",
		open: !0,
		closeOnBackdropClick: !0,
		onClose: t,
		onEscape: t,
		children: [
			/* @__PURE__ */ (0, Q.jsx)(cc.Header, { title: "Create backup from schedule" }),
			/* @__PURE__ */ (0, Q.jsx)(cc.Body, { children: /* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox-col dc__gap-16 p-20 h-250",
				children: [/* @__PURE__ */ (0, Q.jsx)(os, {
					name: "backup-name",
					placeholder: "Eg. Daily Database Backup",
					autoFocus: !0,
					label: "Backup Name",
					onChange: (e) => {
						i(e.target.value);
					},
					value: r,
					error: l?.message,
					required: !0
				}), /* @__PURE__ */ (0, Q.jsx)(V, {
					inputId: "select-backup-schedule",
					required: !0,
					label: "Schedule",
					helperText: "Configurations from the schedule will be used to create the backup",
					options: u,
					isLoading: d,
					optionListError: f,
					reloadOptionList: p,
					onChange: (e) => {
						c(e);
					},
					value: s
				})]
			}) }),
			/* @__PURE__ */ (0, Q.jsx)(cc.Footer, { buttonConfig: {
				secondaryButton: {
					dataTestId: "close-modal--backup-from-schedule",
					text: "Cancel",
					disabled: a,
					onClick: t
				},
				primaryButton: {
					isLoading: a,
					text: "Create Backup",
					dataTestId: "create-backup-from-schedule",
					onClick: async () => {
						o(!0);
						try {
							await nf(O.BACKUP_CREATE, {
								name: r,
								scheduleId: s.value,
								sourceType: "schedule"
							}), o(!1), e?.(), t();
						} catch (e) {
							K(e);
						}
						o(!1);
					},
					disabled: l === null || !l.isValid || !s
				}
			} })
		]
	});
}, hR = (e) => /* @__PURE__ */ (0, Q.jsxs)(qf, { children: [
	/* @__PURE__ */ (0, Q.jsx)(J, {
		path: AI.EDIT_SCHEDULE,
		element: /* @__PURE__ */ (0, Q.jsx)(pR, { ...e })
	}),
	/* @__PURE__ */ (0, Q.jsx)(J, {
		path: AI.CREATE_FROM_SCRATCH,
		element: /* @__PURE__ */ (0, Q.jsx)(pR, { ...e })
	}),
	/* @__PURE__ */ (0, Q.jsx)(J, {
		path: AI.CREATE_FROM_SCHEDULE,
		element: /* @__PURE__ */ (0, Q.jsx)(mR, { ...e })
	})
] }), gR = "backup-schedule-detail-meta-container", _R = [{
	label: "Backups",
	value: "backups"
}, {
	label: "Manifest",
	value: "manifest"
}], vR = ({ detail: e, isDetailLoading: t, detailError: n, refetchDetail: r }) => {
	let i = X(), { search: a } = Yf(), { view: o, id: s } = Z(), { searchParams: c } = jf(), l = c.tab ?? "backups", [u, d] = j(!1), [f, p] = j(!1), m = ({ value: e }) => {
		let t = new URLSearchParams(a);
		t.set("tab", e), i({ search: t.toString() });
	}, { data: h, isLoading: g, error: _, refetch: v } = q({
		queryKey: ["backup-manifest", e],
		queryFn: ({ signal: t }) => Un({
			clusterId: e.k8sManifestDetail.clusterId,
			gvk: e.k8sManifestDetail.gvk,
			name: e.k8sManifestDetail.name,
			namespace: e.k8sManifestDetail.namespace,
			signal: t
		}),
		select: (e) => JSON.stringify(e.manifestResponse.manifest),
		enabled: l === "manifest" && !!e
	}), y = A(() => tL(bo.Backups), []), b = Ka((t, n) => zI({
		...t,
		[XI.CREATED_BY_SCHEDULE]: [String(e.id)],
		[XI.CREATED_BY_USER]: null,
		[XI.STATUS]: null,
		signal: n
	}), [e]), x = () => {
		i(Y(B.DATA_PROTECTION_MANAGEMENT_BACKUP_AND_SCHEDULE, { view: bo.Schedules }), { replace: !0 });
	}, S = async () => {
		d(!0);
		try {
			await sf(Y(e.status === "Enabled" ? O.SCHEDULE_PAUSE : O.SCHEDULE_UNPAUSE, { id: e.id }), null), H.showToast({
				variant: U.success,
				description: `Schedule ${e.status === "Enabled" ? "paused" : "resumed"} successfully`
			}), r();
		} catch (e) {
			K(e);
		} finally {
			d(!1);
		}
	}, C = () => {
		i({
			pathname: `${Y(B.DATA_PROTECTION_MANAGEMENT_BACKUP_AND_SCHEDULE_DETAIL, {
				view: o,
				id: s
			})}/${Y(AI.CREATE_FROM_SCHEDULE, { id: String(e.id) })}`,
			search: a
		});
	};
	if (t) return /* @__PURE__ */ (0, Q.jsx)(ul, { pageLoader: !0 });
	if (n) return /* @__PURE__ */ (0, Q.jsx)(Ks, {
		reload: r,
		on404Redirect: x,
		code: n.code
	});
	let w = () => {
		switch (l) {
			case "backups": return /* @__PURE__ */ (0, Q.jsx)(ru, {
				loading: t,
				id: "table__backup-and-schedule-list",
				columns: y,
				filtersVariant: tc.URL,
				additionalFilterProps: {
					initialSortKey: "backupDate",
					parseSearchParams: QI
				},
				paginationVariant: el.PAGINATED,
				getRows: b,
				emptyStateConfig: { noRowsConfig: {
					title: "No backups found for this schedule",
					subTitle: "The backups will be created as per the defined schedule (cron expression).",
					imgName: "create-backup-snapshot"
				} },
				filter: null
			});
			case "manifest": return _ ? /* @__PURE__ */ (0, Q.jsx)(Ks, {
				reload: v,
				code: _.code
			}) : /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsx)(Xo, {
				loading: g,
				readOnly: !0,
				height: "100%",
				mode: Ic.YAML,
				value: h ?? ""
			}), h && /* @__PURE__ */ (0, Q.jsx)(cl, {
				portalParentId: "backup-schedule-detail-meta-container",
				children: /* @__PURE__ */ (0, Q.jsx)(qo, {
					variant: "button--secondary",
					size: I.small,
					content: h
				})
			})] });
			default: return null;
		}
	}, T = async () => {
		await HI(e.id), i(Y(B.DATA_PROTECTION_MANAGEMENT_BACKUP_AND_SCHEDULE, { view: bo.Schedules }), { replace: !0 });
	}, ee = () => {
		i({
			pathname: Y(B.DATA_PROTECTION_MANAGEMENT_BACKUP_AND_SCHEDULE_DETAIL, {
				view: o,
				id: s
			}),
			search: a
		});
	}, E = () => {
		p(!1);
	};
	return /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [
		/* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox h-100 w-100 dc__overflow-hidden backup-schedule-detail",
			children: [/* @__PURE__ */ (0, Q.jsx)(jI, { ...EL({
				backupScheduleDetail: e,
				onUpdateScheduleEnabledState: S,
				onCreateBackupFromThisScheduleClick: C,
				isPauseUnpauseScheduleAPICallInProgress: u,
				onActionMenuClick: async (t) => {
					switch (t.id) {
						case "delete-schedule":
							p(!0);
							break;
						case "edit":
							i({
								pathname: `${Y(B.DATA_PROTECTION_MANAGEMENT_BACKUP_AND_SCHEDULE_DETAIL, {
									view: o,
									id: s
								})}/${Y(AI.EDIT_SCHEDULE, { id: String(e.id) })}`,
								search: a
							});
							break;
						default:
					}
				}
			}) }), /* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox-col flex-grow-1 dc__overflow-hidden",
				children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "flexbox dc__content-space dc__gap-16 py-12 px-16 border__secondary--bottom dc__no-shrink",
					children: [/* @__PURE__ */ (0, Q.jsx)(Bl, {
						name: "backup-schedule-view-control",
						value: l,
						segments: _R,
						onChange: m
					}), /* @__PURE__ */ (0, Q.jsx)("div", { id: gR })]
				}), /* @__PURE__ */ (0, Q.jsx)("div", {
					className: "flex-grow-1 dc__overflow-hidden flexbox-col",
					children: w()
				})]
			})]
		}),
		/* @__PURE__ */ (0, Q.jsxs)(qf, { children: [/* @__PURE__ */ (0, Q.jsx)(J, {
			path: AI.CREATE_FROM_SCHEDULE,
			element: /* @__PURE__ */ (0, Q.jsx)(mR, {
				reloadOnClose: r,
				onClose: ee
			})
		}), /* @__PURE__ */ (0, Q.jsx)(J, {
			path: AI.EDIT_SCHEDULE,
			element: /* @__PURE__ */ (0, Q.jsx)(pR, { onClose: ee })
		})] }),
		f && /* @__PURE__ */ (0, Q.jsx)(Ts, {
			title: e.name,
			component: "schedule",
			subtitle: "Are you sure you want to delete this backup schedule?",
			closeConfirmationModal: E,
			onDelete: T,
			successToastMessage: "Schedule deleted successfully"
		})
	] });
}, yR = (e, t) => ({ alias: {
	...HF(),
	"backup-and-schedule": {
		component: /* @__PURE__ */ (0, Q.jsx)(Wf, {
			className: "dc__no-decor fs-16 lh-1-5 cb-5 fw-4",
			to: Y(B.DATA_PROTECTION_MANAGEMENT_BACKUP_AND_SCHEDULE, { view: "backups" }),
			children: "Backup & Schedule"
		}),
		linked: !1
	},
	":view": {
		component: /* @__PURE__ */ (0, Q.jsx)(Wf, {
			className: "dc__no-decor fs-16 lh-1-5 cb-5 fw-4",
			to: Y(B.DATA_PROTECTION_MANAGEMENT_BACKUP_AND_SCHEDULE, { view: t }),
			children: Au(t)
		}),
		linked: !1
	},
	detail: null,
	":id": {
		component: e ? /* @__PURE__ */ (0, Q.jsx)("span", {
			className: "fs-16 fw-6 cn-9 lh-1-5",
			children: e.name
		}) : /* @__PURE__ */ (0, Q.jsx)("div", { className: "shimmer h-18 w-120" }),
		linked: !1
	}
} }), bR = () => {
	let { view: e, id: t } = Z(), n = X(), { search: r } = Yf(), { data: i, isLoading: a, error: o, refetch: s } = q({
		queryKey: [
			"backup-detail",
			t,
			e
		],
		queryFn: ({ signal: n }) => e === "backups" ? SL({
			id: +t,
			signal: n
		}) : OL({
			id: +t,
			signal: n
		})
	}), { breadcrumbs: c } = gf(B.DATA_PROTECTION_MANAGEMENT_BACKUP_AND_SCHEDULE_DETAIL, yR(i, e), [i, e]), l = () => /* @__PURE__ */ (0, Q.jsx)(Co, {
		breadcrumbs: c,
		path: B.DATA_PROTECTION_MANAGEMENT_BACKUP_AND_SCHEDULE_DETAIL
	}), u = {
		detail: i,
		isDetailLoading: a,
		detailError: o,
		refetchDetail: s
	}, d = () => {
		n({
			pathname: Y(B.DATA_PROTECTION_MANAGEMENT_BACKUP_AND_SCHEDULE_DETAIL, {
				id: t,
				view: e
			}),
			search: r
		}, { replace: !0 });
	}, f = async () => {
		await s(), d();
	};
	return /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox-col dc__overflow-hidden flex-grow-1",
		children: [/* @__PURE__ */ (0, Q.jsx)(Qc, {
			breadCrumbs: l,
			isBreadcrumbs: !0
		}), e === "backups" ? /* @__PURE__ */ (0, Q.jsx)(TL, { ...u }) : /* @__PURE__ */ (0, Q.jsx)(vR, { ...u })]
	}), /* @__PURE__ */ (0, Q.jsx)(qf, { children: /* @__PURE__ */ (0, Q.jsx)(J, {
		path: AI.CREATE_RESTORE,
		element: /* @__PURE__ */ (0, Q.jsx)(kI, {
			onSuccess: f,
			handleClose: d
		})
	}) })] });
}, xR = (e) => {
	let { children: t, searchKey: n, handleSearch: r, updateSearchParams: i, clearFilters: a } = e, { backupFilterConfigProp: o, backupScheduleFilterConfigProp: s } = e, { search: c } = Yf(), [l, u] = j(!1), { view: d } = Z(), f = X(), p = () => {
		f(Y(B.DATA_PROTECTION_MANAGEMENT_BACKUP_AND_SCHEDULE, { view: d === bo.Backups ? bo.Schedules : bo.Backups }));
	}, { areRowsLoading: m, filteredRows: h, areFiltersApplied: g } = e, _ = !m && h?.length === 0 && !g, { filterSelectPickerPropsMap: v, isFilterApplied: y, options: b } = aL(e, s), { filterSelectPickerPropsMap: x, isFilterApplied: S, options: C } = iL(e, o);
	return /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "h-100 dc__overflow-hidden w-100 flexbox-col",
		children: [
			/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox dc__align-items-center p-16 w-100 dc__gap-8 dc__zi-5",
				children: [
					/* @__PURE__ */ (0, Q.jsx)(Bl, {
						name: "backup-n-schedule-control",
						value: d,
						segments: [{
							label: "Backups",
							value: bo.Backups
						}, {
							label: "Backup Schedules",
							value: bo.Schedules
						}],
						onChange: p
					}),
					!_ && /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsx)(Il, {
						dataTestId: "backup-n-schedule-list-search",
						handleEnter: r,
						initialSearchText: n,
						inputProps: { placeholder: d === bo.Backups ? "Search backup" : "Search schedule" },
						keyboardShortcut: "/"
					}), d === bo.Backups ? /* @__PURE__ */ (0, Q.jsx)(pc, {
						id: "backup-list-filters",
						width: 200,
						isFilterApplied: S,
						options: C,
						filterSelectPickerPropsMap: x
					}) : /* @__PURE__ */ (0, Q.jsx)(pc, {
						id: "backup-schedule-list-filters",
						width: 200,
						isFilterApplied: y,
						options: b,
						filterSelectPickerPropsMap: v
					})] }),
					/* @__PURE__ */ (0, Q.jsx)("div", { className: "flex-grow-1" }),
					/* @__PURE__ */ (0, Q.jsx)("div", {
						className: "dc__separated-flexbox dc__separated-flexbox--gap-8",
						children: /* @__PURE__ */ (0, Q.jsx)(io, {
							id: "backup-and-schedule-list-action-menu",
							buttonProps: {
								text: "Create Backup",
								size: I.medium,
								endIcon: /* @__PURE__ */ (0, Q.jsx)(z, {
									name: "ic-caret-right",
									color: null,
									rotateBy: l ? 270 : 90
								}),
								dataTestId: "create-backup-action-menu--button"
							},
							alignment: "end",
							onOpen: u,
							onClick: $d,
							options: dL(c)
						})
					})
				]
			}),
			!o.scheduleFilterOptions.isLoading && !s.snapshotLocationOptions.isLoading && !s.storageLocationOptions.isLoading && /* @__PURE__ */ (0, Q.jsx)(Zs, {
				filterConfig: d === bo.Backups ? nL(e) : rL(e),
				onRemoveFilter: i,
				clearFilters: a,
				className: "px-20",
				getFormattedLabel: d === bo.Backups ? oL : sL,
				getFormattedValue: (e, t) => d === bo.Backups ? cL(e, t, o) : lL(e, t, s)
			}),
			t
		]
	});
}, SR = ({ onActionClick: e, bulkActionsData: { view: t } }) => /* @__PURE__ */ (0, Q.jsx)("div", {
	className: "flexbox dc__gap-4",
	children: /* @__PURE__ */ (0, Q.jsx)(M, {
		icon: /* @__PURE__ */ (0, Q.jsx)(z, {
			name: "ic-delete",
			color: null
		}),
		dataTestId: "bs-bulk-action__action-widget--delete",
		component: N.button,
		style: P.negativeGrey,
		variant: F.borderLess,
		ariaLabel: "Delete item(s)",
		size: I.small,
		onClick: e,
		showAriaLabelInTippy: !1,
		"data-key": t === bo.Backups ? sF.BACKUP : sF.BACKUP_SCHEDULE
	})
}), CR = () => {
	let { view: e } = Z(), { search: t, pathname: n } = Yf(), r = X(), [i, a] = j(!1), { breadcrumbs: o } = gf(B.DATA_PROTECTION_MANAGEMENT_BACKUP_AND_SCHEDULE, { alias: {
		...HF(),
		"backup-and-schedule": {
			component: /* @__PURE__ */ (0, Q.jsx)("span", {
				className: "fs-16 fw-6 cn-9 lh-1-5",
				children: "Backup & Schedule"
			}),
			linked: !1
		},
		":view": null
	} }), { isSuperAdmin: s } = Tf(), c = A(() => tL(e), [e]), l = Ka((t, n) => e === bo.Backups ? zI({
		...t,
		signal: n
	}) : BI({
		...t,
		signal: n
	}), [e, i]), { data: u, isFetching: d, error: f, refetch: p } = q({
		queryFn: kF,
		queryKey: ["backup-schedule-list-min"],
		select: (e) => e.result?.map(({ id: e, name: t }) => ({
			label: t,
			value: e
		})).sort((e, t) => df(e.label, t.label)) ?? [],
		enabled: e === bo.Backups
	}), { data: m, isFetching: h, error: g, refetch: _ } = q({
		queryFn: ({ signal: e }) => Rt(e),
		queryKey: ["user-filter-options-list"],
		select: (e) => e?.map(({ emailId: e }) => ({
			label: e,
			value: e
		})).sort((e, t) => df(e.value, t.value)) ?? [],
		enabled: e === bo.Backups
	}), { data: v, isFetching: y, error: b, refetch: x } = q({
		queryFn: NF,
		select: (e) => e.result?.map(({ id: e, name: t }) => ({
			label: t,
			value: e
		})).sort((e, t) => df(e.label, t.label)) ?? [],
		queryKey: ["storage-location-list-min"],
		enabled: e === bo.Schedules
	}), { data: S, isFetching: C, error: w, refetch: T } = q({
		queryFn: MF,
		select: (e) => e.result?.map(({ id: e, name: t }) => ({
			label: t,
			value: e
		})).sort((e, t) => df(e.label, t.label)) ?? [],
		queryKey: ["snapshot-location-list-min"],
		enabled: e === bo.Schedules
	}), ee = () => /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox-col dc__align-items-center dc__gap-12",
		children: [/* @__PURE__ */ (0, Q.jsx)(M, {
			component: N.link,
			linkProps: { to: {
				pathname: Y(AI.CREATE_FROM_SCRATCH, { type: MI.SCHEDULE }),
				search: t
			} },
			dataTestId: "create-backup-schedule",
			text: "Create Backup Schedule",
			startIcon: /* @__PURE__ */ (0, Q.jsx)(z, {
				name: "ic-clock-counterclockwise",
				color: null
			})
		}), e === bo.Backups && /* @__PURE__ */ (0, Q.jsx)(M, {
			component: N.link,
			linkProps: { to: {
				pathname: Y(AI.CREATE_FROM_SCRATCH, { type: MI.BACKUP }),
				search: t
			} },
			variant: F.text,
			dataTestId: "create-one-time-backup",
			text: "One-time Backup"
		})]
	}), E = () => /* @__PURE__ */ (0, Q.jsx)(Co, {
		breadcrumbs: o,
		path: B.DATA_PROTECTION_MANAGEMENT_BACKUP_AND_SCHEDULE
	}), D = () => {
		a((e) => !e);
	}, te = () => {
		r({
			pathname: n.replace(AI.CREATE_RESTORE, ""),
			search: t
		}, { replace: !0 });
	};
	return /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox-col flex-grow-1 dc__overflow-hidden backup-n-schedule",
		children: [/* @__PURE__ */ (0, Q.jsx)(Qc, {
			breadCrumbs: E,
			isBreadcrumbs: !0
		}), s ? /* @__PURE__ */ (0, Q.jsx)(ru, {
			id: "table__backup-and-schedule-list",
			columns: c,
			ViewWrapper: xR,
			filtersVariant: tc.URL,
			additionalFilterProps: {
				initialSortKey: e === bo.Backups ? "backupDate" : "lastBackup",
				parseSearchParams: e === bo.Backups ? QI : $I
			},
			bulkSelectionConfig: {
				BulkActionsComponent: SR,
				bulkActionsData: { view: e },
				BulkOperationModal: dF,
				bulkOperationModalData: {
					handleDelete: async (t, n) => {
						await ff(Y(e === bo.Backups ? O.BACKUP_DETAIL : O.SCHEDULE_DETAIL, { id: n }), { signal: t.signal });
					},
					reloadDataAfterBulkOperation: D
				},
				getSelectAllDialogStatus: () => Vl.CLOSED,
				disableSelectAllAcrossEvenIfPaginated: !0
			},
			paginationVariant: el.PAGINATED,
			getRows: l,
			emptyStateConfig: { noRowsConfig: {
				title: e === bo.Backups ? "Create Backup Snapshot" : "Create Backup Schedule",
				subTitle: e === bo.Backups ? "Create new backup snapshots to protect your data" : "Create new backup schedules to automate your data protection",
				isButtonAvailable: !0,
				imgName: e === bo.Backups ? "create-backup-snapshot" : "create-backup-schedule",
				renderButton: ee
			} },
			filter: null,
			additionalProps: {
				backupScheduleFilterConfigProp: {
					snapshotLocationOptions: {
						options: S,
						isLoading: C,
						error: w,
						refetch: T
					},
					storageLocationOptions: {
						options: v,
						isLoading: y,
						error: b,
						refetch: x
					}
				},
				backupFilterConfigProp: {
					userFilterOptions: {
						options: m,
						isLoading: h,
						error: g,
						refetch: _
					},
					scheduleFilterOptions: {
						options: u,
						isLoading: d,
						error: f,
						refetch: p
					}
				},
				reloadTableData: D
			},
			rowActionOnHoverConfig: {
				width: 68,
				Component: YI
			}
		}, `backup-and-schedule-list-${e}-${+i}`) : /* @__PURE__ */ (0, Q.jsx)(qs, {})]
	}), s && /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsx)(hR, {
		reloadOnClose: D,
		onClose: () => {
			r({
				pathname: Y(B.DATA_PROTECTION_MANAGEMENT_BACKUP_AND_SCHEDULE, { view: e }),
				search: t
			});
		}
	}), /* @__PURE__ */ (0, Q.jsx)(qf, { children: /* @__PURE__ */ (0, Q.jsx)(J, {
		path: AI.CREATE_RESTORE,
		element: /* @__PURE__ */ (0, Q.jsx)(kI, {
			onSuccess: () => {
				D(), te();
			},
			handleClose: te
		})
	}) })] })] });
}, wR = vo.DATA_PROTECTION_MANAGEMENT.BACKUP_AND_SCHEDULE, TR = () => /* @__PURE__ */ (0, Q.jsxs)(qf, { children: [/* @__PURE__ */ (0, Q.jsx)(J, {
	path: `${wR.DETAIL}/*`,
	element: /* @__PURE__ */ (0, Q.jsx)(bR, {})
}), /* @__PURE__ */ (0, Q.jsx)(J, {
	index: !0,
	path: "/*",
	element: /* @__PURE__ */ (0, Q.jsx)(CR, {})
})] }), ER = { [VF.GCP]: "ic-google-cloud" }, DR = { [VF.GCP]: "GCP" }, OR = /* @__PURE__ */ function(e) {
	return e.AVAILABLE = "Available", e.UNAVAILABLE = "Unavailable", e.UNKNOWN = "Unknown", e;
}({}), kR = /* @__PURE__ */ function(e) {
	return e.MODAL_TYPE = "modalType", e.UPDATE_LOCATION_ID = "locationId", e;
}({}), AR = /* @__PURE__ */ function(e) {
	return e.EXISTING = "ExistingSecret", e.NEW = "CreateSecret", e;
}({}), jR = /* @__PURE__ */ function(e) {
	return e.READ_WRITE = "ReadWrite", e.READ_ONLY = "ReadOnly", e;
}({}), MR = {
	createdBy: "createdBy",
	name: "name",
	provider: "provider"
}, NR = {
	createdBy: "createdBy",
	status: "status"
}, PR = [{
	groupLabel: "Filter By",
	items: [{
		id: NR.createdBy,
		label: "Created By"
	}, {
		id: NR.status,
		label: "Status"
	}]
}], FR = [{
	groupLabel: "Filter By",
	items: [{
		id: NR.createdBy,
		label: "Created By"
	}]
}], IR = {
	[xo.VOLUME_SNAPSHOT]: "Volume Snapshot Locations",
	[xo.STORAGE]: "Storage Locations"
}, LR = Object.values(xo).map((e) => ({
	label: IR[e],
	value: e
})), RR = {
	[OR.AVAILABLE]: "Available",
	[OR.UNAVAILABLE]: "Unavailable",
	[OR.UNKNOWN]: "Unknown"
}, zR = {
	[OR.AVAILABLE]: "positive",
	[OR.UNAVAILABLE]: "negative",
	[OR.UNKNOWN]: "neutral"
}, BR = {
	[OR.AVAILABLE]: "G500",
	[OR.UNAVAILABLE]: "R500",
	[OR.UNKNOWN]: "N500"
}, VR = {
	name: "name",
	createdBy: "createdBy",
	provider: "provider"
}, HR = ({ statusCountMap: e }) => Object.values(e || {}).some((e) => e > 0) ? /* @__PURE__ */ (0, Q.jsx)(W, {
	alwaysShowTippyOnHover: !0,
	content: /* @__PURE__ */ (0, Q.jsx)("div", {
		className: "flexbox-col dc__gap-4",
		children: Object.values(OR).map((t) => e[t] > 0 ? /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox w-100 dc__content-space dc__gap-8",
			children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox w-100 dc__gap-6",
				children: [/* @__PURE__ */ (0, Q.jsx)(z, {
					name: "ic-circle-small",
					size: 16,
					color: BR[t]
				}), /* @__PURE__ */ (0, Q.jsx)("span", { children: RR[t] })]
			}), /* @__PURE__ */ (0, Q.jsx)("span", { children: e[t] })]
		}, t) : null)
	}),
	placement: "top",
	children: /* @__PURE__ */ (0, Q.jsx)("div", {
		className: "flexbox dc__align-items-center dc__gap-6 dc_width-max-content",
		children: Object.values(OR).map((t) => e[t] > 0 ? /* @__PURE__ */ (0, Q.jsx)(So, {
			variant: zR[t],
			startIconProps: { name: "ic-circle-small" },
			label: `${e[t]}`
		}, t) : null)
	})
}) : /* @__PURE__ */ (0, Q.jsx)("div", {
	className: "flexbox dc__align-items-center cn-9 fs-13 fw-4 lh-20",
	children: "-"
}), UR = ({ row: e, signals: t }) => {
	let n = Ja(null), { type: r } = Z(), i = Y(B.DATA_PROTECTION_MANAGEMENT_BACKUP_LOCATIONS_DETAIL, {
		type: r,
		locationId: String(e.data.id)
	});
	return k(() => {
		let e = () => {
			n.current?.click();
		};
		return t.addEventListener(iu.ENTER_PRESSED, e), () => {
			t.removeEventListener(iu.ENTER_PRESSED, e);
		};
	}, []), /* @__PURE__ */ (0, Q.jsx)("div", {
		className: "flexbox dc__align-items-center",
		children: /* @__PURE__ */ (0, Q.jsx)(W, {
			content: e.data.name,
			children: /* @__PURE__ */ (0, Q.jsx)(Wf, {
				to: i,
				className: "anchor dc__truncate cb-5 fs-13 fw-4 lh-20",
				ref: n,
				children: e.data.name
			})
		})
	});
}, WR = ({ row: e }) => e.data.createdBy ? /* @__PURE__ */ (0, Q.jsx)(gu, { identifier: e.data.createdBy }) : /* @__PURE__ */ (0, Q.jsx)("span", { children: "-" }), GR = ({ row: e }) => /* @__PURE__ */ (0, Q.jsx)(So, {
	variant: "neutral",
	startIconProps: ER[e.data.provider] ? { name: ER[e.data.provider] } : null,
	label: DR[e.data.provider] || e.data.provider,
	size: I.xxs
}), KR = ({ row: e }) => /* @__PURE__ */ (0, Q.jsx)(HR, { statusCountMap: e.data.statusCountMap }), qR = ({ row: e }) => /* @__PURE__ */ (0, Q.jsx)("div", {
	className: "flexbox dc__align-items-center",
	children: /* @__PURE__ */ (0, Q.jsx)("span", {
		className: "cn-9 fs-13 fw-4 lh-20",
		children: Ud(e.data.lastSyncedTime) || "-"
	})
}), JR = (e, t) => {
	let n = e.split("?")[0].split("#")[0];
	return { alias: {
		...HF(),
		"backup-locations": {
			component: /* @__PURE__ */ (0, Q.jsx)(Wf, {
				to: Y(B.DATA_PROTECTION_MANAGEMENT_BACKUP_LOCATIONS, { type: xo.VOLUME_SNAPSHOT }),
				children: /* @__PURE__ */ (0, Q.jsx)(To, {
					isActive: !!Jf({ path: B.DATA_PROTECTION_MANAGEMENT_BACKUP_LOCATIONS }, n),
					heading: "Backup Locations"
				})
			}),
			linked: !1
		},
		":type": {
			component: null,
			linked: !1
		},
		":locationId": {
			component: t ? /* @__PURE__ */ (0, Q.jsx)(To, {
				isActive: !0,
				heading: t
			}) : /* @__PURE__ */ (0, Q.jsx)("div", { className: "h-20 w-120 shimmer-loading" }),
			linked: !1
		}
	} };
}, YR = (e) => [
	{
		field: MR.name,
		label: "Name",
		size: { range: {
			startWidth: e === xo.STORAGE ? 540 : 680,
			maxWidth: 900,
			minWidth: 500
		} },
		CellComponent: UR,
		isSortable: !0,
		horizontallySticky: !0
	},
	{
		field: MR.provider,
		label: "Provider",
		size: { range: {
			startWidth: 280,
			maxWidth: 320,
			minWidth: 100
		} },
		CellComponent: GR,
		isSortable: !0
	},
	...e === xo.STORAGE ? [{
		field: "lastSyncedTime",
		label: "Last Synced",
		size: { range: {
			startWidth: 200,
			maxWidth: 250,
			minWidth: 150
		} },
		isSortable: !1,
		CellComponent: qR
	}, {
		field: "statusCountMap",
		label: "Status",
		size: { fixed: 200 },
		isSortable: !1,
		CellComponent: KR
	}] : [],
	{
		field: MR.createdBy,
		label: "Added By",
		size: { range: {
			startWidth: 180,
			maxWidth: 250,
			minWidth: 100
		} },
		isSortable: !0,
		CellComponent: WR
	}
], XR = (e, t) => t === xo.STORAGE, ZR = (e) => (e || []).reduce((e, t) => (e[t.phase] = (e[t.phase] || 0) + 1, e), {}), QR = (e) => e?.length ? (e || []).reduce((e, t) => (!e.lastSyncedTime && t.lastSyncedTime && (e.lastSyncedTime = t.lastSyncedTime), !e.lastValidationTime && t.lastValidationTime && (e.lastValidationTime = t.lastValidationTime), e.lastSyncedTime = t.lastSyncedTime && Lu(e.lastSyncedTime, t.lastSyncedTime) > 0 ? t.lastSyncedTime : e.lastSyncedTime, e.lastValidationTime = t.lastValidationTime && Lu(e.lastValidationTime, t.lastValidationTime) > 0 ? t.lastValidationTime : e.lastValidationTime, e), {
	lastSyncedTime: null,
	lastValidationTime: null
}) : {
	lastSyncedTime: null,
	lastValidationTime: null
}, $R = (e, t) => (e?.data || []).map((e) => ({
	id: e.id,
	name: e.name,
	provider: e.provider,
	createdBy: e.createdBy,
	...XR(e, t) ? {
		type: xo.STORAGE,
		statusCountMap: e.status?.length ? ZR(e.status) : null,
		...QR(e.status)
	} : { type: xo.VOLUME_SNAPSHOT }
})), ez = (e) => {
	let t = e.getAll(NR.createdBy), n = e.getAll(NR.status).filter((e) => e in RR);
	return {
		createdBy: t.length ? t : void 0,
		status: n.length ? n : void 0
	};
}, tz = (e, t) => {
	let { createdBy: n = [], status: r = [] } = ez(e), i = (n || []).reduce((e, t) => (e[t] = !0, e), {}), a = n.length && t?.createdByOptions.filter((e) => i[e.value]) || null;
	return {
		areFiltersApplied: !!n.length,
		appliedFilterOptions: {
			createdBy: a,
			status: r.map((e) => ({
				label: RR[e] || e,
				value: e
			}))
		}
	};
}, nz = ({ createdBy: e, status: t }) => {
	let n = [];
	return e?.length && n.push({
		key: "createdBy",
		values: e
	}), t?.length && n.push({
		key: "status",
		values: t
	}), n.length ? n : null;
}, rz = Object.values(VF).map((e) => ({
	label: DR[e],
	startIcon: /* @__PURE__ */ (0, Q.jsx)(z, {
		name: ER[e],
		color: null
	}),
	value: e
})), iz = {
	[jR.READ_ONLY]: "Read Only",
	[jR.READ_WRITE]: "Read and Write"
}, az = Object.values(jR).map((e) => ({
	label: iz[e],
	value: e
})), oz = {
	id: 0,
	name: "",
	provider: VF.GCP,
	config: [{
		key: "",
		value: "",
		id: Id()
	}],
	credentialDetails: { isEnabled: !1 }
}, sz = {
	name: null,
	config: !1,
	credentialName: null,
	credentialKey: null,
	credentialData: null
}, cz = {
	name: "name",
	config: "config",
	credentialName: "credentialName",
	credentialKey: "credentialKey",
	credentialData: "credentialData"
}, lz = {
	...structuredClone(oz),
	bucket: "",
	prefix: "",
	region: "",
	caCert: "",
	accessMode: jR.READ_WRITE,
	backupSyncPeriod: "",
	validationFrequency: "",
	isDefault: !1
}, uz = {
	...structuredClone(sz),
	bucket: null
}, dz = { bucket: "bucket" }, fz = /* @__PURE__ */ function(e) {
	return e.PROVIDER_CONFIGURATION = "Provider Configuration", e.OBJECT_STORAGE_DETAILS = "Object Storage Details", e.SYNC_AND_VALIDATION = "Sync & Validation", e.SET_AS_DEFAULT = "Set as Default", e;
}({}), pz = ({ formData: e, setFormData: t, formError: n, setFormError: r }) => /* @__PURE__ */ (0, Q.jsxs)("div", {
	className: "flexbox-col p-20 dc__gap-16 br-8 bg__primary border__secondary",
	children: [
		/* @__PURE__ */ (0, Q.jsx)("h3", {
			className: "m-0 cn-9 fs-14 fw-6 lh-1-5",
			children: fz.OBJECT_STORAGE_DETAILS
		}),
		/* @__PURE__ */ (0, Q.jsx)(os, {
			name: "storage-bucket",
			value: e.bucket,
			label: "Storage Bucket",
			required: !0,
			autoFocus: !0,
			placeholder: "Enter the object storage bucket/container name",
			onChange: (e) => {
				let n = e.target.value;
				t((e) => ({
					...e,
					bucket: n
				})), r((e) => ({
					...e,
					bucket: lf(n).message
				}));
			},
			error: n.bucket,
			fullWidth: !0
		}),
		/* @__PURE__ */ (0, Q.jsx)(os, {
			name: "bucket-path-prefix",
			value: e.prefix,
			label: "Bucket Path Prefix",
			placeholder: "Path prefix within the bucket",
			onChange: (e) => {
				let n = e.target.value;
				t((e) => ({
					...e,
					prefix: n
				}));
			},
			fullWidth: !0
		}),
		/* @__PURE__ */ (0, Q.jsx)("div", { className: "divider divider--n1" }),
		/* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox dc__content-space dc__gap-16 w-100",
			children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox-col",
				children: [/* @__PURE__ */ (0, Q.jsx)("h4", {
					className: "m-0 cn-9 fs-13 fw-4 lh-1-5",
					children: "Access Mode"
				}), /* @__PURE__ */ (0, Q.jsx)("p", {
					className: "m-0 cn-7 fs-12 fw-4 lh-1-5",
					children: "Set the level of permissions this location has for backups and restores"
				})]
			}), /* @__PURE__ */ (0, Q.jsx)("div", {
				className: "w-120",
				children: /* @__PURE__ */ (0, Q.jsx)(V, {
					inputId: "access-mode-select",
					variant: Hl.COMPACT,
					options: az,
					value: az.find((t) => t.value === e.accessMode),
					onChange: (e) => {
						let n = e?.value;
						t((e) => ({
							...e,
							accessMode: n
						}));
					},
					shouldMenuAlignRight: !0
				})
			})]
		})
	]
}), mz = ({ type: e, formData: t, setFormData: n, formError: r, setFormError: i }) => {
	let a = e === xo.VOLUME_SNAPSHOT;
	return /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [
		/* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox-col p-20 dc__gap-16 br-8 bg__primary border__secondary",
			children: [/* @__PURE__ */ (0, Q.jsx)("h3", {
				className: "m-0 cn-9 fs-14 fw-6 lh-1-5",
				children: "Basic Details"
			}), /* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox dc__gap-8",
				children: [
					/* @__PURE__ */ (0, Q.jsx)("div", {
						className: "w-200 dc__no-shrink",
						children: /* @__PURE__ */ (0, Q.jsx)(V, {
							inputId: "provider-configuration-provider-select",
							options: rz,
							value: rz.find((e) => e.value === t.provider) || null,
							required: !0,
							label: "Provider",
							onChange: (e) => {
								n((t) => ({
									...t,
									provider: e.value
								}));
							},
							size: I.large
						})
					}),
					/* @__PURE__ */ (0, Q.jsx)("span", {
						className: "pt-26 fs-20 lh-36 cn-7 dc__no-shrink",
						children: "/"
					}),
					/* @__PURE__ */ (0, Q.jsx)(os, {
						name: "location-name",
						value: t.name,
						label: `${a ? "Volume Snapshot" : "Backup Storage"} Location Name`,
						disabled: !!t.id,
						required: !0,
						autoFocus: !0,
						placeholder: `Type ${a ? "snapshot" : "storage"} location name`,
						onChange: (e) => {
							let t = e.target.value;
							n((e) => ({
								...e,
								name: t
							}));
							let r = Bf(t);
							i((e) => ({
								...e,
								name: r.message
							}));
						},
						error: r.name,
						fullWidth: !0
					})
				]
			})]
		}),
		/* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox-col p-20 dc__gap-16 br-8 bg__primary border__secondary",
			children: [
				/* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "flexbox dc__gap-4",
					children: [/* @__PURE__ */ (0, Q.jsx)("h3", {
						className: "m-0 cn-9 fs-14 fw-6 lh-1-5",
						children: a ? "Configuration Fields" : "Storage Configuration"
					}), /* @__PURE__ */ (0, Q.jsx)(Cc, {
						heading: a ? "Configuration Fields" : "Storage Configuration",
						infoText: a ? /* @__PURE__ */ (0, Q.jsx)("span", { children: "These fields are specific to the selected provider. Pls refer to documentation for further details." }) : /* @__PURE__ */ (0, Q.jsxs)("div", {
							className: "flexbox-col dc__gap-20",
							children: [/* @__PURE__ */ (0, Q.jsx)("span", { children: "Devtron leverages Velero for Backup & Restore capabilities." }), /* @__PURE__ */ (0, Q.jsx)("span", { children: "Velero supports a variety of storage providers for different backup and snapshot operations. Velero has a plugin system which allows anyone to add compatibility for additional backup and volume storage platforms without modifying the Velero codebase." })]
						})
					})]
				}),
				/* @__PURE__ */ (0, Q.jsx)(kc, {
					headerLabel: {
						key: "Key",
						value: "Value"
					},
					placeholder: {
						key: "Enter key",
						value: "Enter value"
					},
					rows: t.config.map(({ key: e, value: t, id: n }) => ({
						data: {
							key: { value: e },
							value: { value: t }
						},
						id: n
					})),
					showError: !0,
					onChange: (e) => {
						n((t) => ({
							...t,
							config: e
						}));
					},
					onError: (e) => {
						i((t) => ({
							...t,
							config: e
						}));
					},
					validateEmptyKeys: !0,
					validateDuplicateKeys: !0,
					isSortable: !0
				}),
				e === xo.STORAGE && /* @__PURE__ */ (0, Q.jsx)(ou, {
					label: "CA Certificate",
					name: "ca-certificate",
					placeholder: "Paste CA certificate",
					value: t.caCert,
					onChange: (e) => {
						let t = e.target.value;
						n((e) => ({
							...e,
							caCert: t
						}));
					}
				})
			]
		}),
		/* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox-col p-20 dc__gap-16 br-8 bg__primary border__secondary",
			children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox dc__content-space",
				children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "flexbox dc__gap-4 flex-grow-1",
					children: [/* @__PURE__ */ (0, Q.jsx)("h3", {
						className: "m-0 cn-9 fs-14 fw-6 lh-1-5",
						children: "Credentials"
					}), /* @__PURE__ */ (0, Q.jsx)(Cc, {
						heading: "Credentials",
						additionalContent: a ? /* @__PURE__ */ (0, Q.jsx)("div", {
							className: "flexbox-col dc__gap-2 px-12 pb-12 pt-4",
							children: /* @__PURE__ */ (0, Q.jsxs)("ul", {
								className: "pl-20 mt-8",
								children: [/* @__PURE__ */ (0, Q.jsx)("li", { children: "It is possible to create additional Volume Snapshot Locations that use their own credentials. This may be necessary if you already have default credentials which don't match the account used by the cloud volumes being backed up." }), /* @__PURE__ */ (0, Q.jsx)("li", { children: "If you create additional Volume Snapshot Locations without specifying the credentials to use, Velero will use the credentials provided at install time and stored in the cloud-credentials secret." })]
							})
						}) : /* @__PURE__ */ (0, Q.jsx)("div", {
							className: "p-12",
							children: /* @__PURE__ */ (0, Q.jsx)("span", { children: "Credentials are stored in a Kubernetes secret. The secret must be in the same namespace as Velero." })
						})
					})]
				}), /* @__PURE__ */ (0, Q.jsx)(bs, {
					ariaLabel: "Enable Credentials Switch",
					name: "enable-credentials",
					isChecked: t.credentialDetails.isEnabled,
					onChange: () => {
						let e = t.credentialDetails.isEnabled ? { isEnabled: !1 } : {
							isEnabled: !0,
							details: {
								name: "",
								key: "",
								type: AR.EXISTING
							}
						};
						n((t) => ({
							...t,
							credentialDetails: e
						})), i((e) => ({
							...e,
							credentialData: null,
							credentialKey: null,
							credentialName: null
						}));
					}
				})]
			}), t.credentialDetails.isEnabled && /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [
				/* @__PURE__ */ (0, Q.jsxs)(vl, {
					name: "credential-type",
					className: "radio-group-no-border",
					value: t.credentialDetails.details.type,
					onChange: (e) => {
						let t = e.target.value;
						n((e) => {
							let n = {
								isEnabled: !0,
								details: t === AR.EXISTING ? {
									type: t,
									name: e.credentialDetails.details.name,
									key: e.credentialDetails.details.key
								} : {
									type: t,
									name: e.credentialDetails.details.name,
									key: e.credentialDetails.details.key,
									data: ""
								}
							};
							return {
								...e,
								credentialDetails: n
							};
						}), i((e) => ({
							...e,
							credentialData: t === AR.NEW ? "" : null
						}));
					},
					children: [/* @__PURE__ */ (0, Q.jsx)(yl, {
						value: AR.EXISTING,
						children: "Select Secret"
					}), /* @__PURE__ */ (0, Q.jsx)(yl, {
						value: AR.NEW,
						children: "Create New Secret"
					})]
				}),
				/* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "flexbox dc__gap-12 dc__grid-rows-2",
					children: [/* @__PURE__ */ (0, Q.jsx)(os, {
						name: "secret-name",
						value: t.credentialDetails.details.name,
						label: "Secret Name",
						required: !0,
						placeholder: "Type secret name",
						onChange: (e) => {
							let t = e.target.value;
							n((e) => ({
								...e,
								credentialDetails: {
									isEnabled: !0,
									details: {
										...e.credentialDetails.details,
										name: t
									}
								}
							})), i((e) => ({
								...e,
								credentialName: lf(t).message
							}));
						},
						error: r.credentialName,
						fullWidth: !0
					}), /* @__PURE__ */ (0, Q.jsx)(os, {
						name: "secret-key",
						value: t.credentialDetails.details.key,
						label: "Secret Key",
						required: !0,
						placeholder: "Type secret key",
						onChange: (e) => {
							let t = e.target.value;
							n((e) => ({
								...e,
								credentialDetails: {
									isEnabled: !0,
									details: {
										...e.credentialDetails.details,
										key: t
									}
								}
							})), i((e) => ({
								...e,
								credentialKey: lf(t).message
							}));
						},
						error: r.credentialKey,
						fullWidth: !0
					})]
				}),
				t.credentialDetails.details.type === AR.NEW && /* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "flexbox-col dc__gap-6",
					children: [/* @__PURE__ */ (0, Q.jsx)("span", {
						className: "dc__required-field cn-7 fs-13 fw-4 lh-20",
						children: "Credential Data"
					}), /* @__PURE__ */ (0, Q.jsx)(Xo, {
						mode: Ic.PLAINTEXT,
						value: t.credentialDetails.details.data,
						placeholder: "Enter secret data",
						onChange: (e) => {
							t.credentialDetails.details.type === AR.NEW && (n((t) => ({
								...t,
								credentialDetails: {
									isEnabled: !0,
									details: {
										...t.credentialDetails.details,
										type: AR.NEW,
										data: e
									}
								}
							})), i((t) => ({
								...t,
								credentialData: lf(e).message
							})));
						},
						children: r.credentialData && /* @__PURE__ */ (0, Q.jsx)(Xo.ErrorBar, { text: r.credentialData })
					})]
				})
			] })]
		})
	] });
}, hz = async ({ offset: e, pageSize: t, sortBy: n, sortOrder: r, searchKey: i, type: a, signal: o, createdBy: s, status: c }) => {
	let { result: l } = await nf(a === xo.STORAGE ? O.STORAGE_LOCATION_LIST : O.VOLUME_SNAPSHOT_LIST, {
		offset: e,
		size: t,
		sortBy: VR[n],
		sortOrder: r,
		searchByName: i,
		filters: nz({
			createdBy: s,
			status: c
		})
	}, { signal: o });
	return {
		totalCount: l.totalCount,
		data: $R(l, a)
	};
}, gz = async (e) => ({ createdByOptions: (await Rt(e) || []).map((e) => ({
	label: e.emailId,
	value: e.emailId
})) }), _z = async ({ id: e, type: t, signal: n, showToast: r = !0, throwError: i = !1 }) => {
	try {
		return await ff(`${t === xo.STORAGE ? O.CLUSTER_BACKUP_STORAGE_LOCATION : O.CLUSTER_BACKUP_SNAPSHOT_LOCATION}/${e}`, null, { signal: n }), r && H.showToast({
			variant: U.success,
			description: `${t === xo.STORAGE ? "Storage" : "Volume snapshot"} successfully deleted`
		}), !0;
	} catch (e) {
		if (r && K(e), i) throw e;
		return !1;
	}
}, vz = async (e, t) => {
	let { result: n } = await G(`${O.CLUSTER_BACKUP_SNAPSHOT_LOCATION}/${e}`, { signal: t });
	return n;
}, yz = async (e, t) => {
	let { result: n } = await G(`${O.CLUSTER_BACKUP_STORAGE_LOCATION}/${e}`, { signal: t });
	return n;
}, bz = (e) => e.credential ? {
	isEnabled: !0,
	details: e.credential.type === AR.EXISTING ? {
		type: AR.EXISTING,
		name: e.credential.name,
		key: e.credential.key
	} : {
		type: AR.NEW,
		name: e.credential.name || "",
		key: e.credential.key || "",
		data: atob(e.credential.data || "")
	}
} : { isEnabled: !1 }, xz = (e) => ({
	id: e.id,
	name: e.name || "",
	provider: e.provider,
	config: [{
		key: "",
		value: "",
		id: Id()
	}].concat(Object.entries(e.config || {}).map(([e, t]) => ({
		key: e,
		value: t,
		id: Id()
	}))),
	credentialDetails: bz(e)
}), Sz = (e) => ({
	...xz(e),
	bucket: e.bucket || "",
	prefix: e.prefix || "",
	region: e.region || "",
	caCert: e.caCert || "",
	accessMode: e.accessMode || jR.READ_WRITE,
	backupSyncPeriod: e.backupSyncPeriod || "",
	validationFrequency: e.validationFrequency || "",
	isDefault: e.isDefault || !1
}), Cz = (e) => !Jd(e) && e !== !1, wz = (e, t) => {
	let n = structuredClone(t);
	if (n.name = n.name || lf(e.name).message, e.credentialDetails.isEnabled) {
		let { details: t } = e.credentialDetails;
		n.credentialName = n.credentialName || lf(t.name).message, n.credentialKey = n.credentialKey || lf(t.key).message, t.type === AR.NEW ? n.credentialData = n.credentialData || lf(t.data).message : n.credentialData = null;
	}
	return {
		isErrorPresent: Object.values(n).some(Cz),
		updatedErrorState: n
	};
}, Tz = (e, t) => {
	let { updatedErrorState: n } = wz(e, t), r = structuredClone({
		...t,
		...n
	});
	return r.bucket = r.bucket || lf(e.bucket).message, {
		isErrorPresent: Object.values(r).some(Cz),
		updatedErrorState: r
	};
}, Ez = (e) => {
	if (!e.isEnabled) return null;
	if (e.details.type === AR.EXISTING) return e.details;
	let t = btoa(e.details.data || "");
	return {
		type: AR.NEW,
		name: e.details.name,
		key: e.details.key,
		data: t
	};
}, Dz = (e) => ({
	name: e.name,
	provider: e.provider,
	credential: Ez(e.credentialDetails),
	config: e.config.reduce((e, t) => (t.key && (e[t.key] = t.value), e), {})
}), Oz = async (e, t) => xz(await vz(e, t)), kz = async (e) => {
	try {
		let t = Dz(e);
		return e.id ? (await sf(O.CLUSTER_BACKUP_SNAPSHOT_LOCATION, {
			id: e.id,
			...t
		}), !0) : (await nf(O.CLUSTER_BACKUP_SNAPSHOT_LOCATION, t), !0);
	} catch (e) {
		return K(e), !1;
	}
}, Az = async (e, t) => Sz(await yz(e, t)), jz = async (e) => {
	try {
		let t = {
			...Dz(e),
			bucket: e.bucket,
			prefix: e.prefix,
			region: e.region,
			caCert: e.caCert,
			accessMode: e.accessMode,
			backupSyncPeriod: e.backupSyncPeriod || null,
			validationFrequency: e.validationFrequency || null,
			isDefault: e.isDefault || !1
		};
		return e.id ? (await sf(O.CLUSTER_BACKUP_STORAGE_LOCATION, {
			id: e.id,
			...t
		}), !0) : (await nf(O.CLUSTER_BACKUP_STORAGE_LOCATION, t), !0);
	} catch (e) {
		return K(e), !1;
	}
}, Mz = ({ currentTab: e, setCurrentTab: t, toggleSetAsDefault: n, isDefault: r, formError: i }) => {
	let a = (e) => {
		switch (e) {
			case fz.PROVIDER_CONFIGURATION: return !Object.values(cz).some((e) => i[e]);
			case fz.OBJECT_STORAGE_DETAILS: return !Object.values(dz).some((e) => i[e]);
			case fz.SYNC_AND_VALIDATION: return !0;
			default: return !0;
		}
	}, o = (e) => () => {
		if (e === fz.SET_AS_DEFAULT) {
			n();
			return;
		}
		t(e);
	};
	return /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox-col py-20 px-12 dc__gap-12 bg__modal--primary dc__overflow-auto",
		children: [
			/* @__PURE__ */ (0, Q.jsx)("div", {
				className: "flexbox-col",
				children: Object.values(fz).map((t) => /* @__PURE__ */ (0, Q.jsxs)("div", {
					className: `py-6 px-8 br-4 flexbox dc__gap-8 dc__align-items-center ${t === e ? "bcb-1" : "bg__hover"}`,
					children: [/* @__PURE__ */ (0, Q.jsxs)("button", {
						type: "button",
						className: `dc__transparent flexbox dc__content-space fs-13 flex-grow-1 dc__align-items-center ${t === e ? "fw-6 cb-5" : "fw-4 cn-9"} lh-1-5`,
						"data-testid": `move-to-${t.replace(" ", "-")}-tab`,
						onClick: o(t),
						children: [t, !a(t) && /* @__PURE__ */ (0, Q.jsx)(z, {
							name: "ic-warning-fill",
							size: 16,
							color: "R500"
						})]
					}), t === fz.SET_AS_DEFAULT && /* @__PURE__ */ (0, Q.jsx)(bs, {
						name: "set-as-default-toggle",
						ariaLabel: "Toggle Set as Default",
						isChecked: r,
						onChange: n,
						size: I.small
					})]
				}, t))
			}),
			/* @__PURE__ */ (0, Q.jsx)("div", { className: "divider divider--n1" }),
			/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox-col dc__gap-4 dc__align-start",
				children: [/* @__PURE__ */ (0, Q.jsx)("span", {
					className: "fs-13 fw-6 lh-20 cn-9",
					children: "📙 Need help?"
				}), /* @__PURE__ */ (0, Q.jsx)(Ns, {
					docLinkKey: "DOC_HOME_PAGE",
					text: "View documentation",
					dataTestId: "storage-location-doc-link",
					showExternalIcon: !0,
					openInNewTab: !0
				})]
			})
		]
	});
}, Nz = ({ formData: e, setFormData: t }) => /* @__PURE__ */ (0, Q.jsxs)("div", {
	className: "flexbox-col p-20 dc__gap-16 br-8 bg__primary border__secondary",
	children: [
		/* @__PURE__ */ (0, Q.jsx)("h3", {
			className: "m-0 cn-9 fs-14 fw-6 lh-1-5",
			children: "Sync & Validation"
		}),
		/* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox dc__content-space w-100",
			children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox-col",
				children: [/* @__PURE__ */ (0, Q.jsx)("h4", {
					className: "cn-9 fs-13 fw-4 lh-1-5 m-0",
					children: "Backup Sync Period"
				}), /* @__PURE__ */ (0, Q.jsx)("p", {
					className: "cn-7 fs-12 fw-4 lh-1-5 m-0",
					children: "How often should backups be synced with this location?"
				})]
			}), /* @__PURE__ */ (0, Q.jsx)("div", {
				className: "w-150",
				children: /* @__PURE__ */ (0, Q.jsx)(os, {
					name: "backup-sync-period",
					autoFocus: !0,
					value: e.backupSyncPeriod,
					placeholder: "Eg. 5m, 1h",
					onChange: (e) => {
						let n = e.target.value;
						t((e) => ({
							...e,
							backupSyncPeriod: n
						}));
					}
				})
			})]
		}),
		/* @__PURE__ */ (0, Q.jsx)("div", { className: "divider divider--n1" }),
		/* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox dc__content-space w-100",
			children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox-col",
				children: [/* @__PURE__ */ (0, Q.jsx)("h4", {
					className: "cn-9 fs-13 fw-4 lh-1-5 m-0",
					children: "Validation Frequency"
				}), /* @__PURE__ */ (0, Q.jsx)("p", {
					className: "cn-7 fs-12 fw-4 lh-1-5 m-0",
					children: "How frequently should object store validation be performed?"
				})]
			}), /* @__PURE__ */ (0, Q.jsx)("div", {
				className: "w-150",
				children: /* @__PURE__ */ (0, Q.jsx)(os, {
					name: "validation-frequency",
					value: e.validationFrequency,
					placeholder: "Eg. 10m, 2h",
					onChange: (e) => {
						let n = e.target.value;
						t((e) => ({
							...e,
							validationFrequency: n
						}));
					}
				})
			})]
		})
	]
}), Pz = ({ handleClose: e, onSuccess: t, id: n }) => {
	let { searchParams: r } = jf(), i = n || r[kR.UPDATE_LOCATION_ID], a = i ? +i : 0, o = !!a, { isFetching: s, data: c, error: l, refetch: u } = q({
		queryKey: ["edit-storage-location", a],
		queryFn: ({ signal: e }) => Az(a, e),
		enabled: o
	}), [d, f] = j(structuredClone(lz)), [p, m] = j(structuredClone(uz)), [h, g] = j(!1), [_, v] = j(fz.PROVIDER_CONFIGURATION), y = o && s;
	return k(() => {
		o && c && f(c);
	}, [c, o]), /* @__PURE__ */ (0, Q.jsx)(Rs, {
		position: "right",
		width: "1024px",
		onEscape: e,
		onClose: e,
		children: /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox-col dc__content-space h-100 bg__modal--primary shadow__modal dc__overflow-auto",
			onClick: uf,
			children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox-col dc__overflow-auto flex-grow-1",
				children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "px-20 py-12 flexbox dc__content-space dc__align-items-center border__primary--bottom",
					children: [/* @__PURE__ */ (0, Q.jsxs)("h2", {
						className: "m-0 fs-16 fw-6 lh-24 cn-9",
						children: [o ? "Edit" : "Add", " Storage Location"]
					}), /* @__PURE__ */ (0, Q.jsx)(M, {
						dataTestId: "header-close-button",
						ariaLabel: "Close",
						showAriaLabelInTippy: !1,
						onClick: e,
						variant: F.borderLess,
						style: P.negativeGrey,
						icon: /* @__PURE__ */ (0, Q.jsx)(z, {
							name: "ic-close-large",
							color: null
						}),
						size: I.xs
					})]
				}), /* @__PURE__ */ (0, Q.jsx)($a, {
					isLoading: y,
					progressingProps: { pageLoader: !0 },
					error: l,
					errorScreenManagerProps: {
						code: l?.code,
						reload: u
					},
					children: /* @__PURE__ */ (0, Q.jsxs)("div", {
						className: "dc__grid create-storage-location-form__container dc__overflow-auto flex-grow-1",
						children: [/* @__PURE__ */ (0, Q.jsx)(Mz, {
							currentTab: _,
							setCurrentTab: v,
							toggleSetAsDefault: () => {
								f((e) => ({
									...e,
									isDefault: !e.isDefault
								}));
							},
							isDefault: d.isDefault,
							formError: p
						}), /* @__PURE__ */ (0, Q.jsx)("div", {
							className: "dc__overflow-auto flexbox-col flex-grow-1 dc__overflow-auto w-100 p-20 dc__gap-20 bg__modal--secondary",
							children: (() => {
								switch (_) {
									case fz.PROVIDER_CONFIGURATION: return /* @__PURE__ */ (0, Q.jsx)(mz, {
										type: xo.STORAGE,
										formData: d,
										setFormData: f,
										formError: p,
										setFormError: m
									});
									case fz.OBJECT_STORAGE_DETAILS: return /* @__PURE__ */ (0, Q.jsx)(pz, {
										formData: d,
										setFormData: f,
										formError: p,
										setFormError: m
									});
									case fz.SYNC_AND_VALIDATION: return /* @__PURE__ */ (0, Q.jsx)(Nz, {
										formData: d,
										setFormData: f
									});
									default: return null;
								}
							})()
						})]
					})
				})]
			}), /* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox dc__content-end dc__gap-12 py-16 px-20 border__primary--top dc__no-shrink",
				children: [/* @__PURE__ */ (0, Q.jsx)(M, {
					dataTestId: "footer-cancel-button",
					variant: F.secondary,
					text: "Cancel",
					style: P.neutral,
					size: I.large,
					onClick: e
				}), /* @__PURE__ */ (0, Q.jsx)(M, {
					dataTestId: "footer-apply-button",
					variant: F.primary,
					size: I.large,
					text: "Save",
					disabled: y || !!l,
					isLoading: h,
					onClick: async () => {
						let { isErrorPresent: n, updatedErrorState: r } = Tz(d, p);
						if (n) {
							m(r), H.showToast({
								variant: U.error,
								description: "Please resolve all the errors before saving."
							});
							return;
						}
						g(!0), await jz(d) && (e(), t()), g(!1);
					}
				})]
			})]
		})
	});
}, Fz = ({ handleClose: e, onSuccess: t, id: n }) => {
	let { searchParams: r } = jf(), i = n || r[kR.UPDATE_LOCATION_ID], a = i ? +i : 0, o = !!a, { isFetching: s, data: c, error: l, refetch: u } = q({
		queryKey: ["volume-snapshot", a],
		queryFn: ({ signal: e }) => Oz(a, e),
		enabled: o
	}), [d, f] = j(structuredClone(oz)), [p, m] = j(structuredClone(sz)), [h, g] = j(!1), _ = o && s;
	return k(() => {
		o && c && f(c);
	}, [c, o]), /* @__PURE__ */ (0, Q.jsx)(Rs, {
		position: "right",
		width: "800px",
		onEscape: e,
		onClose: e,
		children: /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox-col dc__content-space h-100 bg__modal--primary shadow__modal dc__overflow-auto",
			onClick: uf,
			children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox-col dc__overflow-auto flex-grow-1",
				children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "px-20 py-12 flexbox dc__content-space dc__align-items-center border__primary--bottom",
					children: [/* @__PURE__ */ (0, Q.jsxs)("h2", {
						className: "m-0 fs-16 fw-6 lh-24 cn-9",
						children: [o ? "Edit" : "Add", " Volume Snapshot Location"]
					}), /* @__PURE__ */ (0, Q.jsx)(M, {
						dataTestId: "header-close-button",
						ariaLabel: "Close",
						showAriaLabelInTippy: !1,
						onClick: e,
						variant: F.borderLess,
						style: P.negativeGrey,
						icon: /* @__PURE__ */ (0, Q.jsx)(z, {
							name: "ic-close-large",
							color: null
						}),
						size: I.xs
					})]
				}), /* @__PURE__ */ (0, Q.jsx)("div", {
					className: "flexbox-col flex-grow-1 dc__overflow-auto w-100 p-20 dc__gap-20 bg__modal--secondary",
					children: /* @__PURE__ */ (0, Q.jsx)($a, {
						isLoading: _,
						progressingProps: { pageLoader: !0 },
						error: l,
						errorScreenManagerProps: {
							code: l?.code,
							reload: u
						},
						children: /* @__PURE__ */ (0, Q.jsx)(mz, {
							formData: d,
							setFormData: f,
							formError: p,
							setFormError: m,
							type: xo.VOLUME_SNAPSHOT
						})
					})
				})]
			}), /* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox dc__content-end dc__gap-12 py-16 px-20 border__primary--top dc__no-shrink",
				children: [/* @__PURE__ */ (0, Q.jsx)(M, {
					dataTestId: "footer-cancel-button",
					variant: F.secondary,
					text: "Cancel",
					style: P.neutral,
					size: I.large,
					onClick: e
				}), /* @__PURE__ */ (0, Q.jsx)(M, {
					dataTestId: "footer-apply-button",
					variant: F.primary,
					size: I.large,
					text: "Save",
					disabled: _ || !!l,
					isLoading: h,
					onClick: async () => {
						let { isErrorPresent: n, updatedErrorState: r } = wz(d, p);
						if (n) {
							m(r), H.showToast({
								variant: U.error,
								description: "Please resolve all the errors before saving."
							});
							return;
						}
						g(!0), await kz(d) && (e(), t()), g(!1);
					}
				})]
			})]
		})
	});
}, Iz = ({ id: e, name: t, type: n, onSuccess: r, handleClose: i }) => {
	let [a, o] = j(!1);
	return /* @__PURE__ */ (0, Q.jsx)(ns, {
		title: `Are you sure you want to delete '${t}'?`,
		variant: rs.delete,
		handleClose: i,
		confirmationConfig: {
			identifier: `delete-${n}-location`,
			confirmationKeyword: t
		},
		buttonConfig: {
			primaryButtonConfig: {
				text: "Delete",
				onClick: async () => {
					o(!0), await _z({
						id: e,
						type: n
					}) && (r(), i()), o(!1);
				},
				isLoading: a
			},
			secondaryButtonConfig: {
				text: "Cancel",
				onClick: i
			}
		}
	});
}, Lz = /* @__PURE__ */ function(e) {
	return e.MODAL_TYPE = "modalType", e;
}({}), Rz = /* @__PURE__ */ function(e) {
	return e.EDIT = "edit", e;
}({}), zz = ({ locationDetails: e, refetchLocationDetails: t }) => {
	let n = Yf(), r = X(), { searchParams: i } = jf(), [a, o] = j(!1), s = () => {
		r({
			pathname: n.pathname,
			search: ""
		});
	}, c = () => {
		o(!1);
	}, l = () => {
		o(!0);
	}, u = () => {
		r({ pathname: Y(B.DATA_PROTECTION_MANAGEMENT_BACKUP_LOCATIONS, { type: e.type }) });
	}, d = () => a ? /* @__PURE__ */ (0, Q.jsx)(Iz, {
		name: e.name,
		type: e.type,
		id: e.id,
		onSuccess: u,
		handleClose: c
	}) : i[Lz.MODAL_TYPE] === Rz.EDIT ? e.type === xo.VOLUME_SNAPSHOT ? /* @__PURE__ */ (0, Q.jsx)(Fz, {
		handleClose: s,
		onSuccess: t,
		id: e.id
	}) : /* @__PURE__ */ (0, Q.jsx)(Pz, {
		handleClose: s,
		onSuccess: t,
		id: e.id
	}) : null, f = (e, t) => /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox-col dc__gap-4",
		children: [/* @__PURE__ */ (0, Q.jsx)("span", {
			className: "cn-7 fs-13 fw-4 lh-20",
			children: e
		}), /* @__PURE__ */ (0, Q.jsx)(W, {
			content: t,
			children: /* @__PURE__ */ (0, Q.jsx)("span", {
				className: "cn-9 fs-13 fw-4 lh-20 dc__truncate",
				children: t
			})
		})]
	});
	return /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox-col dc__overflow-auto h-100 py-20 px-16 dc__gap-20 border__primary--right",
		children: [
			/* @__PURE__ */ (0, Q.jsx)("div", {
				className: "flexbox-col dc__gap-12",
				children: /* @__PURE__ */ (0, Q.jsx)("h3", {
					className: "m-0 cn-9 font-merriweather fs-16 fw-7 lh-1-5 dc__word-break",
					children: e.name
				})
			}),
			/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox dc__gap-8",
				children: [/* @__PURE__ */ (0, Q.jsx)(M, {
					dataTestId: "edit-backup-location-button",
					startIcon: /* @__PURE__ */ (0, Q.jsx)(z, {
						name: "ic-pencil",
						color: null
					}),
					text: "Edit",
					size: I.medium,
					component: N.link,
					linkProps: { to: {
						pathname: n.pathname,
						search: Rd("", { [Lz.MODAL_TYPE]: Rz.EDIT })
					} }
				}), /* @__PURE__ */ (0, Q.jsx)(M, {
					dataTestId: "delete-backup-location-button",
					icon: /* @__PURE__ */ (0, Q.jsx)(z, {
						name: "ic-delete",
						color: null
					}),
					ariaLabel: "Delete Backup Location",
					showAriaLabelInTippy: !1,
					variant: F.secondary,
					style: P.negativeGrey,
					size: I.medium,
					onClick: l
				})]
			}),
			/* @__PURE__ */ (0, Q.jsx)("div", { className: "divider divider--n1" }),
			/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox-col dc__gap-12",
				children: [
					e.type === xo.STORAGE && /* @__PURE__ */ (0, Q.jsxs)("div", {
						className: "flexbox dc__content-space dc__gap-12",
						children: [/* @__PURE__ */ (0, Q.jsx)("span", {
							className: "cn-7 fs-13 fw-4 lh-20",
							children: "Status"
						}), /* @__PURE__ */ (0, Q.jsx)(HR, { statusCountMap: e.statusCountMap })]
					}),
					f("Added by", e.createdBy),
					f("Provider", DR[e.provider] || e.provider),
					e.type === xo.STORAGE && /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [
						f("Last Synchronization", Ud(e.lastSyncedTime) || "-"),
						f("Last Validation", Ud(e.lastValidationTime) || "-"),
						f("Object Storage Bucket", e.bucket)
					] })
				]
			})
		]
	}), d()] });
}, Bz = async (e, t, n) => {
	let r = await (t === xo.STORAGE ? yz : vz)(e, n), i = {
		name: r.name,
		createdBy: r.createdBy,
		provider: r.provider,
		id: r.id
	};
	if (t === xo.VOLUME_SNAPSHOT) return {
		...i,
		type: xo.VOLUME_SNAPSHOT
	};
	let a = r;
	return {
		...i,
		...QR(a.status),
		type: xo.STORAGE,
		statusCountMap: ZR(a.status),
		bucket: a.bucket
	};
}, Vz = async (e, t) => {
	let n = (await Un({
		...e,
		signal: t
	}))?.manifestResponse?.manifest;
	return Tu(n) || "";
}, Hz = async (e, t, n) => {
	let { result: r } = await G(Y(e === xo.STORAGE ? O.STORAGE_CLUSTER_LIST : O.VOLUME_SNAPSHOT_CLUSTER_LIST, { id: t }), { signal: n });
	return (r || []).filter((e) => !!e.clusterId).map((e) => ({
		id: e.clusterId,
		name: e.clusterName || "-",
		manifestPayload: e.resourceIdentifier ? {
			name: e.resourceIdentifier.name,
			namespace: e.resourceIdentifier.namespace,
			clusterId: e.clusterId,
			gvk: e.resourceIdentifier.groupVersionKind ? {
				Group: e.resourceIdentifier.groupVersionKind.Group,
				Version: e.resourceIdentifier.groupVersionKind.Version,
				Kind: e.resourceIdentifier.groupVersionKind.Kind
			} : null
		} : null
	}));
}, Uz = ({ clusterList: e }) => {
	let [t, n] = j(e?.[0]), { isFetching: r, data: i, error: a, refetch: o } = q({
		queryKey: ["backup-location-manifest", t?.manifestPayload],
		queryFn: ({ signal: e }) => Vz(t?.manifestPayload, e),
		enabled: !!t
	});
	if (!t) return /* @__PURE__ */ (0, Q.jsx)(R, {
		title: "No Cluster found",
		subTitle: "No associated cluster found"
	});
	let s = (t) => {
		n(e.find((e) => e.id === t.value));
	}, c = (e || []).map((e) => ({
		label: e.name,
		value: e.id
	}));
	return /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox-col h-100 dc__content-space flex-grow-1",
		children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "py-12 px-16 flexbox dc__content-space dc__align-items-center border__secondary--bottom",
			children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox dc__gap-4 dc__align-items-center",
				children: [/* @__PURE__ */ (0, Q.jsx)("h2", {
					className: "m-0 cn-9 fs-13 fw-6 lh-1-5",
					children: "Manifest for cluster"
				}), /* @__PURE__ */ (0, Q.jsx)(V, {
					inputId: "backup-location-manifest-cluster-select",
					options: c,
					value: c.find((e) => e.value === t?.id),
					isClearable: !1,
					onChange: s,
					variant: Hl.BORDER_LESS,
					size: I.small
				})]
			}), i && /* @__PURE__ */ (0, Q.jsx)(qo, { content: i })]
		}), /* @__PURE__ */ (0, Q.jsx)($a, {
			isLoading: r,
			error: a,
			genericSectionErrorProps: {
				reload: o,
				rootClassName: "flex-grow-1"
			},
			children: /* @__PURE__ */ (0, Q.jsx)(Xo, {
				mode: Ic.YAML,
				value: i || "",
				height: "fitToParent",
				readOnly: !0
			})
		})]
	});
}, Wz = () => {
	let e = Yf(), { locationId: t, type: n } = Z(), { isFetching: r, data: i, error: a, refetch: o } = q({
		queryKey: [
			"backup-location-details",
			t,
			n
		],
		queryFn: ({ signal: e }) => Bz(+t, n, e),
		enabled: !!t
	}), { isFetching: s, data: c, error: l, refetch: u } = q({
		queryKey: [
			"backup-location-cluster-list",
			t,
			n
		],
		queryFn: ({ signal: e }) => Hz(n, +t, e),
		enabled: !!t
	}), { breadcrumbs: d } = gf(B.DATA_PROTECTION_MANAGEMENT_BACKUP_LOCATIONS_DETAIL, JR(e.pathname, i?.name), [e.pathname, i]);
	return /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox-col dc__content-space flex-grow-1 h-100 dc__overflow-auto",
		children: [/* @__PURE__ */ (0, Q.jsx)(Qc, {
			isBreadcrumbs: !0,
			breadCrumbs: () => /* @__PURE__ */ (0, Q.jsx)(Co, {
				breadcrumbs: d,
				path: B.DATA_PROTECTION_MANAGEMENT_BACKUP_LOCATIONS_DETAIL
			})
		}), /* @__PURE__ */ (0, Q.jsx)("div", {
			className: "flexbox-col flex-grow-1 dc__overflow-auto",
			children: /* @__PURE__ */ (0, Q.jsx)($a, {
				isLoading: r,
				error: a,
				progressingProps: { pageLoader: !0 },
				errorScreenManagerProps: {
					code: a?.code,
					reload: o,
					redirectURL: Y(B.DATA_PROTECTION_MANAGEMENT_BACKUP_LOCATIONS, { type: n })
				},
				children: i && /* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "dc__grid backup-location-details__container dc__overflow-auto flex-grow-1",
					children: [/* @__PURE__ */ (0, Q.jsx)(zz, {
						locationDetails: i,
						refetchLocationDetails: o
					}), /* @__PURE__ */ (0, Q.jsx)($a, {
						isLoading: s,
						error: l,
						progressingProps: { pageLoader: !0 },
						errorScreenManagerProps: {
							code: l?.code,
							reload: u,
							redirectURL: Y(B.DATA_PROTECTION_MANAGEMENT_BACKUP_LOCATIONS, { type: n })
						},
						children: /* @__PURE__ */ (0, Q.jsx)(Uz, { clusterList: c })
					})]
				})
			})
		})]
	});
}, Gz = () => {
	let e = X(), t = Yf(), { type: n } = Z(), { isFetching: r, error: i, data: a, refetch: o } = q({
		queryKey: ["backup-location-list-grouped-select-metadata"],
		queryFn: ({ signal: e }) => gz(e)
	}), { areFiltersApplied: s, appliedFilterOptions: c } = A(() => tz(new URLSearchParams(t.search), a), [t.search, a]), { createdByOptions: l } = a || { createdByOptions: [] }, u = (n) => (r) => {
		let i = new URLSearchParams(t.search);
		i.delete(n), r.forEach((e) => {
			i.append(n, e.value);
		}), e({ search: i.toString() }, { replace: !0 });
	}, d = {
		createdBy: {
			inputId: "backup-location-list-created-by-filter",
			placeholder: "Select User",
			options: l,
			appliedFilterOptions: c.createdBy,
			handleApplyFilter: u("createdBy"),
			isDisabled: r,
			isLoading: r,
			optionListError: i,
			reloadOptionList: o,
			isUserIdentifier: !0
		},
		status: {
			inputId: "backup-location-list-status-filter",
			placeholder: "Select Status",
			options: Object.entries(RR).map(([e, t]) => ({
				label: t,
				value: e
			})),
			appliedFilterOptions: c.status,
			handleApplyFilter: u("status"),
			isDisabled: !1,
			isLoading: !1
		}
	};
	if (n === xo.STORAGE) return /* @__PURE__ */ (0, Q.jsx)(pc, {
		id: "backup-location-list-grouped-filter-select",
		isFilterApplied: s,
		width: 120,
		options: PR,
		filterSelectPickerPropsMap: d
	});
	let { status: f, ...p } = d;
	return /* @__PURE__ */ (0, Q.jsx)(pc, {
		id: "backup-location-list-grouped-filter-select",
		isFilterApplied: s,
		width: 120,
		options: FR,
		filterSelectPickerPropsMap: p
	});
}, Kz = ({ label: e = "Add" }) => {
	let { type: t } = Z(), n = Yf();
	return /* @__PURE__ */ (0, Q.jsx)(M, {
		dataTestId: `create-${t}-button`,
		component: N.link,
		text: e,
		startIcon: /* @__PURE__ */ (0, Q.jsx)(z, {
			name: "ic-add",
			color: null
		}),
		size: I.medium,
		linkProps: { to: {
			pathname: n.pathname,
			search: (() => {
				let e = new URLSearchParams(n.search);
				return e.set(kR.MODAL_TYPE, t), e.toString();
			})()
		} }
	});
}, qz = ({ children: e, searchKey: t, handleSearch: n, hideTableFilters: r }) => {
	let i = X(), a = Yf(), { type: o } = Z(), s = ez(new URLSearchParams(a.search));
	return /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox-col dc__overflow-hidden flex-grow-1",
		children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox-col",
			children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox dc__gap-8 dc__content-space p-16",
				children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "flexbox dc__gap-8 dc__align-items-center",
					children: [/* @__PURE__ */ (0, Q.jsx)(Bl, {
						segments: LR,
						value: o,
						name: "backup-location-tabs",
						onChange: (e) => {
							i(Y(B.DATA_PROTECTION_MANAGEMENT_BACKUP_LOCATIONS, { type: String(e.value) }));
						}
					}), !r && /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsx)(Il, {
						initialSearchText: t,
						handleEnter: n,
						keyboardShortcut: "/"
					}), /* @__PURE__ */ (0, Q.jsx)(Gz, {})] })]
				}), !r && /* @__PURE__ */ (0, Q.jsx)("div", {
					className: "flexbox dc__align-items-center dc__gap-8",
					children: /* @__PURE__ */ (0, Q.jsx)(Kz, {})
				})]
			}), /* @__PURE__ */ (0, Q.jsx)(Zs, {
				className: "px-20 pb-16 py-2",
				filterConfig: {
					createdBy: s.createdBy,
					status: s.status
				},
				onRemoveFilter: (e) => {
					let t = new URLSearchParams(a.search);
					Object.entries(e).forEach(([e, n]) => {
						n ? Array.isArray(n) ? (t.delete(e), n.forEach((n) => t.append(e, n))) : t.set(e, n) : t.delete(e);
					}), i({ search: t.toString() });
				},
				clearFilters: () => {
					i({ search: "" });
				}
			})]
		}), e]
	});
}, Jz = ({ onActionClick: e }) => {
	let { type: t } = Z();
	return /* @__PURE__ */ (0, Q.jsx)(M, {
		dataTestId: "bulk-delete-location-button",
		icon: /* @__PURE__ */ (0, Q.jsx)(z, {
			name: "ic-delete",
			color: null
		}),
		component: N.button,
		style: P.negativeGrey,
		variant: F.borderLess,
		ariaLabel: "Delete Selected Locations",
		size: I.small,
		onClick: e,
		showAriaLabelInTippy: !1,
		"data-key": t === xo.STORAGE ? sF.STORAGE_LOCATION : sF.VOLUME_SNAPSHOT
	});
}, Yz = ({ row: e, handleShowDeleteModal: t }) => {
	let { type: n } = Z(), r = Yf();
	return /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox py-8 px-4 dc__gap-4 dc__content-end dc__align-items-center",
		children: [/* @__PURE__ */ (0, Q.jsx)(M, {
			dataTestId: "edit-location-button",
			icon: /* @__PURE__ */ (0, Q.jsx)(z, {
				name: "ic-pencil",
				color: null
			}),
			component: N.link,
			style: P.neutral,
			variant: F.borderLess,
			ariaLabel: `Edit ${e.data.name}`,
			showAriaLabelInTippy: !1,
			size: I.small,
			linkProps: { to: {
				pathname: r.pathname,
				search: (() => {
					let t = new URLSearchParams(r.search);
					return t.set(kR.MODAL_TYPE, n), t.set(kR.UPDATE_LOCATION_ID, String(e.data.id)), t.toString();
				})()
			} }
		}), /* @__PURE__ */ (0, Q.jsx)(M, {
			dataTestId: "bulk-delete-restore-button",
			icon: /* @__PURE__ */ (0, Q.jsx)(z, {
				name: "ic-delete",
				color: null
			}),
			component: N.button,
			style: P.negativeGrey,
			variant: F.borderLess,
			ariaLabel: "Delete Selected Locations",
			size: I.small,
			onClick: () => {
				t(e.data);
			},
			showAriaLabelInTippy: !1
		})]
	});
}, Xz = () => {
	let [e, t] = j(!1), [n, r] = j(!1), [i, a] = j(null), { type: o } = Z(), s = X(), c = Yf(), { searchParams: l } = jf(), u = Ka(async ({ sortBy: e, sortOrder: n, searchKey: r, offset: i, pageSize: a, createdBy: s, status: c }, l) => {
		try {
			t(!1);
			let u = await hz({
				offset: i,
				pageSize: a,
				sortBy: e,
				sortOrder: n,
				searchKey: r,
				signal: l,
				createdBy: s,
				type: o,
				status: c
			});
			return t(!(r || s?.length || c?.length || i > 0) && u.totalCount === 0), {
				rows: (u.data || []).map((e) => ({
					id: String(e.id),
					data: e
				})),
				totalRows: u.totalCount || 0
			};
		} catch (e) {
			throw e.code === eo.PERMISSION_DENIED && t(!0), e;
		}
	}, [o, n]), d = (e) => {
		a(e);
	}, f = () => {
		a(null);
	}, p = A(() => YR(o), [o]), m = () => {
		let e = new URLSearchParams(c.search);
		Object.values(kR).forEach((t) => {
			e.delete(t);
		}), s({ search: e.toString() }, { replace: !0 });
	}, h = () => {
		r((e) => !e);
	};
	return /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsx)(ru, {
		id: `table__hero-listing-backup-locations-${o}`,
		columns: p,
		emptyStateConfig: {
			noRowsConfig: {
				imgName: "img-no-backup-location",
				title: o === xo.STORAGE ? "No storage locations added" : "No snapshot locations added",
				isButtonAvailable: !0,
				renderButton: () => /* @__PURE__ */ (0, Q.jsx)(Kz, { label: o === xo.STORAGE ? "Add Storage Location" : "Add Snapshot Location" })
			},
			noRowsForFilterConfig: {
				title: "No results",
				subTitle: "We couldn't find any matching results"
			}
		},
		paginationVariant: el.PAGINATED,
		additionalFilterProps: {
			initialSortKey: MR.name,
			parseSearchParams: ez
		},
		bulkSelectionConfig: {
			BulkActionsComponent: Jz,
			bulkActionsData: null,
			BulkOperationModal: dF,
			bulkOperationModalData: {
				handleDelete: async (e, t) => {
					t === "*" ? H.showToast({
						variant: U.error,
						description: "Coming Soon! Bulk delete of all backup locations is not supported yet."
					}) : await _z({
						id: t,
						type: o,
						signal: e.signal,
						showToast: !1,
						throwError: !0
					});
				},
				reloadDataAfterBulkOperation: h
			},
			getSelectAllDialogStatus: () => Vl.CLOSED
		},
		getRows: u,
		filtersVariant: tc.URL,
		ViewWrapper: qz,
		additionalProps: {
			hideTableFilters: e,
			handleShowDeleteModal: d
		},
		filter: null,
		rowActionOnHoverConfig: {
			width: 72,
			Component: Yz
		}
	}, n ? "backup-location-table-1" : "backup-location-table-0"), i ? /* @__PURE__ */ (0, Q.jsx)(Iz, {
		name: i.name,
		id: i.id,
		type: i.type,
		onSuccess: h,
		handleClose: f
	}) : l[kR.MODAL_TYPE] === xo.VOLUME_SNAPSHOT ? /* @__PURE__ */ (0, Q.jsx)(Fz, {
		handleClose: m,
		onSuccess: h
	}) : l[kR.MODAL_TYPE] === xo.STORAGE ? /* @__PURE__ */ (0, Q.jsx)(Pz, {
		handleClose: m,
		onSuccess: h
	}) : null] });
}, Zz = () => {
	let e = Yf(), { breadcrumbs: t } = gf(B.DATA_PROTECTION_MANAGEMENT_BACKUP_LOCATIONS, JR(e.pathname), [e.pathname]);
	return /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox-col dc__content-space flex-grow-1 h-100 dc__overflow-auto",
		children: [/* @__PURE__ */ (0, Q.jsx)(Qc, {
			isBreadcrumbs: !0,
			breadCrumbs: () => /* @__PURE__ */ (0, Q.jsx)(Co, {
				breadcrumbs: t,
				path: B.DATA_PROTECTION_MANAGEMENT_BACKUP_LOCATIONS
			})
		}), /* @__PURE__ */ (0, Q.jsx)("div", {
			className: "flexbox-col flex-grow-1 dc__overflow-auto",
			children: /* @__PURE__ */ (0, Q.jsx)(Xz, {})
		})]
	});
}, Qz = vo.DATA_PROTECTION_MANAGEMENT.BACKUP_LOCATIONS, $z = () => /* @__PURE__ */ (0, Q.jsxs)(qf, { children: [/* @__PURE__ */ (0, Q.jsx)(J, {
	index: !0,
	element: /* @__PURE__ */ (0, Q.jsx)(Zz, {})
}), /* @__PURE__ */ (0, Q.jsx)(J, {
	path: Qz.DETAIL,
	element: /* @__PURE__ */ (0, Q.jsx)(Wz, {})
})] }), eB = /* @__PURE__ */ function(e) {
	return e.BACKUPS_INITIATED = "backupsInitiated", e.RESTORES_INITIATED = "restoresInitiated", e.BACKUP_SCHEDULES = "totalSchedules", e;
}({}), tB = /* @__PURE__ */ function(e) {
	return e.BACKUP_STATUS = "backupStatus", e.RESTORE_STATUS = "restoreStatus", e.SCHEDULE_STATUS = "scheduleStatus", e;
}({}), nB = /* @__PURE__ */ function(e) {
	return e.UNAVAILABLE_STORAGE_LOCATION = "unavailableStorageLocation", e.PAUSED_SCHEDULE = "pausedSchedule", e;
}({}), rB = {
	[eB.BACKUPS_INITIATED]: {
		metricTitle: "Backups Initiated",
		iconName: "ic-bg-backups",
		tooltipContent: "Total number of backups initiated."
	},
	[eB.RESTORES_INITIATED]: {
		metricTitle: "Restores Initiated",
		iconName: "ic-bg-restore",
		tooltipContent: "Total number of restores initiated."
	},
	[eB.BACKUP_SCHEDULES]: {
		metricTitle: "Backup Schedules",
		iconName: "ic-bg-backup-schedule",
		tooltipContent: "Total number of backups scheduled."
	}
}, iB = Object.values(ll).map((e) => ({
	label: `${e} Clusters`,
	value: e
})), aB = {
	AT_A_GLANCE_METRICS: "atAGlanceMetrics",
	BACKUP_AND_RESTORE_SUMMARY: "backupAndRestoreSummary",
	BACKUP_SUCCESS_RATE: "backupSuccessRate"
}, oB = {
	[nB.UNAVAILABLE_STORAGE_LOCATION]: {
		dataTestId: "unavailable-storage-locations",
		metricTitle: "Unavailable Storage Locations",
		iconName: "ic-bg-storage-locations",
		tooltipContent: "Number of backup storage locations that are currently unavailable.",
		subtitle: "View unavailable storage locations",
		subtitleRedirection: Rd(Y(B.DATA_PROTECTION_MANAGEMENT_BACKUP_LOCATIONS, { type: xo.STORAGE }), { status: OR.UNAVAILABLE })
	},
	[nB.PAUSED_SCHEDULE]: {
		dataTestId: "paused-schedules",
		metricTitle: "Paused Schedules",
		iconName: "ic-bg-pause-schedule",
		tooltipContent: "Number of backup schedules that are currently paused.",
		subtitle: "View paused schedules",
		subtitleRedirection: Rd(Y(B.DATA_PROTECTION_MANAGEMENT_BACKUP_AND_SCHEDULE, { view: bo.Schedules }), { pauseState: "true" })
	}
}, sB = {
	Completed: "Completed",
	Failed: "Failed",
	InProgress: "In Progress",
	Deleting: "Deleting",
	PartiallyFailed: "Partially Failed"
}, cB = {
	Completed: "LimeGreen500",
	Failed: "CoralRed500",
	InProgress: "SunsetOrange500",
	Deleting: "CoralRed200",
	PartiallyFailed: "GoldenYellow500"
}, lB = [
	{
		key: tB.BACKUP_STATUS,
		id: "backups-status",
		title: "Backup Status",
		emptyStateTitle: "No Backups Initiated",
		labelMap: sB,
		colorMap: cB
	},
	{
		key: tB.RESTORE_STATUS,
		id: "restore-status",
		title: "Restore Status",
		emptyStateTitle: "No Restores Initiated",
		labelMap: sB,
		colorMap: cB
	},
	{
		key: tB.SCHEDULE_STATUS,
		id: "clusters-with-backup-schedule",
		title: "Clusters with Backup Schedule",
		emptyStateTitle: "No Backup Schedules",
		labelMap: {
			fullBackupSchedule: "Full Backup Schedule",
			partialBackupSchedule: "Partial Backup Schedule",
			notCoveredSchedule: "Not Covered Schedule"
		},
		colorMap: {
			fullBackupSchedule: "LimeGreen500",
			partialBackupSchedule: "SunsetOrange500",
			notCoveredSchedule: "CharcoalGray500"
		}
	}
], uB = (e, t, n) => Object.entries(e).reduce((e, [r, i]) => {
	let a = t[r], o = n[r];
	return a && o && (e.xAxisLabels.push(a), e.colors.push(o), e.yAxisValues.push(i)), e;
}, {
	xAxisLabels: [],
	colors: [],
	yAxisValues: []
}), dB = (e) => lB.map((t) => {
	let { xAxisLabels: n, colors: r, yAxisValues: i } = uB(e?.[t.key] ?? {}, t.labelMap, t.colorMap);
	return {
		id: t.id,
		title: t.title,
		xAxisLabels: n,
		datasets: {
			colors: r,
			datasetName: t.title,
			yAxisValues: i
		},
		emptyStateTitle: t.emptyStateTitle
	};
}), fB = (e) => q({
	queryKey: [aB.AT_A_GLANCE_METRICS, e],
	queryFn: ({ signal: t }) => G(Rd(O.OVERVIEW_GLANCE_METRICS, { clusterType: e.toLowerCase() }), { signal: t }),
	select: (e) => Object.entries(rB).map(([t, n]) => ({
		dataTestId: t,
		metricValue: (e.result?.[t] ?? 0).toLocaleString(),
		...n
	}))
}), pB = (e) => q({
	queryKey: [aB.BACKUP_AND_RESTORE_SUMMARY, e],
	queryFn: ({ signal: t }) => G(Rd(O.OVERVIEW_BACKUP_AND_RESTORE_SUMMARY, { clusterType: e.toLowerCase() }), { signal: t }),
	select: (e) => ({
		chartsConfig: dB(e?.result),
		cardsConfig: Object.entries(oB).map(([t, n]) => ({
			dataTestId: t,
			metricValue: (e.result?.[t]?.count ?? 0).toLocaleString(),
			valueOutOf: (e.result?.[t]?.total ?? 0).toLocaleString(),
			...n
		}))
	})
}), mB = ({ clusterType: e, sortConfig: { sortBy: t, sortOrder: n }, offset: r, pageSize: i }) => q({
	queryKey: [
		aB.BACKUP_SUCCESS_RATE,
		e,
		t,
		n,
		r,
		i
	],
	queryFn: ({ signal: a }) => G(Rd(O.OVERVIEW_BACKUP_SUCCESS_RATE, {
		clusterType: e.toLowerCase(),
		sortBy: t,
		sortOrder: n,
		offset: r,
		size: i
	}), { signal: a }),
	select: (e) => {
		let { clusterNames: t, successRates: n } = (e.result?.data ?? []).reduce((e, t) => (e.clusterNames.push(t.clusterName), e.successRates.push(t.successPercentage), e), {
			clusterNames: [],
			successRates: []
		});
		return {
			clusterNames: t,
			successRates: n,
			totalCount: e.result?.totalCount ?? 0
		};
	}
}), hB = ({ clusterType: e }) => {
	let t = kf(), [n, r] = j(!1), i = async () => {
		r(!0), await Promise.all(Object.values(aB).map((e) => t.refetchQueries({ queryKey: [e] }))), r(!1);
	}, { isFetching: a, isError: o, data: s, refetch: c } = fB(e);
	return /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox-col dc__gap-12",
		children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flex dc__content-space",
			children: [/* @__PURE__ */ (0, Q.jsx)("span", {
				className: "fs-20 fw-4 lh-1-5 cn-9",
				children: "At A Glance"
			}), /* @__PURE__ */ (0, Q.jsx)(M, {
				dataTestId: "refresh-overview-data",
				icon: /* @__PURE__ */ (0, Q.jsx)(z, {
					name: n ? "ic-circle-loader" : "ic-arrows-clockwise",
					color: null
				}),
				variant: F.borderLess,
				style: P.neutral,
				size: I.small,
				ariaLabel: "Refresh data",
				showAriaLabelInTippy: !1,
				disabled: n,
				onClick: i,
				isLoading: n
			})]
		}), a ? /* @__PURE__ */ (0, Q.jsx)("div", {
			className: "dc__grid cards-wrapper",
			children: Object.keys(eB).map((e) => /* @__PURE__ */ (0, Q.jsx)(Bc, {}, e))
		}) : o ? /* @__PURE__ */ (0, Q.jsx)(lc, {
			subTitle: "",
			reload: c,
			rootClassName: "bg__primary br-8 border__secondary"
		}) : /* @__PURE__ */ (0, Q.jsx)("div", {
			className: "dc__grid cards-wrapper",
			children: s.map(({ dataTestId: e, ...t }) => /* @__PURE__ */ (0, Q.jsx)(zc, {
				dataTestId: e,
				...t
			}, e))
		})]
	});
}, gB = [
	{
		label: "High to Low",
		value: {
			sortBy: "successPercentage",
			sortOrder: Jl.DESC
		}
	},
	{
		label: "Low to High",
		value: {
			sortBy: "successPercentage",
			sortOrder: Jl.ASC
		}
	},
	{
		label: "A to Z",
		value: {
			sortBy: "clusterName",
			sortOrder: Jl.ASC
		}
	},
	{
		label: "Z to A",
		value: {
			sortBy: "clusterName",
			sortOrder: Jl.DESC
		}
	}
], _B = ({ clusterType: e }) => {
	let [t, n] = j(gB[0].value), { offset: r, pageSize: i, changePage: a, changePageSize: o } = Mf({ defaultPageSize: Yc[0].value }), { isFetching: s, isError: c, refetch: l, data: u } = mB({
		clusterType: e,
		sortConfig: t,
		offset: r,
		pageSize: i
	});
	return /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox-col bg__primary border__secondary br-8",
		children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flex dc__content-space px-16 py-12 border__secondary--bottom",
			children: [/* @__PURE__ */ (0, Q.jsx)("span", {
				className: "fs-14 fw-6 lh-1-5 cn-9",
				children: "Backup Success Rate by Clusters"
			}), /* @__PURE__ */ (0, Q.jsx)(V, {
				inputId: "success-rate-sort-select",
				options: gB,
				variant: Hl.COMPACT,
				value: Dd(gB, t),
				onChange: (e) => {
					a(1), n(e.value);
				},
				isDisabled: s
			})]
		}), s ? /* @__PURE__ */ (0, Q.jsx)("div", {
			className: "p-16",
			children: /* @__PURE__ */ (0, Q.jsx)("div", { className: "w-100 h-200 br-8 shimmer" })
		}) : c ? /* @__PURE__ */ (0, Q.jsx)(lc, {
			subTitle: "",
			reload: l
		}) : (u?.clusterNames ?? []).length ? /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsx)("div", {
			className: "p-16 mh-200 mxh-600",
			style: { height: (u.clusterNames.length + 1) * 40 },
			children: /* @__PURE__ */ (0, Q.jsx)(Uo, {
				id: "backup-success-rate-chart",
				type: "stackedBarHorizontal",
				xAxisLabels: u.clusterNames,
				datasets: [{
					datasetName: "Success Rate (%)",
					color: "SkyBlue500",
					yAxisValues: u.successRates
				}],
				yScaleTickFormat: (e) => `${e}%`,
				xAxisMax: 100
			})
		}), u.totalCount > Yc[0].value && /* @__PURE__ */ (0, Q.jsx)($c, {
			size: u?.totalCount,
			offset: r,
			pageSize: i,
			changePage: a,
			changePageSize: o,
			pageSizeOptions: Yc,
			rootClassName: "flex dc__content-space border__secondary--top px-16"
		})] }) : /* @__PURE__ */ (0, Q.jsx)(R, {
			title: "No Data Available",
			classname: "h-300"
		})]
	});
}, vB = ({ isFetching: e, data: t, isError: n, refetch: r }) => e ? /* @__PURE__ */ (0, Q.jsx)("div", {
	className: "dc__grid-half dc__gap-8",
	children: Object.values(nB).map((e) => /* @__PURE__ */ (0, Q.jsx)(Bc, { withSubtitle: !0 }, e))
}) : n ? /* @__PURE__ */ (0, Q.jsx)(lc, {
	subTitle: "",
	reload: r,
	rootClassName: "bg__primary br-8 border__secondary"
}) : /* @__PURE__ */ (0, Q.jsx)("div", {
	className: "dc__grid-half dc__gap-8",
	children: t.cardsConfig.map((e) => /* @__PURE__ */ (0, Q.jsx)(zc, {
		dataTestId: e.dataTestId,
		...e
	}, e.dataTestId))
}), yB = ({ id: e, title: t, emptyStateTitle: n, xAxisLabels: r, datasets: i }) => /* @__PURE__ */ (0, Q.jsxs)("div", {
	className: "flexbox-col bg__primary br-8 border__secondary",
	children: [/* @__PURE__ */ (0, Q.jsx)("div", {
		className: "p-12 border__secondary--bottom",
		children: /* @__PURE__ */ (0, Q.jsx)("span", {
			className: "fs-14 fw-6 lh-1-5",
			children: t
		})
	}), /* @__PURE__ */ (0, Q.jsx)("div", {
		className: "flex px-16 py-24 h-200",
		children: r.length ? /* @__PURE__ */ (0, Q.jsx)(Uo, {
			id: e,
			type: "pie",
			xAxisLabels: r,
			datasets: i
		}) : /* @__PURE__ */ (0, Q.jsx)(Ll, { title: n })
	})]
}), bB = ({ isFetching: e, data: t, isError: n }) => e ? /* @__PURE__ */ (0, Q.jsx)("div", {
	className: "dc__grid cards-wrapper",
	children: Object.values(tB).map((e) => /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox-col bg__primary br-8 border__secondary",
		children: [/* @__PURE__ */ (0, Q.jsx)("div", {
			className: "flex left px-16 py-12 border__secondary--bottom",
			children: /* @__PURE__ */ (0, Q.jsx)("span", { className: "shimmer w-100px" })
		}), /* @__PURE__ */ (0, Q.jsx)(Pc, {})]
	}, e))
}) : n ? null : /* @__PURE__ */ (0, Q.jsx)("div", {
	className: "dc__grid cards-wrapper",
	children: t?.chartsConfig.map((e) => /* @__PURE__ */ (0, Q.jsx)(yB, {
		id: e.id,
		...e
	}, e.id))
}), xB = ({ clusterType: e }) => {
	let t = pB(e);
	return /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox-col dc__gap-12",
		children: [
			/* @__PURE__ */ (0, Q.jsx)("span", {
				className: "fs-20 fw-4 lh-1-5 cn-9",
				children: "Backup & Restore Summary"
			}),
			/* @__PURE__ */ (0, Q.jsx)(bB, { ...t }),
			/* @__PURE__ */ (0, Q.jsx)(vB, { ...t }),
			/* @__PURE__ */ (0, Q.jsx)(_B, { clusterType: e })
		]
	});
}, SB = () => {
	let { pathname: e } = Yf(), { breadcrumbs: t } = gf(B.DATA_PROTECTION_MANAGEMENT_OVERVIEW, { alias: {
		...HF(),
		overview: { component: /* @__PURE__ */ (0, Q.jsx)(To, {
			heading: "Overview",
			isActive: !0
		}) }
	} }, [e]);
	return /* @__PURE__ */ (0, Q.jsx)(Qc, {
		isBreadcrumbs: !0,
		breadCrumbs: () => /* @__PURE__ */ (0, Q.jsx)(Co, {
			breadcrumbs: t,
			path: B.DATA_PROTECTION_MANAGEMENT_OVERVIEW
		})
	});
}, CB = () => {
	let [e, t] = j(ll.ALL);
	return /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsx)(SB, {}), /* @__PURE__ */ (0, Q.jsx)("div", {
		className: "data-protection-overview flex-grow-1 bg__secondary dc__overflow-auto",
		children: /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "p-20 w-100 flexbox-col dc__gap-20 dc__mxw-1200 min-w-800 dc__m-auto",
			children: [/* @__PURE__ */ (0, Q.jsx)("div", {
				className: "w-150",
				children: /* @__PURE__ */ (0, Q.jsx)(V, {
					inputId: "prod-non-prod-select",
					options: iB,
					value: Dd(iB, e),
					onChange: (e) => {
						t(e.value);
					}
				})
			}), /* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox-col dc__gap-32",
				children: [/* @__PURE__ */ (0, Q.jsx)(hB, { clusterType: e }), /* @__PURE__ */ (0, Q.jsx)(xB, { clusterType: e })]
			})]
		})
	})] });
}, wB = ({ row: e }) => {
	let { searchParams: t } = jf(), n = t[hu.SEARCH_KEY] || "";
	return /* @__PURE__ */ (0, Q.jsx)("div", {
		className: "flexbox dc__align-items-center",
		children: /* @__PURE__ */ (0, Q.jsx)(W, {
			content: e.data.name,
			children: /* @__PURE__ */ (0, Q.jsx)(Wf, {
				to: Y(B.DATA_PROTECTION_MANAGEMENT_RESTORES_DETAIL, { restoreId: String(e.data.id) }),
				className: "anchor dc__truncate cb-5 fs-13 fw-4 lh-20",
				dangerouslySetInnerHTML: { __html: Ne.sanitize(Gd({
					searchText: n,
					text: e.data.name,
					highlightClasses: "bcy-2"
				})) }
			})
		})
	});
}, TB = ({ row: e }) => {
	let t = MB[e.data.status] || Au(e.data.status || "-");
	return /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox dc__gap-6 dc__align-items-center",
		children: [NB[e.data.status] || null, /* @__PURE__ */ (0, Q.jsx)("span", {
			className: "cn-9 fs-13 fw-4 lh-20 dc__truncate",
			children: t
		})]
	});
}, EB = ({ row: e }) => /* @__PURE__ */ (0, Q.jsxs)("div", {
	className: "flexbox dc__gap-6 dc__align-items-center",
	children: [!!e.data.backupSource.name && /* @__PURE__ */ (0, Q.jsx)(z, {
		name: "ic-database-backup",
		size: 16,
		color: "B500"
	}), /* @__PURE__ */ (0, Q.jsx)(W, {
		content: e.data.backupSource.name,
		children: /* @__PURE__ */ (0, Q.jsx)("span", {
			className: "cn-9 fs-13 fw-4 lh-20 dc__truncate",
			children: e.data.backupSource.name || "-"
		})
	})]
}), DB = ({ row: e }) => /* @__PURE__ */ (0, Q.jsxs)("div", {
	className: "flexbox dc__gap-6 dc__align-items-center",
	children: [!!e.data.schedule.name && /* @__PURE__ */ (0, Q.jsx)(z, {
		name: "ic-job-color",
		size: 16,
		color: "B500"
	}), /* @__PURE__ */ (0, Q.jsx)(W, {
		content: e.data.schedule.name,
		children: /* @__PURE__ */ (0, Q.jsx)("span", {
			className: "cn-9 fs-13 fw-4 lh-20 dc__truncate",
			children: e.data.schedule.name || "-"
		})
	})]
}), OB = ({ row: e }) => /* @__PURE__ */ (0, Q.jsx)("div", {
	className: "flexbox dc__align-items-center",
	children: /* @__PURE__ */ (0, Q.jsx)("span", {
		className: "cn-9 fs-13 fw-4 lh-20 dc__truncate",
		children: e.data.date || "-"
	})
}), kB = ({ row: e }) => e.data.createdBy ? /* @__PURE__ */ (0, Q.jsx)(gu, { identifier: e.data.createdBy }) : /* @__PURE__ */ (0, Q.jsx)("div", {
	className: "flex",
	children: "-"
}), AB = /* @__PURE__ */ function(e) {
	return e.NEW = "New", e.IN_PROGRESS = "InProgress", e.COMPLETED = "Completed", e.PARTIALLY_FAILED = "PartiallyFailed", e.FAILED = "Failed", e.FAILED_VALIDATION = "FailedValidation", e.UNKNOWN = "Unknown", e.INSTALLATION_PENDING = "InstallationPending", e.INSTALLATION_FAILED = "InstallationFailed", e.INSTALLATION_SUCCESS = "InstallationSuccess", e;
}({}), jB = /* @__PURE__ */ function(e) {
	return e.ADD_RESTORE = "addRestore", e;
}({}), MB = {
	[AB.COMPLETED]: "Completed",
	[AB.FAILED]: "Failed",
	[AB.FAILED_VALIDATION]: "Failed Validation",
	[AB.IN_PROGRESS]: "In Progress",
	[AB.NEW]: "New",
	[AB.PARTIALLY_FAILED]: "Partially Failed",
	[AB.UNKNOWN]: "Unknown",
	[AB.INSTALLATION_FAILED]: "Installation Failed",
	[AB.INSTALLATION_PENDING]: "Installation Pending",
	[AB.INSTALLATION_SUCCESS]: "Installation Success"
}, NB = {
	[AB.NEW]: /* @__PURE__ */ (0, Q.jsx)(z, {
		name: "ic-in-progress",
		size: 16,
		color: "O500"
	}),
	[AB.IN_PROGRESS]: /* @__PURE__ */ (0, Q.jsx)(z, {
		name: "ic-in-progress",
		size: 16,
		color: "O500"
	}),
	[AB.COMPLETED]: /* @__PURE__ */ (0, Q.jsx)(z, {
		name: "ic-success",
		size: 16,
		color: "G500"
	}),
	[AB.FAILED]: /* @__PURE__ */ (0, Q.jsx)(z, {
		name: "ic-error",
		size: 16,
		color: "R500"
	}),
	[AB.PARTIALLY_FAILED]: /* @__PURE__ */ (0, Q.jsx)(z, {
		name: "ic-warning-fill",
		size: 16,
		color: "Y500"
	}),
	[AB.FAILED_VALIDATION]: /* @__PURE__ */ (0, Q.jsx)(z, {
		name: "ic-error",
		size: 16,
		color: "R500"
	}),
	[AB.UNKNOWN]: /* @__PURE__ */ (0, Q.jsx)(z, {
		name: "ic-unknown",
		size: 16,
		color: "N500"
	}),
	[AB.INSTALLATION_FAILED]: /* @__PURE__ */ (0, Q.jsx)(z, {
		name: "ic-error",
		size: 16,
		color: "R500"
	}),
	[AB.INSTALLATION_PENDING]: /* @__PURE__ */ (0, Q.jsx)(z, {
		name: "ic-warning-fill",
		size: 16,
		color: "Y500"
	}),
	[AB.INSTALLATION_SUCCESS]: /* @__PURE__ */ (0, Q.jsx)(z, {
		name: "ic-success",
		size: 16,
		color: "G500"
	})
}, PB = {
	name: "name",
	status: "status",
	targetCluster: "targetCluster",
	backupSource: "backupSource",
	schedule: "schedule",
	date: "date",
	createdBy: "createdBy"
}, FB = [
	{
		field: PB.name,
		label: "Restore Name",
		size: { range: {
			startWidth: 334,
			maxWidth: 500,
			minWidth: 100
		} },
		CellComponent: wB,
		isSortable: !0,
		horizontallySticky: !0
	},
	{
		field: PB.status,
		label: "Status",
		size: { range: {
			startWidth: 140,
			maxWidth: 250,
			minWidth: 120
		} },
		CellComponent: TB,
		isSortable: !0
	},
	{
		field: PB.targetCluster,
		label: "Target Cluster",
		size: { range: {
			startWidth: 200,
			maxWidth: 300,
			minWidth: 100
		} },
		isSortable: !0
	},
	{
		field: PB.backupSource,
		label: "Backup Source",
		size: { range: {
			startWidth: 200,
			maxWidth: 300,
			minWidth: 100
		} },
		isSortable: !0,
		CellComponent: EB
	},
	{
		field: PB.schedule,
		label: "Schedule",
		size: { range: {
			startWidth: 200,
			maxWidth: 300,
			minWidth: 100
		} },
		isSortable: !0,
		CellComponent: DB
	},
	{
		field: PB.createdBy,
		label: "Created By",
		size: { range: {
			startWidth: 180,
			maxWidth: 250,
			minWidth: 100
		} },
		isSortable: !0,
		CellComponent: kB
	},
	{
		field: PB.date,
		label: "Date",
		size: { range: {
			startWidth: 180,
			maxWidth: 250,
			minWidth: 100
		} },
		isSortable: !0,
		CellComponent: OB
	}
], IB = {
	status: "status",
	clusterName: "clusterName",
	createdBy: "createdBy"
}, LB = [{
	groupLabel: "Filter By",
	items: [
		{
			id: IB.status,
			label: "Status"
		},
		{
			id: IB.clusterName,
			label: "Cluster Name"
		},
		{
			id: IB.createdBy,
			label: "Created By"
		}
	]
}], RB = Object.entries(MB).map(([e, t]) => ({
	value: e,
	label: t
})), zB = {
	name: "name",
	status: "status",
	targetCluster: "targetClusterName",
	backupSource: "backupName",
	schedule: "scheduleName",
	date: "createdOn",
	createdBy: "createdBy"
}, BB = (e, t) => {
	let n = e.split("?")[0].split("#")[0];
	return { alias: {
		...HF(),
		restores: {
			component: /* @__PURE__ */ (0, Q.jsx)(To, {
				isActive: n === B.DATA_PROTECTION_MANAGEMENT_RESTORES,
				heading: "Restores"
			}),
			linked: n !== B.DATA_PROTECTION_MANAGEMENT_RESTORES
		},
		":restoreId": {
			component: t ? /* @__PURE__ */ (0, Q.jsx)(To, {
				isActive: !0,
				heading: t
			}) : /* @__PURE__ */ (0, Q.jsx)("div", { className: "h-20 w-120 shimmer-loading" }),
			linked: !1
		}
	} };
}, VB = (e) => {
	let t = e.getAll(IB.status), n = e.getAll(IB.clusterName), r = e.getAll(IB.createdBy);
	return {
		status: t.length ? t : void 0,
		clusterName: n.length ? n : void 0,
		createdBy: r.length ? r : void 0
	};
}, HB = (e, t) => {
	let n = e.getAll(IB.status), r = e.getAll(IB.clusterName), i = e.getAll(IB.createdBy), a = (n || []).reduce((e, t) => (e[t] = !0, e), {}), o = (r || []).reduce((e, t) => (e[t] = !0, e), {}), s = (i || []).reduce((e, t) => (e[t] = !0, e), {}), c = n.length && RB.filter((e) => a[e.value]) || null, l = r.length && t?.clusterOptions.filter((e) => o[e.value]) || null, u = i.length && t?.createdByOptions.filter((e) => s[e.value]) || null;
	return {
		areFiltersApplied: !!(n.length || r.length || i.length),
		appliedFilterOptions: {
			status: c,
			clusterName: l,
			createdBy: u
		}
	};
}, UB = (e) => ({
	id: e.id,
	name: e.name || "",
	status: e.status?.phase || AB.UNKNOWN,
	targetCluster: e.targetClusterName || "",
	backupSource: {
		name: e.backupName || "",
		id: e.clusterBackupId
	},
	schedule: {
		name: e.scheduleName || "",
		id: null
	},
	date: Ud(e.createdOn) || "",
	createdBy: e.createdBy
}), WB = /* @__PURE__ */ function(e) {
	return e.NAMESPACE_MAPPING = "namespace-mapping", e.MANIFEST = "manifest", e;
}({}), GB = /* @__PURE__ */ function(e) {
	return e.TAB = "tab", e.SORT_BY = "sortBy", e;
}({}), KB = {
	[WB.NAMESPACE_MAPPING]: "Namespace Mapping",
	[WB.MANIFEST]: "Manifest"
}, qB = [{
	label: KB[WB.NAMESPACE_MAPPING],
	value: WB.NAMESPACE_MAPPING
}, {
	label: KB[WB.MANIFEST],
	value: WB.MANIFEST
}], JB = [{
	field: "sourceNamespace",
	label: "SOURCE NAMESPACE",
	size: { range: {
		startWidth: 250,
		maxWidth: 600,
		minWidth: 100
	} },
	isSortable: !0,
	comparator: df,
	horizontallySticky: !0
}, {
	field: "targetNamespace",
	label: "TARGET NAMESPACE",
	size: { range: {
		startWidth: 250,
		maxWidth: 600,
		minWidth: 120
	} },
	isSortable: !0,
	comparator: df
}], YB = ({ children: e }) => /* @__PURE__ */ (0, Q.jsx)("div", { children: e }), XB = ({ namespaceMapping: e }) => /* @__PURE__ */ (0, Q.jsx)(ru, {
	id: "table__restore-details-namespace-mapping",
	columns: JB,
	rows: e.map((e) => ({
		data: e,
		id: `${e.sourceNamespace}-${e.targetNamespace}`
	})),
	emptyStateConfig: { noRowsConfig: {
		title: "No Mapped Namespaces Found",
		subTitle: "There are no namespace mappings available for this restore."
	} },
	filtersVariant: tc.URL,
	paginationVariant: el.NOT_PAGINATED,
	filter: null,
	additionalFilterProps: { initialSortKey: "sourceNamespace" },
	ViewWrapper: YB
}), ZB = async ({ offset: e, pageSize: t, sortBy: n, searchKey: r, sortOrder: i, signal: a, status: o, createdBy: s, clusterName: c }) => {
	let l = [
		...o?.length ? [{
			key: "status",
			values: o
		}] : [],
		...s?.length ? [{
			key: "createdBy",
			values: s
		}] : [],
		...c?.length ? [{
			key: "clusterName",
			values: c
		}] : []
	], u = {
		offset: e,
		searchByName: r,
		size: t,
		sortOrder: i,
		sortBy: zB[n],
		filters: l.length ? l : null
	}, { result: d } = await nf(O.CLUSTER_BACKUP_RESTORE_LIST, u, { signal: a });
	return {
		totalCount: d.totalCount,
		data: (d.data || []).map(UB)
	};
}, QB = async (e) => {
	let [t, n] = await Promise.all([Rt(e), Zu(e)]);
	return {
		clusterOptions: (n || []).filter((e) => !e.isVirtual).sort((e, t) => df(e.name, t.name)).map((e) => ({
			label: e.name,
			value: e.name
		})),
		createdByOptions: (t || []).filter((e) => !!e.emailId).sort((e, t) => df(e.emailId, t.emailId)).map((e) => ({
			label: e.emailId,
			value: e.emailId
		}))
	};
}, $B = async ({ id: e, signal: t, showToast: n = !0, throwError: r = !1 }) => {
	try {
		return await ff(`${O.CLUSTER_BACKUP_RESTORE}/${e}`, null, { signal: t }), n && H.showToast({
			variant: U.success,
			description: "Restore deleted successfully"
		}), !0;
	} catch (e) {
		if (n && K(e), r) throw e;
		return !1;
	}
}, eV = ({ id: e, name: t, handleSuccess: n, handleClose: r }) => {
	let [i, a] = j(!1);
	return /* @__PURE__ */ (0, Q.jsx)(ns, {
		title: `Are you sure you want to delete '${t}' restore?`,
		variant: rs.delete,
		handleClose: r,
		confirmationConfig: {
			identifier: "delete-restore-dialog-input",
			confirmationKeyword: t
		},
		buttonConfig: {
			primaryButtonConfig: {
				text: "Delete",
				onClick: async () => {
					a(!0), await $B({ id: e }) && (n(), r()), a(!1);
				},
				isLoading: i
			},
			secondaryButtonConfig: {
				text: "Cancel",
				onClick: r
			}
		}
	});
}, tV = ({ restoreDetails: e }) => {
	let t = X(), [n, r] = j(!1), i = () => {
		r(!1);
	}, a = () => {
		r(!0);
	}, o = () => {
		t(B.DATA_PROTECTION_MANAGEMENT_RESTORES);
	}, s = () => n ? /* @__PURE__ */ (0, Q.jsx)(eV, {
		id: e.id,
		name: e.name,
		handleClose: i,
		handleSuccess: o
	}) : null, c = (e, t) => /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox-col dc__gap-4",
		children: [/* @__PURE__ */ (0, Q.jsx)("span", {
			className: "cn-7 fs-13 fw-4 lh-20",
			children: e
		}), typeof t == "string" ? /* @__PURE__ */ (0, Q.jsx)(W, {
			content: t,
			children: /* @__PURE__ */ (0, Q.jsx)("span", {
				className: "cn-9 fs-13 fw-4 lh-20 dc__truncate",
				children: t
			})
		}) : t]
	}), l = (e, t) => /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox dc__content-space dc__gap-12 align-center",
		children: [/* @__PURE__ */ (0, Q.jsx)("span", {
			className: "cn-7 fs-13 fw-4 lh-1-5",
			children: e
		}), t]
	});
	return /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox-col dc__overflow-auto h-100 py-20 px-16 dc__gap-20 border__primary--right",
		children: [
			/* @__PURE__ */ (0, Q.jsx)("div", {
				className: "flexbox-col dc__gap-12",
				children: /* @__PURE__ */ (0, Q.jsx)("h3", {
					className: "m-0 cn-9 font-merriweather fs-16 fw-7 lh-1-5 dc__word-break",
					children: e.name
				})
			}),
			/* @__PURE__ */ (0, Q.jsx)("div", {
				className: "flexbox dc__gap-8",
				children: /* @__PURE__ */ (0, Q.jsx)(M, {
					dataTestId: "delete-backup-location-button",
					startIcon: /* @__PURE__ */ (0, Q.jsx)(z, {
						name: "ic-delete",
						color: null
					}),
					text: "Delete",
					variant: F.secondary,
					style: P.negative,
					size: I.medium,
					onClick: a
				})
			}),
			/* @__PURE__ */ (0, Q.jsx)("div", { className: "divider divider--n1" }),
			/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox-col dc__gap-12",
				children: [
					l("Status", /* @__PURE__ */ (0, Q.jsxs)("div", {
						className: "flexbox align-center dc__gap-6",
						children: [NB[e.status], /* @__PURE__ */ (0, Q.jsx)("span", {
							className: "cn-9 fs-13 fw-4 lh-1-5",
							children: MB[e.status] || e.status
						})]
					})),
					l("Warnings & Errors", /* @__PURE__ */ (0, Q.jsxs)("div", {
						className: "flexbox dc__gap-6 dc__align-items-center",
						children: [
							e.warningCount > 0 && /* @__PURE__ */ (0, Q.jsx)(So, {
								label: `${e.warningCount}`,
								size: I.xxs,
								variant: "warning",
								startIconProps: { name: "ic-warning-stroke" }
							}),
							e.errorCount > 0 && /* @__PURE__ */ (0, Q.jsx)(So, {
								label: `${e.errorCount}`,
								size: I.xxs,
								variant: "negative",
								startIconProps: { name: "ic-error" }
							}),
							e.warningCount === 0 && e.errorCount === 0 && "-"
						]
					})),
					l("Resources", /* @__PURE__ */ (0, Q.jsxs)("span", {
						className: "cn-9 fs-13 fw-4 lh-1-5 dc__truncate",
						children: [
							e.resourceCount,
							"/",
							e.totalResourceCount
						]
					}))
				]
			}),
			/* @__PURE__ */ (0, Q.jsx)("div", { className: "divider divider--n1" }),
			/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox-col dc__gap-12",
				children: [
					c("Target cluster", e.targetCluster),
					c("Created by", e.createdBy),
					c("Restored from backup", e.backupDetails.id ? /* @__PURE__ */ (0, Q.jsx)(Wf, {
						to: Y(B.DATA_PROTECTION_MANAGEMENT_BACKUP_AND_SCHEDULE_DETAIL, {
							view: bo.Backups,
							id: String(e.backupDetails.id)
						}),
						children: e.backupDetails.name || "-"
					}) : "-"),
					c("Duration", e.duration),
					c("Included resources", /* @__PURE__ */ (0, Q.jsx)("span", {
						className: "cn-9 fs-13 fw-4 lh-20 dc__word-break",
						children: e.includeResources.join(", ")
					})),
					c("Excluded resources", /* @__PURE__ */ (0, Q.jsx)("span", {
						className: "cn-9 fs-13 fw-4 lh-20 dc__word-break",
						children: e.excludedResources.join(", ")
					}))
				]
			})
		]
	}), s()] });
}, nV = (e) => !e.manifestGvk || !e.manifestGvk?.gvk || !e.name || !e.targetClusterId || !e.manifestGvk?.veleroNamespace ? null : {
	name: e.name,
	namespace: e.manifestGvk.veleroNamespace,
	clusterId: e.targetClusterId,
	gvk: {
		Group: e.manifestGvk.gvk.Group,
		Version: e.manifestGvk.gvk.Version,
		Kind: e.manifestGvk.gvk.Kind
	}
}, rV = (e) => ({
	id: e.id,
	name: e.name || "",
	status: e.status?.phase || AB.UNKNOWN,
	warningCount: e.status?.warnings || 0,
	errorCount: e.status?.errors || 0,
	resourceCount: e.status?.progress?.itemsRestored || 0,
	totalResourceCount: e.status?.progress?.totalItems || 0,
	targetCluster: e.targetClusterName || "",
	createdBy: e.createdBy || "",
	backupDetails: {
		id: e.clusterBackupId,
		name: e.backupName
	},
	duration: Pd({
		startTime: e.status?.startTimestamp,
		endTime: e.status?.completionTimestamp,
		fallbackString: "-"
	}),
	includeResources: e.includedResources || [],
	excludedResources: e.excludedResources || [],
	namespaceMapping: Object.entries(e.namespaceMapping || {}).map(([e, t]) => ({
		sourceNamespace: e,
		targetNamespace: t
	})),
	manifestPayload: nV(e)
}), iV = async (e, t) => {
	let { result: n } = await G(`${O.CLUSTER_BACKUP_RESTORE}/${e}`, { signal: t });
	return rV(n);
}, aV = async (e, t) => {
	let n = (await Un({
		...e,
		signal: t
	}))?.manifestResponse?.manifest;
	return Tu(n) || "";
}, oV = () => {
	let e = Yf(), t = X(), { searchParams: n } = jf(), { restoreId: r } = Z(), i = n[GB.TAB] || WB.NAMESPACE_MAPPING, { isFetching: a, data: o, error: s, refetch: c } = q({
		queryKey: ["restore-details", r],
		queryFn: ({ signal: e }) => iV(+r, e)
	}), { isFetching: l, data: u, error: d, refetch: f } = q({
		queryKey: [
			"restore-manifest",
			r,
			o,
			i
		],
		queryFn: ({ signal: e }) => aV(o.manifestPayload, e),
		enabled: i === WB.MANIFEST && !!o
	}), { breadcrumbs: p } = gf(B.DATA_PROTECTION_MANAGEMENT_RESTORES_DETAIL, BB(e.pathname, o?.name), [e.pathname, o]);
	return /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox-col dc__content-space flex-grow-1 h-100 dc__overflow-auto",
		children: [/* @__PURE__ */ (0, Q.jsx)(Qc, {
			isBreadcrumbs: !0,
			breadCrumbs: () => /* @__PURE__ */ (0, Q.jsx)(Co, {
				breadcrumbs: p,
				path: B.DATA_PROTECTION_MANAGEMENT_RESTORES_DETAIL
			})
		}), /* @__PURE__ */ (0, Q.jsx)("div", {
			className: "flexbox-col flex-grow-1 dc__overflow-auto",
			children: /* @__PURE__ */ (0, Q.jsx)($a, {
				isLoading: a,
				error: s,
				progressingProps: { pageLoader: !0 },
				errorScreenManagerProps: {
					code: s?.code,
					reload: c,
					redirectURL: B.DATA_PROTECTION_MANAGEMENT_RESTORES
				},
				children: o && /* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "dc__grid restore-details__container dc__overflow-auto flex-grow-1",
					children: [/* @__PURE__ */ (0, Q.jsx)(tV, { restoreDetails: o }), /* @__PURE__ */ (0, Q.jsxs)("div", {
						className: "flexbox-col dc__overflow-auto dc__content-space h-100",
						children: [/* @__PURE__ */ (0, Q.jsx)("div", {
							className: "py-12 px-16 flexbox dc__align-items-center border__secondary--bottom",
							children: /* @__PURE__ */ (0, Q.jsx)(Bl, {
								name: "restore-details-tabs",
								segments: qB,
								onChange: (n) => {
									let r = new URLSearchParams(e.search);
									n.value === WB.NAMESPACE_MAPPING ? r.delete("tab") : r.set("tab", n.value), t({ search: r.toString() }, { replace: !0 });
								},
								value: i
							})
						}), i === WB.MANIFEST ? /* @__PURE__ */ (0, Q.jsx)("div", {
							className: "flex column flex-grow-1",
							children: /* @__PURE__ */ (0, Q.jsx)($a, {
								isLoading: l,
								error: d,
								progressingProps: { pageLoader: !0 },
								genericSectionErrorProps: { reload: f },
								children: /* @__PURE__ */ (0, Q.jsx)(Xo, {
									value: u || "",
									mode: Ic.YAML,
									height: "100%",
									readOnly: !0
								})
							})
						}) : /* @__PURE__ */ (0, Q.jsx)(XB, { namespaceMapping: o.namespaceMapping })]
					})]
				})
			})
		})]
	});
}, sV = () => {
	let e = Yf();
	return /* @__PURE__ */ (0, Q.jsx)(M, {
		dataTestId: "create-restore-button",
		text: "New Restore",
		startIcon: /* @__PURE__ */ (0, Q.jsx)(z, {
			name: "ic-add",
			color: null
		}),
		component: N.link,
		size: I.medium,
		linkProps: { to: (() => {
			let t = new URLSearchParams(e.search);
			return t.set(jB.ADD_RESTORE, "true"), `${e.pathname}?${t.toString()}`;
		})() }
	});
}, cV = () => {
	let e = X(), t = Yf(), { isFetching: n, error: r, data: i, refetch: a } = q({
		queryKey: ["restore-list-grouped-select-metadata"],
		queryFn: ({ signal: e }) => QB(e)
	}), { areFiltersApplied: o, appliedFilterOptions: s } = A(() => HB(new URLSearchParams(t.search), i), [t.search, i]), { clusterOptions: c, createdByOptions: l } = i || {
		clusterOptions: [],
		createdByOptions: []
	}, u = (n) => (r) => {
		let i = new URLSearchParams(t.search);
		i.delete(n), r.forEach((e) => {
			i.append(n, e.value);
		}), e({ search: i.toString() }, { replace: !0 });
	};
	return /* @__PURE__ */ (0, Q.jsx)(pc, {
		id: "restore-list-grouped-filter-select",
		isFilterApplied: o,
		width: 120,
		options: LB,
		filterSelectPickerPropsMap: {
			status: {
				inputId: "restore-list-status-filter",
				placeholder: "Select Status",
				options: RB,
				appliedFilterOptions: s.status,
				handleApplyFilter: u("status"),
				isDisabled: !1,
				isLoading: !1
			},
			clusterName: {
				inputId: "restore-list-cluster-name-filter",
				placeholder: "Select Cluster",
				options: c,
				appliedFilterOptions: s.clusterName,
				handleApplyFilter: u("clusterName"),
				isDisabled: n,
				isLoading: n,
				optionListError: r,
				reloadOptionList: a
			},
			createdBy: {
				inputId: "restore-list-created-by-filter",
				placeholder: "Select User",
				options: l,
				appliedFilterOptions: s.createdBy,
				handleApplyFilter: u("createdBy"),
				isDisabled: n,
				isLoading: n,
				optionListError: r,
				isUserIdentifier: !0,
				reloadOptionList: a
			}
		}
	});
}, lV = ({ children: e, searchKey: t, handleSearch: n, isUnauthorized: r }) => {
	let i = X(), a = Yf(), o = VB(new URLSearchParams(a.search));
	return /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox-col dc__overflow-hidden flex-grow-1",
		children: [!r && /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox-col",
			children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox dc__gap-8 dc__content-space p-16",
				children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "flexbox dc__gap-8 dc__align-items-center",
					children: [/* @__PURE__ */ (0, Q.jsx)(Il, {
						initialSearchText: t,
						handleEnter: n,
						keyboardShortcut: "/"
					}), /* @__PURE__ */ (0, Q.jsx)(cV, {})]
				}), /* @__PURE__ */ (0, Q.jsx)(sV, {})]
			}), /* @__PURE__ */ (0, Q.jsx)(Zs, {
				className: "px-20 pb-16 py-2",
				filterConfig: {
					status: o.status,
					clusterName: o.clusterName,
					createdBy: o.createdBy
				},
				onRemoveFilter: (e) => {
					let t = new URLSearchParams(a.search);
					Object.entries(e).forEach(([e, n]) => {
						n ? Array.isArray(n) ? (t.delete(e), n.forEach((n) => t.append(e, n))) : t.set(e, n) : t.delete(e);
					}), i({ search: t.toString() });
				},
				clearFilters: () => {
					i({ search: "" });
				},
				getFormattedValue: (e, t) => e === IB.status && MB[t] || t
			})]
		}), e]
	});
}, uV = ({ onActionClick: e }) => /* @__PURE__ */ (0, Q.jsx)(M, {
	dataTestId: "bulk-delete-restore-button",
	icon: /* @__PURE__ */ (0, Q.jsx)(z, {
		name: "ic-delete",
		color: null
	}),
	component: N.button,
	style: P.negativeGrey,
	variant: F.borderLess,
	ariaLabel: "Delete Selected Restores",
	size: I.small,
	onClick: e,
	showAriaLabelInTippy: !1,
	"data-key": sF.RESTORE
}), dV = ({ row: e, handleShowDeleteModal: t }) => /* @__PURE__ */ (0, Q.jsx)("div", {
	className: "flex py-8 px-4",
	children: /* @__PURE__ */ (0, Q.jsx)(M, {
		dataTestId: "bulk-delete-restore-button",
		icon: /* @__PURE__ */ (0, Q.jsx)(z, {
			name: "ic-delete",
			color: null
		}),
		component: N.button,
		style: P.negativeGrey,
		variant: F.borderLess,
		ariaLabel: "Delete Selected Restores",
		size: I.small,
		onClick: () => {
			t(e.data);
		},
		showAriaLabelInTippy: !1
	})
}), fV = () => /* @__PURE__ */ (0, Q.jsx)(sV, {}), pV = () => {
	let e = Yf(), t = X(), [n, r] = j(!1), [i, a] = j(null), [o, s] = j(!1), { searchParams: c } = jf(), l = c[jB.ADD_RESTORE] === "true", u = Ka(async ({ sortBy: e, sortOrder: t, searchKey: n, offset: i, pageSize: a, status: o, clusterName: s, createdBy: c }, l) => {
		try {
			r(!1);
			let u = await ZB({
				offset: i,
				pageSize: a,
				sortBy: e,
				sortOrder: t,
				searchKey: n,
				signal: l,
				status: o,
				clusterName: s,
				createdBy: c
			});
			return {
				rows: (u.data || []).map((e) => ({
					id: String(e.id),
					data: e
				})),
				totalRows: u.totalCount || 0
			};
		} catch (e) {
			throw e.code === eo.PERMISSION_DENIED && r(!0), e;
		}
	}, [o]), d = (e) => {
		a(e);
	}, f = () => {
		a(null);
	}, p = () => {
		let n = new URLSearchParams(e.search);
		n.delete(jB.ADD_RESTORE), t({
			pathname: e.pathname,
			search: n.toString()
		}, { replace: !0 });
	}, m = () => {
		s((e) => !e);
	};
	return /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsx)(ru, {
		id: "table__restore-list",
		columns: FB,
		emptyStateConfig: {
			noRowsConfig: {
				imgName: "img-no-restores",
				title: "Restore a backup",
				subTitle: "Restore a previously saved backup to a target cluster",
				isButtonAvailable: !0,
				renderButton: fV
			},
			noRowsForFilterConfig: {
				title: "No results",
				subTitle: "We couldn't find any matching results"
			}
		},
		paginationVariant: el.PAGINATED,
		additionalFilterProps: {
			initialSortKey: PB.name,
			parseSearchParams: VB
		},
		bulkSelectionConfig: {
			BulkActionsComponent: uV,
			bulkActionsData: null,
			BulkOperationModal: dF,
			bulkOperationModalData: {
				handleDelete: async (e, t) => {
					t === "*" ? H.showToast({
						variant: U.error,
						description: "Coming Soon! Bulk delete of restores is not supported yet."
					}) : await $B({
						id: t,
						signal: e.signal,
						showToast: !1,
						throwError: !0
					});
				},
				reloadDataAfterBulkOperation: m
			},
			getSelectAllDialogStatus: () => Vl.CLOSED
		},
		getRows: u,
		filtersVariant: tc.URL,
		ViewWrapper: lV,
		additionalProps: {
			isUnauthorized: n,
			handleShowDeleteModal: d
		},
		filter: null,
		rowActionOnHoverConfig: {
			width: 32,
			Component: dV
		}
	}, `restore-list-table-${+o}`), i ? /* @__PURE__ */ (0, Q.jsx)(eV, {
		id: i.id,
		name: i.name,
		handleClose: f,
		handleSuccess: m
	}) : l ? /* @__PURE__ */ (0, Q.jsx)(kI, {
		handleClose: p,
		onSuccess: m
	}) : null] });
}, mV = () => {
	let e = Yf(), { breadcrumbs: t } = gf(B.DATA_PROTECTION_MANAGEMENT_RESTORES, BB(e.pathname), [e.pathname]);
	return /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox-col dc__content-space flex-grow-1 h-100 dc__overflow-auto",
		children: [/* @__PURE__ */ (0, Q.jsx)(Qc, {
			isBreadcrumbs: !0,
			breadCrumbs: () => /* @__PURE__ */ (0, Q.jsx)(Co, {
				breadcrumbs: t,
				path: B.DATA_PROTECTION_MANAGEMENT_RESTORES
			})
		}), /* @__PURE__ */ (0, Q.jsx)("div", {
			className: "flexbox-col flex-grow-1 dc__overflow-auto",
			children: /* @__PURE__ */ (0, Q.jsx)(pV, {})
		})]
	});
}, hV = vo.DATA_PROTECTION_MANAGEMENT.RESTORES, gV = () => /* @__PURE__ */ (0, Q.jsxs)(qf, { children: [/* @__PURE__ */ (0, Q.jsx)(J, {
	index: !0,
	element: /* @__PURE__ */ (0, Q.jsx)(mV, {})
}), /* @__PURE__ */ (0, Q.jsx)(J, {
	path: hV.DETAIL,
	element: /* @__PURE__ */ (0, Q.jsx)(oV, {})
}, hV.DETAIL)] }), _V = vo.DATA_PROTECTION_MANAGEMENT, vV = () => /* @__PURE__ */ (0, Q.jsxs)(qf, { children: [
	/* @__PURE__ */ (0, Q.jsx)(J, {
		path: _V.OVERVIEW,
		element: /* @__PURE__ */ (0, Q.jsx)(CB, {})
	}, _V.OVERVIEW),
	/* @__PURE__ */ (0, Q.jsx)(J, {
		path: `${_V.BACKUP_AND_SCHEDULE.ROOT}/*`,
		element: /* @__PURE__ */ (0, Q.jsx)(TR, {})
	}, _V.BACKUP_AND_SCHEDULE.ROOT),
	/* @__PURE__ */ (0, Q.jsx)(J, {
		path: `${_V.RESTORES.ROOT}/*`,
		element: /* @__PURE__ */ (0, Q.jsx)(gV, {})
	}, _V.RESTORES.ROOT),
	/* @__PURE__ */ (0, Q.jsx)(J, {
		path: `${_V.BACKUP_LOCATIONS.ROOT}/*`,
		element: /* @__PURE__ */ (0, Q.jsx)($z, {})
	}, _V.BACKUP_LOCATIONS.ROOT),
	/* @__PURE__ */ (0, Q.jsx)(J, {
		path: "*",
		element: /* @__PURE__ */ (0, Q.jsx)(Kf, { to: _V.OVERVIEW })
	})
] }), yV = {
	id: "user-groups",
	title: "User Groups",
	dataTestId: "authorization-user-groups-link",
	href: `${vo.GLOBAL_CONFIG.AUTH.ROOT}/${vo.GLOBAL_CONFIG.AUTH.USER_GROUPS}`
}, bV = "devtronIDB", xV = 1, SV = "autoscalerProfiles", CV = null, wV = () => CV ? Promise.resolve(CV) : new Promise((e, t) => {
	let n = indexedDB.open(bV, xV);
	n.onupgradeneeded = (e) => {
		let t = e.target.result;
		t.objectStoreNames.contains(SV) && t.deleteObjectStore(SV), t.createObjectStore(SV, {
			keyPath: "id",
			autoIncrement: !0
		});
	}, n.onsuccess = () => {
		CV = n.result, CV.onversionchange = () => {
			CV?.close(), CV = null;
		}, CV.onclose = () => {
			CV = null;
		}, e(CV);
	}, n.onerror = () => t(n.error);
}), TV = async (e) => {
	let t = await wV(), n = {
		...e,
		attachedClusters: [],
		createdAt: (/* @__PURE__ */ new Date()).toISOString()
	};
	return new Promise((e, r) => {
		let i = t.transaction(SV, "readwrite").objectStore(SV).add(n);
		i.onsuccess = () => e({
			...n,
			id: i.result
		}), i.onerror = () => r(i.error);
	});
}, EV = async (e) => {
	let t = await wV();
	return new Promise((n, r) => {
		let i = t.transaction(SV, "readonly").objectStore(SV).get(e);
		i.onsuccess = () => {
			if (!i.result) {
				r(/* @__PURE__ */ Error(`Autoscaler profile "${e}" not found`));
				return;
			}
			n(i.result);
		}, i.onerror = () => r(i.error);
	});
}, DV = async (e, t) => {
	let n = await wV();
	return new Promise((r, i) => {
		let a = n.transaction(SV, "readwrite").objectStore(SV), o = a.get(e);
		o.onsuccess = () => {
			let n = o.result;
			if (!n) {
				i(/* @__PURE__ */ Error(`Autoscaler profile "${e}" not found`));
				return;
			}
			let s = {
				...n,
				...t,
				id: e
			}, c = a.put(s);
			c.onsuccess = () => r(s), c.onerror = () => i(c.error);
		}, o.onerror = () => i(o.error);
	});
}, OV = async (e) => {
	let t = await wV();
	return new Promise((n, r) => {
		let i = t.transaction(SV, "readwrite").objectStore(SV).delete(e);
		i.onsuccess = () => n(), i.onerror = () => r(i.error);
	});
}, kV = async () => {
	let e = await wV();
	return new Promise((t, n) => {
		let r = e.transaction(SV, "readonly").objectStore(SV).getAll();
		r.onsuccess = () => t(r.result), r.onerror = () => n(r.error);
	});
}, AV = async (e, t) => {
	let n = await wV();
	return new Promise((r, i) => {
		let a = n.transaction(SV, "readwrite"), o = a.objectStore(SV);
		a.oncomplete = () => r(), a.onerror = () => i(a.error);
		let s = o.getAll();
		s.onsuccess = () => {
			let n = s.result, r = n.find((t) => t.id === e);
			if (!r) {
				i(/* @__PURE__ */ Error(`Autoscaler profile "${e}" not found`)), a.abort();
				return;
			}
			let c = n.find((n) => n.id !== e && n.attachedClusters.includes(t));
			c && o.put({
				...c,
				attachedClusters: c.attachedClusters.filter((e) => e !== t)
			}), r.attachedClusters.includes(t) || o.put({
				...r,
				attachedClusters: [...r.attachedClusters, t]
			});
		}, s.onerror = () => i(s.error);
	});
}, jV = async (e) => {
	let t = (await kV()).find((t) => t.attachedClusters.includes(e));
	return {
		label: t.name,
		value: t.id
	};
}, MV = async () => {
	let e = await kV(), t = {};
	return e.forEach(({ attachedClusters: e, name: n }) => {
		e.forEach((e) => {
			t[e] = n;
		});
	}), t;
}, NV = ({ autoscalerProfile: e, setAutoscalerProfile: t }) => {
	let { isFetching: n, error: r, refetch: i, data: a } = q({
		queryKey: ["autoscaler-profiles"],
		queryFn: () => kV(),
		select: (e) => (e ?? []).map(({ name: e, id: t, description: n = "" }) => ({
			label: e,
			value: t,
			description: n
		}))
	});
	return /* @__PURE__ */ (0, Q.jsx)(V, {
		inputId: "select-autoscaler-profile",
		options: a,
		isLoading: n,
		optionListError: r,
		reloadOptionList: i,
		label: "Autoscaler Profile",
		value: e,
		onChange: t
	});
}, PV = [
	"default (On-Demand)",
	"gpu-nodeclass",
	"arm-nodeclass",
	"spot-nodeclass"
], FV = [
	"c",
	"m",
	"r",
	"t",
	"g",
	"p",
	"inf",
	"x",
	"i"
], IV = [
	"small",
	"medium",
	"large",
	"xlarge",
	"2xlarge",
	"4xlarge",
	"8xlarge",
	"12xlarge",
	"16xlarge"
], LV = [
	{
		id: "basic",
		label: "Basic",
		hint: "Name, class, weight",
		iconName: "ic-info-outline",
		errorKeys: [
			"name",
			"nodeClassRef",
			"weight"
		]
	},
	{
		id: "requirements",
		label: "Node Requirements",
		hint: "Capacity, arch, instance types",
		iconName: "ic-monitoring",
		errorKeys: ["requirements"]
	},
	{
		id: "limits",
		label: "Resource Limits",
		hint: "CPU & memory caps",
		iconName: "ic-activity",
		errorKeys: ["limits"]
	},
	{
		id: "disruption",
		label: "Disruption",
		hint: "Consolidation, budgets",
		iconName: "ic-clock",
		errorKeys: []
	},
	{
		id: "labels",
		label: "Labels & Taints",
		hint: "Node metadata",
		iconName: "ic-tag",
		errorKeys: []
	}
], RV = {
	name: "",
	description: "",
	nodeClassRef: "default",
	weight: 10,
	requirements: {
		capacityTypes: ["On-Demand"],
		architectures: ["amd64"],
		instanceCategories: ["c", "m"],
		instanceSizes: [
			"medium",
			"large",
			"xlarge",
			"2xlarge"
		],
		availabilityZones: ""
	},
	limits: {
		cpu: 500,
		memory: 2e3
	},
	disruption: {
		consolidationPolicy: "WhenEmptyOrUnderutilized",
		consolidateAfter: "30s",
		expireAfter: "720h",
		budgets: []
	},
	labels: [],
	taints: []
}, zV = {
	name: {
		required: !0,
		custom: {
			isValid: (e) => /^[a-z0-9-]*$/.test(e),
			message: "Only lowercase letters, numbers, and hyphens"
		}
	},
	weight: {
		required: !0,
		custom: {
			isValid: (e) => e > 0 && e <= 100,
			message: "Must be between 1 and 100"
		}
	},
	nodeClassRef: { required: !0 },
	requirements: { custom: [
		{
			isValid: (e) => e?.capacityTypes?.length > 0,
			message: "Select at least one capacity type"
		},
		{
			isValid: (e) => e?.architectures?.length > 0,
			message: "Select at least one architecture"
		},
		{
			isValid: (e) => e?.instanceCategories?.length > 0,
			message: "Select at least one instance category"
		}
	] },
	limits: { custom: [{
		isValid: (e) => e?.cpu > 0,
		message: "CPU must be greater than 0"
	}, {
		isValid: (e) => e?.memory > 0,
		message: "Memory must be greater than 0"
	}] }
}, BV = [
	{
		value: "WhenEmptyOrUnderutilized",
		desc: "Remove empty or underutilised nodes"
	},
	{
		value: "WhenEmpty",
		desc: "Only remove completely empty nodes"
	},
	{
		value: "None",
		desc: "Disable consolidation entirely"
	}
], VV = (e) => ({
	name: e.name,
	description: e.description,
	nodeClassRef: e.nodeClassRef,
	weight: e.weight,
	requirements: e.requirements,
	limits: e.limits,
	disruption: e.disruption,
	labels: e.labels,
	taints: e.taints
});
function HV(e, t) {
	return e.includes(t) ? e.filter((e) => e !== t) : [...e, t];
}
//#endregion
//#region src/Pages-Devtron-2.0/GlobalConfiguration/NodeAutoscaler/ProfileForm/BasicSection.tsx
var UV = ({ data: e, errors: t, register: n, setValue: r, isEdit: i }) => /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [
	/* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox dc__gap-8 dc__align-items-center cn-9 fs-13 fw-6",
		children: [
			/* @__PURE__ */ (0, Q.jsx)(z, {
				name: "ic-info-outline",
				color: null
			}),
			"Basic",
			/* @__PURE__ */ (0, Q.jsx)("code", {
				className: "fs-11 cn-7 fw-4 bcn-1 br-3 pl-5 pr-5",
				children: "metadata.name"
			})
		]
	}),
	/* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flex top dc__gap-16",
		children: [/* @__PURE__ */ (0, Q.jsx)(os, {
			name: "profile-name",
			label: "Profile Name",
			placeholder: "e.g. prod-general",
			value: e.name,
			onChange: n("name").onChange,
			error: t.name,
			disabled: i,
			required: !0,
			fullWidth: !0
		}), /* @__PURE__ */ (0, Q.jsx)(V, {
			inputId: "node-class-ref",
			label: "Node Class Ref - EC2NodeClass",
			options: PV.map((e) => ({
				label: e,
				value: e
			})),
			value: {
				label: e.nodeClassRef,
				value: e.nodeClassRef
			},
			onChange: (e) => {
				r("nodeClassRef", e.value, { triggerError: !0 });
			},
			error: t.nodeClassRef?.[0],
			required: !0,
			shouldMenuAlignRight: !0,
			fullWidth: !0
		})]
	}),
	/* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flex top dc__gap-16",
		children: [/* @__PURE__ */ (0, Q.jsx)(os, {
			name: "profile-description",
			label: "Description",
			placeholder: "Brief description of this profile's purpose",
			value: e.description,
			onChange: n("description").onChange,
			fullWidth: !0
		}), /* @__PURE__ */ (0, Q.jsx)(os, {
			name: "profile-weight",
			label: "Scheduling Weight",
			placeholder: "1–100",
			value: String(e.weight),
			onChange: (e) => {
				r("weight", Number(e.target.value), { triggerError: !0 });
			},
			helperText: "Range: 1–100",
			error: t.weight,
			fullWidth: !0
		})]
	}),
	/* @__PURE__ */ (0, Q.jsx)(xc, {
		description: "Higher weight makes this NodePool preferred when multiple pools match a pod's\n                    requirements.",
		size: I.medium,
		variant: Sc.NEUTRAL
	})
] }), WV = ({ disruption: e, updateDisruption: t }) => {
	let n = (e) => {
		t({ consolidationPolicy: e.target.value });
	}, r = (e) => {
		t({ consolidateAfter: e.target.value });
	}, i = (e) => {
		t({ expireAfter: e.target.value });
	}, a = (n) => (r) => {
		let i = [...e.budgets];
		i[n] = {
			...i[n],
			nodes: r.target.value
		}, t({ budgets: i });
	}, o = (n) => (r) => {
		let i = [...e.budgets];
		i[n] = {
			...i[n],
			schedule: r.target.value || void 0
		}, t({ budgets: i });
	}, s = (n) => (r) => {
		let i = [...e.budgets];
		i[n] = {
			...i[n],
			duration: r.target.value || void 0
		}, t({ budgets: i });
	}, c = (n) => () => {
		t({ budgets: e.budgets.filter((e, t) => t !== n) });
	};
	return /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [
		/* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox dc__gap-8 dc__align-items-center cn-9 fs-13 fw-6",
			children: [
				/* @__PURE__ */ (0, Q.jsx)(z, {
					name: "ic-clock",
					color: null
				}),
				"Disruption",
				/* @__PURE__ */ (0, Q.jsx)("code", {
					className: "fs-11 cn-7 fw-4 bcn-1 br-3 pl-5 pr-5",
					children: "spec.disruption"
				})
			]
		}),
		/* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox-col dc__gap-8",
			children: [/* @__PURE__ */ (0, Q.jsxs)("span", {
				className: "fs-13 fw-4 lh-20 cn-7",
				children: ["Consolidation Policy ", /* @__PURE__ */ (0, Q.jsx)("span", {
					className: "cr-5",
					children: "*"
				})]
			}), /* @__PURE__ */ (0, Q.jsx)(vl, {
				className: "flexbox dc__gap-12 dc__wrap-wrap",
				value: e.consolidationPolicy,
				name: "consolidation-policy",
				onChange: n,
				children: BV.map((e) => /* @__PURE__ */ (0, Q.jsx)(yl, {
					value: e.value,
					dataTestId: `consolidation-policy-${e.value}`,
					children: /* @__PURE__ */ (0, Q.jsxs)("div", {
						className: "flexbox-col dc__gap-2",
						children: [/* @__PURE__ */ (0, Q.jsx)("span", {
							className: "fs-13 fw-6 cn-9",
							children: e.value
						}), /* @__PURE__ */ (0, Q.jsx)("span", {
							className: "fs-12 cn-7",
							children: e.desc
						})]
					})
				}, e.value))
			})]
		}),
		/* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flex top dc__gap-16",
			children: [/* @__PURE__ */ (0, Q.jsx)(os, {
				name: "consolidate-after",
				label: "Consolidate After",
				placeholder: "30s",
				value: e.consolidateAfter,
				onChange: r,
				disabled: e.consolidationPolicy === "None",
				helperText: "e.g. 30s, 5m",
				fullWidth: !0
			}), /* @__PURE__ */ (0, Q.jsx)(os, {
				name: "expire-after",
				label: "Expire After",
				placeholder: "720h",
				value: e.expireAfter,
				onChange: i,
				helperText: "Max node lifetime, e.g. 720h",
				fullWidth: !0
			})]
		}),
		/* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox-col dc__gap-8",
			children: [
				/* @__PURE__ */ (0, Q.jsxs)("span", {
					className: "fs-13 fw-4 lh-20 cn-7",
					children: ["Disruption Budgets", /* @__PURE__ */ (0, Q.jsx)("span", {
						className: "fw-4",
						children: " — max nodes disrupted simultaneously"
					})]
				}),
				/* @__PURE__ */ (0, Q.jsx)("div", {
					className: "flexbox-col dc__gap-8",
					children: e.budgets.map((e, t) => /* @__PURE__ */ (0, Q.jsxs)("div", {
						className: "flex top dc__gap-8 dc__align-items-end",
						children: [
							/* @__PURE__ */ (0, Q.jsx)(os, {
								name: `budget-nodes-${t}`,
								label: "Nodes",
								placeholder: "10% or 5",
								value: e.nodes,
								onChange: a(t),
								fullWidth: !0
							}),
							/* @__PURE__ */ (0, Q.jsx)(os, {
								name: `budget-schedule-${t}`,
								label: "Schedule (cron, optional)",
								placeholder: "0 9-17 * * mon-fri",
								value: e.schedule ?? "",
								onChange: o(t),
								fullWidth: !0
							}),
							/* @__PURE__ */ (0, Q.jsx)(os, {
								name: `budget-duration-${t}`,
								label: "Duration",
								placeholder: "8h",
								value: e.duration ?? "",
								onChange: s(t),
								fullWidth: !0
							}),
							/* @__PURE__ */ (0, Q.jsx)("div", {
								className: "mb-6 dc__no-shrink",
								children: /* @__PURE__ */ (0, Q.jsx)(M, {
									dataTestId: `remove-budget-${t}`,
									icon: /* @__PURE__ */ (0, Q.jsx)(z, {
										name: "ic-close-small",
										color: null
									}),
									ariaLabel: "Remove budget",
									variant: F.borderLess,
									style: P.negativeGrey,
									onClick: c(t),
									size: I.xs
								})
							})
						]
					}, t))
				}),
				/* @__PURE__ */ (0, Q.jsx)(M, {
					dataTestId: "add-budget",
					text: "Add Budget",
					startIcon: /* @__PURE__ */ (0, Q.jsx)(z, {
						name: "ic-add",
						color: null
					}),
					variant: F.text,
					style: P.neutral,
					onClick: () => {
						t({ budgets: [...e.budgets, { nodes: "10%" }] });
					}
				})
			]
		})
	] });
}, GV = ({ labels: e, taints: t, setValue: n }) => {
	let r = (t) => (r) => {
		let i = [...e];
		i[t] = {
			...i[t],
			key: r.target.value
		}, n("labels", i);
	}, i = (t) => (r) => {
		let i = [...e];
		i[t] = {
			...i[t],
			value: r.target.value
		}, n("labels", i);
	}, a = (t) => () => {
		n("labels", e.filter((e, n) => n !== t));
	}, o = () => {
		n("labels", [...e, {
			key: "",
			value: ""
		}]);
	}, s = (e) => (r) => {
		let [i, ...a] = r.target.value.split("="), o = [...t];
		o[e] = {
			...o[e],
			key: i ?? "",
			value: a.join("=") || void 0
		}, n("taints", o);
	}, c = (e) => (r) => {
		let i = [...t];
		i[e] = {
			...i[e],
			effect: r.value
		}, n("taints", i);
	}, l = (e) => () => {
		n("taints", t.filter((t, n) => n !== e));
	};
	return /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [
		/* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox dc__gap-8 dc__align-items-center cn-9 fs-13 fw-6",
			children: [
				/* @__PURE__ */ (0, Q.jsx)(z, {
					name: "ic-tag",
					color: null
				}),
				"Labels & Taints",
				/* @__PURE__ */ (0, Q.jsx)("code", {
					className: "fs-11 cn-7 fw-4 bcn-1 br-3 pl-5 pr-5",
					children: "spec.template.metadata"
				})
			]
		}),
		/* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox-col dc__gap-8",
			children: [
				/* @__PURE__ */ (0, Q.jsx)("span", {
					className: "fs-13 fw-4 lh-20 cn-7",
					children: "Node Labels (optional)"
				}),
				/* @__PURE__ */ (0, Q.jsx)("div", {
					className: "flexbox-col dc__gap-8",
					children: e.map((e, t) => /* @__PURE__ */ (0, Q.jsxs)("div", {
						className: "flex top dc__gap-8 dc__align-items-end",
						children: [
							/* @__PURE__ */ (0, Q.jsx)(os, {
								name: `label-key-${t}`,
								label: "Key",
								placeholder: "key",
								value: e.key,
								onChange: r(t),
								fullWidth: !0
							}),
							/* @__PURE__ */ (0, Q.jsx)("span", {
								className: "fs-14 cn-7",
								children: "="
							}),
							/* @__PURE__ */ (0, Q.jsx)(os, {
								name: `label-value-${t}`,
								label: "Value",
								placeholder: "value",
								value: e.value,
								onChange: i(t),
								fullWidth: !0
							}),
							/* @__PURE__ */ (0, Q.jsx)("div", {
								className: "mb-6 dc__no-shrink",
								children: /* @__PURE__ */ (0, Q.jsx)(M, {
									dataTestId: `remove-label-${t}`,
									icon: /* @__PURE__ */ (0, Q.jsx)(z, {
										name: "ic-close-small",
										color: null
									}),
									ariaLabel: "Remove label",
									variant: F.borderLess,
									style: P.negativeGrey,
									onClick: a(t),
									size: I.xs
								})
							})
						]
					}, t))
				}),
				/* @__PURE__ */ (0, Q.jsx)(M, {
					dataTestId: "add-label",
					text: "Add Label",
					startIcon: /* @__PURE__ */ (0, Q.jsx)(z, {
						name: "ic-add",
						color: null
					}),
					variant: F.text,
					style: P.neutral,
					onClick: o
				})
			]
		}),
		/* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox-col dc__gap-8 border__secondary--top pt-8",
			children: [
				/* @__PURE__ */ (0, Q.jsx)("span", {
					className: "fs-13 fw-4 lh-20 cn-7",
					children: "Node Taints (optional)"
				}),
				/* @__PURE__ */ (0, Q.jsx)("div", {
					className: "flexbox-col dc__gap-8",
					children: t.map((e, t) => /* @__PURE__ */ (0, Q.jsxs)("div", {
						className: "flex dc__gap-8 dc__align-items-end",
						children: [
							/* @__PURE__ */ (0, Q.jsx)(os, {
								name: `taint-kv-${t}`,
								label: "Key / Value",
								placeholder: "key=value",
								value: e.value ? `${e.key}=${e.value}` : e.key,
								onChange: s(t),
								fullWidth: !0
							}),
							/* @__PURE__ */ (0, Q.jsx)(V, {
								inputId: "tolerance_effect_select",
								label: "Effect",
								options: Sn,
								onChange: c(t),
								value: {
									label: e.effect,
									value: e.effect
								},
								shouldMenuAlignRight: !0,
								fullWidth: !0
							}),
							/* @__PURE__ */ (0, Q.jsx)("div", {
								className: "mb-6 dc__no-shrink",
								children: /* @__PURE__ */ (0, Q.jsx)(M, {
									dataTestId: `remove-taint-${t}`,
									icon: /* @__PURE__ */ (0, Q.jsx)(z, {
										name: "ic-close-small",
										color: null
									}),
									ariaLabel: "Remove taint",
									variant: F.borderLess,
									style: P.negativeGrey,
									onClick: l(t),
									size: I.xs
								})
							})
						]
					}, t))
				}),
				/* @__PURE__ */ (0, Q.jsx)(M, {
					dataTestId: "add-taint",
					text: "Add Taint",
					startIcon: /* @__PURE__ */ (0, Q.jsx)(z, {
						name: "ic-add",
						color: null
					}),
					variant: F.text,
					style: P.neutral,
					onClick: () => {
						n("taints", [...t, {
							key: "",
							effect: Eo.NO_SCHEDULE
						}]);
					}
				})
			]
		})
	] });
}, KV = ({ requirements: e, updateRequirements: t, errors: n }) => {
	let r = (n) => () => {
		t({ capacityTypes: HV(e.capacityTypes, n) });
	}, i = (n) => () => {
		t({ architectures: HV(e.architectures, n) });
	}, a = (n) => () => {
		t({ instanceCategories: HV(e.instanceCategories, n) });
	}, o = (n) => () => {
		t({ instanceSizes: HV(e.instanceSizes, n) });
	};
	return /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [
		/* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox dc__gap-8 dc__align-items-center cn-9 fs-13 fw-6",
			children: [
				/* @__PURE__ */ (0, Q.jsx)(z, {
					name: "ic-cpu",
					color: null
				}),
				"Node Requirements",
				/* @__PURE__ */ (0, Q.jsx)("code", {
					className: "fs-11 cn-7 fw-4 bcn-1 br-3 pl-5 pr-5",
					children: "spec.template.spec.requirements"
				})
			]
		}),
		/* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flex top dc__gap-16",
			children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox-col dc__gap-8 flex-grow-1",
				children: [
					/* @__PURE__ */ (0, Q.jsxs)("span", {
						className: "fs-13 fw-4 lh-20 cn-7",
						children: ["Capacity Type ", /* @__PURE__ */ (0, Q.jsx)("span", {
							className: "cr-5",
							children: "*"
						})]
					}),
					/* @__PURE__ */ (0, Q.jsx)("div", {
						className: "flexbox dc__gap-16",
						children: ["Spot", "On-Demand"].map((t) => /* @__PURE__ */ (0, Q.jsx)(Wo, {
							isChecked: e.capacityTypes.includes(t),
							value: Io.CHECKED,
							onChange: r(t),
							dataTestId: `capacity-type-${t}`,
							children: t
						}, t))
					}),
					n.requirements?.includes("Select at least one capacity type") && /* @__PURE__ */ (0, Q.jsx)("span", {
						className: "fs-11 cr-5",
						children: "Select at least one capacity type"
					})
				]
			}), /* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox-col dc__gap-8 flex-grow-1",
				children: [
					/* @__PURE__ */ (0, Q.jsx)("span", {
						className: "fs-13 fw-4 lh-20 cn-7",
						children: "Architecture"
					}),
					/* @__PURE__ */ (0, Q.jsx)("div", {
						className: "flexbox dc__gap-16",
						children: ["amd64", "arm64"].map((t) => /* @__PURE__ */ (0, Q.jsx)(Wo, {
							isChecked: e.architectures.includes(t),
							value: Io.CHECKED,
							onChange: i(t),
							dataTestId: `architecture-${t}`,
							children: t
						}, t))
					}),
					n.requirements?.includes("Select at least one architecture") && /* @__PURE__ */ (0, Q.jsx)("span", {
						className: "fs-11 cr-5",
						children: "Select at least one architecture"
					})
				]
			})]
		}),
		/* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox-col dc__gap-8",
			children: [
				/* @__PURE__ */ (0, Q.jsxs)("span", {
					className: "fs-13 fw-4 lh-20 cn-7",
					children: [
						"Instance Categories ",
						/* @__PURE__ */ (0, Q.jsx)("span", {
							className: "cr-5",
							children: "*"
						}),
						/* @__PURE__ */ (0, Q.jsx)("span", {
							className: "fw-4",
							children: " — karpenter.k8s.aws/instance-category"
						})
					]
				}),
				/* @__PURE__ */ (0, Q.jsx)("div", {
					className: "flexbox dc__gap-12 dc__wrap-wrap",
					children: FV.map((t) => /* @__PURE__ */ (0, Q.jsx)(Wo, {
						isChecked: e.instanceCategories.includes(t),
						value: Io.CHECKED,
						onChange: a(t),
						dataTestId: `instance-category-${t}`,
						children: t
					}, t))
				}),
				n.requirements?.includes("Select at least one instance category") && /* @__PURE__ */ (0, Q.jsx)("span", {
					className: "fs-11 cr-5",
					children: "Select at least one instance category"
				})
			]
		}),
		/* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox-col dc__gap-8",
			children: [/* @__PURE__ */ (0, Q.jsxs)("span", {
				className: "fs-13 fw-4 lh-20 cn-7",
				children: ["Instance Sizes", /* @__PURE__ */ (0, Q.jsx)("span", {
					className: "fw-4",
					children: " — karpenter.k8s.aws/instance-size"
				})]
			}), /* @__PURE__ */ (0, Q.jsx)("div", {
				className: "flexbox dc__gap-12 dc__wrap-wrap",
				children: IV.map((t) => /* @__PURE__ */ (0, Q.jsx)(Wo, {
					isChecked: e.instanceSizes.includes(t),
					value: Io.CHECKED,
					onChange: o(t),
					dataTestId: `instance-size-${t}`,
					children: t
				}, t))
			})]
		}),
		/* @__PURE__ */ (0, Q.jsx)(os, {
			name: "availability-zones",
			label: "Availability Zones",
			placeholder: "e.g. us-east-1a, us-east-1b  (leave blank for all zones)",
			value: e.availabilityZones,
			onChange: (e) => {
				t({ availabilityZones: e.target.value });
			},
			helperText: "Optional — comma-separated",
			fullWidth: !0
		})
	] });
}, qV = ({ limits: e, updateLimits: t, errors: n }) => /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [
	/* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox dc__gap-8 dc__align-items-center cn-9 fs-13 fw-6",
		children: [
			/* @__PURE__ */ (0, Q.jsx)(z, {
				name: "ic-activity",
				color: null
			}),
			"Resource Limits",
			/* @__PURE__ */ (0, Q.jsx)("code", {
				className: "fs-11 cn-7 fw-4 bcn-1 br-3 pl-5 pr-5",
				children: "spec.limits"
			})
		]
	}),
	/* @__PURE__ */ (0, Q.jsx)(xc, {
		description: "Karpenter stops provisioning new nodes once the NodePool's total provisioned\n                    resources exceed these limits.",
		size: I.medium,
		variant: Sc.NEUTRAL
	}),
	/* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flex top dc__gap-16",
		children: [/* @__PURE__ */ (0, Q.jsx)(os, {
			name: "limits-cpu",
			label: "Max CPU",
			type: "number",
			placeholder: "500",
			value: String(e.cpu),
			onChange: (e) => {
				t({ cpu: Number(e.target.value) });
			},
			error: n.limits?.includes("CPU must be greater than 0") ? ["CPU must be greater than 0"] : void 0,
			helperText: "Total cores across all nodes",
			fullWidth: !0
		}), /* @__PURE__ */ (0, Q.jsx)(os, {
			name: "limits-memory",
			label: "Max Memory (GiB)",
			type: "number",
			placeholder: "2000",
			value: String(e.memory),
			onChange: (e) => {
				t({ memory: Number(e.target.value) });
			},
			error: n.limits,
			helperText: "Total GiB across all nodes",
			fullWidth: !0
		})]
	})
] }), JV = ({ initialValues: e, isEdit: t, handleClose: n }) => {
	let { profileId: r } = Z(), [i, a] = j(LV[0].id), { data: o, errors: s, register: c, handleSubmit: l, setValue: u } = xf({
		initialValues: e,
		validationMode: "all",
		validations: zV
	}), d = (e) => {
		u("requirements", {
			...o.requirements,
			...e
		}, { triggerError: !0 });
	}, f = (e) => {
		u("limits", {
			...o.limits,
			...e
		}, { triggerError: !0 });
	}, p = (e) => {
		u("disruption", {
			...o.disruption,
			...e
		});
	}, m = l(async (e) => {
		await (t ? DV(+r, e) : TV(e)), n();
	}, (e) => {
		H.showToast({
			variant: U.error,
			description: "Please resolve errors before submitting"
		}), LV.forEach((t) => {
			t.errorKeys.some((t) => (e[t]?.length ?? 0) > 0) && a(t.id);
		});
	}), h = (e) => e.some((e) => (s[e]?.length ?? 0) > 0), g = (e) => () => {
		a(e);
	};
	return /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox flex-grow-1 dc__overflow-hidden",
		children: [/* @__PURE__ */ (0, Q.jsx)("nav", {
			className: "flexbox-col dc__gap-2 py-12 px-8 dc__border-right-n1 dc__no-shrink dc__overflow-auto w-240",
			children: LV.map(({ id: e, label: t, hint: n, iconName: r, errorKeys: a }) => /* @__PURE__ */ (0, Q.jsxs)("button", {
				type: "button",
				className: `flexbox dc__gap-8 dc__align-items-center py-8 px-10 br-6 dc__unset-button-styles ${i === e ? " bcb-1" : ""}`,
				onClick: g(e),
				children: [
					/* @__PURE__ */ (0, Q.jsx)(z, {
						name: r,
						color: null
					}),
					/* @__PURE__ */ (0, Q.jsxs)("div", {
						className: "flexbox-col dc__gap-2 dc__align-left flex-grow-1",
						children: [/* @__PURE__ */ (0, Q.jsx)("span", {
							className: `fs-12 fw-6 lh-18 ${i === e ? "cb-5" : "cn-9"}`,
							children: t
						}), /* @__PURE__ */ (0, Q.jsx)("span", {
							className: "fs-11 cn-7",
							children: n
						})]
					}),
					h(a) && /* @__PURE__ */ (0, Q.jsx)(z, {
						name: "ic-error",
						color: null
					})
				]
			}, e))
		}), /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox-col flex-grow-1 dc__gap-16 px-24 py-20 dc__overflow-auto",
			children: [
				i === "basic" && /* @__PURE__ */ (0, Q.jsx)(UV, {
					data: o,
					errors: s,
					register: c,
					setValue: u,
					isEdit: t
				}),
				i === "requirements" && /* @__PURE__ */ (0, Q.jsx)(KV, {
					requirements: o.requirements,
					updateRequirements: d,
					errors: s
				}),
				i === "limits" && /* @__PURE__ */ (0, Q.jsx)(qV, {
					limits: o.limits,
					updateLimits: f,
					errors: s
				}),
				i === "disruption" && /* @__PURE__ */ (0, Q.jsx)(WV, {
					disruption: o.disruption,
					updateDisruption: p
				}),
				i === "labels" && /* @__PURE__ */ (0, Q.jsx)(GV, {
					labels: o.labels,
					taints: o.taints,
					setValue: u
				})
			]
		})]
	}), /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox dc__content-end dc__gap-12 border__secondary--top px-20 py-16 bg__primary",
		children: [/* @__PURE__ */ (0, Q.jsx)(M, {
			dataTestId: "cancel-profile-form",
			text: "Cancel",
			variant: F.secondary,
			style: P.neutral,
			onClick: n
		}), /* @__PURE__ */ (0, Q.jsx)(M, {
			dataTestId: "submit-profile-form",
			text: t ? "Save Changes" : "Create Profile",
			onClick: m
		})]
	})] });
}, YV = () => {
	let { profileId: e } = Z(), t = X(), n = !!e, r = () => t(".."), { data: i, isFetching: a, error: o, refetch: s } = q({
		queryKey: ["autoscaler-profile", e],
		queryFn: () => EV(+e),
		enabled: n
	});
	return /* @__PURE__ */ (0, Q.jsx)(xu, {
		close: r,
		onEscape: r,
		className: "",
		children: /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "bg__primary dc__position-fixed dc__right-0 dc__top-0 h-100 flexbox-col w-1024",
			onClick: uf,
			children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox dc__content-space dc__align-items-center border__secondary--bottom py-12 px-20",
				children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "flexbox-col dc__gap-2",
					children: [/* @__PURE__ */ (0, Q.jsx)("h2", {
						className: "m-0 cn-9 fs-16 fw-6 lh-24",
						children: n ? `Edit Profile${i ? ` — ${i.name}` : ""}` : "Create Node Autoscaler Profile"
					}), /* @__PURE__ */ (0, Q.jsxs)("span", {
						className: "fs-12 cn-7",
						children: [
							"Karpenter ",
							/* @__PURE__ */ (0, Q.jsx)("code", {
								className: "fs-11 bcn-1 pl-5 pr-5 br-4",
								children: "NodePool"
							}),
							" · karpenter.sh/v1"
						]
					})]
				}), /* @__PURE__ */ (0, Q.jsx)(M, {
					dataTestId: "close-profile-form",
					icon: /* @__PURE__ */ (0, Q.jsx)(z, {
						name: "ic-close-large",
						color: null
					}),
					ariaLabel: "Close",
					variant: F.borderLess,
					style: P.negativeGrey,
					onClick: r,
					size: I.xs
				})]
			}), /* @__PURE__ */ (0, Q.jsx)($a, {
				isLoading: a,
				error: o,
				reloadProps: { reload: s },
				children: /* @__PURE__ */ (0, Q.jsx)(JV, {
					initialValues: i ? VV(i) : RV,
					isEdit: n,
					handleClose: r
				}, n ? e : "new")
			})]
		})
	});
}, XV = () => /* @__PURE__ */ (0, Q.jsx)("div", {
	className: "flex",
	children: /* @__PURE__ */ (0, Q.jsx)(z, {
		name: "ic-stack",
		color: null,
		size: 20
	})
}), ZV = ({ row: e }) => /* @__PURE__ */ (0, Q.jsx)(W, {
	content: e.data.name,
	children: /* @__PURE__ */ (0, Q.jsx)("div", {
		className: "flex left py-10 fs-13 fw-5 cn-9 dc__truncate",
		children: e.data.name
	})
}), QV = ({ row: e }) => {
	let t = e.data.instanceCategories.length;
	return /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flex left py-10 dc__gap-4",
		children: [e.data.instanceCategories.slice(0, 3).map((e) => /* @__PURE__ */ (0, Q.jsx)(So, {
			label: e,
			size: I.xxxs,
			variant: "custom",
			fontColor: "N700",
			bgColor: "N200"
		}, e)), /* @__PURE__ */ (0, Q.jsx)(W, {
			content: e.data.instanceCategories.join(", "),
			alwaysShowTippyOnHover: !0,
			children: /* @__PURE__ */ (0, Q.jsx)("span", {
				className: "fs-11 cn-7",
				children: t > 3 && `+${t - 3} more`
			})
		})]
	});
}, $V = ({ row: e }) => /* @__PURE__ */ (0, Q.jsx)("div", {
	className: "flex left py-10",
	children: /* @__PURE__ */ (0, Q.jsx)(So, {
		label: e.data.capacityTypes.join(" + "),
		size: I.xxs,
		variant: "warning"
	})
}), eH = ({ row: e }) => /* @__PURE__ */ (0, Q.jsxs)("div", {
	className: "flex left py-10 fs-13 fw-4 cn-8",
	children: [e.data.cpuLimits, " cores"]
}), tH = ({ row: e }) => /* @__PURE__ */ (0, Q.jsxs)("div", {
	className: "flex left py-10 fs-13 fw-4 cn-8",
	children: [e.data.memoryLimits, " GiB"]
}), nH = ({ row: e }) => {
	let t = e.data.consolidationPolicy;
	return /* @__PURE__ */ (0, Q.jsx)("div", {
		className: "flex left py-10",
		children: /* @__PURE__ */ (0, Q.jsx)(So, {
			label: t,
			size: I.xxs,
			variant: "positive"
		})
	});
}, rH = ({ row: e }) => {
	let { attachedClusters: t } = e.data;
	return t.length ? /* @__PURE__ */ (0, Q.jsx)(W, {
		content: t.join(" ,"),
		alwaysShowTippyOnHover: !0,
		children: /* @__PURE__ */ (0, Q.jsx)("span", {
			className: "flex left py-10",
			children: rf(t.length)
		})
	}) : /* @__PURE__ */ (0, Q.jsx)("span", {
		className: "flex left py-10",
		children: "-"
	});
}, iH = ({ row: e, handleToggleReload: t }) => {
	let [n, r] = j(!1), i = () => {
		r(!0);
	}, a = () => {
		r(!1);
	};
	return /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flex dc__gap-8 py-10",
		children: [/* @__PURE__ */ (0, Q.jsx)(M, {
			dataTestId: "edit-profile",
			icon: /* @__PURE__ */ (0, Q.jsx)(z, {
				name: "ic-pencil",
				color: null
			}),
			ariaLabel: "Edit Profile",
			showAriaLabelInTippy: !1,
			component: N.link,
			linkProps: { to: Y(vo.GLOBAL_CONFIG.NODE_AUTOSCALER.EDIT_PROFILE, { profileId: `${e.data.id}` }) },
			variant: F.borderLess,
			size: I.xs,
			style: P.neutral
		}), /* @__PURE__ */ (0, Q.jsx)(M, {
			dataTestId: "delete-profile",
			icon: /* @__PURE__ */ (0, Q.jsx)(z, {
				name: "ic-delete",
				color: null
			}),
			ariaLabel: "Delete Profile",
			showAriaLabelInTippy: !1,
			variant: F.borderLess,
			size: I.xs,
			style: P.negativeGrey,
			onClick: i
		})]
	}), n && /* @__PURE__ */ (0, Q.jsx)(ns, {
		variant: rs.delete,
		title: `Are you sure you want to delete ${e.data.name}? This action cannot be undone.`,
		buttonConfig: {
			primaryButtonConfig: {
				text: "Delete",
				onClick: async () => {
					await OV(e.data.id), t(), r(!1);
				}
			},
			secondaryButtonConfig: {
				text: "Cancel",
				onClick: a
			}
		},
		handleClose: a
	})] });
}, aH = [
	{
		field: "icon",
		label: "",
		size: { fixed: 20 },
		CellComponent: XV,
		horizontallySticky: !0
	},
	{
		field: "name",
		label: "Profile Name",
		size: { fixed: 150 },
		CellComponent: ZV,
		horizontallySticky: !0
	},
	{
		field: "instanceCategories",
		label: "Instance Types",
		size: { fixed: 150 },
		CellComponent: QV
	},
	{
		field: "capacityTypes",
		label: "Capacity",
		size: { fixed: 150 },
		CellComponent: $V
	},
	{
		field: "cpuLimits",
		label: "CPU Limits",
		size: { fixed: 150 },
		CellComponent: eH
	},
	{
		field: "memoryLimits",
		label: "Memory Limit",
		size: { fixed: 150 },
		CellComponent: tH
	},
	{
		field: "consolidationPolicy",
		label: "Consolidation",
		size: { fixed: 180 },
		CellComponent: nH
	},
	{
		field: "attachedClusters",
		label: "Attached Clusters",
		size: null,
		CellComponent: rH
	}
], oH = ({ children: e }) => /* @__PURE__ */ (0, Q.jsxs)("div", {
	className: "flexbox-col h-100 bg__primary",
	children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox dc__align-items-center dc__content-space px-20 py-12",
		children: [/* @__PURE__ */ (0, Q.jsx)("h2", {
			className: "fs-16 fw-6 cn-9 -0",
			children: "Node Autoscaler Profiles"
		}), /* @__PURE__ */ (0, Q.jsx)("div", {
			className: "flex dc__gap-8",
			children: /* @__PURE__ */ (0, Q.jsx)(M, {
				dataTestId: "button__create-node-autoscaler-profile",
				text: "Create Profile",
				startIcon: /* @__PURE__ */ (0, Q.jsx)(z, {
					name: "ic-add",
					color: null
				}),
				component: N.link,
				linkProps: { to: vo.GLOBAL_CONFIG.NODE_AUTOSCALER.CREATE_PROFILE }
			})
		})]
	}), e]
}), sH = () => {
	let { isSuperAdmin: e } = Tf(), [t, n] = j(!1);
	return e ? /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsx)(ru, {
		id: "table__node-autoscaler",
		columns: aH,
		getRows: async () => {
			let e = await kV();
			return {
				rows: e.map((e) => ({
					id: `${e.id}`,
					data: {
						id: e.id,
						name: e.name,
						instanceCategories: e.requirements.instanceCategories,
						capacityTypes: e.requirements.capacityTypes,
						cpuLimits: e.limits.cpu,
						memoryLimits: e.limits.memory,
						consolidationPolicy: e.disruption.consolidationPolicy,
						attachedClusters: e.attachedClusters
					}
				})),
				totalRows: e.length
			};
		},
		emptyStateConfig: { noRowsConfig: {
			title: "No Node Autoscaler Profiles Available",
			subTitle: "Node Autoscaler Profiles will be displayed here once created."
		} },
		filter: null,
		paginationVariant: el.PAGINATED,
		filtersVariant: tc.URL,
		ViewWrapper: oH,
		rowActionOnHoverConfig: {
			Component: iH,
			width: "auto"
		},
		additionalProps: { handleToggleReload: () => {
			n((e) => !e);
		} }
	}, `${t}`), /* @__PURE__ */ (0, Q.jsxs)(qf, { children: [/* @__PURE__ */ (0, Q.jsx)(J, {
		path: vo.GLOBAL_CONFIG.NODE_AUTOSCALER.CREATE_PROFILE,
		element: /* @__PURE__ */ (0, Q.jsx)(YV, {})
	}, vo.GLOBAL_CONFIG.NODE_AUTOSCALER.CREATE_PROFILE), /* @__PURE__ */ (0, Q.jsx)(J, {
		path: vo.GLOBAL_CONFIG.NODE_AUTOSCALER.EDIT_PROFILE,
		element: /* @__PURE__ */ (0, Q.jsx)(YV, {})
	}, vo.GLOBAL_CONFIG.NODE_AUTOSCALER.EDIT_PROFILE)] })] }) : /* @__PURE__ */ (0, Q.jsx)(Ks, { code: eo.UNAUTHORIZED });
}, cH = ({ identifier: e }) => q({
	queryKey: ["userGroupDetails", e],
	queryFn: async ({ signal: t }) => G(`${O.USER_GROUP}/${e}`, { signal: t }),
	select: (e) => nt(e.result),
	enabled: !!e
}), lH = (e) => q({
	queryKey: ["userGroupsList"],
	queryFn: async ({ signal: e }) => G(O.USER_GROUP, { signal: e }),
	select: (e) => e.result.map((e) => ({
		id: e.identifier,
		data: nt(e)
	})),
	enabled: e
}), uH = ({ email: e, onDelete: t }) => /* @__PURE__ */ (0, Q.jsxs)("div", {
	className: "flex dc__content-space bg__hover px-16 py-8 br-4 dc__visible-hover dc__visible-hover--parent",
	children: [/* @__PURE__ */ (0, Q.jsx)(gu, { identifier: e }), /* @__PURE__ */ (0, Q.jsx)("div", {
		className: "dc__visible-hover--child",
		children: /* @__PURE__ */ (0, Q.jsx)(M, {
			dataTestId: "remove-user-from-group",
			icon: /* @__PURE__ */ (0, Q.jsx)(z, {
				name: "ic-delete",
				color: null
			}),
			onClick: t,
			variant: F.borderLess,
			style: P.negativeGrey,
			ariaLabel: "Remove user from group",
			showAriaLabelInTippy: !1,
			size: I.xxs
		})
	})]
}), dH = ({ userEmails: e, onChange: t }) => {
	if (e.length === 0) return /* @__PURE__ */ (0, Q.jsx)(R, {
		imgName: "img-folder-create",
		title: "No users added yet",
		subTitle: "Added users will reflect here"
	});
	let n = (n) => () => {
		let r = [...e];
		r.splice(n, 1), t(r);
	};
	return /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox-col",
		children: [/* @__PURE__ */ (0, Q.jsx)("span", {
			className: "fs-12 fw-6 lh-20 cn-7 px-16 py-6 border__primary--bottom",
			children: "EMAIL"
		}), e.map(({ value: e }, t) => /* @__PURE__ */ (0, Q.jsx)(uH, {
			email: e,
			onDelete: n(t)
		}, e))]
	});
}, fH = (e) => e.map((e) => ({
	label: e,
	value: e
})), pH = (e) => {
	let t = e.length;
	return t >= 3 && t <= 50;
}, mH = ({ identifier: e, userGroupDetails: t }) => {
	let n = X(), r = !!e, i = () => {
		n("../");
	}, { isLoading: a, data: o } = q({
		queryKey: ["userList"],
		queryFn: async ({ signal: e }) => sr({
			showAll: !0,
			offset: null,
			size: null,
			sortBy: _u.email,
			sortOrder: Jl.ASC,
			status: []
		}, e),
		select: (e) => (e?.users ?? []).filter((e) => e.email_id !== Cs.system).map((e) => ({
			label: e.email_id,
			value: e.email_id
		}))
	}), { isPending: s, mutate: c } = Ef({
		mutationFn: (t) => r ? sf(`${O.USER_GROUP}/${e}`, t) : nf(O.USER_GROUP, t),
		onSuccess: () => {
			H.showToast({
				variant: U.success,
				description: `User group ${r ? "updated" : "created"} successfully.`
			}), i();
		}
	}), { data: l, errors: u, register: d, handleSubmit: f } = xf({
		initialValues: {
			groupName: t?.name || "",
			groupIdentifier: t?.identifier || "",
			groupDescription: t?.description || "",
			userEmails: fH(t?.userEmails || [])
		},
		validationMode: "all",
		validations: {
			groupName: {
				required: !0,
				custom: {
					isValid: (e) => pH(e),
					message: "Min. 3 and Max. 50 characters allowed."
				}
			},
			groupIdentifier: {
				required: !0,
				custom: {
					isValid: (e) => If(e).isValid,
					message: "Min 3 chars; Start with alphabet; End with alphanumeric; Use only lowercase; Allowed:(-); Do not use 'spaces'"
				}
			},
			groupDescription: {
				required: !1,
				custom: {
					isValid: (e) => e.length <= 350,
					message: "Max. 350 characters allowed."
				}
			},
			userEmails: { required: !1 }
		}
	}), p = f((e) => {
		c({
			identifier: e.groupIdentifier,
			name: e.groupName,
			description: e.groupDescription,
			userEmails: e.userEmails.map(({ value: e }) => e)
		});
	}, () => {
		H.showToast({
			variant: U.error,
			description: "Please resolve errors before continuing"
		});
	});
	return /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox-col h-100",
		children: [/* @__PURE__ */ (0, Q.jsx)("div", {
			className: "flexbox-col flex-grow-1 dc__overflow-auto bg__primary",
			children: /* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flexbox-col dc__gap-24 flex-grow-1 px-16 py-20 bg__primary",
				children: [
					/* @__PURE__ */ (0, Q.jsxs)("div", {
						className: "flex left dc__gap-4 fs-16 lh-32 fw-6",
						children: [
							/* @__PURE__ */ (0, Q.jsx)(Wf, {
								to: "..",
								children: "User Groups"
							}),
							/* @__PURE__ */ (0, Q.jsx)("span", {
								className: "fw-4 cn-5",
								children: "/"
							}),
							/* @__PURE__ */ (0, Q.jsx)("span", {
								className: "cn-9",
								children: r ? e : "Create Group"
							})
						]
					}),
					/* @__PURE__ */ (0, Q.jsxs)("div", {
						className: "flexbox-col dc__gap-16",
						children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
							className: "flex top dc__gap-16",
							children: [/* @__PURE__ */ (0, Q.jsx)(os, {
								name: "user-group-name",
								placeholder: "Eg. Project managers",
								value: l.groupName,
								onChange: d("groupName").onChange,
								fullWidth: !0,
								error: u.groupName,
								label: "Group Name",
								required: !0
							}), /* @__PURE__ */ (0, Q.jsx)(os, {
								name: "user-group-identifier",
								placeholder: "Eg. project-managers",
								disabled: r,
								value: l.groupIdentifier,
								onChange: d("groupIdentifier").onChange,
								fullWidth: !0,
								error: u.groupIdentifier,
								label: "Group ID",
								required: !0
							})]
						}), /* @__PURE__ */ (0, Q.jsx)(ou, {
							name: "user-group-description",
							placeholder: "Enter a description for this group",
							value: l.groupDescription,
							onChange: d("groupDescription").onChange,
							fullWidth: !0,
							label: "Description",
							error: u.groupDescription
						})]
					}),
					/* @__PURE__ */ (0, Q.jsxs)("div", {
						className: "flexbox-col dc__gap-16 flex-grow-1",
						children: [/* @__PURE__ */ (0, Q.jsx)(V, {
							isMulti: !0,
							inputId: "user-emails-selector",
							options: o,
							size: I.large,
							placeholder: "Select users",
							label: "Add users to group",
							isDisabled: a,
							isLoading: a,
							onChange: d("userEmails", { isCustomComponent: !0 }).onChange,
							value: l.userEmails,
							controlShouldRenderValue: !1,
							isUserIdentifier: !0
						}), /* @__PURE__ */ (0, Q.jsx)(dH, {
							userEmails: l.userEmails || [],
							onChange: d("userEmails", { isCustomComponent: !0 }).onChange
						})]
					})
				]
			})
		}), /* @__PURE__ */ (0, Q.jsxs)("footer", {
			className: "flex left dc__gap-16 border__secondary--top px-20 py-16 bg__primary",
			children: [/* @__PURE__ */ (0, Q.jsx)(M, {
				dataTestId: "save-user-group",
				text: "Save",
				onClick: p,
				isLoading: s,
				disabled: a
			}), /* @__PURE__ */ (0, Q.jsx)(M, {
				dataTestId: "cancel-user-group",
				text: "Cancel",
				variant: F.secondary,
				style: P.neutral,
				onClick: i
			})]
		})]
	});
}, hH = () => {
	let { identifier: e } = Z(), { isLoading: t, data: n, error: r, refetch: i } = cH({ identifier: e });
	return t ? /* @__PURE__ */ (0, Q.jsx)(ul, { pageLoader: !0 }) : r ? /* @__PURE__ */ (0, Q.jsx)(Ks, {
		code: r?.code,
		reload: i
	}) : /* @__PURE__ */ (0, Q.jsx)($a, {
		isLoading: t,
		error: r,
		errorScreenManagerProps: {
			code: r?.code,
			reload: i
		},
		progressingProps: { pageLoader: !0 },
		children: /* @__PURE__ */ (0, Q.jsx)(mH, {
			identifier: e,
			userGroupDetails: n
		})
	});
}, gH = () => /* @__PURE__ */ (0, Q.jsx)("div", {
	className: "flex center",
	children: /* @__PURE__ */ (0, Q.jsx)(z, {
		name: "ic-users",
		color: null,
		size: 20
	})
}), _H = ({ row: e, signals: t }) => {
	let n = Ja(null), { name: r, identifier: i } = e.data;
	return k(() => {
		let r = ({ detail: { activeRowData: t } }) => {
			t.id === e.id && n.current?.click();
		};
		return t.addEventListener(iu.ENTER_PRESSED, r), () => {
			t.removeEventListener(iu.ENTER_PRESSED, r);
		};
	}, []), /* @__PURE__ */ (0, Q.jsx)(Wf, {
		ref: n,
		to: Y(vo.GLOBAL_CONFIG.AUTH.EDIT_USER_GROUP, { identifier: i }),
		className: "py-10 flex dc__align-items-center left",
		children: /* @__PURE__ */ (0, Q.jsx)(W, {
			content: r,
			children: /* @__PURE__ */ (0, Q.jsx)("span", {
				className: " dc__truncate",
				children: r
			})
		})
	});
}, vH = ({ row: e }) => {
	let { usersCount: t } = e.data;
	return /* @__PURE__ */ (0, Q.jsx)("span", {
		className: "py-10 flex dc__align-items-center left",
		children: rf(t)
	});
}, yH = ({ row: e }) => /* @__PURE__ */ (0, Q.jsx)("div", {
	className: "py-10 flex dc__align-items-center left",
	children: /* @__PURE__ */ (0, Q.jsx)(W, {
		content: e.data.description,
		children: /* @__PURE__ */ (0, Q.jsx)("span", {
			className: "dc__truncate",
			children: e.data.description
		})
	})
}), bH = () => /* @__PURE__ */ (0, Q.jsx)(M, {
	dataTestId: "create-user-group",
	component: N.link,
	linkProps: { to: vo.GLOBAL_CONFIG.AUTH.CREATE_USER_GROUP },
	text: "Create Group",
	startIcon: /* @__PURE__ */ (0, Q.jsx)(z, {
		name: "ic-add",
		color: null
	})
}), xH = [
	{
		field: "icon",
		label: "",
		size: { fixed: 24 },
		CellComponent: gH
	},
	{
		field: "name",
		label: "Name",
		size: { fixed: 200 },
		CellComponent: _H,
		isSortable: !0,
		comparator: df
	},
	{
		field: "usersCount",
		label: "Users",
		size: { fixed: 100 },
		CellComponent: vH
	},
	{
		field: "description",
		label: "Description",
		size: null,
		CellComponent: yH
	}
], SH = () => "An entity to group users. Useful for applying notifications, policies, or configurations to a set of users without selecting them individually.", CH = ({ children: e, handleSearch: t, searchKey: n }) => /* @__PURE__ */ (0, Q.jsxs)("div", {
	className: "flexbox-col flex-grow-1 h-100 dc__gap-16 pt-16 bg__primary",
	children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flex dc__content-space px-20",
		children: [/* @__PURE__ */ (0, Q.jsx)(Xs, {
			title: "User Groups",
			renderDescriptionContent: SH,
			showInfoIconTippy: !0
		}), /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flex dc__gap-8",
			children: [/* @__PURE__ */ (0, Q.jsx)(Il, {
				inputProps: { placeholder: "Search group" },
				keyboardShortcut: "/",
				handleEnter: t,
				initialSearchText: n,
				size: I.large
			}), /* @__PURE__ */ (0, Q.jsx)(bH, {})]
		})]
	}), e]
}), wH = () => {
	let { isSuperAdmin: e } = Tf(), { isFetching: t, error: n, refetch: r, data: i } = lH(e), a = e ? n : new Wl({
		code: eo.PERMISSION_DENIED,
		errors: []
	});
	return /* @__PURE__ */ (0, Q.jsx)($a, {
		error: a,
		errorScreenManagerProps: {
			code: a?.code,
			reload: r
		},
		children: /* @__PURE__ */ (0, Q.jsx)(ru, {
			id: "table__user-groups",
			rows: i,
			loading: t,
			filter: (e, t) => {
				let { searchKey: n } = t;
				return n ? e.data.name.toLowerCase().includes(n.toLowerCase()) : !0;
			},
			columns: xH,
			emptyStateConfig: { noRowsConfig: {
				title: "Manage User Groups",
				subTitle: "User Groups is an entity to group users. Useful for applying notifications, policies, or configurations to a set of users without selecting them individually.",
				imgName: "img-user-groups"
			} },
			paginationVariant: el.PAGINATED,
			filtersVariant: tc.URL,
			ViewWrapper: CH
		})
	});
}, TH = () => /* @__PURE__ */ (0, Q.jsxs)(qf, { children: [
	/* @__PURE__ */ (0, Q.jsx)(J, {
		path: vo.GLOBAL_CONFIG.AUTH.CREATE_USER_GROUP,
		element: /* @__PURE__ */ (0, Q.jsx)(hH, {})
	}),
	/* @__PURE__ */ (0, Q.jsx)(J, {
		path: vo.GLOBAL_CONFIG.AUTH.EDIT_USER_GROUP,
		element: /* @__PURE__ */ (0, Q.jsx)(hH, {})
	}),
	/* @__PURE__ */ (0, Q.jsx)(J, {
		index: !0,
		element: /* @__PURE__ */ (0, Q.jsx)(wH, {})
	}),
	/* @__PURE__ */ (0, Q.jsx)(J, {
		path: "/*",
		element: /* @__PURE__ */ (0, Q.jsx)(Kf, {
			to: "",
			replace: !0
		})
	})
] }), EH = {
	UPGRADE_COMPATIBILITY: "upgrade-compatibility",
	COST_BREAKDOWN_QUERY_KEY: qj,
	COST_METADATA_QUERY_KEY: Yj,
	COST_OPPORTUNITIES_QUERY_KEY: Kj
};
//#endregion
//#region src/Pages-Devtron-2.0/InfrastructureManagement/Overview/service.ts
$e();
var DH = () => q({
	queryKey: [EH.UPGRADE_COMPATIBILITY],
	queryFn: ({ signal: e }) => G(Rd(O.UPGRADE_COMPATIBILITY, { excludeUpToDate: !0 }), { signal: e }),
	select: ({ result: e }) => ({
		latestVersion: e?.latestVersion || "",
		canCurrentUserUpgrade: e?.canCurrentUserUpgrade || !1,
		clusterList: (e?.clusterList ?? []).map(({ endOfLife: e, ...t }) => ({
			...t,
			...e ? { endOfLife: l(e).format(ss.DD_MMM_YYYY) } : {}
		})).sort((e, t) => df(e.clusterName, t.clusterName, Jl.ASC))
	})
}), OH = 5, kH = () => {
	let e = X(), [t, n] = j(""), [r, i] = j(null), [a, o] = j(!1), { isFetching: s, isError: c, data: l, refetch: u } = DH(), { latestVersion: d, canCurrentUserUpgrade: f, clusterList: p } = l || {}, m = A(() => a ? p : p?.slice(0, OH), [a, p]), h = ({ clusterId: e, clusterName: t, currentVersion: r, upgradePath: a }) => () => {
		i({
			clusterId: e,
			clusterName: t,
			currentVersion: r,
			upgradePath: a
		}), n(a?.[0] ?? "");
	};
	return /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox-col br-8 border__secondary bg__primary",
		children: [
			/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "py-12 px-16 flexbox-col border__secondary--bottom",
				children: [/* @__PURE__ */ (0, Q.jsx)("h4", {
					className: "fw-6 fs-13 m-0 cn-9 lh-1-5",
					children: "Check cluster update compatibility"
				}), s ? /* @__PURE__ */ (0, Q.jsx)("span", { className: "w-100px h-16 mt-2 shimmer" }) : l?.latestVersion && /* @__PURE__ */ (0, Q.jsxs)("span", {
					className: "fs-12 fw-4 cn-7 lh-1-5",
					children: ["Latest stable Kubernetes version is ", d]
				})]
			}),
			/* @__PURE__ */ (0, Q.jsx)("div", {
				className: "flexbox-col p-8",
				children: s ? [
					,
					,
					,
				].fill(0).map((e, t) => /* @__PURE__ */ (0, Q.jsx)("div", {
					className: "py-8 px-12",
					children: /* @__PURE__ */ (0, Q.jsxs)("div", {
						className: "flexbox-col flex-grow-1 dc__gap-6",
						children: [/* @__PURE__ */ (0, Q.jsx)("div", { className: "shimmer-loading h-16 w-75 br-4" }), /* @__PURE__ */ (0, Q.jsx)("div", { className: "shimmer-loading h-14 w-50 br-4" })]
					})
				}, `shimmer-${t}`)) : c || !l || !p ? /* @__PURE__ */ (0, Q.jsx)(lc, {
					subTitle: "",
					reload: u
				}) : p.length ? /* @__PURE__ */ (0, Q.jsx)(Q.Fragment, { children: (m ?? []).map(({ clusterId: e, clusterName: t, currentVersion: n, upgradePath: r, endOfLife: i }) => /* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "py-8 px-12 dc__visible-hover dc__visible-hover--parent dc__hover-n50 br-8 flexbox-col dc__gap-2",
					children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
						className: "flexbox dc__content-space",
						children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
							className: "flexbox-col",
							children: [/* @__PURE__ */ (0, Q.jsx)("span", {
								className: "fs-13 fw-4 cn-9 lh-1-5 dc__truncate",
								children: t
							}), /* @__PURE__ */ (0, Q.jsxs)("span", {
								className: "fs-12 fw-4 cn-7 lh-1-5 dc__truncate",
								children: ["v", n]
							})]
						}), /* @__PURE__ */ (0, Q.jsx)("div", {
							className: "flexbox dc__align-start dc__visible-hover--child",
							children: /* @__PURE__ */ (0, Q.jsx)(M, {
								dataTestId: `upgrade-button-${e}`,
								icon: /* @__PURE__ */ (0, Q.jsx)(z, {
									name: "ic-logs",
									color: null
								}),
								ariaLabel: "Upgrade cluster",
								showAriaLabelInTippy: !1,
								size: I.xxs,
								variant: F.borderLess,
								onClick: h({
									clusterId: e,
									clusterName: t,
									currentVersion: n,
									upgradePath: r
								}),
								disabled: !f,
								showTooltip: !0,
								tooltipProps: { content: f ? "Check compatibility" : "You are not authorized to check compatibility" }
							})
						})]
					}), i && /* @__PURE__ */ (0, Q.jsx)(So, {
						variant: "warning",
						label: `Upgrade before ${i}`,
						startIconProps: { name: "ic-warning-stroke" },
						size: I.xxxs
					})]
				}, `${e}-${t}`)) }) : /* @__PURE__ */ (0, Q.jsx)(Ll, {
					iconName: "ic-party",
					title: "All upgraded",
					subtitle: "All clusters are on latest K8s version"
				})
			}),
			p?.length > OH && /* @__PURE__ */ (0, Q.jsx)("div", {
				className: "flex left border__secondary--top px-16 py-8",
				children: /* @__PURE__ */ (0, Q.jsx)(M, {
					dataTestId: "show-all-upgradable-clusters",
					text: a ? "Show less" : "Show all",
					variant: F.text,
					onClick: () => {
						o((e) => !e);
					},
					endIcon: /* @__PURE__ */ (0, Q.jsx)(z, {
						name: "ic-caret-down-small",
						color: null,
						rotateBy: a ? 180 : 0
					})
				})
			})
		]
	}), r && /* @__PURE__ */ (0, Q.jsx)(Bb, {
		clusterName: r.clusterName,
		currentVersion: r.currentVersion,
		latestVersion: d,
		handleCloseClusterDialog: () => {
			i(null);
		},
		handleOpenScanClusterTab: () => {
			e(Rd(Y(B.RESOURCE_BROWSER.CLUSTER_DETAILS.CLUSTER_UPGRADE, { clusterId: String(r.clusterId) }), { [$l]: t }));
		},
		targetVersion: t,
		setTargetVersion: n,
		clusterListOptions: (r.upgradePath ?? []).map((e) => mb({
			version: e,
			isLatest: e === d
		}))
	})] });
}, AH = () => {
	let { data: e, isFetching: t } = Qj();
	return /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flexbox-col flex-grow-1 bg__primary border__secondary--left dc__overflow-hidden",
		children: [/* @__PURE__ */ (0, Q.jsx)("div", {
			className: "p-16 border__secondary--bottom",
			children: /* @__PURE__ */ (0, Q.jsx)("span", {
				className: "fs-14 fw-6 lh-1-5 cn-9",
				children: "Actions & Insights"
			})
		}), /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flexbox-col dc__gap-12 p-16 dc__overflow-auto",
			children: [/* @__PURE__ */ (0, Q.jsx)(XP, {
				category: L.CLUSTERS,
				currency: e?.defaultCurrency,
				isCurrencyLoading: t
			}), /* @__PURE__ */ (0, Q.jsx)(kH, {})]
		})]
	});
}, jH = () => /* @__PURE__ */ (0, Q.jsxs)("div", {
	className: "flexbox-col dc__gap-12",
	children: [/* @__PURE__ */ (0, Q.jsx)("div", {
		className: "flexbox dc__content-space dc__align-items-center",
		children: /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "flex dc__gap-8",
			children: [/* @__PURE__ */ (0, Q.jsx)("h2", {
				className: "fs-20 fw-4 lh-1-5 cn-9 m-0",
				children: "Cost Visibility"
			}), /* @__PURE__ */ (0, Q.jsx)(M, {
				dataTestId: "redirect-to-cost-visibility",
				icon: /* @__PURE__ */ (0, Q.jsx)(z, {
					name: "ic-arrow-square-out",
					color: null
				}),
				ariaLabel: "Cost Visibility",
				showAriaLabelInTippy: !0,
				variant: F.borderLess,
				style: P.neutral,
				size: I.small,
				component: N.link,
				linkProps: { to: B.COST_VISIBILITY_BREAKDOWN.CLUSTERS }
			})]
		})
	}), /* @__PURE__ */ (0, Q.jsx)(mM, { hideCategoryFilter: !0 })]
}), MH = [
	{
		title: "Deployment Window",
		dataTestId: "click-on-policies-deployment-window",
		id: "application-management-policies-deployment-window",
		href: B.APPLICATION_MANAGEMENT_POLICIES.DEPLOYMENT_WINDOW.ROOT,
		keywords: ["policy"]
	},
	{
		title: "Approval Policy",
		dataTestId: "click-on-policies-approval-policy",
		id: "application-management-policies-approval-policy",
		href: B.APPLICATION_MANAGEMENT_POLICIES.APPROVAL_POLICY.ROOT,
		keywords: ["policy"]
	},
	{
		title: "Plugin Policy",
		dataTestId: "click-on-policies-plugin-policy",
		id: "application-management-policies-plugin-policy",
		href: B.APPLICATION_MANAGEMENT_POLICIES.PLUGIN_POLICY.ROOT,
		keywords: ["policy"]
	},
	{
		title: "Pull Image Digest",
		dataTestId: "click-on-policies-pull-image-digest",
		id: "application-management-policies-pull-image-digest",
		href: B.APPLICATION_MANAGEMENT_POLICIES.PULL_IMAGE_DIGEST,
		keywords: ["policy"]
	},
	{
		title: "Tag Policy",
		dataTestId: "click-on-policies-tag-policy",
		id: "application-management-policies-tag-policy",
		href: B.APPLICATION_MANAGEMENT_POLICIES.TAG_POLICY.ROOT,
		keywords: ["policy"]
	},
	{
		title: "Filter Conditions",
		dataTestId: "click-on-policies-filter-conditions",
		id: "application-management-policies-filter-conditions",
		href: B.APPLICATION_MANAGEMENT_POLICIES.FILTER_CONDITIONS.ROOT,
		keywords: ["policy"]
	},
	{
		title: "Image Promotion",
		dataTestId: "click-on-policies-image-promotion",
		id: "application-management-policies-image-promotion",
		href: B.APPLICATION_MANAGEMENT_POLICIES.IMAGE_PROMOTION.ROOT,
		keywords: ["policy"],
		forceHideEnvKey: "FEATURE_IMAGE_PROMOTION_ENABLE"
	},
	{
		title: "Lock Deployment Configuration",
		dataTestId: "click-on-policies-lock-deployment-configuration",
		id: "application-management-policies-lock-deployment-configuration",
		href: B.APPLICATION_MANAGEMENT_POLICIES.LOCK_DEPLOYMENT_CONFIGURATION.ROOT,
		keywords: ["policy"]
	}
], NH = [
	{
		title: "Clusters",
		dataTestId: "cost-breakdown-clusters",
		id: "cost-visibility-cost-breakdown-clusters",
		href: B.COST_VISIBILITY_BREAKDOWN.CLUSTERS,
		keywords: ["cost"],
		isAvailableInEA: !0
	},
	{
		title: "Environments",
		dataTestId: "cost-breakdown-environments",
		id: "cost-visibility-cost-breakdown-environments",
		href: B.COST_VISIBILITY_BREAKDOWN.ENVIRONMENTS,
		keywords: ["cost"]
	},
	{
		title: "Projects",
		dataTestId: "cost-breakdown-projects",
		id: "cost-visibility-cost-breakdown-projects",
		href: B.COST_VISIBILITY_BREAKDOWN.PROJECTS,
		keywords: ["cost"]
	},
	{
		title: "Applications",
		dataTestId: "cost-breakdown-applications",
		id: "cost-visibility-cost-breakdown-applications",
		href: B.COST_VISIBILITY_BREAKDOWN.APPLICATIONS,
		keywords: ["cost"]
	}
], PH = {
	title: "Policies",
	dataTestId: "click-on-policies",
	id: "application-management-policies",
	hasSubMenu: !0,
	subItems: MH
}, FH = {
	title: "Application Templates",
	dataTestId: "click-on-application-templates",
	id: "application-management-application-templates",
	icon: "ic-application-template",
	href: B.APP_TEMPLATES,
	forceHideEnvKey: "FEATURE_APPLICATION_TEMPLATES_ENABLE"
}, IH = {
	title: "Resource Watcher",
	dataTestId: "resource-watcher",
	id: "infrastructure-management-resource-watcher",
	icon: "ic-resource-watcher",
	href: B.RESOURCE_WATCHER,
	forceHideEnvKey: "FEATURE_RESOURCE_WATCHER_ENABLE",
	isAvailableInEA: !0
}, LH = {
	title: "Security Enablement",
	dataTestId: "security-enablement",
	id: "security-center-security-enablement",
	href: B.SECURITY_CENTER_SECURITY_ENABLEMENT,
	icon: "ic-security-scan"
}, RH = {
	id: "software-release-management",
	title: "Software Release Management",
	icon: "ic-software-release-management",
	items: [
		{
			title: "Overview",
			dataTestId: "software-release-management-overview",
			id: "software-release-management-overview",
			icon: "ic-chart-line-up",
			href: "/dummy-url",
			disabled: !0
		},
		{
			title: "Release Hub",
			dataTestId: "release-hub",
			id: "software-release-management-release-hub",
			icon: "ic-release-hub",
			href: B.RELEASES.ROOT
		},
		{
			title: "Tenants",
			dataTestId: "tenants",
			id: "software-release-management-tenants",
			icon: "ic-tenants",
			href: B.TENANTS.ROOT
		}
	],
	forceHideEnvKey: "FEATURE_SOFTWARE_DISTRIBUTION_HUB_ENABLE"
}, zH = {
	id: "cost-visibility",
	title: "Cost Visibility",
	icon: "ic-cost-visibility",
	items: [
		{
			title: "Overview",
			dataTestId: "cost-visibility-overview",
			id: "cost-visibility-overview",
			icon: "ic-chart-line-up",
			href: B.COST_VISIBILITY_OVERVIEW,
			isAvailableInEA: !0
		},
		{
			title: "Cost Breakdown",
			dataTestId: "cost-breakdown",
			id: "cost-visibility-cost-breakdown",
			hasSubMenu: !0,
			subItems: NH,
			isAvailableInEA: !0
		},
		{
			title: "Configurations",
			dataTestId: "cost-visibility-configurations",
			id: "cost-visibility-configurations",
			icon: "ic-gear",
			href: B.COST_VISIBILITY_CONFIGURATIONS,
			isAvailableInEA: !0
		}
	],
	isAvailableInEA: !0
}, BH = {
	title: "Data Protection Management",
	id: "data-protection-management",
	icon: "ic-database-backup",
	items: [
		{
			title: "Overview",
			dataTestId: "data-protection-overview",
			id: "data-protection-overview",
			icon: "ic-chart-line-up",
			href: B.DATA_PROTECTION_MANAGEMENT_OVERVIEW
		},
		{
			title: "Backup & Schedule",
			dataTestId: "data-protection-backup-and-schedule",
			id: "data-protection-backup-and-schedule",
			icon: "ic-backup-and-schedule",
			href: Y(B.DATA_PROTECTION_MANAGEMENT_BACKUP_AND_SCHEDULE, { view: "backups" })
		},
		{
			title: "Restores",
			dataTestId: "data-protection-restores",
			id: "data-protection-restores",
			icon: "ic-clock-counterclockwise",
			href: B.DATA_PROTECTION_MANAGEMENT_RESTORES
		},
		{
			title: "Backup Locations",
			dataTestId: "backup-locations",
			id: "data-protection-backup-locations",
			icon: "ic-backup-location",
			href: Y(B.DATA_PROTECTION_MANAGEMENT_BACKUP_LOCATIONS, { type: xo.VOLUME_SNAPSHOT })
		}
	],
	forceHideEnvKey: "FEATURE_STORAGE_ENABLE"
}, VH = {
	title: "User Groups",
	dataTestId: "authorization-user-groups",
	id: "global-configuration-authorization-user-groups",
	href: B.GLOBAL_CONFIG_AUTH.USER_GROUPS,
	isAvailableInEA: !0
}, HH = () => {
	let { breadcrumbs: e } = gf(B.SECURITY_CENTER_SECURITY_ENABLEMENT, { alias: {
		...Td(),
		"security-enablement": { component: /* @__PURE__ */ (0, Q.jsx)(To, {
			heading: "Security Enablement",
			isActive: !0
		}) }
	} }, []);
	return /* @__PURE__ */ (0, Q.jsx)(Qc, {
		isBreadcrumbs: !0,
		breadCrumbs: () => /* @__PURE__ */ (0, Q.jsx)(Co, {
			breadcrumbs: e,
			path: B.SECURITY_CENTER_SECURITY_ENABLEMENT
		}),
		docPath: gs.SECURITY_CENTER
	});
}, UH = /* @__PURE__ */ function(e) {
	return e.SCAN_ENABLED = "scanEnabled", e.SCAN_NOT_ENABLED = "scanNotEnabled", e.ALL = "all", e;
}({}), WH = /* @__PURE__ */ function(e) {
	return e.APP_NAME = "appName", e.WORKFLOW_NAME = "workflowName", e.SCAN_ENABLED = "scanEnabled", e.ENVIRONMENTS = "environments", e;
}({}), GH = /* @__PURE__ */ function(e) {
	return e.ENABLE = "enable-security-scan", e.DISABLE = "disable-security-scan", e;
}({}), KH = (e) => ({
	workflowScanType: e.get("workflowScanType") || UH.ALL,
	application: e.getAll("application") || [],
	environment: e.getAll("environment") || [],
	cluster: e.getAll("cluster") || []
}), qH = (e) => {
	let t = new URLSearchParams(e);
	return {
		...KH(t),
		searchQuery: t.get(hu.SEARCH_KEY) || ""
	};
}, JH = (e, t) => Rd(`${mu.APPLICATION_MANAGEMENT_APP}/${e}/${mu.APP_CONFIG}/workflow`, { workflowName: t }), YH = ({ row: e }) => {
	let { data: t } = e, { workflowName: n } = t;
	return /* @__PURE__ */ (0, Q.jsx)("div", {
		className: "flex left py-10",
		children: /* @__PURE__ */ (0, Q.jsx)(W, {
			content: n,
			children: /* @__PURE__ */ (0, Q.jsx)(Wf, {
				className: "dc__truncate",
				to: JH(`${t.appId}`, n),
				children: n
			})
		})
	});
}, XH = ({ row: e }) => {
	let { data: t } = e;
	return /* @__PURE__ */ (0, Q.jsx)("div", {
		className: "flex left py-10",
		children: /* @__PURE__ */ (0, Q.jsx)(W, {
			content: t.environments,
			children: /* @__PURE__ */ (0, Q.jsx)("span", {
				className: "dc__truncate",
				children: t.environments
			})
		})
	});
}, ZH = [
	{
		label: "All Workflows",
		value: UH.ALL
	},
	{
		label: "Scan enabled",
		value: UH.SCAN_ENABLED
	},
	{
		label: "Scan not enabled",
		value: UH.SCAN_NOT_ENABLED
	}
], QH = [{ items: [
	{
		id: "application",
		label: "Application"
	},
	{
		id: "environment",
		label: "Environment"
	},
	{
		id: "cluster",
		label: "Cluster"
	}
] }], $H = [{
	label: "Enable Security Scan",
	value: GH.ENABLE
}, {
	label: "Disable Security Scan",
	value: GH.DISABLE
}], eU = {
	alreadyDisabled: {
		title: "Already Disabled",
		iconName: "ic-success",
		color: "G500"
	},
	alreadyEnabled: {
		title: "Already Enabled",
		iconName: "ic-success",
		color: "G500"
	},
	succeeded: {
		title: "Succeeded",
		iconName: "ic-success",
		color: "G500"
	},
	failed: {
		title: "Failed",
		iconName: "ic-error",
		color: "R500"
	},
	notAuthorized: {
		title: "Not Authorized",
		iconName: "ic-locked",
		color: "Y500"
	},
	cannotEnable: {
		title: "Cannot Enable",
		iconName: "ic-error",
		color: "R500"
	},
	cannotDisable: {
		title: "Cannot Disable",
		iconName: "ic-error",
		color: "R500"
	}
}, tU = [
	{
		label: "Workflow Name",
		field: WH.WORKFLOW_NAME,
		size: { fixed: 200 },
		isSortable: !0,
		CellComponent: YH
	},
	{
		label: "App Name",
		field: WH.APP_NAME,
		size: { fixed: 200 },
		isSortable: !0
	},
	{
		label: "Environments",
		field: WH.ENVIRONMENTS,
		size: { fixed: 300 },
		CellComponent: XH
	},
	{
		label: "Scan",
		field: WH.SCAN_ENABLED,
		size: { fixed: 200 },
		isSortable: !0
	}
], nU = async ({ offset: e, pageSize: t, searchKey: n, sortBy: r, sortOrder: i, workflowScanType: a, application: o, environment: s, cluster: c }) => {
	let l = await nf(O.SCAN_WORKFLOW_LIST, {
		offset: e,
		size: t,
		sortBy: r,
		sortOrder: i,
		searchQuery: n,
		scanEnablement: a,
		appIds: o.map(Number),
		envIds: s.map(Number),
		clusterIds: c.map(Number)
	});
	return {
		totalRows: l.result?.total ?? 0,
		rows: (l.result?.workflows ?? []).map(({ workflowId: e, workflowName: t, appId: n, appName: r, environments: i, scanEnabled: a }) => ({
			id: `${e}-${t}-${n}`,
			data: {
				workflowId: e,
				workflowName: t,
				appId: n,
				appName: r,
				environments: (i ?? []).join(", "),
				scanEnabled: a ? "Enabled" : "Not Enabled"
			}
		}))
	};
}, rU = () => Ef({ mutationFn: (e) => nf(O.SCAN_UPDATE_SCANNING, { ...e }) }), iU = () => {
	let { isResourcesOptionsLoading: e, refetchResourcesOptions: t, resourcesOptionsError: n, resourcesOptionsMap: r } = Sf({ resourcesToFetch: [
		Dl.devtronApplication,
		Dl.cluster,
		Dl.environment
	] });
	return {
		appOptions: (r[Dl.devtronApplication] ?? []).reduce((e, t) => (e.push(...t.appList.map((e) => ({
			label: e.name,
			value: `${e.id}`
		}))), e), []).sort((e, t) => df(e.label, t.label)),
		environmentOptions: (r[Dl.environment] ?? []).flatMap(({ envList: e }) => e.map((e) => ({
			label: e.name,
			value: `${e.id}`
		}))).sort((e, t) => df(e.label, t.label)),
		clusterOptions: (r[Dl.cluster] ?? []).map(({ name: e, id: t }) => ({
			label: e,
			value: `${t}`
		})).sort((e, t) => df(e.label, t.label)),
		isResourcesOptionsLoading: e,
		refetchResourcesOptions: t,
		resourcesOptionsError: n
	};
}, aU = ({ onActionClick: e }) => /* @__PURE__ */ (0, Q.jsx)(V, {
	inputId: "enable-disable-security-scan",
	options: $H,
	placeholder: "Enable/Disable Security Scan",
	onChange: (t) => {
		let n = { currentTarget: { dataset: { key: t.value } } };
		setTimeout(() => {
			e(n);
		}, 100);
	},
	value: null,
	menuPosition: "absolute",
	isSearchable: !1
}), oU = ({ scanEnableTriggerStatus: e }) => {
	let { title: t, iconName: n, color: r } = eU[e];
	return /* @__PURE__ */ (0, Q.jsxs)("div", {
		className: "flex left dc__gap-8",
		children: [/* @__PURE__ */ (0, Q.jsx)(z, {
			name: n,
			color: r
		}), /* @__PURE__ */ (0, Q.jsx)("span", {
			className: "fs-13 lh-20 cn-9 fw-4",
			children: t
		})]
	});
}, sU = ({ headerTitle: e, handleClose: t, isBulkScanEnable: n, mutationProps: { isPending: r, isError: i, error: a, data: o, mutate: s } }) => {
	let { handleSorting: c, sortBy: l, sortOrder: u } = Mf({ initialSortKey: "workflowName" }), d = (e) => () => {
		c(e);
	}, f = A(() => (o?.result?.workflows ?? []).sort((e, t) => df(e[l], t[l], u)), [
		o,
		l,
		u
	]), p = A(() => (o?.result?.workflows ?? []).filter((e) => e.scanEnableTriggerStatus === "failed"), [o]), m = p.length;
	return /* @__PURE__ */ (0, Q.jsx)(Rs, {
		position: "right",
		width: "1024px",
		onClose: t,
		onEscape: t,
		children: /* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "bg__primary h-100 flexbox-col flex-grow-1",
			onClick: uf,
			children: [
				/* @__PURE__ */ (0, Q.jsxs)("div", {
					className: "flex dc__content-space px-20 py-12 border__secondary--bottom",
					children: [/* @__PURE__ */ (0, Q.jsx)("span", {
						className: "fs-16 fw-6 lh-24 cn-9",
						children: e
					}), /* @__PURE__ */ (0, Q.jsx)(M, {
						dataTestId: "close-status-drawer",
						onClick: t,
						icon: /* @__PURE__ */ (0, Q.jsx)(z, {
							name: "ic-close-large",
							color: null
						}),
						ariaLabel: "Close",
						showAriaLabelInTippy: !1,
						size: I.xs,
						variant: F.borderLess,
						style: P.negativeGrey
					})]
				}),
				/* @__PURE__ */ (0, Q.jsx)("div", {
					className: "flexbox-col flex-grow-1 dc__overflow-hidden",
					children: r ? /* @__PURE__ */ (0, Q.jsx)(R, {
						title: "Operation in progress",
						imgName: "img-mechanical-operation"
					}) : i ? /* @__PURE__ */ (0, Q.jsx)(Ks, { code: a?.code }) : /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
						className: "px-20 py-6 dc__grid trigger-status-row",
						children: [
							/* @__PURE__ */ (0, Q.jsx)(ql, {
								title: "Workflow Name",
								isSortable: !0,
								triggerSorting: d("workflowName"),
								sortOrder: u,
								disabled: !1,
								isSorted: l === "workflowName"
							}),
							/* @__PURE__ */ (0, Q.jsx)(ql, {
								title: "App Name",
								isSortable: !0,
								triggerSorting: d("appName"),
								sortOrder: u,
								disabled: !1,
								isSorted: l === "appName"
							}),
							/* @__PURE__ */ (0, Q.jsx)(ql, {
								title: "Environments",
								isSortable: !1,
								triggerSorting: $d,
								sortOrder: Jl.ASC,
								disabled: !1,
								isSorted: !1
							}),
							/* @__PURE__ */ (0, Q.jsx)(ql, {
								title: "Trigger Status",
								isSortable: !0,
								triggerSorting: d("scanEnableTriggerStatus"),
								sortOrder: u,
								disabled: !1,
								isSorted: l === "scanEnableTriggerStatus"
							}),
							/* @__PURE__ */ (0, Q.jsx)(ql, {
								title: "Message",
								isSortable: !1,
								triggerSorting: $d,
								sortOrder: Jl.ASC,
								disabled: !1,
								isSorted: !1
							})
						]
					}), /* @__PURE__ */ (0, Q.jsx)("div", {
						className: "flexbox-col flex-grow-1 mh-0 dc__overflow-auto",
						children: f.map(({ workflowId: e, workflowName: t, appName: n, appId: r, environments: i, scanEnableTriggerStatus: a, message: o }) => /* @__PURE__ */ (0, Q.jsxs)("div", {
							className: "dc__grid trigger-status-row px-20 py-12",
							children: [
								/* @__PURE__ */ (0, Q.jsx)("div", { children: /* @__PURE__ */ (0, Q.jsx)(W, {
									content: t,
									children: /* @__PURE__ */ (0, Q.jsx)(Wf, {
										className: "fs-13 lh-20 fw-4 dc__truncate",
										to: JH(`${r}`, t),
										children: t
									})
								}) }),
								/* @__PURE__ */ (0, Q.jsx)("div", { children: /* @__PURE__ */ (0, Q.jsx)(W, {
									content: n,
									children: /* @__PURE__ */ (0, Q.jsx)("span", {
										className: "fs-13 lh-20 cn-9 fw-4 dc__truncate",
										children: n
									})
								}) }),
								/* @__PURE__ */ (0, Q.jsx)("div", { children: /* @__PURE__ */ (0, Q.jsx)(W, {
									content: (i ?? []).join(", "),
									children: /* @__PURE__ */ (0, Q.jsx)("span", {
										className: "fs-13 lh-20 cn-9 fw-4 dc__truncate",
										children: (i ?? []).join(", ")
									})
								}) }),
								/* @__PURE__ */ (0, Q.jsx)(oU, { scanEnableTriggerStatus: a }),
								/* @__PURE__ */ (0, Q.jsx)(W, {
									content: o,
									children: /* @__PURE__ */ (0, Q.jsx)("span", {
										className: "fs-13 lh-20 cn-9 fw-4 dc__truncate",
										children: o
									})
								})
							]
						}, `${e}-${t}-${n}`))
					})] })
				}),
				!r && !i && m > 0 && /* @__PURE__ */ (0, Q.jsx)("div", {
					className: "flex right px-20 py-12 border__secondary--top",
					children: /* @__PURE__ */ (0, Q.jsx)(M, {
						dataTestId: "retry-failed",
						startIcon: /* @__PURE__ */ (0, Q.jsx)(z, {
							name: "ic-arrow-clockwise",
							color: null
						}),
						text: "Retry failed",
						onClick: () => {
							s({
								workflowIds: p.map((e) => e.workflowId),
								enableScanning: n
							});
						}
					})
				})
			]
		})
	});
}, cU = ({ action: e, onClose: t, selections: n, bulkOperationModalData: { reloadAfterBulkAction: r } }) => {
	let { search: i } = Yf(), { checkboxValue: a } = _f(), { mutate: o, ...s } = rU(), [c, l] = j(!1), u = e === GH.ENABLE, { application: d, environment: f, cluster: p, searchQuery: m, workflowScanType: h } = qH(i), g = a === Io.BULK_CHECKED ? {
		appIds: d.map(Number),
		envIds: f.map(Number),
		clusterIds: p.map(Number),
		scanEnablement: h,
		enableScanning: u,
		searchQuery: m
	} : {
		workflowIds: n.map((e) => e.data.workflowId),
		enableScanning: u
	};
	return c ? /* @__PURE__ */ (0, Q.jsx)(sU, {
		isBulkScanEnable: u,
		handleClose: () => {
			t(), l(!1), r();
		},
		headerTitle: `Scan ${u ? "Enablement" : "Disablement"} Status`,
		mutationProps: {
			...s,
			mutate: o
		}
	}) : /* @__PURE__ */ (0, Q.jsx)(ns, {
		title: `Bulk security scan ${u ? "enablement" : "disablement"} works only for workflows that have build pipelines.`,
		subtitle: "If a workflow doesn’t include a build pipeline, you can still manage security scanning via plugins.",
		variant: rs.info,
		buttonConfig: {
			primaryButtonConfig: {
				text: u ? "Enable Scan" : "Disable Scan",
				onClick: () => {
					l(!0), o(g);
				}
			},
			secondaryButtonConfig: {
				text: "Cancel",
				onClick: t
			}
		},
		handleClose: t
	});
}, lU = ({ children: e, handleSearch: t, updateSearchParams: n, workflowScanType: r, application: i, environment: a, cluster: o, clearFilters: s, searchKey: c }) => {
	let { appOptions: l, environmentOptions: u, clusterOptions: d, isResourcesOptionsLoading: f, refetchResourcesOptions: p, resourcesOptionsError: m } = iU(), h = (e) => {
		n({ workflowScanType: e.value });
	}, g = (e) => (t) => {
		n({ [e]: t.map((e) => e.value) });
	}, _ = (e, t) => {
		switch (e) {
			case "application": return Dd(l, t)?.label ?? t;
			case "environment": return Dd(u, t)?.label ?? t;
			case "cluster": return Dd(d, t)?.label ?? t;
			default: return t;
		}
	}, v = {
		isDisabled: f,
		isLoading: f,
		reloadOptionList: p,
		optionListError: m
	}, y = {
		application: {
			...v,
			placeholder: "Select Application",
			inputId: "workflow-scan-list-application-filter",
			options: l,
			appliedFilterOptions: Od(l, i),
			handleApplyFilter: g("application")
		},
		environment: {
			...v,
			placeholder: "Select Environment",
			inputId: "workflow-scan-list-environment-filter",
			options: u,
			appliedFilterOptions: Od(u, a),
			handleApplyFilter: g("environment")
		},
		cluster: {
			...v,
			placeholder: "Select Cluster",
			inputId: "workflow-scan-list-cluster-filter",
			options: d,
			appliedFilterOptions: Od(d, o),
			handleApplyFilter: g("cluster")
		}
	};
	return /* @__PURE__ */ (0, Q.jsxs)(Q.Fragment, { children: [
		/* @__PURE__ */ (0, Q.jsxs)("div", {
			className: "p-16 flex dc__content-space",
			children: [/* @__PURE__ */ (0, Q.jsxs)("div", {
				className: "flex dc__gap-8",
				children: [/* @__PURE__ */ (0, Q.jsx)(Bl, {
					name: "workflow-list-scan-segments",
					segments: ZH,
					value: r,
					onChange: h
				}), /* @__PURE__ */ (0, Q.jsx)(Il, {
					inputProps: { placeholder: "Search workflow" },
					handleEnter: t,
					keyboardShortcut: "/",
					initialSearchText: c
				})]
			}), /* @__PURE__ */ (0, Q.jsx)(pc, {
				id: "workflow-scan-list-filters",
				options: QH,
				filterSelectPickerPropsMap: y,
				isFilterApplied: !!(i.length || a.length || o.length)
			})]
		}),
		/* @__PURE__ */ (0, Q.jsx)(Zs, {
			filterConfig: {
				application: i,
				environment: a,
				cluster: o
			},
			clearFilters: s,
			onRemoveFilter: n,
			className: "px-20",
			getFormattedValue: _
		}),
		e
	] });
}, uU = () => {
	let e = X(), { pathname: t } = Yf(), { handleBulkSelection: n } = _f(), [r, i] = j(!1);
	return /* @__PURE__ */ (0, Q.jsx)(ru, {
		id: "table__workflow-scan-list",
		columns: tU,
		getRows: nU,
		emptyStateConfig: { noRowsConfig: { title: "No workflows found" } },
		filtersVariant: tc.URL,
		filter: null,
		paginationVariant: el.PAGINATED,
		ViewWrapper: lU,
		additionalFilterProps: {
			initialSortKey: WH.WORKFLOW_NAME,
			parseSearchParams: KH
		},
		bulkSelectionConfig: {
			BulkActionsComponent: aU,
			getSelectAllDialogStatus: () => Vl.CLOSED,
			BulkOperationModal: cU,
			bulkActionsData: {},
			bulkOperationModalData: { reloadAfterBulkAction: () => {
				n({ action: Ao.CLEAR_ALL_SELECTIONS }), e(t, { replace: !0 }), i((e) => !e);
			} }
		}
	}, `${r}`);
}, dU = () => /* @__PURE__ */ (0, Q.jsxs)("div", {
	className: "flexbox-col flex-grow-1 dc__overflow-hidden",
	children: [/* @__PURE__ */ (0, Q.jsx)(HH, {}), /* @__PURE__ */ (0, Q.jsx)(uU, {})]
});
//#endregion
export { Zp as AIChat, Si as AIChatProvider, Jw as AIResponseWidget, We as ALLOWED_ADDITIONAL_ROLES_MAP, PH as APPLICATION_MANAGEMENT_POLICIES_NAV_ITEM, FH as APPLICATION_MANAGEMENT_TEMPLATES_NAV_ITEM, AH as ActionsAndInsights, MO as AllowedWithWarningTippy, e_ as AppDetailsDownloadCard, B_ as ApplyResourceRecommendationModal, Aa as ApprovalCountBadge, tm as ApprovalEmptyState, Gr as ApprovalInfoTippy, Sx as ApprovalMaterial, Mx as ApprovalMaterialModal, Ix as ApprovalNodeEdge, Ce as ApprovalPolicy, Hx as ApproveRequestTippy, Rx as ApprovedImagesMessage, Qp as AskDevtronButton, em as AskValueAtRuntimeCheckbox, cT as AssignCategorySelect, pN as AuditLogs, Dn as AuthenticationTypeRadio, NV as AutoscalerProfileSelect, lb as BADGE_BASE_CLASS, Jh as BULK_EDIT_README_OPTIONS, Yh as BULK_EDIT_VALIDATOR_SCHEMA, jM as BestPractices, Ve as BitBucketDCCredentials, f as BitbucketCloudAndServerToggleSection, yn as BuildInfraRouter, _m as BulkCDStrategy, RC as BulkDeployLink, ni as BulkDeployResistanceTippy, Kh as BulkManageTrafficDrawer, nn as BulkStatusUpdateDropdown, GD as CDMaterialInfo, pa as CIListHeader, zH as COST_VISIBILITY_NAV_GROUP, mC as CacheConfiguration, Ir as Catalog, Xm as ChangeImageSource, eg as ChartCategoryFilters, Fw as ChartSecurityTab, ph as ClonePipelineMenuButton, gh as ClonePipelineModal, Ob as ClusterAddOns, fv as ClusterBulkSelectionActionWidget, Rb as ClusterConfig, kb as ClusterConfigContent, Dp as ClusterCostConfig, jH as ClusterCostVisibility, Ib as ClusterInstallationStatusDialog, pv as CompareClusterButton, uy as CompareClusterViewWrapper, sS as CompareFromApprovalSelector, YS as ConfigApproversInfoTippy, $i as ConfigDriftModal, rS as ConfigMapSecretApproveButton, gC as ConfigSyncStatusButton, _S as ConfigurableGUIViewModel, yS as ConfigurableGUIViewPanel, fa as ConfigurationsAppEnvSelector, CC as ConfigurePatchDialog, sa as ConfiguredFilters, PM as CostMetrics, hN as CostVisibilityRenderProvider, oF as CostVisibilityRouter, Pe as CreateClusterForm, BH as DATA_PROTECTION_MANAGEMENT_NAV_GROUP, h as DEPLOYMENT_APPROVER_ROLE_VALUE, iS as DISABLE_DATA_TYPE_CHANGE_HELPER_MESSAGE, aS as DISABLE_DELETE_TOOLTIP_TEXT, vV as DataProtectionManagementRouter, Gx as DeleteModal, qx as DeleteOverrideDraftModal, fE as DependencyList, la as DeploymentApprovalInfo, re as DeploymentChartActionButton, Ye as DeploymentChartDetail, Qi as DeploymentHistoryTriggerMetaText, bC as DeploymentStrategyCard, BS as DeploymentTemplateLockedDiff, a as DeploymentWindow, jE as DeploymentWindowConfirmationDialog, NE as DeploymentWindowInfoBar, GE as DeploymentWindowModal, GE as DeploymentWindowStatusModal, BE as DeploymentWindowOverview, UE as DeploymentWindowStatusCard, or as DeprecatedTag, Ge as DevtronAppTemplates, wD as DockerfileScansRecommendations, zw as DownloadFileFolderButton, gw as DownloadManifestForVirtualEnvironmentButton, Yx as DraftComments, KS as DryRunEditorModeSelect, de as EnvironmentLabels, xE as ExcludedUsersDescription, Bx as ExpireApproval, zi as ExplainWithAIButton, OT as ExpressDeleteDraftModal, kT as ExpressEditButton, AT as ExpressEditConfirmationModal, cS as ExpressEditDeploymentTemplateCTA, PT as ExpressEditDiffEditor, FT as ExpressEditHeader, Ex as FilterActionBar, Hk as FilterButton, gO as FilterConditions, VH as GLOBAL_CONFIG_AUTH_USER_GROUPS_NAV_ITEM, yV as GLOBAL_CONFIG_USER_GROUP_SIDE_NAV_ITEM, r_ as GeneratedHelmDownload, dD as GenericDirectApprovalModal, o_ as HelmManifestPush, gy as HibernationRulesModal, EH as INFRA_OVERVIEW_QUERY_KEYS, kt as ImagePromotion, ea as ImagePromotionInfoChip, BC as ImagePromotionLink, av as KubeConfigButton, dv as KubeConfigModal, ov as KubeConfigRowCheckbox, s as LINKED_CD_SOURCE_VARIANT, Qw as LicenseInfoDialog, ED as LinkedCDNode, Pn as LockDeploymentConfiguration, Qn as MANGER_ROLE_DEPRECATION_WARNING, vy as MONITORING_DASHBOARD_TAB_NAME, qE as MaintenanceWindowInfoBar, nr as ManageAllAccessToggle, uT as ManageCategories, dT as ManageCategoryButton, qh as ManageTrafficButton, SC as ManageTrafficDrawer, FO as MandatoryPluginWarning, Gk as MandatoryTagWarning, Ep as MandatoryTagsContainer, _y as ManifestGUIView, Gn as ManualApproval, XS as MergePatchWithTemplateCheckbox, Vb as MigrateClusterVersionInfoBar, VO as MissingPluginBlockState, zy as MonitoringDashboard, Jg as NetworkStatusInterface, sH as NodeAutoscalerProfileList, p as OCIRegistryUseActionHelmPushMessage, EC as OpenSecurityModalButton, $n as OtherGitOpsForm, mM as OverviewCostBreakdown, Hr as PartOfReleaseTrack, US as PatchStrategyTooltipInfo, WO as PipelineTaskActionConfirmationDialog, Yt as PluginsPolicy, ik as PodRestart, sk as PodRestartIcon, nk as PodRestartModal, gT as PodSpreadModal, RM as Policies, GO as PolicyEnforcementMessage, $S as ProtectConfigShowCommentsButton, WS as ProtectedDeploymentTemplateCTA, uC as ProtectionViewTabGroup, fC as ProtectionViewToolbarPopupNode, fk as PullImageDigest, $_ as RBBulkOperations, C_ as RBBulkSelectionActions, Wb as RBPageHeaderPopup, Zb as RBRestartWorkloadModal, yy as RB_MONITORING_DRAGGABLE_HANDLE_CLASS, cb as REDFISH_COMPONENTS_BASE_CLASS, ub as REDFISH_NODE_UI_TABS, Tk as RESOURCE_FILTER_KEYS, w_ as RESOURCE_RECOMMENDER_HEADER_TO_TITLE_MAP, T_ as RESOURCE_RECOMMENDER_HEADER_TO_WIDTH_MAP, IH as RESOURCE_WATCHER_NAV_ITEM, c_ as RegistryHelmPushCheckbox, wk as RemoteConnectionRadio, Er as ResistantInput, Gb as ResourceRecommendationChip, Yb as ResourceRecommender, Xb as ResourceRecommenderActionMenu, sx as ResourceWatcherRouter, _T as RuntimeParamTabs, Ba as RuntimeParameters, et as SCOPED_VARIABLES_TEMPLATE_DATA, RH as SDH_NAV_GROUP, LH as SECURITY_ENABLEMENT_NAV_ITEM, $x as SaveChangesModal, jn as ScopedVariablesEnvironmentDetailsForm, gn as ScopedVariablesEnvironmentListContainer, dU as SecurityEnablement, _i as SecurityModalSidebar, zC as SelectDeploymentStrategy, ax as ShowIneligibleChangesModal, Qm as SkipHibernatedCheckbox, br as SoftwareDistributionHub, ia as SoftwareDistributionHubRenderProvider, c as StatusCell, sn as StatusFilterDropdown, Ae as StatusHeaderCell, NC as SwapTraffic, MC as SwapTrafficDialog, BD as SyncEnvironment, FA as TagListContainer, PC as TemplateList, vT as Timer, Ot as ToggleEnableRole, ox as ToggleManifestConfigurationMode, yT as ToggleSecurityScan, ST as TriggerBlockEmptyState, CT as TriggerBlockedError, It as UpdateCreateClusterAction, rr as UserConfigChangeActionType, y as UserGroupCell, TH as UserGroupRouter, C as UserGroupSelector, Je as UserListFilterToolbar, En as UserStatusUpdate, DT as ViewIsPipelineRBACConfigured, g_ as VirtualAppDetailsEmptyState, v_ as VirtualClusterForm, Qg as VirtualEnvHelpTippy, y_ as VirtualEnvSelectionInfoText, Vi as VirtualHistoryArtifact, kw as WebhookAddImageButton, Mw as WebhookAddImageModal, Pw as WorkflowActionRouter, AV as attachProfileToCluster, ot as changeStatusToInactiveIfTemporary, rx as checkForIneligibleChanges, Xn as convertUTCToTimezoneDate, Yn as createDevtronAppUsingTemplate, St as createResource, yb as deleteInstalledCluster, um as downloadManifestForVirtualEnvironment, Qh as dryRunBulkEditScript, jy as generatePanelDataStoreFromResponse, Jt as getAccessManagerRoles, Wt as getAdditionalRolesAccordingToAccess, na as getAllDrafts, bn as getAppEnvsMin, qi as getApprovalPolicyConfigForApp, Ii as getApprovalPolicyConfigForEnv, Ke as getBrowserTimezone, x as getBrowserTimezoneOffset, Xh as getBulkEditConfig, YO as getCIBlockState, nT as getCategoryPayload, YA as getCloudProviderForCluster, MV as getClusterAutoscalerProfileMap, Vn as getClusterNamespaces, pC as getConfigAfterOperations, ne as getDefaultStatusAndTimeout, ge as getDefaultUserStatusAndTimeout, Ay as getDefaultValueForPanelConfiguration, oC as getDeleteDraftPopupButtonConfig, Xe as getDeploymentNotAllowedState, dm as getDeploymentStrategies, Ch as getDeploymentStrategyDetails, it as getDeploymentWindowProfileMetaData, te as getDeploymentWindowState, me as getDeploymentWindowStateAppGroup, _ as getDeploymentWindowTimeStampIcon, ua as getDesiredAndLiveManifest, Fn as getDevtronLicenseDetails, Oe as getDownloadManifestUrl, Ni as getDraft, mi as getDraftByResourceName, sC as getEditHistoryPopupButtonConfig, ui as getEnvFormattedOptionLabel, lC as getExpressDeleteDraftPopupButtonConfig, At as getFilterCriteria, kk as getFilterOptionsFromSearchParams, kS as getFilteredPatches, An as getFormattedTimeToLive, rt as getHibernationPatchConfig, ln as getImageLabelsFromApplications, Cb as getInstallationClusterConfig, xb as getInstallationClusterConfigs, pe as getIsStatusDropdownDisabled, zS as getJsonPath, RS as getLockConfigEligibleAndIneligibleChanges, LS as getLockFilteredTemplate, MS as getLockedJSON, $b as getLockedManifestKeys, Th as getManageTrafficMenuButtonConfig, Qb as getManifestGUISchema, Oy as getMonitoringDashboardTabConfig, ky as getPanelTemplateAttributeKey, pn as getParsedPluginPolicyConsequenceData, oe as getParsedUserGroupList, bt as getPermissionActionValue, kC as getPolicyConsequences, jV as getProfileAttachedToCluster, M_ as getRecommendationChipIconAndClass, an as getRemaining, hk as getRemoteConnectionConfig, Un as getResourceManifestResult, A_ as getResourceRecommendationLabel, O_ as getResourceRecommendationListPayload, j_ as getResourceRecommendationsCSVData, D_ as getResourceRecommenderTabConfig, OC as getResourceScanDetails, Jn as getRoleConfig, Mt as getRuntimeParams, Ra as getRuntimeParamsPayload, gk as getSSHConfig, bD as getSecurityScanRecommendationTitle, pt as getStatusAndTimeoutPayload, lt as getStatusExportText, gt as getStatusFromSearchParams, wO as getTaskActionPluginValidationStatus, o as getTermsAndConditions, aC as getToggleViewLockedKeysPopupButtonConfig, gr as getTotalEligibleApproverCount, NS as getUnlockedJSON, ai as getUserEmailsFromApproversList, Ie as getUserExportToCsvConfiguration, Qe as getUserGroupsPayload, Rt as getUserListMin, i as getUserStatus, Pt as getUserStatusAndTimeoutPayload, zn as getUserTypeToFetchFromSelectedConfigOptions, kr as getUsersEligibleForNotification, Kt as handleCreateResourceError, ee as isFELibAvailable, uS as makeObjectFromJsonPathArray, TT as migrateUserPreferences, My as parseDataStoreConfigToLayoutList, N_ as parseRecommendationGVKListDTO, k_ as parseResourceRecommendationDTO, P_ as parseSearchParams, Zh as postBulkEditScript, On as processDeploymentWindowAppGroupOverviewMap, fe as processDeploymentWindowMetadata, dt as processDeploymentWindowStateAppGroup, ek as processPluginData, ta as processVirtualEnvironmentDeploymentData, IS as reapplyRemovedLockedKeysToYaml, FS as removeLockedKeysFromYaml, ri as renderApprovalStatusIcon, ci as renderCIListHeader, Ci as renderConfigDriftDetectedText, fi as renderDeploymentApprovalInfo, Kr as renderDeploymentHistoryTriggerMetaText, Gi as renderOutOfSyncWarning, dr as renderRunSource, ki as renderRunSourceInDropdown, en as renderVirtualEnvironmentInfoText, ha as renderVirtualHistoryArtifacts, V_ as restartRBWorkload, Ht as sanitizeUserApprovalConfig, Uk as scopedVariablesHelpTippyText, Ea as submitDraftRequest, F_ as tableFilter, wT as updatePipelineRBACView, wn as updateResourceManifest, yv as useClusterUpgradeCompatibilityInfo, gN as useCostVisibilityRenderContext, Se as useDeploymentWindow, Vw as useEnterpriseLicenseConfig, Ti as useReleaseConfigurationContext, ZO as validatePlugins, za as validateRuntimeParameters, Rn as validateUserApprovalConfig, h_ as virtualClusterSaveUpdateApi };
